//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class IConfig {
    getAuthorization!: () => Promise<string>;
    getAdditionalHeaders!: () => Headers;
}

export class AuthorizedApiBase {
    private readonly config: IConfig;

    protected constructor(config: IConfig) {
        this.config = config;
    }
    
    public getInstance(): AxiosInstance {
        return this.instance;
    }

    protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
        const additionalHeaders: Headers = this.config.getAdditionalHeaders(); 
        const headersCopy: Record<string, string> = {};
        if (additionalHeaders instanceof Headers) {
            additionalHeaders.forEach((value: string, name:string) => {
                headersCopy[name] = value;
            });
        }
        
        
        const token = await this.config.getAuthorization()
        options.headers = {
            ...options.headers,
            Authorization: token,
            ...headersCopy,
        };
        
        return Promise.resolve(options);
    };
}

export interface IAccountClient {
    /**
     * @return OK
     */
    getAccountProfileDrawer( cancelToken?: CancelToken): Promise<AccountProfileDrawerResponse>;
    /**
     * Collects all account names and ax numbers given the user is in the Cloud Onboarding team.
     * @param body (optional) 
     * @return OK
     */
    getAllAccountNamesAndAxNumbersForOnboarding(body: AccountSearchQuery | undefined,  cancelToken?: CancelToken): Promise<AccountNameWithAxNumber[]>;
    /**
     * @return OK
     */
    getAllAccountsForCrmAccountTeamSync( cancelToken?: CancelToken): Promise<AccountCRMAccountTeamSyncDTO[]>;
    /**
     * @return OK
     */
    getAccountsForCrmAccountTeamByAxAccountSync(axNumber: string,  cancelToken?: CancelToken): Promise<AccountCRMAccountTeamSyncDTO>;
    /**
     * @return OK
     */
    getAxNumberFromAccountId(accountId: number,  cancelToken?: CancelToken): Promise<string>;
}

export class AccountClient extends AuthorizedApiBase implements IAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAccountProfileDrawer( cancelToken?: CancelToken): Promise<AccountProfileDrawerResponse> {
        let url_ = this.baseUrl + "/api/Account/drawer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountProfileDrawer(_response);
        });
    }

    protected processGetAccountProfileDrawer(response: AxiosResponse): Promise<AccountProfileDrawerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountProfileDrawerResponse.fromJS(resultData200);
            return Promise.resolve<AccountProfileDrawerResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountProfileDrawerResponse>(null as any);
    }

    /**
     * Collects all account names and ax numbers given the user is in the Cloud Onboarding team.
     * @param body (optional) 
     * @return OK
     */
    getAllAccountNamesAndAxNumbersForOnboarding(body: AccountSearchQuery | undefined, cancelToken?: CancelToken): Promise<AccountNameWithAxNumber[]> {
        let url_ = this.baseUrl + "/api/Account/all/account-names-with-ax-numbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAccountNamesAndAxNumbersForOnboarding(_response);
        });
    }

    protected processGetAllAccountNamesAndAxNumbersForOnboarding(response: AxiosResponse): Promise<AccountNameWithAxNumber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountNameWithAxNumber.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AccountNameWithAxNumber[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountNameWithAxNumber[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllAccountsForCrmAccountTeamSync( cancelToken?: CancelToken): Promise<AccountCRMAccountTeamSyncDTO[]> {
        let url_ = this.baseUrl + "/api/Account/all/crm-account-team-sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAccountsForCrmAccountTeamSync(_response);
        });
    }

    protected processGetAllAccountsForCrmAccountTeamSync(response: AxiosResponse): Promise<AccountCRMAccountTeamSyncDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountCRMAccountTeamSyncDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AccountCRMAccountTeamSyncDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountCRMAccountTeamSyncDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getAccountsForCrmAccountTeamByAxAccountSync(axNumber: string, cancelToken?: CancelToken): Promise<AccountCRMAccountTeamSyncDTO> {
        let url_ = this.baseUrl + "/api/Account/account/{axNumber}/crm-account-team-sync";
        if (axNumber === undefined || axNumber === null)
            throw new globalThis.Error("The parameter 'axNumber' must be defined.");
        url_ = url_.replace("{axNumber}", encodeURIComponent("" + axNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountsForCrmAccountTeamByAxAccountSync(_response);
        });
    }

    protected processGetAccountsForCrmAccountTeamByAxAccountSync(response: AxiosResponse): Promise<AccountCRMAccountTeamSyncDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountCRMAccountTeamSyncDTO.fromJS(resultData200);
            return Promise.resolve<AccountCRMAccountTeamSyncDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountCRMAccountTeamSyncDTO>(null as any);
    }

    /**
     * @return OK
     */
    getAxNumberFromAccountId(accountId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Account/account/{accountId}/axnumber";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAxNumberFromAccountId(_response);
        });
    }

    protected processGetAxNumberFromAccountId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IAccountAdminClient {
    /**
     * @return OK
     */
    getAccountNotifications( cancelToken?: CancelToken): Promise<AccountNotifications>;
    /**
     * @return OK
     */
    getAccounts( cancelToken?: CancelToken): Promise<AccountResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    setManualEmailRequired(body: ToggleManualEmailRequest | undefined,  cancelToken?: CancelToken): Promise<AccountResponse>;
}

export class AccountAdminClient extends AuthorizedApiBase implements IAccountAdminClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAccountNotifications( cancelToken?: CancelToken): Promise<AccountNotifications> {
        let url_ = this.baseUrl + "/api/AccountAdmin/accountNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountNotifications(_response);
        });
    }

    protected processGetAccountNotifications(response: AxiosResponse): Promise<AccountNotifications> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountNotifications.fromJS(resultData200);
            return Promise.resolve<AccountNotifications>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountNotifications>(null as any);
    }

    /**
     * @return OK
     */
    getAccounts( cancelToken?: CancelToken): Promise<AccountResponse> {
        let url_ = this.baseUrl + "/api/AccountAdmin/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccounts(_response);
        });
    }

    protected processGetAccounts(response: AxiosResponse): Promise<AccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountResponse.fromJS(resultData200);
            return Promise.resolve<AccountResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setManualEmailRequired(body: ToggleManualEmailRequest | undefined, cancelToken?: CancelToken): Promise<AccountResponse> {
        let url_ = this.baseUrl + "/api/AccountAdmin/setManualEmailRequired";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetManualEmailRequired(_response);
        });
    }

    protected processSetManualEmailRequired(response: AxiosResponse): Promise<AccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountResponse.fromJS(resultData200);
            return Promise.resolve<AccountResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountResponse>(null as any);
    }
}

export interface IAccountTeamMembersClient {
    /**
     * Updates a subset of CRM Account Teams. The list must not contain more than 500 items.
    Each item must include a full representation of the Account Team Members.
    If any users are missing from the list, they will be removed from that Account Team.
     * @param body (optional) 
     * @return OK
     */
    updateAccountTeams(body: AccountTeamMemberSyncDetails[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    saveAccountTeamMember(body: CrmAccountTeamMember[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    saveAccountTeamMembers(body: SaveAccountTeamMembersRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getAccountTeamLastSyncDateTime(accountId: number,  cancelToken?: CancelToken): Promise<AccountTeamLastSyncDateTime>;
    /**
     * @return OK
     */
    getYourShiTeam( cancelToken?: CancelToken): Promise<GetCustomerFacingYourShiTeamResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateCrmUsers(body: CrmUserDetails[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateCrmShiConnectionRoles(body: CrmShiConnectionRole[] | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class AccountTeamMembersClient extends AuthorizedApiBase implements IAccountTeamMembersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Updates a subset of CRM Account Teams. The list must not contain more than 500 items.
    Each item must include a full representation of the Account Team Members.
    If any users are missing from the list, they will be removed from that Account Team.
     * @param body (optional) 
     * @return OK
     */
    updateAccountTeams(body: AccountTeamMemberSyncDetails[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers/update/account-teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccountTeams(_response);
        });
    }

    protected processUpdateAccountTeams(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    saveAccountTeamMember(body: CrmAccountTeamMember[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAccountTeamMember(_response);
        });
    }

    protected processSaveAccountTeamMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAccountTeamMembers(body: SaveAccountTeamMembersRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/accountTeamMembers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAccountTeamMembers(_response);
        });
    }

    protected processSaveAccountTeamMembers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAccountTeamLastSyncDateTime(accountId: number, cancelToken?: CancelToken): Promise<AccountTeamLastSyncDateTime> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers/account-team/{accountId}/last-sync";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountTeamLastSyncDateTime(_response);
        });
    }

    protected processGetAccountTeamLastSyncDateTime(response: AxiosResponse): Promise<AccountTeamLastSyncDateTime> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountTeamLastSyncDateTime.fromJS(resultData200);
            return Promise.resolve<AccountTeamLastSyncDateTime>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTeamLastSyncDateTime>(null as any);
    }

    /**
     * @return OK
     */
    getYourShiTeam( cancelToken?: CancelToken): Promise<GetCustomerFacingYourShiTeamResponse> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers/business-review/your-shi-team";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetYourShiTeam(_response);
        });
    }

    protected processGetYourShiTeam(response: AxiosResponse): Promise<GetCustomerFacingYourShiTeamResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomerFacingYourShiTeamResponse.fromJS(resultData200);
            return Promise.resolve<GetCustomerFacingYourShiTeamResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomerFacingYourShiTeamResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCrmUsers(body: CrmUserDetails[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers/update/crm-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCrmUsers(_response);
        });
    }

    protected processUpdateCrmUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCrmShiConnectionRoles(body: CrmShiConnectionRole[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AccountTeamMembers/update/connection-roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCrmShiConnectionRoles(_response);
        });
    }

    protected processUpdateCrmShiConnectionRoles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IActivityClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getLifecycleActivity(body: GetActivityRequest | undefined,  cancelToken?: CancelToken): Promise<GetActivityResponse>;
}

export class ActivityClient extends AuthorizedApiBase implements IActivityClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getLifecycleActivity(body: GetActivityRequest | undefined, cancelToken?: CancelToken): Promise<GetActivityResponse> {
        let url_ = this.baseUrl + "/api/activity/lifecycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLifecycleActivity(_response);
        });
    }

    protected processGetLifecycleActivity(response: AxiosResponse): Promise<GetActivityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetActivityResponse.fromJS(resultData200);
            return Promise.resolve<GetActivityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetActivityResponse>(null as any);
    }
}

export interface IAlertClient {
    /**
     * @return OK
     */
    getAlertByTicketId(ticketId: number,  cancelToken?: CancelToken): Promise<TicketDTO>;
    /**
     * @return OK
     */
    getAlerts( cancelToken?: CancelToken): Promise<MonitoringAlert[]>;
}

export class AlertClient extends AuthorizedApiBase implements IAlertClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAlertByTicketId(ticketId: number, cancelToken?: CancelToken): Promise<TicketDTO> {
        let url_ = this.baseUrl + "/api/Alert/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlertByTicketId(_response);
        });
    }

    protected processGetAlertByTicketId(response: AxiosResponse): Promise<TicketDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TicketDTO.fromJS(resultData200);
            return Promise.resolve<TicketDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketDTO>(null as any);
    }

    /**
     * @return OK
     */
    getAlerts( cancelToken?: CancelToken): Promise<MonitoringAlert[]> {
        let url_ = this.baseUrl + "/api/Alert";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlerts(_response);
        });
    }

    protected processGetAlerts(response: AxiosResponse): Promise<MonitoringAlert[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonitoringAlert.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MonitoringAlert[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringAlert[]>(null as any);
    }
}

export interface IArchbeeClient {
    /**
     * Retrieves the Archbee URL for SHI Internal Documentation
     * @return OK
     */
    getArchbeeLink( cancelToken?: CancelToken): Promise<string>;
}

export class ArchbeeClient extends AuthorizedApiBase implements IArchbeeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieves the Archbee URL for SHI Internal Documentation
     * @return OK
     */
    getArchbeeLink( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Archbee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArchbeeLink(_response);
        });
    }

    protected processGetArchbeeLink(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IAssessmentsClient {
    /**
     * @param program (optional) 
     * @return OK
     */
    getAssessments(program: AssessmentProgram | undefined,  cancelToken?: CancelToken): Promise<AssessmentDto[]>;
    /**
     * @return OK
     */
    getAssessmentPermissions( cancelToken?: CancelToken): Promise<AssessmentMetadataDto>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getAssessmentOverview(program: AssessmentProgram, id: string | undefined,  cancelToken?: CancelToken): Promise<AssessmentOverviewDto>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getAssessmentMaturityChart(program: AssessmentProgram, id: string | undefined,  cancelToken?: CancelToken): Promise<AssessmentMaturityChartDto>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getAssessmentRecommendations(program: AssessmentProgram, id: string | undefined,  cancelToken?: CancelToken): Promise<AssessmentRecommendationsDto>;
    /**
     * @return OK
     */
    requestAssessmentConsultation(program: AssessmentProgram,  cancelToken?: CancelToken): Promise<SendConsultationEmailsResponse>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getPlatformInsights(program: AssessmentProgram, id: string | undefined,  cancelToken?: CancelToken): Promise<PlatformInsightsDto>;
    /**
     * @param id (optional) 
     * @return OK
     */
    getCapabilityInsights(program: AssessmentProgram, id: string | undefined,  cancelToken?: CancelToken): Promise<CapabilityInsightsDto>;
    /**
     * @return OK
     */
    getHarveyBallsByCapability(capabilityId: string,  cancelToken?: CancelToken): Promise<HarveyBallDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateHarveyBalls(body: HarveyBallsUpdate[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updatePlatforms(body: PlatformsUpdate[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    upsertAssessmentFromAirtable(body: UpsertAssessmentFromAirtableCommand | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createGeneratedAssessmentFromMindspark(body: GeneratedAssessment | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteAssessmentAndIntegration(body: DeleteAssessmentDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateAssessmentIntegration(body: UpdateAssessmentIntegration | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateAssessmentTemplate(body: AssessmentTemplateUpdate | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param program (optional) 
     * @return OK
     */
    getCapabilityChanges(program: AssessmentProgram | undefined,  cancelToken?: CancelToken): Promise<CapabilityChangesDto[]>;
    /**
     * @param program (optional) 
     * @param id (optional) 
     * @return OK
     */
    getMaturityComparison(program: AssessmentProgram | undefined, id: string | undefined,  cancelToken?: CancelToken): Promise<MaturityComparisonDto>;
    /**
     * @return OK
     */
    getRecommendationById(assessmentId: string, recommendationId: string,  cancelToken?: CancelToken): Promise<ResponseRecommendation>;
    /**
     * @return OK
     */
    getMaturityScoreAverages(program: AssessmentProgram,  cancelToken?: CancelToken): Promise<MaturityScoreAveragesDto>;
    /**
     * @return OK
     */
    getTpxVsem(assessmentId: string,  cancelToken?: CancelToken): Promise<VsemAggregateDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateTpxVsem(assessmentId: string, body: EditVsemRequest | undefined,  cancelToken?: CancelToken): Promise<VsemAggregateDto>;
    /**
     * @return OK
     */
    completeTpxVsem(assessmentId: string,  cancelToken?: CancelToken): Promise<VsemAggregateDto>;
    /**
     * @return OK
     */
    publishTpxVsem(assessmentId: string,  cancelToken?: CancelToken): Promise<VsemAggregateDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateTpxExecutionAreas(assessmentId: string, body: BulkUpdateExecutionAreasRequest | undefined,  cancelToken?: CancelToken): Promise<VsemAggregateDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createVsemRecommendation(body: CreateVsemRecommendationRequest | undefined,  cancelToken?: CancelToken): Promise<VsemRecommendationDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateVsemRecommendation(recommendationId: string, body: UpdateVsemRecommendationRequest | undefined,  cancelToken?: CancelToken): Promise<VsemRecommendationDto>;
    /**
     * @return No Content
     */
    deleteVsemRecommendation(recommendationId: string,  cancelToken?: CancelToken): Promise<void>;
}

export class AssessmentsClient extends AuthorizedApiBase implements IAssessmentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param program (optional) 
     * @return OK
     */
    getAssessments(program: AssessmentProgram | undefined, cancelToken?: CancelToken): Promise<AssessmentDto[]> {
        let url_ = this.baseUrl + "/api/Assessments?";
        if (program === null)
            throw new globalThis.Error("The parameter 'program' cannot be null.");
        else if (program !== undefined)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessments(_response);
        });
    }

    protected processGetAssessments(response: AxiosResponse): Promise<AssessmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AssessmentDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getAssessmentPermissions( cancelToken?: CancelToken): Promise<AssessmentMetadataDto> {
        let url_ = this.baseUrl + "/api/Assessments/metadata/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentPermissions(_response);
        });
    }

    protected processGetAssessmentPermissions(response: AxiosResponse): Promise<AssessmentMetadataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentMetadataDto.fromJS(resultData200);
            return Promise.resolve<AssessmentMetadataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentMetadataDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAssessmentOverview(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<AssessmentOverviewDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/overview?";
        if (program === undefined || program === null)
            throw new globalThis.Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentOverview(_response);
        });
    }

    protected processGetAssessmentOverview(response: AxiosResponse): Promise<AssessmentOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentOverviewDto.fromJS(resultData200);
            return Promise.resolve<AssessmentOverviewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentOverviewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAssessmentMaturityChart(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<AssessmentMaturityChartDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/maturity-chart?";
        if (program === undefined || program === null)
            throw new globalThis.Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentMaturityChart(_response);
        });
    }

    protected processGetAssessmentMaturityChart(response: AxiosResponse): Promise<AssessmentMaturityChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentMaturityChartDto.fromJS(resultData200);
            return Promise.resolve<AssessmentMaturityChartDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentMaturityChartDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAssessmentRecommendations(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<AssessmentRecommendationsDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/recommendations?";
        if (program === undefined || program === null)
            throw new globalThis.Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssessmentRecommendations(_response);
        });
    }

    protected processGetAssessmentRecommendations(response: AxiosResponse): Promise<AssessmentRecommendationsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssessmentRecommendationsDto.fromJS(resultData200);
            return Promise.resolve<AssessmentRecommendationsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessmentRecommendationsDto>(null as any);
    }

    /**
     * @return OK
     */
    requestAssessmentConsultation(program: AssessmentProgram, cancelToken?: CancelToken): Promise<SendConsultationEmailsResponse> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/consultation";
        if (program === undefined || program === null)
            throw new globalThis.Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestAssessmentConsultation(_response);
        });
    }

    protected processRequestAssessmentConsultation(response: AxiosResponse): Promise<SendConsultationEmailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendConsultationEmailsResponse.fromJS(resultData200);
            return Promise.resolve<SendConsultationEmailsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendConsultationEmailsResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getPlatformInsights(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<PlatformInsightsDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/platform-insights?";
        if (program === undefined || program === null)
            throw new globalThis.Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlatformInsights(_response);
        });
    }

    protected processGetPlatformInsights(response: AxiosResponse): Promise<PlatformInsightsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlatformInsightsDto.fromJS(resultData200);
            return Promise.resolve<PlatformInsightsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlatformInsightsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCapabilityInsights(program: AssessmentProgram, id: string | undefined, cancelToken?: CancelToken): Promise<CapabilityInsightsDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/capability-insights?";
        if (program === undefined || program === null)
            throw new globalThis.Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCapabilityInsights(_response);
        });
    }

    protected processGetCapabilityInsights(response: AxiosResponse): Promise<CapabilityInsightsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CapabilityInsightsDto.fromJS(resultData200);
            return Promise.resolve<CapabilityInsightsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CapabilityInsightsDto>(null as any);
    }

    /**
     * @return OK
     */
    getHarveyBallsByCapability(capabilityId: string, cancelToken?: CancelToken): Promise<HarveyBallDto> {
        let url_ = this.baseUrl + "/api/Assessments/harvey-balls/{capabilityId}";
        if (capabilityId === undefined || capabilityId === null)
            throw new globalThis.Error("The parameter 'capabilityId' must be defined.");
        url_ = url_.replace("{capabilityId}", encodeURIComponent("" + capabilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHarveyBallsByCapability(_response);
        });
    }

    protected processGetHarveyBallsByCapability(response: AxiosResponse): Promise<HarveyBallDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HarveyBallDto.fromJS(resultData200);
            return Promise.resolve<HarveyBallDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HarveyBallDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateHarveyBalls(body: HarveyBallsUpdate[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/update-harvey-balls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHarveyBalls(_response);
        });
    }

    protected processUpdateHarveyBalls(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePlatforms(body: PlatformsUpdate[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/update-platforms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlatforms(_response);
        });
    }

    protected processUpdatePlatforms(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    upsertAssessmentFromAirtable(body: UpsertAssessmentFromAirtableCommand | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/save-assessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertAssessmentFromAirtable(_response);
        });
    }

    protected processUpsertAssessmentFromAirtable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeneratedAssessmentFromMindspark(body: GeneratedAssessment | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/mindspark-assessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGeneratedAssessmentFromMindspark(_response);
        });
    }

    protected processCreateGeneratedAssessmentFromMindspark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteAssessmentAndIntegration(body: DeleteAssessmentDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/delete-assessment-and-integration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAssessmentAndIntegration(_response);
        });
    }

    protected processDeleteAssessmentAndIntegration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAssessmentIntegration(body: UpdateAssessmentIntegration | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/upsert-assessment-integration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAssessmentIntegration(_response);
        });
    }

    protected processUpdateAssessmentIntegration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAssessmentTemplate(body: AssessmentTemplateUpdate | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/update-assessment-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAssessmentTemplate(_response);
        });
    }

    protected processUpdateAssessmentTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param program (optional) 
     * @return OK
     */
    getCapabilityChanges(program: AssessmentProgram | undefined, cancelToken?: CancelToken): Promise<CapabilityChangesDto[]> {
        let url_ = this.baseUrl + "/api/Assessments/capability-changes?";
        if (program === null)
            throw new globalThis.Error("The parameter 'program' cannot be null.");
        else if (program !== undefined)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCapabilityChanges(_response);
        });
    }

    protected processGetCapabilityChanges(response: AxiosResponse): Promise<CapabilityChangesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CapabilityChangesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CapabilityChangesDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CapabilityChangesDto[]>(null as any);
    }

    /**
     * @param program (optional) 
     * @param id (optional) 
     * @return OK
     */
    getMaturityComparison(program: AssessmentProgram | undefined, id: string | undefined, cancelToken?: CancelToken): Promise<MaturityComparisonDto> {
        let url_ = this.baseUrl + "/api/Assessments/maturity-comparison?";
        if (program === null)
            throw new globalThis.Error("The parameter 'program' cannot be null.");
        else if (program !== undefined)
            url_ += "program=" + encodeURIComponent("" + program) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaturityComparison(_response);
        });
    }

    protected processGetMaturityComparison(response: AxiosResponse): Promise<MaturityComparisonDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaturityComparisonDto.fromJS(resultData200);
            return Promise.resolve<MaturityComparisonDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaturityComparisonDto>(null as any);
    }

    /**
     * @return OK
     */
    getRecommendationById(assessmentId: string, recommendationId: string, cancelToken?: CancelToken): Promise<ResponseRecommendation> {
        let url_ = this.baseUrl + "/api/Assessments/recommendation/{assessmentId}/{recommendationId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        if (recommendationId === undefined || recommendationId === null)
            throw new globalThis.Error("The parameter 'recommendationId' must be defined.");
        url_ = url_.replace("{recommendationId}", encodeURIComponent("" + recommendationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecommendationById(_response);
        });
    }

    protected processGetRecommendationById(response: AxiosResponse): Promise<ResponseRecommendation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseRecommendation.fromJS(resultData200);
            return Promise.resolve<ResponseRecommendation>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseRecommendation>(null as any);
    }

    /**
     * @return OK
     */
    getMaturityScoreAverages(program: AssessmentProgram, cancelToken?: CancelToken): Promise<MaturityScoreAveragesDto> {
        let url_ = this.baseUrl + "/api/Assessments/{program}/maturity-score-averages";
        if (program === undefined || program === null)
            throw new globalThis.Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaturityScoreAverages(_response);
        });
    }

    protected processGetMaturityScoreAverages(response: AxiosResponse): Promise<MaturityScoreAveragesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaturityScoreAveragesDto.fromJS(resultData200);
            return Promise.resolve<MaturityScoreAveragesDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaturityScoreAveragesDto>(null as any);
    }

    /**
     * @return OK
     */
    getTpxVsem(assessmentId: string, cancelToken?: CancelToken): Promise<VsemAggregateDto> {
        let url_ = this.baseUrl + "/api/Assessments/tpx/vsem/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTpxVsem(_response);
        });
    }

    protected processGetTpxVsem(response: AxiosResponse): Promise<VsemAggregateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VsemAggregateDto.fromJS(resultData200);
            return Promise.resolve<VsemAggregateDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VsemAggregateDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTpxVsem(assessmentId: string, body: EditVsemRequest | undefined, cancelToken?: CancelToken): Promise<VsemAggregateDto> {
        let url_ = this.baseUrl + "/api/Assessments/tpx/vsem/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTpxVsem(_response);
        });
    }

    protected processUpdateTpxVsem(response: AxiosResponse): Promise<VsemAggregateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VsemAggregateDto.fromJS(resultData200);
            return Promise.resolve<VsemAggregateDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VsemAggregateDto>(null as any);
    }

    /**
     * @return OK
     */
    completeTpxVsem(assessmentId: string, cancelToken?: CancelToken): Promise<VsemAggregateDto> {
        let url_ = this.baseUrl + "/api/Assessments/tpx/vsem/{assessmentId}/complete";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteTpxVsem(_response);
        });
    }

    protected processCompleteTpxVsem(response: AxiosResponse): Promise<VsemAggregateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VsemAggregateDto.fromJS(resultData200);
            return Promise.resolve<VsemAggregateDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 422) {
            const _responseText = response.data;
            return throwException("Unprocessable Content", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VsemAggregateDto>(null as any);
    }

    /**
     * @return OK
     */
    publishTpxVsem(assessmentId: string, cancelToken?: CancelToken): Promise<VsemAggregateDto> {
        let url_ = this.baseUrl + "/api/Assessments/tpx/vsem/{assessmentId}/publish";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishTpxVsem(_response);
        });
    }

    protected processPublishTpxVsem(response: AxiosResponse): Promise<VsemAggregateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VsemAggregateDto.fromJS(resultData200);
            return Promise.resolve<VsemAggregateDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 422) {
            const _responseText = response.data;
            return throwException("Unprocessable Content", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VsemAggregateDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateTpxExecutionAreas(assessmentId: string, body: BulkUpdateExecutionAreasRequest | undefined, cancelToken?: CancelToken): Promise<VsemAggregateDto> {
        let url_ = this.baseUrl + "/api/Assessments/tpx/vsem/{assessmentId}/execution-areas/bulk";
        if (assessmentId === undefined || assessmentId === null)
            throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdateTpxExecutionAreas(_response);
        });
    }

    protected processBulkUpdateTpxExecutionAreas(response: AxiosResponse): Promise<VsemAggregateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VsemAggregateDto.fromJS(resultData200);
            return Promise.resolve<VsemAggregateDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 422) {
            const _responseText = response.data;
            return throwException("Unprocessable Content", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VsemAggregateDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createVsemRecommendation(body: CreateVsemRecommendationRequest | undefined, cancelToken?: CancelToken): Promise<VsemRecommendationDto> {
        let url_ = this.baseUrl + "/api/Assessments/tpx/vsem/recommendations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateVsemRecommendation(_response);
        });
    }

    protected processCreateVsemRecommendation(response: AxiosResponse): Promise<VsemRecommendationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VsemRecommendationDto.fromJS(resultData200);
            return Promise.resolve<VsemRecommendationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 422) {
            const _responseText = response.data;
            return throwException("Unprocessable Content", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VsemRecommendationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateVsemRecommendation(recommendationId: string, body: UpdateVsemRecommendationRequest | undefined, cancelToken?: CancelToken): Promise<VsemRecommendationDto> {
        let url_ = this.baseUrl + "/api/Assessments/tpx/vsem/recommendations/{recommendationId}";
        if (recommendationId === undefined || recommendationId === null)
            throw new globalThis.Error("The parameter 'recommendationId' must be defined.");
        url_ = url_.replace("{recommendationId}", encodeURIComponent("" + recommendationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVsemRecommendation(_response);
        });
    }

    protected processUpdateVsemRecommendation(response: AxiosResponse): Promise<VsemRecommendationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VsemRecommendationDto.fromJS(resultData200);
            return Promise.resolve<VsemRecommendationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VsemRecommendationDto>(null as any);
    }

    /**
     * @return No Content
     */
    deleteVsemRecommendation(recommendationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Assessments/tpx/vsem/recommendations/{recommendationId}";
        if (recommendationId === undefined || recommendationId === null)
            throw new globalThis.Error("The parameter 'recommendationId' must be defined.");
        url_ = url_.replace("{recommendationId}", encodeURIComponent("" + recommendationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVsemRecommendation(_response);
        });
    }

    protected processDeleteVsemRecommendation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAssetFilterByCategoryWidgetClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getFilteredAssetByCategory(body: AssetWidgetFilterByCategoryRequest | undefined,  cancelToken?: CancelToken): Promise<AssetWidgetFilterByCategoryResponse>;
}

export class AssetFilterByCategoryWidgetClient extends AuthorizedApiBase implements IAssetFilterByCategoryWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFilteredAssetByCategory(body: AssetWidgetFilterByCategoryRequest | undefined, cancelToken?: CancelToken): Promise<AssetWidgetFilterByCategoryResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-by-category-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredAssetByCategory(_response);
        });
    }

    protected processGetFilteredAssetByCategory(response: AxiosResponse): Promise<AssetWidgetFilterByCategoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetWidgetFilterByCategoryResponse.fromJS(resultData200);
            return Promise.resolve<AssetWidgetFilterByCategoryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetWidgetFilterByCategoryResponse>(null as any);
    }
}

export interface IAssetManagementClient {
    /**
     * Retrieves All Assets for the Customer
     * @param body (optional) 
     * @return OK
     */
    getMyAssets(body: AssetManagementSearchQueryDto | undefined,  cancelToken?: CancelToken): Promise<AssetManagementResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetLocations(body: AssetLocationSearchQueryDto | undefined,  cancelToken?: CancelToken): Promise<AssetLocationsResponse>;
    /**
     * @return OK
     */
    getAssetLocationList( cancelToken?: CancelToken): Promise<AssetLocationsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetLifecycle(body: AssetLifecycleSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<AssetLifecycleResponseDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getProductCatalog(body: AssetProductCatalogSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<AssetProductCatalogResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getMyContracts(body: AssetContractSearchQueryDto | undefined,  cancelToken?: CancelToken): Promise<AssetContractsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getDattoRmmData(body: AssetEndUserDevicesRequestDto | undefined,  cancelToken?: CancelToken): Promise<AssetEndUserDevicesResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetTags(body: DynamicTagsGetRequest | undefined,  cancelToken?: CancelToken): Promise<DynamicTagsGetResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postAssetTags(body: DynamicTagsRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteAssetTags(body: DynamicTagsRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putNotes(body: DynamicTagsRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class AssetManagementClient extends AuthorizedApiBase implements IAssetManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieves All Assets for the Customer
     * @param body (optional) 
     * @return OK
     */
    getMyAssets(body: AssetManagementSearchQueryDto | undefined, cancelToken?: CancelToken): Promise<AssetManagementResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyAssets(_response);
        });
    }

    protected processGetMyAssets(response: AxiosResponse): Promise<AssetManagementResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetManagementResponse.fromJS(resultData200);
            return Promise.resolve<AssetManagementResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetManagementResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetLocations(body: AssetLocationSearchQueryDto | undefined, cancelToken?: CancelToken): Promise<AssetLocationsResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/asset-locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetLocations(_response);
        });
    }

    protected processGetAssetLocations(response: AxiosResponse): Promise<AssetLocationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLocationsResponse.fromJS(resultData200);
            return Promise.resolve<AssetLocationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLocationsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAssetLocationList( cancelToken?: CancelToken): Promise<AssetLocationsResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/asset-location-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetLocationList(_response);
        });
    }

    protected processGetAssetLocationList(response: AxiosResponse): Promise<AssetLocationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLocationsResponse.fromJS(resultData200);
            return Promise.resolve<AssetLocationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLocationsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetLifecycle(body: AssetLifecycleSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<AssetLifecycleResponseDto> {
        let url_ = this.baseUrl + "/api/AssetManagement/asset-lifecycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetLifecycle(_response);
        });
    }

    protected processGetAssetLifecycle(response: AxiosResponse): Promise<AssetLifecycleResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLifecycleResponseDto.fromJS(resultData200);
            return Promise.resolve<AssetLifecycleResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLifecycleResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProductCatalog(body: AssetProductCatalogSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<AssetProductCatalogResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/product-catalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductCatalog(_response);
        });
    }

    protected processGetProductCatalog(response: AxiosResponse): Promise<AssetProductCatalogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetProductCatalogResponse.fromJS(resultData200);
            return Promise.resolve<AssetProductCatalogResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetProductCatalogResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMyContracts(body: AssetContractSearchQueryDto | undefined, cancelToken?: CancelToken): Promise<AssetContractsResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/active-contracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyContracts(_response);
        });
    }

    protected processGetMyContracts(response: AxiosResponse): Promise<AssetContractsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetContractsResponse.fromJS(resultData200);
            return Promise.resolve<AssetContractsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetContractsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDattoRmmData(body: AssetEndUserDevicesRequestDto | undefined, cancelToken?: CancelToken): Promise<AssetEndUserDevicesResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/end-user-devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDattoRmmData(_response);
        });
    }

    protected processGetDattoRmmData(response: AxiosResponse): Promise<AssetEndUserDevicesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetEndUserDevicesResponse.fromJS(resultData200);
            return Promise.resolve<AssetEndUserDevicesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetEndUserDevicesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetTags(body: DynamicTagsGetRequest | undefined, cancelToken?: CancelToken): Promise<DynamicTagsGetResponse> {
        let url_ = this.baseUrl + "/api/AssetManagement/get_tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetTags(_response);
        });
    }

    protected processGetAssetTags(response: AxiosResponse): Promise<DynamicTagsGetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DynamicTagsGetResponse.fromJS(resultData200);
            return Promise.resolve<DynamicTagsGetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicTagsGetResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postAssetTags(body: DynamicTagsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AssetManagement/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAssetTags(_response);
        });
    }

    protected processPostAssetTags(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteAssetTags(body: DynamicTagsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AssetManagement/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAssetTags(_response);
        });
    }

    protected processDeleteAssetTags(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putNotes(body: DynamicTagsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AssetManagement/notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutNotes(_response);
        });
    }

    protected processPutNotes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAssetManagementDownloadClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAssetContracts(body: AssetDownloadContractsRequest | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAssetInventory(body: AssetDownloadInventoryRequest | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAssetLifecycle(body: AssetDownloadLifecycleRequest | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAssetProductCatalog(body: AssetDownloadProductCatalogRequest | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
}

export class AssetManagementDownloadClient extends AuthorizedApiBase implements IAssetManagementDownloadClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAssetContracts(body: AssetDownloadContractsRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/AssetManagementDownload/asset-contracts-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetContracts(_response);
        });
    }

    protected processDownloadAssetContracts(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAssetInventory(body: AssetDownloadInventoryRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/AssetManagementDownload/asset-inventory-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetInventory(_response);
        });
    }

    protected processDownloadAssetInventory(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAssetLifecycle(body: AssetDownloadLifecycleRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/AssetManagementDownload/asset-lifecycle-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetLifecycle(_response);
        });
    }

    protected processDownloadAssetLifecycle(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAssetProductCatalog(body: AssetDownloadProductCatalogRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/AssetManagementDownload/asset-product-catalog-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetProductCatalog(_response);
        });
    }

    protected processDownloadAssetProductCatalog(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }
}

export interface IAssetManagementPicklistClient {
    /**
     * @return OK
     */
    getInventoryPicklist( cancelToken?: CancelToken): Promise<AssetInventoryAggregationDto>;
    /**
     * @return OK
     */
    getLocationPicklist( cancelToken?: CancelToken): Promise<AssetLocationAggregationDto>;
    /**
     * @return OK
     */
    getLifeCyclePicklist( cancelToken?: CancelToken): Promise<AssetLifecycleAggregationDto>;
    /**
     * @return OK
     */
    getProductCatalogPicklist( cancelToken?: CancelToken): Promise<ProductCatalogAggregationDto>;
    /**
     * @return OK
     */
    getContractPicklist( cancelToken?: CancelToken): Promise<AssetContractAggregationDto>;
}

export class AssetManagementPicklistClient extends AuthorizedApiBase implements IAssetManagementPicklistClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getInventoryPicklist( cancelToken?: CancelToken): Promise<AssetInventoryAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/inventory-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInventoryPicklist(_response);
        });
    }

    protected processGetInventoryPicklist(response: AxiosResponse): Promise<AssetInventoryAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetInventoryAggregationDto.fromJS(resultData200);
            return Promise.resolve<AssetInventoryAggregationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetInventoryAggregationDto>(null as any);
    }

    /**
     * @return OK
     */
    getLocationPicklist( cancelToken?: CancelToken): Promise<AssetLocationAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/location-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationPicklist(_response);
        });
    }

    protected processGetLocationPicklist(response: AxiosResponse): Promise<AssetLocationAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLocationAggregationDto.fromJS(resultData200);
            return Promise.resolve<AssetLocationAggregationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLocationAggregationDto>(null as any);
    }

    /**
     * @return OK
     */
    getLifeCyclePicklist( cancelToken?: CancelToken): Promise<AssetLifecycleAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/lifecycle-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLifeCyclePicklist(_response);
        });
    }

    protected processGetLifeCyclePicklist(response: AxiosResponse): Promise<AssetLifecycleAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLifecycleAggregationDto.fromJS(resultData200);
            return Promise.resolve<AssetLifecycleAggregationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLifecycleAggregationDto>(null as any);
    }

    /**
     * @return OK
     */
    getProductCatalogPicklist( cancelToken?: CancelToken): Promise<ProductCatalogAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/product-catalog-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductCatalogPicklist(_response);
        });
    }

    protected processGetProductCatalogPicklist(response: AxiosResponse): Promise<ProductCatalogAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductCatalogAggregationDto.fromJS(resultData200);
            return Promise.resolve<ProductCatalogAggregationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCatalogAggregationDto>(null as any);
    }

    /**
     * @return OK
     */
    getContractPicklist( cancelToken?: CancelToken): Promise<AssetContractAggregationDto> {
        let url_ = this.baseUrl + "/api/AssetManagementPicklist/contract-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractPicklist(_response);
        });
    }

    protected processGetContractPicklist(response: AxiosResponse): Promise<AssetContractAggregationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetContractAggregationDto.fromJS(resultData200);
            return Promise.resolve<AssetContractAggregationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetContractAggregationDto>(null as any);
    }
}

export interface IAssetOverviewWidgetClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetsOverviewWidgetData(body: AssetOverviewWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<AssetOverviewWidgetResponse>;
}

export class AssetOverviewWidgetClient extends AuthorizedApiBase implements IAssetOverviewWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetsOverviewWidgetData(body: AssetOverviewWidgetRequest | undefined, cancelToken?: CancelToken): Promise<AssetOverviewWidgetResponse> {
        let url_ = this.baseUrl + "/api/widget/asset-overview-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsOverviewWidgetData(_response);
        });
    }

    protected processGetAssetsOverviewWidgetData(response: AxiosResponse): Promise<AssetOverviewWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetOverviewWidgetResponse.fromJS(resultData200);
            return Promise.resolve<AssetOverviewWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetOverviewWidgetResponse>(null as any);
    }
}

export interface IAssetsByProductOverviewWidgetClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetsProductOverviewWidgetData(body: AssetsByProductOverviewWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<AssetsByProductOverviewWidgetResponse>;
}

export class AssetsByProductOverviewWidgetClient extends AuthorizedApiBase implements IAssetsByProductOverviewWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetsProductOverviewWidgetData(body: AssetsByProductOverviewWidgetRequest | undefined, cancelToken?: CancelToken): Promise<AssetsByProductOverviewWidgetResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-product-overview-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsProductOverviewWidgetData(_response);
        });
    }

    protected processGetAssetsProductOverviewWidgetData(response: AxiosResponse): Promise<AssetsByProductOverviewWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetsByProductOverviewWidgetResponse.fromJS(resultData200);
            return Promise.resolve<AssetsByProductOverviewWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetsByProductOverviewWidgetResponse>(null as any);
    }
}

export interface IAssetsByUseStateWidgetClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetByUseStateData(body: AssetsByUseStateWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<AssetsByUseStateWidgetResponse>;
}

export class AssetsByUseStateWidgetClient extends AuthorizedApiBase implements IAssetsByUseStateWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetByUseStateData(body: AssetsByUseStateWidgetRequest | undefined, cancelToken?: CancelToken): Promise<AssetsByUseStateWidgetResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-by-use-state-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetByUseStateData(_response);
        });
    }

    protected processGetAssetByUseStateData(response: AxiosResponse): Promise<AssetsByUseStateWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetsByUseStateWidgetResponse.fromJS(resultData200);
            return Promise.resolve<AssetsByUseStateWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetsByUseStateWidgetResponse>(null as any);
    }
}

export interface IAssetsLifecycleManagementClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetsLifecycleManagementWidgetData(body: AssetLifecycleManagementWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<AssetLifecycleManagementWidgetResponseDto>;
}

export class AssetsLifecycleManagementClient extends AuthorizedApiBase implements IAssetsLifecycleManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssetsLifecycleManagementWidgetData(body: AssetLifecycleManagementWidgetRequest | undefined, cancelToken?: CancelToken): Promise<AssetLifecycleManagementWidgetResponseDto> {
        let url_ = this.baseUrl + "/api/widget/assets-lifecycle-management-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsLifecycleManagementWidgetData(_response);
        });
    }

    protected processGetAssetsLifecycleManagementWidgetData(response: AxiosResponse): Promise<AssetLifecycleManagementWidgetResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetLifecycleManagementWidgetResponseDto.fromJS(resultData200);
            return Promise.resolve<AssetLifecycleManagementWidgetResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetLifecycleManagementWidgetResponseDto>(null as any);
    }
}

export interface IAssetsTotalSpendWidgetClient {
    /**
     * @param manufacturer (optional) 
     * @param category (optional) 
     * @param subcategory (optional) 
     * @param assetType (optional) 
     * @return OK
     */
    getTotalSpend(manufacturer: string | undefined, category: string | undefined, subcategory: string | undefined, assetType: string | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsTotalSpendResponse>;
}

export class AssetsTotalSpendWidgetClient extends AuthorizedApiBase implements IAssetsTotalSpendWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param manufacturer (optional) 
     * @param category (optional) 
     * @param subcategory (optional) 
     * @param assetType (optional) 
     * @return OK
     */
    getTotalSpend(manufacturer: string | undefined, category: string | undefined, subcategory: string | undefined, assetType: string | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsTotalSpendResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-total-spend?";
        if (manufacturer === null)
            throw new globalThis.Error("The parameter 'manufacturer' cannot be null.");
        else if (manufacturer !== undefined)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (category === null)
            throw new globalThis.Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (subcategory === null)
            throw new globalThis.Error("The parameter 'subcategory' cannot be null.");
        else if (subcategory !== undefined)
            url_ += "Subcategory=" + encodeURIComponent("" + subcategory) + "&";
        if (assetType === null)
            throw new globalThis.Error("The parameter 'assetType' cannot be null.");
        else if (assetType !== undefined)
            url_ += "AssetType=" + encodeURIComponent("" + assetType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTotalSpend(_response);
        });
    }

    protected processGetTotalSpend(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetAssetsTotalSpendResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetAssetsTotalSpendResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsTotalSpendResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsTotalSpendResponse>(null as any);
    }
}

export interface IAssetsWarehouseOrdersWidgetClient {
    /**
     * @return OK
     */
    getAssetsWarehouseOrdersWidgetData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse>;
}

export class AssetsWarehouseOrdersWidgetClient extends AuthorizedApiBase implements IAssetsWarehouseOrdersWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAssetsWarehouseOrdersWidgetData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-warehouse-orders-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsWarehouseOrdersWidgetData(_response);
        });
    }

    protected processGetAssetsWarehouseOrdersWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse>(null as any);
    }
}

export interface IAssetsWarehouseStockWidgetClient {
    /**
     * @param projectId (optional) 
     * @return OK
     */
    getAssetsWarehouseStockWidgetData(projectId: string | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse>;
}

export class AssetsWarehouseStockWidgetClient extends AuthorizedApiBase implements IAssetsWarehouseStockWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getAssetsWarehouseStockWidgetData(projectId: string | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-warehouse-stock-widget?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsWarehouseStockWidgetData(_response);
        });
    }

    protected processGetAssetsWarehouseStockWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse>(null as any);
    }
}

export interface IAttachmentClient {
    /**
     * @return OK
     */
    downloadFile(guid: string,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return OK
     */
    getAttachmentsOnTicket(ticketId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadAttachmentImage(filepond: FileParameter | undefined, hello: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadAttachmentWithMetadata(filepond: FileParameter | undefined, hello: string | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class AttachmentClient extends AuthorizedApiBase implements IAttachmentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    downloadFile(guid: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/attachments/download/{guid}";
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAttachmentsOnTicket(ticketId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/attachments/ticket/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttachmentsOnTicket(_response);
        });
    }

    protected processGetAttachmentsOnTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadAttachmentImage(filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/attachments/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new globalThis.Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAttachmentImage(_response);
        });
    }

    protected processUploadAttachmentImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadAttachmentWithMetadata(filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/attachments/process-with-metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new globalThis.Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAttachmentWithMetadata(_response);
        });
    }

    protected processUploadAttachmentWithMetadata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAuthorizationClient {
    /**
     * @return OK
     */
    getUserClaims( cancelToken?: CancelToken): Promise<ClaimDto[]>;
}

export class AuthorizationClient extends AuthorizedApiBase implements IAuthorizationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getUserClaims( cancelToken?: CancelToken): Promise<ClaimDto[]> {
        let url_ = this.baseUrl + "/api/Authorization/Claims";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserClaims(_response);
        });
    }

    protected processGetUserClaims(response: AxiosResponse): Promise<ClaimDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ClaimDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimDto[]>(null as any);
    }
}

export interface IAutotaskDataExchangeClient {
    /**
     * @param idGreaterThanOrEqual (optional) 
     * @param idLessThanOrEqual (optional) 
     * @param lastActivityDateFrom (optional) 
     * @param lastActivityDateTo (optional) 
     * @param includeDeleted (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    getTicketsMetadata(idGreaterThanOrEqual: number | undefined, idLessThanOrEqual: number | undefined, lastActivityDateFrom: Date | undefined, lastActivityDateTo: Date | undefined, includeDeleted: boolean | undefined, pageSize: number | undefined, orderBy: OrderBy | undefined,  cancelToken?: CancelToken): Promise<TicketMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getTicketsMetadataByIds(body: number[] | undefined,  cancelToken?: CancelToken): Promise<TicketMetadataDto[]>;
    /**
     * @param idGreaterThanOrEqual (optional) 
     * @param idLessThanOrEqual (optional) 
     * @param lastActivityDateFrom (optional) 
     * @param lastActivityDateTo (optional) 
     * @param includeDeleted (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    getTicketNotesMetadata(idGreaterThanOrEqual: number | undefined, idLessThanOrEqual: number | undefined, lastActivityDateFrom: Date | undefined, lastActivityDateTo: Date | undefined, includeDeleted: boolean | undefined, pageSize: number | undefined, orderBy: OrderBy | undefined,  cancelToken?: CancelToken): Promise<TicketNoteMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getTicketNotesMetadataByIds(body: number[] | undefined,  cancelToken?: CancelToken): Promise<TicketNoteMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getTimeEntriesMetadataByIds(body: number[] | undefined,  cancelToken?: CancelToken): Promise<TimeEntryMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getServiceLevelAgreementResultsMetadataByIds(body: number[] | undefined,  cancelToken?: CancelToken): Promise<ServiceLevelAgreementResultMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSurveyResultMetadataByIds(body: number[] | undefined,  cancelToken?: CancelToken): Promise<SurveyResultMetadataDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getBillingItemMetadataByIds(body: number[] | undefined,  cancelToken?: CancelToken): Promise<BillingItemMetadataDto[]>;
}

export class AutotaskDataExchangeClient extends AuthorizedApiBase implements IAutotaskDataExchangeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param idGreaterThanOrEqual (optional) 
     * @param idLessThanOrEqual (optional) 
     * @param lastActivityDateFrom (optional) 
     * @param lastActivityDateTo (optional) 
     * @param includeDeleted (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    getTicketsMetadata(idGreaterThanOrEqual: number | undefined, idLessThanOrEqual: number | undefined, lastActivityDateFrom: Date | undefined, lastActivityDateTo: Date | undefined, includeDeleted: boolean | undefined, pageSize: number | undefined, orderBy: OrderBy | undefined, cancelToken?: CancelToken): Promise<TicketMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/tickets/metadata?";
        if (idGreaterThanOrEqual === null)
            throw new globalThis.Error("The parameter 'idGreaterThanOrEqual' cannot be null.");
        else if (idGreaterThanOrEqual !== undefined)
            url_ += "IdGreaterThanOrEqual=" + encodeURIComponent("" + idGreaterThanOrEqual) + "&";
        if (idLessThanOrEqual === null)
            throw new globalThis.Error("The parameter 'idLessThanOrEqual' cannot be null.");
        else if (idLessThanOrEqual !== undefined)
            url_ += "IdLessThanOrEqual=" + encodeURIComponent("" + idLessThanOrEqual) + "&";
        if (lastActivityDateFrom === null)
            throw new globalThis.Error("The parameter 'lastActivityDateFrom' cannot be null.");
        else if (lastActivityDateFrom !== undefined)
            url_ += "LastActivityDateFrom=" + encodeURIComponent(lastActivityDateFrom ? "" + lastActivityDateFrom.toISOString() : "") + "&";
        if (lastActivityDateTo === null)
            throw new globalThis.Error("The parameter 'lastActivityDateTo' cannot be null.");
        else if (lastActivityDateTo !== undefined)
            url_ += "LastActivityDateTo=" + encodeURIComponent(lastActivityDateTo ? "" + lastActivityDateTo.toISOString() : "") + "&";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketsMetadata(_response);
        });
    }

    protected processGetTicketsMetadata(response: AxiosResponse): Promise<TicketMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketMetadataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TicketMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTicketsMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<TicketMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/tickets/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketsMetadataByIds(_response);
        });
    }

    protected processGetTicketsMetadataByIds(response: AxiosResponse): Promise<TicketMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketMetadataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TicketMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketMetadataDto[]>(null as any);
    }

    /**
     * @param idGreaterThanOrEqual (optional) 
     * @param idLessThanOrEqual (optional) 
     * @param lastActivityDateFrom (optional) 
     * @param lastActivityDateTo (optional) 
     * @param includeDeleted (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    getTicketNotesMetadata(idGreaterThanOrEqual: number | undefined, idLessThanOrEqual: number | undefined, lastActivityDateFrom: Date | undefined, lastActivityDateTo: Date | undefined, includeDeleted: boolean | undefined, pageSize: number | undefined, orderBy: OrderBy | undefined, cancelToken?: CancelToken): Promise<TicketNoteMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/ticket-notes/metadata?";
        if (idGreaterThanOrEqual === null)
            throw new globalThis.Error("The parameter 'idGreaterThanOrEqual' cannot be null.");
        else if (idGreaterThanOrEqual !== undefined)
            url_ += "IdGreaterThanOrEqual=" + encodeURIComponent("" + idGreaterThanOrEqual) + "&";
        if (idLessThanOrEqual === null)
            throw new globalThis.Error("The parameter 'idLessThanOrEqual' cannot be null.");
        else if (idLessThanOrEqual !== undefined)
            url_ += "IdLessThanOrEqual=" + encodeURIComponent("" + idLessThanOrEqual) + "&";
        if (lastActivityDateFrom === null)
            throw new globalThis.Error("The parameter 'lastActivityDateFrom' cannot be null.");
        else if (lastActivityDateFrom !== undefined)
            url_ += "LastActivityDateFrom=" + encodeURIComponent(lastActivityDateFrom ? "" + lastActivityDateFrom.toISOString() : "") + "&";
        if (lastActivityDateTo === null)
            throw new globalThis.Error("The parameter 'lastActivityDateTo' cannot be null.");
        else if (lastActivityDateTo !== undefined)
            url_ += "LastActivityDateTo=" + encodeURIComponent(lastActivityDateTo ? "" + lastActivityDateTo.toISOString() : "") + "&";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketNotesMetadata(_response);
        });
    }

    protected processGetTicketNotesMetadata(response: AxiosResponse): Promise<TicketNoteMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketNoteMetadataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TicketNoteMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketNoteMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTicketNotesMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<TicketNoteMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/ticket-notes/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketNotesMetadataByIds(_response);
        });
    }

    protected processGetTicketNotesMetadataByIds(response: AxiosResponse): Promise<TicketNoteMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketNoteMetadataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TicketNoteMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketNoteMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTimeEntriesMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<TimeEntryMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/time-entries/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeEntriesMetadataByIds(_response);
        });
    }

    protected processGetTimeEntriesMetadataByIds(response: AxiosResponse): Promise<TimeEntryMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeEntryMetadataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TimeEntryMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getServiceLevelAgreementResultsMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<ServiceLevelAgreementResultMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/service-level-agreement-results/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceLevelAgreementResultsMetadataByIds(_response);
        });
    }

    protected processGetServiceLevelAgreementResultsMetadataByIds(response: AxiosResponse): Promise<ServiceLevelAgreementResultMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceLevelAgreementResultMetadataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceLevelAgreementResultMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceLevelAgreementResultMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSurveyResultMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<SurveyResultMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/survey-results/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyResultMetadataByIds(_response);
        });
    }

    protected processGetSurveyResultMetadataByIds(response: AxiosResponse): Promise<SurveyResultMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyResultMetadataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SurveyResultMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResultMetadataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getBillingItemMetadataByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<BillingItemMetadataDto[]> {
        let url_ = this.baseUrl + "/api/data/AutotaskDataExchange/billing-item-results/metadata-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillingItemMetadataByIds(_response);
        });
    }

    protected processGetBillingItemMetadataByIds(response: AxiosResponse): Promise<BillingItemMetadataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingItemMetadataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BillingItemMetadataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillingItemMetadataDto[]>(null as any);
    }
}

export interface IAutoTaskResourceClient {
    /**
     * Get multiple Autotask resources (users) by resource IDs.
     * @param body (optional) Payload containing an array of Autotask resource IDs
     * @return OK
     */
    getResourcesByIds(body: AutoTaskResourceController_ResourceIdsRequest | undefined,  cancelToken?: CancelToken): Promise<Resource[]>;
}

export class AutoTaskResourceClient extends AuthorizedApiBase implements IAutoTaskResourceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get multiple Autotask resources (users) by resource IDs.
     * @param body (optional) Payload containing an array of Autotask resource IDs
     * @return OK
     */
    getResourcesByIds(body: AutoTaskResourceController_ResourceIdsRequest | undefined, cancelToken?: CancelToken): Promise<Resource[]> {
        let url_ = this.baseUrl + "/api/task/resources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourcesByIds(_response);
        });
    }

    protected processGetResourcesByIds(response: AxiosResponse): Promise<Resource[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Resource.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Resource[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Resource[]>(null as any);
    }
}

export interface IAutoTaskWebhookClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    handleNewWebhookEvent(body: AutoTaskWebhookDTO | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class AutoTaskWebhookClient extends AuthorizedApiBase implements IAutoTaskWebhookClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    handleNewWebhookEvent(body: AutoTaskWebhookDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/AutoTaskWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHandleNewWebhookEvent(_response);
        });
    }

    protected processHandleNewWebhookEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAwsAccountClient {
    /**
     * Creates a new AWS account in the specified payer organization.
    Submit-and-inform pattern: request is saved to database and processed asynchronously by nightly sync.
     * @param body (optional) Account creation request details
     * @return OK
     */
    createAccount(body: CreateAccountRequest | undefined,  cancelToken?: CancelToken): Promise<CreateAccountResponse>;
    /**
     * Invites an existing AWS account to join the specified payer organization.
    Submit-and-inform pattern: request is saved to database and processed asynchronously by nightly sync.
     * @param body (optional) Account invitation request details
     * @return OK
     */
    inviteAccount(body: InviteAccountRequest | undefined,  cancelToken?: CancelToken): Promise<InviteAccountResponse>;
}

export class AwsAccountClient extends AuthorizedApiBase implements IAwsAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Creates a new AWS account in the specified payer organization.
    Submit-and-inform pattern: request is saved to database and processed asynchronously by nightly sync.
     * @param body (optional) Account creation request details
     * @return OK
     */
    createAccount(body: CreateAccountRequest | undefined, cancelToken?: CancelToken): Promise<CreateAccountResponse> {
        let url_ = this.baseUrl + "/api/aws/organizations/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAccount(_response);
        });
    }

    protected processCreateAccount(response: AxiosResponse): Promise<CreateAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateAccountResponse.fromJS(resultData200);
            return Promise.resolve<CreateAccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateAccountResponse>(null as any);
    }

    /**
     * Invites an existing AWS account to join the specified payer organization.
    Submit-and-inform pattern: request is saved to database and processed asynchronously by nightly sync.
     * @param body (optional) Account invitation request details
     * @return OK
     */
    inviteAccount(body: InviteAccountRequest | undefined, cancelToken?: CancelToken): Promise<InviteAccountResponse> {
        let url_ = this.baseUrl + "/api/aws/organizations/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInviteAccount(_response);
        });
    }

    protected processInviteAccount(response: AxiosResponse): Promise<InviteAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteAccountResponse.fromJS(resultData200);
            return Promise.resolve<InviteAccountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteAccountResponse>(null as any);
    }
}

export interface IAwsPotentialSavingsWidgetClient {
    /**
     * @return OK
     */
    getAwsPotentialSavingsWidget( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto>;
}

export class AwsPotentialSavingsWidgetClient extends AuthorizedApiBase implements IAwsPotentialSavingsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAwsPotentialSavingsWidget( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/aws-potential-savings-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAwsPotentialSavingsWidget(_response);
        });
    }

    protected processGetAwsPotentialSavingsWidget(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto>(null as any);
    }
}

export interface IAwsSimpleRecommendationsClient {
    /**
     * Gets a Customers Trusted Advisor Check Results, Summaries and Descriptions.
     * @return OK
     */
    getTrustedAdvisor( cancelToken?: CancelToken): Promise<TrustedAdvisorResult[]>;
    /**
     * Gets Customers Reservation Purchase Recommendation data.
     * @param body (optional) 
     * @return OK
     */
    getReservationPurchaseRecommendations(body: AwsReservationSearchRequest | undefined,  cancelToken?: CancelToken): Promise<ReservationPurchaseResult[]>;
    /**
     * Gets Customer Rightsizing Recommendation data.
     * @param body (optional) 
     * @return OK
     */
    getRightsizingRecommendations(body: AwsRightsizingSearchRequest | undefined,  cancelToken?: CancelToken): Promise<RightSizingResult[]>;
    /**
     * Gets a customers Savings Plan Purchase Recommendation Data.
     * @return OK
     */
    getSavingsPlanRecommendations( cancelToken?: CancelToken): Promise<SavingsPlansPurchaseResult[]>;
}

export class AwsSimpleRecommendationsClient extends AuthorizedApiBase implements IAwsSimpleRecommendationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Customers Trusted Advisor Check Results, Summaries and Descriptions.
     * @return OK
     */
    getTrustedAdvisor( cancelToken?: CancelToken): Promise<TrustedAdvisorResult[]> {
        let url_ = this.baseUrl + "/api/AwsSimpleRecommendations/trusted-advisor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrustedAdvisor(_response);
        });
    }

    protected processGetTrustedAdvisor(response: AxiosResponse): Promise<TrustedAdvisorResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrustedAdvisorResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TrustedAdvisorResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrustedAdvisorResult[]>(null as any);
    }

    /**
     * Gets Customers Reservation Purchase Recommendation data.
     * @param body (optional) 
     * @return OK
     */
    getReservationPurchaseRecommendations(body: AwsReservationSearchRequest | undefined, cancelToken?: CancelToken): Promise<ReservationPurchaseResult[]> {
        let url_ = this.baseUrl + "/api/AwsSimpleRecommendations/reservation-purchase-recommendations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReservationPurchaseRecommendations(_response);
        });
    }

    protected processGetReservationPurchaseRecommendations(response: AxiosResponse): Promise<ReservationPurchaseResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationPurchaseResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ReservationPurchaseResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReservationPurchaseResult[]>(null as any);
    }

    /**
     * Gets Customer Rightsizing Recommendation data.
     * @param body (optional) 
     * @return OK
     */
    getRightsizingRecommendations(body: AwsRightsizingSearchRequest | undefined, cancelToken?: CancelToken): Promise<RightSizingResult[]> {
        let url_ = this.baseUrl + "/api/AwsSimpleRecommendations/rightsizing-recommendations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRightsizingRecommendations(_response);
        });
    }

    protected processGetRightsizingRecommendations(response: AxiosResponse): Promise<RightSizingResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RightSizingResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RightSizingResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RightSizingResult[]>(null as any);
    }

    /**
     * Gets a customers Savings Plan Purchase Recommendation Data.
     * @return OK
     */
    getSavingsPlanRecommendations( cancelToken?: CancelToken): Promise<SavingsPlansPurchaseResult[]> {
        let url_ = this.baseUrl + "/api/AwsSimpleRecommendations/savings-plan-recommendations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSavingsPlanRecommendations(_response);
        });
    }

    protected processGetSavingsPlanRecommendations(response: AxiosResponse): Promise<SavingsPlansPurchaseResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SavingsPlansPurchaseResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SavingsPlansPurchaseResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SavingsPlansPurchaseResult[]>(null as any);
    }
}

export interface IAXInvoiceClient {
    /**
     * @return OK
     */
    getInvoicesByTag(tag: string,  cancelToken?: CancelToken): Promise<Invoice_Response>;
    /**
     * @return OK
     */
    getInvoicesByTagAndProjectName(tag: string, projectName: string,  cancelToken?: CancelToken): Promise<Invoice_Response>;
    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getInvoicesByMonth(startDate: Date | undefined, endDate: Date | undefined,  cancelToken?: CancelToken): Promise<InvoicesByMonthResponseDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    requestInvoices(tag: string, projectName: string, body: InvoiceEmail_Request | undefined,  cancelToken?: CancelToken): Promise<InvoiceEmail_Response>;
    /**
     * @param body (optional) 
     * @return OK
     */
    sendInvoicesToEmail(body: EmailInvoicesDto | undefined,  cancelToken?: CancelToken): Promise<InvoiceEmail_Response>;
    /**
     * @param body (optional) 
     * @return OK
     */
    sendOrderInvoicesToEmail(body: EmailInvoicesDto | undefined,  cancelToken?: CancelToken): Promise<InvoiceEmail_Response>;
    /**
     * @return OK
     */
    lastMonthsInvoiceCost(lastMonthsCostType: LastMonthsCostType,  cancelToken?: CancelToken): Promise<LastMonthsCostDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    searchInvoices(body: InvoiceSearchFilterDto | undefined,  cancelToken?: CancelToken): Promise<PagedInvoiceResponseDto>;
}

export class AXInvoiceClient extends AuthorizedApiBase implements IAXInvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getInvoicesByTag(tag: string, cancelToken?: CancelToken): Promise<Invoice_Response> {
        let url_ = this.baseUrl + "/api/invoice/{tag}";
        if (tag === undefined || tag === null)
            throw new globalThis.Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicesByTag(_response);
        });
    }

    protected processGetInvoicesByTag(response: AxiosResponse): Promise<Invoice_Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Invoice_Response.fromJS(resultData200);
            return Promise.resolve<Invoice_Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice_Response>(null as any);
    }

    /**
     * @return OK
     */
    getInvoicesByTagAndProjectName(tag: string, projectName: string, cancelToken?: CancelToken): Promise<Invoice_Response> {
        let url_ = this.baseUrl + "/api/invoice/{tag}/{projectName}";
        if (tag === undefined || tag === null)
            throw new globalThis.Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        if (projectName === undefined || projectName === null)
            throw new globalThis.Error("The parameter 'projectName' must be defined.");
        url_ = url_.replace("{projectName}", encodeURIComponent("" + projectName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicesByTagAndProjectName(_response);
        });
    }

    protected processGetInvoicesByTagAndProjectName(response: AxiosResponse): Promise<Invoice_Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Invoice_Response.fromJS(resultData200);
            return Promise.resolve<Invoice_Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice_Response>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getInvoicesByMonth(startDate: Date | undefined, endDate: Date | undefined, cancelToken?: CancelToken): Promise<InvoicesByMonthResponseDto> {
        let url_ = this.baseUrl + "/api/invoice/month?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicesByMonth(_response);
        });
    }

    protected processGetInvoicesByMonth(response: AxiosResponse): Promise<InvoicesByMonthResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoicesByMonthResponseDto.fromJS(resultData200);
            return Promise.resolve<InvoicesByMonthResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoicesByMonthResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestInvoices(tag: string, projectName: string, body: InvoiceEmail_Request | undefined, cancelToken?: CancelToken): Promise<InvoiceEmail_Response> {
        let url_ = this.baseUrl + "/api/invoice/email/{tag}/{projectName}";
        if (tag === undefined || tag === null)
            throw new globalThis.Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        if (projectName === undefined || projectName === null)
            throw new globalThis.Error("The parameter 'projectName' must be defined.");
        url_ = url_.replace("{projectName}", encodeURIComponent("" + projectName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestInvoices(_response);
        });
    }

    protected processRequestInvoices(response: AxiosResponse): Promise<InvoiceEmail_Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceEmail_Response.fromJS(resultData200);
            return Promise.resolve<InvoiceEmail_Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceEmail_Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendInvoicesToEmail(body: EmailInvoicesDto | undefined, cancelToken?: CancelToken): Promise<InvoiceEmail_Response> {
        let url_ = this.baseUrl + "/api/invoice/email-invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendInvoicesToEmail(_response);
        });
    }

    protected processSendInvoicesToEmail(response: AxiosResponse): Promise<InvoiceEmail_Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceEmail_Response.fromJS(resultData200);
            return Promise.resolve<InvoiceEmail_Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceEmail_Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendOrderInvoicesToEmail(body: EmailInvoicesDto | undefined, cancelToken?: CancelToken): Promise<InvoiceEmail_Response> {
        let url_ = this.baseUrl + "/api/invoice/order-invoices-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendOrderInvoicesToEmail(_response);
        });
    }

    protected processSendOrderInvoicesToEmail(response: AxiosResponse): Promise<InvoiceEmail_Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceEmail_Response.fromJS(resultData200);
            return Promise.resolve<InvoiceEmail_Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceEmail_Response>(null as any);
    }

    /**
     * @return OK
     */
    lastMonthsInvoiceCost(lastMonthsCostType: LastMonthsCostType, cancelToken?: CancelToken): Promise<LastMonthsCostDto> {
        let url_ = this.baseUrl + "/api/invoice/last-months-cost/{lastMonthsCostType}";
        if (lastMonthsCostType === undefined || lastMonthsCostType === null)
            throw new globalThis.Error("The parameter 'lastMonthsCostType' must be defined.");
        url_ = url_.replace("{lastMonthsCostType}", encodeURIComponent("" + lastMonthsCostType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLastMonthsInvoiceCost(_response);
        });
    }

    protected processLastMonthsInvoiceCost(response: AxiosResponse): Promise<LastMonthsCostDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LastMonthsCostDto.fromJS(resultData200);
            return Promise.resolve<LastMonthsCostDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LastMonthsCostDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchInvoices(body: InvoiceSearchFilterDto | undefined, cancelToken?: CancelToken): Promise<PagedInvoiceResponseDto> {
        let url_ = this.baseUrl + "/api/invoice/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoices(_response);
        });
    }

    protected processSearchInvoices(response: AxiosResponse): Promise<PagedInvoiceResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedInvoiceResponseDto.fromJS(resultData200);
            return Promise.resolve<PagedInvoiceResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedInvoiceResponseDto>(null as any);
    }
}

export interface IAzureBackupsClient {
    /**
     * Gets a given customer's Azure Backups by Subscription Id.
     * @return OK
     */
    getAzureBackups( cancelToken?: CancelToken): Promise<SimpleProtectedItemResource[]>;
}

export class AzureBackupsClient extends AuthorizedApiBase implements IAzureBackupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a given customer's Azure Backups by Subscription Id.
     * @return OK
     */
    getAzureBackups( cancelToken?: CancelToken): Promise<SimpleProtectedItemResource[]> {
        let url_ = this.baseUrl + "/api/AzureBackups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureBackups(_response);
        });
    }

    protected processGetAzureBackups(response: AxiosResponse): Promise<SimpleProtectedItemResource[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleProtectedItemResource.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SimpleProtectedItemResource[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleProtectedItemResource[]>(null as any);
    }
}

export interface IAzureComplianceClient {
    /**
     * Gets azure compliance data from the Collectors Web Api.
     * @return OK
     */
    getAzureComplianceData( cancelToken?: CancelToken): Promise<Subscription[]>;
    /**
     * Gets azure compliance data by subscription id from the Collectors Web Api.
     * @param subscriptionId The subscription id we will search with
     * @return OK
     */
    getAzureComplianceBySubscriptionData(subscriptionId: string,  cancelToken?: CancelToken): Promise<Subscription>;
}

export class AzureComplianceClient extends AuthorizedApiBase implements IAzureComplianceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets azure compliance data from the Collectors Web Api.
     * @return OK
     */
    getAzureComplianceData( cancelToken?: CancelToken): Promise<Subscription[]> {
        let url_ = this.baseUrl + "/api/AzureCompliance/subscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureComplianceData(_response);
        });
    }

    protected processGetAzureComplianceData(response: AxiosResponse): Promise<Subscription[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Subscription.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Subscription[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Subscription[]>(null as any);
    }

    /**
     * Gets azure compliance data by subscription id from the Collectors Web Api.
     * @param subscriptionId The subscription id we will search with
     * @return OK
     */
    getAzureComplianceBySubscriptionData(subscriptionId: string, cancelToken?: CancelToken): Promise<Subscription> {
        let url_ = this.baseUrl + "/api/AzureCompliance/subscription/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureComplianceBySubscriptionData(_response);
        });
    }

    protected processGetAzureComplianceBySubscriptionData(response: AxiosResponse): Promise<Subscription> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Subscription.fromJS(resultData200);
            return Promise.resolve<Subscription>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Subscription>(null as any);
    }
}

export interface IAzureSimpleRecommendationsClient {
    /**
     * Gets a given customer's Azure Recommendations by Subscription Id.
     * @return OK
     */
    getAzureSimpleRecommendations( cancelToken?: CancelToken): Promise<ResourceRecommendation[]>;
    /**
     * Gets Azure Recommendations by Subscription Id.
     * @param subscriptionId The subscription id we will search with
     * @return OK
     */
    getAzureSimpleRecommendationsBySubscriptionId(subscriptionId: string,  cancelToken?: CancelToken): Promise<ResourceRecommendation[]>;
    /**
     * Gets a summary of Azure Recommendations grouped by recommendation type for the current account.
     * @return OK
     */
    getAzureSimpleRecommendationsSummary( cancelToken?: CancelToken): Promise<AzureRecommendationsSummaryResponseDto>;
}

export class AzureSimpleRecommendationsClient extends AuthorizedApiBase implements IAzureSimpleRecommendationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a given customer's Azure Recommendations by Subscription Id.
     * @return OK
     */
    getAzureSimpleRecommendations( cancelToken?: CancelToken): Promise<ResourceRecommendation[]> {
        let url_ = this.baseUrl + "/api/AzureSimpleRecommendations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureSimpleRecommendations(_response);
        });
    }

    protected processGetAzureSimpleRecommendations(response: AxiosResponse): Promise<ResourceRecommendation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceRecommendation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ResourceRecommendation[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceRecommendation[]>(null as any);
    }

    /**
     * Gets Azure Recommendations by Subscription Id.
     * @param subscriptionId The subscription id we will search with
     * @return OK
     */
    getAzureSimpleRecommendationsBySubscriptionId(subscriptionId: string, cancelToken?: CancelToken): Promise<ResourceRecommendation[]> {
        let url_ = this.baseUrl + "/api/AzureSimpleRecommendations/simple/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureSimpleRecommendationsBySubscriptionId(_response);
        });
    }

    protected processGetAzureSimpleRecommendationsBySubscriptionId(response: AxiosResponse): Promise<ResourceRecommendation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceRecommendation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ResourceRecommendation[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceRecommendation[]>(null as any);
    }

    /**
     * Gets a summary of Azure Recommendations grouped by recommendation type for the current account.
     * @return OK
     */
    getAzureSimpleRecommendationsSummary( cancelToken?: CancelToken): Promise<AzureRecommendationsSummaryResponseDto> {
        let url_ = this.baseUrl + "/api/AzureSimpleRecommendations/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureSimpleRecommendationsSummary(_response);
        });
    }

    protected processGetAzureSimpleRecommendationsSummary(response: AxiosResponse): Promise<AzureRecommendationsSummaryResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AzureRecommendationsSummaryResponseDto.fromJS(resultData200);
            return Promise.resolve<AzureRecommendationsSummaryResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureRecommendationsSummaryResponseDto>(null as any);
    }
}

export interface IAzureSubscriptionClient {
    /**
     * Creates a new Azure Subscription on behalf of a customer.
     * @param body (optional) 
     * @return OK
     */
    putSubscription(body: AzureCreateSubscriptionRequest | undefined,  cancelToken?: CancelToken): Promise<AzureSubscriptionResponse>;
    /**
     * Gets a list of pending subscriptions.
     * @return OK
     */
    getPendingSubscriptions( cancelToken?: CancelToken): Promise<AzureSubscriptionStatusResponse>;
}

export class AzureSubscriptionClient extends AuthorizedApiBase implements IAzureSubscriptionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Creates a new Azure Subscription on behalf of a customer.
     * @param body (optional) 
     * @return OK
     */
    putSubscription(body: AzureCreateSubscriptionRequest | undefined, cancelToken?: CancelToken): Promise<AzureSubscriptionResponse> {
        let url_ = this.baseUrl + "/api/AzureSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutSubscription(_response);
        });
    }

    protected processPutSubscription(response: AxiosResponse): Promise<AzureSubscriptionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AzureSubscriptionResponse.fromJS(resultData200);
            return Promise.resolve<AzureSubscriptionResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureSubscriptionResponse>(null as any);
    }

    /**
     * Gets a list of pending subscriptions.
     * @return OK
     */
    getPendingSubscriptions( cancelToken?: CancelToken): Promise<AzureSubscriptionStatusResponse> {
        let url_ = this.baseUrl + "/api/AzureSubscription/status/pending";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPendingSubscriptions(_response);
        });
    }

    protected processGetPendingSubscriptions(response: AxiosResponse): Promise<AzureSubscriptionStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AzureSubscriptionStatusResponse.fromJS(resultData200);
            return Promise.resolve<AzureSubscriptionStatusResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureSubscriptionStatusResponse>(null as any);
    }
}

export interface IBackupClient {
    /**
     * @return OK
     */
    getAzureAlerts( cancelToken?: CancelToken): Promise<AzureBackupAlert[]>;
}

export class BackupClient extends AuthorizedApiBase implements IBackupClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAzureAlerts( cancelToken?: CancelToken): Promise<AzureBackupAlert[]> {
        let url_ = this.baseUrl + "/api/backup/azure/alerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureAlerts(_response);
        });
    }

    protected processGetAzureAlerts(response: AxiosResponse): Promise<AzureBackupAlert[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureBackupAlert.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AzureBackupAlert[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureBackupAlert[]>(null as any);
    }
}

export interface IBookmarkClient {
    /**
     * @return OK
     */
    getAllBookmarks(reportId: string,  cancelToken?: CancelToken): Promise<BookmarksDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addBookmark(body: BookmarkDto | undefined,  cancelToken?: CancelToken): Promise<Bookmark>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateBookmark(body: BookmarkDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteBookmark(body: BookmarkDto | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class BookmarkClient extends AuthorizedApiBase implements IBookmarkClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAllBookmarks(reportId: string, cancelToken?: CancelToken): Promise<BookmarksDto> {
        let url_ = this.baseUrl + "/api/Bookmarks/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new globalThis.Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBookmarks(_response);
        });
    }

    protected processGetAllBookmarks(response: AxiosResponse): Promise<BookmarksDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookmarksDto.fromJS(resultData200);
            return Promise.resolve<BookmarksDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookmarksDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addBookmark(body: BookmarkDto | undefined, cancelToken?: CancelToken): Promise<Bookmark> {
        let url_ = this.baseUrl + "/api/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddBookmark(_response);
        });
    }

    protected processAddBookmark(response: AxiosResponse): Promise<Bookmark> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Bookmark.fromJS(resultData200);
            return Promise.resolve<Bookmark>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Bookmark>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBookmark(body: BookmarkDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBookmark(_response);
        });
    }

    protected processUpdateBookmark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteBookmark(body: BookmarkDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBookmark(_response);
        });
    }

    protected processDeleteBookmark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IBusinessUnitClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    updateBusinessPathAccount(body: BusinessPathAccount[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateBusinessPaths(body: BusinessPath[] | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class BusinessUnitClient extends AuthorizedApiBase implements IBusinessUnitClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBusinessPathAccount(body: BusinessPathAccount[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BusinessUnit/update-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBusinessPathAccount(_response);
        });
    }

    protected processUpdateBusinessPathAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBusinessPaths(body: BusinessPath[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BusinessUnit/update-paths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBusinessPaths(_response);
        });
    }

    protected processUpdateBusinessPaths(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICheckoutClient {
    /**
     * Runs the routing state machine and returns the allowed payment methods with their routes. Without
    billingCountryCode a card that may still go to AX routes to Unknown.
     * @param billingCountryCode (optional) 
     * @return OK
     */
    getCheckoutPaymentMethod(billingCountryCode: string | undefined,  cancelToken?: CancelToken): Promise<CheckoutPaymentMethodRouteDto[]>;
    /**
     * Returns the cart's open checkout session, creating one when needed. Called when the checkout page loads and
    after a `503`, which reprices a session that has an address and a shipping method but no totals.
     * @return OK
     */
    getOrCreateCheckoutSession( cancelToken?: CancelToken): Promise<CheckoutSessionDto>;
    /**
     * Sets the ship-to address, clears the shipping method, and returns every shipping method with its freight.
    The address is priced with zero freight and those totals are stored until a method is selected.
     * @return OK
     */
    setCheckoutSessionShipTo(body: UpdateCheckoutSessionShipToRequestDto,  cancelToken?: CancelToken): Promise<CheckoutSessionDto>;
    /**
     * Sets the shipping method and stores the freight, recycling fee, and tax priced for it.
     * @return OK
     */
    setCheckoutSessionShippingMethod(body: UpdateCheckoutSessionShippingMethodRequestDto,  cancelToken?: CancelToken): Promise<CheckoutSessionDto>;
    /**
     * Sets the PO number written with the order; a blank value clears it. Net terms needs it before
    `POST /checkout`. Returns the session with a new version.
     * @return OK
     */
    setCheckoutSessionPoNumber(body: UpdateCheckoutSessionPoNumberRequestDto,  cancelToken?: CancelToken): Promise<CheckoutSessionDto>;
    /**
     * Card routes. Called when the card number is complete. The request route must still be offered by the routing
    state machine (`409 RouteChanged` otherwise). The session id must be the cart's open session and the route's
    checks (expiration, accepted brand, threshold) must pass before the attempt is created in Setup and
    the gateway's setup step runs. A resend with the same key supersedes the attempt and answers
    `409 SetupRequired`. The request body is never logged.
     * @return OK
     */
    setupCheckoutPayment(body: CheckoutPaymentSetupRequestDto,  cancelToken?: CancelToken): Promise<CheckoutPaymentSetupResultDto>;
    /**
     * Places the order. The request route must still be offered by the routing state machine (`409 RouteChanged`
    otherwise). Card routes pay the attempt created by `payment-setup`; net terms needs a PO number. On success
    the orchestrator writes the web order, completes the attempt and the session, empties the cart, and the response
    is `Completed` with the legacy `webOrderId`. The request body is never logged.
     * @return OK
     */
    submitCheckout(body: CheckoutSubmitRequestDto,  cancelToken?: CancelToken): Promise<CheckoutSubmitResultDto>;
    /**
     * Returns the stored status of the caller's payment attempt so a frozen checkout can poll after a client timeout
    or `Unknown`. Read-only: it never calls a gateway or runs the order step. On `Authorized` the client
    resends `POST /checkout` with the same key to finish the order. Unknown keys and other callers' attempts
    return 404.
     * @return OK
     */
    getCheckoutAttempt(idempotencyKey: string,  cancelToken?: CancelToken): Promise<CheckoutSubmitResultDto>;
    /**
     * Resumes an `AwaitingCustomer` attempt after the step-up challenge, with the same body as
    `POST /checkout`. On success the response is `Completed` with the legacy `webOrderId`.
     * @return OK
     */
    completeCheckoutChallenge(body: CheckoutSubmitRequestDto,  cancelToken?: CancelToken): Promise<CheckoutSubmitResultDto>;
}

export class CheckoutClient extends AuthorizedApiBase implements ICheckoutClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Runs the routing state machine and returns the allowed payment methods with their routes. Without
    billingCountryCode a card that may still go to AX routes to Unknown.
     * @param billingCountryCode (optional) 
     * @return OK
     */
    getCheckoutPaymentMethod(billingCountryCode: string | undefined, cancelToken?: CancelToken): Promise<CheckoutPaymentMethodRouteDto[]> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/payment-method?";
        if (billingCountryCode === null)
            throw new globalThis.Error("The parameter 'billingCountryCode' cannot be null.");
        else if (billingCountryCode !== undefined)
            url_ += "billingCountryCode=" + encodeURIComponent("" + billingCountryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCheckoutPaymentMethod(_response);
        });
    }

    protected processGetCheckoutPaymentMethod(response: AxiosResponse): Promise<CheckoutPaymentMethodRouteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckoutPaymentMethodRouteDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckoutPaymentMethodRouteDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutPaymentMethodRouteDto[]>(null as any);
    }

    /**
     * Returns the cart's open checkout session, creating one when needed. Called when the checkout page loads and
    after a `503`, which reprices a session that has an address and a shipping method but no totals.
     * @return OK
     */
    getOrCreateCheckoutSession( cancelToken?: CancelToken): Promise<CheckoutSessionDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrCreateCheckoutSession(_response);
        });
    }

    protected processGetOrCreateCheckoutSession(response: AxiosResponse): Promise<CheckoutSessionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutSessionDto.fromJS(resultData200);
            return Promise.resolve<CheckoutSessionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutSessionDto>(null as any);
    }

    /**
     * Sets the ship-to address, clears the shipping method, and returns every shipping method with its freight.
    The address is priced with zero freight and those totals are stored until a method is selected.
     * @return OK
     */
    setCheckoutSessionShipTo(body: UpdateCheckoutSessionShipToRequestDto, cancelToken?: CancelToken): Promise<CheckoutSessionDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/session/ship-to";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCheckoutSessionShipTo(_response);
        });
    }

    protected processSetCheckoutSessionShipTo(response: AxiosResponse): Promise<CheckoutSessionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutSessionDto.fromJS(resultData200);
            return Promise.resolve<CheckoutSessionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = CheckoutSessionDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutSessionDto>(null as any);
    }

    /**
     * Sets the shipping method and stores the freight, recycling fee, and tax priced for it.
     * @return OK
     */
    setCheckoutSessionShippingMethod(body: UpdateCheckoutSessionShippingMethodRequestDto, cancelToken?: CancelToken): Promise<CheckoutSessionDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/session/shipping-method";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCheckoutSessionShippingMethod(_response);
        });
    }

    protected processSetCheckoutSessionShippingMethod(response: AxiosResponse): Promise<CheckoutSessionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutSessionDto.fromJS(resultData200);
            return Promise.resolve<CheckoutSessionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = CheckoutSessionDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutSessionDto>(null as any);
    }

    /**
     * Sets the PO number written with the order; a blank value clears it. Net terms needs it before
    `POST /checkout`. Returns the session with a new version.
     * @return OK
     */
    setCheckoutSessionPoNumber(body: UpdateCheckoutSessionPoNumberRequestDto, cancelToken?: CancelToken): Promise<CheckoutSessionDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/session/po-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCheckoutSessionPoNumber(_response);
        });
    }

    protected processSetCheckoutSessionPoNumber(response: AxiosResponse): Promise<CheckoutSessionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutSessionDto.fromJS(resultData200);
            return Promise.resolve<CheckoutSessionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = CheckoutSessionDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutSessionDto>(null as any);
    }

    /**
     * Card routes. Called when the card number is complete. The request route must still be offered by the routing
    state machine (`409 RouteChanged` otherwise). The session id must be the cart's open session and the route's
    checks (expiration, accepted brand, threshold) must pass before the attempt is created in Setup and
    the gateway's setup step runs. A resend with the same key supersedes the attempt and answers
    `409 SetupRequired`. The request body is never logged.
     * @return OK
     */
    setupCheckoutPayment(body: CheckoutPaymentSetupRequestDto, cancelToken?: CancelToken): Promise<CheckoutPaymentSetupResultDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/payment-setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetupCheckoutPayment(_response);
        });
    }

    protected processSetupCheckoutPayment(response: AxiosResponse): Promise<CheckoutPaymentSetupResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutPaymentSetupResultDto.fromJS(resultData200);
            return Promise.resolve<CheckoutPaymentSetupResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = CheckoutSessionDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = CheckoutSubmitRejectionDto.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutPaymentSetupResultDto>(null as any);
    }

    /**
     * Places the order. The request route must still be offered by the routing state machine (`409 RouteChanged`
    otherwise). Card routes pay the attempt created by `payment-setup`; net terms needs a PO number. On success
    the orchestrator writes the web order, completes the attempt and the session, empties the cart, and the response
    is `Completed` with the legacy `webOrderId`. The request body is never logged.
     * @return OK
     */
    submitCheckout(body: CheckoutSubmitRequestDto, cancelToken?: CancelToken): Promise<CheckoutSubmitResultDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitCheckout(_response);
        });
    }

    protected processSubmitCheckout(response: AxiosResponse): Promise<CheckoutSubmitResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutSubmitResultDto.fromJS(resultData200);
            return Promise.resolve<CheckoutSubmitResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = CheckoutSessionDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = CheckoutSubmitRejectionDto.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutSubmitResultDto>(null as any);
    }

    /**
     * Returns the stored status of the caller's payment attempt so a frozen checkout can poll after a client timeout
    or `Unknown`. Read-only: it never calls a gateway or runs the order step. On `Authorized` the client
    resends `POST /checkout` with the same key to finish the order. Unknown keys and other callers' attempts
    return 404.
     * @return OK
     */
    getCheckoutAttempt(idempotencyKey: string, cancelToken?: CancelToken): Promise<CheckoutSubmitResultDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/attempts/{idempotencyKey}";
        if (idempotencyKey === undefined || idempotencyKey === null)
            throw new globalThis.Error("The parameter 'idempotencyKey' must be defined.");
        url_ = url_.replace("{idempotencyKey}", encodeURIComponent("" + idempotencyKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCheckoutAttempt(_response);
        });
    }

    protected processGetCheckoutAttempt(response: AxiosResponse): Promise<CheckoutSubmitResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutSubmitResultDto.fromJS(resultData200);
            return Promise.resolve<CheckoutSubmitResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutSubmitResultDto>(null as any);
    }

    /**
     * Resumes an `AwaitingCustomer` attempt after the step-up challenge, with the same body as
    `POST /checkout`. On success the response is `Completed` with the legacy `webOrderId`.
     * @return OK
     */
    completeCheckoutChallenge(body: CheckoutSubmitRequestDto, cancelToken?: CancelToken): Promise<CheckoutSubmitResultDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/complete-challenge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteCheckoutChallenge(_response);
        });
    }

    protected processCompleteCheckoutChallenge(response: AxiosResponse): Promise<CheckoutSubmitResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutSubmitResultDto.fromJS(resultData200);
            return Promise.resolve<CheckoutSubmitResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = CheckoutSessionDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = CheckoutSubmitRejectionDto.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutSubmitResultDto>(null as any);
    }
}

export interface ICheckoutFreightClient {
    /**
     * Returns the available shipping methods + quoted costs for the checkout shipping step. Freight
    is quoted from the ship-to address and the included lines; total weight/value and the
    zero-weight item count are derived server-side from the lines (catalog weights come from the
    ProductDetail service), matching how shi.com quotes freight.
     * @return OK
     */
    getShippingMethods(body: ShippingMethodsRequestDto,  cancelToken?: CancelToken): Promise<ShippingMethodDto[]>;
    /**
     * Returns the estimated checkout totals (freight, recycling fee, tax) for the selected shipping
    method, and the estimate id to echo back at submission. Totals are recomputed here whenever the
    customer changes the shipping method so freight/recycling/tax stay in sync with the selection,
    matching shi.com. All values are estimates.
     * @return OK
     */
    getCheckoutTotals(body: CheckoutTotalsRequestDto,  cancelToken?: CancelToken): Promise<CheckoutTotalsDto>;
}

export class CheckoutFreightClient extends AuthorizedApiBase implements ICheckoutFreightClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the available shipping methods + quoted costs for the checkout shipping step. Freight
    is quoted from the ship-to address and the included lines; total weight/value and the
    zero-weight item count are derived server-side from the lines (catalog weights come from the
    ProductDetail service), matching how shi.com quotes freight.
     * @return OK
     */
    getShippingMethods(body: ShippingMethodsRequestDto, cancelToken?: CancelToken): Promise<ShippingMethodDto[]> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/shipping-methods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShippingMethods(_response);
        });
    }

    protected processGetShippingMethods(response: AxiosResponse): Promise<ShippingMethodDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShippingMethodDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShippingMethodDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShippingMethodDto[]>(null as any);
    }

    /**
     * Returns the estimated checkout totals (freight, recycling fee, tax) for the selected shipping
    method, and the estimate id to echo back at submission. Totals are recomputed here whenever the
    customer changes the shipping method so freight/recycling/tax stay in sync with the selection,
    matching shi.com. All values are estimates.
     * @return OK
     */
    getCheckoutTotals(body: CheckoutTotalsRequestDto, cancelToken?: CancelToken): Promise<CheckoutTotalsDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/totals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCheckoutTotals(_response);
        });
    }

    protected processGetCheckoutTotals(response: AxiosResponse): Promise<CheckoutTotalsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutTotalsDto.fromJS(resultData200);
            return Promise.resolve<CheckoutTotalsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutTotalsDto>(null as any);
    }
}

export interface ICheckoutPaymentClient {
    /**
     * Payment methods for the current org unit (credit card when StdCC is configured, and net terms).
     * @return OK
     * @deprecated
     */
    getPaymentMethods( cancelToken?: CancelToken): Promise<CheckoutPaymentMethodDto[]>;
    /**
     * Starts payer authentication for the entered card (legacy CyberSourceSetupService).
     * @return OK
     * @deprecated
     */
    setupCard(body: CheckoutCardSetupRequestDto,  cancelToken?: CancelToken): Promise<CheckoutCardSetupResultDto>;
    /**
     * Checks 3-D Secure enrollment and authorizes at place order (legacy AuthorizeCS).
     * @return OK
     * @deprecated
     */
    authorizeCard(body: CheckoutCardAuthorizeRequestDto,  cancelToken?: CancelToken): Promise<CheckoutCardAuthorizationResultDto>;
    /**
     * Completes a challenged authorization (legacy CyberSourceAuthenticationWithValidation).
     * @return OK
     * @deprecated
     */
    validateCard(body: CheckoutCardValidateRequestDto,  cancelToken?: CancelToken): Promise<CheckoutCardAuthorizationResultDto>;
}

export class CheckoutPaymentClient extends AuthorizedApiBase implements ICheckoutPaymentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Payment methods for the current org unit (credit card when StdCC is configured, and net terms).
     * @return OK
     * @deprecated
     */
    getPaymentMethods( cancelToken?: CancelToken): Promise<CheckoutPaymentMethodDto[]> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/payment/methods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentMethods(_response);
        });
    }

    protected processGetPaymentMethods(response: AxiosResponse): Promise<CheckoutPaymentMethodDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckoutPaymentMethodDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckoutPaymentMethodDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutPaymentMethodDto[]>(null as any);
    }

    /**
     * Starts payer authentication for the entered card (legacy CyberSourceSetupService).
     * @return OK
     * @deprecated
     */
    setupCard(body: CheckoutCardSetupRequestDto, cancelToken?: CancelToken): Promise<CheckoutCardSetupResultDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/payment/card/setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetupCard(_response);
        });
    }

    protected processSetupCard(response: AxiosResponse): Promise<CheckoutCardSetupResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutCardSetupResultDto.fromJS(resultData200);
            return Promise.resolve<CheckoutCardSetupResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutCardSetupResultDto>(null as any);
    }

    /**
     * Checks 3-D Secure enrollment and authorizes at place order (legacy AuthorizeCS).
     * @return OK
     * @deprecated
     */
    authorizeCard(body: CheckoutCardAuthorizeRequestDto, cancelToken?: CancelToken): Promise<CheckoutCardAuthorizationResultDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/payment/card/authorize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthorizeCard(_response);
        });
    }

    protected processAuthorizeCard(response: AxiosResponse): Promise<CheckoutCardAuthorizationResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutCardAuthorizationResultDto.fromJS(resultData200);
            return Promise.resolve<CheckoutCardAuthorizationResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutCardAuthorizationResultDto>(null as any);
    }

    /**
     * Completes a challenged authorization (legacy CyberSourceAuthenticationWithValidation).
     * @return OK
     * @deprecated
     */
    validateCard(body: CheckoutCardValidateRequestDto, cancelToken?: CancelToken): Promise<CheckoutCardAuthorizationResultDto> {
        let url_ = this.baseUrl + "/api/ecommerce/checkout/payment/card/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateCard(_response);
        });
    }

    protected processValidateCard(response: AxiosResponse): Promise<CheckoutCardAuthorizationResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckoutCardAuthorizationResultDto.fromJS(resultData200);
            return Promise.resolve<CheckoutCardAuthorizationResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutCardAuthorizationResultDto>(null as any);
    }
}

export interface ICiscoReportClient {
    /**
     * @return OK
     */
    updatePbiRenewalReport( cancelToken?: CancelToken): Promise<void>;
}

export class CiscoReportClient extends AuthorizedApiBase implements ICiscoReportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    updatePbiRenewalReport( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/CiscoReport/renewal-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePbiRenewalReport(_response);
        });
    }

    protected processUpdatePbiRenewalReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICloudAssetsWidgetClient {
    /**
     * @param widgetRequestType (optional) 
     * @return OK
     */
    getCloudAssets(widgetRequestType: CloudAssetWidgetRequestType | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf>;
}

export class CloudAssetsWidgetClient extends AuthorizedApiBase implements ICloudAssetsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param widgetRequestType (optional) 
     * @return OK
     */
    getCloudAssets(widgetRequestType: CloudAssetWidgetRequestType | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf> {
        let url_ = this.baseUrl + "/api/widget/cloud-assets-widget?";
        if (widgetRequestType === null)
            throw new globalThis.Error("The parameter 'widgetRequestType' cannot be null.");
        else if (widgetRequestType !== undefined)
            url_ += "widgetRequestType=" + encodeURIComponent("" + widgetRequestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudAssets(_response);
        });
    }

    protected processGetCloudAssets(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf>(null as any);
    }
}

export interface ICloudConfigurationItemClient {
    /**
     * Creates or Updates a configuration item in Autotask
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateCloudConfigItem(body: ConfigurationItem_CreateUpdate | undefined,  cancelToken?: CancelToken): Promise<ConfigurationItemCacheResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    bulkCreateOrUpdateCloudConfig(body: ConfigurationItem_CreateUpdate[] | undefined,  cancelToken?: CancelToken): Promise<ConfigurationItemsCacheResponse>;
}

export class CloudConfigurationItemClient extends AuthorizedApiBase implements ICloudConfigurationItemClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Creates or Updates a configuration item in Autotask
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateCloudConfigItem(body: ConfigurationItem_CreateUpdate | undefined, cancelToken?: CancelToken): Promise<ConfigurationItemCacheResponse> {
        let url_ = this.baseUrl + "/api/CloudConfigurationItem/CreateUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateCloudConfigItem(_response);
        });
    }

    protected processCreateOrUpdateCloudConfigItem(response: AxiosResponse): Promise<ConfigurationItemCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigurationItemCacheResponse.fromJS(resultData200);
            return Promise.resolve<ConfigurationItemCacheResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationItemCacheResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkCreateOrUpdateCloudConfig(body: ConfigurationItem_CreateUpdate[] | undefined, cancelToken?: CancelToken): Promise<ConfigurationItemsCacheResponse> {
        let url_ = this.baseUrl + "/api/CloudConfigurationItem/CreateUpdateBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkCreateOrUpdateCloudConfig(_response);
        });
    }

    protected processBulkCreateOrUpdateCloudConfig(response: AxiosResponse): Promise<ConfigurationItemsCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigurationItemsCacheResponse.fromJS(resultData200);
            return Promise.resolve<ConfigurationItemsCacheResponse>(result200);

        } else if (status === 207) {
            const _responseText = response.data;
            let result207: any = null;
            let resultData207  = _responseText;
            result207 = ConfigurationItemsCacheResponse.fromJS(resultData207);
            return Promise.resolve<ConfigurationItemsCacheResponse>(result207);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Precondition Failed", status, _responseText, _headers);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ConfigurationItemsCacheResponse.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 429) {
            const _responseText = response.data;
            return throwException("Too Many Requests", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationItemsCacheResponse>(null as any);
    }
}

export interface ICloudConsumptionHistoryWidgetClient {
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return OK
     */
    getCloudConsumptionHistory(dateFrom: Date | undefined, dateTo: Date | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse>;
}

export class CloudConsumptionHistoryWidgetClient extends AuthorizedApiBase implements ICloudConsumptionHistoryWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return OK
     */
    getCloudConsumptionHistory(dateFrom: Date | undefined, dateTo: Date | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse> {
        let url_ = this.baseUrl + "/api/widget/cloud-consumption-history-widget?";
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudConsumptionHistory(_response);
        });
    }

    protected processGetCloudConsumptionHistory(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse>(null as any);
    }
}

export interface ICloudPotentialSavingsWidgetClient {
    /**
     * @return OK
     */
    getCloudPotentialSavingsWidgetData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto>;
}

export class CloudPotentialSavingsWidgetClient extends AuthorizedApiBase implements ICloudPotentialSavingsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getCloudPotentialSavingsWidgetData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/cloud-potential-savings-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudPotentialSavingsWidgetData(_response);
        });
    }

    protected processGetCloudPotentialSavingsWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto>(null as any);
    }
}

export interface ICollectorClient {
    /**
     * @return OK
     */
    getCustomerAzureSubscriptions( cancelToken?: CancelToken): Promise<CustomerSubscription[]>;
    /**
     * Gets a list of details around the last collection of a given customers integration data.
     * @return OK
     */
    getHistoricalCollectionProcessorDetails( cancelToken?: CancelToken): Promise<HistoricalCollectionDetails[]>;
    /**
     * Gets a list of customer account identifiers.
     * @param cloudType (optional) 
     * @param serviceLevel (optional) 
     * @return Returns list of customer account identifiers.
     */
    getCloudAccountIdentifiers(cloudType: string | undefined, serviceLevel: string | undefined,  cancelToken?: CancelToken): Promise<CloudAccountIdentifier[]>;
}

export class CollectorClient extends AuthorizedApiBase implements ICollectorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getCustomerAzureSubscriptions( cancelToken?: CancelToken): Promise<CustomerSubscription[]> {
        let url_ = this.baseUrl + "/api/collector/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerAzureSubscriptions(_response);
        });
    }

    protected processGetCustomerAzureSubscriptions(response: AxiosResponse): Promise<CustomerSubscription[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerSubscription.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomerSubscription[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSubscription[]>(null as any);
    }

    /**
     * Gets a list of details around the last collection of a given customers integration data.
     * @return OK
     */
    getHistoricalCollectionProcessorDetails( cancelToken?: CancelToken): Promise<HistoricalCollectionDetails[]> {
        let url_ = this.baseUrl + "/api/collector/historical-collection-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHistoricalCollectionProcessorDetails(_response);
        });
    }

    protected processGetHistoricalCollectionProcessorDetails(response: AxiosResponse): Promise<HistoricalCollectionDetails[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoricalCollectionDetails.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HistoricalCollectionDetails[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoricalCollectionDetails[]>(null as any);
    }

    /**
     * Gets a list of customer account identifiers.
     * @param cloudType (optional) 
     * @param serviceLevel (optional) 
     * @return Returns list of customer account identifiers.
     */
    getCloudAccountIdentifiers(cloudType: string | undefined, serviceLevel: string | undefined, cancelToken?: CancelToken): Promise<CloudAccountIdentifier[]> {
        let url_ = this.baseUrl + "/api/collector/cloud-accounts?";
        if (cloudType === null)
            throw new globalThis.Error("The parameter 'cloudType' cannot be null.");
        else if (cloudType !== undefined)
            url_ += "CloudType=" + encodeURIComponent("" + cloudType) + "&";
        if (serviceLevel === null)
            throw new globalThis.Error("The parameter 'serviceLevel' cannot be null.");
        else if (serviceLevel !== undefined)
            url_ += "ServiceLevel=" + encodeURIComponent("" + serviceLevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudAccountIdentifiers(_response);
        });
    }

    protected processGetCloudAccountIdentifiers(response: AxiosResponse): Promise<CloudAccountIdentifier[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountIdentifier.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CloudAccountIdentifier[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Exception is logged, no customer list is returned.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Bearer token does not have required scope.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountIdentifier[]>(null as any);
    }
}

export interface ICollectorFunctionsClient {
    /**
     * Testing endpoint to validate if a customer account has access to collect their cloud account data.
     * @param body (optional) 
     * @return OK
     */
    checkCustomerCloudAccess(body: AccessValidationRequest | undefined,  cancelToken?: CancelToken): Promise<AccessValidationResponse>;
    /**
     * Endpoint to initial a CRM Account refresh for the indicated account ax number.
     * @return OK
     */
    refreshCrmAccountTeam(accountTeamAxNumber: string,  cancelToken?: CancelToken): Promise<HttpStatusCode>;
}

export class CollectorFunctionsClient extends AuthorizedApiBase implements ICollectorFunctionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Testing endpoint to validate if a customer account has access to collect their cloud account data.
     * @param body (optional) 
     * @return OK
     */
    checkCustomerCloudAccess(body: AccessValidationRequest | undefined, cancelToken?: CancelToken): Promise<AccessValidationResponse> {
        let url_ = this.baseUrl + "/api/CollectorFunctions/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCustomerCloudAccess(_response);
        });
    }

    protected processCheckCustomerCloudAccess(response: AxiosResponse): Promise<AccessValidationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessValidationResponse.fromJS(resultData200);
            return Promise.resolve<AccessValidationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessValidationResponse>(null as any);
    }

    /**
     * Endpoint to initial a CRM Account refresh for the indicated account ax number.
     * @return OK
     */
    refreshCrmAccountTeam(accountTeamAxNumber: string, cancelToken?: CancelToken): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/CollectorFunctions/RefreshCrmAccountTeam/{accountTeamAxNumber}";
        if (accountTeamAxNumber === undefined || accountTeamAxNumber === null)
            throw new globalThis.Error("The parameter 'accountTeamAxNumber' must be defined.");
        url_ = url_.replace("{accountTeamAxNumber}", encodeURIComponent("" + accountTeamAxNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshCrmAccountTeam(_response);
        });
    }

    protected processRefreshCrmAccountTeam(response: AxiosResponse): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<HttpStatusCode>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }
}

export interface ICompanyStandardsClient {
    /**
     * @return OK
     */
    get(orgUnitId: number,  cancelToken?: CancelToken): Promise<GetStandardsFoldersResponse>;
    /**
     * @param x_Current_Folder_Id (optional) 
     * @param body (optional) 
     * @return OK
     */
    reorder(orgUnitId: number, x_Current_Folder_Id: number | undefined, body: ReorderSiblingOrdinalsDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    renameGroup(orgUnitId: number, groupId: number, body: StandardsGroupNameDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createSubgroup(orgUnitId: number, parentGroupId: number, body: StandardsGroupNameDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    moveTo(body: StandardsMoveToDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    delete(orgUnitId: number, groupId: number, body: StandardsIdentifierDto[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addProducts(body: StandardsAddProductsDto | undefined,  cancelToken?: CancelToken): Promise<InsertStandardsProductItemResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    replaceProduct(body: StandardsReplaceProductDto | undefined,  cancelToken?: CancelToken): Promise<ReplaceStandardsProductItemResponse>;
    /**
     * @return OK
     */
    getAutoPopulatePreference(orgUnitId: number,  cancelToken?: CancelToken): Promise<WarehouseAutoPopulatePreferenceDto>;
    /**
     * @return OK
     */
    upsertAutoPopulatePreference(orgUnitId: number, body: UpdateWarehouseAutoPopulatePreferenceRequest,  cancelToken?: CancelToken): Promise<WarehouseAutoPopulatePreferenceDto>;
}

export class CompanyStandardsClient extends AuthorizedApiBase implements ICompanyStandardsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    get(orgUnitId: number, cancelToken?: CancelToken): Promise<GetStandardsFoldersResponse> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/{orgUnitId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<GetStandardsFoldersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStandardsFoldersResponse.fromJS(resultData200);
            return Promise.resolve<GetStandardsFoldersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStandardsFoldersResponse>(null as any);
    }

    /**
     * @param x_Current_Folder_Id (optional) 
     * @param body (optional) 
     * @return OK
     */
    reorder(orgUnitId: number, x_Current_Folder_Id: number | undefined, body: ReorderSiblingOrdinalsDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/{orgUnitId}/reorder";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "X-Current-Folder-Id": x_Current_Folder_Id !== undefined && x_Current_Folder_Id !== null ? "" + x_Current_Folder_Id : "",
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReorder(_response);
        });
    }

    protected processReorder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    renameGroup(orgUnitId: number, groupId: number, body: StandardsGroupNameDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/{orgUnitId}/group/{groupId}/rename";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameGroup(_response);
        });
    }

    protected processRenameGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createSubgroup(orgUnitId: number, parentGroupId: number, body: StandardsGroupNameDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/{orgUnitId}/group/{parentGroupId}/subgroup";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (parentGroupId === undefined || parentGroupId === null)
            throw new globalThis.Error("The parameter 'parentGroupId' must be defined.");
        url_ = url_.replace("{parentGroupId}", encodeURIComponent("" + parentGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSubgroup(_response);
        });
    }

    protected processCreateSubgroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    moveTo(body: StandardsMoveToDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/moveto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveTo(_response);
        });
    }

    protected processMoveTo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    delete(orgUnitId: number, groupId: number, body: StandardsIdentifierDto[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/{orgUnitId}/group/{groupId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addProducts(body: StandardsAddProductsDto | undefined, cancelToken?: CancelToken): Promise<InsertStandardsProductItemResponse> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProducts(_response);
        });
    }

    protected processAddProducts(response: AxiosResponse): Promise<InsertStandardsProductItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertStandardsProductItemResponse.fromJS(resultData200);
            return Promise.resolve<InsertStandardsProductItemResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertStandardsProductItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    replaceProduct(body: StandardsReplaceProductDto | undefined, cancelToken?: CancelToken): Promise<ReplaceStandardsProductItemResponse> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplaceProduct(_response);
        });
    }

    protected processReplaceProduct(response: AxiosResponse): Promise<ReplaceStandardsProductItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReplaceStandardsProductItemResponse.fromJS(resultData200);
            return Promise.resolve<ReplaceStandardsProductItemResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReplaceStandardsProductItemResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAutoPopulatePreference(orgUnitId: number, cancelToken?: CancelToken): Promise<WarehouseAutoPopulatePreferenceDto> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/auto-populate-preferences/{orgUnitId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoPopulatePreference(_response);
        });
    }

    protected processGetAutoPopulatePreference(response: AxiosResponse): Promise<WarehouseAutoPopulatePreferenceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WarehouseAutoPopulatePreferenceDto.fromJS(resultData200);
            return Promise.resolve<WarehouseAutoPopulatePreferenceDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarehouseAutoPopulatePreferenceDto>(null as any);
    }

    /**
     * @return OK
     */
    upsertAutoPopulatePreference(orgUnitId: number, body: UpdateWarehouseAutoPopulatePreferenceRequest, cancelToken?: CancelToken): Promise<WarehouseAutoPopulatePreferenceDto> {
        let url_ = this.baseUrl + "/api/ecommerce/company-standards/auto-populate-preferences/{orgUnitId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertAutoPopulatePreference(_response);
        });
    }

    protected processUpsertAutoPopulatePreference(response: AxiosResponse): Promise<WarehouseAutoPopulatePreferenceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WarehouseAutoPopulatePreferenceDto.fromJS(resultData200);
            return Promise.resolve<WarehouseAutoPopulatePreferenceDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarehouseAutoPopulatePreferenceDto>(null as any);
    }
}

export interface IContractClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getAccountContracts(includeContractsWithProjects: boolean, body: AccountContractRequest | undefined,  cancelToken?: CancelToken): Promise<AccountContractResponse>;
    /**
     * @return OK
     */
    getContractsFilterPicklist( cancelToken?: CancelToken): Promise<ContractsPicklistDto>;
    /**
     * @return OK
     */
    getContractOverview(contractId: number, includeContractsWithProjects: boolean,  cancelToken?: CancelToken): Promise<ContractOverview>;
    /**
     * @return OK
     */
    getContract(contractId: number,  cancelToken?: CancelToken): Promise<ContractDto>;
    /**
     * @return OK
     */
    getFSAs( cancelToken?: CancelToken): Promise<FSACacheResponse>;
    /**
     * @return OK
     */
    getSLAs( cancelToken?: CancelToken): Promise<ContractSlaDto[]>;
    /**
     * @return OK
     */
    getCloudAccounts( cancelToken?: CancelToken): Promise<CloudAccount[]>;
    /**
     * @return OK
     */
    getCloudAccountsV2( cancelToken?: CancelToken): Promise<CloudAccountV2Dto[]>;
    /**
     * @return OK
     */
    picklistValues( cancelToken?: CancelToken): Promise<ContractSchema>;
    /**
     * @return OK
     */
    contractsByAccountAndCategory( cancelToken?: CancelToken): Promise<ContractCacheResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getContractsByAccountId(body: AccountContractRequest | undefined,  cancelToken?: CancelToken): Promise<AccountContractResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getContractsAggregatedData(body: number[] | undefined,  cancelToken?: CancelToken): Promise<AggregatedContractsResponse>;
}

export class ContractClient extends AuthorizedApiBase implements IContractClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAccountContracts(includeContractsWithProjects: boolean, body: AccountContractRequest | undefined, cancelToken?: CancelToken): Promise<AccountContractResponse> {
        let url_ = this.baseUrl + "/api/Contract/contracts/{includeContractsWithProjects}";
        if (includeContractsWithProjects === undefined || includeContractsWithProjects === null)
            throw new globalThis.Error("The parameter 'includeContractsWithProjects' must be defined.");
        url_ = url_.replace("{includeContractsWithProjects}", encodeURIComponent("" + includeContractsWithProjects));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountContracts(_response);
        });
    }

    protected processGetAccountContracts(response: AxiosResponse): Promise<AccountContractResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountContractResponse.fromJS(resultData200);
            return Promise.resolve<AccountContractResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountContractResponse>(null as any);
    }

    /**
     * @return OK
     */
    getContractsFilterPicklist( cancelToken?: CancelToken): Promise<ContractsPicklistDto> {
        let url_ = this.baseUrl + "/api/Contract/contracts/filter-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractsFilterPicklist(_response);
        });
    }

    protected processGetContractsFilterPicklist(response: AxiosResponse): Promise<ContractsPicklistDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractsPicklistDto.fromJS(resultData200);
            return Promise.resolve<ContractsPicklistDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractsPicklistDto>(null as any);
    }

    /**
     * @return OK
     */
    getContractOverview(contractId: number, includeContractsWithProjects: boolean, cancelToken?: CancelToken): Promise<ContractOverview> {
        let url_ = this.baseUrl + "/api/Contract/overview/{contractId}/{includeContractsWithProjects}";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (includeContractsWithProjects === undefined || includeContractsWithProjects === null)
            throw new globalThis.Error("The parameter 'includeContractsWithProjects' must be defined.");
        url_ = url_.replace("{includeContractsWithProjects}", encodeURIComponent("" + includeContractsWithProjects));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractOverview(_response);
        });
    }

    protected processGetContractOverview(response: AxiosResponse): Promise<ContractOverview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractOverview.fromJS(resultData200);
            return Promise.resolve<ContractOverview>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractOverview>(null as any);
    }

    /**
     * @return OK
     */
    getContract(contractId: number, cancelToken?: CancelToken): Promise<ContractDto> {
        let url_ = this.baseUrl + "/api/Contract/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContract(_response);
        });
    }

    protected processGetContract(response: AxiosResponse): Promise<ContractDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractDto.fromJS(resultData200);
            return Promise.resolve<ContractDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractDto>(null as any);
    }

    /**
     * @return OK
     */
    getFSAs( cancelToken?: CancelToken): Promise<FSACacheResponse> {
        let url_ = this.baseUrl + "/api/Contract/fsa";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFSAs(_response);
        });
    }

    protected processGetFSAs(response: AxiosResponse): Promise<FSACacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FSACacheResponse.fromJS(resultData200);
            return Promise.resolve<FSACacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FSACacheResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSLAs( cancelToken?: CancelToken): Promise<ContractSlaDto[]> {
        let url_ = this.baseUrl + "/api/Contract/getslas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSLAs(_response);
        });
    }

    protected processGetSLAs(response: AxiosResponse): Promise<ContractSlaDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractSlaDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ContractSlaDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractSlaDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getCloudAccounts( cancelToken?: CancelToken): Promise<CloudAccount[]> {
        let url_ = this.baseUrl + "/api/Contract/cloudaccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudAccounts(_response);
        });
    }

    protected processGetCloudAccounts(response: AxiosResponse): Promise<CloudAccount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CloudAccount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccount[]>(null as any);
    }

    /**
     * @return OK
     */
    getCloudAccountsV2( cancelToken?: CancelToken): Promise<CloudAccountV2Dto[]> {
        let url_ = this.baseUrl + "/api/Contract/cloudAccountsV2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudAccountsV2(_response);
        });
    }

    protected processGetCloudAccountsV2(response: AxiosResponse): Promise<CloudAccountV2Dto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountV2Dto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CloudAccountV2Dto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountV2Dto[]>(null as any);
    }

    /**
     * @return OK
     */
    picklistValues( cancelToken?: CancelToken): Promise<ContractSchema> {
        let url_ = this.baseUrl + "/api/Contract/picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPicklistValues(_response);
        });
    }

    protected processPicklistValues(response: AxiosResponse): Promise<ContractSchema> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractSchema.fromJS(resultData200);
            return Promise.resolve<ContractSchema>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractSchema>(null as any);
    }

    /**
     * @return OK
     */
    contractsByAccountAndCategory( cancelToken?: CancelToken): Promise<ContractCacheResponse> {
        let url_ = this.baseUrl + "/api/Contract/allCloud";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractsByAccountAndCategory(_response);
        });
    }

    protected processContractsByAccountAndCategory(response: AxiosResponse): Promise<ContractCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractCacheResponse.fromJS(resultData200);
            return Promise.resolve<ContractCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractCacheResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getContractsByAccountId(body: AccountContractRequest | undefined, cancelToken?: CancelToken): Promise<AccountContractResponse> {
        let url_ = this.baseUrl + "/api/Contract/contracts/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractsByAccountId(_response);
        });
    }

    protected processGetContractsByAccountId(response: AxiosResponse): Promise<AccountContractResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountContractResponse.fromJS(resultData200);
            return Promise.resolve<AccountContractResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountContractResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getContractsAggregatedData(body: number[] | undefined, cancelToken?: CancelToken): Promise<AggregatedContractsResponse> {
        let url_ = this.baseUrl + "/api/Contract/contracts/aggregations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractsAggregatedData(_response);
        });
    }

    protected processGetContractsAggregatedData(response: AxiosResponse): Promise<AggregatedContractsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AggregatedContractsResponse.fromJS(resultData200);
            return Promise.resolve<AggregatedContractsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AggregatedContractsResponse>(null as any);
    }
}

export interface IContractInvoiceClient {
    /**
     * @param contractId (optional) 
     * @return OK
     */
    getContractInvoices(contractId: number | undefined,  cancelToken?: CancelToken): Promise<Invoice[]>;
    /**
     * @return OK
     */
    getInvoiceContracts( cancelToken?: CancelToken): Promise<ContractDto[]>;
}

export class ContractInvoiceClient extends AuthorizedApiBase implements IContractInvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param contractId (optional) 
     * @return OK
     */
    getContractInvoices(contractId: number | undefined, cancelToken?: CancelToken): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/ContractInvoice?";
        if (contractId === null)
            throw new globalThis.Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractInvoices(_response);
        });
    }

    protected processGetContractInvoices(response: AxiosResponse): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Invoice[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    /**
     * @return OK
     */
    getInvoiceContracts( cancelToken?: CancelToken): Promise<ContractDto[]> {
        let url_ = this.baseUrl + "/api/ContractInvoice/contracts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceContracts(_response);
        });
    }

    protected processGetInvoiceContracts(response: AxiosResponse): Promise<ContractDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ContractDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractDto[]>(null as any);
    }
}

export interface IContractRequestRankingsWidgetClient {
    /**
     * @param dateFilterOption (optional) 
     * @return OK
     */
    getContractRequestRankingsWidgetData(dateFilterOption: DateFilterOption | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto>;
}

export class ContractRequestRankingsWidgetClient extends AuthorizedApiBase implements IContractRequestRankingsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFilterOption (optional) 
     * @return OK
     */
    getContractRequestRankingsWidgetData(dateFilterOption: DateFilterOption | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto> {
        let url_ = this.baseUrl + "/api/widget/contract-request-rankings-widget?";
        if (dateFilterOption === null)
            throw new globalThis.Error("The parameter 'dateFilterOption' cannot be null.");
        else if (dateFilterOption !== undefined)
            url_ += "dateFilterOption=" + encodeURIComponent("" + dateFilterOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractRequestRankingsWidgetData(_response);
        });
    }

    protected processGetContractRequestRankingsWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto>(null as any);
    }
}

export interface IContractRetainerSpendClient {
    /**
     * @return OK
     */
    getContractRetainerSpendByAccountId(accountId: number,  cancelToken?: CancelToken): Promise<ContractRetainerSpend[]>;
    /**
     * @return OK
     */
    getContractRetainerSpendByContractId(contractId: number,  cancelToken?: CancelToken): Promise<ContractRetainerSpend>;
    /**
     * @return OK
     */
    getDetailedRetainerExpenseByContractId(contractId: number,  cancelToken?: CancelToken): Promise<DetailedContractRetainerExpenseDto>;
}

export class ContractRetainerSpendClient extends AuthorizedApiBase implements IContractRetainerSpendClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getContractRetainerSpendByAccountId(accountId: number, cancelToken?: CancelToken): Promise<ContractRetainerSpend[]> {
        let url_ = this.baseUrl + "/api/ContractRetainerSpend/GetContractRetainerSpendByAccountId/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractRetainerSpendByAccountId(_response);
        });
    }

    protected processGetContractRetainerSpendByAccountId(response: AxiosResponse): Promise<ContractRetainerSpend[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractRetainerSpend.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ContractRetainerSpend[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractRetainerSpend[]>(null as any);
    }

    /**
     * @return OK
     */
    getContractRetainerSpendByContractId(contractId: number, cancelToken?: CancelToken): Promise<ContractRetainerSpend> {
        let url_ = this.baseUrl + "/api/ContractRetainerSpend/GetContractRetainerSpendByContractId/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractRetainerSpendByContractId(_response);
        });
    }

    protected processGetContractRetainerSpendByContractId(response: AxiosResponse): Promise<ContractRetainerSpend> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractRetainerSpend.fromJS(resultData200);
            return Promise.resolve<ContractRetainerSpend>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractRetainerSpend>(null as any);
    }

    /**
     * @return OK
     */
    getDetailedRetainerExpenseByContractId(contractId: number, cancelToken?: CancelToken): Promise<DetailedContractRetainerExpenseDto> {
        let url_ = this.baseUrl + "/api/ContractRetainerSpend/GetDetailedRetainerExpenseByContractId/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailedRetainerExpenseByContractId(_response);
        });
    }

    protected processGetDetailedRetainerExpenseByContractId(response: AxiosResponse): Promise<DetailedContractRetainerExpenseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DetailedContractRetainerExpenseDto.fromJS(resultData200);
            return Promise.resolve<DetailedContractRetainerExpenseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DetailedContractRetainerExpenseDto>(null as any);
    }
}

export interface ICostAnalyticsClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    postAnalyticsForProvider(provider: CostAnalyticProviders, body: PostCostAnalyticsRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    searchAnalyticsByProvider(provider: CostAnalyticProviders,  cancelToken?: CancelToken): Promise<CostAnalyticsResponse>;
}

export class CostAnalyticsClient extends AuthorizedApiBase implements ICostAnalyticsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postAnalyticsForProvider(provider: CostAnalyticProviders, body: PostCostAnalyticsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/costanalytics/{provider}";
        if (provider === undefined || provider === null)
            throw new globalThis.Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAnalyticsForProvider(_response);
        });
    }

    protected processPostAnalyticsForProvider(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    searchAnalyticsByProvider(provider: CostAnalyticProviders, cancelToken?: CancelToken): Promise<CostAnalyticsResponse> {
        let url_ = this.baseUrl + "/api/costanalytics/{provider}";
        if (provider === undefined || provider === null)
            throw new globalThis.Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAnalyticsByProvider(_response);
        });
    }

    protected processSearchAnalyticsByProvider(response: AxiosResponse): Promise<CostAnalyticsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostAnalyticsResponse.fromJS(resultData200);
            return Promise.resolve<CostAnalyticsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostAnalyticsResponse>(null as any);
    }
}

export interface ICostCenterClient {
    /**
     * @param accountId (optional) 
     * @return OK
     */
    getCostCenterByAccount(accountId: number | undefined,  cancelToken?: CancelToken): Promise<CostCenterDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createCostCenter(body: CostCenterDTO | undefined,  cancelToken?: CancelToken): Promise<CostCenterDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateCostCenter(body: CostCenterDTO | undefined,  cancelToken?: CancelToken): Promise<CostCenterDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteCostCenter(body: CostCenterDeleteRequest | undefined,  cancelToken?: CancelToken): Promise<CostCenterDTO>;
    /**
     * @return OK
     */
    cloudAccountsByAccountId( cancelToken?: CancelToken): Promise<CloudAccountDTO[]>;
    /**
     * @return OK
     */
    getCostCenterWithCloudAccountsById(id: number,  cancelToken?: CancelToken): Promise<CostCenterWithCloudAccountsDTO>;
    /**
     * @return OK
     */
    automatedCostCenterWithCloudAccountsById(id: number,  cancelToken?: CancelToken): Promise<CostCenterWithCloudAccountsDTO>;
    /**
     * @return OK
     */
    getCostCentersWithCloudAccounts( cancelToken?: CancelToken): Promise<CostCenterWithCloudAccountsDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addConfigurationItemToCostCenter(body: CostCenterCloudAccountRequest | undefined,  cancelToken?: CancelToken): Promise<CloudAccountDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    allocateConfigurationItemsToCostCenter(body: CostCenterCloudAccountRequest | undefined,  cancelToken?: CancelToken): Promise<CloudAccountDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    removeConfigurationItemFromCostCenter(body: CostCenterCloudAccountRequest | undefined,  cancelToken?: CancelToken): Promise<CloudAccountDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    moveConfigurationItemToCostCenter(body: MoveConfigurationItemRequest | undefined,  cancelToken?: CancelToken): Promise<CloudAccountDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateLicenseAllocations(body: UpdateLicenseAllocationsRequest | undefined,  cancelToken?: CancelToken): Promise<CloudAccountDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    automatedUpdateLicenseAllocations(body: UpdateLicenseAllocationsRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param accountId (optional) 
     * @return OK
     */
    getDefaultCostCenterPurchaseOrderNumbers(accountId: number | undefined,  cancelToken?: CancelToken): Promise<DefaultCostCenterPurchaseOrdersResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateDefaultCostCenterPurchaseOrderNumbers(body: UpdateDefaultCostCenterPurchaseOrdersRequest | undefined,  cancelToken?: CancelToken): Promise<DefaultCostCenterPurchaseOrdersResponse>;
    /**
     * @return OK
     */
    getCostCenterAccounts( cancelToken?: CancelToken): Promise<CostCenterAccountDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpsertCostCentersByPo(body: BulkUpsertCostCenterByPoItem[] | undefined,  cancelToken?: CancelToken): Promise<BulkUpsertCostCenterByPoResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    exportCloudSubscriptions(body: CloudSubscriptionExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
}

export class CostCenterClient extends AuthorizedApiBase implements ICostCenterClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param accountId (optional) 
     * @return OK
     */
    getCostCenterByAccount(accountId: number | undefined, cancelToken?: CancelToken): Promise<CostCenterDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/getByAccount?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCostCenterByAccount(_response);
        });
    }

    protected processGetCostCenterByAccount(response: AxiosResponse): Promise<CostCenterDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CostCenterDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CostCenterDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCostCenter(body: CostCenterDTO | undefined, cancelToken?: CancelToken): Promise<CostCenterDTO> {
        let url_ = this.baseUrl + "/api/CostCenter/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCostCenter(_response);
        });
    }

    protected processCreateCostCenter(response: AxiosResponse): Promise<CostCenterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterDTO.fromJS(resultData200);
            return Promise.resolve<CostCenterDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCostCenter(body: CostCenterDTO | undefined, cancelToken?: CancelToken): Promise<CostCenterDTO> {
        let url_ = this.baseUrl + "/api/CostCenter/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCostCenter(_response);
        });
    }

    protected processUpdateCostCenter(response: AxiosResponse): Promise<CostCenterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterDTO.fromJS(resultData200);
            return Promise.resolve<CostCenterDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteCostCenter(body: CostCenterDeleteRequest | undefined, cancelToken?: CancelToken): Promise<CostCenterDTO> {
        let url_ = this.baseUrl + "/api/CostCenter/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCostCenter(_response);
        });
    }

    protected processDeleteCostCenter(response: AxiosResponse): Promise<CostCenterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterDTO.fromJS(resultData200);
            return Promise.resolve<CostCenterDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterDTO>(null as any);
    }

    /**
     * @return OK
     */
    cloudAccountsByAccountId( cancelToken?: CancelToken): Promise<CloudAccountDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/cloudAccountsByAccountId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloudAccountsByAccountId(_response);
        });
    }

    protected processCloudAccountsByAccountId(response: AxiosResponse): Promise<CloudAccountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CloudAccountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getCostCenterWithCloudAccountsById(id: number, cancelToken?: CancelToken): Promise<CostCenterWithCloudAccountsDTO> {
        let url_ = this.baseUrl + "/api/CostCenter/costCenterWithCloudAccounts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCostCenterWithCloudAccountsById(_response);
        });
    }

    protected processGetCostCenterWithCloudAccountsById(response: AxiosResponse): Promise<CostCenterWithCloudAccountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterWithCloudAccountsDTO.fromJS(resultData200);
            return Promise.resolve<CostCenterWithCloudAccountsDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterWithCloudAccountsDTO>(null as any);
    }

    /**
     * @return OK
     */
    automatedCostCenterWithCloudAccountsById(id: number, cancelToken?: CancelToken): Promise<CostCenterWithCloudAccountsDTO> {
        let url_ = this.baseUrl + "/api/CostCenter/automatedWithCloudAccounts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutomatedCostCenterWithCloudAccountsById(_response);
        });
    }

    protected processAutomatedCostCenterWithCloudAccountsById(response: AxiosResponse): Promise<CostCenterWithCloudAccountsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterWithCloudAccountsDTO.fromJS(resultData200);
            return Promise.resolve<CostCenterWithCloudAccountsDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterWithCloudAccountsDTO>(null as any);
    }

    /**
     * @return OK
     */
    getCostCentersWithCloudAccounts( cancelToken?: CancelToken): Promise<CostCenterWithCloudAccountsDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/costCentersWithCloudAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCostCentersWithCloudAccounts(_response);
        });
    }

    protected processGetCostCentersWithCloudAccounts(response: AxiosResponse): Promise<CostCenterWithCloudAccountsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CostCenterWithCloudAccountsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CostCenterWithCloudAccountsDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterWithCloudAccountsDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addConfigurationItemToCostCenter(body: CostCenterCloudAccountRequest | undefined, cancelToken?: CancelToken): Promise<CloudAccountDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/configuration-item/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddConfigurationItemToCostCenter(_response);
        });
    }

    protected processAddConfigurationItemToCostCenter(response: AxiosResponse): Promise<CloudAccountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CloudAccountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    allocateConfigurationItemsToCostCenter(body: CostCenterCloudAccountRequest | undefined, cancelToken?: CancelToken): Promise<CloudAccountDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/configuration-item/bulk-allocate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllocateConfigurationItemsToCostCenter(_response);
        });
    }

    protected processAllocateConfigurationItemsToCostCenter(response: AxiosResponse): Promise<CloudAccountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CloudAccountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    removeConfigurationItemFromCostCenter(body: CostCenterCloudAccountRequest | undefined, cancelToken?: CancelToken): Promise<CloudAccountDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/configuration-item/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveConfigurationItemFromCostCenter(_response);
        });
    }

    protected processRemoveConfigurationItemFromCostCenter(response: AxiosResponse): Promise<CloudAccountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CloudAccountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    moveConfigurationItemToCostCenter(body: MoveConfigurationItemRequest | undefined, cancelToken?: CancelToken): Promise<CloudAccountDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/configuration-item/move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveConfigurationItemToCostCenter(_response);
        });
    }

    protected processMoveConfigurationItemToCostCenter(response: AxiosResponse): Promise<CloudAccountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CloudAccountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateLicenseAllocations(body: UpdateLicenseAllocationsRequest | undefined, cancelToken?: CancelToken): Promise<CloudAccountDTO[]> {
        let url_ = this.baseUrl + "/api/CostCenter/configuration-item/allocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLicenseAllocations(_response);
        });
    }

    protected processUpdateLicenseAllocations(response: AxiosResponse): Promise<CloudAccountDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CloudAccountDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CloudAccountDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudAccountDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    automatedUpdateLicenseAllocations(body: UpdateLicenseAllocationsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/CostCenter/automated/update-allocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutomatedUpdateLicenseAllocations(_response);
        });
    }

    protected processAutomatedUpdateLicenseAllocations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param accountId (optional) 
     * @return OK
     */
    getDefaultCostCenterPurchaseOrderNumbers(accountId: number | undefined, cancelToken?: CancelToken): Promise<DefaultCostCenterPurchaseOrdersResponse> {
        let url_ = this.baseUrl + "/api/CostCenter/default-cost-center-purchase-orders?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultCostCenterPurchaseOrderNumbers(_response);
        });
    }

    protected processGetDefaultCostCenterPurchaseOrderNumbers(response: AxiosResponse): Promise<DefaultCostCenterPurchaseOrdersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultCostCenterPurchaseOrdersResponse.fromJS(resultData200);
            return Promise.resolve<DefaultCostCenterPurchaseOrdersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultCostCenterPurchaseOrdersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDefaultCostCenterPurchaseOrderNumbers(body: UpdateDefaultCostCenterPurchaseOrdersRequest | undefined, cancelToken?: CancelToken): Promise<DefaultCostCenterPurchaseOrdersResponse> {
        let url_ = this.baseUrl + "/api/CostCenter/update-default-cost-center-purchase-orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDefaultCostCenterPurchaseOrderNumbers(_response);
        });
    }

    protected processUpdateDefaultCostCenterPurchaseOrderNumbers(response: AxiosResponse): Promise<DefaultCostCenterPurchaseOrdersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DefaultCostCenterPurchaseOrdersResponse.fromJS(resultData200);
            return Promise.resolve<DefaultCostCenterPurchaseOrdersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultCostCenterPurchaseOrdersResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCostCenterAccounts( cancelToken?: CancelToken): Promise<CostCenterAccountDto[]> {
        let url_ = this.baseUrl + "/api/CostCenter/cost-center-accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCostCenterAccounts(_response);
        });
    }

    protected processGetCostCenterAccounts(response: AxiosResponse): Promise<CostCenterAccountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CostCenterAccountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CostCenterAccountDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterAccountDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpsertCostCentersByPo(body: BulkUpsertCostCenterByPoItem[] | undefined, cancelToken?: CancelToken): Promise<BulkUpsertCostCenterByPoResponse> {
        let url_ = this.baseUrl + "/api/CostCenter/bulk-upsert-by-po";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpsertCostCentersByPo(_response);
        });
    }

    protected processBulkUpsertCostCentersByPo(response: AxiosResponse): Promise<BulkUpsertCostCenterByPoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BulkUpsertCostCenterByPoResponse.fromJS(resultData200);
            return Promise.resolve<BulkUpsertCostCenterByPoResponse>(result200);

        } else if (status === 207) {
            const _responseText = response.data;
            let result207: any = null;
            let resultData207  = _responseText;
            result207 = BulkUpsertCostCenterByPoResponse.fromJS(resultData207);
            return Promise.resolve<BulkUpsertCostCenterByPoResponse>(result207);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = BulkUpsertCostCenterByPoResponse.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkUpsertCostCenterByPoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportCloudSubscriptions(body: CloudSubscriptionExportRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/CostCenter/cloudSubscriptions/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCloudSubscriptions(_response);
        });
    }

    protected processExportCloudSubscriptions(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }
}

export interface ICoveredAssetsByProductWidgetClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getCoveredAssetsByProductData(body: CoveredAssetsByProductWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<CoveredAssetsByProductWidgetResponse>;
}

export class CoveredAssetsByProductWidgetClient extends AuthorizedApiBase implements ICoveredAssetsByProductWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCoveredAssetsByProductData(body: CoveredAssetsByProductWidgetRequest | undefined, cancelToken?: CancelToken): Promise<CoveredAssetsByProductWidgetResponse> {
        let url_ = this.baseUrl + "/api/widget/covered-assets-by-product-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCoveredAssetsByProductData(_response);
        });
    }

    protected processGetCoveredAssetsByProductData(response: AxiosResponse): Promise<CoveredAssetsByProductWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CoveredAssetsByProductWidgetResponse.fromJS(resultData200);
            return Promise.resolve<CoveredAssetsByProductWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoveredAssetsByProductWidgetResponse>(null as any);
    }
}

export interface ICspPricingClient {
    /**
     * Prices a specific customer/product combination via the Databricks
    `csp_discount_price` function against the SQL warehouse. All four query parameters are
    required; a missing or blank value fails fast with a 400 before reaching Databricks.
    Requires the ShiOne.CspPricing.Application.Api.CustomerExperience.AuthorizationPolicies.READ_CSP_PRICING policy.
     * @param msCustId Microsoft customer identifier (`msCustId`).
     * @param msItemId Microsoft item/product identifier (`msItemId`).
     * @param msTermDuration Subscription term duration (`msTermDuration`).
     * @param msBillingOption Billing option (`msBillingOption`).
     * @return OK
     */
    getCustomerPrice(msCustId: string, msItemId: string, msTermDuration: string, msBillingOption: string,  cancelToken?: CancelToken): Promise<CspPriceDto[]>;
    /**
     * Returns every available price/product for a customer via the Databricks
    `csp_discount_price` function. Because no item is supplied, the function returns all
    available prices/products for the customer. Requires the
    ShiOne.CspPricing.Application.Api.CustomerExperience.AuthorizationPolicies.READ_CSP_PRICING policy.
     * @param customerId Microsoft customer identifier (`msCustId`).
     * @return OK
     */
    getCustomerPrices(customerId: string,  cancelToken?: CancelToken): Promise<CspPriceDto[]>;
    /**
     * Triggers a fire-and-forget warm of the Databricks SQL warehouse and responds
    `202 Accepted` immediately. The facade owns the background dispatch, its own DI scope,
    and shutdown handling. Requires the
    ShiOne.CspPricing.Application.Api.CustomerExperience.AuthorizationPolicies.READ_CSP_PRICING policy.
     * @return Accepted
     */
    warm( cancelToken?: CancelToken): Promise<void>;
}

export class CspPricingClient extends AuthorizedApiBase implements ICspPricingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Prices a specific customer/product combination via the Databricks
    `csp_discount_price` function against the SQL warehouse. All four query parameters are
    required; a missing or blank value fails fast with a 400 before reaching Databricks.
    Requires the ShiOne.CspPricing.Application.Api.CustomerExperience.AuthorizationPolicies.READ_CSP_PRICING policy.
     * @param msCustId Microsoft customer identifier (`msCustId`).
     * @param msItemId Microsoft item/product identifier (`msItemId`).
     * @param msTermDuration Subscription term duration (`msTermDuration`).
     * @param msBillingOption Billing option (`msBillingOption`).
     * @return OK
     */
    getCustomerPrice(msCustId: string, msItemId: string, msTermDuration: string, msBillingOption: string, cancelToken?: CancelToken): Promise<CspPriceDto[]> {
        let url_ = this.baseUrl + "/api/csp-pricing/price?";
        if (msCustId === undefined || msCustId === null)
            throw new globalThis.Error("The parameter 'msCustId' must be defined and cannot be null.");
        else
            url_ += "msCustId=" + encodeURIComponent("" + msCustId) + "&";
        if (msItemId === undefined || msItemId === null)
            throw new globalThis.Error("The parameter 'msItemId' must be defined and cannot be null.");
        else
            url_ += "msItemId=" + encodeURIComponent("" + msItemId) + "&";
        if (msTermDuration === undefined || msTermDuration === null)
            throw new globalThis.Error("The parameter 'msTermDuration' must be defined and cannot be null.");
        else
            url_ += "msTermDuration=" + encodeURIComponent("" + msTermDuration) + "&";
        if (msBillingOption === undefined || msBillingOption === null)
            throw new globalThis.Error("The parameter 'msBillingOption' must be defined and cannot be null.");
        else
            url_ += "msBillingOption=" + encodeURIComponent("" + msBillingOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerPrice(_response);
        });
    }

    protected processGetCustomerPrice(response: AxiosResponse): Promise<CspPriceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CspPriceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CspPriceDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspPriceDto[]>(null as any);
    }

    /**
     * Returns every available price/product for a customer via the Databricks
    `csp_discount_price` function. Because no item is supplied, the function returns all
    available prices/products for the customer. Requires the
    ShiOne.CspPricing.Application.Api.CustomerExperience.AuthorizationPolicies.READ_CSP_PRICING policy.
     * @param customerId Microsoft customer identifier (`msCustId`).
     * @return OK
     */
    getCustomerPrices(customerId: string, cancelToken?: CancelToken): Promise<CspPriceDto[]> {
        let url_ = this.baseUrl + "/api/csp-pricing/{customerId}/prices";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerPrices(_response);
        });
    }

    protected processGetCustomerPrices(response: AxiosResponse): Promise<CspPriceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CspPriceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CspPriceDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspPriceDto[]>(null as any);
    }

    /**
     * Triggers a fire-and-forget warm of the Databricks SQL warehouse and responds
    `202 Accepted` immediately. The facade owns the background dispatch, its own DI scope,
    and shutdown handling. Requires the
    ShiOne.CspPricing.Application.Api.CustomerExperience.AuthorizationPolicies.READ_CSP_PRICING policy.
     * @return Accepted
     */
    warm( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/csp-pricing/warm";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWarm(_response);
        });
    }

    protected processWarm(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICspSelfServiceClient {
    /**
     * Gets active CSP subscriptions for a customer.
     * @return OK
     */
    getSubscriptions(custId: string,  cancelToken?: CancelToken): Promise<CspSubscriptionDto[]>;
    /**
     * Gets a single CSP subscription with up-to-date refundable seat and cancellation window data.
     * @return OK
     */
    getSubscription(customerId: string, subscriptionId: string,  cancelToken?: CancelToken): Promise<CspSubscriptionDto>;
    /**
     * Updates a CSP subscription (auto-renew and/or seat count) in a single call.
     * @param body (optional) 
     * @return OK
     */
    updateSubscription(customerId: string, subscriptionId: string, body: UpdateSubscriptionRequest | undefined,  cancelToken?: CancelToken): Promise<CspSubscriptionDto>;
    /**
     * Gets the customer profile for a CSP customer.
     * @return OK
     */
    getCustomerProfile(custId: string,  cancelToken?: CancelToken): Promise<CspCustomerProfileDto>;
    /**
     * Creates a Microsoft Customer Agreement attestation for a CSP tenant and returns its signing link.
     * @param body (optional) 
     * @return OK
     */
    createAttestationLink(customerId: string, body: CreateAttestationLinkRequest | undefined,  cancelToken?: CancelToken): Promise<AttestationLinkDto>;
    /**
     * Records the signatory's acceptance of the Microsoft Customer Agreement for a CSP tenant.
     * @param body (optional) 
     * @return No Content
     */
    acceptAttestation(customerId: string, body: RecordAttestationAcceptanceRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Gets all tenant subscriptions for the authenticated user's AX account.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getTenantSubscriptions(forceRefresh: boolean | undefined,  cancelToken?: CancelToken): Promise<CspTenantSubscriptionsDto[]>;
    /**
     * Gets a composite summary of all tenants with subscriptions and available offer counts.
    Replaces separate calls to tenants + available-offers per tenant on page load.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getSelfServiceSummary(forceRefresh: boolean | undefined,  cancelToken?: CancelToken): Promise<CspSelfServiceSummaryDto>;
    /**
     * Updates the auto-renew setting for a CSP subscription.
     * @param body (optional) 
     * @return OK
     */
    updateSubscriptionAutoRenew(customerId: string, subscriptionId: string, body: UpdateAutoRenewRequest | undefined,  cancelToken?: CancelToken): Promise<CspSubscriptionDto>;
    /**
     * Updates the seat count for a CSP subscription immediately.
     * @param body (optional) 
     * @return OK
     */
    updateSubscriptionQuantity(customerId: string, subscriptionId: string, body: UpdateQuantityRequest | undefined,  cancelToken?: CancelToken): Promise<CspSubscriptionDto>;
    /**
     * Cancels a CSP subscription via CloudInt.
    Only permitted within the 7-day NCE cancellation window.
     * @return OK
     */
    cancelSubscription(customerId: string, subscriptionId: string,  cancelToken?: CancelToken): Promise<CspSubscriptionDto>;
    /**
     * Gets available offers that this customer can purchase, cross-referenced with AX catalog and current subscriptions.
     * @return OK
     */
    getAvailableOffers(custId: string,  cancelToken?: CancelToken): Promise<CspAvailableOffersResultDto>;
    /**
     * Resolves a 2-part offer ID (product:sku) to the full 3-part CatalogItemId (product:sku:availability).
    Call this when the user selects a product to confirm availability before ordering.
     * @return OK
     */
    resolveOfferAvailability(custId: string, offerId: string,  cancelToken?: CancelToken): Promise<ResolvedOfferDto>;
    /**
     * Gets the allowable custom term end dates for coterminosity when creating a new subscription.
     * @param newTerm (optional) 
     * @param oldEndDate (optional) 
     * @return OK
     */
    getAllowableTermEndDates(custId: string, newTerm: string | undefined, oldEndDate: Date | undefined,  cancelToken?: CancelToken): Promise<Date[]>;
    /**
     * Creates a new CSP subscription order for a customer.
     * @param body (optional) 
     * @return OK
     */
    createOrder(custId: string, body: CreateOrderDto | undefined,  cancelToken?: CancelToken): Promise<CspOrderDto>;
    /**
     * Creates a new CSP add-on subscription order for a customer.
    Add-on subscriptions are tied to a parent subscription via ParentSubscriptionId.
     * @param body (optional) 
     * @return OK
     */
    createAddOnOrder(custId: string, body: CreateAddOnOrderDto | undefined,  cancelToken?: CancelToken): Promise<CspOrderDto>;
    /**
     * Gets available add-on offers for a given parent offer.
     * @return OK
     */
    getOfferAddOns(custId: string, offerId: string,  cancelToken?: CancelToken): Promise<CspOfferDto[]>;
    /**
     * Pings CloudIntAX to verify connectivity (legacy endpoint).
     * @return OK
     */
    pingCloudIntAx( cancelToken?: CancelToken): Promise<void>;
    /**
     * Pings CloudIntAX new endpoint to verify connectivity.
     * @return OK
     */
    pingCloudIntAxNew( cancelToken?: CancelToken): Promise<void>;
    /**
     * Gets all active GDAP DAP relationships scoped to the authenticated user's authorized customers.
     * @return OK
     */
    getAllDapRelationships( cancelToken?: CancelToken): Promise<DapRelationshipDto[]>;
    /**
     * Gets GDAP DAP relationships for a specific customer.
     * @return OK
     */
    getDapRelationshipsByCustomer(custId: string,  cancelToken?: CancelToken): Promise<DapRelationshipDto[]>;
    /**
     * Gets a paged, sorted, filtered page of CSP activity logs for a customer.
    Date range, search text, action filter, paging, and sorting are all applied
    server-side via the CSP SearchActivityLog endpoint.
     * @param start (optional) 
     * @param end (optional) 
     * @param searchText (optional) 
     * @param actions (optional) 
     * @param startIndex (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     * @return OK
     */
    getActivityLogs(custId: string, start: Date | undefined, end: Date | undefined, searchText: string | undefined, actions: string[] | undefined, startIndex: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDirection: string | undefined,  cancelToken?: CancelToken): Promise<SubscriptionActionLogPagedResultDto>;
    /**
     * Gets license usage data for a customer's subscribed products.
    Returns active, consumed, and available unit counts per product.
     * @return OK
     */
    getAvailableLicenses(custId: string,  cancelToken?: CancelToken): Promise<CspLicenseDto[]>;
    /**
     * Gets all users for a CSP customer.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getUsers(custId: string, forceRefresh: boolean | undefined,  cancelToken?: CancelToken): Promise<CspUserDto[]>;
    /**
     * Gets one page of a CSP customer's users, optionally filtered by a search term, with each user's seat state for a product.
     * @param custId CSP customer ID.
     * @param productId (optional) When set, each user's `hasSeat` says whether they hold this product.
     * @param search (optional) Email or display name search; at least 2 characters.
     * @param continuationToken (optional) Token from the previous page; omit for the first page.
     * @param forceRefresh (optional) Re-read the product's license holders from Partner Center instead of the cache.
     * @return OK
     */
    getUsersPage(custId: string, productId: string | undefined, search: string | undefined, continuationToken: string | undefined, forceRefresh: boolean | undefined,  cancelToken?: CancelToken): Promise<CspUserPageDto>;
    /**
     * Gets licenses assigned to a specific user.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getUserLicenses(custId: string, userId: string, forceRefresh: boolean | undefined,  cancelToken?: CancelToken): Promise<CspUserLicenseDto[]>;
    /**
     * Gets all user IDs that have a specific license.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getUsersWithLicense(custId: string, productId: string, forceRefresh: boolean | undefined,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * Removes a license from a user.
     * @param userDisplayName (optional) 
     * @param userEmail (optional) 
     * @return No Content
     */
    removeLicenseFromUser(custId: string, userId: string, productId: string, userDisplayName: string | undefined, userEmail: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Applies a batch of license removals (first) then assignments for a customer.
    Returns per-operation success/failure so callers can handle partial failures.
     * @param body (optional) 
     * @return OK
     */
    batchLicenseChanges(custId: string, body: BatchLicenseChangesRequestDto | undefined,  cancelToken?: CancelToken): Promise<BatchLicenseChangesResultDto>;
}

export class CspSelfServiceClient extends AuthorizedApiBase implements ICspSelfServiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets active CSP subscriptions for a customer.
     * @return OK
     */
    getSubscriptions(custId: string, cancelToken?: CancelToken): Promise<CspSubscriptionDto[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/subscriptions/{custId}";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubscriptions(_response);
        });
    }

    protected processGetSubscriptions(response: AxiosResponse): Promise<CspSubscriptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CspSubscriptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CspSubscriptionDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspSubscriptionDto[]>(null as any);
    }

    /**
     * Gets a single CSP subscription with up-to-date refundable seat and cancellation window data.
     * @return OK
     */
    getSubscription(customerId: string, subscriptionId: string, cancelToken?: CancelToken): Promise<CspSubscriptionDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/subscriptions/{customerId}/{subscriptionId}";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubscription(_response);
        });
    }

    protected processGetSubscription(response: AxiosResponse): Promise<CspSubscriptionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspSubscriptionDto.fromJS(resultData200);
            return Promise.resolve<CspSubscriptionDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspSubscriptionDto>(null as any);
    }

    /**
     * Updates a CSP subscription (auto-renew and/or seat count) in a single call.
     * @param body (optional) 
     * @return OK
     */
    updateSubscription(customerId: string, subscriptionId: string, body: UpdateSubscriptionRequest | undefined, cancelToken?: CancelToken): Promise<CspSubscriptionDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/subscriptions/{customerId}/{subscriptionId}";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubscription(_response);
        });
    }

    protected processUpdateSubscription(response: AxiosResponse): Promise<CspSubscriptionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspSubscriptionDto.fromJS(resultData200);
            return Promise.resolve<CspSubscriptionDto>(result200);

        } else if (status === 207) {
            const _responseText = response.data;
            let result207: any = null;
            let resultData207  = _responseText;
            result207 = ProblemDetails.fromJS(resultData207);
            return throwException("Multi-Status", status, _responseText, _headers, result207);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspSubscriptionDto>(null as any);
    }

    /**
     * Gets the customer profile for a CSP customer.
     * @return OK
     */
    getCustomerProfile(custId: string, cancelToken?: CancelToken): Promise<CspCustomerProfileDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/profile";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerProfile(_response);
        });
    }

    protected processGetCustomerProfile(response: AxiosResponse): Promise<CspCustomerProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspCustomerProfileDto.fromJS(resultData200);
            return Promise.resolve<CspCustomerProfileDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspCustomerProfileDto>(null as any);
    }

    /**
     * Creates a Microsoft Customer Agreement attestation for a CSP tenant and returns its signing link.
     * @param body (optional) 
     * @return OK
     */
    createAttestationLink(customerId: string, body: CreateAttestationLinkRequest | undefined, cancelToken?: CancelToken): Promise<AttestationLinkDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{customerId}/attestations";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAttestationLink(_response);
        });
    }

    protected processCreateAttestationLink(response: AxiosResponse): Promise<AttestationLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttestationLinkDto.fromJS(resultData200);
            return Promise.resolve<AttestationLinkDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status === 504) {
            const _responseText = response.data;
            let result504: any = null;
            let resultData504  = _responseText;
            result504 = ProblemDetails.fromJS(resultData504);
            return throwException("Gateway Timeout", status, _responseText, _headers, result504);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttestationLinkDto>(null as any);
    }

    /**
     * Records the signatory's acceptance of the Microsoft Customer Agreement for a CSP tenant.
     * @param body (optional) 
     * @return No Content
     */
    acceptAttestation(customerId: string, body: RecordAttestationAcceptanceRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{customerId}/agreements";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptAttestation(_response);
        });
    }

    protected processAcceptAttestation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status === 504) {
            const _responseText = response.data;
            let result504: any = null;
            let resultData504  = _responseText;
            result504 = ProblemDetails.fromJS(resultData504);
            return throwException("Gateway Timeout", status, _responseText, _headers, result504);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets all tenant subscriptions for the authenticated user's AX account.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getTenantSubscriptions(forceRefresh: boolean | undefined, cancelToken?: CancelToken): Promise<CspTenantSubscriptionsDto[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/tenants?";
        if (forceRefresh === null)
            throw new globalThis.Error("The parameter 'forceRefresh' cannot be null.");
        else if (forceRefresh !== undefined)
            url_ += "forceRefresh=" + encodeURIComponent("" + forceRefresh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantSubscriptions(_response);
        });
    }

    protected processGetTenantSubscriptions(response: AxiosResponse): Promise<CspTenantSubscriptionsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CspTenantSubscriptionsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CspTenantSubscriptionsDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspTenantSubscriptionsDto[]>(null as any);
    }

    /**
     * Gets a composite summary of all tenants with subscriptions and available offer counts.
    Replaces separate calls to tenants + available-offers per tenant on page load.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getSelfServiceSummary(forceRefresh: boolean | undefined, cancelToken?: CancelToken): Promise<CspSelfServiceSummaryDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/summary?";
        if (forceRefresh === null)
            throw new globalThis.Error("The parameter 'forceRefresh' cannot be null.");
        else if (forceRefresh !== undefined)
            url_ += "forceRefresh=" + encodeURIComponent("" + forceRefresh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelfServiceSummary(_response);
        });
    }

    protected processGetSelfServiceSummary(response: AxiosResponse): Promise<CspSelfServiceSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspSelfServiceSummaryDto.fromJS(resultData200);
            return Promise.resolve<CspSelfServiceSummaryDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspSelfServiceSummaryDto>(null as any);
    }

    /**
     * Updates the auto-renew setting for a CSP subscription.
     * @param body (optional) 
     * @return OK
     */
    updateSubscriptionAutoRenew(customerId: string, subscriptionId: string, body: UpdateAutoRenewRequest | undefined, cancelToken?: CancelToken): Promise<CspSubscriptionDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/subscriptions/{customerId}/{subscriptionId}/auto-renew";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubscriptionAutoRenew(_response);
        });
    }

    protected processUpdateSubscriptionAutoRenew(response: AxiosResponse): Promise<CspSubscriptionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspSubscriptionDto.fromJS(resultData200);
            return Promise.resolve<CspSubscriptionDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspSubscriptionDto>(null as any);
    }

    /**
     * Updates the seat count for a CSP subscription immediately.
     * @param body (optional) 
     * @return OK
     */
    updateSubscriptionQuantity(customerId: string, subscriptionId: string, body: UpdateQuantityRequest | undefined, cancelToken?: CancelToken): Promise<CspSubscriptionDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/subscriptions/{customerId}/{subscriptionId}/quantity";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubscriptionQuantity(_response);
        });
    }

    protected processUpdateSubscriptionQuantity(response: AxiosResponse): Promise<CspSubscriptionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspSubscriptionDto.fromJS(resultData200);
            return Promise.resolve<CspSubscriptionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspSubscriptionDto>(null as any);
    }

    /**
     * Cancels a CSP subscription via CloudInt.
    Only permitted within the 7-day NCE cancellation window.
     * @return OK
     */
    cancelSubscription(customerId: string, subscriptionId: string, cancelToken?: CancelToken): Promise<CspSubscriptionDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/subscriptions/{customerId}/{subscriptionId}/cancel";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelSubscription(_response);
        });
    }

    protected processCancelSubscription(response: AxiosResponse): Promise<CspSubscriptionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspSubscriptionDto.fromJS(resultData200);
            return Promise.resolve<CspSubscriptionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspSubscriptionDto>(null as any);
    }

    /**
     * Gets available offers that this customer can purchase, cross-referenced with AX catalog and current subscriptions.
     * @return OK
     */
    getAvailableOffers(custId: string, cancelToken?: CancelToken): Promise<CspAvailableOffersResultDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/available-offers";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableOffers(_response);
        });
    }

    protected processGetAvailableOffers(response: AxiosResponse): Promise<CspAvailableOffersResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspAvailableOffersResultDto.fromJS(resultData200);
            return Promise.resolve<CspAvailableOffersResultDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspAvailableOffersResultDto>(null as any);
    }

    /**
     * Resolves a 2-part offer ID (product:sku) to the full 3-part CatalogItemId (product:sku:availability).
    Call this when the user selects a product to confirm availability before ordering.
     * @return OK
     */
    resolveOfferAvailability(custId: string, offerId: string, cancelToken?: CancelToken): Promise<ResolvedOfferDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/offers/{offerId}/availability";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (offerId === undefined || offerId === null)
            throw new globalThis.Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveOfferAvailability(_response);
        });
    }

    protected processResolveOfferAvailability(response: AxiosResponse): Promise<ResolvedOfferDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResolvedOfferDto.fromJS(resultData200);
            return Promise.resolve<ResolvedOfferDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResolvedOfferDto>(null as any);
    }

    /**
     * Gets the allowable custom term end dates for coterminosity when creating a new subscription.
     * @param newTerm (optional) 
     * @param oldEndDate (optional) 
     * @return OK
     */
    getAllowableTermEndDates(custId: string, newTerm: string | undefined, oldEndDate: Date | undefined, cancelToken?: CancelToken): Promise<Date[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/allowable-term-end-dates?";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (newTerm === null)
            throw new globalThis.Error("The parameter 'newTerm' cannot be null.");
        else if (newTerm !== undefined)
            url_ += "newTerm=" + encodeURIComponent("" + newTerm) + "&";
        if (oldEndDate === null)
            throw new globalThis.Error("The parameter 'oldEndDate' cannot be null.");
        else if (oldEndDate !== undefined)
            url_ += "oldEndDate=" + encodeURIComponent(oldEndDate ? "" + oldEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllowableTermEndDates(_response);
        });
    }

    protected processGetAllowableTermEndDates(response: AxiosResponse): Promise<Date[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(new Date(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Date[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date[]>(null as any);
    }

    /**
     * Creates a new CSP subscription order for a customer.
     * @param body (optional) 
     * @return OK
     */
    createOrder(custId: string, body: CreateOrderDto | undefined, cancelToken?: CancelToken): Promise<CspOrderDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/orders";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrder(_response);
        });
    }

    protected processCreateOrder(response: AxiosResponse): Promise<CspOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspOrderDto.fromJS(resultData200);
            return Promise.resolve<CspOrderDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspOrderDto>(null as any);
    }

    /**
     * Creates a new CSP add-on subscription order for a customer.
    Add-on subscriptions are tied to a parent subscription via ParentSubscriptionId.
     * @param body (optional) 
     * @return OK
     */
    createAddOnOrder(custId: string, body: CreateAddOnOrderDto | undefined, cancelToken?: CancelToken): Promise<CspOrderDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/add-on-orders";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAddOnOrder(_response);
        });
    }

    protected processCreateAddOnOrder(response: AxiosResponse): Promise<CspOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspOrderDto.fromJS(resultData200);
            return Promise.resolve<CspOrderDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status === 504) {
            const _responseText = response.data;
            let result504: any = null;
            let resultData504  = _responseText;
            result504 = ProblemDetails.fromJS(resultData504);
            return throwException("Gateway Timeout", status, _responseText, _headers, result504);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspOrderDto>(null as any);
    }

    /**
     * Gets available add-on offers for a given parent offer.
     * @return OK
     */
    getOfferAddOns(custId: string, offerId: string, cancelToken?: CancelToken): Promise<CspOfferDto[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/offers/{offerId}/add-ons";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (offerId === undefined || offerId === null)
            throw new globalThis.Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfferAddOns(_response);
        });
    }

    protected processGetOfferAddOns(response: AxiosResponse): Promise<CspOfferDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CspOfferDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CspOfferDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspOfferDto[]>(null as any);
    }

    /**
     * Pings CloudIntAX to verify connectivity (legacy endpoint).
     * @return OK
     */
    pingCloudIntAx( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/csp-self-service/health/cloudintax";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPingCloudIntAx(_response);
        });
    }

    protected processPingCloudIntAx(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Pings CloudIntAX new endpoint to verify connectivity.
     * @return OK
     */
    pingCloudIntAxNew( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/csp-self-service/health/cloudintax/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPingCloudIntAxNew(_response);
        });
    }

    protected processPingCloudIntAxNew(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets all active GDAP DAP relationships scoped to the authenticated user's authorized customers.
     * @return OK
     */
    getAllDapRelationships( cancelToken?: CancelToken): Promise<DapRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/gdap/daprels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDapRelationships(_response);
        });
    }

    protected processGetAllDapRelationships(response: AxiosResponse): Promise<DapRelationshipDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DapRelationshipDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DapRelationshipDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DapRelationshipDto[]>(null as any);
    }

    /**
     * Gets GDAP DAP relationships for a specific customer.
     * @return OK
     */
    getDapRelationshipsByCustomer(custId: string, cancelToken?: CancelToken): Promise<DapRelationshipDto[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/gdap/daprels/{custId}";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDapRelationshipsByCustomer(_response);
        });
    }

    protected processGetDapRelationshipsByCustomer(response: AxiosResponse): Promise<DapRelationshipDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DapRelationshipDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DapRelationshipDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DapRelationshipDto[]>(null as any);
    }

    /**
     * Gets a paged, sorted, filtered page of CSP activity logs for a customer.
    Date range, search text, action filter, paging, and sorting are all applied
    server-side via the CSP SearchActivityLog endpoint.
     * @param start (optional) 
     * @param end (optional) 
     * @param searchText (optional) 
     * @param actions (optional) 
     * @param startIndex (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     * @return OK
     */
    getActivityLogs(custId: string, start: Date | undefined, end: Date | undefined, searchText: string | undefined, actions: string[] | undefined, startIndex: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDirection: string | undefined, cancelToken?: CancelToken): Promise<SubscriptionActionLogPagedResultDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/activity-logs?";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (actions === null)
            throw new globalThis.Error("The parameter 'actions' cannot be null.");
        else if (actions !== undefined)
            actions && actions.forEach(item => { url_ += "actions=" + encodeURIComponent("" + item) + "&"; });
        if (startIndex === null)
            throw new globalThis.Error("The parameter 'startIndex' cannot be null.");
        else if (startIndex !== undefined)
            url_ += "startIndex=" + encodeURIComponent("" + startIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityLogs(_response);
        });
    }

    protected processGetActivityLogs(response: AxiosResponse): Promise<SubscriptionActionLogPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubscriptionActionLogPagedResultDto.fromJS(resultData200);
            return Promise.resolve<SubscriptionActionLogPagedResultDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriptionActionLogPagedResultDto>(null as any);
    }

    /**
     * Gets license usage data for a customer's subscribed products.
    Returns active, consumed, and available unit counts per product.
     * @return OK
     */
    getAvailableLicenses(custId: string, cancelToken?: CancelToken): Promise<CspLicenseDto[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/licenses";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableLicenses(_response);
        });
    }

    protected processGetAvailableLicenses(response: AxiosResponse): Promise<CspLicenseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CspLicenseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CspLicenseDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspLicenseDto[]>(null as any);
    }

    /**
     * Gets all users for a CSP customer.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getUsers(custId: string, forceRefresh: boolean | undefined, cancelToken?: CancelToken): Promise<CspUserDto[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/users?";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (forceRefresh === null)
            throw new globalThis.Error("The parameter 'forceRefresh' cannot be null.");
        else if (forceRefresh !== undefined)
            url_ += "forceRefresh=" + encodeURIComponent("" + forceRefresh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<CspUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CspUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CspUserDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspUserDto[]>(null as any);
    }

    /**
     * Gets one page of a CSP customer's users, optionally filtered by a search term, with each user's seat state for a product.
     * @param custId CSP customer ID.
     * @param productId (optional) When set, each user's `hasSeat` says whether they hold this product.
     * @param search (optional) Email or display name search; at least 2 characters.
     * @param continuationToken (optional) Token from the previous page; omit for the first page.
     * @param forceRefresh (optional) Re-read the product's license holders from Partner Center instead of the cache.
     * @return OK
     */
    getUsersPage(custId: string, productId: string | undefined, search: string | undefined, continuationToken: string | undefined, forceRefresh: boolean | undefined, cancelToken?: CancelToken): Promise<CspUserPageDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/users/paged?";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (continuationToken === null)
            throw new globalThis.Error("The parameter 'continuationToken' cannot be null.");
        else if (continuationToken !== undefined)
            url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        if (forceRefresh === null)
            throw new globalThis.Error("The parameter 'forceRefresh' cannot be null.");
        else if (forceRefresh !== undefined)
            url_ += "forceRefresh=" + encodeURIComponent("" + forceRefresh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersPage(_response);
        });
    }

    protected processGetUsersPage(response: AxiosResponse): Promise<CspUserPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CspUserPageDto.fromJS(resultData200);
            return Promise.resolve<CspUserPageDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspUserPageDto>(null as any);
    }

    /**
     * Gets licenses assigned to a specific user.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getUserLicenses(custId: string, userId: string, forceRefresh: boolean | undefined, cancelToken?: CancelToken): Promise<CspUserLicenseDto[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/users/{userId}/licenses?";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (forceRefresh === null)
            throw new globalThis.Error("The parameter 'forceRefresh' cannot be null.");
        else if (forceRefresh !== undefined)
            url_ += "forceRefresh=" + encodeURIComponent("" + forceRefresh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserLicenses(_response);
        });
    }

    protected processGetUserLicenses(response: AxiosResponse): Promise<CspUserLicenseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CspUserLicenseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CspUserLicenseDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CspUserLicenseDto[]>(null as any);
    }

    /**
     * Gets all user IDs that have a specific license.
     * @param forceRefresh (optional) 
     * @return OK
     */
    getUsersWithLicense(custId: string, productId: string, forceRefresh: boolean | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/users/license/{productId}?";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (forceRefresh === null)
            throw new globalThis.Error("The parameter 'forceRefresh' cannot be null.");
        else if (forceRefresh !== undefined)
            url_ += "forceRefresh=" + encodeURIComponent("" + forceRefresh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersWithLicense(_response);
        });
    }

    protected processGetUsersWithLicense(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Removes a license from a user.
     * @param userDisplayName (optional) 
     * @param userEmail (optional) 
     * @return No Content
     */
    removeLicenseFromUser(custId: string, userId: string, productId: string, userDisplayName: string | undefined, userEmail: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/users/{userId}/licenses/{productId}?";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (userDisplayName === null)
            throw new globalThis.Error("The parameter 'userDisplayName' cannot be null.");
        else if (userDisplayName !== undefined)
            url_ += "userDisplayName=" + encodeURIComponent("" + userDisplayName) + "&";
        if (userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveLicenseFromUser(_response);
        });
    }

    protected processRemoveLicenseFromUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Applies a batch of license removals (first) then assignments for a customer.
    Returns per-operation success/failure so callers can handle partial failures.
     * @param body (optional) 
     * @return OK
     */
    batchLicenseChanges(custId: string, body: BatchLicenseChangesRequestDto | undefined, cancelToken?: CancelToken): Promise<BatchLicenseChangesResultDto> {
        let url_ = this.baseUrl + "/api/csp-self-service/customers/{custId}/users/licenses/batch";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchLicenseChanges(_response);
        });
    }

    protected processBatchLicenseChanges(response: AxiosResponse): Promise<BatchLicenseChangesResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchLicenseChangesResultDto.fromJS(resultData200);
            return Promise.resolve<BatchLicenseChangesResultDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchLicenseChangesResultDto>(null as any);
    }
}

export interface ICurrentMonthCloudConsumptionWidgetClient {
    /**
     * @return OK
     */
    getCurrentMonthCloudConsumption( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse>;
}

export class CurrentMonthCloudConsumptionWidgetClient extends AuthorizedApiBase implements ICurrentMonthCloudConsumptionWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getCurrentMonthCloudConsumption( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse> {
        let url_ = this.baseUrl + "/api/widget/current-month-cloud-consumption-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentMonthCloudConsumption(_response);
        });
    }

    protected processGetCurrentMonthCloudConsumption(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse>(null as any);
    }
}

export interface ICurrentUserClient {
    /**
     * Returns the current user's own phone number.
     * @return OK
     */
    getMyPhoneNumber( cancelToken?: CancelToken): Promise<string>;
    /**
     * Returns the current user's profile drawer data.
     * @return OK
     */
    getUserProfileDrawer( cancelToken?: CancelToken): Promise<CurrentUserDrawerResponse>;
}

export class CurrentUserClient extends AuthorizedApiBase implements ICurrentUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the current user's own phone number.
     * @return OK
     */
    getMyPhoneNumber( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/cx-users/current-user/phone-number";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyPhoneNumber(_response);
        });
    }

    protected processGetMyPhoneNumber(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Returns the current user's profile drawer data.
     * @return OK
     */
    getUserProfileDrawer( cancelToken?: CancelToken): Promise<CurrentUserDrawerResponse> {
        let url_ = this.baseUrl + "/api/cx-users/current-user/drawer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfileDrawer(_response);
        });
    }

    protected processGetUserProfileDrawer(response: AxiosResponse): Promise<CurrentUserDrawerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrentUserDrawerResponse.fromJS(resultData200);
            return Promise.resolve<CurrentUserDrawerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentUserDrawerResponse>(null as any);
    }
}

export interface ICustomerExperienceUsersClient {
    /**
     * Returns paged client users for the provided tenant and query options.
     * @param body (optional) Client user query payload.
     * @return OK
     */
    getClientUsersByTenantId(body: CxUsersByTenantRequestDto | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfCxUserAccountDto>;
}

export class CustomerExperienceUsersClient extends AuthorizedApiBase implements ICustomerExperienceUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns paged client users for the provided tenant and query options.
     * @param body (optional) Client user query payload.
     * @return OK
     */
    getClientUsersByTenantId(body: CxUsersByTenantRequestDto | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfCxUserAccountDto> {
        let url_ = this.baseUrl + "/api/cx-users/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientUsersByTenantId(_response);
        });
    }

    protected processGetClientUsersByTenantId(response: AxiosResponse): Promise<PaginatedResultDto_1OfCxUserAccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfCxUserAccountDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfCxUserAccountDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfCxUserAccountDto>(null as any);
    }
}

export interface ICustomerTenantClient {
    /**
     * @return OK
     */
    getCustomerTenantCurrent( cancelToken?: CancelToken): Promise<CustomerTenantDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    searchCustomerTenants(body: CustomerTenantSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfCustomerTenantSearchResultDto>;
}

export class CustomerTenantClient extends AuthorizedApiBase implements ICustomerTenantClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getCustomerTenantCurrent( cancelToken?: CancelToken): Promise<CustomerTenantDto> {
        let url_ = this.baseUrl + "/api/CustomerTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerTenantCurrent(_response);
        });
    }

    protected processGetCustomerTenantCurrent(response: AxiosResponse): Promise<CustomerTenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerTenantDto.fromJS(resultData200);
            return Promise.resolve<CustomerTenantDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerTenantDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchCustomerTenants(body: CustomerTenantSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfCustomerTenantSearchResultDto> {
        let url_ = this.baseUrl + "/api/CustomerTenant/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCustomerTenants(_response);
        });
    }

    protected processSearchCustomerTenants(response: AxiosResponse): Promise<PaginatedResultDto_1OfCustomerTenantSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfCustomerTenantSearchResultDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfCustomerTenantSearchResultDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfCustomerTenantSearchResultDto>(null as any);
    }
}

export interface ICustomerTenantLogoClient {
    /**
     * @return OK
     */
    downloadCustomerTenantLogo( cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return OK
     */
    downloadByTenantId(tenantId: string,  cancelToken?: CancelToken): Promise<FileResponse>;
}

export class CustomerTenantLogoClient extends AuthorizedApiBase implements ICustomerTenantLogoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    downloadCustomerTenantLogo( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomerTenantLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCustomerTenantLogo(_response);
        });
    }

    protected processDownloadCustomerTenantLogo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    downloadByTenantId(tenantId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomerTenantLogo/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadByTenantId(_response);
        });
    }

    protected processDownloadByTenantId(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IDattoRmmClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    updateIntegrations(body: DattoSite[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getDattoDevices(body: DattoRmmDevicesRequest | undefined,  cancelToken?: CancelToken): Promise<DattoRmmDevice>;
}

export class DattoRmmClient extends AuthorizedApiBase implements IDattoRmmClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateIntegrations(body: DattoSite[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/DattoRmm/update-integrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIntegrations(_response);
        });
    }

    protected processUpdateIntegrations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDattoDevices(body: DattoRmmDevicesRequest | undefined, cancelToken?: CancelToken): Promise<DattoRmmDevice> {
        let url_ = this.baseUrl + "/api/DattoRmm/devices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDattoDevices(_response);
        });
    }

    protected processGetDattoDevices(response: AxiosResponse): Promise<DattoRmmDevice> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DattoRmmDevice.fromJS(resultData200);
            return Promise.resolve<DattoRmmDevice>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DattoRmmDevice>(null as any);
    }
}

export interface IDeviceClient {
    /**
     * @return OK
     */
    getDevice( cancelToken?: CancelToken): Promise<ConfigurationItemDTO[]>;
}

export class DeviceClient extends AuthorizedApiBase implements IDeviceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getDevice( cancelToken?: CancelToken): Promise<ConfigurationItemDTO[]> {
        let url_ = this.baseUrl + "/api/Device";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDevice(_response);
        });
    }

    protected processGetDevice(response: AxiosResponse): Promise<ConfigurationItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfigurationItemDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ConfigurationItemDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationItemDTO[]>(null as any);
    }
}

export interface IDurationControlsClient {
    /**
     * Gets the duration controls for the authenticated account.
     * @return Returns the duration controls for the account.
     */
    getForAccount( cancelToken?: CancelToken): Promise<DurationControlsDto[]>;
    /**
     * Gets the duration controls for the specified AX number under the authenticated account.
     * @param axNumber The AX number to filter duration controls.
     * @return Returns the duration controls for the AX number.
     */
    getForAxNumber(axNumber: string,  cancelToken?: CancelToken): Promise<DurationControlsDto[]>;
    /**
     * Gets associated AX account options for the authenticated account.
     * @return Returns associated AX account options for the account.
     */
    getAssociatedAxAccounts( cancelToken?: CancelToken): Promise<AxAccountDropdownOptionDto[]>;
    /**
     * Gets available solution areas for the authenticated account from purchased asset data.
     * @return Returns available solution areas for the account.
     */
    getSolutionAreas( cancelToken?: CancelToken): Promise<string[]>;
    /**
     * Gets a duration control by id for the authenticated account.
     * @param durationControlId The duration control id.
     * @return Returns the duration control.
     */
    getById(durationControlId: number,  cancelToken?: CancelToken): Promise<DurationControlsDto>;
    /**
     * Creates, Updates, or Deletes a duration control for the account
     * @param body (optional) 
     * @return Returns the duration controls for the account.
     */
    createOrUpdate(body: DurationControlsDto | undefined,  cancelToken?: CancelToken): Promise<DurationControlsDto[]>;
    /**
     * Creates, updates, or deletes duration controls for the account in a single request.
     * @param body (optional) The bulk update request.
     * @return Returns the updated duration controls for the account.
     */
    bulkUpdate(body: DurationControlsBulkUpdateRequest | undefined,  cancelToken?: CancelToken): Promise<DurationControlsDto[]>;
    /**
     * Acknowledges pending duration controls in a single request.
    This is meant to be a machine to machine authorized endpoint so the datalake can acknowledge pending duration
    control changes after they have been processed.
     * @param body (optional) The bulk update request.
     * @return Returns the updated duration controls for the account.
     */
    acknowledgePendingDurationControls(body: DurationControlAcknowledgePendingRequestDto | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class DurationControlsClient extends AuthorizedApiBase implements IDurationControlsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets the duration controls for the authenticated account.
     * @return Returns the duration controls for the account.
     */
    getForAccount( cancelToken?: CancelToken): Promise<DurationControlsDto[]> {
        let url_ = this.baseUrl + "/api/duration-controls";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForAccount(_response);
        });
    }

    protected processGetForAccount(response: AxiosResponse): Promise<DurationControlsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurationControlsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DurationControlsDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Unexpected error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DurationControlsDto[]>(null as any);
    }

    /**
     * Gets the duration controls for the specified AX number under the authenticated account.
     * @param axNumber The AX number to filter duration controls.
     * @return Returns the duration controls for the AX number.
     */
    getForAxNumber(axNumber: string, cancelToken?: CancelToken): Promise<DurationControlsDto[]> {
        let url_ = this.baseUrl + "/api/duration-controls/duration-controls-by-ax-number/{axNumber}";
        if (axNumber === undefined || axNumber === null)
            throw new globalThis.Error("The parameter 'axNumber' must be defined.");
        url_ = url_.replace("{axNumber}", encodeURIComponent("" + axNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForAxNumber(_response);
        });
    }

    protected processGetForAxNumber(response: AxiosResponse): Promise<DurationControlsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurationControlsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DurationControlsDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Duration controls were not found for the AX number.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Unexpected error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DurationControlsDto[]>(null as any);
    }

    /**
     * Gets associated AX account options for the authenticated account.
     * @return Returns associated AX account options for the account.
     */
    getAssociatedAxAccounts( cancelToken?: CancelToken): Promise<AxAccountDropdownOptionDto[]> {
        let url_ = this.baseUrl + "/api/duration-controls/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssociatedAxAccounts(_response);
        });
    }

    protected processGetAssociatedAxAccounts(response: AxiosResponse): Promise<AxAccountDropdownOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AxAccountDropdownOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AxAccountDropdownOptionDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Account was not found for the current context.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Unexpected error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AxAccountDropdownOptionDto[]>(null as any);
    }

    /**
     * Gets available solution areas for the authenticated account from purchased asset data.
     * @return Returns available solution areas for the account.
     */
    getSolutionAreas( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/duration-controls/solution-areas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSolutionAreas(_response);
        });
    }

    protected processGetSolutionAreas(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Account was not found for the current context.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Unexpected error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Gets a duration control by id for the authenticated account.
     * @param durationControlId The duration control id.
     * @return Returns the duration control.
     */
    getById(durationControlId: number, cancelToken?: CancelToken): Promise<DurationControlsDto> {
        let url_ = this.baseUrl + "/api/duration-controls/{durationControlId}";
        if (durationControlId === undefined || durationControlId === null)
            throw new globalThis.Error("The parameter 'durationControlId' must be defined.");
        url_ = url_.replace("{durationControlId}", encodeURIComponent("" + durationControlId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DurationControlsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DurationControlsDto.fromJS(resultData200);
            return Promise.resolve<DurationControlsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Duration control was not found for the account.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Unexpected error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DurationControlsDto>(null as any);
    }

    /**
     * Creates, Updates, or Deletes a duration control for the account
     * @param body (optional) 
     * @return Returns the duration controls for the account.
     */
    createOrUpdate(body: DurationControlsDto | undefined, cancelToken?: CancelToken): Promise<DurationControlsDto[]> {
        let url_ = this.baseUrl + "/api/duration-controls/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<DurationControlsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurationControlsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DurationControlsDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid duration control request.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Duration control was not found for the account.", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflicting pending duration control change exists for the requested scope.", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Unexpected error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DurationControlsDto[]>(null as any);
    }

    /**
     * Creates, updates, or deletes duration controls for the account in a single request.
     * @param body (optional) The bulk update request.
     * @return Returns the updated duration controls for the account.
     */
    bulkUpdate(body: DurationControlsBulkUpdateRequest | undefined, cancelToken?: CancelToken): Promise<DurationControlsDto[]> {
        let url_ = this.baseUrl + "/api/duration-controls/bulk-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdate(_response);
        });
    }

    protected processBulkUpdate(response: AxiosResponse): Promise<DurationControlsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DurationControlsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DurationControlsDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid duration control request.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Duration control was not found for the account.", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflicting pending duration control change exists for the requested scope.", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Unexpected error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DurationControlsDto[]>(null as any);
    }

    /**
     * Acknowledges pending duration controls in a single request.
    This is meant to be a machine to machine authorized endpoint so the datalake can acknowledge pending duration
    control changes after they have been processed.
     * @param body (optional) The bulk update request.
     * @return Returns the updated duration controls for the account.
     */
    acknowledgePendingDurationControls(body: DurationControlAcknowledgePendingRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/duration-controls/acknowledge-pending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcknowledgePendingDurationControls(_response);
        });
    }

    protected processAcknowledgePendingDurationControls(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid duration control request.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Duration control was not found for the account.", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflicting pending duration control change exists for the requested scope.", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Unexpected error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDynamicTagClient {
    /**
     * @return OK
     */
    getAccountDynamicTags( cancelToken?: CancelToken): Promise<DynamicTag[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createDynamicTag(body: DynamicTagRequest | undefined,  cancelToken?: CancelToken): Promise<DynamicTag[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateDynamicTag(body: DynamicTagRequest | undefined,  cancelToken?: CancelToken): Promise<DynamicTag[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteDynamicTag(body: number[] | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class DynamicTagClient extends AuthorizedApiBase implements IDynamicTagClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAccountDynamicTags( cancelToken?: CancelToken): Promise<DynamicTag[]> {
        let url_ = this.baseUrl + "/api/DynamicTag";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountDynamicTags(_response);
        });
    }

    protected processGetAccountDynamicTags(response: AxiosResponse): Promise<DynamicTag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DynamicTag.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DynamicTag[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicTag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createDynamicTag(body: DynamicTagRequest | undefined, cancelToken?: CancelToken): Promise<DynamicTag[]> {
        let url_ = this.baseUrl + "/api/DynamicTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDynamicTag(_response);
        });
    }

    protected processCreateDynamicTag(response: AxiosResponse): Promise<DynamicTag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DynamicTag.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DynamicTag[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 424) {
            const _responseText = response.data;
            let result424: any = null;
            let resultData424  = _responseText;
            result424 = ProblemDetails.fromJS(resultData424);
            return throwException("Failed Dependency", status, _responseText, _headers, result424);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicTag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDynamicTag(body: DynamicTagRequest | undefined, cancelToken?: CancelToken): Promise<DynamicTag[]> {
        let url_ = this.baseUrl + "/api/DynamicTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDynamicTag(_response);
        });
    }

    protected processUpdateDynamicTag(response: AxiosResponse): Promise<DynamicTag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DynamicTag.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DynamicTag[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 424) {
            const _responseText = response.data;
            let result424: any = null;
            let resultData424  = _responseText;
            result424 = ProblemDetails.fromJS(resultData424);
            return throwException("Failed Dependency", status, _responseText, _headers, result424);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicTag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteDynamicTag(body: number[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DynamicTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDynamicTag(_response);
        });
    }

    protected processDeleteDynamicTag(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 424) {
            const _responseText = response.data;
            let result424: any = null;
            let resultData424  = _responseText;
            result424 = ProblemDetails.fromJS(resultData424);
            return throwException("Failed Dependency", status, _responseText, _headers, result424);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IEcommerceShoppingCartClient {
    /**
     * @return OK
     */
    getShoppingCartItems( cancelToken?: CancelToken): Promise<ShoppingCartDto[]>;
    /**
     * Returns cart lines enriched with attached configuration children and availability so the full
    cart page can render devices with their current configuration status.
     * @return OK
     */
    getShoppingCartLines( cancelToken?: CancelToken): Promise<ShoppingCartLineDto[]>;
    /**
     * Adds a device (config-system base system) plus a single warranty option to the cart via the
    config-system mechanism. The warranty quantity is forced to match the device quantity and only
    one warranty is attached per device.
     * @return OK
     */
    addDeviceWithWarranty(body: AddDeviceWarrantyRequestDto,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Updates a device line quantity and keeps any attached warranty's quantity in sync.
     * @return No Content
     */
    updateDeviceQuantity(lineNumber: number, body: UpdateCartItemQuantityRequest,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    deleteShoppingCartItem(lineNumber: number,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    clearShoppingCart(body: ClearShoppingCartRequestDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateShoppingCartItemQuantity(lineNumber: number, body: UpdateCartItemQuantityRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addShoppingCartItem(body: AddShoppingCartDto | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addQuoteItemsToShoppingCart(quoteId: number, body: QuoteCartLineSelectionDto[] | undefined,  cancelToken?: CancelToken): Promise<BuyAgainResponseDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    buyAgain(body: BuyAgainRequestDto | undefined,  cancelToken?: CancelToken): Promise<BuyAgainResponseDto>;
    /**
     * Returns thumbnail image URLs for the supplied cart product ids
    (ShoppingCartDto.ItemId). The response maps product-id-as-string to image URL;
    ids without a thumbnail are omitted.
     * @param body (optional) 
     * @return OK
     */
    getCartItemThumbnails(body: number[] | undefined,  cancelToken?: CancelToken): Promise<{ [key: string]: string; }>;
    /**
     * Returns recommended add-ons (Accessories and Warranty/Support sections) for a single
    hardware product, for the add-to-cart modal. Accessories are returned for any hardware
    product; warranties are returned only for config-system products. Each section is capped
    for display with a "has more" flag that drives the modal's "view more" link.
     * @return OK
     */
    getRecommendedAddOns(productDescriptor: string, productClass: string,  cancelToken?: CancelToken): Promise<RecommendedAddOnsDto>;
    /**
     * Returns related/recommended products for the supplied seed product ids (prior cart/session
    context), enriched for card display. Used by the empty-cart "Browse Related Products" grid.
     * @param body (optional) 
     * @return OK
     */
    getRelatedProducts(body: number[] | undefined,  cancelToken?: CancelToken): Promise<RelatedProductDto[]>;
    /**
     * Returns per-item availability for the supplied cart product ids
    (ShoppingCartDto.ItemId). Each item is mapped to an in-stock / back-order
    indicator derived from the distributor + warehouse stock totals. Items that
    cannot be resolved are omitted rather than reported as out of stock.
     * @param body (optional) 
     * @return OK
     */
    getCartItemAvailability(body: number[] | undefined,  cancelToken?: CancelToken): Promise<CartItemAvailabilityDto[]>;
}

export class EcommerceShoppingCartClient extends AuthorizedApiBase implements IEcommerceShoppingCartClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getShoppingCartItems( cancelToken?: CancelToken): Promise<ShoppingCartDto[]> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShoppingCartItems(_response);
        });
    }

    protected processGetShoppingCartItems(response: AxiosResponse): Promise<ShoppingCartDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShoppingCartDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShoppingCartDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartDto[]>(null as any);
    }

    /**
     * Returns cart lines enriched with attached configuration children and availability so the full
    cart page can render devices with their current configuration status.
     * @return OK
     */
    getShoppingCartLines( cancelToken?: CancelToken): Promise<ShoppingCartLineDto[]> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/lines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShoppingCartLines(_response);
        });
    }

    protected processGetShoppingCartLines(response: AxiosResponse): Promise<ShoppingCartLineDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShoppingCartLineDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShoppingCartLineDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartLineDto[]>(null as any);
    }

    /**
     * Adds a device (config-system base system) plus a single warranty option to the cart via the
    config-system mechanism. The warranty quantity is forced to match the device quantity and only
    one warranty is attached per device.
     * @return OK
     */
    addDeviceWithWarranty(body: AddDeviceWarrantyRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/device-with-warranty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDeviceWithWarranty(_response);
        });
    }

    protected processAddDeviceWithWarranty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates a device line quantity and keeps any attached warranty's quantity in sync.
     * @return No Content
     */
    updateDeviceQuantity(lineNumber: number, body: UpdateCartItemQuantityRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/{lineNumber}/device-quantity";
        if (lineNumber === undefined || lineNumber === null)
            throw new globalThis.Error("The parameter 'lineNumber' must be defined.");
        url_ = url_.replace("{lineNumber}", encodeURIComponent("" + lineNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDeviceQuantity(_response);
        });
    }

    protected processUpdateDeviceQuantity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    deleteShoppingCartItem(lineNumber: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/{lineNumber}";
        if (lineNumber === undefined || lineNumber === null)
            throw new globalThis.Error("The parameter 'lineNumber' must be defined.");
        url_ = url_.replace("{lineNumber}", encodeURIComponent("" + lineNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteShoppingCartItem(_response);
        });
    }

    protected processDeleteShoppingCartItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    clearShoppingCart(body: ClearShoppingCartRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/clear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearShoppingCart(_response);
        });
    }

    protected processClearShoppingCart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateShoppingCartItemQuantity(lineNumber: number, body: UpdateCartItemQuantityRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/{lineNumber}/quantity";
        if (lineNumber === undefined || lineNumber === null)
            throw new globalThis.Error("The parameter 'lineNumber' must be defined.");
        url_ = url_.replace("{lineNumber}", encodeURIComponent("" + lineNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateShoppingCartItemQuantity(_response);
        });
    }

    protected processUpdateShoppingCartItemQuantity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addShoppingCartItem(body: AddShoppingCartDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddShoppingCartItem(_response);
        });
    }

    protected processAddShoppingCartItem(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addQuoteItemsToShoppingCart(quoteId: number, body: QuoteCartLineSelectionDto[] | undefined, cancelToken?: CancelToken): Promise<BuyAgainResponseDto> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/quote/{quoteId}/add-to-cart";
        if (quoteId === undefined || quoteId === null)
            throw new globalThis.Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddQuoteItemsToShoppingCart(_response);
        });
    }

    protected processAddQuoteItemsToShoppingCart(response: AxiosResponse): Promise<BuyAgainResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BuyAgainResponseDto.fromJS(resultData200);
            return Promise.resolve<BuyAgainResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuyAgainResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    buyAgain(body: BuyAgainRequestDto | undefined, cancelToken?: CancelToken): Promise<BuyAgainResponseDto> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/buy-again";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuyAgain(_response);
        });
    }

    protected processBuyAgain(response: AxiosResponse): Promise<BuyAgainResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BuyAgainResponseDto.fromJS(resultData200);
            return Promise.resolve<BuyAgainResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuyAgainResponseDto>(null as any);
    }

    /**
     * Returns thumbnail image URLs for the supplied cart product ids
    (ShoppingCartDto.ItemId). The response maps product-id-as-string to image URL;
    ids without a thumbnail are omitted.
     * @param body (optional) 
     * @return OK
     */
    getCartItemThumbnails(body: number[] | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/thumbnails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCartItemThumbnails(_response);
        });
    }

    protected processGetCartItemThumbnails(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Returns recommended add-ons (Accessories and Warranty/Support sections) for a single
    hardware product, for the add-to-cart modal. Accessories are returned for any hardware
    product; warranties are returned only for config-system products. Each section is capped
    for display with a "has more" flag that drives the modal's "view more" link.
     * @return OK
     */
    getRecommendedAddOns(productDescriptor: string, productClass: string, cancelToken?: CancelToken): Promise<RecommendedAddOnsDto> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/addons?";
        if (productDescriptor === undefined || productDescriptor === null)
            throw new globalThis.Error("The parameter 'productDescriptor' must be defined and cannot be null.");
        else
            url_ += "productDescriptor=" + encodeURIComponent("" + productDescriptor) + "&";
        if (productClass === undefined || productClass === null)
            throw new globalThis.Error("The parameter 'productClass' must be defined and cannot be null.");
        else
            url_ += "productClass=" + encodeURIComponent("" + productClass) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecommendedAddOns(_response);
        });
    }

    protected processGetRecommendedAddOns(response: AxiosResponse): Promise<RecommendedAddOnsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RecommendedAddOnsDto.fromJS(resultData200);
            return Promise.resolve<RecommendedAddOnsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecommendedAddOnsDto>(null as any);
    }

    /**
     * Returns related/recommended products for the supplied seed product ids (prior cart/session
    context), enriched for card display. Used by the empty-cart "Browse Related Products" grid.
     * @param body (optional) 
     * @return OK
     */
    getRelatedProducts(body: number[] | undefined, cancelToken?: CancelToken): Promise<RelatedProductDto[]> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/related-products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRelatedProducts(_response);
        });
    }

    protected processGetRelatedProducts(response: AxiosResponse): Promise<RelatedProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RelatedProductDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RelatedProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelatedProductDto[]>(null as any);
    }

    /**
     * Returns per-item availability for the supplied cart product ids
    (ShoppingCartDto.ItemId). Each item is mapped to an in-stock / back-order
    indicator derived from the distributor + warehouse stock totals. Items that
    cannot be resolved are omitted rather than reported as out of stock.
     * @param body (optional) 
     * @return OK
     */
    getCartItemAvailability(body: number[] | undefined, cancelToken?: CancelToken): Promise<CartItemAvailabilityDto[]> {
        let url_ = this.baseUrl + "/api/EcommerceShoppingCart/shoppingcart/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCartItemAvailability(_response);
        });
    }

    protected processGetCartItemAvailability(response: AxiosResponse): Promise<CartItemAvailabilityDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CartItemAvailabilityDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CartItemAvailabilityDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CartItemAvailabilityDto[]>(null as any);
    }
}

export interface IExpiringContractWidgetClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getExpiringContracts(body: AssetExpiringContractsWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<AssetExpiringContractsWidgetResponse>;
}

export class ExpiringContractWidgetClient extends AuthorizedApiBase implements IExpiringContractWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getExpiringContracts(body: AssetExpiringContractsWidgetRequest | undefined, cancelToken?: CancelToken): Promise<AssetExpiringContractsWidgetResponse> {
        let url_ = this.baseUrl + "/api/widget/assets-expiring-contracts-widget/expiring-contracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExpiringContracts(_response);
        });
    }

    protected processGetExpiringContracts(response: AxiosResponse): Promise<AssetExpiringContractsWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetExpiringContractsWidgetResponse.fromJS(resultData200);
            return Promise.resolve<AssetExpiringContractsWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetExpiringContractsWidgetResponse>(null as any);
    }
}

export interface IFeatureFlagClient {
    /**
     * @return OK
     */
    validateFeatureIsEnabled(key: string,  cancelToken?: CancelToken): Promise<boolean>;
}

export class FeatureFlagClient extends AuthorizedApiBase implements IFeatureFlagClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    validateFeatureIsEnabled(key: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/FeatureFlag/validate/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateFeatureIsEnabled(_response);
        });
    }

    protected processValidateFeatureIsEnabled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IFeatureManagementClient {
    /**
     * @return OK
     */
    getMicrosoftInsightsReportStatus( cancelToken?: CancelToken): Promise<MicrosoftInsightsReportStatusDto>;
}

export class FeatureManagementClient extends AuthorizedApiBase implements IFeatureManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getMicrosoftInsightsReportStatus( cancelToken?: CancelToken): Promise<MicrosoftInsightsReportStatusDto> {
        let url_ = this.baseUrl + "/api/feature-management/microsoft-insights/report-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicrosoftInsightsReportStatus(_response);
        });
    }

    protected processGetMicrosoftInsightsReportStatus(response: AxiosResponse): Promise<MicrosoftInsightsReportStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicrosoftInsightsReportStatusDto.fromJS(resultData200);
            return Promise.resolve<MicrosoftInsightsReportStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicrosoftInsightsReportStatusDto>(null as any);
    }
}

export interface IFileClient {
    /**
     * @return OK
     */
    uploadInternalAdminFileToBlobStorage( cancelToken?: CancelToken): Promise<FileValidationDto>;
    /**
     * @return OK
     */
    deleteInternalAdminTmpFile( cancelToken?: CancelToken): Promise<void>;
    /**
     * @param fileType (optional) 
     * @param filepond (optional) 
     * @return OK
     */
    uploadInternalSHIFileToBlobStorage(fileType: FileTypes | undefined, filepond: FileParameter | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    deleteInternalSHITmpFile( cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    downloadBlobFile(containerName: string, guid: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Downloads employee photos by entraId.
     * @param entraId The ID of the employee.
     * @return OK
     */
    downloadEmployeePhotos(entraId: string,  cancelToken?: CancelToken): Promise<FileResponse>;
}

export class FileClient extends AuthorizedApiBase implements IFileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    uploadInternalAdminFileToBlobStorage( cancelToken?: CancelToken): Promise<FileValidationDto> {
        let url_ = this.baseUrl + "/api/FileController/InternalAdminTmp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadInternalAdminFileToBlobStorage(_response);
        });
    }

    protected processUploadInternalAdminFileToBlobStorage(response: AxiosResponse): Promise<FileValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileValidationDto.fromJS(resultData200);
            return Promise.resolve<FileValidationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileValidationDto>(null as any);
    }

    /**
     * @return OK
     */
    deleteInternalAdminTmpFile( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FileController/InternalAdminTmp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInternalAdminTmpFile(_response);
        });
    }

    protected processDeleteInternalAdminTmpFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileType (optional) 
     * @param filepond (optional) 
     * @return OK
     */
    uploadInternalSHIFileToBlobStorage(fileType: FileTypes | undefined, filepond: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FileController/InternalSHITmp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileType === null || fileType === undefined)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("FileType", fileType.toString());
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadInternalSHIFileToBlobStorage(_response);
        });
    }

    protected processUploadInternalSHIFileToBlobStorage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    deleteInternalSHITmpFile( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FileController/InternalSHITmp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInternalSHITmpFile(_response);
        });
    }

    protected processDeleteInternalSHITmpFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    downloadBlobFile(containerName: string, guid: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FileController/Download/{containerName}/{guid}";
        if (containerName === undefined || containerName === null)
            throw new globalThis.Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadBlobFile(_response);
        });
    }

    protected processDownloadBlobFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Downloads employee photos by entraId.
     * @param entraId The ID of the employee.
     * @return OK
     */
    downloadEmployeePhotos(entraId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/FileController/download/employee-photos/{entraId}";
        if (entraId === undefined || entraId === null)
            throw new globalThis.Error("The parameter 'entraId' must be defined.");
        url_ = url_.replace("{entraId}", encodeURIComponent("" + entraId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadEmployeePhotos(_response);
        });
    }

    protected processDownloadEmployeePhotos(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFileHandlerClient {
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadCiscoSupplementalDataByAccountId(accountId: number, filepond: FileParameter | undefined, hello: string | undefined,  cancelToken?: CancelToken): Promise<FileUploadResponse_1OfCiscoSupplementalDataDto>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadCiscoThirdPartyContractsByAccountId(accountId: number, filepond: FileParameter | undefined, hello: string | undefined,  cancelToken?: CancelToken): Promise<FileUploadResponse_1OfCiscoThirdPartyContractDataDto>;
    /**
     * @param overwriteExistingData (optional) 
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadAssetManagementDataForFileHandler(accountId: number, overwriteExistingData: boolean | undefined, filepond: FileParameter | undefined, hello: string | undefined,  cancelToken?: CancelToken): Promise<FileUploadResponse_1OfManualManagedAssetDataRecordDto>;
    /**
     * @param accountId (optional) 
     * @return OK
     */
    downloadAssetManagementData(accountId: number | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadGcpCloudAssetServiceAccountKey(accountId: number, filepond: FileParameter | undefined, hello: string | undefined,  cancelToken?: CancelToken): Promise<string>;
}

export class FileHandlerClient extends AuthorizedApiBase implements IFileHandlerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadCiscoSupplementalDataByAccountId(accountId: number, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<FileUploadResponse_1OfCiscoSupplementalDataDto> {
        let url_ = this.baseUrl + "/api/FileHandler/cisco-supplemental-data/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new globalThis.Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoSupplementalDataByAccountId(_response);
        });
    }

    protected processUploadCiscoSupplementalDataByAccountId(response: AxiosResponse): Promise<FileUploadResponse_1OfCiscoSupplementalDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadResponse_1OfCiscoSupplementalDataDto.fromJS(resultData200);
            return Promise.resolve<FileUploadResponse_1OfCiscoSupplementalDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponse_1OfCiscoSupplementalDataDto>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadCiscoThirdPartyContractsByAccountId(accountId: number, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<FileUploadResponse_1OfCiscoThirdPartyContractDataDto> {
        let url_ = this.baseUrl + "/api/FileHandler/cisco-third-party-contracts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new globalThis.Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoThirdPartyContractsByAccountId(_response);
        });
    }

    protected processUploadCiscoThirdPartyContractsByAccountId(response: AxiosResponse): Promise<FileUploadResponse_1OfCiscoThirdPartyContractDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadResponse_1OfCiscoThirdPartyContractDataDto.fromJS(resultData200);
            return Promise.resolve<FileUploadResponse_1OfCiscoThirdPartyContractDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponse_1OfCiscoThirdPartyContractDataDto>(null as any);
    }

    /**
     * @param overwriteExistingData (optional) 
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadAssetManagementDataForFileHandler(accountId: number, overwriteExistingData: boolean | undefined, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<FileUploadResponse_1OfManualManagedAssetDataRecordDto> {
        let url_ = this.baseUrl + "/api/FileHandler/asset-management/{accountId}?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (overwriteExistingData === null)
            throw new globalThis.Error("The parameter 'overwriteExistingData' cannot be null.");
        else if (overwriteExistingData !== undefined)
            url_ += "overwriteExistingData=" + encodeURIComponent("" + overwriteExistingData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new globalThis.Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAssetManagementDataForFileHandler(_response);
        });
    }

    protected processUploadAssetManagementDataForFileHandler(response: AxiosResponse): Promise<FileUploadResponse_1OfManualManagedAssetDataRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadResponse_1OfManualManagedAssetDataRecordDto.fromJS(resultData200);
            return Promise.resolve<FileUploadResponse_1OfManualManagedAssetDataRecordDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponse_1OfManualManagedAssetDataRecordDto>(null as any);
    }

    /**
     * @param accountId (optional) 
     * @return OK
     */
    downloadAssetManagementData(accountId: number | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/FileHandler/asset-management?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAssetManagementData(_response);
        });
    }

    protected processDownloadAssetManagementData(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadGcpCloudAssetServiceAccountKey(accountId: number, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/FileHandler/gcp-cloud-asset-inventory/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new globalThis.Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadGcpCloudAssetServiceAccountKey(_response);
        });
    }

    protected processUploadGcpCloudAssetServiceAccountKey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IFunctionUpdateClient {
    /**
     * @return OK
     */
    updateAccountCache( cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getPicklistValues( cancelToken?: CancelToken): Promise<AutotaskPicklistEntity[]>;
    /**
     * @return OK
     */
    updatePicklistValues( cancelToken?: CancelToken): Promise<OldPicklistValue[]>;
}

export class FunctionUpdateClient extends AuthorizedApiBase implements IFunctionUpdateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    updateAccountCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FunctionUpdate/accountcache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccountCache(_response);
        });
    }

    protected processUpdateAccountCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getPicklistValues( cancelToken?: CancelToken): Promise<AutotaskPicklistEntity[]> {
        let url_ = this.baseUrl + "/api/FunctionUpdate/getpicklistvalues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPicklistValues(_response);
        });
    }

    protected processGetPicklistValues(response: AxiosResponse): Promise<AutotaskPicklistEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AutotaskPicklistEntity.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AutotaskPicklistEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutotaskPicklistEntity[]>(null as any);
    }

    /**
     * @return OK
     */
    updatePicklistValues( cancelToken?: CancelToken): Promise<OldPicklistValue[]> {
        let url_ = this.baseUrl + "/api/FunctionUpdate/updatepicklistvalues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePicklistValues(_response);
        });
    }

    protected processUpdatePicklistValues(response: AxiosResponse): Promise<OldPicklistValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OldPicklistValue.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OldPicklistValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OldPicklistValue[]>(null as any);
    }
}

export interface IGridFiltersClient {
    /**
     * Gets all grid filters for the current user and specified location
     * @param location (optional) 
     * @return OK
     */
    getGridFilters(location: string | undefined,  cancelToken?: CancelToken): Promise<GridFilterDto[]>;
    /**
     * Creates a new grid filter
     * @param body (optional) 
     * @return OK
     */
    createGridFilter(body: CreateGridFilterRequest | undefined,  cancelToken?: CancelToken): Promise<GridFilterResult>;
    /**
     * Updates an existing grid filter
     * @param body (optional) 
     * @return OK
     */
    updateGridFilter(filterId: number, body: UpdateGridFilterRequest | undefined,  cancelToken?: CancelToken): Promise<GridFilterResult>;
    /**
     * Deletes a grid filter
     * @return OK
     */
    deleteGridFilter(filterId: number,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Sets or unsets a grid filter as default
     * @param isDefault (optional) 
     * @return OK
     */
    setGridFilterAsDefault(filterId: number, isDefault: boolean | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class GridFiltersClient extends AuthorizedApiBase implements IGridFiltersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets all grid filters for the current user and specified location
     * @param location (optional) 
     * @return OK
     */
    getGridFilters(location: string | undefined, cancelToken?: CancelToken): Promise<GridFilterDto[]> {
        let url_ = this.baseUrl + "/api/GridFilters?";
        if (location === null)
            throw new globalThis.Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGridFilters(_response);
        });
    }

    protected processGetGridFilters(response: AxiosResponse): Promise<GridFilterDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GridFilterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GridFilterDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GridFilterDto[]>(null as any);
    }

    /**
     * Creates a new grid filter
     * @param body (optional) 
     * @return OK
     */
    createGridFilter(body: CreateGridFilterRequest | undefined, cancelToken?: CancelToken): Promise<GridFilterResult> {
        let url_ = this.baseUrl + "/api/GridFilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGridFilter(_response);
        });
    }

    protected processCreateGridFilter(response: AxiosResponse): Promise<GridFilterResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GridFilterResult.fromJS(resultData200);
            return Promise.resolve<GridFilterResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = GridFilterResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GridFilterResult>(null as any);
    }

    /**
     * Updates an existing grid filter
     * @param body (optional) 
     * @return OK
     */
    updateGridFilter(filterId: number, body: UpdateGridFilterRequest | undefined, cancelToken?: CancelToken): Promise<GridFilterResult> {
        let url_ = this.baseUrl + "/api/GridFilters/{filterId}";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGridFilter(_response);
        });
    }

    protected processUpdateGridFilter(response: AxiosResponse): Promise<GridFilterResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GridFilterResult.fromJS(resultData200);
            return Promise.resolve<GridFilterResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = GridFilterResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GridFilterResult>(null as any);
    }

    /**
     * Deletes a grid filter
     * @return OK
     */
    deleteGridFilter(filterId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GridFilters/{filterId}";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGridFilter(_response);
        });
    }

    protected processDeleteGridFilter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = GridFilterResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sets or unsets a grid filter as default
     * @param isDefault (optional) 
     * @return OK
     */
    setGridFilterAsDefault(filterId: number, isDefault: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/GridFilters/{filterId}/default?";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        if (isDefault === null)
            throw new globalThis.Error("The parameter 'isDefault' cannot be null.");
        else if (isDefault !== undefined)
            url_ += "isDefault=" + encodeURIComponent("" + isDefault) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetGridFilterAsDefault(_response);
        });
    }

    protected processSetGridFilterAsDefault(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IHardwareLifeCycleManagementClient {
    /**
     * @return OK
     */
    getHardwareLifecycleManagementStatuses( cancelToken?: CancelToken): Promise<AxCustomerHlmOrderDto>;
}

export class HardwareLifeCycleManagementClient extends AuthorizedApiBase implements IHardwareLifeCycleManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getHardwareLifecycleManagementStatuses( cancelToken?: CancelToken): Promise<AxCustomerHlmOrderDto> {
        let url_ = this.baseUrl + "/api/HardwareLifeCycleManagement/order-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHardwareLifecycleManagementStatuses(_response);
        });
    }

    protected processGetHardwareLifecycleManagementStatuses(response: AxiosResponse): Promise<AxCustomerHlmOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AxCustomerHlmOrderDto.fromJS(resultData200);
            return Promise.resolve<AxCustomerHlmOrderDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AxCustomerHlmOrderDto>(null as any);
    }
}

export interface IIdcsClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    createIdcsChangeRequest(body: CreateIdcsChangeRequestDto | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class IdcsClient extends AuthorizedApiBase implements IIdcsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createIdcsChangeRequest(body: CreateIdcsChangeRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Idcs/idcs-change-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIdcsChangeRequest(_response);
        });
    }

    protected processCreateIdcsChangeRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IIdpAuthenticationClient {
    /**
     * @param connection (optional) 
     * @param user_Agent (optional) 
     * @return OK
     */
    initiateIdpLogin(connection: string | undefined, user_Agent: string | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class IdpAuthenticationClient extends AuthorizedApiBase implements IIdpAuthenticationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param connection (optional) 
     * @param user_Agent (optional) 
     * @return OK
     */
    initiateIdpLogin(connection: string | undefined, user_Agent: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/IdpAuthentication/idp-initiate?";
        if (connection === null)
            throw new globalThis.Error("The parameter 'connection' cannot be null.");
        else if (connection !== undefined)
            url_ += "connection=" + encodeURIComponent("" + connection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "User-Agent": user_Agent !== undefined && user_Agent !== null ? "" + user_Agent : "",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitiateIdpLogin(_response);
        });
    }

    protected processInitiateIdpLogin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IIntegrationClient {
    /**
     * @return No Content
     */
    deleteIntegration(integrationId: number,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    registerIntegration(body: IntegrationDTO | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateIntegration(body: IntegrationDTO | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO>;
    /**
     * Toggles activation of Integrations in the integrations table from active to inactive or inactive to active.
     * @param activate (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleIntegrationActivation(activate: boolean | undefined, body: IntegrationDTO[] | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO[]>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadCiscoReadyReportByAccountId(accountId: string, filepond: FileParameter | undefined, hello: string | undefined,  cancelToken?: CancelToken): Promise<CiscoReadyReportUploadResponse>;
    /**
     * @param enabledOnly (optional) 
     * @return OK
     */
    getIntegrationDefinitions(enabledOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<IntegrationDefinition[]>;
    /**
     * Get a list of all subscriptionIds along with display names for configured integration types
    Currently supports Azure tenant types
     * @return OK
     */
    getIntegrationAccounts( cancelToken?: CancelToken): Promise<CustomerAccount[]>;
    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getIntegrations(activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postIntegration(body: IntegrationDTO | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postIntegrationBatch(body: IntegrationDTO[] | undefined,  cancelToken?: CancelToken): Promise<BatchIntegrationResult>;
    /**
     * @return OK
     */
    doesAccountExists(axNumber: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getAxReferencesByAccountId(accountId: number,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * Get All Integrations by the IntegrationType
     * @param integrationType (optional) Type Of Integrations to retrieve
     * @param activeOnly (optional) True if only active integrations (true by default)
     * @return OK
     */
    getIntegrationsByType(integrationType: IntegrationType | undefined, activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getCiscoSNTCIntegrations(activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<CiscoSNTCIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getCiscoEAIntegrations(activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<CiscoEnterpriseAgreementIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAzureComplianceIntegrations(activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<AzureComplianceIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAwsComplianceIntegrations(activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<AwsComplianceIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAwsSimpleRecommendationsIntegrations(activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<AwsSimpleRecommendationsIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAzureSimpleRecommendationsIntegrations(activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<AzureSimpleRecommendationsIntegrationDTO[]>;
    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAzureBackupsIntegrations(activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<AzureBackupsIntegrationDTO[]>;
    /**
     * @return OK
     */
    allIntegrationsByAccountId(accountId: number,  cancelToken?: CancelToken): Promise<CustomerAccount[]>;
    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    activeIntegrationsByAccountId(accountId: number, activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    uploadCiscoSNTCByAccountId(accountId: number, body: BasicCiscoSNTCIntegrationDTO | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    uploadCiscoEAByAccountId(accountId: number, body: BasicCiscoEAIntegrationDTO | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    registerSelfServiceReportingIntegration(accountId: number, body: SelfServiceReportingIntegrationDto | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    registerHardwareLifecycleManagementIntegration(accountId: string, body: HardwareLifecycleManagementIntegrationDTO | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    registerAwsGovernanceReportIntegration(accountId: string, body: AwsGovernanceReportsDto | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    registerAzureGovernanceReportIntegration(accountId: string, body: AzureGovernanceReportsDto | undefined,  cancelToken?: CancelToken): Promise<IntegrationDTO>;
    /**
     * @return OK
     */
    registerDatadogUsageReportIntegration(accountId: string,  cancelToken?: CancelToken): Promise<IntegrationDTO>;
    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadLiveOpticsProjectByAccountId(accountId: string, filepond: FileParameter | undefined, hello: string | undefined,  cancelToken?: CancelToken): Promise<LiveOpticsProjectUploadResponse>;
}

export class IntegrationClient extends AuthorizedApiBase implements IIntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return No Content
     */
    deleteIntegration(integrationId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/{integrationId}";
        if (integrationId === undefined || integrationId === null)
            throw new globalThis.Error("The parameter 'integrationId' must be defined.");
        url_ = url_.replace("{integrationId}", encodeURIComponent("" + integrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIntegration(_response);
        });
    }

    protected processDeleteIntegration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerIntegration(body: IntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterIntegration(_response);
        });
    }

    protected processRegisterIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateIntegration(body: IntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIntegration(_response);
        });
    }

    protected processUpdateIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * Toggles activation of Integrations in the integrations table from active to inactive or inactive to active.
     * @param activate (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleIntegrationActivation(activate: boolean | undefined, body: IntegrationDTO[] | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/toggle-activation?";
        if (activate === null)
            throw new globalThis.Error("The parameter 'activate' cannot be null.");
        else if (activate !== undefined)
            url_ += "activate=" + encodeURIComponent("" + activate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleIntegrationActivation(_response);
        });
    }

    protected processToggleIntegrationActivation(response: AxiosResponse): Promise<IntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO[]>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadCiscoReadyReportByAccountId(accountId: string, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<CiscoReadyReportUploadResponse> {
        let url_ = this.baseUrl + "/api/Integration/cisco-ready-report/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new globalThis.Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoReadyReportByAccountId(_response);
        });
    }

    protected processUploadCiscoReadyReportByAccountId(response: AxiosResponse): Promise<CiscoReadyReportUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoReadyReportUploadResponse.fromJS(resultData200);
            return Promise.resolve<CiscoReadyReportUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoReadyReportUploadResponse>(null as any);
    }

    /**
     * @param enabledOnly (optional) 
     * @return OK
     */
    getIntegrationDefinitions(enabledOnly: boolean | undefined, cancelToken?: CancelToken): Promise<IntegrationDefinition[]> {
        let url_ = this.baseUrl + "/api/Integration/definitions?";
        if (enabledOnly === null)
            throw new globalThis.Error("The parameter 'enabledOnly' cannot be null.");
        else if (enabledOnly !== undefined)
            url_ += "enabledOnly=" + encodeURIComponent("" + enabledOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationDefinitions(_response);
        });
    }

    protected processGetIntegrationDefinitions(response: AxiosResponse): Promise<IntegrationDefinition[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDefinition.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IntegrationDefinition[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDefinition[]>(null as any);
    }

    /**
     * Get a list of all subscriptionIds along with display names for configured integration types
    Currently supports Azure tenant types
     * @return OK
     */
    getIntegrationAccounts( cancelToken?: CancelToken): Promise<CustomerAccount[]> {
        let url_ = this.baseUrl + "/api/Integration/integration-accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationAccounts(_response);
        });
    }

    protected processGetIntegrationAccounts(response: AxiosResponse): Promise<CustomerAccount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomerAccount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccount[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrations(_response);
        });
    }

    protected processGetIntegrations(response: AxiosResponse): Promise<IntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postIntegration(body: IntegrationDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/integrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostIntegration(_response);
        });
    }

    protected processPostIntegration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postIntegrationBatch(body: IntegrationDTO[] | undefined, cancelToken?: CancelToken): Promise<BatchIntegrationResult> {
        let url_ = this.baseUrl + "/api/Integration/integrations/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostIntegrationBatch(_response);
        });
    }

    protected processPostIntegrationBatch(response: AxiosResponse): Promise<BatchIntegrationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchIntegrationResult.fromJS(resultData200);
            return Promise.resolve<BatchIntegrationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchIntegrationResult>(null as any);
    }

    /**
     * @return OK
     */
    doesAccountExists(axNumber: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/{axNumber}";
        if (axNumber === undefined || axNumber === null)
            throw new globalThis.Error("The parameter 'axNumber' must be defined.");
        url_ = url_.replace("{axNumber}", encodeURIComponent("" + axNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoesAccountExists(_response);
        });
    }

    protected processDoesAccountExists(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAxReferencesByAccountId(accountId: number, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Integration/account-ax-references/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAxReferencesByAccountId(_response);
        });
    }

    protected processGetAxReferencesByAccountId(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get All Integrations by the IntegrationType
     * @param integrationType (optional) Type Of Integrations to retrieve
     * @param activeOnly (optional) True if only active integrations (true by default)
     * @return OK
     */
    getIntegrationsByType(integrationType: IntegrationType | undefined, activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/integrations-by-type?";
        if (integrationType === null)
            throw new globalThis.Error("The parameter 'integrationType' cannot be null.");
        else if (integrationType !== undefined)
            url_ += "integrationType=" + encodeURIComponent("" + integrationType) + "&";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationsByType(_response);
        });
    }

    protected processGetIntegrationsByType(response: AxiosResponse): Promise<IntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getCiscoSNTCIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<CiscoSNTCIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/cisco-sntc?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoSNTCIntegrations(_response);
        });
    }

    protected processGetCiscoSNTCIntegrations(response: AxiosResponse): Promise<CiscoSNTCIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CiscoSNTCIntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CiscoSNTCIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoSNTCIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getCiscoEAIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<CiscoEnterpriseAgreementIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/cisco-ea?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoEAIntegrations(_response);
        });
    }

    protected processGetCiscoEAIntegrations(response: AxiosResponse): Promise<CiscoEnterpriseAgreementIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CiscoEnterpriseAgreementIntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CiscoEnterpriseAgreementIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoEnterpriseAgreementIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAzureComplianceIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AzureComplianceIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/azure-compliance?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureComplianceIntegrations(_response);
        });
    }

    protected processGetAzureComplianceIntegrations(response: AxiosResponse): Promise<AzureComplianceIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureComplianceIntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AzureComplianceIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureComplianceIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAwsComplianceIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AwsComplianceIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/aws-compliance?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAwsComplianceIntegrations(_response);
        });
    }

    protected processGetAwsComplianceIntegrations(response: AxiosResponse): Promise<AwsComplianceIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AwsComplianceIntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AwsComplianceIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AwsComplianceIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAwsSimpleRecommendationsIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AwsSimpleRecommendationsIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/aws-simple-recommendations?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAwsSimpleRecommendationsIntegrations(_response);
        });
    }

    protected processGetAwsSimpleRecommendationsIntegrations(response: AxiosResponse): Promise<AwsSimpleRecommendationsIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AwsSimpleRecommendationsIntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AwsSimpleRecommendationsIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AwsSimpleRecommendationsIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAzureSimpleRecommendationsIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AzureSimpleRecommendationsIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/azure-simple-recommendations?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureSimpleRecommendationsIntegrations(_response);
        });
    }

    protected processGetAzureSimpleRecommendationsIntegrations(response: AxiosResponse): Promise<AzureSimpleRecommendationsIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureSimpleRecommendationsIntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AzureSimpleRecommendationsIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureSimpleRecommendationsIntegrationDTO[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getAzureBackupsIntegrations(activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<AzureBackupsIntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/azure-backups?";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureBackupsIntegrations(_response);
        });
    }

    protected processGetAzureBackupsIntegrations(response: AxiosResponse): Promise<AzureBackupsIntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureBackupsIntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AzureBackupsIntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureBackupsIntegrationDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    allIntegrationsByAccountId(accountId: number, cancelToken?: CancelToken): Promise<CustomerAccount[]> {
        let url_ = this.baseUrl + "/api/Integration/integration-accounts/account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllIntegrationsByAccountId(_response);
        });
    }

    protected processAllIntegrationsByAccountId(response: AxiosResponse): Promise<CustomerAccount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomerAccount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccount[]>(null as any);
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    activeIntegrationsByAccountId(accountId: number, activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO[]> {
        let url_ = this.baseUrl + "/api/Integration/integration/account/{accountId}?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActiveIntegrationsByAccountId(_response);
        });
    }

    protected processActiveIntegrationsByAccountId(response: AxiosResponse): Promise<IntegrationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IntegrationDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadCiscoSNTCByAccountId(accountId: number, body: BasicCiscoSNTCIntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/cisco-SNTC/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoSNTCByAccountId(_response);
        });
    }

    protected processUploadCiscoSNTCByAccountId(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadCiscoEAByAccountId(accountId: number, body: BasicCiscoEAIntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/cisco-EA/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCiscoEAByAccountId(_response);
        });
    }

    protected processUploadCiscoEAByAccountId(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerSelfServiceReportingIntegration(accountId: number, body: SelfServiceReportingIntegrationDto | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/ssr/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterSelfServiceReportingIntegration(_response);
        });
    }

    protected processRegisterSelfServiceReportingIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerHardwareLifecycleManagementIntegration(accountId: string, body: HardwareLifecycleManagementIntegrationDTO | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/hlm/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterHardwareLifecycleManagementIntegration(_response);
        });
    }

    protected processRegisterHardwareLifecycleManagementIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerAwsGovernanceReportIntegration(accountId: string, body: AwsGovernanceReportsDto | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/aws-governance-reports/register/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterAwsGovernanceReportIntegration(_response);
        });
    }

    protected processRegisterAwsGovernanceReportIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerAzureGovernanceReportIntegration(accountId: string, body: AzureGovernanceReportsDto | undefined, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/azure-governance-reports/register/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterAzureGovernanceReportIntegration(_response);
        });
    }

    protected processRegisterAzureGovernanceReportIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @return OK
     */
    registerDatadogUsageReportIntegration(accountId: string, cancelToken?: CancelToken): Promise<IntegrationDTO> {
        let url_ = this.baseUrl + "/api/Integration/datadog-usage-report/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterDatadogUsageReportIntegration(_response);
        });
    }

    protected processRegisterDatadogUsageReportIntegration(response: AxiosResponse): Promise<IntegrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationDTO.fromJS(resultData200);
            return Promise.resolve<IntegrationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationDTO>(null as any);
    }

    /**
     * @param filepond (optional) 
     * @param hello (optional) 
     * @return OK
     */
    uploadLiveOpticsProjectByAccountId(accountId: string, filepond: FileParameter | undefined, hello: string | undefined, cancelToken?: CancelToken): Promise<LiveOpticsProjectUploadResponse> {
        let url_ = this.baseUrl + "/api/Integration/liveoptics-project/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");
        if (hello === null || hello === undefined)
            throw new globalThis.Error("The parameter 'hello' cannot be null.");
        else
            content_.append("Hello", hello.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadLiveOpticsProjectByAccountId(_response);
        });
    }

    protected processUploadLiveOpticsProjectByAccountId(response: AxiosResponse): Promise<LiveOpticsProjectUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LiveOpticsProjectUploadResponse.fromJS(resultData200);
            return Promise.resolve<LiveOpticsProjectUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LiveOpticsProjectUploadResponse>(null as any);
    }
}

export interface IInviteLinkRegistrationClient {
    /**
     * Checks whether the registrant's email domain is permitted by the invitation link.
     * @param body (optional) 
     * @return OK
     */
    checkDomain(body: InviteLinkDomainCheckRequest | undefined,  cancelToken?: CancelToken): Promise<InviteLinkDomainCheckResponse>;
    /**
     * Emails a verification code once the email domain is confirmed allowed.
     * @param body (optional) 
     * @return OK
     */
    generateCode(body: InviteLinkGenerateCodeRequest | undefined,  cancelToken?: CancelToken): Promise<InviteLinkVerificationResponse>;
    /**
     * Verifies a code the registrant received by email.
     * @param body (optional) 
     * @return OK
     */
    verifyCode(body: InviteLinkVerifyCodeRequest | undefined,  cancelToken?: CancelToken): Promise<InviteLinkVerificationResponse>;
    /**
     * Completes registration: re-verifies the code, then creates the user.
     * @param body (optional) 
     * @return OK
     */
    submit(body: InviteLinkRegistrationSubmitRequest | undefined,  cancelToken?: CancelToken): Promise<InviteLinkRegistrationSubmitResponse>;
}

export class InviteLinkRegistrationClient extends AuthorizedApiBase implements IInviteLinkRegistrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Checks whether the registrant's email domain is permitted by the invitation link.
     * @param body (optional) 
     * @return OK
     */
    checkDomain(body: InviteLinkDomainCheckRequest | undefined, cancelToken?: CancelToken): Promise<InviteLinkDomainCheckResponse> {
        let url_ = this.baseUrl + "/api/invite-registration/check-domain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckDomain(_response);
        });
    }

    protected processCheckDomain(response: AxiosResponse): Promise<InviteLinkDomainCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteLinkDomainCheckResponse.fromJS(resultData200);
            return Promise.resolve<InviteLinkDomainCheckResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteLinkDomainCheckResponse>(null as any);
    }

    /**
     * Emails a verification code once the email domain is confirmed allowed.
     * @param body (optional) 
     * @return OK
     */
    generateCode(body: InviteLinkGenerateCodeRequest | undefined, cancelToken?: CancelToken): Promise<InviteLinkVerificationResponse> {
        let url_ = this.baseUrl + "/api/invite-registration/generate-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateCode(_response);
        });
    }

    protected processGenerateCode(response: AxiosResponse): Promise<InviteLinkVerificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteLinkVerificationResponse.fromJS(resultData200);
            return Promise.resolve<InviteLinkVerificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteLinkVerificationResponse>(null as any);
    }

    /**
     * Verifies a code the registrant received by email.
     * @param body (optional) 
     * @return OK
     */
    verifyCode(body: InviteLinkVerifyCodeRequest | undefined, cancelToken?: CancelToken): Promise<InviteLinkVerificationResponse> {
        let url_ = this.baseUrl + "/api/invite-registration/verify-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyCode(_response);
        });
    }

    protected processVerifyCode(response: AxiosResponse): Promise<InviteLinkVerificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteLinkVerificationResponse.fromJS(resultData200);
            return Promise.resolve<InviteLinkVerificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteLinkVerificationResponse>(null as any);
    }

    /**
     * Completes registration: re-verifies the code, then creates the user.
     * @param body (optional) 
     * @return OK
     */
    submit(body: InviteLinkRegistrationSubmitRequest | undefined, cancelToken?: CancelToken): Promise<InviteLinkRegistrationSubmitResponse> {
        let url_ = this.baseUrl + "/api/invite-registration/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<InviteLinkRegistrationSubmitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InviteLinkRegistrationSubmitResponse.fromJS(resultData200);
            return Promise.resolve<InviteLinkRegistrationSubmitResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteLinkRegistrationSubmitResponse>(null as any);
    }
}

export interface IItProjectsClient {
    /**
     * Creates a new IT project for the current user's account.
     * @param body (optional) The project creation request.
     * @return Created
     */
    create(body: ItProjectDto | undefined,  cancelToken?: CancelToken): Promise<ItProjectDto>;
    /**
     * Gets a paginated list of projects for the current user's account.
     * @param page (optional) Page number (1-based).
     * @param pageSize (optional) Number of items per page.
     * @param search (optional) Optional text search applied to title, description, and customer project ID.
     * @return OK
     */
    getProjectsListByAccount(page: number | undefined, pageSize: number | undefined, search: string | undefined,  cancelToken?: CancelToken): Promise<PagedProjectsResponse>;
    /**
     * Gets a project by its SHI project identifier.
     * @param shiProjectId The SHI-generated project GUID.
     * @return OK
     */
    getByShiProjectId(shiProjectId: string,  cancelToken?: CancelToken): Promise<ItProjectDto>;
    /**
     * Updates an existing IT project.
     * @param shiProjectId The SHI-generated project GUID.
     * @param body (optional) The updated project data.
     * @return OK
     */
    update(shiProjectId: string, body: ItProjectDto | undefined,  cancelToken?: CancelToken): Promise<ItProjectDto>;
    /**
     * Deletes an IT project.
     * @param shiProjectId The SHI-generated project GUID.
     * @return No Content
     */
    deleteItProject(shiProjectId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Gets projects linked to a service engagement for the current account.
     * @param serviceEngagementId The service engagement identifier.
     * @return OK
     */
    getByServiceEngagement(serviceEngagementId: number,  cancelToken?: CancelToken): Promise<LinkedItProjectDto[]>;
    /**
     * Gets projects linked to a roadmap for the current account.
     * @param roadmapId The roadmap identifier.
     * @return OK
     */
    getByRoadmap(roadmapId: string,  cancelToken?: CancelToken): Promise<LinkedItProjectDto[]>;
    /**
     * Gets the SHI account team members for the current user's account.
     * @return OK
     */
    getAccountTeamMembers( cancelToken?: CancelToken): Promise<GetShiOneAccountTeamMembersResponse>;
    /**
     * Gets the active client users for the current user's account.
     * @return OK
     */
    getClientUsers( cancelToken?: CancelToken): Promise<CustomerExperienceUserPropertiesDto[]>;
    /**
     * Returns the count of linked items per type for an IT project.
    Lightweight alternative to fetching full linked item lists when only counts are needed.
     * @return OK
     */
    getLinkedCounts(itProjectId: string,  cancelToken?: CancelToken): Promise<LinkedItemCountsDto>;
    /**
     * Returns the count of IT projects grouped by status for the current user's account.
    Used to power the IT projects widget on the home dashboard.
     * @return OK
     */
    getStatusCounts( cancelToken?: CancelToken): Promise<ItProjectStatusCountDto[]>;
}

export class ItProjectsClient extends AuthorizedApiBase implements IItProjectsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Creates a new IT project for the current user's account.
     * @param body (optional) The project creation request.
     * @return Created
     */
    create(body: ItProjectDto | undefined, cancelToken?: CancelToken): Promise<ItProjectDto> {
        let url_ = this.baseUrl + "/api/it-projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ItProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ItProjectDto.fromJS(resultData201);
            return Promise.resolve<ItProjectDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItProjectDto>(null as any);
    }

    /**
     * Gets a paginated list of projects for the current user's account.
     * @param page (optional) Page number (1-based).
     * @param pageSize (optional) Number of items per page.
     * @param search (optional) Optional text search applied to title, description, and customer project ID.
     * @return OK
     */
    getProjectsListByAccount(page: number | undefined, pageSize: number | undefined, search: string | undefined, cancelToken?: CancelToken): Promise<PagedProjectsResponse> {
        let url_ = this.baseUrl + "/api/it-projects?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsListByAccount(_response);
        });
    }

    protected processGetProjectsListByAccount(response: AxiosResponse): Promise<PagedProjectsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedProjectsResponse.fromJS(resultData200);
            return Promise.resolve<PagedProjectsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedProjectsResponse>(null as any);
    }

    /**
     * Gets a project by its SHI project identifier.
     * @param shiProjectId The SHI-generated project GUID.
     * @return OK
     */
    getByShiProjectId(shiProjectId: string, cancelToken?: CancelToken): Promise<ItProjectDto> {
        let url_ = this.baseUrl + "/api/it-projects/{shiProjectId}";
        if (shiProjectId === undefined || shiProjectId === null)
            throw new globalThis.Error("The parameter 'shiProjectId' must be defined.");
        url_ = url_.replace("{shiProjectId}", encodeURIComponent("" + shiProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByShiProjectId(_response);
        });
    }

    protected processGetByShiProjectId(response: AxiosResponse): Promise<ItProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItProjectDto.fromJS(resultData200);
            return Promise.resolve<ItProjectDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItProjectDto>(null as any);
    }

    /**
     * Updates an existing IT project.
     * @param shiProjectId The SHI-generated project GUID.
     * @param body (optional) The updated project data.
     * @return OK
     */
    update(shiProjectId: string, body: ItProjectDto | undefined, cancelToken?: CancelToken): Promise<ItProjectDto> {
        let url_ = this.baseUrl + "/api/it-projects/{shiProjectId}";
        if (shiProjectId === undefined || shiProjectId === null)
            throw new globalThis.Error("The parameter 'shiProjectId' must be defined.");
        url_ = url_.replace("{shiProjectId}", encodeURIComponent("" + shiProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ItProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItProjectDto.fromJS(resultData200);
            return Promise.resolve<ItProjectDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItProjectDto>(null as any);
    }

    /**
     * Deletes an IT project.
     * @param shiProjectId The SHI-generated project GUID.
     * @return No Content
     */
    deleteItProject(shiProjectId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/it-projects/{shiProjectId}";
        if (shiProjectId === undefined || shiProjectId === null)
            throw new globalThis.Error("The parameter 'shiProjectId' must be defined.");
        url_ = url_.replace("{shiProjectId}", encodeURIComponent("" + shiProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteItProject(_response);
        });
    }

    protected processDeleteItProject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets projects linked to a service engagement for the current account.
     * @param serviceEngagementId The service engagement identifier.
     * @return OK
     */
    getByServiceEngagement(serviceEngagementId: number, cancelToken?: CancelToken): Promise<LinkedItProjectDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/by-service-engagement/{serviceEngagementId}";
        if (serviceEngagementId === undefined || serviceEngagementId === null)
            throw new globalThis.Error("The parameter 'serviceEngagementId' must be defined.");
        url_ = url_.replace("{serviceEngagementId}", encodeURIComponent("" + serviceEngagementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByServiceEngagement(_response);
        });
    }

    protected processGetByServiceEngagement(response: AxiosResponse): Promise<LinkedItProjectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedItProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LinkedItProjectDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedItProjectDto[]>(null as any);
    }

    /**
     * Gets projects linked to a roadmap for the current account.
     * @param roadmapId The roadmap identifier.
     * @return OK
     */
    getByRoadmap(roadmapId: string, cancelToken?: CancelToken): Promise<LinkedItProjectDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/by-roadmap/{roadmapId}";
        if (roadmapId === undefined || roadmapId === null)
            throw new globalThis.Error("The parameter 'roadmapId' must be defined.");
        url_ = url_.replace("{roadmapId}", encodeURIComponent("" + roadmapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByRoadmap(_response);
        });
    }

    protected processGetByRoadmap(response: AxiosResponse): Promise<LinkedItProjectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedItProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LinkedItProjectDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedItProjectDto[]>(null as any);
    }

    /**
     * Gets the SHI account team members for the current user's account.
     * @return OK
     */
    getAccountTeamMembers( cancelToken?: CancelToken): Promise<GetShiOneAccountTeamMembersResponse> {
        let url_ = this.baseUrl + "/api/it-projects/team-members";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountTeamMembers(_response);
        });
    }

    protected processGetAccountTeamMembers(response: AxiosResponse): Promise<GetShiOneAccountTeamMembersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetShiOneAccountTeamMembersResponse.fromJS(resultData200);
            return Promise.resolve<GetShiOneAccountTeamMembersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetShiOneAccountTeamMembersResponse>(null as any);
    }

    /**
     * Gets the active client users for the current user's account.
     * @return OK
     */
    getClientUsers( cancelToken?: CancelToken): Promise<CustomerExperienceUserPropertiesDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/client-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientUsers(_response);
        });
    }

    protected processGetClientUsers(response: AxiosResponse): Promise<CustomerExperienceUserPropertiesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerExperienceUserPropertiesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomerExperienceUserPropertiesDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerExperienceUserPropertiesDto[]>(null as any);
    }

    /**
     * Returns the count of linked items per type for an IT project.
    Lightweight alternative to fetching full linked item lists when only counts are needed.
     * @return OK
     */
    getLinkedCounts(itProjectId: string, cancelToken?: CancelToken): Promise<LinkedItemCountsDto> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/linked-counts";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedCounts(_response);
        });
    }

    protected processGetLinkedCounts(response: AxiosResponse): Promise<LinkedItemCountsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkedItemCountsDto.fromJS(resultData200);
            return Promise.resolve<LinkedItemCountsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedItemCountsDto>(null as any);
    }

    /**
     * Returns the count of IT projects grouped by status for the current user's account.
    Used to power the IT projects widget on the home dashboard.
     * @return OK
     */
    getStatusCounts( cancelToken?: CancelToken): Promise<ItProjectStatusCountDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/widget/status-counts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatusCounts(_response);
        });
    }

    protected processGetStatusCounts(response: AxiosResponse): Promise<ItProjectStatusCountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItProjectStatusCountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ItProjectStatusCountDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItProjectStatusCountDto[]>(null as any);
    }
}

export interface IItProjectsAttachmentsClient {
    /**
     * Uploads and links a file attachment to a project.
     * @param fileType (optional) 
     * @param filepond (optional) 
     * @return Created
     */
    upload(shiProjectId: string, fileType: FileTypes | undefined, filepond: FileParameter | undefined,  cancelToken?: CancelToken): Promise<ItProjectAttachmentDto>;
    /**
     * Lists all attachments for a project.
     * @return OK
     */
    list(shiProjectId: string,  cancelToken?: CancelToken): Promise<ItProjectAttachmentDto[]>;
    /**
     * Downloads a project attachment by its identifier.
     * @return OK
     */
    download(shiProjectId: string, attachmentId: string,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * Deletes a project attachment (blob and metadata).
     * @return No Content
     */
    deleteAttachment(shiProjectId: string, attachmentId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Updates the display title of an attachment.
     * @param body (optional) 
     * @return OK
     */
    updateAttachmentTitle(shiProjectId: string, attachmentId: string, body: UpdateAttachmentTitleRequest | undefined,  cancelToken?: CancelToken): Promise<ItProjectAttachmentDto>;
}

export class ItProjectsAttachmentsClient extends AuthorizedApiBase implements IItProjectsAttachmentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Uploads and links a file attachment to a project.
     * @param fileType (optional) 
     * @param filepond (optional) 
     * @return Created
     */
    upload(shiProjectId: string, fileType: FileTypes | undefined, filepond: FileParameter | undefined, cancelToken?: CancelToken): Promise<ItProjectAttachmentDto> {
        let url_ = this.baseUrl + "/api/it-projects/{shiProjectId}/attachments";
        if (shiProjectId === undefined || shiProjectId === null)
            throw new globalThis.Error("The parameter 'shiProjectId' must be defined.");
        url_ = url_.replace("{shiProjectId}", encodeURIComponent("" + shiProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileType === null || fileType === undefined)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("FileType", fileType.toString());
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<ItProjectAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = ItProjectAttachmentDto.fromJS(resultData201);
            return Promise.resolve<ItProjectAttachmentDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 413) {
            const _responseText = response.data;
            let result413: any = null;
            let resultData413  = _responseText;
            result413 = ProblemDetails.fromJS(resultData413);
            return throwException("Content Too Large", status, _responseText, _headers, result413);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItProjectAttachmentDto>(null as any);
    }

    /**
     * Lists all attachments for a project.
     * @return OK
     */
    list(shiProjectId: string, cancelToken?: CancelToken): Promise<ItProjectAttachmentDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{shiProjectId}/attachments";
        if (shiProjectId === undefined || shiProjectId === null)
            throw new globalThis.Error("The parameter 'shiProjectId' must be defined.");
        url_ = url_.replace("{shiProjectId}", encodeURIComponent("" + shiProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ItProjectAttachmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItProjectAttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ItProjectAttachmentDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItProjectAttachmentDto[]>(null as any);
    }

    /**
     * Downloads a project attachment by its identifier.
     * @return OK
     */
    download(shiProjectId: string, attachmentId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/it-projects/{shiProjectId}/attachments/{attachmentId}";
        if (shiProjectId === undefined || shiProjectId === null)
            throw new globalThis.Error("The parameter 'shiProjectId' must be defined.");
        url_ = url_.replace("{shiProjectId}", encodeURIComponent("" + shiProjectId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Deletes a project attachment (blob and metadata).
     * @return No Content
     */
    deleteAttachment(shiProjectId: string, attachmentId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/it-projects/{shiProjectId}/attachments/{attachmentId}";
        if (shiProjectId === undefined || shiProjectId === null)
            throw new globalThis.Error("The parameter 'shiProjectId' must be defined.");
        url_ = url_.replace("{shiProjectId}", encodeURIComponent("" + shiProjectId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAttachment(_response);
        });
    }

    protected processDeleteAttachment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the display title of an attachment.
     * @param body (optional) 
     * @return OK
     */
    updateAttachmentTitle(shiProjectId: string, attachmentId: string, body: UpdateAttachmentTitleRequest | undefined, cancelToken?: CancelToken): Promise<ItProjectAttachmentDto> {
        let url_ = this.baseUrl + "/api/it-projects/{shiProjectId}/attachments/{attachmentId}/title";
        if (shiProjectId === undefined || shiProjectId === null)
            throw new globalThis.Error("The parameter 'shiProjectId' must be defined.");
        url_ = url_.replace("{shiProjectId}", encodeURIComponent("" + shiProjectId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAttachmentTitle(_response);
        });
    }

    protected processUpdateAttachmentTitle(response: AxiosResponse): Promise<ItProjectAttachmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItProjectAttachmentDto.fromJS(resultData200);
            return Promise.resolve<ItProjectAttachmentDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItProjectAttachmentDto>(null as any);
    }
}

export interface IItProjectsPurchaseOrdersClient {
    /**
     * Batch links orders to an IT project by order IDs.
     * @param body (optional) 
     * @return OK
     */
    linkOrdersBatch(itProjectId: string, body: LinkOrderRequest[] | undefined,  cancelToken?: CancelToken): Promise<LinkOrderRequest[]>;
    /**
     * Batch unlinks orders from an IT project by order IDs.
     * @param body (optional) 
     * @return No Content
     */
    unlinkOrdersBatch(itProjectId: string, body: LinkOrderRequest[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Gets order details for all orders linked to this IT project.
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return OK
     */
    getLinkedOrders(itProjectId: string, page: number | undefined, pageSize: number | undefined, search: string | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfOrderSummaryDto>;
    /**
     * Searches all available orders for the user's CRM account that can be linked to this IT project.
     * @param body (optional) 
     * @return OK
     */
    searchItProjectOrders(itProjectId: string, body: SearchOrdersRequest | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfOrderSummaryDto>;
    /**
     * Gets purchased asset spend-by-order data scoped to purchase orders linked to this IT project.
     * @param body (optional) 
     * @return OK
     */
    getPurchasedAssets(itProjectId: string, body: EsPurchasedAssetsSpendByOrderRequest | undefined,  cancelToken?: CancelToken): Promise<EsPurchasedAssetsSpendByOrderResponse>;
    /**
     * Gets shipments for orders linked to this IT project.
     * @return OK
     */
    getShipments(itProjectId: string,  cancelToken?: CancelToken): Promise<ItProjectShipmentDto[]>;
}

export class ItProjectsPurchaseOrdersClient extends AuthorizedApiBase implements IItProjectsPurchaseOrdersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Batch links orders to an IT project by order IDs.
     * @param body (optional) 
     * @return OK
     */
    linkOrdersBatch(itProjectId: string, body: LinkOrderRequest[] | undefined, cancelToken?: CancelToken): Promise<LinkOrderRequest[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/purchase-orders";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkOrdersBatch(_response);
        });
    }

    protected processLinkOrdersBatch(response: AxiosResponse): Promise<LinkOrderRequest[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkOrderRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LinkOrderRequest[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkOrderRequest[]>(null as any);
    }

    /**
     * Batch unlinks orders from an IT project by order IDs.
     * @param body (optional) 
     * @return No Content
     */
    unlinkOrdersBatch(itProjectId: string, body: LinkOrderRequest[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/purchase-orders";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkOrdersBatch(_response);
        });
    }

    protected processUnlinkOrdersBatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets order details for all orders linked to this IT project.
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return OK
     */
    getLinkedOrders(itProjectId: string, page: number | undefined, pageSize: number | undefined, search: string | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfOrderSummaryDto> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/purchase-orders/linked-orders?";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedOrders(_response);
        });
    }

    protected processGetLinkedOrders(response: AxiosResponse): Promise<PaginatedResultDto_1OfOrderSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfOrderSummaryDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfOrderSummaryDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfOrderSummaryDto>(null as any);
    }

    /**
     * Searches all available orders for the user's CRM account that can be linked to this IT project.
     * @param body (optional) 
     * @return OK
     */
    searchItProjectOrders(itProjectId: string, body: SearchOrdersRequest | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfOrderSummaryDto> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/purchase-orders/search";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchItProjectOrders(_response);
        });
    }

    protected processSearchItProjectOrders(response: AxiosResponse): Promise<PaginatedResultDto_1OfOrderSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfOrderSummaryDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfOrderSummaryDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfOrderSummaryDto>(null as any);
    }

    /**
     * Gets purchased asset spend-by-order data scoped to purchase orders linked to this IT project.
     * @param body (optional) 
     * @return OK
     */
    getPurchasedAssets(itProjectId: string, body: EsPurchasedAssetsSpendByOrderRequest | undefined, cancelToken?: CancelToken): Promise<EsPurchasedAssetsSpendByOrderResponse> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/purchase-orders/purchased-assets";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPurchasedAssets(_response);
        });
    }

    protected processGetPurchasedAssets(response: AxiosResponse): Promise<EsPurchasedAssetsSpendByOrderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EsPurchasedAssetsSpendByOrderResponse.fromJS(resultData200);
            return Promise.resolve<EsPurchasedAssetsSpendByOrderResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EsPurchasedAssetsSpendByOrderResponse>(null as any);
    }

    /**
     * Gets shipments for orders linked to this IT project.
     * @return OK
     */
    getShipments(itProjectId: string, cancelToken?: CancelToken): Promise<ItProjectShipmentDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/purchase-orders/shipments";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShipments(_response);
        });
    }

    protected processGetShipments(response: AxiosResponse): Promise<ItProjectShipmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItProjectShipmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ItProjectShipmentDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItProjectShipmentDto[]>(null as any);
    }
}

export interface IItProjectsQuotesClient {
    /**
     * Batch links quotes to an IT project.
     * @param body (optional) 
     * @return OK
     */
    linkQuotesBatch(itProjectId: string, body: LinkQuoteRequest[] | undefined,  cancelToken?: CancelToken): Promise<LinkQuoteRequest[]>;
    /**
     * Batch unlinks quotes from an IT project.
     * @param body (optional) 
     * @return No Content
     */
    unlinkQuotesBatch(itProjectId: string, body: LinkQuoteRequest[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Gets linked quote details for this IT project.
     * @return OK
     */
    getLinkedQuotes(itProjectId: string,  cancelToken?: CancelToken): Promise<PublishedQuoteListItemDto[]>;
    /**
     * Gets all available quotes for the user's org units that can be linked to this IT project.
     * @return OK
     */
    getAvailableQuotes(itProjectId: string,  cancelToken?: CancelToken): Promise<PublishedQuoteListItemDto[]>;
}

export class ItProjectsQuotesClient extends AuthorizedApiBase implements IItProjectsQuotesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Batch links quotes to an IT project.
     * @param body (optional) 
     * @return OK
     */
    linkQuotesBatch(itProjectId: string, body: LinkQuoteRequest[] | undefined, cancelToken?: CancelToken): Promise<LinkQuoteRequest[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/quotes";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkQuotesBatch(_response);
        });
    }

    protected processLinkQuotesBatch(response: AxiosResponse): Promise<LinkQuoteRequest[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkQuoteRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LinkQuoteRequest[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkQuoteRequest[]>(null as any);
    }

    /**
     * Batch unlinks quotes from an IT project.
     * @param body (optional) 
     * @return No Content
     */
    unlinkQuotesBatch(itProjectId: string, body: LinkQuoteRequest[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/quotes";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkQuotesBatch(_response);
        });
    }

    protected processUnlinkQuotesBatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets linked quote details for this IT project.
     * @return OK
     */
    getLinkedQuotes(itProjectId: string, cancelToken?: CancelToken): Promise<PublishedQuoteListItemDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/quotes/linked";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedQuotes(_response);
        });
    }

    protected processGetLinkedQuotes(response: AxiosResponse): Promise<PublishedQuoteListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublishedQuoteListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PublishedQuoteListItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublishedQuoteListItemDto[]>(null as any);
    }

    /**
     * Gets all available quotes for the user's org units that can be linked to this IT project.
     * @return OK
     */
    getAvailableQuotes(itProjectId: string, cancelToken?: CancelToken): Promise<PublishedQuoteListItemDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/quotes/available";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableQuotes(_response);
        });
    }

    protected processGetAvailableQuotes(response: AxiosResponse): Promise<PublishedQuoteListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublishedQuoteListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PublishedQuoteListItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublishedQuoteListItemDto[]>(null as any);
    }
}

export interface IItProjectsRoadmapsClient {
    /**
     * Gets all roadmaps available on the account.
     * @return OK
     */
    getAvailableRoadmaps(itProjectId: string,  cancelToken?: CancelToken): Promise<AvailableRoadmapDto[]>;
    /**
     * Gets roadmaps linked to the specified IT project.
     * @return OK
     */
    getLinkedRoadmaps(itProjectId: string,  cancelToken?: CancelToken): Promise<RoadmapDto[]>;
    /**
     * Batch links roadmaps to an IT project.
     * @param body (optional) 
     * @return OK
     */
    linkRoadmaps(itProjectId: string, body: string[] | undefined,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * Batch unlinks roadmaps from an IT project.
     * @param body (optional) 
     * @return No Content
     */
    unlinkRoadmaps(itProjectId: string, body: string[] | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class ItProjectsRoadmapsClient extends AuthorizedApiBase implements IItProjectsRoadmapsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets all roadmaps available on the account.
     * @return OK
     */
    getAvailableRoadmaps(itProjectId: string, cancelToken?: CancelToken): Promise<AvailableRoadmapDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/roadmaps/available";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableRoadmaps(_response);
        });
    }

    protected processGetAvailableRoadmaps(response: AxiosResponse): Promise<AvailableRoadmapDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableRoadmapDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AvailableRoadmapDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailableRoadmapDto[]>(null as any);
    }

    /**
     * Gets roadmaps linked to the specified IT project.
     * @return OK
     */
    getLinkedRoadmaps(itProjectId: string, cancelToken?: CancelToken): Promise<RoadmapDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/roadmaps";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedRoadmaps(_response);
        });
    }

    protected processGetLinkedRoadmaps(response: AxiosResponse): Promise<RoadmapDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoadmapDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RoadmapDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoadmapDto[]>(null as any);
    }

    /**
     * Batch links roadmaps to an IT project.
     * @param body (optional) 
     * @return OK
     */
    linkRoadmaps(itProjectId: string, body: string[] | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/roadmaps";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkRoadmaps(_response);
        });
    }

    protected processLinkRoadmaps(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Batch unlinks roadmaps from an IT project.
     * @param body (optional) 
     * @return No Content
     */
    unlinkRoadmaps(itProjectId: string, body: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/roadmaps";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkRoadmaps(_response);
        });
    }

    protected processUnlinkRoadmaps(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IItProjectsServiceEngagementsClient {
    /**
     * Gets all service engagements available for linking (scoped to account).
     * @return OK
     */
    getAvailable(itProjectId: string,  cancelToken?: CancelToken): Promise<ProjectListItemDto[]>;
    /**
     * Gets service engagements linked to a project.
     * @return OK
     */
    getLinked(itProjectId: string,  cancelToken?: CancelToken): Promise<ProjectListItemDto[]>;
    /**
     * Batch links service engagements to a project.
     * @param body (optional) 
     * @return OK
     */
    link(itProjectId: string, body: number[] | undefined,  cancelToken?: CancelToken): Promise<number[]>;
    /**
     * Batch removes service engagement links from a project.
     * @param body (optional) 
     * @return No Content
     */
    unlink(itProjectId: string, body: number[] | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class ItProjectsServiceEngagementsClient extends AuthorizedApiBase implements IItProjectsServiceEngagementsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets all service engagements available for linking (scoped to account).
     * @return OK
     */
    getAvailable(itProjectId: string, cancelToken?: CancelToken): Promise<ProjectListItemDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/service-engagements/available";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailable(_response);
        });
    }

    protected processGetAvailable(response: AxiosResponse): Promise<ProjectListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProjectListItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectListItemDto[]>(null as any);
    }

    /**
     * Gets service engagements linked to a project.
     * @return OK
     */
    getLinked(itProjectId: string, cancelToken?: CancelToken): Promise<ProjectListItemDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/service-engagements";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinked(_response);
        });
    }

    protected processGetLinked(response: AxiosResponse): Promise<ProjectListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProjectListItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectListItemDto[]>(null as any);
    }

    /**
     * Batch links service engagements to a project.
     * @param body (optional) 
     * @return OK
     */
    link(itProjectId: string, body: number[] | undefined, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/service-engagements";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLink(_response);
        });
    }

    protected processLink(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Batch removes service engagement links from a project.
     * @param body (optional) 
     * @return No Content
     */
    unlink(itProjectId: string, body: number[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/service-engagements";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlink(_response);
        });
    }

    protected processUnlink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IItProjectsVariantsClient {
    /**
     * Gets all distinct variants available on the account.
     * @return OK
     */
    getAvailableVariants(itProjectId: string,  cancelToken?: CancelToken): Promise<AvailableVariantDto[]>;
    /**
     * Gets variants currently linked to this project.
     * @return OK
     */
    getLinkedVariants(itProjectId: string,  cancelToken?: CancelToken): Promise<AvailableVariantDto[]>;
    /**
     * Batch links variants to an IT project.
     * @param body (optional) 
     * @return OK
     */
    linkVariant(itProjectId: string, body: string[] | undefined,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * Batch removes variant links from an IT project.
     * @param body (optional) 
     * @return No Content
     */
    unlinkVariant(itProjectId: string, body: string[] | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Gets warehouse stock items filtered to only the variants linked to this project.
     * @return OK
     */
    getLinkedVariantStock(itProjectId: string,  cancelToken?: CancelToken): Promise<WarehouseStockItemDto[]>;
    /**
     * Gets lightweight aggregate counts for linked variants.
     * @return OK
     */
    getLinkedVariantAggregateCounts(itProjectId: string,  cancelToken?: CancelToken): Promise<LinkedVariantAggregateCountsDto>;
    /**
     * Gets warehouse orders filtered to only the variants linked to this project.
     * @param body (optional) 
     * @return OK
     */
    getLinkedVariantOrders(itProjectId: string, body: PaginatedFilterQuery | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto>;
}

export class ItProjectsVariantsClient extends AuthorizedApiBase implements IItProjectsVariantsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets all distinct variants available on the account.
     * @return OK
     */
    getAvailableVariants(itProjectId: string, cancelToken?: CancelToken): Promise<AvailableVariantDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/variants/available";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableVariants(_response);
        });
    }

    protected processGetAvailableVariants(response: AxiosResponse): Promise<AvailableVariantDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableVariantDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AvailableVariantDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailableVariantDto[]>(null as any);
    }

    /**
     * Gets variants currently linked to this project.
     * @return OK
     */
    getLinkedVariants(itProjectId: string, cancelToken?: CancelToken): Promise<AvailableVariantDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/variants/linked";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedVariants(_response);
        });
    }

    protected processGetLinkedVariants(response: AxiosResponse): Promise<AvailableVariantDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableVariantDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AvailableVariantDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailableVariantDto[]>(null as any);
    }

    /**
     * Batch links variants to an IT project.
     * @param body (optional) 
     * @return OK
     */
    linkVariant(itProjectId: string, body: string[] | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/variants";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkVariant(_response);
        });
    }

    protected processLinkVariant(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Batch removes variant links from an IT project.
     * @param body (optional) 
     * @return No Content
     */
    unlinkVariant(itProjectId: string, body: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/variants";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkVariant(_response);
        });
    }

    protected processUnlinkVariant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets warehouse stock items filtered to only the variants linked to this project.
     * @return OK
     */
    getLinkedVariantStock(itProjectId: string, cancelToken?: CancelToken): Promise<WarehouseStockItemDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/variants/stock";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedVariantStock(_response);
        });
    }

    protected processGetLinkedVariantStock(response: AxiosResponse): Promise<WarehouseStockItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseStockItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WarehouseStockItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarehouseStockItemDto[]>(null as any);
    }

    /**
     * Gets lightweight aggregate counts for linked variants.
     * @return OK
     */
    getLinkedVariantAggregateCounts(itProjectId: string, cancelToken?: CancelToken): Promise<LinkedVariantAggregateCountsDto> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/variants/aggregate-counts";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedVariantAggregateCounts(_response);
        });
    }

    protected processGetLinkedVariantAggregateCounts(response: AxiosResponse): Promise<LinkedVariantAggregateCountsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkedVariantAggregateCountsDto.fromJS(resultData200);
            return Promise.resolve<LinkedVariantAggregateCountsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkedVariantAggregateCountsDto>(null as any);
    }

    /**
     * Gets warehouse orders filtered to only the variants linked to this project.
     * @param body (optional) 
     * @return OK
     */
    getLinkedVariantOrders(itProjectId: string, body: PaginatedFilterQuery | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/variants/orders";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedVariantOrders(_response);
        });
    }

    protected processGetLinkedVariantOrders(response: AxiosResponse): Promise<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfCombinedWarehouseOrderItemDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto>(null as any);
    }
}

export interface IItProjectsWebLinksClient {
    /**
     * Lists all web links for a project.
     * @return OK
     */
    listWebLinks(itProjectId: string,  cancelToken?: CancelToken): Promise<WebLinkDto[]>;
    /**
     * Creates a web link for a project.
     * @param body (optional) 
     * @return Created
     */
    createWebLink(itProjectId: string, body: CreateWebLinkRequest | undefined,  cancelToken?: CancelToken): Promise<WebLinkDto>;
    /**
     * Deletes a web link from a project.
     * @return No Content
     */
    deleteWebLink(itProjectId: string, webLinkId: number,  cancelToken?: CancelToken): Promise<void>;
}

export class ItProjectsWebLinksClient extends AuthorizedApiBase implements IItProjectsWebLinksClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Lists all web links for a project.
     * @return OK
     */
    listWebLinks(itProjectId: string, cancelToken?: CancelToken): Promise<WebLinkDto[]> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/web-links";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListWebLinks(_response);
        });
    }

    protected processListWebLinks(response: AxiosResponse): Promise<WebLinkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebLinkDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WebLinkDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebLinkDto[]>(null as any);
    }

    /**
     * Creates a web link for a project.
     * @param body (optional) 
     * @return Created
     */
    createWebLink(itProjectId: string, body: CreateWebLinkRequest | undefined, cancelToken?: CancelToken): Promise<WebLinkDto> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/web-links";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWebLink(_response);
        });
    }

    protected processCreateWebLink(response: AxiosResponse): Promise<WebLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = WebLinkDto.fromJS(resultData201);
            return Promise.resolve<WebLinkDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebLinkDto>(null as any);
    }

    /**
     * Deletes a web link from a project.
     * @return No Content
     */
    deleteWebLink(itProjectId: string, webLinkId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/it-projects/{itProjectId}/web-links/{webLinkId}";
        if (itProjectId === undefined || itProjectId === null)
            throw new globalThis.Error("The parameter 'itProjectId' must be defined.");
        url_ = url_.replace("{itProjectId}", encodeURIComponent("" + itProjectId));
        if (webLinkId === undefined || webLinkId === null)
            throw new globalThis.Error("The parameter 'webLinkId' must be defined.");
        url_ = url_.replace("{webLinkId}", encodeURIComponent("" + webLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWebLink(_response);
        });
    }

    protected processDeleteWebLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IKnowledgebaseClient {
    /**
     * @return OK
     */
    getAllKb( cancelToken?: CancelToken): Promise<ContentUnitDto[]>;
}

export class KnowledgebaseClient extends AuthorizedApiBase implements IKnowledgebaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAllKb( cancelToken?: CancelToken): Promise<ContentUnitDto[]> {
        let url_ = this.baseUrl + "/api/Knowledgebase/kb/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllKb(_response);
        });
    }

    protected processGetAllKb(response: AxiosResponse): Promise<ContentUnitDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentUnitDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ContentUnitDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentUnitDto[]>(null as any);
    }
}

export interface ILabsClient {
    /**
     * Returns the complete SHI Lab list from sharepoint with all current available labs
     * @return OK
     */
    getAllLabsFromSharepoint( cancelToken?: CancelToken): Promise<LabDto[]>;
    /**
     * Returns the typed Labs definitions from InsightsCms.
     * @return OK
     */
    getLabsDefinitions( cancelToken?: CancelToken): Promise<LabDto[]>;
    /**
     * Returns the SHI Lab list with available labs based on the search value
     * @return OK
     */
    searchAvailableLabsFromSharepoint(searchTerm: string,  cancelToken?: CancelToken): Promise<LabDto[]>;
    /**
     * Returns the available filter options for labs
     * @return OK
     */
    getLabFilterOptions( cancelToken?: CancelToken): Promise<IncludeExcludeFilterCategory[]>;
    /**
     * Returns the logo for the lab with the given imageId
     * @return OK
     */
    getLabLogo(imageId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Gets the distinct lab practices available in the lab catalog.
     * @return OK
     * @deprecated
     */
    getUniqueLabPracticeList( cancelToken?: CancelToken): Promise<string[]>;
    /**
     * Returns the lab logo dto for the lab with the given imageId
     * @return OK
     */
    getLabLogoBytes(imageId: string,  cancelToken?: CancelToken): Promise<LabLogoDto>;
    /**
     * Returns documentation for a specific lab
     * @param body (optional) 
     * @return OK
     */
    downloadLabDocumentation(body: DownloadLabDocumentationByFileReference | undefined,  cancelToken?: CancelToken): Promise<DownloadLabDocumentationDto>;
    /**
     * Streams a typed Labs attachment from InsightsCms.
     * @return OK
     */
    downloadAttachment(labId: number, attachmentId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Submits a lab access request for the current user.
     * @param body (optional) The requested lab.
     * @return OK
     */
    requestLabAccess(body: Lab | undefined,  cancelToken?: CancelToken): Promise<LabAccessRequestResponse>;
}

export class LabsClient extends AuthorizedApiBase implements ILabsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the complete SHI Lab list from sharepoint with all current available labs
     * @return OK
     */
    getAllLabsFromSharepoint( cancelToken?: CancelToken): Promise<LabDto[]> {
        let url_ = this.baseUrl + "/api/Labs/sharepoint";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllLabsFromSharepoint(_response);
        });
    }

    protected processGetAllLabsFromSharepoint(response: AxiosResponse): Promise<LabDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LabDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabDto[]>(null as any);
    }

    /**
     * Returns the typed Labs definitions from InsightsCms.
     * @return OK
     */
    getLabsDefinitions( cancelToken?: CancelToken): Promise<LabDto[]> {
        let url_ = this.baseUrl + "/api/Labs/definitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLabsDefinitions(_response);
        });
    }

    protected processGetLabsDefinitions(response: AxiosResponse): Promise<LabDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LabDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabDto[]>(null as any);
    }

    /**
     * Returns the SHI Lab list with available labs based on the search value
     * @return OK
     */
    searchAvailableLabsFromSharepoint(searchTerm: string, cancelToken?: CancelToken): Promise<LabDto[]> {
        let url_ = this.baseUrl + "/api/Labs/search/sharepoint/{searchTerm}";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAvailableLabsFromSharepoint(_response);
        });
    }

    protected processSearchAvailableLabsFromSharepoint(response: AxiosResponse): Promise<LabDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LabDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabDto[]>(null as any);
    }

    /**
     * Returns the available filter options for labs
     * @return OK
     */
    getLabFilterOptions( cancelToken?: CancelToken): Promise<IncludeExcludeFilterCategory[]> {
        let url_ = this.baseUrl + "/api/Labs/filter-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLabFilterOptions(_response);
        });
    }

    protected processGetLabFilterOptions(response: AxiosResponse): Promise<IncludeExcludeFilterCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncludeExcludeFilterCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IncludeExcludeFilterCategory[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncludeExcludeFilterCategory[]>(null as any);
    }

    /**
     * Returns the logo for the lab with the given imageId
     * @return OK
     */
    getLabLogo(imageId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Labs/logo/{imageId}";
        if (imageId === undefined || imageId === null)
            throw new globalThis.Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLabLogo(_response);
        });
    }

    protected processGetLabLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the distinct lab practices available in the lab catalog.
     * @return OK
     * @deprecated
     */
    getUniqueLabPracticeList( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Labs/practices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUniqueLabPracticeList(_response);
        });
    }

    protected processGetUniqueLabPracticeList(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Returns the lab logo dto for the lab with the given imageId
     * @return OK
     */
    getLabLogoBytes(imageId: string, cancelToken?: CancelToken): Promise<LabLogoDto> {
        let url_ = this.baseUrl + "/api/Labs/logo-bytes/{imageId}";
        if (imageId === undefined || imageId === null)
            throw new globalThis.Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLabLogoBytes(_response);
        });
    }

    protected processGetLabLogoBytes(response: AxiosResponse): Promise<LabLogoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LabLogoDto.fromJS(resultData200);
            return Promise.resolve<LabLogoDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabLogoDto>(null as any);
    }

    /**
     * Returns documentation for a specific lab
     * @param body (optional) 
     * @return OK
     */
    downloadLabDocumentation(body: DownloadLabDocumentationByFileReference | undefined, cancelToken?: CancelToken): Promise<DownloadLabDocumentationDto> {
        let url_ = this.baseUrl + "/api/Labs/documentation/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadLabDocumentation(_response);
        });
    }

    protected processDownloadLabDocumentation(response: AxiosResponse): Promise<DownloadLabDocumentationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadLabDocumentationDto.fromJS(resultData200);
            return Promise.resolve<DownloadLabDocumentationDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadLabDocumentationDto>(null as any);
    }

    /**
     * Streams a typed Labs attachment from InsightsCms.
     * @return OK
     */
    downloadAttachment(labId: number, attachmentId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Labs/{labId}/attachments/{attachmentId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Submits a lab access request for the current user.
     * @param body (optional) The requested lab.
     * @return OK
     */
    requestLabAccess(body: Lab | undefined, cancelToken?: CancelToken): Promise<LabAccessRequestResponse> {
        let url_ = this.baseUrl + "/api/Labs/request-access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestLabAccess(_response);
        });
    }

    protected processRequestLabAccess(response: AxiosResponse): Promise<LabAccessRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LabAccessRequestResponse.fromJS(resultData200);
            return Promise.resolve<LabAccessRequestResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabAccessRequestResponse>(null as any);
    }
}

export interface ILabsOnDemandClient {
    /**
     * Creates an on-demand lab for the current user.
     * @param labId The lab identifier.
     * @return OK
     */
    createOnDemandLabForUser(labId: string,  cancelToken?: CancelToken): Promise<UserLabsDto>;
    /**
     * Gets the current user's on-demand lab data.
     * @return OK
     */
    getUserLabsData( cancelToken?: CancelToken): Promise<UserLabsDto>;
    /**
     * Gets all recorded labs-on-demand requests.
     * @return OK
     */
    getUserOnDemandLabRequests( cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto[]>;
    /**
     * Creates a labs-on-demand request.
     * @param body (optional) The request payload.
     * @return OK
     */
    createUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined,  cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto[]>;
    /**
     * Updates an existing labs-on-demand request.
     * @param body (optional) The request payload.
     * @return OK
     */
    updateUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined,  cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto[]>;
    /**
     * Removes a labs-on-demand request.
     * @param body (optional) The request payload.
     * @return OK
     */
    removeUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined,  cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto>;
}

export class LabsOnDemandClient extends AuthorizedApiBase implements ILabsOnDemandClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Creates an on-demand lab for the current user.
     * @param labId The lab identifier.
     * @return OK
     */
    createOnDemandLabForUser(labId: string, cancelToken?: CancelToken): Promise<UserLabsDto> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/lab/{labId}";
        if (labId === undefined || labId === null)
            throw new globalThis.Error("The parameter 'labId' must be defined.");
        url_ = url_.replace("{labId}", encodeURIComponent("" + labId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOnDemandLabForUser(_response);
        });
    }

    protected processCreateOnDemandLabForUser(response: AxiosResponse): Promise<UserLabsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserLabsDto.fromJS(resultData200);
            return Promise.resolve<UserLabsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLabsDto>(null as any);
    }

    /**
     * Gets the current user's on-demand lab data.
     * @return OK
     */
    getUserLabsData( cancelToken?: CancelToken): Promise<UserLabsDto> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/user/labs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserLabsData(_response);
        });
    }

    protected processGetUserLabsData(response: AxiosResponse): Promise<UserLabsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserLabsDto.fromJS(resultData200);
            return Promise.resolve<UserLabsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLabsDto>(null as any);
    }

    /**
     * Gets all recorded labs-on-demand requests.
     * @return OK
     */
    getUserOnDemandLabRequests( cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto[]> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/user/labs/requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOnDemandLabRequests(_response);
        });
    }

    protected processGetUserOnDemandLabRequests(response: AxiosResponse): Promise<UserOnDemandLabRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOnDemandLabRequestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserOnDemandLabRequestDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOnDemandLabRequestDto[]>(null as any);
    }

    /**
     * Creates a labs-on-demand request.
     * @param body (optional) The request payload.
     * @return OK
     */
    createUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined, cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto[]> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/labs/requests/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserOnDemandLabRequests(_response);
        });
    }

    protected processCreateUserOnDemandLabRequests(response: AxiosResponse): Promise<UserOnDemandLabRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOnDemandLabRequestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserOnDemandLabRequestDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOnDemandLabRequestDto[]>(null as any);
    }

    /**
     * Updates an existing labs-on-demand request.
     * @param body (optional) The request payload.
     * @return OK
     */
    updateUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined, cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto[]> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/labs/requests/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserOnDemandLabRequests(_response);
        });
    }

    protected processUpdateUserOnDemandLabRequests(response: AxiosResponse): Promise<UserOnDemandLabRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOnDemandLabRequestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserOnDemandLabRequestDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOnDemandLabRequestDto[]>(null as any);
    }

    /**
     * Removes a labs-on-demand request.
     * @param body (optional) The request payload.
     * @return OK
     */
    removeUserOnDemandLabRequests(body: UserOnDemandLabRequestDto | undefined, cancelToken?: CancelToken): Promise<UserOnDemandLabRequestDto> {
        let url_ = this.baseUrl + "/api/LabsOnDemand/labs/requests/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUserOnDemandLabRequests(_response);
        });
    }

    protected processRemoveUserOnDemandLabRequests(response: AxiosResponse): Promise<UserOnDemandLabRequestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserOnDemandLabRequestDto.fromJS(resultData200);
            return Promise.resolve<UserOnDemandLabRequestDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOnDemandLabRequestDto>(null as any);
    }
}

export interface ILastMonthsCostsWidgetClient {
    /**
     * @return OK
     */
    costs(lastMonthsCostType: LastMonthsCostType,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfLastMonthsCostDto>;
}

export class LastMonthsCostsWidgetClient extends AuthorizedApiBase implements ILastMonthsCostsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    costs(lastMonthsCostType: LastMonthsCostType, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfLastMonthsCostDto> {
        let url_ = this.baseUrl + "/api/widget/last-months-cost/{lastMonthsCostType}";
        if (lastMonthsCostType === undefined || lastMonthsCostType === null)
            throw new globalThis.Error("The parameter 'lastMonthsCostType' must be defined.");
        url_ = url_.replace("{lastMonthsCostType}", encodeURIComponent("" + lastMonthsCostType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCosts(_response);
        });
    }

    protected processCosts(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfLastMonthsCostDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfLastMonthsCostDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfLastMonthsCostDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfLastMonthsCostDto>(null as any);
    }
}

export interface ILeasingFormClient {
    /**
     * Returns the renderable leasing inquiry form definition.
     * @return OK
     */
    getLeasingFormDefinition( cancelToken?: CancelToken): Promise<MarketoFormDefinitionResponse>;
}

export class LeasingFormClient extends AuthorizedApiBase implements ILeasingFormClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the renderable leasing inquiry form definition.
     * @return OK
     */
    getLeasingFormDefinition( cancelToken?: CancelToken): Promise<MarketoFormDefinitionResponse> {
        let url_ = this.baseUrl + "/api/ecommerce/leasing/form-definition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeasingFormDefinition(_response);
        });
    }

    protected processGetLeasingFormDefinition(response: AxiosResponse): Promise<MarketoFormDefinitionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarketoFormDefinitionResponse.fromJS(resultData200);
            return Promise.resolve<MarketoFormDefinitionResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketoFormDefinitionResponse>(null as any);
    }
}

export interface ILifecycleBulkImportClient {
    /**
     * Downloads the blank workbook template accepted by the `validate` endpoint.
     * @return OK
     */
    getTemplate( cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * Validates an uploaded workbook and stages a sanitized CSV import file when valid rows exist.
     * @param file (optional) The uploaded workbook.
     * @param axAccountNumber (optional) Account the events belong to.
     * @return OK
     */
    validate(file: FileParameter | undefined, axAccountNumber: string | undefined,  cancelToken?: CancelToken): Promise<LifecycleImportValidationResponse>;
    /**
     * Promotes a previously validated staged import file into the Databricks ingestion inbox.
     * @param body (optional) Opaque staged-workbook token and its selected account.
     * @return Accepted
     */
    submitStaged(body: LifecycleImportStagedSubmissionRequest | undefined,  cancelToken?: CancelToken): Promise<LifecycleImportSubmissionResponse>;
    /**
     * Discards a staged import file when FilePond removes it before submission.
     * @param stagingToken (optional) Optional staging token supplied by a dialog cancel action.
     * @return No Content
     */
    discardStaged(stagingToken: string | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class LifecycleBulkImportClient extends AuthorizedApiBase implements ILifecycleBulkImportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Downloads the blank workbook template accepted by the `validate` endpoint.
     * @return OK
     */
    getTemplate( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/bulk-import/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplate(_response);
        });
    }

    protected processGetTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Validates an uploaded workbook and stages a sanitized CSV import file when valid rows exist.
     * @param file (optional) The uploaded workbook.
     * @param axAccountNumber (optional) Account the events belong to.
     * @return OK
     */
    validate(file: FileParameter | undefined, axAccountNumber: string | undefined, cancelToken?: CancelToken): Promise<LifecycleImportValidationResponse> {
        let url_ = this.baseUrl + "/api/files/lifecycle-bulk-import/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (axAccountNumber === null || axAccountNumber === undefined)
            throw new globalThis.Error("The parameter 'axAccountNumber' cannot be null.");
        else
            content_.append("axAccountNumber", axAccountNumber.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<LifecycleImportValidationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LifecycleImportValidationResponse.fromJS(resultData200);
            return Promise.resolve<LifecycleImportValidationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 413) {
            const _responseText = response.data;
            let result413: any = null;
            let resultData413  = _responseText;
            result413 = ProblemDetails.fromJS(resultData413);
            return throwException("Content Too Large", status, _responseText, _headers, result413);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = LifecycleImportValidationResponse.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LifecycleImportValidationResponse>(null as any);
    }

    /**
     * Promotes a previously validated staged import file into the Databricks ingestion inbox.
     * @param body (optional) Opaque staged-workbook token and its selected account.
     * @return Accepted
     */
    submitStaged(body: LifecycleImportStagedSubmissionRequest | undefined, cancelToken?: CancelToken): Promise<LifecycleImportSubmissionResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/bulk-import/submit-staged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitStaged(_response);
        });
    }

    protected processSubmitStaged(response: AxiosResponse): Promise<LifecycleImportSubmissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = LifecycleImportSubmissionResponse.fromJS(resultData202);
            return Promise.resolve<LifecycleImportSubmissionResponse>(result202);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 410) {
            const _responseText = response.data;
            let result410: any = null;
            let resultData410  = _responseText;
            result410 = ProblemDetails.fromJS(resultData410);
            return throwException("Gone", status, _responseText, _headers, result410);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LifecycleImportSubmissionResponse>(null as any);
    }

    /**
     * Discards a staged import file when FilePond removes it before submission.
     * @param stagingToken (optional) Optional staging token supplied by a dialog cancel action.
     * @return No Content
     */
    discardStaged(stagingToken: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/bulk-import/staged?";
        if (stagingToken === null)
            throw new globalThis.Error("The parameter 'stagingToken' cannot be null.");
        else if (stagingToken !== undefined)
            url_ += "stagingToken=" + encodeURIComponent("" + stagingToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscardStaged(_response);
        });
    }

    protected processDiscardStaged(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ILifecycleEventClient {
    /**
     * Deletes a lifecycle event by unique identifier, dispatching on its source.
     * @param uniqueIdentifier The unique identifier of the lifecycle event to delete.
     * @param source The lifecycle event source, either Custom or Imported.
     * @return No Content
     */
    deleteLifecycleEvent(uniqueIdentifier: string, source: string,  cancelToken?: CancelToken): Promise<void>;
}

export class LifecycleEventClient extends AuthorizedApiBase implements ILifecycleEventClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Deletes a lifecycle event by unique identifier, dispatching on its source.
     * @param uniqueIdentifier The unique identifier of the lifecycle event to delete.
     * @param source The lifecycle event source, either Custom or Imported.
     * @return No Content
     */
    deleteLifecycleEvent(uniqueIdentifier: string, source: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/event/{uniqueIdentifier}?";
        if (uniqueIdentifier === undefined || uniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'uniqueIdentifier' must be defined.");
        url_ = url_.replace("{uniqueIdentifier}", encodeURIComponent("" + uniqueIdentifier));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined and cannot be null.");
        else
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLifecycleEvent(_response);
        });
    }

    protected processDeleteLifecycleEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ILifecycleManagementClient {
    /**
     * @return OK
     */
    getEventByUniqueIdentifier(uniqueIdentifier: string,  cancelToken?: CancelToken): Promise<LifecycleManagementAllEvents>;
    /**
     * @return OK
     */
    picklist( cancelToken?: CancelToken): Promise<GetLifecycleManagementPicklistResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCategoryValues(body: LifecycleManagementSearchCategoryRequestDto | undefined,  cancelToken?: CancelToken): Promise<GetLifecycleManagementCategoryValuesResponse>;
    /**
     * @param term (optional) 
     * @return OK
     */
    getEventCountsByTerm(term: number | undefined,  cancelToken?: CancelToken): Promise<GetEventCountsByTermResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getAllEvents(body: LifecycleManagementAllEventsRequestDto | undefined,  cancelToken?: CancelToken): Promise<GetLifecycleManagementAllEventsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getAllEventsTimeline(body: LifecycleManagementAllEventsTimelineRequestDto | undefined,  cancelToken?: CancelToken): Promise<GetLifecycleManagementAllEventsTimelineResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    putEvent(body: LifecycleManagementUpsertEventRequestDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postRenewal(body: LifecycleManagementCreateRenewalRequestDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param maxCount (optional) 
     * @param months (optional) 
     * @return OK
     */
    getUpcomingRenewals(maxCount: number | undefined, months: number | undefined,  cancelToken?: CancelToken): Promise<GetUpcomingRenewalsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    exportAllEvents(body: LifecycleManagementAllEventsExportRequestDto | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getDrawerOrdersDetails(body: GetLifecycleManagementDrawerOrdersSearchRequest | undefined,  cancelToken?: CancelToken): Promise<GetLifecycleManagementDrawerOrdersResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getEventLineItems(body: GetLifecycleEventLineItemsSearchRequest | undefined,  cancelToken?: CancelToken): Promise<GetLifecycleEventLineItemsResponse>;
    /**
     * @return OK
     */
    getAccountTeamMembersByCrmAccountId(crmAccountId: string,  cancelToken?: CancelToken): Promise<GetShiOneAccountTeamMembersResponse>;
    /**
     * @return OK
     */
    getCustomerOwnersByCrmAccountId(crmAccountId: string,  cancelToken?: CancelToken): Promise<CustomerOwnerDto[]>;
}

export class LifecycleManagementClient extends AuthorizedApiBase implements ILifecycleManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getEventByUniqueIdentifier(uniqueIdentifier: string, cancelToken?: CancelToken): Promise<LifecycleManagementAllEvents> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/event/{uniqueIdentifier}";
        if (uniqueIdentifier === undefined || uniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'uniqueIdentifier' must be defined.");
        url_ = url_.replace("{uniqueIdentifier}", encodeURIComponent("" + uniqueIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEventByUniqueIdentifier(_response);
        });
    }

    protected processGetEventByUniqueIdentifier(response: AxiosResponse): Promise<LifecycleManagementAllEvents> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LifecycleManagementAllEvents.fromJS(resultData200);
            return Promise.resolve<LifecycleManagementAllEvents>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LifecycleManagementAllEvents>(null as any);
    }

    /**
     * @return OK
     */
    picklist( cancelToken?: CancelToken): Promise<GetLifecycleManagementPicklistResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPicklist(_response);
        });
    }

    protected processPicklist(response: AxiosResponse): Promise<GetLifecycleManagementPicklistResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLifecycleManagementPicklistResponse.fromJS(resultData200);
            return Promise.resolve<GetLifecycleManagementPicklistResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLifecycleManagementPicklistResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCategoryValues(body: LifecycleManagementSearchCategoryRequestDto | undefined, cancelToken?: CancelToken): Promise<GetLifecycleManagementCategoryValuesResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/category-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategoryValues(_response);
        });
    }

    protected processGetCategoryValues(response: AxiosResponse): Promise<GetLifecycleManagementCategoryValuesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLifecycleManagementCategoryValuesResponse.fromJS(resultData200);
            return Promise.resolve<GetLifecycleManagementCategoryValuesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLifecycleManagementCategoryValuesResponse>(null as any);
    }

    /**
     * @param term (optional) 
     * @return OK
     */
    getEventCountsByTerm(term: number | undefined, cancelToken?: CancelToken): Promise<GetEventCountsByTermResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/event-counts?";
        if (term === null)
            throw new globalThis.Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEventCountsByTerm(_response);
        });
    }

    protected processGetEventCountsByTerm(response: AxiosResponse): Promise<GetEventCountsByTermResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEventCountsByTermResponse.fromJS(resultData200);
            return Promise.resolve<GetEventCountsByTermResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEventCountsByTermResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllEvents(body: LifecycleManagementAllEventsRequestDto | undefined, cancelToken?: CancelToken): Promise<GetLifecycleManagementAllEventsResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/all-events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEvents(_response);
        });
    }

    protected processGetAllEvents(response: AxiosResponse): Promise<GetLifecycleManagementAllEventsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLifecycleManagementAllEventsResponse.fromJS(resultData200);
            return Promise.resolve<GetLifecycleManagementAllEventsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLifecycleManagementAllEventsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllEventsTimeline(body: LifecycleManagementAllEventsTimelineRequestDto | undefined, cancelToken?: CancelToken): Promise<GetLifecycleManagementAllEventsTimelineResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/all-events/timeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEventsTimeline(_response);
        });
    }

    protected processGetAllEventsTimeline(response: AxiosResponse): Promise<GetLifecycleManagementAllEventsTimelineResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLifecycleManagementAllEventsTimelineResponse.fromJS(resultData200);
            return Promise.resolve<GetLifecycleManagementAllEventsTimelineResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLifecycleManagementAllEventsTimelineResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    putEvent(body: LifecycleManagementUpsertEventRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutEvent(_response);
        });
    }

    protected processPutEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postRenewal(body: LifecycleManagementCreateRenewalRequestDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/renewal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRenewal(_response);
        });
    }

    protected processPostRenewal(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param maxCount (optional) 
     * @param months (optional) 
     * @return OK
     */
    getUpcomingRenewals(maxCount: number | undefined, months: number | undefined, cancelToken?: CancelToken): Promise<GetUpcomingRenewalsResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/upcoming-renewals?";
        if (maxCount === null)
            throw new globalThis.Error("The parameter 'maxCount' cannot be null.");
        else if (maxCount !== undefined)
            url_ += "maxCount=" + encodeURIComponent("" + maxCount) + "&";
        if (months === null)
            throw new globalThis.Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUpcomingRenewals(_response);
        });
    }

    protected processGetUpcomingRenewals(response: AxiosResponse): Promise<GetUpcomingRenewalsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUpcomingRenewalsResponse.fromJS(resultData200);
            return Promise.resolve<GetUpcomingRenewalsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUpcomingRenewalsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportAllEvents(body: LifecycleManagementAllEventsExportRequestDto | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/all-events/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAllEvents(_response);
        });
    }

    protected processExportAllEvents(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDrawerOrdersDetails(body: GetLifecycleManagementDrawerOrdersSearchRequest | undefined, cancelToken?: CancelToken): Promise<GetLifecycleManagementDrawerOrdersResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/drawer-order-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrawerOrdersDetails(_response);
        });
    }

    protected processGetDrawerOrdersDetails(response: AxiosResponse): Promise<GetLifecycleManagementDrawerOrdersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLifecycleManagementDrawerOrdersResponse.fromJS(resultData200);
            return Promise.resolve<GetLifecycleManagementDrawerOrdersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLifecycleManagementDrawerOrdersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getEventLineItems(body: GetLifecycleEventLineItemsSearchRequest | undefined, cancelToken?: CancelToken): Promise<GetLifecycleEventLineItemsResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/drawer-line-items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEventLineItems(_response);
        });
    }

    protected processGetEventLineItems(response: AxiosResponse): Promise<GetLifecycleEventLineItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLifecycleEventLineItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetLifecycleEventLineItemsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLifecycleEventLineItemsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAccountTeamMembersByCrmAccountId(crmAccountId: string, cancelToken?: CancelToken): Promise<GetShiOneAccountTeamMembersResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/accounts/{crmAccountId}/account-team-members";
        if (crmAccountId === undefined || crmAccountId === null)
            throw new globalThis.Error("The parameter 'crmAccountId' must be defined.");
        url_ = url_.replace("{crmAccountId}", encodeURIComponent("" + crmAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountTeamMembersByCrmAccountId(_response);
        });
    }

    protected processGetAccountTeamMembersByCrmAccountId(response: AxiosResponse): Promise<GetShiOneAccountTeamMembersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetShiOneAccountTeamMembersResponse.fromJS(resultData200);
            return Promise.resolve<GetShiOneAccountTeamMembersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetShiOneAccountTeamMembersResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCustomerOwnersByCrmAccountId(crmAccountId: string, cancelToken?: CancelToken): Promise<CustomerOwnerDto[]> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/accounts/{crmAccountId}/customer-owners";
        if (crmAccountId === undefined || crmAccountId === null)
            throw new globalThis.Error("The parameter 'crmAccountId' must be defined.");
        url_ = url_.replace("{crmAccountId}", encodeURIComponent("" + crmAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerOwnersByCrmAccountId(_response);
        });
    }

    protected processGetCustomerOwnersByCrmAccountId(response: AxiosResponse): Promise<CustomerOwnerDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerOwnerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CustomerOwnerDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerOwnerDto[]>(null as any);
    }
}

export interface ILifecycleManufacturerClient {
    /**
     * Suggests up to 20 manufacturers whose name contains search, ignoring case.
    Manufacturers with an Insights card come first, then the rest by product count. A search shorter than
    two characters returns no suggestions.
     * @param search (optional) Part of the manufacturer name.
     * @return OK
     */
    getManufacturerSuggestions(search: string | undefined,  cancelToken?: CancelToken): Promise<BiManufacturerSuggestionDto[]>;
}

export class LifecycleManufacturerClient extends AuthorizedApiBase implements ILifecycleManufacturerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Suggests up to 20 manufacturers whose name contains search, ignoring case.
    Manufacturers with an Insights card come first, then the rest by product count. A search shorter than
    two characters returns no suggestions.
     * @param search (optional) Part of the manufacturer name.
     * @return OK
     */
    getManufacturerSuggestions(search: string | undefined, cancelToken?: CancelToken): Promise<BiManufacturerSuggestionDto[]> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/manufacturers?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerSuggestions(_response);
        });
    }

    protected processGetManufacturerSuggestions(response: AxiosResponse): Promise<BiManufacturerSuggestionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BiManufacturerSuggestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BiManufacturerSuggestionDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BiManufacturerSuggestionDto[]>(null as any);
    }
}

export interface IManuallyCreatedLifecycleEventClient {
    /**
     * Finds existing events on the same account that look like the event about to be saved: same
    manufacturer, same event type, dated within 30 days, from any source, and not Canceled or Ignore.
    The caller warns on matches and never blocks the save.
     * @param body (optional) The event about to be saved.
     * @return OK
     */
    findPossibleDuplicates(body: FindPossibleDuplicateLifecycleEventsRequest | undefined,  cancelToken?: CancelToken): Promise<FindPossibleDuplicateLifecycleEventsResponse>;
    /**
     * Creates a new manually created lifecycle event. An event sent with an Insights card's BI manufacturer ID
    is saved only if the Insights manufacturer registry lists that ID, and takes the registry's name.
     * @param body (optional) The lifecycle event creation request.
     * @return Created
     */
    createManualEvent(body: CreateManuallyCreatedLifecycleEventRequest | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * Gets a manually created lifecycle event by unique identifier.
     * @param uniqueIdentifier (optional) The unique identifier of the lifecycle event.
     * @return OK
     */
    getManualEventByUniqueIdentifier(uniqueIdentifier: string | undefined,  cancelToken?: CancelToken): Promise<ManuallyCreatedLifecycleEventDto>;
}

export class ManuallyCreatedLifecycleEventClient extends AuthorizedApiBase implements IManuallyCreatedLifecycleEventClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Finds existing events on the same account that look like the event about to be saved: same
    manufacturer, same event type, dated within 30 days, from any source, and not Canceled or Ignore.
    The caller warns on matches and never blocks the save.
     * @param body (optional) The event about to be saved.
     * @return OK
     */
    findPossibleDuplicates(body: FindPossibleDuplicateLifecycleEventsRequest | undefined, cancelToken?: CancelToken): Promise<FindPossibleDuplicateLifecycleEventsResponse> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/manual-event/possible-duplicates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindPossibleDuplicates(_response);
        });
    }

    protected processFindPossibleDuplicates(response: AxiosResponse): Promise<FindPossibleDuplicateLifecycleEventsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FindPossibleDuplicateLifecycleEventsResponse.fromJS(resultData200);
            return Promise.resolve<FindPossibleDuplicateLifecycleEventsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FindPossibleDuplicateLifecycleEventsResponse>(null as any);
    }

    /**
     * Creates a new manually created lifecycle event. An event sent with an Insights card's BI manufacturer ID
    is saved only if the Insights manufacturer registry lists that ID, and takes the registry's name.
     * @param body (optional) The lifecycle event creation request.
     * @return Created
     */
    createManualEvent(body: CreateManuallyCreatedLifecycleEventRequest | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/manual-event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateManualEvent(_response);
        });
    }

    protected processCreateManualEvent(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return Promise.resolve<string>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets a manually created lifecycle event by unique identifier.
     * @param uniqueIdentifier (optional) The unique identifier of the lifecycle event.
     * @return OK
     */
    getManualEventByUniqueIdentifier(uniqueIdentifier: string | undefined, cancelToken?: CancelToken): Promise<ManuallyCreatedLifecycleEventDto> {
        let url_ = this.baseUrl + "/api/assets/lifecycle/manual-event?";
        if (uniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'uniqueIdentifier' cannot be null.");
        else if (uniqueIdentifier !== undefined)
            url_ += "uniqueIdentifier=" + encodeURIComponent("" + uniqueIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManualEventByUniqueIdentifier(_response);
        });
    }

    protected processGetManualEventByUniqueIdentifier(response: AxiosResponse): Promise<ManuallyCreatedLifecycleEventDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ManuallyCreatedLifecycleEventDto.fromJS(resultData200);
            return Promise.resolve<ManuallyCreatedLifecycleEventDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManuallyCreatedLifecycleEventDto>(null as any);
    }
}

export interface IManufacturerInsightsClient {
    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerSpendTotals(clientLocalNow: Date | undefined,  cancelToken?: CancelToken): Promise<GetManufacturerSpendTotalsResponse>;
    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerSpendHistory(clientLocalNow: Date | undefined,  cancelToken?: CancelToken): Promise<GetManufacturerSpendHistoryResponse>;
    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerMonthlySpendHistory(clientLocalNow: Date | undefined,  cancelToken?: CancelToken): Promise<GetManufacturerMonthlySpendHistoryResponse>;
    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerSpendForecast(clientLocalNow: Date | undefined,  cancelToken?: CancelToken): Promise<GetManufacturerSpendForecastResponse>;
    /**
     * @return OK
     */
    getManufacturerInsights(manufacturerBiId: string,  cancelToken?: CancelToken): Promise<GetManufacturerInsightsResponse>;
    /**
     * @return OK
     */
    getManufacturerEol(manufacturerBiId: string,  cancelToken?: CancelToken): Promise<GetManufacturerEolProductsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getManufacturerInsightsBatch(body: GetManufacturerInsightsBatchRequest | undefined,  cancelToken?: CancelToken): Promise<GetManufacturerInsightsBatchResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getManufacturerRevenueTrendsBatch(body: GetManufacturerRevenueTrendsBatchRequest | undefined,  cancelToken?: CancelToken): Promise<GetManufacturerRevenueTrendsBatchResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getManufacturerCapabilitiesBatch(body: GetManufacturerCapabilitiesBatchRequest | undefined,  cancelToken?: CancelToken): Promise<GetManufacturerCapabilitiesBatchResponse>;
    /**
     * @return OK
     */
    getEnabledManufacturers( cancelToken?: CancelToken): Promise<GetEnabledManufacturersResponse>;
    /**
     * @return OK
     */
    getAddedManufacturers( cancelToken?: CancelToken): Promise<string[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addManufacturer(body: AddManufacturerRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getEnabledManufacturerNextEvents( cancelToken?: CancelToken): Promise<GetManufacturerNextEventsResponse>;
    /**
     * @return OK
     */
    getManufacturerLifecycleEvents(manufacturerBiId: string,  cancelToken?: CancelToken): Promise<GetManufacturerLifecycleEventsResponse>;
    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerUpcomingSummary(manufacturerBiId: string, clientLocalNow: Date | undefined,  cancelToken?: CancelToken): Promise<GetManufacturerUpcomingSummaryResponse>;
    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerAssetQuantity(manufacturerBiId: string, clientLocalNow: Date | undefined,  cancelToken?: CancelToken): Promise<GetManufacturerAssetQuantityResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    dismissManufacturerInsight(body: DismissManufacturerInsightRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    dismissManufacturerCapability(body: DismissManufacturerCapabilityRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    removeManufacturer(biManufacturerId: string,  cancelToken?: CancelToken): Promise<void>;
}

export class ManufacturerInsightsClient extends AuthorizedApiBase implements IManufacturerInsightsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerSpendTotals(clientLocalNow: Date | undefined, cancelToken?: CancelToken): Promise<GetManufacturerSpendTotalsResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/spend-totals?";
        if (clientLocalNow === null)
            throw new globalThis.Error("The parameter 'clientLocalNow' cannot be null.");
        else if (clientLocalNow !== undefined)
            url_ += "clientLocalNow=" + encodeURIComponent(clientLocalNow ? "" + clientLocalNow.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerSpendTotals(_response);
        });
    }

    protected processGetManufacturerSpendTotals(response: AxiosResponse): Promise<GetManufacturerSpendTotalsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerSpendTotalsResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerSpendTotalsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerSpendTotalsResponse>(null as any);
    }

    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerSpendHistory(clientLocalNow: Date | undefined, cancelToken?: CancelToken): Promise<GetManufacturerSpendHistoryResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/spend-history?";
        if (clientLocalNow === null)
            throw new globalThis.Error("The parameter 'clientLocalNow' cannot be null.");
        else if (clientLocalNow !== undefined)
            url_ += "clientLocalNow=" + encodeURIComponent(clientLocalNow ? "" + clientLocalNow.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerSpendHistory(_response);
        });
    }

    protected processGetManufacturerSpendHistory(response: AxiosResponse): Promise<GetManufacturerSpendHistoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerSpendHistoryResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerSpendHistoryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerSpendHistoryResponse>(null as any);
    }

    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerMonthlySpendHistory(clientLocalNow: Date | undefined, cancelToken?: CancelToken): Promise<GetManufacturerMonthlySpendHistoryResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/spend-history-monthly?";
        if (clientLocalNow === null)
            throw new globalThis.Error("The parameter 'clientLocalNow' cannot be null.");
        else if (clientLocalNow !== undefined)
            url_ += "clientLocalNow=" + encodeURIComponent(clientLocalNow ? "" + clientLocalNow.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerMonthlySpendHistory(_response);
        });
    }

    protected processGetManufacturerMonthlySpendHistory(response: AxiosResponse): Promise<GetManufacturerMonthlySpendHistoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerMonthlySpendHistoryResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerMonthlySpendHistoryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerMonthlySpendHistoryResponse>(null as any);
    }

    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerSpendForecast(clientLocalNow: Date | undefined, cancelToken?: CancelToken): Promise<GetManufacturerSpendForecastResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/spend-forecast?";
        if (clientLocalNow === null)
            throw new globalThis.Error("The parameter 'clientLocalNow' cannot be null.");
        else if (clientLocalNow !== undefined)
            url_ += "clientLocalNow=" + encodeURIComponent(clientLocalNow ? "" + clientLocalNow.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerSpendForecast(_response);
        });
    }

    protected processGetManufacturerSpendForecast(response: AxiosResponse): Promise<GetManufacturerSpendForecastResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerSpendForecastResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerSpendForecastResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerSpendForecastResponse>(null as any);
    }

    /**
     * @return OK
     */
    getManufacturerInsights(manufacturerBiId: string, cancelToken?: CancelToken): Promise<GetManufacturerInsightsResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/{manufacturerBiId}";
        if (manufacturerBiId === undefined || manufacturerBiId === null)
            throw new globalThis.Error("The parameter 'manufacturerBiId' must be defined.");
        url_ = url_.replace("{manufacturerBiId}", encodeURIComponent("" + manufacturerBiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerInsights(_response);
        });
    }

    protected processGetManufacturerInsights(response: AxiosResponse): Promise<GetManufacturerInsightsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerInsightsResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerInsightsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerInsightsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getManufacturerEol(manufacturerBiId: string, cancelToken?: CancelToken): Promise<GetManufacturerEolProductsResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/{manufacturerBiId}/eol";
        if (manufacturerBiId === undefined || manufacturerBiId === null)
            throw new globalThis.Error("The parameter 'manufacturerBiId' must be defined.");
        url_ = url_.replace("{manufacturerBiId}", encodeURIComponent("" + manufacturerBiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerEol(_response);
        });
    }

    protected processGetManufacturerEol(response: AxiosResponse): Promise<GetManufacturerEolProductsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerEolProductsResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerEolProductsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerEolProductsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getManufacturerInsightsBatch(body: GetManufacturerInsightsBatchRequest | undefined, cancelToken?: CancelToken): Promise<GetManufacturerInsightsBatchResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerInsightsBatch(_response);
        });
    }

    protected processGetManufacturerInsightsBatch(response: AxiosResponse): Promise<GetManufacturerInsightsBatchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerInsightsBatchResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerInsightsBatchResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerInsightsBatchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getManufacturerRevenueTrendsBatch(body: GetManufacturerRevenueTrendsBatchRequest | undefined, cancelToken?: CancelToken): Promise<GetManufacturerRevenueTrendsBatchResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/revenue-trends";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerRevenueTrendsBatch(_response);
        });
    }

    protected processGetManufacturerRevenueTrendsBatch(response: AxiosResponse): Promise<GetManufacturerRevenueTrendsBatchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerRevenueTrendsBatchResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerRevenueTrendsBatchResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerRevenueTrendsBatchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getManufacturerCapabilitiesBatch(body: GetManufacturerCapabilitiesBatchRequest | undefined, cancelToken?: CancelToken): Promise<GetManufacturerCapabilitiesBatchResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/capabilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerCapabilitiesBatch(_response);
        });
    }

    protected processGetManufacturerCapabilitiesBatch(response: AxiosResponse): Promise<GetManufacturerCapabilitiesBatchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerCapabilitiesBatchResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerCapabilitiesBatchResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerCapabilitiesBatchResponse>(null as any);
    }

    /**
     * @return OK
     */
    getEnabledManufacturers( cancelToken?: CancelToken): Promise<GetEnabledManufacturersResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/enabled-manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnabledManufacturers(_response);
        });
    }

    protected processGetEnabledManufacturers(response: AxiosResponse): Promise<GetEnabledManufacturersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEnabledManufacturersResponse.fromJS(resultData200);
            return Promise.resolve<GetEnabledManufacturersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEnabledManufacturersResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAddedManufacturers( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/added-manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAddedManufacturers(_response);
        });
    }

    protected processGetAddedManufacturers(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addManufacturer(body: AddManufacturerRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/added-manufacturers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddManufacturer(_response);
        });
    }

    protected processAddManufacturer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getEnabledManufacturerNextEvents( cancelToken?: CancelToken): Promise<GetManufacturerNextEventsResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/enabled-manufacturers/next-events";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnabledManufacturerNextEvents(_response);
        });
    }

    protected processGetEnabledManufacturerNextEvents(response: AxiosResponse): Promise<GetManufacturerNextEventsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerNextEventsResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerNextEventsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerNextEventsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getManufacturerLifecycleEvents(manufacturerBiId: string, cancelToken?: CancelToken): Promise<GetManufacturerLifecycleEventsResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/{manufacturerBiId}/lifecycle-events";
        if (manufacturerBiId === undefined || manufacturerBiId === null)
            throw new globalThis.Error("The parameter 'manufacturerBiId' must be defined.");
        url_ = url_.replace("{manufacturerBiId}", encodeURIComponent("" + manufacturerBiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerLifecycleEvents(_response);
        });
    }

    protected processGetManufacturerLifecycleEvents(response: AxiosResponse): Promise<GetManufacturerLifecycleEventsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerLifecycleEventsResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerLifecycleEventsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerLifecycleEventsResponse>(null as any);
    }

    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerUpcomingSummary(manufacturerBiId: string, clientLocalNow: Date | undefined, cancelToken?: CancelToken): Promise<GetManufacturerUpcomingSummaryResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/{manufacturerBiId}/upcoming-summary?";
        if (manufacturerBiId === undefined || manufacturerBiId === null)
            throw new globalThis.Error("The parameter 'manufacturerBiId' must be defined.");
        url_ = url_.replace("{manufacturerBiId}", encodeURIComponent("" + manufacturerBiId));
        if (clientLocalNow === null)
            throw new globalThis.Error("The parameter 'clientLocalNow' cannot be null.");
        else if (clientLocalNow !== undefined)
            url_ += "clientLocalNow=" + encodeURIComponent(clientLocalNow ? "" + clientLocalNow.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerUpcomingSummary(_response);
        });
    }

    protected processGetManufacturerUpcomingSummary(response: AxiosResponse): Promise<GetManufacturerUpcomingSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerUpcomingSummaryResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerUpcomingSummaryResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerUpcomingSummaryResponse>(null as any);
    }

    /**
     * @param clientLocalNow (optional) 
     * @return OK
     */
    getManufacturerAssetQuantity(manufacturerBiId: string, clientLocalNow: Date | undefined, cancelToken?: CancelToken): Promise<GetManufacturerAssetQuantityResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/{manufacturerBiId}/asset-quantity?";
        if (manufacturerBiId === undefined || manufacturerBiId === null)
            throw new globalThis.Error("The parameter 'manufacturerBiId' must be defined.");
        url_ = url_.replace("{manufacturerBiId}", encodeURIComponent("" + manufacturerBiId));
        if (clientLocalNow === null)
            throw new globalThis.Error("The parameter 'clientLocalNow' cannot be null.");
        else if (clientLocalNow !== undefined)
            url_ += "clientLocalNow=" + encodeURIComponent(clientLocalNow ? "" + clientLocalNow.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerAssetQuantity(_response);
        });
    }

    protected processGetManufacturerAssetQuantity(response: AxiosResponse): Promise<GetManufacturerAssetQuantityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerAssetQuantityResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerAssetQuantityResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerAssetQuantityResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dismissManufacturerInsight(body: DismissManufacturerInsightRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/dismissed-manufacturer-insights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDismissManufacturerInsight(_response);
        });
    }

    protected processDismissManufacturerInsight(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dismissManufacturerCapability(body: DismissManufacturerCapabilityRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/dismissed-manufacturer-capabilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDismissManufacturerCapability(_response);
        });
    }

    protected processDismissManufacturerCapability(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    removeManufacturer(biManufacturerId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ManufacturerInsights/added-manufacturers/{biManufacturerId}";
        if (biManufacturerId === undefined || biManufacturerId === null)
            throw new globalThis.Error("The parameter 'biManufacturerId' must be defined.");
        url_ = url_.replace("{biManufacturerId}", encodeURIComponent("" + biManufacturerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveManufacturer(_response);
        });
    }

    protected processRemoveManufacturer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IManufacturerLogosClient {
    /**
     * @param theme (optional) 
     * @return OK
     */
    getManufacturerLogo(manufacturerBiId: string, theme: string | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
}

export class ManufacturerLogosClient extends AuthorizedApiBase implements IManufacturerLogosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param theme (optional) 
     * @return OK
     */
    getManufacturerLogo(manufacturerBiId: string, theme: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ManufacturerLogos/{manufacturerBiId}?";
        if (manufacturerBiId === undefined || manufacturerBiId === null)
            throw new globalThis.Error("The parameter 'manufacturerBiId' must be defined.");
        url_ = url_.replace("{manufacturerBiId}", encodeURIComponent("" + manufacturerBiId));
        if (theme === null)
            throw new globalThis.Error("The parameter 'theme' cannot be null.");
        else if (theme !== undefined)
            url_ += "theme=" + encodeURIComponent("" + theme) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "image/png"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerLogo(_response);
        });
    }

    protected processGetManufacturerLogo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IMappingClient {
    /**
     * @return OK
     * @deprecated
     */
    getAllContractSLAs( cancelToken?: CancelToken): Promise<ConfigContractSLAsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    createContractsLas(body: ConfigContractSLA | undefined,  cancelToken?: CancelToken): Promise<CreateConfigContractSLAResponse>;
    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    updateContractsLas(body: ConfigContractSLA | undefined,  cancelToken?: CancelToken): Promise<UpdateConfigContractSLAResponse>;
}

export class MappingClient extends AuthorizedApiBase implements IMappingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     * @deprecated
     */
    getAllContractSLAs( cancelToken?: CancelToken): Promise<ConfigContractSLAsResponse> {
        let url_ = this.baseUrl + "/api/Mapping/contractslas/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllContractSLAs(_response);
        });
    }

    protected processGetAllContractSLAs(response: AxiosResponse): Promise<ConfigContractSLAsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigContractSLAsResponse.fromJS(resultData200);
            return Promise.resolve<ConfigContractSLAsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigContractSLAsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    createContractsLas(body: ConfigContractSLA | undefined, cancelToken?: CancelToken): Promise<CreateConfigContractSLAResponse> {
        let url_ = this.baseUrl + "/api/Mapping/contractslas/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContractsLas(_response);
        });
    }

    protected processCreateContractsLas(response: AxiosResponse): Promise<CreateConfigContractSLAResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateConfigContractSLAResponse.fromJS(resultData200);
            return Promise.resolve<CreateConfigContractSLAResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateConfigContractSLAResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    updateContractsLas(body: ConfigContractSLA | undefined, cancelToken?: CancelToken): Promise<UpdateConfigContractSLAResponse> {
        let url_ = this.baseUrl + "/api/Mapping/contractslas/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContractsLas(_response);
        });
    }

    protected processUpdateContractsLas(response: AxiosResponse): Promise<UpdateConfigContractSLAResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateConfigContractSLAResponse.fromJS(resultData200);
            return Promise.resolve<UpdateConfigContractSLAResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateConfigContractSLAResponse>(null as any);
    }
}

export interface IMappingEngineClient {
    /**
     * @param manualHeadersAssignment (optional) 
     * @return OK
     */
    postHeaders(manualHeadersAssignment: string | undefined,  cancelToken?: CancelToken): Promise<MappingRowsResultDto>;
    /**
     * @param schemaType (optional) 
     * @return OK
     */
    getAllSchemasOrByType(schemaType: string | undefined,  cancelToken?: CancelToken): Promise<SchemaDto[]>;
    /**
     * @return OK
     */
    getMappingBySchemaId(schemaId: number,  cancelToken?: CancelToken): Promise<MappingDto>;
    /**
     * @return OK
     */
    getSchemaById(schemaId: number,  cancelToken?: CancelToken): Promise<SchemaDto>;
    /**
     * @param id (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param schemaType (optional) 
     * @param targetSchemaUrl (optional) 
     * @return OK
     */
    createUpdateSchema(id: number | undefined, name: string | undefined, description: string | undefined, schemaType: string | undefined, targetSchemaUrl: string | undefined,  cancelToken?: CancelToken): Promise<SchemaDto>;
    /**
     * @param id (optional) 
     * @param schemaId (optional) 
     * @param version (optional) 
     * @param description (optional) 
     * @param mapping (optional) 
     * @param published (optional) 
     * @param uploadResponse_Guid (optional) 
     * @param uploadResponse_FileType (optional) 
     * @param uploadResponse_ExcelRowsList (optional) 
     * @param uploadResponse_CsvRowsList (optional) 
     * @return OK
     */
    createUpdateMapping(id: number | undefined, schemaId: number | undefined, version: number | undefined, description: string | undefined, mapping: string | undefined, published: boolean | undefined, uploadResponse_Guid: string | undefined, uploadResponse_FileType: MappingFileType | undefined, uploadResponse_ExcelRowsList: ExcelRows[] | undefined, uploadResponse_CsvRowsList: CsvRows[] | undefined,  cancelToken?: CancelToken): Promise<MappingDto>;
    /**
     * @param axNumber (optional) 
     * @param schemaId (optional) 
     * @param schemaType (optional) 
     * @param schemaName (optional) 
     * @return OK
     */
    uploadMappingEngineFile(axNumber: string | undefined, schemaId: string | undefined, schemaType: string | undefined, schemaName: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteMetaData(body: MappingEngineMetadataDto | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class MappingEngineClient extends AuthorizedApiBase implements IMappingEngineClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param manualHeadersAssignment (optional) 
     * @return OK
     */
    postHeaders(manualHeadersAssignment: string | undefined, cancelToken?: CancelToken): Promise<MappingRowsResultDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/headers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (manualHeadersAssignment === null || manualHeadersAssignment === undefined)
            throw new globalThis.Error("The parameter 'manualHeadersAssignment' cannot be null.");
        else
            content_.append("manualHeadersAssignment", manualHeadersAssignment.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostHeaders(_response);
        });
    }

    protected processPostHeaders(response: AxiosResponse): Promise<MappingRowsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MappingRowsResultDto.fromJS(resultData200);
            return Promise.resolve<MappingRowsResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MappingRowsResultDto>(null as any);
    }

    /**
     * @param schemaType (optional) 
     * @return OK
     */
    getAllSchemasOrByType(schemaType: string | undefined, cancelToken?: CancelToken): Promise<SchemaDto[]> {
        let url_ = this.baseUrl + "/api/MappingEngine/schemas?";
        if (schemaType === null)
            throw new globalThis.Error("The parameter 'schemaType' cannot be null.");
        else if (schemaType !== undefined)
            url_ += "schemaType=" + encodeURIComponent("" + schemaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSchemasOrByType(_response);
        });
    }

    protected processGetAllSchemasOrByType(response: AxiosResponse): Promise<SchemaDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SchemaDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SchemaDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchemaDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getMappingBySchemaId(schemaId: number, cancelToken?: CancelToken): Promise<MappingDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/mappingBySchema/{schemaId}";
        if (schemaId === undefined || schemaId === null)
            throw new globalThis.Error("The parameter 'schemaId' must be defined.");
        url_ = url_.replace("{schemaId}", encodeURIComponent("" + schemaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMappingBySchemaId(_response);
        });
    }

    protected processGetMappingBySchemaId(response: AxiosResponse): Promise<MappingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MappingDto.fromJS(resultData200);
            return Promise.resolve<MappingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MappingDto>(null as any);
    }

    /**
     * @return OK
     */
    getSchemaById(schemaId: number, cancelToken?: CancelToken): Promise<SchemaDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/schema/{schemaId}";
        if (schemaId === undefined || schemaId === null)
            throw new globalThis.Error("The parameter 'schemaId' must be defined.");
        url_ = url_.replace("{schemaId}", encodeURIComponent("" + schemaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchemaById(_response);
        });
    }

    protected processGetSchemaById(response: AxiosResponse): Promise<SchemaDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SchemaDto.fromJS(resultData200);
            return Promise.resolve<SchemaDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchemaDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param schemaType (optional) 
     * @param targetSchemaUrl (optional) 
     * @return OK
     */
    createUpdateSchema(id: number | undefined, name: string | undefined, description: string | undefined, schemaType: string | undefined, targetSchemaUrl: string | undefined, cancelToken?: CancelToken): Promise<SchemaDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/createUpdateSchema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description === null || description === undefined)
            throw new globalThis.Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (schemaType === null || schemaType === undefined)
            throw new globalThis.Error("The parameter 'schemaType' cannot be null.");
        else
            content_.append("SchemaType", schemaType.toString());
        if (targetSchemaUrl === null || targetSchemaUrl === undefined)
            throw new globalThis.Error("The parameter 'targetSchemaUrl' cannot be null.");
        else
            content_.append("TargetSchemaUrl", targetSchemaUrl.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUpdateSchema(_response);
        });
    }

    protected processCreateUpdateSchema(response: AxiosResponse): Promise<SchemaDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SchemaDto.fromJS(resultData200);
            return Promise.resolve<SchemaDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchemaDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param schemaId (optional) 
     * @param version (optional) 
     * @param description (optional) 
     * @param mapping (optional) 
     * @param published (optional) 
     * @param uploadResponse_Guid (optional) 
     * @param uploadResponse_FileType (optional) 
     * @param uploadResponse_ExcelRowsList (optional) 
     * @param uploadResponse_CsvRowsList (optional) 
     * @return OK
     */
    createUpdateMapping(id: number | undefined, schemaId: number | undefined, version: number | undefined, description: string | undefined, mapping: string | undefined, published: boolean | undefined, uploadResponse_Guid: string | undefined, uploadResponse_FileType: MappingFileType | undefined, uploadResponse_ExcelRowsList: ExcelRows[] | undefined, uploadResponse_CsvRowsList: CsvRows[] | undefined, cancelToken?: CancelToken): Promise<MappingDto> {
        let url_ = this.baseUrl + "/api/MappingEngine/createUpdateMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (schemaId === null || schemaId === undefined)
            throw new globalThis.Error("The parameter 'schemaId' cannot be null.");
        else
            content_.append("SchemaId", schemaId.toString());
        if (version === null || version === undefined)
            throw new globalThis.Error("The parameter 'version' cannot be null.");
        else
            content_.append("Version", version.toString());
        if (description === null || description === undefined)
            throw new globalThis.Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (mapping === null || mapping === undefined)
            throw new globalThis.Error("The parameter 'mapping' cannot be null.");
        else
            content_.append("Mapping", mapping.toString());
        if (published === null || published === undefined)
            throw new globalThis.Error("The parameter 'published' cannot be null.");
        else
            content_.append("Published", published.toString());
        if (uploadResponse_Guid === null || uploadResponse_Guid === undefined)
            throw new globalThis.Error("The parameter 'uploadResponse_Guid' cannot be null.");
        else
            content_.append("UploadResponse.Guid", uploadResponse_Guid.toString());
        if (uploadResponse_FileType === null || uploadResponse_FileType === undefined)
            throw new globalThis.Error("The parameter 'uploadResponse_FileType' cannot be null.");
        else
            content_.append("UploadResponse.FileType", uploadResponse_FileType.toString());
        if (uploadResponse_ExcelRowsList === null || uploadResponse_ExcelRowsList === undefined)
            throw new globalThis.Error("The parameter 'uploadResponse_ExcelRowsList' cannot be null.");
        else
            uploadResponse_ExcelRowsList.forEach(item_ => content_.append("UploadResponse.ExcelRowsList", item_.toString()));
        if (uploadResponse_CsvRowsList === null || uploadResponse_CsvRowsList === undefined)
            throw new globalThis.Error("The parameter 'uploadResponse_CsvRowsList' cannot be null.");
        else
            uploadResponse_CsvRowsList.forEach(item_ => content_.append("UploadResponse.CsvRowsList", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUpdateMapping(_response);
        });
    }

    protected processCreateUpdateMapping(response: AxiosResponse): Promise<MappingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MappingDto.fromJS(resultData200);
            return Promise.resolve<MappingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MappingDto>(null as any);
    }

    /**
     * @param axNumber (optional) 
     * @param schemaId (optional) 
     * @param schemaType (optional) 
     * @param schemaName (optional) 
     * @return OK
     */
    uploadMappingEngineFile(axNumber: string | undefined, schemaId: string | undefined, schemaType: string | undefined, schemaName: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MappingEngine/validateAndUploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (axNumber === null || axNumber === undefined)
            throw new globalThis.Error("The parameter 'axNumber' cannot be null.");
        else
            content_.append("AxNumber", axNumber.toString());
        if (schemaId === null || schemaId === undefined)
            throw new globalThis.Error("The parameter 'schemaId' cannot be null.");
        else
            content_.append("SchemaId", schemaId.toString());
        if (schemaType === null || schemaType === undefined)
            throw new globalThis.Error("The parameter 'schemaType' cannot be null.");
        else
            content_.append("SchemaType", schemaType.toString());
        if (schemaName === null || schemaName === undefined)
            throw new globalThis.Error("The parameter 'schemaName' cannot be null.");
        else
            content_.append("SchemaName", schemaName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadMappingEngineFile(_response);
        });
    }

    protected processUploadMappingEngineFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteMetaData(body: MappingEngineMetadataDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MappingEngine/removeMetadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMetaData(_response);
        });
    }

    protected processDeleteMetaData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMapsClient {
    /**
     * Renders a static map centered on the supplied coordinates.
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @return OK
     */
    getAddressMap(latitude: number | undefined, longitude: number | undefined, width: number | undefined, height: number | undefined,  cancelToken?: CancelToken): Promise<AddressMapDto>;
    /**
     * Renders a static map of a shipment's origin and destination.
     * @param width (optional) 
     * @param height (optional) 
     * @return OK
     */
    getShipmentMap(biOrderId: number, trackingNumber: string, lastSeenLocation: string, width: number | undefined, height: number | undefined,  cancelToken?: CancelToken): Promise<ShipmentMapDto>;
    /**
     * Resolves a location string to latitude/longitude coordinates.
     * @param location (optional) 
     * @return OK
     */
    geocode(location: string | undefined,  cancelToken?: CancelToken): Promise<GeocodeDto>;
}

export class MapsClient extends AuthorizedApiBase implements IMapsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Renders a static map centered on the supplied coordinates.
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @return OK
     */
    getAddressMap(latitude: number | undefined, longitude: number | undefined, width: number | undefined, height: number | undefined, cancelToken?: CancelToken): Promise<AddressMapDto> {
        let url_ = this.baseUrl + "/api/Maps/address?";
        if (latitude === null)
            throw new globalThis.Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new globalThis.Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (width === null)
            throw new globalThis.Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new globalThis.Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAddressMap(_response);
        });
    }

    protected processGetAddressMap(response: AxiosResponse): Promise<AddressMapDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressMapDto.fromJS(resultData200);
            return Promise.resolve<AddressMapDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressMapDto>(null as any);
    }

    /**
     * Renders a static map of a shipment's origin and destination.
     * @param width (optional) 
     * @param height (optional) 
     * @return OK
     */
    getShipmentMap(biOrderId: number, trackingNumber: string, lastSeenLocation: string, width: number | undefined, height: number | undefined, cancelToken?: CancelToken): Promise<ShipmentMapDto> {
        let url_ = this.baseUrl + "/api/Maps/shipment/{biOrderId}/{trackingNumber}/{lastSeenLocation}?";
        if (biOrderId === undefined || biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' must be defined.");
        url_ = url_.replace("{biOrderId}", encodeURIComponent("" + biOrderId));
        if (trackingNumber === undefined || trackingNumber === null)
            throw new globalThis.Error("The parameter 'trackingNumber' must be defined.");
        url_ = url_.replace("{trackingNumber}", encodeURIComponent("" + trackingNumber));
        if (lastSeenLocation === undefined || lastSeenLocation === null)
            throw new globalThis.Error("The parameter 'lastSeenLocation' must be defined.");
        url_ = url_.replace("{lastSeenLocation}", encodeURIComponent("" + lastSeenLocation));
        if (width === null)
            throw new globalThis.Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new globalThis.Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShipmentMap(_response);
        });
    }

    protected processGetShipmentMap(response: AxiosResponse): Promise<ShipmentMapDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShipmentMapDto.fromJS(resultData200);
            return Promise.resolve<ShipmentMapDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShipmentMapDto>(null as any);
    }

    /**
     * Resolves a location string to latitude/longitude coordinates.
     * @param location (optional) 
     * @return OK
     */
    geocode(location: string | undefined, cancelToken?: CancelToken): Promise<GeocodeDto> {
        let url_ = this.baseUrl + "/api/Maps/geocode?";
        if (location === null)
            throw new globalThis.Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeocode(_response);
        });
    }

    protected processGeocode(response: AxiosResponse): Promise<GeocodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeocodeDto.fromJS(resultData200);
            return Promise.resolve<GeocodeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeocodeDto>(null as any);
    }
}

export interface IMarketplaceMappingClient {
    /**
     * Collects a given customers available tenants and their associated subscriptions from MongoDB.
     * @param unmappedOnly (optional) 
     * @return OK
     */
    getCustomerTenantSubscriptions(unmappedOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<TenantSubscriptions[]>;
    /**
     * Assign an array of subscription IDs to an AX# by creating the appropriate integrations (Azure Compliance + Recs)
     * @param body (optional) 
     * @return OK
     */
    submitSubscriptionMapping(body: SubscriptionMapping | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class MarketplaceMappingClient extends AuthorizedApiBase implements IMarketplaceMappingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Collects a given customers available tenants and their associated subscriptions from MongoDB.
     * @param unmappedOnly (optional) 
     * @return OK
     */
    getCustomerTenantSubscriptions(unmappedOnly: boolean | undefined, cancelToken?: CancelToken): Promise<TenantSubscriptions[]> {
        let url_ = this.baseUrl + "/api/MarketplaceMapping?";
        if (unmappedOnly === null)
            throw new globalThis.Error("The parameter 'unmappedOnly' cannot be null.");
        else if (unmappedOnly !== undefined)
            url_ += "unmappedOnly=" + encodeURIComponent("" + unmappedOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerTenantSubscriptions(_response);
        });
    }

    protected processGetCustomerTenantSubscriptions(response: AxiosResponse): Promise<TenantSubscriptions[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantSubscriptions.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TenantSubscriptions[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantSubscriptions[]>(null as any);
    }

    /**
     * Assign an array of subscription IDs to an AX# by creating the appropriate integrations (Azure Compliance + Recs)
     * @param body (optional) 
     * @return OK
     */
    submitSubscriptionMapping(body: SubscriptionMapping | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MarketplaceMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitSubscriptionMapping(_response);
        });
    }

    protected processSubmitSubscriptionMapping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMicrosoft365IntegrationClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    register(accountId: number, body: Microsoft365ReportsIntegrationDTO | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getTenantIdFromDomain(domain: string,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    validateRegistrationCallback(body: Microsoft365CallbackDetails | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    logRegistrationError(body: RegistrationError | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getAppRegistrationUrl(body: Microsoft365ReportsIntegrationMetadata | undefined,  cancelToken?: CancelToken): Promise<string>;
}

export class Microsoft365IntegrationClient extends AuthorizedApiBase implements IMicrosoft365IntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(accountId: number, body: Microsoft365ReportsIntegrationDTO | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/register/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getTenantIdFromDomain(domain: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/tenant-id-from-domain/{domain}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantIdFromDomain(_response);
        });
    }

    protected processGetTenantIdFromDomain(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateRegistrationCallback(body: Microsoft365CallbackDetails | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/registration-callback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateRegistrationCallback(_response);
        });
    }

    protected processValidateRegistrationCallback(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    logRegistrationError(body: RegistrationError | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/registration-error";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogRegistrationError(_response);
        });
    }

    protected processLogRegistrationError(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAppRegistrationUrl(body: Microsoft365ReportsIntegrationMetadata | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Integration/Microsoft365/get-app-registration-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppRegistrationUrl(_response);
        });
    }

    protected processGetAppRegistrationUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IMicrosoftAdoptionWidgetsClient {
    /**
     * @param dateOption (optional) 
     * @return OK
     */
    getActiveUsersByServiceWidget(dateOption: string | undefined,  cancelToken?: CancelToken): Promise<ActiveUsersByServiceWidgetResponse>;
    /**
     * @param frequency (optional) 
     * @return OK
     */
    getActiveUserTrendsWidget(frequency: string | undefined,  cancelToken?: CancelToken): Promise<ActiveUserTrendsWidgetResponse>;
    /**
     * @param service (optional) 
     * @return OK
     */
    getFeatureAdoptionWidget(service: string | undefined,  cancelToken?: CancelToken): Promise<FeatureAdoptionWidgetResponse>;
    /**
     * @return OK
     */
    getLicenseUtilizationWidget( cancelToken?: CancelToken): Promise<LicenseUtilizationWidgetResponse>;
    /**
     * @param service (optional) 
     * @return OK
     */
    getProductivityWidget(service: string | undefined,  cancelToken?: CancelToken): Promise<ProductivityWidgetResponse>;
    /**
     * @return OK
     */
    getUserEngagementWidget( cancelToken?: CancelToken): Promise<ActiveUsersByServiceWidgetResponse>;
    /**
     * @param type (optional) 
     * @return OK
     */
    getLicenseBreakdownWidget(type: string | undefined,  cancelToken?: CancelToken): Promise<ActiveUsersByServiceWidgetResponse>;
}

export class MicrosoftAdoptionWidgetsClient extends AuthorizedApiBase implements IMicrosoftAdoptionWidgetsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateOption (optional) 
     * @return OK
     */
    getActiveUsersByServiceWidget(dateOption: string | undefined, cancelToken?: CancelToken): Promise<ActiveUsersByServiceWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/active-users-by-service-widget?";
        if (dateOption === null)
            throw new globalThis.Error("The parameter 'dateOption' cannot be null.");
        else if (dateOption !== undefined)
            url_ += "dateOption=" + encodeURIComponent("" + dateOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveUsersByServiceWidget(_response);
        });
    }

    protected processGetActiveUsersByServiceWidget(response: AxiosResponse): Promise<ActiveUsersByServiceWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveUsersByServiceWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ActiveUsersByServiceWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveUsersByServiceWidgetResponse>(null as any);
    }

    /**
     * @param frequency (optional) 
     * @return OK
     */
    getActiveUserTrendsWidget(frequency: string | undefined, cancelToken?: CancelToken): Promise<ActiveUserTrendsWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/active-user-trends-widget?";
        if (frequency === null)
            throw new globalThis.Error("The parameter 'frequency' cannot be null.");
        else if (frequency !== undefined)
            url_ += "frequency=" + encodeURIComponent("" + frequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveUserTrendsWidget(_response);
        });
    }

    protected processGetActiveUserTrendsWidget(response: AxiosResponse): Promise<ActiveUserTrendsWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveUserTrendsWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ActiveUserTrendsWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveUserTrendsWidgetResponse>(null as any);
    }

    /**
     * @param service (optional) 
     * @return OK
     */
    getFeatureAdoptionWidget(service: string | undefined, cancelToken?: CancelToken): Promise<FeatureAdoptionWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/feature-adoption-widget?";
        if (service === null)
            throw new globalThis.Error("The parameter 'service' cannot be null.");
        else if (service !== undefined)
            url_ += "service=" + encodeURIComponent("" + service) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeatureAdoptionWidget(_response);
        });
    }

    protected processGetFeatureAdoptionWidget(response: AxiosResponse): Promise<FeatureAdoptionWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeatureAdoptionWidgetResponse.fromJS(resultData200);
            return Promise.resolve<FeatureAdoptionWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureAdoptionWidgetResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLicenseUtilizationWidget( cancelToken?: CancelToken): Promise<LicenseUtilizationWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/license-utilization-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseUtilizationWidget(_response);
        });
    }

    protected processGetLicenseUtilizationWidget(response: AxiosResponse): Promise<LicenseUtilizationWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LicenseUtilizationWidgetResponse.fromJS(resultData200);
            return Promise.resolve<LicenseUtilizationWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseUtilizationWidgetResponse>(null as any);
    }

    /**
     * @param service (optional) 
     * @return OK
     */
    getProductivityWidget(service: string | undefined, cancelToken?: CancelToken): Promise<ProductivityWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/productivity-widget?";
        if (service === null)
            throw new globalThis.Error("The parameter 'service' cannot be null.");
        else if (service !== undefined)
            url_ += "service=" + encodeURIComponent("" + service) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductivityWidget(_response);
        });
    }

    protected processGetProductivityWidget(response: AxiosResponse): Promise<ProductivityWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductivityWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ProductivityWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductivityWidgetResponse>(null as any);
    }

    /**
     * @return OK
     */
    getUserEngagementWidget( cancelToken?: CancelToken): Promise<ActiveUsersByServiceWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/user-engagement-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserEngagementWidget(_response);
        });
    }

    protected processGetUserEngagementWidget(response: AxiosResponse): Promise<ActiveUsersByServiceWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveUsersByServiceWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ActiveUsersByServiceWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveUsersByServiceWidgetResponse>(null as any);
    }

    /**
     * @param type (optional) 
     * @return OK
     */
    getLicenseBreakdownWidget(type: string | undefined, cancelToken?: CancelToken): Promise<ActiveUsersByServiceWidgetResponse> {
        let url_ = this.baseUrl + "/api/widgets/microsoft-adoption/license-breakdown-widget?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseBreakdownWidget(_response);
        });
    }

    protected processGetLicenseBreakdownWidget(response: AxiosResponse): Promise<ActiveUsersByServiceWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveUsersByServiceWidgetResponse.fromJS(resultData200);
            return Promise.resolve<ActiveUsersByServiceWidgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveUsersByServiceWidgetResponse>(null as any);
    }
}

export interface IMicrosoftInsightsClient {
    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getMicrosoftInsightsReport(tenantId: string | undefined,  cancelToken?: CancelToken): Promise<MicrosoftInsightsReportResponse>;
}

export class MicrosoftInsightsClient extends AuthorizedApiBase implements IMicrosoftInsightsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    getMicrosoftInsightsReport(tenantId: string | undefined, cancelToken?: CancelToken): Promise<MicrosoftInsightsReportResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/microsoft-insights?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicrosoftInsightsReport(_response);
        });
    }

    protected processGetMicrosoftInsightsReport(response: AxiosResponse): Promise<MicrosoftInsightsReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicrosoftInsightsReportResponse.fromJS(resultData200);
            return Promise.resolve<MicrosoftInsightsReportResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicrosoftInsightsReportResponse>(null as any);
    }
}

export interface INewsCenterClient {
    /**
     * @param articleId (optional) 
     * @return OK
     */
    getNewsCenterDetail(articleId: number | undefined,  cancelToken?: CancelToken): Promise<ArticleDetailDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getNewsCenter(body: NewsCenterQuery | undefined,  cancelToken?: CancelToken): Promise<NewsCenterArticlesResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getMessageCenter(body: MessageCenterQuery | undefined,  cancelToken?: CancelToken): Promise<MessageCenterArticlesResponse>;
    /**
     * @return OK
     */
    getMessageCenterIncludeExcludePicklist( cancelToken?: CancelToken): Promise<MessageCenterPicklistsResponse>;
}

export class NewsCenterClient extends AuthorizedApiBase implements INewsCenterClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param articleId (optional) 
     * @return OK
     */
    getNewsCenterDetail(articleId: number | undefined, cancelToken?: CancelToken): Promise<ArticleDetailDto> {
        let url_ = this.baseUrl + "/api/NewsCenter/newscenter/detail?";
        if (articleId === null)
            throw new globalThis.Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsCenterDetail(_response);
        });
    }

    protected processGetNewsCenterDetail(response: AxiosResponse): Promise<ArticleDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleDetailDto.fromJS(resultData200);
            return Promise.resolve<ArticleDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getNewsCenter(body: NewsCenterQuery | undefined, cancelToken?: CancelToken): Promise<NewsCenterArticlesResponse> {
        let url_ = this.baseUrl + "/api/NewsCenter/newscenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsCenter(_response);
        });
    }

    protected processGetNewsCenter(response: AxiosResponse): Promise<NewsCenterArticlesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsCenterArticlesResponse.fromJS(resultData200);
            return Promise.resolve<NewsCenterArticlesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsCenterArticlesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMessageCenter(body: MessageCenterQuery | undefined, cancelToken?: CancelToken): Promise<MessageCenterArticlesResponse> {
        let url_ = this.baseUrl + "/api/NewsCenter/message-center";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessageCenter(_response);
        });
    }

    protected processGetMessageCenter(response: AxiosResponse): Promise<MessageCenterArticlesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageCenterArticlesResponse.fromJS(resultData200);
            return Promise.resolve<MessageCenterArticlesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageCenterArticlesResponse>(null as any);
    }

    /**
     * @return OK
     */
    getMessageCenterIncludeExcludePicklist( cancelToken?: CancelToken): Promise<MessageCenterPicklistsResponse> {
        let url_ = this.baseUrl + "/api/NewsCenter/message-center-include-exclude-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessageCenterIncludeExcludePicklist(_response);
        });
    }

    protected processGetMessageCenterIncludeExcludePicklist(response: AxiosResponse): Promise<MessageCenterPicklistsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageCenterPicklistsResponse.fromJS(resultData200);
            return Promise.resolve<MessageCenterPicklistsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageCenterPicklistsResponse>(null as any);
    }
}

export interface IOnboardingClient {
    /**
     * @return OK
     */
    getWelcomeInformation(guid: string,  cancelToken?: CancelToken): Promise<AccountWelcomeLinkDto>;
    /**
     * @return OK
     */
    getOnboardingStatus(guid: string,  cancelToken?: CancelToken): Promise<OnboardingStatus2>;
    /**
     * @param body (optional) 
     * @return OK
     */
    generateEmailCode(body: EmailVerificationRequest | undefined,  cancelToken?: CancelToken): Promise<ValidateEmailStatus>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateWelcomeOptions(body: AccountWelcomeLinkDto | undefined,  cancelToken?: CancelToken): Promise<AccountWelcomeLinkDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    verifyEmailCode(body: EmailVerificationRequest | undefined,  cancelToken?: CancelToken): Promise<ValidateEmailStatus>;
    /**
     * @param body (optional) 
     * @return OK
     */
    submitOnboardingAdmins(body: OnboardingStatus2 | undefined,  cancelToken?: CancelToken): Promise<OnboardingStatus2>;
}

export class OnboardingClient extends AuthorizedApiBase implements IOnboardingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getWelcomeInformation(guid: string, cancelToken?: CancelToken): Promise<AccountWelcomeLinkDto> {
        let url_ = this.baseUrl + "/api/onboarding/welcome/{guid}";
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWelcomeInformation(_response);
        });
    }

    protected processGetWelcomeInformation(response: AxiosResponse): Promise<AccountWelcomeLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountWelcomeLinkDto.fromJS(resultData200);
            return Promise.resolve<AccountWelcomeLinkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountWelcomeLinkDto>(null as any);
    }

    /**
     * @return OK
     */
    getOnboardingStatus(guid: string, cancelToken?: CancelToken): Promise<OnboardingStatus2> {
        let url_ = this.baseUrl + "/api/onboarding/status/{guid}";
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOnboardingStatus(_response);
        });
    }

    protected processGetOnboardingStatus(response: AxiosResponse): Promise<OnboardingStatus2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OnboardingStatus2.fromJS(resultData200);
            return Promise.resolve<OnboardingStatus2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnboardingStatus2>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateEmailCode(body: EmailVerificationRequest | undefined, cancelToken?: CancelToken): Promise<ValidateEmailStatus> {
        let url_ = this.baseUrl + "/api/onboarding/generateCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateEmailCode(_response);
        });
    }

    protected processGenerateEmailCode(response: AxiosResponse): Promise<ValidateEmailStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateEmailStatus.fromJS(resultData200);
            return Promise.resolve<ValidateEmailStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateEmailStatus>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateWelcomeOptions(body: AccountWelcomeLinkDto | undefined, cancelToken?: CancelToken): Promise<AccountWelcomeLinkDto> {
        let url_ = this.baseUrl + "/api/onboarding/updateWelcomeOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWelcomeOptions(_response);
        });
    }

    protected processUpdateWelcomeOptions(response: AxiosResponse): Promise<AccountWelcomeLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountWelcomeLinkDto.fromJS(resultData200);
            return Promise.resolve<AccountWelcomeLinkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountWelcomeLinkDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifyEmailCode(body: EmailVerificationRequest | undefined, cancelToken?: CancelToken): Promise<ValidateEmailStatus> {
        let url_ = this.baseUrl + "/api/onboarding/verifyCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyEmailCode(_response);
        });
    }

    protected processVerifyEmailCode(response: AxiosResponse): Promise<ValidateEmailStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateEmailStatus.fromJS(resultData200);
            return Promise.resolve<ValidateEmailStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateEmailStatus>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitOnboardingAdmins(body: OnboardingStatus2 | undefined, cancelToken?: CancelToken): Promise<OnboardingStatus2> {
        let url_ = this.baseUrl + "/api/onboarding/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitOnboardingAdmins(_response);
        });
    }

    protected processSubmitOnboardingAdmins(response: AxiosResponse): Promise<OnboardingStatus2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OnboardingStatus2.fromJS(resultData200);
            return Promise.resolve<OnboardingStatus2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnboardingStatus2>(null as any);
    }
}

export interface IOrderAdditionalDetailsClient {
    /**
     * @return OK
     */
    getByBiOrderId(biOrderId: number,  cancelToken?: CancelToken): Promise<OrderRelatedDataDto[]>;
    /**
     * @return OK
     */
    getOrderLineRelatedDataByBiOrderId(biOrderId: number,  cancelToken?: CancelToken): Promise<OrderLineRelatedDataDto[]>;
    /**
     * @return OK
     */
    getOrderLineSerialsByBiOrderId(biOrderId: number,  cancelToken?: CancelToken): Promise<OrderLineSerialDto[]>;
}

export class OrderAdditionalDetailsClient extends AuthorizedApiBase implements IOrderAdditionalDetailsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getByBiOrderId(biOrderId: number, cancelToken?: CancelToken): Promise<OrderRelatedDataDto[]> {
        let url_ = this.baseUrl + "/api/OrderAdditionalDetails/bi/{biOrderId}";
        if (biOrderId === undefined || biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' must be defined.");
        url_ = url_.replace("{biOrderId}", encodeURIComponent("" + biOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByBiOrderId(_response);
        });
    }

    protected processGetByBiOrderId(response: AxiosResponse): Promise<OrderRelatedDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderRelatedDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderRelatedDataDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRelatedDataDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getOrderLineRelatedDataByBiOrderId(biOrderId: number, cancelToken?: CancelToken): Promise<OrderLineRelatedDataDto[]> {
        let url_ = this.baseUrl + "/api/OrderAdditionalDetails/bi/{biOrderId}/lines/related-data";
        if (biOrderId === undefined || biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' must be defined.");
        url_ = url_.replace("{biOrderId}", encodeURIComponent("" + biOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderLineRelatedDataByBiOrderId(_response);
        });
    }

    protected processGetOrderLineRelatedDataByBiOrderId(response: AxiosResponse): Promise<OrderLineRelatedDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderLineRelatedDataDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderLineRelatedDataDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderLineRelatedDataDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getOrderLineSerialsByBiOrderId(biOrderId: number, cancelToken?: CancelToken): Promise<OrderLineSerialDto[]> {
        let url_ = this.baseUrl + "/api/OrderAdditionalDetails/bi/{biOrderId}/lines/serials";
        if (biOrderId === undefined || biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' must be defined.");
        url_ = url_.replace("{biOrderId}", encodeURIComponent("" + biOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderLineSerialsByBiOrderId(_response);
        });
    }

    protected processGetOrderLineSerialsByBiOrderId(response: AxiosResponse): Promise<OrderLineSerialDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderLineSerialDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderLineSerialDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderLineSerialDto[]>(null as any);
    }
}

export interface IOrderApprovalHistoryClient {
    /**
     * @return OK
     */
    getByWebOrderId(webOrderId: number,  cancelToken?: CancelToken): Promise<OrderApprovalHistoryDto>;
}

export class OrderApprovalHistoryClient extends AuthorizedApiBase implements IOrderApprovalHistoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getByWebOrderId(webOrderId: number, cancelToken?: CancelToken): Promise<OrderApprovalHistoryDto> {
        let url_ = this.baseUrl + "/api/OrderApprovalHistory/web/{webOrderId}";
        if (webOrderId === undefined || webOrderId === null)
            throw new globalThis.Error("The parameter 'webOrderId' must be defined.");
        url_ = url_.replace("{webOrderId}", encodeURIComponent("" + webOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByWebOrderId(_response);
        });
    }

    protected processGetByWebOrderId(response: AxiosResponse): Promise<OrderApprovalHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderApprovalHistoryDto.fromJS(resultData200);
            return Promise.resolve<OrderApprovalHistoryDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderApprovalHistoryDto>(null as any);
    }
}

export interface IOrderApprovalsClient {
    /**
     * @param take (optional) 
     * @return OK
     */
    getPendingOrderApprovals(take: number | undefined,  cancelToken?: CancelToken): Promise<GetPendingOrderApprovalsResponse>;
    /**
     * @return OK
     */
    getAllPendingApprovalOrders( cancelToken?: CancelToken): Promise<OrderSummaryDto[]>;
    /**
     * @return OK
     */
    getApprovalCounts( cancelToken?: CancelToken): Promise<OrderApprovalCountDto>;
    /**
     * @return OK
     */
    getWebOrderApprovalDetail(webOrderId: number,  cancelToken?: CancelToken): Promise<WebOrderApprovalDetailDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    submitOrderApprovalDecision(webOrderId: number, body: SubmitOrderApprovalDecisionRequest | undefined,  cancelToken?: CancelToken): Promise<SubmitOrderApprovalDecisionResponse>;
}

export class OrderApprovalsClient extends AuthorizedApiBase implements IOrderApprovalsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param take (optional) 
     * @return OK
     */
    getPendingOrderApprovals(take: number | undefined, cancelToken?: CancelToken): Promise<GetPendingOrderApprovalsResponse> {
        let url_ = this.baseUrl + "/api/OrderApprovals/pendingOrderApprovals?";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPendingOrderApprovals(_response);
        });
    }

    protected processGetPendingOrderApprovals(response: AxiosResponse): Promise<GetPendingOrderApprovalsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPendingOrderApprovalsResponse.fromJS(resultData200);
            return Promise.resolve<GetPendingOrderApprovalsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPendingOrderApprovalsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAllPendingApprovalOrders( cancelToken?: CancelToken): Promise<OrderSummaryDto[]> {
        let url_ = this.baseUrl + "/api/OrderApprovals/orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPendingApprovalOrders(_response);
        });
    }

    protected processGetAllPendingApprovalOrders(response: AxiosResponse): Promise<OrderSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderSummaryDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderSummaryDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getApprovalCounts( cancelToken?: CancelToken): Promise<OrderApprovalCountDto> {
        let url_ = this.baseUrl + "/api/OrderApprovals/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovalCounts(_response);
        });
    }

    protected processGetApprovalCounts(response: AxiosResponse): Promise<OrderApprovalCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderApprovalCountDto.fromJS(resultData200);
            return Promise.resolve<OrderApprovalCountDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderApprovalCountDto>(null as any);
    }

    /**
     * @return OK
     */
    getWebOrderApprovalDetail(webOrderId: number, cancelToken?: CancelToken): Promise<WebOrderApprovalDetailDto> {
        let url_ = this.baseUrl + "/api/OrderApprovals/web/{webOrderId}";
        if (webOrderId === undefined || webOrderId === null)
            throw new globalThis.Error("The parameter 'webOrderId' must be defined.");
        url_ = url_.replace("{webOrderId}", encodeURIComponent("" + webOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWebOrderApprovalDetail(_response);
        });
    }

    protected processGetWebOrderApprovalDetail(response: AxiosResponse): Promise<WebOrderApprovalDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WebOrderApprovalDetailDto.fromJS(resultData200);
            return Promise.resolve<WebOrderApprovalDetailDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebOrderApprovalDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitOrderApprovalDecision(webOrderId: number, body: SubmitOrderApprovalDecisionRequest | undefined, cancelToken?: CancelToken): Promise<SubmitOrderApprovalDecisionResponse> {
        let url_ = this.baseUrl + "/api/OrderApprovals/web/{webOrderId}/decision";
        if (webOrderId === undefined || webOrderId === null)
            throw new globalThis.Error("The parameter 'webOrderId' must be defined.");
        url_ = url_.replace("{webOrderId}", encodeURIComponent("" + webOrderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitOrderApprovalDecision(_response);
        });
    }

    protected processSubmitOrderApprovalDecision(response: AxiosResponse): Promise<SubmitOrderApprovalDecisionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitOrderApprovalDecisionResponse.fromJS(resultData200);
            return Promise.resolve<SubmitOrderApprovalDecisionResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitOrderApprovalDecisionResponse>(null as any);
    }
}

export interface IOrderCheckoutQuestionsClient {
    /**
     * Gets checkout questions for a web order.
     * @return OK
     */
    getByWebOrderIdAll(webOrderId: number,  cancelToken?: CancelToken): Promise<OrderCheckoutQuestionDto[]>;
}

export class OrderCheckoutQuestionsClient extends AuthorizedApiBase implements IOrderCheckoutQuestionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets checkout questions for a web order.
     * @return OK
     */
    getByWebOrderIdAll(webOrderId: number, cancelToken?: CancelToken): Promise<OrderCheckoutQuestionDto[]> {
        let url_ = this.baseUrl + "/api/OrderCheckoutQuestions/web/{webOrderId}";
        if (webOrderId === undefined || webOrderId === null)
            throw new globalThis.Error("The parameter 'webOrderId' must be defined.");
        url_ = url_.replace("{webOrderId}", encodeURIComponent("" + webOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByWebOrderIdAll(_response);
        });
    }

    protected processGetByWebOrderIdAll(response: AxiosResponse): Promise<OrderCheckoutQuestionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderCheckoutQuestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderCheckoutQuestionDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderCheckoutQuestionDto[]>(null as any);
    }
}

export interface IOrderInvoicesClient {
    /**
     * @return OK
     */
    getInvoicesByOrderIdentifiers(oid: number, on: string, po: string,  cancelToken?: CancelToken): Promise<OrderInvoiceDto[]>;
    /**
     * Searches invoices using the supplied filters.
     * @param body (optional) The invoice search filters and paging options.
     * @return OK
     */
    searchInvoices(body: SearchInvoicesRequest | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfInvoiceSummaryDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getFilterValues(body: SearchInvoicesFilterValuesRequest | undefined,  cancelToken?: CancelToken): Promise<string[]>;
}

export class OrderInvoicesClient extends AuthorizedApiBase implements IOrderInvoicesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getInvoicesByOrderIdentifiers(oid: number, on: string, po: string, cancelToken?: CancelToken): Promise<OrderInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/OrderInvoices?";
        if (oid === undefined || oid === null)
            throw new globalThis.Error("The parameter 'oid' must be defined and cannot be null.");
        else
            url_ += "oid=" + encodeURIComponent("" + oid) + "&";
        if (on === undefined || on === null)
            throw new globalThis.Error("The parameter 'on' must be defined and cannot be null.");
        else
            url_ += "on=" + encodeURIComponent("" + on) + "&";
        if (po === undefined || po === null)
            throw new globalThis.Error("The parameter 'po' must be defined and cannot be null.");
        else
            url_ += "po=" + encodeURIComponent("" + po) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicesByOrderIdentifiers(_response);
        });
    }

    protected processGetInvoicesByOrderIdentifiers(response: AxiosResponse): Promise<OrderInvoiceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderInvoiceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderInvoiceDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderInvoiceDto[]>(null as any);
    }

    /**
     * Searches invoices using the supplied filters.
     * @param body (optional) The invoice search filters and paging options.
     * @return OK
     */
    searchInvoices(body: SearchInvoicesRequest | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfInvoiceSummaryDto> {
        let url_ = this.baseUrl + "/api/OrderInvoices/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoices(_response);
        });
    }

    protected processSearchInvoices(response: AxiosResponse): Promise<PaginatedResultDto_1OfInvoiceSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfInvoiceSummaryDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfInvoiceSummaryDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfInvoiceSummaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFilterValues(body: SearchInvoicesFilterValuesRequest | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/OrderInvoices/search/filter-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilterValues(_response);
        });
    }

    protected processGetFilterValues(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface IOrderPaymentClient {
    /**
     * @return OK
     */
    getPaymentByBiOrderId(biOrderId: number,  cancelToken?: CancelToken): Promise<OrderPaymentDto>;
    /**
     * @return OK
     */
    getPaymentByWebOrderId(webOrderId: number,  cancelToken?: CancelToken): Promise<OrderPaymentDto>;
}

export class OrderPaymentClient extends AuthorizedApiBase implements IOrderPaymentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getPaymentByBiOrderId(biOrderId: number, cancelToken?: CancelToken): Promise<OrderPaymentDto> {
        let url_ = this.baseUrl + "/api/OrderPayment/bi/{biOrderId}";
        if (biOrderId === undefined || biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' must be defined.");
        url_ = url_.replace("{biOrderId}", encodeURIComponent("" + biOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentByBiOrderId(_response);
        });
    }

    protected processGetPaymentByBiOrderId(response: AxiosResponse): Promise<OrderPaymentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderPaymentDto.fromJS(resultData200);
            return Promise.resolve<OrderPaymentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderPaymentDto>(null as any);
    }

    /**
     * @return OK
     */
    getPaymentByWebOrderId(webOrderId: number, cancelToken?: CancelToken): Promise<OrderPaymentDto> {
        let url_ = this.baseUrl + "/api/OrderPayment/web/{webOrderId}";
        if (webOrderId === undefined || webOrderId === null)
            throw new globalThis.Error("The parameter 'webOrderId' must be defined.");
        url_ = url_.replace("{webOrderId}", encodeURIComponent("" + webOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentByWebOrderId(_response);
        });
    }

    protected processGetPaymentByWebOrderId(response: AxiosResponse): Promise<OrderPaymentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderPaymentDto.fromJS(resultData200);
            return Promise.resolve<OrderPaymentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderPaymentDto>(null as any);
    }
}

export interface IOrderRmaClient {
    /**
     * Returns the RMA form facts for one order. 404 covers both a missing order and an order outside the caller's
    accounts.
     * @return OK
     */
    getOrderRmaDetail(biOrderId: number,  cancelToken?: CancelToken): Promise<OrderRmaDetailDto>;
    /**
     * Stages one RMA request. A 200 response means the request is committed; check
    `confirmationEmailStatus` for the email outcome. The returned reference is not an RMA number.
     * @return OK
     */
    submitOrderRma(biOrderId: number, body: SubmitOrderRmaRequest,  cancelToken?: CancelToken): Promise<OrderRmaSubmissionDto>;
    /**
     * Uploads one RMA attachment for an order the caller owns and returns an opaque reference to send with the
    submission. The file is validated for type, size, and content before it is stored.
     * @param file (optional) 
     * @return OK
     */
    uploadOrderRmaAttachment(biOrderId: number, file: FileParameter | undefined,  cancelToken?: CancelToken): Promise<OrderRmaAttachmentUploadDto>;
    /**
     * Removes an attachment the caller uploaded for this order and has not submitted yet.
     * @return No Content
     */
    deleteOrderRmaAttachment(biOrderId: number, attachmentId: string,  cancelToken?: CancelToken): Promise<void>;
}

export class OrderRmaClient extends AuthorizedApiBase implements IOrderRmaClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the RMA form facts for one order. 404 covers both a missing order and an order outside the caller's
    accounts.
     * @return OK
     */
    getOrderRmaDetail(biOrderId: number, cancelToken?: CancelToken): Promise<OrderRmaDetailDto> {
        let url_ = this.baseUrl + "/api/OrderRma/{biOrderId}";
        if (biOrderId === undefined || biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' must be defined.");
        url_ = url_.replace("{biOrderId}", encodeURIComponent("" + biOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderRmaDetail(_response);
        });
    }

    protected processGetOrderRmaDetail(response: AxiosResponse): Promise<OrderRmaDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRmaDetailDto.fromJS(resultData200);
            return Promise.resolve<OrderRmaDetailDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRmaDetailDto>(null as any);
    }

    /**
     * Stages one RMA request. A 200 response means the request is committed; check
    `confirmationEmailStatus` for the email outcome. The returned reference is not an RMA number.
     * @return OK
     */
    submitOrderRma(biOrderId: number, body: SubmitOrderRmaRequest, cancelToken?: CancelToken): Promise<OrderRmaSubmissionDto> {
        let url_ = this.baseUrl + "/api/OrderRma/{biOrderId}/submissions";
        if (biOrderId === undefined || biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' must be defined.");
        url_ = url_.replace("{biOrderId}", encodeURIComponent("" + biOrderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitOrderRma(_response);
        });
    }

    protected processSubmitOrderRma(response: AxiosResponse): Promise<OrderRmaSubmissionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRmaSubmissionDto.fromJS(resultData200);
            return Promise.resolve<OrderRmaSubmissionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRmaSubmissionDto>(null as any);
    }

    /**
     * Uploads one RMA attachment for an order the caller owns and returns an opaque reference to send with the
    submission. The file is validated for type, size, and content before it is stored.
     * @param file (optional) 
     * @return OK
     */
    uploadOrderRmaAttachment(biOrderId: number, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<OrderRmaAttachmentUploadDto> {
        let url_ = this.baseUrl + "/api/OrderRma/{biOrderId}/attachments";
        if (biOrderId === undefined || biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' must be defined.");
        url_ = url_.replace("{biOrderId}", encodeURIComponent("" + biOrderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadOrderRmaAttachment(_response);
        });
    }

    protected processUploadOrderRmaAttachment(response: AxiosResponse): Promise<OrderRmaAttachmentUploadDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRmaAttachmentUploadDto.fromJS(resultData200);
            return Promise.resolve<OrderRmaAttachmentUploadDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 413) {
            const _responseText = response.data;
            let result413: any = null;
            let resultData413  = _responseText;
            result413 = ProblemDetails.fromJS(resultData413);
            return throwException("Content Too Large", status, _responseText, _headers, result413);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRmaAttachmentUploadDto>(null as any);
    }

    /**
     * Removes an attachment the caller uploaded for this order and has not submitted yet.
     * @return No Content
     */
    deleteOrderRmaAttachment(biOrderId: number, attachmentId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderRma/{biOrderId}/attachments/{attachmentId}";
        if (biOrderId === undefined || biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' must be defined.");
        url_ = url_.replace("{biOrderId}", encodeURIComponent("" + biOrderId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrderRmaAttachment(_response);
        });
    }

    protected processDeleteOrderRmaAttachment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Service Unavailable", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOrdersClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    searchOrders(body: SearchOrdersRequest | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfOrderSummaryDto>;
    /**
     * Resolves a single order by its sales order (AX order) number, scoped to the caller's
    accounts. Authorized by the assets read permission rather than the order-search view
    permissions so that orders backing account-wide Purchased Assets (which may have been
    placed by another user on the account) can be opened in the order details drawer without
    widening order-search visibility.
     * @return OK
     */
    getOrderBySalesOrderNumber(salesOrderNumber: string,  cancelToken?: CancelToken): Promise<OrderSummaryDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getFilterValues(body: OrdersFilterRequest | undefined,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getReturnOrderEligibilityBatch(body: GetOrderReturnEligibilityBatchRequest | undefined,  cancelToken?: CancelToken): Promise<OrderReturnEligibilityItemDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getRecentOrders(orgUnitId: number, body: RecentOrdersRequest | undefined,  cancelToken?: CancelToken): Promise<RecentOrderDto[]>;
    /**
     * Retrieves product detail drawer data for a line item within an order context.
    Requires order search permissions instead of standard management permissions.
     * @param body (optional) 
     * @return OK
     */
    getOrderProductDetailDrawer(body: ProductDetailDrawerRequestDto | undefined,  cancelToken?: CancelToken): Promise<ProductDetailDrawerDto>;
    /**
     * Retrieves product detail drawer CNET Images or thumbnail (800 x 600) for a line item within an order context.
    Requires order search permissions instead of standard management permissions.
     * @param body (optional) 
     * @return OK
     */
    getOrderProductDetailDrawerImages(body: ProductDetailDrawerRequestDto | undefined,  cancelToken?: CancelToken): Promise<ProductImageDto[]>;
    /**
     * @param biOrderId (optional) 
     * @param webOrderId (optional) 
     * @param orgUnitId (optional) 
     * @return OK
     */
    getShippingDetails(biOrderId: number | undefined, webOrderId: number | undefined, orgUnitId: number | undefined,  cancelToken?: CancelToken): Promise<ShippingDetailsDto>;
    /**
     * @param biOrderId (optional) 
     * @param webOrderId (optional) 
     * @param orgUnitId (optional) 
     * @return OK
     */
    getBillTo(biOrderId: number | undefined, webOrderId: number | undefined, orgUnitId: number | undefined,  cancelToken?: CancelToken): Promise<OrderAddressDto>;
    /**
     * @param biOrderId (optional) 
     * @param trackingNumber (optional) 
     * @return OK
     */
    getShipmentTracking(biOrderId: number | undefined, trackingNumber: string | undefined,  cancelToken?: CancelToken): Promise<ShipmentTrackingDto>;
    /**
     * Submits the caller's shopping cart as a Commerce web order. The ordering employee and org unit
    are resolved from the signed-in user's context; currency, back office entity, and language are
    resolved server-side. The client supplies a generated idempotency key, the shipping address, and
    the cart lines. Returns the created web order id for the checkout success page.
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    submitWebOrderCheckout(body: WebOrderCheckoutRequest | undefined,  cancelToken?: CancelToken): Promise<WebOrderCheckoutResult>;
    /**
     * @return OK
     */
    getCheckoutQuestions( cancelToken?: CancelToken): Promise<CheckoutQuestionDto[]>;
}

export class OrdersClient extends AuthorizedApiBase implements IOrdersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchOrders(body: SearchOrdersRequest | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfOrderSummaryDto> {
        let url_ = this.baseUrl + "/api/Orders/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchOrders(_response);
        });
    }

    protected processSearchOrders(response: AxiosResponse): Promise<PaginatedResultDto_1OfOrderSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfOrderSummaryDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfOrderSummaryDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfOrderSummaryDto>(null as any);
    }

    /**
     * Resolves a single order by its sales order (AX order) number, scoped to the caller's
    accounts. Authorized by the assets read permission rather than the order-search view
    permissions so that orders backing account-wide Purchased Assets (which may have been
    placed by another user on the account) can be opened in the order details drawer without
    widening order-search visibility.
     * @return OK
     */
    getOrderBySalesOrderNumber(salesOrderNumber: string, cancelToken?: CancelToken): Promise<OrderSummaryDto> {
        let url_ = this.baseUrl + "/api/Orders/by-sales-order/{salesOrderNumber}";
        if (salesOrderNumber === undefined || salesOrderNumber === null)
            throw new globalThis.Error("The parameter 'salesOrderNumber' must be defined.");
        url_ = url_.replace("{salesOrderNumber}", encodeURIComponent("" + salesOrderNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderBySalesOrderNumber(_response);
        });
    }

    protected processGetOrderBySalesOrderNumber(response: AxiosResponse): Promise<OrderSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderSummaryDto.fromJS(resultData200);
            return Promise.resolve<OrderSummaryDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderSummaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFilterValues(body: OrdersFilterRequest | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Orders/filter-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilterValues(_response);
        });
    }

    protected processGetFilterValues(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getReturnOrderEligibilityBatch(body: GetOrderReturnEligibilityBatchRequest | undefined, cancelToken?: CancelToken): Promise<OrderReturnEligibilityItemDto[]> {
        let url_ = this.baseUrl + "/api/Orders/return-eligibility/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReturnOrderEligibilityBatch(_response);
        });
    }

    protected processGetReturnOrderEligibilityBatch(response: AxiosResponse): Promise<OrderReturnEligibilityItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderReturnEligibilityItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrderReturnEligibilityItemDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderReturnEligibilityItemDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRecentOrders(orgUnitId: number, body: RecentOrdersRequest | undefined, cancelToken?: CancelToken): Promise<RecentOrderDto[]> {
        let url_ = this.baseUrl + "/api/Orders/{orgUnitId}/recent-orders";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecentOrders(_response);
        });
    }

    protected processGetRecentOrders(response: AxiosResponse): Promise<RecentOrderDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecentOrderDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RecentOrderDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecentOrderDto[]>(null as any);
    }

    /**
     * Retrieves product detail drawer data for a line item within an order context.
    Requires order search permissions instead of standard management permissions.
     * @param body (optional) 
     * @return OK
     */
    getOrderProductDetailDrawer(body: ProductDetailDrawerRequestDto | undefined, cancelToken?: CancelToken): Promise<ProductDetailDrawerDto> {
        let url_ = this.baseUrl + "/api/Orders/product-detail-drawer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderProductDetailDrawer(_response);
        });
    }

    protected processGetOrderProductDetailDrawer(response: AxiosResponse): Promise<ProductDetailDrawerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDetailDrawerDto.fromJS(resultData200);
            return Promise.resolve<ProductDetailDrawerDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDetailDrawerDto>(null as any);
    }

    /**
     * Retrieves product detail drawer CNET Images or thumbnail (800 x 600) for a line item within an order context.
    Requires order search permissions instead of standard management permissions.
     * @param body (optional) 
     * @return OK
     */
    getOrderProductDetailDrawerImages(body: ProductDetailDrawerRequestDto | undefined, cancelToken?: CancelToken): Promise<ProductImageDto[]> {
        let url_ = this.baseUrl + "/api/Orders/product-detail-drawer/images";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderProductDetailDrawerImages(_response);
        });
    }

    protected processGetOrderProductDetailDrawerImages(response: AxiosResponse): Promise<ProductImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductImageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductImageDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductImageDto[]>(null as any);
    }

    /**
     * @param biOrderId (optional) 
     * @param webOrderId (optional) 
     * @param orgUnitId (optional) 
     * @return OK
     */
    getShippingDetails(biOrderId: number | undefined, webOrderId: number | undefined, orgUnitId: number | undefined, cancelToken?: CancelToken): Promise<ShippingDetailsDto> {
        let url_ = this.baseUrl + "/api/Orders/ship-to?";
        if (biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' cannot be null.");
        else if (biOrderId !== undefined)
            url_ += "biOrderId=" + encodeURIComponent("" + biOrderId) + "&";
        if (webOrderId === null)
            throw new globalThis.Error("The parameter 'webOrderId' cannot be null.");
        else if (webOrderId !== undefined)
            url_ += "webOrderId=" + encodeURIComponent("" + webOrderId) + "&";
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            url_ += "orgUnitId=" + encodeURIComponent("" + orgUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShippingDetails(_response);
        });
    }

    protected processGetShippingDetails(response: AxiosResponse): Promise<ShippingDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShippingDetailsDto.fromJS(resultData200);
            return Promise.resolve<ShippingDetailsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShippingDetailsDto>(null as any);
    }

    /**
     * @param biOrderId (optional) 
     * @param webOrderId (optional) 
     * @param orgUnitId (optional) 
     * @return OK
     */
    getBillTo(biOrderId: number | undefined, webOrderId: number | undefined, orgUnitId: number | undefined, cancelToken?: CancelToken): Promise<OrderAddressDto> {
        let url_ = this.baseUrl + "/api/Orders/bill-to?";
        if (biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' cannot be null.");
        else if (biOrderId !== undefined)
            url_ += "biOrderId=" + encodeURIComponent("" + biOrderId) + "&";
        if (webOrderId === null)
            throw new globalThis.Error("The parameter 'webOrderId' cannot be null.");
        else if (webOrderId !== undefined)
            url_ += "webOrderId=" + encodeURIComponent("" + webOrderId) + "&";
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            url_ += "orgUnitId=" + encodeURIComponent("" + orgUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillTo(_response);
        });
    }

    protected processGetBillTo(response: AxiosResponse): Promise<OrderAddressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderAddressDto.fromJS(resultData200);
            return Promise.resolve<OrderAddressDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderAddressDto>(null as any);
    }

    /**
     * @param biOrderId (optional) 
     * @param trackingNumber (optional) 
     * @return OK
     */
    getShipmentTracking(biOrderId: number | undefined, trackingNumber: string | undefined, cancelToken?: CancelToken): Promise<ShipmentTrackingDto> {
        let url_ = this.baseUrl + "/api/Orders/shipment-tracking?";
        if (biOrderId === null)
            throw new globalThis.Error("The parameter 'biOrderId' cannot be null.");
        else if (biOrderId !== undefined)
            url_ += "biOrderId=" + encodeURIComponent("" + biOrderId) + "&";
        if (trackingNumber === null)
            throw new globalThis.Error("The parameter 'trackingNumber' cannot be null.");
        else if (trackingNumber !== undefined)
            url_ += "trackingNumber=" + encodeURIComponent("" + trackingNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShipmentTracking(_response);
        });
    }

    protected processGetShipmentTracking(response: AxiosResponse): Promise<ShipmentTrackingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShipmentTrackingDto.fromJS(resultData200);
            return Promise.resolve<ShipmentTrackingDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShipmentTrackingDto>(null as any);
    }

    /**
     * Submits the caller's shopping cart as a Commerce web order. The ordering employee and org unit
    are resolved from the signed-in user's context; currency, back office entity, and language are
    resolved server-side. The client supplies a generated idempotency key, the shipping address, and
    the cart lines. Returns the created web order id for the checkout success page.
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    submitWebOrderCheckout(body: WebOrderCheckoutRequest | undefined, cancelToken?: CancelToken): Promise<WebOrderCheckoutResult> {
        let url_ = this.baseUrl + "/api/Orders/checkout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitWebOrderCheckout(_response);
        });
    }

    protected processSubmitWebOrderCheckout(response: AxiosResponse): Promise<WebOrderCheckoutResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WebOrderCheckoutResult.fromJS(resultData200);
            return Promise.resolve<WebOrderCheckoutResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 501) {
            const _responseText = response.data;
            return throwException("Not Implemented", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebOrderCheckoutResult>(null as any);
    }

    /**
     * @return OK
     */
    getCheckoutQuestions( cancelToken?: CancelToken): Promise<CheckoutQuestionDto[]> {
        let url_ = this.baseUrl + "/api/Orders/checkout/questions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCheckoutQuestions(_response);
        });
    }

    protected processGetCheckoutQuestions(response: AxiosResponse): Promise<CheckoutQuestionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckoutQuestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CheckoutQuestionDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 501) {
            const _responseText = response.data;
            return throwException("Not Implemented", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckoutQuestionDto[]>(null as any);
    }
}

export interface IOrderSyncStreamClient {
    /**
     * @return OK
     */
    streamSyncStatus( cancelToken?: CancelToken): Promise<void>;
}

export class OrderSyncStreamClient extends AuthorizedApiBase implements IOrderSyncStreamClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    streamSyncStatus( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderSyncStream/sync-stream";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStreamSyncStatus(_response);
        });
    }

    protected processStreamSyncStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOrgUnitClient {
    /**
     * @return OK
     */
    getOrgUnitLogoInfo(orgUnitId: number,  cancelToken?: CancelToken): Promise<GetOrgUnitLogoInfoResponse>;
    /**
     * @return OK
     */
    getOrgUnitLogo(orgUnitId: number,  cancelToken?: CancelToken): Promise<GetOrgUnitLogoResponse>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateOrgUnitLogo(orgUnitId: number, body: ChangeLogoDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateDisplayName(orgUnitId: number, body: OrgUnitDisplayNameDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getWelcomeMessage(orgUnitId: number,  cancelToken?: CancelToken): Promise<GetWelcomeMessageByOrgIdResponse>;
    /**
     * @param body (optional) 
     * @return Created
     */
    insertWelcomeMessage(orgUnitId: number, body: InsertWelcomeMessageBodyRequest | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @return OK
     */
    getOrgQuoteList(orgUnitId: number,  cancelToken?: CancelToken): Promise<PublishedQuoteListItemDto[]>;
}

export class OrgUnitClient extends AuthorizedApiBase implements IOrgUnitClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getOrgUnitLogoInfo(orgUnitId: number, cancelToken?: CancelToken): Promise<GetOrgUnitLogoInfoResponse> {
        let url_ = this.baseUrl + "/api/OrgUnit/{orgUnitId}/logo-info";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgUnitLogoInfo(_response);
        });
    }

    protected processGetOrgUnitLogoInfo(response: AxiosResponse): Promise<GetOrgUnitLogoInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrgUnitLogoInfoResponse.fromJS(resultData200);
            return Promise.resolve<GetOrgUnitLogoInfoResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrgUnitLogoInfoResponse>(null as any);
    }

    /**
     * @return OK
     */
    getOrgUnitLogo(orgUnitId: number, cancelToken?: CancelToken): Promise<GetOrgUnitLogoResponse> {
        let url_ = this.baseUrl + "/api/OrgUnit/{orgUnitId}/logo";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgUnitLogo(_response);
        });
    }

    protected processGetOrgUnitLogo(response: AxiosResponse): Promise<GetOrgUnitLogoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrgUnitLogoResponse.fromJS(resultData200);
            return Promise.resolve<GetOrgUnitLogoResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status === 501) {
            const _responseText = response.data;
            return throwException("Not Implemented", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrgUnitLogoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateOrgUnitLogo(orgUnitId: number, body: ChangeLogoDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/OrgUnit/{orgUnitId}/logo";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrgUnitLogo(_response);
        });
    }

    protected processUpdateOrgUnitLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 501) {
            const _responseText = response.data;
            return throwException("Not Implemented", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateDisplayName(orgUnitId: number, body: OrgUnitDisplayNameDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/OrgUnit/{orgUnitId}/display-name";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDisplayName(_response);
        });
    }

    protected processUpdateDisplayName(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getWelcomeMessage(orgUnitId: number, cancelToken?: CancelToken): Promise<GetWelcomeMessageByOrgIdResponse> {
        let url_ = this.baseUrl + "/api/OrgUnit/welcome-messages/{orgUnitId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWelcomeMessage(_response);
        });
    }

    protected processGetWelcomeMessage(response: AxiosResponse): Promise<GetWelcomeMessageByOrgIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWelcomeMessageByOrgIdResponse.fromJS(resultData200);
            return Promise.resolve<GetWelcomeMessageByOrgIdResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 501) {
            const _responseText = response.data;
            return throwException("Not Implemented", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWelcomeMessageByOrgIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    insertWelcomeMessage(orgUnitId: number, body: InsertWelcomeMessageBodyRequest | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/OrgUnit/welcome-messages/{orgUnitId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertWelcomeMessage(_response);
        });
    }

    protected processInsertWelcomeMessage(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return Promise.resolve<boolean>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 501) {
            const _responseText = response.data;
            return throwException("Not Implemented", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getOrgQuoteList(orgUnitId: number, cancelToken?: CancelToken): Promise<PublishedQuoteListItemDto[]> {
        let url_ = this.baseUrl + "/api/OrgUnit/{orgUnitId}/quotes";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgQuoteList(_response);
        });
    }

    protected processGetOrgQuoteList(response: AxiosResponse): Promise<PublishedQuoteListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublishedQuoteListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PublishedQuoteListItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublishedQuoteListItemDto[]>(null as any);
    }
}

export interface IPageLayoutClient {
    /**
     * @return OK
     */
    getPageLayout(pageLayoutId: string,  cancelToken?: CancelToken): Promise<PageLayoutDto>;
}

export class PageLayoutClient extends AuthorizedApiBase implements IPageLayoutClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getPageLayout(pageLayoutId: string, cancelToken?: CancelToken): Promise<PageLayoutDto> {
        let url_ = this.baseUrl + "/api/pagelayout/{pageLayoutId}";
        if (pageLayoutId === undefined || pageLayoutId === null)
            throw new globalThis.Error("The parameter 'pageLayoutId' must be defined.");
        url_ = url_.replace("{pageLayoutId}", encodeURIComponent("" + pageLayoutId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageLayout(_response);
        });
    }

    protected processGetPageLayout(response: AxiosResponse): Promise<PageLayoutDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageLayoutDto.fromJS(resultData200);
            return Promise.resolve<PageLayoutDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageLayoutDto>(null as any);
    }
}

export interface IPicklistClient {
    /**
     * Retrieves the Picklist JSON from Blob Storage.
     * @return OK
     */
    getPicklist( cancelToken?: CancelToken): Promise<string>;
}

export class PicklistClient extends AuthorizedApiBase implements IPicklistClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieves the Picklist JSON from Blob Storage.
     * @return OK
     */
    getPicklist( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPicklist(_response);
        });
    }

    protected processGetPicklist(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IPingClient {
    /**
     * @return OK
     */
    getPing( cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    headPing( cancelToken?: CancelToken): Promise<void>;
}

export class PingClient extends AuthorizedApiBase implements IPingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getPing( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPing(_response);
        });
    }

    protected processGetPing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    headPing( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHeadPing(_response);
        });
    }

    protected processHeadPing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProductAvailabilityClient {
    /**
     * Returns stock availability for a standards product, scoped to the requested org unit and current user's AX references.
     * @param orgUnitId The org unit id requested by the client.
     * @param productDescriptor The product descriptor (SKU or catalog code).
     * @return OK
     */
    getProductAvailability(orgUnitId: number, productDescriptor: string,  cancelToken?: CancelToken): Promise<ProductAvailabilityResponse>;
}

export class ProductAvailabilityClient extends AuthorizedApiBase implements IProductAvailabilityClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns stock availability for a standards product, scoped to the requested org unit and current user's AX references.
     * @param orgUnitId The org unit id requested by the client.
     * @param productDescriptor The product descriptor (SKU or catalog code).
     * @return OK
     */
    getProductAvailability(orgUnitId: number, productDescriptor: string, cancelToken?: CancelToken): Promise<ProductAvailabilityResponse> {
        let url_ = this.baseUrl + "/api/ecommerce/product-availability/{orgUnitId}/{productDescriptor}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (productDescriptor === undefined || productDescriptor === null)
            throw new globalThis.Error("The parameter 'productDescriptor' must be defined.");
        url_ = url_.replace("{productDescriptor}", encodeURIComponent("" + productDescriptor));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductAvailability(_response);
        });
    }

    protected processGetProductAvailability(response: AxiosResponse): Promise<ProductAvailabilityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductAvailabilityResponse.fromJS(resultData200);
            return Promise.resolve<ProductAvailabilityResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductAvailabilityResponse>(null as any);
    }
}

export interface IProductDetailsClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getProductDetails(body: ProductInputDto[] | undefined,  cancelToken?: CancelToken): Promise<GetProductDetailsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getProductDetailDrawer(body: ProductDetailDrawerRequestDto | undefined,  cancelToken?: CancelToken): Promise<ProductDetailDrawerDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getAvailabilityForProducts(body: ProductInputDto[] | undefined,  cancelToken?: CancelToken): Promise<ProductAvailability[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getProductDetailDrawerImages(body: ProductDetailDrawerRequestDto | undefined,  cancelToken?: CancelToken): Promise<ProductImageDto[]>;
}

export class ProductDetailsClient extends AuthorizedApiBase implements IProductDetailsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProductDetails(body: ProductInputDto[] | undefined, cancelToken?: CancelToken): Promise<GetProductDetailsResponse> {
        let url_ = this.baseUrl + "/api/ecommerce/product-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductDetails(_response);
        });
    }

    protected processGetProductDetails(response: AxiosResponse): Promise<GetProductDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetProductDetailsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductDetailsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProductDetailDrawer(body: ProductDetailDrawerRequestDto | undefined, cancelToken?: CancelToken): Promise<ProductDetailDrawerDto> {
        let url_ = this.baseUrl + "/api/ecommerce/product-details/drawer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductDetailDrawer(_response);
        });
    }

    protected processGetProductDetailDrawer(response: AxiosResponse): Promise<ProductDetailDrawerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDetailDrawerDto.fromJS(resultData200);
            return Promise.resolve<ProductDetailDrawerDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDetailDrawerDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAvailabilityForProducts(body: ProductInputDto[] | undefined, cancelToken?: CancelToken): Promise<ProductAvailability[]> {
        let url_ = this.baseUrl + "/api/ecommerce/product-details/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailabilityForProducts(_response);
        });
    }

    protected processGetAvailabilityForProducts(response: AxiosResponse): Promise<ProductAvailability[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductAvailability.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductAvailability[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductAvailability[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProductDetailDrawerImages(body: ProductDetailDrawerRequestDto | undefined, cancelToken?: CancelToken): Promise<ProductImageDto[]> {
        let url_ = this.baseUrl + "/api/ecommerce/product-details/drawer/images";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductDetailDrawerImages(_response);
        });
    }

    protected processGetProductDetailDrawerImages(response: AxiosResponse): Promise<ProductImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductImageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductImageDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductImageDto[]>(null as any);
    }
}

export interface IProductSearchClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    searchProducts(body: ProductSearchDto | undefined,  cancelToken?: CancelToken): Promise<SearchProductsResponse>;
}

export class ProductSearchClient extends AuthorizedApiBase implements IProductSearchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchProducts(body: ProductSearchDto | undefined, cancelToken?: CancelToken): Promise<SearchProductsResponse> {
        let url_ = this.baseUrl + "/api/ProductSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProducts(_response);
        });
    }

    protected processSearchProducts(response: AxiosResponse): Promise<SearchProductsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchProductsResponse.fromJS(resultData200);
            return Promise.resolve<SearchProductsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchProductsResponse>(null as any);
    }
}

export interface IProjectClient {
    /**
     * @return OK
     */
    getProjectList( cancelToken?: CancelToken): Promise<ProjectListResponse>;
    /**
     * @return OK
     */
    getProjectById(id: number,  cancelToken?: CancelToken): Promise<ProjectIndividualResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getProjectDetail(body: ProjectDetailRequest | undefined,  cancelToken?: CancelToken): Promise<ProjectDetailResponse>;
    /**
     * @return OK
     */
    getProjectsByYourUser( cancelToken?: CancelToken): Promise<ProjectCacheResponse>;
    /**
     * @return OK
     */
    getActiveProjectsByAccount( cancelToken?: CancelToken): Promise<ProjectWidgetItemDto[]>;
}

export class ProjectClient extends AuthorizedApiBase implements IProjectClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getProjectList( cancelToken?: CancelToken): Promise<ProjectListResponse> {
        let url_ = this.baseUrl + "/api/Project/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectList(_response);
        });
    }

    protected processGetProjectList(response: AxiosResponse): Promise<ProjectListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectListResponse.fromJS(resultData200);
            return Promise.resolve<ProjectListResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectListResponse>(null as any);
    }

    /**
     * @return OK
     */
    getProjectById(id: number, cancelToken?: CancelToken): Promise<ProjectIndividualResponse> {
        let url_ = this.baseUrl + "/api/Project/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectById(_response);
        });
    }

    protected processGetProjectById(response: AxiosResponse): Promise<ProjectIndividualResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectIndividualResponse.fromJS(resultData200);
            return Promise.resolve<ProjectIndividualResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectIndividualResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProjectDetail(body: ProjectDetailRequest | undefined, cancelToken?: CancelToken): Promise<ProjectDetailResponse> {
        let url_ = this.baseUrl + "/api/Project/project-detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectDetail(_response);
        });
    }

    protected processGetProjectDetail(response: AxiosResponse): Promise<ProjectDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectDetailResponse.fromJS(resultData200);
            return Promise.resolve<ProjectDetailResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDetailResponse>(null as any);
    }

    /**
     * @return OK
     */
    getProjectsByYourUser( cancelToken?: CancelToken): Promise<ProjectCacheResponse> {
        let url_ = this.baseUrl + "/api/Project";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsByYourUser(_response);
        });
    }

    protected processGetProjectsByYourUser(response: AxiosResponse): Promise<ProjectCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectCacheResponse.fromJS(resultData200);
            return Promise.resolve<ProjectCacheResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectCacheResponse>(null as any);
    }

    /**
     * @return OK
     */
    getActiveProjectsByAccount( cancelToken?: CancelToken): Promise<ProjectWidgetItemDto[]> {
        let url_ = this.baseUrl + "/api/Project/active-projects-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveProjectsByAccount(_response);
        });
    }

    protected processGetActiveProjectsByAccount(response: AxiosResponse): Promise<ProjectWidgetItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectWidgetItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProjectWidgetItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectWidgetItemDto[]>(null as any);
    }
}

export interface IProjectInvoiceClient {
    /**
     * @return OK
     */
    getProjectInvoices( cancelToken?: CancelToken): Promise<AXProjectInvoicesResponse>;
}

export class ProjectInvoiceClient extends AuthorizedApiBase implements IProjectInvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getProjectInvoices( cancelToken?: CancelToken): Promise<AXProjectInvoicesResponse> {
        let url_ = this.baseUrl + "/api/projectinvoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectInvoices(_response);
        });
    }

    protected processGetProjectInvoices(response: AxiosResponse): Promise<AXProjectInvoicesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXProjectInvoicesResponse.fromJS(resultData200);
            return Promise.resolve<AXProjectInvoicesResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXProjectInvoicesResponse>(null as any);
    }
}

export interface IPurchasedAssetsClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByOrder(body: PurchasedAssetSpendRequest | undefined,  cancelToken?: CancelToken): Promise<PurchasedAssetSpendByOrderResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByManufacturer(body: PurchasedAssetSpendRequest | undefined,  cancelToken?: CancelToken): Promise<PurchasedAssetSpendByManufacturerResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByManufacturerFilters(body: PurchasedAssetSpendRequest | undefined,  cancelToken?: CancelToken): Promise<PurchasedAssetSpendByManufacturerFiltersResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByCategory(body: PurchasedAssetSpendByCategoryRequest | undefined,  cancelToken?: CancelToken): Promise<PurchasedAssetSpendByCategoryResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByCategoryFilters(body: PurchasedAssetSpendRequest | undefined,  cancelToken?: CancelToken): Promise<PurchasedAssetSpendByCategoryFiltersResponse>;
    /**
     * @return OK
     */
    getPurchasedAssetsPicklist( cancelToken?: CancelToken): Promise<IncludeExcludeFilterCategory[]>;
    /**
     * Gets a summary of purchased assets including total spend, order count, manufacturer count,
    category breakdowns, and spend chart data with comparison to the previous period.
     * @param body (optional) 
     * @return OK
     */
    getPurchasedAssetsSummary(body: PurchasedAssetAggregationRequest | undefined,  cancelToken?: CancelToken): Promise<PurchasedAssetsSummaryResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getDrawerAssets(body: PurchasedAssetAggregationRequest | undefined,  cancelToken?: CancelToken): Promise<GetPurchasedAssetDrawerAssetsResponse>;
    /**
     * Exports purchased assets data to an Excel file based on the current view and filters.
     * @param body (optional) 
     * @return OK
     */
    exportPurchasedAssets(body: PurchasedAssetsExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
}

export class PurchasedAssetsClient extends AuthorizedApiBase implements IPurchasedAssetsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByOrder(body: PurchasedAssetSpendRequest | undefined, cancelToken?: CancelToken): Promise<PurchasedAssetSpendByOrderResponse> {
        let url_ = this.baseUrl + "/api/assets/purchased/spend-by-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpendByOrder(_response);
        });
    }

    protected processGetSpendByOrder(response: AxiosResponse): Promise<PurchasedAssetSpendByOrderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchasedAssetSpendByOrderResponse.fromJS(resultData200);
            return Promise.resolve<PurchasedAssetSpendByOrderResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchasedAssetSpendByOrderResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByManufacturer(body: PurchasedAssetSpendRequest | undefined, cancelToken?: CancelToken): Promise<PurchasedAssetSpendByManufacturerResponse> {
        let url_ = this.baseUrl + "/api/assets/purchased/spend-by-manufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpendByManufacturer(_response);
        });
    }

    protected processGetSpendByManufacturer(response: AxiosResponse): Promise<PurchasedAssetSpendByManufacturerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchasedAssetSpendByManufacturerResponse.fromJS(resultData200);
            return Promise.resolve<PurchasedAssetSpendByManufacturerResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchasedAssetSpendByManufacturerResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByManufacturerFilters(body: PurchasedAssetSpendRequest | undefined, cancelToken?: CancelToken): Promise<PurchasedAssetSpendByManufacturerFiltersResponse> {
        let url_ = this.baseUrl + "/api/assets/purchased/spend-by-manufacturer-filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpendByManufacturerFilters(_response);
        });
    }

    protected processGetSpendByManufacturerFilters(response: AxiosResponse): Promise<PurchasedAssetSpendByManufacturerFiltersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchasedAssetSpendByManufacturerFiltersResponse.fromJS(resultData200);
            return Promise.resolve<PurchasedAssetSpendByManufacturerFiltersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchasedAssetSpendByManufacturerFiltersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByCategory(body: PurchasedAssetSpendByCategoryRequest | undefined, cancelToken?: CancelToken): Promise<PurchasedAssetSpendByCategoryResponse> {
        let url_ = this.baseUrl + "/api/assets/purchased/spend-by-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpendByCategory(_response);
        });
    }

    protected processGetSpendByCategory(response: AxiosResponse): Promise<PurchasedAssetSpendByCategoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchasedAssetSpendByCategoryResponse.fromJS(resultData200);
            return Promise.resolve<PurchasedAssetSpendByCategoryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchasedAssetSpendByCategoryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByCategoryFilters(body: PurchasedAssetSpendRequest | undefined, cancelToken?: CancelToken): Promise<PurchasedAssetSpendByCategoryFiltersResponse> {
        let url_ = this.baseUrl + "/api/assets/purchased/spend-by-category-filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpendByCategoryFilters(_response);
        });
    }

    protected processGetSpendByCategoryFilters(response: AxiosResponse): Promise<PurchasedAssetSpendByCategoryFiltersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchasedAssetSpendByCategoryFiltersResponse.fromJS(resultData200);
            return Promise.resolve<PurchasedAssetSpendByCategoryFiltersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchasedAssetSpendByCategoryFiltersResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPurchasedAssetsPicklist( cancelToken?: CancelToken): Promise<IncludeExcludeFilterCategory[]> {
        let url_ = this.baseUrl + "/api/assets/purchased/picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPurchasedAssetsPicklist(_response);
        });
    }

    protected processGetPurchasedAssetsPicklist(response: AxiosResponse): Promise<IncludeExcludeFilterCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncludeExcludeFilterCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IncludeExcludeFilterCategory[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncludeExcludeFilterCategory[]>(null as any);
    }

    /**
     * Gets a summary of purchased assets including total spend, order count, manufacturer count,
    category breakdowns, and spend chart data with comparison to the previous period.
     * @param body (optional) 
     * @return OK
     */
    getPurchasedAssetsSummary(body: PurchasedAssetAggregationRequest | undefined, cancelToken?: CancelToken): Promise<PurchasedAssetsSummaryResponse> {
        let url_ = this.baseUrl + "/api/assets/purchased/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPurchasedAssetsSummary(_response);
        });
    }

    protected processGetPurchasedAssetsSummary(response: AxiosResponse): Promise<PurchasedAssetsSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchasedAssetsSummaryResponse.fromJS(resultData200);
            return Promise.resolve<PurchasedAssetsSummaryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchasedAssetsSummaryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDrawerAssets(body: PurchasedAssetAggregationRequest | undefined, cancelToken?: CancelToken): Promise<GetPurchasedAssetDrawerAssetsResponse> {
        let url_ = this.baseUrl + "/api/assets/purchased/drawer-assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrawerAssets(_response);
        });
    }

    protected processGetDrawerAssets(response: AxiosResponse): Promise<GetPurchasedAssetDrawerAssetsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPurchasedAssetDrawerAssetsResponse.fromJS(resultData200);
            return Promise.resolve<GetPurchasedAssetDrawerAssetsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPurchasedAssetDrawerAssetsResponse>(null as any);
    }

    /**
     * Exports purchased assets data to an Excel file based on the current view and filters.
     * @param body (optional) 
     * @return OK
     */
    exportPurchasedAssets(body: PurchasedAssetsExportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/assets/purchased/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPurchasedAssets(_response);
        });
    }

    protected processExportPurchasedAssets(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPurchasedAssetsHardwareByAgeWidgetClient {
    /**
     * @return OK
     */
    getHardwareByAge( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse>;
}

export class PurchasedAssetsHardwareByAgeWidgetClient extends AuthorizedApiBase implements IPurchasedAssetsHardwareByAgeWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getHardwareByAge( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse> {
        let url_ = this.baseUrl + "/api/widget/purchased-assets-hardware/hardware-by-age";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHardwareByAge(_response);
        });
    }

    protected processGetHardwareByAge(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse>(null as any);
    }
}

export interface IPurchasedAssetsSpendWidgetClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendComparison(body: GetPurchasedAssetsSpendWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getWidgetSpendByCategory(body: GetPurchasedAssetsSpendWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getWidgetSpendByManufacturer(body: GetPurchasedAssetsSpendWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByAssetType(body: GetPurchasedAssetsSpendWidgetRequest | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse>;
}

export class PurchasedAssetsSpendWidgetClient extends AuthorizedApiBase implements IPurchasedAssetsSpendWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendComparison(body: GetPurchasedAssetsSpendWidgetRequest | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse> {
        let url_ = this.baseUrl + "/api/widget/purchased-assets-spend/comparison";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpendComparison(_response);
        });
    }

    protected processGetSpendComparison(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getWidgetSpendByCategory(body: GetPurchasedAssetsSpendWidgetRequest | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse> {
        let url_ = this.baseUrl + "/api/widget/purchased-assets-spend/by-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWidgetSpendByCategory(_response);
        });
    }

    protected processGetWidgetSpendByCategory(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getWidgetSpendByManufacturer(body: GetPurchasedAssetsSpendWidgetRequest | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse> {
        let url_ = this.baseUrl + "/api/widget/purchased-assets-spend/by-manufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWidgetSpendByManufacturer(_response);
        });
    }

    protected processGetWidgetSpendByManufacturer(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSpendByAssetType(body: GetPurchasedAssetsSpendWidgetRequest | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse> {
        let url_ = this.baseUrl + "/api/widget/purchased-assets-spend/by-asset-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpendByAssetType(_response);
        });
    }

    protected processGetSpendByAssetType(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse>(null as any);
    }
}

export interface IQuotesClient {
    /**
     * Returns the active quote alert/disclaimer message(s) to display at the top of quote pages
    (SPU-498). Sourced from Azure App Configuration (`Quotes:AlertMessage`) via
    Microsoft.Extensions.Options.IOptionsMonitor`1 for live refresh. Returns an empty collection when no
    alert is configured (blank/unset value), which the frontend treats as "no alert".
     * @return OK
     */
    getQuoteAlerts( cancelToken?: CancelToken): Promise<QuoteAlertDto[]>;
    /**
     * Gets quotes for the current user's org unit, filtered by the requested view scope.
     * @param view (optional) 
     * @return OK
     */
    getQuotes(view: QuoteViewScope | undefined,  cancelToken?: CancelToken): Promise<PublishedQuoteListItemDto[]>;
    /**
     * Creates a ShiOne-native quote (SPU-454 MVP) from a name + commodity line items. When
    `OrgUnitId` is supplied, the quote is created for that storefront (must be in the caller's
    SHI.com-permitted set); otherwise defaults to the caller's current org unit.
     * @param body (optional) 
     * @return Created
     */
    createQuote(body: CreateQuoteRequestDto | undefined,  cancelToken?: CancelToken): Promise<CreateQuoteResultDto>;
    /**
     * Returns the ids of the caller's accessible quotes (for the requested scope) whose line items
    contain a product matching the free-text term -- by product name/description, manufacturer,
    manufacturer part number, or SHI part number. The frontend fires this as an always-on, debounced
    enhancement alongside the client-side name/number search and unions the results. Only ids the
    caller may already see are searched, so this never surfaces quotes outside the caller's scope.
     * @param term (optional) 
     * @param view (optional) 
     * @return OK
     */
    searchQuotesByProduct(term: string | undefined, view: QuoteViewScope | undefined,  cancelToken?: CancelToken): Promise<number[]>;
    /**
     * Downloads the rendered PDF for a quote.
     * @return OK
     */
    downloadPdf(quoteId: number,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Returns the storefronts (org units) the caller is permitted to create or view quotes for,
    sourced from SHI.com's `quotes_OU` security action.
     * @return OK
     */
    getQuoteStorefronts( cancelToken?: CancelToken): Promise<QuoteStorefrontDto[]>;
    /**
     * Returns current catalog pricing for a set of product IDs without creating a quote. Uses the
    same catalog lookup as `CreateQuote` so the prices reflect what the user would
    actually pay. Products not found in the catalog return `InCatalog = false`.
     * @param body (optional) 
     * @return OK
     */
    priceCheck(body: PriceCheckRequestDto | undefined,  cancelToken?: CancelToken): Promise<PriceCheckResultDto>;
    /**
     * Refreshes an expired quote (SPU-477): a new quote from a name + still-in-catalog items, priced
    server-side. Kept separate from create so create-only options never reach refresh.
     * @param body (optional) 
     * @return Created
     */
    refreshQuote(body: RefreshQuoteRequestDto | undefined,  cancelToken?: CancelToken): Promise<CreateQuoteResultDto>;
    /**
     * Returns the estimated tax for a prospective quote (SPU-492). Calculated by the shi.com
    TaxandFee microservice (`GetTax` — the same call shi.com's save-as-quote makes) from the
    included lines, ship-to address, and the selected shipping method's freight cost. The dialog
    only offers tax once shipping is opted in.
     * @param body (optional) 
     * @return OK
     */
    calculateTax(body: QuoteTaxRequestDto | undefined,  cancelToken?: CancelToken): Promise<QuoteTaxResultDto>;
    /**
     * Gets the full detail for a quote (header, customer, public comments, line items, totals).
     * @return OK
     */
    getQuoteDetail(quoteId: number,  cancelToken?: CancelToken): Promise<QuoteDetailDto>;
    /**
     * Unpublishes (soft-deletes) a quote.
     * @return No Content
     */
    deleteQuote(quoteId: number,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Emails a copy of the quote PDF to one or more recipients. Recipients do not need ShiOne access.
     * @param body (optional) 
     * @return OK
     */
    shareQuote(quoteId: number, body: ShareQuoteRequest | undefined,  cancelToken?: CancelToken): Promise<ShareQuoteResultDto>;
    /**
     * Returns enriched product-detail-drawer data (images, specs, inventory) for a catalog product,
    for users who can view quotes. Catalog data is not quote-specific, so this simply lets a quotes
    viewer see the details of products in their own org unit — a dedicated, quote-permissioned
    entry point so we don't borrow the standards/orders permission gates. Scoped to the caller's
    current org unit.
     * @param body (optional) 
     * @return OK
     */
    getQuoteProductDetailDrawer(body: ProductDetailDrawerRequestDto | undefined,  cancelToken?: CancelToken): Promise<ProductDetailDrawerDto>;
    /**
     * Retrieves product images only for a catalog product, for users who can view quotes. Used as
    the client-driven retry when the drawer's initial response defers image resolution (see
    ProductDetailDrawerDto.ImagesDeferred and GetQuoteProductDetailDrawer above). Scoped to the
    caller's current org unit, same as the drawer endpoint.
     * @param body (optional) 
     * @return OK
     */
    getQuoteProductDetailDrawerImages(body: ProductDetailDrawerRequestDto | undefined,  cancelToken?: CancelToken): Promise<ProductImageDto[]>;
    /**
     * Returns the total item quantity (sum of line quantities) for each requested quote the caller may
    access. Quotes the caller cannot access — or that have no items — are omitted. Used to populate
    the list's Total Quantity column lazily for the visible page (the summary list has no quantity).
     * @param ids (optional) 
     * @return OK
     */
    getQuoteQuantities(ids: string | undefined,  cancelToken?: CancelToken): Promise<{ [key: string]: number; }>;
}

export class QuotesClient extends AuthorizedApiBase implements IQuotesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the active quote alert/disclaimer message(s) to display at the top of quote pages
    (SPU-498). Sourced from Azure App Configuration (`Quotes:AlertMessage`) via
    Microsoft.Extensions.Options.IOptionsMonitor`1 for live refresh. Returns an empty collection when no
    alert is configured (blank/unset value), which the frontend treats as "no alert".
     * @return OK
     */
    getQuoteAlerts( cancelToken?: CancelToken): Promise<QuoteAlertDto[]> {
        let url_ = this.baseUrl + "/api/Quotes/alerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteAlerts(_response);
        });
    }

    protected processGetQuoteAlerts(response: AxiosResponse): Promise<QuoteAlertDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteAlertDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<QuoteAlertDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteAlertDto[]>(null as any);
    }

    /**
     * Gets quotes for the current user's org unit, filtered by the requested view scope.
     * @param view (optional) 
     * @return OK
     */
    getQuotes(view: QuoteViewScope | undefined, cancelToken?: CancelToken): Promise<PublishedQuoteListItemDto[]> {
        let url_ = this.baseUrl + "/api/Quotes?";
        if (view === null)
            throw new globalThis.Error("The parameter 'view' cannot be null.");
        else if (view !== undefined)
            url_ += "view=" + encodeURIComponent("" + view) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuotes(_response);
        });
    }

    protected processGetQuotes(response: AxiosResponse): Promise<PublishedQuoteListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublishedQuoteListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PublishedQuoteListItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublishedQuoteListItemDto[]>(null as any);
    }

    /**
     * Creates a ShiOne-native quote (SPU-454 MVP) from a name + commodity line items. When
    `OrgUnitId` is supplied, the quote is created for that storefront (must be in the caller's
    SHI.com-permitted set); otherwise defaults to the caller's current org unit.
     * @param body (optional) 
     * @return Created
     */
    createQuote(body: CreateQuoteRequestDto | undefined, cancelToken?: CancelToken): Promise<CreateQuoteResultDto> {
        let url_ = this.baseUrl + "/api/Quotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQuote(_response);
        });
    }

    protected processCreateQuote(response: AxiosResponse): Promise<CreateQuoteResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = CreateQuoteResultDto.fromJS(resultData201);
            return Promise.resolve<CreateQuoteResultDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateQuoteResultDto>(null as any);
    }

    /**
     * Returns the ids of the caller's accessible quotes (for the requested scope) whose line items
    contain a product matching the free-text term -- by product name/description, manufacturer,
    manufacturer part number, or SHI part number. The frontend fires this as an always-on, debounced
    enhancement alongside the client-side name/number search and unions the results. Only ids the
    caller may already see are searched, so this never surfaces quotes outside the caller's scope.
     * @param term (optional) 
     * @param view (optional) 
     * @return OK
     */
    searchQuotesByProduct(term: string | undefined, view: QuoteViewScope | undefined, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Quotes/product-search?";
        if (term === null)
            throw new globalThis.Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (view === null)
            throw new globalThis.Error("The parameter 'view' cannot be null.");
        else if (view !== undefined)
            url_ += "view=" + encodeURIComponent("" + view) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchQuotesByProduct(_response);
        });
    }

    protected processSearchQuotesByProduct(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Downloads the rendered PDF for a quote.
     * @return OK
     */
    downloadPdf(quoteId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Quotes/{quoteId}/pdf";
        if (quoteId === undefined || quoteId === null)
            throw new globalThis.Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadPdf(_response);
        });
    }

    protected processDownloadPdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns the storefronts (org units) the caller is permitted to create or view quotes for,
    sourced from SHI.com's `quotes_OU` security action.
     * @return OK
     */
    getQuoteStorefronts( cancelToken?: CancelToken): Promise<QuoteStorefrontDto[]> {
        let url_ = this.baseUrl + "/api/Quotes/quote-storefronts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteStorefronts(_response);
        });
    }

    protected processGetQuoteStorefronts(response: AxiosResponse): Promise<QuoteStorefrontDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteStorefrontDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<QuoteStorefrontDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteStorefrontDto[]>(null as any);
    }

    /**
     * Returns current catalog pricing for a set of product IDs without creating a quote. Uses the
    same catalog lookup as `CreateQuote` so the prices reflect what the user would
    actually pay. Products not found in the catalog return `InCatalog = false`.
     * @param body (optional) 
     * @return OK
     */
    priceCheck(body: PriceCheckRequestDto | undefined, cancelToken?: CancelToken): Promise<PriceCheckResultDto> {
        let url_ = this.baseUrl + "/api/Quotes/price-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPriceCheck(_response);
        });
    }

    protected processPriceCheck(response: AxiosResponse): Promise<PriceCheckResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PriceCheckResultDto.fromJS(resultData200);
            return Promise.resolve<PriceCheckResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriceCheckResultDto>(null as any);
    }

    /**
     * Refreshes an expired quote (SPU-477): a new quote from a name + still-in-catalog items, priced
    server-side. Kept separate from create so create-only options never reach refresh.
     * @param body (optional) 
     * @return Created
     */
    refreshQuote(body: RefreshQuoteRequestDto | undefined, cancelToken?: CancelToken): Promise<CreateQuoteResultDto> {
        let url_ = this.baseUrl + "/api/Quotes/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshQuote(_response);
        });
    }

    protected processRefreshQuote(response: AxiosResponse): Promise<CreateQuoteResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = CreateQuoteResultDto.fromJS(resultData201);
            return Promise.resolve<CreateQuoteResultDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateQuoteResultDto>(null as any);
    }

    /**
     * Returns the estimated tax for a prospective quote (SPU-492). Calculated by the shi.com
    TaxandFee microservice (`GetTax` — the same call shi.com's save-as-quote makes) from the
    included lines, ship-to address, and the selected shipping method's freight cost. The dialog
    only offers tax once shipping is opted in.
     * @param body (optional) 
     * @return OK
     */
    calculateTax(body: QuoteTaxRequestDto | undefined, cancelToken?: CancelToken): Promise<QuoteTaxResultDto> {
        let url_ = this.baseUrl + "/api/Quotes/tax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateTax(_response);
        });
    }

    protected processCalculateTax(response: AxiosResponse): Promise<QuoteTaxResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuoteTaxResultDto.fromJS(resultData200);
            return Promise.resolve<QuoteTaxResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteTaxResultDto>(null as any);
    }

    /**
     * Gets the full detail for a quote (header, customer, public comments, line items, totals).
     * @return OK
     */
    getQuoteDetail(quoteId: number, cancelToken?: CancelToken): Promise<QuoteDetailDto> {
        let url_ = this.baseUrl + "/api/Quotes/{quoteId}/detail";
        if (quoteId === undefined || quoteId === null)
            throw new globalThis.Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteDetail(_response);
        });
    }

    protected processGetQuoteDetail(response: AxiosResponse): Promise<QuoteDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuoteDetailDto.fromJS(resultData200);
            return Promise.resolve<QuoteDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteDetailDto>(null as any);
    }

    /**
     * Unpublishes (soft-deletes) a quote.
     * @return No Content
     */
    deleteQuote(quoteId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Quotes/{quoteId}";
        if (quoteId === undefined || quoteId === null)
            throw new globalThis.Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuote(_response);
        });
    }

    protected processDeleteQuote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Emails a copy of the quote PDF to one or more recipients. Recipients do not need ShiOne access.
     * @param body (optional) 
     * @return OK
     */
    shareQuote(quoteId: number, body: ShareQuoteRequest | undefined, cancelToken?: CancelToken): Promise<ShareQuoteResultDto> {
        let url_ = this.baseUrl + "/api/Quotes/{quoteId}/share";
        if (quoteId === undefined || quoteId === null)
            throw new globalThis.Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShareQuote(_response);
        });
    }

    protected processShareQuote(response: AxiosResponse): Promise<ShareQuoteResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShareQuoteResultDto.fromJS(resultData200);
            return Promise.resolve<ShareQuoteResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShareQuoteResultDto>(null as any);
    }

    /**
     * Returns enriched product-detail-drawer data (images, specs, inventory) for a catalog product,
    for users who can view quotes. Catalog data is not quote-specific, so this simply lets a quotes
    viewer see the details of products in their own org unit — a dedicated, quote-permissioned
    entry point so we don't borrow the standards/orders permission gates. Scoped to the caller's
    current org unit.
     * @param body (optional) 
     * @return OK
     */
    getQuoteProductDetailDrawer(body: ProductDetailDrawerRequestDto | undefined, cancelToken?: CancelToken): Promise<ProductDetailDrawerDto> {
        let url_ = this.baseUrl + "/api/Quotes/product-detail-drawer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteProductDetailDrawer(_response);
        });
    }

    protected processGetQuoteProductDetailDrawer(response: AxiosResponse): Promise<ProductDetailDrawerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDetailDrawerDto.fromJS(resultData200);
            return Promise.resolve<ProductDetailDrawerDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDetailDrawerDto>(null as any);
    }

    /**
     * Retrieves product images only for a catalog product, for users who can view quotes. Used as
    the client-driven retry when the drawer's initial response defers image resolution (see
    ProductDetailDrawerDto.ImagesDeferred and GetQuoteProductDetailDrawer above). Scoped to the
    caller's current org unit, same as the drawer endpoint.
     * @param body (optional) 
     * @return OK
     */
    getQuoteProductDetailDrawerImages(body: ProductDetailDrawerRequestDto | undefined, cancelToken?: CancelToken): Promise<ProductImageDto[]> {
        let url_ = this.baseUrl + "/api/Quotes/product-detail-drawer/images";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteProductDetailDrawerImages(_response);
        });
    }

    protected processGetQuoteProductDetailDrawerImages(response: AxiosResponse): Promise<ProductImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductImageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductImageDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductImageDto[]>(null as any);
    }

    /**
     * Returns the total item quantity (sum of line quantities) for each requested quote the caller may
    access. Quotes the caller cannot access — or that have no items — are omitted. Used to populate
    the list's Total Quantity column lazily for the visible page (the summary list has no quantity).
     * @param ids (optional) 
     * @return OK
     */
    getQuoteQuantities(ids: string | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/Quotes/quantities?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteQuantities(_response);
        });
    }

    protected processGetQuoteQuantities(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }
}

export interface IRecommendationsClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    searchRecommendations(body: GetRecommendationsRequest | undefined,  cancelToken?: CancelToken): Promise<GetRecommendationsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getRecommendationsByIds(body: string[] | undefined,  cancelToken?: CancelToken): Promise<GetRecommendationsByIdsResponse>;
    /**
     * @return OK
     */
    getFilterOptions( cancelToken?: CancelToken): Promise<GetRecommendationFilterOptionsResponse>;
    /**
     * @return OK
     */
    getUnlinkedRecommendationsSummary( cancelToken?: CancelToken): Promise<GetUnlinkedRecommendationsSummaryResponse>;
}

export class RecommendationsClient extends AuthorizedApiBase implements IRecommendationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchRecommendations(body: GetRecommendationsRequest | undefined, cancelToken?: CancelToken): Promise<GetRecommendationsResponse> {
        let url_ = this.baseUrl + "/api/Recommendations/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRecommendations(_response);
        });
    }

    protected processSearchRecommendations(response: AxiosResponse): Promise<GetRecommendationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRecommendationsResponse.fromJS(resultData200);
            return Promise.resolve<GetRecommendationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRecommendationsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRecommendationsByIds(body: string[] | undefined, cancelToken?: CancelToken): Promise<GetRecommendationsByIdsResponse> {
        let url_ = this.baseUrl + "/api/Recommendations/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecommendationsByIds(_response);
        });
    }

    protected processGetRecommendationsByIds(response: AxiosResponse): Promise<GetRecommendationsByIdsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRecommendationsByIdsResponse.fromJS(resultData200);
            return Promise.resolve<GetRecommendationsByIdsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRecommendationsByIdsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getFilterOptions( cancelToken?: CancelToken): Promise<GetRecommendationFilterOptionsResponse> {
        let url_ = this.baseUrl + "/api/Recommendations/filter-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilterOptions(_response);
        });
    }

    protected processGetFilterOptions(response: AxiosResponse): Promise<GetRecommendationFilterOptionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRecommendationFilterOptionsResponse.fromJS(resultData200);
            return Promise.resolve<GetRecommendationFilterOptionsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRecommendationFilterOptionsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getUnlinkedRecommendationsSummary( cancelToken?: CancelToken): Promise<GetUnlinkedRecommendationsSummaryResponse> {
        let url_ = this.baseUrl + "/api/Recommendations/unlinked-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnlinkedRecommendationsSummary(_response);
        });
    }

    protected processGetUnlinkedRecommendationsSummary(response: AxiosResponse): Promise<GetUnlinkedRecommendationsSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUnlinkedRecommendationsSummaryResponse.fromJS(resultData200);
            return Promise.resolve<GetUnlinkedRecommendationsSummaryResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUnlinkedRecommendationsSummaryResponse>(null as any);
    }
}

export interface IRecurringServicesContractsClient {
    /**
     * Get complete contract detail including burndown and monthly breakdown in a single call.
     * @param contractId The contract ID
     * @return Returns the combined contract detail
     */
    getContractDetail(contractId: number,  cancelToken?: CancelToken): Promise<RecurringServicesContractDetailDto>;
    /**
     * Get contract burndown information including all metrics for Overview tab.
     * @param contractId The contract ID
     * @return Returns the contract burndown data
     */
    getContractBurndown(contractId: number,  cancelToken?: CancelToken): Promise<RecurringServicesContractBurndownDto>;
    /**
     * Get monthly breakdown of hours and dollars used per role for Detail tab.
     * @param contractId The contract ID
     * @return Returns the monthly breakdown data
     */
    getMonthlyBreakdown(contractId: number,  cancelToken?: CancelToken): Promise<RecurringServicesContractMonthlyBreakdownDto[]>;
}

export class RecurringServicesContractsClient extends AuthorizedApiBase implements IRecurringServicesContractsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get complete contract detail including burndown and monthly breakdown in a single call.
     * @param contractId The contract ID
     * @return Returns the combined contract detail
     */
    getContractDetail(contractId: number, cancelToken?: CancelToken): Promise<RecurringServicesContractDetailDto> {
        let url_ = this.baseUrl + "/api/RecurringServicesContracts/{contractId}/detail";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractDetail(_response);
        });
    }

    protected processGetContractDetail(response: AxiosResponse): Promise<RecurringServicesContractDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RecurringServicesContractDetailDto.fromJS(resultData200);
            return Promise.resolve<RecurringServicesContractDetailDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized - invalid or missing authentication", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Contract not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecurringServicesContractDetailDto>(null as any);
    }

    /**
     * Get contract burndown information including all metrics for Overview tab.
     * @param contractId The contract ID
     * @return Returns the contract burndown data
     */
    getContractBurndown(contractId: number, cancelToken?: CancelToken): Promise<RecurringServicesContractBurndownDto> {
        let url_ = this.baseUrl + "/api/RecurringServicesContracts/{contractId}/burndown";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractBurndown(_response);
        });
    }

    protected processGetContractBurndown(response: AxiosResponse): Promise<RecurringServicesContractBurndownDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RecurringServicesContractBurndownDto.fromJS(resultData200);
            return Promise.resolve<RecurringServicesContractBurndownDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized - invalid or missing authentication", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Contract not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecurringServicesContractBurndownDto>(null as any);
    }

    /**
     * Get monthly breakdown of hours and dollars used per role for Detail tab.
     * @param contractId The contract ID
     * @return Returns the monthly breakdown data
     */
    getMonthlyBreakdown(contractId: number, cancelToken?: CancelToken): Promise<RecurringServicesContractMonthlyBreakdownDto[]> {
        let url_ = this.baseUrl + "/api/RecurringServicesContracts/{contractId}/monthly-breakdown";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthlyBreakdown(_response);
        });
    }

    protected processGetMonthlyBreakdown(response: AxiosResponse): Promise<RecurringServicesContractMonthlyBreakdownDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecurringServicesContractMonthlyBreakdownDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RecurringServicesContractMonthlyBreakdownDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized - invalid or missing authentication", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Contract not found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecurringServicesContractMonthlyBreakdownDto[]>(null as any);
    }
}

export interface IRegistrationsClient {
    /**
     * @return OK
     */
    getRegistrationRules(ruleName: string,  cancelToken?: CancelToken): Promise<RuleDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    registerRule(body: RuleDto | undefined,  cancelToken?: CancelToken): Promise<FeatureRulesDto[]>;
}

export class RegistrationsClient extends AuthorizedApiBase implements IRegistrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getRegistrationRules(ruleName: string, cancelToken?: CancelToken): Promise<RuleDto> {
        let url_ = this.baseUrl + "/api/notifications/GetRulesAndRegisterUser/{ruleName}";
        if (ruleName === undefined || ruleName === null)
            throw new globalThis.Error("The parameter 'ruleName' must be defined.");
        url_ = url_.replace("{ruleName}", encodeURIComponent("" + ruleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationRules(_response);
        });
    }

    protected processGetRegistrationRules(response: AxiosResponse): Promise<RuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleDto.fromJS(resultData200);
            return Promise.resolve<RuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerRule(body: RuleDto | undefined, cancelToken?: CancelToken): Promise<FeatureRulesDto[]> {
        let url_ = this.baseUrl + "/api/notifications/RegisterRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterRule(_response);
        });
    }

    protected processRegisterRule(response: AxiosResponse): Promise<FeatureRulesDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureRulesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FeatureRulesDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureRulesDto[]>(null as any);
    }
}

export interface IReportClient {
    /**
     * @param filter (optional) 
     * @return OK
     */
    getEmbedParams(reportKey: string, filter: string | undefined,  cancelToken?: CancelToken): Promise<EmbedParams>;
    /**
     * @param filter (optional) 
     * @return OK
     */
    getNewAccessToken(reportKey: string, filter: string | undefined,  cancelToken?: CancelToken): Promise<EmbedToken>;
}

export class ReportClient extends AuthorizedApiBase implements IReportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getEmbedParams(reportKey: string, filter: string | undefined, cancelToken?: CancelToken): Promise<EmbedParams> {
        let url_ = this.baseUrl + "/api/Report/{reportKey}?";
        if (reportKey === undefined || reportKey === null)
            throw new globalThis.Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmbedParams(_response);
        });
    }

    protected processGetEmbedParams(response: AxiosResponse): Promise<EmbedParams> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmbedParams.fromJS(resultData200);
            return Promise.resolve<EmbedParams>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmbedParams>(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getNewAccessToken(reportKey: string, filter: string | undefined, cancelToken?: CancelToken): Promise<EmbedToken> {
        let url_ = this.baseUrl + "/api/Report/{reportKey}?";
        if (reportKey === undefined || reportKey === null)
            throw new globalThis.Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewAccessToken(_response);
        });
    }

    protected processGetNewAccessToken(response: AxiosResponse): Promise<EmbedToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmbedToken.fromJS(resultData200);
            return Promise.resolve<EmbedToken>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmbedToken>(null as any);
    }
}

export interface IReportCenterClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaProducts(body: CiscoIbaSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<CiscoIbaProductResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaEnterpriseAgreements(body: CiscoIbaSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<CiscoIbaEaResponse>;
    /**
     * @return OK
     */
    getCiscoIbaPicklist( cancelToken?: CancelToken): Promise<CiscoIbaPicklistResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSmartNetSlasWidget(body: SmartNetSlasWidgetRequestDto | undefined,  cancelToken?: CancelToken): Promise<SmartNetSlasWidgetResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoGuidsWidget(body: GuidsWidgetRequestDto | undefined,  cancelToken?: CancelToken): Promise<GuidsWidgetResponse>;
    /**
     * @return OK
     */
    getCiscoEaHealthWidget( cancelToken?: CancelToken): Promise<GetCiscoEaHealthWidgetResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaLocationData(body: CiscoIbaSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<CiscoIbaLocationResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaShippedHardware(body: CiscoIbaShippedHardwareRequestDto | undefined,  cancelToken?: CancelToken): Promise<CiscoIbaShippedHardwareResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaBaseInsightsData(body: CiscoIbaSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<CiscoIbaBaseInsightsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoExpiringAssetsData(body: CiscoIbaSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<CiscoIbaExpiringAssetsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaAssets(body: CiscoIbaAssetsSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<CiscoIbaAssetsSearchResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postCiscoIbaTagProducts(body: CiscoIbaUpdateTagsByProductsRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postCiscoIbaTagAssets(body: CiscoIbaUpdateTagsByAssetsRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaLdos(body: CiscoIbaLdosRequestDto | undefined,  cancelToken?: CancelToken): Promise<CiscoIbaLdosResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaAssetsArchitectureLdos(body: CiscoIbaAssetsArchitectureLdosRequestDto | undefined,  cancelToken?: CancelToken): Promise<CiscoIbaAssetsArchitectureLdosResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaEaDetail(body: CiscoIbaAssetsSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<GetCiscoIbaEaDetailResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadCiscoIbaProductTable(body: CiscoIbaTableDownloadRequestDto | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadCiscoIbaLocationTable(body: CiscoIbaTableDownloadRequestDto | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadCiscoIbaProductAssetTable(body: CiscoIbaTableDownloadRequestDto | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
    /**
     * Retrieves available filter options for aging inventory
     * @return OK
     */
    getAgingInventoryPicklist( cancelToken?: CancelToken): Promise<AgingInventoryPicklistResponse>;
    /**
     * Indicates whether the current account has any aging inventory data.
     * @return OK
     */
    hasAgingInventoryData( cancelToken?: CancelToken): Promise<boolean>;
    /**
     * Search aging inventory data with filtering, sorting, and pagination.
     * @param body (optional) Search parameters including filters, pagination, and sorting options
     * @return OK
     */
    searchAgingInventory(body: AgingInventorySearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<AgingInventorySearchResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAgingInventory(body: AgingInventorySearchWithoutPagingRequestDto | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
}

export class ReportCenterClient extends AuthorizedApiBase implements IReportCenterClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaProducts(body: CiscoIbaSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaProductResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaProducts(_response);
        });
    }

    protected processGetCiscoIbaProducts(response: AxiosResponse): Promise<CiscoIbaProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaProductResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaProductResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaProductResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaEnterpriseAgreements(body: CiscoIbaSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaEaResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/enterprise-agreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaEnterpriseAgreements(_response);
        });
    }

    protected processGetCiscoIbaEnterpriseAgreements(response: AxiosResponse): Promise<CiscoIbaEaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaEaResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaEaResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaEaResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCiscoIbaPicklist( cancelToken?: CancelToken): Promise<CiscoIbaPicklistResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba-picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaPicklist(_response);
        });
    }

    protected processGetCiscoIbaPicklist(response: AxiosResponse): Promise<CiscoIbaPicklistResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaPicklistResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaPicklistResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaPicklistResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSmartNetSlasWidget(body: SmartNetSlasWidgetRequestDto | undefined, cancelToken?: CancelToken): Promise<SmartNetSlasWidgetResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/smart-net-slas-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSmartNetSlasWidget(_response);
        });
    }

    protected processGetSmartNetSlasWidget(response: AxiosResponse): Promise<SmartNetSlasWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SmartNetSlasWidgetResponse.fromJS(resultData200);
            return Promise.resolve<SmartNetSlasWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SmartNetSlasWidgetResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoGuidsWidget(body: GuidsWidgetRequestDto | undefined, cancelToken?: CancelToken): Promise<GuidsWidgetResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/guids-widget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoGuidsWidget(_response);
        });
    }

    protected processGetCiscoGuidsWidget(response: AxiosResponse): Promise<GuidsWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GuidsWidgetResponse.fromJS(resultData200);
            return Promise.resolve<GuidsWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidsWidgetResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCiscoEaHealthWidget( cancelToken?: CancelToken): Promise<GetCiscoEaHealthWidgetResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/ea-health-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoEaHealthWidget(_response);
        });
    }

    protected processGetCiscoEaHealthWidget(response: AxiosResponse): Promise<GetCiscoEaHealthWidgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCiscoEaHealthWidgetResponse.fromJS(resultData200);
            return Promise.resolve<GetCiscoEaHealthWidgetResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCiscoEaHealthWidgetResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaLocationData(body: CiscoIbaSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaLocationResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaLocationData(_response);
        });
    }

    protected processGetCiscoIbaLocationData(response: AxiosResponse): Promise<CiscoIbaLocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaLocationResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaLocationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaLocationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaShippedHardware(body: CiscoIbaShippedHardwareRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaShippedHardwareResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/shipped-hardware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaShippedHardware(_response);
        });
    }

    protected processGetCiscoIbaShippedHardware(response: AxiosResponse): Promise<CiscoIbaShippedHardwareResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaShippedHardwareResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaShippedHardwareResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaShippedHardwareResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaBaseInsightsData(body: CiscoIbaSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaBaseInsightsResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/base-insights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaBaseInsightsData(_response);
        });
    }

    protected processGetCiscoIbaBaseInsightsData(response: AxiosResponse): Promise<CiscoIbaBaseInsightsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaBaseInsightsResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaBaseInsightsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaBaseInsightsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoExpiringAssetsData(body: CiscoIbaSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaExpiringAssetsResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/expiring-assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoExpiringAssetsData(_response);
        });
    }

    protected processGetCiscoExpiringAssetsData(response: AxiosResponse): Promise<CiscoIbaExpiringAssetsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaExpiringAssetsResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaExpiringAssetsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaExpiringAssetsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaAssets(body: CiscoIbaAssetsSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaAssetsSearchResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaAssets(_response);
        });
    }

    protected processGetCiscoIbaAssets(response: AxiosResponse): Promise<CiscoIbaAssetsSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaAssetsSearchResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaAssetsSearchResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaAssetsSearchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postCiscoIbaTagProducts(body: CiscoIbaUpdateTagsByProductsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/tag-products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCiscoIbaTagProducts(_response);
        });
    }

    protected processPostCiscoIbaTagProducts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postCiscoIbaTagAssets(body: CiscoIbaUpdateTagsByAssetsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/tag-assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCiscoIbaTagAssets(_response);
        });
    }

    protected processPostCiscoIbaTagAssets(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaLdos(body: CiscoIbaLdosRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaLdosResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/ldos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaLdos(_response);
        });
    }

    protected processGetCiscoIbaLdos(response: AxiosResponse): Promise<CiscoIbaLdosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaLdosResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaLdosResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaLdosResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaAssetsArchitectureLdos(body: CiscoIbaAssetsArchitectureLdosRequestDto | undefined, cancelToken?: CancelToken): Promise<CiscoIbaAssetsArchitectureLdosResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/assets-architecture-ldos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaAssetsArchitectureLdos(_response);
        });
    }

    protected processGetCiscoIbaAssetsArchitectureLdos(response: AxiosResponse): Promise<CiscoIbaAssetsArchitectureLdosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CiscoIbaAssetsArchitectureLdosResponse.fromJS(resultData200);
            return Promise.resolve<CiscoIbaAssetsArchitectureLdosResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CiscoIbaAssetsArchitectureLdosResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCiscoIbaEaDetail(body: CiscoIbaAssetsSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<GetCiscoIbaEaDetailResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/ea-detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCiscoIbaEaDetail(_response);
        });
    }

    protected processGetCiscoIbaEaDetail(response: AxiosResponse): Promise<GetCiscoIbaEaDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCiscoIbaEaDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetCiscoIbaEaDetailResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCiscoIbaEaDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadCiscoIbaProductTable(body: CiscoIbaTableDownloadRequestDto | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/product-table-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCiscoIbaProductTable(_response);
        });
    }

    protected processDownloadCiscoIbaProductTable(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadCiscoIbaLocationTable(body: CiscoIbaTableDownloadRequestDto | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/location-table-download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCiscoIbaLocationTable(_response);
        });
    }

    protected processDownloadCiscoIbaLocationTable(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadCiscoIbaProductAssetTable(body: CiscoIbaTableDownloadRequestDto | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/cisco-iba/product-table-download/assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCiscoIbaProductAssetTable(_response);
        });
    }

    protected processDownloadCiscoIbaProductAssetTable(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }

    /**
     * Retrieves available filter options for aging inventory
     * @return OK
     */
    getAgingInventoryPicklist( cancelToken?: CancelToken): Promise<AgingInventoryPicklistResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/aging-inventory/picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgingInventoryPicklist(_response);
        });
    }

    protected processGetAgingInventoryPicklist(response: AxiosResponse): Promise<AgingInventoryPicklistResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgingInventoryPicklistResponse.fromJS(resultData200);
            return Promise.resolve<AgingInventoryPicklistResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgingInventoryPicklistResponse>(null as any);
    }

    /**
     * Indicates whether the current account has any aging inventory data.
     * @return OK
     */
    hasAgingInventoryData( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ReportCenter/aging-inventory/has-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasAgingInventoryData(_response);
        });
    }

    protected processHasAgingInventoryData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Search aging inventory data with filtering, sorting, and pagination.
     * @param body (optional) Search parameters including filters, pagination, and sorting options
     * @return OK
     */
    searchAgingInventory(body: AgingInventorySearchRequestDto | undefined, cancelToken?: CancelToken): Promise<AgingInventorySearchResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/aging-inventory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAgingInventory(_response);
        });
    }

    protected processSearchAgingInventory(response: AxiosResponse): Promise<AgingInventorySearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgingInventorySearchResponse.fromJS(resultData200);
            return Promise.resolve<AgingInventorySearchResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgingInventorySearchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadAgingInventory(body: AgingInventorySearchWithoutPagingRequestDto | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/ReportCenter/aging-inventory/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAgingInventory(_response);
        });
    }

    protected processDownloadAgingInventory(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }
}

export interface IReportingClient {
    /**
     * Lists the reports the caller can open.
     * @return OK
     */
    getReportCatalog( cancelToken?: CancelToken): Promise<ReportCatalogEntryDto[]>;
    /**
     * Returns a report's definition: columns, date ranges, account scope, and export formats.
     * @return OK
     */
    getReportDefinition(reportKey: string,  cancelToken?: CancelToken): Promise<ReportDefinitionDto>;
    /**
     * Lists the accounts the caller can choose for a report.
     * @return OK
     */
    getReportAccounts(reportKey: string,  cancelToken?: CancelToken): Promise<ReportAccountDto[]>;
    /**
     * Returns one page of report rows for the selected accounts and date range, sorted and filtered as requested.
    Any account outside the caller's scope refuses the whole request with 403.
     * @return OK
     */
    getReportRows(reportKey: string, body: ReportRowsRequestDto,  cancelToken?: CancelToken): Promise<ReportRowsResponseDto>;
    /**
     * Returns the values the user can pick for each pick-list filter, found in the selected accounts and date range.
     * @return OK
     */
    getReportFilterOptions(reportKey: string, body: ReportFilterOptionsRequestDto,  cancelToken?: CancelToken): Promise<IncludeExcludeFilterCategory[]>;
    /**
     * Returns up to 20 values of a search filter that contain the term, found in the selected accounts and date range.
     * @return OK
     */
    getReportFilterValues(reportKey: string, body: ReportFilterValuesRequestDto,  cancelToken?: CancelToken): Promise<string[]>;
}

export class ReportingClient extends AuthorizedApiBase implements IReportingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Lists the reports the caller can open.
     * @return OK
     */
    getReportCatalog( cancelToken?: CancelToken): Promise<ReportCatalogEntryDto[]> {
        let url_ = this.baseUrl + "/api/reporting/reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportCatalog(_response);
        });
    }

    protected processGetReportCatalog(response: AxiosResponse): Promise<ReportCatalogEntryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportCatalogEntryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ReportCatalogEntryDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportCatalogEntryDto[]>(null as any);
    }

    /**
     * Returns a report's definition: columns, date ranges, account scope, and export formats.
     * @return OK
     */
    getReportDefinition(reportKey: string, cancelToken?: CancelToken): Promise<ReportDefinitionDto> {
        let url_ = this.baseUrl + "/api/reporting/reports/{reportKey}/definition";
        if (reportKey === undefined || reportKey === null)
            throw new globalThis.Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportDefinition(_response);
        });
    }

    protected processGetReportDefinition(response: AxiosResponse): Promise<ReportDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDefinitionDto.fromJS(resultData200);
            return Promise.resolve<ReportDefinitionDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDefinitionDto>(null as any);
    }

    /**
     * Lists the accounts the caller can choose for a report.
     * @return OK
     */
    getReportAccounts(reportKey: string, cancelToken?: CancelToken): Promise<ReportAccountDto[]> {
        let url_ = this.baseUrl + "/api/reporting/reports/{reportKey}/accounts";
        if (reportKey === undefined || reportKey === null)
            throw new globalThis.Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportAccounts(_response);
        });
    }

    protected processGetReportAccounts(response: AxiosResponse): Promise<ReportAccountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportAccountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ReportAccountDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportAccountDto[]>(null as any);
    }

    /**
     * Returns one page of report rows for the selected accounts and date range, sorted and filtered as requested.
    Any account outside the caller's scope refuses the whole request with 403.
     * @return OK
     */
    getReportRows(reportKey: string, body: ReportRowsRequestDto, cancelToken?: CancelToken): Promise<ReportRowsResponseDto> {
        let url_ = this.baseUrl + "/api/reporting/reports/{reportKey}/rows";
        if (reportKey === undefined || reportKey === null)
            throw new globalThis.Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportRows(_response);
        });
    }

    protected processGetReportRows(response: AxiosResponse): Promise<ReportRowsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportRowsResponseDto.fromJS(resultData200);
            return Promise.resolve<ReportRowsResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportRowsResponseDto>(null as any);
    }

    /**
     * Returns the values the user can pick for each pick-list filter, found in the selected accounts and date range.
     * @return OK
     */
    getReportFilterOptions(reportKey: string, body: ReportFilterOptionsRequestDto, cancelToken?: CancelToken): Promise<IncludeExcludeFilterCategory[]> {
        let url_ = this.baseUrl + "/api/reporting/reports/{reportKey}/filter-options";
        if (reportKey === undefined || reportKey === null)
            throw new globalThis.Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportFilterOptions(_response);
        });
    }

    protected processGetReportFilterOptions(response: AxiosResponse): Promise<IncludeExcludeFilterCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncludeExcludeFilterCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IncludeExcludeFilterCategory[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncludeExcludeFilterCategory[]>(null as any);
    }

    /**
     * Returns up to 20 values of a search filter that contain the term, found in the selected accounts and date range.
     * @return OK
     */
    getReportFilterValues(reportKey: string, body: ReportFilterValuesRequestDto, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/reporting/reports/{reportKey}/filter-values";
        if (reportKey === undefined || reportKey === null)
            throw new globalThis.Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportFilterValues(_response);
        });
    }

    protected processGetReportFilterValues(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface IRequestConsultationClient {
    /**
     * @return OK
     */
    createRequestConsultation(applicationContext: string,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    submitRequestConsultation(body: CreateRequestConsultationRequest | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class RequestConsultationClient extends AuthorizedApiBase implements IRequestConsultationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    createRequestConsultation(applicationContext: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/RequestConsultation/create-request-consultation/{applicationContext}";
        if (applicationContext === undefined || applicationContext === null)
            throw new globalThis.Error("The parameter 'applicationContext' must be defined.");
        url_ = url_.replace("{applicationContext}", encodeURIComponent("" + applicationContext));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRequestConsultation(_response);
        });
    }

    protected processCreateRequestConsultation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitRequestConsultation(body: CreateRequestConsultationRequest | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/RequestConsultation/create-request-consultation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitRequestConsultation(_response);
        });
    }

    protected processSubmitRequestConsultation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IRequesterRankingsWidgetClient {
    /**
     * @param dateFilterOption (optional) 
     * @return OK
     */
    getRequesterRankings(dateFilterOption: DateFilterOption | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto>;
}

export class RequesterRankingsWidgetClient extends AuthorizedApiBase implements IRequesterRankingsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFilterOption (optional) 
     * @return OK
     */
    getRequesterRankings(dateFilterOption: DateFilterOption | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto> {
        let url_ = this.baseUrl + "/api/widget/requestor-rankings-widget?";
        if (dateFilterOption === null)
            throw new globalThis.Error("The parameter 'dateFilterOption' cannot be null.");
        else if (dateFilterOption !== undefined)
            url_ += "dateFilterOption=" + encodeURIComponent("" + dateFilterOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequesterRankings(_response);
        });
    }

    protected processGetRequesterRankings(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfRequesterRankingsVisualsDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfRequesterRankingsVisualsDto>(null as any);
    }
}

export interface IRequestsMetricsWidgetClient {
    /**
     * @param dateFilterOption (optional) 
     * @return OK
     */
    getRequestMetrics(dateFilterOption: DateFilterOption | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfRequestMetricsVisualsDto>;
}

export class RequestsMetricsWidgetClient extends AuthorizedApiBase implements IRequestsMetricsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFilterOption (optional) 
     * @return OK
     */
    getRequestMetrics(dateFilterOption: DateFilterOption | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfRequestMetricsVisualsDto> {
        let url_ = this.baseUrl + "/api/widget/requests-metrics-widget?";
        if (dateFilterOption === null)
            throw new globalThis.Error("The parameter 'dateFilterOption' cannot be null.");
        else if (dateFilterOption !== undefined)
            url_ += "dateFilterOption=" + encodeURIComponent("" + dateFilterOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestMetrics(_response);
        });
    }

    protected processGetRequestMetrics(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfRequestMetricsVisualsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfRequestMetricsVisualsDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfRequestMetricsVisualsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfRequestMetricsVisualsDto>(null as any);
    }
}

export interface IRoadmapsClient {
    /**
     * @return OK
     */
    getRoadmaps( cancelToken?: CancelToken): Promise<GetRoadmapsByCustomerResponse>;
    /**
     * @return OK
     */
    getRoadmap(roadmapId: string,  cancelToken?: CancelToken): Promise<GetRoadmapByIdResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createRoadmap(body: RoadmapDto | undefined,  cancelToken?: CancelToken): Promise<CreateRoadmapResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateRoadmap(body: RoadmapDto | undefined,  cancelToken?: CancelToken): Promise<UpdateRoadmapResponse>;
    /**
     * @return OK
     */
    deleteRoadmap(roadmapId: string,  cancelToken?: CancelToken): Promise<DeleteRoadmapResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    toggleRoadmapIsCompleted(body: ToggleRoadmapIsCompletedDto | undefined,  cancelToken?: CancelToken): Promise<ToggleRoadmapIsCompletedResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createRoadmapItem(body: RoadmapItemDto | undefined,  cancelToken?: CancelToken): Promise<CreateRoadmapItemResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    bulkCreateRoadmapItems(body: RoadmapItemDto[] | undefined,  cancelToken?: CancelToken): Promise<BulkCreateRoadmapItemsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateRoadmapItem(body: RoadmapItemDto | undefined,  cancelToken?: CancelToken): Promise<UpdateRoadmapItemResponse>;
    /**
     * @return OK
     */
    deleteRoadmapItem(roadmapItemId: string,  cancelToken?: CancelToken): Promise<DeleteRoadmapItemResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    checkSourceLinks(body: string[] | undefined,  cancelToken?: CancelToken): Promise<CheckSourceIdsRoadmapLinkResponse>;
    /**
     * @param fileType (optional) 
     * @param filepond (optional) 
     * @return OK
     */
    uploadRoadmapItemTempFile(fileType: FileTypes | undefined, filepond: FileParameter | undefined,  cancelToken?: CancelToken): Promise<UploadRoadmapItemTempFileResponse>;
    /**
     * @return OK
     */
    downloadRoadmapItemFile(containerName: string, guid: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    setRoadmapsPublishStatus(body: RoadmapDto | undefined,  cancelToken?: CancelToken): Promise<SetRoadmapsPublishStatusResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getRoadmapsAssets(body: RoadmapsAssetsSearchRequestDto | undefined,  cancelToken?: CancelToken): Promise<RoadmapsAssetsSearchResponse>;
}

export class RoadmapsClient extends AuthorizedApiBase implements IRoadmapsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getRoadmaps( cancelToken?: CancelToken): Promise<GetRoadmapsByCustomerResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoadmaps(_response);
        });
    }

    protected processGetRoadmaps(response: AxiosResponse): Promise<GetRoadmapsByCustomerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoadmapsByCustomerResponse.fromJS(resultData200);
            return Promise.resolve<GetRoadmapsByCustomerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoadmapsByCustomerResponse>(null as any);
    }

    /**
     * @return OK
     */
    getRoadmap(roadmapId: string, cancelToken?: CancelToken): Promise<GetRoadmapByIdResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/{roadmapId}";
        if (roadmapId === undefined || roadmapId === null)
            throw new globalThis.Error("The parameter 'roadmapId' must be defined.");
        url_ = url_.replace("{roadmapId}", encodeURIComponent("" + roadmapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoadmap(_response);
        });
    }

    protected processGetRoadmap(response: AxiosResponse): Promise<GetRoadmapByIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoadmapByIdResponse.fromJS(resultData200);
            return Promise.resolve<GetRoadmapByIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoadmapByIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRoadmap(body: RoadmapDto | undefined, cancelToken?: CancelToken): Promise<CreateRoadmapResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRoadmap(_response);
        });
    }

    protected processCreateRoadmap(response: AxiosResponse): Promise<CreateRoadmapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRoadmapResponse.fromJS(resultData200);
            return Promise.resolve<CreateRoadmapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRoadmapResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateRoadmap(body: RoadmapDto | undefined, cancelToken?: CancelToken): Promise<UpdateRoadmapResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRoadmap(_response);
        });
    }

    protected processUpdateRoadmap(response: AxiosResponse): Promise<UpdateRoadmapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRoadmapResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRoadmapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRoadmapResponse>(null as any);
    }

    /**
     * @return OK
     */
    deleteRoadmap(roadmapId: string, cancelToken?: CancelToken): Promise<DeleteRoadmapResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/delete/{roadmapId}";
        if (roadmapId === undefined || roadmapId === null)
            throw new globalThis.Error("The parameter 'roadmapId' must be defined.");
        url_ = url_.replace("{roadmapId}", encodeURIComponent("" + roadmapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRoadmap(_response);
        });
    }

    protected processDeleteRoadmap(response: AxiosResponse): Promise<DeleteRoadmapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteRoadmapResponse.fromJS(resultData200);
            return Promise.resolve<DeleteRoadmapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteRoadmapResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    toggleRoadmapIsCompleted(body: ToggleRoadmapIsCompletedDto | undefined, cancelToken?: CancelToken): Promise<ToggleRoadmapIsCompletedResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/set-completed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleRoadmapIsCompleted(_response);
        });
    }

    protected processToggleRoadmapIsCompleted(response: AxiosResponse): Promise<ToggleRoadmapIsCompletedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ToggleRoadmapIsCompletedResponse.fromJS(resultData200);
            return Promise.resolve<ToggleRoadmapIsCompletedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ToggleRoadmapIsCompletedResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRoadmapItem(body: RoadmapItemDto | undefined, cancelToken?: CancelToken): Promise<CreateRoadmapItemResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmap-item/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRoadmapItem(_response);
        });
    }

    protected processCreateRoadmapItem(response: AxiosResponse): Promise<CreateRoadmapItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRoadmapItemResponse.fromJS(resultData200);
            return Promise.resolve<CreateRoadmapItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRoadmapItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkCreateRoadmapItems(body: RoadmapItemDto[] | undefined, cancelToken?: CancelToken): Promise<BulkCreateRoadmapItemsResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmap-item/bulk-create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkCreateRoadmapItems(_response);
        });
    }

    protected processBulkCreateRoadmapItems(response: AxiosResponse): Promise<BulkCreateRoadmapItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BulkCreateRoadmapItemsResponse.fromJS(resultData200);
            return Promise.resolve<BulkCreateRoadmapItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkCreateRoadmapItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateRoadmapItem(body: RoadmapItemDto | undefined, cancelToken?: CancelToken): Promise<UpdateRoadmapItemResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmap-item/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRoadmapItem(_response);
        });
    }

    protected processUpdateRoadmapItem(response: AxiosResponse): Promise<UpdateRoadmapItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRoadmapItemResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRoadmapItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRoadmapItemResponse>(null as any);
    }

    /**
     * @return OK
     */
    deleteRoadmapItem(roadmapItemId: string, cancelToken?: CancelToken): Promise<DeleteRoadmapItemResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmap-item/delete/{roadmapItemId}";
        if (roadmapItemId === undefined || roadmapItemId === null)
            throw new globalThis.Error("The parameter 'roadmapItemId' must be defined.");
        url_ = url_.replace("{roadmapItemId}", encodeURIComponent("" + roadmapItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRoadmapItem(_response);
        });
    }

    protected processDeleteRoadmapItem(response: AxiosResponse): Promise<DeleteRoadmapItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteRoadmapItemResponse.fromJS(resultData200);
            return Promise.resolve<DeleteRoadmapItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteRoadmapItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkSourceLinks(body: string[] | undefined, cancelToken?: CancelToken): Promise<CheckSourceIdsRoadmapLinkResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/check-source-links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckSourceLinks(_response);
        });
    }

    protected processCheckSourceLinks(response: AxiosResponse): Promise<CheckSourceIdsRoadmapLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckSourceIdsRoadmapLinkResponse.fromJS(resultData200);
            return Promise.resolve<CheckSourceIdsRoadmapLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckSourceIdsRoadmapLinkResponse>(null as any);
    }

    /**
     * @param fileType (optional) 
     * @param filepond (optional) 
     * @return OK
     */
    uploadRoadmapItemTempFile(fileType: FileTypes | undefined, filepond: FileParameter | undefined, cancelToken?: CancelToken): Promise<UploadRoadmapItemTempFileResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmap-item/files/temp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileType === null || fileType === undefined)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("FileType", fileType.toString());
        if (filepond === null || filepond === undefined)
            throw new globalThis.Error("The parameter 'filepond' cannot be null.");
        else
            content_.append("filepond", filepond.data, filepond.fileName ? filepond.fileName : "filepond");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadRoadmapItemTempFile(_response);
        });
    }

    protected processUploadRoadmapItemTempFile(response: AxiosResponse): Promise<UploadRoadmapItemTempFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadRoadmapItemTempFileResponse.fromJS(resultData200);
            return Promise.resolve<UploadRoadmapItemTempFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadRoadmapItemTempFileResponse>(null as any);
    }

    /**
     * @return OK
     */
    downloadRoadmapItemFile(containerName: string, guid: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmap-item/files/download/{containerName}/{guid}";
        if (containerName === undefined || containerName === null)
            throw new globalThis.Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadRoadmapItemFile(_response);
        });
    }

    protected processDownloadRoadmapItemFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setRoadmapsPublishStatus(body: RoadmapDto | undefined, cancelToken?: CancelToken): Promise<SetRoadmapsPublishStatusResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/set-roadmap-publish-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRoadmapsPublishStatus(_response);
        });
    }

    protected processSetRoadmapsPublishStatus(response: AxiosResponse): Promise<SetRoadmapsPublishStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetRoadmapsPublishStatusResponse.fromJS(resultData200);
            return Promise.resolve<SetRoadmapsPublishStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetRoadmapsPublishStatusResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRoadmapsAssets(body: RoadmapsAssetsSearchRequestDto | undefined, cancelToken?: CancelToken): Promise<RoadmapsAssetsSearchResponse> {
        let url_ = this.baseUrl + "/api/Roadmaps/roadmaps/assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoadmapsAssets(_response);
        });
    }

    protected processGetRoadmapsAssets(response: AxiosResponse): Promise<RoadmapsAssetsSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoadmapsAssetsSearchResponse.fromJS(resultData200);
            return Promise.resolve<RoadmapsAssetsSearchResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoadmapsAssetsSearchResponse>(null as any);
    }
}

export interface ISampleEmptyWidgetClient {
    /**
     * @return OK
     */
    getSampleEmptyWidget( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto>;
}

export class SampleEmptyWidgetClient extends AuthorizedApiBase implements ISampleEmptyWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getSampleEmptyWidget( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        let url_ = this.baseUrl + "/api/widget/sample-empty-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleEmptyWidget(_response);
        });
    }

    protected processGetSampleEmptyWidget(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfPieChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(null as any);
    }
}

export interface ISampleErrorWidgetClient {
    /**
     * @return OK
     */
    getSampleErrorWidget( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto>;
}

export class SampleErrorWidgetClient extends AuthorizedApiBase implements ISampleErrorWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getSampleErrorWidget( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        let url_ = this.baseUrl + "/api/widget/sample-error-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleErrorWidget(_response);
        });
    }

    protected processGetSampleErrorWidget(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfPieChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(null as any);
    }
}

export interface ISampleWidgetAClient {
    /**
     * @return OK
     */
    getSampleWidgetA( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfString>;
}

export class SampleWidgetAClient extends AuthorizedApiBase implements ISampleWidgetAClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getSampleWidgetA( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfString> {
        let url_ = this.baseUrl + "/api/widget/sample-widget-a";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleWidgetA(_response);
        });
    }

    protected processGetSampleWidgetA(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfString.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfString>(null as any);
    }
}

export interface ISampleWidgetBClient {
    /**
     * @return OK
     */
    getSampleWidgetB( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfSampleWidgetBResponseDto>;
}

export class SampleWidgetBClient extends AuthorizedApiBase implements ISampleWidgetBClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getSampleWidgetB( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfSampleWidgetBResponseDto> {
        let url_ = this.baseUrl + "/api/widget/sample-widget-b";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleWidgetB(_response);
        });
    }

    protected processGetSampleWidgetB(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfSampleWidgetBResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfSampleWidgetBResponseDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfSampleWidgetBResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfSampleWidgetBResponseDto>(null as any);
    }
}

export interface ISampleWidgetCClient {
    /**
     * @return OK
     */
    getSampleWidgetC( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto>;
}

export class SampleWidgetCClient extends AuthorizedApiBase implements ISampleWidgetCClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getSampleWidgetC( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        let url_ = this.baseUrl + "/api/widget/sample-widget-c";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleWidgetC(_response);
        });
    }

    protected processGetSampleWidgetC(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfPieChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(null as any);
    }
}

export interface ISecretManagerClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    createUpdateSecret(body: CreateUpdateSecretDto | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteSecret(body: DeleteSecretDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSecret(body: GetSecretDto | undefined,  cancelToken?: CancelToken): Promise<string>;
}

export class SecretManagerClient extends AuthorizedApiBase implements ISecretManagerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createUpdateSecret(body: CreateUpdateSecretDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/SecretManager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUpdateSecret(_response);
        });
    }

    protected processCreateUpdateSecret(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteSecret(body: DeleteSecretDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/SecretManager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSecret(_response);
        });
    }

    protected processDeleteSecret(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSecret(body: GetSecretDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/SecretManager/getsecret";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSecret(_response);
        });
    }

    protected processGetSecret(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ISecurityGroupClient {
    /**
     * Creates a new security group for the current user's account.
     * @param body (optional) 
     * @return OK
     */
    createSecurityGroup(body: SecurityGroupNameRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Lists every security group for the current user's account.
     * @return OK
     */
    listSecurityGroups( cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto[]>;
    /**
     * Lists the security groups the current user belongs to (or all, if a global admin).
     * @return OK
     */
    getMySecurityGroups( cancelToken?: CancelToken): Promise<MySecurityGroupsResponse>;
    /**
     * Gets a single security group owned by the current user's account.
     * @return OK
     */
    getSecurityGroup(id: number,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Renames a security group. Default and system groups cannot be renamed.
     * @param body (optional) 
     * @return OK
     */
    renameSecurityGroup(id: number, body: SecurityGroupNameRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Deletes a security group. Default and system groups cannot be deleted.
     * @return OK
     */
    deleteSecurityGroup(id: number,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Adds members to a security group by CustomerExperienceUser id.
     * @param body (optional) 
     * @return OK
     */
    addMembers(id: number, body: SecurityGroupMemberIdsRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Removes members from a security group by CustomerExperienceUser id.
     * @param body (optional) 
     * @return OK
     */
    removeMembers(id: number, body: SecurityGroupMemberIdsRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Sets whether a member can edit the security group. Requires CustomerAdmin, or the caller must already be a manager of the group.
     * @param body (optional) 
     * @return OK
     */
    setMemberCanEdit(id: number, userId: string, body: SetSecurityGroupMemberCanEditRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Replaces the full set of permissions granted to a security group.
     * @param body (optional) 
     * @return OK
     */
    setPermissions(id: number, body: SetSecurityGroupPermissionsRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Attaches Autotask contracts to a security group's support-request scope.
     * @param body (optional) 
     * @return OK
     */
    addContracts(id: number, body: SecurityGroupContractIdsRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Removes Autotask contracts from a security group's support-request scope.
     * @param body (optional) 
     * @return OK
     */
    removeContracts(id: number, body: SecurityGroupContractIdsRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Attaches Autotask configuration items to a security group after validating their
    owning contract and account scope.
     * @param body (optional) 
     * @return OK
     */
    addConfigItems(id: number, body: AddSecurityGroupConfigItemsRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Removes Autotask configuration items from a security group.
     * @param body (optional) 
     * @return OK
     */
    removeConfigItems(id: number, body: RemoveSecurityGroupConfigItemsRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Replaces the ticket-category-mapping issue-type scope for the group's attached contracts.
     * @param body (optional) 
     * @return OK
     */
    setTicketCategoryMappings(id: number, body: SetSecurityGroupTicketCategoryMappingsRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
    /**
     * Replaces ticket-category mappings and adds/removes config items in a single request, for
    the "Contract Request Permissions" dialog's one Save action. Combining both into a single
    call avoids the two separate requests racing against each other.
     * @param body (optional) 
     * @return OK
     */
    setContractRequestPermissions(id: number, body: SetContractRequestPermissionsRequest | undefined,  cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto>;
}

export class SecurityGroupClient extends AuthorizedApiBase implements ISecurityGroupClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Creates a new security group for the current user's account.
     * @param body (optional) 
     * @return OK
     */
    createSecurityGroup(body: SecurityGroupNameRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSecurityGroup(_response);
        });
    }

    protected processCreateSecurityGroup(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Lists every security group for the current user's account.
     * @return OK
     */
    listSecurityGroups( cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto[]> {
        let url_ = this.baseUrl + "/api/security-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSecurityGroups(_response);
        });
    }

    protected processListSecurityGroups(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CxSecurityGroupDetailsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CxSecurityGroupDetailsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto[]>(null as any);
    }

    /**
     * Lists the security groups the current user belongs to (or all, if a global admin).
     * @return OK
     */
    getMySecurityGroups( cancelToken?: CancelToken): Promise<MySecurityGroupsResponse> {
        let url_ = this.baseUrl + "/api/security-groups/mine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMySecurityGroups(_response);
        });
    }

    protected processGetMySecurityGroups(response: AxiosResponse): Promise<MySecurityGroupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MySecurityGroupsResponse.fromJS(resultData200);
            return Promise.resolve<MySecurityGroupsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MySecurityGroupsResponse>(null as any);
    }

    /**
     * Gets a single security group owned by the current user's account.
     * @return OK
     */
    getSecurityGroup(id: number, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSecurityGroup(_response);
        });
    }

    protected processGetSecurityGroup(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Renames a security group. Default and system groups cannot be renamed.
     * @param body (optional) 
     * @return OK
     */
    renameSecurityGroup(id: number, body: SecurityGroupNameRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameSecurityGroup(_response);
        });
    }

    protected processRenameSecurityGroup(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Deletes a security group. Default and system groups cannot be deleted.
     * @return OK
     */
    deleteSecurityGroup(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/security-groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSecurityGroup(_response);
        });
    }

    protected processDeleteSecurityGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Adds members to a security group by CustomerExperienceUser id.
     * @param body (optional) 
     * @return OK
     */
    addMembers(id: number, body: SecurityGroupMemberIdsRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/members";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMembers(_response);
        });
    }

    protected processAddMembers(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Removes members from a security group by CustomerExperienceUser id.
     * @param body (optional) 
     * @return OK
     */
    removeMembers(id: number, body: SecurityGroupMemberIdsRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/members/remove";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveMembers(_response);
        });
    }

    protected processRemoveMembers(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Sets whether a member can edit the security group. Requires CustomerAdmin, or the caller must already be a manager of the group.
     * @param body (optional) 
     * @return OK
     */
    setMemberCanEdit(id: number, userId: string, body: SetSecurityGroupMemberCanEditRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/members/{userId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMemberCanEdit(_response);
        });
    }

    protected processSetMemberCanEdit(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Replaces the full set of permissions granted to a security group.
     * @param body (optional) 
     * @return OK
     */
    setPermissions(id: number, body: SetSecurityGroupPermissionsRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/permissions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPermissions(_response);
        });
    }

    protected processSetPermissions(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Attaches Autotask contracts to a security group's support-request scope.
     * @param body (optional) 
     * @return OK
     */
    addContracts(id: number, body: SecurityGroupContractIdsRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/contracts";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddContracts(_response);
        });
    }

    protected processAddContracts(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Removes Autotask contracts from a security group's support-request scope.
     * @param body (optional) 
     * @return OK
     */
    removeContracts(id: number, body: SecurityGroupContractIdsRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/contracts/remove";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveContracts(_response);
        });
    }

    protected processRemoveContracts(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Attaches Autotask configuration items to a security group after validating their
    owning contract and account scope.
     * @param body (optional) 
     * @return OK
     */
    addConfigItems(id: number, body: AddSecurityGroupConfigItemsRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/config-items";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddConfigItems(_response);
        });
    }

    protected processAddConfigItems(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Removes Autotask configuration items from a security group.
     * @param body (optional) 
     * @return OK
     */
    removeConfigItems(id: number, body: RemoveSecurityGroupConfigItemsRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/config-items/remove";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveConfigItems(_response);
        });
    }

    protected processRemoveConfigItems(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Replaces the ticket-category-mapping issue-type scope for the group's attached contracts.
     * @param body (optional) 
     * @return OK
     */
    setTicketCategoryMappings(id: number, body: SetSecurityGroupTicketCategoryMappingsRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/ticket-category-mappings";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTicketCategoryMappings(_response);
        });
    }

    protected processSetTicketCategoryMappings(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }

    /**
     * Replaces ticket-category mappings and adds/removes config items in a single request, for
    the "Contract Request Permissions" dialog's one Save action. Combining both into a single
    call avoids the two separate requests racing against each other.
     * @param body (optional) 
     * @return OK
     */
    setContractRequestPermissions(id: number, body: SetContractRequestPermissionsRequest | undefined, cancelToken?: CancelToken): Promise<CxSecurityGroupDetailsDto> {
        let url_ = this.baseUrl + "/api/security-groups/{id}/contract-request-permissions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetContractRequestPermissions(_response);
        });
    }

    protected processSetContractRequestPermissions(response: AxiosResponse): Promise<CxSecurityGroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxSecurityGroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<CxSecurityGroupDetailsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDetailsDto>(null as any);
    }
}

export interface ISecurityGroupMetadataClient {
    /**
     * Account-wide catalog of permission actions assignable to any security group. Not group-specific.
     * @return OK
     */
    getResourceDefinitions( cancelToken?: CancelToken): Promise<ResourceDefinition[]>;
    /**
     * @return OK
     */
    getTeamContracts( cancelToken?: CancelToken): Promise<TeamContractReponse>;
}

export class SecurityGroupMetadataClient extends AuthorizedApiBase implements ISecurityGroupMetadataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Account-wide catalog of permission actions assignable to any security group. Not group-specific.
     * @return OK
     */
    getResourceDefinitions( cancelToken?: CancelToken): Promise<ResourceDefinition[]> {
        let url_ = this.baseUrl + "/api/Team/resourceDefinitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceDefinitions(_response);
        });
    }

    protected processGetResourceDefinitions(response: AxiosResponse): Promise<ResourceDefinition[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceDefinition.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ResourceDefinition[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceDefinition[]>(null as any);
    }

    /**
     * @return OK
     */
    getTeamContracts( cancelToken?: CancelToken): Promise<TeamContractReponse> {
        let url_ = this.baseUrl + "/api/Team/teamContracts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeamContracts(_response);
        });
    }

    protected processGetTeamContracts(response: AxiosResponse): Promise<TeamContractReponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamContractReponse.fromJS(resultData200);
            return Promise.resolve<TeamContractReponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamContractReponse>(null as any);
    }
}

export interface ISelfServiceDatasetClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    createSelfReportingDataset(body: SelfServiceDatasetRequest | undefined,  cancelToken?: CancelToken): Promise<SelfServiceDatasetDto>;
    /**
     * @return OK
     */
    getDatasets( cancelToken?: CancelToken): Promise<SelfServiceDatasetsDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateSelfServiceDataset(body: SelfServiceDatasetDto | undefined,  cancelToken?: CancelToken): Promise<SelfServiceDatasetDto>;
}

export class SelfServiceDatasetClient extends AuthorizedApiBase implements ISelfServiceDatasetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSelfReportingDataset(body: SelfServiceDatasetRequest | undefined, cancelToken?: CancelToken): Promise<SelfServiceDatasetDto> {
        let url_ = this.baseUrl + "/api/SelfServiceDataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSelfReportingDataset(_response);
        });
    }

    protected processCreateSelfReportingDataset(response: AxiosResponse): Promise<SelfServiceDatasetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfServiceDatasetDto.fromJS(resultData200);
            return Promise.resolve<SelfServiceDatasetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfServiceDatasetDto>(null as any);
    }

    /**
     * @return OK
     */
    getDatasets( cancelToken?: CancelToken): Promise<SelfServiceDatasetsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceDataset";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDatasets(_response);
        });
    }

    protected processGetDatasets(response: AxiosResponse): Promise<SelfServiceDatasetsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfServiceDatasetsDto.fromJS(resultData200);
            return Promise.resolve<SelfServiceDatasetsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfServiceDatasetsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSelfServiceDataset(body: SelfServiceDatasetDto | undefined, cancelToken?: CancelToken): Promise<SelfServiceDatasetDto> {
        let url_ = this.baseUrl + "/api/SelfServiceDataset/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSelfServiceDataset(_response);
        });
    }

    protected processUpdateSelfServiceDataset(response: AxiosResponse): Promise<SelfServiceDatasetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfServiceDatasetDto.fromJS(resultData200);
            return Promise.resolve<SelfServiceDatasetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfServiceDatasetDto>(null as any);
    }
}

export interface ISelfServiceEnvironmentsClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    createSelfReportingEnvironment(body: SelfServiceEnvironmentRequest | undefined,  cancelToken?: CancelToken): Promise<SelfServiceEnvironmentDto>;
    /**
     * @return OK
     */
    getAccountsPendingEnvironments( cancelToken?: CancelToken): Promise<AccountsPendingSelfServiceEnvironmentCreationDto>;
}

export class SelfServiceEnvironmentsClient extends AuthorizedApiBase implements ISelfServiceEnvironmentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSelfReportingEnvironment(body: SelfServiceEnvironmentRequest | undefined, cancelToken?: CancelToken): Promise<SelfServiceEnvironmentDto> {
        let url_ = this.baseUrl + "/api/SelfServiceEnvironments/self-service-environment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSelfReportingEnvironment(_response);
        });
    }

    protected processCreateSelfReportingEnvironment(response: AxiosResponse): Promise<SelfServiceEnvironmentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelfServiceEnvironmentDto.fromJS(resultData200);
            return Promise.resolve<SelfServiceEnvironmentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelfServiceEnvironmentDto>(null as any);
    }

    /**
     * @return OK
     */
    getAccountsPendingEnvironments( cancelToken?: CancelToken): Promise<AccountsPendingSelfServiceEnvironmentCreationDto> {
        let url_ = this.baseUrl + "/api/SelfServiceEnvironments/account-details-for-environments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountsPendingEnvironments(_response);
        });
    }

    protected processGetAccountsPendingEnvironments(response: AxiosResponse): Promise<AccountsPendingSelfServiceEnvironmentCreationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountsPendingSelfServiceEnvironmentCreationDto.fromJS(resultData200);
            return Promise.resolve<AccountsPendingSelfServiceEnvironmentCreationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountsPendingSelfServiceEnvironmentCreationDto>(null as any);
    }
}

export interface ISelfServiceIntegrationsClient {
    /**
     * @return OK
     */
    getActiveSelfServiceIntegrations( cancelToken?: CancelToken): Promise<ActiveSelfServiceIntegrationDto[]>;
}

export class SelfServiceIntegrationsClient extends AuthorizedApiBase implements ISelfServiceIntegrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getActiveSelfServiceIntegrations( cancelToken?: CancelToken): Promise<ActiveSelfServiceIntegrationDto[]> {
        let url_ = this.baseUrl + "/api/SelfServiceIntegrations/active-integrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveSelfServiceIntegrations(_response);
        });
    }

    protected processGetActiveSelfServiceIntegrations(response: AxiosResponse): Promise<ActiveSelfServiceIntegrationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveSelfServiceIntegrationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ActiveSelfServiceIntegrationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveSelfServiceIntegrationDto[]>(null as any);
    }
}

export interface ISelfServiceReportClient {
    /**
     * @return OK
     */
    getReports( cancelToken?: CancelToken): Promise<ReportsDto>;
    /**
     * @return OK
     */
    getReport(reportId: string,  cancelToken?: CancelToken): Promise<ReportDto>;
    /**
     * @return OK
     */
    createReport(reportId: string,  cancelToken?: CancelToken): Promise<ReportDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    publishReport(body: ReportDto | undefined,  cancelToken?: CancelToken): Promise<ReportsDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    unpublishReport(body: ReportDto | undefined,  cancelToken?: CancelToken): Promise<ReportsDto>;
    /**
     * @return OK
     */
    deleteReport(reportId: number,  cancelToken?: CancelToken): Promise<ReportsDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    discardChanges(body: number | undefined,  cancelToken?: CancelToken): Promise<ReportsDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    discardChangesAndTakeOwnership(body: number | undefined,  cancelToken?: CancelToken): Promise<ReportsDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    fallBackToDraftVersion(body: number | undefined,  cancelToken?: CancelToken): Promise<ReportDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    beginEditReport(body: number | undefined,  cancelToken?: CancelToken): Promise<ReportDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    duplicateReport(body: DuplicateReportRequest | undefined,  cancelToken?: CancelToken): Promise<ReportDto>;
    /**
     * @return OK
     */
    getEmbedToken( cancelToken?: CancelToken): Promise<EmbedToken>;
    /**
     * @return OK
     */
    getReportHistory(reportId: number,  cancelToken?: CancelToken): Promise<GetReportHistory>;
}

export class SelfServiceReportClient extends AuthorizedApiBase implements ISelfServiceReportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getReports( cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReports(_response);
        });
    }

    protected processGetReports(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @return OK
     */
    getReport(reportId: string, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new globalThis.Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @return OK
     */
    createReport(reportId: string, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new globalThis.Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReport(_response);
        });
    }

    protected processCreateReport(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    publishReport(body: ReportDto | undefined, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishReport(_response);
        });
    }

    protected processPublishReport(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unpublishReport(body: ReportDto | undefined, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/unpublish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnpublishReport(_response);
        });
    }

    protected processUnpublishReport(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @return OK
     */
    deleteReport(reportId: number, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/delete/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new globalThis.Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReport(_response);
        });
    }

    protected processDeleteReport(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    discardChanges(body: number | undefined, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/discard-changes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscardChanges(_response);
        });
    }

    protected processDiscardChanges(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    discardChangesAndTakeOwnership(body: number | undefined, cancelToken?: CancelToken): Promise<ReportsDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/discard-changes-and-take-ownership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscardChangesAndTakeOwnership(_response);
        });
    }

    protected processDiscardChangesAndTakeOwnership(response: AxiosResponse): Promise<ReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportsDto.fromJS(resultData200);
            return Promise.resolve<ReportsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fallBackToDraftVersion(body: number | undefined, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/fall-back";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFallBackToDraftVersion(_response);
        });
    }

    protected processFallBackToDraftVersion(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    beginEditReport(body: number | undefined, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/begin-edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBeginEditReport(_response);
        });
    }

    protected processBeginEditReport(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    duplicateReport(body: DuplicateReportRequest | undefined, cancelToken?: CancelToken): Promise<ReportDto> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/duplicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicateReport(_response);
        });
    }

    protected processDuplicateReport(response: AxiosResponse): Promise<ReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDto.fromJS(resultData200);
            return Promise.resolve<ReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDto>(null as any);
    }

    /**
     * @return OK
     */
    getEmbedToken( cancelToken?: CancelToken): Promise<EmbedToken> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmbedToken(_response);
        });
    }

    protected processGetEmbedToken(response: AxiosResponse): Promise<EmbedToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmbedToken.fromJS(resultData200);
            return Promise.resolve<EmbedToken>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmbedToken>(null as any);
    }

    /**
     * @return OK
     */
    getReportHistory(reportId: number, cancelToken?: CancelToken): Promise<GetReportHistory> {
        let url_ = this.baseUrl + "/api/SelfServiceReport/report/history/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new globalThis.Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportHistory(_response);
        });
    }

    protected processGetReportHistory(response: AxiosResponse): Promise<GetReportHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetReportHistory.fromJS(resultData200);
            return Promise.resolve<GetReportHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportHistory>(null as any);
    }
}

export interface IServiceCatalogClient {
    /**
     * Gets all service catalog items from the cached SharePoint source.
     * @return OK
     */
    getAllServiceCatalogsFromSharepoint( cancelToken?: CancelToken): Promise<ServiceCatalogDto[]>;
    /**
     * Gets the logo for the specified service catalog item.
     * @param imageId The logo image identifier.
     * @return OK
     */
    getLogo(imageId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Searches the service catalog by search term.
     * @param searchTerm The search term.
     * @return OK
     */
    searchAvailableServiceCatalogsFromSharepoint(searchTerm: string,  cancelToken?: CancelToken): Promise<ServiceCatalogDto[]>;
    /**
     * Gets a paginated service catalog result.
     * @param pageNumber (optional) The page number.
     * @param pageSize (optional) The page size.
     * @param body (optional) The search and filter criteria.
     * @return OK
     */
    getPaginatedServiceCatalog(pageNumber: number | undefined, pageSize: number | undefined, body: SearchFilter | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfServiceCatalogDto>;
    /**
     * Submits a service catalog access request for the current user.
     * @param body (optional) The requested service catalog item.
     * @return OK
     */
    requestAccess(body: ServiceCatalogDto | undefined,  cancelToken?: CancelToken): Promise<ServiceCatalogAccessResponse>;
}

export class ServiceCatalogClient extends AuthorizedApiBase implements IServiceCatalogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets all service catalog items from the cached SharePoint source.
     * @return OK
     */
    getAllServiceCatalogsFromSharepoint( cancelToken?: CancelToken): Promise<ServiceCatalogDto[]> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/getAllServiceCatalogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllServiceCatalogsFromSharepoint(_response);
        });
    }

    protected processGetAllServiceCatalogsFromSharepoint(response: AxiosResponse): Promise<ServiceCatalogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCatalogDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceCatalogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceCatalogDto[]>(null as any);
    }

    /**
     * Gets the logo for the specified service catalog item.
     * @param imageId The logo image identifier.
     * @return OK
     */
    getLogo(imageId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/logo/{imageId}";
        if (imageId === undefined || imageId === null)
            throw new globalThis.Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogo(_response);
        });
    }

    protected processGetLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Searches the service catalog by search term.
     * @param searchTerm The search term.
     * @return OK
     */
    searchAvailableServiceCatalogsFromSharepoint(searchTerm: string, cancelToken?: CancelToken): Promise<ServiceCatalogDto[]> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/search/sharepoint/{searchTerm}";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAvailableServiceCatalogsFromSharepoint(_response);
        });
    }

    protected processSearchAvailableServiceCatalogsFromSharepoint(response: AxiosResponse): Promise<ServiceCatalogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCatalogDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceCatalogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceCatalogDto[]>(null as any);
    }

    /**
     * Gets a paginated service catalog result.
     * @param pageNumber (optional) The page number.
     * @param pageSize (optional) The page size.
     * @param body (optional) The search and filter criteria.
     * @return OK
     */
    getPaginatedServiceCatalog(pageNumber: number | undefined, pageSize: number | undefined, body: SearchFilter | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfServiceCatalogDto> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/paging?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaginatedServiceCatalog(_response);
        });
    }

    protected processGetPaginatedServiceCatalog(response: AxiosResponse): Promise<PaginatedResultDto_1OfServiceCatalogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfServiceCatalogDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfServiceCatalogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfServiceCatalogDto>(null as any);
    }

    /**
     * Submits a service catalog access request for the current user.
     * @param body (optional) The requested service catalog item.
     * @return OK
     */
    requestAccess(body: ServiceCatalogDto | undefined, cancelToken?: CancelToken): Promise<ServiceCatalogAccessResponse> {
        let url_ = this.baseUrl + "/api/ServiceCatalog/request-access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestAccess(_response);
        });
    }

    protected processRequestAccess(response: AxiosResponse): Promise<ServiceCatalogAccessResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceCatalogAccessResponse.fromJS(resultData200);
            return Promise.resolve<ServiceCatalogAccessResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceCatalogAccessResponse>(null as any);
    }
}

export interface IServiceContractsWidgetClient {
    /**
     * @return OK
     */
    getServiceContractsWidgetData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfServiceContractsWidgetDto>;
    /**
     * @param expirationDate (optional) 
     * @return OK
     */
    getServicesExpiringContractsWidgetData(expirationDate: Date | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto>;
}

export class ServiceContractsWidgetClient extends AuthorizedApiBase implements IServiceContractsWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getServiceContractsWidgetData( cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfServiceContractsWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/service-contracts-widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceContractsWidgetData(_response);
        });
    }

    protected processGetServiceContractsWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfServiceContractsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfServiceContractsWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfServiceContractsWidgetDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfServiceContractsWidgetDto>(null as any);
    }

    /**
     * @param expirationDate (optional) 
     * @return OK
     */
    getServicesExpiringContractsWidgetData(expirationDate: Date | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/services-expiring-contracts-widget?";
        if (expirationDate === null)
            throw new globalThis.Error("The parameter 'expirationDate' cannot be null.");
        else if (expirationDate !== undefined)
            url_ += "expirationDate=" + encodeURIComponent(expirationDate ? "" + expirationDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServicesExpiringContractsWidgetData(_response);
        });
    }

    protected processGetServicesExpiringContractsWidgetData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto>(null as any);
    }
}

export interface IServiceRequestClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    getAllAccountServiceRequests(body: AllServiceRequestsRequest | undefined,  cancelToken?: CancelToken): Promise<AllServiceRequestsResponse>;
    /**
     * @return OK
     */
    getMyServiceRequests( cancelToken?: CancelToken): Promise<ServiceRequestDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createNewServiceRequest(body: ServiceRequestDTO | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestResponse>;
    /**
     * @return OK
     */
    getMyAdditionalContactServiceRequests( cancelToken?: CancelToken): Promise<ServiceRequestDTO[]>;
    /**
     * @return OK
     */
    getServiceRequestByServiceRequestId(serviceRequestId: string,  cancelToken?: CancelToken): Promise<ServiceRequestDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateServiceRequest(serviceRequestId: number, body: ServiceRequestDTO | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    allRequests(body: ServiceRequestsRequest | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestsResponseDTO>;
    /**
     * @return OK
     */
    getServiceRequestsByAccount(accountId: number,  cancelToken?: CancelToken): Promise<ServiceRequestDto[]>;
    /**
     * @param fromServiceRequestId (optional) 
     * @param toServiceRequestId (optional) 
     * @return OK
     */
    createBulkIndexes(fromServiceRequestId: number | undefined, toServiceRequestId: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    uniqueFilterValues(body: GetUniqueFilterValuesRequestBase | undefined,  cancelToken?: CancelToken): Promise<UniqueFilterValuesDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getPicklistCategories(body: GetServiceRequestPicklistCategoriesRequest | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestPicklistCategoriesResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    searchServiceRequests(body: ServiceReportsFilterRequest | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestListDocumentDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    serviceRequestVisuals(body: GetServiceRequestVisuals | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestVisualsDto>;
    /**
     * @param contractStatusInclude (optional) 
     * @param contractStatusExclude (optional) 
     * @return OK
     */
    serviceRequestTabCounts(activeOnly: boolean, contractStatusInclude: string[] | undefined, contractStatusExclude: string[] | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestTabCountsDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    exportServiceReport(body: ServiceReportExportRequest | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getServiceReportsOverview(body: ServiceReportsFilterRequest | undefined,  cancelToken?: CancelToken): Promise<ServiceReportsOverviewResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getServiceReportsRequesterRankings(body: ServiceReportsFilterRequest | undefined,  cancelToken?: CancelToken): Promise<RequesterRankingsVisualsDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSurveyMetrics(body: ServiceReportsFilterRequest | undefined,  cancelToken?: CancelToken): Promise<SurveyMetricsResponse>;
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return OK
     */
    issueRankingsWidget(dateFrom: Date | undefined, dateTo: Date | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestIssueRankingsWidgetDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getServiceReportsIssueRankings(body: ServiceReportsFilterRequest | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestIssueRankingsWidgetDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    myRequests(body: ServiceRequestsRequest | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestsResponseDTO>;
    /**
     * @param body (optional) 
     * @return OK
     */
    secondaryContact(body: ServiceRequestsRequest | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestsResponseDTO>;
    /**
     * @return OK
     */
    summary( cancelToken?: CancelToken): Promise<ServiceRequestSummaryDTO>;
    /**
     * @return OK
     */
    requestHistory(months: number,  cancelToken?: CancelToken): Promise<MonthlyReportsDto>;
    /**
     * @return OK
     */
    serviceRequestDetails(serviceRequestId: string,  cancelToken?: CancelToken): Promise<ServiceRequestDetailsDto>;
    /**
     * @return OK
     */
    additionalContacts(serviceRequestId: number,  cancelToken?: CancelToken): Promise<ContactDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateAdditionalContacts(serviceRequestId: string, body: ServiceRequestContactSelectionDto[] | undefined,  cancelToken?: CancelToken): Promise<UpdateServiceRequestContactsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    additionalContactsBulk(body: number[] | undefined,  cancelToken?: CancelToken): Promise<ContactDtoWithServiceRequestIdAndAxNumber[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updatePreferredContactMethod(serviceRequestId: number, body: string | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getServiceRequestContactCandidates(accountId: number,  cancelToken?: CancelToken): Promise<ServiceRequestContactCandidateDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addServiceRequestMessage(body: ServiceRequestMessageDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    serviceRequestsDownload(body: ServiceRequestDownloadRequest | undefined,  cancelToken?: CancelToken): Promise<FileDownloadResponse>;
}

export class ServiceRequestClient extends AuthorizedApiBase implements IServiceRequestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllAccountServiceRequests(body: AllServiceRequestsRequest | undefined, cancelToken?: CancelToken): Promise<AllServiceRequestsResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAccountServiceRequests(_response);
        });
    }

    protected processGetAllAccountServiceRequests(response: AxiosResponse): Promise<AllServiceRequestsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AllServiceRequestsResponse.fromJS(resultData200);
            return Promise.resolve<AllServiceRequestsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllServiceRequestsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getMyServiceRequests( cancelToken?: CancelToken): Promise<ServiceRequestDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyServiceRequests(_response);
        });
    }

    protected processGetMyServiceRequests(response: AxiosResponse): Promise<ServiceRequestDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createNewServiceRequest(body: ServiceRequestDTO | undefined, cancelToken?: CancelToken): Promise<ServiceRequestResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewServiceRequest(_response);
        });
    }

    protected processCreateNewServiceRequest(response: AxiosResponse): Promise<ServiceRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestResponse.fromJS(resultData200);
            return Promise.resolve<ServiceRequestResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestResponse>(null as any);
    }

    /**
     * @return OK
     */
    getMyAdditionalContactServiceRequests( cancelToken?: CancelToken): Promise<ServiceRequestDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/additional-contact";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyAdditionalContactServiceRequests(_response);
        });
    }

    protected processGetMyAdditionalContactServiceRequests(response: AxiosResponse): Promise<ServiceRequestDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getServiceRequestByServiceRequestId(serviceRequestId: string, cancelToken?: CancelToken): Promise<ServiceRequestDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceRequestByServiceRequestId(_response);
        });
    }

    protected processGetServiceRequestByServiceRequestId(response: AxiosResponse): Promise<ServiceRequestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateServiceRequest(serviceRequestId: number, body: ServiceRequestDTO | undefined, cancelToken?: CancelToken): Promise<ServiceRequestResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateServiceRequest(_response);
        });
    }

    protected processUpdateServiceRequest(response: AxiosResponse): Promise<ServiceRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestResponse.fromJS(resultData200);
            return Promise.resolve<ServiceRequestResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    allRequests(body: ServiceRequestsRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestsResponseDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/all-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllRequests(_response);
        });
    }

    protected processAllRequests(response: AxiosResponse): Promise<ServiceRequestsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestsResponseDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestsResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestsResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    getServiceRequestsByAccount(accountId: number, cancelToken?: CancelToken): Promise<ServiceRequestDto[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceRequestsByAccount(_response);
        });
    }

    protected processGetServiceRequestsByAccount(response: AxiosResponse): Promise<ServiceRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDto[]>(null as any);
    }

    /**
     * @param fromServiceRequestId (optional) 
     * @param toServiceRequestId (optional) 
     * @return OK
     */
    createBulkIndexes(fromServiceRequestId: number | undefined, toServiceRequestId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/createBulkIndexes?";
        if (fromServiceRequestId === null)
            throw new globalThis.Error("The parameter 'fromServiceRequestId' cannot be null.");
        else if (fromServiceRequestId !== undefined)
            url_ += "fromServiceRequestId=" + encodeURIComponent("" + fromServiceRequestId) + "&";
        if (toServiceRequestId === null)
            throw new globalThis.Error("The parameter 'toServiceRequestId' cannot be null.");
        else if (toServiceRequestId !== undefined)
            url_ += "toServiceRequestId=" + encodeURIComponent("" + toServiceRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulkIndexes(_response);
        });
    }

    protected processCreateBulkIndexes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uniqueFilterValues(body: GetUniqueFilterValuesRequestBase | undefined, cancelToken?: CancelToken): Promise<UniqueFilterValuesDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/query/unique-filter-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUniqueFilterValues(_response);
        });
    }

    protected processUniqueFilterValues(response: AxiosResponse): Promise<UniqueFilterValuesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UniqueFilterValuesDto.fromJS(resultData200);
            return Promise.resolve<UniqueFilterValuesDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UniqueFilterValuesDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPicklistCategories(body: GetServiceRequestPicklistCategoriesRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestPicklistCategoriesResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/query/picklist-categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPicklistCategories(_response);
        });
    }

    protected processGetPicklistCategories(response: AxiosResponse): Promise<ServiceRequestPicklistCategoriesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestPicklistCategoriesResponse.fromJS(resultData200);
            return Promise.resolve<ServiceRequestPicklistCategoriesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestPicklistCategoriesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchServiceRequests(body: ServiceReportsFilterRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestListDocumentDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchServiceRequests(_response);
        });
    }

    protected processSearchServiceRequests(response: AxiosResponse): Promise<ServiceRequestListDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestListDocumentDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestListDocumentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestListDocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    serviceRequestVisuals(body: GetServiceRequestVisuals | undefined, cancelToken?: CancelToken): Promise<ServiceRequestVisualsDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/visuals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestVisuals(_response);
        });
    }

    protected processServiceRequestVisuals(response: AxiosResponse): Promise<ServiceRequestVisualsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestVisualsDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestVisualsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestVisualsDto>(null as any);
    }

    /**
     * @param contractStatusInclude (optional) 
     * @param contractStatusExclude (optional) 
     * @return OK
     */
    serviceRequestTabCounts(activeOnly: boolean, contractStatusInclude: string[] | undefined, contractStatusExclude: string[] | undefined, cancelToken?: CancelToken): Promise<ServiceRequestTabCountsDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/tabCounts/{activeOnly}?";
        if (activeOnly === undefined || activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' must be defined.");
        url_ = url_.replace("{activeOnly}", encodeURIComponent("" + activeOnly));
        if (contractStatusInclude === null)
            throw new globalThis.Error("The parameter 'contractStatusInclude' cannot be null.");
        else if (contractStatusInclude !== undefined)
            contractStatusInclude && contractStatusInclude.forEach(item => { url_ += "contractStatusInclude=" + encodeURIComponent("" + item) + "&"; });
        if (contractStatusExclude === null)
            throw new globalThis.Error("The parameter 'contractStatusExclude' cannot be null.");
        else if (contractStatusExclude !== undefined)
            contractStatusExclude && contractStatusExclude.forEach(item => { url_ += "contractStatusExclude=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestTabCounts(_response);
        });
    }

    protected processServiceRequestTabCounts(response: AxiosResponse): Promise<ServiceRequestTabCountsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestTabCountsDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestTabCountsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestTabCountsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportServiceReport(body: ServiceReportExportRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportServiceReport(_response);
        });
    }

    protected processExportServiceReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getServiceReportsOverview(body: ServiceReportsFilterRequest | undefined, cancelToken?: CancelToken): Promise<ServiceReportsOverviewResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/reports/overview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceReportsOverview(_response);
        });
    }

    protected processGetServiceReportsOverview(response: AxiosResponse): Promise<ServiceReportsOverviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceReportsOverviewResponse.fromJS(resultData200);
            return Promise.resolve<ServiceReportsOverviewResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceReportsOverviewResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getServiceReportsRequesterRankings(body: ServiceReportsFilterRequest | undefined, cancelToken?: CancelToken): Promise<RequesterRankingsVisualsDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/reports/requester-rankings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceReportsRequesterRankings(_response);
        });
    }

    protected processGetServiceReportsRequesterRankings(response: AxiosResponse): Promise<RequesterRankingsVisualsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequesterRankingsVisualsDto.fromJS(resultData200);
            return Promise.resolve<RequesterRankingsVisualsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequesterRankingsVisualsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSurveyMetrics(body: ServiceReportsFilterRequest | undefined, cancelToken?: CancelToken): Promise<SurveyMetricsResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/reports/survey-metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyMetrics(_response);
        });
    }

    protected processGetSurveyMetrics(response: AxiosResponse): Promise<SurveyMetricsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyMetricsResponse.fromJS(resultData200);
            return Promise.resolve<SurveyMetricsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyMetricsResponse>(null as any);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return OK
     */
    issueRankingsWidget(dateFrom: Date | undefined, dateTo: Date | undefined, cancelToken?: CancelToken): Promise<ServiceRequestIssueRankingsWidgetDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/issue-rankings-widget?";
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueRankingsWidget(_response);
        });
    }

    protected processIssueRankingsWidget(response: AxiosResponse): Promise<ServiceRequestIssueRankingsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestIssueRankingsWidgetDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestIssueRankingsWidgetDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestIssueRankingsWidgetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getServiceReportsIssueRankings(body: ServiceReportsFilterRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestIssueRankingsWidgetDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/reports/issue-rankings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceReportsIssueRankings(_response);
        });
    }

    protected processGetServiceReportsIssueRankings(response: AxiosResponse): Promise<ServiceRequestIssueRankingsWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestIssueRankingsWidgetDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestIssueRankingsWidgetDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestIssueRankingsWidgetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    myRequests(body: ServiceRequestsRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestsResponseDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/my-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMyRequests(_response);
        });
    }

    protected processMyRequests(response: AxiosResponse): Promise<ServiceRequestsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestsResponseDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestsResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestsResponseDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    secondaryContact(body: ServiceRequestsRequest | undefined, cancelToken?: CancelToken): Promise<ServiceRequestsResponseDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/secondary-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSecondaryContact(_response);
        });
    }

    protected processSecondaryContact(response: AxiosResponse): Promise<ServiceRequestsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestsResponseDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestsResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestsResponseDTO>(null as any);
    }

    /**
     * @return OK
     */
    summary( cancelToken?: CancelToken): Promise<ServiceRequestSummaryDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequest/request-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: AxiosResponse): Promise<ServiceRequestSummaryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestSummaryDTO.fromJS(resultData200);
            return Promise.resolve<ServiceRequestSummaryDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestSummaryDTO>(null as any);
    }

    /**
     * @return OK
     */
    requestHistory(months: number, cancelToken?: CancelToken): Promise<MonthlyReportsDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/history/{months}";
        if (months === undefined || months === null)
            throw new globalThis.Error("The parameter 'months' must be defined.");
        url_ = url_.replace("{months}", encodeURIComponent("" + months));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestHistory(_response);
        });
    }

    protected processRequestHistory(response: AxiosResponse): Promise<MonthlyReportsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthlyReportsDto.fromJS(resultData200);
            return Promise.resolve<MonthlyReportsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthlyReportsDto>(null as any);
    }

    /**
     * @return OK
     */
    serviceRequestDetails(serviceRequestId: string, cancelToken?: CancelToken): Promise<ServiceRequestDetailsDto> {
        let url_ = this.baseUrl + "/api/ServiceRequest/details/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestDetails(_response);
        });
    }

    protected processServiceRequestDetails(response: AxiosResponse): Promise<ServiceRequestDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestDetailsDto.fromJS(resultData200);
            return Promise.resolve<ServiceRequestDetailsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestDetailsDto>(null as any);
    }

    /**
     * @return OK
     */
    additionalContacts(serviceRequestId: number, cancelToken?: CancelToken): Promise<ContactDto[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/additionalContacts/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdditionalContacts(_response);
        });
    }

    protected processAdditionalContacts(response: AxiosResponse): Promise<ContactDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ContactDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAdditionalContacts(serviceRequestId: string, body: ServiceRequestContactSelectionDto[] | undefined, cancelToken?: CancelToken): Promise<UpdateServiceRequestContactsResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/additionalContacts/{serviceRequestId}";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAdditionalContacts(_response);
        });
    }

    protected processUpdateAdditionalContacts(response: AxiosResponse): Promise<UpdateServiceRequestContactsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateServiceRequestContactsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateServiceRequestContactsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateServiceRequestContactsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    additionalContactsBulk(body: number[] | undefined, cancelToken?: CancelToken): Promise<ContactDtoWithServiceRequestIdAndAxNumber[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/additionalContacts/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdditionalContactsBulk(_response);
        });
    }

    protected processAdditionalContactsBulk(response: AxiosResponse): Promise<ContactDtoWithServiceRequestIdAndAxNumber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactDtoWithServiceRequestIdAndAxNumber.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ContactDtoWithServiceRequestIdAndAxNumber[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDtoWithServiceRequestIdAndAxNumber[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePreferredContactMethod(serviceRequestId: number, body: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceRequest/details/{serviceRequestId}/preferredContactMethod";
        if (serviceRequestId === undefined || serviceRequestId === null)
            throw new globalThis.Error("The parameter 'serviceRequestId' must be defined.");
        url_ = url_.replace("{serviceRequestId}", encodeURIComponent("" + serviceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePreferredContactMethod(_response);
        });
    }

    protected processUpdatePreferredContactMethod(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getServiceRequestContactCandidates(accountId: number, cancelToken?: CancelToken): Promise<ServiceRequestContactCandidateDto[]> {
        let url_ = this.baseUrl + "/api/ServiceRequest/contactCandidates/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceRequestContactCandidates(_response);
        });
    }

    protected processGetServiceRequestContactCandidates(response: AxiosResponse): Promise<ServiceRequestContactCandidateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestContactCandidateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestContactCandidateDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestContactCandidateDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addServiceRequestMessage(body: ServiceRequestMessageDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceRequest/message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddServiceRequestMessage(_response);
        });
    }

    protected processAddServiceRequestMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    serviceRequestsDownload(body: ServiceRequestDownloadRequest | undefined, cancelToken?: CancelToken): Promise<FileDownloadResponse> {
        let url_ = this.baseUrl + "/api/ServiceRequest/elastic/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceRequestsDownload(_response);
        });
    }

    protected processServiceRequestsDownload(response: AxiosResponse): Promise<FileDownloadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDownloadResponse.fromJS(resultData200);
            return Promise.resolve<FileDownloadResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDownloadResponse>(null as any);
    }
}

export interface IServiceRequestLandingPageClient {
    /**
     * @return OK
     */
    getLandingPageTiles( cancelToken?: CancelToken): Promise<ServiceRequestLandingPageItemDto[]>;
}

export class ServiceRequestLandingPageClient extends AuthorizedApiBase implements IServiceRequestLandingPageClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getLandingPageTiles( cancelToken?: CancelToken): Promise<ServiceRequestLandingPageItemDto[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestLandingPage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLandingPageTiles(_response);
        });
    }

    protected processGetLandingPageTiles(response: AxiosResponse): Promise<ServiceRequestLandingPageItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestLandingPageItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestLandingPageItemDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestLandingPageItemDto[]>(null as any);
    }
}

export interface IServiceRequestMappingClient {
    /**
     * @return OK
     */
    getServiceRequestMappings( cancelToken?: CancelToken): Promise<ServiceRequestMapping[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createServiceRequestMapping(body: ServiceRequestMapping | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestMapping[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateServiceRequestMapping(body: ServiceRequestMapping | undefined,  cancelToken?: CancelToken): Promise<ServiceRequestMapping[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteServiceRequestMapping(body: ServiceRequestMapping | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    setApprovalServiceRequestMapping(mappingId: string, revision: number, status: boolean,  cancelToken?: CancelToken): Promise<ServiceRequestMapping>;
}

export class ServiceRequestMappingClient extends AuthorizedApiBase implements IServiceRequestMappingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getServiceRequestMappings( cancelToken?: CancelToken): Promise<ServiceRequestMapping[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceRequestMappings(_response);
        });
    }

    protected processGetServiceRequestMappings(response: AxiosResponse): Promise<ServiceRequestMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestMapping.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestMapping[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestMapping[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createServiceRequestMapping(body: ServiceRequestMapping | undefined, cancelToken?: CancelToken): Promise<ServiceRequestMapping[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateServiceRequestMapping(_response);
        });
    }

    protected processCreateServiceRequestMapping(response: AxiosResponse): Promise<ServiceRequestMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestMapping.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestMapping[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestMapping[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateServiceRequestMapping(body: ServiceRequestMapping | undefined, cancelToken?: CancelToken): Promise<ServiceRequestMapping[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateServiceRequestMapping(_response);
        });
    }

    protected processUpdateServiceRequestMapping(response: AxiosResponse): Promise<ServiceRequestMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestMapping.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestMapping[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestMapping[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteServiceRequestMapping(body: ServiceRequestMapping | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteServiceRequestMapping(_response);
        });
    }

    protected processDeleteServiceRequestMapping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    setApprovalServiceRequestMapping(mappingId: string, revision: number, status: boolean, cancelToken?: CancelToken): Promise<ServiceRequestMapping> {
        let url_ = this.baseUrl + "/api/ServiceRequestMapping/set-approval/{mappingId}/{revision}/{status}";
        if (mappingId === undefined || mappingId === null)
            throw new globalThis.Error("The parameter 'mappingId' must be defined.");
        url_ = url_.replace("{mappingId}", encodeURIComponent("" + mappingId));
        if (revision === undefined || revision === null)
            throw new globalThis.Error("The parameter 'revision' must be defined.");
        url_ = url_.replace("{revision}", encodeURIComponent("" + revision));
        if (status === undefined || status === null)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetApprovalServiceRequestMapping(_response);
        });
    }

    protected processSetApprovalServiceRequestMapping(response: AxiosResponse): Promise<ServiceRequestMapping> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceRequestMapping.fromJS(resultData200);
            return Promise.resolve<ServiceRequestMapping>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestMapping>(null as any);
    }
}

export interface IServiceRequestTemplateClient {
    /**
     * @return OK
     */
    getAvailableContacts(accountId: number,  cancelToken?: CancelToken): Promise<ServiceRequestContactDTO[]>;
    /**
     * @return OK
     */
    getAvailableAccountLocations(accountId: number,  cancelToken?: CancelToken): Promise<ServiceRequestAccountLocationDTO[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    uploadAttachments(body: Body | undefined,  cancelToken?: CancelToken): Promise<string[]>;
    /**
     * @return OK
     */
    getShiAccountDetails(axAccountNumber: string,  cancelToken?: CancelToken): Promise<AXAccountDetailsDTO>;
    /**
     * @return OK
     */
    getAllBillingUsersByAxAccountNumber(axAccountNumber: string,  cancelToken?: CancelToken): Promise<AXAccountBillingUsersDTO[]>;
    /**
     * @return OK
     */
    getShiBillingAddressesByAxAccountNumberAndCloudType(axAccountNumber: string, cloudType: ServiceRequestCloudTypes,  cancelToken?: CancelToken): Promise<AXBillingAddressDTO>;
    /**
     * @return OK
     */
    getShiBillingAddressesByAxAccountNumber(axAccountNumber: string,  cancelToken?: CancelToken): Promise<AXBillingAddressDTO>;
}

export class ServiceRequestTemplateClient extends AuthorizedApiBase implements IServiceRequestTemplateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAvailableContacts(accountId: number, cancelToken?: CancelToken): Promise<ServiceRequestContactDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/contacts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableContacts(_response);
        });
    }

    protected processGetAvailableContacts(response: AxiosResponse): Promise<ServiceRequestContactDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestContactDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestContactDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestContactDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getAvailableAccountLocations(accountId: number, cancelToken?: CancelToken): Promise<ServiceRequestAccountLocationDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/accountLocations/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableAccountLocations(_response);
        });
    }

    protected processGetAvailableAccountLocations(response: AxiosResponse): Promise<ServiceRequestAccountLocationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRequestAccountLocationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceRequestAccountLocationDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceRequestAccountLocationDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadAttachments(body: Body | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/attachments/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAttachments(_response);
        });
    }

    protected processUploadAttachments(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    getShiAccountDetails(axAccountNumber: string, cancelToken?: CancelToken): Promise<AXAccountDetailsDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/account-details/{axAccountNumber}";
        if (axAccountNumber === undefined || axAccountNumber === null)
            throw new globalThis.Error("The parameter 'axAccountNumber' must be defined.");
        url_ = url_.replace("{axAccountNumber}", encodeURIComponent("" + axAccountNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiAccountDetails(_response);
        });
    }

    protected processGetShiAccountDetails(response: AxiosResponse): Promise<AXAccountDetailsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXAccountDetailsDTO.fromJS(resultData200);
            return Promise.resolve<AXAccountDetailsDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXAccountDetailsDTO>(null as any);
    }

    /**
     * @return OK
     */
    getAllBillingUsersByAxAccountNumber(axAccountNumber: string, cancelToken?: CancelToken): Promise<AXAccountBillingUsersDTO[]> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/billing-users/{axAccountNumber}";
        if (axAccountNumber === undefined || axAccountNumber === null)
            throw new globalThis.Error("The parameter 'axAccountNumber' must be defined.");
        url_ = url_.replace("{axAccountNumber}", encodeURIComponent("" + axAccountNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBillingUsersByAxAccountNumber(_response);
        });
    }

    protected processGetAllBillingUsersByAxAccountNumber(response: AxiosResponse): Promise<AXAccountBillingUsersDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AXAccountBillingUsersDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AXAccountBillingUsersDTO[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXAccountBillingUsersDTO[]>(null as any);
    }

    /**
     * @return OK
     */
    getShiBillingAddressesByAxAccountNumberAndCloudType(axAccountNumber: string, cloudType: ServiceRequestCloudTypes, cancelToken?: CancelToken): Promise<AXBillingAddressDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/billing-address/{cloudType}/{axAccountNumber}";
        if (axAccountNumber === undefined || axAccountNumber === null)
            throw new globalThis.Error("The parameter 'axAccountNumber' must be defined.");
        url_ = url_.replace("{axAccountNumber}", encodeURIComponent("" + axAccountNumber));
        if (cloudType === undefined || cloudType === null)
            throw new globalThis.Error("The parameter 'cloudType' must be defined.");
        url_ = url_.replace("{cloudType}", encodeURIComponent("" + cloudType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiBillingAddressesByAxAccountNumberAndCloudType(_response);
        });
    }

    protected processGetShiBillingAddressesByAxAccountNumberAndCloudType(response: AxiosResponse): Promise<AXBillingAddressDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXBillingAddressDTO.fromJS(resultData200);
            return Promise.resolve<AXBillingAddressDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXBillingAddressDTO>(null as any);
    }

    /**
     * @return OK
     */
    getShiBillingAddressesByAxAccountNumber(axAccountNumber: string, cancelToken?: CancelToken): Promise<AXBillingAddressDTO> {
        let url_ = this.baseUrl + "/api/ServiceRequestTemplate/billing-address/{axAccountNumber}";
        if (axAccountNumber === undefined || axAccountNumber === null)
            throw new globalThis.Error("The parameter 'axAccountNumber' must be defined.");
        url_ = url_.replace("{axAccountNumber}", encodeURIComponent("" + axAccountNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiBillingAddressesByAxAccountNumber(_response);
        });
    }

    protected processGetShiBillingAddressesByAxAccountNumber(response: AxiosResponse): Promise<AXBillingAddressDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AXBillingAddressDTO.fromJS(resultData200);
            return Promise.resolve<AXBillingAddressDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AXBillingAddressDTO>(null as any);
    }
}

export interface IShoppingCartChangesClient {
    /**
     * Lists the cart lines the last storefront switch removed and the user has not acknowledged.
     * @return OK
     */
    getRemovedLines( cancelToken?: CancelToken): Promise<RemovedCartLineDto[]>;
    /**
     * Clears the removed-line list once the user has seen it.
     * @return No Content
     */
    acknowledgeRemovedLines( cancelToken?: CancelToken): Promise<void>;
}

export class ShoppingCartChangesClient extends AuthorizedApiBase implements IShoppingCartChangesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Lists the cart lines the last storefront switch removed and the user has not acknowledged.
     * @return OK
     */
    getRemovedLines( cancelToken?: CancelToken): Promise<RemovedCartLineDto[]> {
        let url_ = this.baseUrl + "/api/shopping-cart-changes/removed-lines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRemovedLines(_response);
        });
    }

    protected processGetRemovedLines(response: AxiosResponse): Promise<RemovedCartLineDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RemovedCartLineDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RemovedCartLineDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemovedCartLineDto[]>(null as any);
    }

    /**
     * Clears the removed-line list once the user has seen it.
     * @return No Content
     */
    acknowledgeRemovedLines( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/shopping-cart-changes/removed-lines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcknowledgeRemovedLines(_response);
        });
    }

    protected processAcknowledgeRemovedLines(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISiteClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    setSubdomain(body: WhiteLabelResult | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @return OK
     */
    uploadNewSiteLogo( cancelToken?: CancelToken): Promise<FileUploadResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    setWhitelabel(body: WhiteLabelResult | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @return OK
     */
    getLogoUrl(prefix: string,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getSubdomainFromPrefix(body: CurrentPrefix | undefined,  cancelToken?: CancelToken): Promise<string>;
}

export class SiteClient extends AuthorizedApiBase implements ISiteClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setSubdomain(body: WhiteLabelResult | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Site/subdomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSubdomain(_response);
        });
    }

    protected processSetSubdomain(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    uploadNewSiteLogo( cancelToken?: CancelToken): Promise<FileUploadResponse> {
        let url_ = this.baseUrl + "/api/Site/uploadimage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadNewSiteLogo(_response);
        });
    }

    protected processUploadNewSiteLogo(response: AxiosResponse): Promise<FileUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadResponse.fromJS(resultData200);
            return Promise.resolve<FileUploadResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setWhitelabel(body: WhiteLabelResult | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Site/whitelabel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetWhitelabel(_response);
        });
    }

    protected processSetWhitelabel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getLogoUrl(prefix: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Site/logo/{prefix}";
        if (prefix === undefined || prefix === null)
            throw new globalThis.Error("The parameter 'prefix' must be defined.");
        url_ = url_.replace("{prefix}", encodeURIComponent("" + prefix));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogoUrl(_response);
        });
    }

    protected processGetLogoUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSubdomainFromPrefix(body: CurrentPrefix | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Site/getsite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubdomainFromPrefix(_response);
        });
    }

    protected processGetSubdomainFromPrefix(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IStandardsClient {
    /**
     * @param inCatalog (optional) 
     * @param top (optional) 
     * @return OK
     */
    getFeaturedProductDetails(orgUnitId: number, inCatalog: boolean | undefined, top: number | undefined,  cancelToken?: CancelToken): Promise<ProductDetailDto[]>;
}

export class StandardsClient extends AuthorizedApiBase implements IStandardsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param inCatalog (optional) 
     * @param top (optional) 
     * @return OK
     */
    getFeaturedProductDetails(orgUnitId: number, inCatalog: boolean | undefined, top: number | undefined, cancelToken?: CancelToken): Promise<ProductDetailDto[]> {
        let url_ = this.baseUrl + "/api/Standards/feature/{orgUnitId}?";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (inCatalog === null)
            throw new globalThis.Error("The parameter 'inCatalog' cannot be null.");
        else if (inCatalog !== undefined)
            url_ += "inCatalog=" + encodeURIComponent("" + inCatalog) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeaturedProductDetails(_response);
        });
    }

    protected processGetFeaturedProductDetails(response: AxiosResponse): Promise<ProductDetailDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductDetailDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProductDetailDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Bad Gateway", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDetailDto[]>(null as any);
    }
}

export interface IStandardsShopClient {
    /**
     * Returns standards shop folders and products in a render-ready tree shape for users
    who can browse the Standards Shop. Scoped to the caller's current org unit.
     * @return OK
     */
    getStandardsShop( cancelToken?: CancelToken): Promise<StandardsShopResponseDto>;
    /**
     * Returns enriched product detail drawer data (images, specs) for a catalog product, for users
    who can browse the Standards Shop. Scoped to the caller's current org unit.
     * @param body (optional) 
     * @return OK
     */
    getStandardsProductDetailDrawer(body: ProductDetailDrawerRequestDto | undefined,  cancelToken?: CancelToken): Promise<ProductDetailDrawerDto>;
}

export class StandardsShopClient extends AuthorizedApiBase implements IStandardsShopClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns standards shop folders and products in a render-ready tree shape for users
    who can browse the Standards Shop. Scoped to the caller's current org unit.
     * @return OK
     */
    getStandardsShop( cancelToken?: CancelToken): Promise<StandardsShopResponseDto> {
        let url_ = this.baseUrl + "/api/ecommerce/standards-shop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStandardsShop(_response);
        });
    }

    protected processGetStandardsShop(response: AxiosResponse): Promise<StandardsShopResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StandardsShopResponseDto.fromJS(resultData200);
            return Promise.resolve<StandardsShopResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StandardsShopResponseDto>(null as any);
    }

    /**
     * Returns enriched product detail drawer data (images, specs) for a catalog product, for users
    who can browse the Standards Shop. Scoped to the caller's current org unit.
     * @param body (optional) 
     * @return OK
     */
    getStandardsProductDetailDrawer(body: ProductDetailDrawerRequestDto | undefined, cancelToken?: CancelToken): Promise<ProductDetailDrawerDto> {
        let url_ = this.baseUrl + "/api/ecommerce/standards-shop/product-detail-drawer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStandardsProductDetailDrawer(_response);
        });
    }

    protected processGetStandardsProductDetailDrawer(response: AxiosResponse): Promise<ProductDetailDrawerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDetailDrawerDto.fromJS(resultData200);
            return Promise.resolve<ProductDetailDrawerDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDetailDrawerDto>(null as any);
    }
}

export interface IStorefrontClient {
    /**
     * Retrieve all OrgUnits for the current user's account. This will include the org units that belong to the account's associated accounts.
     * @return OK
     */
    getOrgUnitNavHeadersForCurrentUserAccount( cancelToken?: CancelToken): Promise<OrgUnitNavHeaderDto[]>;
    /**
     * @return OK
     */
    getOrgUnitNavHeader(orgUnitId: number,  cancelToken?: CancelToken): Promise<StorefrontOrgUnitNavHeaderResponse>;
    /**
     * Endpoint: TopNavigation - Retrieves SHIcom top horizontal navigation menu Items from SHIcom.Micro.RemoteLayout.
     * @return OK
     */
    getTopNavMenuItems( cancelToken?: CancelToken): Promise<TopNavMenuItemDto[]>;
}

export class StorefrontClient extends AuthorizedApiBase implements IStorefrontClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieve all OrgUnits for the current user's account. This will include the org units that belong to the account's associated accounts.
     * @return OK
     */
    getOrgUnitNavHeadersForCurrentUserAccount( cancelToken?: CancelToken): Promise<OrgUnitNavHeaderDto[]> {
        let url_ = this.baseUrl + "/api/Storefront/org-units";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgUnitNavHeadersForCurrentUserAccount(_response);
        });
    }

    protected processGetOrgUnitNavHeadersForCurrentUserAccount(response: AxiosResponse): Promise<OrgUnitNavHeaderDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrgUnitNavHeaderDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrgUnitNavHeaderDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgUnitNavHeaderDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getOrgUnitNavHeader(orgUnitId: number, cancelToken?: CancelToken): Promise<StorefrontOrgUnitNavHeaderResponse> {
        let url_ = this.baseUrl + "/api/Storefront/org-units/{orgUnitId}/nav-header";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgUnitNavHeader(_response);
        });
    }

    protected processGetOrgUnitNavHeader(response: AxiosResponse): Promise<StorefrontOrgUnitNavHeaderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorefrontOrgUnitNavHeaderResponse.fromJS(resultData200);
            return Promise.resolve<StorefrontOrgUnitNavHeaderResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontOrgUnitNavHeaderResponse>(null as any);
    }

    /**
     * Endpoint: TopNavigation - Retrieves SHIcom top horizontal navigation menu Items from SHIcom.Micro.RemoteLayout.
     * @return OK
     */
    getTopNavMenuItems( cancelToken?: CancelToken): Promise<TopNavMenuItemDto[]> {
        let url_ = this.baseUrl + "/api/Storefront/TopNavigation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopNavMenuItems(_response);
        });
    }

    protected processGetTopNavMenuItems(response: AxiosResponse): Promise<TopNavMenuItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopNavMenuItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TopNavMenuItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopNavMenuItemDto[]>(null as any);
    }
}

export interface IStorefrontAddressClient {
    /**
     * @param includeEmptyGroups (optional) 
     * @return OK
     */
    getOrgUnitAddressGroups(orgUnitId: number, includeEmptyGroups: boolean | undefined,  cancelToken?: CancelToken): Promise<OrgUnitAddressGroupDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createOrgUnitAddressGroup(orgUnitId: number, body: CreateAddressGroupRequest | undefined,  cancelToken?: CancelToken): Promise<OrgUnitAddressGroupDto>;
    /**
     * @return OK
     */
    getAddressLocations(orgUnitId: number,  cancelToken?: CancelToken): Promise<AddressLocationItemDto[]>;
    /**
     * @param searchText (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param addressGroupNames (optional) 
     * @param locationFilters (optional) 
     * @return OK
     */
    searchAddresses(orgUnitId: number, searchText: string | undefined, page: number | undefined, pageSize: number | undefined, addressGroupNames: string[] | undefined, locationFilters: string | undefined,  cancelToken?: CancelToken): Promise<AddressSearchResultDto>;
    /**
     * @param query (optional) 
     * @return OK
     */
    lookupAddresses(query: string | undefined,  cancelToken?: CancelToken): Promise<AddressLookupResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    lookupAddressCoordinates(body: AddressCoordinateLookupRequest | undefined,  cancelToken?: CancelToken): Promise<AddressCoordinateLookupResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createAddress(orgUnitId: number, body: CreateAddressDto | undefined,  cancelToken?: CancelToken): Promise<CreateAddressResponseDto>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateAddress(orgUnitId: number, streetAddressId: number, body: UpdateAddressDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param searchText (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    searchPersonalAddresses(searchText: string | undefined, page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<AddressSearchResultDto>;
    /**
     * @param orgUnitId (optional) 
     * @param count (optional) 
     * @return OK
     */
    getRecentAddresses(orgUnitId: number | undefined, count: number | undefined,  cancelToken?: CancelToken): Promise<AddressSearchResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    createPersonalAddress(body: CreatePersonalAddressDto | undefined,  cancelToken?: CancelToken): Promise<CreatePersonalAddressResponseDto>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updatePersonalAddress(streetAddressId: number, body: UpdatePersonalAddressDto | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class StorefrontAddressClient extends AuthorizedApiBase implements IStorefrontAddressClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param includeEmptyGroups (optional) 
     * @return OK
     */
    getOrgUnitAddressGroups(orgUnitId: number, includeEmptyGroups: boolean | undefined, cancelToken?: CancelToken): Promise<OrgUnitAddressGroupDto[]> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/org-unit/{orgUnitId}/groups?";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (includeEmptyGroups === null)
            throw new globalThis.Error("The parameter 'includeEmptyGroups' cannot be null.");
        else if (includeEmptyGroups !== undefined)
            url_ += "includeEmptyGroups=" + encodeURIComponent("" + includeEmptyGroups) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgUnitAddressGroups(_response);
        });
    }

    protected processGetOrgUnitAddressGroups(response: AxiosResponse): Promise<OrgUnitAddressGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrgUnitAddressGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<OrgUnitAddressGroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgUnitAddressGroupDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrgUnitAddressGroup(orgUnitId: number, body: CreateAddressGroupRequest | undefined, cancelToken?: CancelToken): Promise<OrgUnitAddressGroupDto> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/org-unit/{orgUnitId}/groups";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrgUnitAddressGroup(_response);
        });
    }

    protected processCreateOrgUnitAddressGroup(response: AxiosResponse): Promise<OrgUnitAddressGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrgUnitAddressGroupDto.fromJS(resultData200);
            return Promise.resolve<OrgUnitAddressGroupDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgUnitAddressGroupDto>(null as any);
    }

    /**
     * @return OK
     */
    getAddressLocations(orgUnitId: number, cancelToken?: CancelToken): Promise<AddressLocationItemDto[]> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/org-unit/{orgUnitId}/locations";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAddressLocations(_response);
        });
    }

    protected processGetAddressLocations(response: AxiosResponse): Promise<AddressLocationItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressLocationItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AddressLocationItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressLocationItemDto[]>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param addressGroupNames (optional) 
     * @param locationFilters (optional) 
     * @return OK
     */
    searchAddresses(orgUnitId: number, searchText: string | undefined, page: number | undefined, pageSize: number | undefined, addressGroupNames: string[] | undefined, locationFilters: string | undefined, cancelToken?: CancelToken): Promise<AddressSearchResultDto> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/org-unit/{orgUnitId}/search?";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (addressGroupNames === null)
            throw new globalThis.Error("The parameter 'addressGroupNames' cannot be null.");
        else if (addressGroupNames !== undefined)
            addressGroupNames && addressGroupNames.forEach(item => { url_ += "addressGroupNames=" + encodeURIComponent("" + item) + "&"; });
        if (locationFilters === null)
            throw new globalThis.Error("The parameter 'locationFilters' cannot be null.");
        else if (locationFilters !== undefined)
            url_ += "locationFilters=" + encodeURIComponent("" + locationFilters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAddresses(_response);
        });
    }

    protected processSearchAddresses(response: AxiosResponse): Promise<AddressSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressSearchResultDto.fromJS(resultData200);
            return Promise.resolve<AddressSearchResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressSearchResultDto>(null as any);
    }

    /**
     * @param query (optional) 
     * @return OK
     */
    lookupAddresses(query: string | undefined, cancelToken?: CancelToken): Promise<AddressLookupResponse> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/lookup?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookupAddresses(_response);
        });
    }

    protected processLookupAddresses(response: AxiosResponse): Promise<AddressLookupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressLookupResponse.fromJS(resultData200);
            return Promise.resolve<AddressLookupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressLookupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    lookupAddressCoordinates(body: AddressCoordinateLookupRequest | undefined, cancelToken?: CancelToken): Promise<AddressCoordinateLookupResponse> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/coordinates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookupAddressCoordinates(_response);
        });
    }

    protected processLookupAddressCoordinates(response: AxiosResponse): Promise<AddressCoordinateLookupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressCoordinateLookupResponse.fromJS(resultData200);
            return Promise.resolve<AddressCoordinateLookupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressCoordinateLookupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAddress(orgUnitId: number, body: CreateAddressDto | undefined, cancelToken?: CancelToken): Promise<CreateAddressResponseDto> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/org-unit/{orgUnitId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAddress(_response);
        });
    }

    protected processCreateAddress(response: AxiosResponse): Promise<CreateAddressResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateAddressResponseDto.fromJS(resultData200);
            return Promise.resolve<CreateAddressResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateAddressResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateAddress(orgUnitId: number, streetAddressId: number, body: UpdateAddressDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/org-unit/{orgUnitId}/{streetAddressId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (streetAddressId === undefined || streetAddressId === null)
            throw new globalThis.Error("The parameter 'streetAddressId' must be defined.");
        url_ = url_.replace("{streetAddressId}", encodeURIComponent("" + streetAddressId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAddress(_response);
        });
    }

    protected processUpdateAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    searchPersonalAddresses(searchText: string | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<AddressSearchResultDto> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/personal/search?";
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPersonalAddresses(_response);
        });
    }

    protected processSearchPersonalAddresses(response: AxiosResponse): Promise<AddressSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressSearchResultDto.fromJS(resultData200);
            return Promise.resolve<AddressSearchResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressSearchResultDto>(null as any);
    }

    /**
     * @param orgUnitId (optional) 
     * @param count (optional) 
     * @return OK
     */
    getRecentAddresses(orgUnitId: number | undefined, count: number | undefined, cancelToken?: CancelToken): Promise<AddressSearchResultDto> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/recent?";
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            url_ += "orgUnitId=" + encodeURIComponent("" + orgUnitId) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecentAddresses(_response);
        });
    }

    protected processGetRecentAddresses(response: AxiosResponse): Promise<AddressSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressSearchResultDto.fromJS(resultData200);
            return Promise.resolve<AddressSearchResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressSearchResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPersonalAddress(body: CreatePersonalAddressDto | undefined, cancelToken?: CancelToken): Promise<CreatePersonalAddressResponseDto> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/personal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePersonalAddress(_response);
        });
    }

    protected processCreatePersonalAddress(response: AxiosResponse): Promise<CreatePersonalAddressResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreatePersonalAddressResponseDto.fromJS(resultData200);
            return Promise.resolve<CreatePersonalAddressResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatePersonalAddressResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updatePersonalAddress(streetAddressId: number, body: UpdatePersonalAddressDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/StorefrontAddress/personal/{streetAddressId}";
        if (streetAddressId === undefined || streetAddressId === null)
            throw new globalThis.Error("The parameter 'streetAddressId' must be defined.");
        url_ = url_.replace("{streetAddressId}", encodeURIComponent("" + streetAddressId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePersonalAddress(_response);
        });
    }

    protected processUpdatePersonalAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IStorefrontBundlesClient {
    /**
     * @return OK
     */
    listStorefrontBundles(orgUnitId: number,  cancelToken?: CancelToken): Promise<BundleListItemDto[]>;
    /**
     * @return Created
     */
    createStorefrontBundle(orgUnitId: number, body: CreateBundleRequest,  cancelToken?: CancelToken): Promise<BundleWriteResponse>;
    /**
     * @return OK
     */
    listStorefrontBundleStatuses(orgUnitId: number,  cancelToken?: CancelToken): Promise<BundleStatusDto[]>;
    /**
     * @return OK
     */
    getStorefrontBundle(orgUnitId: number, bundleId: number,  cancelToken?: CancelToken): Promise<BundleDto>;
    /**
     * @return OK
     */
    updateStorefrontBundle(orgUnitId: number, bundleId: number, body: UpdateBundleRequest,  cancelToken?: CancelToken): Promise<BundleWriteResponse>;
    /**
     * @return No Content
     */
    deleteStorefrontBundle(orgUnitId: number, bundleId: number,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return Created
     */
    createStorefrontSystemItem(orgUnitId: number, body: CreateSystemItemRequest,  cancelToken?: CancelToken): Promise<SystemItemWriteResponse>;
    /**
     * @return OK
     */
    getStorefrontProductSupplierOptions(productId: number, orgUnitId: number,  cancelToken?: CancelToken): Promise<SupplierOptionDto[]>;
    /**
     * @return OK
     */
    validateStorefrontBundleProducts(orgUnitId: number, body: ValidateProductsForBundleRequest,  cancelToken?: CancelToken): Promise<ValidateProductsForBundleResponse>;
    /**
     * @return OK
     */
    resolveStorefrontBundleCompositeItems(orgUnitId: number, body: ResolveBundleCompositeItemsRequest,  cancelToken?: CancelToken): Promise<ResolveBundleCompositeItemsResponse>;
    /**
     * @return OK
     */
    applyStorefrontBundleBulkAction(orgUnitId: number, body: BulkBundleActionRequest,  cancelToken?: CancelToken): Promise<BulkBundleActionResponse>;
}

export class StorefrontBundlesClient extends AuthorizedApiBase implements IStorefrontBundlesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    listStorefrontBundles(orgUnitId: number, cancelToken?: CancelToken): Promise<BundleListItemDto[]> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/{orgUnitId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListStorefrontBundles(_response);
        });
    }

    protected processListStorefrontBundles(response: AxiosResponse): Promise<BundleListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BundleListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BundleListItemDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BundleListItemDto[]>(null as any);
    }

    /**
     * @return Created
     */
    createStorefrontBundle(orgUnitId: number, body: CreateBundleRequest, cancelToken?: CancelToken): Promise<BundleWriteResponse> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/{orgUnitId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStorefrontBundle(_response);
        });
    }

    protected processCreateStorefrontBundle(response: AxiosResponse): Promise<BundleWriteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = BundleWriteResponse.fromJS(resultData201);
            return Promise.resolve<BundleWriteResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BundleWriteResponse>(null as any);
    }

    /**
     * @return OK
     */
    listStorefrontBundleStatuses(orgUnitId: number, cancelToken?: CancelToken): Promise<BundleStatusDto[]> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/{orgUnitId}/statuses";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListStorefrontBundleStatuses(_response);
        });
    }

    protected processListStorefrontBundleStatuses(response: AxiosResponse): Promise<BundleStatusDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BundleStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BundleStatusDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BundleStatusDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getStorefrontBundle(orgUnitId: number, bundleId: number, cancelToken?: CancelToken): Promise<BundleDto> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/{orgUnitId}/{bundleId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (bundleId === undefined || bundleId === null)
            throw new globalThis.Error("The parameter 'bundleId' must be defined.");
        url_ = url_.replace("{bundleId}", encodeURIComponent("" + bundleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStorefrontBundle(_response);
        });
    }

    protected processGetStorefrontBundle(response: AxiosResponse): Promise<BundleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BundleDto.fromJS(resultData200);
            return Promise.resolve<BundleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BundleDto>(null as any);
    }

    /**
     * @return OK
     */
    updateStorefrontBundle(orgUnitId: number, bundleId: number, body: UpdateBundleRequest, cancelToken?: CancelToken): Promise<BundleWriteResponse> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/{orgUnitId}/{bundleId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (bundleId === undefined || bundleId === null)
            throw new globalThis.Error("The parameter 'bundleId' must be defined.");
        url_ = url_.replace("{bundleId}", encodeURIComponent("" + bundleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStorefrontBundle(_response);
        });
    }

    protected processUpdateStorefrontBundle(response: AxiosResponse): Promise<BundleWriteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BundleWriteResponse.fromJS(resultData200);
            return Promise.resolve<BundleWriteResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BundleWriteResponse>(null as any);
    }

    /**
     * @return No Content
     */
    deleteStorefrontBundle(orgUnitId: number, bundleId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/{orgUnitId}/{bundleId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (bundleId === undefined || bundleId === null)
            throw new globalThis.Error("The parameter 'bundleId' must be defined.");
        url_ = url_.replace("{bundleId}", encodeURIComponent("" + bundleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStorefrontBundle(_response);
        });
    }

    protected processDeleteStorefrontBundle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Created
     */
    createStorefrontSystemItem(orgUnitId: number, body: CreateSystemItemRequest, cancelToken?: CancelToken): Promise<SystemItemWriteResponse> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/system-items?";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined and cannot be null.");
        else
            url_ += "orgUnitId=" + encodeURIComponent("" + orgUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStorefrontSystemItem(_response);
        });
    }

    protected processCreateStorefrontSystemItem(response: AxiosResponse): Promise<SystemItemWriteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SystemItemWriteResponse.fromJS(resultData201);
            return Promise.resolve<SystemItemWriteResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemItemWriteResponse>(null as any);
    }

    /**
     * @return OK
     */
    getStorefrontProductSupplierOptions(productId: number, orgUnitId: number, cancelToken?: CancelToken): Promise<SupplierOptionDto[]> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/products/{productId}/supplier-options?";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined and cannot be null.");
        else
            url_ += "orgUnitId=" + encodeURIComponent("" + orgUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStorefrontProductSupplierOptions(_response);
        });
    }

    protected processGetStorefrontProductSupplierOptions(response: AxiosResponse): Promise<SupplierOptionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SupplierOptionDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SupplierOptionDto[]>(null as any);
    }

    /**
     * @return OK
     */
    validateStorefrontBundleProducts(orgUnitId: number, body: ValidateProductsForBundleRequest, cancelToken?: CancelToken): Promise<ValidateProductsForBundleResponse> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/{orgUnitId}/validate-products";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateStorefrontBundleProducts(_response);
        });
    }

    protected processValidateStorefrontBundleProducts(response: AxiosResponse): Promise<ValidateProductsForBundleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateProductsForBundleResponse.fromJS(resultData200);
            return Promise.resolve<ValidateProductsForBundleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateProductsForBundleResponse>(null as any);
    }

    /**
     * @return OK
     */
    resolveStorefrontBundleCompositeItems(orgUnitId: number, body: ResolveBundleCompositeItemsRequest, cancelToken?: CancelToken): Promise<ResolveBundleCompositeItemsResponse> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/{orgUnitId}/composite-items/resolve";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveStorefrontBundleCompositeItems(_response);
        });
    }

    protected processResolveStorefrontBundleCompositeItems(response: AxiosResponse): Promise<ResolveBundleCompositeItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResolveBundleCompositeItemsResponse.fromJS(resultData200);
            return Promise.resolve<ResolveBundleCompositeItemsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResolveBundleCompositeItemsResponse>(null as any);
    }

    /**
     * @return OK
     */
    applyStorefrontBundleBulkAction(orgUnitId: number, body: BulkBundleActionRequest, cancelToken?: CancelToken): Promise<BulkBundleActionResponse> {
        let url_ = this.baseUrl + "/api/StorefrontBundles/{orgUnitId}/bulk-action";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyStorefrontBundleBulkAction(_response);
        });
    }

    protected processApplyStorefrontBundleBulkAction(response: AxiosResponse): Promise<BulkBundleActionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BulkBundleActionResponse.fromJS(resultData200);
            return Promise.resolve<BulkBundleActionResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkBundleActionResponse>(null as any);
    }
}

export interface IStorefrontCatalogClient {
    /**
     * @return OK
     */
    getCatalogRules(orgUnitId: number,  cancelToken?: CancelToken): Promise<CatalogViewDto>;
    /**
     * @param searchText (optional) 
     * @param inCatalogOnly (optional) 
     * @param adjustmentsOnly (optional) 
     * @return OK
     */
    searchManufacturers(orgUnitId: number, searchText: string | undefined, pageIndex: number, pageSize: number, inCatalogOnly: boolean | undefined, adjustmentsOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<ManufacturerProductLineSearchResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    toggleStandardsOnly(orgUnitId: number, body: ToggleStandardsOnlyRequestDto | undefined,  cancelToken?: CancelToken): Promise<CatalogViewDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateHWSWInclusion(orgUnitId: number, body: UpdateHWSWInclusionRequestDto | undefined,  cancelToken?: CancelToken): Promise<CatalogViewDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addProductToCatalog(orgUnitId: number, body: CatalogProductOverrideDto | undefined,  cancelToken?: CancelToken): Promise<AddProductToCatalogResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    removeProductFromCatalog(orgUnitId: number, body: CatalogProductOverrideDto | undefined,  cancelToken?: CancelToken): Promise<CatalogViewDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    setProductPriceRule(orgUnitId: number, productId: number, body: SetProductPriceRuleRequestDto | undefined,  cancelToken?: CancelToken): Promise<ProductPriceRuleMutationResultDto>;
    /**
     * @return OK
     */
    removeProductPriceRule(orgUnitId: number, productId: number,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param body (optional) 
     * @return OK
     */
    toggleManufacturerInclusion(orgUnitId: number, body: ToggleManufacturerInclusionRequestDto | undefined,  cancelToken?: CancelToken): Promise<CatalogRuleToggleResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    toggleProductLineInclusion(orgUnitId: number, body: ToggleProductLineInclusionRequestDto | undefined,  cancelToken?: CancelToken): Promise<CatalogRuleToggleResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addProductToStandards(orgUnitId: number, body: StorefrontAddToStandardsDto | undefined,  cancelToken?: CancelToken): Promise<StandardsProductResultDto>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    removeProductFromStandards(orgUnitId: number, body: StorefrontRemoveFromStandardsDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getStandardsDirectory(orgUnitId: number,  cancelToken?: CancelToken): Promise<GetStandardsFoldersResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    searchCatalogProducts(body: ProductSearchDto | undefined,  cancelToken?: CancelToken): Promise<SearchProductsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    extendedSearchProducts(body: ProductSearchDto | undefined,  cancelToken?: CancelToken): Promise<SearchProductsResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    warehouseSearchProducts(body: ProductSearchDto | undefined,  cancelToken?: CancelToken): Promise<SearchProductsResponse>;
    /**
     * @param orgUnitId (optional) 
     * @param useUnscopedCatalogCounts (optional) 
     * @return OK
     */
    getCatalogNavigationPaths(orgUnitId: number | undefined, useUnscopedCatalogCounts: boolean | undefined,  cancelToken?: CancelToken): Promise<CatalogNavigationPathsResponse>;
    /**
     * @return OK
     */
    getCatalogInfo(orgUnitId: number,  cancelToken?: CancelToken): Promise<StorefrontCatalogInfoResult>;
}

export class StorefrontCatalogClient extends AuthorizedApiBase implements IStorefrontCatalogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getCatalogRules(orgUnitId: number, cancelToken?: CancelToken): Promise<CatalogViewDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogRules(_response);
        });
    }

    protected processGetCatalogRules(response: AxiosResponse): Promise<CatalogViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogViewDto.fromJS(resultData200);
            return Promise.resolve<CatalogViewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogViewDto>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param inCatalogOnly (optional) 
     * @param adjustmentsOnly (optional) 
     * @return OK
     */
    searchManufacturers(orgUnitId: number, searchText: string | undefined, pageIndex: number, pageSize: number, inCatalogOnly: boolean | undefined, adjustmentsOnly: boolean | undefined, cancelToken?: CancelToken): Promise<ManufacturerProductLineSearchResultDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}/manufacturers?";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (inCatalogOnly === null)
            throw new globalThis.Error("The parameter 'inCatalogOnly' cannot be null.");
        else if (inCatalogOnly !== undefined)
            url_ += "inCatalogOnly=" + encodeURIComponent("" + inCatalogOnly) + "&";
        if (adjustmentsOnly === null)
            throw new globalThis.Error("The parameter 'adjustmentsOnly' cannot be null.");
        else if (adjustmentsOnly !== undefined)
            url_ += "adjustmentsOnly=" + encodeURIComponent("" + adjustmentsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchManufacturers(_response);
        });
    }

    protected processSearchManufacturers(response: AxiosResponse): Promise<ManufacturerProductLineSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ManufacturerProductLineSearchResultDto.fromJS(resultData200);
            return Promise.resolve<ManufacturerProductLineSearchResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManufacturerProductLineSearchResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    toggleStandardsOnly(orgUnitId: number, body: ToggleStandardsOnlyRequestDto | undefined, cancelToken?: CancelToken): Promise<CatalogViewDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}/standards-only";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleStandardsOnly(_response);
        });
    }

    protected processToggleStandardsOnly(response: AxiosResponse): Promise<CatalogViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogViewDto.fromJS(resultData200);
            return Promise.resolve<CatalogViewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateHWSWInclusion(orgUnitId: number, body: UpdateHWSWInclusionRequestDto | undefined, cancelToken?: CancelToken): Promise<CatalogViewDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}/hwsw-inclusion";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHWSWInclusion(_response);
        });
    }

    protected processUpdateHWSWInclusion(response: AxiosResponse): Promise<CatalogViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogViewDto.fromJS(resultData200);
            return Promise.resolve<CatalogViewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addProductToCatalog(orgUnitId: number, body: CatalogProductOverrideDto | undefined, cancelToken?: CancelToken): Promise<AddProductToCatalogResultDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}/products/add";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProductToCatalog(_response);
        });
    }

    protected processAddProductToCatalog(response: AxiosResponse): Promise<AddProductToCatalogResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddProductToCatalogResultDto.fromJS(resultData200);
            return Promise.resolve<AddProductToCatalogResultDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddProductToCatalogResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    removeProductFromCatalog(orgUnitId: number, body: CatalogProductOverrideDto | undefined, cancelToken?: CancelToken): Promise<CatalogViewDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}/products/remove";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveProductFromCatalog(_response);
        });
    }

    protected processRemoveProductFromCatalog(response: AxiosResponse): Promise<CatalogViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogViewDto.fromJS(resultData200);
            return Promise.resolve<CatalogViewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setProductPriceRule(orgUnitId: number, productId: number, body: SetProductPriceRuleRequestDto | undefined, cancelToken?: CancelToken): Promise<ProductPriceRuleMutationResultDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}/products/{productId}/price";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetProductPriceRule(_response);
        });
    }

    protected processSetProductPriceRule(response: AxiosResponse): Promise<ProductPriceRuleMutationResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductPriceRuleMutationResultDto.fromJS(resultData200);
            return Promise.resolve<ProductPriceRuleMutationResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductPriceRuleMutationResultDto>(null as any);
    }

    /**
     * @return OK
     */
    removeProductPriceRule(orgUnitId: number, productId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}/products/{productId}/price";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveProductPriceRule(_response);
        });
    }

    protected processRemoveProductPriceRule(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    toggleManufacturerInclusion(orgUnitId: number, body: ToggleManufacturerInclusionRequestDto | undefined, cancelToken?: CancelToken): Promise<CatalogRuleToggleResultDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}/manufacturers/inclusion";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleManufacturerInclusion(_response);
        });
    }

    protected processToggleManufacturerInclusion(response: AxiosResponse): Promise<CatalogRuleToggleResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogRuleToggleResultDto.fromJS(resultData200);
            return Promise.resolve<CatalogRuleToggleResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogRuleToggleResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    toggleProductLineInclusion(orgUnitId: number, body: ToggleProductLineInclusionRequestDto | undefined, cancelToken?: CancelToken): Promise<CatalogRuleToggleResultDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-rules/{orgUnitId}/product-lines/inclusion";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleProductLineInclusion(_response);
        });
    }

    protected processToggleProductLineInclusion(response: AxiosResponse): Promise<CatalogRuleToggleResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogRuleToggleResultDto.fromJS(resultData200);
            return Promise.resolve<CatalogRuleToggleResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogRuleToggleResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addProductToStandards(orgUnitId: number, body: StorefrontAddToStandardsDto | undefined, cancelToken?: CancelToken): Promise<StandardsProductResultDto> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/standards/{orgUnitId}/products/add";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProductToStandards(_response);
        });
    }

    protected processAddProductToStandards(response: AxiosResponse): Promise<StandardsProductResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StandardsProductResultDto.fromJS(resultData200);
            return Promise.resolve<StandardsProductResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StandardsProductResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    removeProductFromStandards(orgUnitId: number, body: StorefrontRemoveFromStandardsDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/standards/{orgUnitId}/products/remove";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveProductFromStandards(_response);
        });
    }

    protected processRemoveProductFromStandards(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getStandardsDirectory(orgUnitId: number, cancelToken?: CancelToken): Promise<GetStandardsFoldersResponse> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/standards/{orgUnitId}/directory";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStandardsDirectory(_response);
        });
    }

    protected processGetStandardsDirectory(response: AxiosResponse): Promise<GetStandardsFoldersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStandardsFoldersResponse.fromJS(resultData200);
            return Promise.resolve<GetStandardsFoldersResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStandardsFoldersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchCatalogProducts(body: ProductSearchDto | undefined, cancelToken?: CancelToken): Promise<SearchProductsResponse> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/product-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCatalogProducts(_response);
        });
    }

    protected processSearchCatalogProducts(response: AxiosResponse): Promise<SearchProductsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchProductsResponse.fromJS(resultData200);
            return Promise.resolve<SearchProductsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
                result502 = resultData502 !== undefined ? resultData502 : null as any;
    
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchProductsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    extendedSearchProducts(body: ProductSearchDto | undefined, cancelToken?: CancelToken): Promise<SearchProductsResponse> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/extended-product-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExtendedSearchProducts(_response);
        });
    }

    protected processExtendedSearchProducts(response: AxiosResponse): Promise<SearchProductsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchProductsResponse.fromJS(resultData200);
            return Promise.resolve<SearchProductsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
                result502 = resultData502 !== undefined ? resultData502 : null as any;
    
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchProductsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    warehouseSearchProducts(body: ProductSearchDto | undefined, cancelToken?: CancelToken): Promise<SearchProductsResponse> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/warehouse-product-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWarehouseSearchProducts(_response);
        });
    }

    protected processWarehouseSearchProducts(response: AxiosResponse): Promise<SearchProductsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchProductsResponse.fromJS(resultData200);
            return Promise.resolve<SearchProductsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
                result502 = resultData502 !== undefined ? resultData502 : null as any;
    
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchProductsResponse>(null as any);
    }

    /**
     * @param orgUnitId (optional) 
     * @param useUnscopedCatalogCounts (optional) 
     * @return OK
     */
    getCatalogNavigationPaths(orgUnitId: number | undefined, useUnscopedCatalogCounts: boolean | undefined, cancelToken?: CancelToken): Promise<CatalogNavigationPathsResponse> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/catalog-navigation-paths?";
        if (orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' cannot be null.");
        else if (orgUnitId !== undefined)
            url_ += "orgUnitId=" + encodeURIComponent("" + orgUnitId) + "&";
        if (useUnscopedCatalogCounts === null)
            throw new globalThis.Error("The parameter 'useUnscopedCatalogCounts' cannot be null.");
        else if (useUnscopedCatalogCounts !== undefined)
            url_ += "useUnscopedCatalogCounts=" + encodeURIComponent("" + useUnscopedCatalogCounts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogNavigationPaths(_response);
        });
    }

    protected processGetCatalogNavigationPaths(response: AxiosResponse): Promise<CatalogNavigationPathsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogNavigationPathsResponse.fromJS(resultData200);
            return Promise.resolve<CatalogNavigationPathsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
                result502 = resultData502 !== undefined ? resultData502 : null as any;
    
            return throwException("Bad Gateway", status, _responseText, _headers, result502);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogNavigationPathsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCatalogInfo(orgUnitId: number, cancelToken?: CancelToken): Promise<StorefrontCatalogInfoResult> {
        let url_ = this.baseUrl + "/api/StorefrontCatalog/org-units/{orgUnitId}/catalog-info";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogInfo(_response);
        });
    }

    protected processGetCatalogInfo(response: AxiosResponse): Promise<StorefrontCatalogInfoResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorefrontCatalogInfoResult.fromJS(resultData200);
            return Promise.resolve<StorefrontCatalogInfoResult>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontCatalogInfoResult>(null as any);
    }
}

export interface IStorefrontCurrencyClient {
    /**
     * Returns the currency the signed-in user's current org unit transacts in. Every authenticated
    caller may read it: it carries no account data, and any price the user can already see has to
    be labelled with it.
     * @return OK
     */
    getStorefrontCurrency( cancelToken?: CancelToken): Promise<StorefrontCurrencyDto>;
    /**
     * Returns the currency of a storefront the caller is authorized to manage.
     * @return OK
     */
    getStorefrontCurrencyForOrgUnit(orgUnitId: number,  cancelToken?: CancelToken): Promise<StorefrontCurrencyDto>;
    /**
     * @return OK
     */
    getStorefrontCurrencyById(id: number[],  cancelToken?: CancelToken): Promise<StorefrontCurrencyDto[]>;
}

export class StorefrontCurrencyClient extends AuthorizedApiBase implements IStorefrontCurrencyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the currency the signed-in user's current org unit transacts in. Every authenticated
    caller may read it: it carries no account data, and any price the user can already see has to
    be labelled with it.
     * @return OK
     */
    getStorefrontCurrency( cancelToken?: CancelToken): Promise<StorefrontCurrencyDto> {
        let url_ = this.baseUrl + "/api/ecommerce/storefront/currency";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStorefrontCurrency(_response);
        });
    }

    protected processGetStorefrontCurrency(response: AxiosResponse): Promise<StorefrontCurrencyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorefrontCurrencyDto.fromJS(resultData200);
            return Promise.resolve<StorefrontCurrencyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontCurrencyDto>(null as any);
    }

    /**
     * Returns the currency of a storefront the caller is authorized to manage.
     * @return OK
     */
    getStorefrontCurrencyForOrgUnit(orgUnitId: number, cancelToken?: CancelToken): Promise<StorefrontCurrencyDto> {
        let url_ = this.baseUrl + "/api/ecommerce/storefront/{orgUnitId}/currency";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStorefrontCurrencyForOrgUnit(_response);
        });
    }

    protected processGetStorefrontCurrencyForOrgUnit(response: AxiosResponse): Promise<StorefrontCurrencyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorefrontCurrencyDto.fromJS(resultData200);
            return Promise.resolve<StorefrontCurrencyDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontCurrencyDto>(null as any);
    }

    /**
     * @return OK
     */
    getStorefrontCurrencyById(id: number[], cancelToken?: CancelToken): Promise<StorefrontCurrencyDto[]> {
        let url_ = this.baseUrl + "/api/ecommerce/storefront/currency/by-id?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStorefrontCurrencyById(_response);
        });
    }

    protected processGetStorefrontCurrencyById(response: AxiosResponse): Promise<StorefrontCurrencyDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StorefrontCurrencyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StorefrontCurrencyDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontCurrencyDto[]>(null as any);
    }
}

export interface IStorefrontsClient {
    /**
     * Lists storefronts for the current user's active CRM account.
     * @return OK
     */
    getStorefronts( cancelToken?: CancelToken): Promise<StorefrontDto[]>;
    /**
     * Lists storefront groups and memberships for the storefronts the current user may manage:
    every storefront of the account for a storefront admin, and only their own storefronts for a Storefront Manager.
    Other users get an empty list.
     * @return OK
     */
    getStorefrontSecurityGroups( cancelToken?: CancelToken): Promise<StorefrontSecurityGroupDto[]>;
    /**
     * Lists the users of an org unit's storefront once each, merged across its groups, with search, sorting and paging.
     * @param orgUnitId The org unit the storefront was created for.
     * @param body (optional) Search, sort and paging parameters.
     * @return OK
     */
    searchStorefrontMembers(orgUnitId: number, body: StorefrontMembersRequest | undefined,  cancelToken?: CancelToken): Promise<StorefrontMembersPageDto>;
    /**
     * Lists one page of the users of the caller's tenant who can be added to an org unit's storefront, sorted by name.
     * @param orgUnitId The org unit the storefront was created for.
     * @param searchString (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    listStorefrontAssignableUsers(orgUnitId: number, searchString: string | undefined, page: number | undefined, pageSize: number | undefined,  cancelToken?: CancelToken): Promise<StorefrontAssignableUsersPageDto>;
    /**
     * Adds or updates storefront group memberships for active users in the current user's account.
     * @param storefrontId The storefront identifier.
     * @param groupId The storefront group identifier.
     * @param body (optional) The user assignments to add or update.
     * @return OK
     */
    addUsersToStorefrontGroup(storefrontId: number, groupId: number, body: AddUsersToStorefrontGroupRequest | undefined,  cancelToken?: CancelToken): Promise<StorefrontGroupUserDto[]>;
    /**
     * Removes a storefront group membership for a user in the current user's account.
     * @param storefrontId The storefront identifier.
     * @param groupId The storefront group identifier.
     * @param userId The Customer Experience user identifier.
     * @return No Content
     */
    removeUserFromStorefrontGroup(storefrontId: number, groupId: number, userId: string,  cancelToken?: CancelToken): Promise<void>;
}

export class StorefrontsClient extends AuthorizedApiBase implements IStorefrontsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Lists storefronts for the current user's active CRM account.
     * @return OK
     */
    getStorefronts( cancelToken?: CancelToken): Promise<StorefrontDto[]> {
        let url_ = this.baseUrl + "/api/storefronts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStorefronts(_response);
        });
    }

    protected processGetStorefronts(response: AxiosResponse): Promise<StorefrontDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StorefrontDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StorefrontDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontDto[]>(null as any);
    }

    /**
     * Lists storefront groups and memberships for the storefronts the current user may manage:
    every storefront of the account for a storefront admin, and only their own storefronts for a Storefront Manager.
    Other users get an empty list.
     * @return OK
     */
    getStorefrontSecurityGroups( cancelToken?: CancelToken): Promise<StorefrontSecurityGroupDto[]> {
        let url_ = this.baseUrl + "/api/storefronts/security-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStorefrontSecurityGroups(_response);
        });
    }

    protected processGetStorefrontSecurityGroups(response: AxiosResponse): Promise<StorefrontSecurityGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StorefrontSecurityGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StorefrontSecurityGroupDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontSecurityGroupDto[]>(null as any);
    }

    /**
     * Lists the users of an org unit's storefront once each, merged across its groups, with search, sorting and paging.
     * @param orgUnitId The org unit the storefront was created for.
     * @param body (optional) Search, sort and paging parameters.
     * @return OK
     */
    searchStorefrontMembers(orgUnitId: number, body: StorefrontMembersRequest | undefined, cancelToken?: CancelToken): Promise<StorefrontMembersPageDto> {
        let url_ = this.baseUrl + "/api/storefronts/{orgUnitId}/users/search";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchStorefrontMembers(_response);
        });
    }

    protected processSearchStorefrontMembers(response: AxiosResponse): Promise<StorefrontMembersPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorefrontMembersPageDto.fromJS(resultData200);
            return Promise.resolve<StorefrontMembersPageDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontMembersPageDto>(null as any);
    }

    /**
     * Lists one page of the users of the caller's tenant who can be added to an org unit's storefront, sorted by name.
     * @param orgUnitId The org unit the storefront was created for.
     * @param searchString (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    listStorefrontAssignableUsers(orgUnitId: number, searchString: string | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<StorefrontAssignableUsersPageDto> {
        let url_ = this.baseUrl + "/api/storefronts/{orgUnitId}/assignable-users?";
        if (orgUnitId === undefined || orgUnitId === null)
            throw new globalThis.Error("The parameter 'orgUnitId' must be defined.");
        url_ = url_.replace("{orgUnitId}", encodeURIComponent("" + orgUnitId));
        if (searchString === null)
            throw new globalThis.Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListStorefrontAssignableUsers(_response);
        });
    }

    protected processListStorefrontAssignableUsers(response: AxiosResponse): Promise<StorefrontAssignableUsersPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorefrontAssignableUsersPageDto.fromJS(resultData200);
            return Promise.resolve<StorefrontAssignableUsersPageDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontAssignableUsersPageDto>(null as any);
    }

    /**
     * Adds or updates storefront group memberships for active users in the current user's account.
     * @param storefrontId The storefront identifier.
     * @param groupId The storefront group identifier.
     * @param body (optional) The user assignments to add or update.
     * @return OK
     */
    addUsersToStorefrontGroup(storefrontId: number, groupId: number, body: AddUsersToStorefrontGroupRequest | undefined, cancelToken?: CancelToken): Promise<StorefrontGroupUserDto[]> {
        let url_ = this.baseUrl + "/api/storefronts/{storefrontId}/groups/{groupId}/users";
        if (storefrontId === undefined || storefrontId === null)
            throw new globalThis.Error("The parameter 'storefrontId' must be defined.");
        url_ = url_.replace("{storefrontId}", encodeURIComponent("" + storefrontId));
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUsersToStorefrontGroup(_response);
        });
    }

    protected processAddUsersToStorefrontGroup(response: AxiosResponse): Promise<StorefrontGroupUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StorefrontGroupUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StorefrontGroupUserDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorefrontGroupUserDto[]>(null as any);
    }

    /**
     * Removes a storefront group membership for a user in the current user's account.
     * @param storefrontId The storefront identifier.
     * @param groupId The storefront group identifier.
     * @param userId The Customer Experience user identifier.
     * @return No Content
     */
    removeUserFromStorefrontGroup(storefrontId: number, groupId: number, userId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/storefronts/{storefrontId}/groups/{groupId}/users/{userId}";
        if (storefrontId === undefined || storefrontId === null)
            throw new globalThis.Error("The parameter 'storefrontId' must be defined.");
        url_ = url_.replace("{storefrontId}", encodeURIComponent("" + storefrontId));
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUserFromStorefrontGroup(_response);
        });
    }

    protected processRemoveUserFromStorefrontGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISupportOverviewWidgetClient {
    /**
     * @param dateFilter (optional) 
     * @return OK
     */
    getSupportRequestsOverview(dateFilter: DateFilterOption | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfSupportOverviewDto>;
}

export class SupportOverviewWidgetClient extends AuthorizedApiBase implements ISupportOverviewWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFilter (optional) 
     * @return OK
     */
    getSupportRequestsOverview(dateFilter: DateFilterOption | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfSupportOverviewDto> {
        let url_ = this.baseUrl + "/api/widget/support-requests_overview-widgets?";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "dateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSupportRequestsOverview(_response);
        });
    }

    protected processGetSupportRequestsOverview(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfSupportOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfSupportOverviewDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfSupportOverviewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfSupportOverviewDto>(null as any);
    }
}

export interface ISupportRequestWidgetsClient {
    /**
     * @param visualKey (optional) 
     * @param dateFilterOption (optional) 
     * @param activeOnly (optional) 
     * @return OK
     */
    getSupportRequestsData(visualKey: ServiceRequestVisualsTypes | undefined, dateFilterOption: DateFilterOption | undefined, activeOnly: boolean | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto>;
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return OK
     */
    getCompletedRequestsMeetingSlaWidget(dateFrom: Date | undefined, dateTo: Date | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto>;
}

export class SupportRequestWidgetsClient extends AuthorizedApiBase implements ISupportRequestWidgetsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param visualKey (optional) 
     * @param dateFilterOption (optional) 
     * @param activeOnly (optional) 
     * @return OK
     */
    getSupportRequestsData(visualKey: ServiceRequestVisualsTypes | undefined, dateFilterOption: DateFilterOption | undefined, activeOnly: boolean | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        let url_ = this.baseUrl + "/api/widget/support-requests-widgets/support-request-data?";
        if (visualKey === null)
            throw new globalThis.Error("The parameter 'visualKey' cannot be null.");
        else if (visualKey !== undefined)
            url_ += "visualKey=" + encodeURIComponent("" + visualKey) + "&";
        if (dateFilterOption === null)
            throw new globalThis.Error("The parameter 'dateFilterOption' cannot be null.");
        else if (dateFilterOption !== undefined)
            url_ += "dateFilterOption=" + encodeURIComponent("" + dateFilterOption) + "&";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSupportRequestsData(_response);
        });
    }

    protected processGetSupportRequestsData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfPieChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfPieChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfPieChartDto>(null as any);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return OK
     */
    getCompletedRequestsMeetingSlaWidget(dateFrom: Date | undefined, dateTo: Date | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto> {
        let url_ = this.baseUrl + "/api/widget/support-requests-widgets/completed-requests-meeting-sla-widget?";
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompletedRequestsMeetingSlaWidget(_response);
        });
    }

    protected processGetCompletedRequestsMeetingSlaWidget(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto>(null as any);
    }
}

export interface ITenantSwitchClient {
    /**
     * Returns the signed-in user's tenants and the current selection.
     * @return OK
     */
    getMyTenants( cancelToken?: CancelToken): Promise<UserTenantsResponse>;
    /**
     * Changes the current tenant for this session.
     * @param body (optional) 
     * @return No Content
     */
    switchTenant(body: SwitchTenantRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Invalidates the cached identity for the current session.
     * @return No Content
     */
    invalidateSessionCache( cancelToken?: CancelToken): Promise<void>;
}

export class TenantSwitchClient extends AuthorizedApiBase implements ITenantSwitchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the signed-in user's tenants and the current selection.
     * @return OK
     */
    getMyTenants( cancelToken?: CancelToken): Promise<UserTenantsResponse> {
        let url_ = this.baseUrl + "/api/cx-users/current-user/tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyTenants(_response);
        });
    }

    protected processGetMyTenants(response: AxiosResponse): Promise<UserTenantsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTenantsResponse.fromJS(resultData200);
            return Promise.resolve<UserTenantsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTenantsResponse>(null as any);
    }

    /**
     * Changes the current tenant for this session.
     * @param body (optional) 
     * @return No Content
     */
    switchTenant(body: SwitchTenantRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cx-users/current-user/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchTenant(_response);
        });
    }

    protected processSwitchTenant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Invalidates the cached identity for the current session.
     * @return No Content
     */
    invalidateSessionCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cx-users/current-user/tenants/invalidate-session-cache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateSessionCache(_response);
        });
    }

    protected processInvalidateSessionCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITestClient {
    /**
     * Generate telemetry data that contains (fake) PII to test the PII processor in the OTel collector.
     * @return OK
     */
    piiTelemetry( cancelToken?: CancelToken): Promise<void>;
}

export class TestClient extends AuthorizedApiBase implements ITestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Generate telemetry data that contains (fake) PII to test the PII processor in the OTel collector.
     * @return OK
     */
    piiTelemetry( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Test/pii-telemetry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPiiTelemetry(_response);
        });
    }

    protected processPiiTelemetry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITicketClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    postTicketNote(body: TicketNoteDTO | undefined,  cancelToken?: CancelToken): Promise<TicketCacheResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    postTicketAdditionalContacts(ticketId: number, body: ServiceRequestContactSelectionDto[] | undefined,  cancelToken?: CancelToken): Promise<PostTicketServiceRequestContactsResponse>;
    /**
     * @return OK
     */
    getTicketAdditionalContactsByTicket(ticketId: number,  cancelToken?: CancelToken): Promise<TicketAdditionalContactDTO[]>;
}

export class TicketClient extends AuthorizedApiBase implements ITicketClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postTicketNote(body: TicketNoteDTO | undefined, cancelToken?: CancelToken): Promise<TicketCacheResponse> {
        let url_ = this.baseUrl + "/api/Ticket/ticketnote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostTicketNote(_response);
        });
    }

    protected processPostTicketNote(response: AxiosResponse): Promise<TicketCacheResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TicketCacheResponse.fromJS(resultData200);
            return Promise.resolve<TicketCacheResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketCacheResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postTicketAdditionalContacts(ticketId: number, body: ServiceRequestContactSelectionDto[] | undefined, cancelToken?: CancelToken): Promise<PostTicketServiceRequestContactsResponse> {
        let url_ = this.baseUrl + "/api/Ticket/additional-contacts/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostTicketAdditionalContacts(_response);
        });
    }

    protected processPostTicketAdditionalContacts(response: AxiosResponse): Promise<PostTicketServiceRequestContactsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostTicketServiceRequestContactsResponse.fromJS(resultData200);
            return Promise.resolve<PostTicketServiceRequestContactsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostTicketServiceRequestContactsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getTicketAdditionalContactsByTicket(ticketId: number, cancelToken?: CancelToken): Promise<TicketAdditionalContactDTO[]> {
        let url_ = this.baseUrl + "/api/Ticket/additional-contacts/ticket/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketAdditionalContactsByTicket(_response);
        });
    }

    protected processGetTicketAdditionalContactsByTicket(response: AxiosResponse): Promise<TicketAdditionalContactDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketAdditionalContactDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TicketAdditionalContactDTO[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TicketAdditionalContactDTO[]>(null as any);
    }
}

export interface ITicketIntegrationClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    submitTicket(body: any | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    deleteTicket(ticketId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    addNoteToTicket(ticketId: string, body: any | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    deleteNoteFromTicket(ticketId: string, noteId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param fileName (optional) 
     * @return OK
     */
    addAttachmentToTicket(ticketId: string, fileName: string | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class TicketIntegrationClient extends AuthorizedApiBase implements ITicketIntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitTicket(body: any | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitTicket(_response);
        });
    }

    protected processSubmitTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    deleteTicket(ticketId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTicket(_response);
        });
    }

    protected processDeleteTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addNoteToTicket(ticketId: string, body: any | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets/{ticketId}/notes";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNoteToTicket(_response);
        });
    }

    protected processAddNoteToTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    deleteNoteFromTicket(ticketId: string, noteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets/{ticketId}/notes/{noteId}";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (noteId === undefined || noteId === null)
            throw new globalThis.Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNoteFromTicket(_response);
        });
    }

    protected processDeleteNoteFromTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @return OK
     */
    addAttachmentToTicket(ticketId: string, fileName: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/TicketIntegration/tickets/{ticketId}/attachments?";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAttachmentToTicket(_response);
        });
    }

    protected processAddAttachmentToTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITotalRequestsCompletedWidgetClient {
    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return OK
     */
    getTotalRequestsCompletedData(dateFrom: Date | undefined, dateTo: Date | undefined,  cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfBarChartDto>;
}

export class TotalRequestsCompletedWidgetClient extends AuthorizedApiBase implements ITotalRequestsCompletedWidgetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @return OK
     */
    getTotalRequestsCompletedData(dateFrom: Date | undefined, dateTo: Date | undefined, cancelToken?: CancelToken): Promise<WidgetContentResponseDto_1OfBarChartDto> {
        let url_ = this.baseUrl + "/api/widget/total-requests-completed-widget?";
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTotalRequestsCompletedData(_response);
        });
    }

    protected processGetTotalRequestsCompletedData(response: AxiosResponse): Promise<WidgetContentResponseDto_1OfBarChartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WidgetContentResponseDto_1OfBarChartDto.fromJS(resultData200);
            return Promise.resolve<WidgetContentResponseDto_1OfBarChartDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetContentResponseDto_1OfBarChartDto>(null as any);
    }
}

export interface IUnityClient {
    /**
     * @return OK
     */
    getUnityStatus( cancelToken?: CancelToken): Promise<UnityStatusDto>;
    /**
     * @param newStatus (optional) 
     * @return OK
     */
    updateUnityStatus(newStatus: UnityExperienceStatus | undefined,  cancelToken?: CancelToken): Promise<UnityStatusDto>;
}

export class UnityClient extends AuthorizedApiBase implements IUnityClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getUnityStatus( cancelToken?: CancelToken): Promise<UnityStatusDto> {
        let url_ = this.baseUrl + "/api/Unity/UnityStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnityStatus(_response);
        });
    }

    protected processGetUnityStatus(response: AxiosResponse): Promise<UnityStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnityStatusDto.fromJS(resultData200);
            return Promise.resolve<UnityStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnityStatusDto>(null as any);
    }

    /**
     * @param newStatus (optional) 
     * @return OK
     */
    updateUnityStatus(newStatus: UnityExperienceStatus | undefined, cancelToken?: CancelToken): Promise<UnityStatusDto> {
        let url_ = this.baseUrl + "/api/Unity/UnityStatus?";
        if (newStatus === null)
            throw new globalThis.Error("The parameter 'newStatus' cannot be null.");
        else if (newStatus !== undefined)
            url_ += "newStatus=" + encodeURIComponent("" + newStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUnityStatus(_response);
        });
    }

    protected processUpdateUnityStatus(response: AxiosResponse): Promise<UnityStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnityStatusDto.fromJS(resultData200);
            return Promise.resolve<UnityStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnityStatusDto>(null as any);
    }
}

export interface IUserContextClient {
    /**
     * @return OK
     */
    getContext( cancelToken?: CancelToken): Promise<UserContextResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    switchContext(body: SwitchUserContextRequest | undefined,  cancelToken?: CancelToken): Promise<SwitchUserContextResponse>;
}

export class UserContextClient extends AuthorizedApiBase implements IUserContextClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getContext( cancelToken?: CancelToken): Promise<UserContextResponse> {
        let url_ = this.baseUrl + "/api/cx-users/current-user/context";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContext(_response);
        });
    }

    protected processGetContext(response: AxiosResponse): Promise<UserContextResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserContextResponse.fromJS(resultData200);
            return Promise.resolve<UserContextResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserContextResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    switchContext(body: SwitchUserContextRequest | undefined, cancelToken?: CancelToken): Promise<SwitchUserContextResponse> {
        let url_ = this.baseUrl + "/api/cx-users/current-user/context";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchContext(_response);
        });
    }

    protected processSwitchContext(response: AxiosResponse): Promise<SwitchUserContextResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SwitchUserContextResponse.fromJS(resultData200);
            return Promise.resolve<SwitchUserContextResponse>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwitchUserContextResponse>(null as any);
    }
}

export interface IUserManagementClient {
    /**
     * Returns the admin users for the current user's tenant.
     * @return OK
     */
    getAdministrators( cancelToken?: CancelToken): Promise<TenantAdminUserDto[]>;
    /**
     * Returns user counts by status for the current user's tenant.
     * @return OK
     */
    getBasicInfo( cancelToken?: CancelToken): Promise<CxTenantBasicInfoDto>;
    /**
     * Returns a paged, filtered, sorted list of users for the current user's tenant.
     * @param body (optional) 
     * @return OK
     */
    getPagedUsers(body: CxAccountUsersPageRequest | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfTenantAdminUserDto>;
    /**
     * Returns all users for the current user's tenant, unpaged.
     * @return OK
     */
    getMappedUsers( cancelToken?: CancelToken): Promise<TenantAdminUserDto[]>;
    /**
     * Approves an awaiting-approval user-tenant membership.
     * @param body (optional) 
     * @return OK
     */
    approveUser(body: ApproveUserRequest | undefined,  cancelToken?: CancelToken): Promise<TenantAdminUserDto>;
    /**
     * Rejects an awaiting-approval user-tenant membership: verifies the membership is still
    AwaitingApproval, then deletes only the membership row (the user record is preserved).
     * @return No Content
     */
    rejectUser(userId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Creates a new user-tenant membership for the current tenant. If a
    CustomerExperienceUser already exists for the given email (e.g. from another tenant),
    that record is reused/updated instead of creating a duplicate user.
     * @param body (optional) 
     * @return OK
     */
    createUser(body: CreateCxUserRequest | undefined,  cancelToken?: CancelToken): Promise<TenantAdminUserDto>;
    /**
     * Updates a user's profile fields, admin flag, and role.
     * @param body (optional) 
     * @return OK
     */
    updateUser(body: UpdateCxUserRequest | undefined,  cancelToken?: CancelToken): Promise<TenantAdminUserDto>;
    /**
     * Reactivates an inactive user (sets the tenant membership back to Active).
     * @return OK
     */
    reactivateUser(userId: string,  cancelToken?: CancelToken): Promise<TenantAdminUserDto>;
    /**
     * Returns guest users for the current tenant with their permission sets.
     * @return OK
     */
    getGuestUsers( cancelToken?: CancelToken): Promise<CxGuestUserDto[]>;
    /**
     * Creates guest memberships by email and sends each one a welcome email.
     * @param body (optional) 
     * @return No Content
     */
    createGuestUsers(body: CxCreateGuestUsersRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Catalog of permissions that may be assigned to a guest.
     * @return OK
     */
    getAllowedGuestPermissions( cancelToken?: CancelToken): Promise<string[]>;
    /**
     * Resends the guest welcome email. Changes no permissions.
     * @param body (optional) 
     * @return No Content
     */
    emailGuestUsers(body: CxEmailGuestUsersRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Replaces a guest's permission set. Never creates.
     * @param body (optional) 
     * @return No Content
     */
    updateGuestUserPermissions(userId: string, body: CxUpdateGuestUserPermissionsRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Deletes a guest user's tenant membership.
     * @return No Content
     */
    deleteGuestUser(userId: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * Returns the security groups available for assignment on the current tenant.
     * @return OK
     */
    getSecurityGroups( cancelToken?: CancelToken): Promise<CxSecurityGroupDto[]>;
    /**
     * Returns the ids of the security groups a user currently belongs to.
     * @return OK
     */
    getUserSecurityGroups(userId: string,  cancelToken?: CancelToken): Promise<number[]>;
    /**
     * Returns the current effective portal role for a user on this tenant.
     * @return OK
     */
    getUserRole(userId: string,  cancelToken?: CancelToken): Promise<PortalRole>;
}

export class UserManagementClient extends AuthorizedApiBase implements IUserManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns the admin users for the current user's tenant.
     * @return OK
     */
    getAdministrators( cancelToken?: CancelToken): Promise<TenantAdminUserDto[]> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/administrators";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdministrators(_response);
        });
    }

    protected processGetAdministrators(response: AxiosResponse): Promise<TenantAdminUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantAdminUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TenantAdminUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantAdminUserDto[]>(null as any);
    }

    /**
     * Returns user counts by status for the current user's tenant.
     * @return OK
     */
    getBasicInfo( cancelToken?: CancelToken): Promise<CxTenantBasicInfoDto> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/basic-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicInfo(_response);
        });
    }

    protected processGetBasicInfo(response: AxiosResponse): Promise<CxTenantBasicInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CxTenantBasicInfoDto.fromJS(resultData200);
            return Promise.resolve<CxTenantBasicInfoDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxTenantBasicInfoDto>(null as any);
    }

    /**
     * Returns a paged, filtered, sorted list of users for the current user's tenant.
     * @param body (optional) 
     * @return OK
     */
    getPagedUsers(body: CxAccountUsersPageRequest | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfTenantAdminUserDto> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/users/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedUsers(_response);
        });
    }

    protected processGetPagedUsers(response: AxiosResponse): Promise<PaginatedResultDto_1OfTenantAdminUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfTenantAdminUserDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfTenantAdminUserDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfTenantAdminUserDto>(null as any);
    }

    /**
     * Returns all users for the current user's tenant, unpaged.
     * @return OK
     */
    getMappedUsers( cancelToken?: CancelToken): Promise<TenantAdminUserDto[]> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/users/mapped";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMappedUsers(_response);
        });
    }

    protected processGetMappedUsers(response: AxiosResponse): Promise<TenantAdminUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantAdminUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TenantAdminUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantAdminUserDto[]>(null as any);
    }

    /**
     * Approves an awaiting-approval user-tenant membership.
     * @param body (optional) 
     * @return OK
     */
    approveUser(body: ApproveUserRequest | undefined, cancelToken?: CancelToken): Promise<TenantAdminUserDto> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/users/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveUser(_response);
        });
    }

    protected processApproveUser(response: AxiosResponse): Promise<TenantAdminUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantAdminUserDto.fromJS(resultData200);
            return Promise.resolve<TenantAdminUserDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantAdminUserDto>(null as any);
    }

    /**
     * Rejects an awaiting-approval user-tenant membership: verifies the membership is still
    AwaitingApproval, then deletes only the membership row (the user record is preserved).
     * @return No Content
     */
    rejectUser(userId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/users/{userId}/reject";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectUser(_response);
        });
    }

    protected processRejectUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a new user-tenant membership for the current tenant. If a
    CustomerExperienceUser already exists for the given email (e.g. from another tenant),
    that record is reused/updated instead of creating a duplicate user.
     * @param body (optional) 
     * @return OK
     */
    createUser(body: CreateCxUserRequest | undefined, cancelToken?: CancelToken): Promise<TenantAdminUserDto> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<TenantAdminUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantAdminUserDto.fromJS(resultData200);
            return Promise.resolve<TenantAdminUserDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantAdminUserDto>(null as any);
    }

    /**
     * Updates a user's profile fields, admin flag, and role.
     * @param body (optional) 
     * @return OK
     */
    updateUser(body: UpdateCxUserRequest | undefined, cancelToken?: CancelToken): Promise<TenantAdminUserDto> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<TenantAdminUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantAdminUserDto.fromJS(resultData200);
            return Promise.resolve<TenantAdminUserDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantAdminUserDto>(null as any);
    }

    /**
     * Reactivates an inactive user (sets the tenant membership back to Active).
     * @return OK
     */
    reactivateUser(userId: string, cancelToken?: CancelToken): Promise<TenantAdminUserDto> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/users/{userId}/reactivate";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivateUser(_response);
        });
    }

    protected processReactivateUser(response: AxiosResponse): Promise<TenantAdminUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantAdminUserDto.fromJS(resultData200);
            return Promise.resolve<TenantAdminUserDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantAdminUserDto>(null as any);
    }

    /**
     * Returns guest users for the current tenant with their permission sets.
     * @return OK
     */
    getGuestUsers( cancelToken?: CancelToken): Promise<CxGuestUserDto[]> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/guest-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGuestUsers(_response);
        });
    }

    protected processGetGuestUsers(response: AxiosResponse): Promise<CxGuestUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CxGuestUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CxGuestUserDto[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxGuestUserDto[]>(null as any);
    }

    /**
     * Creates guest memberships by email and sends each one a welcome email.
     * @param body (optional) 
     * @return No Content
     */
    createGuestUsers(body: CxCreateGuestUsersRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/guest-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGuestUsers(_response);
        });
    }

    protected processCreateGuestUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Catalog of permissions that may be assigned to a guest.
     * @return OK
     */
    getAllowedGuestPermissions( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/guest-users/allowed-permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllowedGuestPermissions(_response);
        });
    }

    protected processGetAllowedGuestPermissions(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Resends the guest welcome email. Changes no permissions.
     * @param body (optional) 
     * @return No Content
     */
    emailGuestUsers(body: CxEmailGuestUsersRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/guest-users/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailGuestUsers(_response);
        });
    }

    protected processEmailGuestUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Replaces a guest's permission set. Never creates.
     * @param body (optional) 
     * @return No Content
     */
    updateGuestUserPermissions(userId: string, body: CxUpdateGuestUserPermissionsRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/guest-users/{userId}/permissions";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGuestUserPermissions(_response);
        });
    }

    protected processUpdateGuestUserPermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes a guest user's tenant membership.
     * @return No Content
     */
    deleteGuestUser(userId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/guest-users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGuestUser(_response);
        });
    }

    protected processDeleteGuestUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns the security groups available for assignment on the current tenant.
     * @return OK
     */
    getSecurityGroups( cancelToken?: CancelToken): Promise<CxSecurityGroupDto[]> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/security-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSecurityGroups(_response);
        });
    }

    protected processGetSecurityGroups(response: AxiosResponse): Promise<CxSecurityGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CxSecurityGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CxSecurityGroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CxSecurityGroupDto[]>(null as any);
    }

    /**
     * Returns the ids of the security groups a user currently belongs to.
     * @return OK
     */
    getUserSecurityGroups(userId: string, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/users/{userId}/security-groups";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSecurityGroups(_response);
        });
    }

    protected processGetUserSecurityGroups(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Returns the current effective portal role for a user on this tenant.
     * @return OK
     */
    getUserRole(userId: string, cancelToken?: CancelToken): Promise<PortalRole> {
        let url_ = this.baseUrl + "/api/cx-users/account-admin/users/{userId}/role";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRole(_response);
        });
    }

    protected processGetUserRole(response: AxiosResponse): Promise<PortalRole> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<PortalRole>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PortalRole>(null as any);
    }
}

export interface IUserProfileClient {
    /**
     * @return OK
     */
    getProvisioningData( cancelToken?: CancelToken): Promise<UserProvisioningResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    updateProfile(body: CreateProfile | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class UserProfileClient extends AuthorizedApiBase implements IUserProfileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getProvisioningData( cancelToken?: CancelToken): Promise<UserProvisioningResponse> {
        let url_ = this.baseUrl + "/api/Profile/provisioning";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProvisioningData(_response);
        });
    }

    protected processGetProvisioningData(response: AxiosResponse): Promise<UserProvisioningResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProvisioningResponse.fromJS(resultData200);
            return Promise.resolve<UserProvisioningResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProvisioningResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProfile(body: CreateProfile | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Profile/updateprofile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUserSettingsClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    postUserConfig(body: UserConfigDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteUserConfig(body: UserConfigDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    getUserConfigs( cancelToken?: CancelToken): Promise<UserConfigDto[]>;
}

export class UserSettingsClient extends AuthorizedApiBase implements IUserSettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postUserConfig(body: UserConfigDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/UserSettings/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUserConfig(_response);
        });
    }

    protected processPostUserConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteUserConfig(body: UserConfigDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/UserSettings/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserConfig(_response);
        });
    }

    protected processDeleteUserConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getUserConfigs( cancelToken?: CancelToken): Promise<UserConfigDto[]> {
        let url_ = this.baseUrl + "/api/UserSettings/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserConfigs(_response);
        });
    }

    protected processGetUserConfigs(response: AxiosResponse): Promise<UserConfigDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserConfigDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserConfigDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserConfigDto[]>(null as any);
    }
}

export interface IWarehouseClient {
    /**
     * @return OK
     */
    getWarehouseStock( cancelToken?: CancelToken): Promise<GetWarehouseStockResponse>;
    /**
     * @return OK
     */
    getWarehouseOrdersPicklist( cancelToken?: CancelToken): Promise<IncludeExcludeFilterCategory[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    getWarehouseOrders(body: PaginatedFilterQuery | undefined,  cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto>;
}

export class WarehouseClient extends AuthorizedApiBase implements IWarehouseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getWarehouseStock( cancelToken?: CancelToken): Promise<GetWarehouseStockResponse> {
        let url_ = this.baseUrl + "/api/Warehouse/stock";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehouseStock(_response);
        });
    }

    protected processGetWarehouseStock(response: AxiosResponse): Promise<GetWarehouseStockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehouseStockResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehouseStockResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehouseStockResponse>(null as any);
    }

    /**
     * @return OK
     */
    getWarehouseOrdersPicklist( cancelToken?: CancelToken): Promise<IncludeExcludeFilterCategory[]> {
        let url_ = this.baseUrl + "/api/Warehouse/orders/picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehouseOrdersPicklist(_response);
        });
    }

    protected processGetWarehouseOrdersPicklist(response: AxiosResponse): Promise<IncludeExcludeFilterCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncludeExcludeFilterCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IncludeExcludeFilterCategory[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncludeExcludeFilterCategory[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getWarehouseOrders(body: PaginatedFilterQuery | undefined, cancelToken?: CancelToken): Promise<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto> {
        let url_ = this.baseUrl + "/api/Warehouse/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehouseOrders(_response);
        });
    }

    protected processGetWarehouseOrders(response: AxiosResponse): Promise<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultDto_1OfCombinedWarehouseOrderItemDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto>(null as any);
    }
}

export enum ActionTypes {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Deactivated = "Deactivated",
    Error = "Error",
}

export enum EntityTypes {
    TicketNotes = "TicketNotes",
    Tickets = "Tickets",
    Contact = "Contact",
    ConfigurationItems = "ConfigurationItems",
    Assets = "Assets",
    Companies = "Companies",
    Error = "Error",
    ServiceLevelAgreementResults = "ServiceLevelAgreementResults",
    SurveyResults = "SurveyResults",
    BillingItem = "BillingItem",
    TicketAttachments = "TicketAttachments",
    TicketNoteAttachments = "TicketNoteAttachments",
    TimeEntryAttachments = "TimeEntryAttachments",
}

export class AutoTaskWebhookDTO implements IAutoTaskWebhookDTO {
    action?: ActionTypes;
    guid?: string;
    entityType?: EntityTypes;
    id?: number;
    fields?: { [key: string]: string; } | undefined;
    eventTime?: Date;
    sequenceNumber?: number;
    personId?: number;
    eventSource?: string | undefined;

    constructor(data?: IAutoTaskWebhookDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.guid = _data["guid"];
            this.entityType = _data["entityType"];
            this.id = _data["id"];
            if (_data["fields"]) {
                this.fields = {} as any;
                for (let key in _data["fields"]) {
                    if (_data["fields"].hasOwnProperty(key))
                        (this.fields as any)![key] = _data["fields"][key];
                }
            }
            this.eventTime = _data["eventTime"] ? new Date(_data["eventTime"].toString()) : undefined as any;
            this.sequenceNumber = _data["sequenceNumber"];
            this.personId = _data["personId"];
            this.eventSource = _data["eventSource"];
        }
    }

    static fromJS(data: any): AutoTaskWebhookDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutoTaskWebhookDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["guid"] = this.guid;
        data["entityType"] = this.entityType;
        data["id"] = this.id;
        if (this.fields) {
            data["fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (data["fields"] as any)[key] = (this.fields as any)[key];
            }
        }
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : undefined as any;
        data["sequenceNumber"] = this.sequenceNumber;
        data["personId"] = this.personId;
        data["eventSource"] = this.eventSource;
        return data;
    }
}

export interface IAutoTaskWebhookDTO {
    action?: ActionTypes;
    guid?: string;
    entityType?: EntityTypes;
    id?: number;
    fields?: { [key: string]: string; } | undefined;
    eventTime?: Date;
    sequenceNumber?: number;
    personId?: number;
    eventSource?: string | undefined;
}

export enum AutotaskEntityType {
    Account = "Account",
    AttachmentInfo = "AttachmentInfo",
    Contact = "Contact",
    Ticket = "Ticket",
    TicketNote = "TicketNote",
    Resource = "Resource",
    Contract = "Contract",
    Project = "Project",
    Product = "Product",
    ContractRetainer = "ContractRetainer",
    ContractService = "ContractService",
}

export class AutotaskPicklistEntity implements IAutotaskPicklistEntity {
    entityType!: AutotaskEntityType;
    fields?: AutotaskPicklistField[] | undefined;

    constructor(data?: IAutotaskPicklistEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(AutotaskPicklistField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutotaskPicklistEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AutotaskPicklistEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAutotaskPicklistEntity {
    entityType: AutotaskEntityType;
    fields?: AutotaskPicklistField[] | undefined;
}

export class AutotaskPicklistField implements IAutotaskPicklistField {
    name?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    length?: number;
    description?: string | undefined;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isQueryable?: boolean;
    isReference?: boolean;
    isPickList?: boolean;
    pickListValues?: AutotaskPicklistValue[] | undefined;
    picklistParentValueField?: string | undefined;
    defaultValue?: string | undefined;
    isSupportedWebhookField?: boolean;

    constructor(data?: IAutotaskPicklistField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.type = _data["type"];
            this.length = _data["length"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
            this.isReadOnly = _data["isReadOnly"];
            this.isQueryable = _data["isQueryable"];
            this.isReference = _data["isReference"];
            this.isPickList = _data["isPickList"];
            if (Array.isArray(_data["pickListValues"])) {
                this.pickListValues = [] as any;
                for (let item of _data["pickListValues"])
                    this.pickListValues!.push(AutotaskPicklistValue.fromJS(item));
            }
            this.picklistParentValueField = _data["picklistParentValueField"];
            this.defaultValue = _data["defaultValue"];
            this.isSupportedWebhookField = _data["isSupportedWebhookField"];
        }
    }

    static fromJS(data: any): AutotaskPicklistField {
        data = typeof data === 'object' ? data : {};
        let result = new AutotaskPicklistField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["type"] = this.type;
        data["length"] = this.length;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        data["isReadOnly"] = this.isReadOnly;
        data["isQueryable"] = this.isQueryable;
        data["isReference"] = this.isReference;
        data["isPickList"] = this.isPickList;
        if (Array.isArray(this.pickListValues)) {
            data["pickListValues"] = [];
            for (let item of this.pickListValues)
                data["pickListValues"].push(item ? item.toJSON() : undefined as any);
        }
        data["picklistParentValueField"] = this.picklistParentValueField;
        data["defaultValue"] = this.defaultValue;
        data["isSupportedWebhookField"] = this.isSupportedWebhookField;
        return data;
    }
}

export interface IAutotaskPicklistField {
    name?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    length?: number;
    description?: string | undefined;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isQueryable?: boolean;
    isReference?: boolean;
    isPickList?: boolean;
    pickListValues?: AutotaskPicklistValue[] | undefined;
    picklistParentValueField?: string | undefined;
    defaultValue?: string | undefined;
    isSupportedWebhookField?: boolean;
}

export class AutotaskPicklistValue implements IAutotaskPicklistValue {
    value?: string | undefined;
    label?: string | undefined;
    isDefaultValue?: boolean;
    sortOrder?: number;
    parentValue?: string | undefined;
    isActive?: boolean;
    isActiveSpecified?: boolean;
    isSystem?: boolean;
    isSystemSpecified?: boolean;

    constructor(data?: IAutotaskPicklistValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.isDefaultValue = _data["isDefaultValue"];
            this.sortOrder = _data["sortOrder"];
            this.parentValue = _data["parentValue"];
            this.isActive = _data["isActive"];
            this.isActiveSpecified = _data["isActiveSpecified"];
            this.isSystem = _data["isSystem"];
            this.isSystemSpecified = _data["isSystemSpecified"];
        }
    }

    static fromJS(data: any): AutotaskPicklistValue {
        data = typeof data === 'object' ? data : {};
        let result = new AutotaskPicklistValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["isDefaultValue"] = this.isDefaultValue;
        data["sortOrder"] = this.sortOrder;
        data["parentValue"] = this.parentValue;
        data["isActive"] = this.isActive;
        data["isActiveSpecified"] = this.isActiveSpecified;
        data["isSystem"] = this.isSystem;
        data["isSystemSpecified"] = this.isSystemSpecified;
        return data;
    }
}

export interface IAutotaskPicklistValue {
    value?: string | undefined;
    label?: string | undefined;
    isDefaultValue?: boolean;
    sortOrder?: number;
    parentValue?: string | undefined;
    isActive?: boolean;
    isActiveSpecified?: boolean;
    isSystem?: boolean;
    isSystemSpecified?: boolean;
}

export class HttpValidationProblemDetails implements IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; } | undefined;
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; } | undefined;
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    errors?: { [key: string]: string[]; } | undefined;
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IValidationProblemDetails {
    errors?: { [key: string]: string[]; } | undefined;
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class EmbedToken implements IEmbedToken {
    token?: string | undefined;
    tokenId?: string;
    expiration?: Date;

    constructor(data?: IEmbedToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenId = _data["tokenId"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmbedToken {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenId"] = this.tokenId;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : undefined as any;
        return data;
    }
}

export interface IEmbedToken {
    token?: string | undefined;
    tokenId?: string;
    expiration?: Date;
}

export class DattoDevicesStatus implements IDattoDevicesStatus {
    numberOfDevices?: number;
    numberOfOnlineDevices?: number;
    numberOfOfflineDevices?: number;

    constructor(data?: IDattoDevicesStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfDevices = _data["numberOfDevices"];
            this.numberOfOnlineDevices = _data["numberOfOnlineDevices"];
            this.numberOfOfflineDevices = _data["numberOfOfflineDevices"];
        }
    }

    static fromJS(data: any): DattoDevicesStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DattoDevicesStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfDevices"] = this.numberOfDevices;
        data["numberOfOnlineDevices"] = this.numberOfOnlineDevices;
        data["numberOfOfflineDevices"] = this.numberOfOfflineDevices;
        return data;
    }
}

export interface IDattoDevicesStatus {
    numberOfDevices?: number;
    numberOfOnlineDevices?: number;
    numberOfOfflineDevices?: number;
}

export class DattoSite implements IDattoSite {
    id?: number;
    uid?: string | undefined;
    accountUid?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    onDemand?: boolean;
    splashtopAutoInstall?: boolean;
    devicesStatus?: DattoDevicesStatus;
    autotaskCompanyName?: string | undefined;
    autotaskCompanyId?: string | undefined;
    portalUrl?: string | undefined;

    constructor(data?: IDattoSite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.accountUid = _data["accountUid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.onDemand = _data["onDemand"];
            this.splashtopAutoInstall = _data["splashtopAutoInstall"];
            this.devicesStatus = _data["devicesStatus"] ? DattoDevicesStatus.fromJS(_data["devicesStatus"]) : undefined as any;
            this.autotaskCompanyName = _data["autotaskCompanyName"];
            this.autotaskCompanyId = _data["autotaskCompanyId"];
            this.portalUrl = _data["portalUrl"];
        }
    }

    static fromJS(data: any): DattoSite {
        data = typeof data === 'object' ? data : {};
        let result = new DattoSite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["accountUid"] = this.accountUid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["onDemand"] = this.onDemand;
        data["splashtopAutoInstall"] = this.splashtopAutoInstall;
        data["devicesStatus"] = this.devicesStatus ? this.devicesStatus.toJSON() : undefined as any;
        data["autotaskCompanyName"] = this.autotaskCompanyName;
        data["autotaskCompanyId"] = this.autotaskCompanyId;
        data["portalUrl"] = this.portalUrl;
        return data;
    }
}

export interface IDattoSite {
    id?: number;
    uid?: string | undefined;
    accountUid?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    onDemand?: boolean;
    splashtopAutoInstall?: boolean;
    devicesStatus?: DattoDevicesStatus;
    autotaskCompanyName?: string | undefined;
    autotaskCompanyId?: string | undefined;
    portalUrl?: string | undefined;
}

export class GetCustomerFacingYourShiTeamResponse implements IGetCustomerFacingYourShiTeamResponse {
    primaryAccountExecutive?: YourShiAccountTeamMemberDto;
    yourShiTeamMembers?: YourShiAccountTeamMemberDto[] | undefined;

    constructor(data?: IGetCustomerFacingYourShiTeamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryAccountExecutive = _data["primaryAccountExecutive"] ? YourShiAccountTeamMemberDto.fromJS(_data["primaryAccountExecutive"]) : undefined as any;
            if (Array.isArray(_data["yourShiTeamMembers"])) {
                this.yourShiTeamMembers = [] as any;
                for (let item of _data["yourShiTeamMembers"])
                    this.yourShiTeamMembers!.push(YourShiAccountTeamMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomerFacingYourShiTeamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerFacingYourShiTeamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryAccountExecutive"] = this.primaryAccountExecutive ? this.primaryAccountExecutive.toJSON() : undefined as any;
        if (Array.isArray(this.yourShiTeamMembers)) {
            data["yourShiTeamMembers"] = [];
            for (let item of this.yourShiTeamMembers)
                data["yourShiTeamMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCustomerFacingYourShiTeamResponse {
    primaryAccountExecutive?: YourShiAccountTeamMemberDto;
    yourShiTeamMembers?: YourShiAccountTeamMemberDto[] | undefined;
}

export class GetShiOneAccountTeamMembersResponse implements IGetShiOneAccountTeamMembersResponse {
    shiOneAccountTeamAlias?: TeamAliasDto;
    teamMembers?: ShiOneAccountTeamMemberDto[] | undefined;
    crmPrimaryAeShiEmployeeId?: string | undefined;

    constructor(data?: IGetShiOneAccountTeamMembersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiOneAccountTeamAlias = _data["shiOneAccountTeamAlias"] ? TeamAliasDto.fromJS(_data["shiOneAccountTeamAlias"]) : undefined as any;
            if (Array.isArray(_data["teamMembers"])) {
                this.teamMembers = [] as any;
                for (let item of _data["teamMembers"])
                    this.teamMembers!.push(ShiOneAccountTeamMemberDto.fromJS(item));
            }
            this.crmPrimaryAeShiEmployeeId = _data["crmPrimaryAeShiEmployeeId"];
        }
    }

    static fromJS(data: any): GetShiOneAccountTeamMembersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiOneAccountTeamMembersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiOneAccountTeamAlias"] = this.shiOneAccountTeamAlias ? this.shiOneAccountTeamAlias.toJSON() : undefined as any;
        if (Array.isArray(this.teamMembers)) {
            data["teamMembers"] = [];
            for (let item of this.teamMembers)
                data["teamMembers"].push(item ? item.toJSON() : undefined as any);
        }
        data["crmPrimaryAeShiEmployeeId"] = this.crmPrimaryAeShiEmployeeId;
        return data;
    }
}

export interface IGetShiOneAccountTeamMembersResponse {
    shiOneAccountTeamAlias?: TeamAliasDto;
    teamMembers?: ShiOneAccountTeamMemberDto[] | undefined;
    crmPrimaryAeShiEmployeeId?: string | undefined;
}

export class YourShiAccountTeamMemberDto implements IYourShiAccountTeamMemberDto {
    shiEmployeeId?: string;
    fullName?: string | undefined;
    customerFacingTitle?: string | undefined;
    customerFacingEmailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    photoUrl?: string | undefined;

    constructor(data?: IYourShiAccountTeamMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiEmployeeId = _data["shiEmployeeId"];
            this.fullName = _data["fullName"];
            this.customerFacingTitle = _data["customerFacingTitle"];
            this.customerFacingEmailAddress = _data["customerFacingEmailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.photoUrl = _data["photoUrl"];
        }
    }

    static fromJS(data: any): YourShiAccountTeamMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new YourShiAccountTeamMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiEmployeeId"] = this.shiEmployeeId;
        data["fullName"] = this.fullName;
        data["customerFacingTitle"] = this.customerFacingTitle;
        data["customerFacingEmailAddress"] = this.customerFacingEmailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["photoUrl"] = this.photoUrl;
        return data;
    }
}

export interface IYourShiAccountTeamMemberDto {
    shiEmployeeId?: string;
    fullName?: string | undefined;
    customerFacingTitle?: string | undefined;
    customerFacingEmailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    photoUrl?: string | undefined;
}

export class CustomerTenantAccountDto implements ICustomerTenantAccountDto {
    crmAccountId!: string;
    name!: string | undefined;
    axNumber!: string | undefined;
    autotaskAccountId?: number | undefined;
    accountExecutiveEntraId?: string | undefined;
    isPrimaryAccount?: boolean;

    constructor(data?: ICustomerTenantAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crmAccountId = _data["crmAccountId"];
            this.name = _data["name"];
            this.axNumber = _data["axNumber"];
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.accountExecutiveEntraId = _data["accountExecutiveEntraId"];
            this.isPrimaryAccount = _data["isPrimaryAccount"];
        }
    }

    static fromJS(data: any): CustomerTenantAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTenantAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crmAccountId"] = this.crmAccountId;
        data["name"] = this.name;
        data["axNumber"] = this.axNumber;
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["accountExecutiveEntraId"] = this.accountExecutiveEntraId;
        data["isPrimaryAccount"] = this.isPrimaryAccount;
        return data;
    }
}

export interface ICustomerTenantAccountDto {
    crmAccountId: string;
    name: string | undefined;
    axNumber: string | undefined;
    autotaskAccountId?: number | undefined;
    accountExecutiveEntraId?: string | undefined;
    isPrimaryAccount?: boolean;
}

export class CustomerTenantDto implements ICustomerTenantDto {
    tenantId!: string;
    name!: string | undefined;
    onboardingStatus?: OnboardingStatus;
    accountGroupId!: string;
    accounts!: CustomerTenantAccountDto[] | undefined;

    constructor(data?: ICustomerTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.onboardingStatus = _data["onboardingStatus"];
            this.accountGroupId = _data["accountGroupId"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(CustomerTenantAccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["onboardingStatus"] = this.onboardingStatus;
        data["accountGroupId"] = this.accountGroupId;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerTenantDto {
    tenantId: string;
    name: string | undefined;
    onboardingStatus?: OnboardingStatus;
    accountGroupId: string;
    accounts: CustomerTenantAccountDto[] | undefined;
}

export class CustomerTenantSearchFilterDto implements ICustomerTenantSearchFilterDto {
    accountExecutiveName?: string[] | undefined;
    accountGroupName?: string[] | undefined;
    tenantName?: string[] | undefined;
    accountName?: string[] | undefined;
    axNumber?: string[] | undefined;
    onboardingStatus?: string[] | undefined;
    businessUnit?: string[] | undefined;
    accessType?: string[] | undefined;
    active?: string[] | undefined;
    isamOwnerName?: string[] | undefined;

    constructor(data?: ICustomerTenantSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountExecutiveName"])) {
                this.accountExecutiveName = [] as any;
                for (let item of _data["accountExecutiveName"])
                    this.accountExecutiveName!.push(item);
            }
            if (Array.isArray(_data["accountGroupName"])) {
                this.accountGroupName = [] as any;
                for (let item of _data["accountGroupName"])
                    this.accountGroupName!.push(item);
            }
            if (Array.isArray(_data["tenantName"])) {
                this.tenantName = [] as any;
                for (let item of _data["tenantName"])
                    this.tenantName!.push(item);
            }
            if (Array.isArray(_data["accountName"])) {
                this.accountName = [] as any;
                for (let item of _data["accountName"])
                    this.accountName!.push(item);
            }
            if (Array.isArray(_data["axNumber"])) {
                this.axNumber = [] as any;
                for (let item of _data["axNumber"])
                    this.axNumber!.push(item);
            }
            if (Array.isArray(_data["onboardingStatus"])) {
                this.onboardingStatus = [] as any;
                for (let item of _data["onboardingStatus"])
                    this.onboardingStatus!.push(item);
            }
            if (Array.isArray(_data["businessUnit"])) {
                this.businessUnit = [] as any;
                for (let item of _data["businessUnit"])
                    this.businessUnit!.push(item);
            }
            if (Array.isArray(_data["accessType"])) {
                this.accessType = [] as any;
                for (let item of _data["accessType"])
                    this.accessType!.push(item);
            }
            if (Array.isArray(_data["active"])) {
                this.active = [] as any;
                for (let item of _data["active"])
                    this.active!.push(item);
            }
            if (Array.isArray(_data["isamOwnerName"])) {
                this.isamOwnerName = [] as any;
                for (let item of _data["isamOwnerName"])
                    this.isamOwnerName!.push(item);
            }
        }
    }

    static fromJS(data: any): CustomerTenantSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTenantSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountExecutiveName)) {
            data["accountExecutiveName"] = [];
            for (let item of this.accountExecutiveName)
                data["accountExecutiveName"].push(item);
        }
        if (Array.isArray(this.accountGroupName)) {
            data["accountGroupName"] = [];
            for (let item of this.accountGroupName)
                data["accountGroupName"].push(item);
        }
        if (Array.isArray(this.tenantName)) {
            data["tenantName"] = [];
            for (let item of this.tenantName)
                data["tenantName"].push(item);
        }
        if (Array.isArray(this.accountName)) {
            data["accountName"] = [];
            for (let item of this.accountName)
                data["accountName"].push(item);
        }
        if (Array.isArray(this.axNumber)) {
            data["axNumber"] = [];
            for (let item of this.axNumber)
                data["axNumber"].push(item);
        }
        if (Array.isArray(this.onboardingStatus)) {
            data["onboardingStatus"] = [];
            for (let item of this.onboardingStatus)
                data["onboardingStatus"].push(item);
        }
        if (Array.isArray(this.businessUnit)) {
            data["businessUnit"] = [];
            for (let item of this.businessUnit)
                data["businessUnit"].push(item);
        }
        if (Array.isArray(this.accessType)) {
            data["accessType"] = [];
            for (let item of this.accessType)
                data["accessType"].push(item);
        }
        if (Array.isArray(this.active)) {
            data["active"] = [];
            for (let item of this.active)
                data["active"].push(item);
        }
        if (Array.isArray(this.isamOwnerName)) {
            data["isamOwnerName"] = [];
            for (let item of this.isamOwnerName)
                data["isamOwnerName"].push(item);
        }
        return data;
    }
}

export interface ICustomerTenantSearchFilterDto {
    accountExecutiveName?: string[] | undefined;
    accountGroupName?: string[] | undefined;
    tenantName?: string[] | undefined;
    accountName?: string[] | undefined;
    axNumber?: string[] | undefined;
    onboardingStatus?: string[] | undefined;
    businessUnit?: string[] | undefined;
    accessType?: string[] | undefined;
    active?: string[] | undefined;
    isamOwnerName?: string[] | undefined;
}

export class CustomerTenantSearchRequestDto implements ICustomerTenantSearchRequestDto {
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: CustomerTenantSearchFilterDto;
    searchFilterExclude?: CustomerTenantSearchFilterDto;

    constructor(data?: ICustomerTenantSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortByColumn = _data["sortByColumn"];
            this.isDescending = _data["isDescending"];
            this.afterKey = _data["afterKey"];
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? CustomerTenantSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CustomerTenantSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerTenantSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTenantSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortByColumn"] = this.sortByColumn;
        data["isDescending"] = this.isDescending;
        data["afterKey"] = this.afterKey;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerTenantSearchRequestDto {
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: CustomerTenantSearchFilterDto;
    searchFilterExclude?: CustomerTenantSearchFilterDto;
}

export class CustomerTenantSearchResultDto implements ICustomerTenantSearchResultDto {
    rowKey!: string;
    accountGroupId!: string;
    accountGroupName!: string | undefined;
    accountGroupAccountExecutiveName?: string | undefined;
    accountGroupAccountExecutiveEntraId?: string | undefined;
    accountGroupTenants?: number;
    accountGroupOnboardedTenants?: number;
    accountGroupAccounts?: number;
    accountGroupOnboardedAccounts?: number;
    accountGroupUsers?: number;
    accountGroupLastActivityDate?: Date | undefined;
    tenantId?: string | undefined;
    tenantName?: string | undefined;
    tenantAccounts?: number | undefined;
    tenantAccountExecutiveName?: string | undefined;
    tenantAccountExecutiveEntraId?: string | undefined;
    tenantPrimaryAutotaskAccountId?: number | undefined;
    tenantOnboardingStatus?: OnboardingStatus;
    tenantUsers?: number | undefined;
    tenantLastActivityDate?: Date | undefined;
    crmAccountId!: string;
    autotaskAccountId?: number | undefined;
    axNumber!: string | undefined;
    accountName!: string | undefined;
    accountExecutiveName?: string | undefined;
    accountExecutiveEntraId?: string | undefined;
    accountIsActive?: boolean;

    constructor(data?: ICustomerTenantSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowKey = _data["rowKey"];
            this.accountGroupId = _data["accountGroupId"];
            this.accountGroupName = _data["accountGroupName"];
            this.accountGroupAccountExecutiveName = _data["accountGroupAccountExecutiveName"];
            this.accountGroupAccountExecutiveEntraId = _data["accountGroupAccountExecutiveEntraId"];
            this.accountGroupTenants = _data["accountGroupTenants"];
            this.accountGroupOnboardedTenants = _data["accountGroupOnboardedTenants"];
            this.accountGroupAccounts = _data["accountGroupAccounts"];
            this.accountGroupOnboardedAccounts = _data["accountGroupOnboardedAccounts"];
            this.accountGroupUsers = _data["accountGroupUsers"];
            this.accountGroupLastActivityDate = _data["accountGroupLastActivityDate"] ? new Date(_data["accountGroupLastActivityDate"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.tenantAccounts = _data["tenantAccounts"];
            this.tenantAccountExecutiveName = _data["tenantAccountExecutiveName"];
            this.tenantAccountExecutiveEntraId = _data["tenantAccountExecutiveEntraId"];
            this.tenantPrimaryAutotaskAccountId = _data["tenantPrimaryAutotaskAccountId"];
            this.tenantOnboardingStatus = _data["tenantOnboardingStatus"];
            this.tenantUsers = _data["tenantUsers"];
            this.tenantLastActivityDate = _data["tenantLastActivityDate"] ? new Date(_data["tenantLastActivityDate"].toString()) : undefined as any;
            this.crmAccountId = _data["crmAccountId"];
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.axNumber = _data["axNumber"];
            this.accountName = _data["accountName"];
            this.accountExecutiveName = _data["accountExecutiveName"];
            this.accountExecutiveEntraId = _data["accountExecutiveEntraId"];
            this.accountIsActive = _data["accountIsActive"];
        }
    }

    static fromJS(data: any): CustomerTenantSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTenantSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowKey"] = this.rowKey;
        data["accountGroupId"] = this.accountGroupId;
        data["accountGroupName"] = this.accountGroupName;
        data["accountGroupAccountExecutiveName"] = this.accountGroupAccountExecutiveName;
        data["accountGroupAccountExecutiveEntraId"] = this.accountGroupAccountExecutiveEntraId;
        data["accountGroupTenants"] = this.accountGroupTenants;
        data["accountGroupOnboardedTenants"] = this.accountGroupOnboardedTenants;
        data["accountGroupAccounts"] = this.accountGroupAccounts;
        data["accountGroupOnboardedAccounts"] = this.accountGroupOnboardedAccounts;
        data["accountGroupUsers"] = this.accountGroupUsers;
        data["accountGroupLastActivityDate"] = this.accountGroupLastActivityDate ? formatDate(this.accountGroupLastActivityDate) : undefined as any;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["tenantAccounts"] = this.tenantAccounts;
        data["tenantAccountExecutiveName"] = this.tenantAccountExecutiveName;
        data["tenantAccountExecutiveEntraId"] = this.tenantAccountExecutiveEntraId;
        data["tenantPrimaryAutotaskAccountId"] = this.tenantPrimaryAutotaskAccountId;
        data["tenantOnboardingStatus"] = this.tenantOnboardingStatus;
        data["tenantUsers"] = this.tenantUsers;
        data["tenantLastActivityDate"] = this.tenantLastActivityDate ? formatDate(this.tenantLastActivityDate) : undefined as any;
        data["crmAccountId"] = this.crmAccountId;
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["axNumber"] = this.axNumber;
        data["accountName"] = this.accountName;
        data["accountExecutiveName"] = this.accountExecutiveName;
        data["accountExecutiveEntraId"] = this.accountExecutiveEntraId;
        data["accountIsActive"] = this.accountIsActive;
        return data;
    }
}

export interface ICustomerTenantSearchResultDto {
    rowKey: string;
    accountGroupId: string;
    accountGroupName: string | undefined;
    accountGroupAccountExecutiveName?: string | undefined;
    accountGroupAccountExecutiveEntraId?: string | undefined;
    accountGroupTenants?: number;
    accountGroupOnboardedTenants?: number;
    accountGroupAccounts?: number;
    accountGroupOnboardedAccounts?: number;
    accountGroupUsers?: number;
    accountGroupLastActivityDate?: Date | undefined;
    tenantId?: string | undefined;
    tenantName?: string | undefined;
    tenantAccounts?: number | undefined;
    tenantAccountExecutiveName?: string | undefined;
    tenantAccountExecutiveEntraId?: string | undefined;
    tenantPrimaryAutotaskAccountId?: number | undefined;
    tenantOnboardingStatus?: OnboardingStatus;
    tenantUsers?: number | undefined;
    tenantLastActivityDate?: Date | undefined;
    crmAccountId: string;
    autotaskAccountId?: number | undefined;
    axNumber: string | undefined;
    accountName: string | undefined;
    accountExecutiveName?: string | undefined;
    accountExecutiveEntraId?: string | undefined;
    accountIsActive?: boolean;
}

export class ShiOneAccountTeamMemberDto implements IShiOneAccountTeamMemberDto {
    shiEmployeeId?: string;
    lastName?: string | undefined;
    firstName?: string | undefined;
    fullName?: string | undefined;
    title?: string | undefined;
    customerFacingTitle?: string | undefined;
    connectionRoleName?: string | undefined;
    allConnectionRoleNames?: string[] | undefined;
    internalEmailAddress?: string | undefined;
    customerFacingEmailAddress?: string | undefined;
    canRemoveFromAccount?: boolean;
    isVisibleToCustomer?: boolean | undefined;
    displayOrder?: number | undefined;
    isPrimaryAccountExecutive?: boolean;

    constructor(data?: IShiOneAccountTeamMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiEmployeeId = _data["shiEmployeeId"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.fullName = _data["fullName"];
            this.title = _data["title"];
            this.customerFacingTitle = _data["customerFacingTitle"];
            this.connectionRoleName = _data["connectionRoleName"];
            if (Array.isArray(_data["allConnectionRoleNames"])) {
                this.allConnectionRoleNames = [] as any;
                for (let item of _data["allConnectionRoleNames"])
                    this.allConnectionRoleNames!.push(item);
            }
            this.internalEmailAddress = _data["internalEmailAddress"];
            this.customerFacingEmailAddress = _data["customerFacingEmailAddress"];
            this.canRemoveFromAccount = _data["canRemoveFromAccount"];
            this.isVisibleToCustomer = _data["isVisibleToCustomer"];
            this.displayOrder = _data["displayOrder"];
            this.isPrimaryAccountExecutive = _data["isPrimaryAccountExecutive"];
        }
    }

    static fromJS(data: any): ShiOneAccountTeamMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiOneAccountTeamMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiEmployeeId"] = this.shiEmployeeId;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["fullName"] = this.fullName;
        data["title"] = this.title;
        data["customerFacingTitle"] = this.customerFacingTitle;
        data["connectionRoleName"] = this.connectionRoleName;
        if (Array.isArray(this.allConnectionRoleNames)) {
            data["allConnectionRoleNames"] = [];
            for (let item of this.allConnectionRoleNames)
                data["allConnectionRoleNames"].push(item);
        }
        data["internalEmailAddress"] = this.internalEmailAddress;
        data["customerFacingEmailAddress"] = this.customerFacingEmailAddress;
        data["canRemoveFromAccount"] = this.canRemoveFromAccount;
        data["isVisibleToCustomer"] = this.isVisibleToCustomer;
        data["displayOrder"] = this.displayOrder;
        data["isPrimaryAccountExecutive"] = this.isPrimaryAccountExecutive;
        return data;
    }
}

export interface IShiOneAccountTeamMemberDto {
    shiEmployeeId?: string;
    lastName?: string | undefined;
    firstName?: string | undefined;
    fullName?: string | undefined;
    title?: string | undefined;
    customerFacingTitle?: string | undefined;
    connectionRoleName?: string | undefined;
    allConnectionRoleNames?: string[] | undefined;
    internalEmailAddress?: string | undefined;
    customerFacingEmailAddress?: string | undefined;
    canRemoveFromAccount?: boolean;
    isVisibleToCustomer?: boolean | undefined;
    displayOrder?: number | undefined;
    isPrimaryAccountExecutive?: boolean;
}

export class TeamAliasDto implements ITeamAliasDto {
    id?: string;
    crmAccountId?: string;
    emailAddressAlias?: string | undefined;
    overrideTeamMembersEmails?: boolean;
    primaryAeOverrideShiEmployeeId?: string | undefined;
    suppressPrimaryAe?: boolean;

    constructor(data?: ITeamAliasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crmAccountId = _data["crmAccountId"];
            this.emailAddressAlias = _data["emailAddressAlias"];
            this.overrideTeamMembersEmails = _data["overrideTeamMembersEmails"];
            this.primaryAeOverrideShiEmployeeId = _data["primaryAeOverrideShiEmployeeId"];
            this.suppressPrimaryAe = _data["suppressPrimaryAe"];
        }
    }

    static fromJS(data: any): TeamAliasDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamAliasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crmAccountId"] = this.crmAccountId;
        data["emailAddressAlias"] = this.emailAddressAlias;
        data["overrideTeamMembersEmails"] = this.overrideTeamMembersEmails;
        data["primaryAeOverrideShiEmployeeId"] = this.primaryAeOverrideShiEmployeeId;
        data["suppressPrimaryAe"] = this.suppressPrimaryAe;
        return data;
    }
}

export interface ITeamAliasDto {
    id?: string;
    crmAccountId?: string;
    emailAddressAlias?: string | undefined;
    overrideTeamMembersEmails?: boolean;
    primaryAeOverrideShiEmployeeId?: string | undefined;
    suppressPrimaryAe?: boolean;
}

export class UpsertAssessmentFromAirtableCommand implements IUpsertAssessmentFromAirtableCommand {
    id?: string | undefined;
    program?: string | undefined;
    name?: string | undefined;
    customerAx?: string | undefined;
    customerCrmGuid?: string | undefined;
    status?: string | undefined;
    assessmentDate?: string | undefined;
    assessorEmail?: string | undefined;
    createdDate?: string | undefined;
    lastModifiedBy?: string | undefined;
    responses?: UpsertAssessmentFromAirtableCommand_Response[] | undefined;

    constructor(data?: IUpsertAssessmentFromAirtableCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.program = _data["program"];
            this.name = _data["name"];
            this.customerAx = _data["customerAx"];
            this.customerCrmGuid = _data["customerCrmGuid"];
            this.status = _data["status"];
            this.assessmentDate = _data["assessmentDate"];
            this.assessorEmail = _data["assessorEmail"];
            this.createdDate = _data["createdDate"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(UpsertAssessmentFromAirtableCommand_Response.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertAssessmentFromAirtableCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssessmentFromAirtableCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["program"] = this.program;
        data["name"] = this.name;
        data["customerAx"] = this.customerAx;
        data["customerCrmGuid"] = this.customerCrmGuid;
        data["status"] = this.status;
        data["assessmentDate"] = this.assessmentDate;
        data["assessorEmail"] = this.assessorEmail;
        data["createdDate"] = this.createdDate;
        data["lastModifiedBy"] = this.lastModifiedBy;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpsertAssessmentFromAirtableCommand {
    id?: string | undefined;
    program?: string | undefined;
    name?: string | undefined;
    customerAx?: string | undefined;
    customerCrmGuid?: string | undefined;
    status?: string | undefined;
    assessmentDate?: string | undefined;
    assessorEmail?: string | undefined;
    createdDate?: string | undefined;
    lastModifiedBy?: string | undefined;
    responses?: UpsertAssessmentFromAirtableCommand_Response[] | undefined;
}

export class UpsertAssessmentFromAirtableCommand_Response implements IUpsertAssessmentFromAirtableCommand_Response {
    id?: string | undefined;
    name?: string | undefined;
    key?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    orderedCategory?: string | undefined;
    capabilityId?: string | undefined;
    capabilityName?: string | undefined;
    knownTools?: string | undefined;
    otherTools?: string | undefined;
    maturity?: string | undefined;
    targetMaturity?: string | undefined;
    notes?: string | undefined;
    recommendations?: string | undefined;
    operationalPriority?: string | undefined;
    compliancePriority?: string | undefined;
    showRecommendationToCustomer?: string | undefined;
    showHarveyBallToCustomer?: string | undefined;
    submitResponseToMindspark?: string | undefined;
    optOut?: string | undefined;
    recommendationPriority?: string | undefined;
    recommendationImpact?: string | undefined;
    recommendationPriorityV2?: string | undefined;
    recommendationImpactV2?: string | undefined;
    unknownTools?: string | undefined;
    capabilityOrder?: string | undefined;
    capabilityShortName?: string | undefined;
    customerAx?: string | undefined;
    customerCrmGuid?: string | undefined;
    recommendationsSummary?: string | undefined;

    constructor(data?: IUpsertAssessmentFromAirtableCommand_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.key = _data["key"];
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.orderedCategory = _data["orderedCategory"];
            this.capabilityId = _data["capabilityId"];
            this.capabilityName = _data["capabilityName"];
            this.knownTools = _data["knownTools"];
            this.otherTools = _data["otherTools"];
            this.maturity = _data["maturity"];
            this.targetMaturity = _data["targetMaturity"];
            this.notes = _data["notes"];
            this.recommendations = _data["recommendations"];
            this.operationalPriority = _data["operationalPriority"];
            this.compliancePriority = _data["compliancePriority"];
            this.showRecommendationToCustomer = _data["showRecommendationToCustomer"];
            this.showHarveyBallToCustomer = _data["showHarveyBallToCustomer"];
            this.submitResponseToMindspark = _data["submitResponseToMindspark"];
            this.optOut = _data["optOut"];
            this.recommendationPriority = _data["recommendationPriority"];
            this.recommendationImpact = _data["recommendationImpact"];
            this.recommendationPriorityV2 = _data["recommendationPriorityV2"];
            this.recommendationImpactV2 = _data["recommendationImpactV2"];
            this.unknownTools = _data["unknownTools"];
            this.capabilityOrder = _data["capabilityOrder"];
            this.capabilityShortName = _data["capabilityShortName"];
            this.customerAx = _data["customerAx"];
            this.customerCrmGuid = _data["customerCrmGuid"];
            this.recommendationsSummary = _data["recommendationsSummary"];
        }
    }

    static fromJS(data: any): UpsertAssessmentFromAirtableCommand_Response {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssessmentFromAirtableCommand_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["orderedCategory"] = this.orderedCategory;
        data["capabilityId"] = this.capabilityId;
        data["capabilityName"] = this.capabilityName;
        data["knownTools"] = this.knownTools;
        data["otherTools"] = this.otherTools;
        data["maturity"] = this.maturity;
        data["targetMaturity"] = this.targetMaturity;
        data["notes"] = this.notes;
        data["recommendations"] = this.recommendations;
        data["operationalPriority"] = this.operationalPriority;
        data["compliancePriority"] = this.compliancePriority;
        data["showRecommendationToCustomer"] = this.showRecommendationToCustomer;
        data["showHarveyBallToCustomer"] = this.showHarveyBallToCustomer;
        data["submitResponseToMindspark"] = this.submitResponseToMindspark;
        data["optOut"] = this.optOut;
        data["recommendationPriority"] = this.recommendationPriority;
        data["recommendationImpact"] = this.recommendationImpact;
        data["recommendationPriorityV2"] = this.recommendationPriorityV2;
        data["recommendationImpactV2"] = this.recommendationImpactV2;
        data["unknownTools"] = this.unknownTools;
        data["capabilityOrder"] = this.capabilityOrder;
        data["capabilityShortName"] = this.capabilityShortName;
        data["customerAx"] = this.customerAx;
        data["customerCrmGuid"] = this.customerCrmGuid;
        data["recommendationsSummary"] = this.recommendationsSummary;
        return data;
    }
}

export interface IUpsertAssessmentFromAirtableCommand_Response {
    id?: string | undefined;
    name?: string | undefined;
    key?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    orderedCategory?: string | undefined;
    capabilityId?: string | undefined;
    capabilityName?: string | undefined;
    knownTools?: string | undefined;
    otherTools?: string | undefined;
    maturity?: string | undefined;
    targetMaturity?: string | undefined;
    notes?: string | undefined;
    recommendations?: string | undefined;
    operationalPriority?: string | undefined;
    compliancePriority?: string | undefined;
    showRecommendationToCustomer?: string | undefined;
    showHarveyBallToCustomer?: string | undefined;
    submitResponseToMindspark?: string | undefined;
    optOut?: string | undefined;
    recommendationPriority?: string | undefined;
    recommendationImpact?: string | undefined;
    recommendationPriorityV2?: string | undefined;
    recommendationImpactV2?: string | undefined;
    unknownTools?: string | undefined;
    capabilityOrder?: string | undefined;
    capabilityShortName?: string | undefined;
    customerAx?: string | undefined;
    customerCrmGuid?: string | undefined;
    recommendationsSummary?: string | undefined;
}

export class DataGatewayAssignedLicenseDto implements IDataGatewayAssignedLicenseDto {
    id?: string;
    servicePlanList?: string[] | undefined;

    constructor(data?: IDataGatewayAssignedLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["servicePlanList"])) {
                this.servicePlanList = [] as any;
                for (let item of _data["servicePlanList"])
                    this.servicePlanList!.push(item);
            }
        }
    }

    static fromJS(data: any): DataGatewayAssignedLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataGatewayAssignedLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.servicePlanList)) {
            data["servicePlanList"] = [];
            for (let item of this.servicePlanList)
                data["servicePlanList"].push(item);
        }
        return data;
    }
}

export interface IDataGatewayAssignedLicenseDto {
    id?: string;
    servicePlanList?: string[] | undefined;
}

export class DataGatewayAvailableLicenseDto implements IDataGatewayAvailableLicenseDto {
    id?: string;
    count?: number;
    servicePlanList?: string[] | undefined;

    constructor(data?: IDataGatewayAvailableLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            if (Array.isArray(_data["servicePlanList"])) {
                this.servicePlanList = [] as any;
                for (let item of _data["servicePlanList"])
                    this.servicePlanList!.push(item);
            }
        }
    }

    static fromJS(data: any): DataGatewayAvailableLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataGatewayAvailableLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        if (Array.isArray(this.servicePlanList)) {
            data["servicePlanList"] = [];
            for (let item of this.servicePlanList)
                data["servicePlanList"].push(item);
        }
        return data;
    }
}

export interface IDataGatewayAvailableLicenseDto {
    id?: string;
    count?: number;
    servicePlanList?: string[] | undefined;
}

export class DataGatewayServiceValueDto implements IDataGatewayServiceValueDto {
    featureBreakdown?: { [key: string]: boolean; } | undefined;
    principalCount?: number | undefined;

    constructor(data?: IDataGatewayServiceValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["featureBreakdown"]) {
                this.featureBreakdown = {} as any;
                for (let key in _data["featureBreakdown"]) {
                    if (_data["featureBreakdown"].hasOwnProperty(key))
                        (this.featureBreakdown as any)![key] = _data["featureBreakdown"][key];
                }
            }
            this.principalCount = _data["principalCount"];
        }
    }

    static fromJS(data: any): DataGatewayServiceValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataGatewayServiceValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.featureBreakdown) {
            data["featureBreakdown"] = {};
            for (let key in this.featureBreakdown) {
                if (this.featureBreakdown.hasOwnProperty(key))
                    (data["featureBreakdown"] as any)[key] = (this.featureBreakdown as any)[key];
            }
        }
        data["principalCount"] = this.principalCount;
        return data;
    }
}

export interface IDataGatewayServiceValueDto {
    featureBreakdown?: { [key: string]: boolean; } | undefined;
    principalCount?: number | undefined;
}

export class MicrosoftInsightsPrincipalDataDto implements IMicrosoftInsightsPrincipalDataDto {
    user?: { [key: string]: MicrosoftInsightsUserPrincipalDataDto; } | undefined;

    constructor(data?: IMicrosoftInsightsPrincipalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["user"]) {
                this.user = {} as any;
                for (let key in _data["user"]) {
                    if (_data["user"].hasOwnProperty(key))
                        (this.user as any)![key] = _data["user"][key] ? MicrosoftInsightsUserPrincipalDataDto.fromJS(_data["user"][key]) : new MicrosoftInsightsUserPrincipalDataDto();
                }
            }
        }
    }

    static fromJS(data: any): MicrosoftInsightsPrincipalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftInsightsPrincipalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.user) {
            data["user"] = {};
            for (let key in this.user) {
                if (this.user.hasOwnProperty(key))
                    (data["user"] as any)[key] = this.user[key] ? this.user[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IMicrosoftInsightsPrincipalDataDto {
    user?: { [key: string]: MicrosoftInsightsUserPrincipalDataDto; } | undefined;
}

export class MicrosoftInsightsReport implements IMicrosoftInsightsReport {
    availableLicense?: DataGatewayAvailableLicenseDto[] | undefined;
    principalData?: MicrosoftInsightsPrincipalDataDto;

    constructor(data?: IMicrosoftInsightsReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableLicense"])) {
                this.availableLicense = [] as any;
                for (let item of _data["availableLicense"])
                    this.availableLicense!.push(DataGatewayAvailableLicenseDto.fromJS(item));
            }
            this.principalData = _data["principalData"] ? MicrosoftInsightsPrincipalDataDto.fromJS(_data["principalData"]) : undefined as any;
        }
    }

    static fromJS(data: any): MicrosoftInsightsReport {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftInsightsReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableLicense)) {
            data["availableLicense"] = [];
            for (let item of this.availableLicense)
                data["availableLicense"].push(item ? item.toJSON() : undefined as any);
        }
        data["principalData"] = this.principalData ? this.principalData.toJSON() : undefined as any;
        return data;
    }
}

export interface IMicrosoftInsightsReport {
    availableLicense?: DataGatewayAvailableLicenseDto[] | undefined;
    principalData?: MicrosoftInsightsPrincipalDataDto;
}

export class MicrosoftInsightsReportResponse implements IMicrosoftInsightsReportResponse {
    report?: MicrosoftInsightsReport;
    metadata?: { [key: string]: string; } | undefined;
    tenants?: MicrosoftInsightsTenant[] | undefined;

    constructor(data?: IMicrosoftInsightsReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report = _data["report"] ? MicrosoftInsightsReport.fromJS(_data["report"]) : undefined as any;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(MicrosoftInsightsTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MicrosoftInsightsReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftInsightsReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["report"] = this.report ? this.report.toJSON() : undefined as any;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMicrosoftInsightsReportResponse {
    report?: MicrosoftInsightsReport;
    metadata?: { [key: string]: string; } | undefined;
    tenants?: MicrosoftInsightsTenant[] | undefined;
}

export class MicrosoftInsightsTenant implements IMicrosoftInsightsTenant {
    tenantId?: string | undefined;
    tenantDomain?: string | undefined;

    constructor(data?: IMicrosoftInsightsTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenantDomain = _data["tenantDomain"];
        }
    }

    static fromJS(data: any): MicrosoftInsightsTenant {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftInsightsTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantDomain"] = this.tenantDomain;
        return data;
    }
}

export interface IMicrosoftInsightsTenant {
    tenantId?: string | undefined;
    tenantDomain?: string | undefined;
}

export class MicrosoftInsightsUserPrincipalDataDto implements IMicrosoftInsightsUserPrincipalDataDto {
    assignedLicense?: DataGatewayAssignedLicenseDto[] | undefined;
    assignedService?: { [key: string]: DataGatewayServiceValueDto; } | undefined;
    consumedService?: { [key: string]: DataGatewayServiceValueDto; } | undefined;

    constructor(data?: IMicrosoftInsightsUserPrincipalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignedLicense"])) {
                this.assignedLicense = [] as any;
                for (let item of _data["assignedLicense"])
                    this.assignedLicense!.push(DataGatewayAssignedLicenseDto.fromJS(item));
            }
            if (_data["assignedService"]) {
                this.assignedService = {} as any;
                for (let key in _data["assignedService"]) {
                    if (_data["assignedService"].hasOwnProperty(key))
                        (this.assignedService as any)![key] = _data["assignedService"][key] ? DataGatewayServiceValueDto.fromJS(_data["assignedService"][key]) : new DataGatewayServiceValueDto();
                }
            }
            if (_data["consumedService"]) {
                this.consumedService = {} as any;
                for (let key in _data["consumedService"]) {
                    if (_data["consumedService"].hasOwnProperty(key))
                        (this.consumedService as any)![key] = _data["consumedService"][key] ? DataGatewayServiceValueDto.fromJS(_data["consumedService"][key]) : new DataGatewayServiceValueDto();
                }
            }
        }
    }

    static fromJS(data: any): MicrosoftInsightsUserPrincipalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftInsightsUserPrincipalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignedLicense)) {
            data["assignedLicense"] = [];
            for (let item of this.assignedLicense)
                data["assignedLicense"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.assignedService) {
            data["assignedService"] = {};
            for (let key in this.assignedService) {
                if (this.assignedService.hasOwnProperty(key))
                    (data["assignedService"] as any)[key] = this.assignedService[key] ? this.assignedService[key].toJSON() : undefined as any;
            }
        }
        if (this.consumedService) {
            data["consumedService"] = {};
            for (let key in this.consumedService) {
                if (this.consumedService.hasOwnProperty(key))
                    (data["consumedService"] as any)[key] = this.consumedService[key] ? this.consumedService[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IMicrosoftInsightsUserPrincipalDataDto {
    assignedLicense?: DataGatewayAssignedLicenseDto[] | undefined;
    assignedService?: { [key: string]: DataGatewayServiceValueDto; } | undefined;
    consumedService?: { [key: string]: DataGatewayServiceValueDto; } | undefined;
}

export class SendConsultationEmailsResponse implements ISendConsultationEmailsResponse {
    success?: boolean;

    constructor(data?: ISendConsultationEmailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SendConsultationEmailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendConsultationEmailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISendConsultationEmailsResponse {
    success?: boolean;
}

export enum AssessmentProgram {
    Unknown = "Unknown",
    SecurityPostureReview = "SecurityPostureReview",
    MicrosoftAdoptionAssessment = "MicrosoftAdoptionAssessment",
    AiReadiness = "AiReadiness",
    DevOpsPostureReview = "DevOpsPostureReview",
    AwsMaturity = "AwsMaturity",
    SecurityPostureReviewV2 = "SecurityPostureReviewV2",
    Tpx = "Tpx",
    CloudMatrix = "CloudMatrix",
    MicrosoftInsights = "MicrosoftInsights",
}

export class AssessmentSummary implements IAssessmentSummary {
    maturityScore?: number;
    capabilityAreas!: CapabilityAreas;
    recommendations?: number;

    constructor(data?: IAssessmentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.capabilityAreas = new CapabilityAreas();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maturityScore = _data["maturityScore"];
            this.capabilityAreas = _data["capabilityAreas"] ? CapabilityAreas.fromJS(_data["capabilityAreas"]) : new CapabilityAreas();
            this.recommendations = _data["recommendations"];
        }
    }

    static fromJS(data: any): AssessmentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maturityScore"] = this.maturityScore;
        data["capabilityAreas"] = this.capabilityAreas ? this.capabilityAreas.toJSON() : undefined as any;
        data["recommendations"] = this.recommendations;
        return data;
    }
}

export interface IAssessmentSummary {
    maturityScore?: number;
    capabilityAreas: CapabilityAreas;
    recommendations?: number;
}

export class AssessmentTemplateRow implements IAssessmentTemplateRow {
    category!: string | undefined;
    subcategory!: string | undefined;
    capability!: string | undefined;

    constructor(data?: IAssessmentTemplateRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.capability = _data["capability"];
        }
    }

    static fromJS(data: any): AssessmentTemplateRow {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTemplateRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["capability"] = this.capability;
        return data;
    }
}

export interface IAssessmentTemplateRow {
    category: string | undefined;
    subcategory: string | undefined;
    capability: string | undefined;
}

export class AssessmentTemplateUpdate implements IAssessmentTemplateUpdate {
    assessmentProgram!: string | undefined;
    assessmentTemplateRows?: AssessmentTemplateRow[] | undefined;

    constructor(data?: IAssessmentTemplateUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentProgram = _data["assessmentProgram"];
            if (Array.isArray(_data["assessmentTemplateRows"])) {
                this.assessmentTemplateRows = [] as any;
                for (let item of _data["assessmentTemplateRows"])
                    this.assessmentTemplateRows!.push(AssessmentTemplateRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentTemplateUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentTemplateUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentProgram"] = this.assessmentProgram;
        if (Array.isArray(this.assessmentTemplateRows)) {
            data["assessmentTemplateRows"] = [];
            for (let item of this.assessmentTemplateRows)
                data["assessmentTemplateRows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssessmentTemplateUpdate {
    assessmentProgram: string | undefined;
    assessmentTemplateRows?: AssessmentTemplateRow[] | undefined;
}

export class CapabilityAreas implements ICapabilityAreas {
    optimizedAreas?: number;
    operationalAreas?: number;
    functionalAreas?: number;
    evaluatingAreas?: number;
    areasWithGaps?: number;
    unknown?: number;

    constructor(data?: ICapabilityAreas) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optimizedAreas = _data["optimizedAreas"];
            this.operationalAreas = _data["operationalAreas"];
            this.functionalAreas = _data["functionalAreas"];
            this.evaluatingAreas = _data["evaluatingAreas"];
            this.areasWithGaps = _data["areasWithGaps"];
            this.unknown = _data["unknown"];
        }
    }

    static fromJS(data: any): CapabilityAreas {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityAreas();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optimizedAreas"] = this.optimizedAreas;
        data["operationalAreas"] = this.operationalAreas;
        data["functionalAreas"] = this.functionalAreas;
        data["evaluatingAreas"] = this.evaluatingAreas;
        data["areasWithGaps"] = this.areasWithGaps;
        data["unknown"] = this.unknown;
        return data;
    }
}

export interface ICapabilityAreas {
    optimizedAreas?: number;
    operationalAreas?: number;
    functionalAreas?: number;
    evaluatingAreas?: number;
    areasWithGaps?: number;
    unknown?: number;
}

export class CapabilityInsightsProduct implements ICapabilityInsightsProduct {
    productName!: string | undefined;
    productId!: string | undefined;
    productLogo?: string | undefined;
    featureScoresList?: FeatureScores[] | undefined;

    constructor(data?: ICapabilityInsightsProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.productId = _data["productId"];
            this.productLogo = _data["productLogo"];
            if (Array.isArray(_data["featureScoresList"])) {
                this.featureScoresList = [] as any;
                for (let item of _data["featureScoresList"])
                    this.featureScoresList!.push(FeatureScores.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CapabilityInsightsProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityInsightsProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productId"] = this.productId;
        data["productLogo"] = this.productLogo;
        if (Array.isArray(this.featureScoresList)) {
            data["featureScoresList"] = [];
            for (let item of this.featureScoresList)
                data["featureScoresList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICapabilityInsightsProduct {
    productName: string | undefined;
    productId: string | undefined;
    productLogo?: string | undefined;
    featureScoresList?: FeatureScores[] | undefined;
}

export class CapabilityWithCategories implements ICapabilityWithCategories {
    name!: string | undefined;
    shortName?: string | undefined;
    maturity?: string | undefined;
    products?: CapabilityInsightsProduct[] | undefined;
    harveyBallCategories?: string[] | undefined;
    knownProductIds?: string[] | undefined;
    hasHarveyBall?: boolean | undefined;

    constructor(data?: ICapabilityWithCategories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.maturity = _data["maturity"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CapabilityInsightsProduct.fromJS(item));
            }
            if (Array.isArray(_data["harveyBallCategories"])) {
                this.harveyBallCategories = [] as any;
                for (let item of _data["harveyBallCategories"])
                    this.harveyBallCategories!.push(item);
            }
            if (Array.isArray(_data["knownProductIds"])) {
                this.knownProductIds = [] as any;
                for (let item of _data["knownProductIds"])
                    this.knownProductIds!.push(item);
            }
            this.hasHarveyBall = _data["hasHarveyBall"];
        }
    }

    static fromJS(data: any): CapabilityWithCategories {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityWithCategories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["maturity"] = this.maturity;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.harveyBallCategories)) {
            data["harveyBallCategories"] = [];
            for (let item of this.harveyBallCategories)
                data["harveyBallCategories"].push(item);
        }
        if (Array.isArray(this.knownProductIds)) {
            data["knownProductIds"] = [];
            for (let item of this.knownProductIds)
                data["knownProductIds"].push(item);
        }
        data["hasHarveyBall"] = this.hasHarveyBall;
        return data;
    }
}

export interface ICapabilityWithCategories {
    name: string | undefined;
    shortName?: string | undefined;
    maturity?: string | undefined;
    products?: CapabilityInsightsProduct[] | undefined;
    harveyBallCategories?: string[] | undefined;
    knownProductIds?: string[] | undefined;
    hasHarveyBall?: boolean | undefined;
}

export class AssessmentDto implements IAssessmentDto {
    id?: string | undefined;
    program?: string | undefined;
    name?: string | undefined;
    assessorEmail?: string | undefined;
    assessor?: ShiEmployeeDto;
    assessmentDate?: Date | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    maturity?: number;
    status?: string | undefined;

    constructor(data?: IAssessmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.program = _data["program"];
            this.name = _data["name"];
            this.assessorEmail = _data["assessorEmail"];
            this.assessor = _data["assessor"] ? ShiEmployeeDto.fromJS(_data["assessor"]) : undefined as any;
            this.assessmentDate = _data["assessmentDate"] ? new Date(_data["assessmentDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.maturity = _data["maturity"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["program"] = this.program;
        data["name"] = this.name;
        data["assessorEmail"] = this.assessorEmail;
        data["assessor"] = this.assessor ? this.assessor.toJSON() : undefined as any;
        data["assessmentDate"] = this.assessmentDate ? this.assessmentDate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["maturity"] = this.maturity;
        data["status"] = this.status;
        return data;
    }
}

export interface IAssessmentDto {
    id?: string | undefined;
    program?: string | undefined;
    name?: string | undefined;
    assessorEmail?: string | undefined;
    assessor?: ShiEmployeeDto;
    assessmentDate?: Date | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    maturity?: number;
    status?: string | undefined;
}

export class AssessmentMaturityChartDto implements IAssessmentMaturityChartDto {
    responseCategories!: ResponseCategory[] | undefined;

    constructor(data?: IAssessmentMaturityChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseCategories"])) {
                this.responseCategories = [] as any;
                for (let item of _data["responseCategories"])
                    this.responseCategories!.push(ResponseCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentMaturityChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentMaturityChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseCategories)) {
            data["responseCategories"] = [];
            for (let item of this.responseCategories)
                data["responseCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssessmentMaturityChartDto {
    responseCategories: ResponseCategory[] | undefined;
}

export class AssessmentMetadataDto implements IAssessmentMetadataDto {
    programPermissions?: { [key: string]: string; } | undefined;

    constructor(data?: IAssessmentMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["programPermissions"]) {
                this.programPermissions = {} as any;
                for (let key in _data["programPermissions"]) {
                    if (_data["programPermissions"].hasOwnProperty(key))
                        (this.programPermissions as any)![key] = _data["programPermissions"][key];
                }
            }
        }
    }

    static fromJS(data: any): AssessmentMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.programPermissions) {
            data["programPermissions"] = {};
            for (let key in this.programPermissions) {
                if (this.programPermissions.hasOwnProperty(key))
                    (data["programPermissions"] as any)[key] = (this.programPermissions as any)[key];
            }
        }
        return data;
    }
}

export interface IAssessmentMetadataDto {
    programPermissions?: { [key: string]: string; } | undefined;
}

export class AssessmentOverviewDto implements IAssessmentOverviewDto {
    program!: AssessmentProgram;
    targetMaturityBreakdown!: TargetMaturityBreakdown[] | undefined;
    summary!: AssessmentSummary;

    constructor(data?: IAssessmentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.summary = new AssessmentSummary();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.program = _data["program"];
            if (Array.isArray(_data["targetMaturityBreakdown"])) {
                this.targetMaturityBreakdown = [] as any;
                for (let item of _data["targetMaturityBreakdown"])
                    this.targetMaturityBreakdown!.push(TargetMaturityBreakdown.fromJS(item));
            }
            this.summary = _data["summary"] ? AssessmentSummary.fromJS(_data["summary"]) : new AssessmentSummary();
        }
    }

    static fromJS(data: any): AssessmentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["program"] = this.program;
        if (Array.isArray(this.targetMaturityBreakdown)) {
            data["targetMaturityBreakdown"] = [];
            for (let item of this.targetMaturityBreakdown)
                data["targetMaturityBreakdown"].push(item ? item.toJSON() : undefined as any);
        }
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssessmentOverviewDto {
    program: AssessmentProgram;
    targetMaturityBreakdown: TargetMaturityBreakdown[] | undefined;
    summary: AssessmentSummary;
}

export class AssessmentRecommendationsDto implements IAssessmentRecommendationsDto {
    prioritizedRecommendations!: PrioritizedRecommendation[] | undefined;

    constructor(data?: IAssessmentRecommendationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prioritizedRecommendations"])) {
                this.prioritizedRecommendations = [] as any;
                for (let item of _data["prioritizedRecommendations"])
                    this.prioritizedRecommendations!.push(PrioritizedRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentRecommendationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentRecommendationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prioritizedRecommendations)) {
            data["prioritizedRecommendations"] = [];
            for (let item of this.prioritizedRecommendations)
                data["prioritizedRecommendations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssessmentRecommendationsDto {
    prioritizedRecommendations: PrioritizedRecommendation[] | undefined;
}

export class CapabilityChangesDto implements ICapabilityChangesDto {
    assessmentId!: string | undefined;
    capabilityChangesScoresList!: any[] | undefined;
    date!: Date;

    constructor(data?: ICapabilityChangesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentId = _data["assessmentId"];
            if (Array.isArray(_data["capabilityChangesScoresList"])) {
                this.capabilityChangesScoresList = [] as any;
                for (let item of _data["capabilityChangesScoresList"])
                    this.capabilityChangesScoresList!.push(item);
            }
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CapabilityChangesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityChangesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        if (Array.isArray(this.capabilityChangesScoresList)) {
            data["capabilityChangesScoresList"] = [];
            for (let item of this.capabilityChangesScoresList)
                data["capabilityChangesScoresList"].push(item);
        }
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }
}

export interface ICapabilityChangesDto {
    assessmentId: string | undefined;
    capabilityChangesScoresList: any[] | undefined;
    date: Date;
}

export class CapabilityInsightsDto implements ICapabilityInsightsDto {
    capabilityWithCategoriesList!: CapabilityWithCategories[] | undefined;

    constructor(data?: ICapabilityInsightsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["capabilityWithCategoriesList"])) {
                this.capabilityWithCategoriesList = [] as any;
                for (let item of _data["capabilityWithCategoriesList"])
                    this.capabilityWithCategoriesList!.push(CapabilityWithCategories.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CapabilityInsightsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityInsightsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.capabilityWithCategoriesList)) {
            data["capabilityWithCategoriesList"] = [];
            for (let item of this.capabilityWithCategoriesList)
                data["capabilityWithCategoriesList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICapabilityInsightsDto {
    capabilityWithCategoriesList: CapabilityWithCategories[] | undefined;
}

export class DeleteAssessmentDto implements IDeleteAssessmentDto {
    airtableId?: string | undefined;
    axNumber?: string | undefined;

    constructor(data?: IDeleteAssessmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airtableId = _data["airtableId"];
            this.axNumber = _data["axNumber"];
        }
    }

    static fromJS(data: any): DeleteAssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airtableId"] = this.airtableId;
        data["axNumber"] = this.axNumber;
        return data;
    }
}

export interface IDeleteAssessmentDto {
    airtableId?: string | undefined;
    axNumber?: string | undefined;
}

export class HarveyBallDto implements IHarveyBallDto {
    harveyBallScoresCollection?: HarveyBallScores[] | undefined;
    harveyBallRowsCollection?: HarveyBallRows[] | undefined;
    harveyBallProductsCollection?: HarveyBallProducts[] | undefined;

    constructor(data?: IHarveyBallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["harveyBallScoresCollection"])) {
                this.harveyBallScoresCollection = [] as any;
                for (let item of _data["harveyBallScoresCollection"])
                    this.harveyBallScoresCollection!.push(HarveyBallScores.fromJS(item));
            }
            if (Array.isArray(_data["harveyBallRowsCollection"])) {
                this.harveyBallRowsCollection = [] as any;
                for (let item of _data["harveyBallRowsCollection"])
                    this.harveyBallRowsCollection!.push(HarveyBallRows.fromJS(item));
            }
            if (Array.isArray(_data["harveyBallProductsCollection"])) {
                this.harveyBallProductsCollection = [] as any;
                for (let item of _data["harveyBallProductsCollection"])
                    this.harveyBallProductsCollection!.push(HarveyBallProducts.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HarveyBallDto {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.harveyBallScoresCollection)) {
            data["harveyBallScoresCollection"] = [];
            for (let item of this.harveyBallScoresCollection)
                data["harveyBallScoresCollection"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.harveyBallRowsCollection)) {
            data["harveyBallRowsCollection"] = [];
            for (let item of this.harveyBallRowsCollection)
                data["harveyBallRowsCollection"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.harveyBallProductsCollection)) {
            data["harveyBallProductsCollection"] = [];
            for (let item of this.harveyBallProductsCollection)
                data["harveyBallProductsCollection"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IHarveyBallDto {
    harveyBallScoresCollection?: HarveyBallScores[] | undefined;
    harveyBallRowsCollection?: HarveyBallRows[] | undefined;
    harveyBallProductsCollection?: HarveyBallProducts[] | undefined;
}

export class HarveyBallProducts implements IHarveyBallProducts {
    productName!: string | undefined;
    productId!: string | undefined;
    productLogo?: string | undefined;

    constructor(data?: IHarveyBallProducts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.productId = _data["productId"];
            this.productLogo = _data["productLogo"];
        }
    }

    static fromJS(data: any): HarveyBallProducts {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallProducts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productId"] = this.productId;
        data["productLogo"] = this.productLogo;
        return data;
    }
}

export interface IHarveyBallProducts {
    productName: string | undefined;
    productId: string | undefined;
    productLogo?: string | undefined;
}

export class HarveyBallRows implements IHarveyBallRows {
    sectionName!: string | undefined;
    harveyBallCategory!: string | undefined;
    relatedFeaturesCollection!: RelatedFeatures[] | undefined;

    constructor(data?: IHarveyBallRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionName = _data["sectionName"];
            this.harveyBallCategory = _data["harveyBallCategory"];
            if (Array.isArray(_data["relatedFeaturesCollection"])) {
                this.relatedFeaturesCollection = [] as any;
                for (let item of _data["relatedFeaturesCollection"])
                    this.relatedFeaturesCollection!.push(RelatedFeatures.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HarveyBallRows {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionName"] = this.sectionName;
        data["harveyBallCategory"] = this.harveyBallCategory;
        if (Array.isArray(this.relatedFeaturesCollection)) {
            data["relatedFeaturesCollection"] = [];
            for (let item of this.relatedFeaturesCollection)
                data["relatedFeaturesCollection"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IHarveyBallRows {
    sectionName: string | undefined;
    harveyBallCategory: string | undefined;
    relatedFeaturesCollection: RelatedFeatures[] | undefined;
}

export class HarveyBallScores implements IHarveyBallScores {
    productId!: string | undefined;
    score!: number;
    featureName!: string | undefined;

    constructor(data?: IHarveyBallScores) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.score = _data["score"];
            this.featureName = _data["featureName"];
        }
    }

    static fromJS(data: any): HarveyBallScores {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallScores();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["score"] = this.score;
        data["featureName"] = this.featureName;
        return data;
    }
}

export interface IHarveyBallScores {
    productId: string | undefined;
    score: number;
    featureName: string | undefined;
}

export class MaturityComparisonData implements IMaturityComparisonData {
    date!: Date;
    maturityData!: MaturityComparison[] | undefined;

    constructor(data?: IMaturityComparisonData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["maturityData"])) {
                this.maturityData = [] as any;
                for (let item of _data["maturityData"])
                    this.maturityData!.push(MaturityComparison.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaturityComparisonData {
        data = typeof data === 'object' ? data : {};
        let result = new MaturityComparisonData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.maturityData)) {
            data["maturityData"] = [];
            for (let item of this.maturityData)
                data["maturityData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMaturityComparisonData {
    date: Date;
    maturityData: MaturityComparison[] | undefined;
}

export class MaturityComparisonDto implements IMaturityComparisonDto {
    current!: MaturityComparisonData;
    previous!: MaturityComparisonData;
    first!: MaturityComparisonData;

    constructor(data?: IMaturityComparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.current = new MaturityComparisonData();
            this.previous = new MaturityComparisonData();
            this.first = new MaturityComparisonData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current = _data["current"] ? MaturityComparisonData.fromJS(_data["current"]) : new MaturityComparisonData();
            this.previous = _data["previous"] ? MaturityComparisonData.fromJS(_data["previous"]) : new MaturityComparisonData();
            this.first = _data["first"] ? MaturityComparisonData.fromJS(_data["first"]) : new MaturityComparisonData();
        }
    }

    static fromJS(data: any): MaturityComparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaturityComparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current ? this.current.toJSON() : undefined as any;
        data["previous"] = this.previous ? this.previous.toJSON() : undefined as any;
        data["first"] = this.first ? this.first.toJSON() : undefined as any;
        return data;
    }
}

export interface IMaturityComparisonDto {
    current: MaturityComparisonData;
    previous: MaturityComparisonData;
    first: MaturityComparisonData;
}

export class MaturityScoreAveragesDto implements IMaturityScoreAveragesDto {
    averageMaturity?: number | undefined;
    averageTargetMaturity?: number | undefined;
    averageMaturityAllUsers?: number | undefined;
    averageMaturityCompaniesLikeYou?: number | undefined;

    constructor(data?: IMaturityScoreAveragesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageMaturity = _data["averageMaturity"];
            this.averageTargetMaturity = _data["averageTargetMaturity"];
            this.averageMaturityAllUsers = _data["averageMaturityAllUsers"];
            this.averageMaturityCompaniesLikeYou = _data["averageMaturityCompaniesLikeYou"];
        }
    }

    static fromJS(data: any): MaturityScoreAveragesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaturityScoreAveragesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageMaturity"] = this.averageMaturity;
        data["averageTargetMaturity"] = this.averageTargetMaturity;
        data["averageMaturityAllUsers"] = this.averageMaturityAllUsers;
        data["averageMaturityCompaniesLikeYou"] = this.averageMaturityCompaniesLikeYou;
        return data;
    }
}

export interface IMaturityScoreAveragesDto {
    averageMaturity?: number | undefined;
    averageTargetMaturity?: number | undefined;
    averageMaturityAllUsers?: number | undefined;
    averageMaturityCompaniesLikeYou?: number | undefined;
}

export class PlatformInsightsDto implements IPlatformInsightsDto {
    products!: PlatformInsightProduct[] | undefined;

    constructor(data?: IPlatformInsightsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(PlatformInsightProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformInsightsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformInsightsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPlatformInsightsDto {
    products: PlatformInsightProduct[] | undefined;
}

export class RelatedFeatures implements IRelatedFeatures {
    featureName!: string | undefined;

    constructor(data?: IRelatedFeatures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureName = _data["featureName"];
        }
    }

    static fromJS(data: any): RelatedFeatures {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedFeatures();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureName"] = this.featureName;
        return data;
    }
}

export interface IRelatedFeatures {
    featureName: string | undefined;
}

export class FeatureScores implements IFeatureScores {
    averageFeatureScore!: number;
    harveyBallCategory!: string | undefined;

    constructor(data?: IFeatureScores) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageFeatureScore = _data["averageFeatureScore"];
            this.harveyBallCategory = _data["harveyBallCategory"];
        }
    }

    static fromJS(data: any): FeatureScores {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureScores();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageFeatureScore"] = this.averageFeatureScore;
        data["harveyBallCategory"] = this.harveyBallCategory;
        return data;
    }
}

export interface IFeatureScores {
    averageFeatureScore: number;
    harveyBallCategory: string | undefined;
}

export class GeneratedAssessment implements IGeneratedAssessment {
    generatedResponsesList?: GeneratedAssessment_GeneratedResponses[] | undefined;
    error?: string | undefined;
    filename?: string | undefined;

    constructor(data?: IGeneratedAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["generatedResponsesList"])) {
                this.generatedResponsesList = [] as any;
                for (let item of _data["generatedResponsesList"])
                    this.generatedResponsesList!.push(GeneratedAssessment_GeneratedResponses.fromJS(item));
            }
            this.error = _data["error"];
            this.filename = _data["filename"];
        }
    }

    static fromJS(data: any): GeneratedAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratedAssessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generatedResponsesList)) {
            data["generatedResponsesList"] = [];
            for (let item of this.generatedResponsesList)
                data["generatedResponsesList"].push(item ? item.toJSON() : undefined as any);
        }
        data["error"] = this.error;
        data["filename"] = this.filename;
        return data;
    }
}

export interface IGeneratedAssessment {
    generatedResponsesList?: GeneratedAssessment_GeneratedResponses[] | undefined;
    error?: string | undefined;
    filename?: string | undefined;
}

export class GeneratedAssessment_GeneratedResponses implements IGeneratedAssessment_GeneratedResponses {
    name?: string | undefined;
    notes?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    recommendations?: string | undefined;
    operationalPriority?: string | undefined;
    compliancePriority?: string | undefined;
    currentMaturity?: string | undefined;
    targetMaturity?: string | undefined;
    tools?: string | undefined;
    capability?: string | undefined;

    constructor(data?: IGeneratedAssessment_GeneratedResponses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.recommendations = _data["recommendations"];
            this.operationalPriority = _data["operationalPriority"];
            this.compliancePriority = _data["compliancePriority"];
            this.currentMaturity = _data["currentMaturity"];
            this.targetMaturity = _data["targetMaturity"];
            this.tools = _data["tools"];
            this.capability = _data["capability"];
        }
    }

    static fromJS(data: any): GeneratedAssessment_GeneratedResponses {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratedAssessment_GeneratedResponses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["recommendations"] = this.recommendations;
        data["operationalPriority"] = this.operationalPriority;
        data["compliancePriority"] = this.compliancePriority;
        data["currentMaturity"] = this.currentMaturity;
        data["targetMaturity"] = this.targetMaturity;
        data["tools"] = this.tools;
        data["capability"] = this.capability;
        return data;
    }
}

export interface IGeneratedAssessment_GeneratedResponses {
    name?: string | undefined;
    notes?: string | undefined;
    category?: string | undefined;
    subcategory?: string | undefined;
    recommendations?: string | undefined;
    operationalPriority?: string | undefined;
    compliancePriority?: string | undefined;
    currentMaturity?: string | undefined;
    targetMaturity?: string | undefined;
    tools?: string | undefined;
    capability?: string | undefined;
}

export class HarveyBallsUpdate implements IHarveyBallsUpdate {
    harveyBallName?: string | undefined;
    harveyBallId?: string | undefined;
    harveyBallProgram?: string | undefined;
    harveyBallCategory?: string | undefined;
    harveyBallCategoryId?: string | undefined;
    harveyBallCategorySection?: string | undefined;
    feature?: string | undefined;
    featureId?: string | undefined;
    featureScoreId?: string | undefined;
    productName?: string | undefined;
    productId?: string | undefined;
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    platformId?: string | undefined;
    platformName?: string | undefined;
    productScore?: string | undefined;
    harveyBallCapability?: string | undefined;
    harveyBallCapabilityId?: string | undefined;
    productLogo?: string | undefined;

    constructor(data?: IHarveyBallsUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.harveyBallName = _data["harveyBallName"];
            this.harveyBallId = _data["harveyBallId"];
            this.harveyBallProgram = _data["harveyBallProgram"];
            this.harveyBallCategory = _data["harveyBallCategory"];
            this.harveyBallCategoryId = _data["harveyBallCategoryId"];
            this.harveyBallCategorySection = _data["harveyBallCategorySection"];
            this.feature = _data["feature"];
            this.featureId = _data["featureId"];
            this.featureScoreId = _data["featureScoreId"];
            this.productName = _data["productName"];
            this.productId = _data["productId"];
            this.partnerId = _data["partnerId"];
            this.partnerName = _data["partnerName"];
            this.platformId = _data["platformId"];
            this.platformName = _data["platformName"];
            this.productScore = _data["productScore"];
            this.harveyBallCapability = _data["harveyBallCapability"];
            this.harveyBallCapabilityId = _data["harveyBallCapabilityId"];
            this.productLogo = _data["productLogo"];
        }
    }

    static fromJS(data: any): HarveyBallsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new HarveyBallsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["harveyBallName"] = this.harveyBallName;
        data["harveyBallId"] = this.harveyBallId;
        data["harveyBallProgram"] = this.harveyBallProgram;
        data["harveyBallCategory"] = this.harveyBallCategory;
        data["harveyBallCategoryId"] = this.harveyBallCategoryId;
        data["harveyBallCategorySection"] = this.harveyBallCategorySection;
        data["feature"] = this.feature;
        data["featureId"] = this.featureId;
        data["featureScoreId"] = this.featureScoreId;
        data["productName"] = this.productName;
        data["productId"] = this.productId;
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["platformId"] = this.platformId;
        data["platformName"] = this.platformName;
        data["productScore"] = this.productScore;
        data["harveyBallCapability"] = this.harveyBallCapability;
        data["harveyBallCapabilityId"] = this.harveyBallCapabilityId;
        data["productLogo"] = this.productLogo;
        return data;
    }
}

export interface IHarveyBallsUpdate {
    harveyBallName?: string | undefined;
    harveyBallId?: string | undefined;
    harveyBallProgram?: string | undefined;
    harveyBallCategory?: string | undefined;
    harveyBallCategoryId?: string | undefined;
    harveyBallCategorySection?: string | undefined;
    feature?: string | undefined;
    featureId?: string | undefined;
    featureScoreId?: string | undefined;
    productName?: string | undefined;
    productId?: string | undefined;
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    platformId?: string | undefined;
    platformName?: string | undefined;
    productScore?: string | undefined;
    harveyBallCapability?: string | undefined;
    harveyBallCapabilityId?: string | undefined;
    productLogo?: string | undefined;
}

export class MaturityComparison implements IMaturityComparison {
    subCategory?: string | undefined;
    currentMaturity?: number;

    constructor(data?: IMaturityComparison) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory = _data["subCategory"];
            this.currentMaturity = _data["currentMaturity"];
        }
    }

    static fromJS(data: any): MaturityComparison {
        data = typeof data === 'object' ? data : {};
        let result = new MaturityComparison();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory"] = this.subCategory;
        data["currentMaturity"] = this.currentMaturity;
        return data;
    }
}

export interface IMaturityComparison {
    subCategory?: string | undefined;
    currentMaturity?: number;
}

export class PlatformInsightCapability implements IPlatformInsightCapability {
    capabilityId!: string | undefined;
    capabilityName!: string | undefined;
    shortName?: string | undefined;
    currentMaturity?: string | undefined;
    hasHarveyBallData!: boolean;
    currentlyUsingProductNames?: string[] | undefined;
    alsoUsingProductNames?: string[] | undefined;

    constructor(data?: IPlatformInsightCapability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.capabilityId = _data["capabilityId"];
            this.capabilityName = _data["capabilityName"];
            this.shortName = _data["shortName"];
            this.currentMaturity = _data["currentMaturity"];
            this.hasHarveyBallData = _data["hasHarveyBallData"];
            if (Array.isArray(_data["currentlyUsingProductNames"])) {
                this.currentlyUsingProductNames = [] as any;
                for (let item of _data["currentlyUsingProductNames"])
                    this.currentlyUsingProductNames!.push(item);
            }
            if (Array.isArray(_data["alsoUsingProductNames"])) {
                this.alsoUsingProductNames = [] as any;
                for (let item of _data["alsoUsingProductNames"])
                    this.alsoUsingProductNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PlatformInsightCapability {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformInsightCapability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capabilityId"] = this.capabilityId;
        data["capabilityName"] = this.capabilityName;
        data["shortName"] = this.shortName;
        data["currentMaturity"] = this.currentMaturity;
        data["hasHarveyBallData"] = this.hasHarveyBallData;
        if (Array.isArray(this.currentlyUsingProductNames)) {
            data["currentlyUsingProductNames"] = [];
            for (let item of this.currentlyUsingProductNames)
                data["currentlyUsingProductNames"].push(item);
        }
        if (Array.isArray(this.alsoUsingProductNames)) {
            data["alsoUsingProductNames"] = [];
            for (let item of this.alsoUsingProductNames)
                data["alsoUsingProductNames"].push(item);
        }
        return data;
    }
}

export interface IPlatformInsightCapability {
    capabilityId: string | undefined;
    capabilityName: string | undefined;
    shortName?: string | undefined;
    currentMaturity?: string | undefined;
    hasHarveyBallData: boolean;
    currentlyUsingProductNames?: string[] | undefined;
    alsoUsingProductNames?: string[] | undefined;
}

export class PlatformInsightProduct implements IPlatformInsightProduct {
    partnerId!: string | undefined;
    partnerName!: string | undefined;
    productId!: string | undefined;
    productName!: string | undefined;
    platformId?: string | undefined;
    platformName?: string | undefined;
    isKnownProduct!: boolean;
    logo?: string | undefined;
    capabilities?: PlatformInsightCapability[] | undefined;

    constructor(data?: IPlatformInsightProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.partnerName = _data["partnerName"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.platformId = _data["platformId"];
            this.platformName = _data["platformName"];
            this.isKnownProduct = _data["isKnownProduct"];
            this.logo = _data["logo"];
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(PlatformInsightCapability.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformInsightProduct {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformInsightProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["platformId"] = this.platformId;
        data["platformName"] = this.platformName;
        data["isKnownProduct"] = this.isKnownProduct;
        data["logo"] = this.logo;
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPlatformInsightProduct {
    partnerId: string | undefined;
    partnerName: string | undefined;
    productId: string | undefined;
    productName: string | undefined;
    platformId?: string | undefined;
    platformName?: string | undefined;
    isKnownProduct: boolean;
    logo?: string | undefined;
    capabilities?: PlatformInsightCapability[] | undefined;
}

export class PlatformsUpdate implements IPlatformsUpdate {
    platformId?: string | undefined;
    platformName?: string | undefined;
    platformProgram?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    productLogo?: string | undefined;
    capabilities?: string | undefined;

    constructor(data?: IPlatformsUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platformId = _data["platformId"];
            this.platformName = _data["platformName"];
            this.platformProgram = _data["platformProgram"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.partnerId = _data["partnerId"];
            this.partnerName = _data["partnerName"];
            this.productLogo = _data["productLogo"];
            this.capabilities = _data["capabilities"];
        }
    }

    static fromJS(data: any): PlatformsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platformId"] = this.platformId;
        data["platformName"] = this.platformName;
        data["platformProgram"] = this.platformProgram;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["productLogo"] = this.productLogo;
        data["capabilities"] = this.capabilities;
        return data;
    }
}

export interface IPlatformsUpdate {
    platformId?: string | undefined;
    platformName?: string | undefined;
    platformProgram?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    productLogo?: string | undefined;
    capabilities?: string | undefined;
}

export class PrioritizedRecommendation implements IPrioritizedRecommendation {
    priority!: string | undefined;
    responseRecommendations!: ResponseRecommendation[] | undefined;

    constructor(data?: IPrioritizedRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"];
            if (Array.isArray(_data["responseRecommendations"])) {
                this.responseRecommendations = [] as any;
                for (let item of _data["responseRecommendations"])
                    this.responseRecommendations!.push(ResponseRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrioritizedRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new PrioritizedRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority;
        if (Array.isArray(this.responseRecommendations)) {
            data["responseRecommendations"] = [];
            for (let item of this.responseRecommendations)
                data["responseRecommendations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPrioritizedRecommendation {
    priority: string | undefined;
    responseRecommendations: ResponseRecommendation[] | undefined;
}

export class ResponseCapability implements IResponseCapability {
    order!: number;
    name!: string | undefined;
    maturity!: string | undefined;
    targetMaturity?: string | undefined;
    tools!: string[] | undefined;
    hasRecommendation?: boolean;

    constructor(data?: IResponseCapability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.maturity = _data["maturity"];
            this.targetMaturity = _data["targetMaturity"];
            if (Array.isArray(_data["tools"])) {
                this.tools = [] as any;
                for (let item of _data["tools"])
                    this.tools!.push(item);
            }
            this.hasRecommendation = _data["hasRecommendation"];
        }
    }

    static fromJS(data: any): ResponseCapability {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseCapability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["maturity"] = this.maturity;
        data["targetMaturity"] = this.targetMaturity;
        if (Array.isArray(this.tools)) {
            data["tools"] = [];
            for (let item of this.tools)
                data["tools"].push(item);
        }
        data["hasRecommendation"] = this.hasRecommendation;
        return data;
    }
}

export interface IResponseCapability {
    order: number;
    name: string | undefined;
    maturity: string | undefined;
    targetMaturity?: string | undefined;
    tools: string[] | undefined;
    hasRecommendation?: boolean;
}

export class ResponseCategory implements IResponseCategory {
    order!: number;
    name!: string | undefined;
    responseSubcategories!: ResponseSubcategory[] | undefined;

    constructor(data?: IResponseCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            if (Array.isArray(_data["responseSubcategories"])) {
                this.responseSubcategories = [] as any;
                for (let item of _data["responseSubcategories"])
                    this.responseSubcategories!.push(ResponseSubcategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        if (Array.isArray(this.responseSubcategories)) {
            data["responseSubcategories"] = [];
            for (let item of this.responseSubcategories)
                data["responseSubcategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseCategory {
    order: number;
    name: string | undefined;
    responseSubcategories: ResponseSubcategory[] | undefined;
}

export class ResponseRecommendation implements IResponseRecommendation {
    recommendationId!: string | undefined;
    assessmentId!: string | undefined;
    impact!: string | undefined;
    capability!: string | undefined;
    capabilityId!: string | undefined;
    category!: string | undefined;
    subcategory!: string | undefined;
    recommendationsSummary!: string | undefined;
    recommendations!: string | undefined;
    knownTools?: string[] | undefined;
    otherTools?: string[] | undefined;
    knownToolsLogos?: string[] | undefined;
    otherToolsLogos?: string[] | undefined;
    hasHarveyBallData?: boolean;
    isLinkedToRoadmap?: boolean;
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;
    initiativeId?: string | undefined;
    initiativeName?: string | undefined;
    program?: string | undefined;

    constructor(data?: IResponseRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendationId = _data["recommendationId"];
            this.assessmentId = _data["assessmentId"];
            this.impact = _data["impact"];
            this.capability = _data["capability"];
            this.capabilityId = _data["capabilityId"];
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.recommendationsSummary = _data["recommendationsSummary"];
            this.recommendations = _data["recommendations"];
            if (Array.isArray(_data["knownTools"])) {
                this.knownTools = [] as any;
                for (let item of _data["knownTools"])
                    this.knownTools!.push(item);
            }
            if (Array.isArray(_data["otherTools"])) {
                this.otherTools = [] as any;
                for (let item of _data["otherTools"])
                    this.otherTools!.push(item);
            }
            if (Array.isArray(_data["knownToolsLogos"])) {
                this.knownToolsLogos = [] as any;
                for (let item of _data["knownToolsLogos"])
                    this.knownToolsLogos!.push(item);
            }
            if (Array.isArray(_data["otherToolsLogos"])) {
                this.otherToolsLogos = [] as any;
                for (let item of _data["otherToolsLogos"])
                    this.otherToolsLogos!.push(item);
            }
            this.hasHarveyBallData = _data["hasHarveyBallData"];
            this.isLinkedToRoadmap = _data["isLinkedToRoadmap"];
            this.roadmapId = _data["roadmapId"];
            this.roadmapName = _data["roadmapName"];
            this.initiativeId = _data["initiativeId"];
            this.initiativeName = _data["initiativeName"];
            this.program = _data["program"];
        }
    }

    static fromJS(data: any): ResponseRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendationId"] = this.recommendationId;
        data["assessmentId"] = this.assessmentId;
        data["impact"] = this.impact;
        data["capability"] = this.capability;
        data["capabilityId"] = this.capabilityId;
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["recommendationsSummary"] = this.recommendationsSummary;
        data["recommendations"] = this.recommendations;
        if (Array.isArray(this.knownTools)) {
            data["knownTools"] = [];
            for (let item of this.knownTools)
                data["knownTools"].push(item);
        }
        if (Array.isArray(this.otherTools)) {
            data["otherTools"] = [];
            for (let item of this.otherTools)
                data["otherTools"].push(item);
        }
        if (Array.isArray(this.knownToolsLogos)) {
            data["knownToolsLogos"] = [];
            for (let item of this.knownToolsLogos)
                data["knownToolsLogos"].push(item);
        }
        if (Array.isArray(this.otherToolsLogos)) {
            data["otherToolsLogos"] = [];
            for (let item of this.otherToolsLogos)
                data["otherToolsLogos"].push(item);
        }
        data["hasHarveyBallData"] = this.hasHarveyBallData;
        data["isLinkedToRoadmap"] = this.isLinkedToRoadmap;
        data["roadmapId"] = this.roadmapId;
        data["roadmapName"] = this.roadmapName;
        data["initiativeId"] = this.initiativeId;
        data["initiativeName"] = this.initiativeName;
        data["program"] = this.program;
        return data;
    }
}

export interface IResponseRecommendation {
    recommendationId: string | undefined;
    assessmentId: string | undefined;
    impact: string | undefined;
    capability: string | undefined;
    capabilityId: string | undefined;
    category: string | undefined;
    subcategory: string | undefined;
    recommendationsSummary: string | undefined;
    recommendations: string | undefined;
    knownTools?: string[] | undefined;
    otherTools?: string[] | undefined;
    knownToolsLogos?: string[] | undefined;
    otherToolsLogos?: string[] | undefined;
    hasHarveyBallData?: boolean;
    isLinkedToRoadmap?: boolean;
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;
    initiativeId?: string | undefined;
    initiativeName?: string | undefined;
    program?: string | undefined;
}

export class ResponseSubcategory implements IResponseSubcategory {
    name!: string | undefined;
    responseCapabilities!: ResponseCapability[] | undefined;

    constructor(data?: IResponseSubcategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["responseCapabilities"])) {
                this.responseCapabilities = [] as any;
                for (let item of _data["responseCapabilities"])
                    this.responseCapabilities!.push(ResponseCapability.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseSubcategory {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseSubcategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.responseCapabilities)) {
            data["responseCapabilities"] = [];
            for (let item of this.responseCapabilities)
                data["responseCapabilities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseSubcategory {
    name: string | undefined;
    responseCapabilities: ResponseCapability[] | undefined;
}

export class TargetMaturityBreakdown implements ITargetMaturityBreakdown {
    subCategory!: string | undefined;
    currentMaturity?: number;
    targetMaturity?: number;

    constructor(data?: ITargetMaturityBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory = _data["subCategory"];
            this.currentMaturity = _data["currentMaturity"];
            this.targetMaturity = _data["targetMaturity"];
        }
    }

    static fromJS(data: any): TargetMaturityBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new TargetMaturityBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory"] = this.subCategory;
        data["currentMaturity"] = this.currentMaturity;
        data["targetMaturity"] = this.targetMaturity;
        return data;
    }
}

export interface ITargetMaturityBreakdown {
    subCategory: string | undefined;
    currentMaturity?: number;
    targetMaturity?: number;
}

export class UpdateAssessmentIntegration implements IUpdateAssessmentIntegration {
    airtableAssessmentLink?: string | undefined;
    axAccountNumber?: string | undefined;
    crmGuid?: string | undefined;
    assessmentProgram?: string | undefined;
    status?: string | undefined;
    airtableId?: string | undefined;
    assessmentGuid?: string | undefined;

    constructor(data?: IUpdateAssessmentIntegration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airtableAssessmentLink = _data["airtableAssessmentLink"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.crmGuid = _data["crmGuid"];
            this.assessmentProgram = _data["assessmentProgram"];
            this.status = _data["status"];
            this.airtableId = _data["airtableId"];
            this.assessmentGuid = _data["assessmentGuid"];
        }
    }

    static fromJS(data: any): UpdateAssessmentIntegration {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssessmentIntegration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airtableAssessmentLink"] = this.airtableAssessmentLink;
        data["axAccountNumber"] = this.axAccountNumber;
        data["crmGuid"] = this.crmGuid;
        data["assessmentProgram"] = this.assessmentProgram;
        data["status"] = this.status;
        data["airtableId"] = this.airtableId;
        data["assessmentGuid"] = this.assessmentGuid;
        return data;
    }
}

export interface IUpdateAssessmentIntegration {
    airtableAssessmentLink?: string | undefined;
    axAccountNumber?: string | undefined;
    crmGuid?: string | undefined;
    assessmentProgram?: string | undefined;
    status?: string | undefined;
    airtableId?: string | undefined;
    assessmentGuid?: string | undefined;
}

export class AgingInventoryPicklistResponse implements IAgingInventoryPicklistResponse {
    picklist?: { [key: string]: string[]; } | undefined;

    constructor(data?: IAgingInventoryPicklistResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["picklist"]) {
                this.picklist = {} as any;
                for (let key in _data["picklist"]) {
                    if (_data["picklist"].hasOwnProperty(key))
                        (this.picklist as any)![key] = _data["picklist"][key] !== undefined ? _data["picklist"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): AgingInventoryPicklistResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgingInventoryPicklistResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.picklist) {
            data["picklist"] = {};
            for (let key in this.picklist) {
                if (this.picklist.hasOwnProperty(key))
                    (data["picklist"] as any)[key] = (this.picklist as any)[key];
            }
        }
        return data;
    }
}

export interface IAgingInventoryPicklistResponse {
    picklist?: { [key: string]: string[]; } | undefined;
}

export class AgingInventorySearchFilterDto implements IAgingInventorySearchFilterDto {
    region?: string[] | undefined;
    country?: string[] | undefined;
    warehouse?: string[] | undefined;
    axCompany?: string[] | undefined;
    variant?: string[] | undefined;
    owner?: string[] | undefined;
    axAccountNumber?: string[] | undefined;
    manufacturer?: string[] | undefined;
    mfgPartNumber?: string[] | undefined;
    partDescription?: string[] | undefined;
    receiptRef?: string[] | undefined;
    buildNames?: string[] | undefined;
    soNumbers?: string[] | undefined;

    constructor(data?: IAgingInventorySearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["region"])) {
                this.region = [] as any;
                for (let item of _data["region"])
                    this.region!.push(item);
            }
            if (Array.isArray(_data["country"])) {
                this.country = [] as any;
                for (let item of _data["country"])
                    this.country!.push(item);
            }
            if (Array.isArray(_data["warehouse"])) {
                this.warehouse = [] as any;
                for (let item of _data["warehouse"])
                    this.warehouse!.push(item);
            }
            if (Array.isArray(_data["axCompany"])) {
                this.axCompany = [] as any;
                for (let item of _data["axCompany"])
                    this.axCompany!.push(item);
            }
            if (Array.isArray(_data["variant"])) {
                this.variant = [] as any;
                for (let item of _data["variant"])
                    this.variant!.push(item);
            }
            if (Array.isArray(_data["owner"])) {
                this.owner = [] as any;
                for (let item of _data["owner"])
                    this.owner!.push(item);
            }
            if (Array.isArray(_data["axAccountNumber"])) {
                this.axAccountNumber = [] as any;
                for (let item of _data["axAccountNumber"])
                    this.axAccountNumber!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["mfgPartNumber"])) {
                this.mfgPartNumber = [] as any;
                for (let item of _data["mfgPartNumber"])
                    this.mfgPartNumber!.push(item);
            }
            if (Array.isArray(_data["partDescription"])) {
                this.partDescription = [] as any;
                for (let item of _data["partDescription"])
                    this.partDescription!.push(item);
            }
            if (Array.isArray(_data["receiptRef"])) {
                this.receiptRef = [] as any;
                for (let item of _data["receiptRef"])
                    this.receiptRef!.push(item);
            }
            if (Array.isArray(_data["buildNames"])) {
                this.buildNames = [] as any;
                for (let item of _data["buildNames"])
                    this.buildNames!.push(item);
            }
            if (Array.isArray(_data["soNumbers"])) {
                this.soNumbers = [] as any;
                for (let item of _data["soNumbers"])
                    this.soNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): AgingInventorySearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgingInventorySearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item);
        }
        if (Array.isArray(this.country)) {
            data["country"] = [];
            for (let item of this.country)
                data["country"].push(item);
        }
        if (Array.isArray(this.warehouse)) {
            data["warehouse"] = [];
            for (let item of this.warehouse)
                data["warehouse"].push(item);
        }
        if (Array.isArray(this.axCompany)) {
            data["axCompany"] = [];
            for (let item of this.axCompany)
                data["axCompany"].push(item);
        }
        if (Array.isArray(this.variant)) {
            data["variant"] = [];
            for (let item of this.variant)
                data["variant"].push(item);
        }
        if (Array.isArray(this.owner)) {
            data["owner"] = [];
            for (let item of this.owner)
                data["owner"].push(item);
        }
        if (Array.isArray(this.axAccountNumber)) {
            data["axAccountNumber"] = [];
            for (let item of this.axAccountNumber)
                data["axAccountNumber"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.mfgPartNumber)) {
            data["mfgPartNumber"] = [];
            for (let item of this.mfgPartNumber)
                data["mfgPartNumber"].push(item);
        }
        if (Array.isArray(this.partDescription)) {
            data["partDescription"] = [];
            for (let item of this.partDescription)
                data["partDescription"].push(item);
        }
        if (Array.isArray(this.receiptRef)) {
            data["receiptRef"] = [];
            for (let item of this.receiptRef)
                data["receiptRef"].push(item);
        }
        if (Array.isArray(this.buildNames)) {
            data["buildNames"] = [];
            for (let item of this.buildNames)
                data["buildNames"].push(item);
        }
        if (Array.isArray(this.soNumbers)) {
            data["soNumbers"] = [];
            for (let item of this.soNumbers)
                data["soNumbers"].push(item);
        }
        return data;
    }
}

export interface IAgingInventorySearchFilterDto {
    region?: string[] | undefined;
    country?: string[] | undefined;
    warehouse?: string[] | undefined;
    axCompany?: string[] | undefined;
    variant?: string[] | undefined;
    owner?: string[] | undefined;
    axAccountNumber?: string[] | undefined;
    manufacturer?: string[] | undefined;
    mfgPartNumber?: string[] | undefined;
    partDescription?: string[] | undefined;
    receiptRef?: string[] | undefined;
    buildNames?: string[] | undefined;
    soNumbers?: string[] | undefined;
}

export class AgingInventorySearchResponse implements IAgingInventorySearchResponse {
    items?: AgingInventoryItemDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IAgingInventorySearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgingInventoryItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): AgingInventorySearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgingInventorySearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IAgingInventorySearchResponse {
    items?: AgingInventoryItemDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class ElasticSearchCompositeAggregationPagination implements IElasticSearchCompositeAggregationPagination {
    pageSize?: number;
    afterKey?: string | undefined;
    hasMore?: boolean;
    totalCount?: number | undefined;
    pageIndex?: number | undefined;

    constructor(data?: IElasticSearchCompositeAggregationPagination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["pageSize"];
            this.afterKey = _data["afterKey"];
            this.hasMore = _data["hasMore"];
            this.totalCount = _data["totalCount"];
            this.pageIndex = _data["pageIndex"];
        }
    }

    static fromJS(data: any): ElasticSearchCompositeAggregationPagination {
        data = typeof data === 'object' ? data : {};
        let result = new ElasticSearchCompositeAggregationPagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize;
        data["afterKey"] = this.afterKey;
        data["hasMore"] = this.hasMore;
        data["totalCount"] = this.totalCount;
        data["pageIndex"] = this.pageIndex;
        return data;
    }
}

export interface IElasticSearchCompositeAggregationPagination {
    pageSize?: number;
    afterKey?: string | undefined;
    hasMore?: boolean;
    totalCount?: number | undefined;
    pageIndex?: number | undefined;
}

export class GetAssetsSpendByAssetTypeResponse implements IGetAssetsSpendByAssetTypeResponse {
    assetTypeSpendData?: AssetTypeSpendDataDto[] | undefined;

    constructor(data?: IGetAssetsSpendByAssetTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assetTypeSpendData"])) {
                this.assetTypeSpendData = [] as any;
                for (let item of _data["assetTypeSpendData"])
                    this.assetTypeSpendData!.push(AssetTypeSpendDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssetsSpendByAssetTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetsSpendByAssetTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assetTypeSpendData)) {
            data["assetTypeSpendData"] = [];
            for (let item of this.assetTypeSpendData)
                data["assetTypeSpendData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAssetsSpendByAssetTypeResponse {
    assetTypeSpendData?: AssetTypeSpendDataDto[] | undefined;
}

export class GetAssetsSpendByCategoryResponse implements IGetAssetsSpendByCategoryResponse {
    categorySpendData?: CategorySpendDataDto[] | undefined;

    constructor(data?: IGetAssetsSpendByCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categorySpendData"])) {
                this.categorySpendData = [] as any;
                for (let item of _data["categorySpendData"])
                    this.categorySpendData!.push(CategorySpendDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssetsSpendByCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetsSpendByCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categorySpendData)) {
            data["categorySpendData"] = [];
            for (let item of this.categorySpendData)
                data["categorySpendData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAssetsSpendByCategoryResponse {
    categorySpendData?: CategorySpendDataDto[] | undefined;
}

export class GetAssetsSpendByManufacturerResponse implements IGetAssetsSpendByManufacturerResponse {
    manufacturerSpendData?: ManufacturerSpendDataDto[] | undefined;

    constructor(data?: IGetAssetsSpendByManufacturerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturerSpendData"])) {
                this.manufacturerSpendData = [] as any;
                for (let item of _data["manufacturerSpendData"])
                    this.manufacturerSpendData!.push(ManufacturerSpendDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssetsSpendByManufacturerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetsSpendByManufacturerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturerSpendData)) {
            data["manufacturerSpendData"] = [];
            for (let item of this.manufacturerSpendData)
                data["manufacturerSpendData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAssetsSpendByManufacturerResponse {
    manufacturerSpendData?: ManufacturerSpendDataDto[] | undefined;
}

export class GetAssetsSpendComparisonResponse implements IGetAssetsSpendComparisonResponse {
    monthlySpendData?: MonthlySpendDataDto[] | undefined;

    constructor(data?: IGetAssetsSpendComparisonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["monthlySpendData"])) {
                this.monthlySpendData = [] as any;
                for (let item of _data["monthlySpendData"])
                    this.monthlySpendData!.push(MonthlySpendDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssetsSpendComparisonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetsSpendComparisonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.monthlySpendData)) {
            data["monthlySpendData"] = [];
            for (let item of this.monthlySpendData)
                data["monthlySpendData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAssetsSpendComparisonResponse {
    monthlySpendData?: MonthlySpendDataDto[] | undefined;
}

export class GetAssetsTotalSpendResponse implements IGetAssetsTotalSpendResponse {
    weeklySpendData?: WeeklySpendDataDto[] | undefined;
    monthlySpendData?: MonthlySpendDataDto[] | undefined;
    totalSpend?: number;
    totalSpendChangePercent?: number;
    ordersCount?: number;
    ordersChangePercent?: number;
    manufacturersCount?: number;
    manufacturersChangePercent?: number;

    constructor(data?: IGetAssetsTotalSpendResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weeklySpendData"])) {
                this.weeklySpendData = [] as any;
                for (let item of _data["weeklySpendData"])
                    this.weeklySpendData!.push(WeeklySpendDataDto.fromJS(item));
            }
            if (Array.isArray(_data["monthlySpendData"])) {
                this.monthlySpendData = [] as any;
                for (let item of _data["monthlySpendData"])
                    this.monthlySpendData!.push(MonthlySpendDataDto.fromJS(item));
            }
            this.totalSpend = _data["totalSpend"];
            this.totalSpendChangePercent = _data["totalSpendChangePercent"];
            this.ordersCount = _data["ordersCount"];
            this.ordersChangePercent = _data["ordersChangePercent"];
            this.manufacturersCount = _data["manufacturersCount"];
            this.manufacturersChangePercent = _data["manufacturersChangePercent"];
        }
    }

    static fromJS(data: any): GetAssetsTotalSpendResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetsTotalSpendResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weeklySpendData)) {
            data["weeklySpendData"] = [];
            for (let item of this.weeklySpendData)
                data["weeklySpendData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.monthlySpendData)) {
            data["monthlySpendData"] = [];
            for (let item of this.monthlySpendData)
                data["monthlySpendData"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalSpend"] = this.totalSpend;
        data["totalSpendChangePercent"] = this.totalSpendChangePercent;
        data["ordersCount"] = this.ordersCount;
        data["ordersChangePercent"] = this.ordersChangePercent;
        data["manufacturersCount"] = this.manufacturersCount;
        data["manufacturersChangePercent"] = this.manufacturersChangePercent;
        return data;
    }
}

export interface IGetAssetsTotalSpendResponse {
    weeklySpendData?: WeeklySpendDataDto[] | undefined;
    monthlySpendData?: MonthlySpendDataDto[] | undefined;
    totalSpend?: number;
    totalSpendChangePercent?: number;
    ordersCount?: number;
    ordersChangePercent?: number;
    manufacturersCount?: number;
    manufacturersChangePercent?: number;
}

export class GetPurchasedAssetsSpendWidgetRequest implements IGetPurchasedAssetsSpendWidgetRequest {
    clientLocalNow!: Date;

    constructor(data?: IGetPurchasedAssetsSpendWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientLocalNow = _data["clientLocalNow"] ? new Date(_data["clientLocalNow"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetPurchasedAssetsSpendWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchasedAssetsSpendWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientLocalNow"] = this.clientLocalNow ? this.clientLocalNow.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetPurchasedAssetsSpendWidgetRequest {
    clientLocalNow: Date;
}

export class GetWarehouseAggregatedOrdersResponse implements IGetWarehouseAggregatedOrdersResponse {
    openTransfersOrders?: number;
    openIntegrationOrders?: number;
    openRackAndStackOrders?: number;
    totalOutgoingOrders?: number;
    totalShippedOrders?: number;
    rmaOrders?: number;

    constructor(data?: IGetWarehouseAggregatedOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openTransfersOrders = _data["openTransfersOrders"];
            this.openIntegrationOrders = _data["openIntegrationOrders"];
            this.openRackAndStackOrders = _data["openRackAndStackOrders"];
            this.totalOutgoingOrders = _data["totalOutgoingOrders"];
            this.totalShippedOrders = _data["totalShippedOrders"];
            this.rmaOrders = _data["rmaOrders"];
        }
    }

    static fromJS(data: any): GetWarehouseAggregatedOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseAggregatedOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openTransfersOrders"] = this.openTransfersOrders;
        data["openIntegrationOrders"] = this.openIntegrationOrders;
        data["openRackAndStackOrders"] = this.openRackAndStackOrders;
        data["totalOutgoingOrders"] = this.totalOutgoingOrders;
        data["totalShippedOrders"] = this.totalShippedOrders;
        data["rmaOrders"] = this.rmaOrders;
        return data;
    }
}

export interface IGetWarehouseAggregatedOrdersResponse {
    openTransfersOrders?: number;
    openIntegrationOrders?: number;
    openRackAndStackOrders?: number;
    totalOutgoingOrders?: number;
    totalShippedOrders?: number;
    rmaOrders?: number;
}

export class GetWarehouseAggregatedStockResponse implements IGetWarehouseAggregatedStockResponse {
    incomingAssets?: number;
    transferringAssets?: number;
    assetsAvailableToTransfer?: number;
    productsAtLevelRisk?: number;
    projectOptions?: string[] | undefined;

    constructor(data?: IGetWarehouseAggregatedStockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomingAssets = _data["incomingAssets"];
            this.transferringAssets = _data["transferringAssets"];
            this.assetsAvailableToTransfer = _data["assetsAvailableToTransfer"];
            this.productsAtLevelRisk = _data["productsAtLevelRisk"];
            if (Array.isArray(_data["projectOptions"])) {
                this.projectOptions = [] as any;
                for (let item of _data["projectOptions"])
                    this.projectOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetWarehouseAggregatedStockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseAggregatedStockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomingAssets"] = this.incomingAssets;
        data["transferringAssets"] = this.transferringAssets;
        data["assetsAvailableToTransfer"] = this.assetsAvailableToTransfer;
        data["productsAtLevelRisk"] = this.productsAtLevelRisk;
        if (Array.isArray(this.projectOptions)) {
            data["projectOptions"] = [];
            for (let item of this.projectOptions)
                data["projectOptions"].push(item);
        }
        return data;
    }
}

export interface IGetWarehouseAggregatedStockResponse {
    incomingAssets?: number;
    transferringAssets?: number;
    assetsAvailableToTransfer?: number;
    productsAtLevelRisk?: number;
    projectOptions?: string[] | undefined;
}

export class GetWarehouseStockResponse implements IGetWarehouseStockResponse {
    warehouseStock?: WarehouseStockItemDto[] | undefined;

    constructor(data?: IGetWarehouseStockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehouseStock"])) {
                this.warehouseStock = [] as any;
                for (let item of _data["warehouseStock"])
                    this.warehouseStock!.push(WarehouseStockItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehouseStockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseStockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouseStock)) {
            data["warehouseStock"] = [];
            for (let item of this.warehouseStock)
                data["warehouseStock"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetWarehouseStockResponse {
    warehouseStock?: WarehouseStockItemDto[] | undefined;
}

export enum LifecycleImportErrorCategory {
    Unknown = "Unknown",
    RequiredFieldMissing = "RequiredFieldMissing",
    EmptyRow = "EmptyRow",
    InvalidEventType = "InvalidEventType",
    InvalidDate = "InvalidDate",
    InvalidNumber = "InvalidNumber",
    InvalidEmail = "InvalidEmail",
    InvalidCategory = "InvalidCategory",
    InvalidListFormat = "InvalidListFormat",
}

export class LifecycleImportErrorGroup implements ILifecycleImportErrorGroup {
    category?: LifecycleImportErrorCategory;
    failureCount?: number;
    affectedRowCount?: number;
    affectedRows?: number[] | undefined;
    errors?: LifecycleImportRowError[] | undefined;

    constructor(data?: ILifecycleImportErrorGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.failureCount = _data["failureCount"];
            this.affectedRowCount = _data["affectedRowCount"];
            if (Array.isArray(_data["affectedRows"])) {
                this.affectedRows = [] as any;
                for (let item of _data["affectedRows"])
                    this.affectedRows!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(LifecycleImportRowError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LifecycleImportErrorGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleImportErrorGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["failureCount"] = this.failureCount;
        data["affectedRowCount"] = this.affectedRowCount;
        if (Array.isArray(this.affectedRows)) {
            data["affectedRows"] = [];
            for (let item of this.affectedRows)
                data["affectedRows"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILifecycleImportErrorGroup {
    category?: LifecycleImportErrorCategory;
    failureCount?: number;
    affectedRowCount?: number;
    affectedRows?: number[] | undefined;
    errors?: LifecycleImportRowError[] | undefined;
}

export class LifecycleImportRowError implements ILifecycleImportRowError {
    rowNumber?: number;
    columnName?: string | undefined;
    message?: string | undefined;

    constructor(data?: ILifecycleImportRowError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.columnName = _data["columnName"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): LifecycleImportRowError {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleImportRowError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["columnName"] = this.columnName;
        data["message"] = this.message;
        return data;
    }
}

export interface ILifecycleImportRowError {
    rowNumber?: number;
    columnName?: string | undefined;
    message?: string | undefined;
}

export class LifecycleImportStagedSubmissionRequest implements ILifecycleImportStagedSubmissionRequest {
    stagingToken?: string | undefined;
    axAccountNumber?: string | undefined;

    constructor(data?: ILifecycleImportStagedSubmissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stagingToken = _data["stagingToken"];
            this.axAccountNumber = _data["axAccountNumber"];
        }
    }

    static fromJS(data: any): LifecycleImportStagedSubmissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleImportStagedSubmissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stagingToken"] = this.stagingToken;
        data["axAccountNumber"] = this.axAccountNumber;
        return data;
    }
}

export interface ILifecycleImportStagedSubmissionRequest {
    stagingToken?: string | undefined;
    axAccountNumber?: string | undefined;
}

export class LifecycleImportSubmissionResponse implements ILifecycleImportSubmissionResponse {
    importId?: string | undefined;
    status?: string | undefined;
    acceptedAtUtc?: Date;
    submittedRows?: number;
    skippedRows?: number;

    constructor(data?: ILifecycleImportSubmissionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importId = _data["importId"];
            this.status = _data["status"];
            this.acceptedAtUtc = _data["acceptedAtUtc"] ? new Date(_data["acceptedAtUtc"].toString()) : undefined as any;
            this.submittedRows = _data["submittedRows"];
            this.skippedRows = _data["skippedRows"];
        }
    }

    static fromJS(data: any): LifecycleImportSubmissionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleImportSubmissionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importId"] = this.importId;
        data["status"] = this.status;
        data["acceptedAtUtc"] = this.acceptedAtUtc ? this.acceptedAtUtc.toISOString() : undefined as any;
        data["submittedRows"] = this.submittedRows;
        data["skippedRows"] = this.skippedRows;
        return data;
    }
}

export interface ILifecycleImportSubmissionResponse {
    importId?: string | undefined;
    status?: string | undefined;
    acceptedAtUtc?: Date;
    submittedRows?: number;
    skippedRows?: number;
}

export class LifecycleImportValidationResponse implements ILifecycleImportValidationResponse {
    isValid?: boolean;
    structuralError?: string | undefined;
    totalRows?: number;
    validRows?: number;
    invalidRows?: number;
    readonly canSubmit?: boolean;
    rowErrors?: LifecycleImportErrorGroup[] | undefined;
    rowWarnings?: LifecycleImportErrorGroup[] | undefined;
    categoriesVerified?: boolean;
    stagingToken?: string | undefined;

    constructor(data?: ILifecycleImportValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.structuralError = _data["structuralError"];
            this.totalRows = _data["totalRows"];
            this.validRows = _data["validRows"];
            this.invalidRows = _data["invalidRows"];
            (this as any).canSubmit = _data["canSubmit"];
            if (Array.isArray(_data["rowErrors"])) {
                this.rowErrors = [] as any;
                for (let item of _data["rowErrors"])
                    this.rowErrors!.push(LifecycleImportErrorGroup.fromJS(item));
            }
            if (Array.isArray(_data["rowWarnings"])) {
                this.rowWarnings = [] as any;
                for (let item of _data["rowWarnings"])
                    this.rowWarnings!.push(LifecycleImportErrorGroup.fromJS(item));
            }
            this.categoriesVerified = _data["categoriesVerified"];
            this.stagingToken = _data["stagingToken"];
        }
    }

    static fromJS(data: any): LifecycleImportValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleImportValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["structuralError"] = this.structuralError;
        data["totalRows"] = this.totalRows;
        data["validRows"] = this.validRows;
        data["invalidRows"] = this.invalidRows;
        data["canSubmit"] = this.canSubmit;
        if (Array.isArray(this.rowErrors)) {
            data["rowErrors"] = [];
            for (let item of this.rowErrors)
                data["rowErrors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rowWarnings)) {
            data["rowWarnings"] = [];
            for (let item of this.rowWarnings)
                data["rowWarnings"].push(item ? item.toJSON() : undefined as any);
        }
        data["categoriesVerified"] = this.categoriesVerified;
        data["stagingToken"] = this.stagingToken;
        return data;
    }
}

export interface ILifecycleImportValidationResponse {
    isValid?: boolean;
    structuralError?: string | undefined;
    totalRows?: number;
    validRows?: number;
    invalidRows?: number;
    canSubmit?: boolean;
    rowErrors?: LifecycleImportErrorGroup[] | undefined;
    rowWarnings?: LifecycleImportErrorGroup[] | undefined;
    categoriesVerified?: boolean;
    stagingToken?: string | undefined;
}

export class CustomerOwnerDto implements ICustomerOwnerDto {
    id!: string | undefined;
    displayName!: string | undefined;
    email!: string | undefined;
    isSelectable!: boolean;

    constructor(data?: ICustomerOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.isSelectable = _data["isSelectable"];
        }
    }

    static fromJS(data: any): CustomerOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["isSelectable"] = this.isSelectable;
        return data;
    }
}

export interface ICustomerOwnerDto {
    id: string | undefined;
    displayName: string | undefined;
    email: string | undefined;
    isSelectable: boolean;
}

export class FindPossibleDuplicateLifecycleEventsRequest implements IFindPossibleDuplicateLifecycleEventsRequest {
    axAccountNumber!: string | undefined;
    manufacturer!: string | undefined;
    biManufacturerId?: number | undefined;
    eventType!: LifecycleManagementEventType;
    compellingEventDate!: Date;

    constructor(data?: IFindPossibleDuplicateLifecycleEventsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.manufacturer = _data["manufacturer"];
            this.biManufacturerId = _data["biManufacturerId"];
            this.eventType = _data["eventType"];
            this.compellingEventDate = _data["compellingEventDate"] ? new Date(_data["compellingEventDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FindPossibleDuplicateLifecycleEventsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FindPossibleDuplicateLifecycleEventsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["manufacturer"] = this.manufacturer;
        data["biManufacturerId"] = this.biManufacturerId;
        data["eventType"] = this.eventType;
        data["compellingEventDate"] = this.compellingEventDate ? this.compellingEventDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IFindPossibleDuplicateLifecycleEventsRequest {
    axAccountNumber: string | undefined;
    manufacturer: string | undefined;
    biManufacturerId?: number | undefined;
    eventType: LifecycleManagementEventType;
    compellingEventDate: Date;
}

export class FindPossibleDuplicateLifecycleEventsResponse implements IFindPossibleDuplicateLifecycleEventsResponse {
    matches?: PossibleDuplicateLifecycleEvent[] | undefined;

    constructor(data?: IFindPossibleDuplicateLifecycleEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(PossibleDuplicateLifecycleEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FindPossibleDuplicateLifecycleEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FindPossibleDuplicateLifecycleEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFindPossibleDuplicateLifecycleEventsResponse {
    matches?: PossibleDuplicateLifecycleEvent[] | undefined;
}

export class GetEventCountsByTermResponse implements IGetEventCountsByTermResponse {
    totalEvents?: number;
    eventsActioned?: number;
    eventsNotActioned?: number;
    billingEventCount?: number;

    constructor(data?: IGetEventCountsByTermResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEvents = _data["totalEvents"];
            this.eventsActioned = _data["eventsActioned"];
            this.eventsNotActioned = _data["eventsNotActioned"];
            this.billingEventCount = _data["billingEventCount"];
        }
    }

    static fromJS(data: any): GetEventCountsByTermResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventCountsByTermResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEvents"] = this.totalEvents;
        data["eventsActioned"] = this.eventsActioned;
        data["eventsNotActioned"] = this.eventsNotActioned;
        data["billingEventCount"] = this.billingEventCount;
        return data;
    }
}

export interface IGetEventCountsByTermResponse {
    totalEvents?: number;
    eventsActioned?: number;
    eventsNotActioned?: number;
    billingEventCount?: number;
}

export class GetLifecycleEventLineItemsResponse implements IGetLifecycleEventLineItemsResponse {
    lineItems!: LifecycleEventLineItemDto[] | undefined;
    total!: LifecycleEventLineItemsTotalDto;

    constructor(data?: IGetLifecycleEventLineItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.total = new LifecycleEventLineItemsTotalDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(LifecycleEventLineItemDto.fromJS(item));
            }
            this.total = _data["total"] ? LifecycleEventLineItemsTotalDto.fromJS(_data["total"]) : new LifecycleEventLineItemsTotalDto();
        }
    }

    static fromJS(data: any): GetLifecycleEventLineItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifecycleEventLineItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total ? this.total.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLifecycleEventLineItemsResponse {
    lineItems: LifecycleEventLineItemDto[] | undefined;
    total: LifecycleEventLineItemsTotalDto;
}

export class GetLifecycleEventLineItemsSearchRequest implements IGetLifecycleEventLineItemsSearchRequest {
    uniqueIdentifiers!: string[] | undefined;
    pagination?: LifecycleManagementSearchPaginationRequestDto;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;

    constructor(data?: IGetLifecycleEventLineItemsSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniqueIdentifiers"])) {
                this.uniqueIdentifiers = [] as any;
                for (let item of _data["uniqueIdentifiers"])
                    this.uniqueIdentifiers!.push(item);
            }
            this.pagination = _data["pagination"] ? LifecycleManagementSearchPaginationRequestDto.fromJS(_data["pagination"]) : undefined as any;
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.searchFor = _data["searchFor"];
            this.excludeSearchFor = _data["excludeSearchFor"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLifecycleEventLineItemsSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifecycleEventLineItemsSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniqueIdentifiers)) {
            data["uniqueIdentifiers"] = [];
            for (let item of this.uniqueIdentifiers)
                data["uniqueIdentifiers"].push(item);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["searchFor"] = this.searchFor;
        data["excludeSearchFor"] = this.excludeSearchFor;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLifecycleEventLineItemsSearchRequest {
    uniqueIdentifiers: string[] | undefined;
    pagination?: LifecycleManagementSearchPaginationRequestDto;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;
}

export class GetLifecycleManagementAllEventsResponse implements IGetLifecycleManagementAllEventsResponse {
    items!: LifecycleManagementAllEvents[] | undefined;
    pagination!: GetLifecycleManagementSearchPaginationResponse;
    totalPreviousPurchaseCost?: number | undefined;
    totalGm?: number | undefined;

    constructor(data?: IGetLifecycleManagementAllEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.pagination = new GetLifecycleManagementSearchPaginationResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LifecycleManagementAllEvents.fromJS(item));
            }
            this.pagination = _data["pagination"] ? GetLifecycleManagementSearchPaginationResponse.fromJS(_data["pagination"]) : new GetLifecycleManagementSearchPaginationResponse();
            this.totalPreviousPurchaseCost = _data["totalPreviousPurchaseCost"];
            this.totalGm = _data["totalGm"];
        }
    }

    static fromJS(data: any): GetLifecycleManagementAllEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifecycleManagementAllEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["totalPreviousPurchaseCost"] = this.totalPreviousPurchaseCost;
        data["totalGm"] = this.totalGm;
        return data;
    }
}

export interface IGetLifecycleManagementAllEventsResponse {
    items: LifecycleManagementAllEvents[] | undefined;
    pagination: GetLifecycleManagementSearchPaginationResponse;
    totalPreviousPurchaseCost?: number | undefined;
    totalGm?: number | undefined;
}

export class GetLifecycleManagementAllEventsTimelineResponse implements IGetLifecycleManagementAllEventsTimelineResponse {
    months?: LifecycleManagementEventDateSummary[] | undefined;

    constructor(data?: IGetLifecycleManagementAllEventsTimelineResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(LifecycleManagementEventDateSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLifecycleManagementAllEventsTimelineResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifecycleManagementAllEventsTimelineResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetLifecycleManagementAllEventsTimelineResponse {
    months?: LifecycleManagementEventDateSummary[] | undefined;
}

export class GetLifecycleManagementCategoryValuesResponse implements IGetLifecycleManagementCategoryValuesResponse {
    values?: string[] | undefined;
    error?: string | undefined;

    constructor(data?: IGetLifecycleManagementCategoryValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetLifecycleManagementCategoryValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifecycleManagementCategoryValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["error"] = this.error;
        return data;
    }
}

export interface IGetLifecycleManagementCategoryValuesResponse {
    values?: string[] | undefined;
    error?: string | undefined;
}

export class GetLifecycleManagementDrawerOrdersResponse implements IGetLifecycleManagementDrawerOrdersResponse {
    totalOrders?: number | undefined;
    totalCoveredItems?: number | undefined;
    totalPreviousPurchaseCost?: number | undefined;
    totalPreviousGrossMargin?: number | undefined;
    orders?: LifecycleManagementDrawerOrdersDto[] | undefined;

    constructor(data?: IGetLifecycleManagementDrawerOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalOrders = _data["totalOrders"];
            this.totalCoveredItems = _data["totalCoveredItems"];
            this.totalPreviousPurchaseCost = _data["totalPreviousPurchaseCost"];
            this.totalPreviousGrossMargin = _data["totalPreviousGrossMargin"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(LifecycleManagementDrawerOrdersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLifecycleManagementDrawerOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifecycleManagementDrawerOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalOrders"] = this.totalOrders;
        data["totalCoveredItems"] = this.totalCoveredItems;
        data["totalPreviousPurchaseCost"] = this.totalPreviousPurchaseCost;
        data["totalPreviousGrossMargin"] = this.totalPreviousGrossMargin;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetLifecycleManagementDrawerOrdersResponse {
    totalOrders?: number | undefined;
    totalCoveredItems?: number | undefined;
    totalPreviousPurchaseCost?: number | undefined;
    totalPreviousGrossMargin?: number | undefined;
    orders?: LifecycleManagementDrawerOrdersDto[] | undefined;
}

export class GetLifecycleManagementDrawerOrdersSearchRequest implements IGetLifecycleManagementDrawerOrdersSearchRequest {
    uniqueIdentifiers!: string[] | undefined;
    pagination?: LifecycleManagementSearchPaginationRequestDto;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;

    constructor(data?: IGetLifecycleManagementDrawerOrdersSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniqueIdentifiers"])) {
                this.uniqueIdentifiers = [] as any;
                for (let item of _data["uniqueIdentifiers"])
                    this.uniqueIdentifiers!.push(item);
            }
            this.pagination = _data["pagination"] ? LifecycleManagementSearchPaginationRequestDto.fromJS(_data["pagination"]) : undefined as any;
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.searchFor = _data["searchFor"];
            this.excludeSearchFor = _data["excludeSearchFor"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLifecycleManagementDrawerOrdersSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifecycleManagementDrawerOrdersSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniqueIdentifiers)) {
            data["uniqueIdentifiers"] = [];
            for (let item of this.uniqueIdentifiers)
                data["uniqueIdentifiers"].push(item);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["searchFor"] = this.searchFor;
        data["excludeSearchFor"] = this.excludeSearchFor;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLifecycleManagementDrawerOrdersSearchRequest {
    uniqueIdentifiers: string[] | undefined;
    pagination?: LifecycleManagementSearchPaginationRequestDto;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;
}

export class GetLifecycleManagementPicklistResponse implements IGetLifecycleManagementPicklistResponse {
    eventType?: string[] | undefined;
    status?: string[] | undefined;
    strategy?: string[] | undefined;
    searchCategories?: string[] | undefined;
    axAccounts?: AxAccountOption[] | undefined;
    segments?: LifecyclePicklistSegmentGroup[] | undefined;
    source?: string[] | undefined;
    tier?: string[] | undefined;
    solutionArea?: string[] | undefined;
    categories?: LifecyclePicklistSolutionAreaGroup[] | undefined;
    assignedTo?: LifecycleManagementAssignedToDto[] | undefined;
    accountExecutive?: string[] | undefined;
    revenueBounds?: LifecycleManagementNumberRangeBounds;
    gmBounds?: LifecycleManagementNumberRangeBounds;

    constructor(data?: IGetLifecycleManagementPicklistResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["eventType"])) {
                this.eventType = [] as any;
                for (let item of _data["eventType"])
                    this.eventType!.push(item);
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["strategy"])) {
                this.strategy = [] as any;
                for (let item of _data["strategy"])
                    this.strategy!.push(item);
            }
            if (Array.isArray(_data["searchCategories"])) {
                this.searchCategories = [] as any;
                for (let item of _data["searchCategories"])
                    this.searchCategories!.push(item);
            }
            if (Array.isArray(_data["axAccounts"])) {
                this.axAccounts = [] as any;
                for (let item of _data["axAccounts"])
                    this.axAccounts!.push(AxAccountOption.fromJS(item));
            }
            if (Array.isArray(_data["segments"])) {
                this.segments = [] as any;
                for (let item of _data["segments"])
                    this.segments!.push(LifecyclePicklistSegmentGroup.fromJS(item));
            }
            if (Array.isArray(_data["source"])) {
                this.source = [] as any;
                for (let item of _data["source"])
                    this.source!.push(item);
            }
            if (Array.isArray(_data["tier"])) {
                this.tier = [] as any;
                for (let item of _data["tier"])
                    this.tier!.push(item);
            }
            if (Array.isArray(_data["solutionArea"])) {
                this.solutionArea = [] as any;
                for (let item of _data["solutionArea"])
                    this.solutionArea!.push(item);
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(LifecyclePicklistSolutionAreaGroup.fromJS(item));
            }
            if (Array.isArray(_data["assignedTo"])) {
                this.assignedTo = [] as any;
                for (let item of _data["assignedTo"])
                    this.assignedTo!.push(LifecycleManagementAssignedToDto.fromJS(item));
            }
            if (Array.isArray(_data["accountExecutive"])) {
                this.accountExecutive = [] as any;
                for (let item of _data["accountExecutive"])
                    this.accountExecutive!.push(item);
            }
            this.revenueBounds = _data["revenueBounds"] ? LifecycleManagementNumberRangeBounds.fromJS(_data["revenueBounds"]) : undefined as any;
            this.gmBounds = _data["gmBounds"] ? LifecycleManagementNumberRangeBounds.fromJS(_data["gmBounds"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLifecycleManagementPicklistResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifecycleManagementPicklistResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.eventType)) {
            data["eventType"] = [];
            for (let item of this.eventType)
                data["eventType"].push(item);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.strategy)) {
            data["strategy"] = [];
            for (let item of this.strategy)
                data["strategy"].push(item);
        }
        if (Array.isArray(this.searchCategories)) {
            data["searchCategories"] = [];
            for (let item of this.searchCategories)
                data["searchCategories"].push(item);
        }
        if (Array.isArray(this.axAccounts)) {
            data["axAccounts"] = [];
            for (let item of this.axAccounts)
                data["axAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.segments)) {
            data["segments"] = [];
            for (let item of this.segments)
                data["segments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.source)) {
            data["source"] = [];
            for (let item of this.source)
                data["source"].push(item);
        }
        if (Array.isArray(this.tier)) {
            data["tier"] = [];
            for (let item of this.tier)
                data["tier"].push(item);
        }
        if (Array.isArray(this.solutionArea)) {
            data["solutionArea"] = [];
            for (let item of this.solutionArea)
                data["solutionArea"].push(item);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignedTo)) {
            data["assignedTo"] = [];
            for (let item of this.assignedTo)
                data["assignedTo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.accountExecutive)) {
            data["accountExecutive"] = [];
            for (let item of this.accountExecutive)
                data["accountExecutive"].push(item);
        }
        data["revenueBounds"] = this.revenueBounds ? this.revenueBounds.toJSON() : undefined as any;
        data["gmBounds"] = this.gmBounds ? this.gmBounds.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLifecycleManagementPicklistResponse {
    eventType?: string[] | undefined;
    status?: string[] | undefined;
    strategy?: string[] | undefined;
    searchCategories?: string[] | undefined;
    axAccounts?: AxAccountOption[] | undefined;
    segments?: LifecyclePicklistSegmentGroup[] | undefined;
    source?: string[] | undefined;
    tier?: string[] | undefined;
    solutionArea?: string[] | undefined;
    categories?: LifecyclePicklistSolutionAreaGroup[] | undefined;
    assignedTo?: LifecycleManagementAssignedToDto[] | undefined;
    accountExecutive?: string[] | undefined;
    revenueBounds?: LifecycleManagementNumberRangeBounds;
    gmBounds?: LifecycleManagementNumberRangeBounds;
}

export class GetLifecycleManagementSearchPaginationResponse implements IGetLifecycleManagementSearchPaginationResponse {
    pageSize?: number;
    afterKey?: string | undefined;
    hasMore?: boolean;

    constructor(data?: IGetLifecycleManagementSearchPaginationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["pageSize"];
            this.afterKey = _data["afterKey"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): GetLifecycleManagementSearchPaginationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLifecycleManagementSearchPaginationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize;
        data["afterKey"] = this.afterKey;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IGetLifecycleManagementSearchPaginationResponse {
    pageSize?: number;
    afterKey?: string | undefined;
    hasMore?: boolean;
}

export class GetUpcomingRenewalsResponse implements IGetUpcomingRenewalsResponse {
    items?: UpcomingRenewalsResponseItem[] | undefined;

    constructor(data?: IGetUpcomingRenewalsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UpcomingRenewalsResponseItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUpcomingRenewalsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUpcomingRenewalsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUpcomingRenewalsResponse {
    items?: UpcomingRenewalsResponseItem[] | undefined;
}

export class LifecycleDivisionGroup implements ILifecycleDivisionGroup {
    division?: string | undefined;
    regions?: LifecyclePicklistRegionGroup[] | undefined;

    constructor(data?: ILifecycleDivisionGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"];
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(LifecyclePicklistRegionGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LifecycleDivisionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleDivisionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILifecycleDivisionGroup {
    division?: string | undefined;
    regions?: LifecyclePicklistRegionGroup[] | undefined;
}

export class LifecycleEventLineItemDto implements ILifecycleEventLineItemDto {
    groupId?: string | undefined;
    account?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    productDescription?: string | undefined;
    serialNumber?: string | undefined;
    quantity?: number | undefined;
    category?: string | undefined;
    eventType?: string | undefined;
    eventDate?: string | undefined;
    orderDate?: string | undefined;
    poNumber?: string | undefined;
    shiPoNumber?: string | undefined;
    soNumber?: string | undefined;
    contractNumber?: string | undefined;
    agreementNumber?: string | undefined;
    previousPurchaseCost?: number | undefined;
    gm?: number | undefined;
    groupQuantity?: number | undefined;
    groupPreviousPurchaseCost?: number | undefined;
    groupGm?: number | undefined;
    isHidden?: boolean | undefined;
    assetUniqueIdentifier?: string | undefined;
    version?: number;

    constructor(data?: ILifecycleEventLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.account = _data["account"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.productDescription = _data["productDescription"];
            this.serialNumber = _data["serialNumber"];
            this.quantity = _data["quantity"];
            this.category = _data["category"];
            this.eventType = _data["eventType"];
            this.eventDate = _data["eventDate"];
            this.orderDate = _data["orderDate"];
            this.poNumber = _data["poNumber"];
            this.shiPoNumber = _data["shiPoNumber"];
            this.soNumber = _data["soNumber"];
            this.contractNumber = _data["contractNumber"];
            this.agreementNumber = _data["agreementNumber"];
            this.previousPurchaseCost = _data["previousPurchaseCost"];
            this.gm = _data["gm"];
            this.groupQuantity = _data["groupQuantity"];
            this.groupPreviousPurchaseCost = _data["groupPreviousPurchaseCost"];
            this.groupGm = _data["groupGm"];
            this.isHidden = _data["isHidden"];
            this.assetUniqueIdentifier = _data["assetUniqueIdentifier"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): LifecycleEventLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleEventLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["account"] = this.account;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["productDescription"] = this.productDescription;
        data["serialNumber"] = this.serialNumber;
        data["quantity"] = this.quantity;
        data["category"] = this.category;
        data["eventType"] = this.eventType;
        data["eventDate"] = this.eventDate;
        data["orderDate"] = this.orderDate;
        data["poNumber"] = this.poNumber;
        data["shiPoNumber"] = this.shiPoNumber;
        data["soNumber"] = this.soNumber;
        data["contractNumber"] = this.contractNumber;
        data["agreementNumber"] = this.agreementNumber;
        data["previousPurchaseCost"] = this.previousPurchaseCost;
        data["gm"] = this.gm;
        data["groupQuantity"] = this.groupQuantity;
        data["groupPreviousPurchaseCost"] = this.groupPreviousPurchaseCost;
        data["groupGm"] = this.groupGm;
        data["isHidden"] = this.isHidden;
        data["assetUniqueIdentifier"] = this.assetUniqueIdentifier;
        data["version"] = this.version;
        return data;
    }
}

export interface ILifecycleEventLineItemDto {
    groupId?: string | undefined;
    account?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    productDescription?: string | undefined;
    serialNumber?: string | undefined;
    quantity?: number | undefined;
    category?: string | undefined;
    eventType?: string | undefined;
    eventDate?: string | undefined;
    orderDate?: string | undefined;
    poNumber?: string | undefined;
    shiPoNumber?: string | undefined;
    soNumber?: string | undefined;
    contractNumber?: string | undefined;
    agreementNumber?: string | undefined;
    previousPurchaseCost?: number | undefined;
    gm?: number | undefined;
    groupQuantity?: number | undefined;
    groupPreviousPurchaseCost?: number | undefined;
    groupGm?: number | undefined;
    isHidden?: boolean | undefined;
    assetUniqueIdentifier?: string | undefined;
    version?: number;
}

export class LifecycleEventLineItemsTotalDto implements ILifecycleEventLineItemsTotalDto {
    orders?: number;
    lineItems?: number;
    previousPurchaseCost?: number;
    previousGrossMargin?: number | undefined;

    constructor(data?: ILifecycleEventLineItemsTotalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orders = _data["orders"];
            this.lineItems = _data["lineItems"];
            this.previousPurchaseCost = _data["previousPurchaseCost"];
            this.previousGrossMargin = _data["previousGrossMargin"];
        }
    }

    static fromJS(data: any): LifecycleEventLineItemsTotalDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleEventLineItemsTotalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orders"] = this.orders;
        data["lineItems"] = this.lineItems;
        data["previousPurchaseCost"] = this.previousPurchaseCost;
        data["previousGrossMargin"] = this.previousGrossMargin;
        return data;
    }
}

export interface ILifecycleEventLineItemsTotalDto {
    orders?: number;
    lineItems?: number;
    previousPurchaseCost?: number;
    previousGrossMargin?: number | undefined;
}

export class LifecycleManagementAllEvents implements ILifecycleManagementAllEvents {
    id!: string | undefined;
    axAccountNumber?: string | undefined;
    customerNameAx?: string | undefined;
    manufacturer?: string | undefined;
    eventType?: string | undefined;
    eventDate?: string | undefined;
    status?: string | undefined;
    manualStatus?: string | undefined;
    isStrategicFutureRenewal?: boolean;
    strategy?: string | undefined;
    eventDateMessage?: string | undefined;
    purchaseTimeframe?: string | undefined;
    notes?: string | undefined;
    customerFacingNotes?: string | undefined;
    coveredItems?: number;
    previousPurchaseCost?: number | undefined;
    previousPurchaseCostBeforeQuoteRollup?: number | undefined;
    gm?: number | undefined;
    previousGm?: number | undefined;
    allUniqueIdentifiers?: string[] | undefined;
    assignedTo?: LifecycleManagementAssignedToDto[] | undefined;
    customerOwner?: string[] | undefined;
    manualOverrideEventDate?: string | undefined;
    ruleBasedEventDate?: string | undefined;
    crmAccountId?: string | undefined;
    source?: string | undefined;
    poNumberList?: string[] | undefined;
    shiPoNumberList?: string[] | undefined;
    prevDeliveryContact?: string[] | undefined;
    products?: LifecycleManagementProductDto[] | undefined;
    salesPlayIds?: string[] | undefined;
    accountExecutive?: string | undefined;

    constructor(data?: ILifecycleManagementAllEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.customerNameAx = _data["customerNameAx"];
            this.manufacturer = _data["manufacturer"];
            this.eventType = _data["eventType"];
            this.eventDate = _data["eventDate"];
            this.status = _data["status"];
            this.manualStatus = _data["manualStatus"];
            this.isStrategicFutureRenewal = _data["isStrategicFutureRenewal"];
            this.strategy = _data["strategy"];
            this.eventDateMessage = _data["eventDateMessage"];
            this.purchaseTimeframe = _data["purchaseTimeframe"];
            this.notes = _data["notes"];
            this.customerFacingNotes = _data["customerFacingNotes"];
            this.coveredItems = _data["coveredItems"];
            this.previousPurchaseCost = _data["previousPurchaseCost"];
            this.previousPurchaseCostBeforeQuoteRollup = _data["previousPurchaseCostBeforeQuoteRollup"];
            this.gm = _data["gm"];
            this.previousGm = _data["previousGm"];
            if (Array.isArray(_data["allUniqueIdentifiers"])) {
                this.allUniqueIdentifiers = [] as any;
                for (let item of _data["allUniqueIdentifiers"])
                    this.allUniqueIdentifiers!.push(item);
            }
            if (Array.isArray(_data["assignedTo"])) {
                this.assignedTo = [] as any;
                for (let item of _data["assignedTo"])
                    this.assignedTo!.push(LifecycleManagementAssignedToDto.fromJS(item));
            }
            if (Array.isArray(_data["customerOwner"])) {
                this.customerOwner = [] as any;
                for (let item of _data["customerOwner"])
                    this.customerOwner!.push(item);
            }
            this.manualOverrideEventDate = _data["manualOverrideEventDate"];
            this.ruleBasedEventDate = _data["ruleBasedEventDate"];
            this.crmAccountId = _data["crmAccountId"];
            this.source = _data["source"];
            if (Array.isArray(_data["poNumberList"])) {
                this.poNumberList = [] as any;
                for (let item of _data["poNumberList"])
                    this.poNumberList!.push(item);
            }
            if (Array.isArray(_data["shiPoNumberList"])) {
                this.shiPoNumberList = [] as any;
                for (let item of _data["shiPoNumberList"])
                    this.shiPoNumberList!.push(item);
            }
            if (Array.isArray(_data["prevDeliveryContact"])) {
                this.prevDeliveryContact = [] as any;
                for (let item of _data["prevDeliveryContact"])
                    this.prevDeliveryContact!.push(item);
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(LifecycleManagementProductDto.fromJS(item));
            }
            if (Array.isArray(_data["salesPlayIds"])) {
                this.salesPlayIds = [] as any;
                for (let item of _data["salesPlayIds"])
                    this.salesPlayIds!.push(item);
            }
            this.accountExecutive = _data["accountExecutive"];
        }
    }

    static fromJS(data: any): LifecycleManagementAllEvents {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementAllEvents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axAccountNumber"] = this.axAccountNumber;
        data["customerNameAx"] = this.customerNameAx;
        data["manufacturer"] = this.manufacturer;
        data["eventType"] = this.eventType;
        data["eventDate"] = this.eventDate;
        data["status"] = this.status;
        data["manualStatus"] = this.manualStatus;
        data["isStrategicFutureRenewal"] = this.isStrategicFutureRenewal;
        data["strategy"] = this.strategy;
        data["eventDateMessage"] = this.eventDateMessage;
        data["purchaseTimeframe"] = this.purchaseTimeframe;
        data["notes"] = this.notes;
        data["customerFacingNotes"] = this.customerFacingNotes;
        data["coveredItems"] = this.coveredItems;
        data["previousPurchaseCost"] = this.previousPurchaseCost;
        data["previousPurchaseCostBeforeQuoteRollup"] = this.previousPurchaseCostBeforeQuoteRollup;
        data["gm"] = this.gm;
        data["previousGm"] = this.previousGm;
        if (Array.isArray(this.allUniqueIdentifiers)) {
            data["allUniqueIdentifiers"] = [];
            for (let item of this.allUniqueIdentifiers)
                data["allUniqueIdentifiers"].push(item);
        }
        if (Array.isArray(this.assignedTo)) {
            data["assignedTo"] = [];
            for (let item of this.assignedTo)
                data["assignedTo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerOwner)) {
            data["customerOwner"] = [];
            for (let item of this.customerOwner)
                data["customerOwner"].push(item);
        }
        data["manualOverrideEventDate"] = this.manualOverrideEventDate;
        data["ruleBasedEventDate"] = this.ruleBasedEventDate;
        data["crmAccountId"] = this.crmAccountId;
        data["source"] = this.source;
        if (Array.isArray(this.poNumberList)) {
            data["poNumberList"] = [];
            for (let item of this.poNumberList)
                data["poNumberList"].push(item);
        }
        if (Array.isArray(this.shiPoNumberList)) {
            data["shiPoNumberList"] = [];
            for (let item of this.shiPoNumberList)
                data["shiPoNumberList"].push(item);
        }
        if (Array.isArray(this.prevDeliveryContact)) {
            data["prevDeliveryContact"] = [];
            for (let item of this.prevDeliveryContact)
                data["prevDeliveryContact"].push(item);
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesPlayIds)) {
            data["salesPlayIds"] = [];
            for (let item of this.salesPlayIds)
                data["salesPlayIds"].push(item);
        }
        data["accountExecutive"] = this.accountExecutive;
        return data;
    }
}

export interface ILifecycleManagementAllEvents {
    id: string | undefined;
    axAccountNumber?: string | undefined;
    customerNameAx?: string | undefined;
    manufacturer?: string | undefined;
    eventType?: string | undefined;
    eventDate?: string | undefined;
    status?: string | undefined;
    manualStatus?: string | undefined;
    isStrategicFutureRenewal?: boolean;
    strategy?: string | undefined;
    eventDateMessage?: string | undefined;
    purchaseTimeframe?: string | undefined;
    notes?: string | undefined;
    customerFacingNotes?: string | undefined;
    coveredItems?: number;
    previousPurchaseCost?: number | undefined;
    previousPurchaseCostBeforeQuoteRollup?: number | undefined;
    gm?: number | undefined;
    previousGm?: number | undefined;
    allUniqueIdentifiers?: string[] | undefined;
    assignedTo?: LifecycleManagementAssignedToDto[] | undefined;
    customerOwner?: string[] | undefined;
    manualOverrideEventDate?: string | undefined;
    ruleBasedEventDate?: string | undefined;
    crmAccountId?: string | undefined;
    source?: string | undefined;
    poNumberList?: string[] | undefined;
    shiPoNumberList?: string[] | undefined;
    prevDeliveryContact?: string[] | undefined;
    products?: LifecycleManagementProductDto[] | undefined;
    salesPlayIds?: string[] | undefined;
    accountExecutive?: string | undefined;
}

export class LifecycleManagementAssignedToDto implements ILifecycleManagementAssignedToDto {
    entraId!: string | undefined;
    name?: string | undefined;

    constructor(data?: ILifecycleManagementAssignedToDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entraId = _data["entraId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LifecycleManagementAssignedToDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementAssignedToDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entraId"] = this.entraId;
        data["name"] = this.name;
        return data;
    }
}

export interface ILifecycleManagementAssignedToDto {
    entraId: string | undefined;
    name?: string | undefined;
}

export class LifecycleManagementDrawerOrderItemsDto implements ILifecycleManagementDrawerOrderItemsDto {
    uniqueIdentifier?: string | undefined;
    serialNumber?: string | undefined;
    description?: string | undefined;
    manufacturerPart?: string | undefined;
    startDate?: Date | undefined;
    endDate?: string | undefined;
    licenseQty?: number | undefined;
    previousPurchaseCost?: number | undefined;
    eachCost?: number | undefined;

    constructor(data?: ILifecycleManagementDrawerOrderItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.serialNumber = _data["serialNumber"];
            this.description = _data["description"];
            this.manufacturerPart = _data["manufacturerPart"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"];
            this.licenseQty = _data["licenseQty"];
            this.previousPurchaseCost = _data["previousPurchaseCost"];
            this.eachCost = _data["eachCost"];
        }
    }

    static fromJS(data: any): LifecycleManagementDrawerOrderItemsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementDrawerOrderItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["serialNumber"] = this.serialNumber;
        data["description"] = this.description;
        data["manufacturerPart"] = this.manufacturerPart;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate;
        data["licenseQty"] = this.licenseQty;
        data["previousPurchaseCost"] = this.previousPurchaseCost;
        data["eachCost"] = this.eachCost;
        return data;
    }
}

export interface ILifecycleManagementDrawerOrderItemsDto {
    uniqueIdentifier?: string | undefined;
    serialNumber?: string | undefined;
    description?: string | undefined;
    manufacturerPart?: string | undefined;
    startDate?: Date | undefined;
    endDate?: string | undefined;
    licenseQty?: number | undefined;
    previousPurchaseCost?: number | undefined;
    eachCost?: number | undefined;
}

export class LifecycleManagementDrawerOrdersDto implements ILifecycleManagementDrawerOrdersDto {
    order!: string | undefined;
    orderUrl?: string | undefined;
    poNumber?: string | undefined;
    shiPoNumber?: string | undefined;
    previousPurchaseCost?: number | undefined;
    orderDate?: string | undefined;
    quantity?: number | undefined;
    items?: LifecycleManagementDrawerOrderItemsDto[] | undefined;

    constructor(data?: ILifecycleManagementDrawerOrdersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.orderUrl = _data["orderUrl"];
            this.poNumber = _data["poNumber"];
            this.shiPoNumber = _data["shiPoNumber"];
            this.previousPurchaseCost = _data["previousPurchaseCost"];
            this.orderDate = _data["orderDate"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LifecycleManagementDrawerOrderItemsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LifecycleManagementDrawerOrdersDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementDrawerOrdersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["orderUrl"] = this.orderUrl;
        data["poNumber"] = this.poNumber;
        data["shiPoNumber"] = this.shiPoNumber;
        data["previousPurchaseCost"] = this.previousPurchaseCost;
        data["orderDate"] = this.orderDate;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILifecycleManagementDrawerOrdersDto {
    order: string | undefined;
    orderUrl?: string | undefined;
    poNumber?: string | undefined;
    shiPoNumber?: string | undefined;
    previousPurchaseCost?: number | undefined;
    orderDate?: string | undefined;
    quantity?: number | undefined;
    items?: LifecycleManagementDrawerOrderItemsDto[] | undefined;
}

export class LifecycleManagementEventDateSummary implements ILifecycleManagementEventDateSummary {
    month?: number | undefined;
    year?: number | undefined;
    count?: number;
    eventType?: string | undefined;
    potentialRevenue?: number | undefined;
    manufacturers?: LifecycleManagementManufacturerSummary[] | undefined;

    constructor(data?: ILifecycleManagementEventDateSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.count = _data["count"];
            this.eventType = _data["eventType"];
            this.potentialRevenue = _data["potentialRevenue"];
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(LifecycleManagementManufacturerSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LifecycleManagementEventDateSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementEventDateSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["count"] = this.count;
        data["eventType"] = this.eventType;
        data["potentialRevenue"] = this.potentialRevenue;
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILifecycleManagementEventDateSummary {
    month?: number | undefined;
    year?: number | undefined;
    count?: number;
    eventType?: string | undefined;
    potentialRevenue?: number | undefined;
    manufacturers?: LifecycleManagementManufacturerSummary[] | undefined;
}

export class LifecycleManagementEventTypeSummary implements ILifecycleManagementEventTypeSummary {
    eventType?: string | undefined;
    count?: number;
    potentialRevenue?: number | undefined;

    constructor(data?: ILifecycleManagementEventTypeSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.count = _data["count"];
            this.potentialRevenue = _data["potentialRevenue"];
        }
    }

    static fromJS(data: any): LifecycleManagementEventTypeSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementEventTypeSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["count"] = this.count;
        data["potentialRevenue"] = this.potentialRevenue;
        return data;
    }
}

export interface ILifecycleManagementEventTypeSummary {
    eventType?: string | undefined;
    count?: number;
    potentialRevenue?: number | undefined;
}

export class LifecycleManagementManufacturerSummary implements ILifecycleManagementManufacturerSummary {
    manufacturer?: string | undefined;
    count?: number;
    potentialRevenue?: number | undefined;
    eventTypes?: LifecycleManagementEventTypeSummary[] | undefined;

    constructor(data?: ILifecycleManagementManufacturerSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.count = _data["count"];
            this.potentialRevenue = _data["potentialRevenue"];
            if (Array.isArray(_data["eventTypes"])) {
                this.eventTypes = [] as any;
                for (let item of _data["eventTypes"])
                    this.eventTypes!.push(LifecycleManagementEventTypeSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LifecycleManagementManufacturerSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementManufacturerSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["count"] = this.count;
        data["potentialRevenue"] = this.potentialRevenue;
        if (Array.isArray(this.eventTypes)) {
            data["eventTypes"] = [];
            for (let item of this.eventTypes)
                data["eventTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILifecycleManagementManufacturerSummary {
    manufacturer?: string | undefined;
    count?: number;
    potentialRevenue?: number | undefined;
    eventTypes?: LifecycleManagementEventTypeSummary[] | undefined;
}

export class LifecycleManagementNumberRangeBounds implements ILifecycleManagementNumberRangeBounds {
    min?: number;
    max?: number;

    constructor(data?: ILifecycleManagementNumberRangeBounds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): LifecycleManagementNumberRangeBounds {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementNumberRangeBounds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        return data;
    }
}

export interface ILifecycleManagementNumberRangeBounds {
    min?: number;
    max?: number;
}

export class LifecycleManagementProductDto implements ILifecycleManagementProductDto {
    manufacturer?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    solutionArea?: string | undefined;
    salesMotion?: string | undefined;
    visiblePreviousPurchaseCost?: number | undefined;

    constructor(data?: ILifecycleManagementProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.solutionArea = _data["solutionArea"];
            this.salesMotion = _data["salesMotion"];
            this.visiblePreviousPurchaseCost = _data["visiblePreviousPurchaseCost"];
        }
    }

    static fromJS(data: any): LifecycleManagementProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["solutionArea"] = this.solutionArea;
        data["salesMotion"] = this.salesMotion;
        data["visiblePreviousPurchaseCost"] = this.visiblePreviousPurchaseCost;
        return data;
    }
}

export interface ILifecycleManagementProductDto {
    manufacturer?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    solutionArea?: string | undefined;
    salesMotion?: string | undefined;
    visiblePreviousPurchaseCost?: number | undefined;
}

export class LifecyclePicklistCategoryGroup implements ILifecyclePicklistCategoryGroup {
    category?: string | undefined;
    subCategories?: string[] | undefined;

    constructor(data?: ILifecyclePicklistCategoryGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["subCategories"])
                    this.subCategories!.push(item);
            }
        }
    }

    static fromJS(data: any): LifecyclePicklistCategoryGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LifecyclePicklistCategoryGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item);
        }
        return data;
    }
}

export interface ILifecyclePicklistCategoryGroup {
    category?: string | undefined;
    subCategories?: string[] | undefined;
}

export class LifecyclePicklistRegionGroup implements ILifecyclePicklistRegionGroup {
    region?: string | undefined;
    districts?: string[] | undefined;

    constructor(data?: ILifecyclePicklistRegionGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts!.push(item);
            }
        }
    }

    static fromJS(data: any): LifecyclePicklistRegionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LifecyclePicklistRegionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item);
        }
        return data;
    }
}

export interface ILifecyclePicklistRegionGroup {
    region?: string | undefined;
    districts?: string[] | undefined;
}

export class LifecyclePicklistSegmentGroup implements ILifecyclePicklistSegmentGroup {
    segment?: string | undefined;
    divisions?: LifecycleDivisionGroup[] | undefined;

    constructor(data?: ILifecyclePicklistSegmentGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.segment = _data["segment"];
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(LifecycleDivisionGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LifecyclePicklistSegmentGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LifecyclePicklistSegmentGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["segment"] = this.segment;
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILifecyclePicklistSegmentGroup {
    segment?: string | undefined;
    divisions?: LifecycleDivisionGroup[] | undefined;
}

export class LifecyclePicklistSolutionAreaGroup implements ILifecyclePicklistSolutionAreaGroup {
    solutionArea?: string | undefined;
    categories?: LifecyclePicklistCategoryGroup[] | undefined;

    constructor(data?: ILifecyclePicklistSolutionAreaGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solutionArea = _data["solutionArea"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(LifecyclePicklistCategoryGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LifecyclePicklistSolutionAreaGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LifecyclePicklistSolutionAreaGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solutionArea"] = this.solutionArea;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILifecyclePicklistSolutionAreaGroup {
    solutionArea?: string | undefined;
    categories?: LifecyclePicklistCategoryGroup[] | undefined;
}

export class PossibleDuplicateLifecycleEvent implements IPossibleDuplicateLifecycleEvent {
    id?: string | undefined;
    manufacturer?: string | undefined;
    eventType?: string | undefined;
    compellingEventDate?: Date;
    source?: string | undefined;
    status?: string | undefined;
    previousPurchaseCost?: number | undefined;

    constructor(data?: IPossibleDuplicateLifecycleEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.eventType = _data["eventType"];
            this.compellingEventDate = _data["compellingEventDate"] ? new Date(_data["compellingEventDate"].toString()) : undefined as any;
            this.source = _data["source"];
            this.status = _data["status"];
            this.previousPurchaseCost = _data["previousPurchaseCost"];
        }
    }

    static fromJS(data: any): PossibleDuplicateLifecycleEvent {
        data = typeof data === 'object' ? data : {};
        let result = new PossibleDuplicateLifecycleEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["eventType"] = this.eventType;
        data["compellingEventDate"] = this.compellingEventDate ? this.compellingEventDate.toISOString() : undefined as any;
        data["source"] = this.source;
        data["status"] = this.status;
        data["previousPurchaseCost"] = this.previousPurchaseCost;
        return data;
    }
}

export interface IPossibleDuplicateLifecycleEvent {
    id?: string | undefined;
    manufacturer?: string | undefined;
    eventType?: string | undefined;
    compellingEventDate?: Date;
    source?: string | undefined;
    status?: string | undefined;
    previousPurchaseCost?: number | undefined;
}

export class UpcomingRenewalsResponseItem implements IUpcomingRenewalsResponseItem {
    identifier?: string | undefined;
    manufacturer?: string | undefined;
    assetQuantity?: number;
    compellingEventDate?: Date;
    itemType?: string | undefined;
    previousPurchaseCost?: number | undefined;
    compellingEventDateDesc?: string | undefined;
    logoUrl?: string | undefined;

    constructor(data?: IUpcomingRenewalsResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.manufacturer = _data["manufacturer"];
            this.assetQuantity = _data["assetQuantity"];
            this.compellingEventDate = _data["compellingEventDate"] ? new Date(_data["compellingEventDate"].toString()) : undefined as any;
            this.itemType = _data["itemType"];
            this.previousPurchaseCost = _data["previousPurchaseCost"];
            this.compellingEventDateDesc = _data["compellingEventDateDesc"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): UpcomingRenewalsResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingRenewalsResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["manufacturer"] = this.manufacturer;
        data["assetQuantity"] = this.assetQuantity;
        data["compellingEventDate"] = this.compellingEventDate ? this.compellingEventDate.toISOString() : undefined as any;
        data["itemType"] = this.itemType;
        data["previousPurchaseCost"] = this.previousPurchaseCost;
        data["compellingEventDateDesc"] = this.compellingEventDateDesc;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export interface IUpcomingRenewalsResponseItem {
    identifier?: string | undefined;
    manufacturer?: string | undefined;
    assetQuantity?: number;
    compellingEventDate?: Date;
    itemType?: string | undefined;
    previousPurchaseCost?: number | undefined;
    compellingEventDateDesc?: string | undefined;
    logoUrl?: string | undefined;
}

export class CategoryComparison implements ICategoryComparison {
    category?: string | undefined;
    currentTotal?: number;
    previousTotal?: number;
    percentChange?: number;
    percentOfOverallCurrent?: number;

    constructor(data?: ICategoryComparison) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.currentTotal = _data["currentTotal"];
            this.previousTotal = _data["previousTotal"];
            this.percentChange = _data["percentChange"];
            this.percentOfOverallCurrent = _data["percentOfOverallCurrent"];
        }
    }

    static fromJS(data: any): CategoryComparison {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryComparison();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["currentTotal"] = this.currentTotal;
        data["previousTotal"] = this.previousTotal;
        data["percentChange"] = this.percentChange;
        data["percentOfOverallCurrent"] = this.percentOfOverallCurrent;
        return data;
    }
}

export interface ICategoryComparison {
    category?: string | undefined;
    currentTotal?: number;
    previousTotal?: number;
    percentChange?: number;
    percentOfOverallCurrent?: number;
}

export class CategoryFilter implements ICategoryFilter {
    categoryName!: string | undefined;
    categoryCount!: number;
    subCategoryFilters!: SubCategoryFilter[] | undefined;

    constructor(data?: ICategoryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
            this.categoryCount = _data["categoryCount"];
            if (Array.isArray(_data["subCategoryFilters"])) {
                this.subCategoryFilters = [] as any;
                for (let item of _data["subCategoryFilters"])
                    this.subCategoryFilters!.push(SubCategoryFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["categoryCount"] = this.categoryCount;
        if (Array.isArray(this.subCategoryFilters)) {
            data["subCategoryFilters"] = [];
            for (let item of this.subCategoryFilters)
                data["subCategoryFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategoryFilter {
    categoryName: string | undefined;
    categoryCount: number;
    subCategoryFilters: SubCategoryFilter[] | undefined;
}

export class CategorySpend implements ICategorySpend {
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    manufacturerName?: string | undefined;
    solutionArea?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    totalSpend?: number | undefined;
    totalQuantity?: number | undefined;

    constructor(data?: ICategorySpend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiPartNumber = _data["shiPartNumber"];
            this.description = _data["description"];
            this.assetType = _data["assetType"];
            this.manufacturerName = _data["manufacturerName"];
            this.solutionArea = _data["solutionArea"];
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.totalSpend = _data["totalSpend"];
            this.totalQuantity = _data["totalQuantity"];
        }
    }

    static fromJS(data: any): CategorySpend {
        data = typeof data === 'object' ? data : {};
        let result = new CategorySpend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiPartNumber"] = this.shiPartNumber;
        data["description"] = this.description;
        data["assetType"] = this.assetType;
        data["manufacturerName"] = this.manufacturerName;
        data["solutionArea"] = this.solutionArea;
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["totalSpend"] = this.totalSpend;
        data["totalQuantity"] = this.totalQuantity;
        return data;
    }
}

export interface ICategorySpend {
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    manufacturerName?: string | undefined;
    solutionArea?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    totalSpend?: number | undefined;
    totalQuantity?: number | undefined;
}

export class GetPurchasedAssetDrawerAssetsResponse implements IGetPurchasedAssetDrawerAssetsResponse {
    rows?: PurchasedAssetDrawerRow[] | undefined;

    constructor(data?: IGetPurchasedAssetDrawerAssetsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PurchasedAssetDrawerRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPurchasedAssetDrawerAssetsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchasedAssetDrawerAssetsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPurchasedAssetDrawerAssetsResponse {
    rows?: PurchasedAssetDrawerRow[] | undefined;
}

export class HistogramBucket implements IHistogramBucket {
    key?: Date;
    value?: number;

    constructor(data?: IHistogramBucket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? new Date(_data["key"].toString()) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HistogramBucket {
        data = typeof data === 'object' ? data : {};
        let result = new HistogramBucket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toISOString() : undefined as any;
        data["value"] = this.value;
        return data;
    }
}

export interface IHistogramBucket {
    key?: Date;
    value?: number;
}

export class ManufacturerFilter implements IManufacturerFilter {
    manufacturerName!: string | undefined;
    totalQuantity!: number;

    constructor(data?: IManufacturerFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerName = _data["manufacturerName"];
            this.totalQuantity = _data["totalQuantity"];
        }
    }

    static fromJS(data: any): ManufacturerFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerName"] = this.manufacturerName;
        data["totalQuantity"] = this.totalQuantity;
        return data;
    }
}

export interface IManufacturerFilter {
    manufacturerName: string | undefined;
    totalQuantity: number;
}

export class ManufacturerSpend implements IManufacturerSpend {
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    manufacturerName?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    totalSpend?: number | undefined;
    totalQuantity?: number | undefined;

    constructor(data?: IManufacturerSpend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiPartNumber = _data["shiPartNumber"];
            this.description = _data["description"];
            this.assetType = _data["assetType"];
            this.manufacturerName = _data["manufacturerName"];
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.totalSpend = _data["totalSpend"];
            this.totalQuantity = _data["totalQuantity"];
        }
    }

    static fromJS(data: any): ManufacturerSpend {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerSpend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiPartNumber"] = this.shiPartNumber;
        data["description"] = this.description;
        data["assetType"] = this.assetType;
        data["manufacturerName"] = this.manufacturerName;
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["totalSpend"] = this.totalSpend;
        data["totalQuantity"] = this.totalQuantity;
        return data;
    }
}

export interface IManufacturerSpend {
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    manufacturerName?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    totalSpend?: number | undefined;
    totalQuantity?: number | undefined;
}

export class MetricComparison implements IMetricComparison {
    metricName!: string | undefined;
    currentTotal?: number;
    previousTotal?: number;
    percentChange?: number;

    constructor(data?: IMetricComparison) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metricName = _data["metricName"];
            this.currentTotal = _data["currentTotal"];
            this.previousTotal = _data["previousTotal"];
            this.percentChange = _data["percentChange"];
        }
    }

    static fromJS(data: any): MetricComparison {
        data = typeof data === 'object' ? data : {};
        let result = new MetricComparison();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metricName"] = this.metricName;
        data["currentTotal"] = this.currentTotal;
        data["previousTotal"] = this.previousTotal;
        data["percentChange"] = this.percentChange;
        return data;
    }
}

export interface IMetricComparison {
    metricName: string | undefined;
    currentTotal?: number;
    previousTotal?: number;
    percentChange?: number;
}

export class OrderSpend implements IOrderSpend {
    orderNumber?: string | undefined;
    poNumber?: string | undefined;
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    manufacturerName?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    orderDate?: Date | undefined;
    compellingEventDate?: Date | undefined;
    serialNumber?: string | undefined;
    totalSpend?: number;
    totalQuantity?: number;

    constructor(data?: IOrderSpend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"];
            this.poNumber = _data["poNumber"];
            this.shiPartNumber = _data["shiPartNumber"];
            this.description = _data["description"];
            this.assetType = _data["assetType"];
            this.manufacturerName = _data["manufacturerName"];
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : undefined as any;
            this.compellingEventDate = _data["compellingEventDate"] ? new Date(_data["compellingEventDate"].toString()) : undefined as any;
            this.serialNumber = _data["serialNumber"];
            this.totalSpend = _data["totalSpend"];
            this.totalQuantity = _data["totalQuantity"];
        }
    }

    static fromJS(data: any): OrderSpend {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSpend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["poNumber"] = this.poNumber;
        data["shiPartNumber"] = this.shiPartNumber;
        data["description"] = this.description;
        data["assetType"] = this.assetType;
        data["manufacturerName"] = this.manufacturerName;
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined as any;
        data["compellingEventDate"] = this.compellingEventDate ? this.compellingEventDate.toISOString() : undefined as any;
        data["serialNumber"] = this.serialNumber;
        data["totalSpend"] = this.totalSpend;
        data["totalQuantity"] = this.totalQuantity;
        return data;
    }
}

export interface IOrderSpend {
    orderNumber?: string | undefined;
    poNumber?: string | undefined;
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    manufacturerName?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    orderDate?: Date | undefined;
    compellingEventDate?: Date | undefined;
    serialNumber?: string | undefined;
    totalSpend?: number;
    totalQuantity?: number;
}

export class PurchasedAssetAggregationRequest implements IPurchasedAssetAggregationRequest {
    orderDateFrom?: Date | undefined;
    orderDateTo?: Date | undefined;
    assetType?: string[] | undefined;
    sortCriteria?: ElasticSortCriteria;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: PurchasedAssetSearchFilter;
    searchFilterExclude?: PurchasedAssetSearchFilter;

    constructor(data?: IPurchasedAssetAggregationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderDateFrom = _data["orderDateFrom"] ? new Date(_data["orderDateFrom"].toString()) : undefined as any;
            this.orderDateTo = _data["orderDateTo"] ? new Date(_data["orderDateTo"].toString()) : undefined as any;
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : undefined as any;
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? PurchasedAssetSearchFilter.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? PurchasedAssetSearchFilter.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): PurchasedAssetAggregationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetAggregationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDateFrom"] = this.orderDateFrom ? this.orderDateFrom.toISOString() : undefined as any;
        data["orderDateTo"] = this.orderDateTo ? this.orderDateTo.toISOString() : undefined as any;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : undefined as any;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IPurchasedAssetAggregationRequest {
    orderDateFrom?: Date | undefined;
    orderDateTo?: Date | undefined;
    assetType?: string[] | undefined;
    sortCriteria?: ElasticSortCriteria;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: PurchasedAssetSearchFilter;
    searchFilterExclude?: PurchasedAssetSearchFilter;
}

export class PurchasedAssetDrawerRow implements IPurchasedAssetDrawerRow {
    productId?: string | undefined;
    contractNumber?: string | undefined;
    serialNumber?: string | undefined;
    orderDate?: Date | undefined;
    orderNumber?: string | undefined;
    poNumber?: string | undefined;
    quantity?: number;
    compellingEventDate?: Date | undefined;
    compellingEventDateDesc?: string | undefined;
    eventType?: string | undefined;

    constructor(data?: IPurchasedAssetDrawerRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.contractNumber = _data["contractNumber"];
            this.serialNumber = _data["serialNumber"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : undefined as any;
            this.orderNumber = _data["orderNumber"];
            this.poNumber = _data["poNumber"];
            this.quantity = _data["quantity"];
            this.compellingEventDate = _data["compellingEventDate"] ? new Date(_data["compellingEventDate"].toString()) : undefined as any;
            this.compellingEventDateDesc = _data["compellingEventDateDesc"];
            this.eventType = _data["eventType"];
        }
    }

    static fromJS(data: any): PurchasedAssetDrawerRow {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetDrawerRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["contractNumber"] = this.contractNumber;
        data["serialNumber"] = this.serialNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined as any;
        data["orderNumber"] = this.orderNumber;
        data["poNumber"] = this.poNumber;
        data["quantity"] = this.quantity;
        data["compellingEventDate"] = this.compellingEventDate ? this.compellingEventDate.toISOString() : undefined as any;
        data["compellingEventDateDesc"] = this.compellingEventDateDesc;
        data["eventType"] = this.eventType;
        return data;
    }
}

export interface IPurchasedAssetDrawerRow {
    productId?: string | undefined;
    contractNumber?: string | undefined;
    serialNumber?: string | undefined;
    orderDate?: Date | undefined;
    orderNumber?: string | undefined;
    poNumber?: string | undefined;
    quantity?: number;
    compellingEventDate?: Date | undefined;
    compellingEventDateDesc?: string | undefined;
    eventType?: string | undefined;
}

export class PurchasedAssetSearchFilter implements IPurchasedAssetSearchFilter {
    uniqueIdentifier?: string[] | undefined;
    axAccountNumber?: string[] | undefined;
    customerNameAx?: string[] | undefined;
    agreementNumber?: string[] | undefined;
    assetType?: string[] | undefined;
    category?: string[] | undefined;
    currency?: string[] | undefined;
    compellingEventDate?: ElasticDateTimeOffsetRangeQueryFilter;
    description?: string[] | undefined;
    invoiceNumber?: string[] | undefined;
    invoiceYearMonth?: string[] | undefined;
    lineAmount?: string[] | undefined;
    invoiceDate?: ElasticDateTimeOffsetRangeQueryFilter;
    orderDate?: ElasticDateTimeOffsetRangeQueryFilter;
    maintenanceStartDate?: ElasticDateTimeOffsetRangeQueryFilter;
    maintenanceEndDate?: ElasticDateTimeOffsetRangeQueryFilter;
    maintenanceTerm?: string[] | undefined;
    manufacturerName?: string[] | undefined;
    biManufacturerId?: number[] | undefined;
    productType?: string[] | undefined;
    quantity?: string[] | undefined;
    solutionArea?: string[] | undefined;
    shiPartNumber?: string[] | undefined;
    subCategory?: string[] | undefined;
    subscriptionTerm?: string[] | undefined;
    unitPrice?: string[] | undefined;
    isRenewable?: string[] | undefined;
    indexedAt?: string[] | undefined;
    orderNumber?: string[] | undefined;
    poNumber?: string[] | undefined;

    constructor(data?: IPurchasedAssetSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniqueIdentifier"])) {
                this.uniqueIdentifier = [] as any;
                for (let item of _data["uniqueIdentifier"])
                    this.uniqueIdentifier!.push(item);
            }
            if (Array.isArray(_data["axAccountNumber"])) {
                this.axAccountNumber = [] as any;
                for (let item of _data["axAccountNumber"])
                    this.axAccountNumber!.push(item);
            }
            if (Array.isArray(_data["customerNameAx"])) {
                this.customerNameAx = [] as any;
                for (let item of _data["customerNameAx"])
                    this.customerNameAx!.push(item);
            }
            if (Array.isArray(_data["agreementNumber"])) {
                this.agreementNumber = [] as any;
                for (let item of _data["agreementNumber"])
                    this.agreementNumber!.push(item);
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            if (Array.isArray(_data["currency"])) {
                this.currency = [] as any;
                for (let item of _data["currency"])
                    this.currency!.push(item);
            }
            this.compellingEventDate = _data["compellingEventDate"] ? ElasticDateTimeOffsetRangeQueryFilter.fromJS(_data["compellingEventDate"]) : undefined as any;
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(item);
            }
            if (Array.isArray(_data["invoiceNumber"])) {
                this.invoiceNumber = [] as any;
                for (let item of _data["invoiceNumber"])
                    this.invoiceNumber!.push(item);
            }
            if (Array.isArray(_data["invoiceYearMonth"])) {
                this.invoiceYearMonth = [] as any;
                for (let item of _data["invoiceYearMonth"])
                    this.invoiceYearMonth!.push(item);
            }
            if (Array.isArray(_data["lineAmount"])) {
                this.lineAmount = [] as any;
                for (let item of _data["lineAmount"])
                    this.lineAmount!.push(item);
            }
            this.invoiceDate = _data["invoiceDate"] ? ElasticDateTimeOffsetRangeQueryFilter.fromJS(_data["invoiceDate"]) : undefined as any;
            this.orderDate = _data["orderDate"] ? ElasticDateTimeOffsetRangeQueryFilter.fromJS(_data["orderDate"]) : undefined as any;
            this.maintenanceStartDate = _data["maintenanceStartDate"] ? ElasticDateTimeOffsetRangeQueryFilter.fromJS(_data["maintenanceStartDate"]) : undefined as any;
            this.maintenanceEndDate = _data["maintenanceEndDate"] ? ElasticDateTimeOffsetRangeQueryFilter.fromJS(_data["maintenanceEndDate"]) : undefined as any;
            if (Array.isArray(_data["maintenanceTerm"])) {
                this.maintenanceTerm = [] as any;
                for (let item of _data["maintenanceTerm"])
                    this.maintenanceTerm!.push(item);
            }
            if (Array.isArray(_data["manufacturerName"])) {
                this.manufacturerName = [] as any;
                for (let item of _data["manufacturerName"])
                    this.manufacturerName!.push(item);
            }
            if (Array.isArray(_data["biManufacturerId"])) {
                this.biManufacturerId = [] as any;
                for (let item of _data["biManufacturerId"])
                    this.biManufacturerId!.push(item);
            }
            if (Array.isArray(_data["productType"])) {
                this.productType = [] as any;
                for (let item of _data["productType"])
                    this.productType!.push(item);
            }
            if (Array.isArray(_data["quantity"])) {
                this.quantity = [] as any;
                for (let item of _data["quantity"])
                    this.quantity!.push(item);
            }
            if (Array.isArray(_data["solutionArea"])) {
                this.solutionArea = [] as any;
                for (let item of _data["solutionArea"])
                    this.solutionArea!.push(item);
            }
            if (Array.isArray(_data["shiPartNumber"])) {
                this.shiPartNumber = [] as any;
                for (let item of _data["shiPartNumber"])
                    this.shiPartNumber!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["subscriptionTerm"])) {
                this.subscriptionTerm = [] as any;
                for (let item of _data["subscriptionTerm"])
                    this.subscriptionTerm!.push(item);
            }
            if (Array.isArray(_data["unitPrice"])) {
                this.unitPrice = [] as any;
                for (let item of _data["unitPrice"])
                    this.unitPrice!.push(item);
            }
            if (Array.isArray(_data["isRenewable"])) {
                this.isRenewable = [] as any;
                for (let item of _data["isRenewable"])
                    this.isRenewable!.push(item);
            }
            if (Array.isArray(_data["indexedAt"])) {
                this.indexedAt = [] as any;
                for (let item of _data["indexedAt"])
                    this.indexedAt!.push(item);
            }
            if (Array.isArray(_data["orderNumber"])) {
                this.orderNumber = [] as any;
                for (let item of _data["orderNumber"])
                    this.orderNumber!.push(item);
            }
            if (Array.isArray(_data["poNumber"])) {
                this.poNumber = [] as any;
                for (let item of _data["poNumber"])
                    this.poNumber!.push(item);
            }
        }
    }

    static fromJS(data: any): PurchasedAssetSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniqueIdentifier)) {
            data["uniqueIdentifier"] = [];
            for (let item of this.uniqueIdentifier)
                data["uniqueIdentifier"].push(item);
        }
        if (Array.isArray(this.axAccountNumber)) {
            data["axAccountNumber"] = [];
            for (let item of this.axAccountNumber)
                data["axAccountNumber"].push(item);
        }
        if (Array.isArray(this.customerNameAx)) {
            data["customerNameAx"] = [];
            for (let item of this.customerNameAx)
                data["customerNameAx"].push(item);
        }
        if (Array.isArray(this.agreementNumber)) {
            data["agreementNumber"] = [];
            for (let item of this.agreementNumber)
                data["agreementNumber"].push(item);
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        if (Array.isArray(this.currency)) {
            data["currency"] = [];
            for (let item of this.currency)
                data["currency"].push(item);
        }
        data["compellingEventDate"] = this.compellingEventDate ? this.compellingEventDate.toJSON() : undefined as any;
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item);
        }
        if (Array.isArray(this.invoiceNumber)) {
            data["invoiceNumber"] = [];
            for (let item of this.invoiceNumber)
                data["invoiceNumber"].push(item);
        }
        if (Array.isArray(this.invoiceYearMonth)) {
            data["invoiceYearMonth"] = [];
            for (let item of this.invoiceYearMonth)
                data["invoiceYearMonth"].push(item);
        }
        if (Array.isArray(this.lineAmount)) {
            data["lineAmount"] = [];
            for (let item of this.lineAmount)
                data["lineAmount"].push(item);
        }
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toJSON() : undefined as any;
        data["orderDate"] = this.orderDate ? this.orderDate.toJSON() : undefined as any;
        data["maintenanceStartDate"] = this.maintenanceStartDate ? this.maintenanceStartDate.toJSON() : undefined as any;
        data["maintenanceEndDate"] = this.maintenanceEndDate ? this.maintenanceEndDate.toJSON() : undefined as any;
        if (Array.isArray(this.maintenanceTerm)) {
            data["maintenanceTerm"] = [];
            for (let item of this.maintenanceTerm)
                data["maintenanceTerm"].push(item);
        }
        if (Array.isArray(this.manufacturerName)) {
            data["manufacturerName"] = [];
            for (let item of this.manufacturerName)
                data["manufacturerName"].push(item);
        }
        if (Array.isArray(this.biManufacturerId)) {
            data["biManufacturerId"] = [];
            for (let item of this.biManufacturerId)
                data["biManufacturerId"].push(item);
        }
        if (Array.isArray(this.productType)) {
            data["productType"] = [];
            for (let item of this.productType)
                data["productType"].push(item);
        }
        if (Array.isArray(this.quantity)) {
            data["quantity"] = [];
            for (let item of this.quantity)
                data["quantity"].push(item);
        }
        if (Array.isArray(this.solutionArea)) {
            data["solutionArea"] = [];
            for (let item of this.solutionArea)
                data["solutionArea"].push(item);
        }
        if (Array.isArray(this.shiPartNumber)) {
            data["shiPartNumber"] = [];
            for (let item of this.shiPartNumber)
                data["shiPartNumber"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.subscriptionTerm)) {
            data["subscriptionTerm"] = [];
            for (let item of this.subscriptionTerm)
                data["subscriptionTerm"].push(item);
        }
        if (Array.isArray(this.unitPrice)) {
            data["unitPrice"] = [];
            for (let item of this.unitPrice)
                data["unitPrice"].push(item);
        }
        if (Array.isArray(this.isRenewable)) {
            data["isRenewable"] = [];
            for (let item of this.isRenewable)
                data["isRenewable"].push(item);
        }
        if (Array.isArray(this.indexedAt)) {
            data["indexedAt"] = [];
            for (let item of this.indexedAt)
                data["indexedAt"].push(item);
        }
        if (Array.isArray(this.orderNumber)) {
            data["orderNumber"] = [];
            for (let item of this.orderNumber)
                data["orderNumber"].push(item);
        }
        if (Array.isArray(this.poNumber)) {
            data["poNumber"] = [];
            for (let item of this.poNumber)
                data["poNumber"].push(item);
        }
        return data;
    }
}

export interface IPurchasedAssetSearchFilter {
    uniqueIdentifier?: string[] | undefined;
    axAccountNumber?: string[] | undefined;
    customerNameAx?: string[] | undefined;
    agreementNumber?: string[] | undefined;
    assetType?: string[] | undefined;
    category?: string[] | undefined;
    currency?: string[] | undefined;
    compellingEventDate?: ElasticDateTimeOffsetRangeQueryFilter;
    description?: string[] | undefined;
    invoiceNumber?: string[] | undefined;
    invoiceYearMonth?: string[] | undefined;
    lineAmount?: string[] | undefined;
    invoiceDate?: ElasticDateTimeOffsetRangeQueryFilter;
    orderDate?: ElasticDateTimeOffsetRangeQueryFilter;
    maintenanceStartDate?: ElasticDateTimeOffsetRangeQueryFilter;
    maintenanceEndDate?: ElasticDateTimeOffsetRangeQueryFilter;
    maintenanceTerm?: string[] | undefined;
    manufacturerName?: string[] | undefined;
    biManufacturerId?: number[] | undefined;
    productType?: string[] | undefined;
    quantity?: string[] | undefined;
    solutionArea?: string[] | undefined;
    shiPartNumber?: string[] | undefined;
    subCategory?: string[] | undefined;
    subscriptionTerm?: string[] | undefined;
    unitPrice?: string[] | undefined;
    isRenewable?: string[] | undefined;
    indexedAt?: string[] | undefined;
    orderNumber?: string[] | undefined;
    poNumber?: string[] | undefined;
}

export class PurchasedAssetSearchQuery implements IPurchasedAssetSearchQuery {
    limit?: number | undefined;
    offset?: number | undefined;
    sortCriteria?: ElasticSortCriteria;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: PurchasedAssetSearchFilter;
    searchFilterExclude?: PurchasedAssetSearchFilter;

    constructor(data?: IPurchasedAssetSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : undefined as any;
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? PurchasedAssetSearchFilter.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? PurchasedAssetSearchFilter.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): PurchasedAssetSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : undefined as any;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IPurchasedAssetSearchQuery {
    limit?: number | undefined;
    offset?: number | undefined;
    sortCriteria?: ElasticSortCriteria;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: PurchasedAssetSearchFilter;
    searchFilterExclude?: PurchasedAssetSearchFilter;
}

export class PurchasedAssetSpendByCategoryFiltersResponse implements IPurchasedAssetSpendByCategoryFiltersResponse {
    solutionAreaFilters?: SolutionAreaFilter[] | undefined;

    constructor(data?: IPurchasedAssetSpendByCategoryFiltersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["solutionAreaFilters"])) {
                this.solutionAreaFilters = [] as any;
                for (let item of _data["solutionAreaFilters"])
                    this.solutionAreaFilters!.push(SolutionAreaFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchasedAssetSpendByCategoryFiltersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetSpendByCategoryFiltersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.solutionAreaFilters)) {
            data["solutionAreaFilters"] = [];
            for (let item of this.solutionAreaFilters)
                data["solutionAreaFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPurchasedAssetSpendByCategoryFiltersResponse {
    solutionAreaFilters?: SolutionAreaFilter[] | undefined;
}

export class PurchasedAssetSpendByCategoryRequest implements IPurchasedAssetSpendByCategoryRequest {
    categoryFilterSearchFor?: string | undefined;
    searchQuery?: PurchasedAssetSearchQuery;
    pagination?: ElasticSearchCompositeAggregationPagination;
    sortCriteria?: ElasticSortCriteria;

    constructor(data?: IPurchasedAssetSpendByCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryFilterSearchFor = _data["categoryFilterSearchFor"];
            this.searchQuery = _data["searchQuery"] ? PurchasedAssetSearchQuery.fromJS(_data["searchQuery"]) : undefined as any;
            this.pagination = _data["pagination"] ? ElasticSearchCompositeAggregationPagination.fromJS(_data["pagination"]) : undefined as any;
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): PurchasedAssetSpendByCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetSpendByCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryFilterSearchFor"] = this.categoryFilterSearchFor;
        data["searchQuery"] = this.searchQuery ? this.searchQuery.toJSON() : undefined as any;
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : undefined as any;
        return data;
    }
}

export interface IPurchasedAssetSpendByCategoryRequest {
    categoryFilterSearchFor?: string | undefined;
    searchQuery?: PurchasedAssetSearchQuery;
    pagination?: ElasticSearchCompositeAggregationPagination;
    sortCriteria?: ElasticSortCriteria;
}

export class PurchasedAssetSpendByCategoryResponse implements IPurchasedAssetSpendByCategoryResponse {
    categorySpends?: CategorySpend[] | undefined;
    pagination?: ElasticSearchCompositeAggregationPagination;

    constructor(data?: IPurchasedAssetSpendByCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categorySpends"])) {
                this.categorySpends = [] as any;
                for (let item of _data["categorySpends"])
                    this.categorySpends!.push(CategorySpend.fromJS(item));
            }
            this.pagination = _data["pagination"] ? ElasticSearchCompositeAggregationPagination.fromJS(_data["pagination"]) : undefined as any;
        }
    }

    static fromJS(data: any): PurchasedAssetSpendByCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetSpendByCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categorySpends)) {
            data["categorySpends"] = [];
            for (let item of this.categorySpends)
                data["categorySpends"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        return data;
    }
}

export interface IPurchasedAssetSpendByCategoryResponse {
    categorySpends?: CategorySpend[] | undefined;
    pagination?: ElasticSearchCompositeAggregationPagination;
}

export class PurchasedAssetSpendByManufacturerFiltersResponse implements IPurchasedAssetSpendByManufacturerFiltersResponse {
    manufacturerFilters?: ManufacturerFilter[] | undefined;

    constructor(data?: IPurchasedAssetSpendByManufacturerFiltersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturerFilters"])) {
                this.manufacturerFilters = [] as any;
                for (let item of _data["manufacturerFilters"])
                    this.manufacturerFilters!.push(ManufacturerFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchasedAssetSpendByManufacturerFiltersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetSpendByManufacturerFiltersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturerFilters)) {
            data["manufacturerFilters"] = [];
            for (let item of this.manufacturerFilters)
                data["manufacturerFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPurchasedAssetSpendByManufacturerFiltersResponse {
    manufacturerFilters?: ManufacturerFilter[] | undefined;
}

export class PurchasedAssetSpendByManufacturerResponse implements IPurchasedAssetSpendByManufacturerResponse {
    manufacturerFilters?: ManufacturerFilter[] | undefined;
    manufacturerSpends?: ManufacturerSpend[] | undefined;
    pagination?: ElasticSearchCompositeAggregationPagination;

    constructor(data?: IPurchasedAssetSpendByManufacturerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturerFilters"])) {
                this.manufacturerFilters = [] as any;
                for (let item of _data["manufacturerFilters"])
                    this.manufacturerFilters!.push(ManufacturerFilter.fromJS(item));
            }
            if (Array.isArray(_data["manufacturerSpends"])) {
                this.manufacturerSpends = [] as any;
                for (let item of _data["manufacturerSpends"])
                    this.manufacturerSpends!.push(ManufacturerSpend.fromJS(item));
            }
            this.pagination = _data["pagination"] ? ElasticSearchCompositeAggregationPagination.fromJS(_data["pagination"]) : undefined as any;
        }
    }

    static fromJS(data: any): PurchasedAssetSpendByManufacturerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetSpendByManufacturerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturerFilters)) {
            data["manufacturerFilters"] = [];
            for (let item of this.manufacturerFilters)
                data["manufacturerFilters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.manufacturerSpends)) {
            data["manufacturerSpends"] = [];
            for (let item of this.manufacturerSpends)
                data["manufacturerSpends"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        return data;
    }
}

export interface IPurchasedAssetSpendByManufacturerResponse {
    manufacturerFilters?: ManufacturerFilter[] | undefined;
    manufacturerSpends?: ManufacturerSpend[] | undefined;
    pagination?: ElasticSearchCompositeAggregationPagination;
}

export class PurchasedAssetSpendByOrderResponse implements IPurchasedAssetSpendByOrderResponse {
    orderSpends?: OrderSpend[] | undefined;
    pagination?: ElasticSearchCompositeAggregationPagination;

    constructor(data?: IPurchasedAssetSpendByOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderSpends"])) {
                this.orderSpends = [] as any;
                for (let item of _data["orderSpends"])
                    this.orderSpends!.push(OrderSpend.fromJS(item));
            }
            this.pagination = _data["pagination"] ? ElasticSearchCompositeAggregationPagination.fromJS(_data["pagination"]) : undefined as any;
        }
    }

    static fromJS(data: any): PurchasedAssetSpendByOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetSpendByOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderSpends)) {
            data["orderSpends"] = [];
            for (let item of this.orderSpends)
                data["orderSpends"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        return data;
    }
}

export interface IPurchasedAssetSpendByOrderResponse {
    orderSpends?: OrderSpend[] | undefined;
    pagination?: ElasticSearchCompositeAggregationPagination;
}

export class PurchasedAssetSpendRequest implements IPurchasedAssetSpendRequest {
    searchQuery?: PurchasedAssetSearchQuery;
    pagination?: ElasticSearchCompositeAggregationPagination;
    sortCriteria?: ElasticSortCriteria;

    constructor(data?: IPurchasedAssetSpendRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchQuery = _data["searchQuery"] ? PurchasedAssetSearchQuery.fromJS(_data["searchQuery"]) : undefined as any;
            this.pagination = _data["pagination"] ? ElasticSearchCompositeAggregationPagination.fromJS(_data["pagination"]) : undefined as any;
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): PurchasedAssetSpendRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetSpendRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchQuery"] = this.searchQuery ? this.searchQuery.toJSON() : undefined as any;
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : undefined as any;
        return data;
    }
}

export interface IPurchasedAssetSpendRequest {
    searchQuery?: PurchasedAssetSearchQuery;
    pagination?: ElasticSearchCompositeAggregationPagination;
    sortCriteria?: ElasticSortCriteria;
}

export class PurchasedAssetsExportRequest implements IPurchasedAssetsExportRequest {
    searchQuery!: PurchasedAssetSearchQuery;
    viewBy!: string | undefined;
    activeTab?: string | undefined;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    gridDefinitions!: ExcelDownloadDefinition[] | undefined;

    constructor(data?: IPurchasedAssetsExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.searchQuery = new PurchasedAssetSearchQuery();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchQuery = _data["searchQuery"] ? PurchasedAssetSearchQuery.fromJS(_data["searchQuery"]) : new PurchasedAssetSearchQuery();
            this.viewBy = _data["viewBy"];
            this.activeTab = _data["activeTab"];
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchasedAssetsExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetsExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchQuery"] = this.searchQuery ? this.searchQuery.toJSON() : undefined as any;
        data["viewBy"] = this.viewBy;
        data["activeTab"] = this.activeTab;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPurchasedAssetsExportRequest {
    searchQuery: PurchasedAssetSearchQuery;
    viewBy: string | undefined;
    activeTab?: string | undefined;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    gridDefinitions: ExcelDownloadDefinition[] | undefined;
}

export class PurchasedAssetsHardwareByAgeResponse implements IPurchasedAssetsHardwareByAgeResponse {
    yearlyHardwareCounts?: HardwareByYearDto[] | undefined;
    totalHardwareCount?: number;

    constructor(data?: IPurchasedAssetsHardwareByAgeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["yearlyHardwareCounts"])) {
                this.yearlyHardwareCounts = [] as any;
                for (let item of _data["yearlyHardwareCounts"])
                    this.yearlyHardwareCounts!.push(HardwareByYearDto.fromJS(item));
            }
            this.totalHardwareCount = _data["totalHardwareCount"];
        }
    }

    static fromJS(data: any): PurchasedAssetsHardwareByAgeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetsHardwareByAgeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.yearlyHardwareCounts)) {
            data["yearlyHardwareCounts"] = [];
            for (let item of this.yearlyHardwareCounts)
                data["yearlyHardwareCounts"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalHardwareCount"] = this.totalHardwareCount;
        return data;
    }
}

export interface IPurchasedAssetsHardwareByAgeResponse {
    yearlyHardwareCounts?: HardwareByYearDto[] | undefined;
    totalHardwareCount?: number;
}

export class PurchasedAssetsSummaryResponse implements IPurchasedAssetsSummaryResponse {
    metrics?: MetricComparison[] | undefined;
    categoryBreakdowns?: CategoryComparison[] | undefined;
    spendChartData?: HistogramBucket[] | undefined;

    constructor(data?: IPurchasedAssetsSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["metrics"])) {
                this.metrics = [] as any;
                for (let item of _data["metrics"])
                    this.metrics!.push(MetricComparison.fromJS(item));
            }
            if (Array.isArray(_data["categoryBreakdowns"])) {
                this.categoryBreakdowns = [] as any;
                for (let item of _data["categoryBreakdowns"])
                    this.categoryBreakdowns!.push(CategoryComparison.fromJS(item));
            }
            if (Array.isArray(_data["spendChartData"])) {
                this.spendChartData = [] as any;
                for (let item of _data["spendChartData"])
                    this.spendChartData!.push(HistogramBucket.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchasedAssetsSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasedAssetsSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.metrics)) {
            data["metrics"] = [];
            for (let item of this.metrics)
                data["metrics"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categoryBreakdowns)) {
            data["categoryBreakdowns"] = [];
            for (let item of this.categoryBreakdowns)
                data["categoryBreakdowns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.spendChartData)) {
            data["spendChartData"] = [];
            for (let item of this.spendChartData)
                data["spendChartData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPurchasedAssetsSummaryResponse {
    metrics?: MetricComparison[] | undefined;
    categoryBreakdowns?: CategoryComparison[] | undefined;
    spendChartData?: HistogramBucket[] | undefined;
}

export class SolutionAreaFilter implements ISolutionAreaFilter {
    solutionAreaName!: string | undefined;
    solutionAreaCount!: number;
    categoryFilters!: CategoryFilter[] | undefined;

    constructor(data?: ISolutionAreaFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solutionAreaName = _data["solutionAreaName"];
            this.solutionAreaCount = _data["solutionAreaCount"];
            if (Array.isArray(_data["categoryFilters"])) {
                this.categoryFilters = [] as any;
                for (let item of _data["categoryFilters"])
                    this.categoryFilters!.push(CategoryFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SolutionAreaFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SolutionAreaFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solutionAreaName"] = this.solutionAreaName;
        data["solutionAreaCount"] = this.solutionAreaCount;
        if (Array.isArray(this.categoryFilters)) {
            data["categoryFilters"] = [];
            for (let item of this.categoryFilters)
                data["categoryFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISolutionAreaFilter {
    solutionAreaName: string | undefined;
    solutionAreaCount: number;
    categoryFilters: CategoryFilter[] | undefined;
}

export class SubCategoryFilter implements ISubCategoryFilter {
    subCategoryName!: string | undefined;
    subCategoryCount!: number;

    constructor(data?: ISubCategoryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategoryName = _data["subCategoryName"];
            this.subCategoryCount = _data["subCategoryCount"];
        }
    }

    static fromJS(data: any): SubCategoryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategoryName"] = this.subCategoryName;
        data["subCategoryCount"] = this.subCategoryCount;
        return data;
    }
}

export interface ISubCategoryFilter {
    subCategoryName: string | undefined;
    subCategoryCount: number;
}

export class AgingInventoryItemDto implements IAgingInventoryItemDto {
    id?: string;
    region?: string | undefined;
    country?: string | undefined;
    warehouse?: string | undefined;
    axCompany?: string | undefined;
    variant?: string | undefined;
    owner?: string | undefined;
    axAccountNumber?: string | undefined;
    manufacturer?: string | undefined;
    mfgPartNumber?: string | undefined;
    partDescription?: string | undefined;
    quantity?: number | undefined;
    allocated?: number | undefined;
    unallocated?: number | undefined;
    receiptRef?: string | undefined;
    receiptDate?: Date | undefined;
    age?: number | undefined;
    buildNames?: string | undefined;
    soNumbers?: string | undefined;

    constructor(data?: IAgingInventoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.region = _data["region"];
            this.country = _data["country"];
            this.warehouse = _data["warehouse"];
            this.axCompany = _data["axCompany"];
            this.variant = _data["variant"];
            this.owner = _data["owner"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.manufacturer = _data["manufacturer"];
            this.mfgPartNumber = _data["mfgPartNumber"];
            this.partDescription = _data["partDescription"];
            this.quantity = _data["quantity"];
            this.allocated = _data["allocated"];
            this.unallocated = _data["unallocated"];
            this.receiptRef = _data["receiptRef"];
            this.receiptDate = _data["receiptDate"] ? new Date(_data["receiptDate"].toString()) : undefined as any;
            this.age = _data["age"];
            this.buildNames = _data["buildNames"];
            this.soNumbers = _data["soNumbers"];
        }
    }

    static fromJS(data: any): AgingInventoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgingInventoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["region"] = this.region;
        data["country"] = this.country;
        data["warehouse"] = this.warehouse;
        data["axCompany"] = this.axCompany;
        data["variant"] = this.variant;
        data["owner"] = this.owner;
        data["axAccountNumber"] = this.axAccountNumber;
        data["manufacturer"] = this.manufacturer;
        data["mfgPartNumber"] = this.mfgPartNumber;
        data["partDescription"] = this.partDescription;
        data["quantity"] = this.quantity;
        data["allocated"] = this.allocated;
        data["unallocated"] = this.unallocated;
        data["receiptRef"] = this.receiptRef;
        data["receiptDate"] = this.receiptDate ? formatDate(this.receiptDate) : undefined as any;
        data["age"] = this.age;
        data["buildNames"] = this.buildNames;
        data["soNumbers"] = this.soNumbers;
        return data;
    }
}

export interface IAgingInventoryItemDto {
    id?: string;
    region?: string | undefined;
    country?: string | undefined;
    warehouse?: string | undefined;
    axCompany?: string | undefined;
    variant?: string | undefined;
    owner?: string | undefined;
    axAccountNumber?: string | undefined;
    manufacturer?: string | undefined;
    mfgPartNumber?: string | undefined;
    partDescription?: string | undefined;
    quantity?: number | undefined;
    allocated?: number | undefined;
    unallocated?: number | undefined;
    receiptRef?: string | undefined;
    receiptDate?: Date | undefined;
    age?: number | undefined;
    buildNames?: string | undefined;
    soNumbers?: string | undefined;
}

export class AgingInventorySearchRequestDto implements IAgingInventorySearchRequestDto {
    searchText?: string | undefined;
    searchFilterInclude?: AgingInventorySearchFilterDto;
    searchFilterExclude?: AgingInventorySearchFilterDto;
    pageNumber?: number;
    pageSize?: number;
    sortOption?: QuerySortOption;

    constructor(data?: IAgingInventorySearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? AgingInventorySearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? AgingInventorySearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortOption = _data["sortOption"] ? QuerySortOption.fromJS(_data["sortOption"]) : undefined as any;
        }
    }

    static fromJS(data: any): AgingInventorySearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgingInventorySearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortOption"] = this.sortOption ? this.sortOption.toJSON() : undefined as any;
        return data;
    }
}

export interface IAgingInventorySearchRequestDto {
    searchText?: string | undefined;
    searchFilterInclude?: AgingInventorySearchFilterDto;
    searchFilterExclude?: AgingInventorySearchFilterDto;
    pageNumber?: number;
    pageSize?: number;
    sortOption?: QuerySortOption;
}

export class AgingInventorySearchWithoutPagingRequestDto implements IAgingInventorySearchWithoutPagingRequestDto {
    searchText?: string | undefined;
    searchFilterInclude?: AgingInventorySearchFilterDto;
    searchFilterExclude?: AgingInventorySearchFilterDto;
    sortOption?: QuerySortOption;
    gridDefinitions!: ExcelDownloadDefinition[] | undefined;

    constructor(data?: IAgingInventorySearchWithoutPagingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? AgingInventorySearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? AgingInventorySearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
            this.sortOption = _data["sortOption"] ? QuerySortOption.fromJS(_data["sortOption"]) : undefined as any;
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgingInventorySearchWithoutPagingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgingInventorySearchWithoutPagingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        data["sortOption"] = this.sortOption ? this.sortOption.toJSON() : undefined as any;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAgingInventorySearchWithoutPagingRequestDto {
    searchText?: string | undefined;
    searchFilterInclude?: AgingInventorySearchFilterDto;
    searchFilterExclude?: AgingInventorySearchFilterDto;
    sortOption?: QuerySortOption;
    gridDefinitions: ExcelDownloadDefinition[] | undefined;
}

export class AssetTypeSpendDataDto implements IAssetTypeSpendDataDto {
    assetType?: string | undefined;
    year?: number;
    month?: number;
    amount?: number;

    constructor(data?: IAssetTypeSpendDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetType = _data["assetType"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): AssetTypeSpendDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTypeSpendDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetType"] = this.assetType;
        data["year"] = this.year;
        data["month"] = this.month;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IAssetTypeSpendDataDto {
    assetType?: string | undefined;
    year?: number;
    month?: number;
    amount?: number;
}

export class AxCustomerHlmOrderDto implements IAxCustomerHlmOrderDto {
    axCustAccount?: string | undefined;
    axCompany?: string | undefined;
    itemNumber?: string | undefined;
    serialNumber?: string | undefined;
    rmaNumber?: string | undefined;
    custRef?: string | undefined;
    hlmStatus?: string | undefined;
    itemName?: string | undefined;
    hlmFinalDisp?: string | undefined;
    salesId?: string | undefined;
    orderDate?: Date | undefined;
    orderStatus?: string | undefined;
    deliveryAddress?: string | undefined;
    trackNum?: string | undefined;
    purchOrder?: string | undefined;
    receivedDate?: Date | undefined;
    reasonDescription?: string | undefined;
    itemDescription?: string | undefined;
    manufacturer?: string | undefined;
    mfrPartNumber?: string | undefined;
    deviceReceived?: string | undefined;
    inTriage?: string | undefined;
    hlmReqDispAndGrading?: string | undefined;
    dataErasure?: string | undefined;
    hlmActualDisposition?: string | undefined;
    complete?: string | undefined;
    readonly nextOrderStatus?: string | undefined;

    constructor(data?: IAxCustomerHlmOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axCustAccount = _data["axCustAccount"];
            this.axCompany = _data["axCompany"];
            this.itemNumber = _data["itemNumber"];
            this.serialNumber = _data["serialNumber"];
            this.rmaNumber = _data["rmaNumber"];
            this.custRef = _data["custRef"];
            this.hlmStatus = _data["hlmStatus"];
            this.itemName = _data["itemName"];
            this.hlmFinalDisp = _data["hlmFinalDisp"];
            this.salesId = _data["salesId"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : undefined as any;
            this.orderStatus = _data["orderStatus"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.trackNum = _data["trackNum"];
            this.purchOrder = _data["purchOrder"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : undefined as any;
            this.reasonDescription = _data["reasonDescription"];
            this.itemDescription = _data["itemDescription"];
            this.manufacturer = _data["manufacturer"];
            this.mfrPartNumber = _data["mfrPartNumber"];
            this.deviceReceived = _data["deviceReceived"];
            this.inTriage = _data["inTriage"];
            this.hlmReqDispAndGrading = _data["hlmReqDispAndGrading"];
            this.dataErasure = _data["dataErasure"];
            this.hlmActualDisposition = _data["hlmActualDisposition"];
            this.complete = _data["complete"];
            (this as any).nextOrderStatus = _data["nextOrderStatus"];
        }
    }

    static fromJS(data: any): AxCustomerHlmOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AxCustomerHlmOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axCustAccount"] = this.axCustAccount;
        data["axCompany"] = this.axCompany;
        data["itemNumber"] = this.itemNumber;
        data["serialNumber"] = this.serialNumber;
        data["rmaNumber"] = this.rmaNumber;
        data["custRef"] = this.custRef;
        data["hlmStatus"] = this.hlmStatus;
        data["itemName"] = this.itemName;
        data["hlmFinalDisp"] = this.hlmFinalDisp;
        data["salesId"] = this.salesId;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined as any;
        data["orderStatus"] = this.orderStatus;
        data["deliveryAddress"] = this.deliveryAddress;
        data["trackNum"] = this.trackNum;
        data["purchOrder"] = this.purchOrder;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : undefined as any;
        data["reasonDescription"] = this.reasonDescription;
        data["itemDescription"] = this.itemDescription;
        data["manufacturer"] = this.manufacturer;
        data["mfrPartNumber"] = this.mfrPartNumber;
        data["deviceReceived"] = this.deviceReceived;
        data["inTriage"] = this.inTriage;
        data["hlmReqDispAndGrading"] = this.hlmReqDispAndGrading;
        data["dataErasure"] = this.dataErasure;
        data["hlmActualDisposition"] = this.hlmActualDisposition;
        data["complete"] = this.complete;
        data["nextOrderStatus"] = this.nextOrderStatus;
        return data;
    }
}

export interface IAxCustomerHlmOrderDto {
    axCustAccount?: string | undefined;
    axCompany?: string | undefined;
    itemNumber?: string | undefined;
    serialNumber?: string | undefined;
    rmaNumber?: string | undefined;
    custRef?: string | undefined;
    hlmStatus?: string | undefined;
    itemName?: string | undefined;
    hlmFinalDisp?: string | undefined;
    salesId?: string | undefined;
    orderDate?: Date | undefined;
    orderStatus?: string | undefined;
    deliveryAddress?: string | undefined;
    trackNum?: string | undefined;
    purchOrder?: string | undefined;
    receivedDate?: Date | undefined;
    reasonDescription?: string | undefined;
    itemDescription?: string | undefined;
    manufacturer?: string | undefined;
    mfrPartNumber?: string | undefined;
    deviceReceived?: string | undefined;
    inTriage?: string | undefined;
    hlmReqDispAndGrading?: string | undefined;
    dataErasure?: string | undefined;
    hlmActualDisposition?: string | undefined;
    complete?: string | undefined;
    nextOrderStatus?: string | undefined;
}

export enum BiManufacturerIdSource {
    InsightsCard = "InsightsCard",
    ManufacturerSearch = "ManufacturerSearch",
}

export class BiManufacturerSuggestionDto implements IBiManufacturerSuggestionDto {
    name!: string | undefined;
    biManufacturerId!: number;

    constructor(data?: IBiManufacturerSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.biManufacturerId = _data["biManufacturerId"];
        }
    }

    static fromJS(data: any): BiManufacturerSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BiManufacturerSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["biManufacturerId"] = this.biManufacturerId;
        return data;
    }
}

export interface IBiManufacturerSuggestionDto {
    name: string | undefined;
    biManufacturerId: number;
}

export class CategorySpendDataDto implements ICategorySpendDataDto {
    category?: string | undefined;
    year?: number;
    month?: number;
    amount?: number;

    constructor(data?: ICategorySpendDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CategorySpendDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategorySpendDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["year"] = this.year;
        data["month"] = this.month;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ICategorySpendDataDto {
    category?: string | undefined;
    year?: number;
    month?: number;
    amount?: number;
}

export class CombinedWarehouseOrderItemDto implements ICombinedWarehouseOrderItemDto {
    id?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    uniqueIdentifier?: string | undefined;
    salesId?: string | undefined;
    purchOrder?: string | undefined;
    invoiceId?: string | undefined;
    orderStatus?: string | undefined;
    expensePurpose?: string | undefined;
    orderType?: string | undefined;
    assetTag?: string | undefined;
    serialNum?: string | undefined;
    lineNum?: number;
    itemId?: string | undefined;
    itemName?: string | undefined;
    mfgName?: string | undefined;
    mfgPart?: string | undefined;
    quantity?: number;
    orderItemQty?: number;
    qty?: number | undefined;
    qtyOrdered?: number | undefined;
    qtyOnOrderItem?: number | undefined;
    deliveryInfo?: Delivery[] | undefined;
    carrierName?: string | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    destination?: string | undefined;
    trackNum?: string | undefined;
    items?: WarehouseOrderItemGroupingDto[] | undefined;
    projectName?: string | undefined;
    solution?: string | undefined;
    projectDefinedField?: string | undefined;
    buildTeamIssues?: string | undefined;
    buildTeamNotes?: string | undefined;
    serverOEM?: string | undefined;
    engineeringNotes?: string | undefined;
    qcNotes?: string | undefined;
    projectCoordinator?: string | undefined;
    confirmedDate?: Date | undefined;
    readonly orderDate?: Date | undefined;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    nowFormula?: Date | undefined;
    opActual?: Date | undefined;
    scheduledDeliveryDate?: Date | undefined;
    targetDeliveryDate?: Date | undefined;
    lastModified?: Date;
    nextOrderStatus?: string | undefined;
    hlmFinalDisp?: string | undefined;
    receivedDate?: Date | undefined;
    reasonDescription?: string | undefined;
    itemDescription?: string | undefined;
    deviceReceived?: string | undefined;
    inTriage?: string | undefined;
    hlmReqDispAndGrading?: string | undefined;
    dataErasure?: string | undefined;
    hlmActualDisposition?: string | undefined;
    complete?: string | undefined;

    constructor(data?: ICombinedWarehouseOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            this.customerRef = _data["customerRef"];
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.salesId = _data["salesId"];
            this.purchOrder = _data["purchOrder"];
            this.invoiceId = _data["invoiceId"];
            this.orderStatus = _data["orderStatus"];
            this.expensePurpose = _data["expensePurpose"];
            this.orderType = _data["orderType"];
            this.assetTag = _data["assetTag"];
            this.serialNum = _data["serialNum"];
            this.lineNum = _data["lineNum"];
            this.itemId = _data["itemId"];
            this.itemName = _data["itemName"];
            this.mfgName = _data["mfgName"];
            this.mfgPart = _data["mfgPart"];
            this.quantity = _data["quantity"];
            this.orderItemQty = _data["orderItemQty"];
            this.qty = _data["qty"];
            this.qtyOrdered = _data["qtyOrdered"];
            this.qtyOnOrderItem = _data["qtyOnOrderItem"];
            if (Array.isArray(_data["deliveryInfo"])) {
                this.deliveryInfo = [] as any;
                for (let item of _data["deliveryInfo"])
                    this.deliveryInfo!.push(Delivery.fromJS(item));
            }
            this.carrierName = _data["carrierName"];
            this.deliveryName = _data["deliveryName"];
            this.deliveryContact = _data["deliveryContact"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.destination = _data["destination"];
            this.trackNum = _data["trackNum"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WarehouseOrderItemGroupingDto.fromJS(item));
            }
            this.projectName = _data["projectName"];
            this.solution = _data["solution"];
            this.projectDefinedField = _data["projectDefinedField"];
            this.buildTeamIssues = _data["buildTeamIssues"];
            this.buildTeamNotes = _data["buildTeamNotes"];
            this.serverOEM = _data["serverOEM"];
            this.engineeringNotes = _data["engineeringNotes"];
            this.qcNotes = _data["qcNotes"];
            this.projectCoordinator = _data["projectCoordinator"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : undefined as any;
            (this as any).orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : undefined as any;
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.nowFormula = _data["nowFormula"] ? new Date(_data["nowFormula"].toString()) : undefined as any;
            this.opActual = _data["opActual"] ? new Date(_data["opActual"].toString()) : undefined as any;
            this.scheduledDeliveryDate = _data["scheduledDeliveryDate"] ? new Date(_data["scheduledDeliveryDate"].toString()) : undefined as any;
            this.targetDeliveryDate = _data["targetDeliveryDate"] ? new Date(_data["targetDeliveryDate"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.nextOrderStatus = _data["nextOrderStatus"];
            this.hlmFinalDisp = _data["hlmFinalDisp"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : undefined as any;
            this.reasonDescription = _data["reasonDescription"];
            this.itemDescription = _data["itemDescription"];
            this.deviceReceived = _data["deviceReceived"];
            this.inTriage = _data["inTriage"];
            this.hlmReqDispAndGrading = _data["hlmReqDispAndGrading"];
            this.dataErasure = _data["dataErasure"];
            this.hlmActualDisposition = _data["hlmActualDisposition"];
            this.complete = _data["complete"];
        }
    }

    static fromJS(data: any): CombinedWarehouseOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombinedWarehouseOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        data["customerRef"] = this.customerRef;
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["salesId"] = this.salesId;
        data["purchOrder"] = this.purchOrder;
        data["invoiceId"] = this.invoiceId;
        data["orderStatus"] = this.orderStatus;
        data["expensePurpose"] = this.expensePurpose;
        data["orderType"] = this.orderType;
        data["assetTag"] = this.assetTag;
        data["serialNum"] = this.serialNum;
        data["lineNum"] = this.lineNum;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["mfgName"] = this.mfgName;
        data["mfgPart"] = this.mfgPart;
        data["quantity"] = this.quantity;
        data["orderItemQty"] = this.orderItemQty;
        data["qty"] = this.qty;
        data["qtyOrdered"] = this.qtyOrdered;
        data["qtyOnOrderItem"] = this.qtyOnOrderItem;
        if (Array.isArray(this.deliveryInfo)) {
            data["deliveryInfo"] = [];
            for (let item of this.deliveryInfo)
                data["deliveryInfo"].push(item ? item.toJSON() : undefined as any);
        }
        data["carrierName"] = this.carrierName;
        data["deliveryName"] = this.deliveryName;
        data["deliveryContact"] = this.deliveryContact;
        data["deliveryMethod"] = this.deliveryMethod;
        data["destination"] = this.destination;
        data["trackNum"] = this.trackNum;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectName"] = this.projectName;
        data["solution"] = this.solution;
        data["projectDefinedField"] = this.projectDefinedField;
        data["buildTeamIssues"] = this.buildTeamIssues;
        data["buildTeamNotes"] = this.buildTeamNotes;
        data["serverOEM"] = this.serverOEM;
        data["engineeringNotes"] = this.engineeringNotes;
        data["qcNotes"] = this.qcNotes;
        data["projectCoordinator"] = this.projectCoordinator;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : undefined as any;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined as any;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["nowFormula"] = this.nowFormula ? this.nowFormula.toISOString() : undefined as any;
        data["opActual"] = this.opActual ? this.opActual.toISOString() : undefined as any;
        data["scheduledDeliveryDate"] = this.scheduledDeliveryDate ? this.scheduledDeliveryDate.toISOString() : undefined as any;
        data["targetDeliveryDate"] = this.targetDeliveryDate ? this.targetDeliveryDate.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["nextOrderStatus"] = this.nextOrderStatus;
        data["hlmFinalDisp"] = this.hlmFinalDisp;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : undefined as any;
        data["reasonDescription"] = this.reasonDescription;
        data["itemDescription"] = this.itemDescription;
        data["deviceReceived"] = this.deviceReceived;
        data["inTriage"] = this.inTriage;
        data["hlmReqDispAndGrading"] = this.hlmReqDispAndGrading;
        data["dataErasure"] = this.dataErasure;
        data["hlmActualDisposition"] = this.hlmActualDisposition;
        data["complete"] = this.complete;
        return data;
    }
}

export interface ICombinedWarehouseOrderItemDto {
    id?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    uniqueIdentifier?: string | undefined;
    salesId?: string | undefined;
    purchOrder?: string | undefined;
    invoiceId?: string | undefined;
    orderStatus?: string | undefined;
    expensePurpose?: string | undefined;
    orderType?: string | undefined;
    assetTag?: string | undefined;
    serialNum?: string | undefined;
    lineNum?: number;
    itemId?: string | undefined;
    itemName?: string | undefined;
    mfgName?: string | undefined;
    mfgPart?: string | undefined;
    quantity?: number;
    orderItemQty?: number;
    qty?: number | undefined;
    qtyOrdered?: number | undefined;
    qtyOnOrderItem?: number | undefined;
    deliveryInfo?: Delivery[] | undefined;
    carrierName?: string | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    destination?: string | undefined;
    trackNum?: string | undefined;
    items?: WarehouseOrderItemGroupingDto[] | undefined;
    projectName?: string | undefined;
    solution?: string | undefined;
    projectDefinedField?: string | undefined;
    buildTeamIssues?: string | undefined;
    buildTeamNotes?: string | undefined;
    serverOEM?: string | undefined;
    engineeringNotes?: string | undefined;
    qcNotes?: string | undefined;
    projectCoordinator?: string | undefined;
    confirmedDate?: Date | undefined;
    orderDate?: Date | undefined;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    nowFormula?: Date | undefined;
    opActual?: Date | undefined;
    scheduledDeliveryDate?: Date | undefined;
    targetDeliveryDate?: Date | undefined;
    lastModified?: Date;
    nextOrderStatus?: string | undefined;
    hlmFinalDisp?: string | undefined;
    receivedDate?: Date | undefined;
    reasonDescription?: string | undefined;
    itemDescription?: string | undefined;
    deviceReceived?: string | undefined;
    inTriage?: string | undefined;
    hlmReqDispAndGrading?: string | undefined;
    dataErasure?: string | undefined;
    hlmActualDisposition?: string | undefined;
    complete?: string | undefined;
}

export class CreateIdcsChangeRequestDto implements ICreateIdcsChangeRequestDto {
    requestorName?: string | undefined;
    requestorEmail?: string | undefined;
    projectName?: string | undefined;
    projectIdentifier?: string | undefined;
    changeType?: string | undefined;
    changeDescription?: string | undefined;
    attachments?: AirtableFileObject[] | undefined;

    constructor(data?: ICreateIdcsChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestorName = _data["requestorName"];
            this.requestorEmail = _data["requestorEmail"];
            this.projectName = _data["projectName"];
            this.projectIdentifier = _data["projectIdentifier"];
            this.changeType = _data["changeType"];
            this.changeDescription = _data["changeDescription"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AirtableFileObject.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateIdcsChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIdcsChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestorName"] = this.requestorName;
        data["requestorEmail"] = this.requestorEmail;
        data["projectName"] = this.projectName;
        data["projectIdentifier"] = this.projectIdentifier;
        data["changeType"] = this.changeType;
        data["changeDescription"] = this.changeDescription;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateIdcsChangeRequestDto {
    requestorName?: string | undefined;
    requestorEmail?: string | undefined;
    projectName?: string | undefined;
    projectIdentifier?: string | undefined;
    changeType?: string | undefined;
    changeDescription?: string | undefined;
    attachments?: AirtableFileObject[] | undefined;
}

export class CreateManuallyCreatedLifecycleEventRequest implements ICreateManuallyCreatedLifecycleEventRequest {
    lifecycleEventDto?: ManuallyCreatedLifecycleEventDto;

    constructor(data?: ICreateManuallyCreatedLifecycleEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lifecycleEventDto = _data["lifecycleEventDto"] ? ManuallyCreatedLifecycleEventDto.fromJS(_data["lifecycleEventDto"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateManuallyCreatedLifecycleEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManuallyCreatedLifecycleEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lifecycleEventDto"] = this.lifecycleEventDto ? this.lifecycleEventDto.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateManuallyCreatedLifecycleEventRequest {
    lifecycleEventDto?: ManuallyCreatedLifecycleEventDto;
}

export class DateRange implements IDateRange {
    start!: Date;
    end?: Date | undefined;

    constructor(data?: IDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DateRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }
}

export interface IDateRange {
    start: Date;
    end?: Date | undefined;
}

export class Delivery implements IDelivery {
    deliveryMethod?: string | undefined;
    trackNum?: string | undefined;
    trackUrl?: string | undefined;
    shipDate?: Date | undefined;

    constructor(data?: IDelivery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryMethod = _data["deliveryMethod"];
            this.trackNum = _data["trackNum"];
            this.trackUrl = _data["trackUrl"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Delivery {
        data = typeof data === 'object' ? data : {};
        let result = new Delivery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryMethod"] = this.deliveryMethod;
        data["trackNum"] = this.trackNum;
        data["trackUrl"] = this.trackUrl;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IDelivery {
    deliveryMethod?: string | undefined;
    trackNum?: string | undefined;
    trackUrl?: string | undefined;
    shipDate?: Date | undefined;
}

export class GetActivityRequest implements IGetActivityRequest {
    id!: string | undefined;
    dateRange!: DateRange;

    constructor(data?: IGetActivityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRange();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateRange = _data["dateRange"] ? DateRange.fromJS(_data["dateRange"]) : new DateRange();
        }
    }

    static fromJS(data: any): GetActivityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetActivityRequest {
    id: string | undefined;
    dateRange: DateRange;
}

export class GetActivityResponse implements IGetActivityResponse {
    id!: string | undefined;
    dateRange!: DateRange;
    history!: ChangeHistory;
    assignees?: LifecycleManagementAssignedToDto[] | undefined;

    constructor(data?: IGetActivityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRange();
            this.history = new ChangeHistory();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateRange = _data["dateRange"] ? DateRange.fromJS(_data["dateRange"]) : new DateRange();
            this.history = _data["history"] ? ChangeHistory.fromJS(_data["history"]) : new ChangeHistory();
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(LifecycleManagementAssignedToDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActivityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        data["history"] = this.history ? this.history.toJSON() : undefined as any;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetActivityResponse {
    id: string | undefined;
    dateRange: DateRange;
    history: ChangeHistory;
    assignees?: LifecycleManagementAssignedToDto[] | undefined;
}

export class HardwareByYearDto implements IHardwareByYearDto {
    year?: number;
    count?: number;

    constructor(data?: IHardwareByYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): HardwareByYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new HardwareByYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["count"] = this.count;
        return data;
    }
}

export interface IHardwareByYearDto {
    year?: number;
    count?: number;
}

export class LifecycleManagementAllEventsExportRequestDto implements ILifecycleManagementAllEventsExportRequestDto {
    searchRequest!: LifecycleManagementSearchRequestDto;
    sortBy!: string | undefined;
    sortDirection!: string | undefined;
    gridDefinitions!: ExcelDownloadDefinition[] | undefined;
    lineItemGridDefinitions?: ExcelDownloadDefinition[] | undefined;

    constructor(data?: ILifecycleManagementAllEventsExportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.searchRequest = new LifecycleManagementSearchRequestDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchRequest = _data["searchRequest"] ? LifecycleManagementSearchRequestDto.fromJS(_data["searchRequest"]) : new LifecycleManagementSearchRequestDto();
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
            if (Array.isArray(_data["lineItemGridDefinitions"])) {
                this.lineItemGridDefinitions = [] as any;
                for (let item of _data["lineItemGridDefinitions"])
                    this.lineItemGridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LifecycleManagementAllEventsExportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementAllEventsExportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchRequest"] = this.searchRequest ? this.searchRequest.toJSON() : undefined as any;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lineItemGridDefinitions)) {
            data["lineItemGridDefinitions"] = [];
            for (let item of this.lineItemGridDefinitions)
                data["lineItemGridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILifecycleManagementAllEventsExportRequestDto {
    searchRequest: LifecycleManagementSearchRequestDto;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    gridDefinitions: ExcelDownloadDefinition[] | undefined;
    lineItemGridDefinitions?: ExcelDownloadDefinition[] | undefined;
}

export class LifecycleManagementAllEventsRequestDto implements ILifecycleManagementAllEventsRequestDto {
    pagination?: LifecycleManagementSearchPaginationRequestDto;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;

    constructor(data?: ILifecycleManagementAllEventsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pagination = _data["pagination"] ? LifecycleManagementSearchPaginationRequestDto.fromJS(_data["pagination"]) : undefined as any;
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.searchFor = _data["searchFor"];
            this.excludeSearchFor = _data["excludeSearchFor"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): LifecycleManagementAllEventsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementAllEventsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["searchFor"] = this.searchFor;
        data["excludeSearchFor"] = this.excludeSearchFor;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ILifecycleManagementAllEventsRequestDto {
    pagination?: LifecycleManagementSearchPaginationRequestDto;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;
}

export class LifecycleManagementAllEventsTimelineRequestDto implements ILifecycleManagementAllEventsTimelineRequestDto {
    startDate?: Date | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;

    constructor(data?: ILifecycleManagementAllEventsTimelineRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.searchFor = _data["searchFor"];
            this.excludeSearchFor = _data["excludeSearchFor"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): LifecycleManagementAllEventsTimelineRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementAllEventsTimelineRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["searchFor"] = this.searchFor;
        data["excludeSearchFor"] = this.excludeSearchFor;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ILifecycleManagementAllEventsTimelineRequestDto {
    startDate?: Date | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;
}

export class LifecycleManagementCreateRenewalRequestDto implements ILifecycleManagementCreateRenewalRequestDto {
    uniqueIdentifier!: string[] | undefined;
    strategy!: LifecycleManagementEventStrategyType;
    customerFacingNotes?: string | undefined;

    constructor(data?: ILifecycleManagementCreateRenewalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniqueIdentifier"])) {
                this.uniqueIdentifier = [] as any;
                for (let item of _data["uniqueIdentifier"])
                    this.uniqueIdentifier!.push(item);
            }
            this.strategy = _data["strategy"];
            this.customerFacingNotes = _data["customerFacingNotes"];
        }
    }

    static fromJS(data: any): LifecycleManagementCreateRenewalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementCreateRenewalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniqueIdentifier)) {
            data["uniqueIdentifier"] = [];
            for (let item of this.uniqueIdentifier)
                data["uniqueIdentifier"].push(item);
        }
        data["strategy"] = this.strategy;
        data["customerFacingNotes"] = this.customerFacingNotes;
        return data;
    }
}

export interface ILifecycleManagementCreateRenewalRequestDto {
    uniqueIdentifier: string[] | undefined;
    strategy: LifecycleManagementEventStrategyType;
    customerFacingNotes?: string | undefined;
}

export enum LifecycleManagementEventStatusType {
    NotActioned = "NotActioned",
    Requested = "Requested",
    Completed = "Completed",
    PastDue = "PastDue",
    Canceled = "Canceled",
    Ignore = "Ignore",
    Quoted = "Quoted",
}

export enum LifecycleManagementEventStrategyType {
    NotSelected = "NotSelected",
    RenewAsIs = "RenewAsIs",
    RenewWithAdjustments = "RenewWithAdjustments",
    NotRenewing = "NotRenewing",
    EvaluateAlternative = "EvaluateAlternative",
}

export enum LifecycleManagementEventType {
    Refresh = "Refresh",
    Renewal = "Renewal",
    Billing = "Billing",
}

export class LifecycleManagementSearchCategoryRequestDto implements ILifecycleManagementSearchCategoryRequestDto {
    category?: string | undefined;
    searchValue?: string | undefined;

    constructor(data?: ILifecycleManagementSearchCategoryRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.searchValue = _data["searchValue"];
        }
    }

    static fromJS(data: any): LifecycleManagementSearchCategoryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementSearchCategoryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["searchValue"] = this.searchValue;
        return data;
    }
}

export interface ILifecycleManagementSearchCategoryRequestDto {
    category?: string | undefined;
    searchValue?: string | undefined;
}

export class LifecycleManagementSearchFilterRequestDto implements ILifecycleManagementSearchFilterRequestDto {
    eventType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    status?: string[] | undefined;
    strategy?: string[] | undefined;
    compellingEventDate?: string[] | undefined;
    axAccountNumber?: string[] | undefined;
    customerNameAx?: string[] | undefined;
    segment?: string[] | undefined;
    division?: string[] | undefined;
    region?: string[] | undefined;
    district?: string[] | undefined;
    businessUnitPaths?: string[] | undefined;
    source?: string[] | undefined;
    tier?: string[] | undefined;
    solutionArea?: string[] | undefined;
    category?: string[] | undefined;
    subCategory?: string[] | undefined;
    assignedTo?: string[] | undefined;
    accountExecutive?: string[] | undefined;
    salesPlayIds?: string[] | undefined;
    dealRegistrationCountBuckets?: string[] | undefined;
    revenueRange?: string[] | undefined;
    gmRange?: string[] | undefined;

    constructor(data?: ILifecycleManagementSearchFilterRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["eventType"])) {
                this.eventType = [] as any;
                for (let item of _data["eventType"])
                    this.eventType!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["strategy"])) {
                this.strategy = [] as any;
                for (let item of _data["strategy"])
                    this.strategy!.push(item);
            }
            if (Array.isArray(_data["compellingEventDate"])) {
                this.compellingEventDate = [] as any;
                for (let item of _data["compellingEventDate"])
                    this.compellingEventDate!.push(item);
            }
            if (Array.isArray(_data["axAccountNumber"])) {
                this.axAccountNumber = [] as any;
                for (let item of _data["axAccountNumber"])
                    this.axAccountNumber!.push(item);
            }
            if (Array.isArray(_data["customerNameAx"])) {
                this.customerNameAx = [] as any;
                for (let item of _data["customerNameAx"])
                    this.customerNameAx!.push(item);
            }
            if (Array.isArray(_data["segment"])) {
                this.segment = [] as any;
                for (let item of _data["segment"])
                    this.segment!.push(item);
            }
            if (Array.isArray(_data["division"])) {
                this.division = [] as any;
                for (let item of _data["division"])
                    this.division!.push(item);
            }
            if (Array.isArray(_data["region"])) {
                this.region = [] as any;
                for (let item of _data["region"])
                    this.region!.push(item);
            }
            if (Array.isArray(_data["district"])) {
                this.district = [] as any;
                for (let item of _data["district"])
                    this.district!.push(item);
            }
            if (Array.isArray(_data["businessUnitPaths"])) {
                this.businessUnitPaths = [] as any;
                for (let item of _data["businessUnitPaths"])
                    this.businessUnitPaths!.push(item);
            }
            if (Array.isArray(_data["source"])) {
                this.source = [] as any;
                for (let item of _data["source"])
                    this.source!.push(item);
            }
            if (Array.isArray(_data["tier"])) {
                this.tier = [] as any;
                for (let item of _data["tier"])
                    this.tier!.push(item);
            }
            if (Array.isArray(_data["solutionArea"])) {
                this.solutionArea = [] as any;
                for (let item of _data["solutionArea"])
                    this.solutionArea!.push(item);
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["assignedTo"])) {
                this.assignedTo = [] as any;
                for (let item of _data["assignedTo"])
                    this.assignedTo!.push(item);
            }
            if (Array.isArray(_data["accountExecutive"])) {
                this.accountExecutive = [] as any;
                for (let item of _data["accountExecutive"])
                    this.accountExecutive!.push(item);
            }
            if (Array.isArray(_data["salesPlayIds"])) {
                this.salesPlayIds = [] as any;
                for (let item of _data["salesPlayIds"])
                    this.salesPlayIds!.push(item);
            }
            if (Array.isArray(_data["dealRegistrationCountBuckets"])) {
                this.dealRegistrationCountBuckets = [] as any;
                for (let item of _data["dealRegistrationCountBuckets"])
                    this.dealRegistrationCountBuckets!.push(item);
            }
            if (Array.isArray(_data["revenueRange"])) {
                this.revenueRange = [] as any;
                for (let item of _data["revenueRange"])
                    this.revenueRange!.push(item);
            }
            if (Array.isArray(_data["gmRange"])) {
                this.gmRange = [] as any;
                for (let item of _data["gmRange"])
                    this.gmRange!.push(item);
            }
        }
    }

    static fromJS(data: any): LifecycleManagementSearchFilterRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementSearchFilterRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.eventType)) {
            data["eventType"] = [];
            for (let item of this.eventType)
                data["eventType"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.strategy)) {
            data["strategy"] = [];
            for (let item of this.strategy)
                data["strategy"].push(item);
        }
        if (Array.isArray(this.compellingEventDate)) {
            data["compellingEventDate"] = [];
            for (let item of this.compellingEventDate)
                data["compellingEventDate"].push(item);
        }
        if (Array.isArray(this.axAccountNumber)) {
            data["axAccountNumber"] = [];
            for (let item of this.axAccountNumber)
                data["axAccountNumber"].push(item);
        }
        if (Array.isArray(this.customerNameAx)) {
            data["customerNameAx"] = [];
            for (let item of this.customerNameAx)
                data["customerNameAx"].push(item);
        }
        if (Array.isArray(this.segment)) {
            data["segment"] = [];
            for (let item of this.segment)
                data["segment"].push(item);
        }
        if (Array.isArray(this.division)) {
            data["division"] = [];
            for (let item of this.division)
                data["division"].push(item);
        }
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item);
        }
        if (Array.isArray(this.district)) {
            data["district"] = [];
            for (let item of this.district)
                data["district"].push(item);
        }
        if (Array.isArray(this.businessUnitPaths)) {
            data["businessUnitPaths"] = [];
            for (let item of this.businessUnitPaths)
                data["businessUnitPaths"].push(item);
        }
        if (Array.isArray(this.source)) {
            data["source"] = [];
            for (let item of this.source)
                data["source"].push(item);
        }
        if (Array.isArray(this.tier)) {
            data["tier"] = [];
            for (let item of this.tier)
                data["tier"].push(item);
        }
        if (Array.isArray(this.solutionArea)) {
            data["solutionArea"] = [];
            for (let item of this.solutionArea)
                data["solutionArea"].push(item);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.assignedTo)) {
            data["assignedTo"] = [];
            for (let item of this.assignedTo)
                data["assignedTo"].push(item);
        }
        if (Array.isArray(this.accountExecutive)) {
            data["accountExecutive"] = [];
            for (let item of this.accountExecutive)
                data["accountExecutive"].push(item);
        }
        if (Array.isArray(this.salesPlayIds)) {
            data["salesPlayIds"] = [];
            for (let item of this.salesPlayIds)
                data["salesPlayIds"].push(item);
        }
        if (Array.isArray(this.dealRegistrationCountBuckets)) {
            data["dealRegistrationCountBuckets"] = [];
            for (let item of this.dealRegistrationCountBuckets)
                data["dealRegistrationCountBuckets"].push(item);
        }
        if (Array.isArray(this.revenueRange)) {
            data["revenueRange"] = [];
            for (let item of this.revenueRange)
                data["revenueRange"].push(item);
        }
        if (Array.isArray(this.gmRange)) {
            data["gmRange"] = [];
            for (let item of this.gmRange)
                data["gmRange"].push(item);
        }
        return data;
    }
}

export interface ILifecycleManagementSearchFilterRequestDto {
    eventType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    status?: string[] | undefined;
    strategy?: string[] | undefined;
    compellingEventDate?: string[] | undefined;
    axAccountNumber?: string[] | undefined;
    customerNameAx?: string[] | undefined;
    segment?: string[] | undefined;
    division?: string[] | undefined;
    region?: string[] | undefined;
    district?: string[] | undefined;
    businessUnitPaths?: string[] | undefined;
    source?: string[] | undefined;
    tier?: string[] | undefined;
    solutionArea?: string[] | undefined;
    category?: string[] | undefined;
    subCategory?: string[] | undefined;
    assignedTo?: string[] | undefined;
    accountExecutive?: string[] | undefined;
    salesPlayIds?: string[] | undefined;
    dealRegistrationCountBuckets?: string[] | undefined;
    revenueRange?: string[] | undefined;
    gmRange?: string[] | undefined;
}

export class LifecycleManagementSearchPaginationRequestDto implements ILifecycleManagementSearchPaginationRequestDto {
    pageSize?: number;
    afterKey?: string | undefined;

    constructor(data?: ILifecycleManagementSearchPaginationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["pageSize"];
            this.afterKey = _data["afterKey"];
        }
    }

    static fromJS(data: any): LifecycleManagementSearchPaginationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementSearchPaginationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize;
        data["afterKey"] = this.afterKey;
        return data;
    }
}

export interface ILifecycleManagementSearchPaginationRequestDto {
    pageSize?: number;
    afterKey?: string | undefined;
}

export class LifecycleManagementSearchRequestDto implements ILifecycleManagementSearchRequestDto {
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;

    constructor(data?: ILifecycleManagementSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            this.excludeSearchFor = _data["excludeSearchFor"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? LifecycleManagementSearchFilterRequestDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): LifecycleManagementSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        data["excludeSearchFor"] = this.excludeSearchFor;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ILifecycleManagementSearchRequestDto {
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: LifecycleManagementSearchFilterRequestDto;
    searchFilterExclude?: LifecycleManagementSearchFilterRequestDto;
}

export class LifecycleManagementUpsertEventRequestDto implements ILifecycleManagementUpsertEventRequestDto {
    uniqueIdentifier!: string | undefined;
    eventType?: LifecycleManagementEventType;
    status?: LifecycleManagementEventStatusType;
    strategy?: LifecycleManagementEventStrategyType;
    notes?: string | undefined;
    customerFacingNotes?: string | undefined;
    manualOverrideEventDate?: Date | undefined;
    clearManualOverrideEventDate?: boolean;
    assignedTo?: string[] | undefined;
    customerOwner?: string[] | undefined;
    initialValue?: LifecycleManagementUpsertEventRequestDto;

    constructor(data?: ILifecycleManagementUpsertEventRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.eventType = _data["eventType"];
            this.status = _data["status"];
            this.strategy = _data["strategy"];
            this.notes = _data["notes"];
            this.customerFacingNotes = _data["customerFacingNotes"];
            this.manualOverrideEventDate = _data["manualOverrideEventDate"] ? new Date(_data["manualOverrideEventDate"].toString()) : undefined as any;
            this.clearManualOverrideEventDate = _data["clearManualOverrideEventDate"];
            if (Array.isArray(_data["assignedTo"])) {
                this.assignedTo = [] as any;
                for (let item of _data["assignedTo"])
                    this.assignedTo!.push(item);
            }
            if (Array.isArray(_data["customerOwner"])) {
                this.customerOwner = [] as any;
                for (let item of _data["customerOwner"])
                    this.customerOwner!.push(item);
            }
            this.initialValue = _data["initialValue"] ? LifecycleManagementUpsertEventRequestDto.fromJS(_data["initialValue"]) : undefined as any;
        }
    }

    static fromJS(data: any): LifecycleManagementUpsertEventRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifecycleManagementUpsertEventRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["eventType"] = this.eventType;
        data["status"] = this.status;
        data["strategy"] = this.strategy;
        data["notes"] = this.notes;
        data["customerFacingNotes"] = this.customerFacingNotes;
        data["manualOverrideEventDate"] = this.manualOverrideEventDate ? this.manualOverrideEventDate.toISOString() : undefined as any;
        data["clearManualOverrideEventDate"] = this.clearManualOverrideEventDate;
        if (Array.isArray(this.assignedTo)) {
            data["assignedTo"] = [];
            for (let item of this.assignedTo)
                data["assignedTo"].push(item);
        }
        if (Array.isArray(this.customerOwner)) {
            data["customerOwner"] = [];
            for (let item of this.customerOwner)
                data["customerOwner"].push(item);
        }
        data["initialValue"] = this.initialValue ? this.initialValue.toJSON() : undefined as any;
        return data;
    }
}

export interface ILifecycleManagementUpsertEventRequestDto {
    uniqueIdentifier: string | undefined;
    eventType?: LifecycleManagementEventType;
    status?: LifecycleManagementEventStatusType;
    strategy?: LifecycleManagementEventStrategyType;
    notes?: string | undefined;
    customerFacingNotes?: string | undefined;
    manualOverrideEventDate?: Date | undefined;
    clearManualOverrideEventDate?: boolean;
    assignedTo?: string[] | undefined;
    customerOwner?: string[] | undefined;
    initialValue?: LifecycleManagementUpsertEventRequestDto;
}

export class ManuallyCreatedLifecycleEventDto implements IManuallyCreatedLifecycleEventDto {
    uniqueIdentifier?: string | undefined;
    manufacturer!: string | undefined;
    biManufacturerId?: number | undefined;
    biManufacturerIdSource?: BiManufacturerIdSource | undefined;
    eventType!: LifecycleManagementEventType;
    assetQty?: number;
    axAccountNumber?: string | undefined;
    crmGuid?: string | undefined;
    potentialRevenue?: number | undefined;
    productIds?: string | undefined;
    serialNumbers?: string | undefined;
    agreementNumbers?: string | undefined;
    status?: LifecycleManagementEventStatusType;
    strategy?: LifecycleManagementEventStrategyType;
    customerFacingNotes?: string | undefined;
    lastModifiedByEmail?: string | undefined;
    lastModifiedByFullName?: string | undefined;
    compellingEventDate?: Date | undefined;

    constructor(data?: IManuallyCreatedLifecycleEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.manufacturer = _data["manufacturer"];
            this.biManufacturerId = _data["biManufacturerId"];
            this.biManufacturerIdSource = _data["biManufacturerIdSource"];
            this.eventType = _data["eventType"];
            this.assetQty = _data["assetQty"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.crmGuid = _data["crmGuid"];
            this.potentialRevenue = _data["potentialRevenue"];
            this.productIds = _data["productIds"];
            this.serialNumbers = _data["serialNumbers"];
            this.agreementNumbers = _data["agreementNumbers"];
            this.status = _data["status"];
            this.strategy = _data["strategy"];
            this.customerFacingNotes = _data["customerFacingNotes"];
            this.lastModifiedByEmail = _data["lastModifiedByEmail"];
            this.lastModifiedByFullName = _data["lastModifiedByFullName"];
            this.compellingEventDate = _data["compellingEventDate"] ? new Date(_data["compellingEventDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ManuallyCreatedLifecycleEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManuallyCreatedLifecycleEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["manufacturer"] = this.manufacturer;
        data["biManufacturerId"] = this.biManufacturerId;
        data["biManufacturerIdSource"] = this.biManufacturerIdSource;
        data["eventType"] = this.eventType;
        data["assetQty"] = this.assetQty;
        data["axAccountNumber"] = this.axAccountNumber;
        data["crmGuid"] = this.crmGuid;
        data["potentialRevenue"] = this.potentialRevenue;
        data["productIds"] = this.productIds;
        data["serialNumbers"] = this.serialNumbers;
        data["agreementNumbers"] = this.agreementNumbers;
        data["status"] = this.status;
        data["strategy"] = this.strategy;
        data["customerFacingNotes"] = this.customerFacingNotes;
        data["lastModifiedByEmail"] = this.lastModifiedByEmail;
        data["lastModifiedByFullName"] = this.lastModifiedByFullName;
        data["compellingEventDate"] = this.compellingEventDate ? this.compellingEventDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IManuallyCreatedLifecycleEventDto {
    uniqueIdentifier?: string | undefined;
    manufacturer: string | undefined;
    biManufacturerId?: number | undefined;
    biManufacturerIdSource?: BiManufacturerIdSource | undefined;
    eventType: LifecycleManagementEventType;
    assetQty?: number;
    axAccountNumber?: string | undefined;
    crmGuid?: string | undefined;
    potentialRevenue?: number | undefined;
    productIds?: string | undefined;
    serialNumbers?: string | undefined;
    agreementNumbers?: string | undefined;
    status?: LifecycleManagementEventStatusType;
    strategy?: LifecycleManagementEventStrategyType;
    customerFacingNotes?: string | undefined;
    lastModifiedByEmail?: string | undefined;
    lastModifiedByFullName?: string | undefined;
    compellingEventDate?: Date | undefined;
}

export class ManufacturerSpendDataDto implements IManufacturerSpendDataDto {
    manufacturer?: string | undefined;
    year?: number;
    month?: number;
    amount?: number;

    constructor(data?: IManufacturerSpendDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ManufacturerSpendDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerSpendDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["year"] = this.year;
        data["month"] = this.month;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IManufacturerSpendDataDto {
    manufacturer?: string | undefined;
    year?: number;
    month?: number;
    amount?: number;
}

export class MonthlySpendDataDto implements IMonthlySpendDataDto {
    year?: number;
    month?: number;
    amount?: number;

    constructor(data?: IMonthlySpendDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): MonthlySpendDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlySpendDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IMonthlySpendDataDto {
    year?: number;
    month?: number;
    amount?: number;
}

export class WarehouseOrderItemDto implements IWarehouseOrderItemDto {
    uniquePrePickId?: string | undefined;
    salesId?: string | undefined;
    assetTag?: string | undefined;
    serialNum?: string | undefined;
    lineNum?: number;
    confirmedDate?: Date | undefined;
    itemId?: string | undefined;
    mfgPart?: string | undefined;
    variant?: string | undefined;
    itemName?: string | undefined;
    mfgName?: string | undefined;
    shipDate?: Date | undefined;
    invoiceId?: string | undefined;
    invoiceDate?: Date | undefined;
    deliveryInfo!: Delivery[] | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    deliveryAddress?: string | undefined;
    trackNum?: string | undefined;
    orderStatus!: string | undefined;
    orderItemIdentifier?: string | undefined;
    purchOrder?: string | undefined;
    expensePurpose?: string | undefined;
    quantity?: number;
    orderItemQty?: number;
    qty?: number | undefined;
    qtyOrdered?: number | undefined;
    qtyOnOrderItem?: number | undefined;
    carrierName?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    items!: WarehouseOrderItemGroupingDto[] | undefined;

    constructor(data?: IWarehouseOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniquePrePickId = _data["uniquePrePickId"];
            this.salesId = _data["salesId"];
            this.assetTag = _data["assetTag"];
            this.serialNum = _data["serialNum"];
            this.lineNum = _data["lineNum"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : undefined as any;
            this.itemId = _data["itemId"];
            this.mfgPart = _data["mfgPart"];
            this.variant = _data["variant"];
            this.itemName = _data["itemName"];
            this.mfgName = _data["mfgName"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
            this.invoiceId = _data["invoiceId"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            if (Array.isArray(_data["deliveryInfo"])) {
                this.deliveryInfo = [] as any;
                for (let item of _data["deliveryInfo"])
                    this.deliveryInfo!.push(Delivery.fromJS(item));
            }
            this.deliveryName = _data["deliveryName"];
            this.deliveryContact = _data["deliveryContact"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.trackNum = _data["trackNum"];
            this.orderStatus = _data["orderStatus"];
            this.orderItemIdentifier = _data["orderItemIdentifier"];
            this.purchOrder = _data["purchOrder"];
            this.expensePurpose = _data["expensePurpose"];
            this.quantity = _data["quantity"];
            this.orderItemQty = _data["orderItemQty"];
            this.qty = _data["qty"];
            this.qtyOrdered = _data["qtyOrdered"];
            this.qtyOnOrderItem = _data["qtyOnOrderItem"];
            this.carrierName = _data["carrierName"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            this.customerRef = _data["customerRef"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WarehouseOrderItemGroupingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniquePrePickId"] = this.uniquePrePickId;
        data["salesId"] = this.salesId;
        data["assetTag"] = this.assetTag;
        data["serialNum"] = this.serialNum;
        data["lineNum"] = this.lineNum;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : undefined as any;
        data["itemId"] = this.itemId;
        data["mfgPart"] = this.mfgPart;
        data["variant"] = this.variant;
        data["itemName"] = this.itemName;
        data["mfgName"] = this.mfgName;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        data["invoiceId"] = this.invoiceId;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        if (Array.isArray(this.deliveryInfo)) {
            data["deliveryInfo"] = [];
            for (let item of this.deliveryInfo)
                data["deliveryInfo"].push(item ? item.toJSON() : undefined as any);
        }
        data["deliveryName"] = this.deliveryName;
        data["deliveryContact"] = this.deliveryContact;
        data["deliveryMethod"] = this.deliveryMethod;
        data["deliveryAddress"] = this.deliveryAddress;
        data["trackNum"] = this.trackNum;
        data["orderStatus"] = this.orderStatus;
        data["orderItemIdentifier"] = this.orderItemIdentifier;
        data["purchOrder"] = this.purchOrder;
        data["expensePurpose"] = this.expensePurpose;
        data["quantity"] = this.quantity;
        data["orderItemQty"] = this.orderItemQty;
        data["qty"] = this.qty;
        data["qtyOrdered"] = this.qtyOrdered;
        data["qtyOnOrderItem"] = this.qtyOnOrderItem;
        data["carrierName"] = this.carrierName;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        data["customerRef"] = this.customerRef;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWarehouseOrderItemDto {
    uniquePrePickId?: string | undefined;
    salesId?: string | undefined;
    assetTag?: string | undefined;
    serialNum?: string | undefined;
    lineNum?: number;
    confirmedDate?: Date | undefined;
    itemId?: string | undefined;
    mfgPart?: string | undefined;
    variant?: string | undefined;
    itemName?: string | undefined;
    mfgName?: string | undefined;
    shipDate?: Date | undefined;
    invoiceId?: string | undefined;
    invoiceDate?: Date | undefined;
    deliveryInfo: Delivery[] | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    deliveryAddress?: string | undefined;
    trackNum?: string | undefined;
    orderStatus: string | undefined;
    orderItemIdentifier?: string | undefined;
    purchOrder?: string | undefined;
    expensePurpose?: string | undefined;
    quantity?: number;
    orderItemQty?: number;
    qty?: number | undefined;
    qtyOrdered?: number | undefined;
    qtyOnOrderItem?: number | undefined;
    carrierName?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    items: WarehouseOrderItemGroupingDto[] | undefined;
}

export class WarehouseOrderItemGroupingDto implements IWarehouseOrderItemGroupingDto {
    salesId?: string | undefined;
    confirmedDate?: Date | undefined;
    itemId?: string | undefined;
    itemName?: string | undefined;
    shipDate?: Date | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    deliveryAddress?: string | undefined;
    carrierName?: string | undefined;
    trackNum?: string | undefined;
    orderStatus?: string | undefined;
    orderItemIdentifier?: string | undefined;
    purchOrder?: string | undefined;
    expensePurpose?: string | undefined;
    qty?: number;
    qtyOrdered?: number | undefined;
    variant?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    items?: WarehouseOrderItemDto[] | undefined;

    constructor(data?: IWarehouseOrderItemGroupingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesId = _data["salesId"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : undefined as any;
            this.itemId = _data["itemId"];
            this.itemName = _data["itemName"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
            this.deliveryName = _data["deliveryName"];
            this.deliveryContact = _data["deliveryContact"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.carrierName = _data["carrierName"];
            this.trackNum = _data["trackNum"];
            this.orderStatus = _data["orderStatus"];
            this.orderItemIdentifier = _data["orderItemIdentifier"];
            this.purchOrder = _data["purchOrder"];
            this.expensePurpose = _data["expensePurpose"];
            this.qty = _data["qty"];
            this.qtyOrdered = _data["qtyOrdered"];
            this.variant = _data["variant"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            this.customerRef = _data["customerRef"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WarehouseOrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseOrderItemGroupingDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOrderItemGroupingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesId"] = this.salesId;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : undefined as any;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        data["deliveryName"] = this.deliveryName;
        data["deliveryContact"] = this.deliveryContact;
        data["deliveryMethod"] = this.deliveryMethod;
        data["deliveryAddress"] = this.deliveryAddress;
        data["carrierName"] = this.carrierName;
        data["trackNum"] = this.trackNum;
        data["orderStatus"] = this.orderStatus;
        data["orderItemIdentifier"] = this.orderItemIdentifier;
        data["purchOrder"] = this.purchOrder;
        data["expensePurpose"] = this.expensePurpose;
        data["qty"] = this.qty;
        data["qtyOrdered"] = this.qtyOrdered;
        data["variant"] = this.variant;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        data["customerRef"] = this.customerRef;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWarehouseOrderItemGroupingDto {
    salesId?: string | undefined;
    confirmedDate?: Date | undefined;
    itemId?: string | undefined;
    itemName?: string | undefined;
    shipDate?: Date | undefined;
    deliveryName?: string | undefined;
    deliveryContact?: string | undefined;
    deliveryMethod?: string | undefined;
    deliveryAddress?: string | undefined;
    carrierName?: string | undefined;
    trackNum?: string | undefined;
    orderStatus?: string | undefined;
    orderItemIdentifier?: string | undefined;
    purchOrder?: string | undefined;
    expensePurpose?: string | undefined;
    qty?: number;
    qtyOrdered?: number | undefined;
    variant?: string | undefined;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    customerRef?: string | undefined;
    items?: WarehouseOrderItemDto[] | undefined;
}

export class WarehouseStockItemDto implements IWarehouseStockItemDto {
    productName?: string | undefined;
    itemNumber?: string | undefined;
    variant?: string | undefined;
    productLine?: string | undefined;
    mfgPartNum?: string | undefined;
    warehouse?: string | undefined;
    warehouseDisplayName?: string | undefined;
    location?: string | undefined;
    batchNumber?: string | undefined;
    salesKey?: string | undefined;
    salesKeyOwner?: string | undefined;
    productCategory?: string | undefined;
    productCategoryDisplayName?: string | undefined;
    physInv?: number;
    pickedInv?: number;
    totalShi?: number;
    physRes?: number;
    ordered?: number;
    onOrder?: number;
    orderRes?: number;
    totalAvail?: number;
    total?: number;
    lastPOReceiptDate?: Date | undefined;
    invoiced30Days?: number;
    invoiced90Days?: number;
    invoiced180Days?: number;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    contributingAxNumbers?: string[] | undefined;
    projectID?: string | undefined;
    isProject?: boolean;
    uniqueId?: string;

    constructor(data?: IWarehouseStockItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.itemNumber = _data["itemNumber"];
            this.variant = _data["variant"];
            this.productLine = _data["productLine"];
            this.mfgPartNum = _data["mfgPartNum"];
            this.warehouse = _data["warehouse"];
            this.warehouseDisplayName = _data["warehouseDisplayName"];
            this.location = _data["location"];
            this.batchNumber = _data["batchNumber"];
            this.salesKey = _data["salesKey"];
            this.salesKeyOwner = _data["salesKeyOwner"];
            this.productCategory = _data["productCategory"];
            this.productCategoryDisplayName = _data["productCategoryDisplayName"];
            this.physInv = _data["physInv"];
            this.pickedInv = _data["pickedInv"];
            this.totalShi = _data["totalShi"];
            this.physRes = _data["physRes"];
            this.ordered = _data["ordered"];
            this.onOrder = _data["onOrder"];
            this.orderRes = _data["orderRes"];
            this.totalAvail = _data["totalAvail"];
            this.total = _data["total"];
            this.lastPOReceiptDate = _data["lastPOReceiptDate"] ? new Date(_data["lastPOReceiptDate"].toString()) : undefined as any;
            this.invoiced30Days = _data["invoiced30Days"];
            this.invoiced90Days = _data["invoiced90Days"];
            this.invoiced180Days = _data["invoiced180Days"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            if (Array.isArray(_data["contributingAxNumbers"])) {
                this.contributingAxNumbers = [] as any;
                for (let item of _data["contributingAxNumbers"])
                    this.contributingAxNumbers!.push(item);
            }
            this.projectID = _data["projectID"];
            this.isProject = _data["isProject"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): WarehouseStockItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseStockItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["itemNumber"] = this.itemNumber;
        data["variant"] = this.variant;
        data["productLine"] = this.productLine;
        data["mfgPartNum"] = this.mfgPartNum;
        data["warehouse"] = this.warehouse;
        data["warehouseDisplayName"] = this.warehouseDisplayName;
        data["location"] = this.location;
        data["batchNumber"] = this.batchNumber;
        data["salesKey"] = this.salesKey;
        data["salesKeyOwner"] = this.salesKeyOwner;
        data["productCategory"] = this.productCategory;
        data["productCategoryDisplayName"] = this.productCategoryDisplayName;
        data["physInv"] = this.physInv;
        data["pickedInv"] = this.pickedInv;
        data["totalShi"] = this.totalShi;
        data["physRes"] = this.physRes;
        data["ordered"] = this.ordered;
        data["onOrder"] = this.onOrder;
        data["orderRes"] = this.orderRes;
        data["totalAvail"] = this.totalAvail;
        data["total"] = this.total;
        data["lastPOReceiptDate"] = this.lastPOReceiptDate ? this.lastPOReceiptDate.toISOString() : undefined as any;
        data["invoiced30Days"] = this.invoiced30Days;
        data["invoiced90Days"] = this.invoiced90Days;
        data["invoiced180Days"] = this.invoiced180Days;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        if (Array.isArray(this.contributingAxNumbers)) {
            data["contributingAxNumbers"] = [];
            for (let item of this.contributingAxNumbers)
                data["contributingAxNumbers"].push(item);
        }
        data["projectID"] = this.projectID;
        data["isProject"] = this.isProject;
        data["uniqueId"] = this.uniqueId;
        return data;
    }
}

export interface IWarehouseStockItemDto {
    productName?: string | undefined;
    itemNumber?: string | undefined;
    variant?: string | undefined;
    productLine?: string | undefined;
    mfgPartNum?: string | undefined;
    warehouse?: string | undefined;
    warehouseDisplayName?: string | undefined;
    location?: string | undefined;
    batchNumber?: string | undefined;
    salesKey?: string | undefined;
    salesKeyOwner?: string | undefined;
    productCategory?: string | undefined;
    productCategoryDisplayName?: string | undefined;
    physInv?: number;
    pickedInv?: number;
    totalShi?: number;
    physRes?: number;
    ordered?: number;
    onOrder?: number;
    orderRes?: number;
    totalAvail?: number;
    total?: number;
    lastPOReceiptDate?: Date | undefined;
    invoiced30Days?: number;
    invoiced90Days?: number;
    invoiced180Days?: number;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    contributingAxNumbers?: string[] | undefined;
    projectID?: string | undefined;
    isProject?: boolean;
    uniqueId?: string;
}

export class WeeklySpendDataDto implements IWeeklySpendDataDto {
    year?: number;
    month?: number;
    day?: number;
    amount?: number;

    constructor(data?: IWeeklySpendDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.day = _data["day"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): WeeklySpendDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklySpendDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["day"] = this.day;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IWeeklySpendDataDto {
    year?: number;
    month?: number;
    day?: number;
    amount?: number;
}

export class CurrentInstance implements ICurrentInstance {
    currencyCode?: string | undefined;
    instanceName?: string | undefined;
    monthlyCost?: string | undefined;
    onDemandHoursInLookbackPeriod?: string | undefined;
    reservationCoveredHoursInLookbackPeriod?: string | undefined;
    resourceDetails?: ResourceDetails;
    resourceId?: string | undefined;
    resourceUtilization?: ResourceUtilization;
    savingsPlansCoveredHoursInLookbackPeriod?: string | undefined;
    tags?: TagValues[] | undefined;
    totalRunningHoursInLookbackPeriod?: string | undefined;

    constructor(data?: ICurrentInstance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.instanceName = _data["instanceName"];
            this.monthlyCost = _data["monthlyCost"];
            this.onDemandHoursInLookbackPeriod = _data["onDemandHoursInLookbackPeriod"];
            this.reservationCoveredHoursInLookbackPeriod = _data["reservationCoveredHoursInLookbackPeriod"];
            this.resourceDetails = _data["resourceDetails"] ? ResourceDetails.fromJS(_data["resourceDetails"]) : undefined as any;
            this.resourceId = _data["resourceId"];
            this.resourceUtilization = _data["resourceUtilization"] ? ResourceUtilization.fromJS(_data["resourceUtilization"]) : undefined as any;
            this.savingsPlansCoveredHoursInLookbackPeriod = _data["savingsPlansCoveredHoursInLookbackPeriod"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagValues.fromJS(item));
            }
            this.totalRunningHoursInLookbackPeriod = _data["totalRunningHoursInLookbackPeriod"];
        }
    }

    static fromJS(data: any): CurrentInstance {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["instanceName"] = this.instanceName;
        data["monthlyCost"] = this.monthlyCost;
        data["onDemandHoursInLookbackPeriod"] = this.onDemandHoursInLookbackPeriod;
        data["reservationCoveredHoursInLookbackPeriod"] = this.reservationCoveredHoursInLookbackPeriod;
        data["resourceDetails"] = this.resourceDetails ? this.resourceDetails.toJSON() : undefined as any;
        data["resourceId"] = this.resourceId;
        data["resourceUtilization"] = this.resourceUtilization ? this.resourceUtilization.toJSON() : undefined as any;
        data["savingsPlansCoveredHoursInLookbackPeriod"] = this.savingsPlansCoveredHoursInLookbackPeriod;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRunningHoursInLookbackPeriod"] = this.totalRunningHoursInLookbackPeriod;
        return data;
    }
}

export interface ICurrentInstance {
    currencyCode?: string | undefined;
    instanceName?: string | undefined;
    monthlyCost?: string | undefined;
    onDemandHoursInLookbackPeriod?: string | undefined;
    reservationCoveredHoursInLookbackPeriod?: string | undefined;
    resourceDetails?: ResourceDetails;
    resourceId?: string | undefined;
    resourceUtilization?: ResourceUtilization;
    savingsPlansCoveredHoursInLookbackPeriod?: string | undefined;
    tags?: TagValues[] | undefined;
    totalRunningHoursInLookbackPeriod?: string | undefined;
}

export class EBSResourceUtilization implements IEBSResourceUtilization {
    ebsReadBytesPerSecond?: string | undefined;
    ebsReadOpsPerSecond?: string | undefined;
    ebsWriteBytesPerSecond?: string | undefined;
    ebsWriteOpsPerSecond?: string | undefined;

    constructor(data?: IEBSResourceUtilization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ebsReadBytesPerSecond = _data["ebsReadBytesPerSecond"];
            this.ebsReadOpsPerSecond = _data["ebsReadOpsPerSecond"];
            this.ebsWriteBytesPerSecond = _data["ebsWriteBytesPerSecond"];
            this.ebsWriteOpsPerSecond = _data["ebsWriteOpsPerSecond"];
        }
    }

    static fromJS(data: any): EBSResourceUtilization {
        data = typeof data === 'object' ? data : {};
        let result = new EBSResourceUtilization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ebsReadBytesPerSecond"] = this.ebsReadBytesPerSecond;
        data["ebsReadOpsPerSecond"] = this.ebsReadOpsPerSecond;
        data["ebsWriteBytesPerSecond"] = this.ebsWriteBytesPerSecond;
        data["ebsWriteOpsPerSecond"] = this.ebsWriteOpsPerSecond;
        return data;
    }
}

export interface IEBSResourceUtilization {
    ebsReadBytesPerSecond?: string | undefined;
    ebsReadOpsPerSecond?: string | undefined;
    ebsWriteBytesPerSecond?: string | undefined;
    ebsWriteOpsPerSecond?: string | undefined;
}

export class EC2InstanceDetails implements IEC2InstanceDetails {
    availabilityZone?: string | undefined;
    currentGeneration?: boolean;
    family?: string | undefined;
    instanceType?: string | undefined;
    platform?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
    tenancy?: string | undefined;

    constructor(data?: IEC2InstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityZone = _data["availabilityZone"];
            this.currentGeneration = _data["currentGeneration"];
            this.family = _data["family"];
            this.instanceType = _data["instanceType"];
            this.platform = _data["platform"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
            this.tenancy = _data["tenancy"];
        }
    }

    static fromJS(data: any): EC2InstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EC2InstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityZone"] = this.availabilityZone;
        data["currentGeneration"] = this.currentGeneration;
        data["family"] = this.family;
        data["instanceType"] = this.instanceType;
        data["platform"] = this.platform;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        data["tenancy"] = this.tenancy;
        return data;
    }
}

export interface IEC2InstanceDetails {
    availabilityZone?: string | undefined;
    currentGeneration?: boolean;
    family?: string | undefined;
    instanceType?: string | undefined;
    platform?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
    tenancy?: string | undefined;
}

export class EC2ResourceDetails implements IEC2ResourceDetails {
    hourlyOnDemandRate?: string | undefined;
    instanceType?: string | undefined;
    memory?: string | undefined;
    networkPerformance?: string | undefined;
    platform?: string | undefined;
    region?: string | undefined;
    sku?: string | undefined;
    storage?: string | undefined;
    vcpu?: string | undefined;

    constructor(data?: IEC2ResourceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hourlyOnDemandRate = _data["hourlyOnDemandRate"];
            this.instanceType = _data["instanceType"];
            this.memory = _data["memory"];
            this.networkPerformance = _data["networkPerformance"];
            this.platform = _data["platform"];
            this.region = _data["region"];
            this.sku = _data["sku"];
            this.storage = _data["storage"];
            this.vcpu = _data["vcpu"];
        }
    }

    static fromJS(data: any): EC2ResourceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EC2ResourceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourlyOnDemandRate"] = this.hourlyOnDemandRate;
        data["instanceType"] = this.instanceType;
        data["memory"] = this.memory;
        data["networkPerformance"] = this.networkPerformance;
        data["platform"] = this.platform;
        data["region"] = this.region;
        data["sku"] = this.sku;
        data["storage"] = this.storage;
        data["vcpu"] = this.vcpu;
        return data;
    }
}

export interface IEC2ResourceDetails {
    hourlyOnDemandRate?: string | undefined;
    instanceType?: string | undefined;
    memory?: string | undefined;
    networkPerformance?: string | undefined;
    platform?: string | undefined;
    region?: string | undefined;
    sku?: string | undefined;
    storage?: string | undefined;
    vcpu?: string | undefined;
}

export class EC2ResourceUtilization implements IEC2ResourceUtilization {
    ebsResourceUtilization?: EBSResourceUtilization;
    maxCpuUtilizationPercentage?: string | undefined;
    maxMemoryUtilizationPercentage?: string | undefined;
    maxStorageUtilizationPercentage?: string | undefined;

    constructor(data?: IEC2ResourceUtilization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ebsResourceUtilization = _data["ebsResourceUtilization"] ? EBSResourceUtilization.fromJS(_data["ebsResourceUtilization"]) : undefined as any;
            this.maxCpuUtilizationPercentage = _data["maxCpuUtilizationPercentage"];
            this.maxMemoryUtilizationPercentage = _data["maxMemoryUtilizationPercentage"];
            this.maxStorageUtilizationPercentage = _data["maxStorageUtilizationPercentage"];
        }
    }

    static fromJS(data: any): EC2ResourceUtilization {
        data = typeof data === 'object' ? data : {};
        let result = new EC2ResourceUtilization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ebsResourceUtilization"] = this.ebsResourceUtilization ? this.ebsResourceUtilization.toJSON() : undefined as any;
        data["maxCpuUtilizationPercentage"] = this.maxCpuUtilizationPercentage;
        data["maxMemoryUtilizationPercentage"] = this.maxMemoryUtilizationPercentage;
        data["maxStorageUtilizationPercentage"] = this.maxStorageUtilizationPercentage;
        return data;
    }
}

export interface IEC2ResourceUtilization {
    ebsResourceUtilization?: EBSResourceUtilization;
    maxCpuUtilizationPercentage?: string | undefined;
    maxMemoryUtilizationPercentage?: string | undefined;
    maxStorageUtilizationPercentage?: string | undefined;
}

export class EC2Specification implements IEC2Specification {
    offeringClass?: string | undefined;

    constructor(data?: IEC2Specification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offeringClass = _data["offeringClass"];
        }
    }

    static fromJS(data: any): EC2Specification {
        data = typeof data === 'object' ? data : {};
        let result = new EC2Specification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offeringClass"] = this.offeringClass;
        return data;
    }
}

export interface IEC2Specification {
    offeringClass?: string | undefined;
}

export class ESInstanceDetails implements IESInstanceDetails {
    currentGeneration?: boolean;
    instanceClass?: string | undefined;
    instanceSize?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;

    constructor(data?: IESInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentGeneration = _data["currentGeneration"];
            this.instanceClass = _data["instanceClass"];
            this.instanceSize = _data["instanceSize"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
        }
    }

    static fromJS(data: any): ESInstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ESInstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentGeneration"] = this.currentGeneration;
        data["instanceClass"] = this.instanceClass;
        data["instanceSize"] = this.instanceSize;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        return data;
    }
}

export interface IESInstanceDetails {
    currentGeneration?: boolean;
    instanceClass?: string | undefined;
    instanceSize?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
}

export class ElastiCacheInstanceDetails implements IElastiCacheInstanceDetails {
    currentGeneration?: boolean;
    family?: string | undefined;
    nodeType?: string | undefined;
    productDescription?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;

    constructor(data?: IElastiCacheInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentGeneration = _data["currentGeneration"];
            this.family = _data["family"];
            this.nodeType = _data["nodeType"];
            this.productDescription = _data["productDescription"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
        }
    }

    static fromJS(data: any): ElastiCacheInstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ElastiCacheInstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentGeneration"] = this.currentGeneration;
        data["family"] = this.family;
        data["nodeType"] = this.nodeType;
        data["productDescription"] = this.productDescription;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        return data;
    }
}

export interface IElastiCacheInstanceDetails {
    currentGeneration?: boolean;
    family?: string | undefined;
    nodeType?: string | undefined;
    productDescription?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
}

export class InstanceDetails implements IInstanceDetails {
    eC2InstanceDetails?: EC2InstanceDetails;
    elastiCacheInstanceDetails?: ElastiCacheInstanceDetails;
    esInstanceDetails?: ESInstanceDetails;
    rdsInstanceDetails?: RDSInstanceDetails;
    redshiftInstanceDetails?: RedshiftInstanceDetails;

    constructor(data?: IInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eC2InstanceDetails = _data["eC2InstanceDetails"] ? EC2InstanceDetails.fromJS(_data["eC2InstanceDetails"]) : undefined as any;
            this.elastiCacheInstanceDetails = _data["elastiCacheInstanceDetails"] ? ElastiCacheInstanceDetails.fromJS(_data["elastiCacheInstanceDetails"]) : undefined as any;
            this.esInstanceDetails = _data["esInstanceDetails"] ? ESInstanceDetails.fromJS(_data["esInstanceDetails"]) : undefined as any;
            this.rdsInstanceDetails = _data["rdsInstanceDetails"] ? RDSInstanceDetails.fromJS(_data["rdsInstanceDetails"]) : undefined as any;
            this.redshiftInstanceDetails = _data["redshiftInstanceDetails"] ? RedshiftInstanceDetails.fromJS(_data["redshiftInstanceDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): InstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eC2InstanceDetails"] = this.eC2InstanceDetails ? this.eC2InstanceDetails.toJSON() : undefined as any;
        data["elastiCacheInstanceDetails"] = this.elastiCacheInstanceDetails ? this.elastiCacheInstanceDetails.toJSON() : undefined as any;
        data["esInstanceDetails"] = this.esInstanceDetails ? this.esInstanceDetails.toJSON() : undefined as any;
        data["rdsInstanceDetails"] = this.rdsInstanceDetails ? this.rdsInstanceDetails.toJSON() : undefined as any;
        data["redshiftInstanceDetails"] = this.redshiftInstanceDetails ? this.redshiftInstanceDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IInstanceDetails {
    eC2InstanceDetails?: EC2InstanceDetails;
    elastiCacheInstanceDetails?: ElastiCacheInstanceDetails;
    esInstanceDetails?: ESInstanceDetails;
    rdsInstanceDetails?: RDSInstanceDetails;
    redshiftInstanceDetails?: RedshiftInstanceDetails;
}

export class ModifyRecommendationDetail implements IModifyRecommendationDetail {
    targetInstances?: TargetInstance[] | undefined;

    constructor(data?: IModifyRecommendationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["targetInstances"])) {
                this.targetInstances = [] as any;
                for (let item of _data["targetInstances"])
                    this.targetInstances!.push(TargetInstance.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModifyRecommendationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyRecommendationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.targetInstances)) {
            data["targetInstances"] = [];
            for (let item of this.targetInstances)
                data["targetInstances"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModifyRecommendationDetail {
    targetInstances?: TargetInstance[] | undefined;
}

export class RDSInstanceDetails implements IRDSInstanceDetails {
    currentGeneration?: boolean;
    databaseEdition?: string | undefined;
    databaseEngine?: string | undefined;
    deploymentOption?: string | undefined;
    family?: string | undefined;
    instanceType?: string | undefined;
    licenseModel?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;

    constructor(data?: IRDSInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentGeneration = _data["currentGeneration"];
            this.databaseEdition = _data["databaseEdition"];
            this.databaseEngine = _data["databaseEngine"];
            this.deploymentOption = _data["deploymentOption"];
            this.family = _data["family"];
            this.instanceType = _data["instanceType"];
            this.licenseModel = _data["licenseModel"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
        }
    }

    static fromJS(data: any): RDSInstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RDSInstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentGeneration"] = this.currentGeneration;
        data["databaseEdition"] = this.databaseEdition;
        data["databaseEngine"] = this.databaseEngine;
        data["deploymentOption"] = this.deploymentOption;
        data["family"] = this.family;
        data["instanceType"] = this.instanceType;
        data["licenseModel"] = this.licenseModel;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        return data;
    }
}

export interface IRDSInstanceDetails {
    currentGeneration?: boolean;
    databaseEdition?: string | undefined;
    databaseEngine?: string | undefined;
    deploymentOption?: string | undefined;
    family?: string | undefined;
    instanceType?: string | undefined;
    licenseModel?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
}

export class RedshiftInstanceDetails implements IRedshiftInstanceDetails {
    currentGeneration?: boolean;
    family?: string | undefined;
    nodeType?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;

    constructor(data?: IRedshiftInstanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentGeneration = _data["currentGeneration"];
            this.family = _data["family"];
            this.nodeType = _data["nodeType"];
            this.region = _data["region"];
            this.sizeFlexEligible = _data["sizeFlexEligible"];
        }
    }

    static fromJS(data: any): RedshiftInstanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RedshiftInstanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentGeneration"] = this.currentGeneration;
        data["family"] = this.family;
        data["nodeType"] = this.nodeType;
        data["region"] = this.region;
        data["sizeFlexEligible"] = this.sizeFlexEligible;
        return data;
    }
}

export interface IRedshiftInstanceDetails {
    currentGeneration?: boolean;
    family?: string | undefined;
    nodeType?: string | undefined;
    region?: string | undefined;
    sizeFlexEligible?: boolean;
}

export class ReservationPurchaseRecommendation implements IReservationPurchaseRecommendation {
    accountScope?: string | undefined;
    lookbackPeriodInDays?: string | undefined;
    paymentOption?: string | undefined;
    recommendationDetails?: ReservationPurchaseRecommendationDetail[] | undefined;
    recommendationSummary?: ReservationPurchaseRecommendationSummary;
    serviceSpecification?: ServiceSpecification;
    termInYears?: string | undefined;

    constructor(data?: IReservationPurchaseRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountScope = _data["accountScope"];
            this.lookbackPeriodInDays = _data["lookbackPeriodInDays"];
            this.paymentOption = _data["paymentOption"];
            if (Array.isArray(_data["recommendationDetails"])) {
                this.recommendationDetails = [] as any;
                for (let item of _data["recommendationDetails"])
                    this.recommendationDetails!.push(ReservationPurchaseRecommendationDetail.fromJS(item));
            }
            this.recommendationSummary = _data["recommendationSummary"] ? ReservationPurchaseRecommendationSummary.fromJS(_data["recommendationSummary"]) : undefined as any;
            this.serviceSpecification = _data["serviceSpecification"] ? ServiceSpecification.fromJS(_data["serviceSpecification"]) : undefined as any;
            this.termInYears = _data["termInYears"];
        }
    }

    static fromJS(data: any): ReservationPurchaseRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPurchaseRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountScope"] = this.accountScope;
        data["lookbackPeriodInDays"] = this.lookbackPeriodInDays;
        data["paymentOption"] = this.paymentOption;
        if (Array.isArray(this.recommendationDetails)) {
            data["recommendationDetails"] = [];
            for (let item of this.recommendationDetails)
                data["recommendationDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["recommendationSummary"] = this.recommendationSummary ? this.recommendationSummary.toJSON() : undefined as any;
        data["serviceSpecification"] = this.serviceSpecification ? this.serviceSpecification.toJSON() : undefined as any;
        data["termInYears"] = this.termInYears;
        return data;
    }
}

export interface IReservationPurchaseRecommendation {
    accountScope?: string | undefined;
    lookbackPeriodInDays?: string | undefined;
    paymentOption?: string | undefined;
    recommendationDetails?: ReservationPurchaseRecommendationDetail[] | undefined;
    recommendationSummary?: ReservationPurchaseRecommendationSummary;
    serviceSpecification?: ServiceSpecification;
    termInYears?: string | undefined;
}

export class ReservationPurchaseRecommendationDetail implements IReservationPurchaseRecommendationDetail {
    accountId?: string | undefined;
    averageNormalizedUnitsUsedPerHour?: string | undefined;
    averageNumberOfInstancesUsedPerHour?: string | undefined;
    averageUtilization?: string | undefined;
    currencyCode?: string | undefined;
    estimatedBreakEvenInMonths?: string | undefined;
    estimatedMonthlyOnDemandCost?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedMonthlySavingsPercentage?: string | undefined;
    estimatedReservationCostForLookbackPeriod?: string | undefined;
    instanceDetails?: InstanceDetails;
    maximumNormalizedUnitsUsedPerHour?: string | undefined;
    maximumNumberOfInstancesUsedPerHour?: string | undefined;
    minimumNormalizedUnitsUsedPerHour?: string | undefined;
    minimumNumberOfInstancesUsedPerHour?: string | undefined;
    recommendedNormalizedUnitsToPurchase?: string | undefined;
    recommendedNumberOfInstancesToPurchase?: string | undefined;
    recurringStandardMonthlyCost?: string | undefined;
    upfrontCost?: string | undefined;

    constructor(data?: IReservationPurchaseRecommendationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.averageNormalizedUnitsUsedPerHour = _data["averageNormalizedUnitsUsedPerHour"];
            this.averageNumberOfInstancesUsedPerHour = _data["averageNumberOfInstancesUsedPerHour"];
            this.averageUtilization = _data["averageUtilization"];
            this.currencyCode = _data["currencyCode"];
            this.estimatedBreakEvenInMonths = _data["estimatedBreakEvenInMonths"];
            this.estimatedMonthlyOnDemandCost = _data["estimatedMonthlyOnDemandCost"];
            this.estimatedMonthlySavingsAmount = _data["estimatedMonthlySavingsAmount"];
            this.estimatedMonthlySavingsPercentage = _data["estimatedMonthlySavingsPercentage"];
            this.estimatedReservationCostForLookbackPeriod = _data["estimatedReservationCostForLookbackPeriod"];
            this.instanceDetails = _data["instanceDetails"] ? InstanceDetails.fromJS(_data["instanceDetails"]) : undefined as any;
            this.maximumNormalizedUnitsUsedPerHour = _data["maximumNormalizedUnitsUsedPerHour"];
            this.maximumNumberOfInstancesUsedPerHour = _data["maximumNumberOfInstancesUsedPerHour"];
            this.minimumNormalizedUnitsUsedPerHour = _data["minimumNormalizedUnitsUsedPerHour"];
            this.minimumNumberOfInstancesUsedPerHour = _data["minimumNumberOfInstancesUsedPerHour"];
            this.recommendedNormalizedUnitsToPurchase = _data["recommendedNormalizedUnitsToPurchase"];
            this.recommendedNumberOfInstancesToPurchase = _data["recommendedNumberOfInstancesToPurchase"];
            this.recurringStandardMonthlyCost = _data["recurringStandardMonthlyCost"];
            this.upfrontCost = _data["upfrontCost"];
        }
    }

    static fromJS(data: any): ReservationPurchaseRecommendationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPurchaseRecommendationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["averageNormalizedUnitsUsedPerHour"] = this.averageNormalizedUnitsUsedPerHour;
        data["averageNumberOfInstancesUsedPerHour"] = this.averageNumberOfInstancesUsedPerHour;
        data["averageUtilization"] = this.averageUtilization;
        data["currencyCode"] = this.currencyCode;
        data["estimatedBreakEvenInMonths"] = this.estimatedBreakEvenInMonths;
        data["estimatedMonthlyOnDemandCost"] = this.estimatedMonthlyOnDemandCost;
        data["estimatedMonthlySavingsAmount"] = this.estimatedMonthlySavingsAmount;
        data["estimatedMonthlySavingsPercentage"] = this.estimatedMonthlySavingsPercentage;
        data["estimatedReservationCostForLookbackPeriod"] = this.estimatedReservationCostForLookbackPeriod;
        data["instanceDetails"] = this.instanceDetails ? this.instanceDetails.toJSON() : undefined as any;
        data["maximumNormalizedUnitsUsedPerHour"] = this.maximumNormalizedUnitsUsedPerHour;
        data["maximumNumberOfInstancesUsedPerHour"] = this.maximumNumberOfInstancesUsedPerHour;
        data["minimumNormalizedUnitsUsedPerHour"] = this.minimumNormalizedUnitsUsedPerHour;
        data["minimumNumberOfInstancesUsedPerHour"] = this.minimumNumberOfInstancesUsedPerHour;
        data["recommendedNormalizedUnitsToPurchase"] = this.recommendedNormalizedUnitsToPurchase;
        data["recommendedNumberOfInstancesToPurchase"] = this.recommendedNumberOfInstancesToPurchase;
        data["recurringStandardMonthlyCost"] = this.recurringStandardMonthlyCost;
        data["upfrontCost"] = this.upfrontCost;
        return data;
    }
}

export interface IReservationPurchaseRecommendationDetail {
    accountId?: string | undefined;
    averageNormalizedUnitsUsedPerHour?: string | undefined;
    averageNumberOfInstancesUsedPerHour?: string | undefined;
    averageUtilization?: string | undefined;
    currencyCode?: string | undefined;
    estimatedBreakEvenInMonths?: string | undefined;
    estimatedMonthlyOnDemandCost?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedMonthlySavingsPercentage?: string | undefined;
    estimatedReservationCostForLookbackPeriod?: string | undefined;
    instanceDetails?: InstanceDetails;
    maximumNormalizedUnitsUsedPerHour?: string | undefined;
    maximumNumberOfInstancesUsedPerHour?: string | undefined;
    minimumNormalizedUnitsUsedPerHour?: string | undefined;
    minimumNumberOfInstancesUsedPerHour?: string | undefined;
    recommendedNormalizedUnitsToPurchase?: string | undefined;
    recommendedNumberOfInstancesToPurchase?: string | undefined;
    recurringStandardMonthlyCost?: string | undefined;
    upfrontCost?: string | undefined;
}

export class ReservationPurchaseRecommendationSummary implements IReservationPurchaseRecommendationSummary {
    currencyCode?: string | undefined;
    totalEstimatedMonthlySavingsAmount?: string | undefined;
    totalEstimatedMonthlySavingsPercentage?: string | undefined;

    constructor(data?: IReservationPurchaseRecommendationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.totalEstimatedMonthlySavingsAmount = _data["totalEstimatedMonthlySavingsAmount"];
            this.totalEstimatedMonthlySavingsPercentage = _data["totalEstimatedMonthlySavingsPercentage"];
        }
    }

    static fromJS(data: any): ReservationPurchaseRecommendationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPurchaseRecommendationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["totalEstimatedMonthlySavingsAmount"] = this.totalEstimatedMonthlySavingsAmount;
        data["totalEstimatedMonthlySavingsPercentage"] = this.totalEstimatedMonthlySavingsPercentage;
        return data;
    }
}

export interface IReservationPurchaseRecommendationSummary {
    currencyCode?: string | undefined;
    totalEstimatedMonthlySavingsAmount?: string | undefined;
    totalEstimatedMonthlySavingsPercentage?: string | undefined;
}

export class ResourceDetails implements IResourceDetails {
    eC2ResourceDetails?: EC2ResourceDetails;

    constructor(data?: IResourceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eC2ResourceDetails = _data["eC2ResourceDetails"] ? EC2ResourceDetails.fromJS(_data["eC2ResourceDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResourceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eC2ResourceDetails"] = this.eC2ResourceDetails ? this.eC2ResourceDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IResourceDetails {
    eC2ResourceDetails?: EC2ResourceDetails;
}

export class ResourceUtilization implements IResourceUtilization {
    eC2ResourceUtilization?: EC2ResourceUtilization;

    constructor(data?: IResourceUtilization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eC2ResourceUtilization = _data["eC2ResourceUtilization"] ? EC2ResourceUtilization.fromJS(_data["eC2ResourceUtilization"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResourceUtilization {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceUtilization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eC2ResourceUtilization"] = this.eC2ResourceUtilization ? this.eC2ResourceUtilization.toJSON() : undefined as any;
        return data;
    }
}

export interface IResourceUtilization {
    eC2ResourceUtilization?: EC2ResourceUtilization;
}

export class RightsizingRecommendation implements IRightsizingRecommendation {
    accountId?: string | undefined;
    currentInstance?: CurrentInstance;
    modifyRecommendationDetail?: ModifyRecommendationDetail;
    rightsizingType?: string | undefined;
    terminateRecommendationDetail?: TerminateRecommendationDetail;

    constructor(data?: IRightsizingRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.currentInstance = _data["currentInstance"] ? CurrentInstance.fromJS(_data["currentInstance"]) : undefined as any;
            this.modifyRecommendationDetail = _data["modifyRecommendationDetail"] ? ModifyRecommendationDetail.fromJS(_data["modifyRecommendationDetail"]) : undefined as any;
            this.rightsizingType = _data["rightsizingType"];
            this.terminateRecommendationDetail = _data["terminateRecommendationDetail"] ? TerminateRecommendationDetail.fromJS(_data["terminateRecommendationDetail"]) : undefined as any;
        }
    }

    static fromJS(data: any): RightsizingRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new RightsizingRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["currentInstance"] = this.currentInstance ? this.currentInstance.toJSON() : undefined as any;
        data["modifyRecommendationDetail"] = this.modifyRecommendationDetail ? this.modifyRecommendationDetail.toJSON() : undefined as any;
        data["rightsizingType"] = this.rightsizingType;
        data["terminateRecommendationDetail"] = this.terminateRecommendationDetail ? this.terminateRecommendationDetail.toJSON() : undefined as any;
        return data;
    }
}

export interface IRightsizingRecommendation {
    accountId?: string | undefined;
    currentInstance?: CurrentInstance;
    modifyRecommendationDetail?: ModifyRecommendationDetail;
    rightsizingType?: string | undefined;
    terminateRecommendationDetail?: TerminateRecommendationDetail;
}

export class SavingsPlansDetails implements ISavingsPlansDetails {
    instanceFamily?: string | undefined;
    offeringId?: string | undefined;
    region?: string | undefined;

    constructor(data?: ISavingsPlansDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceFamily = _data["instanceFamily"];
            this.offeringId = _data["offeringId"];
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): SavingsPlansDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceFamily"] = this.instanceFamily;
        data["offeringId"] = this.offeringId;
        data["region"] = this.region;
        return data;
    }
}

export interface ISavingsPlansDetails {
    instanceFamily?: string | undefined;
    offeringId?: string | undefined;
    region?: string | undefined;
}

export class SavingsPlansPurchaseRecommendation implements ISavingsPlansPurchaseRecommendation {
    accountScope?: string | undefined;
    lookbackPeriodInDays?: string | undefined;
    paymentOption?: string | undefined;
    savingsPlansPurchaseRecommendationDetails?: SavingsPlansPurchaseRecommendationDetail[] | undefined;
    savingsPlansPurchaseRecommendationSummary?: SavingsPlansPurchaseRecommendationSummary;
    savingsPlansType?: string | undefined;
    termInYears?: string | undefined;

    constructor(data?: ISavingsPlansPurchaseRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountScope = _data["accountScope"];
            this.lookbackPeriodInDays = _data["lookbackPeriodInDays"];
            this.paymentOption = _data["paymentOption"];
            if (Array.isArray(_data["savingsPlansPurchaseRecommendationDetails"])) {
                this.savingsPlansPurchaseRecommendationDetails = [] as any;
                for (let item of _data["savingsPlansPurchaseRecommendationDetails"])
                    this.savingsPlansPurchaseRecommendationDetails!.push(SavingsPlansPurchaseRecommendationDetail.fromJS(item));
            }
            this.savingsPlansPurchaseRecommendationSummary = _data["savingsPlansPurchaseRecommendationSummary"] ? SavingsPlansPurchaseRecommendationSummary.fromJS(_data["savingsPlansPurchaseRecommendationSummary"]) : undefined as any;
            this.savingsPlansType = _data["savingsPlansType"];
            this.termInYears = _data["termInYears"];
        }
    }

    static fromJS(data: any): SavingsPlansPurchaseRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansPurchaseRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountScope"] = this.accountScope;
        data["lookbackPeriodInDays"] = this.lookbackPeriodInDays;
        data["paymentOption"] = this.paymentOption;
        if (Array.isArray(this.savingsPlansPurchaseRecommendationDetails)) {
            data["savingsPlansPurchaseRecommendationDetails"] = [];
            for (let item of this.savingsPlansPurchaseRecommendationDetails)
                data["savingsPlansPurchaseRecommendationDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["savingsPlansPurchaseRecommendationSummary"] = this.savingsPlansPurchaseRecommendationSummary ? this.savingsPlansPurchaseRecommendationSummary.toJSON() : undefined as any;
        data["savingsPlansType"] = this.savingsPlansType;
        data["termInYears"] = this.termInYears;
        return data;
    }
}

export interface ISavingsPlansPurchaseRecommendation {
    accountScope?: string | undefined;
    lookbackPeriodInDays?: string | undefined;
    paymentOption?: string | undefined;
    savingsPlansPurchaseRecommendationDetails?: SavingsPlansPurchaseRecommendationDetail[] | undefined;
    savingsPlansPurchaseRecommendationSummary?: SavingsPlansPurchaseRecommendationSummary;
    savingsPlansType?: string | undefined;
    termInYears?: string | undefined;
}

export class SavingsPlansPurchaseRecommendationDetail implements ISavingsPlansPurchaseRecommendationDetail {
    accountId?: string | undefined;
    currencyCode?: string | undefined;
    currentAverageHourlyOnDemandSpend?: string | undefined;
    currentMaximumHourlyOnDemandSpend?: string | undefined;
    currentMinimumHourlyOnDemandSpend?: string | undefined;
    estimatedAverageUtilization?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedOnDemandCost?: string | undefined;
    estimatedOnDemandCostWithCurrentCommitment?: string | undefined;
    estimatedROI?: string | undefined;
    estimatedSavingsAmount?: string | undefined;
    estimatedSavingsPercentage?: string | undefined;
    estimatedSPCost?: string | undefined;
    hourlyCommitmentToPurchase?: string | undefined;
    savingsPlansDetails?: SavingsPlansDetails;
    upfrontCost?: string | undefined;

    constructor(data?: ISavingsPlansPurchaseRecommendationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.currencyCode = _data["currencyCode"];
            this.currentAverageHourlyOnDemandSpend = _data["currentAverageHourlyOnDemandSpend"];
            this.currentMaximumHourlyOnDemandSpend = _data["currentMaximumHourlyOnDemandSpend"];
            this.currentMinimumHourlyOnDemandSpend = _data["currentMinimumHourlyOnDemandSpend"];
            this.estimatedAverageUtilization = _data["estimatedAverageUtilization"];
            this.estimatedMonthlySavingsAmount = _data["estimatedMonthlySavingsAmount"];
            this.estimatedOnDemandCost = _data["estimatedOnDemandCost"];
            this.estimatedOnDemandCostWithCurrentCommitment = _data["estimatedOnDemandCostWithCurrentCommitment"];
            this.estimatedROI = _data["estimatedROI"];
            this.estimatedSavingsAmount = _data["estimatedSavingsAmount"];
            this.estimatedSavingsPercentage = _data["estimatedSavingsPercentage"];
            this.estimatedSPCost = _data["estimatedSPCost"];
            this.hourlyCommitmentToPurchase = _data["hourlyCommitmentToPurchase"];
            this.savingsPlansDetails = _data["savingsPlansDetails"] ? SavingsPlansDetails.fromJS(_data["savingsPlansDetails"]) : undefined as any;
            this.upfrontCost = _data["upfrontCost"];
        }
    }

    static fromJS(data: any): SavingsPlansPurchaseRecommendationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansPurchaseRecommendationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["currencyCode"] = this.currencyCode;
        data["currentAverageHourlyOnDemandSpend"] = this.currentAverageHourlyOnDemandSpend;
        data["currentMaximumHourlyOnDemandSpend"] = this.currentMaximumHourlyOnDemandSpend;
        data["currentMinimumHourlyOnDemandSpend"] = this.currentMinimumHourlyOnDemandSpend;
        data["estimatedAverageUtilization"] = this.estimatedAverageUtilization;
        data["estimatedMonthlySavingsAmount"] = this.estimatedMonthlySavingsAmount;
        data["estimatedOnDemandCost"] = this.estimatedOnDemandCost;
        data["estimatedOnDemandCostWithCurrentCommitment"] = this.estimatedOnDemandCostWithCurrentCommitment;
        data["estimatedROI"] = this.estimatedROI;
        data["estimatedSavingsAmount"] = this.estimatedSavingsAmount;
        data["estimatedSavingsPercentage"] = this.estimatedSavingsPercentage;
        data["estimatedSPCost"] = this.estimatedSPCost;
        data["hourlyCommitmentToPurchase"] = this.hourlyCommitmentToPurchase;
        data["savingsPlansDetails"] = this.savingsPlansDetails ? this.savingsPlansDetails.toJSON() : undefined as any;
        data["upfrontCost"] = this.upfrontCost;
        return data;
    }
}

export interface ISavingsPlansPurchaseRecommendationDetail {
    accountId?: string | undefined;
    currencyCode?: string | undefined;
    currentAverageHourlyOnDemandSpend?: string | undefined;
    currentMaximumHourlyOnDemandSpend?: string | undefined;
    currentMinimumHourlyOnDemandSpend?: string | undefined;
    estimatedAverageUtilization?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedOnDemandCost?: string | undefined;
    estimatedOnDemandCostWithCurrentCommitment?: string | undefined;
    estimatedROI?: string | undefined;
    estimatedSavingsAmount?: string | undefined;
    estimatedSavingsPercentage?: string | undefined;
    estimatedSPCost?: string | undefined;
    hourlyCommitmentToPurchase?: string | undefined;
    savingsPlansDetails?: SavingsPlansDetails;
    upfrontCost?: string | undefined;
}

export class SavingsPlansPurchaseRecommendationSummary implements ISavingsPlansPurchaseRecommendationSummary {
    currencyCode?: string | undefined;
    currentOnDemandSpend?: string | undefined;
    dailyCommitmentToPurchase?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedOnDemandCostWithCurrentCommitment?: string | undefined;
    estimatedROI?: string | undefined;
    estimatedSavingsAmount?: string | undefined;
    estimatedSavingsPercentage?: string | undefined;
    estimatedTotalCost?: string | undefined;
    hourlyCommitmentToPurchase?: string | undefined;
    totalRecommendationCount?: string | undefined;

    constructor(data?: ISavingsPlansPurchaseRecommendationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.currentOnDemandSpend = _data["currentOnDemandSpend"];
            this.dailyCommitmentToPurchase = _data["dailyCommitmentToPurchase"];
            this.estimatedMonthlySavingsAmount = _data["estimatedMonthlySavingsAmount"];
            this.estimatedOnDemandCostWithCurrentCommitment = _data["estimatedOnDemandCostWithCurrentCommitment"];
            this.estimatedROI = _data["estimatedROI"];
            this.estimatedSavingsAmount = _data["estimatedSavingsAmount"];
            this.estimatedSavingsPercentage = _data["estimatedSavingsPercentage"];
            this.estimatedTotalCost = _data["estimatedTotalCost"];
            this.hourlyCommitmentToPurchase = _data["hourlyCommitmentToPurchase"];
            this.totalRecommendationCount = _data["totalRecommendationCount"];
        }
    }

    static fromJS(data: any): SavingsPlansPurchaseRecommendationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansPurchaseRecommendationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["currentOnDemandSpend"] = this.currentOnDemandSpend;
        data["dailyCommitmentToPurchase"] = this.dailyCommitmentToPurchase;
        data["estimatedMonthlySavingsAmount"] = this.estimatedMonthlySavingsAmount;
        data["estimatedOnDemandCostWithCurrentCommitment"] = this.estimatedOnDemandCostWithCurrentCommitment;
        data["estimatedROI"] = this.estimatedROI;
        data["estimatedSavingsAmount"] = this.estimatedSavingsAmount;
        data["estimatedSavingsPercentage"] = this.estimatedSavingsPercentage;
        data["estimatedTotalCost"] = this.estimatedTotalCost;
        data["hourlyCommitmentToPurchase"] = this.hourlyCommitmentToPurchase;
        data["totalRecommendationCount"] = this.totalRecommendationCount;
        return data;
    }
}

export interface ISavingsPlansPurchaseRecommendationSummary {
    currencyCode?: string | undefined;
    currentOnDemandSpend?: string | undefined;
    dailyCommitmentToPurchase?: string | undefined;
    estimatedMonthlySavingsAmount?: string | undefined;
    estimatedOnDemandCostWithCurrentCommitment?: string | undefined;
    estimatedROI?: string | undefined;
    estimatedSavingsAmount?: string | undefined;
    estimatedSavingsPercentage?: string | undefined;
    estimatedTotalCost?: string | undefined;
    hourlyCommitmentToPurchase?: string | undefined;
    totalRecommendationCount?: string | undefined;
}

export class ServiceSpecification implements IServiceSpecification {
    eC2Specification?: EC2Specification;

    constructor(data?: IServiceSpecification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eC2Specification = _data["eC2Specification"] ? EC2Specification.fromJS(_data["eC2Specification"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceSpecification {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSpecification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eC2Specification"] = this.eC2Specification ? this.eC2Specification.toJSON() : undefined as any;
        return data;
    }
}

export interface IServiceSpecification {
    eC2Specification?: EC2Specification;
}

export class TagValues implements ITagValues {
    key?: string | undefined;
    matchOptions?: string[] | undefined;
    values?: string[] | undefined;

    constructor(data?: ITagValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["matchOptions"])) {
                this.matchOptions = [] as any;
                for (let item of _data["matchOptions"])
                    this.matchOptions!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): TagValues {
        data = typeof data === 'object' ? data : {};
        let result = new TagValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.matchOptions)) {
            data["matchOptions"] = [];
            for (let item of this.matchOptions)
                data["matchOptions"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface ITagValues {
    key?: string | undefined;
    matchOptions?: string[] | undefined;
    values?: string[] | undefined;
}

export class TargetInstance implements ITargetInstance {
    currencyCode?: string | undefined;
    defaultTargetInstance?: boolean;
    estimatedMonthlyCost?: string | undefined;
    estimatedMonthlySavings?: string | undefined;
    expectedResourceUtilization?: ResourceUtilization;
    resourceDetails?: ResourceDetails;

    constructor(data?: ITargetInstance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.defaultTargetInstance = _data["defaultTargetInstance"];
            this.estimatedMonthlyCost = _data["estimatedMonthlyCost"];
            this.estimatedMonthlySavings = _data["estimatedMonthlySavings"];
            this.expectedResourceUtilization = _data["expectedResourceUtilization"] ? ResourceUtilization.fromJS(_data["expectedResourceUtilization"]) : undefined as any;
            this.resourceDetails = _data["resourceDetails"] ? ResourceDetails.fromJS(_data["resourceDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): TargetInstance {
        data = typeof data === 'object' ? data : {};
        let result = new TargetInstance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["defaultTargetInstance"] = this.defaultTargetInstance;
        data["estimatedMonthlyCost"] = this.estimatedMonthlyCost;
        data["estimatedMonthlySavings"] = this.estimatedMonthlySavings;
        data["expectedResourceUtilization"] = this.expectedResourceUtilization ? this.expectedResourceUtilization.toJSON() : undefined as any;
        data["resourceDetails"] = this.resourceDetails ? this.resourceDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface ITargetInstance {
    currencyCode?: string | undefined;
    defaultTargetInstance?: boolean;
    estimatedMonthlyCost?: string | undefined;
    estimatedMonthlySavings?: string | undefined;
    expectedResourceUtilization?: ResourceUtilization;
    resourceDetails?: ResourceDetails;
}

export class TerminateRecommendationDetail implements ITerminateRecommendationDetail {
    currencyCode?: string | undefined;
    estimatedMonthlySavings?: string | undefined;

    constructor(data?: ITerminateRecommendationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.estimatedMonthlySavings = _data["estimatedMonthlySavings"];
        }
    }

    static fromJS(data: any): TerminateRecommendationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TerminateRecommendationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["estimatedMonthlySavings"] = this.estimatedMonthlySavings;
        return data;
    }
}

export interface ITerminateRecommendationDetail {
    currencyCode?: string | undefined;
    estimatedMonthlySavings?: string | undefined;
}

export class TrustedAdvisorCategorySpecificSummary implements ITrustedAdvisorCategorySpecificSummary {
    costOptimizing?: TrustedAdvisorCostOptimizingSummary;

    constructor(data?: ITrustedAdvisorCategorySpecificSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costOptimizing = _data["costOptimizing"] ? TrustedAdvisorCostOptimizingSummary.fromJS(_data["costOptimizing"]) : undefined as any;
        }
    }

    static fromJS(data: any): TrustedAdvisorCategorySpecificSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCategorySpecificSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costOptimizing"] = this.costOptimizing ? this.costOptimizing.toJSON() : undefined as any;
        return data;
    }
}

export interface ITrustedAdvisorCategorySpecificSummary {
    costOptimizing?: TrustedAdvisorCostOptimizingSummary;
}

export class TrustedAdvisorCheckDescription implements ITrustedAdvisorCheckDescription {
    category?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    metadata?: string[] | undefined;
    name?: string | undefined;

    constructor(data?: ITrustedAdvisorCheckDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.description = _data["description"];
            this.id = _data["id"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(item);
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TrustedAdvisorCheckDescription {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCheckDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["description"] = this.description;
        data["id"] = this.id;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item);
        }
        data["name"] = this.name;
        return data;
    }
}

export interface ITrustedAdvisorCheckDescription {
    category?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    metadata?: string[] | undefined;
    name?: string | undefined;
}

export class TrustedAdvisorCheckResult implements ITrustedAdvisorCheckResult {
    categorySpecificSummary?: TrustedAdvisorCategorySpecificSummary;
    checkId?: string | undefined;
    flaggedResources?: TrustedAdvisorResourceDetail[] | undefined;
    resourcesSummary?: TrustedAdvisorResourcesSummary;
    status?: string | undefined;
    timestamp?: string | undefined;

    constructor(data?: ITrustedAdvisorCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categorySpecificSummary = _data["categorySpecificSummary"] ? TrustedAdvisorCategorySpecificSummary.fromJS(_data["categorySpecificSummary"]) : undefined as any;
            this.checkId = _data["checkId"];
            if (Array.isArray(_data["flaggedResources"])) {
                this.flaggedResources = [] as any;
                for (let item of _data["flaggedResources"])
                    this.flaggedResources!.push(TrustedAdvisorResourceDetail.fromJS(item));
            }
            this.resourcesSummary = _data["resourcesSummary"] ? TrustedAdvisorResourcesSummary.fromJS(_data["resourcesSummary"]) : undefined as any;
            this.status = _data["status"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): TrustedAdvisorCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categorySpecificSummary"] = this.categorySpecificSummary ? this.categorySpecificSummary.toJSON() : undefined as any;
        data["checkId"] = this.checkId;
        if (Array.isArray(this.flaggedResources)) {
            data["flaggedResources"] = [];
            for (let item of this.flaggedResources)
                data["flaggedResources"].push(item ? item.toJSON() : undefined as any);
        }
        data["resourcesSummary"] = this.resourcesSummary ? this.resourcesSummary.toJSON() : undefined as any;
        data["status"] = this.status;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface ITrustedAdvisorCheckResult {
    categorySpecificSummary?: TrustedAdvisorCategorySpecificSummary;
    checkId?: string | undefined;
    flaggedResources?: TrustedAdvisorResourceDetail[] | undefined;
    resourcesSummary?: TrustedAdvisorResourcesSummary;
    status?: string | undefined;
    timestamp?: string | undefined;
}

export class TrustedAdvisorCheckSummary implements ITrustedAdvisorCheckSummary {
    categorySpecificSummary?: TrustedAdvisorCategorySpecificSummary;
    checkId?: string | undefined;
    hasFlaggedResources?: boolean;
    resourcesSummary?: TrustedAdvisorResourcesSummary;
    status?: string | undefined;
    timestamp?: string | undefined;

    constructor(data?: ITrustedAdvisorCheckSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categorySpecificSummary = _data["categorySpecificSummary"] ? TrustedAdvisorCategorySpecificSummary.fromJS(_data["categorySpecificSummary"]) : undefined as any;
            this.checkId = _data["checkId"];
            this.hasFlaggedResources = _data["hasFlaggedResources"];
            this.resourcesSummary = _data["resourcesSummary"] ? TrustedAdvisorResourcesSummary.fromJS(_data["resourcesSummary"]) : undefined as any;
            this.status = _data["status"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): TrustedAdvisorCheckSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCheckSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categorySpecificSummary"] = this.categorySpecificSummary ? this.categorySpecificSummary.toJSON() : undefined as any;
        data["checkId"] = this.checkId;
        data["hasFlaggedResources"] = this.hasFlaggedResources;
        data["resourcesSummary"] = this.resourcesSummary ? this.resourcesSummary.toJSON() : undefined as any;
        data["status"] = this.status;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface ITrustedAdvisorCheckSummary {
    categorySpecificSummary?: TrustedAdvisorCategorySpecificSummary;
    checkId?: string | undefined;
    hasFlaggedResources?: boolean;
    resourcesSummary?: TrustedAdvisorResourcesSummary;
    status?: string | undefined;
    timestamp?: string | undefined;
}

export class TrustedAdvisorCostOptimizingSummary implements ITrustedAdvisorCostOptimizingSummary {
    estimatedMonthlySavings?: number;
    estimatedPercentMonthlySavings?: number;

    constructor(data?: ITrustedAdvisorCostOptimizingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedMonthlySavings = _data["estimatedMonthlySavings"];
            this.estimatedPercentMonthlySavings = _data["estimatedPercentMonthlySavings"];
        }
    }

    static fromJS(data: any): TrustedAdvisorCostOptimizingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorCostOptimizingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedMonthlySavings"] = this.estimatedMonthlySavings;
        data["estimatedPercentMonthlySavings"] = this.estimatedPercentMonthlySavings;
        return data;
    }
}

export interface ITrustedAdvisorCostOptimizingSummary {
    estimatedMonthlySavings?: number;
    estimatedPercentMonthlySavings?: number;
}

export class TrustedAdvisorResourceDetail implements ITrustedAdvisorResourceDetail {
    isSuppressed?: boolean;
    metadata?: string[] | undefined;
    region?: string | undefined;
    resourceId?: string | undefined;
    status?: string | undefined;

    constructor(data?: ITrustedAdvisorResourceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuppressed = _data["isSuppressed"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(item);
            }
            this.region = _data["region"];
            this.resourceId = _data["resourceId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TrustedAdvisorResourceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorResourceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuppressed"] = this.isSuppressed;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item);
        }
        data["region"] = this.region;
        data["resourceId"] = this.resourceId;
        data["status"] = this.status;
        return data;
    }
}

export interface ITrustedAdvisorResourceDetail {
    isSuppressed?: boolean;
    metadata?: string[] | undefined;
    region?: string | undefined;
    resourceId?: string | undefined;
    status?: string | undefined;
}

export class TrustedAdvisorResourcesSummary implements ITrustedAdvisorResourcesSummary {
    resourcesFlagged?: number;
    resourcesIgnored?: number;
    resourcesProcessed?: number;
    resourcesSuppressed?: number;

    constructor(data?: ITrustedAdvisorResourcesSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourcesFlagged = _data["resourcesFlagged"];
            this.resourcesIgnored = _data["resourcesIgnored"];
            this.resourcesProcessed = _data["resourcesProcessed"];
            this.resourcesSuppressed = _data["resourcesSuppressed"];
        }
    }

    static fromJS(data: any): TrustedAdvisorResourcesSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorResourcesSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourcesFlagged"] = this.resourcesFlagged;
        data["resourcesIgnored"] = this.resourcesIgnored;
        data["resourcesProcessed"] = this.resourcesProcessed;
        data["resourcesSuppressed"] = this.resourcesSuppressed;
        return data;
    }
}

export interface ITrustedAdvisorResourcesSummary {
    resourcesFlagged?: number;
    resourcesIgnored?: number;
    resourcesProcessed?: number;
    resourcesSuppressed?: number;
}

export class AssessmentStatus implements IAssessmentStatus {
    code?: string | undefined;
    cause?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAssessmentStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.cause = _data["cause"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AssessmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["cause"] = this.cause;
        data["description"] = this.description;
        return data;
    }
}

export interface IAssessmentStatus {
    code?: string | undefined;
    cause?: string | undefined;
    description?: string | undefined;
}

export class AzureResourceLink implements IAzureResourceLink {
    id?: string | undefined;
    securityAssessmentMetadata?: SecurityAssessmentMetadata;

    constructor(data?: IAzureResourceLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.securityAssessmentMetadata = _data["securityAssessmentMetadata"] ? SecurityAssessmentMetadata.fromJS(_data["securityAssessmentMetadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): AzureResourceLink {
        data = typeof data === 'object' ? data : {};
        let result = new AzureResourceLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["securityAssessmentMetadata"] = this.securityAssessmentMetadata ? this.securityAssessmentMetadata.toJSON() : undefined as any;
        return data;
    }
}

export interface IAzureResourceLink {
    id?: string | undefined;
    securityAssessmentMetadata?: SecurityAssessmentMetadata;
}

export class ErrorDetail implements IErrorDetail {
    code?: string | undefined;
    message?: string | undefined;
    recommendations?: string[] | undefined;

    constructor(data?: IErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            if (Array.isArray(_data["recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["recommendations"])
                    this.recommendations!.push(item);
            }
        }
    }

    static fromJS(data: any): ErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        if (Array.isArray(this.recommendations)) {
            data["recommendations"] = [];
            for (let item of this.recommendations)
                data["recommendations"].push(item);
        }
        return data;
    }
}

export interface IErrorDetail {
    code?: string | undefined;
    message?: string | undefined;
    recommendations?: string[] | undefined;
}

export class RegulatoryComplianceAssessment implements IRegulatoryComplianceAssessment {
    description?: string | undefined;
    assessmentType?: string | undefined;
    assessmentDetailsLink?: string | undefined;
    state?: string | undefined;
    passedResources?: number | undefined;
    failedResources?: number | undefined;
    skippedResources?: number | undefined;
    unsupportedResources?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: IRegulatoryComplianceAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.assessmentType = _data["assessmentType"];
            this.assessmentDetailsLink = _data["assessmentDetailsLink"];
            this.state = _data["state"];
            this.passedResources = _data["passedResources"];
            this.failedResources = _data["failedResources"];
            this.skippedResources = _data["skippedResources"];
            this.unsupportedResources = _data["unsupportedResources"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RegulatoryComplianceAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatoryComplianceAssessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["assessmentType"] = this.assessmentType;
        data["assessmentDetailsLink"] = this.assessmentDetailsLink;
        data["state"] = this.state;
        data["passedResources"] = this.passedResources;
        data["failedResources"] = this.failedResources;
        data["skippedResources"] = this.skippedResources;
        data["unsupportedResources"] = this.unsupportedResources;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IRegulatoryComplianceAssessment {
    description?: string | undefined;
    assessmentType?: string | undefined;
    assessmentDetailsLink?: string | undefined;
    state?: string | undefined;
    passedResources?: number | undefined;
    failedResources?: number | undefined;
    skippedResources?: number | undefined;
    unsupportedResources?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class RegulatoryComplianceControl implements IRegulatoryComplianceControl {
    description?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    state?: string | undefined;
    passedAssessments?: number | undefined;
    failedAssessments?: number | undefined;
    skippedAssessments?: number | undefined;
    complianceAssessments?: RegulatoryComplianceAssessment[] | undefined;

    constructor(data?: IRegulatoryComplianceControl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.state = _data["state"];
            this.passedAssessments = _data["passedAssessments"];
            this.failedAssessments = _data["failedAssessments"];
            this.skippedAssessments = _data["skippedAssessments"];
            if (Array.isArray(_data["complianceAssessments"])) {
                this.complianceAssessments = [] as any;
                for (let item of _data["complianceAssessments"])
                    this.complianceAssessments!.push(RegulatoryComplianceAssessment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegulatoryComplianceControl {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatoryComplianceControl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["state"] = this.state;
        data["passedAssessments"] = this.passedAssessments;
        data["failedAssessments"] = this.failedAssessments;
        data["skippedAssessments"] = this.skippedAssessments;
        if (Array.isArray(this.complianceAssessments)) {
            data["complianceAssessments"] = [];
            for (let item of this.complianceAssessments)
                data["complianceAssessments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegulatoryComplianceControl {
    description?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    state?: string | undefined;
    passedAssessments?: number | undefined;
    failedAssessments?: number | undefined;
    skippedAssessments?: number | undefined;
    complianceAssessments?: RegulatoryComplianceAssessment[] | undefined;
}

export class RegulatoryComplianceStandard implements IRegulatoryComplianceStandard {
    state?: string | undefined;
    passedControls?: number | undefined;
    failedControls?: number | undefined;
    skippedControls?: number | undefined;
    unsupportedControls?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    complianceControls?: RegulatoryComplianceControl[] | undefined;

    constructor(data?: IRegulatoryComplianceStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.passedControls = _data["passedControls"];
            this.failedControls = _data["failedControls"];
            this.skippedControls = _data["skippedControls"];
            this.unsupportedControls = _data["unsupportedControls"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["complianceControls"])) {
                this.complianceControls = [] as any;
                for (let item of _data["complianceControls"])
                    this.complianceControls!.push(RegulatoryComplianceControl.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegulatoryComplianceStandard {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatoryComplianceStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["passedControls"] = this.passedControls;
        data["failedControls"] = this.failedControls;
        data["skippedControls"] = this.skippedControls;
        data["unsupportedControls"] = this.unsupportedControls;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.complianceControls)) {
            data["complianceControls"] = [];
            for (let item of this.complianceControls)
                data["complianceControls"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegulatoryComplianceStandard {
    state?: string | undefined;
    passedControls?: number | undefined;
    failedControls?: number | undefined;
    skippedControls?: number | undefined;
    unsupportedControls?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    complianceControls?: RegulatoryComplianceControl[] | undefined;
}

export class ResourceRecommendation implements IResourceRecommendation {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    category?: string | undefined;
    impact?: string | undefined;
    impactedField?: string | undefined;
    impactedValue?: string | undefined;
    lastUpdated?: Date | undefined;
    metadata?: { [key: string]: any; } | undefined;
    recommendationTypeId?: string | undefined;
    risk?: string | undefined;
    shortDescription?: ShortDescription;
    suppressionIds?: (string | undefined)[] | undefined;
    extendedProperties?: { [key: string]: string; } | undefined;

    constructor(data?: IResourceRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.category = _data["category"];
            this.impact = _data["impact"];
            this.impactedField = _data["impactedField"];
            this.impactedValue = _data["impactedValue"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : undefined as any;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            this.recommendationTypeId = _data["recommendationTypeId"];
            this.risk = _data["risk"];
            this.shortDescription = _data["shortDescription"] ? ShortDescription.fromJS(_data["shortDescription"]) : undefined as any;
            if (Array.isArray(_data["suppressionIds"])) {
                this.suppressionIds = [] as any;
                for (let item of _data["suppressionIds"])
                    this.suppressionIds!.push(item);
            }
            if (_data["extendedProperties"]) {
                this.extendedProperties = {} as any;
                for (let key in _data["extendedProperties"]) {
                    if (_data["extendedProperties"].hasOwnProperty(key))
                        (this.extendedProperties as any)![key] = _data["extendedProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): ResourceRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["category"] = this.category;
        data["impact"] = this.impact;
        data["impactedField"] = this.impactedField;
        data["impactedValue"] = this.impactedValue;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined as any;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["recommendationTypeId"] = this.recommendationTypeId;
        data["risk"] = this.risk;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined as any;
        if (Array.isArray(this.suppressionIds)) {
            data["suppressionIds"] = [];
            for (let item of this.suppressionIds)
                data["suppressionIds"].push(item);
        }
        if (this.extendedProperties) {
            data["extendedProperties"] = {};
            for (let key in this.extendedProperties) {
                if (this.extendedProperties.hasOwnProperty(key))
                    (data["extendedProperties"] as any)[key] = (this.extendedProperties as any)[key];
            }
        }
        return data;
    }
}

export interface IResourceRecommendation {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    category?: string | undefined;
    impact?: string | undefined;
    impactedField?: string | undefined;
    impactedValue?: string | undefined;
    lastUpdated?: Date | undefined;
    metadata?: { [key: string]: any; } | undefined;
    recommendationTypeId?: string | undefined;
    risk?: string | undefined;
    shortDescription?: ShortDescription;
    suppressionIds?: (string | undefined)[] | undefined;
    extendedProperties?: { [key: string]: string; } | undefined;
}

export class AzureComplianceSubscriptionSummary implements IAzureComplianceSubscriptionSummary {
    regulatoryComplianceSummaries?: RegulatoryComplianceSummary[] | undefined;
    securityAssessmentSummary?: SecurityAssessmentSummary;

    constructor(data?: IAzureComplianceSubscriptionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["regulatoryComplianceSummaries"])) {
                this.regulatoryComplianceSummaries = [] as any;
                for (let item of _data["regulatoryComplianceSummaries"])
                    this.regulatoryComplianceSummaries!.push(RegulatoryComplianceSummary.fromJS(item));
            }
            this.securityAssessmentSummary = _data["securityAssessmentSummary"] ? SecurityAssessmentSummary.fromJS(_data["securityAssessmentSummary"]) : undefined as any;
        }
    }

    static fromJS(data: any): AzureComplianceSubscriptionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AzureComplianceSubscriptionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regulatoryComplianceSummaries)) {
            data["regulatoryComplianceSummaries"] = [];
            for (let item of this.regulatoryComplianceSummaries)
                data["regulatoryComplianceSummaries"].push(item ? item.toJSON() : undefined as any);
        }
        data["securityAssessmentSummary"] = this.securityAssessmentSummary ? this.securityAssessmentSummary.toJSON() : undefined as any;
        return data;
    }
}

export interface IAzureComplianceSubscriptionSummary {
    regulatoryComplianceSummaries?: RegulatoryComplianceSummary[] | undefined;
    securityAssessmentSummary?: SecurityAssessmentSummary;
}

export class RegulatoryComplianceSummary implements IRegulatoryComplianceSummary {
    name?: string | undefined;
    passedControls?: number | undefined;
    totalControls?: number;

    constructor(data?: IRegulatoryComplianceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.passedControls = _data["passedControls"];
            this.totalControls = _data["totalControls"];
        }
    }

    static fromJS(data: any): RegulatoryComplianceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatoryComplianceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["passedControls"] = this.passedControls;
        data["totalControls"] = this.totalControls;
        return data;
    }
}

export interface IRegulatoryComplianceSummary {
    name?: string | undefined;
    passedControls?: number | undefined;
    totalControls?: number;
}

export class SecurityAssessmentSummary implements ISecurityAssessmentSummary {
    healthyAssessments?: number;
    totalAssessments?: number;

    constructor(data?: ISecurityAssessmentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthyAssessments = _data["healthyAssessments"];
            this.totalAssessments = _data["totalAssessments"];
        }
    }

    static fromJS(data: any): SecurityAssessmentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAssessmentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthyAssessments"] = this.healthyAssessments;
        data["totalAssessments"] = this.totalAssessments;
        return data;
    }
}

export interface ISecurityAssessmentSummary {
    healthyAssessments?: number;
    totalAssessments?: number;
}

export class Subscription implements ISubscription {
    subscriptionId?: string | undefined;
    data?: SubscriptionData;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.data = _data["data"] ? SubscriptionData.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ISubscription {
    subscriptionId?: string | undefined;
    data?: SubscriptionData;
}

export class SubscriptionData implements ISubscriptionData {
    summary?: AzureComplianceSubscriptionSummary;
    secureScoreItem?: SecureScoreItem[] | undefined;
    regulatoryComplianceStandard?: RegulatoryComplianceStandard[] | undefined;
    securityAssessment?: SecurityAssessment[] | undefined;

    constructor(data?: ISubscriptionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? AzureComplianceSubscriptionSummary.fromJS(_data["summary"]) : undefined as any;
            if (Array.isArray(_data["secureScoreItem"])) {
                this.secureScoreItem = [] as any;
                for (let item of _data["secureScoreItem"])
                    this.secureScoreItem!.push(SecureScoreItem.fromJS(item));
            }
            if (Array.isArray(_data["regulatoryComplianceStandard"])) {
                this.regulatoryComplianceStandard = [] as any;
                for (let item of _data["regulatoryComplianceStandard"])
                    this.regulatoryComplianceStandard!.push(RegulatoryComplianceStandard.fromJS(item));
            }
            if (Array.isArray(_data["securityAssessment"])) {
                this.securityAssessment = [] as any;
                for (let item of _data["securityAssessment"])
                    this.securityAssessment!.push(SecurityAssessment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionData {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        if (Array.isArray(this.secureScoreItem)) {
            data["secureScoreItem"] = [];
            for (let item of this.secureScoreItem)
                data["secureScoreItem"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regulatoryComplianceStandard)) {
            data["regulatoryComplianceStandard"] = [];
            for (let item of this.regulatoryComplianceStandard)
                data["regulatoryComplianceStandard"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securityAssessment)) {
            data["securityAssessment"] = [];
            for (let item of this.securityAssessment)
                data["securityAssessment"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubscriptionData {
    summary?: AzureComplianceSubscriptionSummary;
    secureScoreItem?: SecureScoreItem[] | undefined;
    regulatoryComplianceStandard?: RegulatoryComplianceStandard[] | undefined;
    securityAssessment?: SecurityAssessment[] | undefined;
}

export class SecureScoreControlDefinitionItem implements ISecureScoreControlDefinitionItem {
    displayName?: string | undefined;
    description?: string | undefined;
    maxScore?: number | undefined;
    source?: SecureScoreControlDefinitionSource;
    assessmentDefinitions?: AzureResourceLink[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: ISecureScoreControlDefinitionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.maxScore = _data["maxScore"];
            this.source = _data["source"] ? SecureScoreControlDefinitionSource.fromJS(_data["source"]) : undefined as any;
            if (Array.isArray(_data["assessmentDefinitions"])) {
                this.assessmentDefinitions = [] as any;
                for (let item of _data["assessmentDefinitions"])
                    this.assessmentDefinitions!.push(AzureResourceLink.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SecureScoreControlDefinitionItem {
        data = typeof data === 'object' ? data : {};
        let result = new SecureScoreControlDefinitionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["maxScore"] = this.maxScore;
        data["source"] = this.source ? this.source.toJSON() : undefined as any;
        if (Array.isArray(this.assessmentDefinitions)) {
            data["assessmentDefinitions"] = [];
            for (let item of this.assessmentDefinitions)
                data["assessmentDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ISecureScoreControlDefinitionItem {
    displayName?: string | undefined;
    description?: string | undefined;
    maxScore?: number | undefined;
    source?: SecureScoreControlDefinitionSource;
    assessmentDefinitions?: AzureResourceLink[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class SecureScoreControlDefinitionSource implements ISecureScoreControlDefinitionSource {
    sourceType?: string | undefined;

    constructor(data?: ISecureScoreControlDefinitionSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceType = _data["sourceType"];
        }
    }

    static fromJS(data: any): SecureScoreControlDefinitionSource {
        data = typeof data === 'object' ? data : {};
        let result = new SecureScoreControlDefinitionSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        return data;
    }
}

export interface ISecureScoreControlDefinitionSource {
    sourceType?: string | undefined;
}

export class SecureScoreControlDetails implements ISecureScoreControlDetails {
    displayName?: string | undefined;
    max?: number | undefined;
    current?: number | undefined;
    percentage?: number | undefined;
    healthyResourceCount?: number | undefined;
    unhealthyResourceCount?: number | undefined;
    notApplicableResourceCount?: number | undefined;
    weight?: number | undefined;
    definition?: SecureScoreControlDefinitionItem;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: ISecureScoreControlDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.max = _data["max"];
            this.current = _data["current"];
            this.percentage = _data["percentage"];
            this.healthyResourceCount = _data["healthyResourceCount"];
            this.unhealthyResourceCount = _data["unhealthyResourceCount"];
            this.notApplicableResourceCount = _data["notApplicableResourceCount"];
            this.weight = _data["weight"];
            this.definition = _data["definition"] ? SecureScoreControlDefinitionItem.fromJS(_data["definition"]) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SecureScoreControlDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SecureScoreControlDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["max"] = this.max;
        data["current"] = this.current;
        data["percentage"] = this.percentage;
        data["healthyResourceCount"] = this.healthyResourceCount;
        data["unhealthyResourceCount"] = this.unhealthyResourceCount;
        data["notApplicableResourceCount"] = this.notApplicableResourceCount;
        data["weight"] = this.weight;
        data["definition"] = this.definition ? this.definition.toJSON() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ISecureScoreControlDetails {
    displayName?: string | undefined;
    max?: number | undefined;
    current?: number | undefined;
    percentage?: number | undefined;
    healthyResourceCount?: number | undefined;
    unhealthyResourceCount?: number | undefined;
    notApplicableResourceCount?: number | undefined;
    weight?: number | undefined;
    definition?: SecureScoreControlDefinitionItem;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class SecureScoreItem implements ISecureScoreItem {
    percentage?: number | undefined;
    current?: number | undefined;
    max?: number | undefined;
    weight?: number | undefined;
    displayName?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    controlDetails?: SecureScoreControlDetails[] | undefined;

    constructor(data?: ISecureScoreItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.current = _data["current"];
            this.max = _data["max"];
            this.weight = _data["weight"];
            this.displayName = _data["displayName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["controlDetails"])) {
                this.controlDetails = [] as any;
                for (let item of _data["controlDetails"])
                    this.controlDetails!.push(SecureScoreControlDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecureScoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new SecureScoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["current"] = this.current;
        data["max"] = this.max;
        data["weight"] = this.weight;
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.controlDetails)) {
            data["controlDetails"] = [];
            for (let item of this.controlDetails)
                data["controlDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISecureScoreItem {
    percentage?: number | undefined;
    current?: number | undefined;
    max?: number | undefined;
    weight?: number | undefined;
    displayName?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    controlDetails?: SecureScoreControlDetails[] | undefined;
}

export class SecurityAssessment implements ISecurityAssessment {
    displayName?: string | undefined;
    status?: AssessmentStatus;
    additionalData?: { [key: string]: string; } | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subAssessments?: SecuritySubAssessment[] | undefined;

    constructor(data?: ISecurityAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.status = _data["status"] ? AssessmentStatus.fromJS(_data["status"]) : undefined as any;
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["subAssessments"])) {
                this.subAssessments = [] as any;
                for (let item of _data["subAssessments"])
                    this.subAssessments!.push(SecuritySubAssessment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SecurityAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAssessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.subAssessments)) {
            data["subAssessments"] = [];
            for (let item of this.subAssessments)
                data["subAssessments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISecurityAssessment {
    displayName?: string | undefined;
    status?: AssessmentStatus;
    additionalData?: { [key: string]: string; } | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subAssessments?: SecuritySubAssessment[] | undefined;
}

export class SecurityAssessmentMetadata implements ISecurityAssessmentMetadata {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    displayName?: string | undefined;
    policyDefinitionId?: string | undefined;
    description?: string | undefined;
    remediationDescription?: string | undefined;
    category?: string[] | undefined;
    severity?: string | undefined;
    userImpact?: string | undefined;
    implementationEffort?: string | undefined;
    threats?: string[] | undefined;
    preview?: boolean | undefined;
    assessmentType?: string | undefined;
    partnerData?: SecurityAssessmentMetadataPartnerData;

    constructor(data?: ISecurityAssessmentMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.displayName = _data["displayName"];
            this.policyDefinitionId = _data["policyDefinitionId"];
            this.description = _data["description"];
            this.remediationDescription = _data["remediationDescription"];
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            this.severity = _data["severity"];
            this.userImpact = _data["userImpact"];
            this.implementationEffort = _data["implementationEffort"];
            if (Array.isArray(_data["threats"])) {
                this.threats = [] as any;
                for (let item of _data["threats"])
                    this.threats!.push(item);
            }
            this.preview = _data["preview"];
            this.assessmentType = _data["assessmentType"];
            this.partnerData = _data["partnerData"] ? SecurityAssessmentMetadataPartnerData.fromJS(_data["partnerData"]) : undefined as any;
        }
    }

    static fromJS(data: any): SecurityAssessmentMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAssessmentMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["displayName"] = this.displayName;
        data["policyDefinitionId"] = this.policyDefinitionId;
        data["description"] = this.description;
        data["remediationDescription"] = this.remediationDescription;
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        data["severity"] = this.severity;
        data["userImpact"] = this.userImpact;
        data["implementationEffort"] = this.implementationEffort;
        if (Array.isArray(this.threats)) {
            data["threats"] = [];
            for (let item of this.threats)
                data["threats"].push(item);
        }
        data["preview"] = this.preview;
        data["assessmentType"] = this.assessmentType;
        data["partnerData"] = this.partnerData ? this.partnerData.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecurityAssessmentMetadata {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    displayName?: string | undefined;
    policyDefinitionId?: string | undefined;
    description?: string | undefined;
    remediationDescription?: string | undefined;
    category?: string[] | undefined;
    severity?: string | undefined;
    userImpact?: string | undefined;
    implementationEffort?: string | undefined;
    threats?: string[] | undefined;
    preview?: boolean | undefined;
    assessmentType?: string | undefined;
    partnerData?: SecurityAssessmentMetadataPartnerData;
}

export class SecurityAssessmentMetadataPartnerData implements ISecurityAssessmentMetadataPartnerData {
    partnerName?: string | undefined;
    productName?: string | undefined;
    secret?: string | undefined;

    constructor(data?: ISecurityAssessmentMetadataPartnerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerName = _data["partnerName"];
            this.productName = _data["productName"];
            this.secret = _data["secret"];
        }
    }

    static fromJS(data: any): SecurityAssessmentMetadataPartnerData {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAssessmentMetadataPartnerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerName"] = this.partnerName;
        data["productName"] = this.productName;
        data["secret"] = this.secret;
        return data;
    }
}

export interface ISecurityAssessmentMetadataPartnerData {
    partnerName?: string | undefined;
    productName?: string | undefined;
    secret?: string | undefined;
}

export class SecuritySubAssessment implements ISecuritySubAssessment {
    securitySubAssessmentId?: string | undefined;
    displayName?: string | undefined;
    status?: SubAssessmentStatus;
    remediation?: string | undefined;
    impact?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    timeGenerated?: Date | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: ISecuritySubAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securitySubAssessmentId = _data["securitySubAssessmentId"];
            this.displayName = _data["displayName"];
            this.status = _data["status"] ? SubAssessmentStatus.fromJS(_data["status"]) : undefined as any;
            this.remediation = _data["remediation"];
            this.impact = _data["impact"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.timeGenerated = _data["timeGenerated"] ? new Date(_data["timeGenerated"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SecuritySubAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySubAssessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securitySubAssessmentId"] = this.securitySubAssessmentId;
        data["displayName"] = this.displayName;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["remediation"] = this.remediation;
        data["impact"] = this.impact;
        data["category"] = this.category;
        data["description"] = this.description;
        data["timeGenerated"] = this.timeGenerated ? this.timeGenerated.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ISecuritySubAssessment {
    securitySubAssessmentId?: string | undefined;
    displayName?: string | undefined;
    status?: SubAssessmentStatus;
    remediation?: string | undefined;
    impact?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    timeGenerated?: Date | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
}

export class ShortDescription implements IShortDescription {
    problem?: string | undefined;
    solution?: string | undefined;

    constructor(data?: IShortDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.problem = _data["problem"];
            this.solution = _data["solution"];
        }
    }

    static fromJS(data: any): ShortDescription {
        data = typeof data === 'object' ? data : {};
        let result = new ShortDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["problem"] = this.problem;
        data["solution"] = this.solution;
        return data;
    }
}

export interface IShortDescription {
    problem?: string | undefined;
    solution?: string | undefined;
}

export class SimpleProtectedItemResource implements ISimpleProtectedItemResource {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    location?: string | undefined;
    tags?: { [key: string]: string; } | undefined;
    eTag?: string | undefined;
    backupManagementType?: string | undefined;
    workloadType?: string | undefined;
    containerName?: string | undefined;
    sourceResourceId?: string | undefined;
    policyId?: string | undefined;
    lastRecoveryPoint?: Date | undefined;
    backupSetName?: string | undefined;
    createMode?: string | undefined;
    deferredDeleteTimeInUTC?: Date | undefined;
    isScheduledForDeferredDelete?: boolean | undefined;
    deferredDeleteTimeRemaining?: string | undefined;
    isDeferredDeleteScheduleUpcoming?: boolean | undefined;
    isRehydrate?: boolean | undefined;
    friendlyName?: string | undefined;
    protectionStatus?: string | undefined;
    protectionState?: string | undefined;
    lastBackupStatus?: string | undefined;
    lastBackupTime?: Date | undefined;
    healthStatus?: string | undefined;
    lastBackupErrorDetail?: ErrorDetail;
    virtualMachineId?: string | undefined;
    oldestRecoveryPoint?: Date | undefined;
    recoveryPointCount?: number | undefined;

    constructor(data?: ISimpleProtectedItemResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.location = _data["location"];
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (this.tags as any)![key] = _data["tags"][key];
                }
            }
            this.eTag = _data["eTag"];
            this.backupManagementType = _data["backupManagementType"];
            this.workloadType = _data["workloadType"];
            this.containerName = _data["containerName"];
            this.sourceResourceId = _data["sourceResourceId"];
            this.policyId = _data["policyId"];
            this.lastRecoveryPoint = _data["lastRecoveryPoint"] ? new Date(_data["lastRecoveryPoint"].toString()) : undefined as any;
            this.backupSetName = _data["backupSetName"];
            this.createMode = _data["createMode"];
            this.deferredDeleteTimeInUTC = _data["deferredDeleteTimeInUTC"] ? new Date(_data["deferredDeleteTimeInUTC"].toString()) : undefined as any;
            this.isScheduledForDeferredDelete = _data["isScheduledForDeferredDelete"];
            this.deferredDeleteTimeRemaining = _data["deferredDeleteTimeRemaining"];
            this.isDeferredDeleteScheduleUpcoming = _data["isDeferredDeleteScheduleUpcoming"];
            this.isRehydrate = _data["isRehydrate"];
            this.friendlyName = _data["friendlyName"];
            this.protectionStatus = _data["protectionStatus"];
            this.protectionState = _data["protectionState"];
            this.lastBackupStatus = _data["lastBackupStatus"];
            this.lastBackupTime = _data["lastBackupTime"] ? new Date(_data["lastBackupTime"].toString()) : undefined as any;
            this.healthStatus = _data["healthStatus"];
            this.lastBackupErrorDetail = _data["lastBackupErrorDetail"] ? ErrorDetail.fromJS(_data["lastBackupErrorDetail"]) : undefined as any;
            this.virtualMachineId = _data["virtualMachineId"];
            this.oldestRecoveryPoint = _data["oldestRecoveryPoint"] ? new Date(_data["oldestRecoveryPoint"].toString()) : undefined as any;
            this.recoveryPointCount = _data["recoveryPointCount"];
        }
    }

    static fromJS(data: any): SimpleProtectedItemResource {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleProtectedItemResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["location"] = this.location;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (data["tags"] as any)[key] = (this.tags as any)[key];
            }
        }
        data["eTag"] = this.eTag;
        data["backupManagementType"] = this.backupManagementType;
        data["workloadType"] = this.workloadType;
        data["containerName"] = this.containerName;
        data["sourceResourceId"] = this.sourceResourceId;
        data["policyId"] = this.policyId;
        data["lastRecoveryPoint"] = this.lastRecoveryPoint ? this.lastRecoveryPoint.toISOString() : undefined as any;
        data["backupSetName"] = this.backupSetName;
        data["createMode"] = this.createMode;
        data["deferredDeleteTimeInUTC"] = this.deferredDeleteTimeInUTC ? this.deferredDeleteTimeInUTC.toISOString() : undefined as any;
        data["isScheduledForDeferredDelete"] = this.isScheduledForDeferredDelete;
        data["deferredDeleteTimeRemaining"] = this.deferredDeleteTimeRemaining;
        data["isDeferredDeleteScheduleUpcoming"] = this.isDeferredDeleteScheduleUpcoming;
        data["isRehydrate"] = this.isRehydrate;
        data["friendlyName"] = this.friendlyName;
        data["protectionStatus"] = this.protectionStatus;
        data["protectionState"] = this.protectionState;
        data["lastBackupStatus"] = this.lastBackupStatus;
        data["lastBackupTime"] = this.lastBackupTime ? this.lastBackupTime.toISOString() : undefined as any;
        data["healthStatus"] = this.healthStatus;
        data["lastBackupErrorDetail"] = this.lastBackupErrorDetail ? this.lastBackupErrorDetail.toJSON() : undefined as any;
        data["virtualMachineId"] = this.virtualMachineId;
        data["oldestRecoveryPoint"] = this.oldestRecoveryPoint ? this.oldestRecoveryPoint.toISOString() : undefined as any;
        data["recoveryPointCount"] = this.recoveryPointCount;
        return data;
    }
}

export interface ISimpleProtectedItemResource {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    location?: string | undefined;
    tags?: { [key: string]: string; } | undefined;
    eTag?: string | undefined;
    backupManagementType?: string | undefined;
    workloadType?: string | undefined;
    containerName?: string | undefined;
    sourceResourceId?: string | undefined;
    policyId?: string | undefined;
    lastRecoveryPoint?: Date | undefined;
    backupSetName?: string | undefined;
    createMode?: string | undefined;
    deferredDeleteTimeInUTC?: Date | undefined;
    isScheduledForDeferredDelete?: boolean | undefined;
    deferredDeleteTimeRemaining?: string | undefined;
    isDeferredDeleteScheduleUpcoming?: boolean | undefined;
    isRehydrate?: boolean | undefined;
    friendlyName?: string | undefined;
    protectionStatus?: string | undefined;
    protectionState?: string | undefined;
    lastBackupStatus?: string | undefined;
    lastBackupTime?: Date | undefined;
    healthStatus?: string | undefined;
    lastBackupErrorDetail?: ErrorDetail;
    virtualMachineId?: string | undefined;
    oldestRecoveryPoint?: Date | undefined;
    recoveryPointCount?: number | undefined;
}

export class SubAssessmentStatus implements ISubAssessmentStatus {
    code?: string | undefined;
    cause?: string | undefined;
    description?: string | undefined;
    severity?: string | undefined;

    constructor(data?: ISubAssessmentStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.cause = _data["cause"];
            this.description = _data["description"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): SubAssessmentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SubAssessmentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["cause"] = this.cause;
        data["description"] = this.description;
        data["severity"] = this.severity;
        return data;
    }
}

export interface ISubAssessmentStatus {
    code?: string | undefined;
    cause?: string | undefined;
    description?: string | undefined;
    severity?: string | undefined;
}

export enum CollectionProcessingStatus {
    Failed = "Failed",
    Success = "Success",
}

export class HistoricalCollectionDetails implements IHistoricalCollectionDetails {
    customerId?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    status?: CollectionProcessingStatus;
    duration?: string;
    integrationType?: number;
    exceptionMessage?: string | undefined;
    exceptionTime?: Date | undefined;
    _ts?: Date;

    constructor(data?: IHistoricalCollectionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.status = _data["status"];
            this.duration = _data["duration"];
            this.integrationType = _data["integrationType"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.exceptionTime = _data["exceptionTime"] ? new Date(_data["exceptionTime"].toString()) : undefined as any;
            this._ts = _data["_ts"] ? new Date(_data["_ts"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): HistoricalCollectionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalCollectionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["status"] = this.status;
        data["duration"] = this.duration;
        data["integrationType"] = this.integrationType;
        data["exceptionMessage"] = this.exceptionMessage;
        data["exceptionTime"] = this.exceptionTime ? this.exceptionTime.toISOString() : undefined as any;
        data["_ts"] = this._ts ? this._ts.toISOString() : undefined as any;
        return data;
    }
}

export interface IHistoricalCollectionDetails {
    customerId?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    status?: CollectionProcessingStatus;
    duration?: string;
    integrationType?: number;
    exceptionMessage?: string | undefined;
    exceptionTime?: Date | undefined;
    _ts?: Date;
}

export class CspPriceDto implements ICspPriceDto {
    cspPartNum?: string | undefined;
    cspPartName?: string | undefined;
    salesPrice?: number;
    serviceType?: string | undefined;
    blockNew?: boolean;
    endCustomerType?: string | undefined;
    nce?: boolean;
    termDuration?: string | undefined;
    billingOption?: string | undefined;

    constructor(data?: ICspPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cspPartNum = _data["cspPartNum"];
            this.cspPartName = _data["cspPartName"];
            this.salesPrice = _data["salesPrice"];
            this.serviceType = _data["serviceType"];
            this.blockNew = _data["blockNew"];
            this.endCustomerType = _data["endCustomerType"];
            this.nce = _data["nce"];
            this.termDuration = _data["termDuration"];
            this.billingOption = _data["billingOption"];
        }
    }

    static fromJS(data: any): CspPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cspPartNum"] = this.cspPartNum;
        data["cspPartName"] = this.cspPartName;
        data["salesPrice"] = this.salesPrice;
        data["serviceType"] = this.serviceType;
        data["blockNew"] = this.blockNew;
        data["endCustomerType"] = this.endCustomerType;
        data["nce"] = this.nce;
        data["termDuration"] = this.termDuration;
        data["billingOption"] = this.billingOption;
        return data;
    }
}

export interface ICspPriceDto {
    cspPartNum?: string | undefined;
    cspPartName?: string | undefined;
    salesPrice?: number;
    serviceType?: string | undefined;
    blockNew?: boolean;
    endCustomerType?: string | undefined;
    nce?: boolean;
    termDuration?: string | undefined;
    billingOption?: string | undefined;
}

export class BulkConfigurationItemResult implements IBulkConfigurationItemResult {
    referenceNumber?: string | undefined;
    success?: boolean;
    errorType?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IBulkConfigurationItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceNumber = _data["referenceNumber"];
            this.success = _data["success"];
            this.errorType = _data["errorType"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BulkConfigurationItemResult {
        data = typeof data === 'object' ? data : {};
        let result = new BulkConfigurationItemResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceNumber"] = this.referenceNumber;
        data["success"] = this.success;
        data["errorType"] = this.errorType;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBulkConfigurationItemResult {
    referenceNumber?: string | undefined;
    success?: boolean;
    errorType?: string | undefined;
    errorMessage?: string | undefined;
}

export class ConfigurationItemCacheResponse implements IConfigurationItemCacheResponse {
    configurationItem?: ConfigurationItem;
    configurationItemId?: number | undefined;
    responseStatus?: number;
    message?: string | undefined;
    syncErrorOccurred?: boolean;
    syncErrorMessage?: string | undefined;

    constructor(data?: IConfigurationItemCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItem = _data["configurationItem"] ? ConfigurationItem.fromJS(_data["configurationItem"]) : undefined as any;
            this.configurationItemId = _data["configurationItemId"];
            this.responseStatus = _data["responseStatus"];
            this.message = _data["message"];
            this.syncErrorOccurred = _data["syncErrorOccurred"];
            this.syncErrorMessage = _data["syncErrorMessage"];
        }
    }

    static fromJS(data: any): ConfigurationItemCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationItemCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItem"] = this.configurationItem ? this.configurationItem.toJSON() : undefined as any;
        data["configurationItemId"] = this.configurationItemId;
        data["responseStatus"] = this.responseStatus;
        data["message"] = this.message;
        data["syncErrorOccurred"] = this.syncErrorOccurred;
        data["syncErrorMessage"] = this.syncErrorMessage;
        return data;
    }
}

export interface IConfigurationItemCacheResponse {
    configurationItem?: ConfigurationItem;
    configurationItemId?: number | undefined;
    responseStatus?: number;
    message?: string | undefined;
    syncErrorOccurred?: boolean;
    syncErrorMessage?: string | undefined;
}

export class ConfigurationItemsCacheResponse implements IConfigurationItemsCacheResponse {
    createdConfigurationItems?: ConfigurationItem[] | undefined;
    updatedConfigurationItems?: ConfigurationItem[] | undefined;
    inactivatedConfigurationItems?: ConfigurationItem[] | undefined;
    configurationItemIds?: number[] | undefined;
    itemResults?: BulkConfigurationItemResult[] | undefined;
    responseStatus?: number;
    message?: string | undefined;
    syncErrorOccurred?: boolean;
    syncErrorMessage?: string | undefined;

    constructor(data?: IConfigurationItemsCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["createdConfigurationItems"])) {
                this.createdConfigurationItems = [] as any;
                for (let item of _data["createdConfigurationItems"])
                    this.createdConfigurationItems!.push(ConfigurationItem.fromJS(item));
            }
            if (Array.isArray(_data["updatedConfigurationItems"])) {
                this.updatedConfigurationItems = [] as any;
                for (let item of _data["updatedConfigurationItems"])
                    this.updatedConfigurationItems!.push(ConfigurationItem.fromJS(item));
            }
            if (Array.isArray(_data["inactivatedConfigurationItems"])) {
                this.inactivatedConfigurationItems = [] as any;
                for (let item of _data["inactivatedConfigurationItems"])
                    this.inactivatedConfigurationItems!.push(ConfigurationItem.fromJS(item));
            }
            if (Array.isArray(_data["configurationItemIds"])) {
                this.configurationItemIds = [] as any;
                for (let item of _data["configurationItemIds"])
                    this.configurationItemIds!.push(item);
            }
            if (Array.isArray(_data["itemResults"])) {
                this.itemResults = [] as any;
                for (let item of _data["itemResults"])
                    this.itemResults!.push(BulkConfigurationItemResult.fromJS(item));
            }
            this.responseStatus = _data["responseStatus"];
            this.message = _data["message"];
            this.syncErrorOccurred = _data["syncErrorOccurred"];
            this.syncErrorMessage = _data["syncErrorMessage"];
        }
    }

    static fromJS(data: any): ConfigurationItemsCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationItemsCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.createdConfigurationItems)) {
            data["createdConfigurationItems"] = [];
            for (let item of this.createdConfigurationItems)
                data["createdConfigurationItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.updatedConfigurationItems)) {
            data["updatedConfigurationItems"] = [];
            for (let item of this.updatedConfigurationItems)
                data["updatedConfigurationItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inactivatedConfigurationItems)) {
            data["inactivatedConfigurationItems"] = [];
            for (let item of this.inactivatedConfigurationItems)
                data["inactivatedConfigurationItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.configurationItemIds)) {
            data["configurationItemIds"] = [];
            for (let item of this.configurationItemIds)
                data["configurationItemIds"].push(item);
        }
        if (Array.isArray(this.itemResults)) {
            data["itemResults"] = [];
            for (let item of this.itemResults)
                data["itemResults"].push(item ? item.toJSON() : undefined as any);
        }
        data["responseStatus"] = this.responseStatus;
        data["message"] = this.message;
        data["syncErrorOccurred"] = this.syncErrorOccurred;
        data["syncErrorMessage"] = this.syncErrorMessage;
        return data;
    }
}

export interface IConfigurationItemsCacheResponse {
    createdConfigurationItems?: ConfigurationItem[] | undefined;
    updatedConfigurationItems?: ConfigurationItem[] | undefined;
    inactivatedConfigurationItems?: ConfigurationItem[] | undefined;
    configurationItemIds?: number[] | undefined;
    itemResults?: BulkConfigurationItemResult[] | undefined;
    responseStatus?: number;
    message?: string | undefined;
    syncErrorOccurred?: boolean;
    syncErrorMessage?: string | undefined;
}

export class AddSecurityGroupConfigItemsRequest implements IAddSecurityGroupConfigItemsRequest {
    configItems!: TeamConfigItemDto[] | undefined;

    constructor(data?: IAddSecurityGroupConfigItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["configItems"])) {
                this.configItems = [] as any;
                for (let item of _data["configItems"])
                    this.configItems!.push(TeamConfigItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddSecurityGroupConfigItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddSecurityGroupConfigItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.configItems)) {
            data["configItems"] = [];
            for (let item of this.configItems)
                data["configItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddSecurityGroupConfigItemsRequest {
    configItems: TeamConfigItemDto[] | undefined;
}

export class AddUsersToStorefrontGroupRequest implements IAddUsersToStorefrontGroupRequest {
    users!: StorefrontGroupUserRoleRequest[];

    constructor(data?: IAddUsersToStorefrontGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(StorefrontGroupUserRoleRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddUsersToStorefrontGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUsersToStorefrontGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddUsersToStorefrontGroupRequest {
    users: StorefrontGroupUserRoleRequest[];
}

export class ApproveUserRequest implements IApproveUserRequest {
    userId?: string;
    role?: PortalRole;

    constructor(data?: IApproveUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ApproveUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["role"] = this.role;
        return data;
    }
}

export interface IApproveUserRequest {
    userId?: string;
    role?: PortalRole;
}

export class AutotaskContractResourceJson implements IAutotaskContractResourceJson {
    contractId?: number;
    configItems?: number[] | undefined;
    enabledIssueTypes?: number[] | undefined;
    ticketCategoryMappings?: AutotaskTicketCategoryMappingResourceJson[] | undefined;

    constructor(data?: IAutotaskContractResourceJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            if (Array.isArray(_data["configItems"])) {
                this.configItems = [] as any;
                for (let item of _data["configItems"])
                    this.configItems!.push(item);
            }
            if (Array.isArray(_data["enabledIssueTypes"])) {
                this.enabledIssueTypes = [] as any;
                for (let item of _data["enabledIssueTypes"])
                    this.enabledIssueTypes!.push(item);
            }
            if (Array.isArray(_data["ticketCategoryMappings"])) {
                this.ticketCategoryMappings = [] as any;
                for (let item of _data["ticketCategoryMappings"])
                    this.ticketCategoryMappings!.push(AutotaskTicketCategoryMappingResourceJson.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutotaskContractResourceJson {
        data = typeof data === 'object' ? data : {};
        let result = new AutotaskContractResourceJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        if (Array.isArray(this.configItems)) {
            data["configItems"] = [];
            for (let item of this.configItems)
                data["configItems"].push(item);
        }
        if (Array.isArray(this.enabledIssueTypes)) {
            data["enabledIssueTypes"] = [];
            for (let item of this.enabledIssueTypes)
                data["enabledIssueTypes"].push(item);
        }
        if (Array.isArray(this.ticketCategoryMappings)) {
            data["ticketCategoryMappings"] = [];
            for (let item of this.ticketCategoryMappings)
                data["ticketCategoryMappings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAutotaskContractResourceJson {
    contractId?: number;
    configItems?: number[] | undefined;
    enabledIssueTypes?: number[] | undefined;
    ticketCategoryMappings?: AutotaskTicketCategoryMappingResourceJson[] | undefined;
}

export class AutotaskTicketCategoryMappingResourceJson implements IAutotaskTicketCategoryMappingResourceJson {
    ticketCategoryMappingId?: number;
    enabledIssueTypes?: number[] | undefined;

    constructor(data?: IAutotaskTicketCategoryMappingResourceJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketCategoryMappingId = _data["ticketCategoryMappingId"];
            if (Array.isArray(_data["enabledIssueTypes"])) {
                this.enabledIssueTypes = [] as any;
                for (let item of _data["enabledIssueTypes"])
                    this.enabledIssueTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): AutotaskTicketCategoryMappingResourceJson {
        data = typeof data === 'object' ? data : {};
        let result = new AutotaskTicketCategoryMappingResourceJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketCategoryMappingId"] = this.ticketCategoryMappingId;
        if (Array.isArray(this.enabledIssueTypes)) {
            data["enabledIssueTypes"] = [];
            for (let item of this.enabledIssueTypes)
                data["enabledIssueTypes"].push(item);
        }
        return data;
    }
}

export interface IAutotaskTicketCategoryMappingResourceJson {
    ticketCategoryMappingId?: number;
    enabledIssueTypes?: number[] | undefined;
}

export class CreateCxUserRequest implements ICreateCxUserRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    role?: PortalRole;
    securityGroupIds?: number[] | undefined;

    constructor(data?: ICreateCxUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.role = _data["role"];
            if (Array.isArray(_data["securityGroupIds"])) {
                this.securityGroupIds = [] as any;
                for (let item of _data["securityGroupIds"])
                    this.securityGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateCxUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCxUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["role"] = this.role;
        if (Array.isArray(this.securityGroupIds)) {
            data["securityGroupIds"] = [];
            for (let item of this.securityGroupIds)
                data["securityGroupIds"].push(item);
        }
        return data;
    }
}

export interface ICreateCxUserRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    role?: PortalRole;
    securityGroupIds?: number[] | undefined;
}

export class CurrentUserDrawerResponse implements ICurrentUserDrawerResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    profilePhotoUrl?: string | undefined;
    roleDisplayName?: string | undefined;
    isGuestUser?: boolean;
    isCustomerAdmin?: boolean;
    isShi?: boolean;
    isImpersonating?: boolean;
    accountName?: string | undefined;
    primaryAxNumber?: string | undefined;
    securityGroups?: CurrentUserSecurityGroupDto[] | undefined;
    storefronts?: CurrentUserStorefrontDto[] | undefined;

    constructor(data?: ICurrentUserDrawerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.profilePhotoUrl = _data["profilePhotoUrl"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isGuestUser = _data["isGuestUser"];
            this.isCustomerAdmin = _data["isCustomerAdmin"];
            this.isShi = _data["isShi"];
            this.isImpersonating = _data["isImpersonating"];
            this.accountName = _data["accountName"];
            this.primaryAxNumber = _data["primaryAxNumber"];
            if (Array.isArray(_data["securityGroups"])) {
                this.securityGroups = [] as any;
                for (let item of _data["securityGroups"])
                    this.securityGroups!.push(CurrentUserSecurityGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["storefronts"])) {
                this.storefronts = [] as any;
                for (let item of _data["storefronts"])
                    this.storefronts!.push(CurrentUserStorefrontDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurrentUserDrawerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserDrawerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["profilePhotoUrl"] = this.profilePhotoUrl;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isGuestUser"] = this.isGuestUser;
        data["isCustomerAdmin"] = this.isCustomerAdmin;
        data["isShi"] = this.isShi;
        data["isImpersonating"] = this.isImpersonating;
        data["accountName"] = this.accountName;
        data["primaryAxNumber"] = this.primaryAxNumber;
        if (Array.isArray(this.securityGroups)) {
            data["securityGroups"] = [];
            for (let item of this.securityGroups)
                data["securityGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.storefronts)) {
            data["storefronts"] = [];
            for (let item of this.storefronts)
                data["storefronts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICurrentUserDrawerResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    profilePhotoUrl?: string | undefined;
    roleDisplayName?: string | undefined;
    isGuestUser?: boolean;
    isCustomerAdmin?: boolean;
    isShi?: boolean;
    isImpersonating?: boolean;
    accountName?: string | undefined;
    primaryAxNumber?: string | undefined;
    securityGroups?: CurrentUserSecurityGroupDto[] | undefined;
    storefronts?: CurrentUserStorefrontDto[] | undefined;
}

export class CurrentUserSecurityGroupDto implements ICurrentUserSecurityGroupDto {
    id?: number;
    name?: string | undefined;
    role?: string | undefined;
    isDefaultGroup?: boolean;

    constructor(data?: ICurrentUserSecurityGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.role = _data["role"];
            this.isDefaultGroup = _data["isDefaultGroup"];
        }
    }

    static fromJS(data: any): CurrentUserSecurityGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserSecurityGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["role"] = this.role;
        data["isDefaultGroup"] = this.isDefaultGroup;
        return data;
    }
}

export interface ICurrentUserSecurityGroupDto {
    id?: number;
    name?: string | undefined;
    role?: string | undefined;
    isDefaultGroup?: boolean;
}

export class CurrentUserStorefrontDto implements ICurrentUserStorefrontDto {
    id?: number;
    name?: string | undefined;
    role?: string | undefined;

    constructor(data?: ICurrentUserStorefrontDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): CurrentUserStorefrontDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserStorefrontDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["role"] = this.role;
        return data;
    }
}

export interface ICurrentUserStorefrontDto {
    id?: number;
    name?: string | undefined;
    role?: string | undefined;
}

export class CustomerExperienceUserPropertiesDto implements ICustomerExperienceUserPropertiesDto {
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    email!: string | undefined;
    profilePhoto?: string | undefined;

    constructor(data?: ICustomerExperienceUserPropertiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.email = _data["email"];
            this.profilePhoto = _data["profilePhoto"];
        }
    }

    static fromJS(data: any): CustomerExperienceUserPropertiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerExperienceUserPropertiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["email"] = this.email;
        data["profilePhoto"] = this.profilePhoto;
        return data;
    }
}

export interface ICustomerExperienceUserPropertiesDto {
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    email: string | undefined;
    profilePhoto?: string | undefined;
}

export class CxAccountUsersPageRequest implements ICxAccountUsersPageRequest {
    page?: number;
    pageSize?: number;
    searchString?: string | undefined;
    sortColumn?: string | undefined;
    sortDescending?: boolean;
    userTypeFilter?: CxUserTypeFilter;

    constructor(data?: ICxAccountUsersPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.searchString = _data["searchString"];
            this.sortColumn = _data["sortColumn"];
            this.sortDescending = _data["sortDescending"];
            this.userTypeFilter = _data["userTypeFilter"];
        }
    }

    static fromJS(data: any): CxAccountUsersPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CxAccountUsersPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["searchString"] = this.searchString;
        data["sortColumn"] = this.sortColumn;
        data["sortDescending"] = this.sortDescending;
        data["userTypeFilter"] = this.userTypeFilter;
        return data;
    }
}

export interface ICxAccountUsersPageRequest {
    page?: number;
    pageSize?: number;
    searchString?: string | undefined;
    sortColumn?: string | undefined;
    sortDescending?: boolean;
    userTypeFilter?: CxUserTypeFilter;
}

export class CxCreateGuestUsersRequest implements ICxCreateGuestUsersRequest {
    emailAddresses?: string[] | undefined;
    permissions?: string[] | undefined;

    constructor(data?: ICxCreateGuestUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [] as any;
                for (let item of _data["emailAddresses"])
                    this.emailAddresses!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CxCreateGuestUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CxCreateGuestUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface ICxCreateGuestUsersRequest {
    emailAddresses?: string[] | undefined;
    permissions?: string[] | undefined;
}

export class CxEmailGuestUsersRequest implements ICxEmailGuestUsersRequest {
    emailAddresses?: string[] | undefined;

    constructor(data?: ICxEmailGuestUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [] as any;
                for (let item of _data["emailAddresses"])
                    this.emailAddresses!.push(item);
            }
        }
    }

    static fromJS(data: any): CxEmailGuestUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CxEmailGuestUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        return data;
    }
}

export interface ICxEmailGuestUsersRequest {
    emailAddresses?: string[] | undefined;
}

export class CxGuestUserDto implements ICxGuestUserDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    permissions?: string[] | undefined;

    constructor(data?: ICxGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CxGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CxGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface ICxGuestUserDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    permissions?: string[] | undefined;
}

export class CxSecurityGroupContractDto implements ICxSecurityGroupContractDto {
    contractId!: number;
    configItems?: number[] | undefined;
    enabledIssueTypes?: number[] | undefined;
    ticketCategoryMappings?: AutotaskTicketCategoryMappingResourceJson[] | undefined;
    accountId?: number | undefined;
    accountName?: string | undefined;
    contractName?: string | undefined;
    status?: number | undefined;
    contractCategory?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    configItemDetails?: SecurityGroupConfigItemDetailsDto[] | undefined;

    constructor(data?: ICxSecurityGroupContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            if (Array.isArray(_data["configItems"])) {
                this.configItems = [] as any;
                for (let item of _data["configItems"])
                    this.configItems!.push(item);
            }
            if (Array.isArray(_data["enabledIssueTypes"])) {
                this.enabledIssueTypes = [] as any;
                for (let item of _data["enabledIssueTypes"])
                    this.enabledIssueTypes!.push(item);
            }
            if (Array.isArray(_data["ticketCategoryMappings"])) {
                this.ticketCategoryMappings = [] as any;
                for (let item of _data["ticketCategoryMappings"])
                    this.ticketCategoryMappings!.push(AutotaskTicketCategoryMappingResourceJson.fromJS(item));
            }
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.contractName = _data["contractName"];
            this.status = _data["status"];
            this.contractCategory = _data["contractCategory"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            if (Array.isArray(_data["configItemDetails"])) {
                this.configItemDetails = [] as any;
                for (let item of _data["configItemDetails"])
                    this.configItemDetails!.push(SecurityGroupConfigItemDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CxSecurityGroupContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new CxSecurityGroupContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        if (Array.isArray(this.configItems)) {
            data["configItems"] = [];
            for (let item of this.configItems)
                data["configItems"].push(item);
        }
        if (Array.isArray(this.enabledIssueTypes)) {
            data["enabledIssueTypes"] = [];
            for (let item of this.enabledIssueTypes)
                data["enabledIssueTypes"].push(item);
        }
        if (Array.isArray(this.ticketCategoryMappings)) {
            data["ticketCategoryMappings"] = [];
            for (let item of this.ticketCategoryMappings)
                data["ticketCategoryMappings"].push(item ? item.toJSON() : undefined as any);
        }
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["contractName"] = this.contractName;
        data["status"] = this.status;
        data["contractCategory"] = this.contractCategory;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        if (Array.isArray(this.configItemDetails)) {
            data["configItemDetails"] = [];
            for (let item of this.configItemDetails)
                data["configItemDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICxSecurityGroupContractDto {
    contractId: number;
    configItems?: number[] | undefined;
    enabledIssueTypes?: number[] | undefined;
    ticketCategoryMappings?: AutotaskTicketCategoryMappingResourceJson[] | undefined;
    accountId?: number | undefined;
    accountName?: string | undefined;
    contractName?: string | undefined;
    status?: number | undefined;
    contractCategory?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    configItemDetails?: SecurityGroupConfigItemDetailsDto[] | undefined;
}

export class CxSecurityGroupDetailsDto implements ICxSecurityGroupDetailsDto {
    id!: number;
    name!: string | undefined;
    tenantId?: string | undefined;
    isDefaultGroup?: boolean;
    isSystemGroup?: boolean;
    members?: CxSecurityGroupMemberDto[] | undefined;
    permissions?: string[] | undefined;
    contracts?: AutotaskContractResourceJson[] | undefined;
    contractDetails?: CxSecurityGroupContractDto[] | undefined;

    constructor(data?: ICxSecurityGroupDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.tenantId = _data["tenantId"];
            this.isDefaultGroup = _data["isDefaultGroup"];
            this.isSystemGroup = _data["isSystemGroup"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(CxSecurityGroupMemberDto.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(AutotaskContractResourceJson.fromJS(item));
            }
            if (Array.isArray(_data["contractDetails"])) {
                this.contractDetails = [] as any;
                for (let item of _data["contractDetails"])
                    this.contractDetails!.push(CxSecurityGroupContractDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CxSecurityGroupDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CxSecurityGroupDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["isDefaultGroup"] = this.isDefaultGroup;
        data["isSystemGroup"] = this.isSystemGroup;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractDetails)) {
            data["contractDetails"] = [];
            for (let item of this.contractDetails)
                data["contractDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICxSecurityGroupDetailsDto {
    id: number;
    name: string | undefined;
    tenantId?: string | undefined;
    isDefaultGroup?: boolean;
    isSystemGroup?: boolean;
    members?: CxSecurityGroupMemberDto[] | undefined;
    permissions?: string[] | undefined;
    contracts?: AutotaskContractResourceJson[] | undefined;
    contractDetails?: CxSecurityGroupContractDto[] | undefined;
}

export class CxSecurityGroupDto implements ICxSecurityGroupDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ICxSecurityGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CxSecurityGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CxSecurityGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICxSecurityGroupDto {
    id?: number;
    name?: string | undefined;
}

export class CxSecurityGroupMemberDto implements ICxSecurityGroupMemberDto {
    userId!: string;
    canEditSecurityGroup!: boolean;

    constructor(data?: ICxSecurityGroupMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.canEditSecurityGroup = _data["canEditSecurityGroup"];
        }
    }

    static fromJS(data: any): CxSecurityGroupMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CxSecurityGroupMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["canEditSecurityGroup"] = this.canEditSecurityGroup;
        return data;
    }
}

export interface ICxSecurityGroupMemberDto {
    userId: string;
    canEditSecurityGroup: boolean;
}

export class CxTenantBasicInfoDto implements ICxTenantBasicInfoDto {
    tenantId?: string;
    activeCount?: number;
    inactiveCount?: number;
    awaitingApprovalCount?: number;
    pendingCount?: number;
    guestCount?: number;

    constructor(data?: ICxTenantBasicInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.activeCount = _data["activeCount"];
            this.inactiveCount = _data["inactiveCount"];
            this.awaitingApprovalCount = _data["awaitingApprovalCount"];
            this.pendingCount = _data["pendingCount"];
            this.guestCount = _data["guestCount"];
        }
    }

    static fromJS(data: any): CxTenantBasicInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CxTenantBasicInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["activeCount"] = this.activeCount;
        data["inactiveCount"] = this.inactiveCount;
        data["awaitingApprovalCount"] = this.awaitingApprovalCount;
        data["pendingCount"] = this.pendingCount;
        data["guestCount"] = this.guestCount;
        return data;
    }
}

export interface ICxTenantBasicInfoDto {
    tenantId?: string;
    activeCount?: number;
    inactiveCount?: number;
    awaitingApprovalCount?: number;
    pendingCount?: number;
    guestCount?: number;
}

export class CxUpdateGuestUserPermissionsRequest implements ICxUpdateGuestUserPermissionsRequest {
    permissions?: string[] | undefined;

    constructor(data?: ICxUpdateGuestUserPermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CxUpdateGuestUserPermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CxUpdateGuestUserPermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface ICxUpdateGuestUserPermissionsRequest {
    permissions?: string[] | undefined;
}

export class CxUserAccountDto implements ICxUserAccountDto {
    id!: string;
    shiComEmployeeId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email!: string | undefined;
    photo?: string | undefined;
    isAdmin?: boolean;
    isGuest?: boolean;
    active?: boolean;
    pending?: boolean;
    awaitingApproval?: boolean;

    constructor(data?: ICxUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiComEmployeeId = _data["shiComEmployeeId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.photo = _data["photo"];
            this.isAdmin = _data["isAdmin"];
            this.isGuest = _data["isGuest"];
            this.active = _data["active"];
            this.pending = _data["pending"];
            this.awaitingApproval = _data["awaitingApproval"];
        }
    }

    static fromJS(data: any): CxUserAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CxUserAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiComEmployeeId"] = this.shiComEmployeeId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["photo"] = this.photo;
        data["isAdmin"] = this.isAdmin;
        data["isGuest"] = this.isGuest;
        data["active"] = this.active;
        data["pending"] = this.pending;
        data["awaitingApproval"] = this.awaitingApproval;
        return data;
    }
}

export interface ICxUserAccountDto {
    id: string;
    shiComEmployeeId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email: string | undefined;
    photo?: string | undefined;
    isAdmin?: boolean;
    isGuest?: boolean;
    active?: boolean;
    pending?: boolean;
    awaitingApproval?: boolean;
}

export enum CxUserTypeFilter {
    All = "All",
    Inactive = "Inactive",
    Pending = "Pending",
    AwaitingApproval = "AwaitingApproval",
    Active = "Active",
    ActiveOrGuest = "ActiveOrGuest",
}

export class CxUsersByTenantRequestDto implements ICxUsersByTenantRequestDto {
    tenantId?: string;
    page?: number;
    pageSize?: number;
    searchString?: string | undefined;
    sortColumn?: string | undefined;
    sortDescending?: boolean;
    userTypeFilter?: CxUserTypeFilter;

    constructor(data?: ICxUsersByTenantRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.searchString = _data["searchString"];
            this.sortColumn = _data["sortColumn"];
            this.sortDescending = _data["sortDescending"];
            this.userTypeFilter = _data["userTypeFilter"];
        }
    }

    static fromJS(data: any): CxUsersByTenantRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CxUsersByTenantRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["searchString"] = this.searchString;
        data["sortColumn"] = this.sortColumn;
        data["sortDescending"] = this.sortDescending;
        data["userTypeFilter"] = this.userTypeFilter;
        return data;
    }
}

export interface ICxUsersByTenantRequestDto {
    tenantId?: string;
    page?: number;
    pageSize?: number;
    searchString?: string | undefined;
    sortColumn?: string | undefined;
    sortDescending?: boolean;
    userTypeFilter?: CxUserTypeFilter;
}

export class InviteLinkDomainCheckRequest implements IInviteLinkDomainCheckRequest {
    invitationId?: string;
    email?: string | undefined;

    constructor(data?: IInviteLinkDomainCheckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationId = _data["invitationId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): InviteLinkDomainCheckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteLinkDomainCheckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationId"] = this.invitationId;
        data["email"] = this.email;
        return data;
    }
}

export interface IInviteLinkDomainCheckRequest {
    invitationId?: string;
    email?: string | undefined;
}

export class InviteLinkDomainCheckResponse implements IInviteLinkDomainCheckResponse {
    isAllowed?: boolean;
    message?: string | undefined;

    constructor(data?: IInviteLinkDomainCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAllowed = _data["isAllowed"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InviteLinkDomainCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InviteLinkDomainCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAllowed"] = this.isAllowed;
        data["message"] = this.message;
        return data;
    }
}

export interface IInviteLinkDomainCheckResponse {
    isAllowed?: boolean;
    message?: string | undefined;
}

export class InviteLinkGenerateCodeRequest implements IInviteLinkGenerateCodeRequest {
    invitationId!: string;
    email!: string;

    constructor(data?: IInviteLinkGenerateCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationId = _data["invitationId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): InviteLinkGenerateCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteLinkGenerateCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationId"] = this.invitationId;
        data["email"] = this.email;
        return data;
    }
}

export interface IInviteLinkGenerateCodeRequest {
    invitationId: string;
    email: string;
}

export class InviteLinkRegistrationSubmitRequest implements IInviteLinkRegistrationSubmitRequest {
    invitationId?: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    code?: number;

    constructor(data?: IInviteLinkRegistrationSubmitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationId = _data["invitationId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): InviteLinkRegistrationSubmitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteLinkRegistrationSubmitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationId"] = this.invitationId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["code"] = this.code;
        return data;
    }
}

export interface IInviteLinkRegistrationSubmitRequest {
    invitationId?: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    code?: number;
}

export class InviteLinkRegistrationSubmitResponse implements IInviteLinkRegistrationSubmitResponse {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IInviteLinkRegistrationSubmitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InviteLinkRegistrationSubmitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InviteLinkRegistrationSubmitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IInviteLinkRegistrationSubmitResponse {
    success?: boolean;
    message?: string | undefined;
}

export class InviteLinkVerificationResponse implements IInviteLinkVerificationResponse {
    codeGenerated?: boolean;
    emailSent?: boolean;
    validCode?: boolean;
    codeExpired?: boolean;

    constructor(data?: IInviteLinkVerificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeGenerated = _data["codeGenerated"];
            this.emailSent = _data["emailSent"];
            this.validCode = _data["validCode"];
            this.codeExpired = _data["codeExpired"];
        }
    }

    static fromJS(data: any): InviteLinkVerificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InviteLinkVerificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeGenerated"] = this.codeGenerated;
        data["emailSent"] = this.emailSent;
        data["validCode"] = this.validCode;
        data["codeExpired"] = this.codeExpired;
        return data;
    }
}

export interface IInviteLinkVerificationResponse {
    codeGenerated?: boolean;
    emailSent?: boolean;
    validCode?: boolean;
    codeExpired?: boolean;
}

export class InviteLinkVerifyCodeRequest implements IInviteLinkVerifyCodeRequest {
    invitationId!: string;
    email!: string;
    code!: number;

    constructor(data?: IInviteLinkVerifyCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationId = _data["invitationId"];
            this.email = _data["email"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): InviteLinkVerifyCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteLinkVerifyCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationId"] = this.invitationId;
        data["email"] = this.email;
        data["code"] = this.code;
        return data;
    }
}

export interface IInviteLinkVerifyCodeRequest {
    invitationId: string;
    email: string;
    code: number;
}

export class MySecurityGroupsResponse implements IMySecurityGroupsResponse {
    isSecurityGroupsEnabled!: boolean;
    isGlobalAdmin!: boolean;
    securityGroups?: CxSecurityGroupDetailsDto[] | undefined;

    constructor(data?: IMySecurityGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSecurityGroupsEnabled = _data["isSecurityGroupsEnabled"];
            this.isGlobalAdmin = _data["isGlobalAdmin"];
            if (Array.isArray(_data["securityGroups"])) {
                this.securityGroups = [] as any;
                for (let item of _data["securityGroups"])
                    this.securityGroups!.push(CxSecurityGroupDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MySecurityGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MySecurityGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSecurityGroupsEnabled"] = this.isSecurityGroupsEnabled;
        data["isGlobalAdmin"] = this.isGlobalAdmin;
        if (Array.isArray(this.securityGroups)) {
            data["securityGroups"] = [];
            for (let item of this.securityGroups)
                data["securityGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMySecurityGroupsResponse {
    isSecurityGroupsEnabled: boolean;
    isGlobalAdmin: boolean;
    securityGroups?: CxSecurityGroupDetailsDto[] | undefined;
}

export enum PortalRole {
    User = "User",
    LegacyAdmin = "LegacyAdmin",
    SecurityAdmin = "SecurityAdmin",
    ProcurementAdmin = "ProcurementAdmin",
    GlobalAdmin = "GlobalAdmin",
    GuestUser = "GuestUser",
}

export class RemoveSecurityGroupConfigItemsRequest implements IRemoveSecurityGroupConfigItemsRequest {
    configItemIds!: number[] | undefined;

    constructor(data?: IRemoveSecurityGroupConfigItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["configItemIds"])) {
                this.configItemIds = [] as any;
                for (let item of _data["configItemIds"])
                    this.configItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RemoveSecurityGroupConfigItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveSecurityGroupConfigItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.configItemIds)) {
            data["configItemIds"] = [];
            for (let item of this.configItemIds)
                data["configItemIds"].push(item);
        }
        return data;
    }
}

export interface IRemoveSecurityGroupConfigItemsRequest {
    configItemIds: number[] | undefined;
}

export class SecurityGroupConfigItemDetailsDto implements ISecurityGroupConfigItemDetailsDto {
    configurationItemId!: number;
    contractId?: number | undefined;
    cloudAccountName?: string | undefined;
    cloudAccountId?: string | undefined;
    accountId?: number | undefined;
    accountName!: string | undefined;

    constructor(data?: ISecurityGroupConfigItemDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            this.contractId = _data["contractId"];
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloudAccountId = _data["cloudAccountId"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): SecurityGroupConfigItemDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityGroupConfigItemDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        data["contractId"] = this.contractId;
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloudAccountId"] = this.cloudAccountId;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        return data;
    }
}

export interface ISecurityGroupConfigItemDetailsDto {
    configurationItemId: number;
    contractId?: number | undefined;
    cloudAccountName?: string | undefined;
    cloudAccountId?: string | undefined;
    accountId?: number | undefined;
    accountName: string | undefined;
}

export class SecurityGroupContractIdsRequest implements ISecurityGroupContractIdsRequest {
    contractIds!: number[] | undefined;

    constructor(data?: ISecurityGroupContractIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contractIds"])) {
                this.contractIds = [] as any;
                for (let item of _data["contractIds"])
                    this.contractIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SecurityGroupContractIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityGroupContractIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contractIds)) {
            data["contractIds"] = [];
            for (let item of this.contractIds)
                data["contractIds"].push(item);
        }
        return data;
    }
}

export interface ISecurityGroupContractIdsRequest {
    contractIds: number[] | undefined;
}

export class SecurityGroupMemberIdsRequest implements ISecurityGroupMemberIdsRequest {
    userIds!: string[] | undefined;

    constructor(data?: ISecurityGroupMemberIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SecurityGroupMemberIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityGroupMemberIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}

export interface ISecurityGroupMemberIdsRequest {
    userIds: string[] | undefined;
}

export class SecurityGroupNameRequest implements ISecurityGroupNameRequest {
    name!: string | undefined;

    constructor(data?: ISecurityGroupNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SecurityGroupNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityGroupNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISecurityGroupNameRequest {
    name: string | undefined;
}

export class SetContractRequestPermissionsRequest implements ISetContractRequestPermissionsRequest {
    mappings!: TeamTicketCategoryMappingDto[] | undefined;
    configItemsToAdd!: TeamConfigItemDto[] | undefined;
    configItemIdsToRemove!: number[] | undefined;

    constructor(data?: ISetContractRequestPermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mappings"])) {
                this.mappings = [] as any;
                for (let item of _data["mappings"])
                    this.mappings!.push(TeamTicketCategoryMappingDto.fromJS(item));
            }
            if (Array.isArray(_data["configItemsToAdd"])) {
                this.configItemsToAdd = [] as any;
                for (let item of _data["configItemsToAdd"])
                    this.configItemsToAdd!.push(TeamConfigItemDto.fromJS(item));
            }
            if (Array.isArray(_data["configItemIdsToRemove"])) {
                this.configItemIdsToRemove = [] as any;
                for (let item of _data["configItemIdsToRemove"])
                    this.configItemIdsToRemove!.push(item);
            }
        }
    }

    static fromJS(data: any): SetContractRequestPermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetContractRequestPermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mappings)) {
            data["mappings"] = [];
            for (let item of this.mappings)
                data["mappings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.configItemsToAdd)) {
            data["configItemsToAdd"] = [];
            for (let item of this.configItemsToAdd)
                data["configItemsToAdd"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.configItemIdsToRemove)) {
            data["configItemIdsToRemove"] = [];
            for (let item of this.configItemIdsToRemove)
                data["configItemIdsToRemove"].push(item);
        }
        return data;
    }
}

export interface ISetContractRequestPermissionsRequest {
    mappings: TeamTicketCategoryMappingDto[] | undefined;
    configItemsToAdd: TeamConfigItemDto[] | undefined;
    configItemIdsToRemove: number[] | undefined;
}

export class SetSecurityGroupMemberCanEditRequest implements ISetSecurityGroupMemberCanEditRequest {
    canEditSecurityGroup!: boolean;

    constructor(data?: ISetSecurityGroupMemberCanEditRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canEditSecurityGroup = _data["canEditSecurityGroup"];
        }
    }

    static fromJS(data: any): SetSecurityGroupMemberCanEditRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetSecurityGroupMemberCanEditRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canEditSecurityGroup"] = this.canEditSecurityGroup;
        return data;
    }
}

export interface ISetSecurityGroupMemberCanEditRequest {
    canEditSecurityGroup: boolean;
}

export class SetSecurityGroupPermissionsRequest implements ISetSecurityGroupPermissionsRequest {
    permissions!: string[] | undefined;

    constructor(data?: ISetSecurityGroupPermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): SetSecurityGroupPermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetSecurityGroupPermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface ISetSecurityGroupPermissionsRequest {
    permissions: string[] | undefined;
}

export class SetSecurityGroupTicketCategoryMappingsRequest implements ISetSecurityGroupTicketCategoryMappingsRequest {
    mappings!: TeamTicketCategoryMappingDto[] | undefined;

    constructor(data?: ISetSecurityGroupTicketCategoryMappingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mappings"])) {
                this.mappings = [] as any;
                for (let item of _data["mappings"])
                    this.mappings!.push(TeamTicketCategoryMappingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetSecurityGroupTicketCategoryMappingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetSecurityGroupTicketCategoryMappingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mappings)) {
            data["mappings"] = [];
            for (let item of this.mappings)
                data["mappings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetSecurityGroupTicketCategoryMappingsRequest {
    mappings: TeamTicketCategoryMappingDto[] | undefined;
}

export class StorefrontAssignableUserDto implements IStorefrontAssignableUserDto {
    userId!: string;
    name!: string;
    email!: string;

    constructor(data?: IStorefrontAssignableUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): StorefrontAssignableUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontAssignableUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IStorefrontAssignableUserDto {
    userId: string;
    name: string;
    email: string;
}

export class StorefrontAssignableUsersPageDto implements IStorefrontAssignableUsersPageDto {
    items?: StorefrontAssignableUserDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IStorefrontAssignableUsersPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StorefrontAssignableUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): StorefrontAssignableUsersPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontAssignableUsersPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IStorefrontAssignableUsersPageDto {
    items?: StorefrontAssignableUserDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class StorefrontDto implements IStorefrontDto {
    id!: number;
    orgUnitId!: number;
    crmAccountId!: string;
    orgUnitName!: string;
    displayName!: string;
    createdBy!: string;
    createdAt?: Date;
    lastModifiedBy!: string;
    lastModifiedAt?: Date;

    constructor(data?: IStorefrontDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orgUnitId = _data["orgUnitId"];
            this.crmAccountId = _data["crmAccountId"];
            this.orgUnitName = _data["orgUnitName"];
            this.displayName = _data["displayName"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StorefrontDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orgUnitId"] = this.orgUnitId;
        data["crmAccountId"] = this.crmAccountId;
        data["orgUnitName"] = this.orgUnitName;
        data["displayName"] = this.displayName;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IStorefrontDto {
    id: number;
    orgUnitId: number;
    crmAccountId: string;
    orgUnitName: string;
    displayName: string;
    createdBy: string;
    createdAt?: Date;
    lastModifiedBy: string;
    lastModifiedAt?: Date;
}

export class StorefrontGroupDto implements IStorefrontGroupDto {
    id!: number;
    storefrontId!: number;
    name!: string;
    createdBy!: string;
    createdAt?: Date;
    lastModifiedBy!: string;
    lastModifiedAt?: Date;

    constructor(data?: IStorefrontGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storefrontId = _data["storefrontId"];
            this.name = _data["name"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StorefrontGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storefrontId"] = this.storefrontId;
        data["name"] = this.name;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IStorefrontGroupDto {
    id: number;
    storefrontId: number;
    name: string;
    createdBy: string;
    createdAt?: Date;
    lastModifiedBy: string;
    lastModifiedAt?: Date;
}

export class StorefrontGroupUserDto implements IStorefrontGroupUserDto {
    userId!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    email!: string;
    profilePhoto?: string | undefined;
    canEditStorefrontGroup!: boolean;

    constructor(data?: IStorefrontGroupUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.email = _data["email"];
            this.profilePhoto = _data["profilePhoto"];
            this.canEditStorefrontGroup = _data["canEditStorefrontGroup"];
        }
    }

    static fromJS(data: any): StorefrontGroupUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontGroupUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["email"] = this.email;
        data["profilePhoto"] = this.profilePhoto;
        data["canEditStorefrontGroup"] = this.canEditStorefrontGroup;
        return data;
    }
}

export interface IStorefrontGroupUserDto {
    userId: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    email: string;
    profilePhoto?: string | undefined;
    canEditStorefrontGroup: boolean;
}

export class StorefrontGroupUserRoleRequest implements IStorefrontGroupUserRoleRequest {
    userId?: string;
    email?: string | undefined;
    canEditStorefrontGroup?: boolean;

    constructor(data?: IStorefrontGroupUserRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.canEditStorefrontGroup = _data["canEditStorefrontGroup"];
        }
    }

    static fromJS(data: any): StorefrontGroupUserRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontGroupUserRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["canEditStorefrontGroup"] = this.canEditStorefrontGroup;
        return data;
    }
}

export interface IStorefrontGroupUserRoleRequest {
    userId?: string;
    email?: string | undefined;
    canEditStorefrontGroup?: boolean;
}

export class StorefrontInheritedMemberMatchDto implements IStorefrontInheritedMemberMatchDto {
    userId!: string;
    name!: string;
    accessRoleName!: string;

    constructor(data?: IStorefrontInheritedMemberMatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.accessRoleName = _data["accessRoleName"];
        }
    }

    static fromJS(data: any): StorefrontInheritedMemberMatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontInheritedMemberMatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["accessRoleName"] = this.accessRoleName;
        return data;
    }
}

export interface IStorefrontInheritedMemberMatchDto {
    userId: string;
    name: string;
    accessRoleName: string;
}

export class StorefrontMemberDto implements IStorefrontMemberDto {
    userId!: string;
    name!: string;
    email!: string;
    role!: StorefrontMemberRole;
    lastActivityDate?: Date | undefined;
    isInherited!: boolean;
    accessRoleName?: string | undefined;
    isLastManager!: boolean;

    constructor(data?: IStorefrontMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
            this.isInherited = _data["isInherited"];
            this.accessRoleName = _data["accessRoleName"];
            this.isLastManager = _data["isLastManager"];
        }
    }

    static fromJS(data: any): StorefrontMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["role"] = this.role;
        data["lastActivityDate"] = this.lastActivityDate ? formatDate(this.lastActivityDate) : undefined as any;
        data["isInherited"] = this.isInherited;
        data["accessRoleName"] = this.accessRoleName;
        data["isLastManager"] = this.isLastManager;
        return data;
    }
}

export interface IStorefrontMemberDto {
    userId: string;
    name: string;
    email: string;
    role: StorefrontMemberRole;
    lastActivityDate?: Date | undefined;
    isInherited: boolean;
    accessRoleName?: string | undefined;
    isLastManager: boolean;
}

export enum StorefrontMemberRole {
    Member = "Member",
    Manager = "Manager",
}

export class StorefrontMembersPageDto implements IStorefrontMembersPageDto {
    directMembersCount!: number;
    everyoneWithAccessCount!: number;
    unlistedInheritedMember?: StorefrontInheritedMemberMatchDto;
    unlistedInheritedMemberCount!: number;
    items?: StorefrontMemberDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IStorefrontMembersPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.directMembersCount = _data["directMembersCount"];
            this.everyoneWithAccessCount = _data["everyoneWithAccessCount"];
            this.unlistedInheritedMember = _data["unlistedInheritedMember"] ? StorefrontInheritedMemberMatchDto.fromJS(_data["unlistedInheritedMember"]) : undefined as any;
            this.unlistedInheritedMemberCount = _data["unlistedInheritedMemberCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StorefrontMemberDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): StorefrontMembersPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontMembersPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["directMembersCount"] = this.directMembersCount;
        data["everyoneWithAccessCount"] = this.everyoneWithAccessCount;
        data["unlistedInheritedMember"] = this.unlistedInheritedMember ? this.unlistedInheritedMember.toJSON() : undefined as any;
        data["unlistedInheritedMemberCount"] = this.unlistedInheritedMemberCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IStorefrontMembersPageDto {
    directMembersCount: number;
    everyoneWithAccessCount: number;
    unlistedInheritedMember?: StorefrontInheritedMemberMatchDto;
    unlistedInheritedMemberCount: number;
    items?: StorefrontMemberDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class StorefrontMembersRequest implements IStorefrontMembersRequest {
    view?: StorefrontMembersView;
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: { [key: string]: string[]; } | undefined;
    searchFilterExclude?: { [key: string]: string[]; } | undefined;

    constructor(data?: IStorefrontMembersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.view = _data["view"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortByColumn = _data["sortByColumn"];
            this.isDescending = _data["isDescending"];
            this.afterKey = _data["afterKey"];
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            if (_data["searchFilterInclude"]) {
                this.searchFilterInclude = {} as any;
                for (let key in _data["searchFilterInclude"]) {
                    if (_data["searchFilterInclude"].hasOwnProperty(key))
                        (this.searchFilterInclude as any)![key] = _data["searchFilterInclude"][key];
                }
            }
            if (_data["searchFilterExclude"]) {
                this.searchFilterExclude = {} as any;
                for (let key in _data["searchFilterExclude"]) {
                    if (_data["searchFilterExclude"].hasOwnProperty(key))
                        (this.searchFilterExclude as any)![key] = _data["searchFilterExclude"][key];
                }
            }
        }
    }

    static fromJS(data: any): StorefrontMembersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontMembersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["view"] = this.view;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortByColumn"] = this.sortByColumn;
        data["isDescending"] = this.isDescending;
        data["afterKey"] = this.afterKey;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        if (this.searchFilterInclude) {
            data["searchFilterInclude"] = {};
            for (let key in this.searchFilterInclude) {
                if (this.searchFilterInclude.hasOwnProperty(key))
                    (data["searchFilterInclude"] as any)[key] = (this.searchFilterInclude as any)[key];
            }
        }
        if (this.searchFilterExclude) {
            data["searchFilterExclude"] = {};
            for (let key in this.searchFilterExclude) {
                if (this.searchFilterExclude.hasOwnProperty(key))
                    (data["searchFilterExclude"] as any)[key] = (this.searchFilterExclude as any)[key];
            }
        }
        return data;
    }
}

export interface IStorefrontMembersRequest {
    view?: StorefrontMembersView;
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: { [key: string]: string[]; } | undefined;
    searchFilterExclude?: { [key: string]: string[]; } | undefined;
}

export enum StorefrontMembersView {
    DirectMembers = "DirectMembers",
    EveryoneWithAccess = "EveryoneWithAccess",
}

export class StorefrontSecurityGroupDto implements IStorefrontSecurityGroupDto {
    storefront!: StorefrontDto;
    group!: StorefrontGroupDto;
    users!: StorefrontGroupUserDto[];

    constructor(data?: IStorefrontSecurityGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.storefront = new StorefrontDto();
            this.group = new StorefrontGroupDto();
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storefront = _data["storefront"] ? StorefrontDto.fromJS(_data["storefront"]) : new StorefrontDto();
            this.group = _data["group"] ? StorefrontGroupDto.fromJS(_data["group"]) : new StorefrontGroupDto();
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(StorefrontGroupUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StorefrontSecurityGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontSecurityGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storefront"] = this.storefront ? this.storefront.toJSON() : undefined as any;
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStorefrontSecurityGroupDto {
    storefront: StorefrontDto;
    group: StorefrontGroupDto;
    users: StorefrontGroupUserDto[];
}

export class TeamConfigItemDto implements ITeamConfigItemDto {
    configurationItemId?: number;
    contractId?: number | undefined;

    constructor(data?: ITeamConfigItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            this.contractId = _data["contractId"];
        }
    }

    static fromJS(data: any): TeamConfigItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamConfigItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        data["contractId"] = this.contractId;
        return data;
    }
}

export interface ITeamConfigItemDto {
    configurationItemId?: number;
    contractId?: number | undefined;
}

export class TeamTicketCategoryMappingDto implements ITeamTicketCategoryMappingDto {
    contractId?: number;
    enabledIssueType?: string | undefined;
    ticketCategoryMappingId?: number;

    constructor(data?: ITeamTicketCategoryMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.enabledIssueType = _data["enabledIssueType"];
            this.ticketCategoryMappingId = _data["ticketCategoryMappingId"];
        }
    }

    static fromJS(data: any): TeamTicketCategoryMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamTicketCategoryMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["enabledIssueType"] = this.enabledIssueType;
        data["ticketCategoryMappingId"] = this.ticketCategoryMappingId;
        return data;
    }
}

export interface ITeamTicketCategoryMappingDto {
    contractId?: number;
    enabledIssueType?: string | undefined;
    ticketCategoryMappingId?: number;
}

export class TenantAdminUserDto implements ITenantAdminUserDto {
    id!: string;
    migratedFromUserProfileId?: number | undefined;
    contactId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    email!: string | undefined;
    isAdmin?: boolean;
    active?: boolean;
    tenantId!: string;
    role!: PortalRole;

    constructor(data?: ITenantAdminUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.migratedFromUserProfileId = _data["migratedFromUserProfileId"];
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.email = _data["email"];
            this.isAdmin = _data["isAdmin"];
            this.active = _data["active"];
            this.tenantId = _data["tenantId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): TenantAdminUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAdminUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["migratedFromUserProfileId"] = this.migratedFromUserProfileId;
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["email"] = this.email;
        data["isAdmin"] = this.isAdmin;
        data["active"] = this.active;
        data["tenantId"] = this.tenantId;
        data["role"] = this.role;
        return data;
    }
}

export interface ITenantAdminUserDto {
    id: string;
    migratedFromUserProfileId?: number | undefined;
    contactId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    email: string | undefined;
    isAdmin?: boolean;
    active?: boolean;
    tenantId: string;
    role: PortalRole;
}

export class SwitchTenantRequest implements ISwitchTenantRequest {
    tenantId!: string;

    constructor(data?: ISwitchTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): SwitchTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ISwitchTenantRequest {
    tenantId: string;
}

export class UserTenantDto implements IUserTenantDto {
    tenantId!: string;
    name!: string | undefined;
    isCurrent!: boolean;

    constructor(data?: IUserTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isCurrent = _data["isCurrent"];
        }
    }

    static fromJS(data: any): UserTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isCurrent"] = this.isCurrent;
        return data;
    }
}

export interface IUserTenantDto {
    tenantId: string;
    name: string | undefined;
    isCurrent: boolean;
}

export class UserTenantsResponse implements IUserTenantsResponse {
    tenants!: UserTenantDto[] | undefined;
    currentTenantId?: string | undefined;
    canSwitch!: boolean;

    constructor(data?: IUserTenantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(UserTenantDto.fromJS(item));
            }
            this.currentTenantId = _data["currentTenantId"];
            this.canSwitch = _data["canSwitch"];
        }
    }

    static fromJS(data: any): UserTenantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserTenantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentTenantId"] = this.currentTenantId;
        data["canSwitch"] = this.canSwitch;
        return data;
    }
}

export interface IUserTenantsResponse {
    tenants: UserTenantDto[] | undefined;
    currentTenantId?: string | undefined;
    canSwitch: boolean;
}

export enum UnityExperienceStatus {
    NotEligible = "NotEligible",
    InExperience = "InExperience",
    OptedOut = "OptedOut",
}

export class UpdateCxUserRequest implements IUpdateCxUserRequest {
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    role?: PortalRole;
    active?: boolean | undefined;

    constructor(data?: IUpdateCxUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.role = _data["role"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): UpdateCxUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCxUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["role"] = this.role;
        data["active"] = this.active;
        return data;
    }
}

export interface IUpdateCxUserRequest {
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    role?: PortalRole;
    active?: boolean | undefined;
}

export class UserProvisioningResponse implements IUserProvisioningResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    myAdmins?: string[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserProvisioningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["myAdmins"])) {
                this.myAdmins = [] as any;
                for (let item of _data["myAdmins"])
                    this.myAdmins!.push(item);
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserProvisioningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserProvisioningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.myAdmins)) {
            data["myAdmins"] = [];
            for (let item of this.myAdmins)
                data["myAdmins"].push(item);
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserProvisioningResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    myAdmins?: string[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
}

export class AddProductToCatalogResultDto implements IAddProductToCatalogResultDto {
    view?: CatalogViewDto;
    requiresPriceRule?: boolean;

    constructor(data?: IAddProductToCatalogResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.view = _data["view"] ? CatalogViewDto.fromJS(_data["view"]) : undefined as any;
            this.requiresPriceRule = _data["requiresPriceRule"];
        }
    }

    static fromJS(data: any): AddProductToCatalogResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductToCatalogResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["view"] = this.view ? this.view.toJSON() : undefined as any;
        data["requiresPriceRule"] = this.requiresPriceRule;
        return data;
    }
}

export interface IAddProductToCatalogResultDto {
    view?: CatalogViewDto;
    requiresPriceRule?: boolean;
}

export class AddressCoordinateLookupRequest implements IAddressCoordinateLookupRequest {
    streetAddress?: string | undefined;
    streetAddress2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;

    constructor(data?: IAddressCoordinateLookupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetAddress = _data["streetAddress"];
            this.streetAddress2 = _data["streetAddress2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): AddressCoordinateLookupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddressCoordinateLookupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddress"] = this.streetAddress;
        data["streetAddress2"] = this.streetAddress2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        return data;
    }
}

export interface IAddressCoordinateLookupRequest {
    streetAddress?: string | undefined;
    streetAddress2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
}

export class AddressCoordinateLookupResponse implements IAddressCoordinateLookupResponse {
    latitude?: number | undefined;
    longitude?: number | undefined;
    provider?: string | undefined;
    resolvedAddress?: string | undefined;
    wasExactMatch?: boolean;

    constructor(data?: IAddressCoordinateLookupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.provider = _data["provider"];
            this.resolvedAddress = _data["resolvedAddress"];
            this.wasExactMatch = _data["wasExactMatch"];
        }
    }

    static fromJS(data: any): AddressCoordinateLookupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressCoordinateLookupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["provider"] = this.provider;
        data["resolvedAddress"] = this.resolvedAddress;
        data["wasExactMatch"] = this.wasExactMatch;
        return data;
    }
}

export interface IAddressCoordinateLookupResponse {
    latitude?: number | undefined;
    longitude?: number | undefined;
    provider?: string | undefined;
    resolvedAddress?: string | undefined;
    wasExactMatch?: boolean;
}

export class AddressGroupEntryDto implements IAddressGroupEntryDto {
    addressGroupNumber?: number;
    name?: string | undefined;
    wasCreated?: boolean;

    constructor(data?: IAddressGroupEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressGroupNumber = _data["addressGroupNumber"];
            this.name = _data["name"];
            this.wasCreated = _data["wasCreated"];
        }
    }

    static fromJS(data: any): AddressGroupEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressGroupEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressGroupNumber"] = this.addressGroupNumber;
        data["name"] = this.name;
        data["wasCreated"] = this.wasCreated;
        return data;
    }
}

export interface IAddressGroupEntryDto {
    addressGroupNumber?: number;
    name?: string | undefined;
    wasCreated?: boolean;
}

export class AddressLocationItemDto implements IAddressLocationItemDto {
    countryCode?: string | undefined;
    countryName?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;

    constructor(data?: IAddressLocationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.state = _data["state"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): AddressLocationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressLocationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["state"] = this.state;
        data["city"] = this.city;
        return data;
    }
}

export interface IAddressLocationItemDto {
    countryCode?: string | undefined;
    countryName?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
}

export class AddressLookupResponse implements IAddressLookupResponse {
    suggestions?: AddressSuggestionDto[] | undefined;

    constructor(data?: IAddressLookupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(AddressSuggestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddressLookupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressLookupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddressLookupResponse {
    suggestions?: AddressSuggestionDto[] | undefined;
}

export class AddressSearchItemDto implements IAddressSearchItemDto {
    streetAddressId?: number;
    addressGroups?: string[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    addressName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    residential?: boolean;
    isDefault?: boolean;

    constructor(data?: IAddressSearchItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetAddressId = _data["streetAddressId"];
            if (Array.isArray(_data["addressGroups"])) {
                this.addressGroups = [] as any;
                for (let item of _data["addressGroups"])
                    this.addressGroups!.push(item);
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.addressName = _data["addressName"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.countryCode = _data["countryCode"];
            this.residential = _data["residential"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): AddressSearchItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSearchItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddressId"] = this.streetAddressId;
        if (Array.isArray(this.addressGroups)) {
            data["addressGroups"] = [];
            for (let item of this.addressGroups)
                data["addressGroups"].push(item);
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["addressName"] = this.addressName;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["countryCode"] = this.countryCode;
        data["residential"] = this.residential;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IAddressSearchItemDto {
    streetAddressId?: number;
    addressGroups?: string[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    addressName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    residential?: boolean;
    isDefault?: boolean;
}

export class AddressSearchResultDto implements IAddressSearchResultDto {
    totalCount?: number;
    addresses?: AddressSearchItemDto[] | undefined;

    constructor(data?: IAddressSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressSearchItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddressSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddressSearchResultDto {
    totalCount?: number;
    addresses?: AddressSearchItemDto[] | undefined;
}

export class AddressSuggestionDto implements IAddressSuggestionDto {
    suggestionKey?: string | undefined;
    streetAddress?: string | undefined;
    streetAddress2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    source?: string | undefined;

    constructor(data?: IAddressSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suggestionKey = _data["suggestionKey"];
            this.streetAddress = _data["streetAddress"];
            this.streetAddress2 = _data["streetAddress2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
            this.countryCode = _data["countryCode"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): AddressSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestionKey"] = this.suggestionKey;
        data["streetAddress"] = this.streetAddress;
        data["streetAddress2"] = this.streetAddress2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        data["countryCode"] = this.countryCode;
        data["source"] = this.source;
        return data;
    }
}

export interface IAddressSuggestionDto {
    suggestionKey?: string | undefined;
    streetAddress?: string | undefined;
    streetAddress2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    source?: string | undefined;
}

export class AdjustmentCountsDto implements IAdjustmentCountsDto {
    products?: number;
    productLines?: number;
    manufacturers?: number;
    categories?: number;
    types?: number;

    constructor(data?: IAdjustmentCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.products = _data["products"];
            this.productLines = _data["productLines"];
            this.manufacturers = _data["manufacturers"];
            this.categories = _data["categories"];
            this.types = _data["types"];
        }
    }

    static fromJS(data: any): AdjustmentCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["products"] = this.products;
        data["productLines"] = this.productLines;
        data["manufacturers"] = this.manufacturers;
        data["categories"] = this.categories;
        data["types"] = this.types;
        return data;
    }
}

export interface IAdjustmentCountsDto {
    products?: number;
    productLines?: number;
    manufacturers?: number;
    categories?: number;
    types?: number;
}

export class AddOnSectionDto implements IAddOnSectionDto {
    name!: string;
    description?: string | undefined;
    displayGroupFlag?: string | undefined;
    sortOrder?: number;
    isExclusive?: boolean;
    isMandatory?: boolean;
    items?: OptionSettingsDto[] | undefined;

    constructor(data?: IAddOnSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.displayGroupFlag = _data["displayGroupFlag"];
            this.sortOrder = _data["sortOrder"];
            this.isExclusive = _data["isExclusive"];
            this.isMandatory = _data["isMandatory"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OptionSettingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddOnSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddOnSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["displayGroupFlag"] = this.displayGroupFlag;
        data["sortOrder"] = this.sortOrder;
        data["isExclusive"] = this.isExclusive;
        data["isMandatory"] = this.isMandatory;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddOnSectionDto {
    name: string;
    description?: string | undefined;
    displayGroupFlag?: string | undefined;
    sortOrder?: number;
    isExclusive?: boolean;
    isMandatory?: boolean;
    items?: OptionSettingsDto[] | undefined;
}

export class BulkBundleActionRequest implements IBulkBundleActionRequest {
    bundleIds?: number[] | undefined;
    action?: string | undefined;
    orgUnitId?: number;
    catalogSubsetId?: number | undefined;

    constructor(data?: IBulkBundleActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bundleIds"])) {
                this.bundleIds = [] as any;
                for (let item of _data["bundleIds"])
                    this.bundleIds!.push(item);
            }
            this.action = _data["action"];
            this.orgUnitId = _data["orgUnitId"];
            this.catalogSubsetId = _data["catalogSubsetId"];
        }
    }

    static fromJS(data: any): BulkBundleActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkBundleActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bundleIds)) {
            data["bundleIds"] = [];
            for (let item of this.bundleIds)
                data["bundleIds"].push(item);
        }
        data["action"] = this.action;
        data["orgUnitId"] = this.orgUnitId;
        data["catalogSubsetId"] = this.catalogSubsetId;
        return data;
    }
}

export interface IBulkBundleActionRequest {
    bundleIds?: number[] | undefined;
    action?: string | undefined;
    orgUnitId?: number;
    catalogSubsetId?: number | undefined;
}

export class BulkBundleActionResponse implements IBulkBundleActionResponse {
    successCount?: number;
    failureCount?: number;
    results?: BulkBundleItemResult[] | undefined;

    constructor(data?: IBulkBundleActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successCount = _data["successCount"];
            this.failureCount = _data["failureCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BulkBundleItemResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkBundleActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BulkBundleActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successCount"] = this.successCount;
        data["failureCount"] = this.failureCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBulkBundleActionResponse {
    successCount?: number;
    failureCount?: number;
    results?: BulkBundleItemResult[] | undefined;
}

export class BulkBundleItemResult implements IBulkBundleItemResult {
    bundleId?: number;
    success?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IBulkBundleItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bundleId = _data["bundleId"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BulkBundleItemResult {
        data = typeof data === 'object' ? data : {};
        let result = new BulkBundleItemResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bundleId"] = this.bundleId;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBulkBundleItemResult {
    bundleId?: number;
    success?: boolean;
    errorMessage?: string | undefined;
}

export class BundleCompositeItemResolution implements IBundleCompositeItemResolution {
    productId?: number;
    compositeItemId?: number | undefined;
    outcome?: BundleCompositeItemResolutionOutcome;
    message?: string | undefined;

    constructor(data?: IBundleCompositeItemResolution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.compositeItemId = _data["compositeItemId"];
            this.outcome = _data["outcome"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BundleCompositeItemResolution {
        data = typeof data === 'object' ? data : {};
        let result = new BundleCompositeItemResolution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["compositeItemId"] = this.compositeItemId;
        data["outcome"] = this.outcome;
        data["message"] = this.message;
        return data;
    }
}

export interface IBundleCompositeItemResolution {
    productId?: number;
    compositeItemId?: number | undefined;
    outcome?: BundleCompositeItemResolutionOutcome;
    message?: string | undefined;
}

export enum BundleCompositeItemResolutionOutcome {
    Existing = "Existing",
    Created = "Created",
    NotFound = "NotFound",
    NoUsableSupplier = "NoUsableSupplier",
    NoUsablePricing = "NoUsablePricing",
    Ambiguous = "Ambiguous",
    Busy = "Busy",
}

export class BundleDto implements IBundleDto {
    id?: number;
    compositeItemId?: number;
    baseProductName?: string | undefined;
    summary?: string | undefined;
    statusCode?: string | undefined;
    imageUrl?: string | undefined;
    baseProductImageUrl?: string | undefined;
    displayOrder?: number | undefined;
    configurableItemTypeId?: number | undefined;
    inventoryCount?: number | undefined;
    locationCode?: string | undefined;
    serviceProviderSupported?: boolean | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;
    sections?: BundleSectionDto[] | undefined;

    constructor(data?: IBundleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.compositeItemId = _data["compositeItemId"];
            this.baseProductName = _data["baseProductName"];
            this.summary = _data["summary"];
            this.statusCode = _data["statusCode"];
            this.imageUrl = _data["imageUrl"];
            this.baseProductImageUrl = _data["baseProductImageUrl"];
            this.displayOrder = _data["displayOrder"];
            this.configurableItemTypeId = _data["configurableItemTypeId"];
            this.inventoryCount = _data["inventoryCount"];
            this.locationCode = _data["locationCode"];
            this.serviceProviderSupported = _data["serviceProviderSupported"];
            this.statusMinDays = _data["statusMinDays"];
            this.statusMaxDays = _data["statusMaxDays"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(BundleSectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BundleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BundleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["compositeItemId"] = this.compositeItemId;
        data["baseProductName"] = this.baseProductName;
        data["summary"] = this.summary;
        data["statusCode"] = this.statusCode;
        data["imageUrl"] = this.imageUrl;
        data["baseProductImageUrl"] = this.baseProductImageUrl;
        data["displayOrder"] = this.displayOrder;
        data["configurableItemTypeId"] = this.configurableItemTypeId;
        data["inventoryCount"] = this.inventoryCount;
        data["locationCode"] = this.locationCode;
        data["serviceProviderSupported"] = this.serviceProviderSupported;
        data["statusMinDays"] = this.statusMinDays;
        data["statusMaxDays"] = this.statusMaxDays;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBundleDto {
    id?: number;
    compositeItemId?: number;
    baseProductName?: string | undefined;
    summary?: string | undefined;
    statusCode?: string | undefined;
    imageUrl?: string | undefined;
    baseProductImageUrl?: string | undefined;
    displayOrder?: number | undefined;
    configurableItemTypeId?: number | undefined;
    inventoryCount?: number | undefined;
    locationCode?: string | undefined;
    serviceProviderSupported?: boolean | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;
    sections?: BundleSectionDto[] | undefined;
}

export class BundleListItemDto implements IBundleListItemDto {
    configurableItemId?: number;
    configurableItemCatalogId?: number;
    configurableItemCatalogSubsetId?: number;
    compositeItemId?: number;
    summary?: string | undefined;
    baseProductName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    productId?: number | undefined;
    basePrice?: number | undefined;
    statusCode?: string | undefined;
    imageUrl?: string | undefined;
    baseProductImageUrl?: string | undefined;
    displayOrder?: number | undefined;
    locationCode?: string | undefined;
    serviceProviderSupported?: boolean | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;
    standardsLocation?: string | undefined;

    constructor(data?: IBundleListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurableItemId = _data["configurableItemId"];
            this.configurableItemCatalogId = _data["configurableItemCatalogId"];
            this.configurableItemCatalogSubsetId = _data["configurableItemCatalogSubsetId"];
            this.compositeItemId = _data["compositeItemId"];
            this.summary = _data["summary"];
            this.baseProductName = _data["baseProductName"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.productId = _data["productId"];
            this.basePrice = _data["basePrice"];
            this.statusCode = _data["statusCode"];
            this.imageUrl = _data["imageUrl"];
            this.baseProductImageUrl = _data["baseProductImageUrl"];
            this.displayOrder = _data["displayOrder"];
            this.locationCode = _data["locationCode"];
            this.serviceProviderSupported = _data["serviceProviderSupported"];
            this.statusMinDays = _data["statusMinDays"];
            this.statusMaxDays = _data["statusMaxDays"];
            this.standardsLocation = _data["standardsLocation"];
        }
    }

    static fromJS(data: any): BundleListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BundleListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurableItemId"] = this.configurableItemId;
        data["configurableItemCatalogId"] = this.configurableItemCatalogId;
        data["configurableItemCatalogSubsetId"] = this.configurableItemCatalogSubsetId;
        data["compositeItemId"] = this.compositeItemId;
        data["summary"] = this.summary;
        data["baseProductName"] = this.baseProductName;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["productId"] = this.productId;
        data["basePrice"] = this.basePrice;
        data["statusCode"] = this.statusCode;
        data["imageUrl"] = this.imageUrl;
        data["baseProductImageUrl"] = this.baseProductImageUrl;
        data["displayOrder"] = this.displayOrder;
        data["locationCode"] = this.locationCode;
        data["serviceProviderSupported"] = this.serviceProviderSupported;
        data["statusMinDays"] = this.statusMinDays;
        data["statusMaxDays"] = this.statusMaxDays;
        data["standardsLocation"] = this.standardsLocation;
        return data;
    }
}

export interface IBundleListItemDto {
    configurableItemId?: number;
    configurableItemCatalogId?: number;
    configurableItemCatalogSubsetId?: number;
    compositeItemId?: number;
    summary?: string | undefined;
    baseProductName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    productId?: number | undefined;
    basePrice?: number | undefined;
    statusCode?: string | undefined;
    imageUrl?: string | undefined;
    baseProductImageUrl?: string | undefined;
    displayOrder?: number | undefined;
    locationCode?: string | undefined;
    serviceProviderSupported?: boolean | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;
    standardsLocation?: string | undefined;
}

export class BundleSectionDto implements IBundleSectionDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    displayGroupFlag?: string | undefined;
    sortOrder?: number;
    isExclusive?: boolean;
    isMandatory?: boolean;
    items?: BundleSectionItemDto[] | undefined;

    constructor(data?: IBundleSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.displayGroupFlag = _data["displayGroupFlag"];
            this.sortOrder = _data["sortOrder"];
            this.isExclusive = _data["isExclusive"];
            this.isMandatory = _data["isMandatory"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BundleSectionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BundleSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BundleSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["displayGroupFlag"] = this.displayGroupFlag;
        data["sortOrder"] = this.sortOrder;
        data["isExclusive"] = this.isExclusive;
        data["isMandatory"] = this.isMandatory;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBundleSectionDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    displayGroupFlag?: string | undefined;
    sortOrder?: number;
    isExclusive?: boolean;
    isMandatory?: boolean;
    items?: BundleSectionItemDto[] | undefined;
}

export class BundleSectionItemDto implements IBundleSectionItemDto {
    id?: number;
    compositeItemId?: number;
    productName?: string | undefined;
    imageUrl?: string | undefined;
    defaultQuantity?: number;
    minQuantity?: number;
    maxQuantity?: number;
    sortOrder?: number;
    isDefault?: boolean;
    canReceiveSeparately?: boolean | undefined;
    reportSeparatelyToProcurement?: boolean | undefined;
    requiredAddonItemId?: number | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;

    constructor(data?: IBundleSectionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.compositeItemId = _data["compositeItemId"];
            this.productName = _data["productName"];
            this.imageUrl = _data["imageUrl"];
            this.defaultQuantity = _data["defaultQuantity"];
            this.minQuantity = _data["minQuantity"];
            this.maxQuantity = _data["maxQuantity"];
            this.sortOrder = _data["sortOrder"];
            this.isDefault = _data["isDefault"];
            this.canReceiveSeparately = _data["canReceiveSeparately"];
            this.reportSeparatelyToProcurement = _data["reportSeparatelyToProcurement"];
            this.requiredAddonItemId = _data["requiredAddonItemId"];
            this.statusMinDays = _data["statusMinDays"];
            this.statusMaxDays = _data["statusMaxDays"];
        }
    }

    static fromJS(data: any): BundleSectionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BundleSectionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["compositeItemId"] = this.compositeItemId;
        data["productName"] = this.productName;
        data["imageUrl"] = this.imageUrl;
        data["defaultQuantity"] = this.defaultQuantity;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["sortOrder"] = this.sortOrder;
        data["isDefault"] = this.isDefault;
        data["canReceiveSeparately"] = this.canReceiveSeparately;
        data["reportSeparatelyToProcurement"] = this.reportSeparatelyToProcurement;
        data["requiredAddonItemId"] = this.requiredAddonItemId;
        data["statusMinDays"] = this.statusMinDays;
        data["statusMaxDays"] = this.statusMaxDays;
        return data;
    }
}

export interface IBundleSectionItemDto {
    id?: number;
    compositeItemId?: number;
    productName?: string | undefined;
    imageUrl?: string | undefined;
    defaultQuantity?: number;
    minQuantity?: number;
    maxQuantity?: number;
    sortOrder?: number;
    isDefault?: boolean;
    canReceiveSeparately?: boolean | undefined;
    reportSeparatelyToProcurement?: boolean | undefined;
    requiredAddonItemId?: number | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;
}

export class BundleStatusDto implements IBundleStatusDto {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IBundleStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BundleStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new BundleStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IBundleStatusDto {
    code?: string | undefined;
    description?: string | undefined;
}

export class BundleWriteResponse implements IBundleWriteResponse {
    bundleId?: number | undefined;
    catalogSubsetId?: number | undefined;
    createdSections?: CreatedSectionInfo[] | undefined;
    errors?: string[] | undefined;

    constructor(data?: IBundleWriteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bundleId = _data["bundleId"];
            this.catalogSubsetId = _data["catalogSubsetId"];
            if (Array.isArray(_data["createdSections"])) {
                this.createdSections = [] as any;
                for (let item of _data["createdSections"])
                    this.createdSections!.push(CreatedSectionInfo.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): BundleWriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BundleWriteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bundleId"] = this.bundleId;
        data["catalogSubsetId"] = this.catalogSubsetId;
        if (Array.isArray(this.createdSections)) {
            data["createdSections"] = [];
            for (let item of this.createdSections)
                data["createdSections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IBundleWriteResponse {
    bundleId?: number | undefined;
    catalogSubsetId?: number | undefined;
    createdSections?: CreatedSectionInfo[] | undefined;
    errors?: string[] | undefined;
}

export class CreateBundleRequest implements ICreateBundleRequest {
    compositeItemId?: number;
    summary!: string;
    locationCode!: string;
    standardsGroupIds!: number[];
    statusCode?: string | undefined;
    imageUrl?: string | undefined;
    displayOrder?: number | undefined;
    configurableItemTypeId?: number | undefined;
    sections?: AddOnSectionDto[] | undefined;

    constructor(data?: ICreateBundleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.standardsGroupIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compositeItemId = _data["compositeItemId"];
            this.summary = _data["summary"];
            this.locationCode = _data["locationCode"];
            if (Array.isArray(_data["standardsGroupIds"])) {
                this.standardsGroupIds = [] as any;
                for (let item of _data["standardsGroupIds"])
                    this.standardsGroupIds!.push(item);
            }
            this.statusCode = _data["statusCode"];
            this.imageUrl = _data["imageUrl"];
            this.displayOrder = _data["displayOrder"];
            this.configurableItemTypeId = _data["configurableItemTypeId"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(AddOnSectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateBundleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBundleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compositeItemId"] = this.compositeItemId;
        data["summary"] = this.summary;
        data["locationCode"] = this.locationCode;
        if (Array.isArray(this.standardsGroupIds)) {
            data["standardsGroupIds"] = [];
            for (let item of this.standardsGroupIds)
                data["standardsGroupIds"].push(item);
        }
        data["statusCode"] = this.statusCode;
        data["imageUrl"] = this.imageUrl;
        data["displayOrder"] = this.displayOrder;
        data["configurableItemTypeId"] = this.configurableItemTypeId;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateBundleRequest {
    compositeItemId?: number;
    summary: string;
    locationCode: string;
    standardsGroupIds: number[];
    statusCode?: string | undefined;
    imageUrl?: string | undefined;
    displayOrder?: number | undefined;
    configurableItemTypeId?: number | undefined;
    sections?: AddOnSectionDto[] | undefined;
}

export class CreateSystemItemRequest implements ICreateSystemItemRequest {
    productId!: number;
    supplierId!: number;
    customerPrice!: number;
    manufacturerId?: number | undefined;
    pricingMethodId?: number | undefined;
    pricingPercent?: number | undefined;

    constructor(data?: ICreateSystemItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.supplierId = _data["supplierId"];
            this.customerPrice = _data["customerPrice"];
            this.manufacturerId = _data["manufacturerId"];
            this.pricingMethodId = _data["pricingMethodId"];
            this.pricingPercent = _data["pricingPercent"];
        }
    }

    static fromJS(data: any): CreateSystemItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSystemItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["supplierId"] = this.supplierId;
        data["customerPrice"] = this.customerPrice;
        data["manufacturerId"] = this.manufacturerId;
        data["pricingMethodId"] = this.pricingMethodId;
        data["pricingPercent"] = this.pricingPercent;
        return data;
    }
}

export interface ICreateSystemItemRequest {
    productId: number;
    supplierId: number;
    customerPrice: number;
    manufacturerId?: number | undefined;
    pricingMethodId?: number | undefined;
    pricingPercent?: number | undefined;
}

export class CreatedSectionInfo implements ICreatedSectionInfo {
    sectionId?: number;
    name?: string | undefined;
    itemIds?: number[] | undefined;

    constructor(data?: ICreatedSectionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.name = _data["name"];
            if (Array.isArray(_data["itemIds"])) {
                this.itemIds = [] as any;
                for (let item of _data["itemIds"])
                    this.itemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatedSectionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedSectionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["name"] = this.name;
        if (Array.isArray(this.itemIds)) {
            data["itemIds"] = [];
            for (let item of this.itemIds)
                data["itemIds"].push(item);
        }
        return data;
    }
}

export interface ICreatedSectionInfo {
    sectionId?: number;
    name?: string | undefined;
    itemIds?: number[] | undefined;
}

export class OptionSettingsDto implements IOptionSettingsDto {
    compositeItemId?: number;
    defaultQuantity?: number;
    minQuantity?: number;
    maxQuantity?: number;
    sortOrder?: number;
    canReceiveSeparately?: boolean | undefined;
    reportSeparatelyToProcurement?: boolean | undefined;
    requiredAddonItemId?: number | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;
    isDefault?: boolean;
    id?: number | undefined;

    constructor(data?: IOptionSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compositeItemId = _data["compositeItemId"];
            this.defaultQuantity = _data["defaultQuantity"];
            this.minQuantity = _data["minQuantity"];
            this.maxQuantity = _data["maxQuantity"];
            this.sortOrder = _data["sortOrder"];
            this.canReceiveSeparately = _data["canReceiveSeparately"];
            this.reportSeparatelyToProcurement = _data["reportSeparatelyToProcurement"];
            this.requiredAddonItemId = _data["requiredAddonItemId"];
            this.statusMinDays = _data["statusMinDays"];
            this.statusMaxDays = _data["statusMaxDays"];
            this.isDefault = _data["isDefault"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OptionSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compositeItemId"] = this.compositeItemId;
        data["defaultQuantity"] = this.defaultQuantity;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["sortOrder"] = this.sortOrder;
        data["canReceiveSeparately"] = this.canReceiveSeparately;
        data["reportSeparatelyToProcurement"] = this.reportSeparatelyToProcurement;
        data["requiredAddonItemId"] = this.requiredAddonItemId;
        data["statusMinDays"] = this.statusMinDays;
        data["statusMaxDays"] = this.statusMaxDays;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data;
    }
}

export interface IOptionSettingsDto {
    compositeItemId?: number;
    defaultQuantity?: number;
    minQuantity?: number;
    maxQuantity?: number;
    sortOrder?: number;
    canReceiveSeparately?: boolean | undefined;
    reportSeparatelyToProcurement?: boolean | undefined;
    requiredAddonItemId?: number | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;
    isDefault?: boolean;
    id?: number | undefined;
}

export class ProductBundleEligibility implements IProductBundleEligibility {
    productId?: number;
    hasCompositeItems?: boolean;
    compositeItemId?: number | undefined;
    state?: ProductBundleEligibilityState;

    constructor(data?: IProductBundleEligibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.hasCompositeItems = _data["hasCompositeItems"];
            this.compositeItemId = _data["compositeItemId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ProductBundleEligibility {
        data = typeof data === 'object' ? data : {};
        let result = new ProductBundleEligibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["hasCompositeItems"] = this.hasCompositeItems;
        data["compositeItemId"] = this.compositeItemId;
        data["state"] = this.state;
        return data;
    }
}

export interface IProductBundleEligibility {
    productId?: number;
    hasCompositeItems?: boolean;
    compositeItemId?: number | undefined;
    state?: ProductBundleEligibilityState;
}

export enum ProductBundleEligibilityState {
    Eligible = "Eligible",
    NeedsPricing = "NeedsPricing",
    Ambiguous = "Ambiguous",
}

export class ResolveBundleCompositeItemsRequest implements IResolveBundleCompositeItemsRequest {
    productIds?: number[] | undefined;

    constructor(data?: IResolveBundleCompositeItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ResolveBundleCompositeItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveBundleCompositeItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        return data;
    }
}

export interface IResolveBundleCompositeItemsRequest {
    productIds?: number[] | undefined;
}

export class ResolveBundleCompositeItemsResponse implements IResolveBundleCompositeItemsResponse {
    results?: BundleCompositeItemResolution[] | undefined;

    constructor(data?: IResolveBundleCompositeItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BundleCompositeItemResolution.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResolveBundleCompositeItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveBundleCompositeItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResolveBundleCompositeItemsResponse {
    results?: BundleCompositeItemResolution[] | undefined;
}

export class SupplierOptionDto implements ISupplierOptionDto {
    supplierId?: number;
    supplierName?: string | undefined;
    price?: number;
    manufacturerId?: number | undefined;
    cost?: number | undefined;
    msrp?: number | undefined;

    constructor(data?: ISupplierOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.price = _data["price"];
            this.manufacturerId = _data["manufacturerId"];
            this.cost = _data["cost"];
            this.msrp = _data["msrp"];
        }
    }

    static fromJS(data: any): SupplierOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["price"] = this.price;
        data["manufacturerId"] = this.manufacturerId;
        data["cost"] = this.cost;
        data["msrp"] = this.msrp;
        return data;
    }
}

export interface ISupplierOptionDto {
    supplierId?: number;
    supplierName?: string | undefined;
    price?: number;
    manufacturerId?: number | undefined;
    cost?: number | undefined;
    msrp?: number | undefined;
}

export class SystemItemWriteResponse implements ISystemItemWriteResponse {
    systemItemId?: number;
    price?: number | undefined;

    constructor(data?: ISystemItemWriteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemItemId = _data["systemItemId"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): SystemItemWriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SystemItemWriteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemItemId"] = this.systemItemId;
        data["price"] = this.price;
        return data;
    }
}

export interface ISystemItemWriteResponse {
    systemItemId?: number;
    price?: number | undefined;
}

export class UpdateAddOnSectionDto implements IUpdateAddOnSectionDto {
    name?: string | undefined;
    description?: string | undefined;
    displayGroupFlag?: string | undefined;
    sortOrder?: number;
    isExclusive?: boolean | undefined;
    isMandatory?: boolean | undefined;
    items?: OptionSettingsDto[] | undefined;
    itemIdsToRemove?: number[] | undefined;
    id?: number | undefined;

    constructor(data?: IUpdateAddOnSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.displayGroupFlag = _data["displayGroupFlag"];
            this.sortOrder = _data["sortOrder"];
            this.isExclusive = _data["isExclusive"];
            this.isMandatory = _data["isMandatory"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OptionSettingsDto.fromJS(item));
            }
            if (Array.isArray(_data["itemIdsToRemove"])) {
                this.itemIdsToRemove = [] as any;
                for (let item of _data["itemIdsToRemove"])
                    this.itemIdsToRemove!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAddOnSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddOnSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["displayGroupFlag"] = this.displayGroupFlag;
        data["sortOrder"] = this.sortOrder;
        data["isExclusive"] = this.isExclusive;
        data["isMandatory"] = this.isMandatory;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.itemIdsToRemove)) {
            data["itemIdsToRemove"] = [];
            for (let item of this.itemIdsToRemove)
                data["itemIdsToRemove"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateAddOnSectionDto {
    name?: string | undefined;
    description?: string | undefined;
    displayGroupFlag?: string | undefined;
    sortOrder?: number;
    isExclusive?: boolean | undefined;
    isMandatory?: boolean | undefined;
    items?: OptionSettingsDto[] | undefined;
    itemIdsToRemove?: number[] | undefined;
    id?: number | undefined;
}

export class UpdateBundleRequest implements IUpdateBundleRequest {
    summary?: string | undefined;
    statusCode?: string | undefined;
    imageUrl?: string | undefined;
    displayOrder?: number | undefined;
    configurableItemTypeId?: number | undefined;
    locationCode?: string | undefined;
    serviceProviderSupported?: boolean | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;
    sections?: UpdateAddOnSectionDto[] | undefined;
    sectionIdsToRemove?: number[] | undefined;
    standardsGroupIdsToAdd?: number[] | undefined;
    standardsGroupIdsToRemove?: number[] | undefined;

    constructor(data?: IUpdateBundleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"];
            this.statusCode = _data["statusCode"];
            this.imageUrl = _data["imageUrl"];
            this.displayOrder = _data["displayOrder"];
            this.configurableItemTypeId = _data["configurableItemTypeId"];
            this.locationCode = _data["locationCode"];
            this.serviceProviderSupported = _data["serviceProviderSupported"];
            this.statusMinDays = _data["statusMinDays"];
            this.statusMaxDays = _data["statusMaxDays"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(UpdateAddOnSectionDto.fromJS(item));
            }
            if (Array.isArray(_data["sectionIdsToRemove"])) {
                this.sectionIdsToRemove = [] as any;
                for (let item of _data["sectionIdsToRemove"])
                    this.sectionIdsToRemove!.push(item);
            }
            if (Array.isArray(_data["standardsGroupIdsToAdd"])) {
                this.standardsGroupIdsToAdd = [] as any;
                for (let item of _data["standardsGroupIdsToAdd"])
                    this.standardsGroupIdsToAdd!.push(item);
            }
            if (Array.isArray(_data["standardsGroupIdsToRemove"])) {
                this.standardsGroupIdsToRemove = [] as any;
                for (let item of _data["standardsGroupIdsToRemove"])
                    this.standardsGroupIdsToRemove!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateBundleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBundleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["statusCode"] = this.statusCode;
        data["imageUrl"] = this.imageUrl;
        data["displayOrder"] = this.displayOrder;
        data["configurableItemTypeId"] = this.configurableItemTypeId;
        data["locationCode"] = this.locationCode;
        data["serviceProviderSupported"] = this.serviceProviderSupported;
        data["statusMinDays"] = this.statusMinDays;
        data["statusMaxDays"] = this.statusMaxDays;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sectionIdsToRemove)) {
            data["sectionIdsToRemove"] = [];
            for (let item of this.sectionIdsToRemove)
                data["sectionIdsToRemove"].push(item);
        }
        if (Array.isArray(this.standardsGroupIdsToAdd)) {
            data["standardsGroupIdsToAdd"] = [];
            for (let item of this.standardsGroupIdsToAdd)
                data["standardsGroupIdsToAdd"].push(item);
        }
        if (Array.isArray(this.standardsGroupIdsToRemove)) {
            data["standardsGroupIdsToRemove"] = [];
            for (let item of this.standardsGroupIdsToRemove)
                data["standardsGroupIdsToRemove"].push(item);
        }
        return data;
    }
}

export interface IUpdateBundleRequest {
    summary?: string | undefined;
    statusCode?: string | undefined;
    imageUrl?: string | undefined;
    displayOrder?: number | undefined;
    configurableItemTypeId?: number | undefined;
    locationCode?: string | undefined;
    serviceProviderSupported?: boolean | undefined;
    statusMinDays?: number | undefined;
    statusMaxDays?: number | undefined;
    sections?: UpdateAddOnSectionDto[] | undefined;
    sectionIdsToRemove?: number[] | undefined;
    standardsGroupIdsToAdd?: number[] | undefined;
    standardsGroupIdsToRemove?: number[] | undefined;
}

export class ValidateProductsForBundleRequest implements IValidateProductsForBundleRequest {
    productIds?: number[] | undefined;

    constructor(data?: IValidateProductsForBundleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateProductsForBundleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateProductsForBundleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        return data;
    }
}

export interface IValidateProductsForBundleRequest {
    productIds?: number[] | undefined;
}

export class ValidateProductsForBundleResponse implements IValidateProductsForBundleResponse {
    results?: ProductBundleEligibility[] | undefined;

    constructor(data?: IValidateProductsForBundleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProductBundleEligibility.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateProductsForBundleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateProductsForBundleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidateProductsForBundleResponse {
    results?: ProductBundleEligibility[] | undefined;
}

export class CatalogNavigationCategoryDto implements ICatalogNavigationCategoryDto {
    categoryId?: string | undefined;
    categoryName?: string | undefined;
    count?: number | undefined;

    constructor(data?: ICatalogNavigationCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CatalogNavigationCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogNavigationCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["count"] = this.count;
        return data;
    }
}

export interface ICatalogNavigationCategoryDto {
    categoryId?: string | undefined;
    categoryName?: string | undefined;
    count?: number | undefined;
}

export class CatalogNavigationPathsResponse implements ICatalogNavigationPathsResponse {
    categories?: CatalogNavigationCategoryDto[] | undefined;
    resultsCount?: number | undefined;

    constructor(data?: ICatalogNavigationPathsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CatalogNavigationCategoryDto.fromJS(item));
            }
            this.resultsCount = _data["resultsCount"];
        }
    }

    static fromJS(data: any): CatalogNavigationPathsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogNavigationPathsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["resultsCount"] = this.resultsCount;
        return data;
    }
}

export interface ICatalogNavigationPathsResponse {
    categories?: CatalogNavigationCategoryDto[] | undefined;
    resultsCount?: number | undefined;
}

export enum CatalogProductClassDto {
    Unspecified = "Unspecified",
    Commodity = "Commodity",
    ConfigSystem = "ConfigSystem",
}

export class CatalogProductOverrideDto implements ICatalogProductOverrideDto {
    compositeCatalogId?: number;
    productId?: number;
    productClass?: CatalogProductClassDto;

    constructor(data?: ICatalogProductOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compositeCatalogId = _data["compositeCatalogId"];
            this.productId = _data["productId"];
            this.productClass = _data["productClass"];
        }
    }

    static fromJS(data: any): CatalogProductOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogProductOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compositeCatalogId"] = this.compositeCatalogId;
        data["productId"] = this.productId;
        data["productClass"] = this.productClass;
        return data;
    }
}

export interface ICatalogProductOverrideDto {
    compositeCatalogId?: number;
    productId?: number;
    productClass?: CatalogProductClassDto;
}

export class CatalogRuleActionDto implements ICatalogRuleActionDto {
    actionType?: string | undefined;
    catalogRuleId?: string | undefined;
    createdBy?: string | undefined;
    createdOnUtc?: string | undefined;
    id?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedOnUtc?: string | undefined;
    operation?: string | undefined;

    constructor(data?: ICatalogRuleActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.catalogRuleId = _data["catalogRuleId"];
            this.createdBy = _data["createdBy"];
            this.createdOnUtc = _data["createdOnUtc"];
            this.id = _data["id"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOnUtc = _data["modifiedOnUtc"];
            this.operation = _data["operation"];
        }
    }

    static fromJS(data: any): CatalogRuleActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogRuleActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["catalogRuleId"] = this.catalogRuleId;
        data["createdBy"] = this.createdBy;
        data["createdOnUtc"] = this.createdOnUtc;
        data["id"] = this.id;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOnUtc"] = this.modifiedOnUtc;
        data["operation"] = this.operation;
        return data;
    }
}

export interface ICatalogRuleActionDto {
    actionType?: string | undefined;
    catalogRuleId?: string | undefined;
    createdBy?: string | undefined;
    createdOnUtc?: string | undefined;
    id?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedOnUtc?: string | undefined;
    operation?: string | undefined;
}

export class CatalogRuleConditionDto implements ICatalogRuleConditionDto {
    fact?: string | undefined;
    values?: string[] | undefined;
    operator?: string | undefined;
    id?: string | undefined;
    isActive?: boolean | undefined;
    conditionSetId?: string | undefined;
    createdBy?: string | undefined;
    createdOnUtc?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedOnUtc?: string | undefined;

    constructor(data?: ICatalogRuleConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fact = _data["fact"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.operator = _data["operator"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.conditionSetId = _data["conditionSetId"];
            this.createdBy = _data["createdBy"];
            this.createdOnUtc = _data["createdOnUtc"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOnUtc = _data["modifiedOnUtc"];
        }
    }

    static fromJS(data: any): CatalogRuleConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogRuleConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fact"] = this.fact;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["operator"] = this.operator;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["conditionSetId"] = this.conditionSetId;
        data["createdBy"] = this.createdBy;
        data["createdOnUtc"] = this.createdOnUtc;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOnUtc"] = this.modifiedOnUtc;
        return data;
    }
}

export interface ICatalogRuleConditionDto {
    fact?: string | undefined;
    values?: string[] | undefined;
    operator?: string | undefined;
    id?: string | undefined;
    isActive?: boolean | undefined;
    conditionSetId?: string | undefined;
    createdBy?: string | undefined;
    createdOnUtc?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedOnUtc?: string | undefined;
}

export class CatalogRuleConditionSetDto implements ICatalogRuleConditionSetDto {
    conditions?: CatalogRuleConditionDto[] | undefined;
    setLogic?: string | undefined;
    id?: string | undefined;
    isActive?: boolean | undefined;
    catalogRuleId?: string | undefined;
    createdBy?: string | undefined;
    createdOnUtc?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedOnUtc?: string | undefined;

    constructor(data?: ICatalogRuleConditionSetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(CatalogRuleConditionDto.fromJS(item));
            }
            this.setLogic = _data["setLogic"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.catalogRuleId = _data["catalogRuleId"];
            this.createdBy = _data["createdBy"];
            this.createdOnUtc = _data["createdOnUtc"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOnUtc = _data["modifiedOnUtc"];
        }
    }

    static fromJS(data: any): CatalogRuleConditionSetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogRuleConditionSetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        data["setLogic"] = this.setLogic;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["catalogRuleId"] = this.catalogRuleId;
        data["createdBy"] = this.createdBy;
        data["createdOnUtc"] = this.createdOnUtc;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOnUtc"] = this.modifiedOnUtc;
        return data;
    }
}

export interface ICatalogRuleConditionSetDto {
    conditions?: CatalogRuleConditionDto[] | undefined;
    setLogic?: string | undefined;
    id?: string | undefined;
    isActive?: boolean | undefined;
    catalogRuleId?: string | undefined;
    createdBy?: string | undefined;
    createdOnUtc?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedOnUtc?: string | undefined;
}

export class CatalogRuleDto implements ICatalogRuleDto {
    id?: string | undefined;
    orgUnitId?: number;
    isActive?: boolean;
    conditionSets?: CatalogRuleConditionSetDto[] | undefined;
    actions?: CatalogRuleActionDto[] | undefined;
    ruleType?: string | undefined;
    priority?: number | undefined;
    description?: string | undefined;
    validFrom?: string | undefined;
    validUntil?: string | undefined;
    createdBy?: string | undefined;
    createdOnUtc?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedOnUtc?: string | undefined;

    constructor(data?: ICatalogRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orgUnitId = _data["orgUnitId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["conditionSets"])) {
                this.conditionSets = [] as any;
                for (let item of _data["conditionSets"])
                    this.conditionSets!.push(CatalogRuleConditionSetDto.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(CatalogRuleActionDto.fromJS(item));
            }
            this.ruleType = _data["ruleType"];
            this.priority = _data["priority"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"];
            this.validUntil = _data["validUntil"];
            this.createdBy = _data["createdBy"];
            this.createdOnUtc = _data["createdOnUtc"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOnUtc = _data["modifiedOnUtc"];
        }
    }

    static fromJS(data: any): CatalogRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orgUnitId"] = this.orgUnitId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.conditionSets)) {
            data["conditionSets"] = [];
            for (let item of this.conditionSets)
                data["conditionSets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        data["ruleType"] = this.ruleType;
        data["priority"] = this.priority;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom;
        data["validUntil"] = this.validUntil;
        data["createdBy"] = this.createdBy;
        data["createdOnUtc"] = this.createdOnUtc;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOnUtc"] = this.modifiedOnUtc;
        return data;
    }
}

export interface ICatalogRuleDto {
    id?: string | undefined;
    orgUnitId?: number;
    isActive?: boolean;
    conditionSets?: CatalogRuleConditionSetDto[] | undefined;
    actions?: CatalogRuleActionDto[] | undefined;
    ruleType?: string | undefined;
    priority?: number | undefined;
    description?: string | undefined;
    validFrom?: string | undefined;
    validUntil?: string | undefined;
    createdBy?: string | undefined;
    createdOnUtc?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedOnUtc?: string | undefined;
}

export class CatalogRuleToggleResultDto implements ICatalogRuleToggleResultDto {
    message?: string | undefined;

    constructor(data?: ICatalogRuleToggleResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CatalogRuleToggleResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogRuleToggleResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface ICatalogRuleToggleResultDto {
    message?: string | undefined;
}

export class CatalogViewDto implements ICatalogViewDto {
    standardsOnly?: boolean;
    hwswInclusion?: HwswInclusionDto;
    adjustmentCounts?: AdjustmentCountsDto;
    rules?: CatalogRuleDto[] | undefined;

    constructor(data?: ICatalogViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardsOnly = _data["standardsOnly"];
            this.hwswInclusion = _data["hwswInclusion"] ? HwswInclusionDto.fromJS(_data["hwswInclusion"]) : undefined as any;
            this.adjustmentCounts = _data["adjustmentCounts"] ? AdjustmentCountsDto.fromJS(_data["adjustmentCounts"]) : undefined as any;
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(CatalogRuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CatalogViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardsOnly"] = this.standardsOnly;
        data["hwswInclusion"] = this.hwswInclusion ? this.hwswInclusion.toJSON() : undefined as any;
        data["adjustmentCounts"] = this.adjustmentCounts ? this.adjustmentCounts.toJSON() : undefined as any;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICatalogViewDto {
    standardsOnly?: boolean;
    hwswInclusion?: HwswInclusionDto;
    adjustmentCounts?: AdjustmentCountsDto;
    rules?: CatalogRuleDto[] | undefined;
}

export class CreateAddressDto implements ICreateAddressDto {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    addressName?: string | undefined;
    isDefault?: boolean;
    addressGroupNames?: string[] | undefined;
    attention?: string | undefined;
    residential?: boolean;

    constructor(data?: ICreateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.addressName = _data["addressName"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["addressGroupNames"])) {
                this.addressGroupNames = [] as any;
                for (let item of _data["addressGroupNames"])
                    this.addressGroupNames!.push(item);
            }
            this.attention = _data["attention"];
            this.residential = _data["residential"];
        }
    }

    static fromJS(data: any): CreateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["addressName"] = this.addressName;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.addressGroupNames)) {
            data["addressGroupNames"] = [];
            for (let item of this.addressGroupNames)
                data["addressGroupNames"].push(item);
        }
        data["attention"] = this.attention;
        data["residential"] = this.residential;
        return data;
    }
}

export interface ICreateAddressDto {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    addressName?: string | undefined;
    isDefault?: boolean;
    addressGroupNames?: string[] | undefined;
    attention?: string | undefined;
    residential?: boolean;
}

export class CreateAddressGroupRequest implements ICreateAddressGroupRequest {
    orgUnitId?: number;
    groupName?: string | undefined;

    constructor(data?: ICreateAddressGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): CreateAddressGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["groupName"] = this.groupName;
        return data;
    }
}

export interface ICreateAddressGroupRequest {
    orgUnitId?: number;
    groupName?: string | undefined;
}

export class CreateAddressResponseDto implements ICreateAddressResponseDto {
    streetAddressId?: number;
    isExisting?: boolean;
    addressGroups?: AddressGroupEntryDto[] | undefined;

    constructor(data?: ICreateAddressResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetAddressId = _data["streetAddressId"];
            this.isExisting = _data["isExisting"];
            if (Array.isArray(_data["addressGroups"])) {
                this.addressGroups = [] as any;
                for (let item of _data["addressGroups"])
                    this.addressGroups!.push(AddressGroupEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAddressResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddressId"] = this.streetAddressId;
        data["isExisting"] = this.isExisting;
        if (Array.isArray(this.addressGroups)) {
            data["addressGroups"] = [];
            for (let item of this.addressGroups)
                data["addressGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateAddressResponseDto {
    streetAddressId?: number;
    isExisting?: boolean;
    addressGroups?: AddressGroupEntryDto[] | undefined;
}

export class CreatePersonalAddressDto implements ICreatePersonalAddressDto {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    addressName?: string | undefined;
    attention?: string | undefined;
    residential?: boolean;

    constructor(data?: ICreatePersonalAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.addressName = _data["addressName"];
            this.attention = _data["attention"];
            this.residential = _data["residential"];
        }
    }

    static fromJS(data: any): CreatePersonalAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonalAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["addressName"] = this.addressName;
        data["attention"] = this.attention;
        data["residential"] = this.residential;
        return data;
    }
}

export interface ICreatePersonalAddressDto {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    addressName?: string | undefined;
    attention?: string | undefined;
    residential?: boolean;
}

export class CreatePersonalAddressResponseDto implements ICreatePersonalAddressResponseDto {
    streetAddressId?: number;
    isExisting?: boolean;

    constructor(data?: ICreatePersonalAddressResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetAddressId = _data["streetAddressId"];
            this.isExisting = _data["isExisting"];
        }
    }

    static fromJS(data: any): CreatePersonalAddressResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonalAddressResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddressId"] = this.streetAddressId;
        data["isExisting"] = this.isExisting;
        return data;
    }
}

export interface ICreatePersonalAddressResponseDto {
    streetAddressId?: number;
    isExisting?: boolean;
}

export class GetOrgUnitLogoInfoResponse implements IGetOrgUnitLogoInfoResponse {
    logo?: OrgUnitLogoDto;

    constructor(data?: IGetOrgUnitLogoInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logo = _data["logo"] ? OrgUnitLogoDto.fromJS(_data["logo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetOrgUnitLogoInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrgUnitLogoInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo ? this.logo.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetOrgUnitLogoInfoResponse {
    logo?: OrgUnitLogoDto;
}

export class GetOrgUnitLogoResponse implements IGetOrgUnitLogoResponse {
    logo?: string | undefined;

    constructor(data?: IGetOrgUnitLogoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): GetOrgUnitLogoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrgUnitLogoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        return data;
    }
}

export interface IGetOrgUnitLogoResponse {
    logo?: string | undefined;
}

export class GetProductDetailsResponse implements IGetProductDetailsResponse {
    productDetails?: ProductDetailDto[] | undefined;

    constructor(data?: IGetProductDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productDetails"])) {
                this.productDetails = [] as any;
                for (let item of _data["productDetails"])
                    this.productDetails!.push(ProductDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productDetails)) {
            data["productDetails"] = [];
            for (let item of this.productDetails)
                data["productDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProductDetailsResponse {
    productDetails?: ProductDetailDto[] | undefined;
}

export class GetStandardsFoldersResponse implements IGetStandardsFoldersResponse {
    standardsGroups?: StandardsGroupDto[] | undefined;

    constructor(data?: IGetStandardsFoldersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standardsGroups"])) {
                this.standardsGroups = [] as any;
                for (let item of _data["standardsGroups"])
                    this.standardsGroups!.push(StandardsGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStandardsFoldersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardsFoldersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standardsGroups)) {
            data["standardsGroups"] = [];
            for (let item of this.standardsGroups)
                data["standardsGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetStandardsFoldersResponse {
    standardsGroups?: StandardsGroupDto[] | undefined;
}

export class GetWelcomeMessageByOrgIdResponse implements IGetWelcomeMessageByOrgIdResponse {
    messageText?: string | undefined;
    messageKey?: string | undefined;

    constructor(data?: IGetWelcomeMessageByOrgIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageText = _data["messageText"];
            this.messageKey = _data["messageKey"];
        }
    }

    static fromJS(data: any): GetWelcomeMessageByOrgIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWelcomeMessageByOrgIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageText"] = this.messageText;
        data["messageKey"] = this.messageKey;
        return data;
    }
}

export interface IGetWelcomeMessageByOrgIdResponse {
    messageText?: string | undefined;
    messageKey?: string | undefined;
}

export class HwswInclusionDto implements IHwswInclusionDto {
    hardware?: boolean;
    software?: boolean;
    otherProducts?: boolean;

    constructor(data?: IHwswInclusionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hardware = _data["hardware"];
            this.software = _data["software"];
            this.otherProducts = _data["otherProducts"];
        }
    }

    static fromJS(data: any): HwswInclusionDto {
        data = typeof data === 'object' ? data : {};
        let result = new HwswInclusionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hardware"] = this.hardware;
        data["software"] = this.software;
        data["otherProducts"] = this.otherProducts;
        return data;
    }
}

export interface IHwswInclusionDto {
    hardware?: boolean;
    software?: boolean;
    otherProducts?: boolean;
}

export class InsertStandardsProductItemResponse implements IInsertStandardsProductItemResponse {
    orgUnitId?: number;
    standardsGroupId?: number;
    products?: StandardsProductItemDto[] | undefined;
    productDetails?: ProductDetailDto[] | undefined;
    addedProductCount?: number;

    constructor(data?: IInsertStandardsProductItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.standardsGroupId = _data["standardsGroupId"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(StandardsProductItemDto.fromJS(item));
            }
            if (Array.isArray(_data["productDetails"])) {
                this.productDetails = [] as any;
                for (let item of _data["productDetails"])
                    this.productDetails!.push(ProductDetailDto.fromJS(item));
            }
            this.addedProductCount = _data["addedProductCount"];
        }
    }

    static fromJS(data: any): InsertStandardsProductItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsertStandardsProductItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["standardsGroupId"] = this.standardsGroupId;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productDetails)) {
            data["productDetails"] = [];
            for (let item of this.productDetails)
                data["productDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["addedProductCount"] = this.addedProductCount;
        return data;
    }
}

export interface IInsertStandardsProductItemResponse {
    orgUnitId?: number;
    standardsGroupId?: number;
    products?: StandardsProductItemDto[] | undefined;
    productDetails?: ProductDetailDto[] | undefined;
    addedProductCount?: number;
}

export class ManufacturerCatalogRuleGroupDto implements IManufacturerCatalogRuleGroupDto {
    manufacturerId?: number;
    manufacturerName?: string | undefined;
    productLineCount?: number;
    productCount?: number;
    inCatalog?: string | undefined;
    productLines?: ProductLineCatalogRuleRowDto[] | undefined;
    priceRuleSummary?: ManufacturerPriceRuleSummaryDto;

    constructor(data?: IManufacturerCatalogRuleGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerId = _data["manufacturerId"];
            this.manufacturerName = _data["manufacturerName"];
            this.productLineCount = _data["productLineCount"];
            this.productCount = _data["productCount"];
            this.inCatalog = _data["inCatalog"];
            if (Array.isArray(_data["productLines"])) {
                this.productLines = [] as any;
                for (let item of _data["productLines"])
                    this.productLines!.push(ProductLineCatalogRuleRowDto.fromJS(item));
            }
            this.priceRuleSummary = _data["priceRuleSummary"] ? ManufacturerPriceRuleSummaryDto.fromJS(_data["priceRuleSummary"]) : undefined as any;
        }
    }

    static fromJS(data: any): ManufacturerCatalogRuleGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerCatalogRuleGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerId"] = this.manufacturerId;
        data["manufacturerName"] = this.manufacturerName;
        data["productLineCount"] = this.productLineCount;
        data["productCount"] = this.productCount;
        data["inCatalog"] = this.inCatalog;
        if (Array.isArray(this.productLines)) {
            data["productLines"] = [];
            for (let item of this.productLines)
                data["productLines"].push(item ? item.toJSON() : undefined as any);
        }
        data["priceRuleSummary"] = this.priceRuleSummary ? this.priceRuleSummary.toJSON() : undefined as any;
        return data;
    }
}

export interface IManufacturerCatalogRuleGroupDto {
    manufacturerId?: number;
    manufacturerName?: string | undefined;
    productLineCount?: number;
    productCount?: number;
    inCatalog?: string | undefined;
    productLines?: ProductLineCatalogRuleRowDto[] | undefined;
    priceRuleSummary?: ManufacturerPriceRuleSummaryDto;
}

export class ManufacturerPriceRuleSummaryDto implements IManufacturerPriceRuleSummaryDto {
    productLineCount?: number;
    productLinesWithRuleCount?: number;
    distinctRuleCount?: number;
    sharedPriceRule?: ProductLinePriceRuleDto;
    productLinePriceRules?: ManufacturerProductLinePriceRuleDto[] | undefined;

    constructor(data?: IManufacturerPriceRuleSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productLineCount = _data["productLineCount"];
            this.productLinesWithRuleCount = _data["productLinesWithRuleCount"];
            this.distinctRuleCount = _data["distinctRuleCount"];
            this.sharedPriceRule = _data["sharedPriceRule"] ? ProductLinePriceRuleDto.fromJS(_data["sharedPriceRule"]) : undefined as any;
            if (Array.isArray(_data["productLinePriceRules"])) {
                this.productLinePriceRules = [] as any;
                for (let item of _data["productLinePriceRules"])
                    this.productLinePriceRules!.push(ManufacturerProductLinePriceRuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManufacturerPriceRuleSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerPriceRuleSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLineCount"] = this.productLineCount;
        data["productLinesWithRuleCount"] = this.productLinesWithRuleCount;
        data["distinctRuleCount"] = this.distinctRuleCount;
        data["sharedPriceRule"] = this.sharedPriceRule ? this.sharedPriceRule.toJSON() : undefined as any;
        if (Array.isArray(this.productLinePriceRules)) {
            data["productLinePriceRules"] = [];
            for (let item of this.productLinePriceRules)
                data["productLinePriceRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IManufacturerPriceRuleSummaryDto {
    productLineCount?: number;
    productLinesWithRuleCount?: number;
    distinctRuleCount?: number;
    sharedPriceRule?: ProductLinePriceRuleDto;
    productLinePriceRules?: ManufacturerProductLinePriceRuleDto[] | undefined;
}

export class ManufacturerProductLinePriceRuleDto implements IManufacturerProductLinePriceRuleDto {
    productLineId?: number;
    productLineName?: string | undefined;
    priceRule?: ProductLinePriceRuleDto;

    constructor(data?: IManufacturerProductLinePriceRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productLineId = _data["productLineId"];
            this.productLineName = _data["productLineName"];
            this.priceRule = _data["priceRule"] ? ProductLinePriceRuleDto.fromJS(_data["priceRule"]) : undefined as any;
        }
    }

    static fromJS(data: any): ManufacturerProductLinePriceRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerProductLinePriceRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLineId"] = this.productLineId;
        data["productLineName"] = this.productLineName;
        data["priceRule"] = this.priceRule ? this.priceRule.toJSON() : undefined as any;
        return data;
    }
}

export interface IManufacturerProductLinePriceRuleDto {
    productLineId?: number;
    productLineName?: string | undefined;
    priceRule?: ProductLinePriceRuleDto;
}

export class ManufacturerProductLineSearchResultDto implements IManufacturerProductLineSearchResultDto {
    manufacturers?: ManufacturerCatalogRuleGroupDto[] | undefined;
    totalManufacturers?: number;
    totalProductLines?: number;
    totalProducts?: number;
    pageIndex?: number;
    pageSize?: number;
    isNewPriceCalculationEngineEnabled?: boolean;

    constructor(data?: IManufacturerProductLineSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(ManufacturerCatalogRuleGroupDto.fromJS(item));
            }
            this.totalManufacturers = _data["totalManufacturers"];
            this.totalProductLines = _data["totalProductLines"];
            this.totalProducts = _data["totalProducts"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.isNewPriceCalculationEngineEnabled = _data["isNewPriceCalculationEngineEnabled"];
        }
    }

    static fromJS(data: any): ManufacturerProductLineSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerProductLineSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalManufacturers"] = this.totalManufacturers;
        data["totalProductLines"] = this.totalProductLines;
        data["totalProducts"] = this.totalProducts;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["isNewPriceCalculationEngineEnabled"] = this.isNewPriceCalculationEngineEnabled;
        return data;
    }
}

export interface IManufacturerProductLineSearchResultDto {
    manufacturers?: ManufacturerCatalogRuleGroupDto[] | undefined;
    totalManufacturers?: number;
    totalProductLines?: number;
    totalProducts?: number;
    pageIndex?: number;
    pageSize?: number;
    isNewPriceCalculationEngineEnabled?: boolean;
}

export class OrgUnitAddressGroupDto implements IOrgUnitAddressGroupDto {
    addressGroupId?: number;
    name?: string | undefined;

    constructor(data?: IOrgUnitAddressGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressGroupId = _data["addressGroupId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrgUnitAddressGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitAddressGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressGroupId"] = this.addressGroupId;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrgUnitAddressGroupDto {
    addressGroupId?: number;
    name?: string | undefined;
}

export enum PriceRuleDial {
    Penny = "Penny",
    Dime = "Dime",
    Dollar = "Dollar",
}

export enum PricingMethod {
    DefaultCatalogPrice = "DefaultCatalogPrice",
    CostMarkup = "CostMarkup",
    CostMargin = "CostMargin",
    ListPriceDiscount = "ListPriceDiscount",
}

export enum ProductAvailabilityRowType {
    ShiStock = "ShiStock",
    OwnedStock = "OwnedStock",
    ReservedStock = "ReservedStock",
}

export class ProductAvailabilityStockRowDto implements IProductAvailabilityStockRowDto {
    rowType?: ProductAvailabilityRowType;
    location?: string | undefined;
    inStock?: number;
    onOrder?: number;
    onOrderEta?: Date | undefined;

    constructor(data?: IProductAvailabilityStockRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowType = _data["rowType"];
            this.location = _data["location"];
            this.inStock = _data["inStock"];
            this.onOrder = _data["onOrder"];
            this.onOrderEta = _data["onOrderEta"] ? new Date(_data["onOrderEta"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProductAvailabilityStockRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAvailabilityStockRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowType"] = this.rowType;
        data["location"] = this.location;
        data["inStock"] = this.inStock;
        data["onOrder"] = this.onOrder;
        data["onOrderEta"] = this.onOrderEta ? this.onOrderEta.toISOString() : undefined as any;
        return data;
    }
}

export interface IProductAvailabilityStockRowDto {
    rowType?: ProductAvailabilityRowType;
    location?: string | undefined;
    inStock?: number;
    onOrder?: number;
    onOrderEta?: Date | undefined;
}

export class ProductAvailabilitySummaryDto implements IProductAvailabilitySummaryDto {
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    price?: number | undefined;
    itemStatus?: string | undefined;
    imageUrl?: string | undefined;
    mediaClass?: string | undefined;

    constructor(data?: IProductAvailabilitySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.price = _data["price"];
            this.itemStatus = _data["itemStatus"];
            this.imageUrl = _data["imageUrl"];
            this.mediaClass = _data["mediaClass"];
        }
    }

    static fromJS(data: any): ProductAvailabilitySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAvailabilitySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["price"] = this.price;
        data["itemStatus"] = this.itemStatus;
        data["imageUrl"] = this.imageUrl;
        data["mediaClass"] = this.mediaClass;
        return data;
    }
}

export interface IProductAvailabilitySummaryDto {
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    price?: number | undefined;
    itemStatus?: string | undefined;
    imageUrl?: string | undefined;
    mediaClass?: string | undefined;
}

export class ProductLineCatalogRuleRowDto implements IProductLineCatalogRuleRowDto {
    productLineId?: number;
    productLineName?: string | undefined;
    productCount?: number;
    inCatalog?: string | undefined;
    priceRule?: ProductLinePriceRuleDto;

    constructor(data?: IProductLineCatalogRuleRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productLineId = _data["productLineId"];
            this.productLineName = _data["productLineName"];
            this.productCount = _data["productCount"];
            this.inCatalog = _data["inCatalog"];
            this.priceRule = _data["priceRule"] ? ProductLinePriceRuleDto.fromJS(_data["priceRule"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProductLineCatalogRuleRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLineCatalogRuleRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLineId"] = this.productLineId;
        data["productLineName"] = this.productLineName;
        data["productCount"] = this.productCount;
        data["inCatalog"] = this.inCatalog;
        data["priceRule"] = this.priceRule ? this.priceRule.toJSON() : undefined as any;
        return data;
    }
}

export interface IProductLineCatalogRuleRowDto {
    productLineId?: number;
    productLineName?: string | undefined;
    productCount?: number;
    inCatalog?: string | undefined;
    priceRule?: ProductLinePriceRuleDto;
}

export class ProductLinePriceRuleDto implements IProductLinePriceRuleDto {
    pricingMethod?: PricingMethod;
    dial?: PriceRuleDial;
    operation?: number;

    constructor(data?: IProductLinePriceRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricingMethod = _data["pricingMethod"];
            this.dial = _data["dial"];
            this.operation = _data["operation"];
        }
    }

    static fromJS(data: any): ProductLinePriceRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLinePriceRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricingMethod"] = this.pricingMethod;
        data["dial"] = this.dial;
        data["operation"] = this.operation;
        return data;
    }
}

export interface IProductLinePriceRuleDto {
    pricingMethod?: PricingMethod;
    dial?: PriceRuleDial;
    operation?: number;
}

export class ProductPriceRuleMutationResultDto implements IProductPriceRuleMutationResultDto {
    rule?: CatalogRuleDto;
    usesDefaultCatalogPrice?: boolean;

    constructor(data?: IProductPriceRuleMutationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rule = _data["rule"] ? CatalogRuleDto.fromJS(_data["rule"]) : undefined as any;
            this.usesDefaultCatalogPrice = _data["usesDefaultCatalogPrice"];
        }
    }

    static fromJS(data: any): ProductPriceRuleMutationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceRuleMutationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rule"] = this.rule ? this.rule.toJSON() : undefined as any;
        data["usesDefaultCatalogPrice"] = this.usesDefaultCatalogPrice;
        return data;
    }
}

export interface IProductPriceRuleMutationResultDto {
    rule?: CatalogRuleDto;
    usesDefaultCatalogPrice?: boolean;
}

export class ProductSearchCategoryNode implements IProductSearchCategoryNode {
    categoryId!: string | undefined;
    categoryName!: string | undefined;
    count!: number;
    moreKey!: string | undefined;
    parentCategoryId?: string | undefined;
    slug!: string | undefined;
    children!: ProductSearchCategoryNode[] | undefined;

    constructor(data?: IProductSearchCategoryNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.count = _data["count"];
            this.moreKey = _data["moreKey"];
            this.parentCategoryId = _data["parentCategoryId"];
            this.slug = _data["slug"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ProductSearchCategoryNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductSearchCategoryNode {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSearchCategoryNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["count"] = this.count;
        data["moreKey"] = this.moreKey;
        data["parentCategoryId"] = this.parentCategoryId;
        data["slug"] = this.slug;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductSearchCategoryNode {
    categoryId: string | undefined;
    categoryName: string | undefined;
    count: number;
    moreKey: string | undefined;
    parentCategoryId?: string | undefined;
    slug: string | undefined;
    children: ProductSearchCategoryNode[] | undefined;
}

export class ProductSearchCategoryTree implements IProductSearchCategoryTree {
    selectedValues!: ProductSearchRefinementValue[] | undefined;
    categories!: ProductSearchCategoryNode[] | undefined;

    constructor(data?: IProductSearchCategoryTree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedValues"])) {
                this.selectedValues = [] as any;
                for (let item of _data["selectedValues"])
                    this.selectedValues!.push(ProductSearchRefinementValue.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ProductSearchCategoryNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductSearchCategoryTree {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSearchCategoryTree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedValues)) {
            data["selectedValues"] = [];
            for (let item of this.selectedValues)
                data["selectedValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductSearchCategoryTree {
    selectedValues: ProductSearchRefinementValue[] | undefined;
    categories: ProductSearchCategoryNode[] | undefined;
}

export class ProductSearchRefinement implements IProductSearchRefinement {
    name?: string | undefined;
    displayName?: string | undefined;
    isSingleSelect?: boolean;
    hasMore?: boolean;
    values?: ProductSearchRefinementValue[] | undefined;
    selectedValues?: ProductSearchRefinementValue[] | undefined;

    constructor(data?: IProductSearchRefinement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isSingleSelect = _data["isSingleSelect"];
            this.hasMore = _data["hasMore"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ProductSearchRefinementValue.fromJS(item));
            }
            if (Array.isArray(_data["selectedValues"])) {
                this.selectedValues = [] as any;
                for (let item of _data["selectedValues"])
                    this.selectedValues!.push(ProductSearchRefinementValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductSearchRefinement {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSearchRefinement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isSingleSelect"] = this.isSingleSelect;
        data["hasMore"] = this.hasMore;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.selectedValues)) {
            data["selectedValues"] = [];
            for (let item of this.selectedValues)
                data["selectedValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductSearchRefinement {
    name?: string | undefined;
    displayName?: string | undefined;
    isSingleSelect?: boolean;
    hasMore?: boolean;
    values?: ProductSearchRefinementValue[] | undefined;
    selectedValues?: ProductSearchRefinementValue[] | undefined;
}

export class ProductSearchRefinementValue implements IProductSearchRefinementValue {
    value?: string | undefined;
    label?: string | undefined;
    count?: number | undefined;

    constructor(data?: IProductSearchRefinementValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ProductSearchRefinementValue {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSearchRefinementValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["count"] = this.count;
        return data;
    }
}

export interface IProductSearchRefinementValue {
    value?: string | undefined;
    label?: string | undefined;
    count?: number | undefined;
}

export class ReplaceStandardsProductItemResponse implements IReplaceStandardsProductItemResponse {
    orgUnitId?: number;
    standardsGroupId?: number;
    origin?: ProductIdentifierDto;
    product?: StandardsProductItemDto;
    productDetail?: ProductDetailDto;

    constructor(data?: IReplaceStandardsProductItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.standardsGroupId = _data["standardsGroupId"];
            this.origin = _data["origin"] ? ProductIdentifierDto.fromJS(_data["origin"]) : undefined as any;
            this.product = _data["product"] ? StandardsProductItemDto.fromJS(_data["product"]) : undefined as any;
            this.productDetail = _data["productDetail"] ? ProductDetailDto.fromJS(_data["productDetail"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReplaceStandardsProductItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReplaceStandardsProductItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["standardsGroupId"] = this.standardsGroupId;
        data["origin"] = this.origin ? this.origin.toJSON() : undefined as any;
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        data["productDetail"] = this.productDetail ? this.productDetail.toJSON() : undefined as any;
        return data;
    }
}

export interface IReplaceStandardsProductItemResponse {
    orgUnitId?: number;
    standardsGroupId?: number;
    origin?: ProductIdentifierDto;
    product?: StandardsProductItemDto;
    productDetail?: ProductDetailDto;
}

export class SearchProductsResponse implements ISearchProductsResponse {
    products?: CatalogedProductDto[] | undefined;
    page?: number;
    pageSize?: number;
    pageCount?: number;
    total?: number;
    isNewPriceCalculationEngineEnabled?: boolean;
    refinements?: ProductSearchRefinement[] | undefined;
    categoryNavigation?: ProductSearchCategoryTree;
    categorySlugResolved?: boolean | undefined;
    nextOffset?: number | undefined;

    constructor(data?: ISearchProductsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CatalogedProductDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.pageCount = _data["pageCount"];
            this.total = _data["total"];
            this.isNewPriceCalculationEngineEnabled = _data["isNewPriceCalculationEngineEnabled"];
            if (Array.isArray(_data["refinements"])) {
                this.refinements = [] as any;
                for (let item of _data["refinements"])
                    this.refinements!.push(ProductSearchRefinement.fromJS(item));
            }
            this.categoryNavigation = _data["categoryNavigation"] ? ProductSearchCategoryTree.fromJS(_data["categoryNavigation"]) : undefined as any;
            this.categorySlugResolved = _data["categorySlugResolved"];
            this.nextOffset = _data["nextOffset"];
        }
    }

    static fromJS(data: any): SearchProductsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProductsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["pageCount"] = this.pageCount;
        data["total"] = this.total;
        data["isNewPriceCalculationEngineEnabled"] = this.isNewPriceCalculationEngineEnabled;
        if (Array.isArray(this.refinements)) {
            data["refinements"] = [];
            for (let item of this.refinements)
                data["refinements"].push(item ? item.toJSON() : undefined as any);
        }
        data["categoryNavigation"] = this.categoryNavigation ? this.categoryNavigation.toJSON() : undefined as any;
        data["categorySlugResolved"] = this.categorySlugResolved;
        data["nextOffset"] = this.nextOffset;
        return data;
    }
}

export interface ISearchProductsResponse {
    products?: CatalogedProductDto[] | undefined;
    page?: number;
    pageSize?: number;
    pageCount?: number;
    total?: number;
    isNewPriceCalculationEngineEnabled?: boolean;
    refinements?: ProductSearchRefinement[] | undefined;
    categoryNavigation?: ProductSearchCategoryTree;
    categorySlugResolved?: boolean | undefined;
    nextOffset?: number | undefined;
}

export class SetProductPriceRuleRequestDto implements ISetProductPriceRuleRequestDto {
    productId?: number;
    pricingMethod?: PricingMethod | undefined;
    dial?: PriceRuleDial | undefined;
    operation?: number | undefined;

    constructor(data?: ISetProductPriceRuleRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.pricingMethod = _data["pricingMethod"];
            this.dial = _data["dial"];
            this.operation = _data["operation"];
        }
    }

    static fromJS(data: any): SetProductPriceRuleRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetProductPriceRuleRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["pricingMethod"] = this.pricingMethod;
        data["dial"] = this.dial;
        data["operation"] = this.operation;
        return data;
    }
}

export interface ISetProductPriceRuleRequestDto {
    productId?: number;
    pricingMethod?: PricingMethod | undefined;
    dial?: PriceRuleDial | undefined;
    operation?: number | undefined;
}

export class StandardsProductResultDto implements IStandardsProductResultDto {
    groupId?: number;
    productId?: number;
    productClass?: string | undefined;
    displayOrder?: number;
    enableBuyNow?: boolean;

    constructor(data?: IStandardsProductResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.productId = _data["productId"];
            this.productClass = _data["productClass"];
            this.displayOrder = _data["displayOrder"];
            this.enableBuyNow = _data["enableBuyNow"];
        }
    }

    static fromJS(data: any): StandardsProductResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsProductResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["productId"] = this.productId;
        data["productClass"] = this.productClass;
        data["displayOrder"] = this.displayOrder;
        data["enableBuyNow"] = this.enableBuyNow;
        return data;
    }
}

export interface IStandardsProductResultDto {
    groupId?: number;
    productId?: number;
    productClass?: string | undefined;
    displayOrder?: number;
    enableBuyNow?: boolean;
}

export class StorefrontAddToStandardsDto implements IStorefrontAddToStandardsDto {
    compositeCatalogId?: number;
    groupId?: number;
    productId?: number;
    productClass?: string | undefined;

    constructor(data?: IStorefrontAddToStandardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compositeCatalogId = _data["compositeCatalogId"];
            this.groupId = _data["groupId"];
            this.productId = _data["productId"];
            this.productClass = _data["productClass"];
        }
    }

    static fromJS(data: any): StorefrontAddToStandardsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontAddToStandardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compositeCatalogId"] = this.compositeCatalogId;
        data["groupId"] = this.groupId;
        data["productId"] = this.productId;
        data["productClass"] = this.productClass;
        return data;
    }
}

export interface IStorefrontAddToStandardsDto {
    compositeCatalogId?: number;
    groupId?: number;
    productId?: number;
    productClass?: string | undefined;
}

export class StorefrontCatalogInfoResult implements IStorefrontCatalogInfoResult {
    baseCatalogId?: number | undefined;
    baseCatalogName?: string | undefined;
    compositeCatalogId?: number | undefined;

    constructor(data?: IStorefrontCatalogInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCatalogId = _data["baseCatalogId"];
            this.baseCatalogName = _data["baseCatalogName"];
            this.compositeCatalogId = _data["compositeCatalogId"];
        }
    }

    static fromJS(data: any): StorefrontCatalogInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontCatalogInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCatalogId"] = this.baseCatalogId;
        data["baseCatalogName"] = this.baseCatalogName;
        data["compositeCatalogId"] = this.compositeCatalogId;
        return data;
    }
}

export interface IStorefrontCatalogInfoResult {
    baseCatalogId?: number | undefined;
    baseCatalogName?: string | undefined;
    compositeCatalogId?: number | undefined;
}

export class StorefrontRemoveFromStandardsDto implements IStorefrontRemoveFromStandardsDto {
    groupId?: number;
    productId?: number;

    constructor(data?: IStorefrontRemoveFromStandardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): StorefrontRemoveFromStandardsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontRemoveFromStandardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["productId"] = this.productId;
        return data;
    }
}

export interface IStorefrontRemoveFromStandardsDto {
    groupId?: number;
    productId?: number;
}

export class ToggleManufacturerInclusionRequestDto implements IToggleManufacturerInclusionRequestDto {
    manufacturerId?: number;
    inCatalog?: boolean;

    constructor(data?: IToggleManufacturerInclusionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerId = _data["manufacturerId"];
            this.inCatalog = _data["inCatalog"];
        }
    }

    static fromJS(data: any): ToggleManufacturerInclusionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleManufacturerInclusionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerId"] = this.manufacturerId;
        data["inCatalog"] = this.inCatalog;
        return data;
    }
}

export interface IToggleManufacturerInclusionRequestDto {
    manufacturerId?: number;
    inCatalog?: boolean;
}

export class ToggleProductLineInclusionRequestDto implements IToggleProductLineInclusionRequestDto {
    productLineId?: number;
    inCatalog?: boolean;

    constructor(data?: IToggleProductLineInclusionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productLineId = _data["productLineId"];
            this.inCatalog = _data["inCatalog"];
        }
    }

    static fromJS(data: any): ToggleProductLineInclusionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleProductLineInclusionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLineId"] = this.productLineId;
        data["inCatalog"] = this.inCatalog;
        return data;
    }
}

export interface IToggleProductLineInclusionRequestDto {
    productLineId?: number;
    inCatalog?: boolean;
}

export class ToggleStandardsOnlyRequestDto implements IToggleStandardsOnlyRequestDto {
    isEnabled?: boolean;

    constructor(data?: IToggleStandardsOnlyRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ToggleStandardsOnlyRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleStandardsOnlyRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IToggleStandardsOnlyRequestDto {
    isEnabled?: boolean;
}

export class UpdateAddressDto implements IUpdateAddressDto {
    streetAddressId?: number;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    addressName?: string | undefined;
    isDefault?: boolean;
    addressGroupNames?: string[] | undefined;

    constructor(data?: IUpdateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetAddressId = _data["streetAddressId"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.addressName = _data["addressName"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["addressGroupNames"])) {
                this.addressGroupNames = [] as any;
                for (let item of _data["addressGroupNames"])
                    this.addressGroupNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddressId"] = this.streetAddressId;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["addressName"] = this.addressName;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.addressGroupNames)) {
            data["addressGroupNames"] = [];
            for (let item of this.addressGroupNames)
                data["addressGroupNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateAddressDto {
    streetAddressId?: number;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    addressName?: string | undefined;
    isDefault?: boolean;
    addressGroupNames?: string[] | undefined;
}

export class UpdateHWSWInclusionRequestDto implements IUpdateHWSWInclusionRequestDto {
    hardware?: boolean;
    software?: boolean;
    otherProducts?: boolean;

    constructor(data?: IUpdateHWSWInclusionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hardware = _data["hardware"];
            this.software = _data["software"];
            this.otherProducts = _data["otherProducts"];
        }
    }

    static fromJS(data: any): UpdateHWSWInclusionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHWSWInclusionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hardware"] = this.hardware;
        data["software"] = this.software;
        data["otherProducts"] = this.otherProducts;
        return data;
    }
}

export interface IUpdateHWSWInclusionRequestDto {
    hardware?: boolean;
    software?: boolean;
    otherProducts?: boolean;
}

export class UpdatePersonalAddressDto implements IUpdatePersonalAddressDto {
    streetAddressId?: number;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    addressName?: string | undefined;

    constructor(data?: IUpdatePersonalAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetAddressId = _data["streetAddressId"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.addressName = _data["addressName"];
        }
    }

    static fromJS(data: any): UpdatePersonalAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonalAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddressId"] = this.streetAddressId;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["addressName"] = this.addressName;
        return data;
    }
}

export interface IUpdatePersonalAddressDto {
    streetAddressId?: number;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    addressName?: string | undefined;
}

export enum ProductSearchSort {
    BestMatch = "BestMatch",
    PriceLowToHigh = "PriceLowToHigh",
    PriceHighToLow = "PriceHighToLow",
    MfgPartNumberAscending = "MfgPartNumberAscending",
}

export class AddDeviceWarrantyRequestDto implements IAddDeviceWarrantyRequestDto {
    baseSystemId!: number;
    quantity!: number;
    baseSystemOptionId!: number;

    constructor(data?: IAddDeviceWarrantyRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSystemId = _data["baseSystemId"];
            this.quantity = _data["quantity"];
            this.baseSystemOptionId = _data["baseSystemOptionId"];
        }
    }

    static fromJS(data: any): AddDeviceWarrantyRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddDeviceWarrantyRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSystemId"] = this.baseSystemId;
        data["quantity"] = this.quantity;
        data["baseSystemOptionId"] = this.baseSystemOptionId;
        return data;
    }
}

export interface IAddDeviceWarrantyRequestDto {
    baseSystemId: number;
    quantity: number;
    baseSystemOptionId: number;
}

export class AddShoppingCartDto implements IAddShoppingCartDto {
    products?: ProductToAdd[] | undefined;
    providingModule?: string | undefined;

    constructor(data?: IAddShoppingCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductToAdd.fromJS(item));
            }
            this.providingModule = _data["providingModule"];
        }
    }

    static fromJS(data: any): AddShoppingCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddShoppingCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        data["providingModule"] = this.providingModule;
        return data;
    }
}

export interface IAddShoppingCartDto {
    products?: ProductToAdd[] | undefined;
    providingModule?: string | undefined;
}

export class BuyAgainFailedItemDto implements IBuyAgainFailedItemDto {
    productDescriptor?: string | undefined;
    productName?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IBuyAgainFailedItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productName = _data["productName"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): BuyAgainFailedItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyAgainFailedItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productName"] = this.productName;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IBuyAgainFailedItemDto {
    productDescriptor?: string | undefined;
    productName?: string | undefined;
    reason?: string | undefined;
}

export class BuyAgainItemDto implements IBuyAgainItemDto {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    quantity?: number;
    productName?: string | undefined;
    shiPartNumber?: string | undefined;

    constructor(data?: IBuyAgainItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.quantity = _data["quantity"];
            this.productName = _data["productName"];
            this.shiPartNumber = _data["shiPartNumber"];
        }
    }

    static fromJS(data: any): BuyAgainItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyAgainItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["quantity"] = this.quantity;
        data["productName"] = this.productName;
        data["shiPartNumber"] = this.shiPartNumber;
        return data;
    }
}

export interface IBuyAgainItemDto {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    quantity?: number;
    productName?: string | undefined;
    shiPartNumber?: string | undefined;
}

export class BuyAgainRequestDto implements IBuyAgainRequestDto {
    items?: BuyAgainItemDto[] | undefined;

    constructor(data?: IBuyAgainRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BuyAgainItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuyAgainRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyAgainRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBuyAgainRequestDto {
    items?: BuyAgainItemDto[] | undefined;
}

export class BuyAgainResponseDto implements IBuyAgainResponseDto {
    successCount?: number;
    failedCount?: number;
    failedItems?: BuyAgainFailedItemDto[] | undefined;

    constructor(data?: IBuyAgainResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            if (Array.isArray(_data["failedItems"])) {
                this.failedItems = [] as any;
                for (let item of _data["failedItems"])
                    this.failedItems!.push(BuyAgainFailedItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuyAgainResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyAgainResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        if (Array.isArray(this.failedItems)) {
            data["failedItems"] = [];
            for (let item of this.failedItems)
                data["failedItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBuyAgainResponseDto {
    successCount?: number;
    failedCount?: number;
    failedItems?: BuyAgainFailedItemDto[] | undefined;
}

export class CartItemAvailabilityDto implements ICartItemAvailabilityDto {
    itemId?: number;
    inStock?: boolean;
    totalUnits?: number;
    stockDataAvailable?: boolean;
    itemStatus?: string | undefined;
    mfrPartNumber?: string | undefined;

    constructor(data?: ICartItemAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.inStock = _data["inStock"];
            this.totalUnits = _data["totalUnits"];
            this.stockDataAvailable = _data["stockDataAvailable"];
            this.itemStatus = _data["itemStatus"];
            this.mfrPartNumber = _data["mfrPartNumber"];
        }
    }

    static fromJS(data: any): CartItemAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["inStock"] = this.inStock;
        data["totalUnits"] = this.totalUnits;
        data["stockDataAvailable"] = this.stockDataAvailable;
        data["itemStatus"] = this.itemStatus;
        data["mfrPartNumber"] = this.mfrPartNumber;
        return data;
    }
}

export interface ICartItemAvailabilityDto {
    itemId?: number;
    inStock?: boolean;
    totalUnits?: number;
    stockDataAvailable?: boolean;
    itemStatus?: string | undefined;
    mfrPartNumber?: string | undefined;
}

export class CartLineAvailabilityDto implements ICartLineAvailabilityDto {
    inStock?: boolean | undefined;
    totalUnits?: number | undefined;
    stockDataAvailable?: boolean | undefined;
    statuses?: CartLineAvailabilityStatusDto[] | undefined;

    constructor(data?: ICartLineAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inStock = _data["inStock"];
            this.totalUnits = _data["totalUnits"];
            this.stockDataAvailable = _data["stockDataAvailable"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(CartLineAvailabilityStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CartLineAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartLineAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inStock"] = this.inStock;
        data["totalUnits"] = this.totalUnits;
        data["stockDataAvailable"] = this.stockDataAvailable;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICartLineAvailabilityDto {
    inStock?: boolean | undefined;
    totalUnits?: number | undefined;
    stockDataAvailable?: boolean | undefined;
    statuses?: CartLineAvailabilityStatusDto[] | undefined;
}

export class CartLineAvailabilityStatusDto implements ICartLineAvailabilityStatusDto {
    label?: string | undefined;
    detail?: string | undefined;

    constructor(data?: ICartLineAvailabilityStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): CartLineAvailabilityStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartLineAvailabilityStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["detail"] = this.detail;
        return data;
    }
}

export interface ICartLineAvailabilityStatusDto {
    label?: string | undefined;
    detail?: string | undefined;
}

export class CartWarrantyDto implements ICartWarrantyDto {
    baseSystemOptionId?: number | undefined;
    lineNumber?: number | undefined;
    quantity?: number | undefined;
    description?: string | undefined;
    productId?: number | undefined;
    manufacturerPartNumber?: string | undefined;
    unitPrice?: number | undefined;

    constructor(data?: ICartWarrantyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSystemOptionId = _data["baseSystemOptionId"];
            this.lineNumber = _data["lineNumber"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.productId = _data["productId"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.unitPrice = _data["unitPrice"];
        }
    }

    static fromJS(data: any): CartWarrantyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartWarrantyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSystemOptionId"] = this.baseSystemOptionId;
        data["lineNumber"] = this.lineNumber;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["productId"] = this.productId;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["unitPrice"] = this.unitPrice;
        return data;
    }
}

export interface ICartWarrantyDto {
    baseSystemOptionId?: number | undefined;
    lineNumber?: number | undefined;
    quantity?: number | undefined;
    description?: string | undefined;
    productId?: number | undefined;
    manufacturerPartNumber?: string | undefined;
    unitPrice?: number | undefined;
}

export class CatalogedProductDto implements ICatalogedProductDto {
    productDescriptor!: string | undefined;
    productClass!: string | undefined;
    imageUrl?: string | undefined;
    manufacturer?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    productName?: string | undefined;
    description?: string[] | undefined;
    price?: number | undefined;
    vendorCost?: number | undefined;
    calculatedPrice?: number | undefined;
    hasPriceRule?: boolean | undefined;
    selectedPriceRuleIsProductLevel?: boolean | undefined;
    actionTypeApplied?: string | undefined;
    operationApplied?: number | undefined;
    msrp?: number | undefined;
    inventoryStatus?: string | undefined;
    inCatalog?: boolean | undefined;
    inBaseCatalog?: boolean | undefined;
    canAddToCart?: boolean | undefined;

    constructor(data?: ICatalogedProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.imageUrl = _data["imageUrl"];
            this.manufacturer = _data["manufacturer"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.productName = _data["productName"];
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(item);
            }
            this.price = _data["price"];
            this.vendorCost = _data["vendorCost"];
            this.calculatedPrice = _data["calculatedPrice"];
            this.hasPriceRule = _data["hasPriceRule"];
            this.selectedPriceRuleIsProductLevel = _data["selectedPriceRuleIsProductLevel"];
            this.actionTypeApplied = _data["actionTypeApplied"];
            this.operationApplied = _data["operationApplied"];
            this.msrp = _data["msrp"];
            this.inventoryStatus = _data["inventoryStatus"];
            this.inCatalog = _data["inCatalog"];
            this.inBaseCatalog = _data["inBaseCatalog"];
            this.canAddToCart = _data["canAddToCart"];
        }
    }

    static fromJS(data: any): CatalogedProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogedProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["imageUrl"] = this.imageUrl;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["productName"] = this.productName;
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item);
        }
        data["price"] = this.price;
        data["vendorCost"] = this.vendorCost;
        data["calculatedPrice"] = this.calculatedPrice;
        data["hasPriceRule"] = this.hasPriceRule;
        data["selectedPriceRuleIsProductLevel"] = this.selectedPriceRuleIsProductLevel;
        data["actionTypeApplied"] = this.actionTypeApplied;
        data["operationApplied"] = this.operationApplied;
        data["msrp"] = this.msrp;
        data["inventoryStatus"] = this.inventoryStatus;
        data["inCatalog"] = this.inCatalog;
        data["inBaseCatalog"] = this.inBaseCatalog;
        data["canAddToCart"] = this.canAddToCart;
        return data;
    }
}

export interface ICatalogedProductDto {
    productDescriptor: string | undefined;
    productClass: string | undefined;
    imageUrl?: string | undefined;
    manufacturer?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    productName?: string | undefined;
    description?: string[] | undefined;
    price?: number | undefined;
    vendorCost?: number | undefined;
    calculatedPrice?: number | undefined;
    hasPriceRule?: boolean | undefined;
    selectedPriceRuleIsProductLevel?: boolean | undefined;
    actionTypeApplied?: string | undefined;
    operationApplied?: number | undefined;
    msrp?: number | undefined;
    inventoryStatus?: string | undefined;
    inCatalog?: boolean | undefined;
    inBaseCatalog?: boolean | undefined;
    canAddToCart?: boolean | undefined;
}

export class ChangeLogoDto implements IChangeLogoDto {
    state?: OrgUnitLogoState;
    logoBase64?: string | undefined;

    constructor(data?: IChangeLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.logoBase64 = _data["logoBase64"];
        }
    }

    static fromJS(data: any): ChangeLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["logoBase64"] = this.logoBase64;
        return data;
    }
}

export interface IChangeLogoDto {
    state?: OrgUnitLogoState;
    logoBase64?: string | undefined;
}

export class CheckoutBillingAddressDto implements ICheckoutBillingAddressDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    addressName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    phone?: string | undefined;

    constructor(data?: ICheckoutBillingAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.addressName = _data["addressName"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.countryCode = _data["countryCode"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CheckoutBillingAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutBillingAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["addressName"] = this.addressName;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["countryCode"] = this.countryCode;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ICheckoutBillingAddressDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    addressName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    phone?: string | undefined;
}

export class CheckoutCardAuthorizationDto implements ICheckoutCardAuthorizationDto {
    authorizationId?: string | undefined;
    estimateId?: string | undefined;
    creditCardLast4Digits?: string | undefined;
    expirationMonth?: string | undefined;
    expirationYear?: string | undefined;
    cardBrand?: string | undefined;

    constructor(data?: ICheckoutCardAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationId = _data["authorizationId"];
            this.estimateId = _data["estimateId"];
            this.creditCardLast4Digits = _data["creditCardLast4Digits"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            this.cardBrand = _data["cardBrand"];
        }
    }

    static fromJS(data: any): CheckoutCardAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutCardAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationId"] = this.authorizationId;
        data["estimateId"] = this.estimateId;
        data["creditCardLast4Digits"] = this.creditCardLast4Digits;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["cardBrand"] = this.cardBrand;
        return data;
    }
}

export interface ICheckoutCardAuthorizationDto {
    authorizationId?: string | undefined;
    estimateId?: string | undefined;
    creditCardLast4Digits?: string | undefined;
    expirationMonth?: string | undefined;
    expirationYear?: string | undefined;
    cardBrand?: string | undefined;
}

export class CheckoutCardAuthorizationResultDto implements ICheckoutCardAuthorizationResultDto {
    outcome?: string | undefined;
    authorization?: CheckoutCardAuthorizationDto;
    stepUp?: CheckoutStepUpChallengeDto;
    failureCode?: string | undefined;

    constructor(data?: ICheckoutCardAuthorizationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outcome = _data["outcome"];
            this.authorization = _data["authorization"] ? CheckoutCardAuthorizationDto.fromJS(_data["authorization"]) : undefined as any;
            this.stepUp = _data["stepUp"] ? CheckoutStepUpChallengeDto.fromJS(_data["stepUp"]) : undefined as any;
            this.failureCode = _data["failureCode"];
        }
    }

    static fromJS(data: any): CheckoutCardAuthorizationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutCardAuthorizationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outcome"] = this.outcome;
        data["authorization"] = this.authorization ? this.authorization.toJSON() : undefined as any;
        data["stepUp"] = this.stepUp ? this.stepUp.toJSON() : undefined as any;
        data["failureCode"] = this.failureCode;
        return data;
    }
}

export interface ICheckoutCardAuthorizationResultDto {
    outcome?: string | undefined;
    authorization?: CheckoutCardAuthorizationDto;
    stepUp?: CheckoutStepUpChallengeDto;
    failureCode?: string | undefined;
}

export class CheckoutCardAuthorizeRequestDto implements ICheckoutCardAuthorizeRequestDto {
    estimateId?: string | undefined;
    requestClientRefCode?: string | undefined;
    card?: CheckoutCardDto;
    billingAddress?: CheckoutBillingAddressDto;
    idempotencyKey?: string | undefined;

    constructor(data?: ICheckoutCardAuthorizeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimateId = _data["estimateId"];
            this.requestClientRefCode = _data["requestClientRefCode"];
            this.card = _data["card"] ? CheckoutCardDto.fromJS(_data["card"]) : undefined as any;
            this.billingAddress = _data["billingAddress"] ? CheckoutBillingAddressDto.fromJS(_data["billingAddress"]) : undefined as any;
            this.idempotencyKey = _data["idempotencyKey"];
        }
    }

    static fromJS(data: any): CheckoutCardAuthorizeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutCardAuthorizeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimateId"] = this.estimateId;
        data["requestClientRefCode"] = this.requestClientRefCode;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        data["idempotencyKey"] = this.idempotencyKey;
        return data;
    }
}

export interface ICheckoutCardAuthorizeRequestDto {
    estimateId?: string | undefined;
    requestClientRefCode?: string | undefined;
    card?: CheckoutCardDto;
    billingAddress?: CheckoutBillingAddressDto;
    idempotencyKey?: string | undefined;
}

export class CheckoutCardDto implements ICheckoutCardDto {
    cardNumber?: string | undefined;
    expirationMonth?: string | undefined;
    expirationYear?: string | undefined;
    securityCode?: string | undefined;
    nameOnCard?: string | undefined;

    constructor(data?: ICheckoutCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            this.securityCode = _data["securityCode"];
            this.nameOnCard = _data["nameOnCard"];
        }
    }

    static fromJS(data: any): CheckoutCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["securityCode"] = this.securityCode;
        data["nameOnCard"] = this.nameOnCard;
        return data;
    }
}

export interface ICheckoutCardDto {
    cardNumber?: string | undefined;
    expirationMonth?: string | undefined;
    expirationYear?: string | undefined;
    securityCode?: string | undefined;
    nameOnCard?: string | undefined;
}

export class CheckoutCardSetupRequestDto implements ICheckoutCardSetupRequestDto {
    estimateId?: string | undefined;
    card?: CheckoutCardDto;

    constructor(data?: ICheckoutCardSetupRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimateId = _data["estimateId"];
            this.card = _data["card"] ? CheckoutCardDto.fromJS(_data["card"]) : undefined as any;
        }
    }

    static fromJS(data: any): CheckoutCardSetupRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutCardSetupRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimateId"] = this.estimateId;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckoutCardSetupRequestDto {
    estimateId?: string | undefined;
    card?: CheckoutCardDto;
}

export class CheckoutCardSetupResultDto implements ICheckoutCardSetupResultDto {
    requestClientRefCode?: string | undefined;
    referenceId?: string | undefined;
    deviceDataCollectionUrl?: string | undefined;
    accessToken?: string | undefined;
    failureCode?: string | undefined;

    constructor(data?: ICheckoutCardSetupResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestClientRefCode = _data["requestClientRefCode"];
            this.referenceId = _data["referenceId"];
            this.deviceDataCollectionUrl = _data["deviceDataCollectionUrl"];
            this.accessToken = _data["accessToken"];
            this.failureCode = _data["failureCode"];
        }
    }

    static fromJS(data: any): CheckoutCardSetupResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutCardSetupResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestClientRefCode"] = this.requestClientRefCode;
        data["referenceId"] = this.referenceId;
        data["deviceDataCollectionUrl"] = this.deviceDataCollectionUrl;
        data["accessToken"] = this.accessToken;
        data["failureCode"] = this.failureCode;
        return data;
    }
}

export interface ICheckoutCardSetupResultDto {
    requestClientRefCode?: string | undefined;
    referenceId?: string | undefined;
    deviceDataCollectionUrl?: string | undefined;
    accessToken?: string | undefined;
    failureCode?: string | undefined;
}

export class CheckoutCardValidateRequestDto implements ICheckoutCardValidateRequestDto {
    estimateId?: string | undefined;
    requestClientRefCode?: string | undefined;
    authenticationTransactionId?: string | undefined;
    card?: CheckoutCardDto;
    billingAddress?: CheckoutBillingAddressDto;
    idempotencyKey?: string | undefined;

    constructor(data?: ICheckoutCardValidateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimateId = _data["estimateId"];
            this.requestClientRefCode = _data["requestClientRefCode"];
            this.authenticationTransactionId = _data["authenticationTransactionId"];
            this.card = _data["card"] ? CheckoutCardDto.fromJS(_data["card"]) : undefined as any;
            this.billingAddress = _data["billingAddress"] ? CheckoutBillingAddressDto.fromJS(_data["billingAddress"]) : undefined as any;
            this.idempotencyKey = _data["idempotencyKey"];
        }
    }

    static fromJS(data: any): CheckoutCardValidateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutCardValidateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimateId"] = this.estimateId;
        data["requestClientRefCode"] = this.requestClientRefCode;
        data["authenticationTransactionId"] = this.authenticationTransactionId;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        data["idempotencyKey"] = this.idempotencyKey;
        return data;
    }
}

export interface ICheckoutCardValidateRequestDto {
    estimateId?: string | undefined;
    requestClientRefCode?: string | undefined;
    authenticationTransactionId?: string | undefined;
    card?: CheckoutCardDto;
    billingAddress?: CheckoutBillingAddressDto;
    idempotencyKey?: string | undefined;
}

export class CheckoutDeviceDataCollectionDto implements ICheckoutDeviceDataCollectionDto {
    referenceId?: string | undefined;
    url?: string | undefined;
    accessToken?: string | undefined;

    constructor(data?: ICheckoutDeviceDataCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.url = _data["url"];
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): CheckoutDeviceDataCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutDeviceDataCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["url"] = this.url;
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface ICheckoutDeviceDataCollectionDto {
    referenceId?: string | undefined;
    url?: string | undefined;
    accessToken?: string | undefined;
}

export class CheckoutOrderDetailsDto implements ICheckoutOrderDetailsDto {
    shipToAddressId?: number | undefined;
    shipToAddressName?: string | undefined;
    shipToAttention?: string | undefined;
    shipToCountry?: string | undefined;

    constructor(data?: ICheckoutOrderDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipToAddressId = _data["shipToAddressId"];
            this.shipToAddressName = _data["shipToAddressName"];
            this.shipToAttention = _data["shipToAttention"];
            this.shipToCountry = _data["shipToCountry"];
        }
    }

    static fromJS(data: any): CheckoutOrderDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutOrderDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipToAddressId"] = this.shipToAddressId;
        data["shipToAddressName"] = this.shipToAddressName;
        data["shipToAttention"] = this.shipToAttention;
        data["shipToCountry"] = this.shipToCountry;
        return data;
    }
}

export interface ICheckoutOrderDetailsDto {
    shipToAddressId?: number | undefined;
    shipToAddressName?: string | undefined;
    shipToAttention?: string | undefined;
    shipToCountry?: string | undefined;
}

export class CheckoutPaymentMethodDto implements ICheckoutPaymentMethodDto {
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    acceptedCardBrands?: string[] | undefined;
    orderThreshold?: number | undefined;
    shippingFromAddress?: string | undefined;

    constructor(data?: ICheckoutPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["acceptedCardBrands"])) {
                this.acceptedCardBrands = [] as any;
                for (let item of _data["acceptedCardBrands"])
                    this.acceptedCardBrands!.push(item);
            }
            this.orderThreshold = _data["orderThreshold"];
            this.shippingFromAddress = _data["shippingFromAddress"];
        }
    }

    static fromJS(data: any): CheckoutPaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.acceptedCardBrands)) {
            data["acceptedCardBrands"] = [];
            for (let item of this.acceptedCardBrands)
                data["acceptedCardBrands"].push(item);
        }
        data["orderThreshold"] = this.orderThreshold;
        data["shippingFromAddress"] = this.shippingFromAddress;
        return data;
    }
}

export interface ICheckoutPaymentMethodDto {
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    acceptedCardBrands?: string[] | undefined;
    orderThreshold?: number | undefined;
    shippingFromAddress?: string | undefined;
}

export class CheckoutPaymentMethodRouteDto implements ICheckoutPaymentMethodRouteDto {
    code?: string | undefined;
    route?: CheckoutPaymentRoute;

    constructor(data?: ICheckoutPaymentMethodRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.route = _data["route"];
        }
    }

    static fromJS(data: any): CheckoutPaymentMethodRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutPaymentMethodRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["route"] = this.route;
        return data;
    }
}

export interface ICheckoutPaymentMethodRouteDto {
    code?: string | undefined;
    route?: CheckoutPaymentRoute;
}

export enum CheckoutPaymentRoute {
    NetTerms = "NetTerms",
    CyberSource = "CyberSource",
    Payflow = "Payflow",
    Ax = "Ax",
    Unknown = "Unknown",
}

export class CheckoutPaymentSetupCardDto implements ICheckoutPaymentSetupCardDto {
    cardNumber?: string | undefined;
    expirationMonth?: string | undefined;
    expirationYear?: string | undefined;
    securityCode?: string | undefined;
    nameOnCard?: string | undefined;

    constructor(data?: ICheckoutPaymentSetupCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            this.securityCode = _data["securityCode"];
            this.nameOnCard = _data["nameOnCard"];
        }
    }

    static fromJS(data: any): CheckoutPaymentSetupCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutPaymentSetupCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["securityCode"] = this.securityCode;
        data["nameOnCard"] = this.nameOnCard;
        return data;
    }
}

export interface ICheckoutPaymentSetupCardDto {
    cardNumber?: string | undefined;
    expirationMonth?: string | undefined;
    expirationYear?: string | undefined;
    securityCode?: string | undefined;
    nameOnCard?: string | undefined;
}

export class CheckoutPaymentSetupRequestDto implements ICheckoutPaymentSetupRequestDto {
    idempotencyKey?: string;
    checkoutSessionId?: string;
    route?: CheckoutPaymentRoute;
    billingCountryCode?: string | undefined;
    card?: CheckoutPaymentSetupCardDto;
    billTo?: CheckoutBillingAddressDto;

    constructor(data?: ICheckoutPaymentSetupRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idempotencyKey = _data["idempotencyKey"];
            this.checkoutSessionId = _data["checkoutSessionId"];
            this.route = _data["route"];
            this.billingCountryCode = _data["billingCountryCode"];
            this.card = _data["card"] ? CheckoutPaymentSetupCardDto.fromJS(_data["card"]) : undefined as any;
            this.billTo = _data["billTo"] ? CheckoutBillingAddressDto.fromJS(_data["billTo"]) : undefined as any;
        }
    }

    static fromJS(data: any): CheckoutPaymentSetupRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutPaymentSetupRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idempotencyKey"] = this.idempotencyKey;
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["route"] = this.route;
        data["billingCountryCode"] = this.billingCountryCode;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["billTo"] = this.billTo ? this.billTo.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckoutPaymentSetupRequestDto {
    idempotencyKey?: string;
    checkoutSessionId?: string;
    route?: CheckoutPaymentRoute;
    billingCountryCode?: string | undefined;
    card?: CheckoutPaymentSetupCardDto;
    billTo?: CheckoutBillingAddressDto;
}

export class CheckoutPaymentSetupResultDto implements ICheckoutPaymentSetupResultDto {
    outcome?: string | undefined;
    attemptId?: string;
    deviceDataCollection?: CheckoutDeviceDataCollectionDto;
    reason?: string | undefined;

    constructor(data?: ICheckoutPaymentSetupResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outcome = _data["outcome"];
            this.attemptId = _data["attemptId"];
            this.deviceDataCollection = _data["deviceDataCollection"] ? CheckoutDeviceDataCollectionDto.fromJS(_data["deviceDataCollection"]) : undefined as any;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CheckoutPaymentSetupResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutPaymentSetupResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outcome"] = this.outcome;
        data["attemptId"] = this.attemptId;
        data["deviceDataCollection"] = this.deviceDataCollection ? this.deviceDataCollection.toJSON() : undefined as any;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICheckoutPaymentSetupResultDto {
    outcome?: string | undefined;
    attemptId?: string;
    deviceDataCollection?: CheckoutDeviceDataCollectionDto;
    reason?: string | undefined;
}

export class CheckoutQuestionAnswerDto implements ICheckoutQuestionAnswerDto {
    id!: number;
    answerText?: string | undefined;
    answerHtml?: string | undefined;
    listAnswerListedOrder?: number | undefined;
    isDefaultAnswer?: boolean | undefined;
    listAnswerValue?: string | undefined;
    textAnswerName?: string | undefined;
    textAnswerMaxLength?: number | undefined;
    textAnswerMaxChars?: number | undefined;
    textAnswerSize?: number | undefined;
    textDefaultAnswer?: string | undefined;
    shoesId?: string | undefined;
    textAreaAnswerName?: string | undefined;
    textAreaAnswerRows?: number | undefined;
    textAreaAnswerCols?: number | undefined;
    textAreaDefaultAnswer?: string | undefined;
    isTerminal?: boolean | undefined;
    terminalMessage?: string | undefined;

    constructor(data?: ICheckoutQuestionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answerText = _data["answerText"];
            this.answerHtml = _data["answerHtml"];
            this.listAnswerListedOrder = _data["listAnswerListedOrder"];
            this.isDefaultAnswer = _data["isDefaultAnswer"];
            this.listAnswerValue = _data["listAnswerValue"];
            this.textAnswerName = _data["textAnswerName"];
            this.textAnswerMaxLength = _data["textAnswerMaxLength"];
            this.textAnswerMaxChars = _data["textAnswerMaxChars"];
            this.textAnswerSize = _data["textAnswerSize"];
            this.textDefaultAnswer = _data["textDefaultAnswer"];
            this.shoesId = _data["shoesId"];
            this.textAreaAnswerName = _data["textAreaAnswerName"];
            this.textAreaAnswerRows = _data["textAreaAnswerRows"];
            this.textAreaAnswerCols = _data["textAreaAnswerCols"];
            this.textAreaDefaultAnswer = _data["textAreaDefaultAnswer"];
            this.isTerminal = _data["isTerminal"];
            this.terminalMessage = _data["terminalMessage"];
        }
    }

    static fromJS(data: any): CheckoutQuestionAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutQuestionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answerText"] = this.answerText;
        data["answerHtml"] = this.answerHtml;
        data["listAnswerListedOrder"] = this.listAnswerListedOrder;
        data["isDefaultAnswer"] = this.isDefaultAnswer;
        data["listAnswerValue"] = this.listAnswerValue;
        data["textAnswerName"] = this.textAnswerName;
        data["textAnswerMaxLength"] = this.textAnswerMaxLength;
        data["textAnswerMaxChars"] = this.textAnswerMaxChars;
        data["textAnswerSize"] = this.textAnswerSize;
        data["textDefaultAnswer"] = this.textDefaultAnswer;
        data["shoesId"] = this.shoesId;
        data["textAreaAnswerName"] = this.textAreaAnswerName;
        data["textAreaAnswerRows"] = this.textAreaAnswerRows;
        data["textAreaAnswerCols"] = this.textAreaAnswerCols;
        data["textAreaDefaultAnswer"] = this.textAreaDefaultAnswer;
        data["isTerminal"] = this.isTerminal;
        data["terminalMessage"] = this.terminalMessage;
        return data;
    }
}

export interface ICheckoutQuestionAnswerDto {
    id: number;
    answerText?: string | undefined;
    answerHtml?: string | undefined;
    listAnswerListedOrder?: number | undefined;
    isDefaultAnswer?: boolean | undefined;
    listAnswerValue?: string | undefined;
    textAnswerName?: string | undefined;
    textAnswerMaxLength?: number | undefined;
    textAnswerMaxChars?: number | undefined;
    textAnswerSize?: number | undefined;
    textDefaultAnswer?: string | undefined;
    shoesId?: string | undefined;
    textAreaAnswerName?: string | undefined;
    textAreaAnswerRows?: number | undefined;
    textAreaAnswerCols?: number | undefined;
    textAreaDefaultAnswer?: string | undefined;
    isTerminal?: boolean | undefined;
    terminalMessage?: string | undefined;
}

export class CheckoutQuestionDto implements ICheckoutQuestionDto {
    id!: number;
    questionText!: string | undefined;
    questionHtml?: string | undefined;
    questionHeadingHtml?: string | undefined;
    checkoutQuestionTypeCode!: string | undefined;
    pageNumber!: number;
    pageDisplayOrder!: number;
    requiresAnswer?: boolean | undefined;
    isDisplayed!: boolean;
    questionTag?: string | undefined;
    checkoutQuestionGroupCode?: string | undefined;
    validationString?: string | undefined;
    validationHelpText?: string | undefined;
    hasCustomValidation?: boolean | undefined;
    requiresUniqueAnswer?: boolean | undefined;
    checkoutQuestionProductTypeCode?: string | undefined;
    shoesCustomFieldId?: number | undefined;
    isApproverUpdateable?: boolean | undefined;
    approvalDisplayOrder?: number | undefined;
    checkoutQuestionScopeCode!: string | undefined;
    isInheritable?: boolean;
    v2Enabled?: boolean;
    v2SortOrder?: number | undefined;
    v2SectionCode?: string | undefined;
    v2UpdatedAtUtc?: Date | undefined;
    answers?: CheckoutQuestionAnswerDto[] | undefined;

    constructor(data?: ICheckoutQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionText = _data["questionText"];
            this.questionHtml = _data["questionHtml"];
            this.questionHeadingHtml = _data["questionHeadingHtml"];
            this.checkoutQuestionTypeCode = _data["checkoutQuestionTypeCode"];
            this.pageNumber = _data["pageNumber"];
            this.pageDisplayOrder = _data["pageDisplayOrder"];
            this.requiresAnswer = _data["requiresAnswer"];
            this.isDisplayed = _data["isDisplayed"];
            this.questionTag = _data["questionTag"];
            this.checkoutQuestionGroupCode = _data["checkoutQuestionGroupCode"];
            this.validationString = _data["validationString"];
            this.validationHelpText = _data["validationHelpText"];
            this.hasCustomValidation = _data["hasCustomValidation"];
            this.requiresUniqueAnswer = _data["requiresUniqueAnswer"];
            this.checkoutQuestionProductTypeCode = _data["checkoutQuestionProductTypeCode"];
            this.shoesCustomFieldId = _data["shoesCustomFieldId"];
            this.isApproverUpdateable = _data["isApproverUpdateable"];
            this.approvalDisplayOrder = _data["approvalDisplayOrder"];
            this.checkoutQuestionScopeCode = _data["checkoutQuestionScopeCode"];
            this.isInheritable = _data["isInheritable"];
            this.v2Enabled = _data["v2Enabled"];
            this.v2SortOrder = _data["v2SortOrder"];
            this.v2SectionCode = _data["v2SectionCode"];
            this.v2UpdatedAtUtc = _data["v2UpdatedAtUtc"] ? new Date(_data["v2UpdatedAtUtc"].toString()) : undefined as any;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(CheckoutQuestionAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckoutQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionText"] = this.questionText;
        data["questionHtml"] = this.questionHtml;
        data["questionHeadingHtml"] = this.questionHeadingHtml;
        data["checkoutQuestionTypeCode"] = this.checkoutQuestionTypeCode;
        data["pageNumber"] = this.pageNumber;
        data["pageDisplayOrder"] = this.pageDisplayOrder;
        data["requiresAnswer"] = this.requiresAnswer;
        data["isDisplayed"] = this.isDisplayed;
        data["questionTag"] = this.questionTag;
        data["checkoutQuestionGroupCode"] = this.checkoutQuestionGroupCode;
        data["validationString"] = this.validationString;
        data["validationHelpText"] = this.validationHelpText;
        data["hasCustomValidation"] = this.hasCustomValidation;
        data["requiresUniqueAnswer"] = this.requiresUniqueAnswer;
        data["checkoutQuestionProductTypeCode"] = this.checkoutQuestionProductTypeCode;
        data["shoesCustomFieldId"] = this.shoesCustomFieldId;
        data["isApproverUpdateable"] = this.isApproverUpdateable;
        data["approvalDisplayOrder"] = this.approvalDisplayOrder;
        data["checkoutQuestionScopeCode"] = this.checkoutQuestionScopeCode;
        data["isInheritable"] = this.isInheritable;
        data["v2Enabled"] = this.v2Enabled;
        data["v2SortOrder"] = this.v2SortOrder;
        data["v2SectionCode"] = this.v2SectionCode;
        data["v2UpdatedAtUtc"] = this.v2UpdatedAtUtc ? this.v2UpdatedAtUtc.toISOString() : undefined as any;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICheckoutQuestionDto {
    id: number;
    questionText: string | undefined;
    questionHtml?: string | undefined;
    questionHeadingHtml?: string | undefined;
    checkoutQuestionTypeCode: string | undefined;
    pageNumber: number;
    pageDisplayOrder: number;
    requiresAnswer?: boolean | undefined;
    isDisplayed: boolean;
    questionTag?: string | undefined;
    checkoutQuestionGroupCode?: string | undefined;
    validationString?: string | undefined;
    validationHelpText?: string | undefined;
    hasCustomValidation?: boolean | undefined;
    requiresUniqueAnswer?: boolean | undefined;
    checkoutQuestionProductTypeCode?: string | undefined;
    shoesCustomFieldId?: number | undefined;
    isApproverUpdateable?: boolean | undefined;
    approvalDisplayOrder?: number | undefined;
    checkoutQuestionScopeCode: string | undefined;
    isInheritable?: boolean;
    v2Enabled?: boolean;
    v2SortOrder?: number | undefined;
    v2SectionCode?: string | undefined;
    v2UpdatedAtUtc?: Date | undefined;
    answers?: CheckoutQuestionAnswerDto[] | undefined;
}

export class CheckoutSessionDto implements ICheckoutSessionDto {
    checkoutSessionId?: string;
    sessionVersion?: string;
    status?: string | undefined;
    expiresAt?: Date;
    shipTo?: CheckoutSessionShipToDto;
    shippingMethods?: CheckoutSessionShippingMethodDto[] | undefined;
    shippingMethodId?: number | undefined;
    poNumber?: string | undefined;
    totals?: CheckoutSessionTotalsDto;
    lines?: CheckoutSessionLineDto[] | undefined;

    constructor(data?: ICheckoutSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionId = _data["checkoutSessionId"];
            this.sessionVersion = _data["sessionVersion"];
            this.status = _data["status"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.shipTo = _data["shipTo"] ? CheckoutSessionShipToDto.fromJS(_data["shipTo"]) : undefined as any;
            if (Array.isArray(_data["shippingMethods"])) {
                this.shippingMethods = [] as any;
                for (let item of _data["shippingMethods"])
                    this.shippingMethods!.push(CheckoutSessionShippingMethodDto.fromJS(item));
            }
            this.shippingMethodId = _data["shippingMethodId"];
            this.poNumber = _data["poNumber"];
            this.totals = _data["totals"] ? CheckoutSessionTotalsDto.fromJS(_data["totals"]) : undefined as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(CheckoutSessionLineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckoutSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["sessionVersion"] = this.sessionVersion;
        data["status"] = this.status;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        if (Array.isArray(this.shippingMethods)) {
            data["shippingMethods"] = [];
            for (let item of this.shippingMethods)
                data["shippingMethods"].push(item ? item.toJSON() : undefined as any);
        }
        data["shippingMethodId"] = this.shippingMethodId;
        data["poNumber"] = this.poNumber;
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICheckoutSessionDto {
    checkoutSessionId?: string;
    sessionVersion?: string;
    status?: string | undefined;
    expiresAt?: Date;
    shipTo?: CheckoutSessionShipToDto;
    shippingMethods?: CheckoutSessionShippingMethodDto[] | undefined;
    shippingMethodId?: number | undefined;
    poNumber?: string | undefined;
    totals?: CheckoutSessionTotalsDto;
    lines?: CheckoutSessionLineDto[] | undefined;
}

export class CheckoutSessionLineDto implements ICheckoutSessionLineDto {
    lineNumber?: number;
    itemId?: number;
    quantity?: number;
    unitPrice?: number;

    constructor(data?: ICheckoutSessionLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.itemId = _data["itemId"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
        }
    }

    static fromJS(data: any): CheckoutSessionLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSessionLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["itemId"] = this.itemId;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        return data;
    }
}

export interface ICheckoutSessionLineDto {
    lineNumber?: number;
    itemId?: number;
    quantity?: number;
    unitPrice?: number;
}

export class CheckoutSessionShipToDto implements ICheckoutSessionShipToDto {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: ICheckoutSessionShipToDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): CheckoutSessionShipToDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSessionShipToDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface ICheckoutSessionShipToDto {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    countryCode?: string | undefined;
}

export class CheckoutSessionShippingMethodDto implements ICheckoutSessionShippingMethodDto {
    id?: number;
    carrier?: string | undefined;
    shippingType?: string | undefined;
    freight?: number;
    deliveryEstimate?: string | undefined;
    isQuotePreselected?: boolean;

    constructor(data?: ICheckoutSessionShippingMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carrier = _data["carrier"];
            this.shippingType = _data["shippingType"];
            this.freight = _data["freight"];
            this.deliveryEstimate = _data["deliveryEstimate"];
            this.isQuotePreselected = _data["isQuotePreselected"];
        }
    }

    static fromJS(data: any): CheckoutSessionShippingMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSessionShippingMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carrier"] = this.carrier;
        data["shippingType"] = this.shippingType;
        data["freight"] = this.freight;
        data["deliveryEstimate"] = this.deliveryEstimate;
        data["isQuotePreselected"] = this.isQuotePreselected;
        return data;
    }
}

export interface ICheckoutSessionShippingMethodDto {
    id?: number;
    carrier?: string | undefined;
    shippingType?: string | undefined;
    freight?: number;
    deliveryEstimate?: string | undefined;
    isQuotePreselected?: boolean;
}

export class CheckoutSessionTotalsDto implements ICheckoutSessionTotalsDto {
    subtotal?: number;
    freight?: number;
    recyclingFee?: number;
    tax?: number;
    amount?: number;
    currencyCode?: string | undefined;

    constructor(data?: ICheckoutSessionTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subtotal = _data["subtotal"];
            this.freight = _data["freight"];
            this.recyclingFee = _data["recyclingFee"];
            this.tax = _data["tax"];
            this.amount = _data["amount"];
            this.currencyCode = _data["currencyCode"];
        }
    }

    static fromJS(data: any): CheckoutSessionTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSessionTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subtotal"] = this.subtotal;
        data["freight"] = this.freight;
        data["recyclingFee"] = this.recyclingFee;
        data["tax"] = this.tax;
        data["amount"] = this.amount;
        data["currencyCode"] = this.currencyCode;
        return data;
    }
}

export interface ICheckoutSessionTotalsDto {
    subtotal?: number;
    freight?: number;
    recyclingFee?: number;
    tax?: number;
    amount?: number;
    currencyCode?: string | undefined;
}

export class CheckoutStepUpChallengeDto implements ICheckoutStepUpChallengeDto {
    stepUpUrl?: string | undefined;
    accessToken?: string | undefined;
    authenticationTransactionId?: string | undefined;
    width?: string | undefined;
    height?: string | undefined;

    constructor(data?: ICheckoutStepUpChallengeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepUpUrl = _data["stepUpUrl"];
            this.accessToken = _data["accessToken"];
            this.authenticationTransactionId = _data["authenticationTransactionId"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): CheckoutStepUpChallengeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutStepUpChallengeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepUpUrl"] = this.stepUpUrl;
        data["accessToken"] = this.accessToken;
        data["authenticationTransactionId"] = this.authenticationTransactionId;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface ICheckoutStepUpChallengeDto {
    stepUpUrl?: string | undefined;
    accessToken?: string | undefined;
    authenticationTransactionId?: string | undefined;
    width?: string | undefined;
    height?: string | undefined;
}

export class CheckoutSubmitChallengeDto implements ICheckoutSubmitChallengeDto {
    stepUpUrl?: string | undefined;
    accessToken?: string | undefined;
    width?: string | undefined;
    height?: string | undefined;

    constructor(data?: ICheckoutSubmitChallengeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepUpUrl = _data["stepUpUrl"];
            this.accessToken = _data["accessToken"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): CheckoutSubmitChallengeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSubmitChallengeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepUpUrl"] = this.stepUpUrl;
        data["accessToken"] = this.accessToken;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface ICheckoutSubmitChallengeDto {
    stepUpUrl?: string | undefined;
    accessToken?: string | undefined;
    width?: string | undefined;
    height?: string | undefined;
}

export class CheckoutSubmitRejectionDto implements ICheckoutSubmitRejectionDto {
    reason?: string | undefined;
    missingFields?: string[] | undefined;

    constructor(data?: ICheckoutSubmitRejectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            if (Array.isArray(_data["missingFields"])) {
                this.missingFields = [] as any;
                for (let item of _data["missingFields"])
                    this.missingFields!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckoutSubmitRejectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSubmitRejectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        if (Array.isArray(this.missingFields)) {
            data["missingFields"] = [];
            for (let item of this.missingFields)
                data["missingFields"].push(item);
        }
        return data;
    }
}

export interface ICheckoutSubmitRejectionDto {
    reason?: string | undefined;
    missingFields?: string[] | undefined;
}

export class CheckoutSubmitRequestDto implements ICheckoutSubmitRequestDto {
    idempotencyKey?: string;
    checkoutSessionId?: string;
    sessionVersion?: string;
    route?: CheckoutPaymentRoute;
    card?: CheckoutCardDto;
    billTo?: CheckoutBillingAddressDto;
    order?: CheckoutOrderDetailsDto;

    constructor(data?: ICheckoutSubmitRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idempotencyKey = _data["idempotencyKey"];
            this.checkoutSessionId = _data["checkoutSessionId"];
            this.sessionVersion = _data["sessionVersion"];
            this.route = _data["route"];
            this.card = _data["card"] ? CheckoutCardDto.fromJS(_data["card"]) : undefined as any;
            this.billTo = _data["billTo"] ? CheckoutBillingAddressDto.fromJS(_data["billTo"]) : undefined as any;
            this.order = _data["order"] ? CheckoutOrderDetailsDto.fromJS(_data["order"]) : undefined as any;
        }
    }

    static fromJS(data: any): CheckoutSubmitRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSubmitRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idempotencyKey"] = this.idempotencyKey;
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["sessionVersion"] = this.sessionVersion;
        data["route"] = this.route;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["billTo"] = this.billTo ? this.billTo.toJSON() : undefined as any;
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckoutSubmitRequestDto {
    idempotencyKey?: string;
    checkoutSessionId?: string;
    sessionVersion?: string;
    route?: CheckoutPaymentRoute;
    card?: CheckoutCardDto;
    billTo?: CheckoutBillingAddressDto;
    order?: CheckoutOrderDetailsDto;
}

export class CheckoutSubmitResultDto implements ICheckoutSubmitResultDto {
    attemptId?: string;
    status?: string | undefined;
    webOrderId?: number | undefined;
    challenge?: CheckoutSubmitChallengeDto;

    constructor(data?: ICheckoutSubmitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
            this.status = _data["status"];
            this.webOrderId = _data["webOrderId"];
            this.challenge = _data["challenge"] ? CheckoutSubmitChallengeDto.fromJS(_data["challenge"]) : undefined as any;
        }
    }

    static fromJS(data: any): CheckoutSubmitResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutSubmitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        data["status"] = this.status;
        data["webOrderId"] = this.webOrderId;
        data["challenge"] = this.challenge ? this.challenge.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckoutSubmitResultDto {
    attemptId?: string;
    status?: string | undefined;
    webOrderId?: number | undefined;
    challenge?: CheckoutSubmitChallengeDto;
}

export class CheckoutTotalsDto implements ICheckoutTotalsDto {
    freight?: number;
    recyclingFee?: number | undefined;
    tax?: number | undefined;
    estimateId?: string | undefined;

    constructor(data?: ICheckoutTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freight = _data["freight"];
            this.recyclingFee = _data["recyclingFee"];
            this.tax = _data["tax"];
            this.estimateId = _data["estimateId"];
        }
    }

    static fromJS(data: any): CheckoutTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freight"] = this.freight;
        data["recyclingFee"] = this.recyclingFee;
        data["tax"] = this.tax;
        data["estimateId"] = this.estimateId;
        return data;
    }
}

export interface ICheckoutTotalsDto {
    freight?: number;
    recyclingFee?: number | undefined;
    tax?: number | undefined;
    estimateId?: string | undefined;
}

export class CheckoutTotalsRequestDto implements ICheckoutTotalsRequestDto {
    shipTo?: CreateQuoteAddressDto;
    items?: FreightLineItemDto[] | undefined;
    selectedShippingMethodId?: number;

    constructor(data?: ICheckoutTotalsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipTo = _data["shipTo"] ? CreateQuoteAddressDto.fromJS(_data["shipTo"]) : undefined as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FreightLineItemDto.fromJS(item));
            }
            this.selectedShippingMethodId = _data["selectedShippingMethodId"];
        }
    }

    static fromJS(data: any): CheckoutTotalsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutTotalsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["selectedShippingMethodId"] = this.selectedShippingMethodId;
        return data;
    }
}

export interface ICheckoutTotalsRequestDto {
    shipTo?: CreateQuoteAddressDto;
    items?: FreightLineItemDto[] | undefined;
    selectedShippingMethodId?: number;
}

export class ClearShoppingCartRequestDto implements IClearShoppingCartRequestDto {
    lineNumbers?: number[] | undefined;

    constructor(data?: IClearShoppingCartRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lineNumbers"])) {
                this.lineNumbers = [] as any;
                for (let item of _data["lineNumbers"])
                    this.lineNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): ClearShoppingCartRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClearShoppingCartRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lineNumbers)) {
            data["lineNumbers"] = [];
            for (let item of this.lineNumbers)
                data["lineNumbers"].push(item);
        }
        return data;
    }
}

export interface IClearShoppingCartRequestDto {
    lineNumbers?: number[] | undefined;
}

export class CreateQuoteAddressDto implements ICreateQuoteAddressDto {
    street?: string | undefined;
    city?: string | undefined;
    stateProvince?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: ICreateQuoteAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateProvince = _data["stateProvince"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CreateQuoteAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuoteAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateProvince"] = this.stateProvince;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }
}

export interface ICreateQuoteAddressDto {
    street?: string | undefined;
    city?: string | undefined;
    stateProvince?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
}

export class CreateQuoteContactDto implements ICreateQuoteContactDto {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;

    constructor(data?: ICreateQuoteContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): CreateQuoteContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuoteContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["company"] = this.company;
        return data;
    }
}

export interface ICreateQuoteContactDto {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
}

export class CreateQuoteLineRequestDto implements ICreateQuoteLineRequestDto {
    productId?: number;
    quantity?: number;
    cartLineNumber?: number | undefined;
    sourceCartLineNumber?: number | undefined;
    sourceQuoteItemDescriptor?: string | undefined;
    included?: boolean | undefined;

    constructor(data?: ICreateQuoteLineRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.cartLineNumber = _data["cartLineNumber"];
            this.sourceCartLineNumber = _data["sourceCartLineNumber"];
            this.sourceQuoteItemDescriptor = _data["sourceQuoteItemDescriptor"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): CreateQuoteLineRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuoteLineRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["cartLineNumber"] = this.cartLineNumber;
        data["sourceCartLineNumber"] = this.sourceCartLineNumber;
        data["sourceQuoteItemDescriptor"] = this.sourceQuoteItemDescriptor;
        data["included"] = this.included;
        return data;
    }
}

export interface ICreateQuoteLineRequestDto {
    productId?: number;
    quantity?: number;
    cartLineNumber?: number | undefined;
    sourceCartLineNumber?: number | undefined;
    sourceQuoteItemDescriptor?: string | undefined;
    included?: boolean | undefined;
}

export class CreateQuoteRequestDto implements ICreateQuoteRequestDto {
    name?: string | undefined;
    reference?: string | undefined;
    currencyId?: number | undefined;
    orgUnitId?: number | undefined;
    items?: CreateQuoteLineRequestDto[] | undefined;
    contact?: CreateQuoteContactDto;
    shipTo?: CreateQuoteAddressDto;
    shippingCost?: number | undefined;
    shippingMethodId?: number | undefined;
    shippingCarrier?: string | undefined;
    shippingMethodName?: string | undefined;
    taxAmount?: number | undefined;
    description?: string | undefined;
    emailOnCreate?: boolean;
    emailRecipients?: string[] | undefined;
    emailMessage?: string | undefined;
    sendCopyToSelf?: boolean;

    constructor(data?: ICreateQuoteRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.currencyId = _data["currencyId"];
            this.orgUnitId = _data["orgUnitId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CreateQuoteLineRequestDto.fromJS(item));
            }
            this.contact = _data["contact"] ? CreateQuoteContactDto.fromJS(_data["contact"]) : undefined as any;
            this.shipTo = _data["shipTo"] ? CreateQuoteAddressDto.fromJS(_data["shipTo"]) : undefined as any;
            this.shippingCost = _data["shippingCost"];
            this.shippingMethodId = _data["shippingMethodId"];
            this.shippingCarrier = _data["shippingCarrier"];
            this.shippingMethodName = _data["shippingMethodName"];
            this.taxAmount = _data["taxAmount"];
            this.description = _data["description"];
            this.emailOnCreate = _data["emailOnCreate"];
            if (Array.isArray(_data["emailRecipients"])) {
                this.emailRecipients = [] as any;
                for (let item of _data["emailRecipients"])
                    this.emailRecipients!.push(item);
            }
            this.emailMessage = _data["emailMessage"];
            this.sendCopyToSelf = _data["sendCopyToSelf"];
        }
    }

    static fromJS(data: any): CreateQuoteRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuoteRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["currencyId"] = this.currencyId;
        data["orgUnitId"] = this.orgUnitId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        data["shippingCost"] = this.shippingCost;
        data["shippingMethodId"] = this.shippingMethodId;
        data["shippingCarrier"] = this.shippingCarrier;
        data["shippingMethodName"] = this.shippingMethodName;
        data["taxAmount"] = this.taxAmount;
        data["description"] = this.description;
        data["emailOnCreate"] = this.emailOnCreate;
        if (Array.isArray(this.emailRecipients)) {
            data["emailRecipients"] = [];
            for (let item of this.emailRecipients)
                data["emailRecipients"].push(item);
        }
        data["emailMessage"] = this.emailMessage;
        data["sendCopyToSelf"] = this.sendCopyToSelf;
        return data;
    }
}

export interface ICreateQuoteRequestDto {
    name?: string | undefined;
    reference?: string | undefined;
    currencyId?: number | undefined;
    orgUnitId?: number | undefined;
    items?: CreateQuoteLineRequestDto[] | undefined;
    contact?: CreateQuoteContactDto;
    shipTo?: CreateQuoteAddressDto;
    shippingCost?: number | undefined;
    shippingMethodId?: number | undefined;
    shippingCarrier?: string | undefined;
    shippingMethodName?: string | undefined;
    taxAmount?: number | undefined;
    description?: string | undefined;
    emailOnCreate?: boolean;
    emailRecipients?: string[] | undefined;
    emailMessage?: string | undefined;
    sendCopyToSelf?: boolean;
}

export class CreateQuoteResultDto implements ICreateQuoteResultDto {
    quoteId?: number;
    quoteGuid?: string;
    expiresOn?: Date;

    constructor(data?: ICreateQuoteResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.quoteGuid = _data["quoteGuid"];
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateQuoteResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuoteResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["quoteGuid"] = this.quoteGuid;
        data["expiresOn"] = this.expiresOn ? formatDate(this.expiresOn) : undefined as any;
        return data;
    }
}

export interface ICreateQuoteResultDto {
    quoteId?: number;
    quoteGuid?: string;
    expiresOn?: Date;
}

export class FreightLineItemDto implements IFreightLineItemDto {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    unitPrice?: number;
    quantity?: number;
    sourceCartLineNumber?: number | undefined;
    sourceQuoteItemDescriptor?: string | undefined;

    constructor(data?: IFreightLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.sourceCartLineNumber = _data["sourceCartLineNumber"];
            this.sourceQuoteItemDescriptor = _data["sourceQuoteItemDescriptor"];
        }
    }

    static fromJS(data: any): FreightLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreightLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["sourceCartLineNumber"] = this.sourceCartLineNumber;
        data["sourceQuoteItemDescriptor"] = this.sourceQuoteItemDescriptor;
        return data;
    }
}

export interface IFreightLineItemDto {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    unitPrice?: number;
    quantity?: number;
    sourceCartLineNumber?: number | undefined;
    sourceQuoteItemDescriptor?: string | undefined;
}

export class MarketoFormDefinitionResponse implements IMarketoFormDefinitionResponse {
    formId?: string | undefined;
    baseUrl?: string | undefined;
    munchkinId?: string | undefined;
    fields?: MarketoFormFieldResponse[] | undefined;

    constructor(data?: IMarketoFormDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.baseUrl = _data["baseUrl"];
            this.munchkinId = _data["munchkinId"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(MarketoFormFieldResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarketoFormDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarketoFormDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["baseUrl"] = this.baseUrl;
        data["munchkinId"] = this.munchkinId;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMarketoFormDefinitionResponse {
    formId?: string | undefined;
    baseUrl?: string | undefined;
    munchkinId?: string | undefined;
    fields?: MarketoFormFieldResponse[] | undefined;
}

export class MarketoFormFieldResponse implements IMarketoFormFieldResponse {
    name?: string | undefined;
    dataType?: string | undefined;
    label?: string | undefined;
    required?: boolean;
    maxLength?: number | undefined;
    visibleRows?: number | undefined;
    validationMessage?: string | undefined;
    options?: MarketoPicklistOptionResponse[] | undefined;

    constructor(data?: IMarketoFormFieldResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.label = _data["label"];
            this.required = _data["required"];
            this.maxLength = _data["maxLength"];
            this.visibleRows = _data["visibleRows"];
            this.validationMessage = _data["validationMessage"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(MarketoPicklistOptionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarketoFormFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarketoFormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["label"] = this.label;
        data["required"] = this.required;
        data["maxLength"] = this.maxLength;
        data["visibleRows"] = this.visibleRows;
        data["validationMessage"] = this.validationMessage;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMarketoFormFieldResponse {
    name?: string | undefined;
    dataType?: string | undefined;
    label?: string | undefined;
    required?: boolean;
    maxLength?: number | undefined;
    visibleRows?: number | undefined;
    validationMessage?: string | undefined;
    options?: MarketoPicklistOptionResponse[] | undefined;
}

export class MarketoPicklistOptionResponse implements IMarketoPicklistOptionResponse {
    label?: string | undefined;
    value?: string | undefined;

    constructor(data?: IMarketoPicklistOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MarketoPicklistOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarketoPicklistOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IMarketoPicklistOptionResponse {
    label?: string | undefined;
    value?: string | undefined;
}

export class OrgUnitDisplayNameDto implements IOrgUnitDisplayNameDto {
    displayName?: string | undefined;

    constructor(data?: IOrgUnitDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrgUnitDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrgUnitDisplayNameDto {
    displayName?: string | undefined;
}

export class OrgUnitLogoDto implements IOrgUnitLogoDto {
    orgUnitId!: number;
    effectiveLogo?: string | undefined;
    logo?: string | undefined;
    logoState!: OrgUnitLogoState;
    resolvingOrgUnitId?: number | undefined;

    constructor(data?: IOrgUnitLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.effectiveLogo = _data["effectiveLogo"];
            this.logo = _data["logo"];
            this.logoState = _data["logoState"];
            this.resolvingOrgUnitId = _data["resolvingOrgUnitId"];
        }
    }

    static fromJS(data: any): OrgUnitLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["effectiveLogo"] = this.effectiveLogo;
        data["logo"] = this.logo;
        data["logoState"] = this.logoState;
        data["resolvingOrgUnitId"] = this.resolvingOrgUnitId;
        return data;
    }
}

export interface IOrgUnitLogoDto {
    orgUnitId: number;
    effectiveLogo?: string | undefined;
    logo?: string | undefined;
    logoState: OrgUnitLogoState;
    resolvingOrgUnitId?: number | undefined;
}

export enum OrgUnitLogoState {
    Show = "Show",
    Hide = "Hide",
    Inherit = "Inherit",
}

export class OrgUnitNavHeaderDto implements IOrgUnitNavHeaderDto {
    orgUnitId!: number;
    orgUnitName?: string | undefined;
    displayName?: string | undefined;
    parentOrgUnitId?: number | undefined;
    customCatalogId?: number | undefined;
    customCatalogName?: string | undefined;
    compositeCatalogId?: number | undefined;
    axAccountNumber?: string | undefined;
    accountName?: string | undefined;
    customerName?: string | undefined;
    logoUrl?: string | undefined;
    fallbackInitials?: string | undefined;
    crmAccountId?: string | undefined;
    currencyId?: number | undefined;
    backOfficeEntityId?: number | undefined;

    constructor(data?: IOrgUnitNavHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.orgUnitName = _data["orgUnitName"];
            this.displayName = _data["displayName"];
            this.parentOrgUnitId = _data["parentOrgUnitId"];
            this.customCatalogId = _data["customCatalogId"];
            this.customCatalogName = _data["customCatalogName"];
            this.compositeCatalogId = _data["compositeCatalogId"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.accountName = _data["accountName"];
            this.customerName = _data["customerName"];
            this.logoUrl = _data["logoUrl"];
            this.fallbackInitials = _data["fallbackInitials"];
            this.crmAccountId = _data["crmAccountId"];
            this.currencyId = _data["currencyId"];
            this.backOfficeEntityId = _data["backOfficeEntityId"];
        }
    }

    static fromJS(data: any): OrgUnitNavHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgUnitNavHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["orgUnitName"] = this.orgUnitName;
        data["displayName"] = this.displayName;
        data["parentOrgUnitId"] = this.parentOrgUnitId;
        data["customCatalogId"] = this.customCatalogId;
        data["customCatalogName"] = this.customCatalogName;
        data["compositeCatalogId"] = this.compositeCatalogId;
        data["axAccountNumber"] = this.axAccountNumber;
        data["accountName"] = this.accountName;
        data["customerName"] = this.customerName;
        data["logoUrl"] = this.logoUrl;
        data["fallbackInitials"] = this.fallbackInitials;
        data["crmAccountId"] = this.crmAccountId;
        data["currencyId"] = this.currencyId;
        data["backOfficeEntityId"] = this.backOfficeEntityId;
        return data;
    }
}

export interface IOrgUnitNavHeaderDto {
    orgUnitId: number;
    orgUnitName?: string | undefined;
    displayName?: string | undefined;
    parentOrgUnitId?: number | undefined;
    customCatalogId?: number | undefined;
    customCatalogName?: string | undefined;
    compositeCatalogId?: number | undefined;
    axAccountNumber?: string | undefined;
    accountName?: string | undefined;
    customerName?: string | undefined;
    logoUrl?: string | undefined;
    fallbackInitials?: string | undefined;
    crmAccountId?: string | undefined;
    currencyId?: number | undefined;
    backOfficeEntityId?: number | undefined;
}

export class ProductAvailability implements IProductAvailability {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    mediaClass?: string | undefined;
    inventoryStatus?: string | undefined;
    inStock?: boolean;
    totalUnits?: number;
    stockDataAvailable?: boolean;

    constructor(data?: IProductAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.mediaClass = _data["mediaClass"];
            this.inventoryStatus = _data["inventoryStatus"];
            this.inStock = _data["inStock"];
            this.totalUnits = _data["totalUnits"];
            this.stockDataAvailable = _data["stockDataAvailable"];
        }
    }

    static fromJS(data: any): ProductAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["mediaClass"] = this.mediaClass;
        data["inventoryStatus"] = this.inventoryStatus;
        data["inStock"] = this.inStock;
        data["totalUnits"] = this.totalUnits;
        data["stockDataAvailable"] = this.stockDataAvailable;
        return data;
    }
}

export interface IProductAvailability {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    mediaClass?: string | undefined;
    inventoryStatus?: string | undefined;
    inStock?: boolean;
    totalUnits?: number;
    stockDataAvailable?: boolean;
}

export class ProductAvailabilityResponse implements IProductAvailabilityResponse {
    summary?: ProductAvailabilitySummaryDto;
    productAvailability?: ProductAvailabilityStockRowDto[] | undefined;
    totalUnits?: number;
    stockDataAvailable?: boolean;

    constructor(data?: IProductAvailabilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? ProductAvailabilitySummaryDto.fromJS(_data["summary"]) : undefined as any;
            if (Array.isArray(_data["productAvailability"])) {
                this.productAvailability = [] as any;
                for (let item of _data["productAvailability"])
                    this.productAvailability!.push(ProductAvailabilityStockRowDto.fromJS(item));
            }
            this.totalUnits = _data["totalUnits"];
            this.stockDataAvailable = _data["stockDataAvailable"];
        }
    }

    static fromJS(data: any): ProductAvailabilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAvailabilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        if (Array.isArray(this.productAvailability)) {
            data["productAvailability"] = [];
            for (let item of this.productAvailability)
                data["productAvailability"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalUnits"] = this.totalUnits;
        data["stockDataAvailable"] = this.stockDataAvailable;
        return data;
    }
}

export interface IProductAvailabilityResponse {
    summary?: ProductAvailabilitySummaryDto;
    productAvailability?: ProductAvailabilityStockRowDto[] | undefined;
    totalUnits?: number;
    stockDataAvailable?: boolean;
}

export class ProductDetailDrawerDto implements IProductDetailDrawerDto {
    images?: ProductImageDto[] | undefined;
    imagesDeferred?: boolean;
    specification?: ProductSpecificationDto;
    productDetail?: ProductDetailDto;
    fullSpecification?: SpecificationItemDto[] | undefined;

    constructor(data?: IProductDetailDrawerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ProductImageDto.fromJS(item));
            }
            this.imagesDeferred = _data["imagesDeferred"];
            this.specification = _data["specification"] ? ProductSpecificationDto.fromJS(_data["specification"]) : undefined as any;
            this.productDetail = _data["productDetail"] ? ProductDetailDto.fromJS(_data["productDetail"]) : undefined as any;
            if (Array.isArray(_data["fullSpecification"])) {
                this.fullSpecification = [] as any;
                for (let item of _data["fullSpecification"])
                    this.fullSpecification!.push(SpecificationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDetailDrawerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailDrawerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["imagesDeferred"] = this.imagesDeferred;
        data["specification"] = this.specification ? this.specification.toJSON() : undefined as any;
        data["productDetail"] = this.productDetail ? this.productDetail.toJSON() : undefined as any;
        if (Array.isArray(this.fullSpecification)) {
            data["fullSpecification"] = [];
            for (let item of this.fullSpecification)
                data["fullSpecification"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductDetailDrawerDto {
    images?: ProductImageDto[] | undefined;
    imagesDeferred?: boolean;
    specification?: ProductSpecificationDto;
    productDetail?: ProductDetailDto;
    fullSpecification?: SpecificationItemDto[] | undefined;
}

export class ProductDetailDrawerRequestDto implements IProductDetailDrawerRequestDto {
    cNetProductId?: string | undefined;
    productClass!: string | undefined;
    orgunitId?: number;
    productDescriptor!: string | undefined;
    deferImages?: boolean | undefined;

    constructor(data?: IProductDetailDrawerRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cNetProductId = _data["cNetProductId"];
            this.productClass = _data["productClass"];
            this.orgunitId = _data["orgunitId"];
            this.productDescriptor = _data["productDescriptor"];
            this.deferImages = _data["deferImages"];
        }
    }

    static fromJS(data: any): ProductDetailDrawerRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailDrawerRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cNetProductId"] = this.cNetProductId;
        data["productClass"] = this.productClass;
        data["orgunitId"] = this.orgunitId;
        data["productDescriptor"] = this.productDescriptor;
        data["deferImages"] = this.deferImages;
        return data;
    }
}

export interface IProductDetailDrawerRequestDto {
    cNetProductId?: string | undefined;
    productClass: string | undefined;
    orgunitId?: number;
    productDescriptor: string | undefined;
    deferImages?: boolean | undefined;
}

export class ProductDetailDto implements IProductDetailDto {
    productDescriptor!: string | undefined;
    productClass!: string | undefined;
    imageUrl?: string | undefined;
    mfrPartNum?: string | undefined;
    productName?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    parsedDescriptionsList?: string[] | undefined;
    category?: string | undefined;
    mediaClass?: string | undefined;
    manufacturer?: string | undefined;
    msrp?: number | undefined;
    unspsc?: string | undefined;
    cNetProductId?: string | undefined;
    inventoryStatus?: string | undefined;
    canAddToCart?: boolean | undefined;
    containedInCatalog?: boolean | undefined;

    constructor(data?: IProductDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.imageUrl = _data["imageUrl"];
            this.mfrPartNum = _data["mfrPartNum"];
            this.productName = _data["productName"];
            this.description = _data["description"];
            this.price = _data["price"];
            if (Array.isArray(_data["parsedDescriptionsList"])) {
                this.parsedDescriptionsList = [] as any;
                for (let item of _data["parsedDescriptionsList"])
                    this.parsedDescriptionsList!.push(item);
            }
            this.category = _data["category"];
            this.mediaClass = _data["mediaClass"];
            this.manufacturer = _data["manufacturer"];
            this.msrp = _data["msrp"];
            this.unspsc = _data["unspsc"];
            this.cNetProductId = _data["cNetProductId"];
            this.inventoryStatus = _data["inventoryStatus"];
            this.canAddToCart = _data["canAddToCart"];
            this.containedInCatalog = _data["containedInCatalog"];
        }
    }

    static fromJS(data: any): ProductDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["imageUrl"] = this.imageUrl;
        data["mfrPartNum"] = this.mfrPartNum;
        data["productName"] = this.productName;
        data["description"] = this.description;
        data["price"] = this.price;
        if (Array.isArray(this.parsedDescriptionsList)) {
            data["parsedDescriptionsList"] = [];
            for (let item of this.parsedDescriptionsList)
                data["parsedDescriptionsList"].push(item);
        }
        data["category"] = this.category;
        data["mediaClass"] = this.mediaClass;
        data["manufacturer"] = this.manufacturer;
        data["msrp"] = this.msrp;
        data["unspsc"] = this.unspsc;
        data["cNetProductId"] = this.cNetProductId;
        data["inventoryStatus"] = this.inventoryStatus;
        data["canAddToCart"] = this.canAddToCart;
        data["containedInCatalog"] = this.containedInCatalog;
        return data;
    }
}

export interface IProductDetailDto {
    productDescriptor: string | undefined;
    productClass: string | undefined;
    imageUrl?: string | undefined;
    mfrPartNum?: string | undefined;
    productName?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    parsedDescriptionsList?: string[] | undefined;
    category?: string | undefined;
    mediaClass?: string | undefined;
    manufacturer?: string | undefined;
    msrp?: number | undefined;
    unspsc?: string | undefined;
    cNetProductId?: string | undefined;
    inventoryStatus?: string | undefined;
    canAddToCart?: boolean | undefined;
    containedInCatalog?: boolean | undefined;
}

export class ProductIdentifierDto implements IProductIdentifierDto {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;

    constructor(data?: IProductIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
        }
    }

    static fromJS(data: any): ProductIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        return data;
    }
}

export interface IProductIdentifierDto {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
}

export class ProductImageDto implements IProductImageDto {
    url!: string | undefined;
    resolution?: string | undefined;
    angle?: string | undefined;
    imageId?: number | undefined;
    sortOrder?: number | undefined;

    constructor(data?: IProductImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.resolution = _data["resolution"];
            this.angle = _data["angle"];
            this.imageId = _data["imageId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ProductImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["resolution"] = this.resolution;
        data["angle"] = this.angle;
        data["imageId"] = this.imageId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IProductImageDto {
    url: string | undefined;
    resolution?: string | undefined;
    angle?: string | undefined;
    imageId?: number | undefined;
    sortOrder?: number | undefined;
}

export class ProductInputDto implements IProductInputDto {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    orgunitId?: number;
    quantity?: number | undefined;

    constructor(data?: IProductInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.orgunitId = _data["orgunitId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ProductInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["orgunitId"] = this.orgunitId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IProductInputDto {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    orgunitId?: number;
    quantity?: number | undefined;
}

export class ProductSearchDto implements IProductSearchDto {
    orgUnitId?: number;
    catalogId?: number;
    query?: string | undefined;
    page?: number;
    pageSize?: number;
    isRelatedProductOnly?: boolean;
    top?: number | undefined;
    isReturnPagingInfo?: boolean | undefined;
    baseCatalogId?: number | undefined;
    filters?: string[] | undefined;
    inCatalogOnly?: boolean;
    isAdjustment?: boolean;
    category?: string | undefined;
    categorySlug?: string | undefined;
    manufacturer?: string | undefined;
    sort?: ProductSearchSort;
    moreFacet?: string | undefined;
    includeCategoryNavigation?: boolean | undefined;
    includeAllResults?: boolean;
    offset?: number | undefined;

    constructor(data?: IProductSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.catalogId = _data["catalogId"];
            this.query = _data["query"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.isRelatedProductOnly = _data["isRelatedProductOnly"];
            this.top = _data["top"];
            this.isReturnPagingInfo = _data["isReturnPagingInfo"];
            this.baseCatalogId = _data["baseCatalogId"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(item);
            }
            this.inCatalogOnly = _data["inCatalogOnly"];
            this.isAdjustment = _data["isAdjustment"];
            this.category = _data["category"];
            this.categorySlug = _data["categorySlug"];
            this.manufacturer = _data["manufacturer"];
            this.sort = _data["sort"];
            this.moreFacet = _data["moreFacet"];
            this.includeCategoryNavigation = _data["includeCategoryNavigation"];
            this.includeAllResults = _data["includeAllResults"];
            this.offset = _data["offset"];
        }
    }

    static fromJS(data: any): ProductSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["catalogId"] = this.catalogId;
        data["query"] = this.query;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["isRelatedProductOnly"] = this.isRelatedProductOnly;
        data["top"] = this.top;
        data["isReturnPagingInfo"] = this.isReturnPagingInfo;
        data["baseCatalogId"] = this.baseCatalogId;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item);
        }
        data["inCatalogOnly"] = this.inCatalogOnly;
        data["isAdjustment"] = this.isAdjustment;
        data["category"] = this.category;
        data["categorySlug"] = this.categorySlug;
        data["manufacturer"] = this.manufacturer;
        data["sort"] = this.sort;
        data["moreFacet"] = this.moreFacet;
        data["includeCategoryNavigation"] = this.includeCategoryNavigation;
        data["includeAllResults"] = this.includeAllResults;
        data["offset"] = this.offset;
        return data;
    }
}

export interface IProductSearchDto {
    orgUnitId?: number;
    catalogId?: number;
    query?: string | undefined;
    page?: number;
    pageSize?: number;
    isRelatedProductOnly?: boolean;
    top?: number | undefined;
    isReturnPagingInfo?: boolean | undefined;
    baseCatalogId?: number | undefined;
    filters?: string[] | undefined;
    inCatalogOnly?: boolean;
    isAdjustment?: boolean;
    category?: string | undefined;
    categorySlug?: string | undefined;
    manufacturer?: string | undefined;
    sort?: ProductSearchSort;
    moreFacet?: string | undefined;
    includeCategoryNavigation?: boolean | undefined;
    includeAllResults?: boolean;
    offset?: number | undefined;
}

export class ProductSpecificationDto implements IProductSpecificationDto {
    weight?: string | undefined;
    dimensions?: string | undefined;

    constructor(data?: IProductSpecificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weight = _data["weight"];
            this.dimensions = _data["dimensions"];
        }
    }

    static fromJS(data: any): ProductSpecificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSpecificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["dimensions"] = this.dimensions;
        return data;
    }
}

export interface IProductSpecificationDto {
    weight?: string | undefined;
    dimensions?: string | undefined;
}

export class ProductToAdd implements IProductToAdd {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    quantity?: number;
    priceName?: string | undefined;

    constructor(data?: IProductToAdd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.quantity = _data["quantity"];
            this.priceName = _data["priceName"];
        }
    }

    static fromJS(data: any): ProductToAdd {
        data = typeof data === 'object' ? data : {};
        let result = new ProductToAdd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["quantity"] = this.quantity;
        data["priceName"] = this.priceName;
        return data;
    }
}

export interface IProductToAdd {
    productDescriptor?: string | undefined;
    productClass?: string | undefined;
    quantity?: number;
    priceName?: string | undefined;
}

export class PublishedQuoteListItemDto implements IPublishedQuoteListItemDto {
    contact?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    currency?: string | undefined;
    currencyId?: number | undefined;
    currencyFormat?: string | undefined;
    description?: string | undefined;
    expiresOn?: Date | undefined;
    guid?: string | undefined;
    id?: number | undefined;
    isDeleted?: boolean | undefined;
    quoteId?: number | undefined;
    itemCount?: number | undefined;
    reference?: string | undefined;
    totalValue?: number | undefined;
    totalValueFormatted?: string | undefined;
    isMyQuote?: boolean;
    storefrontName?: string | undefined;

    constructor(data?: IPublishedQuoteListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.currency = _data["currency"];
            this.currencyId = _data["currencyId"];
            this.currencyFormat = _data["currencyFormat"];
            this.description = _data["description"];
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : undefined as any;
            this.guid = _data["guid"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.quoteId = _data["quoteId"];
            this.itemCount = _data["itemCount"];
            this.reference = _data["reference"];
            this.totalValue = _data["totalValue"];
            this.totalValueFormatted = _data["totalValueFormatted"];
            this.isMyQuote = _data["isMyQuote"];
            this.storefrontName = _data["storefrontName"];
        }
    }

    static fromJS(data: any): PublishedQuoteListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublishedQuoteListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["currency"] = this.currency;
        data["currencyId"] = this.currencyId;
        data["currencyFormat"] = this.currencyFormat;
        data["description"] = this.description;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        data["guid"] = this.guid;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["quoteId"] = this.quoteId;
        data["itemCount"] = this.itemCount;
        data["reference"] = this.reference;
        data["totalValue"] = this.totalValue;
        data["totalValueFormatted"] = this.totalValueFormatted;
        data["isMyQuote"] = this.isMyQuote;
        data["storefrontName"] = this.storefrontName;
        return data;
    }
}

export interface IPublishedQuoteListItemDto {
    contact?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    currency?: string | undefined;
    currencyId?: number | undefined;
    currencyFormat?: string | undefined;
    description?: string | undefined;
    expiresOn?: Date | undefined;
    guid?: string | undefined;
    id?: number | undefined;
    isDeleted?: boolean | undefined;
    quoteId?: number | undefined;
    itemCount?: number | undefined;
    reference?: string | undefined;
    totalValue?: number | undefined;
    totalValueFormatted?: string | undefined;
    isMyQuote?: boolean;
    storefrontName?: string | undefined;
}

export class QuoteCartLineSelectionDto implements IQuoteCartLineSelectionDto {
    lineId?: number;
    quantity?: number;

    constructor(data?: IQuoteCartLineSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): QuoteCartLineSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteCartLineSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IQuoteCartLineSelectionDto {
    lineId?: number;
    quantity?: number;
}

export class QuoteDetailAccountTeamDto implements IQuoteDetailAccountTeamDto {
    name?: string | undefined;
    email?: string | undefined;
    title?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IQuoteDetailAccountTeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.title = _data["title"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): QuoteDetailAccountTeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDetailAccountTeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["title"] = this.title;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IQuoteDetailAccountTeamDto {
    name?: string | undefined;
    email?: string | undefined;
    title?: string | undefined;
    phone?: string | undefined;
}

export class QuoteDetailAddressDto implements IQuoteDetailAddressDto {
    company?: string | undefined;
    deliveryAddress?: string | undefined;
    city?: string | undefined;
    stateProvince?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IQuoteDetailAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.city = _data["city"];
            this.stateProvince = _data["stateProvince"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): QuoteDetailAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDetailAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["deliveryAddress"] = this.deliveryAddress;
        data["city"] = this.city;
        data["stateProvince"] = this.stateProvince;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }
}

export interface IQuoteDetailAddressDto {
    company?: string | undefined;
    deliveryAddress?: string | undefined;
    city?: string | undefined;
    stateProvince?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
}

export class QuoteDetailContactDto implements IQuoteDetailContactDto {
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IQuoteDetailContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): QuoteDetailContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDetailContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface IQuoteDetailContactDto {
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class QuoteDetailDto implements IQuoteDetailDto {
    quoteId?: number;
    shippingMethodId?: number | undefined;
    guid?: string | undefined;
    reference?: string | undefined;
    description?: string | undefined;
    customerDescription?: string | undefined;
    createdOn?: Date | undefined;
    expiresOn?: Date | undefined;
    isExpired?: boolean;
    currency?: string | undefined;
    currencyId?: number | undefined;
    currencyFormat?: string | undefined;
    storefrontName?: string | undefined;
    contact?: QuoteDetailContactDto;
    shipTo?: QuoteDetailAddressDto;
    shippingMethod?: ShippingMethodDto;
    accountTeam?: QuoteDetailAccountTeamDto;
    publicComment?: string | undefined;
    items?: QuoteDetailItemDto[] | undefined;
    optionalItems?: QuoteDetailItemDto[] | undefined;
    totals?: QuoteDetailTotalsDto;

    constructor(data?: IQuoteDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.shippingMethodId = _data["shippingMethodId"];
            this.guid = _data["guid"];
            this.reference = _data["reference"];
            this.description = _data["description"];
            this.customerDescription = _data["customerDescription"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : undefined as any;
            this.isExpired = _data["isExpired"];
            this.currency = _data["currency"];
            this.currencyId = _data["currencyId"];
            this.currencyFormat = _data["currencyFormat"];
            this.storefrontName = _data["storefrontName"];
            this.contact = _data["contact"] ? QuoteDetailContactDto.fromJS(_data["contact"]) : undefined as any;
            this.shipTo = _data["shipTo"] ? QuoteDetailAddressDto.fromJS(_data["shipTo"]) : undefined as any;
            this.shippingMethod = _data["shippingMethod"] ? ShippingMethodDto.fromJS(_data["shippingMethod"]) : undefined as any;
            this.accountTeam = _data["accountTeam"] ? QuoteDetailAccountTeamDto.fromJS(_data["accountTeam"]) : undefined as any;
            this.publicComment = _data["publicComment"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuoteDetailItemDto.fromJS(item));
            }
            if (Array.isArray(_data["optionalItems"])) {
                this.optionalItems = [] as any;
                for (let item of _data["optionalItems"])
                    this.optionalItems!.push(QuoteDetailItemDto.fromJS(item));
            }
            this.totals = _data["totals"] ? QuoteDetailTotalsDto.fromJS(_data["totals"]) : undefined as any;
        }
    }

    static fromJS(data: any): QuoteDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["shippingMethodId"] = this.shippingMethodId;
        data["guid"] = this.guid;
        data["reference"] = this.reference;
        data["description"] = this.description;
        data["customerDescription"] = this.customerDescription;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["expiresOn"] = this.expiresOn ? formatDate(this.expiresOn) : undefined as any;
        data["isExpired"] = this.isExpired;
        data["currency"] = this.currency;
        data["currencyId"] = this.currencyId;
        data["currencyFormat"] = this.currencyFormat;
        data["storefrontName"] = this.storefrontName;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        data["shippingMethod"] = this.shippingMethod ? this.shippingMethod.toJSON() : undefined as any;
        data["accountTeam"] = this.accountTeam ? this.accountTeam.toJSON() : undefined as any;
        data["publicComment"] = this.publicComment;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.optionalItems)) {
            data["optionalItems"] = [];
            for (let item of this.optionalItems)
                data["optionalItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        return data;
    }
}

export interface IQuoteDetailDto {
    quoteId?: number;
    shippingMethodId?: number | undefined;
    guid?: string | undefined;
    reference?: string | undefined;
    description?: string | undefined;
    customerDescription?: string | undefined;
    createdOn?: Date | undefined;
    expiresOn?: Date | undefined;
    isExpired?: boolean;
    currency?: string | undefined;
    currencyId?: number | undefined;
    currencyFormat?: string | undefined;
    storefrontName?: string | undefined;
    contact?: QuoteDetailContactDto;
    shipTo?: QuoteDetailAddressDto;
    shippingMethod?: ShippingMethodDto;
    accountTeam?: QuoteDetailAccountTeamDto;
    publicComment?: string | undefined;
    items?: QuoteDetailItemDto[] | undefined;
    optionalItems?: QuoteDetailItemDto[] | undefined;
    totals?: QuoteDetailTotalsDto;
}

export class QuoteDetailItemDto implements IQuoteDetailItemDto {
    id?: number | undefined;
    productId?: number | undefined;
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    manufacturer?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    quantity?: number;
    unitPrice?: number | undefined;
    extendedPrice?: number | undefined;
    msrp?: number | undefined;
    imageUrl?: string | undefined;
    availabilityStatus?: string | undefined;
    serialNumber?: string | undefined;
    maintenanceStart?: Date | undefined;
    maintenanceEnd?: Date | undefined;
    publicNote?: string | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractProgram?: string | undefined;
    isOptional?: boolean;
    parentId?: number | undefined;

    constructor(data?: IQuoteDetailItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.shiPartNumber = _data["shiPartNumber"];
            this.description = _data["description"];
            this.manufacturer = _data["manufacturer"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.extendedPrice = _data["extendedPrice"];
            this.msrp = _data["msrp"];
            this.imageUrl = _data["imageUrl"];
            this.availabilityStatus = _data["availabilityStatus"];
            this.serialNumber = _data["serialNumber"];
            this.maintenanceStart = _data["maintenanceStart"] ? new Date(_data["maintenanceStart"].toString()) : undefined as any;
            this.maintenanceEnd = _data["maintenanceEnd"] ? new Date(_data["maintenanceEnd"].toString()) : undefined as any;
            this.publicNote = _data["publicNote"];
            this.contractName = _data["contractName"];
            this.contractNumber = _data["contractNumber"];
            this.contractProgram = _data["contractProgram"];
            this.isOptional = _data["isOptional"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): QuoteDetailItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDetailItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["shiPartNumber"] = this.shiPartNumber;
        data["description"] = this.description;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["extendedPrice"] = this.extendedPrice;
        data["msrp"] = this.msrp;
        data["imageUrl"] = this.imageUrl;
        data["availabilityStatus"] = this.availabilityStatus;
        data["serialNumber"] = this.serialNumber;
        data["maintenanceStart"] = this.maintenanceStart ? this.maintenanceStart.toISOString() : undefined as any;
        data["maintenanceEnd"] = this.maintenanceEnd ? this.maintenanceEnd.toISOString() : undefined as any;
        data["publicNote"] = this.publicNote;
        data["contractName"] = this.contractName;
        data["contractNumber"] = this.contractNumber;
        data["contractProgram"] = this.contractProgram;
        data["isOptional"] = this.isOptional;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IQuoteDetailItemDto {
    id?: number | undefined;
    productId?: number | undefined;
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    manufacturer?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    quantity?: number;
    unitPrice?: number | undefined;
    extendedPrice?: number | undefined;
    msrp?: number | undefined;
    imageUrl?: string | undefined;
    availabilityStatus?: string | undefined;
    serialNumber?: string | undefined;
    maintenanceStart?: Date | undefined;
    maintenanceEnd?: Date | undefined;
    publicNote?: string | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractProgram?: string | undefined;
    isOptional?: boolean;
    parentId?: number | undefined;
}

export class QuoteDetailTotalsDto implements IQuoteDetailTotalsDto {
    subtotal?: number;
    shipping?: number;
    tax?: number;
    total?: number;
    shippingRendered?: boolean;
    taxRendered?: boolean;

    constructor(data?: IQuoteDetailTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subtotal = _data["subtotal"];
            this.shipping = _data["shipping"];
            this.tax = _data["tax"];
            this.total = _data["total"];
            this.shippingRendered = _data["shippingRendered"];
            this.taxRendered = _data["taxRendered"];
        }
    }

    static fromJS(data: any): QuoteDetailTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDetailTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subtotal"] = this.subtotal;
        data["shipping"] = this.shipping;
        data["tax"] = this.tax;
        data["total"] = this.total;
        data["shippingRendered"] = this.shippingRendered;
        data["taxRendered"] = this.taxRendered;
        return data;
    }
}

export interface IQuoteDetailTotalsDto {
    subtotal?: number;
    shipping?: number;
    tax?: number;
    total?: number;
    shippingRendered?: boolean;
    taxRendered?: boolean;
}

export class QuoteTaxRequestDto implements IQuoteTaxRequestDto {
    shipTo?: CreateQuoteAddressDto;
    freight?: number;
    items?: FreightLineItemDto[] | undefined;

    constructor(data?: IQuoteTaxRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipTo = _data["shipTo"] ? CreateQuoteAddressDto.fromJS(_data["shipTo"]) : undefined as any;
            this.freight = _data["freight"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FreightLineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteTaxRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteTaxRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        data["freight"] = this.freight;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuoteTaxRequestDto {
    shipTo?: CreateQuoteAddressDto;
    freight?: number;
    items?: FreightLineItemDto[] | undefined;
}

export class QuoteTaxResultDto implements IQuoteTaxResultDto {
    tax?: number;

    constructor(data?: IQuoteTaxResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tax = _data["tax"];
        }
    }

    static fromJS(data: any): QuoteTaxResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteTaxResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tax"] = this.tax;
        return data;
    }
}

export interface IQuoteTaxResultDto {
    tax?: number;
}

export class RecommendedAddOnItemDto implements IRecommendedAddOnItemDto {
    productDescriptor!: string | undefined;
    productClass!: string | undefined;
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    imageUrl?: string | undefined;
    price?: number | undefined;
    inventoryStatus?: string | undefined;
    parsedDescriptionsList?: string[] | undefined;
    canAddToCart?: boolean;
    baseSystemId?: number | undefined;
    baseSystemOptionId?: number | undefined;

    constructor(data?: IRecommendedAddOnItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.productName = _data["productName"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.imageUrl = _data["imageUrl"];
            this.price = _data["price"];
            this.inventoryStatus = _data["inventoryStatus"];
            if (Array.isArray(_data["parsedDescriptionsList"])) {
                this.parsedDescriptionsList = [] as any;
                for (let item of _data["parsedDescriptionsList"])
                    this.parsedDescriptionsList!.push(item);
            }
            this.canAddToCart = _data["canAddToCart"];
            this.baseSystemId = _data["baseSystemId"];
            this.baseSystemOptionId = _data["baseSystemOptionId"];
        }
    }

    static fromJS(data: any): RecommendedAddOnItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendedAddOnItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["productName"] = this.productName;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["imageUrl"] = this.imageUrl;
        data["price"] = this.price;
        data["inventoryStatus"] = this.inventoryStatus;
        if (Array.isArray(this.parsedDescriptionsList)) {
            data["parsedDescriptionsList"] = [];
            for (let item of this.parsedDescriptionsList)
                data["parsedDescriptionsList"].push(item);
        }
        data["canAddToCart"] = this.canAddToCart;
        data["baseSystemId"] = this.baseSystemId;
        data["baseSystemOptionId"] = this.baseSystemOptionId;
        return data;
    }
}

export interface IRecommendedAddOnItemDto {
    productDescriptor: string | undefined;
    productClass: string | undefined;
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    imageUrl?: string | undefined;
    price?: number | undefined;
    inventoryStatus?: string | undefined;
    parsedDescriptionsList?: string[] | undefined;
    canAddToCart?: boolean;
    baseSystemId?: number | undefined;
    baseSystemOptionId?: number | undefined;
}

export class RecommendedAddOnSectionDto implements IRecommendedAddOnSectionDto {
    items?: RecommendedAddOnItemDto[] | undefined;
    hasMore?: boolean;
    totalCount?: number;

    constructor(data?: IRecommendedAddOnSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RecommendedAddOnItemDto.fromJS(item));
            }
            this.hasMore = _data["hasMore"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RecommendedAddOnSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendedAddOnSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasMore"] = this.hasMore;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IRecommendedAddOnSectionDto {
    items?: RecommendedAddOnItemDto[] | undefined;
    hasMore?: boolean;
    totalCount?: number;
}

export class RecommendedAddOnsDto implements IRecommendedAddOnsDto {
    accessories?: RecommendedAddOnSectionDto;
    warranties?: RecommendedAddOnSectionDto;

    constructor(data?: IRecommendedAddOnsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessories = _data["accessories"] ? RecommendedAddOnSectionDto.fromJS(_data["accessories"]) : undefined as any;
            this.warranties = _data["warranties"] ? RecommendedAddOnSectionDto.fromJS(_data["warranties"]) : undefined as any;
        }
    }

    static fromJS(data: any): RecommendedAddOnsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendedAddOnsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessories"] = this.accessories ? this.accessories.toJSON() : undefined as any;
        data["warranties"] = this.warranties ? this.warranties.toJSON() : undefined as any;
        return data;
    }
}

export interface IRecommendedAddOnsDto {
    accessories?: RecommendedAddOnSectionDto;
    warranties?: RecommendedAddOnSectionDto;
}

export class RefreshQuoteRequestDto implements IRefreshQuoteRequestDto {
    name?: string | undefined;
    items?: CreateQuoteLineRequestDto[] | undefined;

    constructor(data?: IRefreshQuoteRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CreateQuoteLineRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RefreshQuoteRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshQuoteRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRefreshQuoteRequestDto {
    name?: string | undefined;
    items?: CreateQuoteLineRequestDto[] | undefined;
}

export class RelatedProductDto implements IRelatedProductDto {
    productDescriptor!: string | undefined;
    productClass!: string | undefined;
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    imageUrl?: string | undefined;
    price?: number | undefined;
    inventoryStatus?: string | undefined;

    constructor(data?: IRelatedProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.productName = _data["productName"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.imageUrl = _data["imageUrl"];
            this.price = _data["price"];
            this.inventoryStatus = _data["inventoryStatus"];
        }
    }

    static fromJS(data: any): RelatedProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["productName"] = this.productName;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["imageUrl"] = this.imageUrl;
        data["price"] = this.price;
        data["inventoryStatus"] = this.inventoryStatus;
        return data;
    }
}

export interface IRelatedProductDto {
    productDescriptor: string | undefined;
    productClass: string | undefined;
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    imageUrl?: string | undefined;
    price?: number | undefined;
    inventoryStatus?: string | undefined;
}

export class RemovedCartLineDto implements IRemovedCartLineDto {
    lineNumber!: number;
    productName?: string | undefined;
    quantity!: number;
    origShiSystemId!: string | undefined;

    constructor(data?: IRemovedCartLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            this.origShiSystemId = _data["origShiSystemId"];
        }
    }

    static fromJS(data: any): RemovedCartLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemovedCartLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["origShiSystemId"] = this.origShiSystemId;
        return data;
    }
}

export interface IRemovedCartLineDto {
    lineNumber: number;
    productName?: string | undefined;
    quantity: number;
    origShiSystemId: string | undefined;
}

export class ReorderSiblingOrdinalsDto implements IReorderSiblingOrdinalsDto {
    items!: ReorderSiblingOrdinalsDto_ReorderItem[] | undefined;

    constructor(data?: IReorderSiblingOrdinalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReorderSiblingOrdinalsDto_ReorderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReorderSiblingOrdinalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderSiblingOrdinalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReorderSiblingOrdinalsDto {
    items: ReorderSiblingOrdinalsDto_ReorderItem[] | undefined;
}

export class ReorderSiblingOrdinalsDto_ReorderItem implements IReorderSiblingOrdinalsDto_ReorderItem {
    folderId!: number;
    parentId!: number;
    ordinal!: number;
    productDescriptor!: string | undefined;

    constructor(data?: IReorderSiblingOrdinalsDto_ReorderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderId = _data["folderId"];
            this.parentId = _data["parentId"];
            this.ordinal = _data["ordinal"];
            this.productDescriptor = _data["productDescriptor"];
        }
    }

    static fromJS(data: any): ReorderSiblingOrdinalsDto_ReorderItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderSiblingOrdinalsDto_ReorderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderId"] = this.folderId;
        data["parentId"] = this.parentId;
        data["ordinal"] = this.ordinal;
        data["productDescriptor"] = this.productDescriptor;
        return data;
    }
}

export interface IReorderSiblingOrdinalsDto_ReorderItem {
    folderId: number;
    parentId: number;
    ordinal: number;
    productDescriptor: string | undefined;
}

export class ShippingMethodDto implements IShippingMethodDto {
    id?: number;
    carrier?: string | undefined;
    shippingType?: string | undefined;
    freight?: number;
    deliveryEstimate?: string | undefined;
    isQuotePreselected?: boolean;

    constructor(data?: IShippingMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carrier = _data["carrier"];
            this.shippingType = _data["shippingType"];
            this.freight = _data["freight"];
            this.deliveryEstimate = _data["deliveryEstimate"];
            this.isQuotePreselected = _data["isQuotePreselected"];
        }
    }

    static fromJS(data: any): ShippingMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carrier"] = this.carrier;
        data["shippingType"] = this.shippingType;
        data["freight"] = this.freight;
        data["deliveryEstimate"] = this.deliveryEstimate;
        data["isQuotePreselected"] = this.isQuotePreselected;
        return data;
    }
}

export interface IShippingMethodDto {
    id?: number;
    carrier?: string | undefined;
    shippingType?: string | undefined;
    freight?: number;
    deliveryEstimate?: string | undefined;
    isQuotePreselected?: boolean;
}

export class ShippingMethodsRequestDto implements IShippingMethodsRequestDto {
    shipTo?: CreateQuoteAddressDto;
    items?: FreightLineItemDto[] | undefined;

    constructor(data?: IShippingMethodsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipTo = _data["shipTo"] ? CreateQuoteAddressDto.fromJS(_data["shipTo"]) : undefined as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FreightLineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShippingMethodsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingMethodsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShippingMethodsRequestDto {
    shipTo?: CreateQuoteAddressDto;
    items?: FreightLineItemDto[] | undefined;
}

export class ShoppingCartDto implements IShoppingCartDto {
    unitPrice?: number | undefined;
    cost?: number | undefined;
    quantity?: number | undefined;
    productName?: string | undefined;
    itemId?: number | undefined;
    lineNumber?: number | undefined;

    constructor(data?: IShoppingCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitPrice = _data["unitPrice"];
            this.cost = _data["cost"];
            this.quantity = _data["quantity"];
            this.productName = _data["productName"];
            this.itemId = _data["itemId"];
            this.lineNumber = _data["lineNumber"];
        }
    }

    static fromJS(data: any): ShoppingCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitPrice"] = this.unitPrice;
        data["cost"] = this.cost;
        data["quantity"] = this.quantity;
        data["productName"] = this.productName;
        data["itemId"] = this.itemId;
        data["lineNumber"] = this.lineNumber;
        return data;
    }
}

export interface IShoppingCartDto {
    unitPrice?: number | undefined;
    cost?: number | undefined;
    quantity?: number | undefined;
    productName?: string | undefined;
    itemId?: number | undefined;
    lineNumber?: number | undefined;
}

export class ShoppingCartLineDto implements IShoppingCartLineDto {
    unitPrice?: number | undefined;
    cost?: number | undefined;
    quantity?: number | undefined;
    productName?: string | undefined;
    itemId?: number | undefined;
    lineNumber?: number | undefined;
    baseSystemId?: number | undefined;
    configId?: number | undefined;
    manufacturerPartNumber?: string | undefined;
    availability?: CartLineAvailabilityDto;
    warranties?: CartWarrantyDto[] | undefined;
    origShiSystemId?: string | undefined;
    providingModule?: string | undefined;
    productIdentity?: string | undefined;
    isQuoteExpired?: boolean | undefined;
    isFabricatedQuoteItem?: boolean | undefined;
    productInteractionEventId?: string | undefined;
    additionalItemData?: string | undefined;

    constructor(data?: IShoppingCartLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitPrice = _data["unitPrice"];
            this.cost = _data["cost"];
            this.quantity = _data["quantity"];
            this.productName = _data["productName"];
            this.itemId = _data["itemId"];
            this.lineNumber = _data["lineNumber"];
            this.baseSystemId = _data["baseSystemId"];
            this.configId = _data["configId"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.availability = _data["availability"] ? CartLineAvailabilityDto.fromJS(_data["availability"]) : undefined as any;
            if (Array.isArray(_data["warranties"])) {
                this.warranties = [] as any;
                for (let item of _data["warranties"])
                    this.warranties!.push(CartWarrantyDto.fromJS(item));
            }
            this.origShiSystemId = _data["origShiSystemId"];
            this.providingModule = _data["providingModule"];
            this.productIdentity = _data["productIdentity"];
            this.isQuoteExpired = _data["isQuoteExpired"];
            this.isFabricatedQuoteItem = _data["isFabricatedQuoteItem"];
            this.productInteractionEventId = _data["productInteractionEventId"];
            this.additionalItemData = _data["additionalItemData"];
        }
    }

    static fromJS(data: any): ShoppingCartLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitPrice"] = this.unitPrice;
        data["cost"] = this.cost;
        data["quantity"] = this.quantity;
        data["productName"] = this.productName;
        data["itemId"] = this.itemId;
        data["lineNumber"] = this.lineNumber;
        data["baseSystemId"] = this.baseSystemId;
        data["configId"] = this.configId;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["availability"] = this.availability ? this.availability.toJSON() : undefined as any;
        if (Array.isArray(this.warranties)) {
            data["warranties"] = [];
            for (let item of this.warranties)
                data["warranties"].push(item ? item.toJSON() : undefined as any);
        }
        data["origShiSystemId"] = this.origShiSystemId;
        data["providingModule"] = this.providingModule;
        data["productIdentity"] = this.productIdentity;
        data["isQuoteExpired"] = this.isQuoteExpired;
        data["isFabricatedQuoteItem"] = this.isFabricatedQuoteItem;
        data["productInteractionEventId"] = this.productInteractionEventId;
        data["additionalItemData"] = this.additionalItemData;
        return data;
    }
}

export interface IShoppingCartLineDto {
    unitPrice?: number | undefined;
    cost?: number | undefined;
    quantity?: number | undefined;
    productName?: string | undefined;
    itemId?: number | undefined;
    lineNumber?: number | undefined;
    baseSystemId?: number | undefined;
    configId?: number | undefined;
    manufacturerPartNumber?: string | undefined;
    availability?: CartLineAvailabilityDto;
    warranties?: CartWarrantyDto[] | undefined;
    origShiSystemId?: string | undefined;
    providingModule?: string | undefined;
    productIdentity?: string | undefined;
    isQuoteExpired?: boolean | undefined;
    isFabricatedQuoteItem?: boolean | undefined;
    productInteractionEventId?: string | undefined;
    additionalItemData?: string | undefined;
}

export class SpecificationItemDto implements ISpecificationItemDto {
    groupName?: string | undefined;
    displayName?: string | undefined;
    displayValue?: string | undefined;

    constructor(data?: ISpecificationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.displayName = _data["displayName"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any): SpecificationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecificationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["displayName"] = this.displayName;
        data["displayValue"] = this.displayValue;
        return data;
    }
}

export interface ISpecificationItemDto {
    groupName?: string | undefined;
    displayName?: string | undefined;
    displayValue?: string | undefined;
}

export class StandardsAddProductsDto implements IStandardsAddProductsDto {
    orgUnitId?: number;
    standardsGroupId?: number;
    items?: ProductIdentifierDto[] | undefined;

    constructor(data?: IStandardsAddProductsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.standardsGroupId = _data["standardsGroupId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductIdentifierDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StandardsAddProductsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsAddProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["standardsGroupId"] = this.standardsGroupId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStandardsAddProductsDto {
    orgUnitId?: number;
    standardsGroupId?: number;
    items?: ProductIdentifierDto[] | undefined;
}

export class StandardsGroupDto implements IStandardsGroupDto {
    groupID?: number | undefined;
    containerID?: number | undefined;
    parentGroupID?: number | undefined;
    description?: string | undefined;
    linkText?: string | undefined;
    imageLocation?: string | undefined;
    statusCode?: string | undefined;
    displayOrder?: number | undefined;
    groupPurpose?: string | undefined;
    parent?: StandardsGroupDto;
    children?: StandardsGroupDto[] | undefined;
    products?: StandardsProductItemDto[] | undefined;

    constructor(data?: IStandardsGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupID = _data["groupID"];
            this.containerID = _data["containerID"];
            this.parentGroupID = _data["parentGroupID"];
            this.description = _data["description"];
            this.linkText = _data["linkText"];
            this.imageLocation = _data["imageLocation"];
            this.statusCode = _data["statusCode"];
            this.displayOrder = _data["displayOrder"];
            this.groupPurpose = _data["groupPurpose"];
            this.parent = _data["parent"] ? StandardsGroupDto.fromJS(_data["parent"]) : undefined as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(StandardsGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(StandardsProductItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StandardsGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupID"] = this.groupID;
        data["containerID"] = this.containerID;
        data["parentGroupID"] = this.parentGroupID;
        data["description"] = this.description;
        data["linkText"] = this.linkText;
        data["imageLocation"] = this.imageLocation;
        data["statusCode"] = this.statusCode;
        data["displayOrder"] = this.displayOrder;
        data["groupPurpose"] = this.groupPurpose;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStandardsGroupDto {
    groupID?: number | undefined;
    containerID?: number | undefined;
    parentGroupID?: number | undefined;
    description?: string | undefined;
    linkText?: string | undefined;
    imageLocation?: string | undefined;
    statusCode?: string | undefined;
    displayOrder?: number | undefined;
    groupPurpose?: string | undefined;
    parent?: StandardsGroupDto;
    children?: StandardsGroupDto[] | undefined;
    products?: StandardsProductItemDto[] | undefined;
}

export class StandardsGroupNameDto implements IStandardsGroupNameDto {
    linkText?: string | undefined;
    description?: string | undefined;

    constructor(data?: IStandardsGroupNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkText = _data["linkText"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): StandardsGroupNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsGroupNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkText"] = this.linkText;
        data["description"] = this.description;
        return data;
    }
}

export interface IStandardsGroupNameDto {
    linkText?: string | undefined;
    description?: string | undefined;
}

export class StandardsIdentifierDto implements IStandardsIdentifierDto {
    id?: number;
    isStandardsGroup?: boolean;

    constructor(data?: IStandardsIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isStandardsGroup = _data["isStandardsGroup"];
        }
    }

    static fromJS(data: any): StandardsIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isStandardsGroup"] = this.isStandardsGroup;
        return data;
    }
}

export interface IStandardsIdentifierDto {
    id?: number;
    isStandardsGroup?: boolean;
}

export class StandardsMoveToDto implements IStandardsMoveToDto {
    orgUnitId?: number | undefined;
    sourceGroupID?: number;
    targetGroupID?: number;
    items?: StandardsIdentifierDto[] | undefined;

    constructor(data?: IStandardsMoveToDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.sourceGroupID = _data["sourceGroupID"];
            this.targetGroupID = _data["targetGroupID"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StandardsIdentifierDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StandardsMoveToDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsMoveToDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["sourceGroupID"] = this.sourceGroupID;
        data["targetGroupID"] = this.targetGroupID;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStandardsMoveToDto {
    orgUnitId?: number | undefined;
    sourceGroupID?: number;
    targetGroupID?: number;
    items?: StandardsIdentifierDto[] | undefined;
}

export class StandardsProductItemDto implements IStandardsProductItemDto {
    groupID?: number | undefined;
    productDescriptor?: number | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    enableBuyNow?: boolean | undefined;
    displayOrder?: number | undefined;
    productClass?: string | undefined;
    validProductStatus?: string | undefined;
    addedOn?: Date | undefined;
    sectionCount?: number | undefined;

    constructor(data?: IStandardsProductItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupID = _data["groupID"];
            this.productDescriptor = _data["productDescriptor"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.enableBuyNow = _data["enableBuyNow"];
            this.displayOrder = _data["displayOrder"];
            this.productClass = _data["productClass"];
            this.validProductStatus = _data["validProductStatus"];
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : undefined as any;
            this.sectionCount = _data["sectionCount"];
        }
    }

    static fromJS(data: any): StandardsProductItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsProductItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupID"] = this.groupID;
        data["productDescriptor"] = this.productDescriptor;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        data["enableBuyNow"] = this.enableBuyNow;
        data["displayOrder"] = this.displayOrder;
        data["productClass"] = this.productClass;
        data["validProductStatus"] = this.validProductStatus;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : undefined as any;
        data["sectionCount"] = this.sectionCount;
        return data;
    }
}

export interface IStandardsProductItemDto {
    groupID?: number | undefined;
    productDescriptor?: number | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    enableBuyNow?: boolean | undefined;
    displayOrder?: number | undefined;
    productClass?: string | undefined;
    validProductStatus?: string | undefined;
    addedOn?: Date | undefined;
    sectionCount?: number | undefined;
}

export class StandardsReplaceProductDto implements IStandardsReplaceProductDto {
    orgUnitId?: number;
    standardsGroupId?: number;
    origin?: ProductIdentifierDto;
    target?: ProductIdentifierDto;

    constructor(data?: IStandardsReplaceProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.standardsGroupId = _data["standardsGroupId"];
            this.origin = _data["origin"] ? ProductIdentifierDto.fromJS(_data["origin"]) : undefined as any;
            this.target = _data["target"] ? ProductIdentifierDto.fromJS(_data["target"]) : undefined as any;
        }
    }

    static fromJS(data: any): StandardsReplaceProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsReplaceProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["standardsGroupId"] = this.standardsGroupId;
        data["origin"] = this.origin ? this.origin.toJSON() : undefined as any;
        data["target"] = this.target ? this.target.toJSON() : undefined as any;
        return data;
    }
}

export interface IStandardsReplaceProductDto {
    orgUnitId?: number;
    standardsGroupId?: number;
    origin?: ProductIdentifierDto;
    target?: ProductIdentifierDto;
}

export class StandardsShopFolderDto implements IStandardsShopFolderDto {
    groupId?: number;
    name?: string | undefined;
    displayOrder?: number | undefined;
    children?: StandardsShopFolderDto[] | undefined;
    products?: StandardsShopProductDto[] | undefined;

    constructor(data?: IStandardsShopFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.name = _data["name"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(StandardsShopFolderDto.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(StandardsShopProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StandardsShopFolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsShopFolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["name"] = this.name;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStandardsShopFolderDto {
    groupId?: number;
    name?: string | undefined;
    displayOrder?: number | undefined;
    children?: StandardsShopFolderDto[] | undefined;
    products?: StandardsShopProductDto[] | undefined;
}

export class StandardsShopProductDto implements IStandardsShopProductDto {
    productDescriptor!: string | undefined;
    productClass!: string | undefined;
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    manufacturer?: string | undefined;
    imageUrl?: string | undefined;
    price?: number | undefined;
    inventoryStatus?: string | undefined;
    validProductStatus?: string | undefined;
    parsedDescriptionsList?: string[] | undefined;
    canAddToCart?: boolean | undefined;

    constructor(data?: IStandardsShopProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDescriptor = _data["productDescriptor"];
            this.productClass = _data["productClass"];
            this.productName = _data["productName"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.manufacturer = _data["manufacturer"];
            this.imageUrl = _data["imageUrl"];
            this.price = _data["price"];
            this.inventoryStatus = _data["inventoryStatus"];
            this.validProductStatus = _data["validProductStatus"];
            if (Array.isArray(_data["parsedDescriptionsList"])) {
                this.parsedDescriptionsList = [] as any;
                for (let item of _data["parsedDescriptionsList"])
                    this.parsedDescriptionsList!.push(item);
            }
            this.canAddToCart = _data["canAddToCart"];
        }
    }

    static fromJS(data: any): StandardsShopProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsShopProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDescriptor"] = this.productDescriptor;
        data["productClass"] = this.productClass;
        data["productName"] = this.productName;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["manufacturer"] = this.manufacturer;
        data["imageUrl"] = this.imageUrl;
        data["price"] = this.price;
        data["inventoryStatus"] = this.inventoryStatus;
        data["validProductStatus"] = this.validProductStatus;
        if (Array.isArray(this.parsedDescriptionsList)) {
            data["parsedDescriptionsList"] = [];
            for (let item of this.parsedDescriptionsList)
                data["parsedDescriptionsList"].push(item);
        }
        data["canAddToCart"] = this.canAddToCart;
        return data;
    }
}

export interface IStandardsShopProductDto {
    productDescriptor: string | undefined;
    productClass: string | undefined;
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    manufacturer?: string | undefined;
    imageUrl?: string | undefined;
    price?: number | undefined;
    inventoryStatus?: string | undefined;
    validProductStatus?: string | undefined;
    parsedDescriptionsList?: string[] | undefined;
    canAddToCart?: boolean | undefined;
}

export class StandardsShopResponseDto implements IStandardsShopResponseDto {
    folders?: StandardsShopFolderDto[] | undefined;

    constructor(data?: IStandardsShopResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders!.push(StandardsShopFolderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StandardsShopResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardsShopResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStandardsShopResponseDto {
    folders?: StandardsShopFolderDto[] | undefined;
}

export class StorefrontCurrencyDto implements IStorefrontCurrencyDto {
    id?: number;
    code!: string | undefined;
    symbol!: string | undefined;
    locale!: string | undefined;

    constructor(data?: IStorefrontCurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.symbol = _data["symbol"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): StorefrontCurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontCurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["symbol"] = this.symbol;
        data["locale"] = this.locale;
        return data;
    }
}

export interface IStorefrontCurrencyDto {
    id?: number;
    code: string | undefined;
    symbol: string | undefined;
    locale: string | undefined;
}

export class SubscriptionActionLogDto implements ISubscriptionActionLogDto {
    logId?: number;
    orgUnitId!: number;
    employeeId!: number;
    cspCustomerId!: string;
    requestedAction?: string | undefined;
    requestedUrl?: string | undefined;
    requestedAt?: Date;
    responseStatusCode?: string | undefined;
    response?: string | undefined;
    responseMessage?: string | undefined;
    filename?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    axAccountNo?: string | undefined;
    productName?: string | undefined;

    constructor(data?: ISubscriptionActionLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logId = _data["logId"];
            this.orgUnitId = _data["orgUnitId"];
            this.employeeId = _data["employeeId"];
            this.cspCustomerId = _data["cspCustomerId"];
            this.requestedAction = _data["requestedAction"];
            this.requestedUrl = _data["requestedUrl"];
            this.requestedAt = _data["requestedAt"] ? new Date(_data["requestedAt"].toString()) : undefined as any;
            this.responseStatusCode = _data["responseStatusCode"];
            this.response = _data["response"];
            this.responseMessage = _data["responseMessage"];
            this.filename = _data["filename"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.axAccountNo = _data["axAccountNo"];
            this.productName = _data["productName"];
        }
    }

    static fromJS(data: any): SubscriptionActionLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionActionLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logId"] = this.logId;
        data["orgUnitId"] = this.orgUnitId;
        data["employeeId"] = this.employeeId;
        data["cspCustomerId"] = this.cspCustomerId;
        data["requestedAction"] = this.requestedAction;
        data["requestedUrl"] = this.requestedUrl;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["responseStatusCode"] = this.responseStatusCode;
        data["response"] = this.response;
        data["responseMessage"] = this.responseMessage;
        data["filename"] = this.filename;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["axAccountNo"] = this.axAccountNo;
        data["productName"] = this.productName;
        return data;
    }
}

export interface ISubscriptionActionLogDto {
    logId?: number;
    orgUnitId: number;
    employeeId: number;
    cspCustomerId: string;
    requestedAction?: string | undefined;
    requestedUrl?: string | undefined;
    requestedAt?: Date;
    responseStatusCode?: string | undefined;
    response?: string | undefined;
    responseMessage?: string | undefined;
    filename?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    axAccountNo?: string | undefined;
    productName?: string | undefined;
}

export class SubscriptionActionLogPagedResultDto implements ISubscriptionActionLogPagedResultDto {
    records?: SubscriptionActionLogDto[] | undefined;
    totalCount?: number;
    startIndex?: number;
    pageSize?: number;
    returnedCount?: number;
    hasMore?: boolean;

    constructor(data?: ISubscriptionActionLogPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(SubscriptionActionLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.startIndex = _data["startIndex"];
            this.pageSize = _data["pageSize"];
            this.returnedCount = _data["returnedCount"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): SubscriptionActionLogPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionActionLogPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["startIndex"] = this.startIndex;
        data["pageSize"] = this.pageSize;
        data["returnedCount"] = this.returnedCount;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface ISubscriptionActionLogPagedResultDto {
    records?: SubscriptionActionLogDto[] | undefined;
    totalCount?: number;
    startIndex?: number;
    pageSize?: number;
    returnedCount?: number;
    hasMore?: boolean;
}

export class TopNavMenuItemDto implements ITopNavMenuItemDto {
    actionUrl?: string | undefined;
    actionTarget?: string | undefined;
    children?: TopNavMenuItemDto[] | undefined;
    contentValue?: string | undefined;
    contentValueType?: string | undefined;
    displayValue?: string | undefined;
    googleAnalyticsClass?: string | undefined;
    hideSideMenu?: boolean;
    readonly hasChildren?: boolean;
    menuId?: number;
    navigationBarMenuPluginName?: string | undefined;
    parentMenuId?: number | undefined;
    securityActionName?: string | undefined;
    sortOrder?: number;
    uiTextName?: string | undefined;
    uiBehaviorName?: string | undefined;
    visibility?: string | undefined;

    constructor(data?: ITopNavMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionUrl = _data["actionUrl"];
            this.actionTarget = _data["actionTarget"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(TopNavMenuItemDto.fromJS(item));
            }
            this.contentValue = _data["contentValue"];
            this.contentValueType = _data["contentValueType"];
            this.displayValue = _data["displayValue"];
            this.googleAnalyticsClass = _data["googleAnalyticsClass"];
            this.hideSideMenu = _data["hideSideMenu"];
            (this as any).hasChildren = _data["hasChildren"];
            this.menuId = _data["menuId"];
            this.navigationBarMenuPluginName = _data["navigationBarMenuPluginName"];
            this.parentMenuId = _data["parentMenuId"];
            this.securityActionName = _data["securityActionName"];
            this.sortOrder = _data["sortOrder"];
            this.uiTextName = _data["uiTextName"];
            this.uiBehaviorName = _data["uiBehaviorName"];
            this.visibility = _data["visibility"];
        }
    }

    static fromJS(data: any): TopNavMenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopNavMenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionUrl"] = this.actionUrl;
        data["actionTarget"] = this.actionTarget;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["contentValue"] = this.contentValue;
        data["contentValueType"] = this.contentValueType;
        data["displayValue"] = this.displayValue;
        data["googleAnalyticsClass"] = this.googleAnalyticsClass;
        data["hideSideMenu"] = this.hideSideMenu;
        data["hasChildren"] = this.hasChildren;
        data["menuId"] = this.menuId;
        data["navigationBarMenuPluginName"] = this.navigationBarMenuPluginName;
        data["parentMenuId"] = this.parentMenuId;
        data["securityActionName"] = this.securityActionName;
        data["sortOrder"] = this.sortOrder;
        data["uiTextName"] = this.uiTextName;
        data["uiBehaviorName"] = this.uiBehaviorName;
        data["visibility"] = this.visibility;
        return data;
    }
}

export interface ITopNavMenuItemDto {
    actionUrl?: string | undefined;
    actionTarget?: string | undefined;
    children?: TopNavMenuItemDto[] | undefined;
    contentValue?: string | undefined;
    contentValueType?: string | undefined;
    displayValue?: string | undefined;
    googleAnalyticsClass?: string | undefined;
    hideSideMenu?: boolean;
    hasChildren?: boolean;
    menuId?: number;
    navigationBarMenuPluginName?: string | undefined;
    parentMenuId?: number | undefined;
    securityActionName?: string | undefined;
    sortOrder?: number;
    uiTextName?: string | undefined;
    uiBehaviorName?: string | undefined;
    visibility?: string | undefined;
}

export class UpdateCartItemQuantityRequest implements IUpdateCartItemQuantityRequest {
    quantity?: number;

    constructor(data?: IUpdateCartItemQuantityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): UpdateCartItemQuantityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCartItemQuantityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IUpdateCartItemQuantityRequest {
    quantity?: number;
}

export class UpdateCheckoutSessionPoNumberRequestDto implements IUpdateCheckoutSessionPoNumberRequestDto {
    sessionVersion?: string;
    poNumber?: string | undefined;

    constructor(data?: IUpdateCheckoutSessionPoNumberRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionVersion = _data["sessionVersion"];
            this.poNumber = _data["poNumber"];
        }
    }

    static fromJS(data: any): UpdateCheckoutSessionPoNumberRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCheckoutSessionPoNumberRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionVersion"] = this.sessionVersion;
        data["poNumber"] = this.poNumber;
        return data;
    }
}

export interface IUpdateCheckoutSessionPoNumberRequestDto {
    sessionVersion?: string;
    poNumber?: string | undefined;
}

export class UpdateCheckoutSessionShipToRequestDto implements IUpdateCheckoutSessionShipToRequestDto {
    sessionVersion?: string;
    shipTo?: CheckoutSessionShipToDto;

    constructor(data?: IUpdateCheckoutSessionShipToRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionVersion = _data["sessionVersion"];
            this.shipTo = _data["shipTo"] ? CheckoutSessionShipToDto.fromJS(_data["shipTo"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateCheckoutSessionShipToRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCheckoutSessionShipToRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionVersion"] = this.sessionVersion;
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateCheckoutSessionShipToRequestDto {
    sessionVersion?: string;
    shipTo?: CheckoutSessionShipToDto;
}

export class UpdateCheckoutSessionShippingMethodRequestDto implements IUpdateCheckoutSessionShippingMethodRequestDto {
    sessionVersion?: string;
    shippingMethodId?: number;

    constructor(data?: IUpdateCheckoutSessionShippingMethodRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionVersion = _data["sessionVersion"];
            this.shippingMethodId = _data["shippingMethodId"];
        }
    }

    static fromJS(data: any): UpdateCheckoutSessionShippingMethodRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCheckoutSessionShippingMethodRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionVersion"] = this.sessionVersion;
        data["shippingMethodId"] = this.shippingMethodId;
        return data;
    }
}

export interface IUpdateCheckoutSessionShippingMethodRequestDto {
    sessionVersion?: string;
    shippingMethodId?: number;
}

export class UpdateWarehouseAutoPopulatePreferenceRequest implements IUpdateWarehouseAutoPopulatePreferenceRequest {
    enabled?: boolean;
    warehouseRules?: { [key: string]: boolean; } | undefined;
    targetGroupId?: number | undefined;
    crmAccountId?: string | undefined;

    constructor(data?: IUpdateWarehouseAutoPopulatePreferenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            if (_data["warehouseRules"]) {
                this.warehouseRules = {} as any;
                for (let key in _data["warehouseRules"]) {
                    if (_data["warehouseRules"].hasOwnProperty(key))
                        (this.warehouseRules as any)![key] = _data["warehouseRules"][key];
                }
            }
            this.targetGroupId = _data["targetGroupId"];
            this.crmAccountId = _data["crmAccountId"];
        }
    }

    static fromJS(data: any): UpdateWarehouseAutoPopulatePreferenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWarehouseAutoPopulatePreferenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        if (this.warehouseRules) {
            data["warehouseRules"] = {};
            for (let key in this.warehouseRules) {
                if (this.warehouseRules.hasOwnProperty(key))
                    (data["warehouseRules"] as any)[key] = (this.warehouseRules as any)[key];
            }
        }
        data["targetGroupId"] = this.targetGroupId;
        data["crmAccountId"] = this.crmAccountId;
        return data;
    }
}

export interface IUpdateWarehouseAutoPopulatePreferenceRequest {
    enabled?: boolean;
    warehouseRules?: { [key: string]: boolean; } | undefined;
    targetGroupId?: number | undefined;
    crmAccountId?: string | undefined;
}

export class WarehouseAutoPopulatePreferenceDto implements IWarehouseAutoPopulatePreferenceDto {
    orgUnitId?: number;
    enabled?: boolean;
    warehouseRules?: { [key: string]: boolean; } | undefined;
    targetGroupId?: number | undefined;
    targetGroupName?: string | undefined;
    crmAccountId?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IWarehouseAutoPopulatePreferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.enabled = _data["enabled"];
            if (_data["warehouseRules"]) {
                this.warehouseRules = {} as any;
                for (let key in _data["warehouseRules"]) {
                    if (_data["warehouseRules"].hasOwnProperty(key))
                        (this.warehouseRules as any)![key] = _data["warehouseRules"][key];
                }
            }
            this.targetGroupId = _data["targetGroupId"];
            this.targetGroupName = _data["targetGroupName"];
            this.crmAccountId = _data["crmAccountId"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): WarehouseAutoPopulatePreferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseAutoPopulatePreferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["enabled"] = this.enabled;
        if (this.warehouseRules) {
            data["warehouseRules"] = {};
            for (let key in this.warehouseRules) {
                if (this.warehouseRules.hasOwnProperty(key))
                    (data["warehouseRules"] as any)[key] = (this.warehouseRules as any)[key];
            }
        }
        data["targetGroupId"] = this.targetGroupId;
        data["targetGroupName"] = this.targetGroupName;
        data["crmAccountId"] = this.crmAccountId;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IWarehouseAutoPopulatePreferenceDto {
    orgUnitId?: number;
    enabled?: boolean;
    warehouseRules?: { [key: string]: boolean; } | undefined;
    targetGroupId?: number | undefined;
    targetGroupName?: string | undefined;
    crmAccountId?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
}

export class WebOrderCheckoutAnswer implements IWebOrderCheckoutAnswer {
    questionId?: number;
    answerId?: number;
    value?: string | undefined;
    valueInternal?: string | undefined;

    constructor(data?: IWebOrderCheckoutAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answerId = _data["answerId"];
            this.value = _data["value"];
            this.valueInternal = _data["valueInternal"];
        }
    }

    static fromJS(data: any): WebOrderCheckoutAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new WebOrderCheckoutAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answerId"] = this.answerId;
        data["value"] = this.value;
        data["valueInternal"] = this.valueInternal;
        return data;
    }
}

export interface IWebOrderCheckoutAnswer {
    questionId?: number;
    answerId?: number;
    value?: string | undefined;
    valueInternal?: string | undefined;
}

export class WebOrderCheckoutLine implements IWebOrderCheckoutLine {
    lineNumber?: number;
    origShiSystemId?: string | undefined;
    itemId?: number | undefined;
    providingModule?: string | undefined;
    productInteractionEventId?: string | undefined;
    quantity?: number;
    additionalItemData?: string | undefined;

    constructor(data?: IWebOrderCheckoutLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.origShiSystemId = _data["origShiSystemId"];
            this.itemId = _data["itemId"];
            this.providingModule = _data["providingModule"];
            this.productInteractionEventId = _data["productInteractionEventId"];
            this.quantity = _data["quantity"];
            this.additionalItemData = _data["additionalItemData"];
        }
    }

    static fromJS(data: any): WebOrderCheckoutLine {
        data = typeof data === 'object' ? data : {};
        let result = new WebOrderCheckoutLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["origShiSystemId"] = this.origShiSystemId;
        data["itemId"] = this.itemId;
        data["providingModule"] = this.providingModule;
        data["productInteractionEventId"] = this.productInteractionEventId;
        data["quantity"] = this.quantity;
        data["additionalItemData"] = this.additionalItemData;
        return data;
    }
}

export interface IWebOrderCheckoutLine {
    lineNumber?: number;
    origShiSystemId?: string | undefined;
    itemId?: number | undefined;
    providingModule?: string | undefined;
    productInteractionEventId?: string | undefined;
    quantity?: number;
    additionalItemData?: string | undefined;
}

export class WebOrderCheckoutRequest implements IWebOrderCheckoutRequest {
    orderGuid?: string;
    shippingAddress?: WebOrderCheckoutShippingAddress;
    lines?: WebOrderCheckoutLine[] | undefined;
    subtotal?: number | undefined;
    estFreight?: number;
    estTax?: number;
    recyclingFee?: number;
    totalPrice?: number;
    selectedShippingMethodId?: number | undefined;
    estimateId?: string | undefined;
    poNumber?: string | undefined;
    answers?: WebOrderCheckoutAnswer[] | undefined;
    paymentMethodCode?: string | undefined;
    cardAuthorizationId?: string | undefined;

    constructor(data?: IWebOrderCheckoutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderGuid = _data["orderGuid"];
            this.shippingAddress = _data["shippingAddress"] ? WebOrderCheckoutShippingAddress.fromJS(_data["shippingAddress"]) : undefined as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WebOrderCheckoutLine.fromJS(item));
            }
            this.subtotal = _data["subtotal"];
            this.estFreight = _data["estFreight"];
            this.estTax = _data["estTax"];
            this.recyclingFee = _data["recyclingFee"];
            this.totalPrice = _data["totalPrice"];
            this.selectedShippingMethodId = _data["selectedShippingMethodId"];
            this.estimateId = _data["estimateId"];
            this.poNumber = _data["poNumber"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(WebOrderCheckoutAnswer.fromJS(item));
            }
            this.paymentMethodCode = _data["paymentMethodCode"];
            this.cardAuthorizationId = _data["cardAuthorizationId"];
        }
    }

    static fromJS(data: any): WebOrderCheckoutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebOrderCheckoutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderGuid"] = this.orderGuid;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : undefined as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        data["subtotal"] = this.subtotal;
        data["estFreight"] = this.estFreight;
        data["estTax"] = this.estTax;
        data["recyclingFee"] = this.recyclingFee;
        data["totalPrice"] = this.totalPrice;
        data["selectedShippingMethodId"] = this.selectedShippingMethodId;
        data["estimateId"] = this.estimateId;
        data["poNumber"] = this.poNumber;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        data["paymentMethodCode"] = this.paymentMethodCode;
        data["cardAuthorizationId"] = this.cardAuthorizationId;
        return data;
    }
}

export interface IWebOrderCheckoutRequest {
    orderGuid?: string;
    shippingAddress?: WebOrderCheckoutShippingAddress;
    lines?: WebOrderCheckoutLine[] | undefined;
    subtotal?: number | undefined;
    estFreight?: number;
    estTax?: number;
    recyclingFee?: number;
    totalPrice?: number;
    selectedShippingMethodId?: number | undefined;
    estimateId?: string | undefined;
    poNumber?: string | undefined;
    answers?: WebOrderCheckoutAnswer[] | undefined;
    paymentMethodCode?: string | undefined;
    cardAuthorizationId?: string | undefined;
}

export class WebOrderCheckoutResult implements IWebOrderCheckoutResult {
    webOrderId?: number;
    orderGuid?: string;
    orderStatus?: string | undefined;
    estFreight?: number;
    estTax?: number;
    recyclingFee?: number;
    totalPrice?: number;

    constructor(data?: IWebOrderCheckoutResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webOrderId = _data["webOrderId"];
            this.orderGuid = _data["orderGuid"];
            this.orderStatus = _data["orderStatus"];
            this.estFreight = _data["estFreight"];
            this.estTax = _data["estTax"];
            this.recyclingFee = _data["recyclingFee"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): WebOrderCheckoutResult {
        data = typeof data === 'object' ? data : {};
        let result = new WebOrderCheckoutResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webOrderId"] = this.webOrderId;
        data["orderGuid"] = this.orderGuid;
        data["orderStatus"] = this.orderStatus;
        data["estFreight"] = this.estFreight;
        data["estTax"] = this.estTax;
        data["recyclingFee"] = this.recyclingFee;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IWebOrderCheckoutResult {
    webOrderId?: number;
    orderGuid?: string;
    orderStatus?: string | undefined;
    estFreight?: number;
    estTax?: number;
    recyclingFee?: number;
    totalPrice?: number;
}

export class WebOrderCheckoutShippingAddress implements IWebOrderCheckoutShippingAddress {
    addressId?: number | undefined;
    addressName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    attention?: string | undefined;
    deliveryContactPhone?: string | undefined;

    constructor(data?: IWebOrderCheckoutShippingAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.addressName = _data["addressName"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.countryCode = _data["countryCode"];
            this.attention = _data["attention"];
            this.deliveryContactPhone = _data["deliveryContactPhone"];
        }
    }

    static fromJS(data: any): WebOrderCheckoutShippingAddress {
        data = typeof data === 'object' ? data : {};
        let result = new WebOrderCheckoutShippingAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["addressName"] = this.addressName;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["countryCode"] = this.countryCode;
        data["attention"] = this.attention;
        data["deliveryContactPhone"] = this.deliveryContactPhone;
        return data;
    }
}

export interface IWebOrderCheckoutShippingAddress {
    addressId?: number | undefined;
    addressName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    attention?: string | undefined;
    deliveryContactPhone?: string | undefined;
}

export enum DateFilterOption {
    CurrentMonth = "CurrentMonth",
    LastMonth = "LastMonth",
    CurrentQuarter = "CurrentQuarter",
    LastQuarter = "LastQuarter",
    YearToDate = "YearToDate",
    LastYear = "LastYear",
    None = "None",
}

export enum CiscoIbaFilterDates {
    Next12Months = "Next12Months",
    Next3Years = "Next3Years",
    Last12Months = "Last12Months",
}

export enum ServiceRequestQueryType {
    AllRequests = "AllRequests",
    PrimaryContactRequests = "PrimaryContactRequests",
    SecondaryContactRequests = "SecondaryContactRequests",
    BillableRequests = "BillableRequests",
}

export class AssetEndUserDevicesRequestDto implements IAssetEndUserDevicesRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;

    constructor(data?: IAssetEndUserDevicesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetEndUserDevicesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetEndUserDevicesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        return data;
    }
}

export interface IAssetEndUserDevicesRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
}

export class AssetLifecycleSearchRequestDto implements IAssetLifecycleSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    sortCriteria?: ElasticSortCriteria;
    searchFilter?: AssetLifecycleSearchFilterDto;
    searchFilterInclude?: AssetLifecycleSearchFilterDto;
    searchFilterExclude?: AssetLifecycleSearchFilterDto;
    scrollSearch?: boolean;

    constructor(data?: IAssetLifecycleSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.showParentsOnly = _data["showParentsOnly"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : undefined as any;
            this.searchFilter = _data["searchFilter"] ? AssetLifecycleSearchFilterDto.fromJS(_data["searchFilter"]) : undefined as any;
            this.searchFilterInclude = _data["searchFilterInclude"] ? AssetLifecycleSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? AssetLifecycleSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
            this.scrollSearch = _data["scrollSearch"];
        }
    }

    static fromJS(data: any): AssetLifecycleSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["showParentsOnly"] = this.showParentsOnly;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : undefined as any;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : undefined as any;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        data["scrollSearch"] = this.scrollSearch;
        return data;
    }
}

export interface IAssetLifecycleSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    sortCriteria?: ElasticSortCriteria;
    searchFilter?: AssetLifecycleSearchFilterDto;
    searchFilterInclude?: AssetLifecycleSearchFilterDto;
    searchFilterExclude?: AssetLifecycleSearchFilterDto;
    scrollSearch?: boolean;
}

export class AssetProductCatalogSearchRequestDto implements IAssetProductCatalogSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetProductSearchFilterDto;
    searchFilterInclude?: AssetProductSearchFilterDto;
    searchFilterExclude?: AssetProductSearchFilterDto;

    constructor(data?: IAssetProductCatalogSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? AssetProductSearchFilterDto.fromJS(_data["searchFilter"]) : undefined as any;
            this.searchFilterInclude = _data["searchFilterInclude"] ? AssetProductSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? AssetProductSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetProductCatalogSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProductCatalogSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : undefined as any;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetProductCatalogSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetProductSearchFilterDto;
    searchFilterInclude?: AssetProductSearchFilterDto;
    searchFilterExclude?: AssetProductSearchFilterDto;
}

export class CiscoIbaAssetsArchitectureLdosRequestDto implements ICiscoIbaAssetsArchitectureLdosRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
    includeUncovered?: boolean;

    constructor(data?: ICiscoIbaAssetsArchitectureLdosRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
            this.includeUncovered = _data["includeUncovered"];
        }
    }

    static fromJS(data: any): CiscoIbaAssetsArchitectureLdosRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsArchitectureLdosRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        data["includeUncovered"] = this.includeUncovered;
        return data;
    }
}

export interface ICiscoIbaAssetsArchitectureLdosRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
    includeUncovered?: boolean;
}

export class CiscoIbaAssetsSearchRequestDto implements ICiscoIbaAssetsSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: CiscoIbaAssetsSearchFilterDto;
    searchFilterExclude?: CiscoIbaAssetsSearchFilterDto;
    limit?: number | undefined;
    offset?: number | undefined;
    sortCriteria?: ElasticSortCriteria;
    scrollSearch?: boolean | undefined;

    constructor(data?: ICiscoIbaAssetsSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFor = _data["searchFor"];
            this.excludeSearchFor = _data["excludeSearchFor"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaAssetsSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaAssetsSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : undefined as any;
            this.scrollSearch = _data["scrollSearch"];
        }
    }

    static fromJS(data: any): CiscoIbaAssetsSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFor"] = this.searchFor;
        data["excludeSearchFor"] = this.excludeSearchFor;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : undefined as any;
        data["scrollSearch"] = this.scrollSearch;
        return data;
    }
}

export interface ICiscoIbaAssetsSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: CiscoIbaAssetsSearchFilterDto;
    searchFilterExclude?: CiscoIbaAssetsSearchFilterDto;
    limit?: number | undefined;
    offset?: number | undefined;
    sortCriteria?: ElasticSortCriteria;
    scrollSearch?: boolean | undefined;
}

export class CiscoIbaLdosRequestDto implements ICiscoIbaLdosRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
    selectedDateRange?: CiscoIbaFilterDates;

    constructor(data?: ICiscoIbaLdosRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
            this.selectedDateRange = _data["selectedDateRange"];
        }
    }

    static fromJS(data: any): CiscoIbaLdosRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLdosRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        data["selectedDateRange"] = this.selectedDateRange;
        return data;
    }
}

export interface ICiscoIbaLdosRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
    selectedDateRange?: CiscoIbaFilterDates;
}

export class CiscoIbaShippedHardwareRequestDto implements ICiscoIbaShippedHardwareRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;

    constructor(data?: ICiscoIbaShippedHardwareRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): CiscoIbaShippedHardwareRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaShippedHardwareRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ICiscoIbaShippedHardwareRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
}

export class CiscoIbaUpdateTagsByAssetsRequest implements ICiscoIbaUpdateTagsByAssetsRequest {
    assets!: CiscoIbaUpdateTagsByAssetsRequestAsset[] | undefined;
    tagValue?: string | undefined;

    constructor(data?: ICiscoIbaUpdateTagsByAssetsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(CiscoIbaUpdateTagsByAssetsRequestAsset.fromJS(item));
            }
            this.tagValue = _data["tagValue"];
        }
    }

    static fromJS(data: any): CiscoIbaUpdateTagsByAssetsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaUpdateTagsByAssetsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        data["tagValue"] = this.tagValue;
        return data;
    }
}

export interface ICiscoIbaUpdateTagsByAssetsRequest {
    assets: CiscoIbaUpdateTagsByAssetsRequestAsset[] | undefined;
    tagValue?: string | undefined;
}

export class CiscoIbaUpdateTagsByAssetsRequestAsset implements ICiscoIbaUpdateTagsByAssetsRequestAsset {
    guid!: string | undefined;
    accountIdentifier!: string | undefined;

    constructor(data?: ICiscoIbaUpdateTagsByAssetsRequestAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.accountIdentifier = _data["accountIdentifier"];
        }
    }

    static fromJS(data: any): CiscoIbaUpdateTagsByAssetsRequestAsset {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaUpdateTagsByAssetsRequestAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["accountIdentifier"] = this.accountIdentifier;
        return data;
    }
}

export interface ICiscoIbaUpdateTagsByAssetsRequestAsset {
    guid: string | undefined;
    accountIdentifier: string | undefined;
}

export class CiscoIbaUpdateTagsByProductsRequest implements ICiscoIbaUpdateTagsByProductsRequest {
    products!: string[] | undefined;
    tagValue?: string | undefined;
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;

    constructor(data?: ICiscoIbaUpdateTagsByProductsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(item);
            }
            this.tagValue = _data["tagValue"];
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): CiscoIbaUpdateTagsByProductsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaUpdateTagsByProductsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item);
        }
        data["tagValue"] = this.tagValue;
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ICiscoIbaUpdateTagsByProductsRequest {
    products: string[] | undefined;
    tagValue?: string | undefined;
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
}

export class GuidsWidgetRequestDto implements IGuidsWidgetRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;

    constructor(data?: IGuidsWidgetRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): GuidsWidgetRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidsWidgetRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IGuidsWidgetRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
}

export class SmartNetSlasWidgetRequestDto implements ISmartNetSlasWidgetRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;

    constructor(data?: ISmartNetSlasWidgetRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): SmartNetSlasWidgetRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartNetSlasWidgetRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ISmartNetSlasWidgetRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
}

export class EsCompositePagination implements IEsCompositePagination {
    pageSize?: number;
    afterKey?: string | undefined;
    hasMore?: boolean;
    totalCount?: number | undefined;
    pageIndex?: number | undefined;

    constructor(data?: IEsCompositePagination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["pageSize"];
            this.afterKey = _data["afterKey"];
            this.hasMore = _data["hasMore"];
            this.totalCount = _data["totalCount"];
            this.pageIndex = _data["pageIndex"];
        }
    }

    static fromJS(data: any): EsCompositePagination {
        data = typeof data === 'object' ? data : {};
        let result = new EsCompositePagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize;
        data["afterKey"] = this.afterKey;
        data["hasMore"] = this.hasMore;
        data["totalCount"] = this.totalCount;
        data["pageIndex"] = this.pageIndex;
        return data;
    }
}

export interface IEsCompositePagination {
    pageSize?: number;
    afterKey?: string | undefined;
    hasMore?: boolean;
    totalCount?: number | undefined;
    pageIndex?: number | undefined;
}

export class EsPurchasedAssetsOrderSpend implements IEsPurchasedAssetsOrderSpend {
    orderNumber?: string | undefined;
    poNumber?: string | undefined;
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    manufacturerName?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    orderDate?: Date | undefined;
    compellingEventDate?: Date | undefined;
    serialNumber?: string | undefined;
    totalSpend?: number;
    totalQuantity?: number;

    constructor(data?: IEsPurchasedAssetsOrderSpend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"];
            this.poNumber = _data["poNumber"];
            this.shiPartNumber = _data["shiPartNumber"];
            this.description = _data["description"];
            this.assetType = _data["assetType"];
            this.manufacturerName = _data["manufacturerName"];
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : undefined as any;
            this.compellingEventDate = _data["compellingEventDate"] ? new Date(_data["compellingEventDate"].toString()) : undefined as any;
            this.serialNumber = _data["serialNumber"];
            this.totalSpend = _data["totalSpend"];
            this.totalQuantity = _data["totalQuantity"];
        }
    }

    static fromJS(data: any): EsPurchasedAssetsOrderSpend {
        data = typeof data === 'object' ? data : {};
        let result = new EsPurchasedAssetsOrderSpend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["poNumber"] = this.poNumber;
        data["shiPartNumber"] = this.shiPartNumber;
        data["description"] = this.description;
        data["assetType"] = this.assetType;
        data["manufacturerName"] = this.manufacturerName;
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined as any;
        data["compellingEventDate"] = this.compellingEventDate ? this.compellingEventDate.toISOString() : undefined as any;
        data["serialNumber"] = this.serialNumber;
        data["totalSpend"] = this.totalSpend;
        data["totalQuantity"] = this.totalQuantity;
        return data;
    }
}

export interface IEsPurchasedAssetsOrderSpend {
    orderNumber?: string | undefined;
    poNumber?: string | undefined;
    shiPartNumber?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    manufacturerName?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    orderDate?: Date | undefined;
    compellingEventDate?: Date | undefined;
    serialNumber?: string | undefined;
    totalSpend?: number;
    totalQuantity?: number;
}

export class EsPurchasedAssetsSpendByOrderRequest implements IEsPurchasedAssetsSpendByOrderRequest {
    orderNumbers?: string[] | undefined;
    shiPartNumbers?: string[] | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    pagination?: EsCompositePagination;
    sortCriteria?: ElasticSortCriteria;

    constructor(data?: IEsPurchasedAssetsSpendByOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderNumbers"])) {
                this.orderNumbers = [] as any;
                for (let item of _data["orderNumbers"])
                    this.orderNumbers!.push(item);
            }
            if (Array.isArray(_data["shiPartNumbers"])) {
                this.shiPartNumbers = [] as any;
                for (let item of _data["shiPartNumbers"])
                    this.shiPartNumbers!.push(item);
            }
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.pagination = _data["pagination"] ? EsCompositePagination.fromJS(_data["pagination"]) : undefined as any;
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : undefined as any;
        }
    }

    static fromJS(data: any): EsPurchasedAssetsSpendByOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EsPurchasedAssetsSpendByOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderNumbers)) {
            data["orderNumbers"] = [];
            for (let item of this.orderNumbers)
                data["orderNumbers"].push(item);
        }
        if (Array.isArray(this.shiPartNumbers)) {
            data["shiPartNumbers"] = [];
            for (let item of this.shiPartNumbers)
                data["shiPartNumbers"].push(item);
        }
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : undefined as any;
        return data;
    }
}

export interface IEsPurchasedAssetsSpendByOrderRequest {
    orderNumbers?: string[] | undefined;
    shiPartNumbers?: string[] | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    pagination?: EsCompositePagination;
    sortCriteria?: ElasticSortCriteria;
}

export class EsPurchasedAssetsSpendByOrderResponse implements IEsPurchasedAssetsSpendByOrderResponse {
    orderSpends?: EsPurchasedAssetsOrderSpend[] | undefined;
    pagination?: EsCompositePagination;

    constructor(data?: IEsPurchasedAssetsSpendByOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderSpends"])) {
                this.orderSpends = [] as any;
                for (let item of _data["orderSpends"])
                    this.orderSpends!.push(EsPurchasedAssetsOrderSpend.fromJS(item));
            }
            this.pagination = _data["pagination"] ? EsCompositePagination.fromJS(_data["pagination"]) : undefined as any;
        }
    }

    static fromJS(data: any): EsPurchasedAssetsSpendByOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EsPurchasedAssetsSpendByOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderSpends)) {
            data["orderSpends"] = [];
            for (let item of this.orderSpends)
                data["orderSpends"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        return data;
    }
}

export interface IEsPurchasedAssetsSpendByOrderResponse {
    orderSpends?: EsPurchasedAssetsOrderSpend[] | undefined;
    pagination?: EsCompositePagination;
}

export class GetServiceRequestPicklistCategoriesRequest implements IGetServiceRequestPicklistCategoriesRequest {
    contactIds?: number[] | undefined;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;
    query?: ServiceRequestSearchQuery;

    constructor(data?: IGetServiceRequestPicklistCategoriesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            this.serviceRequestQueryType = _data["serviceRequestQueryType"];
            this.isAdmin = _data["isAdmin"];
            this.query = _data["query"] ? ServiceRequestSearchQuery.fromJS(_data["query"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetServiceRequestPicklistCategoriesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceRequestPicklistCategoriesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        data["serviceRequestQueryType"] = this.serviceRequestQueryType;
        data["isAdmin"] = this.isAdmin;
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetServiceRequestPicklistCategoriesRequest {
    contactIds?: number[] | undefined;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;
    query?: ServiceRequestSearchQuery;
}

export class GetServiceRequestVisuals implements IGetServiceRequestVisuals {
    visuals?: { [key: string]: ServiceRequestBaseElasticQueryRequest; } | undefined;

    constructor(data?: IGetServiceRequestVisuals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["visuals"]) {
                this.visuals = {} as any;
                for (let key in _data["visuals"]) {
                    if (_data["visuals"].hasOwnProperty(key))
                        (this.visuals as any)![key] = _data["visuals"][key] ? ServiceRequestBaseElasticQueryRequest.fromJS(_data["visuals"][key]) : new ServiceRequestBaseElasticQueryRequest();
                }
            }
        }
    }

    static fromJS(data: any): GetServiceRequestVisuals {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceRequestVisuals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.visuals) {
            data["visuals"] = {};
            for (let key in this.visuals) {
                if (this.visuals.hasOwnProperty(key))
                    (data["visuals"] as any)[key] = this.visuals[key] ? this.visuals[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IGetServiceRequestVisuals {
    visuals?: { [key: string]: ServiceRequestBaseElasticQueryRequest; } | undefined;
}

export class GetUniqueFilterValuesRequestBase implements IGetUniqueFilterValuesRequestBase {
    contactIds?: number[] | undefined;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;
    query?: ServiceRequestSearchQuery;

    constructor(data?: IGetUniqueFilterValuesRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            this.serviceRequestQueryType = _data["serviceRequestQueryType"];
            this.isAdmin = _data["isAdmin"];
            this.query = _data["query"] ? ServiceRequestSearchQuery.fromJS(_data["query"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetUniqueFilterValuesRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new GetUniqueFilterValuesRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        data["serviceRequestQueryType"] = this.serviceRequestQueryType;
        data["isAdmin"] = this.isAdmin;
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetUniqueFilterValuesRequestBase {
    contactIds?: number[] | undefined;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;
    query?: ServiceRequestSearchQuery;
}

export class ServiceReportExportRequest implements IServiceReportExportRequest {
    tabIdentifier?: ServiceReportExportTabIdentifier;
    filters?: ServiceReportsFilterRequest;

    constructor(data?: IServiceReportExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabIdentifier = _data["tabIdentifier"];
            this.filters = _data["filters"] ? ServiceReportsFilterRequest.fromJS(_data["filters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceReportExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabIdentifier"] = this.tabIdentifier;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface IServiceReportExportRequest {
    tabIdentifier?: ServiceReportExportTabIdentifier;
    filters?: ServiceReportsFilterRequest;
}

export enum ServiceReportExportTabIdentifier {
    Overview = "Overview",
    Requests = "Requests",
    SubmittedBy = "SubmittedBy",
    Billable = "Billable",
    IssueType = "IssueType",
    SurveyMetrics = "SurveyMetrics",
}

export class ServiceReportsFilterRequest implements IServiceReportsFilterRequest {
    accountIds?: number[] | undefined;
    contactIds?: number[] | undefined;
    isAdmin?: boolean;
    dateFilters?: { [key: string]: DateRangeFilter; } | undefined;
    queryType?: ServiceRequestQueryType;
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: ServiceRequestPicklist;
    searchFilterExclude?: ServiceRequestPicklist;

    constructor(data?: IServiceReportsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            this.isAdmin = _data["isAdmin"];
            if (_data["dateFilters"]) {
                this.dateFilters = {} as any;
                for (let key in _data["dateFilters"]) {
                    if (_data["dateFilters"].hasOwnProperty(key))
                        (this.dateFilters as any)![key] = _data["dateFilters"][key] ? DateRangeFilter.fromJS(_data["dateFilters"][key]) : new DateRangeFilter();
                }
            }
            this.queryType = _data["queryType"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortByColumn = _data["sortByColumn"];
            this.isDescending = _data["isDescending"];
            this.afterKey = _data["afterKey"];
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? ServiceRequestPicklist.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? ServiceRequestPicklist.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceReportsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        data["isAdmin"] = this.isAdmin;
        if (this.dateFilters) {
            data["dateFilters"] = {};
            for (let key in this.dateFilters) {
                if (this.dateFilters.hasOwnProperty(key))
                    (data["dateFilters"] as any)[key] = this.dateFilters[key] ? this.dateFilters[key].toJSON() : undefined as any;
            }
        }
        data["queryType"] = this.queryType;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortByColumn"] = this.sortByColumn;
        data["isDescending"] = this.isDescending;
        data["afterKey"] = this.afterKey;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IServiceReportsFilterRequest {
    accountIds?: number[] | undefined;
    contactIds?: number[] | undefined;
    isAdmin?: boolean;
    dateFilters?: { [key: string]: DateRangeFilter; } | undefined;
    queryType?: ServiceRequestQueryType;
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: ServiceRequestPicklist;
    searchFilterExclude?: ServiceRequestPicklist;
}

export class ServiceRequestBaseElasticQueryRequest implements IServiceRequestBaseElasticQueryRequest {
    contactIds?: number[] | undefined;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;
    query?: ServiceRequestSearchQuery;

    constructor(data?: IServiceRequestBaseElasticQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            this.serviceRequestQueryType = _data["serviceRequestQueryType"];
            this.isAdmin = _data["isAdmin"];
            this.query = _data["query"] ? ServiceRequestSearchQuery.fromJS(_data["query"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceRequestBaseElasticQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestBaseElasticQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        data["serviceRequestQueryType"] = this.serviceRequestQueryType;
        data["isAdmin"] = this.isAdmin;
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        return data;
    }
}

export interface IServiceRequestBaseElasticQueryRequest {
    contactIds?: number[] | undefined;
    serviceRequestQueryType?: ServiceRequestQueryType;
    isAdmin?: boolean;
    query?: ServiceRequestSearchQuery;
}

export class CiscoIbaSearchRequestDto implements ICiscoIbaSearchRequestDto {
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;

    constructor(data?: ICiscoIbaSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            this.excludeSearchFor = _data["excludeSearchFor"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? CiscoIbaSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): CiscoIbaSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        data["excludeSearchFor"] = this.excludeSearchFor;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ICiscoIbaSearchRequestDto {
    searchFor?: string | undefined;
    excludeSearchFor?: boolean | undefined;
    searchFilterInclude?: CiscoIbaSearchFilterDto | undefined;
    searchFilterExclude?: CiscoIbaSearchFilterDto | undefined;
}

export class CiscoIbaTableDownloadRequestDto implements ICiscoIbaTableDownloadRequestDto {
    query!: CiscoIbaSearchRequestDto;
    gridDefinitions!: ExcelDownloadDefinition[] | undefined;

    constructor(data?: ICiscoIbaTableDownloadRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.query = new CiscoIbaSearchRequestDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? CiscoIbaSearchRequestDto.fromJS(_data["query"]) : new CiscoIbaSearchRequestDto();
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CiscoIbaTableDownloadRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaTableDownloadRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICiscoIbaTableDownloadRequestDto {
    query: CiscoIbaSearchRequestDto;
    gridDefinitions: ExcelDownloadDefinition[] | undefined;
}

export class ServiceRequestDateFilter implements IServiceRequestDateFilter {
    start?: Date | undefined;
    end?: Date | undefined;

    constructor(data?: IServiceRequestDateFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceRequestDateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDateFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }
}

export interface IServiceRequestDateFilter {
    start?: Date | undefined;
    end?: Date | undefined;
}

export class ContractRequestRankingDto implements IContractRequestRankingDto {
    contractId?: number;
    contractName?: string | undefined;
    requestsCount?: number;
    requestsPercentage?: number;

    constructor(data?: IContractRequestRankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.requestsCount = _data["requestsCount"];
            this.requestsPercentage = _data["requestsPercentage"];
        }
    }

    static fromJS(data: any): ContractRequestRankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRequestRankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["requestsCount"] = this.requestsCount;
        data["requestsPercentage"] = this.requestsPercentage;
        return data;
    }
}

export interface IContractRequestRankingDto {
    contractId?: number;
    contractName?: string | undefined;
    requestsCount?: number;
    requestsPercentage?: number;
}

export class ContractRequestRankingsVisualsDto implements IContractRequestRankingsVisualsDto {
    contractRequestRankings?: ContractRequestRankingDto[] | undefined;

    constructor(data?: IContractRequestRankingsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contractRequestRankings"])) {
                this.contractRequestRankings = [] as any;
                for (let item of _data["contractRequestRankings"])
                    this.contractRequestRankings!.push(ContractRequestRankingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractRequestRankingsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRequestRankingsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contractRequestRankings)) {
            data["contractRequestRankings"] = [];
            for (let item of this.contractRequestRankings)
                data["contractRequestRankings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContractRequestRankingsVisualsDto {
    contractRequestRankings?: ContractRequestRankingDto[] | undefined;
}

export class ElasticDateTimeOffsetRangeQueryFilter implements IElasticDateTimeOffsetRangeQueryFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IElasticDateTimeOffsetRangeQueryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ElasticDateTimeOffsetRangeQueryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ElasticDateTimeOffsetRangeQueryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IElasticDateTimeOffsetRangeQueryFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class MonthlyReportDto implements IMonthlyReportDto {
    month?: number;
    createdTickets?: number;
    completedTickets?: number;
    monthDate?: Date;
    monthName?: string | undefined;
    monthNameShort?: string | undefined;

    constructor(data?: IMonthlyReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.createdTickets = _data["createdTickets"];
            this.completedTickets = _data["completedTickets"];
            this.monthDate = _data["monthDate"] ? new Date(_data["monthDate"].toString()) : undefined as any;
            this.monthName = _data["monthName"];
            this.monthNameShort = _data["monthNameShort"];
        }
    }

    static fromJS(data: any): MonthlyReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["createdTickets"] = this.createdTickets;
        data["completedTickets"] = this.completedTickets;
        data["monthDate"] = this.monthDate ? this.monthDate.toISOString() : undefined as any;
        data["monthName"] = this.monthName;
        data["monthNameShort"] = this.monthNameShort;
        return data;
    }
}

export interface IMonthlyReportDto {
    month?: number;
    createdTickets?: number;
    completedTickets?: number;
    monthDate?: Date;
    monthName?: string | undefined;
    monthNameShort?: string | undefined;
}

export class MonthlyReportsDto implements IMonthlyReportsDto {
    reports?: MonthlyReportDto[] | undefined;

    constructor(data?: IMonthlyReportsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(MonthlyReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthlyReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyReportsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMonthlyReportsDto {
    reports?: MonthlyReportDto[] | undefined;
}

export class RequestMetricsVisualsDto implements IRequestMetricsVisualsDto {
    averageRating?: number | undefined;
    firstResponseMetPercentage?: number | undefined;
    firstResponseMetCount?: number | undefined;
    firstResponseNotMetCount?: number | undefined;
    firstResponseNotMetWarning?: boolean | undefined;

    constructor(data?: IRequestMetricsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageRating = _data["averageRating"];
            this.firstResponseMetPercentage = _data["firstResponseMetPercentage"];
            this.firstResponseMetCount = _data["firstResponseMetCount"];
            this.firstResponseNotMetCount = _data["firstResponseNotMetCount"];
            this.firstResponseNotMetWarning = _data["firstResponseNotMetWarning"];
        }
    }

    static fromJS(data: any): RequestMetricsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestMetricsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageRating"] = this.averageRating;
        data["firstResponseMetPercentage"] = this.firstResponseMetPercentage;
        data["firstResponseMetCount"] = this.firstResponseMetCount;
        data["firstResponseNotMetCount"] = this.firstResponseNotMetCount;
        data["firstResponseNotMetWarning"] = this.firstResponseNotMetWarning;
        return data;
    }
}

export interface IRequestMetricsVisualsDto {
    averageRating?: number | undefined;
    firstResponseMetPercentage?: number | undefined;
    firstResponseMetCount?: number | undefined;
    firstResponseNotMetCount?: number | undefined;
    firstResponseNotMetWarning?: boolean | undefined;
}

export class RequesterRankingDto implements IRequesterRankingDto {
    requester?: string | undefined;
    requestCount?: number;
    requestPercentage?: number;

    constructor(data?: IRequesterRankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requester = _data["requester"];
            this.requestCount = _data["requestCount"];
            this.requestPercentage = _data["requestPercentage"];
        }
    }

    static fromJS(data: any): RequesterRankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequesterRankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requester"] = this.requester;
        data["requestCount"] = this.requestCount;
        data["requestPercentage"] = this.requestPercentage;
        return data;
    }
}

export interface IRequesterRankingDto {
    requester?: string | undefined;
    requestCount?: number;
    requestPercentage?: number;
}

export class RequesterRankingsVisualsDto implements IRequesterRankingsVisualsDto {
    requesterRankings?: RequesterRankingDto[] | undefined;

    constructor(data?: IRequesterRankingsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requesterRankings"])) {
                this.requesterRankings = [] as any;
                for (let item of _data["requesterRankings"])
                    this.requesterRankings!.push(RequesterRankingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequesterRankingsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequesterRankingsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requesterRankings)) {
            data["requesterRankings"] = [];
            for (let item of this.requesterRankings)
                data["requesterRankings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRequesterRankingsVisualsDto {
    requesterRankings?: RequesterRankingDto[] | undefined;
}

export class DateRangeFilter implements IDateRangeFilter {
    start?: Date | undefined;
    end?: Date | undefined;
    startExpression?: string | undefined;
    endExpression?: string | undefined;

    constructor(data?: IDateRangeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.startExpression = _data["startExpression"];
            this.endExpression = _data["endExpression"];
        }
    }

    static fromJS(data: any): DateRangeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        data["startExpression"] = this.startExpression;
        data["endExpression"] = this.endExpression;
        return data;
    }
}

export interface IDateRangeFilter {
    start?: Date | undefined;
    end?: Date | undefined;
    startExpression?: string | undefined;
    endExpression?: string | undefined;
}

export class ServiceReportsFilterOptionsResponse implements IServiceReportsFilterOptionsResponse {
    priorities?: string[] | undefined;
    serviceRequestTypes?: string[] | undefined;
    statuses?: string[] | undefined;
    ticketCategories?: string[] | undefined;
    issueTypes?: string[] | undefined;
    assignedTo?: string[] | undefined;
    createdBy?: string[] | undefined;
    contractNames?: string[] | undefined;
    contractStatuses?: string[] | undefined;

    constructor(data?: IServiceReportsFilterOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["priorities"])
                    this.priorities!.push(item);
            }
            if (Array.isArray(_data["serviceRequestTypes"])) {
                this.serviceRequestTypes = [] as any;
                for (let item of _data["serviceRequestTypes"])
                    this.serviceRequestTypes!.push(item);
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            if (Array.isArray(_data["ticketCategories"])) {
                this.ticketCategories = [] as any;
                for (let item of _data["ticketCategories"])
                    this.ticketCategories!.push(item);
            }
            if (Array.isArray(_data["issueTypes"])) {
                this.issueTypes = [] as any;
                for (let item of _data["issueTypes"])
                    this.issueTypes!.push(item);
            }
            if (Array.isArray(_data["assignedTo"])) {
                this.assignedTo = [] as any;
                for (let item of _data["assignedTo"])
                    this.assignedTo!.push(item);
            }
            if (Array.isArray(_data["createdBy"])) {
                this.createdBy = [] as any;
                for (let item of _data["createdBy"])
                    this.createdBy!.push(item);
            }
            if (Array.isArray(_data["contractNames"])) {
                this.contractNames = [] as any;
                for (let item of _data["contractNames"])
                    this.contractNames!.push(item);
            }
            if (Array.isArray(_data["contractStatuses"])) {
                this.contractStatuses = [] as any;
                for (let item of _data["contractStatuses"])
                    this.contractStatuses!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceReportsFilterOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportsFilterOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priorities)) {
            data["priorities"] = [];
            for (let item of this.priorities)
                data["priorities"].push(item);
        }
        if (Array.isArray(this.serviceRequestTypes)) {
            data["serviceRequestTypes"] = [];
            for (let item of this.serviceRequestTypes)
                data["serviceRequestTypes"].push(item);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        if (Array.isArray(this.ticketCategories)) {
            data["ticketCategories"] = [];
            for (let item of this.ticketCategories)
                data["ticketCategories"].push(item);
        }
        if (Array.isArray(this.issueTypes)) {
            data["issueTypes"] = [];
            for (let item of this.issueTypes)
                data["issueTypes"].push(item);
        }
        if (Array.isArray(this.assignedTo)) {
            data["assignedTo"] = [];
            for (let item of this.assignedTo)
                data["assignedTo"].push(item);
        }
        if (Array.isArray(this.createdBy)) {
            data["createdBy"] = [];
            for (let item of this.createdBy)
                data["createdBy"].push(item);
        }
        if (Array.isArray(this.contractNames)) {
            data["contractNames"] = [];
            for (let item of this.contractNames)
                data["contractNames"].push(item);
        }
        if (Array.isArray(this.contractStatuses)) {
            data["contractStatuses"] = [];
            for (let item of this.contractStatuses)
                data["contractStatuses"].push(item);
        }
        return data;
    }
}

export interface IServiceReportsFilterOptionsResponse {
    priorities?: string[] | undefined;
    serviceRequestTypes?: string[] | undefined;
    statuses?: string[] | undefined;
    ticketCategories?: string[] | undefined;
    issueTypes?: string[] | undefined;
    assignedTo?: string[] | undefined;
    createdBy?: string[] | undefined;
    contractNames?: string[] | undefined;
    contractStatuses?: string[] | undefined;
}

export class ServiceReportsOverviewResponse implements IServiceReportsOverviewResponse {
    slaByPriority!: SlaByPriorityDto;
    filterOptions!: ServiceReportsFilterOptionsResponse;
    overview?: SupportOverviewDto;
    metrics?: RequestMetricsVisualsDto;
    requestsByType?: ServiceRequestVisualsDto;
    burnRate?: number | undefined;
    projectedAnnualBurnRate?: number | undefined;

    constructor(data?: IServiceReportsOverviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.slaByPriority = new SlaByPriorityDto();
            this.filterOptions = new ServiceReportsFilterOptionsResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slaByPriority = _data["slaByPriority"] ? SlaByPriorityDto.fromJS(_data["slaByPriority"]) : new SlaByPriorityDto();
            this.filterOptions = _data["filterOptions"] ? ServiceReportsFilterOptionsResponse.fromJS(_data["filterOptions"]) : new ServiceReportsFilterOptionsResponse();
            this.overview = _data["overview"] ? SupportOverviewDto.fromJS(_data["overview"]) : undefined as any;
            this.metrics = _data["metrics"] ? RequestMetricsVisualsDto.fromJS(_data["metrics"]) : undefined as any;
            this.requestsByType = _data["requestsByType"] ? ServiceRequestVisualsDto.fromJS(_data["requestsByType"]) : undefined as any;
            this.burnRate = _data["burnRate"];
            this.projectedAnnualBurnRate = _data["projectedAnnualBurnRate"];
        }
    }

    static fromJS(data: any): ServiceReportsOverviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportsOverviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slaByPriority"] = this.slaByPriority ? this.slaByPriority.toJSON() : undefined as any;
        data["filterOptions"] = this.filterOptions ? this.filterOptions.toJSON() : undefined as any;
        data["overview"] = this.overview ? this.overview.toJSON() : undefined as any;
        data["metrics"] = this.metrics ? this.metrics.toJSON() : undefined as any;
        data["requestsByType"] = this.requestsByType ? this.requestsByType.toJSON() : undefined as any;
        data["burnRate"] = this.burnRate;
        data["projectedAnnualBurnRate"] = this.projectedAnnualBurnRate;
        return data;
    }
}

export interface IServiceReportsOverviewResponse {
    slaByPriority: SlaByPriorityDto;
    filterOptions: ServiceReportsFilterOptionsResponse;
    overview?: SupportOverviewDto;
    metrics?: RequestMetricsVisualsDto;
    requestsByType?: ServiceRequestVisualsDto;
    burnRate?: number | undefined;
    projectedAnnualBurnRate?: number | undefined;
}

export class ServiceRequestDto implements IServiceRequestDto {
    id?: number;
    requestIdentifier?: string | undefined;
    description?: string | undefined;
    createdById?: number | undefined;
    createdBy?: string | undefined;
    secondaryContacts?: number[] | undefined;
    assignedToId?: number | undefined;
    assignedTo?: string | undefined;
    accountId?: number;
    serviceRequestType?: string | undefined;
    status?: string | undefined;
    activeOrComplete?: string | undefined;
    priority?: string | undefined;
    source?: string | undefined;
    serviceRequestCategory?: string | undefined;
    issueType?: string | undefined;
    subIssueType?: string | undefined;
    title?: string | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    completedDate?: Date;
    firstResponseMet?: boolean | undefined;
    surveyRating?: number | undefined;
    createdByEmail?: string | undefined;
    isAllowedForSla?: boolean;
    isWaitingForResponse?: boolean;
    externalCaseId?: string | undefined;
    billingItemIds?: number[] | undefined;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;
    totalHoursWorked?: number;
    contractId?: number | undefined;
    contractName?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    changeInfoField1?: string | undefined;
    changeInfoField2?: string | undefined;
    changeInfoField3?: string | undefined;
    changeInfoField4?: string | undefined;
    changeInfoField5?: string | undefined;
    salesId?: string | undefined;
    boxOrderStatus?: string | undefined;
    lineNum?: string | undefined;
    shipDate?: Date | undefined;
    deliveryAddress?: string | undefined;
    purchOrder?: string | undefined;
    qty?: string | undefined;
    qtyOrdered?: string | undefined;
    hlmStatus?: string | undefined;
    rmaNumber?: string | undefined;
    receivedDate?: Date | undefined;
    deviceReceived?: string | undefined;
    inTriage?: string | undefined;
    hlmReqDispAndGrading?: string | undefined;
    dataErasure?: string | undefined;
    hlmActualDisposition?: string | undefined;
    complete?: string | undefined;
    itemName?: string | undefined;
    itemNumber?: string | undefined;
    manufacturer?: string | undefined;
    serialNum?: string | undefined;
    trackNum?: string | undefined;

    constructor(data?: IServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestIdentifier = _data["requestIdentifier"];
            this.description = _data["description"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["secondaryContacts"])) {
                this.secondaryContacts = [] as any;
                for (let item of _data["secondaryContacts"])
                    this.secondaryContacts!.push(item);
            }
            this.assignedToId = _data["assignedToId"];
            this.assignedTo = _data["assignedTo"];
            this.accountId = _data["accountId"];
            this.serviceRequestType = _data["serviceRequestType"];
            this.status = _data["status"];
            this.activeOrComplete = _data["activeOrComplete"];
            this.priority = _data["priority"];
            this.source = _data["source"];
            this.serviceRequestCategory = _data["serviceRequestCategory"];
            this.issueType = _data["issueType"];
            this.subIssueType = _data["subIssueType"];
            this.title = _data["title"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined as any;
            this.firstResponseMet = _data["firstResponseMet"];
            this.surveyRating = _data["surveyRating"];
            this.createdByEmail = _data["createdByEmail"];
            this.isAllowedForSla = _data["isAllowedForSla"];
            this.isWaitingForResponse = _data["isWaitingForResponse"];
            this.externalCaseId = _data["externalCaseId"];
            if (Array.isArray(_data["billingItemIds"])) {
                this.billingItemIds = [] as any;
                for (let item of _data["billingItemIds"])
                    this.billingItemIds!.push(item);
            }
            this.totalBillingHours = _data["totalBillingHours"];
            this.totalBillingAmount = _data["totalBillingAmount"];
            this.totalHoursWorked = _data["totalHoursWorked"];
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.changeInfoField1 = _data["changeInfoField1"];
            this.changeInfoField2 = _data["changeInfoField2"];
            this.changeInfoField3 = _data["changeInfoField3"];
            this.changeInfoField4 = _data["changeInfoField4"];
            this.changeInfoField5 = _data["changeInfoField5"];
            this.salesId = _data["salesId"];
            this.boxOrderStatus = _data["boxOrderStatus"];
            this.lineNum = _data["lineNum"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
            this.deliveryAddress = _data["deliveryAddress"];
            this.purchOrder = _data["purchOrder"];
            this.qty = _data["qty"];
            this.qtyOrdered = _data["qtyOrdered"];
            this.hlmStatus = _data["hlmStatus"];
            this.rmaNumber = _data["rmaNumber"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : undefined as any;
            this.deviceReceived = _data["deviceReceived"];
            this.inTriage = _data["inTriage"];
            this.hlmReqDispAndGrading = _data["hlmReqDispAndGrading"];
            this.dataErasure = _data["dataErasure"];
            this.hlmActualDisposition = _data["hlmActualDisposition"];
            this.complete = _data["complete"];
            this.itemName = _data["itemName"];
            this.itemNumber = _data["itemNumber"];
            this.manufacturer = _data["manufacturer"];
            this.serialNum = _data["serialNum"];
            this.trackNum = _data["trackNum"];
        }
    }

    static fromJS(data: any): ServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestIdentifier"] = this.requestIdentifier;
        data["description"] = this.description;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.secondaryContacts)) {
            data["secondaryContacts"] = [];
            for (let item of this.secondaryContacts)
                data["secondaryContacts"].push(item);
        }
        data["assignedToId"] = this.assignedToId;
        data["assignedTo"] = this.assignedTo;
        data["accountId"] = this.accountId;
        data["serviceRequestType"] = this.serviceRequestType;
        data["status"] = this.status;
        data["activeOrComplete"] = this.activeOrComplete;
        data["priority"] = this.priority;
        data["source"] = this.source;
        data["serviceRequestCategory"] = this.serviceRequestCategory;
        data["issueType"] = this.issueType;
        data["subIssueType"] = this.subIssueType;
        data["title"] = this.title;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        data["firstResponseMet"] = this.firstResponseMet;
        data["surveyRating"] = this.surveyRating;
        data["createdByEmail"] = this.createdByEmail;
        data["isAllowedForSla"] = this.isAllowedForSla;
        data["isWaitingForResponse"] = this.isWaitingForResponse;
        data["externalCaseId"] = this.externalCaseId;
        if (Array.isArray(this.billingItemIds)) {
            data["billingItemIds"] = [];
            for (let item of this.billingItemIds)
                data["billingItemIds"].push(item);
        }
        data["totalBillingHours"] = this.totalBillingHours;
        data["totalBillingAmount"] = this.totalBillingAmount;
        data["totalHoursWorked"] = this.totalHoursWorked;
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["changeInfoField1"] = this.changeInfoField1;
        data["changeInfoField2"] = this.changeInfoField2;
        data["changeInfoField3"] = this.changeInfoField3;
        data["changeInfoField4"] = this.changeInfoField4;
        data["changeInfoField5"] = this.changeInfoField5;
        data["salesId"] = this.salesId;
        data["boxOrderStatus"] = this.boxOrderStatus;
        data["lineNum"] = this.lineNum;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        data["deliveryAddress"] = this.deliveryAddress;
        data["purchOrder"] = this.purchOrder;
        data["qty"] = this.qty;
        data["qtyOrdered"] = this.qtyOrdered;
        data["hlmStatus"] = this.hlmStatus;
        data["rmaNumber"] = this.rmaNumber;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : undefined as any;
        data["deviceReceived"] = this.deviceReceived;
        data["inTriage"] = this.inTriage;
        data["hlmReqDispAndGrading"] = this.hlmReqDispAndGrading;
        data["dataErasure"] = this.dataErasure;
        data["hlmActualDisposition"] = this.hlmActualDisposition;
        data["complete"] = this.complete;
        data["itemName"] = this.itemName;
        data["itemNumber"] = this.itemNumber;
        data["manufacturer"] = this.manufacturer;
        data["serialNum"] = this.serialNum;
        data["trackNum"] = this.trackNum;
        return data;
    }
}

export interface IServiceRequestDto {
    id?: number;
    requestIdentifier?: string | undefined;
    description?: string | undefined;
    createdById?: number | undefined;
    createdBy?: string | undefined;
    secondaryContacts?: number[] | undefined;
    assignedToId?: number | undefined;
    assignedTo?: string | undefined;
    accountId?: number;
    serviceRequestType?: string | undefined;
    status?: string | undefined;
    activeOrComplete?: string | undefined;
    priority?: string | undefined;
    source?: string | undefined;
    serviceRequestCategory?: string | undefined;
    issueType?: string | undefined;
    subIssueType?: string | undefined;
    title?: string | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    completedDate?: Date;
    firstResponseMet?: boolean | undefined;
    surveyRating?: number | undefined;
    createdByEmail?: string | undefined;
    isAllowedForSla?: boolean;
    isWaitingForResponse?: boolean;
    externalCaseId?: string | undefined;
    billingItemIds?: number[] | undefined;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;
    totalHoursWorked?: number;
    contractId?: number | undefined;
    contractName?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    changeInfoField1?: string | undefined;
    changeInfoField2?: string | undefined;
    changeInfoField3?: string | undefined;
    changeInfoField4?: string | undefined;
    changeInfoField5?: string | undefined;
    salesId?: string | undefined;
    boxOrderStatus?: string | undefined;
    lineNum?: string | undefined;
    shipDate?: Date | undefined;
    deliveryAddress?: string | undefined;
    purchOrder?: string | undefined;
    qty?: string | undefined;
    qtyOrdered?: string | undefined;
    hlmStatus?: string | undefined;
    rmaNumber?: string | undefined;
    receivedDate?: Date | undefined;
    deviceReceived?: string | undefined;
    inTriage?: string | undefined;
    hlmReqDispAndGrading?: string | undefined;
    dataErasure?: string | undefined;
    hlmActualDisposition?: string | undefined;
    complete?: string | undefined;
    itemName?: string | undefined;
    itemNumber?: string | undefined;
    manufacturer?: string | undefined;
    serialNum?: string | undefined;
    trackNum?: string | undefined;
}

export class ServiceRequestIssueRankingsWidgetDto implements IServiceRequestIssueRankingsWidgetDto {
    issueRankings?: { [key: string]: ServiceRequestSubIssueRankingDto; } | undefined;
    totalRecordsCount?: number;

    constructor(data?: IServiceRequestIssueRankingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["issueRankings"]) {
                this.issueRankings = {} as any;
                for (let key in _data["issueRankings"]) {
                    if (_data["issueRankings"].hasOwnProperty(key))
                        (this.issueRankings as any)![key] = _data["issueRankings"][key] ? ServiceRequestSubIssueRankingDto.fromJS(_data["issueRankings"][key]) : new ServiceRequestSubIssueRankingDto();
                }
            }
            this.totalRecordsCount = _data["totalRecordsCount"];
        }
    }

    static fromJS(data: any): ServiceRequestIssueRankingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestIssueRankingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.issueRankings) {
            data["issueRankings"] = {};
            for (let key in this.issueRankings) {
                if (this.issueRankings.hasOwnProperty(key))
                    (data["issueRankings"] as any)[key] = this.issueRankings[key] ? this.issueRankings[key].toJSON() : undefined as any;
            }
        }
        data["totalRecordsCount"] = this.totalRecordsCount;
        return data;
    }
}

export interface IServiceRequestIssueRankingsWidgetDto {
    issueRankings?: { [key: string]: ServiceRequestSubIssueRankingDto; } | undefined;
    totalRecordsCount?: number;
}

export class ServiceRequestListDocumentDto implements IServiceRequestListDocumentDto {
    serviceRequestDtos?: ServiceRequestDto[] | undefined;
    totalCount?: number;
    afterKey?: string | undefined;

    constructor(data?: IServiceRequestListDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceRequestDtos"])) {
                this.serviceRequestDtos = [] as any;
                for (let item of _data["serviceRequestDtos"])
                    this.serviceRequestDtos!.push(ServiceRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.afterKey = _data["afterKey"];
        }
    }

    static fromJS(data: any): ServiceRequestListDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestListDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceRequestDtos)) {
            data["serviceRequestDtos"] = [];
            for (let item of this.serviceRequestDtos)
                data["serviceRequestDtos"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["afterKey"] = this.afterKey;
        return data;
    }
}

export interface IServiceRequestListDocumentDto {
    serviceRequestDtos?: ServiceRequestDto[] | undefined;
    totalCount?: number;
    afterKey?: string | undefined;
}

export class ServiceRequestPicklist implements IServiceRequestPicklist {
    serviceRequestType?: string[] | undefined;
    ticketCategory?: string[] | undefined;
    issueType?: string[] | undefined;
    priority?: string[] | undefined;
    source?: string[] | undefined;
    status?: string[] | undefined;
    createdBy?: string[] | undefined;
    assignedTo?: string[] | undefined;
    contractName?: string[] | undefined;
    activeOrComplete?: string[] | undefined;
    isWaitingForResponse?: string[] | undefined;
    firstResponseMet?: string[] | undefined;
    externalCaseId?: string[] | undefined;
    requestIdentifier?: string[] | undefined;
    contractStatus?: string[] | undefined;

    constructor(data?: IServiceRequestPicklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceRequestType"])) {
                this.serviceRequestType = [] as any;
                for (let item of _data["serviceRequestType"])
                    this.serviceRequestType!.push(item);
            }
            if (Array.isArray(_data["ticketCategory"])) {
                this.ticketCategory = [] as any;
                for (let item of _data["ticketCategory"])
                    this.ticketCategory!.push(item);
            }
            if (Array.isArray(_data["issueType"])) {
                this.issueType = [] as any;
                for (let item of _data["issueType"])
                    this.issueType!.push(item);
            }
            if (Array.isArray(_data["priority"])) {
                this.priority = [] as any;
                for (let item of _data["priority"])
                    this.priority!.push(item);
            }
            if (Array.isArray(_data["source"])) {
                this.source = [] as any;
                for (let item of _data["source"])
                    this.source!.push(item);
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["createdBy"])) {
                this.createdBy = [] as any;
                for (let item of _data["createdBy"])
                    this.createdBy!.push(item);
            }
            if (Array.isArray(_data["assignedTo"])) {
                this.assignedTo = [] as any;
                for (let item of _data["assignedTo"])
                    this.assignedTo!.push(item);
            }
            if (Array.isArray(_data["contractName"])) {
                this.contractName = [] as any;
                for (let item of _data["contractName"])
                    this.contractName!.push(item);
            }
            if (Array.isArray(_data["activeOrComplete"])) {
                this.activeOrComplete = [] as any;
                for (let item of _data["activeOrComplete"])
                    this.activeOrComplete!.push(item);
            }
            if (Array.isArray(_data["isWaitingForResponse"])) {
                this.isWaitingForResponse = [] as any;
                for (let item of _data["isWaitingForResponse"])
                    this.isWaitingForResponse!.push(item);
            }
            if (Array.isArray(_data["firstResponseMet"])) {
                this.firstResponseMet = [] as any;
                for (let item of _data["firstResponseMet"])
                    this.firstResponseMet!.push(item);
            }
            if (Array.isArray(_data["externalCaseId"])) {
                this.externalCaseId = [] as any;
                for (let item of _data["externalCaseId"])
                    this.externalCaseId!.push(item);
            }
            if (Array.isArray(_data["requestIdentifier"])) {
                this.requestIdentifier = [] as any;
                for (let item of _data["requestIdentifier"])
                    this.requestIdentifier!.push(item);
            }
            if (Array.isArray(_data["contractStatus"])) {
                this.contractStatus = [] as any;
                for (let item of _data["contractStatus"])
                    this.contractStatus!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceRequestPicklist {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestPicklist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceRequestType)) {
            data["serviceRequestType"] = [];
            for (let item of this.serviceRequestType)
                data["serviceRequestType"].push(item);
        }
        if (Array.isArray(this.ticketCategory)) {
            data["ticketCategory"] = [];
            for (let item of this.ticketCategory)
                data["ticketCategory"].push(item);
        }
        if (Array.isArray(this.issueType)) {
            data["issueType"] = [];
            for (let item of this.issueType)
                data["issueType"].push(item);
        }
        if (Array.isArray(this.priority)) {
            data["priority"] = [];
            for (let item of this.priority)
                data["priority"].push(item);
        }
        if (Array.isArray(this.source)) {
            data["source"] = [];
            for (let item of this.source)
                data["source"].push(item);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.createdBy)) {
            data["createdBy"] = [];
            for (let item of this.createdBy)
                data["createdBy"].push(item);
        }
        if (Array.isArray(this.assignedTo)) {
            data["assignedTo"] = [];
            for (let item of this.assignedTo)
                data["assignedTo"].push(item);
        }
        if (Array.isArray(this.contractName)) {
            data["contractName"] = [];
            for (let item of this.contractName)
                data["contractName"].push(item);
        }
        if (Array.isArray(this.activeOrComplete)) {
            data["activeOrComplete"] = [];
            for (let item of this.activeOrComplete)
                data["activeOrComplete"].push(item);
        }
        if (Array.isArray(this.isWaitingForResponse)) {
            data["isWaitingForResponse"] = [];
            for (let item of this.isWaitingForResponse)
                data["isWaitingForResponse"].push(item);
        }
        if (Array.isArray(this.firstResponseMet)) {
            data["firstResponseMet"] = [];
            for (let item of this.firstResponseMet)
                data["firstResponseMet"].push(item);
        }
        if (Array.isArray(this.externalCaseId)) {
            data["externalCaseId"] = [];
            for (let item of this.externalCaseId)
                data["externalCaseId"].push(item);
        }
        if (Array.isArray(this.requestIdentifier)) {
            data["requestIdentifier"] = [];
            for (let item of this.requestIdentifier)
                data["requestIdentifier"].push(item);
        }
        if (Array.isArray(this.contractStatus)) {
            data["contractStatus"] = [];
            for (let item of this.contractStatus)
                data["contractStatus"].push(item);
        }
        return data;
    }
}

export interface IServiceRequestPicklist {
    serviceRequestType?: string[] | undefined;
    ticketCategory?: string[] | undefined;
    issueType?: string[] | undefined;
    priority?: string[] | undefined;
    source?: string[] | undefined;
    status?: string[] | undefined;
    createdBy?: string[] | undefined;
    assignedTo?: string[] | undefined;
    contractName?: string[] | undefined;
    activeOrComplete?: string[] | undefined;
    isWaitingForResponse?: string[] | undefined;
    firstResponseMet?: string[] | undefined;
    externalCaseId?: string[] | undefined;
    requestIdentifier?: string[] | undefined;
    contractStatus?: string[] | undefined;
}

export class ServiceRequestPicklistCategoriesResponse implements IServiceRequestPicklistCategoriesResponse {
    includeExcludeFilterCategories?: IncludeExcludeFilterCategory[] | undefined;

    constructor(data?: IServiceRequestPicklistCategoriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["includeExcludeFilterCategories"])) {
                this.includeExcludeFilterCategories = [] as any;
                for (let item of _data["includeExcludeFilterCategories"])
                    this.includeExcludeFilterCategories!.push(IncludeExcludeFilterCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceRequestPicklistCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestPicklistCategoriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.includeExcludeFilterCategories)) {
            data["includeExcludeFilterCategories"] = [];
            for (let item of this.includeExcludeFilterCategories)
                data["includeExcludeFilterCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IServiceRequestPicklistCategoriesResponse {
    includeExcludeFilterCategories?: IncludeExcludeFilterCategory[] | undefined;
}

export class ServiceRequestSearchQuery implements IServiceRequestSearchQuery {
    accountIds?: number[] | undefined;
    searchTerm?: string | undefined;
    termFilters?: { [key: string]: string[]; } | undefined;
    dateFilters?: { [key: string]: ServiceRequestDateFilter; } | undefined;
    mustNotTermFilters?: { [key: string]: string[]; } | undefined;
    contractStatusInclude?: string[] | undefined;
    contractStatusExclude?: string[] | undefined;
    sortBy?: string | undefined;
    sortDirection?: SortDirection;
    resultsFrom?: number;
    pageSize?: number;
    afterKey?: string | undefined;

    constructor(data?: IServiceRequestSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            this.searchTerm = _data["searchTerm"];
            if (_data["termFilters"]) {
                this.termFilters = {} as any;
                for (let key in _data["termFilters"]) {
                    if (_data["termFilters"].hasOwnProperty(key))
                        (this.termFilters as any)![key] = _data["termFilters"][key] !== undefined ? _data["termFilters"][key] : [];
                }
            }
            if (_data["dateFilters"]) {
                this.dateFilters = {} as any;
                for (let key in _data["dateFilters"]) {
                    if (_data["dateFilters"].hasOwnProperty(key))
                        (this.dateFilters as any)![key] = _data["dateFilters"][key] ? ServiceRequestDateFilter.fromJS(_data["dateFilters"][key]) : new ServiceRequestDateFilter();
                }
            }
            if (_data["mustNotTermFilters"]) {
                this.mustNotTermFilters = {} as any;
                for (let key in _data["mustNotTermFilters"]) {
                    if (_data["mustNotTermFilters"].hasOwnProperty(key))
                        (this.mustNotTermFilters as any)![key] = _data["mustNotTermFilters"][key] !== undefined ? _data["mustNotTermFilters"][key] : [];
                }
            }
            if (Array.isArray(_data["contractStatusInclude"])) {
                this.contractStatusInclude = [] as any;
                for (let item of _data["contractStatusInclude"])
                    this.contractStatusInclude!.push(item);
            }
            if (Array.isArray(_data["contractStatusExclude"])) {
                this.contractStatusExclude = [] as any;
                for (let item of _data["contractStatusExclude"])
                    this.contractStatusExclude!.push(item);
            }
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.resultsFrom = _data["resultsFrom"];
            this.pageSize = _data["pageSize"];
            this.afterKey = _data["afterKey"];
        }
    }

    static fromJS(data: any): ServiceRequestSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        data["searchTerm"] = this.searchTerm;
        if (this.termFilters) {
            data["termFilters"] = {};
            for (let key in this.termFilters) {
                if (this.termFilters.hasOwnProperty(key))
                    (data["termFilters"] as any)[key] = (this.termFilters as any)[key];
            }
        }
        if (this.dateFilters) {
            data["dateFilters"] = {};
            for (let key in this.dateFilters) {
                if (this.dateFilters.hasOwnProperty(key))
                    (data["dateFilters"] as any)[key] = this.dateFilters[key] ? this.dateFilters[key].toJSON() : undefined as any;
            }
        }
        if (this.mustNotTermFilters) {
            data["mustNotTermFilters"] = {};
            for (let key in this.mustNotTermFilters) {
                if (this.mustNotTermFilters.hasOwnProperty(key))
                    (data["mustNotTermFilters"] as any)[key] = (this.mustNotTermFilters as any)[key];
            }
        }
        if (Array.isArray(this.contractStatusInclude)) {
            data["contractStatusInclude"] = [];
            for (let item of this.contractStatusInclude)
                data["contractStatusInclude"].push(item);
        }
        if (Array.isArray(this.contractStatusExclude)) {
            data["contractStatusExclude"] = [];
            for (let item of this.contractStatusExclude)
                data["contractStatusExclude"].push(item);
        }
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["resultsFrom"] = this.resultsFrom;
        data["pageSize"] = this.pageSize;
        data["afterKey"] = this.afterKey;
        return data;
    }
}

export interface IServiceRequestSearchQuery {
    accountIds?: number[] | undefined;
    searchTerm?: string | undefined;
    termFilters?: { [key: string]: string[]; } | undefined;
    dateFilters?: { [key: string]: ServiceRequestDateFilter; } | undefined;
    mustNotTermFilters?: { [key: string]: string[]; } | undefined;
    contractStatusInclude?: string[] | undefined;
    contractStatusExclude?: string[] | undefined;
    sortBy?: string | undefined;
    sortDirection?: SortDirection;
    resultsFrom?: number;
    pageSize?: number;
    afterKey?: string | undefined;
}

export class ServiceRequestSubIssueRankingDto implements IServiceRequestSubIssueRankingDto {
    subIssueRankings?: { [key: string]: number; } | undefined;
    totalRecords?: number;

    constructor(data?: IServiceRequestSubIssueRankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["subIssueRankings"]) {
                this.subIssueRankings = {} as any;
                for (let key in _data["subIssueRankings"]) {
                    if (_data["subIssueRankings"].hasOwnProperty(key))
                        (this.subIssueRankings as any)![key] = _data["subIssueRankings"][key];
                }
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): ServiceRequestSubIssueRankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestSubIssueRankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.subIssueRankings) {
            data["subIssueRankings"] = {};
            for (let key in this.subIssueRankings) {
                if (this.subIssueRankings.hasOwnProperty(key))
                    (data["subIssueRankings"] as any)[key] = (this.subIssueRankings as any)[key];
            }
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface IServiceRequestSubIssueRankingDto {
    subIssueRankings?: { [key: string]: number; } | undefined;
    totalRecords?: number;
}

export class ServiceRequestTabCountsDto implements IServiceRequestTabCountsDto {
    counts?: { [key: string]: number; } | undefined;

    constructor(data?: IServiceRequestTabCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["counts"]) {
                this.counts = {} as any;
                for (let key in _data["counts"]) {
                    if (_data["counts"].hasOwnProperty(key))
                        (this.counts as any)![key] = _data["counts"][key];
                }
            }
        }
    }

    static fromJS(data: any): ServiceRequestTabCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestTabCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.counts) {
            data["counts"] = {};
            for (let key in this.counts) {
                if (this.counts.hasOwnProperty(key))
                    (data["counts"] as any)[key] = (this.counts as any)[key];
            }
        }
        return data;
    }
}

export interface IServiceRequestTabCountsDto {
    counts?: { [key: string]: number; } | undefined;
}

export class ServiceRequestVisualsDto implements IServiceRequestVisualsDto {
    visuals?: { [key: string]: { [key: string]: number; }; } | undefined;

    constructor(data?: IServiceRequestVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["visuals"]) {
                this.visuals = {} as any;
                for (let key in _data["visuals"]) {
                    if (_data["visuals"].hasOwnProperty(key))
                        (this.visuals as any)![key] = _data["visuals"][key] !== undefined ? _data["visuals"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): ServiceRequestVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.visuals) {
            data["visuals"] = {};
            for (let key in this.visuals) {
                if (this.visuals.hasOwnProperty(key))
                    (data["visuals"] as any)[key] = (this.visuals as any)[key];
            }
        }
        return data;
    }
}

export interface IServiceRequestVisualsDto {
    visuals?: { [key: string]: { [key: string]: number; }; } | undefined;
}

export class SlaByPriorityBucket implements ISlaByPriorityBucket {
    priority!: string | undefined;
    totalCount?: number;
    metCount?: number;
    notMetCount?: number;
    metPercentage?: number;

    constructor(data?: ISlaByPriorityBucket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"];
            this.totalCount = _data["totalCount"];
            this.metCount = _data["metCount"];
            this.notMetCount = _data["notMetCount"];
            this.metPercentage = _data["metPercentage"];
        }
    }

    static fromJS(data: any): SlaByPriorityBucket {
        data = typeof data === 'object' ? data : {};
        let result = new SlaByPriorityBucket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority;
        data["totalCount"] = this.totalCount;
        data["metCount"] = this.metCount;
        data["notMetCount"] = this.notMetCount;
        data["metPercentage"] = this.metPercentage;
        return data;
    }
}

export interface ISlaByPriorityBucket {
    priority: string | undefined;
    totalCount?: number;
    metCount?: number;
    notMetCount?: number;
    metPercentage?: number;
}

export class SlaByPriorityDto implements ISlaByPriorityDto {
    buckets?: SlaByPriorityBucket[] | undefined;

    constructor(data?: ISlaByPriorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buckets"])) {
                this.buckets = [] as any;
                for (let item of _data["buckets"])
                    this.buckets!.push(SlaByPriorityBucket.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlaByPriorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaByPriorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buckets)) {
            data["buckets"] = [];
            for (let item of this.buckets)
                data["buckets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISlaByPriorityDto {
    buckets?: SlaByPriorityBucket[] | undefined;
}

export enum SortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export class SupportOverviewDto implements ISupportOverviewDto {
    totalRequests?: number | undefined;
    totalOpenRequests?: number;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;
    vendorResolvedCount?: number | undefined;
    internallyResolvedCount?: number | undefined;
    earliestCreatedDate?: Date | undefined;
    latestCreatedDate?: Date | undefined;

    constructor(data?: ISupportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRequests = _data["totalRequests"];
            this.totalOpenRequests = _data["totalOpenRequests"];
            this.totalBillingHours = _data["totalBillingHours"];
            this.totalBillingAmount = _data["totalBillingAmount"];
            this.vendorResolvedCount = _data["vendorResolvedCount"];
            this.internallyResolvedCount = _data["internallyResolvedCount"];
            this.earliestCreatedDate = _data["earliestCreatedDate"] ? new Date(_data["earliestCreatedDate"].toString()) : undefined as any;
            this.latestCreatedDate = _data["latestCreatedDate"] ? new Date(_data["latestCreatedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SupportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRequests"] = this.totalRequests;
        data["totalOpenRequests"] = this.totalOpenRequests;
        data["totalBillingHours"] = this.totalBillingHours;
        data["totalBillingAmount"] = this.totalBillingAmount;
        data["vendorResolvedCount"] = this.vendorResolvedCount;
        data["internallyResolvedCount"] = this.internallyResolvedCount;
        data["earliestCreatedDate"] = this.earliestCreatedDate ? this.earliestCreatedDate.toISOString() : undefined as any;
        data["latestCreatedDate"] = this.latestCreatedDate ? this.latestCreatedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISupportOverviewDto {
    totalRequests?: number | undefined;
    totalOpenRequests?: number;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;
    vendorResolvedCount?: number | undefined;
    internallyResolvedCount?: number | undefined;
    earliestCreatedDate?: Date | undefined;
    latestCreatedDate?: Date | undefined;
}

export class SurveyMetricsResponse implements ISurveyMetricsResponse {
    metrics!: RequestMetricsVisualsDto;
    submissions!: SurveySubmissionDto[] | undefined;
    totalSubmissionCount?: number;

    constructor(data?: ISurveyMetricsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.metrics = new RequestMetricsVisualsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metrics = _data["metrics"] ? RequestMetricsVisualsDto.fromJS(_data["metrics"]) : new RequestMetricsVisualsDto();
            if (Array.isArray(_data["submissions"])) {
                this.submissions = [] as any;
                for (let item of _data["submissions"])
                    this.submissions!.push(SurveySubmissionDto.fromJS(item));
            }
            this.totalSubmissionCount = _data["totalSubmissionCount"];
        }
    }

    static fromJS(data: any): SurveyMetricsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyMetricsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metrics"] = this.metrics ? this.metrics.toJSON() : undefined as any;
        if (Array.isArray(this.submissions)) {
            data["submissions"] = [];
            for (let item of this.submissions)
                data["submissions"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalSubmissionCount"] = this.totalSubmissionCount;
        return data;
    }
}

export interface ISurveyMetricsResponse {
    metrics: RequestMetricsVisualsDto;
    submissions: SurveySubmissionDto[] | undefined;
    totalSubmissionCount?: number;
}

export class SurveySubmissionDto implements ISurveySubmissionDto {
    serviceRequestId?: number;
    requestIdentifier?: string | undefined;
    title?: string | undefined;
    createdBy?: string | undefined;
    completedDate?: Date;
    surveyRating?: number | undefined;

    constructor(data?: ISurveySubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"];
            this.requestIdentifier = _data["requestIdentifier"];
            this.title = _data["title"];
            this.createdBy = _data["createdBy"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined as any;
            this.surveyRating = _data["surveyRating"];
        }
    }

    static fromJS(data: any): SurveySubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveySubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId;
        data["requestIdentifier"] = this.requestIdentifier;
        data["title"] = this.title;
        data["createdBy"] = this.createdBy;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        data["surveyRating"] = this.surveyRating;
        return data;
    }
}

export interface ISurveySubmissionDto {
    serviceRequestId?: number;
    requestIdentifier?: string | undefined;
    title?: string | undefined;
    createdBy?: string | undefined;
    completedDate?: Date;
    surveyRating?: number | undefined;
}

export class UniqueFilterValuesDto implements IUniqueFilterValuesDto {
    uniqueCreatedByValues?: string[] | undefined;
    uniqueAssignedToValues?: string[] | undefined;
    uniquePriorityValues?: string[] | undefined;
    uniqueSourceValues?: string[] | undefined;
    uniqueCategoryValues?: string[] | undefined;
    uniqueRequestTypeValues?: string[] | undefined;
    uniqueIssueTypeValues?: string[] | undefined;
    uniqueStatusValues?: string[] | undefined;
    uniqueContractValues?: string[] | undefined;
    uniqueTicketNumberValues?: string[] | undefined;

    constructor(data?: IUniqueFilterValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniqueCreatedByValues"])) {
                this.uniqueCreatedByValues = [] as any;
                for (let item of _data["uniqueCreatedByValues"])
                    this.uniqueCreatedByValues!.push(item);
            }
            if (Array.isArray(_data["uniqueAssignedToValues"])) {
                this.uniqueAssignedToValues = [] as any;
                for (let item of _data["uniqueAssignedToValues"])
                    this.uniqueAssignedToValues!.push(item);
            }
            if (Array.isArray(_data["uniquePriorityValues"])) {
                this.uniquePriorityValues = [] as any;
                for (let item of _data["uniquePriorityValues"])
                    this.uniquePriorityValues!.push(item);
            }
            if (Array.isArray(_data["uniqueSourceValues"])) {
                this.uniqueSourceValues = [] as any;
                for (let item of _data["uniqueSourceValues"])
                    this.uniqueSourceValues!.push(item);
            }
            if (Array.isArray(_data["uniqueCategoryValues"])) {
                this.uniqueCategoryValues = [] as any;
                for (let item of _data["uniqueCategoryValues"])
                    this.uniqueCategoryValues!.push(item);
            }
            if (Array.isArray(_data["uniqueRequestTypeValues"])) {
                this.uniqueRequestTypeValues = [] as any;
                for (let item of _data["uniqueRequestTypeValues"])
                    this.uniqueRequestTypeValues!.push(item);
            }
            if (Array.isArray(_data["uniqueIssueTypeValues"])) {
                this.uniqueIssueTypeValues = [] as any;
                for (let item of _data["uniqueIssueTypeValues"])
                    this.uniqueIssueTypeValues!.push(item);
            }
            if (Array.isArray(_data["uniqueStatusValues"])) {
                this.uniqueStatusValues = [] as any;
                for (let item of _data["uniqueStatusValues"])
                    this.uniqueStatusValues!.push(item);
            }
            if (Array.isArray(_data["uniqueContractValues"])) {
                this.uniqueContractValues = [] as any;
                for (let item of _data["uniqueContractValues"])
                    this.uniqueContractValues!.push(item);
            }
            if (Array.isArray(_data["uniqueTicketNumberValues"])) {
                this.uniqueTicketNumberValues = [] as any;
                for (let item of _data["uniqueTicketNumberValues"])
                    this.uniqueTicketNumberValues!.push(item);
            }
        }
    }

    static fromJS(data: any): UniqueFilterValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UniqueFilterValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniqueCreatedByValues)) {
            data["uniqueCreatedByValues"] = [];
            for (let item of this.uniqueCreatedByValues)
                data["uniqueCreatedByValues"].push(item);
        }
        if (Array.isArray(this.uniqueAssignedToValues)) {
            data["uniqueAssignedToValues"] = [];
            for (let item of this.uniqueAssignedToValues)
                data["uniqueAssignedToValues"].push(item);
        }
        if (Array.isArray(this.uniquePriorityValues)) {
            data["uniquePriorityValues"] = [];
            for (let item of this.uniquePriorityValues)
                data["uniquePriorityValues"].push(item);
        }
        if (Array.isArray(this.uniqueSourceValues)) {
            data["uniqueSourceValues"] = [];
            for (let item of this.uniqueSourceValues)
                data["uniqueSourceValues"].push(item);
        }
        if (Array.isArray(this.uniqueCategoryValues)) {
            data["uniqueCategoryValues"] = [];
            for (let item of this.uniqueCategoryValues)
                data["uniqueCategoryValues"].push(item);
        }
        if (Array.isArray(this.uniqueRequestTypeValues)) {
            data["uniqueRequestTypeValues"] = [];
            for (let item of this.uniqueRequestTypeValues)
                data["uniqueRequestTypeValues"].push(item);
        }
        if (Array.isArray(this.uniqueIssueTypeValues)) {
            data["uniqueIssueTypeValues"] = [];
            for (let item of this.uniqueIssueTypeValues)
                data["uniqueIssueTypeValues"].push(item);
        }
        if (Array.isArray(this.uniqueStatusValues)) {
            data["uniqueStatusValues"] = [];
            for (let item of this.uniqueStatusValues)
                data["uniqueStatusValues"].push(item);
        }
        if (Array.isArray(this.uniqueContractValues)) {
            data["uniqueContractValues"] = [];
            for (let item of this.uniqueContractValues)
                data["uniqueContractValues"].push(item);
        }
        if (Array.isArray(this.uniqueTicketNumberValues)) {
            data["uniqueTicketNumberValues"] = [];
            for (let item of this.uniqueTicketNumberValues)
                data["uniqueTicketNumberValues"].push(item);
        }
        return data;
    }
}

export interface IUniqueFilterValuesDto {
    uniqueCreatedByValues?: string[] | undefined;
    uniqueAssignedToValues?: string[] | undefined;
    uniquePriorityValues?: string[] | undefined;
    uniqueSourceValues?: string[] | undefined;
    uniqueCategoryValues?: string[] | undefined;
    uniqueRequestTypeValues?: string[] | undefined;
    uniqueIssueTypeValues?: string[] | undefined;
    uniqueStatusValues?: string[] | undefined;
    uniqueContractValues?: string[] | undefined;
    uniqueTicketNumberValues?: string[] | undefined;
}

export class MicrosoftInsightsReportStatusDto implements IMicrosoftInsightsReportStatusDto {
    isComplete?: boolean;

    constructor(data?: IMicrosoftInsightsReportStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplete = _data["isComplete"];
        }
    }

    static fromJS(data: any): MicrosoftInsightsReportStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftInsightsReportStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplete"] = this.isComplete;
        return data;
    }
}

export interface IMicrosoftInsightsReportStatusDto {
    isComplete?: boolean;
}

export class AddManufacturerRequest implements IAddManufacturerRequest {
    biManufacturerId?: string | undefined;

    constructor(data?: IAddManufacturerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biManufacturerId = _data["biManufacturerId"];
        }
    }

    static fromJS(data: any): AddManufacturerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddManufacturerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biManufacturerId"] = this.biManufacturerId;
        return data;
    }
}

export interface IAddManufacturerRequest {
    biManufacturerId?: string | undefined;
}

export class DismissManufacturerCapabilityRequest implements IDismissManufacturerCapabilityRequest {
    biManufacturerId?: string | undefined;
    capabilityId?: string | undefined;

    constructor(data?: IDismissManufacturerCapabilityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biManufacturerId = _data["biManufacturerId"];
            this.capabilityId = _data["capabilityId"];
        }
    }

    static fromJS(data: any): DismissManufacturerCapabilityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DismissManufacturerCapabilityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biManufacturerId"] = this.biManufacturerId;
        data["capabilityId"] = this.capabilityId;
        return data;
    }
}

export interface IDismissManufacturerCapabilityRequest {
    biManufacturerId?: string | undefined;
    capabilityId?: string | undefined;
}

export class DismissManufacturerInsightRequest implements IDismissManufacturerInsightRequest {
    biManufacturerId?: string | undefined;
    insightId?: string | undefined;

    constructor(data?: IDismissManufacturerInsightRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biManufacturerId = _data["biManufacturerId"];
            this.insightId = _data["insightId"];
        }
    }

    static fromJS(data: any): DismissManufacturerInsightRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DismissManufacturerInsightRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biManufacturerId"] = this.biManufacturerId;
        data["insightId"] = this.insightId;
        return data;
    }
}

export interface IDismissManufacturerInsightRequest {
    biManufacturerId?: string | undefined;
    insightId?: string | undefined;
}

export enum EnabledManufacturersStatus {
    Found = "Found",
    Unavailable = "Unavailable",
}

export class GetEnabledManufacturersResponse implements IGetEnabledManufacturersResponse {
    status?: EnabledManufacturersStatus;
    enabledManufacturers?: EnabledManufacturer[] | undefined;

    constructor(data?: IGetEnabledManufacturersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["enabledManufacturers"])) {
                this.enabledManufacturers = [] as any;
                for (let item of _data["enabledManufacturers"])
                    this.enabledManufacturers!.push(EnabledManufacturer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEnabledManufacturersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEnabledManufacturersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.enabledManufacturers)) {
            data["enabledManufacturers"] = [];
            for (let item of this.enabledManufacturers)
                data["enabledManufacturers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetEnabledManufacturersResponse {
    status?: EnabledManufacturersStatus;
    enabledManufacturers?: EnabledManufacturer[] | undefined;
}

export class GetManufacturerAssetQuantityResponse implements IGetManufacturerAssetQuantityResponse {
    quantity?: number;

    constructor(data?: IGetManufacturerAssetQuantityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): GetManufacturerAssetQuantityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerAssetQuantityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IGetManufacturerAssetQuantityResponse {
    quantity?: number;
}

export class GetManufacturerCapabilitiesBatchRequest implements IGetManufacturerCapabilitiesBatchRequest {
    manufacturerBiIds?: string[] | undefined;

    constructor(data?: IGetManufacturerCapabilitiesBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturerBiIds"])) {
                this.manufacturerBiIds = [] as any;
                for (let item of _data["manufacturerBiIds"])
                    this.manufacturerBiIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetManufacturerCapabilitiesBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerCapabilitiesBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturerBiIds)) {
            data["manufacturerBiIds"] = [];
            for (let item of this.manufacturerBiIds)
                data["manufacturerBiIds"].push(item);
        }
        return data;
    }
}

export interface IGetManufacturerCapabilitiesBatchRequest {
    manufacturerBiIds?: string[] | undefined;
}

export class GetManufacturerCapabilitiesBatchResponse implements IGetManufacturerCapabilitiesBatchResponse {
    manufacturers?: ManufacturerCapabilitiesResult[] | undefined;

    constructor(data?: IGetManufacturerCapabilitiesBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(ManufacturerCapabilitiesResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturerCapabilitiesBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerCapabilitiesBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetManufacturerCapabilitiesBatchResponse {
    manufacturers?: ManufacturerCapabilitiesResult[] | undefined;
}

export class GetManufacturerEolProductsResponse implements IGetManufacturerEolProductsResponse {
    status?: ManufacturerEolStatus;
    products?: ManufacturerEolProduct[] | undefined;
    failureCorrelationId?: string | undefined;

    constructor(data?: IGetManufacturerEolProductsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ManufacturerEolProduct.fromJS(item));
            }
            this.failureCorrelationId = _data["failureCorrelationId"];
        }
    }

    static fromJS(data: any): GetManufacturerEolProductsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerEolProductsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        data["failureCorrelationId"] = this.failureCorrelationId;
        return data;
    }
}

export interface IGetManufacturerEolProductsResponse {
    status?: ManufacturerEolStatus;
    products?: ManufacturerEolProduct[] | undefined;
    failureCorrelationId?: string | undefined;
}

export class GetManufacturerInsightsBatchRequest implements IGetManufacturerInsightsBatchRequest {
    manufacturerBiIds?: string[] | undefined;

    constructor(data?: IGetManufacturerInsightsBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturerBiIds"])) {
                this.manufacturerBiIds = [] as any;
                for (let item of _data["manufacturerBiIds"])
                    this.manufacturerBiIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetManufacturerInsightsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerInsightsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturerBiIds)) {
            data["manufacturerBiIds"] = [];
            for (let item of this.manufacturerBiIds)
                data["manufacturerBiIds"].push(item);
        }
        return data;
    }
}

export interface IGetManufacturerInsightsBatchRequest {
    manufacturerBiIds?: string[] | undefined;
}

export class GetManufacturerInsightsBatchResponse implements IGetManufacturerInsightsBatchResponse {
    manufacturers?: ManufacturerInsightsResult[] | undefined;

    constructor(data?: IGetManufacturerInsightsBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(ManufacturerInsightsResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturerInsightsBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerInsightsBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetManufacturerInsightsBatchResponse {
    manufacturers?: ManufacturerInsightsResult[] | undefined;
}

export class GetManufacturerInsightsResponse implements IGetManufacturerInsightsResponse {
    status?: ManufacturerInsightsStatus;
    insights?: ManufacturerInsights;
    retrievedAt?: Date | undefined;
    isStale?: boolean;
    failureCorrelationId?: string | undefined;

    constructor(data?: IGetManufacturerInsightsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.insights = _data["insights"] ? ManufacturerInsights.fromJS(_data["insights"]) : undefined as any;
            this.retrievedAt = _data["retrievedAt"] ? new Date(_data["retrievedAt"].toString()) : undefined as any;
            this.isStale = _data["isStale"];
            this.failureCorrelationId = _data["failureCorrelationId"];
        }
    }

    static fromJS(data: any): GetManufacturerInsightsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerInsightsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["insights"] = this.insights ? this.insights.toJSON() : undefined as any;
        data["retrievedAt"] = this.retrievedAt ? this.retrievedAt.toISOString() : undefined as any;
        data["isStale"] = this.isStale;
        data["failureCorrelationId"] = this.failureCorrelationId;
        return data;
    }
}

export interface IGetManufacturerInsightsResponse {
    status?: ManufacturerInsightsStatus;
    insights?: ManufacturerInsights;
    retrievedAt?: Date | undefined;
    isStale?: boolean;
    failureCorrelationId?: string | undefined;
}

export class GetManufacturerLifecycleEventsResponse implements IGetManufacturerLifecycleEventsResponse {
    renewals?: ManufacturerLifecycleEvent[] | undefined;
    refreshes?: ManufacturerLifecycleEvent[] | undefined;

    constructor(data?: IGetManufacturerLifecycleEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["renewals"])) {
                this.renewals = [] as any;
                for (let item of _data["renewals"])
                    this.renewals!.push(ManufacturerLifecycleEvent.fromJS(item));
            }
            if (Array.isArray(_data["refreshes"])) {
                this.refreshes = [] as any;
                for (let item of _data["refreshes"])
                    this.refreshes!.push(ManufacturerLifecycleEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturerLifecycleEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerLifecycleEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.renewals)) {
            data["renewals"] = [];
            for (let item of this.renewals)
                data["renewals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.refreshes)) {
            data["refreshes"] = [];
            for (let item of this.refreshes)
                data["refreshes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetManufacturerLifecycleEventsResponse {
    renewals?: ManufacturerLifecycleEvent[] | undefined;
    refreshes?: ManufacturerLifecycleEvent[] | undefined;
}

export class GetManufacturerMonthlySpendHistoryResponse implements IGetManufacturerMonthlySpendHistoryResponse {
    spendHistory?: BiManufacturerMonthlySpendHistory[] | undefined;

    constructor(data?: IGetManufacturerMonthlySpendHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["spendHistory"])) {
                this.spendHistory = [] as any;
                for (let item of _data["spendHistory"])
                    this.spendHistory!.push(BiManufacturerMonthlySpendHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturerMonthlySpendHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerMonthlySpendHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.spendHistory)) {
            data["spendHistory"] = [];
            for (let item of this.spendHistory)
                data["spendHistory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetManufacturerMonthlySpendHistoryResponse {
    spendHistory?: BiManufacturerMonthlySpendHistory[] | undefined;
}

export class GetManufacturerNextEventsResponse implements IGetManufacturerNextEventsResponse {
    manufacturers?: ManufacturerNextEventsGroup[] | undefined;

    constructor(data?: IGetManufacturerNextEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(ManufacturerNextEventsGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturerNextEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerNextEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetManufacturerNextEventsResponse {
    manufacturers?: ManufacturerNextEventsGroup[] | undefined;
}

export class GetManufacturerRevenueTrendsBatchRequest implements IGetManufacturerRevenueTrendsBatchRequest {
    manufacturerBiIds?: string[] | undefined;

    constructor(data?: IGetManufacturerRevenueTrendsBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturerBiIds"])) {
                this.manufacturerBiIds = [] as any;
                for (let item of _data["manufacturerBiIds"])
                    this.manufacturerBiIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetManufacturerRevenueTrendsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerRevenueTrendsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturerBiIds)) {
            data["manufacturerBiIds"] = [];
            for (let item of this.manufacturerBiIds)
                data["manufacturerBiIds"].push(item);
        }
        return data;
    }
}

export interface IGetManufacturerRevenueTrendsBatchRequest {
    manufacturerBiIds?: string[] | undefined;
}

export class GetManufacturerRevenueTrendsBatchResponse implements IGetManufacturerRevenueTrendsBatchResponse {
    manufacturers?: ManufacturerRevenueTrendResult[] | undefined;

    constructor(data?: IGetManufacturerRevenueTrendsBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(ManufacturerRevenueTrendResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturerRevenueTrendsBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerRevenueTrendsBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetManufacturerRevenueTrendsBatchResponse {
    manufacturers?: ManufacturerRevenueTrendResult[] | undefined;
}

export class GetManufacturerSpendForecastResponse implements IGetManufacturerSpendForecastResponse {
    spendForecast?: BiManufacturerSpendForecast[] | undefined;

    constructor(data?: IGetManufacturerSpendForecastResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["spendForecast"])) {
                this.spendForecast = [] as any;
                for (let item of _data["spendForecast"])
                    this.spendForecast!.push(BiManufacturerSpendForecast.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturerSpendForecastResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerSpendForecastResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.spendForecast)) {
            data["spendForecast"] = [];
            for (let item of this.spendForecast)
                data["spendForecast"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetManufacturerSpendForecastResponse {
    spendForecast?: BiManufacturerSpendForecast[] | undefined;
}

export class GetManufacturerSpendHistoryResponse implements IGetManufacturerSpendHistoryResponse {
    spendHistory?: BiManufacturerSpendHistory[] | undefined;

    constructor(data?: IGetManufacturerSpendHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["spendHistory"])) {
                this.spendHistory = [] as any;
                for (let item of _data["spendHistory"])
                    this.spendHistory!.push(BiManufacturerSpendHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturerSpendHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerSpendHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.spendHistory)) {
            data["spendHistory"] = [];
            for (let item of this.spendHistory)
                data["spendHistory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetManufacturerSpendHistoryResponse {
    spendHistory?: BiManufacturerSpendHistory[] | undefined;
}

export class GetManufacturerSpendTotalsResponse implements IGetManufacturerSpendTotalsResponse {
    spendTotals?: BiManufacturerSpendTotal[] | undefined;

    constructor(data?: IGetManufacturerSpendTotalsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["spendTotals"])) {
                this.spendTotals = [] as any;
                for (let item of _data["spendTotals"])
                    this.spendTotals!.push(BiManufacturerSpendTotal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturerSpendTotalsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerSpendTotalsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.spendTotals)) {
            data["spendTotals"] = [];
            for (let item of this.spendTotals)
                data["spendTotals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetManufacturerSpendTotalsResponse {
    spendTotals?: BiManufacturerSpendTotal[] | undefined;
}

export class GetManufacturerUpcomingSummaryResponse implements IGetManufacturerUpcomingSummaryResponse {
    renewals?: ManufacturerUpcomingEventTotals;
    refreshes?: ManufacturerUpcomingEventTotals;
    billing?: ManufacturerUpcomingEventTotals;

    constructor(data?: IGetManufacturerUpcomingSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.renewals = _data["renewals"] ? ManufacturerUpcomingEventTotals.fromJS(_data["renewals"]) : undefined as any;
            this.refreshes = _data["refreshes"] ? ManufacturerUpcomingEventTotals.fromJS(_data["refreshes"]) : undefined as any;
            this.billing = _data["billing"] ? ManufacturerUpcomingEventTotals.fromJS(_data["billing"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetManufacturerUpcomingSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerUpcomingSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renewals"] = this.renewals ? this.renewals.toJSON() : undefined as any;
        data["refreshes"] = this.refreshes ? this.refreshes.toJSON() : undefined as any;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetManufacturerUpcomingSummaryResponse {
    renewals?: ManufacturerUpcomingEventTotals;
    refreshes?: ManufacturerUpcomingEventTotals;
    billing?: ManufacturerUpcomingEventTotals;
}

export class ManufacturerCapabilitiesResult implements IManufacturerCapabilitiesResult {
    manufacturerBiId?: string | undefined;
    status?: ManufacturerCapabilitiesStatus;
    capabilities?: ManufacturerCapabilityItem[] | undefined;
    failureCorrelationId?: string | undefined;

    constructor(data?: IManufacturerCapabilitiesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerBiId = _data["manufacturerBiId"];
            this.status = _data["status"];
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(ManufacturerCapabilityItem.fromJS(item));
            }
            this.failureCorrelationId = _data["failureCorrelationId"];
        }
    }

    static fromJS(data: any): ManufacturerCapabilitiesResult {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerCapabilitiesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerBiId"] = this.manufacturerBiId;
        data["status"] = this.status;
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item ? item.toJSON() : undefined as any);
        }
        data["failureCorrelationId"] = this.failureCorrelationId;
        return data;
    }
}

export interface IManufacturerCapabilitiesResult {
    manufacturerBiId?: string | undefined;
    status?: ManufacturerCapabilitiesStatus;
    capabilities?: ManufacturerCapabilityItem[] | undefined;
    failureCorrelationId?: string | undefined;
}

export enum ManufacturerCapabilitiesStatus {
    Found = "Found",
    Unavailable = "Unavailable",
}

export class ManufacturerCapabilityItem implements IManufacturerCapabilityItem {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    recommendedActions?: string[] | undefined;
    datePosted?: Date | undefined;
    dateExpiring?: Date | undefined;
    contactEmails?: string[] | undefined;
    labUniqueId?: string | undefined;

    constructor(data?: IManufacturerCapabilityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            if (Array.isArray(_data["recommendedActions"])) {
                this.recommendedActions = [] as any;
                for (let item of _data["recommendedActions"])
                    this.recommendedActions!.push(item);
            }
            this.datePosted = _data["datePosted"] ? new Date(_data["datePosted"].toString()) : undefined as any;
            this.dateExpiring = _data["dateExpiring"] ? new Date(_data["dateExpiring"].toString()) : undefined as any;
            if (Array.isArray(_data["contactEmails"])) {
                this.contactEmails = [] as any;
                for (let item of _data["contactEmails"])
                    this.contactEmails!.push(item);
            }
            this.labUniqueId = _data["labUniqueId"];
        }
    }

    static fromJS(data: any): ManufacturerCapabilityItem {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerCapabilityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        if (Array.isArray(this.recommendedActions)) {
            data["recommendedActions"] = [];
            for (let item of this.recommendedActions)
                data["recommendedActions"].push(item);
        }
        data["datePosted"] = this.datePosted ? formatDate(this.datePosted) : undefined as any;
        data["dateExpiring"] = this.dateExpiring ? formatDate(this.dateExpiring) : undefined as any;
        if (Array.isArray(this.contactEmails)) {
            data["contactEmails"] = [];
            for (let item of this.contactEmails)
                data["contactEmails"].push(item);
        }
        data["labUniqueId"] = this.labUniqueId;
        return data;
    }
}

export interface IManufacturerCapabilityItem {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    recommendedActions?: string[] | undefined;
    datePosted?: Date | undefined;
    dateExpiring?: Date | undefined;
    contactEmails?: string[] | undefined;
    labUniqueId?: string | undefined;
}

export class ManufacturerEolProduct implements IManufacturerEolProduct {
    manufacturerModelIdentifier?: string | undefined;
    replacementParts?: ReplacementPart[] | undefined;
    endOfSupportDate?: Date | undefined;

    constructor(data?: IManufacturerEolProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerModelIdentifier = _data["manufacturerModelIdentifier"];
            if (Array.isArray(_data["replacementParts"])) {
                this.replacementParts = [] as any;
                for (let item of _data["replacementParts"])
                    this.replacementParts!.push(ReplacementPart.fromJS(item));
            }
            this.endOfSupportDate = _data["endOfSupportDate"] ? new Date(_data["endOfSupportDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ManufacturerEolProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerEolProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerModelIdentifier"] = this.manufacturerModelIdentifier;
        if (Array.isArray(this.replacementParts)) {
            data["replacementParts"] = [];
            for (let item of this.replacementParts)
                data["replacementParts"].push(item ? item.toJSON() : undefined as any);
        }
        data["endOfSupportDate"] = this.endOfSupportDate ? formatDate(this.endOfSupportDate) : undefined as any;
        return data;
    }
}

export interface IManufacturerEolProduct {
    manufacturerModelIdentifier?: string | undefined;
    replacementParts?: ReplacementPart[] | undefined;
    endOfSupportDate?: Date | undefined;
}

export enum ManufacturerEolStatus {
    Found = "Found",
    NotFound = "NotFound",
    Unavailable = "Unavailable",
}

export class ManufacturerInsightsResult implements IManufacturerInsightsResult {
    manufacturerBiId?: string | undefined;
    status?: ManufacturerInsightsStatus;
    insights?: ManufacturerInsights;
    retrievedAt?: Date | undefined;
    isStale?: boolean;
    failureCorrelationId?: string | undefined;

    constructor(data?: IManufacturerInsightsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerBiId = _data["manufacturerBiId"];
            this.status = _data["status"];
            this.insights = _data["insights"] ? ManufacturerInsights.fromJS(_data["insights"]) : undefined as any;
            this.retrievedAt = _data["retrievedAt"] ? new Date(_data["retrievedAt"].toString()) : undefined as any;
            this.isStale = _data["isStale"];
            this.failureCorrelationId = _data["failureCorrelationId"];
        }
    }

    static fromJS(data: any): ManufacturerInsightsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerInsightsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerBiId"] = this.manufacturerBiId;
        data["status"] = this.status;
        data["insights"] = this.insights ? this.insights.toJSON() : undefined as any;
        data["retrievedAt"] = this.retrievedAt ? this.retrievedAt.toISOString() : undefined as any;
        data["isStale"] = this.isStale;
        data["failureCorrelationId"] = this.failureCorrelationId;
        return data;
    }
}

export interface IManufacturerInsightsResult {
    manufacturerBiId?: string | undefined;
    status?: ManufacturerInsightsStatus;
    insights?: ManufacturerInsights;
    retrievedAt?: Date | undefined;
    isStale?: boolean;
    failureCorrelationId?: string | undefined;
}

export enum ManufacturerInsightsStatus {
    Found = "Found",
    NotFound = "NotFound",
    Unavailable = "Unavailable",
}

export class ManufacturerLifecycleEvent implements IManufacturerLifecycleEvent {
    id?: string | undefined;
    manufacturer?: string | undefined;
    eventType?: string | undefined;
    eventDate?: string | undefined;
    status?: string | undefined;
    strategy?: string | undefined;
    productNames?: string[] | undefined;
    coveredItems?: number;
    previousPurchaseCost?: number | undefined;

    constructor(data?: IManufacturerLifecycleEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.manufacturer = _data["manufacturer"];
            this.eventType = _data["eventType"];
            this.eventDate = _data["eventDate"];
            this.status = _data["status"];
            this.strategy = _data["strategy"];
            if (Array.isArray(_data["productNames"])) {
                this.productNames = [] as any;
                for (let item of _data["productNames"])
                    this.productNames!.push(item);
            }
            this.coveredItems = _data["coveredItems"];
            this.previousPurchaseCost = _data["previousPurchaseCost"];
        }
    }

    static fromJS(data: any): ManufacturerLifecycleEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerLifecycleEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["manufacturer"] = this.manufacturer;
        data["eventType"] = this.eventType;
        data["eventDate"] = this.eventDate;
        data["status"] = this.status;
        data["strategy"] = this.strategy;
        if (Array.isArray(this.productNames)) {
            data["productNames"] = [];
            for (let item of this.productNames)
                data["productNames"].push(item);
        }
        data["coveredItems"] = this.coveredItems;
        data["previousPurchaseCost"] = this.previousPurchaseCost;
        return data;
    }
}

export interface IManufacturerLifecycleEvent {
    id?: string | undefined;
    manufacturer?: string | undefined;
    eventType?: string | undefined;
    eventDate?: string | undefined;
    status?: string | undefined;
    strategy?: string | undefined;
    productNames?: string[] | undefined;
    coveredItems?: number;
    previousPurchaseCost?: number | undefined;
}

export class ManufacturerNextEventsGroup implements IManufacturerNextEventsGroup {
    biManufacturerId?: string | undefined;
    displayName?: string | undefined;
    events?: ManufacturerLifecycleEvent[] | undefined;
    indexedManufacturerNames?: string[] | undefined;
    totalEventCount?: number;
    nextRenewalDate?: Date | undefined;
    nextRefreshDate?: Date | undefined;

    constructor(data?: IManufacturerNextEventsGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biManufacturerId = _data["biManufacturerId"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(ManufacturerLifecycleEvent.fromJS(item));
            }
            if (Array.isArray(_data["indexedManufacturerNames"])) {
                this.indexedManufacturerNames = [] as any;
                for (let item of _data["indexedManufacturerNames"])
                    this.indexedManufacturerNames!.push(item);
            }
            this.totalEventCount = _data["totalEventCount"];
            this.nextRenewalDate = _data["nextRenewalDate"] ? new Date(_data["nextRenewalDate"].toString()) : undefined as any;
            this.nextRefreshDate = _data["nextRefreshDate"] ? new Date(_data["nextRefreshDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ManufacturerNextEventsGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerNextEventsGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biManufacturerId"] = this.biManufacturerId;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.indexedManufacturerNames)) {
            data["indexedManufacturerNames"] = [];
            for (let item of this.indexedManufacturerNames)
                data["indexedManufacturerNames"].push(item);
        }
        data["totalEventCount"] = this.totalEventCount;
        data["nextRenewalDate"] = this.nextRenewalDate ? formatDate(this.nextRenewalDate) : undefined as any;
        data["nextRefreshDate"] = this.nextRefreshDate ? formatDate(this.nextRefreshDate) : undefined as any;
        return data;
    }
}

export interface IManufacturerNextEventsGroup {
    biManufacturerId?: string | undefined;
    displayName?: string | undefined;
    events?: ManufacturerLifecycleEvent[] | undefined;
    indexedManufacturerNames?: string[] | undefined;
    totalEventCount?: number;
    nextRenewalDate?: Date | undefined;
    nextRefreshDate?: Date | undefined;
}

export class ManufacturerRevenueTrendResult implements IManufacturerRevenueTrendResult {
    manufacturerBiId?: string | undefined;
    status?: ManufacturerRevenueTrendStatus;
    shiResaleRevenueHistory?: ShiResaleRevenueHistoryEntry[] | undefined;
    retrievedAt?: Date | undefined;
    isStale?: boolean;
    failureCorrelationId?: string | undefined;
    vendorPerformanceInsights?: ManufacturerVendorPerformanceInsights;
    category?: string | undefined;

    constructor(data?: IManufacturerRevenueTrendResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerBiId = _data["manufacturerBiId"];
            this.status = _data["status"];
            if (Array.isArray(_data["shiResaleRevenueHistory"])) {
                this.shiResaleRevenueHistory = [] as any;
                for (let item of _data["shiResaleRevenueHistory"])
                    this.shiResaleRevenueHistory!.push(ShiResaleRevenueHistoryEntry.fromJS(item));
            }
            this.retrievedAt = _data["retrievedAt"] ? new Date(_data["retrievedAt"].toString()) : undefined as any;
            this.isStale = _data["isStale"];
            this.failureCorrelationId = _data["failureCorrelationId"];
            this.vendorPerformanceInsights = _data["vendorPerformanceInsights"] ? ManufacturerVendorPerformanceInsights.fromJS(_data["vendorPerformanceInsights"]) : undefined as any;
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): ManufacturerRevenueTrendResult {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerRevenueTrendResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerBiId"] = this.manufacturerBiId;
        data["status"] = this.status;
        if (Array.isArray(this.shiResaleRevenueHistory)) {
            data["shiResaleRevenueHistory"] = [];
            for (let item of this.shiResaleRevenueHistory)
                data["shiResaleRevenueHistory"].push(item ? item.toJSON() : undefined as any);
        }
        data["retrievedAt"] = this.retrievedAt ? this.retrievedAt.toISOString() : undefined as any;
        data["isStale"] = this.isStale;
        data["failureCorrelationId"] = this.failureCorrelationId;
        data["vendorPerformanceInsights"] = this.vendorPerformanceInsights ? this.vendorPerformanceInsights.toJSON() : undefined as any;
        data["category"] = this.category;
        return data;
    }
}

export interface IManufacturerRevenueTrendResult {
    manufacturerBiId?: string | undefined;
    status?: ManufacturerRevenueTrendStatus;
    shiResaleRevenueHistory?: ShiResaleRevenueHistoryEntry[] | undefined;
    retrievedAt?: Date | undefined;
    isStale?: boolean;
    failureCorrelationId?: string | undefined;
    vendorPerformanceInsights?: ManufacturerVendorPerformanceInsights;
    category?: string | undefined;
}

export enum ManufacturerRevenueTrendStatus {
    Found = "Found",
    NotFound = "NotFound",
    Unavailable = "Unavailable",
}

export class BiManufacturerMonthlySpendHistory implements IBiManufacturerMonthlySpendHistory {
    biManufacturerId?: string | undefined;
    yearMonth?: string | undefined;
    amount?: number;

    constructor(data?: IBiManufacturerMonthlySpendHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biManufacturerId = _data["biManufacturerId"];
            this.yearMonth = _data["yearMonth"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): BiManufacturerMonthlySpendHistory {
        data = typeof data === 'object' ? data : {};
        let result = new BiManufacturerMonthlySpendHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biManufacturerId"] = this.biManufacturerId;
        data["yearMonth"] = this.yearMonth;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IBiManufacturerMonthlySpendHistory {
    biManufacturerId?: string | undefined;
    yearMonth?: string | undefined;
    amount?: number;
}

export class BiManufacturerSpendForecast implements IBiManufacturerSpendForecast {
    biManufacturerId?: string | undefined;
    amount?: number;

    constructor(data?: IBiManufacturerSpendForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biManufacturerId = _data["biManufacturerId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): BiManufacturerSpendForecast {
        data = typeof data === 'object' ? data : {};
        let result = new BiManufacturerSpendForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biManufacturerId"] = this.biManufacturerId;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IBiManufacturerSpendForecast {
    biManufacturerId?: string | undefined;
    amount?: number;
}

export class BiManufacturerSpendHistory implements IBiManufacturerSpendHistory {
    biManufacturerId?: string | undefined;
    year?: number;
    amount?: number;

    constructor(data?: IBiManufacturerSpendHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biManufacturerId = _data["biManufacturerId"];
            this.year = _data["year"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): BiManufacturerSpendHistory {
        data = typeof data === 'object' ? data : {};
        let result = new BiManufacturerSpendHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biManufacturerId"] = this.biManufacturerId;
        data["year"] = this.year;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IBiManufacturerSpendHistory {
    biManufacturerId?: string | undefined;
    year?: number;
    amount?: number;
}

export class BiManufacturerSpendTotal implements IBiManufacturerSpendTotal {
    biManufacturerId?: string | undefined;
    totalSpend?: number;

    constructor(data?: IBiManufacturerSpendTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biManufacturerId = _data["biManufacturerId"];
            this.totalSpend = _data["totalSpend"];
        }
    }

    static fromJS(data: any): BiManufacturerSpendTotal {
        data = typeof data === 'object' ? data : {};
        let result = new BiManufacturerSpendTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biManufacturerId"] = this.biManufacturerId;
        data["totalSpend"] = this.totalSpend;
        return data;
    }
}

export interface IBiManufacturerSpendTotal {
    biManufacturerId?: string | undefined;
    totalSpend?: number;
}

export class EnabledManufacturer implements IEnabledManufacturer {
    biManufacturerId?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IEnabledManufacturer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biManufacturerId = _data["biManufacturerId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EnabledManufacturer {
        data = typeof data === 'object' ? data : {};
        let result = new EnabledManufacturer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biManufacturerId"] = this.biManufacturerId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEnabledManufacturer {
    biManufacturerId?: string | undefined;
    displayName?: string | undefined;
}

export class ManufacturerInsights implements IManufacturerInsights {
    manufacturerBiId?: number;
    entries?: ManufacturerInsightsEntry[] | undefined;

    constructor(data?: IManufacturerInsights) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerBiId = _data["manufacturerBiId"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(ManufacturerInsightsEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManufacturerInsights {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerInsights();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerBiId"] = this.manufacturerBiId;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IManufacturerInsights {
    manufacturerBiId?: number;
    entries?: ManufacturerInsightsEntry[] | undefined;
}

export class ManufacturerInsightsEntry implements IManufacturerInsightsEntry {
    id?: string | undefined;
    title?: string | undefined;
    insightType?: string | undefined;
    description?: string | undefined;
    datePosted?: Date | undefined;
    dateExpiring?: Date | undefined;
    actionRequiredBy?: Date | undefined;
    recommendedActions?: string[] | undefined;
    contactEmail?: string | undefined;

    constructor(data?: IManufacturerInsightsEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.insightType = _data["insightType"];
            this.description = _data["description"];
            this.datePosted = _data["datePosted"] ? new Date(_data["datePosted"].toString()) : undefined as any;
            this.dateExpiring = _data["dateExpiring"] ? new Date(_data["dateExpiring"].toString()) : undefined as any;
            this.actionRequiredBy = _data["actionRequiredBy"] ? new Date(_data["actionRequiredBy"].toString()) : undefined as any;
            if (Array.isArray(_data["recommendedActions"])) {
                this.recommendedActions = [] as any;
                for (let item of _data["recommendedActions"])
                    this.recommendedActions!.push(item);
            }
            this.contactEmail = _data["contactEmail"];
        }
    }

    static fromJS(data: any): ManufacturerInsightsEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerInsightsEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["insightType"] = this.insightType;
        data["description"] = this.description;
        data["datePosted"] = this.datePosted ? formatDate(this.datePosted) : undefined as any;
        data["dateExpiring"] = this.dateExpiring ? formatDate(this.dateExpiring) : undefined as any;
        data["actionRequiredBy"] = this.actionRequiredBy ? formatDate(this.actionRequiredBy) : undefined as any;
        if (Array.isArray(this.recommendedActions)) {
            data["recommendedActions"] = [];
            for (let item of this.recommendedActions)
                data["recommendedActions"].push(item);
        }
        data["contactEmail"] = this.contactEmail;
        return data;
    }
}

export interface IManufacturerInsightsEntry {
    id?: string | undefined;
    title?: string | undefined;
    insightType?: string | undefined;
    description?: string | undefined;
    datePosted?: Date | undefined;
    dateExpiring?: Date | undefined;
    actionRequiredBy?: Date | undefined;
    recommendedActions?: string[] | undefined;
    contactEmail?: string | undefined;
}

export class ManufacturerUpcomingEventTotals implements IManufacturerUpcomingEventTotals {
    eventCount?: number;
    amount?: number;

    constructor(data?: IManufacturerUpcomingEventTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventCount = _data["eventCount"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ManufacturerUpcomingEventTotals {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerUpcomingEventTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventCount"] = this.eventCount;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IManufacturerUpcomingEventTotals {
    eventCount?: number;
    amount?: number;
}

export class ManufacturerVendorPerformanceInsights implements IManufacturerVendorPerformanceInsights {
    keyGrowthDrivers?: string[] | undefined;
    riskFactors?: string[] | undefined;

    constructor(data?: IManufacturerVendorPerformanceInsights) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["keyGrowthDrivers"])) {
                this.keyGrowthDrivers = [] as any;
                for (let item of _data["keyGrowthDrivers"])
                    this.keyGrowthDrivers!.push(item);
            }
            if (Array.isArray(_data["riskFactors"])) {
                this.riskFactors = [] as any;
                for (let item of _data["riskFactors"])
                    this.riskFactors!.push(item);
            }
        }
    }

    static fromJS(data: any): ManufacturerVendorPerformanceInsights {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerVendorPerformanceInsights();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keyGrowthDrivers)) {
            data["keyGrowthDrivers"] = [];
            for (let item of this.keyGrowthDrivers)
                data["keyGrowthDrivers"].push(item);
        }
        if (Array.isArray(this.riskFactors)) {
            data["riskFactors"] = [];
            for (let item of this.riskFactors)
                data["riskFactors"].push(item);
        }
        return data;
    }
}

export interface IManufacturerVendorPerformanceInsights {
    keyGrowthDrivers?: string[] | undefined;
    riskFactors?: string[] | undefined;
}

export class ReplacementPart implements IReplacementPart {
    partNumber?: string | undefined;
    description?: string | undefined;

    constructor(data?: IReplacementPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partNumber = _data["partNumber"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ReplacementPart {
        data = typeof data === 'object' ? data : {};
        let result = new ReplacementPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partNumber"] = this.partNumber;
        data["description"] = this.description;
        return data;
    }
}

export interface IReplacementPart {
    partNumber?: string | undefined;
    description?: string | undefined;
}

export class ShiResaleRevenueHistoryEntry implements IShiResaleRevenueHistoryEntry {
    periodLabel?: string | undefined;
    quarterEndDate?: Date | undefined;
    revenueUsdMillions?: number | undefined;
    calendarQuarter?: string | undefined;
    fiscalQuarter?: string | undefined;
    yoyGrowthPercent?: number | undefined;
    source?: string | undefined;

    constructor(data?: IShiResaleRevenueHistoryEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodLabel = _data["periodLabel"];
            this.quarterEndDate = _data["quarterEndDate"] ? new Date(_data["quarterEndDate"].toString()) : undefined as any;
            this.revenueUsdMillions = _data["revenueUsdMillions"];
            this.calendarQuarter = _data["calendarQuarter"];
            this.fiscalQuarter = _data["fiscalQuarter"];
            this.yoyGrowthPercent = _data["yoyGrowthPercent"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ShiResaleRevenueHistoryEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ShiResaleRevenueHistoryEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodLabel"] = this.periodLabel;
        data["quarterEndDate"] = this.quarterEndDate ? formatDate(this.quarterEndDate) : undefined as any;
        data["revenueUsdMillions"] = this.revenueUsdMillions;
        data["calendarQuarter"] = this.calendarQuarter;
        data["fiscalQuarter"] = this.fiscalQuarter;
        data["yoyGrowthPercent"] = this.yoyGrowthPercent;
        data["source"] = this.source;
        return data;
    }
}

export interface IShiResaleRevenueHistoryEntry {
    periodLabel?: string | undefined;
    quarterEndDate?: Date | undefined;
    revenueUsdMillions?: number | undefined;
    calendarQuarter?: string | undefined;
    fiscalQuarter?: string | undefined;
    yoyGrowthPercent?: number | undefined;
    source?: string | undefined;
}

export class AvailableRoadmapDto implements IAvailableRoadmapDto {
    id?: string;
    name!: string | undefined;

    constructor(data?: IAvailableRoadmapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AvailableRoadmapDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableRoadmapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAvailableRoadmapDto {
    id?: string;
    name: string | undefined;
}

export class AvailableVariantDto implements IAvailableVariantDto {
    variant!: string | undefined;
    variantName!: string | undefined;
    stockItemCount!: number;
    orderItemCount!: number;

    constructor(data?: IAvailableVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variant = _data["variant"];
            this.variantName = _data["variantName"];
            this.stockItemCount = _data["stockItemCount"];
            this.orderItemCount = _data["orderItemCount"];
        }
    }

    static fromJS(data: any): AvailableVariantDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableVariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variant"] = this.variant;
        data["variantName"] = this.variantName;
        data["stockItemCount"] = this.stockItemCount;
        data["orderItemCount"] = this.orderItemCount;
        return data;
    }
}

export interface IAvailableVariantDto {
    variant: string | undefined;
    variantName: string | undefined;
    stockItemCount: number;
    orderItemCount: number;
}

export class CreateWebLinkRequest implements ICreateWebLinkRequest {
    name?: string | undefined;
    url?: string | undefined;

    constructor(data?: ICreateWebLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateWebLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWebLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface ICreateWebLinkRequest {
    name?: string | undefined;
    url?: string | undefined;
}

export class ItProjectAttachmentDto implements IItProjectAttachmentDto {
    attachmentId?: string;
    fileName?: string | undefined;
    fileTitle?: string | undefined;
    contentType?: string | undefined;
    fileSizeBytes?: number;
    uploadedAt?: Date;
    uploadedBy?: string | undefined;

    constructor(data?: IItProjectAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
            this.fileName = _data["fileName"];
            this.fileTitle = _data["fileTitle"];
            this.contentType = _data["contentType"];
            this.fileSizeBytes = _data["fileSizeBytes"];
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : undefined as any;
            this.uploadedBy = _data["uploadedBy"];
        }
    }

    static fromJS(data: any): ItProjectAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItProjectAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        data["fileName"] = this.fileName;
        data["fileTitle"] = this.fileTitle;
        data["contentType"] = this.contentType;
        data["fileSizeBytes"] = this.fileSizeBytes;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : undefined as any;
        data["uploadedBy"] = this.uploadedBy;
        return data;
    }
}

export interface IItProjectAttachmentDto {
    attachmentId?: string;
    fileName?: string | undefined;
    fileTitle?: string | undefined;
    contentType?: string | undefined;
    fileSizeBytes?: number;
    uploadedAt?: Date;
    uploadedBy?: string | undefined;
}

export class ItProjectDto implements IItProjectDto {
    itProjectId?: string;
    crmAccountId?: string | undefined;
    accountName?: string | undefined;
    axNumber?: string | undefined;
    customerItProjectId?: string | undefined;
    title!: string | undefined;
    description?: string | undefined;
    itProjectType!: ItProjectType;
    customProjectTypeName?: string | undefined;
    targetStartDate?: Date | undefined;
    targetEndDate?: Date | undefined;
    status!: ItProjectStatus;
    shiLeadId?: string | undefined;
    customerLeadId?: string | undefined;
    purchaseOrders?: number;
    quotes?: number;
    integrationOrders?: number;
    totalInvestments?: number;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedAt?: Date;

    constructor(data?: IItProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itProjectId = _data["itProjectId"];
            this.crmAccountId = _data["crmAccountId"];
            this.accountName = _data["accountName"];
            this.axNumber = _data["axNumber"];
            this.customerItProjectId = _data["customerItProjectId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.itProjectType = _data["itProjectType"];
            this.customProjectTypeName = _data["customProjectTypeName"];
            this.targetStartDate = _data["targetStartDate"] ? new Date(_data["targetStartDate"].toString()) : undefined as any;
            this.targetEndDate = _data["targetEndDate"] ? new Date(_data["targetEndDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.shiLeadId = _data["shiLeadId"];
            this.customerLeadId = _data["customerLeadId"];
            this.purchaseOrders = _data["purchaseOrders"];
            this.quotes = _data["quotes"];
            this.integrationOrders = _data["integrationOrders"];
            this.totalInvestments = _data["totalInvestments"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ItProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itProjectId"] = this.itProjectId;
        data["crmAccountId"] = this.crmAccountId;
        data["accountName"] = this.accountName;
        data["axNumber"] = this.axNumber;
        data["customerItProjectId"] = this.customerItProjectId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["itProjectType"] = this.itProjectType;
        data["customProjectTypeName"] = this.customProjectTypeName;
        data["targetStartDate"] = this.targetStartDate ? formatDate(this.targetStartDate) : undefined as any;
        data["targetEndDate"] = this.targetEndDate ? formatDate(this.targetEndDate) : undefined as any;
        data["status"] = this.status;
        data["shiLeadId"] = this.shiLeadId;
        data["customerLeadId"] = this.customerLeadId;
        data["purchaseOrders"] = this.purchaseOrders;
        data["quotes"] = this.quotes;
        data["integrationOrders"] = this.integrationOrders;
        data["totalInvestments"] = this.totalInvestments;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IItProjectDto {
    itProjectId?: string;
    crmAccountId?: string | undefined;
    accountName?: string | undefined;
    axNumber?: string | undefined;
    customerItProjectId?: string | undefined;
    title: string | undefined;
    description?: string | undefined;
    itProjectType: ItProjectType;
    customProjectTypeName?: string | undefined;
    targetStartDate?: Date | undefined;
    targetEndDate?: Date | undefined;
    status: ItProjectStatus;
    shiLeadId?: string | undefined;
    customerLeadId?: string | undefined;
    purchaseOrders?: number;
    quotes?: number;
    integrationOrders?: number;
    totalInvestments?: number;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedAt?: Date;
}

export class ItProjectShipmentDto implements IItProjectShipmentDto {
    id?: string | undefined;
    shipmentName?: string | undefined;
    orderReference?: string | undefined;
    biOrderId?: number | undefined;
    webOrderId?: number | undefined;
    carrier?: string | undefined;
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;
    shipToName?: string | undefined;
    shipToAddress?: string | undefined;
    deliveryStatus?: string | undefined;
    estimatedDelivery?: Date | undefined;
    shippedDate?: Date | undefined;
    shipmentItems?: ItProjectShipmentItemDto[] | undefined;
    serialNumbers?: string[] | undefined;

    constructor(data?: IItProjectShipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shipmentName = _data["shipmentName"];
            this.orderReference = _data["orderReference"];
            this.biOrderId = _data["biOrderId"];
            this.webOrderId = _data["webOrderId"];
            this.carrier = _data["carrier"];
            this.trackingNumber = _data["trackingNumber"];
            this.trackingUrl = _data["trackingUrl"];
            this.shipToName = _data["shipToName"];
            this.shipToAddress = _data["shipToAddress"];
            this.deliveryStatus = _data["deliveryStatus"];
            this.estimatedDelivery = _data["estimatedDelivery"] ? new Date(_data["estimatedDelivery"].toString()) : undefined as any;
            this.shippedDate = _data["shippedDate"] ? new Date(_data["shippedDate"].toString()) : undefined as any;
            if (Array.isArray(_data["shipmentItems"])) {
                this.shipmentItems = [] as any;
                for (let item of _data["shipmentItems"])
                    this.shipmentItems!.push(ItProjectShipmentItemDto.fromJS(item));
            }
            if (Array.isArray(_data["serialNumbers"])) {
                this.serialNumbers = [] as any;
                for (let item of _data["serialNumbers"])
                    this.serialNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): ItProjectShipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItProjectShipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shipmentName"] = this.shipmentName;
        data["orderReference"] = this.orderReference;
        data["biOrderId"] = this.biOrderId;
        data["webOrderId"] = this.webOrderId;
        data["carrier"] = this.carrier;
        data["trackingNumber"] = this.trackingNumber;
        data["trackingUrl"] = this.trackingUrl;
        data["shipToName"] = this.shipToName;
        data["shipToAddress"] = this.shipToAddress;
        data["deliveryStatus"] = this.deliveryStatus;
        data["estimatedDelivery"] = this.estimatedDelivery ? this.estimatedDelivery.toISOString() : undefined as any;
        data["shippedDate"] = this.shippedDate ? this.shippedDate.toISOString() : undefined as any;
        if (Array.isArray(this.shipmentItems)) {
            data["shipmentItems"] = [];
            for (let item of this.shipmentItems)
                data["shipmentItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.serialNumbers)) {
            data["serialNumbers"] = [];
            for (let item of this.serialNumbers)
                data["serialNumbers"].push(item);
        }
        return data;
    }
}

export interface IItProjectShipmentDto {
    id?: string | undefined;
    shipmentName?: string | undefined;
    orderReference?: string | undefined;
    biOrderId?: number | undefined;
    webOrderId?: number | undefined;
    carrier?: string | undefined;
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;
    shipToName?: string | undefined;
    shipToAddress?: string | undefined;
    deliveryStatus?: string | undefined;
    estimatedDelivery?: Date | undefined;
    shippedDate?: Date | undefined;
    shipmentItems?: ItProjectShipmentItemDto[] | undefined;
    serialNumbers?: string[] | undefined;
}

export class ItProjectShipmentItemDto implements IItProjectShipmentItemDto {
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    imageUrl?: string | undefined;

    constructor(data?: IItProjectShipmentItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): ItProjectShipmentItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItProjectShipmentItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IItProjectShipmentItemDto {
    productName?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    imageUrl?: string | undefined;
}

export class ItProjectStatusCountDto implements IItProjectStatusCountDto {
    status!: ItProjectStatus;
    count!: number;

    constructor(data?: IItProjectStatusCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ItProjectStatusCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItProjectStatusCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IItProjectStatusCountDto {
    status: ItProjectStatus;
    count: number;
}

export class LinkOrderRequest implements ILinkOrderRequest {
    biOrderId?: number | undefined;
    webOrderId?: number | undefined;
    orderNumber?: string | undefined;

    constructor(data?: ILinkOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biOrderId = _data["biOrderId"];
            this.webOrderId = _data["webOrderId"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): LinkOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biOrderId"] = this.biOrderId;
        data["webOrderId"] = this.webOrderId;
        data["orderNumber"] = this.orderNumber;
        return data;
    }
}

export interface ILinkOrderRequest {
    biOrderId?: number | undefined;
    webOrderId?: number | undefined;
    orderNumber?: string | undefined;
}

export class LinkQuoteRequest implements ILinkQuoteRequest {
    quoteGuid?: string;

    constructor(data?: ILinkQuoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteGuid = _data["quoteGuid"];
        }
    }

    static fromJS(data: any): LinkQuoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkQuoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteGuid"] = this.quoteGuid;
        return data;
    }
}

export interface ILinkQuoteRequest {
    quoteGuid?: string;
}

export class LinkedItProjectDto implements ILinkedItProjectDto {
    itProjectId?: string;
    title!: string | undefined;
    crmAccountId?: string;

    constructor(data?: ILinkedItProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itProjectId = _data["itProjectId"];
            this.title = _data["title"];
            this.crmAccountId = _data["crmAccountId"];
        }
    }

    static fromJS(data: any): LinkedItProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedItProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itProjectId"] = this.itProjectId;
        data["title"] = this.title;
        data["crmAccountId"] = this.crmAccountId;
        return data;
    }
}

export interface ILinkedItProjectDto {
    itProjectId?: string;
    title: string | undefined;
    crmAccountId?: string;
}

export class LinkedItemCountsDto implements ILinkedItemCountsDto {
    serviceEngagements?: number;
    purchaseOrders?: number;
    roadmaps?: number;
    variants?: number;
    attachments?: number;
    quotes?: number;
    shipments?: number;

    constructor(data?: ILinkedItemCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceEngagements = _data["serviceEngagements"];
            this.purchaseOrders = _data["purchaseOrders"];
            this.roadmaps = _data["roadmaps"];
            this.variants = _data["variants"];
            this.attachments = _data["attachments"];
            this.quotes = _data["quotes"];
            this.shipments = _data["shipments"];
        }
    }

    static fromJS(data: any): LinkedItemCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedItemCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceEngagements"] = this.serviceEngagements;
        data["purchaseOrders"] = this.purchaseOrders;
        data["roadmaps"] = this.roadmaps;
        data["variants"] = this.variants;
        data["attachments"] = this.attachments;
        data["quotes"] = this.quotes;
        data["shipments"] = this.shipments;
        return data;
    }
}

export interface ILinkedItemCountsDto {
    serviceEngagements?: number;
    purchaseOrders?: number;
    roadmaps?: number;
    variants?: number;
    attachments?: number;
    quotes?: number;
    shipments?: number;
}

export class LinkedVariantAggregateCountsDto implements ILinkedVariantAggregateCountsDto {
    integrationStock?: number;
    integrationOrders?: number;

    constructor(data?: ILinkedVariantAggregateCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationStock = _data["integrationStock"];
            this.integrationOrders = _data["integrationOrders"];
        }
    }

    static fromJS(data: any): LinkedVariantAggregateCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedVariantAggregateCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationStock"] = this.integrationStock;
        data["integrationOrders"] = this.integrationOrders;
        return data;
    }
}

export interface ILinkedVariantAggregateCountsDto {
    integrationStock?: number;
    integrationOrders?: number;
}

export class PagedProjectsResponse implements IPagedProjectsResponse {
    items?: ItProjectDto[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;

    constructor(data?: IPagedProjectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItProjectDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedProjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedProjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedProjectsResponse {
    items?: ItProjectDto[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export class UpdateAttachmentTitleRequest implements IUpdateAttachmentTitleRequest {
    fileTitle?: string | undefined;

    constructor(data?: IUpdateAttachmentTitleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileTitle = _data["fileTitle"];
        }
    }

    static fromJS(data: any): UpdateAttachmentTitleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttachmentTitleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileTitle"] = this.fileTitle;
        return data;
    }
}

export interface IUpdateAttachmentTitleRequest {
    fileTitle?: string | undefined;
}

export class WebLinkDto implements IWebLinkDto {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    addedBy?: string | undefined;
    dateAdded?: Date;

    constructor(data?: IWebLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.addedBy = _data["addedBy"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WebLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["addedBy"] = this.addedBy;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined as any;
        return data;
    }
}

export interface IWebLinkDto {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    addedBy?: string | undefined;
    dateAdded?: Date;
}

export enum ItProjectStatus {
    Planning = "Planning",
    InProgress = "InProgress",
    OnHold = "OnHold",
    Canceled = "Canceled",
    Closed = "Closed",
}

export enum ItProjectType {
    SiteRefresh = "SiteRefresh",
    MultiSiteRefresh = "MultiSiteRefresh",
    RackDeployment = "RackDeployment",
    EndUserRefresh = "EndUserRefresh",
    Other = "Other",
}

export class ContentUnitDto implements IContentUnitDto {
    identifier?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    isPublic?: boolean;
    icon?: string | undefined;
    contractCategoryIds?: number[] | undefined;

    constructor(data?: IContentUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.isPublic = _data["isPublic"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["contractCategoryIds"])) {
                this.contractCategoryIds = [] as any;
                for (let item of _data["contractCategoryIds"])
                    this.contractCategoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ContentUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["title"] = this.title;
        data["url"] = this.url;
        data["isPublic"] = this.isPublic;
        data["icon"] = this.icon;
        if (Array.isArray(this.contractCategoryIds)) {
            data["contractCategoryIds"] = [];
            for (let item of this.contractCategoryIds)
                data["contractCategoryIds"].push(item);
        }
        return data;
    }
}

export interface IContentUnitDto {
    identifier?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    isPublic?: boolean;
    icon?: string | undefined;
    contractCategoryIds?: number[] | undefined;
}

export class AxAccountDropdownOptionDto implements IAxAccountDropdownOptionDto {
    axNumber!: string | undefined;
    displayName!: string | undefined;
    label!: string | undefined;

    constructor(data?: IAxAccountDropdownOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axNumber = _data["axNumber"];
            this.displayName = _data["displayName"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): AxAccountDropdownOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AxAccountDropdownOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axNumber"] = this.axNumber;
        data["displayName"] = this.displayName;
        data["label"] = this.label;
        return data;
    }
}

export interface IAxAccountDropdownOptionDto {
    axNumber: string | undefined;
    displayName: string | undefined;
    label: string | undefined;
}

export enum Category {
    Manufacturer = "Manufacturer",
    SolutionArea = "SolutionArea",
}

export class DurationControlAcknowledgePendingRequestDto implements IDurationControlAcknowledgePendingRequestDto {
    pendingDurationControlIds?: number[] | undefined;

    constructor(data?: IDurationControlAcknowledgePendingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pendingDurationControlIds"])) {
                this.pendingDurationControlIds = [] as any;
                for (let item of _data["pendingDurationControlIds"])
                    this.pendingDurationControlIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DurationControlAcknowledgePendingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationControlAcknowledgePendingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pendingDurationControlIds)) {
            data["pendingDurationControlIds"] = [];
            for (let item of this.pendingDurationControlIds)
                data["pendingDurationControlIds"].push(item);
        }
        return data;
    }
}

export interface IDurationControlAcknowledgePendingRequestDto {
    pendingDurationControlIds?: number[] | undefined;
}

export class DurationControlCreateRequestDto implements IDurationControlCreateRequestDto {
    axAccountNumber!: string | undefined;
    ruleType?: RuleType;
    category?: Category;
    categoryItemValue?: string | undefined;
    refreshInterval?: number;
    refreshUnit?: RefreshUnit;
    startFromDateField?: StartFromDateField;
    priority?: number;
    rejectConflictingPendingChanges?: boolean;

    constructor(data?: IDurationControlCreateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.ruleType = _data["ruleType"];
            this.category = _data["category"];
            this.categoryItemValue = _data["categoryItemValue"];
            this.refreshInterval = _data["refreshInterval"];
            this.refreshUnit = _data["refreshUnit"];
            this.startFromDateField = _data["startFromDateField"];
            this.priority = _data["priority"];
            this.rejectConflictingPendingChanges = _data["rejectConflictingPendingChanges"];
        }
    }

    static fromJS(data: any): DurationControlCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationControlCreateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["ruleType"] = this.ruleType;
        data["category"] = this.category;
        data["categoryItemValue"] = this.categoryItemValue;
        data["refreshInterval"] = this.refreshInterval;
        data["refreshUnit"] = this.refreshUnit;
        data["startFromDateField"] = this.startFromDateField;
        data["priority"] = this.priority;
        data["rejectConflictingPendingChanges"] = this.rejectConflictingPendingChanges;
        return data;
    }
}

export interface IDurationControlCreateRequestDto {
    axAccountNumber: string | undefined;
    ruleType?: RuleType;
    category?: Category;
    categoryItemValue?: string | undefined;
    refreshInterval?: number;
    refreshUnit?: RefreshUnit;
    startFromDateField?: StartFromDateField;
    priority?: number;
    rejectConflictingPendingChanges?: boolean;
}

export class DurationControlDeleteRequestDto implements IDurationControlDeleteRequestDto {
    id?: number;
    axAccountNumber!: string | undefined;
    version?: number;
    rejectConflictingPendingChanges?: boolean;

    constructor(data?: IDurationControlDeleteRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.version = _data["version"];
            this.rejectConflictingPendingChanges = _data["rejectConflictingPendingChanges"];
        }
    }

    static fromJS(data: any): DurationControlDeleteRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationControlDeleteRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axAccountNumber"] = this.axAccountNumber;
        data["version"] = this.version;
        data["rejectConflictingPendingChanges"] = this.rejectConflictingPendingChanges;
        return data;
    }
}

export interface IDurationControlDeleteRequestDto {
    id?: number;
    axAccountNumber: string | undefined;
    version?: number;
    rejectConflictingPendingChanges?: boolean;
}

export class DurationControlUpdateRequestDto implements IDurationControlUpdateRequestDto {
    id?: number;
    axAccountNumber!: string | undefined;
    ruleType?: RuleType;
    category?: Category;
    categoryItemValue?: string | undefined;
    refreshInterval?: number;
    refreshUnit?: RefreshUnit;
    startFromDateField?: StartFromDateField;
    isDeleted?: boolean | undefined;
    priority?: number;
    version?: number;
    rejectConflictingPendingChanges?: boolean;

    constructor(data?: IDurationControlUpdateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.ruleType = _data["ruleType"];
            this.category = _data["category"];
            this.categoryItemValue = _data["categoryItemValue"];
            this.refreshInterval = _data["refreshInterval"];
            this.refreshUnit = _data["refreshUnit"];
            this.startFromDateField = _data["startFromDateField"];
            this.isDeleted = _data["isDeleted"];
            this.priority = _data["priority"];
            this.version = _data["version"];
            this.rejectConflictingPendingChanges = _data["rejectConflictingPendingChanges"];
        }
    }

    static fromJS(data: any): DurationControlUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationControlUpdateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axAccountNumber"] = this.axAccountNumber;
        data["ruleType"] = this.ruleType;
        data["category"] = this.category;
        data["categoryItemValue"] = this.categoryItemValue;
        data["refreshInterval"] = this.refreshInterval;
        data["refreshUnit"] = this.refreshUnit;
        data["startFromDateField"] = this.startFromDateField;
        data["isDeleted"] = this.isDeleted;
        data["priority"] = this.priority;
        data["version"] = this.version;
        data["rejectConflictingPendingChanges"] = this.rejectConflictingPendingChanges;
        return data;
    }
}

export interface IDurationControlUpdateRequestDto {
    id?: number;
    axAccountNumber: string | undefined;
    ruleType?: RuleType;
    category?: Category;
    categoryItemValue?: string | undefined;
    refreshInterval?: number;
    refreshUnit?: RefreshUnit;
    startFromDateField?: StartFromDateField;
    isDeleted?: boolean | undefined;
    priority?: number;
    version?: number;
    rejectConflictingPendingChanges?: boolean;
}

export class DurationControlsBulkUpdateRequest implements IDurationControlsBulkUpdateRequest {
    creates?: DurationControlCreateRequestDto[] | undefined;
    updates?: DurationControlUpdateRequestDto[] | undefined;
    deletes?: DurationControlDeleteRequestDto[] | undefined;

    constructor(data?: IDurationControlsBulkUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["creates"])) {
                this.creates = [] as any;
                for (let item of _data["creates"])
                    this.creates!.push(DurationControlCreateRequestDto.fromJS(item));
            }
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(DurationControlUpdateRequestDto.fromJS(item));
            }
            if (Array.isArray(_data["deletes"])) {
                this.deletes = [] as any;
                for (let item of _data["deletes"])
                    this.deletes!.push(DurationControlDeleteRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DurationControlsBulkUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DurationControlsBulkUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.creates)) {
            data["creates"] = [];
            for (let item of this.creates)
                data["creates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletes)) {
            data["deletes"] = [];
            for (let item of this.deletes)
                data["deletes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDurationControlsBulkUpdateRequest {
    creates?: DurationControlCreateRequestDto[] | undefined;
    updates?: DurationControlUpdateRequestDto[] | undefined;
    deletes?: DurationControlDeleteRequestDto[] | undefined;
}

export class DurationControlsDto implements IDurationControlsDto {
    id?: number;
    axAccountNumber!: string | undefined;
    ruleType?: RuleType;
    category?: Category;
    categoryItemValue?: string | undefined;
    refreshInterval?: number;
    refreshUnit?: RefreshUnit;
    startFromDateField?: StartFromDateField;
    pending?: boolean;
    priority?: number;
    version?: number;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedAt?: Date;
    isDeleted?: boolean;
    deletedBy?: string | undefined;
    deletedAt?: Date | undefined;

    constructor(data?: IDurationControlsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.ruleType = _data["ruleType"];
            this.category = _data["category"];
            this.categoryItemValue = _data["categoryItemValue"];
            this.refreshInterval = _data["refreshInterval"];
            this.refreshUnit = _data["refreshUnit"];
            this.startFromDateField = _data["startFromDateField"];
            this.pending = _data["pending"];
            this.priority = _data["priority"];
            this.version = _data["version"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deletedBy = _data["deletedBy"];
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DurationControlsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationControlsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axAccountNumber"] = this.axAccountNumber;
        data["ruleType"] = this.ruleType;
        data["category"] = this.category;
        data["categoryItemValue"] = this.categoryItemValue;
        data["refreshInterval"] = this.refreshInterval;
        data["refreshUnit"] = this.refreshUnit;
        data["startFromDateField"] = this.startFromDateField;
        data["pending"] = this.pending;
        data["priority"] = this.priority;
        data["version"] = this.version;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deletedBy"] = this.deletedBy;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IDurationControlsDto {
    id?: number;
    axAccountNumber: string | undefined;
    ruleType?: RuleType;
    category?: Category;
    categoryItemValue?: string | undefined;
    refreshInterval?: number;
    refreshUnit?: RefreshUnit;
    startFromDateField?: StartFromDateField;
    pending?: boolean;
    priority?: number;
    version?: number;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedAt?: Date;
    isDeleted?: boolean;
    deletedBy?: string | undefined;
    deletedAt?: Date | undefined;
}

export enum RefreshUnit {
    Month = "Month",
    Year = "Year",
}

export enum RuleType {
    Base = "Base",
    Custom = "Custom",
}

export enum StartFromDateField {
    Order = "Order",
    Ship = "Ship",
}

export class AddressMapDto implements IAddressMapDto {
    mapSasUrl?: string | undefined;
    latitude?: number;
    longitude?: number;
    width?: number;
    height?: number;

    constructor(data?: IAddressMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapSasUrl = _data["mapSasUrl"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): AddressMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapSasUrl"] = this.mapSasUrl;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IAddressMapDto {
    mapSasUrl?: string | undefined;
    latitude?: number;
    longitude?: number;
    width?: number;
    height?: number;
}

export class GeocodeDto implements IGeocodeDto {
    latitude?: number;
    longitude?: number;

    constructor(data?: IGeocodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): GeocodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IGeocodeDto {
    latitude?: number;
    longitude?: number;
}

export class LocationDto implements ILocationDto {
    latitude?: number;
    longitude?: number;
    address?: string | undefined;
    pixelX?: number;
    pixelY?: number;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.pixelX = _data["pixelX"];
            this.pixelY = _data["pixelY"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["pixelX"] = this.pixelX;
        data["pixelY"] = this.pixelY;
        return data;
    }
}

export interface ILocationDto {
    latitude?: number;
    longitude?: number;
    address?: string | undefined;
    pixelX?: number;
    pixelY?: number;
}

export class ShipmentMapDto implements IShipmentMapDto {
    mapSasUrl?: string | undefined;
    trackingNumber?: string | undefined;
    currentLocation?: LocationDto;
    destination?: LocationDto;
    width?: number;
    height?: number;

    constructor(data?: IShipmentMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapSasUrl = _data["mapSasUrl"];
            this.trackingNumber = _data["trackingNumber"];
            this.currentLocation = _data["currentLocation"] ? LocationDto.fromJS(_data["currentLocation"]) : undefined as any;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : undefined as any;
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): ShipmentMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapSasUrl"] = this.mapSasUrl;
        data["trackingNumber"] = this.trackingNumber;
        data["currentLocation"] = this.currentLocation ? this.currentLocation.toJSON() : undefined as any;
        data["destination"] = this.destination ? this.destination.toJSON() : undefined as any;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IShipmentMapDto {
    mapSasUrl?: string | undefined;
    trackingNumber?: string | undefined;
    currentLocation?: LocationDto;
    destination?: LocationDto;
    width?: number;
    height?: number;
}

export class ActiveUserTrendsServiceItem implements IActiveUserTrendsServiceItem {
    displayName?: string | undefined;
    activeUsersCounts?: number[] | undefined;

    constructor(data?: IActiveUserTrendsServiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["activeUsersCounts"])) {
                this.activeUsersCounts = [] as any;
                for (let item of _data["activeUsersCounts"])
                    this.activeUsersCounts!.push(item);
            }
        }
    }

    static fromJS(data: any): ActiveUserTrendsServiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUserTrendsServiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        if (Array.isArray(this.activeUsersCounts)) {
            data["activeUsersCounts"] = [];
            for (let item of this.activeUsersCounts)
                data["activeUsersCounts"].push(item);
        }
        return data;
    }
}

export interface IActiveUserTrendsServiceItem {
    displayName?: string | undefined;
    activeUsersCounts?: number[] | undefined;
}

export class ActiveUserTrendsWidgetResponse implements IActiveUserTrendsWidgetResponse {
    services?: ActiveUserTrendsServiceItem[] | undefined;
    activeUsersTimeframeLabels?: string[] | undefined;

    constructor(data?: IActiveUserTrendsWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ActiveUserTrendsServiceItem.fromJS(item));
            }
            if (Array.isArray(_data["activeUsersTimeframeLabels"])) {
                this.activeUsersTimeframeLabels = [] as any;
                for (let item of _data["activeUsersTimeframeLabels"])
                    this.activeUsersTimeframeLabels!.push(item);
            }
        }
    }

    static fromJS(data: any): ActiveUserTrendsWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUserTrendsWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.activeUsersTimeframeLabels)) {
            data["activeUsersTimeframeLabels"] = [];
            for (let item of this.activeUsersTimeframeLabels)
                data["activeUsersTimeframeLabels"].push(item);
        }
        return data;
    }
}

export interface IActiveUserTrendsWidgetResponse {
    services?: ActiveUserTrendsServiceItem[] | undefined;
    activeUsersTimeframeLabels?: string[] | undefined;
}

export class ActiveUsersByServiceWidgetResponse implements IActiveUsersByServiceWidgetResponse {
    services?: ServiceItem[] | undefined;

    constructor(data?: IActiveUsersByServiceWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveUsersByServiceWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUsersByServiceWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IActiveUsersByServiceWidgetResponse {
    services?: ServiceItem[] | undefined;
}

export class FeatureAdoptionWidgetResponse implements IFeatureAdoptionWidgetResponse {
    services?: ServiceItem[] | undefined;

    constructor(data?: IFeatureAdoptionWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureAdoptionWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureAdoptionWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFeatureAdoptionWidgetResponse {
    services?: ServiceItem[] | undefined;
}

export class License implements ILicense {
    licenseName?: string | undefined;
    active?: number;
    inactive?: number;
    onboarding?: number;
    notUsed?: number;
    total?: number;

    constructor(data?: ILicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseName = _data["licenseName"];
            this.active = _data["active"];
            this.inactive = _data["inactive"];
            this.onboarding = _data["onboarding"];
            this.notUsed = _data["notUsed"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): License {
        data = typeof data === 'object' ? data : {};
        let result = new License();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseName"] = this.licenseName;
        data["active"] = this.active;
        data["inactive"] = this.inactive;
        data["onboarding"] = this.onboarding;
        data["notUsed"] = this.notUsed;
        data["total"] = this.total;
        return data;
    }
}

export interface ILicense {
    licenseName?: string | undefined;
    active?: number;
    inactive?: number;
    onboarding?: number;
    notUsed?: number;
    total?: number;
}

export class LicenseUtilizationWidgetResponse implements ILicenseUtilizationWidgetResponse {
    licenses?: License[] | undefined;

    constructor(data?: ILicenseUtilizationWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(License.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseUtilizationWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseUtilizationWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicenseUtilizationWidgetResponse {
    licenses?: License[] | undefined;
}

export class ProductivityItem implements IProductivityItem {
    id?: number;
    service?: string | undefined;
    amount?: number;
    unit?: string | undefined;

    constructor(data?: IProductivityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): ProductivityItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IProductivityItem {
    id?: number;
    service?: string | undefined;
    amount?: number;
    unit?: string | undefined;
}

export class ProductivityWidgetResponse implements IProductivityWidgetResponse {
    services?: ProductivityItem[] | undefined;

    constructor(data?: IProductivityWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ProductivityItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductivityWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductivityWidgetResponse {
    services?: ProductivityItem[] | undefined;
}

export class ServiceItem implements IServiceItem {
    id?: number;
    service?: string | undefined;
    activeUsers?: number;
    totalUsers?: number;

    constructor(data?: IServiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"];
            this.activeUsers = _data["activeUsers"];
            this.totalUsers = _data["totalUsers"];
        }
    }

    static fromJS(data: any): ServiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service;
        data["activeUsers"] = this.activeUsers;
        data["totalUsers"] = this.totalUsers;
        return data;
    }
}

export interface IServiceItem {
    id?: number;
    service?: string | undefined;
    activeUsers?: number;
    totalUsers?: number;
}

export class AttestationLinkDto implements IAttestationLinkDto {
    attestationId?: string | undefined;
    attestationUrl?: string | undefined;

    constructor(data?: IAttestationLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attestationId = _data["attestationId"];
            this.attestationUrl = _data["attestationUrl"];
        }
    }

    static fromJS(data: any): AttestationLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attestationId"] = this.attestationId;
        data["attestationUrl"] = this.attestationUrl;
        return data;
    }
}

export interface IAttestationLinkDto {
    attestationId?: string | undefined;
    attestationUrl?: string | undefined;
}

export class BatchAssignLicenseItemDto implements IBatchAssignLicenseItemDto {
    userId?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    userDisplayName?: string | undefined;
    userEmail?: string | undefined;
    excludePlans?: string[] | undefined;

    constructor(data?: IBatchAssignLicenseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.userDisplayName = _data["userDisplayName"];
            this.userEmail = _data["userEmail"];
            if (Array.isArray(_data["excludePlans"])) {
                this.excludePlans = [] as any;
                for (let item of _data["excludePlans"])
                    this.excludePlans!.push(item);
            }
        }
    }

    static fromJS(data: any): BatchAssignLicenseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchAssignLicenseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["userDisplayName"] = this.userDisplayName;
        data["userEmail"] = this.userEmail;
        if (Array.isArray(this.excludePlans)) {
            data["excludePlans"] = [];
            for (let item of this.excludePlans)
                data["excludePlans"].push(item);
        }
        return data;
    }
}

export interface IBatchAssignLicenseItemDto {
    userId?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    userDisplayName?: string | undefined;
    userEmail?: string | undefined;
    excludePlans?: string[] | undefined;
}

export class BatchLicenseChangesRequestDto implements IBatchLicenseChangesRequestDto {
    removals?: BatchRemoveLicenseItemDto[] | undefined;
    assignments?: BatchAssignLicenseItemDto[] | undefined;

    constructor(data?: IBatchLicenseChangesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["removals"])) {
                this.removals = [] as any;
                for (let item of _data["removals"])
                    this.removals!.push(BatchRemoveLicenseItemDto.fromJS(item));
            }
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(BatchAssignLicenseItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchLicenseChangesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLicenseChangesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.removals)) {
            data["removals"] = [];
            for (let item of this.removals)
                data["removals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBatchLicenseChangesRequestDto {
    removals?: BatchRemoveLicenseItemDto[] | undefined;
    assignments?: BatchAssignLicenseItemDto[] | undefined;
}

export class BatchLicenseChangesResultDto implements IBatchLicenseChangesResultDto {
    results?: BatchLicenseOperationResultDto[] | undefined;

    constructor(data?: IBatchLicenseChangesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BatchLicenseOperationResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchLicenseChangesResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLicenseChangesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBatchLicenseChangesResultDto {
    results?: BatchLicenseOperationResultDto[] | undefined;
}

export class BatchLicenseOperationResultDto implements IBatchLicenseOperationResultDto {
    userId?: string | undefined;
    productId?: string | undefined;
    operationType?: string | undefined;
    success?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IBatchLicenseOperationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.productId = _data["productId"];
            this.operationType = _data["operationType"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BatchLicenseOperationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLicenseOperationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["productId"] = this.productId;
        data["operationType"] = this.operationType;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBatchLicenseOperationResultDto {
    userId?: string | undefined;
    productId?: string | undefined;
    operationType?: string | undefined;
    success?: boolean;
    errorMessage?: string | undefined;
}

export class BatchRemoveLicenseItemDto implements IBatchRemoveLicenseItemDto {
    userId?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    userDisplayName?: string | undefined;
    userEmail?: string | undefined;

    constructor(data?: IBatchRemoveLicenseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.userDisplayName = _data["userDisplayName"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): BatchRemoveLicenseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchRemoveLicenseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["userDisplayName"] = this.userDisplayName;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface IBatchRemoveLicenseItemDto {
    userId?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    userDisplayName?: string | undefined;
    userEmail?: string | undefined;
}

export class CreateAddOnOrderDto implements ICreateAddOnOrderDto {
    offerId?: string | undefined;
    quantity?: number;
    friendlyName?: string | undefined;
    termDuration?: string | undefined;
    billingCycle?: string | undefined;
    parentSubscriptionId?: string | undefined;

    constructor(data?: ICreateAddOnOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["offerId"];
            this.quantity = _data["quantity"];
            this.friendlyName = _data["friendlyName"];
            this.termDuration = _data["termDuration"];
            this.billingCycle = _data["billingCycle"];
            this.parentSubscriptionId = _data["parentSubscriptionId"];
        }
    }

    static fromJS(data: any): CreateAddOnOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddOnOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        data["quantity"] = this.quantity;
        data["friendlyName"] = this.friendlyName;
        data["termDuration"] = this.termDuration;
        data["billingCycle"] = this.billingCycle;
        data["parentSubscriptionId"] = this.parentSubscriptionId;
        return data;
    }
}

export interface ICreateAddOnOrderDto {
    offerId?: string | undefined;
    quantity?: number;
    friendlyName?: string | undefined;
    termDuration?: string | undefined;
    billingCycle?: string | undefined;
    parentSubscriptionId?: string | undefined;
}

export class CreateOrderDto implements ICreateOrderDto {
    offerId?: string | undefined;
    quantity?: number;
    friendlyName?: string | undefined;
    termDuration?: string | undefined;
    billingCycle?: string | undefined;
    customTermEndDate?: Date | undefined;

    constructor(data?: ICreateOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["offerId"];
            this.quantity = _data["quantity"];
            this.friendlyName = _data["friendlyName"];
            this.termDuration = _data["termDuration"];
            this.billingCycle = _data["billingCycle"];
            this.customTermEndDate = _data["customTermEndDate"] ? new Date(_data["customTermEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        data["quantity"] = this.quantity;
        data["friendlyName"] = this.friendlyName;
        data["termDuration"] = this.termDuration;
        data["billingCycle"] = this.billingCycle;
        data["customTermEndDate"] = this.customTermEndDate ? this.customTermEndDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateOrderDto {
    offerId?: string | undefined;
    quantity?: number;
    friendlyName?: string | undefined;
    termDuration?: string | undefined;
    billingCycle?: string | undefined;
    customTermEndDate?: Date | undefined;
}

export class CspAvailableOfferDto implements ICspAvailableOfferDto {
    offerId?: string | undefined;
    productName?: string | undefined;
    description?: string | undefined;
    minQuantity?: number;
    maxQuantity?: number;
    isNce?: boolean;
    isAddOn?: boolean;
    alreadySubscribed?: boolean;
    isSuspended?: boolean;
    pricingTiers?: CspOfferPricingTierDto[] | undefined;
    currencyCode?: string | undefined;

    constructor(data?: ICspAvailableOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["offerId"];
            this.productName = _data["productName"];
            this.description = _data["description"];
            this.minQuantity = _data["minQuantity"];
            this.maxQuantity = _data["maxQuantity"];
            this.isNce = _data["isNce"];
            this.isAddOn = _data["isAddOn"];
            this.alreadySubscribed = _data["alreadySubscribed"];
            this.isSuspended = _data["isSuspended"];
            if (Array.isArray(_data["pricingTiers"])) {
                this.pricingTiers = [] as any;
                for (let item of _data["pricingTiers"])
                    this.pricingTiers!.push(CspOfferPricingTierDto.fromJS(item));
            }
            this.currencyCode = _data["currencyCode"];
        }
    }

    static fromJS(data: any): CspAvailableOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspAvailableOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        data["productName"] = this.productName;
        data["description"] = this.description;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["isNce"] = this.isNce;
        data["isAddOn"] = this.isAddOn;
        data["alreadySubscribed"] = this.alreadySubscribed;
        data["isSuspended"] = this.isSuspended;
        if (Array.isArray(this.pricingTiers)) {
            data["pricingTiers"] = [];
            for (let item of this.pricingTiers)
                data["pricingTiers"].push(item ? item.toJSON() : undefined as any);
        }
        data["currencyCode"] = this.currencyCode;
        return data;
    }
}

export interface ICspAvailableOfferDto {
    offerId?: string | undefined;
    productName?: string | undefined;
    description?: string | undefined;
    minQuantity?: number;
    maxQuantity?: number;
    isNce?: boolean;
    isAddOn?: boolean;
    alreadySubscribed?: boolean;
    isSuspended?: boolean;
    pricingTiers?: CspOfferPricingTierDto[] | undefined;
    currencyCode?: string | undefined;
}

export class CspAvailableOffersResultDto implements ICspAvailableOffersResultDto {
    offers?: CspAvailableOfferDto[] | undefined;
    pricingEstimatesUnavailable?: boolean;

    constructor(data?: ICspAvailableOffersResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(CspAvailableOfferDto.fromJS(item));
            }
            this.pricingEstimatesUnavailable = _data["pricingEstimatesUnavailable"];
        }
    }

    static fromJS(data: any): CspAvailableOffersResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspAvailableOffersResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item ? item.toJSON() : undefined as any);
        }
        data["pricingEstimatesUnavailable"] = this.pricingEstimatesUnavailable;
        return data;
    }
}

export interface ICspAvailableOffersResultDto {
    offers?: CspAvailableOfferDto[] | undefined;
    pricingEstimatesUnavailable?: boolean;
}

export class CspCustomerProfileDto implements ICspCustomerProfileDto {
    id?: string | undefined;
    companyName?: string | undefined;
    domain?: string | undefined;
    billFirstName?: string | undefined;
    billLastName?: string | undefined;
    billEmail?: string | undefined;
    billPhoneNumber?: string | undefined;
    billAddressLine1?: string | undefined;
    billAddressLine2?: string | undefined;
    billCity?: string | undefined;
    billState?: string | undefined;
    billPostalCode?: string | undefined;
    billCountry?: string | undefined;
    relationship?: string | undefined;

    constructor(data?: ICspCustomerProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            this.domain = _data["domain"];
            this.billFirstName = _data["billFirstName"];
            this.billLastName = _data["billLastName"];
            this.billEmail = _data["billEmail"];
            this.billPhoneNumber = _data["billPhoneNumber"];
            this.billAddressLine1 = _data["billAddressLine1"];
            this.billAddressLine2 = _data["billAddressLine2"];
            this.billCity = _data["billCity"];
            this.billState = _data["billState"];
            this.billPostalCode = _data["billPostalCode"];
            this.billCountry = _data["billCountry"];
            this.relationship = _data["relationship"];
        }
    }

    static fromJS(data: any): CspCustomerProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspCustomerProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        data["domain"] = this.domain;
        data["billFirstName"] = this.billFirstName;
        data["billLastName"] = this.billLastName;
        data["billEmail"] = this.billEmail;
        data["billPhoneNumber"] = this.billPhoneNumber;
        data["billAddressLine1"] = this.billAddressLine1;
        data["billAddressLine2"] = this.billAddressLine2;
        data["billCity"] = this.billCity;
        data["billState"] = this.billState;
        data["billPostalCode"] = this.billPostalCode;
        data["billCountry"] = this.billCountry;
        data["relationship"] = this.relationship;
        return data;
    }
}

export interface ICspCustomerProfileDto {
    id?: string | undefined;
    companyName?: string | undefined;
    domain?: string | undefined;
    billFirstName?: string | undefined;
    billLastName?: string | undefined;
    billEmail?: string | undefined;
    billPhoneNumber?: string | undefined;
    billAddressLine1?: string | undefined;
    billAddressLine2?: string | undefined;
    billCity?: string | undefined;
    billState?: string | undefined;
    billPostalCode?: string | undefined;
    billCountry?: string | undefined;
    relationship?: string | undefined;
}

export class CspLicenseDto implements ICspLicenseDto {
    productId?: string | undefined;
    productName?: string | undefined;
    productPartNo?: string | undefined;
    licenseGroupId?: string | undefined;
    availableUnits?: number | undefined;
    activeUnits?: number | undefined;
    consumedUnits?: number | undefined;
    suspendedUnits?: number | undefined;
    totalUnits?: number | undefined;
    warningUnits?: number | undefined;
    capabilityStatus?: string | undefined;

    constructor(data?: ICspLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productPartNo = _data["productPartNo"];
            this.licenseGroupId = _data["licenseGroupId"];
            this.availableUnits = _data["availableUnits"];
            this.activeUnits = _data["activeUnits"];
            this.consumedUnits = _data["consumedUnits"];
            this.suspendedUnits = _data["suspendedUnits"];
            this.totalUnits = _data["totalUnits"];
            this.warningUnits = _data["warningUnits"];
            this.capabilityStatus = _data["capabilityStatus"];
        }
    }

    static fromJS(data: any): CspLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productPartNo"] = this.productPartNo;
        data["licenseGroupId"] = this.licenseGroupId;
        data["availableUnits"] = this.availableUnits;
        data["activeUnits"] = this.activeUnits;
        data["consumedUnits"] = this.consumedUnits;
        data["suspendedUnits"] = this.suspendedUnits;
        data["totalUnits"] = this.totalUnits;
        data["warningUnits"] = this.warningUnits;
        data["capabilityStatus"] = this.capabilityStatus;
        return data;
    }
}

export interface ICspLicenseDto {
    productId?: string | undefined;
    productName?: string | undefined;
    productPartNo?: string | undefined;
    licenseGroupId?: string | undefined;
    availableUnits?: number | undefined;
    activeUnits?: number | undefined;
    consumedUnits?: number | undefined;
    suspendedUnits?: number | undefined;
    totalUnits?: number | undefined;
    warningUnits?: number | undefined;
    capabilityStatus?: string | undefined;
}

export class CspOfferDto implements ICspOfferDto {
    offerId?: string | undefined;
    offerName?: string | undefined;
    minQuantity?: number | undefined;
    maxQuantity?: number | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    description?: string | undefined;
    categoryId?: string | undefined;
    categoryName?: string | undefined;
    billingType?: string | undefined;
    unitType?: string | undefined;
    billingFrequencies?: string[] | undefined;
    prerequisiteOfferIds?: string[] | undefined;
    isAddOn?: boolean;
    hasAddOns?: boolean;
    isTrial?: boolean;

    constructor(data?: ICspOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["offerId"];
            this.offerName = _data["offerName"];
            this.minQuantity = _data["minQuantity"];
            this.maxQuantity = _data["maxQuantity"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.billingType = _data["billingType"];
            this.unitType = _data["unitType"];
            if (Array.isArray(_data["billingFrequencies"])) {
                this.billingFrequencies = [] as any;
                for (let item of _data["billingFrequencies"])
                    this.billingFrequencies!.push(item);
            }
            if (Array.isArray(_data["prerequisiteOfferIds"])) {
                this.prerequisiteOfferIds = [] as any;
                for (let item of _data["prerequisiteOfferIds"])
                    this.prerequisiteOfferIds!.push(item);
            }
            this.isAddOn = _data["isAddOn"];
            this.hasAddOns = _data["hasAddOns"];
            this.isTrial = _data["isTrial"];
        }
    }

    static fromJS(data: any): CspOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        data["offerName"] = this.offerName;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["billingType"] = this.billingType;
        data["unitType"] = this.unitType;
        if (Array.isArray(this.billingFrequencies)) {
            data["billingFrequencies"] = [];
            for (let item of this.billingFrequencies)
                data["billingFrequencies"].push(item);
        }
        if (Array.isArray(this.prerequisiteOfferIds)) {
            data["prerequisiteOfferIds"] = [];
            for (let item of this.prerequisiteOfferIds)
                data["prerequisiteOfferIds"].push(item);
        }
        data["isAddOn"] = this.isAddOn;
        data["hasAddOns"] = this.hasAddOns;
        data["isTrial"] = this.isTrial;
        return data;
    }
}

export interface ICspOfferDto {
    offerId?: string | undefined;
    offerName?: string | undefined;
    minQuantity?: number | undefined;
    maxQuantity?: number | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    description?: string | undefined;
    categoryId?: string | undefined;
    categoryName?: string | undefined;
    billingType?: string | undefined;
    unitType?: string | undefined;
    billingFrequencies?: string[] | undefined;
    prerequisiteOfferIds?: string[] | undefined;
    isAddOn?: boolean;
    hasAddOns?: boolean;
    isTrial?: boolean;
}

export class CspOfferPricingTierDto implements ICspOfferPricingTierDto {
    termDuration?: string | undefined;
    billingOption?: string | undefined;
    price?: number;

    constructor(data?: ICspOfferPricingTierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termDuration = _data["termDuration"];
            this.billingOption = _data["billingOption"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CspOfferPricingTierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspOfferPricingTierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termDuration"] = this.termDuration;
        data["billingOption"] = this.billingOption;
        data["price"] = this.price;
        return data;
    }
}

export interface ICspOfferPricingTierDto {
    termDuration?: string | undefined;
    billingOption?: string | undefined;
    price?: number;
}

export class CspOrderDto implements ICspOrderDto {
    orderId?: string | undefined;
    status?: string | undefined;
    creationDate?: Date | undefined;
    billingCycle?: string | undefined;
    success?: boolean | undefined;
    errorCategory?: string | undefined;
    errorMessage?: string | undefined;
    lineItems?: CspOrderLineItemDto[] | undefined;

    constructor(data?: ICspOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.status = _data["status"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.billingCycle = _data["billingCycle"];
            this.success = _data["success"];
            this.errorCategory = _data["errorCategory"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(CspOrderLineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CspOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["status"] = this.status;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["billingCycle"] = this.billingCycle;
        data["success"] = this.success;
        data["errorCategory"] = this.errorCategory;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICspOrderDto {
    orderId?: string | undefined;
    status?: string | undefined;
    creationDate?: Date | undefined;
    billingCycle?: string | undefined;
    success?: boolean | undefined;
    errorCategory?: string | undefined;
    errorMessage?: string | undefined;
    lineItems?: CspOrderLineItemDto[] | undefined;
}

export class CspOrderLineItemDto implements ICspOrderLineItemDto {
    lineItemNumber?: number;
    offerId?: string | undefined;
    quantity?: number;
    friendlyName?: string | undefined;
    termDuration?: string | undefined;
    subscriptionId?: string | undefined;
    parentSubscriptionId?: string | undefined;

    constructor(data?: ICspOrderLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineItemNumber = _data["lineItemNumber"];
            this.offerId = _data["offerId"];
            this.quantity = _data["quantity"];
            this.friendlyName = _data["friendlyName"];
            this.termDuration = _data["termDuration"];
            this.subscriptionId = _data["subscriptionId"];
            this.parentSubscriptionId = _data["parentSubscriptionId"];
        }
    }

    static fromJS(data: any): CspOrderLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspOrderLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineItemNumber"] = this.lineItemNumber;
        data["offerId"] = this.offerId;
        data["quantity"] = this.quantity;
        data["friendlyName"] = this.friendlyName;
        data["termDuration"] = this.termDuration;
        data["subscriptionId"] = this.subscriptionId;
        data["parentSubscriptionId"] = this.parentSubscriptionId;
        return data;
    }
}

export interface ICspOrderLineItemDto {
    lineItemNumber?: number;
    offerId?: string | undefined;
    quantity?: number;
    friendlyName?: string | undefined;
    termDuration?: string | undefined;
    subscriptionId?: string | undefined;
    parentSubscriptionId?: string | undefined;
}

export class CspRefundableQuantityDetailDto implements ICspRefundableQuantityDetailDto {
    quantity?: number | undefined;
    allowedUntilDateTime?: Date | undefined;

    constructor(data?: ICspRefundableQuantityDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.allowedUntilDateTime = _data["allowedUntilDateTime"] ? new Date(_data["allowedUntilDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CspRefundableQuantityDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspRefundableQuantityDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["allowedUntilDateTime"] = this.allowedUntilDateTime ? this.allowedUntilDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ICspRefundableQuantityDetailDto {
    quantity?: number | undefined;
    allowedUntilDateTime?: Date | undefined;
}

export class CspRefundableQuantityDto implements ICspRefundableQuantityDto {
    totalQuantity?: number | undefined;
    details?: CspRefundableQuantityDetailDto[] | undefined;

    constructor(data?: ICspRefundableQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalQuantity = _data["totalQuantity"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(CspRefundableQuantityDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CspRefundableQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspRefundableQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalQuantity"] = this.totalQuantity;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICspRefundableQuantityDto {
    totalQuantity?: number | undefined;
    details?: CspRefundableQuantityDetailDto[] | undefined;
}

export class CspScheduledActionDto implements ICspScheduledActionDto {
    scheduleType?: string | undefined;
    actionType?: string | undefined;
    effectiveDate?: Date | undefined;

    constructor(data?: ICspScheduledActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleType = _data["scheduleType"];
            this.actionType = _data["actionType"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CspScheduledActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspScheduledActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleType"] = this.scheduleType;
        data["actionType"] = this.actionType;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICspScheduledActionDto {
    scheduleType?: string | undefined;
    actionType?: string | undefined;
    effectiveDate?: Date | undefined;
}

export class CspScheduledNextTermInstructionsDto implements ICspScheduledNextTermInstructionsDto {
    product?: CspScheduledNextTermProductDto;
    quantity?: number | undefined;
    customTermEndDate?: Date | undefined;

    constructor(data?: ICspScheduledNextTermInstructionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? CspScheduledNextTermProductDto.fromJS(_data["product"]) : undefined as any;
            this.quantity = _data["quantity"];
            this.customTermEndDate = _data["customTermEndDate"] ? new Date(_data["customTermEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CspScheduledNextTermInstructionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspScheduledNextTermInstructionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        data["quantity"] = this.quantity;
        data["customTermEndDate"] = this.customTermEndDate ? this.customTermEndDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICspScheduledNextTermInstructionsDto {
    product?: CspScheduledNextTermProductDto;
    quantity?: number | undefined;
    customTermEndDate?: Date | undefined;
}

export class CspScheduledNextTermProductDto implements ICspScheduledNextTermProductDto {
    productId?: string | undefined;
    skuId?: string | undefined;
    availabilityId?: string | undefined;
    billingCycle?: string | undefined;
    termDuration?: string | undefined;

    constructor(data?: ICspScheduledNextTermProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.skuId = _data["skuId"];
            this.availabilityId = _data["availabilityId"];
            this.billingCycle = _data["billingCycle"];
            this.termDuration = _data["termDuration"];
        }
    }

    static fromJS(data: any): CspScheduledNextTermProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspScheduledNextTermProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["skuId"] = this.skuId;
        data["availabilityId"] = this.availabilityId;
        data["billingCycle"] = this.billingCycle;
        data["termDuration"] = this.termDuration;
        return data;
    }
}

export interface ICspScheduledNextTermProductDto {
    productId?: string | undefined;
    skuId?: string | undefined;
    availabilityId?: string | undefined;
    billingCycle?: string | undefined;
    termDuration?: string | undefined;
}

export class CspSelfServiceSummaryDto implements ICspSelfServiceSummaryDto {
    tenants?: CspTenantSummaryDto[] | undefined;
    pricingEstimatesUnavailable?: boolean;
    attestationDeadlineDisplayDate?: Date | undefined;

    constructor(data?: ICspSelfServiceSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(CspTenantSummaryDto.fromJS(item));
            }
            this.pricingEstimatesUnavailable = _data["pricingEstimatesUnavailable"];
            this.attestationDeadlineDisplayDate = _data["attestationDeadlineDisplayDate"] ? new Date(_data["attestationDeadlineDisplayDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CspSelfServiceSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspSelfServiceSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        data["pricingEstimatesUnavailable"] = this.pricingEstimatesUnavailable;
        data["attestationDeadlineDisplayDate"] = this.attestationDeadlineDisplayDate ? this.attestationDeadlineDisplayDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICspSelfServiceSummaryDto {
    tenants?: CspTenantSummaryDto[] | undefined;
    pricingEstimatesUnavailable?: boolean;
    attestationDeadlineDisplayDate?: Date | undefined;
}

export class CspSubscriptionDto implements ICspSubscriptionDto {
    subscriptionId?: string | undefined;
    friendlyName?: string | undefined;
    status?: string | undefined;
    offerId?: string | undefined;
    productId?: string | undefined;
    quantity?: number | undefined;
    effectiveStartDate?: Date | undefined;
    commitmentEndDateTime?: Date | undefined;
    billingCycle?: string | undefined;
    productName?: string | undefined;
    autoRenewEnabled?: boolean | undefined;
    termDuration?: string | undefined;
    productType?: string | undefined;
    contractType?: string | undefined;
    orderId?: string | undefined;
    parentSubscriptionId?: string | undefined;
    isTrial?: boolean | undefined;
    actions?: string[] | undefined;
    suspensionReasons?: string[] | undefined;
    refundableQuantity?: CspRefundableQuantityDto;
    scheduledNextTermInstructions?: CspScheduledNextTermInstructionsDto;
    renewalTermDuration?: string | undefined;
    scheduledActions?: CspScheduledActionDto[] | undefined;
    unitPrice?: number | undefined;
    currencyCode?: string | undefined;
    pricingTiers?: CspOfferPricingTierDto[] | undefined;
    addons?: CspSubscriptionDto[] | undefined;
    isNce?: boolean;
    totalRefundableQuantity?: number | undefined;
    cancellationAllowedUntilDate?: Date | undefined;
    isCancellable?: boolean | undefined;
    seatReductionFloor?: number | undefined;

    constructor(data?: ICspSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.friendlyName = _data["friendlyName"];
            this.status = _data["status"];
            this.offerId = _data["offerId"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.effectiveStartDate = _data["effectiveStartDate"] ? new Date(_data["effectiveStartDate"].toString()) : undefined as any;
            this.commitmentEndDateTime = _data["commitmentEndDateTime"] ? new Date(_data["commitmentEndDateTime"].toString()) : undefined as any;
            this.billingCycle = _data["billingCycle"];
            this.productName = _data["productName"];
            this.autoRenewEnabled = _data["autoRenewEnabled"];
            this.termDuration = _data["termDuration"];
            this.productType = _data["productType"];
            this.contractType = _data["contractType"];
            this.orderId = _data["orderId"];
            this.parentSubscriptionId = _data["parentSubscriptionId"];
            this.isTrial = _data["isTrial"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
            if (Array.isArray(_data["suspensionReasons"])) {
                this.suspensionReasons = [] as any;
                for (let item of _data["suspensionReasons"])
                    this.suspensionReasons!.push(item);
            }
            this.refundableQuantity = _data["refundableQuantity"] ? CspRefundableQuantityDto.fromJS(_data["refundableQuantity"]) : undefined as any;
            this.scheduledNextTermInstructions = _data["scheduledNextTermInstructions"] ? CspScheduledNextTermInstructionsDto.fromJS(_data["scheduledNextTermInstructions"]) : undefined as any;
            this.renewalTermDuration = _data["renewalTermDuration"];
            if (Array.isArray(_data["scheduledActions"])) {
                this.scheduledActions = [] as any;
                for (let item of _data["scheduledActions"])
                    this.scheduledActions!.push(CspScheduledActionDto.fromJS(item));
            }
            this.unitPrice = _data["unitPrice"];
            this.currencyCode = _data["currencyCode"];
            if (Array.isArray(_data["pricingTiers"])) {
                this.pricingTiers = [] as any;
                for (let item of _data["pricingTiers"])
                    this.pricingTiers!.push(CspOfferPricingTierDto.fromJS(item));
            }
            if (Array.isArray(_data["addons"])) {
                this.addons = [] as any;
                for (let item of _data["addons"])
                    this.addons!.push(CspSubscriptionDto.fromJS(item));
            }
            this.isNce = _data["isNce"];
            this.totalRefundableQuantity = _data["totalRefundableQuantity"];
            this.cancellationAllowedUntilDate = _data["cancellationAllowedUntilDate"] ? new Date(_data["cancellationAllowedUntilDate"].toString()) : undefined as any;
            this.isCancellable = _data["isCancellable"];
            this.seatReductionFloor = _data["seatReductionFloor"];
        }
    }

    static fromJS(data: any): CspSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["friendlyName"] = this.friendlyName;
        data["status"] = this.status;
        data["offerId"] = this.offerId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["effectiveStartDate"] = this.effectiveStartDate ? this.effectiveStartDate.toISOString() : undefined as any;
        data["commitmentEndDateTime"] = this.commitmentEndDateTime ? this.commitmentEndDateTime.toISOString() : undefined as any;
        data["billingCycle"] = this.billingCycle;
        data["productName"] = this.productName;
        data["autoRenewEnabled"] = this.autoRenewEnabled;
        data["termDuration"] = this.termDuration;
        data["productType"] = this.productType;
        data["contractType"] = this.contractType;
        data["orderId"] = this.orderId;
        data["parentSubscriptionId"] = this.parentSubscriptionId;
        data["isTrial"] = this.isTrial;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        if (Array.isArray(this.suspensionReasons)) {
            data["suspensionReasons"] = [];
            for (let item of this.suspensionReasons)
                data["suspensionReasons"].push(item);
        }
        data["refundableQuantity"] = this.refundableQuantity ? this.refundableQuantity.toJSON() : undefined as any;
        data["scheduledNextTermInstructions"] = this.scheduledNextTermInstructions ? this.scheduledNextTermInstructions.toJSON() : undefined as any;
        data["renewalTermDuration"] = this.renewalTermDuration;
        if (Array.isArray(this.scheduledActions)) {
            data["scheduledActions"] = [];
            for (let item of this.scheduledActions)
                data["scheduledActions"].push(item ? item.toJSON() : undefined as any);
        }
        data["unitPrice"] = this.unitPrice;
        data["currencyCode"] = this.currencyCode;
        if (Array.isArray(this.pricingTiers)) {
            data["pricingTiers"] = [];
            for (let item of this.pricingTiers)
                data["pricingTiers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.addons)) {
            data["addons"] = [];
            for (let item of this.addons)
                data["addons"].push(item ? item.toJSON() : undefined as any);
        }
        data["isNce"] = this.isNce;
        data["totalRefundableQuantity"] = this.totalRefundableQuantity;
        data["cancellationAllowedUntilDate"] = this.cancellationAllowedUntilDate ? this.cancellationAllowedUntilDate.toISOString() : undefined as any;
        data["isCancellable"] = this.isCancellable;
        data["seatReductionFloor"] = this.seatReductionFloor;
        return data;
    }
}

export interface ICspSubscriptionDto {
    subscriptionId?: string | undefined;
    friendlyName?: string | undefined;
    status?: string | undefined;
    offerId?: string | undefined;
    productId?: string | undefined;
    quantity?: number | undefined;
    effectiveStartDate?: Date | undefined;
    commitmentEndDateTime?: Date | undefined;
    billingCycle?: string | undefined;
    productName?: string | undefined;
    autoRenewEnabled?: boolean | undefined;
    termDuration?: string | undefined;
    productType?: string | undefined;
    contractType?: string | undefined;
    orderId?: string | undefined;
    parentSubscriptionId?: string | undefined;
    isTrial?: boolean | undefined;
    actions?: string[] | undefined;
    suspensionReasons?: string[] | undefined;
    refundableQuantity?: CspRefundableQuantityDto;
    scheduledNextTermInstructions?: CspScheduledNextTermInstructionsDto;
    renewalTermDuration?: string | undefined;
    scheduledActions?: CspScheduledActionDto[] | undefined;
    unitPrice?: number | undefined;
    currencyCode?: string | undefined;
    pricingTiers?: CspOfferPricingTierDto[] | undefined;
    addons?: CspSubscriptionDto[] | undefined;
    isNce?: boolean;
    totalRefundableQuantity?: number | undefined;
    cancellationAllowedUntilDate?: Date | undefined;
    isCancellable?: boolean | undefined;
    seatReductionFloor?: number | undefined;
}

export enum CspTenantAgreementStatus {
    Signed = "Signed",
    Unsigned = "Unsigned",
    NoResellerRelationship = "NoResellerRelationship",
    Unavailable = "Unavailable",
}

export class CspTenantSubscriptionsDto implements ICspTenantSubscriptionsDto {
    cspCustId?: string | undefined;
    primaryDomain?: string | undefined;
    businessType?: string | undefined;
    subscriptions?: CspSubscriptionDto[] | undefined;
    agreementStatus?: CspTenantAgreementStatus | undefined;

    constructor(data?: ICspTenantSubscriptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cspCustId = _data["cspCustId"];
            this.primaryDomain = _data["primaryDomain"];
            this.businessType = _data["businessType"];
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(CspSubscriptionDto.fromJS(item));
            }
            this.agreementStatus = _data["agreementStatus"];
        }
    }

    static fromJS(data: any): CspTenantSubscriptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspTenantSubscriptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cspCustId"] = this.cspCustId;
        data["primaryDomain"] = this.primaryDomain;
        data["businessType"] = this.businessType;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item ? item.toJSON() : undefined as any);
        }
        data["agreementStatus"] = this.agreementStatus;
        return data;
    }
}

export interface ICspTenantSubscriptionsDto {
    cspCustId?: string | undefined;
    primaryDomain?: string | undefined;
    businessType?: string | undefined;
    subscriptions?: CspSubscriptionDto[] | undefined;
    agreementStatus?: CspTenantAgreementStatus | undefined;
}

export class CspTenantSummaryDto implements ICspTenantSummaryDto {
    cspCustId?: string | undefined;
    primaryDomain?: string | undefined;
    businessType?: string | undefined;
    subscriptions?: CspSubscriptionDto[] | undefined;
    availableOfferCount?: number;
    agreementStatus?: CspTenantAgreementStatus | undefined;

    constructor(data?: ICspTenantSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cspCustId = _data["cspCustId"];
            this.primaryDomain = _data["primaryDomain"];
            this.businessType = _data["businessType"];
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(CspSubscriptionDto.fromJS(item));
            }
            this.availableOfferCount = _data["availableOfferCount"];
            this.agreementStatus = _data["agreementStatus"];
        }
    }

    static fromJS(data: any): CspTenantSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspTenantSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cspCustId"] = this.cspCustId;
        data["primaryDomain"] = this.primaryDomain;
        data["businessType"] = this.businessType;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item ? item.toJSON() : undefined as any);
        }
        data["availableOfferCount"] = this.availableOfferCount;
        data["agreementStatus"] = this.agreementStatus;
        return data;
    }
}

export interface ICspTenantSummaryDto {
    cspCustId?: string | undefined;
    primaryDomain?: string | undefined;
    businessType?: string | undefined;
    subscriptions?: CspSubscriptionDto[] | undefined;
    availableOfferCount?: number;
    agreementStatus?: CspTenantAgreementStatus | undefined;
}

export class CspUserDto implements ICspUserDto {
    userId?: string | undefined;
    userPrincipalName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    usageLocation?: string | undefined;
    userDomainType?: string | undefined;
    softDeletionDate?: Date | undefined;
    licenseFlag?: boolean | undefined;
    hasSeat?: boolean | undefined;

    constructor(data?: ICspUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.usageLocation = _data["usageLocation"];
            this.userDomainType = _data["userDomainType"];
            this.softDeletionDate = _data["softDeletionDate"] ? new Date(_data["softDeletionDate"].toString()) : undefined as any;
            this.licenseFlag = _data["licenseFlag"];
            this.hasSeat = _data["hasSeat"];
        }
    }

    static fromJS(data: any): CspUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userPrincipalName"] = this.userPrincipalName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["usageLocation"] = this.usageLocation;
        data["userDomainType"] = this.userDomainType;
        data["softDeletionDate"] = this.softDeletionDate ? this.softDeletionDate.toISOString() : undefined as any;
        data["licenseFlag"] = this.licenseFlag;
        data["hasSeat"] = this.hasSeat;
        return data;
    }
}

export interface ICspUserDto {
    userId?: string | undefined;
    userPrincipalName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    usageLocation?: string | undefined;
    userDomainType?: string | undefined;
    softDeletionDate?: Date | undefined;
    licenseFlag?: boolean | undefined;
    hasSeat?: boolean | undefined;
}

export class CspUserLicenseDto implements ICspUserLicenseDto {
    productId?: string | undefined;
    productName?: string | undefined;
    productPartNo?: string | undefined;
    licenseGroupId?: string | undefined;

    constructor(data?: ICspUserLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productPartNo = _data["productPartNo"];
            this.licenseGroupId = _data["licenseGroupId"];
        }
    }

    static fromJS(data: any): CspUserLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspUserLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productPartNo"] = this.productPartNo;
        data["licenseGroupId"] = this.licenseGroupId;
        return data;
    }
}

export interface ICspUserLicenseDto {
    productId?: string | undefined;
    productName?: string | undefined;
    productPartNo?: string | undefined;
    licenseGroupId?: string | undefined;
}

export class CspUserPageDto implements ICspUserPageDto {
    users?: CspUserDto[] | undefined;
    continuationToken?: string | undefined;

    constructor(data?: ICspUserPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(CspUserDto.fromJS(item));
            }
            this.continuationToken = _data["continuationToken"];
        }
    }

    static fromJS(data: any): CspUserPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CspUserPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        data["continuationToken"] = this.continuationToken;
        return data;
    }
}

export interface ICspUserPageDto {
    users?: CspUserDto[] | undefined;
    continuationToken?: string | undefined;
}

export class DapRelationshipDto implements IDapRelationshipDto {
    id?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    status?: string | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    autoExtendDuration?: string | undefined;
    unifiedRoles?: string[] | undefined;

    constructor(data?: IDapRelationshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.status = _data["status"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : undefined as any;
            this.autoExtendDuration = _data["autoExtendDuration"];
            if (Array.isArray(_data["unifiedRoles"])) {
                this.unifiedRoles = [] as any;
                for (let item of _data["unifiedRoles"])
                    this.unifiedRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): DapRelationshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new DapRelationshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["status"] = this.status;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["autoExtendDuration"] = this.autoExtendDuration;
        if (Array.isArray(this.unifiedRoles)) {
            data["unifiedRoles"] = [];
            for (let item of this.unifiedRoles)
                data["unifiedRoles"].push(item);
        }
        return data;
    }
}

export interface IDapRelationshipDto {
    id?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    status?: string | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    autoExtendDuration?: string | undefined;
    unifiedRoles?: string[] | undefined;
}

export class ResolvedOfferDto implements IResolvedOfferDto {
    originalOfferId?: string | undefined;
    resolvedOfferId?: string | undefined;
    isResolved?: boolean;

    constructor(data?: IResolvedOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalOfferId = _data["originalOfferId"];
            this.resolvedOfferId = _data["resolvedOfferId"];
            this.isResolved = _data["isResolved"];
        }
    }

    static fromJS(data: any): ResolvedOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvedOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalOfferId"] = this.originalOfferId;
        data["resolvedOfferId"] = this.resolvedOfferId;
        data["isResolved"] = this.isResolved;
        return data;
    }
}

export interface IResolvedOfferDto {
    originalOfferId?: string | undefined;
    resolvedOfferId?: string | undefined;
    isResolved?: boolean;
}

export class ScheduleSubscriptionChangeDto implements IScheduleSubscriptionChangeDto {
    newQuantity?: number | undefined;
    customTermEndDate?: Date | undefined;
    newBillingCycle?: string | undefined;
    newTermDuration?: string | undefined;

    constructor(data?: IScheduleSubscriptionChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newQuantity = _data["newQuantity"];
            this.customTermEndDate = _data["customTermEndDate"] ? new Date(_data["customTermEndDate"].toString()) : undefined as any;
            this.newBillingCycle = _data["newBillingCycle"];
            this.newTermDuration = _data["newTermDuration"];
        }
    }

    static fromJS(data: any): ScheduleSubscriptionChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleSubscriptionChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newQuantity"] = this.newQuantity;
        data["customTermEndDate"] = this.customTermEndDate ? this.customTermEndDate.toISOString() : undefined as any;
        data["newBillingCycle"] = this.newBillingCycle;
        data["newTermDuration"] = this.newTermDuration;
        return data;
    }
}

export interface IScheduleSubscriptionChangeDto {
    newQuantity?: number | undefined;
    customTermEndDate?: Date | undefined;
    newBillingCycle?: string | undefined;
    newTermDuration?: string | undefined;
}

export class GetOrderReturnEligibilityBatchRequest implements IGetOrderReturnEligibilityBatchRequest {
    biOrderIds?: number[] | undefined;
    orgUnitId?: number | undefined;

    constructor(data?: IGetOrderReturnEligibilityBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["biOrderIds"])) {
                this.biOrderIds = [] as any;
                for (let item of _data["biOrderIds"])
                    this.biOrderIds!.push(item);
            }
            this.orgUnitId = _data["orgUnitId"];
        }
    }

    static fromJS(data: any): GetOrderReturnEligibilityBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderReturnEligibilityBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.biOrderIds)) {
            data["biOrderIds"] = [];
            for (let item of this.biOrderIds)
                data["biOrderIds"].push(item);
        }
        data["orgUnitId"] = this.orgUnitId;
        return data;
    }
}

export interface IGetOrderReturnEligibilityBatchRequest {
    biOrderIds?: number[] | undefined;
    orgUnitId?: number | undefined;
}

export class GetPendingOrderApprovalsResponse implements IGetPendingOrderApprovalsResponse {
    items?: OrderApprovalPendingItemDto[] | undefined;

    constructor(data?: IGetPendingOrderApprovalsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderApprovalPendingItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPendingOrderApprovalsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPendingOrderApprovalsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPendingOrderApprovalsResponse {
    items?: OrderApprovalPendingItemDto[] | undefined;
}

export class OrderRmaContactRequest implements IOrderRmaContactRequest {
    fullName!: string;
    emailAddress!: string;
    phoneNumber?: string | undefined;

    constructor(data?: IOrderRmaContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): OrderRmaContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRmaContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IOrderRmaContactRequest {
    fullName: string;
    emailAddress: string;
    phoneNumber?: string | undefined;
}

export class OrdersFilterRequest implements IOrdersFilterRequest {
    field!: string | undefined;
    limit?: number;
    query?: string | undefined;
    orgUnitId?: number | undefined;
    crmAccountId?: string | undefined;
    ordersViewType?: OrdersViewType;

    constructor(data?: IOrdersFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.limit = _data["limit"];
            this.query = _data["query"];
            this.orgUnitId = _data["orgUnitId"];
            this.crmAccountId = _data["crmAccountId"];
            this.ordersViewType = _data["ordersViewType"];
        }
    }

    static fromJS(data: any): OrdersFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["limit"] = this.limit;
        data["query"] = this.query;
        data["orgUnitId"] = this.orgUnitId;
        data["crmAccountId"] = this.crmAccountId;
        data["ordersViewType"] = this.ordersViewType;
        return data;
    }
}

export interface IOrdersFilterRequest {
    field: string | undefined;
    limit?: number;
    query?: string | undefined;
    orgUnitId?: number | undefined;
    crmAccountId?: string | undefined;
    ordersViewType?: OrdersViewType;
}

export class RecentOrdersRequest implements IRecentOrdersRequest {
    view?: OrdersViewType;
    employeeId?: number | undefined;
    numberOfDays?: number | undefined;
    top?: number | undefined;

    constructor(data?: IRecentOrdersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.view = _data["view"];
            this.employeeId = _data["employeeId"];
            this.numberOfDays = _data["numberOfDays"];
            this.top = _data["top"];
        }
    }

    static fromJS(data: any): RecentOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecentOrdersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["view"] = this.view;
        data["employeeId"] = this.employeeId;
        data["numberOfDays"] = this.numberOfDays;
        data["top"] = this.top;
        return data;
    }
}

export interface IRecentOrdersRequest {
    view?: OrdersViewType;
    employeeId?: number | undefined;
    numberOfDays?: number | undefined;
    top?: number | undefined;
}

export class SearchInvoicesFilterValuesRequest implements ISearchInvoicesFilterValuesRequest {
    view!: InvoicesViewType;
    field!: string | undefined;
    query!: string | undefined;
    from!: Date;
    to!: Date;
    limit?: number;

    constructor(data?: ISearchInvoicesFilterValuesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.view = _data["view"];
            this.field = _data["field"];
            this.query = _data["query"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): SearchInvoicesFilterValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchInvoicesFilterValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["view"] = this.view;
        data["field"] = this.field;
        data["query"] = this.query;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ISearchInvoicesFilterValuesRequest {
    view: InvoicesViewType;
    field: string | undefined;
    query: string | undefined;
    from: Date;
    to: Date;
    limit?: number;
}

export class SearchInvoicesRequest implements ISearchInvoicesRequest {
    view?: InvoicesViewType;
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: SearchInvoicesRequestFilter;
    searchFilterExclude?: SearchInvoicesRequestFilter;

    constructor(data?: ISearchInvoicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.view = _data["view"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortByColumn = _data["sortByColumn"];
            this.isDescending = _data["isDescending"];
            this.afterKey = _data["afterKey"];
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? SearchInvoicesRequestFilter.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? SearchInvoicesRequestFilter.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchInvoicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchInvoicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["view"] = this.view;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortByColumn"] = this.sortByColumn;
        data["isDescending"] = this.isDescending;
        data["afterKey"] = this.afterKey;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchInvoicesRequest {
    view?: InvoicesViewType;
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: SearchInvoicesRequestFilter;
    searchFilterExclude?: SearchInvoicesRequestFilter;
}

export class SearchInvoicesRequestFilter implements ISearchInvoicesRequestFilter {
    storefront?: string[] | undefined;
    invoiceDateRange?: string[] | undefined;
    salesOrder?: string[] | undefined;
    currency?: string[] | undefined;

    constructor(data?: ISearchInvoicesRequestFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["storefront"])) {
                this.storefront = [] as any;
                for (let item of _data["storefront"])
                    this.storefront!.push(item);
            }
            if (Array.isArray(_data["invoiceDateRange"])) {
                this.invoiceDateRange = [] as any;
                for (let item of _data["invoiceDateRange"])
                    this.invoiceDateRange!.push(item);
            }
            if (Array.isArray(_data["salesOrder"])) {
                this.salesOrder = [] as any;
                for (let item of _data["salesOrder"])
                    this.salesOrder!.push(item);
            }
            if (Array.isArray(_data["currency"])) {
                this.currency = [] as any;
                for (let item of _data["currency"])
                    this.currency!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchInvoicesRequestFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SearchInvoicesRequestFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storefront)) {
            data["storefront"] = [];
            for (let item of this.storefront)
                data["storefront"].push(item);
        }
        if (Array.isArray(this.invoiceDateRange)) {
            data["invoiceDateRange"] = [];
            for (let item of this.invoiceDateRange)
                data["invoiceDateRange"].push(item);
        }
        if (Array.isArray(this.salesOrder)) {
            data["salesOrder"] = [];
            for (let item of this.salesOrder)
                data["salesOrder"].push(item);
        }
        if (Array.isArray(this.currency)) {
            data["currency"] = [];
            for (let item of this.currency)
                data["currency"].push(item);
        }
        return data;
    }
}

export interface ISearchInvoicesRequestFilter {
    storefront?: string[] | undefined;
    invoiceDateRange?: string[] | undefined;
    salesOrder?: string[] | undefined;
    currency?: string[] | undefined;
}

export class SearchOrderRequestFilter implements ISearchOrderRequestFilter {
    crmAccountIds?: string[] | undefined;
    orgUnitIds?: number[] | undefined;
    orderDate?: Date | undefined;
    orderNumber?: string[] | undefined;
    orderedBy?: string[] | undefined;
    purchaseOrderNumber?: string[] | undefined;
    shipTo?: string[] | undefined;
    status?: string[] | undefined;
    totalItems?: number | undefined;
    orderDateRange?: string[] | undefined;
    biOrderIds?: number[] | undefined;
    webOrderIds?: number[] | undefined;

    constructor(data?: ISearchOrderRequestFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["crmAccountIds"])) {
                this.crmAccountIds = [] as any;
                for (let item of _data["crmAccountIds"])
                    this.crmAccountIds!.push(item);
            }
            if (Array.isArray(_data["orgUnitIds"])) {
                this.orgUnitIds = [] as any;
                for (let item of _data["orgUnitIds"])
                    this.orgUnitIds!.push(item);
            }
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : undefined as any;
            if (Array.isArray(_data["orderNumber"])) {
                this.orderNumber = [] as any;
                for (let item of _data["orderNumber"])
                    this.orderNumber!.push(item);
            }
            if (Array.isArray(_data["orderedBy"])) {
                this.orderedBy = [] as any;
                for (let item of _data["orderedBy"])
                    this.orderedBy!.push(item);
            }
            if (Array.isArray(_data["purchaseOrderNumber"])) {
                this.purchaseOrderNumber = [] as any;
                for (let item of _data["purchaseOrderNumber"])
                    this.purchaseOrderNumber!.push(item);
            }
            if (Array.isArray(_data["shipTo"])) {
                this.shipTo = [] as any;
                for (let item of _data["shipTo"])
                    this.shipTo!.push(item);
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.totalItems = _data["totalItems"];
            if (Array.isArray(_data["orderDateRange"])) {
                this.orderDateRange = [] as any;
                for (let item of _data["orderDateRange"])
                    this.orderDateRange!.push(item);
            }
            if (Array.isArray(_data["biOrderIds"])) {
                this.biOrderIds = [] as any;
                for (let item of _data["biOrderIds"])
                    this.biOrderIds!.push(item);
            }
            if (Array.isArray(_data["webOrderIds"])) {
                this.webOrderIds = [] as any;
                for (let item of _data["webOrderIds"])
                    this.webOrderIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchOrderRequestFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOrderRequestFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.crmAccountIds)) {
            data["crmAccountIds"] = [];
            for (let item of this.crmAccountIds)
                data["crmAccountIds"].push(item);
        }
        if (Array.isArray(this.orgUnitIds)) {
            data["orgUnitIds"] = [];
            for (let item of this.orgUnitIds)
                data["orgUnitIds"].push(item);
        }
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined as any;
        if (Array.isArray(this.orderNumber)) {
            data["orderNumber"] = [];
            for (let item of this.orderNumber)
                data["orderNumber"].push(item);
        }
        if (Array.isArray(this.orderedBy)) {
            data["orderedBy"] = [];
            for (let item of this.orderedBy)
                data["orderedBy"].push(item);
        }
        if (Array.isArray(this.purchaseOrderNumber)) {
            data["purchaseOrderNumber"] = [];
            for (let item of this.purchaseOrderNumber)
                data["purchaseOrderNumber"].push(item);
        }
        if (Array.isArray(this.shipTo)) {
            data["shipTo"] = [];
            for (let item of this.shipTo)
                data["shipTo"].push(item);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["totalItems"] = this.totalItems;
        if (Array.isArray(this.orderDateRange)) {
            data["orderDateRange"] = [];
            for (let item of this.orderDateRange)
                data["orderDateRange"].push(item);
        }
        if (Array.isArray(this.biOrderIds)) {
            data["biOrderIds"] = [];
            for (let item of this.biOrderIds)
                data["biOrderIds"].push(item);
        }
        if (Array.isArray(this.webOrderIds)) {
            data["webOrderIds"] = [];
            for (let item of this.webOrderIds)
                data["webOrderIds"].push(item);
        }
        return data;
    }
}

export interface ISearchOrderRequestFilter {
    crmAccountIds?: string[] | undefined;
    orgUnitIds?: number[] | undefined;
    orderDate?: Date | undefined;
    orderNumber?: string[] | undefined;
    orderedBy?: string[] | undefined;
    purchaseOrderNumber?: string[] | undefined;
    shipTo?: string[] | undefined;
    status?: string[] | undefined;
    totalItems?: number | undefined;
    orderDateRange?: string[] | undefined;
    biOrderIds?: number[] | undefined;
    webOrderIds?: number[] | undefined;
}

export class SearchOrdersRequest implements ISearchOrdersRequest {
    ordersViewType?: OrdersViewType;
    orgUnitId?: number | undefined;
    crmAccountId?: string | undefined;
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: SearchOrderRequestFilter;
    searchFilterExclude?: SearchOrderRequestFilter;

    constructor(data?: ISearchOrdersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordersViewType = _data["ordersViewType"];
            this.orgUnitId = _data["orgUnitId"];
            this.crmAccountId = _data["crmAccountId"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortByColumn = _data["sortByColumn"];
            this.isDescending = _data["isDescending"];
            this.afterKey = _data["afterKey"];
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? SearchOrderRequestFilter.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? SearchOrderRequestFilter.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOrdersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordersViewType"] = this.ordersViewType;
        data["orgUnitId"] = this.orgUnitId;
        data["crmAccountId"] = this.crmAccountId;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortByColumn"] = this.sortByColumn;
        data["isDescending"] = this.isDescending;
        data["afterKey"] = this.afterKey;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchOrdersRequest {
    ordersViewType?: OrdersViewType;
    orgUnitId?: number | undefined;
    crmAccountId?: string | undefined;
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: SearchOrderRequestFilter;
    searchFilterExclude?: SearchOrderRequestFilter;
}

export class SubmitOrderApprovalDecisionRequest implements ISubmitOrderApprovalDecisionRequest {
    approvalPathStepId?: number;
    approvalStateCode?: string | undefined;
    comments?: string | undefined;
    questionAnswers?: OrderApprovalQuestionAnswerDto[] | undefined;
    extraRecipients?: string[] | undefined;

    constructor(data?: ISubmitOrderApprovalDecisionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvalPathStepId = _data["approvalPathStepId"];
            this.approvalStateCode = _data["approvalStateCode"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["questionAnswers"])) {
                this.questionAnswers = [] as any;
                for (let item of _data["questionAnswers"])
                    this.questionAnswers!.push(OrderApprovalQuestionAnswerDto.fromJS(item));
            }
            if (Array.isArray(_data["extraRecipients"])) {
                this.extraRecipients = [] as any;
                for (let item of _data["extraRecipients"])
                    this.extraRecipients!.push(item);
            }
        }
    }

    static fromJS(data: any): SubmitOrderApprovalDecisionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitOrderApprovalDecisionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalPathStepId"] = this.approvalPathStepId;
        data["approvalStateCode"] = this.approvalStateCode;
        data["comments"] = this.comments;
        if (Array.isArray(this.questionAnswers)) {
            data["questionAnswers"] = [];
            for (let item of this.questionAnswers)
                data["questionAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.extraRecipients)) {
            data["extraRecipients"] = [];
            for (let item of this.extraRecipients)
                data["extraRecipients"].push(item);
        }
        return data;
    }
}

export interface ISubmitOrderApprovalDecisionRequest {
    approvalPathStepId?: number;
    approvalStateCode?: string | undefined;
    comments?: string | undefined;
    questionAnswers?: OrderApprovalQuestionAnswerDto[] | undefined;
    extraRecipients?: string[] | undefined;
}

export class SubmitOrderApprovalDecisionResponse implements ISubmitOrderApprovalDecisionResponse {
    status?: number;
    isSuccess?: boolean;
    clientErrorMessage?: string | undefined;

    constructor(data?: ISubmitOrderApprovalDecisionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.isSuccess = _data["isSuccess"];
            this.clientErrorMessage = _data["clientErrorMessage"];
        }
    }

    static fromJS(data: any): SubmitOrderApprovalDecisionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitOrderApprovalDecisionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["isSuccess"] = this.isSuccess;
        data["clientErrorMessage"] = this.clientErrorMessage;
        return data;
    }
}

export interface ISubmitOrderApprovalDecisionResponse {
    status?: number;
    isSuccess?: boolean;
    clientErrorMessage?: string | undefined;
}

export class SubmitOrderRmaLineRequest implements ISubmitOrderRmaLineRequest {
    orderLineNumber!: number;
    quantity!: number;
    returnReasonCode!: string;
    packageOpened!: OrderRmaPackageOpened;
    additionalInfo?: string | undefined;
    attachmentIds!: string[];

    constructor(data?: ISubmitOrderRmaLineRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.attachmentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLineNumber = _data["orderLineNumber"];
            this.quantity = _data["quantity"];
            this.returnReasonCode = _data["returnReasonCode"];
            this.packageOpened = _data["packageOpened"];
            this.additionalInfo = _data["additionalInfo"];
            if (Array.isArray(_data["attachmentIds"])) {
                this.attachmentIds = [] as any;
                for (let item of _data["attachmentIds"])
                    this.attachmentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SubmitOrderRmaLineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitOrderRmaLineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderLineNumber"] = this.orderLineNumber;
        data["quantity"] = this.quantity;
        data["returnReasonCode"] = this.returnReasonCode;
        data["packageOpened"] = this.packageOpened;
        data["additionalInfo"] = this.additionalInfo;
        if (Array.isArray(this.attachmentIds)) {
            data["attachmentIds"] = [];
            for (let item of this.attachmentIds)
                data["attachmentIds"].push(item);
        }
        return data;
    }
}

export interface ISubmitOrderRmaLineRequest {
    orderLineNumber: number;
    quantity: number;
    returnReasonCode: string;
    packageOpened: OrderRmaPackageOpened;
    additionalInfo?: string | undefined;
    attachmentIds: string[];
}

export class SubmitOrderRmaRequest implements ISubmitOrderRmaRequest {
    contact!: OrderRmaContactRequest;
    lines!: SubmitOrderRmaLineRequest[];

    constructor(data?: ISubmitOrderRmaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.contact = new OrderRmaContactRequest();
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? OrderRmaContactRequest.fromJS(_data["contact"]) : new OrderRmaContactRequest();
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(SubmitOrderRmaLineRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmitOrderRmaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitOrderRmaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubmitOrderRmaRequest {
    contact: OrderRmaContactRequest;
    lines: SubmitOrderRmaLineRequest[];
}

export enum Carriers {
    Ups = "Ups",
    Fedex = "Fedex",
    Dhl = "Dhl",
    Other = "Other",
}

export enum CheckoutAnswerKind {
    Unspecified = "Unspecified",
    Text = "Text",
    TextArea = "TextArea",
    RadioList = "RadioList",
    DropdownList = "DropdownList",
    CheckboxList = "CheckboxList",
    Boolean = "Boolean",
    Date = "Date",
    DisplayOnly = "DisplayOnly",
    System = "System",
}

export enum FulfillmentStatus {
    AwaitingApproval = "AwaitingApproval",
    TransferApprover = "TransferApprover",
    Denied = "Denied",
    ApprovalExpired = "ApprovalExpired",
    PoRequested = "PoRequested",
    OrderPlaced = "OrderPlaced",
    Processing = "Processing",
    PartiallyShipped = "PartiallyShipped",
    Shipped = "Shipped",
    Delivered = "Delivered",
    PendingReturn = "PendingReturn",
    Returned = "Returned",
    Cancelled = "Cancelled",
    NotApplicable = "NotApplicable",
}

export enum InvoiceType {
    Unknown = "Unknown",
    Software = "Software",
    Hardware = "Hardware",
    Service = "Service",
    Fees = "Fees",
    Other = "Other",
    Aws = "Aws",
    Azure = "Azure",
    Gcp = "Gcp",
    Office365 = "Office365",
    Cloud = "Cloud",
    CorpServices = "CorpServices",
    CreditMemo = "CreditMemo",
}

export enum InvoicesViewType {
    Storefront = "Storefront",
    My = "My",
    All = "All",
}

export enum OrderRmaConfirmationEmailStatus {
    NotAttempted = "NotAttempted",
    Sent = "Sent",
    Failed = "Failed",
    Queued = "Queued",
}

export enum OrderRmaPackageOpened {
    Unspecified = "Unspecified",
    None = "None",
    Some = "Some",
    All = "All",
}

export enum OrdersViewType {
    My = "My",
    Storefront = "Storefront",
    All = "All",
    PendingApprovals = "PendingApprovals",
}

export enum ProductType {
    SOFTWARE = "SOFTWARE",
    HARDWARE = "HARDWARE",
    SERVICE = "SERVICE",
    FEES = "FEES",
    OTHER = "OTHER",
}

export class DeliveryDetailsDto implements IDeliveryDetailsDto {
    contact?: string | undefined;
    email?: string | undefined;
    memo?: string | undefined;
    mode?: string | undefined;

    constructor(data?: IDeliveryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"];
            this.email = _data["email"];
            this.memo = _data["memo"];
            this.mode = _data["mode"];
        }
    }

    static fromJS(data: any): DeliveryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact;
        data["email"] = this.email;
        data["memo"] = this.memo;
        data["mode"] = this.mode;
        return data;
    }
}

export interface IDeliveryDetailsDto {
    contact?: string | undefined;
    email?: string | undefined;
    memo?: string | undefined;
    mode?: string | undefined;
}

export class InvoiceAppliesToDto implements IInvoiceAppliesToDto {
    invoiceNumber?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceId?: number | undefined;

    constructor(data?: IInvoiceAppliesToDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.invoiceId = _data["invoiceId"];
        }
    }

    static fromJS(data: any): InvoiceAppliesToDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAppliesToDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["invoiceId"] = this.invoiceId;
        return data;
    }
}

export interface IInvoiceAppliesToDto {
    invoiceNumber?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceId?: number | undefined;
}

export class InvoiceLineDto implements IInvoiceLineDto {
    biInvoiceLineId?: number;
    biInvoiceId?: number;
    lineNumber?: number;
    invoiceLineNumber?: string | undefined;
    orderLineNumber?: string | undefined;
    description?: string | undefined;
    erpPartNumber?: string | undefined;
    qtyInvoiced?: number;
    unitPrice?: number | undefined;
    extendedPrice?: number | undefined;
    maintenanceDateStart?: Date | undefined;
    maintenanceDateEnd?: Date | undefined;
    agreementNumber?: string | undefined;
    agreementName?: string | undefined;
    enrollmentNumber?: string | undefined;
    enrollmentName?: string | undefined;
    subscriptionTerm?: string | undefined;
    buyingProgramName?: string | undefined;
    shiOrderType?: string | undefined;
    billingOption?: string | undefined;
    qtyOrdered?: number | undefined;
    qtyShipped?: number | undefined;
    qtyRemaining?: number | undefined;
    productClass?: string | undefined;
    productDescriptor?: string | undefined;
    mfgPartNumber?: string | undefined;
    imageUrl?: string | undefined;
    invoiceType?: InvoiceType;

    constructor(data?: IInvoiceLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biInvoiceLineId = _data["biInvoiceLineId"];
            this.biInvoiceId = _data["biInvoiceId"];
            this.lineNumber = _data["lineNumber"];
            this.invoiceLineNumber = _data["invoiceLineNumber"];
            this.orderLineNumber = _data["orderLineNumber"];
            this.description = _data["description"];
            this.erpPartNumber = _data["erpPartNumber"];
            this.qtyInvoiced = _data["qtyInvoiced"];
            this.unitPrice = _data["unitPrice"];
            this.extendedPrice = _data["extendedPrice"];
            this.maintenanceDateStart = _data["maintenanceDateStart"] ? new Date(_data["maintenanceDateStart"].toString()) : undefined as any;
            this.maintenanceDateEnd = _data["maintenanceDateEnd"] ? new Date(_data["maintenanceDateEnd"].toString()) : undefined as any;
            this.agreementNumber = _data["agreementNumber"];
            this.agreementName = _data["agreementName"];
            this.enrollmentNumber = _data["enrollmentNumber"];
            this.enrollmentName = _data["enrollmentName"];
            this.subscriptionTerm = _data["subscriptionTerm"];
            this.buyingProgramName = _data["buyingProgramName"];
            this.shiOrderType = _data["shiOrderType"];
            this.billingOption = _data["billingOption"];
            this.qtyOrdered = _data["qtyOrdered"];
            this.qtyShipped = _data["qtyShipped"];
            this.qtyRemaining = _data["qtyRemaining"];
            this.productClass = _data["productClass"];
            this.productDescriptor = _data["productDescriptor"];
            this.mfgPartNumber = _data["mfgPartNumber"];
            this.imageUrl = _data["imageUrl"];
            this.invoiceType = _data["invoiceType"];
        }
    }

    static fromJS(data: any): InvoiceLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biInvoiceLineId"] = this.biInvoiceLineId;
        data["biInvoiceId"] = this.biInvoiceId;
        data["lineNumber"] = this.lineNumber;
        data["invoiceLineNumber"] = this.invoiceLineNumber;
        data["orderLineNumber"] = this.orderLineNumber;
        data["description"] = this.description;
        data["erpPartNumber"] = this.erpPartNumber;
        data["qtyInvoiced"] = this.qtyInvoiced;
        data["unitPrice"] = this.unitPrice;
        data["extendedPrice"] = this.extendedPrice;
        data["maintenanceDateStart"] = this.maintenanceDateStart ? this.maintenanceDateStart.toISOString() : undefined as any;
        data["maintenanceDateEnd"] = this.maintenanceDateEnd ? this.maintenanceDateEnd.toISOString() : undefined as any;
        data["agreementNumber"] = this.agreementNumber;
        data["agreementName"] = this.agreementName;
        data["enrollmentNumber"] = this.enrollmentNumber;
        data["enrollmentName"] = this.enrollmentName;
        data["subscriptionTerm"] = this.subscriptionTerm;
        data["buyingProgramName"] = this.buyingProgramName;
        data["shiOrderType"] = this.shiOrderType;
        data["billingOption"] = this.billingOption;
        data["qtyOrdered"] = this.qtyOrdered;
        data["qtyShipped"] = this.qtyShipped;
        data["qtyRemaining"] = this.qtyRemaining;
        data["productClass"] = this.productClass;
        data["productDescriptor"] = this.productDescriptor;
        data["mfgPartNumber"] = this.mfgPartNumber;
        data["imageUrl"] = this.imageUrl;
        data["invoiceType"] = this.invoiceType;
        return data;
    }
}

export interface IInvoiceLineDto {
    biInvoiceLineId?: number;
    biInvoiceId?: number;
    lineNumber?: number;
    invoiceLineNumber?: string | undefined;
    orderLineNumber?: string | undefined;
    description?: string | undefined;
    erpPartNumber?: string | undefined;
    qtyInvoiced?: number;
    unitPrice?: number | undefined;
    extendedPrice?: number | undefined;
    maintenanceDateStart?: Date | undefined;
    maintenanceDateEnd?: Date | undefined;
    agreementNumber?: string | undefined;
    agreementName?: string | undefined;
    enrollmentNumber?: string | undefined;
    enrollmentName?: string | undefined;
    subscriptionTerm?: string | undefined;
    buyingProgramName?: string | undefined;
    shiOrderType?: string | undefined;
    billingOption?: string | undefined;
    qtyOrdered?: number | undefined;
    qtyShipped?: number | undefined;
    qtyRemaining?: number | undefined;
    productClass?: string | undefined;
    productDescriptor?: string | undefined;
    mfgPartNumber?: string | undefined;
    imageUrl?: string | undefined;
    invoiceType?: InvoiceType;
}

export class InvoiceSummaryDto implements IInvoiceSummaryDto {
    biInvoiceId?: number;
    biOrderId?: number;
    types?: InvoiceType[] | undefined;
    invoiceNumber?: string | undefined;
    invoiceDate?: Date;
    salesOrder?: string | undefined;
    purchaseOrder?: string | undefined;
    axAccountNumber?: string | undefined;
    contractNumber?: string | undefined;
    webOrderId?: number | undefined;
    orgUnitId?: number | undefined;
    billTo?: OrderAddressDto;
    shipTo?: OrderAddressDto;
    appliesTo?: InvoiceAppliesToDto;
    paymentTerms?: string | undefined;
    subTotal?: number | undefined;
    freight?: number | undefined;
    recyclingFee?: number | undefined;
    tax?: number | undefined;
    totalValue?: number | undefined;
    totalItems?: number | undefined;
    currencyId?: number | undefined;
    linkOrder?: boolean;
    lines?: InvoiceLineDto[] | undefined;
    serviceContracts?: string[] | undefined;
    contractTypes?: string[] | undefined;
    billingTypes?: string[] | undefined;
    billingPeriod?: Date[] | undefined;

    constructor(data?: IInvoiceSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biInvoiceId = _data["biInvoiceId"];
            this.biOrderId = _data["biOrderId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.salesOrder = _data["salesOrder"];
            this.purchaseOrder = _data["purchaseOrder"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.contractNumber = _data["contractNumber"];
            this.webOrderId = _data["webOrderId"];
            this.orgUnitId = _data["orgUnitId"];
            this.billTo = _data["billTo"] ? OrderAddressDto.fromJS(_data["billTo"]) : undefined as any;
            this.shipTo = _data["shipTo"] ? OrderAddressDto.fromJS(_data["shipTo"]) : undefined as any;
            this.appliesTo = _data["appliesTo"] ? InvoiceAppliesToDto.fromJS(_data["appliesTo"]) : undefined as any;
            this.paymentTerms = _data["paymentTerms"];
            this.subTotal = _data["subTotal"];
            this.freight = _data["freight"];
            this.recyclingFee = _data["recyclingFee"];
            this.tax = _data["tax"];
            this.totalValue = _data["totalValue"];
            this.totalItems = _data["totalItems"];
            this.currencyId = _data["currencyId"];
            this.linkOrder = _data["linkOrder"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(InvoiceLineDto.fromJS(item));
            }
            if (Array.isArray(_data["serviceContracts"])) {
                this.serviceContracts = [] as any;
                for (let item of _data["serviceContracts"])
                    this.serviceContracts!.push(item);
            }
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(item);
            }
            if (Array.isArray(_data["billingTypes"])) {
                this.billingTypes = [] as any;
                for (let item of _data["billingTypes"])
                    this.billingTypes!.push(item);
            }
            if (Array.isArray(_data["billingPeriod"])) {
                this.billingPeriod = [] as any;
                for (let item of _data["billingPeriod"])
                    this.billingPeriod!.push(new Date(item));
            }
        }
    }

    static fromJS(data: any): InvoiceSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biInvoiceId"] = this.biInvoiceId;
        data["biOrderId"] = this.biOrderId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["salesOrder"] = this.salesOrder;
        data["purchaseOrder"] = this.purchaseOrder;
        data["axAccountNumber"] = this.axAccountNumber;
        data["contractNumber"] = this.contractNumber;
        data["webOrderId"] = this.webOrderId;
        data["orgUnitId"] = this.orgUnitId;
        data["billTo"] = this.billTo ? this.billTo.toJSON() : undefined as any;
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        data["appliesTo"] = this.appliesTo ? this.appliesTo.toJSON() : undefined as any;
        data["paymentTerms"] = this.paymentTerms;
        data["subTotal"] = this.subTotal;
        data["freight"] = this.freight;
        data["recyclingFee"] = this.recyclingFee;
        data["tax"] = this.tax;
        data["totalValue"] = this.totalValue;
        data["totalItems"] = this.totalItems;
        data["currencyId"] = this.currencyId;
        data["linkOrder"] = this.linkOrder;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.serviceContracts)) {
            data["serviceContracts"] = [];
            for (let item of this.serviceContracts)
                data["serviceContracts"].push(item);
        }
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item);
        }
        if (Array.isArray(this.billingTypes)) {
            data["billingTypes"] = [];
            for (let item of this.billingTypes)
                data["billingTypes"].push(item);
        }
        if (Array.isArray(this.billingPeriod)) {
            data["billingPeriod"] = [];
            for (let item of this.billingPeriod)
                data["billingPeriod"].push(item.toISOString());
        }
        return data;
    }
}

export interface IInvoiceSummaryDto {
    biInvoiceId?: number;
    biOrderId?: number;
    types?: InvoiceType[] | undefined;
    invoiceNumber?: string | undefined;
    invoiceDate?: Date;
    salesOrder?: string | undefined;
    purchaseOrder?: string | undefined;
    axAccountNumber?: string | undefined;
    contractNumber?: string | undefined;
    webOrderId?: number | undefined;
    orgUnitId?: number | undefined;
    billTo?: OrderAddressDto;
    shipTo?: OrderAddressDto;
    appliesTo?: InvoiceAppliesToDto;
    paymentTerms?: string | undefined;
    subTotal?: number | undefined;
    freight?: number | undefined;
    recyclingFee?: number | undefined;
    tax?: number | undefined;
    totalValue?: number | undefined;
    totalItems?: number | undefined;
    currencyId?: number | undefined;
    linkOrder?: boolean;
    lines?: InvoiceLineDto[] | undefined;
    serviceContracts?: string[] | undefined;
    contractTypes?: string[] | undefined;
    billingTypes?: string[] | undefined;
    billingPeriod?: Date[] | undefined;
}

export class OrderAddressDto implements IOrderAddressDto {
    addressName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    attention?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    county?: string | undefined;
    postalCode?: string | undefined;
    stateProvince?: string | undefined;

    constructor(data?: IOrderAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressName = _data["addressName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.attention = _data["attention"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.countryCode = _data["countryCode"];
            this.county = _data["county"];
            this.postalCode = _data["postalCode"];
            this.stateProvince = _data["stateProvince"];
        }
    }

    static fromJS(data: any): OrderAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressName"] = this.addressName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["attention"] = this.attention;
        data["city"] = this.city;
        data["country"] = this.country;
        data["countryCode"] = this.countryCode;
        data["county"] = this.county;
        data["postalCode"] = this.postalCode;
        data["stateProvince"] = this.stateProvince;
        return data;
    }
}

export interface IOrderAddressDto {
    addressName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    attention?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    county?: string | undefined;
    postalCode?: string | undefined;
    stateProvince?: string | undefined;
}

export class OrderApprovalCheckoutQuestionDto implements IOrderApprovalCheckoutQuestionDto {
    questionText!: string | undefined;
    questionHtml?: string | undefined;
    questionHeadingHtml?: string | undefined;
    checkOutQuestionId?: number | undefined;
    checkOutAnswerId?: number | undefined;
    checkoutQuestionTypeCode?: string | undefined;
    answerKind?: CheckoutAnswerKind;
    answerValue?: string | undefined;
    isApproverUpdateable?: boolean | undefined;
    approvalDisplayOrder?: number | undefined;
    requiresAnswer?: boolean | undefined;
    validationString?: string | undefined;
    validationHelpText?: string | undefined;
    isFromApprovalStep?: boolean;
    answers?: OrderCheckoutQuestionAnswerDto[] | undefined;

    constructor(data?: IOrderApprovalCheckoutQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionText = _data["questionText"];
            this.questionHtml = _data["questionHtml"];
            this.questionHeadingHtml = _data["questionHeadingHtml"];
            this.checkOutQuestionId = _data["checkOutQuestionId"];
            this.checkOutAnswerId = _data["checkOutAnswerId"];
            this.checkoutQuestionTypeCode = _data["checkoutQuestionTypeCode"];
            this.answerKind = _data["answerKind"];
            this.answerValue = _data["answerValue"];
            this.isApproverUpdateable = _data["isApproverUpdateable"];
            this.approvalDisplayOrder = _data["approvalDisplayOrder"];
            this.requiresAnswer = _data["requiresAnswer"];
            this.validationString = _data["validationString"];
            this.validationHelpText = _data["validationHelpText"];
            this.isFromApprovalStep = _data["isFromApprovalStep"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(OrderCheckoutQuestionAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderApprovalCheckoutQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalCheckoutQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["questionHtml"] = this.questionHtml;
        data["questionHeadingHtml"] = this.questionHeadingHtml;
        data["checkOutQuestionId"] = this.checkOutQuestionId;
        data["checkOutAnswerId"] = this.checkOutAnswerId;
        data["checkoutQuestionTypeCode"] = this.checkoutQuestionTypeCode;
        data["answerKind"] = this.answerKind;
        data["answerValue"] = this.answerValue;
        data["isApproverUpdateable"] = this.isApproverUpdateable;
        data["approvalDisplayOrder"] = this.approvalDisplayOrder;
        data["requiresAnswer"] = this.requiresAnswer;
        data["validationString"] = this.validationString;
        data["validationHelpText"] = this.validationHelpText;
        data["isFromApprovalStep"] = this.isFromApprovalStep;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrderApprovalCheckoutQuestionDto {
    questionText: string | undefined;
    questionHtml?: string | undefined;
    questionHeadingHtml?: string | undefined;
    checkOutQuestionId?: number | undefined;
    checkOutAnswerId?: number | undefined;
    checkoutQuestionTypeCode?: string | undefined;
    answerKind?: CheckoutAnswerKind;
    answerValue?: string | undefined;
    isApproverUpdateable?: boolean | undefined;
    approvalDisplayOrder?: number | undefined;
    requiresAnswer?: boolean | undefined;
    validationString?: string | undefined;
    validationHelpText?: string | undefined;
    isFromApprovalStep?: boolean;
    answers?: OrderCheckoutQuestionAnswerDto[] | undefined;
}

export class OrderApprovalCountDto implements IOrderApprovalCountDto {
    pendingCount?: number;
    overdueCount?: number;

    constructor(data?: IOrderApprovalCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingCount = _data["pendingCount"];
            this.overdueCount = _data["overdueCount"];
        }
    }

    static fromJS(data: any): OrderApprovalCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingCount"] = this.pendingCount;
        data["overdueCount"] = this.overdueCount;
        return data;
    }
}

export interface IOrderApprovalCountDto {
    pendingCount?: number;
    overdueCount?: number;
}

export class OrderApprovalHistoryDto implements IOrderApprovalHistoryDto {
    hasApprovalWorkflow?: boolean;
    canReview?: boolean;
    pendingApprovers?: string[] | undefined;
    steps?: OrderApprovalHistoryStepDto[] | undefined;

    constructor(data?: IOrderApprovalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasApprovalWorkflow = _data["hasApprovalWorkflow"];
            this.canReview = _data["canReview"];
            if (Array.isArray(_data["pendingApprovers"])) {
                this.pendingApprovers = [] as any;
                for (let item of _data["pendingApprovers"])
                    this.pendingApprovers!.push(item);
            }
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(OrderApprovalHistoryStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderApprovalHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasApprovalWorkflow"] = this.hasApprovalWorkflow;
        data["canReview"] = this.canReview;
        if (Array.isArray(this.pendingApprovers)) {
            data["pendingApprovers"] = [];
            for (let item of this.pendingApprovers)
                data["pendingApprovers"].push(item);
        }
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrderApprovalHistoryDto {
    hasApprovalWorkflow?: boolean;
    canReview?: boolean;
    pendingApprovers?: string[] | undefined;
    steps?: OrderApprovalHistoryStepDto[] | undefined;
}

export class OrderApprovalHistoryStepDto implements IOrderApprovalHistoryStepDto {
    approvalPathStepId?: number | undefined;
    approverEmployeeId?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    date?: Date | undefined;
    approver?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IOrderApprovalHistoryStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvalPathStepId = _data["approvalPathStepId"];
            this.approverEmployeeId = _data["approverEmployeeId"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.approver = _data["approver"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): OrderApprovalHistoryStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalHistoryStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalPathStepId"] = this.approvalPathStepId;
        data["approverEmployeeId"] = this.approverEmployeeId;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["approver"] = this.approver;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IOrderApprovalHistoryStepDto {
    approvalPathStepId?: number | undefined;
    approverEmployeeId?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    date?: Date | undefined;
    approver?: string | undefined;
    comments?: string | undefined;
}

export class OrderApprovalPendingItemDto implements IOrderApprovalPendingItemDto {
    currency?: number | undefined;
    currencySymbol?: string | undefined;
    dateOrdered?: Date | undefined;
    orderedBy?: string | undefined;
    orgUnitName?: string | undefined;
    totalPrice?: number | undefined;
    webOrderId?: number | undefined;
    poNumber?: string | undefined;
    productCount?: number | undefined;
    reviewUrl?: string | undefined;
    canApprove?: boolean;
    daysPending?: number;
    shipTo?: string | undefined;
    pendingSince?: Date | undefined;
    lines?: OrderApprovalPendingLineItemDto[] | undefined;

    constructor(data?: IOrderApprovalPendingItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.currencySymbol = _data["currencySymbol"];
            this.dateOrdered = _data["dateOrdered"] ? new Date(_data["dateOrdered"].toString()) : undefined as any;
            this.orderedBy = _data["orderedBy"];
            this.orgUnitName = _data["orgUnitName"];
            this.totalPrice = _data["totalPrice"];
            this.webOrderId = _data["webOrderId"];
            this.poNumber = _data["poNumber"];
            this.productCount = _data["productCount"];
            this.reviewUrl = _data["reviewUrl"];
            this.canApprove = _data["canApprove"];
            this.daysPending = _data["daysPending"];
            this.shipTo = _data["shipTo"];
            this.pendingSince = _data["pendingSince"] ? new Date(_data["pendingSince"].toString()) : undefined as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(OrderApprovalPendingLineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderApprovalPendingItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalPendingItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["currencySymbol"] = this.currencySymbol;
        data["dateOrdered"] = this.dateOrdered ? this.dateOrdered.toISOString() : undefined as any;
        data["orderedBy"] = this.orderedBy;
        data["orgUnitName"] = this.orgUnitName;
        data["totalPrice"] = this.totalPrice;
        data["webOrderId"] = this.webOrderId;
        data["poNumber"] = this.poNumber;
        data["productCount"] = this.productCount;
        data["reviewUrl"] = this.reviewUrl;
        data["canApprove"] = this.canApprove;
        data["daysPending"] = this.daysPending;
        data["shipTo"] = this.shipTo;
        data["pendingSince"] = this.pendingSince ? this.pendingSince.toISOString() : undefined as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrderApprovalPendingItemDto {
    currency?: number | undefined;
    currencySymbol?: string | undefined;
    dateOrdered?: Date | undefined;
    orderedBy?: string | undefined;
    orgUnitName?: string | undefined;
    totalPrice?: number | undefined;
    webOrderId?: number | undefined;
    poNumber?: string | undefined;
    productCount?: number | undefined;
    reviewUrl?: string | undefined;
    canApprove?: boolean;
    daysPending?: number;
    shipTo?: string | undefined;
    pendingSince?: Date | undefined;
    lines?: OrderApprovalPendingLineItemDto[] | undefined;
}

export class OrderApprovalPendingLineItemDto implements IOrderApprovalPendingLineItemDto {
    lineNumber?: number;
    productId?: number | undefined;
    productName?: string | undefined;
    productDescription?: string | undefined;
    mfgPartNumber?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    extendedPrice?: number;
    productClass?: string | undefined;
    imageUrl?: string | undefined;

    constructor(data?: IOrderApprovalPendingLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productDescription = _data["productDescription"];
            this.mfgPartNumber = _data["mfgPartNumber"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.extendedPrice = _data["extendedPrice"];
            this.productClass = _data["productClass"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): OrderApprovalPendingLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalPendingLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productDescription"] = this.productDescription;
        data["mfgPartNumber"] = this.mfgPartNumber;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["extendedPrice"] = this.extendedPrice;
        data["productClass"] = this.productClass;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IOrderApprovalPendingLineItemDto {
    lineNumber?: number;
    productId?: number | undefined;
    productName?: string | undefined;
    productDescription?: string | undefined;
    mfgPartNumber?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    extendedPrice?: number;
    productClass?: string | undefined;
    imageUrl?: string | undefined;
}

export class OrderApprovalQuestionAnswerDto implements IOrderApprovalQuestionAnswerDto {
    checkOutQuestionId?: number;
    checkOutAnswerId?: number;
    answerKind?: CheckoutAnswerKind;
    value?: string | undefined;
    valueInternal?: string | undefined;

    constructor(data?: IOrderApprovalQuestionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkOutQuestionId = _data["checkOutQuestionId"];
            this.checkOutAnswerId = _data["checkOutAnswerId"];
            this.answerKind = _data["answerKind"];
            this.value = _data["value"];
            this.valueInternal = _data["valueInternal"];
        }
    }

    static fromJS(data: any): OrderApprovalQuestionAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalQuestionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkOutQuestionId"] = this.checkOutQuestionId;
        data["checkOutAnswerId"] = this.checkOutAnswerId;
        data["answerKind"] = this.answerKind;
        data["value"] = this.value;
        data["valueInternal"] = this.valueInternal;
        return data;
    }
}

export interface IOrderApprovalQuestionAnswerDto {
    checkOutQuestionId?: number;
    checkOutAnswerId?: number;
    answerKind?: CheckoutAnswerKind;
    value?: string | undefined;
    valueInternal?: string | undefined;
}

export class OrderCheckoutQuestionAnswerDto implements IOrderCheckoutQuestionAnswerDto {
    id!: number;
    answerText?: string | undefined;
    answerHtml?: string | undefined;
    listAnswerListedOrder?: number | undefined;
    isDefaultAnswer?: boolean | undefined;
    listAnswerValue?: string | undefined;
    textAnswerMaxLength?: number | undefined;
    textAnswerMaxChars?: number | undefined;
    textAnswerSize?: number | undefined;
    textDefaultAnswer?: string | undefined;
    textAreaAnswerRows?: number | undefined;
    textAreaAnswerCols?: number | undefined;
    textAreaDefaultAnswer?: string | undefined;
    isTerminal?: boolean | undefined;
    terminalMessage?: string | undefined;

    constructor(data?: IOrderCheckoutQuestionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answerText = _data["answerText"];
            this.answerHtml = _data["answerHtml"];
            this.listAnswerListedOrder = _data["listAnswerListedOrder"];
            this.isDefaultAnswer = _data["isDefaultAnswer"];
            this.listAnswerValue = _data["listAnswerValue"];
            this.textAnswerMaxLength = _data["textAnswerMaxLength"];
            this.textAnswerMaxChars = _data["textAnswerMaxChars"];
            this.textAnswerSize = _data["textAnswerSize"];
            this.textDefaultAnswer = _data["textDefaultAnswer"];
            this.textAreaAnswerRows = _data["textAreaAnswerRows"];
            this.textAreaAnswerCols = _data["textAreaAnswerCols"];
            this.textAreaDefaultAnswer = _data["textAreaDefaultAnswer"];
            this.isTerminal = _data["isTerminal"];
            this.terminalMessage = _data["terminalMessage"];
        }
    }

    static fromJS(data: any): OrderCheckoutQuestionAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCheckoutQuestionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answerText"] = this.answerText;
        data["answerHtml"] = this.answerHtml;
        data["listAnswerListedOrder"] = this.listAnswerListedOrder;
        data["isDefaultAnswer"] = this.isDefaultAnswer;
        data["listAnswerValue"] = this.listAnswerValue;
        data["textAnswerMaxLength"] = this.textAnswerMaxLength;
        data["textAnswerMaxChars"] = this.textAnswerMaxChars;
        data["textAnswerSize"] = this.textAnswerSize;
        data["textDefaultAnswer"] = this.textDefaultAnswer;
        data["textAreaAnswerRows"] = this.textAreaAnswerRows;
        data["textAreaAnswerCols"] = this.textAreaAnswerCols;
        data["textAreaDefaultAnswer"] = this.textAreaDefaultAnswer;
        data["isTerminal"] = this.isTerminal;
        data["terminalMessage"] = this.terminalMessage;
        return data;
    }
}

export interface IOrderCheckoutQuestionAnswerDto {
    id: number;
    answerText?: string | undefined;
    answerHtml?: string | undefined;
    listAnswerListedOrder?: number | undefined;
    isDefaultAnswer?: boolean | undefined;
    listAnswerValue?: string | undefined;
    textAnswerMaxLength?: number | undefined;
    textAnswerMaxChars?: number | undefined;
    textAnswerSize?: number | undefined;
    textDefaultAnswer?: string | undefined;
    textAreaAnswerRows?: number | undefined;
    textAreaAnswerCols?: number | undefined;
    textAreaDefaultAnswer?: string | undefined;
    isTerminal?: boolean | undefined;
    terminalMessage?: string | undefined;
}

export class OrderCheckoutQuestionDto implements IOrderCheckoutQuestionDto {
    questionText!: string | undefined;
    checkOutQuestionId?: number | undefined;
    checkOutAnswerId?: number | undefined;
    checkoutQuestionTypeCode?: string | undefined;
    answerValue?: string | undefined;

    constructor(data?: IOrderCheckoutQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionText = _data["questionText"];
            this.checkOutQuestionId = _data["checkOutQuestionId"];
            this.checkOutAnswerId = _data["checkOutAnswerId"];
            this.checkoutQuestionTypeCode = _data["checkoutQuestionTypeCode"];
            this.answerValue = _data["answerValue"];
        }
    }

    static fromJS(data: any): OrderCheckoutQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCheckoutQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionText"] = this.questionText;
        data["checkOutQuestionId"] = this.checkOutQuestionId;
        data["checkOutAnswerId"] = this.checkOutAnswerId;
        data["checkoutQuestionTypeCode"] = this.checkoutQuestionTypeCode;
        data["answerValue"] = this.answerValue;
        return data;
    }
}

export interface IOrderCheckoutQuestionDto {
    questionText: string | undefined;
    checkOutQuestionId?: number | undefined;
    checkOutAnswerId?: number | undefined;
    checkoutQuestionTypeCode?: string | undefined;
    answerValue?: string | undefined;
}

export class OrderInvoiceDto implements IOrderInvoiceDto {
    invoiceId?: number | undefined;
    invoiceNumber?: string | undefined;
    invoicedOn?: Date | undefined;
    orderId?: number | undefined;
    orderNumber?: string | undefined;
    custPONumber?: string | undefined;
    webOrderId?: number | undefined;
    shiQuoteId?: number | undefined;
    freight?: number | undefined;
    recyclingFee?: number | undefined;
    subTotal?: number | undefined;
    tax?: number | undefined;
    totalValue?: number | undefined;
    paymentTerms?: string | undefined;
    transactionType?: string | undefined;
    billTo?: OrderAddressDto;
    shipTo?: OrderAddressDto;

    constructor(data?: IOrderInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoicedOn = _data["invoicedOn"] ? new Date(_data["invoicedOn"].toString()) : undefined as any;
            this.orderId = _data["orderId"];
            this.orderNumber = _data["orderNumber"];
            this.custPONumber = _data["custPONumber"];
            this.webOrderId = _data["webOrderId"];
            this.shiQuoteId = _data["shiQuoteId"];
            this.freight = _data["freight"];
            this.recyclingFee = _data["recyclingFee"];
            this.subTotal = _data["subTotal"];
            this.tax = _data["tax"];
            this.totalValue = _data["totalValue"];
            this.paymentTerms = _data["paymentTerms"];
            this.transactionType = _data["transactionType"];
            this.billTo = _data["billTo"] ? OrderAddressDto.fromJS(_data["billTo"]) : undefined as any;
            this.shipTo = _data["shipTo"] ? OrderAddressDto.fromJS(_data["shipTo"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrderInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoicedOn"] = this.invoicedOn ? this.invoicedOn.toISOString() : undefined as any;
        data["orderId"] = this.orderId;
        data["orderNumber"] = this.orderNumber;
        data["custPONumber"] = this.custPONumber;
        data["webOrderId"] = this.webOrderId;
        data["shiQuoteId"] = this.shiQuoteId;
        data["freight"] = this.freight;
        data["recyclingFee"] = this.recyclingFee;
        data["subTotal"] = this.subTotal;
        data["tax"] = this.tax;
        data["totalValue"] = this.totalValue;
        data["paymentTerms"] = this.paymentTerms;
        data["transactionType"] = this.transactionType;
        data["billTo"] = this.billTo ? this.billTo.toJSON() : undefined as any;
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrderInvoiceDto {
    invoiceId?: number | undefined;
    invoiceNumber?: string | undefined;
    invoicedOn?: Date | undefined;
    orderId?: number | undefined;
    orderNumber?: string | undefined;
    custPONumber?: string | undefined;
    webOrderId?: number | undefined;
    shiQuoteId?: number | undefined;
    freight?: number | undefined;
    recyclingFee?: number | undefined;
    subTotal?: number | undefined;
    tax?: number | undefined;
    totalValue?: number | undefined;
    paymentTerms?: string | undefined;
    transactionType?: string | undefined;
    billTo?: OrderAddressDto;
    shipTo?: OrderAddressDto;
}

export class OrderLineItemDto implements IOrderLineItemDto {
    lineItemId?: string | undefined;
    productName?: string | undefined;
    orderId?: string | undefined;
    lineCanceled?: string | undefined;
    lineNumber?: number;
    lineStatus?: string | undefined;
    mfgPartNumber?: string | undefined;
    quantity?: number;
    status?: string | undefined;
    extendedPrice?: number | undefined;
    unitPrice?: number | undefined;
    productClass?: string | undefined;
    mediaClassName?: string | undefined;
    productDescription?: string | undefined;
    productDescriptor?: string | undefined;
    carrier?: string | undefined;
    carrierEnum?: Carriers;
    trackingNumber?: string | undefined;
    carrierTrackingLabel?: string | undefined;
    qtyShipped?: number | undefined;
    shippedOn?: Date | undefined;
    deliveryOn?: Date | undefined;
    estimatedDeliveryOn?: Date | undefined;
    deliveryPerson?: string | undefined;
    shiPartNumber?: string | undefined;
    itemGroupId?: string | undefined;
    imageUrl?: string | undefined;
    productType?: ProductType;
    lastSeenLocation?: string | undefined;

    constructor(data?: IOrderLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineItemId = _data["lineItemId"];
            this.productName = _data["productName"];
            this.orderId = _data["orderId"];
            this.lineCanceled = _data["lineCanceled"];
            this.lineNumber = _data["lineNumber"];
            this.lineStatus = _data["lineStatus"];
            this.mfgPartNumber = _data["mfgPartNumber"];
            this.quantity = _data["quantity"];
            this.status = _data["status"];
            this.extendedPrice = _data["extendedPrice"];
            this.unitPrice = _data["unitPrice"];
            this.productClass = _data["productClass"];
            this.mediaClassName = _data["mediaClassName"];
            this.productDescription = _data["productDescription"];
            this.productDescriptor = _data["productDescriptor"];
            this.carrier = _data["carrier"];
            this.carrierEnum = _data["carrierEnum"];
            this.trackingNumber = _data["trackingNumber"];
            this.carrierTrackingLabel = _data["carrierTrackingLabel"];
            this.qtyShipped = _data["qtyShipped"];
            this.shippedOn = _data["shippedOn"] ? new Date(_data["shippedOn"].toString()) : undefined as any;
            this.deliveryOn = _data["deliveryOn"] ? new Date(_data["deliveryOn"].toString()) : undefined as any;
            this.estimatedDeliveryOn = _data["estimatedDeliveryOn"] ? new Date(_data["estimatedDeliveryOn"].toString()) : undefined as any;
            this.deliveryPerson = _data["deliveryPerson"];
            this.shiPartNumber = _data["shiPartNumber"];
            this.itemGroupId = _data["itemGroupId"];
            this.imageUrl = _data["imageUrl"];
            this.productType = _data["productType"];
            this.lastSeenLocation = _data["lastSeenLocation"];
        }
    }

    static fromJS(data: any): OrderLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineItemId"] = this.lineItemId;
        data["productName"] = this.productName;
        data["orderId"] = this.orderId;
        data["lineCanceled"] = this.lineCanceled;
        data["lineNumber"] = this.lineNumber;
        data["lineStatus"] = this.lineStatus;
        data["mfgPartNumber"] = this.mfgPartNumber;
        data["quantity"] = this.quantity;
        data["status"] = this.status;
        data["extendedPrice"] = this.extendedPrice;
        data["unitPrice"] = this.unitPrice;
        data["productClass"] = this.productClass;
        data["mediaClassName"] = this.mediaClassName;
        data["productDescription"] = this.productDescription;
        data["productDescriptor"] = this.productDescriptor;
        data["carrier"] = this.carrier;
        data["carrierEnum"] = this.carrierEnum;
        data["trackingNumber"] = this.trackingNumber;
        data["carrierTrackingLabel"] = this.carrierTrackingLabel;
        data["qtyShipped"] = this.qtyShipped;
        data["shippedOn"] = this.shippedOn ? this.shippedOn.toISOString() : undefined as any;
        data["deliveryOn"] = this.deliveryOn ? this.deliveryOn.toISOString() : undefined as any;
        data["estimatedDeliveryOn"] = this.estimatedDeliveryOn ? this.estimatedDeliveryOn.toISOString() : undefined as any;
        data["deliveryPerson"] = this.deliveryPerson;
        data["shiPartNumber"] = this.shiPartNumber;
        data["itemGroupId"] = this.itemGroupId;
        data["imageUrl"] = this.imageUrl;
        data["productType"] = this.productType;
        data["lastSeenLocation"] = this.lastSeenLocation;
        return data;
    }
}

export interface IOrderLineItemDto {
    lineItemId?: string | undefined;
    productName?: string | undefined;
    orderId?: string | undefined;
    lineCanceled?: string | undefined;
    lineNumber?: number;
    lineStatus?: string | undefined;
    mfgPartNumber?: string | undefined;
    quantity?: number;
    status?: string | undefined;
    extendedPrice?: number | undefined;
    unitPrice?: number | undefined;
    productClass?: string | undefined;
    mediaClassName?: string | undefined;
    productDescription?: string | undefined;
    productDescriptor?: string | undefined;
    carrier?: string | undefined;
    carrierEnum?: Carriers;
    trackingNumber?: string | undefined;
    carrierTrackingLabel?: string | undefined;
    qtyShipped?: number | undefined;
    shippedOn?: Date | undefined;
    deliveryOn?: Date | undefined;
    estimatedDeliveryOn?: Date | undefined;
    deliveryPerson?: string | undefined;
    shiPartNumber?: string | undefined;
    itemGroupId?: string | undefined;
    imageUrl?: string | undefined;
    productType?: ProductType;
    lastSeenLocation?: string | undefined;
}

export class OrderLineRelatedDataDto implements IOrderLineRelatedDataDto {
    lineNumber?: number;
    fieldName!: string | undefined;
    valueString?: string | undefined;

    constructor(data?: IOrderLineRelatedDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.fieldName = _data["fieldName"];
            this.valueString = _data["valueString"];
        }
    }

    static fromJS(data: any): OrderLineRelatedDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineRelatedDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["fieldName"] = this.fieldName;
        data["valueString"] = this.valueString;
        return data;
    }
}

export interface IOrderLineRelatedDataDto {
    lineNumber?: number;
    fieldName: string | undefined;
    valueString?: string | undefined;
}

export class OrderLineSerialDto implements IOrderLineSerialDto {
    lineNumber?: number | undefined;
    serialNumber?: string | undefined;
    assetTag?: string | undefined;

    constructor(data?: IOrderLineSerialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.serialNumber = _data["serialNumber"];
            this.assetTag = _data["assetTag"];
        }
    }

    static fromJS(data: any): OrderLineSerialDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineSerialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["serialNumber"] = this.serialNumber;
        data["assetTag"] = this.assetTag;
        return data;
    }
}

export interface IOrderLineSerialDto {
    lineNumber?: number | undefined;
    serialNumber?: string | undefined;
    assetTag?: string | undefined;
}

export class OrderPaymentDto implements IOrderPaymentDto {
    subTotal?: number | undefined;
    freight?: number | undefined;
    tax?: number | undefined;
    recyclingFee?: number | undefined;
    total?: number | undefined;
    currencyCode?: string | undefined;
    paymentTerms?: string | undefined;
    creditCardLast4Digits?: string | undefined;
    hasCreditCard?: boolean;

    constructor(data?: IOrderPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subTotal = _data["subTotal"];
            this.freight = _data["freight"];
            this.tax = _data["tax"];
            this.recyclingFee = _data["recyclingFee"];
            this.total = _data["total"];
            this.currencyCode = _data["currencyCode"];
            this.paymentTerms = _data["paymentTerms"];
            this.creditCardLast4Digits = _data["creditCardLast4Digits"];
            this.hasCreditCard = _data["hasCreditCard"];
        }
    }

    static fromJS(data: any): OrderPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subTotal"] = this.subTotal;
        data["freight"] = this.freight;
        data["tax"] = this.tax;
        data["recyclingFee"] = this.recyclingFee;
        data["total"] = this.total;
        data["currencyCode"] = this.currencyCode;
        data["paymentTerms"] = this.paymentTerms;
        data["creditCardLast4Digits"] = this.creditCardLast4Digits;
        data["hasCreditCard"] = this.hasCreditCard;
        return data;
    }
}

export interface IOrderPaymentDto {
    subTotal?: number | undefined;
    freight?: number | undefined;
    tax?: number | undefined;
    recyclingFee?: number | undefined;
    total?: number | undefined;
    currencyCode?: string | undefined;
    paymentTerms?: string | undefined;
    creditCardLast4Digits?: string | undefined;
    hasCreditCard?: boolean;
}

export class OrderRelatedDataDto implements IOrderRelatedDataDto {
    fieldName!: string | undefined;
    valueString?: string | undefined;

    constructor(data?: IOrderRelatedDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.valueString = _data["valueString"];
        }
    }

    static fromJS(data: any): OrderRelatedDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRelatedDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["valueString"] = this.valueString;
        return data;
    }
}

export interface IOrderRelatedDataDto {
    fieldName: string | undefined;
    valueString?: string | undefined;
}

export class OrderReturnEligibilityItemDto implements IOrderReturnEligibilityItemDto {
    biOrderId?: number;
    canReturn?: boolean;

    constructor(data?: IOrderReturnEligibilityItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biOrderId = _data["biOrderId"];
            this.canReturn = _data["canReturn"];
        }
    }

    static fromJS(data: any): OrderReturnEligibilityItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReturnEligibilityItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biOrderId"] = this.biOrderId;
        data["canReturn"] = this.canReturn;
        return data;
    }
}

export interface IOrderReturnEligibilityItemDto {
    biOrderId?: number;
    canReturn?: boolean;
}

export class OrderRmaAttachmentUploadDto implements IOrderRmaAttachmentUploadDto {
    attachmentId?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;

    constructor(data?: IOrderRmaAttachmentUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeBytes = _data["sizeBytes"];
        }
    }

    static fromJS(data: any): OrderRmaAttachmentUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRmaAttachmentUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeBytes"] = this.sizeBytes;
        return data;
    }
}

export interface IOrderRmaAttachmentUploadDto {
    attachmentId?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;
}

export class OrderRmaContactDto implements IOrderRmaContactDto {
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IOrderRmaContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): OrderRmaContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRmaContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IOrderRmaContactDto {
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
}

export class OrderRmaDetailDto implements IOrderRmaDetailDto {
    biOrderId?: number;
    orderNumber?: string | undefined;
    orderedOn?: Date;
    lines?: OrderRmaLineDto[] | undefined;
    returnReasons?: OrderRmaReturnReasonDto[] | undefined;
    contactDefaults?: OrderRmaContactDto;

    constructor(data?: IOrderRmaDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biOrderId = _data["biOrderId"];
            this.orderNumber = _data["orderNumber"];
            this.orderedOn = _data["orderedOn"] ? new Date(_data["orderedOn"].toString()) : undefined as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(OrderRmaLineDto.fromJS(item));
            }
            if (Array.isArray(_data["returnReasons"])) {
                this.returnReasons = [] as any;
                for (let item of _data["returnReasons"])
                    this.returnReasons!.push(OrderRmaReturnReasonDto.fromJS(item));
            }
            this.contactDefaults = _data["contactDefaults"] ? OrderRmaContactDto.fromJS(_data["contactDefaults"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrderRmaDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRmaDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biOrderId"] = this.biOrderId;
        data["orderNumber"] = this.orderNumber;
        data["orderedOn"] = this.orderedOn ? this.orderedOn.toISOString() : undefined as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.returnReasons)) {
            data["returnReasons"] = [];
            for (let item of this.returnReasons)
                data["returnReasons"].push(item ? item.toJSON() : undefined as any);
        }
        data["contactDefaults"] = this.contactDefaults ? this.contactDefaults.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrderRmaDetailDto {
    biOrderId?: number;
    orderNumber?: string | undefined;
    orderedOn?: Date;
    lines?: OrderRmaLineDto[] | undefined;
    returnReasons?: OrderRmaReturnReasonDto[] | undefined;
    contactDefaults?: OrderRmaContactDto;
}

export class OrderRmaLineDto implements IOrderRmaLineDto {
    lineNumber?: number;
    shiPartNumber?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    manufacturerName?: string | undefined;
    description?: string | undefined;
    quantityOrdered?: number;
    isReturnable?: boolean;

    constructor(data?: IOrderRmaLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.shiPartNumber = _data["shiPartNumber"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.manufacturerName = _data["manufacturerName"];
            this.description = _data["description"];
            this.quantityOrdered = _data["quantityOrdered"];
            this.isReturnable = _data["isReturnable"];
        }
    }

    static fromJS(data: any): OrderRmaLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRmaLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["shiPartNumber"] = this.shiPartNumber;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["manufacturerName"] = this.manufacturerName;
        data["description"] = this.description;
        data["quantityOrdered"] = this.quantityOrdered;
        data["isReturnable"] = this.isReturnable;
        return data;
    }
}

export interface IOrderRmaLineDto {
    lineNumber?: number;
    shiPartNumber?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    manufacturerName?: string | undefined;
    description?: string | undefined;
    quantityOrdered?: number;
    isReturnable?: boolean;
}

export class OrderRmaReturnReasonDto implements IOrderRmaReturnReasonDto {
    code?: string | undefined;
    label?: string | undefined;
    requiresAdditionalInfo?: boolean;
    requiresAttachment?: boolean;

    constructor(data?: IOrderRmaReturnReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
            this.requiresAdditionalInfo = _data["requiresAdditionalInfo"];
            this.requiresAttachment = _data["requiresAttachment"];
        }
    }

    static fromJS(data: any): OrderRmaReturnReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRmaReturnReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        data["requiresAdditionalInfo"] = this.requiresAdditionalInfo;
        data["requiresAttachment"] = this.requiresAttachment;
        return data;
    }
}

export interface IOrderRmaReturnReasonDto {
    code?: string | undefined;
    label?: string | undefined;
    requiresAdditionalInfo?: boolean;
    requiresAttachment?: boolean;
}

export class OrderRmaSubmissionDto implements IOrderRmaSubmissionDto {
    requestReferenceId?: string;
    requestedOnUtc?: Date;
    biOrderId?: number;
    orderNumber?: string | undefined;
    contact?: OrderRmaContactDto;
    lines?: OrderRmaSubmittedLineDto[] | undefined;
    confirmationEmailStatus?: OrderRmaConfirmationEmailStatus;

    constructor(data?: IOrderRmaSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestReferenceId = _data["requestReferenceId"];
            this.requestedOnUtc = _data["requestedOnUtc"] ? new Date(_data["requestedOnUtc"].toString()) : undefined as any;
            this.biOrderId = _data["biOrderId"];
            this.orderNumber = _data["orderNumber"];
            this.contact = _data["contact"] ? OrderRmaContactDto.fromJS(_data["contact"]) : undefined as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(OrderRmaSubmittedLineDto.fromJS(item));
            }
            this.confirmationEmailStatus = _data["confirmationEmailStatus"];
        }
    }

    static fromJS(data: any): OrderRmaSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRmaSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestReferenceId"] = this.requestReferenceId;
        data["requestedOnUtc"] = this.requestedOnUtc ? this.requestedOnUtc.toISOString() : undefined as any;
        data["biOrderId"] = this.biOrderId;
        data["orderNumber"] = this.orderNumber;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        data["confirmationEmailStatus"] = this.confirmationEmailStatus;
        return data;
    }
}

export interface IOrderRmaSubmissionDto {
    requestReferenceId?: string;
    requestedOnUtc?: Date;
    biOrderId?: number;
    orderNumber?: string | undefined;
    contact?: OrderRmaContactDto;
    lines?: OrderRmaSubmittedLineDto[] | undefined;
    confirmationEmailStatus?: OrderRmaConfirmationEmailStatus;
}

export class OrderRmaSubmittedLineDto implements IOrderRmaSubmittedLineDto {
    orderLineNumber?: number;
    shiPartNumber?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    returnReasonCode?: string | undefined;
    packageOpened?: OrderRmaPackageOpened;
    additionalInfo?: string | undefined;
    attachmentCount?: number;

    constructor(data?: IOrderRmaSubmittedLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLineNumber = _data["orderLineNumber"];
            this.shiPartNumber = _data["shiPartNumber"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.returnReasonCode = _data["returnReasonCode"];
            this.packageOpened = _data["packageOpened"];
            this.additionalInfo = _data["additionalInfo"];
            this.attachmentCount = _data["attachmentCount"];
        }
    }

    static fromJS(data: any): OrderRmaSubmittedLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRmaSubmittedLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderLineNumber"] = this.orderLineNumber;
        data["shiPartNumber"] = this.shiPartNumber;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["returnReasonCode"] = this.returnReasonCode;
        data["packageOpened"] = this.packageOpened;
        data["additionalInfo"] = this.additionalInfo;
        data["attachmentCount"] = this.attachmentCount;
        return data;
    }
}

export interface IOrderRmaSubmittedLineDto {
    orderLineNumber?: number;
    shiPartNumber?: string | undefined;
    manufacturerPartNumber?: string | undefined;
    description?: string | undefined;
    quantity?: number;
    returnReasonCode?: string | undefined;
    packageOpened?: OrderRmaPackageOpened;
    additionalInfo?: string | undefined;
    attachmentCount?: number;
}

export class OrderSummaryDto implements IOrderSummaryDto {
    id?: string | undefined;
    axNumber?: string | undefined;
    biOrderId?: number | undefined;
    crmAccountId?: string;
    customerPoNumber?: string | undefined;
    isInvoiceComplete?: boolean;
    isWebOrder?: boolean;
    orderDate?: Date;
    fulfillmentGroups?: { [key: string]: OrderLineItemDto[]; } | undefined;
    status?: string | undefined;
    orderNumber?: string | undefined;
    orgUnitId?: number | undefined;
    orgUnitName?: string | undefined;
    daysPending?: number | undefined;
    canApprove?: boolean | undefined;
    orderedBy?: string | undefined;
    deliveryContact?: string | undefined;
    orderedByEmployeeId?: number;
    purchaseOrder?: string | undefined;
    salesOrderNumber?: string | undefined;
    shipTo?: OrderAddressDto;
    fulfillmentStatus?: FulfillmentStatus;
    total?: number | undefined;
    totalItems?: number;
    webOrderId?: number | undefined;
    currencyAbbr?: string | undefined;
    currencyLocale?: string | undefined;

    constructor(data?: IOrderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axNumber = _data["axNumber"];
            this.biOrderId = _data["biOrderId"];
            this.crmAccountId = _data["crmAccountId"];
            this.customerPoNumber = _data["customerPoNumber"];
            this.isInvoiceComplete = _data["isInvoiceComplete"];
            this.isWebOrder = _data["isWebOrder"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : undefined as any;
            if (_data["fulfillmentGroups"]) {
                this.fulfillmentGroups = {} as any;
                for (let key in _data["fulfillmentGroups"]) {
                    if (_data["fulfillmentGroups"].hasOwnProperty(key))
                        (this.fulfillmentGroups as any)![key] = _data["fulfillmentGroups"][key] ? _data["fulfillmentGroups"][key].map((i: any) => OrderLineItemDto.fromJS(i)) : [];
                }
            }
            this.status = _data["status"];
            this.orderNumber = _data["orderNumber"];
            this.orgUnitId = _data["orgUnitId"];
            this.orgUnitName = _data["orgUnitName"];
            this.daysPending = _data["daysPending"];
            this.canApprove = _data["canApprove"];
            this.orderedBy = _data["orderedBy"];
            this.deliveryContact = _data["deliveryContact"];
            this.orderedByEmployeeId = _data["orderedByEmployeeId"];
            this.purchaseOrder = _data["purchaseOrder"];
            this.salesOrderNumber = _data["salesOrderNumber"];
            this.shipTo = _data["shipTo"] ? OrderAddressDto.fromJS(_data["shipTo"]) : undefined as any;
            this.fulfillmentStatus = _data["fulfillmentStatus"];
            this.total = _data["total"];
            this.totalItems = _data["totalItems"];
            this.webOrderId = _data["webOrderId"];
            this.currencyAbbr = _data["currencyAbbr"];
            this.currencyLocale = _data["currencyLocale"];
        }
    }

    static fromJS(data: any): OrderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axNumber"] = this.axNumber;
        data["biOrderId"] = this.biOrderId;
        data["crmAccountId"] = this.crmAccountId;
        data["customerPoNumber"] = this.customerPoNumber;
        data["isInvoiceComplete"] = this.isInvoiceComplete;
        data["isWebOrder"] = this.isWebOrder;
        data["orderDate"] = this.orderDate ? formatDate(this.orderDate) : undefined as any;
        if (this.fulfillmentGroups) {
            data["fulfillmentGroups"] = {};
            for (let key in this.fulfillmentGroups) {
                if (this.fulfillmentGroups.hasOwnProperty(key))
                    (data["fulfillmentGroups"] as any)[key] = (this.fulfillmentGroups as any)[key];
            }
        }
        data["status"] = this.status;
        data["orderNumber"] = this.orderNumber;
        data["orgUnitId"] = this.orgUnitId;
        data["orgUnitName"] = this.orgUnitName;
        data["daysPending"] = this.daysPending;
        data["canApprove"] = this.canApprove;
        data["orderedBy"] = this.orderedBy;
        data["deliveryContact"] = this.deliveryContact;
        data["orderedByEmployeeId"] = this.orderedByEmployeeId;
        data["purchaseOrder"] = this.purchaseOrder;
        data["salesOrderNumber"] = this.salesOrderNumber;
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        data["fulfillmentStatus"] = this.fulfillmentStatus;
        data["total"] = this.total;
        data["totalItems"] = this.totalItems;
        data["webOrderId"] = this.webOrderId;
        data["currencyAbbr"] = this.currencyAbbr;
        data["currencyLocale"] = this.currencyLocale;
        return data;
    }
}

export interface IOrderSummaryDto {
    id?: string | undefined;
    axNumber?: string | undefined;
    biOrderId?: number | undefined;
    crmAccountId?: string;
    customerPoNumber?: string | undefined;
    isInvoiceComplete?: boolean;
    isWebOrder?: boolean;
    orderDate?: Date;
    fulfillmentGroups?: { [key: string]: OrderLineItemDto[]; } | undefined;
    status?: string | undefined;
    orderNumber?: string | undefined;
    orgUnitId?: number | undefined;
    orgUnitName?: string | undefined;
    daysPending?: number | undefined;
    canApprove?: boolean | undefined;
    orderedBy?: string | undefined;
    deliveryContact?: string | undefined;
    orderedByEmployeeId?: number;
    purchaseOrder?: string | undefined;
    salesOrderNumber?: string | undefined;
    shipTo?: OrderAddressDto;
    fulfillmentStatus?: FulfillmentStatus;
    total?: number | undefined;
    totalItems?: number;
    webOrderId?: number | undefined;
    currencyAbbr?: string | undefined;
    currencyLocale?: string | undefined;
}

export class RecentOrderDto implements IRecentOrderDto {
    orgUnitId?: number | undefined;
    webOrderId?: number | undefined;
    biOrderId?: number | undefined;
    orderNumber?: string | undefined;
    poNumber?: string | undefined;
    orderedBy?: string | undefined;
    shipTo?: string | undefined;
    status?: string | undefined;
    productCount?: number | undefined;
    totalPrice?: number | undefined;
    orderedOn?: Date | undefined;

    constructor(data?: IRecentOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.webOrderId = _data["webOrderId"];
            this.biOrderId = _data["biOrderId"];
            this.orderNumber = _data["orderNumber"];
            this.poNumber = _data["poNumber"];
            this.orderedBy = _data["orderedBy"];
            this.shipTo = _data["shipTo"];
            this.status = _data["status"];
            this.productCount = _data["productCount"];
            this.totalPrice = _data["totalPrice"];
            this.orderedOn = _data["orderedOn"] ? new Date(_data["orderedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RecentOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecentOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["webOrderId"] = this.webOrderId;
        data["biOrderId"] = this.biOrderId;
        data["orderNumber"] = this.orderNumber;
        data["poNumber"] = this.poNumber;
        data["orderedBy"] = this.orderedBy;
        data["shipTo"] = this.shipTo;
        data["status"] = this.status;
        data["productCount"] = this.productCount;
        data["totalPrice"] = this.totalPrice;
        data["orderedOn"] = this.orderedOn ? this.orderedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IRecentOrderDto {
    orgUnitId?: number | undefined;
    webOrderId?: number | undefined;
    biOrderId?: number | undefined;
    orderNumber?: string | undefined;
    poNumber?: string | undefined;
    orderedBy?: string | undefined;
    shipTo?: string | undefined;
    status?: string | undefined;
    productCount?: number | undefined;
    totalPrice?: number | undefined;
    orderedOn?: Date | undefined;
}

export class ShipmentTrackingDto implements IShipmentTrackingDto {
    trackingNumber?: string | undefined;
    carrier?: string | undefined;
    serviceType?: string | undefined;
    weight?: string | undefined;
    shippedOn?: Date | undefined;
    deliveredOn?: Date | undefined;
    estimatedDeliveryOn?: Date | undefined;
    trackingHistory?: TrackingEventDto[] | undefined;

    constructor(data?: IShipmentTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingNumber = _data["trackingNumber"];
            this.carrier = _data["carrier"];
            this.serviceType = _data["serviceType"];
            this.weight = _data["weight"];
            this.shippedOn = _data["shippedOn"] ? new Date(_data["shippedOn"].toString()) : undefined as any;
            this.deliveredOn = _data["deliveredOn"] ? new Date(_data["deliveredOn"].toString()) : undefined as any;
            this.estimatedDeliveryOn = _data["estimatedDeliveryOn"] ? new Date(_data["estimatedDeliveryOn"].toString()) : undefined as any;
            if (Array.isArray(_data["trackingHistory"])) {
                this.trackingHistory = [] as any;
                for (let item of _data["trackingHistory"])
                    this.trackingHistory!.push(TrackingEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShipmentTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingNumber"] = this.trackingNumber;
        data["carrier"] = this.carrier;
        data["serviceType"] = this.serviceType;
        data["weight"] = this.weight;
        data["shippedOn"] = this.shippedOn ? this.shippedOn.toISOString() : undefined as any;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : undefined as any;
        data["estimatedDeliveryOn"] = this.estimatedDeliveryOn ? this.estimatedDeliveryOn.toISOString() : undefined as any;
        if (Array.isArray(this.trackingHistory)) {
            data["trackingHistory"] = [];
            for (let item of this.trackingHistory)
                data["trackingHistory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShipmentTrackingDto {
    trackingNumber?: string | undefined;
    carrier?: string | undefined;
    serviceType?: string | undefined;
    weight?: string | undefined;
    shippedOn?: Date | undefined;
    deliveredOn?: Date | undefined;
    estimatedDeliveryOn?: Date | undefined;
    trackingHistory?: TrackingEventDto[] | undefined;
}

export class ShippingDetailsDto implements IShippingDetailsDto {
    biOrderId?: number | undefined;
    webOrderId?: number | undefined;
    orgUnitId?: number | undefined;
    delivery?: DeliveryDetailsDto;
    shipTo?: OrderAddressDto;

    constructor(data?: IShippingDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biOrderId = _data["biOrderId"];
            this.webOrderId = _data["webOrderId"];
            this.orgUnitId = _data["orgUnitId"];
            this.delivery = _data["delivery"] ? DeliveryDetailsDto.fromJS(_data["delivery"]) : undefined as any;
            this.shipTo = _data["shipTo"] ? OrderAddressDto.fromJS(_data["shipTo"]) : undefined as any;
        }
    }

    static fromJS(data: any): ShippingDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biOrderId"] = this.biOrderId;
        data["webOrderId"] = this.webOrderId;
        data["orgUnitId"] = this.orgUnitId;
        data["delivery"] = this.delivery ? this.delivery.toJSON() : undefined as any;
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        return data;
    }
}

export interface IShippingDetailsDto {
    biOrderId?: number | undefined;
    webOrderId?: number | undefined;
    orgUnitId?: number | undefined;
    delivery?: DeliveryDetailsDto;
    shipTo?: OrderAddressDto;
}

export class TrackingEventDto implements ITrackingEventDto {
    updateDate?: Date | undefined;
    status?: string | undefined;
    location?: string | undefined;

    constructor(data?: ITrackingEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): TrackingEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["location"] = this.location;
        return data;
    }
}

export interface ITrackingEventDto {
    updateDate?: Date | undefined;
    status?: string | undefined;
    location?: string | undefined;
}

export class WebOrderApprovalDetailDto implements IWebOrderApprovalDetailDto {
    webOrderId?: number;
    currencyCode?: string | undefined;
    orgUnitId?: number | undefined;
    poNumber?: string | undefined;
    orderStatus?: string | undefined;
    dateOrdered?: Date | undefined;
    orgUnitName?: string | undefined;
    daysPending?: number | undefined;
    orderedByName?: string | undefined;
    orderedByEmployeeId?: number | undefined;
    lineItems?: OrderLineItemDto[] | undefined;
    shipTo?: ShippingDetailsDto;
    billTo?: OrderAddressDto;
    payment?: OrderPaymentDto;
    checkoutQuestions?: OrderApprovalCheckoutQuestionDto[] | undefined;
    approval?: WebOrderApprovalInfoDto;

    constructor(data?: IWebOrderApprovalDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webOrderId = _data["webOrderId"];
            this.currencyCode = _data["currencyCode"];
            this.orgUnitId = _data["orgUnitId"];
            this.poNumber = _data["poNumber"];
            this.orderStatus = _data["orderStatus"];
            this.dateOrdered = _data["dateOrdered"] ? new Date(_data["dateOrdered"].toString()) : undefined as any;
            this.orgUnitName = _data["orgUnitName"];
            this.daysPending = _data["daysPending"];
            this.orderedByName = _data["orderedByName"];
            this.orderedByEmployeeId = _data["orderedByEmployeeId"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(OrderLineItemDto.fromJS(item));
            }
            this.shipTo = _data["shipTo"] ? ShippingDetailsDto.fromJS(_data["shipTo"]) : undefined as any;
            this.billTo = _data["billTo"] ? OrderAddressDto.fromJS(_data["billTo"]) : undefined as any;
            this.payment = _data["payment"] ? OrderPaymentDto.fromJS(_data["payment"]) : undefined as any;
            if (Array.isArray(_data["checkoutQuestions"])) {
                this.checkoutQuestions = [] as any;
                for (let item of _data["checkoutQuestions"])
                    this.checkoutQuestions!.push(OrderApprovalCheckoutQuestionDto.fromJS(item));
            }
            this.approval = _data["approval"] ? WebOrderApprovalInfoDto.fromJS(_data["approval"]) : undefined as any;
        }
    }

    static fromJS(data: any): WebOrderApprovalDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebOrderApprovalDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webOrderId"] = this.webOrderId;
        data["currencyCode"] = this.currencyCode;
        data["orgUnitId"] = this.orgUnitId;
        data["poNumber"] = this.poNumber;
        data["orderStatus"] = this.orderStatus;
        data["dateOrdered"] = this.dateOrdered ? this.dateOrdered.toISOString() : undefined as any;
        data["orgUnitName"] = this.orgUnitName;
        data["daysPending"] = this.daysPending;
        data["orderedByName"] = this.orderedByName;
        data["orderedByEmployeeId"] = this.orderedByEmployeeId;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["shipTo"] = this.shipTo ? this.shipTo.toJSON() : undefined as any;
        data["billTo"] = this.billTo ? this.billTo.toJSON() : undefined as any;
        data["payment"] = this.payment ? this.payment.toJSON() : undefined as any;
        if (Array.isArray(this.checkoutQuestions)) {
            data["checkoutQuestions"] = [];
            for (let item of this.checkoutQuestions)
                data["checkoutQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        data["approval"] = this.approval ? this.approval.toJSON() : undefined as any;
        return data;
    }
}

export interface IWebOrderApprovalDetailDto {
    webOrderId?: number;
    currencyCode?: string | undefined;
    orgUnitId?: number | undefined;
    poNumber?: string | undefined;
    orderStatus?: string | undefined;
    dateOrdered?: Date | undefined;
    orgUnitName?: string | undefined;
    daysPending?: number | undefined;
    orderedByName?: string | undefined;
    orderedByEmployeeId?: number | undefined;
    lineItems?: OrderLineItemDto[] | undefined;
    shipTo?: ShippingDetailsDto;
    billTo?: OrderAddressDto;
    payment?: OrderPaymentDto;
    checkoutQuestions?: OrderApprovalCheckoutQuestionDto[] | undefined;
    approval?: WebOrderApprovalInfoDto;
}

export class WebOrderApprovalInfoDto implements IWebOrderApprovalInfoDto {
    hasApprovalWorkflow?: boolean;
    canApprove?: boolean;
    currentApprovalPathStepId?: number | undefined;
    pendingApprovers?: string[] | undefined;
    steps?: OrderApprovalHistoryStepDto[] | undefined;

    constructor(data?: IWebOrderApprovalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasApprovalWorkflow = _data["hasApprovalWorkflow"];
            this.canApprove = _data["canApprove"];
            this.currentApprovalPathStepId = _data["currentApprovalPathStepId"];
            if (Array.isArray(_data["pendingApprovers"])) {
                this.pendingApprovers = [] as any;
                for (let item of _data["pendingApprovers"])
                    this.pendingApprovers!.push(item);
            }
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(OrderApprovalHistoryStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebOrderApprovalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebOrderApprovalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasApprovalWorkflow"] = this.hasApprovalWorkflow;
        data["canApprove"] = this.canApprove;
        data["currentApprovalPathStepId"] = this.currentApprovalPathStepId;
        if (Array.isArray(this.pendingApprovers)) {
            data["pendingApprovers"] = [];
            for (let item of this.pendingApprovers)
                data["pendingApprovers"].push(item);
        }
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWebOrderApprovalInfoDto {
    hasApprovalWorkflow?: boolean;
    canApprove?: boolean;
    currentApprovalPathStepId?: number | undefined;
    pendingApprovers?: string[] | undefined;
    steps?: OrderApprovalHistoryStepDto[] | undefined;
}

export class AwsPotentialSavingsWidgetDto implements IAwsPotentialSavingsWidgetDto {
    optimizationSavingsAmount?: number | undefined;
    optimizationSavingsSeverityColor?: SeverityColor;
    rightsizingSavingsAmount?: number;
    rightsizingSavingsSeverityColor?: SeverityColor;
    withSavingsPlansAmount?: number;
    withSavingsPlansSeverityColor?: SeverityColor;
    reservationsSavingsAmount?: number;
    reservationsSavingsSeverityColor?: SeverityColor;

    constructor(data?: IAwsPotentialSavingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optimizationSavingsAmount = _data["optimizationSavingsAmount"];
            this.optimizationSavingsSeverityColor = _data["optimizationSavingsSeverityColor"];
            this.rightsizingSavingsAmount = _data["rightsizingSavingsAmount"];
            this.rightsizingSavingsSeverityColor = _data["rightsizingSavingsSeverityColor"];
            this.withSavingsPlansAmount = _data["withSavingsPlansAmount"];
            this.withSavingsPlansSeverityColor = _data["withSavingsPlansSeverityColor"];
            this.reservationsSavingsAmount = _data["reservationsSavingsAmount"];
            this.reservationsSavingsSeverityColor = _data["reservationsSavingsSeverityColor"];
        }
    }

    static fromJS(data: any): AwsPotentialSavingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwsPotentialSavingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optimizationSavingsAmount"] = this.optimizationSavingsAmount;
        data["optimizationSavingsSeverityColor"] = this.optimizationSavingsSeverityColor;
        data["rightsizingSavingsAmount"] = this.rightsizingSavingsAmount;
        data["rightsizingSavingsSeverityColor"] = this.rightsizingSavingsSeverityColor;
        data["withSavingsPlansAmount"] = this.withSavingsPlansAmount;
        data["withSavingsPlansSeverityColor"] = this.withSavingsPlansSeverityColor;
        data["reservationsSavingsAmount"] = this.reservationsSavingsAmount;
        data["reservationsSavingsSeverityColor"] = this.reservationsSavingsSeverityColor;
        return data;
    }
}

export interface IAwsPotentialSavingsWidgetDto {
    optimizationSavingsAmount?: number | undefined;
    optimizationSavingsSeverityColor?: SeverityColor;
    rightsizingSavingsAmount?: number;
    rightsizingSavingsSeverityColor?: SeverityColor;
    withSavingsPlansAmount?: number;
    withSavingsPlansSeverityColor?: SeverityColor;
    reservationsSavingsAmount?: number;
    reservationsSavingsSeverityColor?: SeverityColor;
}

export class BarChartDatasetDto implements IBarChartDatasetDto {
    label?: string | undefined;
    stackId?: string | undefined;
    data?: number[] | undefined;

    constructor(data?: IBarChartDatasetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.stackId = _data["stackId"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): BarChartDatasetDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarChartDatasetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["stackId"] = this.stackId;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IBarChartDatasetDto {
    label?: string | undefined;
    stackId?: string | undefined;
    data?: number[] | undefined;
}

export class BarChartDto implements IBarChartDto {
    datasets?: BarChartDatasetDto[] | undefined;
    labels?: string[] | undefined;

    constructor(data?: IBarChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets!.push(BarChartDatasetDto.fromJS(item));
            }
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
        }
    }

    static fromJS(data: any): BarChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        return data;
    }
}

export interface IBarChartDto {
    datasets?: BarChartDatasetDto[] | undefined;
    labels?: string[] | undefined;
}

export class CloudPotentialSavingsWidgetDto implements ICloudPotentialSavingsWidgetDto {
    optimizationSavingsAmount?: number | undefined;
    optimizationSavingsSeverityColor?: SeverityColor;
    rightsizingSavingsAmount?: number;
    rightsizingSavingsSeverityColor?: SeverityColor;
    withSavingsPlansAmount?: number;
    withSavingsPlansSeverityColor?: SeverityColor;
    reservationsSavingsAmount?: number;
    reservationsSavingsSeverityColor?: SeverityColor;

    constructor(data?: ICloudPotentialSavingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optimizationSavingsAmount = _data["optimizationSavingsAmount"];
            this.optimizationSavingsSeverityColor = _data["optimizationSavingsSeverityColor"];
            this.rightsizingSavingsAmount = _data["rightsizingSavingsAmount"];
            this.rightsizingSavingsSeverityColor = _data["rightsizingSavingsSeverityColor"];
            this.withSavingsPlansAmount = _data["withSavingsPlansAmount"];
            this.withSavingsPlansSeverityColor = _data["withSavingsPlansSeverityColor"];
            this.reservationsSavingsAmount = _data["reservationsSavingsAmount"];
            this.reservationsSavingsSeverityColor = _data["reservationsSavingsSeverityColor"];
        }
    }

    static fromJS(data: any): CloudPotentialSavingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudPotentialSavingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optimizationSavingsAmount"] = this.optimizationSavingsAmount;
        data["optimizationSavingsSeverityColor"] = this.optimizationSavingsSeverityColor;
        data["rightsizingSavingsAmount"] = this.rightsizingSavingsAmount;
        data["rightsizingSavingsSeverityColor"] = this.rightsizingSavingsSeverityColor;
        data["withSavingsPlansAmount"] = this.withSavingsPlansAmount;
        data["withSavingsPlansSeverityColor"] = this.withSavingsPlansSeverityColor;
        data["reservationsSavingsAmount"] = this.reservationsSavingsAmount;
        data["reservationsSavingsSeverityColor"] = this.reservationsSavingsSeverityColor;
        return data;
    }
}

export interface ICloudPotentialSavingsWidgetDto {
    optimizationSavingsAmount?: number | undefined;
    optimizationSavingsSeverityColor?: SeverityColor;
    rightsizingSavingsAmount?: number;
    rightsizingSavingsSeverityColor?: SeverityColor;
    withSavingsPlansAmount?: number;
    withSavingsPlansSeverityColor?: SeverityColor;
    reservationsSavingsAmount?: number;
    reservationsSavingsSeverityColor?: SeverityColor;
}

export class PageLayoutColumnDto implements IPageLayoutColumnDto {
    widgets?: PageLayoutWidgetDto[] | undefined;

    constructor(data?: IPageLayoutColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(PageLayoutWidgetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PageLayoutColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageLayoutColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPageLayoutColumnDto {
    widgets?: PageLayoutWidgetDto[] | undefined;
}

export class PageLayoutDto implements IPageLayoutDto {
    pageLayoutId?: string | undefined;
    columns?: PageLayoutColumnDto[] | undefined;
    widgetGroups?: string[] | undefined;

    constructor(data?: IPageLayoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageLayoutId = _data["pageLayoutId"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(PageLayoutColumnDto.fromJS(item));
            }
            if (Array.isArray(_data["widgetGroups"])) {
                this.widgetGroups = [] as any;
                for (let item of _data["widgetGroups"])
                    this.widgetGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): PageLayoutDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageLayoutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageLayoutId"] = this.pageLayoutId;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.widgetGroups)) {
            data["widgetGroups"] = [];
            for (let item of this.widgetGroups)
                data["widgetGroups"].push(item);
        }
        return data;
    }
}

export interface IPageLayoutDto {
    pageLayoutId?: string | undefined;
    columns?: PageLayoutColumnDto[] | undefined;
    widgetGroups?: string[] | undefined;
}

export class PageLayoutWidgetDto implements IPageLayoutWidgetDto {
    widgetId?: string | undefined;
    title?: string | undefined;
    widgetGroup?: string | undefined;
    enabled?: boolean;
    featureFlag?: string | undefined;

    constructor(data?: IPageLayoutWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.title = _data["title"];
            this.widgetGroup = _data["widgetGroup"];
            this.enabled = _data["enabled"];
            this.featureFlag = _data["featureFlag"];
        }
    }

    static fromJS(data: any): PageLayoutWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageLayoutWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["title"] = this.title;
        data["widgetGroup"] = this.widgetGroup;
        data["enabled"] = this.enabled;
        data["featureFlag"] = this.featureFlag;
        return data;
    }
}

export interface IPageLayoutWidgetDto {
    widgetId?: string | undefined;
    title?: string | undefined;
    widgetGroup?: string | undefined;
    enabled?: boolean;
    featureFlag?: string | undefined;
}

export class PieChartDto implements IPieChartDto {
    totalLabel?: string | undefined;
    totalCount?: number;
    slices?: PieChartSliceDto[] | undefined;

    constructor(data?: IPieChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLabel = _data["totalLabel"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["slices"])) {
                this.slices = [] as any;
                for (let item of _data["slices"])
                    this.slices!.push(PieChartSliceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PieChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PieChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLabel"] = this.totalLabel;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.slices)) {
            data["slices"] = [];
            for (let item of this.slices)
                data["slices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPieChartDto {
    totalLabel?: string | undefined;
    totalCount?: number;
    slices?: PieChartSliceDto[] | undefined;
}

export class PieChartSliceDto implements IPieChartSliceDto {
    label?: string | undefined;
    quantity?: number;
    percentage?: number | undefined;

    constructor(data?: IPieChartSliceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.quantity = _data["quantity"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): PieChartSliceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PieChartSliceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["quantity"] = this.quantity;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IPieChartSliceDto {
    label?: string | undefined;
    quantity?: number;
    percentage?: number | undefined;
}

export class SampleWidgetBResponseDto implements ISampleWidgetBResponseDto {
    incomingAssets?: number;
    transferringAssets?: number;
    assetsAvailableToTransfer?: number;
    productsAtLevelRisk?: number;

    constructor(data?: ISampleWidgetBResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomingAssets = _data["incomingAssets"];
            this.transferringAssets = _data["transferringAssets"];
            this.assetsAvailableToTransfer = _data["assetsAvailableToTransfer"];
            this.productsAtLevelRisk = _data["productsAtLevelRisk"];
        }
    }

    static fromJS(data: any): SampleWidgetBResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SampleWidgetBResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomingAssets"] = this.incomingAssets;
        data["transferringAssets"] = this.transferringAssets;
        data["assetsAvailableToTransfer"] = this.assetsAvailableToTransfer;
        data["productsAtLevelRisk"] = this.productsAtLevelRisk;
        return data;
    }
}

export interface ISampleWidgetBResponseDto {
    incomingAssets?: number;
    transferringAssets?: number;
    assetsAvailableToTransfer?: number;
    productsAtLevelRisk?: number;
}

export enum SeverityColor {
    BadCritical = "BadCritical",
    WarningHigh = "WarningHigh",
    Medium = "Medium",
    GoodLow = "GoodLow",
}

export class WidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse implements IWidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsSpendByAssetTypeResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetAssetsSpendByAssetTypeResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetAssetsSpendByAssetTypeResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsSpendByAssetTypeResponse;
}

export class WidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse implements IWidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsSpendByCategoryResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetAssetsSpendByCategoryResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetAssetsSpendByCategoryResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsSpendByCategoryResponse;
}

export class WidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse implements IWidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsSpendByManufacturerResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetAssetsSpendByManufacturerResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetAssetsSpendByManufacturerResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsSpendByManufacturerResponse;
}

export class WidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse implements IWidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsSpendComparisonResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetAssetsSpendComparisonResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetAssetsSpendComparisonResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsSpendComparisonResponse;
}

export class WidgetContentResponseDto_1OfGetAssetsTotalSpendResponse implements IWidgetContentResponseDto_1OfGetAssetsTotalSpendResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsTotalSpendResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetAssetsTotalSpendResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetAssetsTotalSpendResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetAssetsTotalSpendResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetAssetsTotalSpendResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetAssetsTotalSpendResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetAssetsTotalSpendResponse;
}

export class WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse implements IWidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetWarehouseAggregatedOrdersResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetWarehouseAggregatedOrdersResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetWarehouseAggregatedOrdersResponse;
}

export class WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse implements IWidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetWarehouseAggregatedStockResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetWarehouseAggregatedStockResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetWarehouseAggregatedStockResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetWarehouseAggregatedStockResponse;
}

export class WidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse implements IWidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: PurchasedAssetsHardwareByAgeResponse;

    constructor(data?: IWidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? PurchasedAssetsHardwareByAgeResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfPurchasedAssetsHardwareByAgeResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: PurchasedAssetsHardwareByAgeResponse;
}

export class WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto implements IWidgetContentResponseDto_1OfContractRequestRankingsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ContractRequestRankingsVisualsDto;

    constructor(data?: IWidgetContentResponseDto_1OfContractRequestRankingsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? ContractRequestRankingsVisualsDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfContractRequestRankingsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfContractRequestRankingsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ContractRequestRankingsVisualsDto;
}

export class WidgetContentResponseDto_1OfRequestMetricsVisualsDto implements IWidgetContentResponseDto_1OfRequestMetricsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: RequestMetricsVisualsDto;

    constructor(data?: IWidgetContentResponseDto_1OfRequestMetricsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? RequestMetricsVisualsDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfRequestMetricsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfRequestMetricsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfRequestMetricsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: RequestMetricsVisualsDto;
}

export class WidgetContentResponseDto_1OfRequesterRankingsVisualsDto implements IWidgetContentResponseDto_1OfRequesterRankingsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: RequesterRankingsVisualsDto;

    constructor(data?: IWidgetContentResponseDto_1OfRequesterRankingsVisualsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? RequesterRankingsVisualsDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfRequesterRankingsVisualsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfRequesterRankingsVisualsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfRequesterRankingsVisualsDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: RequesterRankingsVisualsDto;
}

export class WidgetContentResponseDto_1OfSupportOverviewDto implements IWidgetContentResponseDto_1OfSupportOverviewDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: SupportOverviewDto;

    constructor(data?: IWidgetContentResponseDto_1OfSupportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? SupportOverviewDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfSupportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfSupportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfSupportOverviewDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: SupportOverviewDto;
}

export class WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto implements IWidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: AwsPotentialSavingsWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? AwsPotentialSavingsWidgetDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfAwsPotentialSavingsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: AwsPotentialSavingsWidgetDto;
}

export class WidgetContentResponseDto_1OfBarChartDto implements IWidgetContentResponseDto_1OfBarChartDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: BarChartDto;

    constructor(data?: IWidgetContentResponseDto_1OfBarChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? BarChartDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfBarChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfBarChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfBarChartDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: BarChartDto;
}

export class WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto implements IWidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CloudPotentialSavingsWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? CloudPotentialSavingsWidgetDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfCloudPotentialSavingsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CloudPotentialSavingsWidgetDto;
}

export class WidgetContentResponseDto_1OfPieChartDto implements IWidgetContentResponseDto_1OfPieChartDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: PieChartDto;

    constructor(data?: IWidgetContentResponseDto_1OfPieChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? PieChartDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfPieChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfPieChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfPieChartDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: PieChartDto;
}

export class WidgetContentResponseDto_1OfSampleWidgetBResponseDto implements IWidgetContentResponseDto_1OfSampleWidgetBResponseDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: SampleWidgetBResponseDto;

    constructor(data?: IWidgetContentResponseDto_1OfSampleWidgetBResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? SampleWidgetBResponseDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfSampleWidgetBResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfSampleWidgetBResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfSampleWidgetBResponseDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: SampleWidgetBResponseDto;
}

export class WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse implements IWidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetCurrentMonthCloudConsumptionResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetCurrentMonthCloudConsumptionResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetCurrentMonthCloudConsumptionResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetCurrentMonthCloudConsumptionResponse;
}

export class WidgetContentResponseDto_1OfLastMonthsCostDto implements IWidgetContentResponseDto_1OfLastMonthsCostDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: LastMonthsCostDto;

    constructor(data?: IWidgetContentResponseDto_1OfLastMonthsCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? LastMonthsCostDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfLastMonthsCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfLastMonthsCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfLastMonthsCostDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: LastMonthsCostDto;
}

export class WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf implements IWidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CloudAssetsWidgetDto[] | undefined;

    constructor(data?: IWidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CloudAssetsWidgetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfCloudAssetsWidgetDtoOf {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: CloudAssetsWidgetDto[] | undefined;
}

export class WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse implements IWidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetCloudConsumptionHistoryResponse;

    constructor(data?: IWidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? GetCloudConsumptionHistoryResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfGetCloudConsumptionHistoryResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: GetCloudConsumptionHistoryResponse;
}

export class WidgetContentResponseDto_1OfServiceContractsWidgetDto implements IWidgetContentResponseDto_1OfServiceContractsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServiceContractsWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfServiceContractsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? ServiceContractsWidgetDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfServiceContractsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfServiceContractsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfServiceContractsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServiceContractsWidgetDto;
}

export class WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto implements IWidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServiceRequestCompletedMeetingSlaWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? ServiceRequestCompletedMeetingSlaWidgetDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfServiceRequestCompletedMeetingSlaWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServiceRequestCompletedMeetingSlaWidgetDto;
}

export class WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto implements IWidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServicesExpiringContractsWidgetDto;

    constructor(data?: IWidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"] ? ServicesExpiringContractsWidgetDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfServicesExpiringContractsWidgetDto {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: ServicesExpiringContractsWidgetDto;
}

export class WidgetContentResponseDto_1OfString implements IWidgetContentResponseDto_1OfString {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: string | undefined;

    constructor(data?: IWidgetContentResponseDto_1OfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.isEmptyDataSet = _data["isEmptyDataSet"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): WidgetContentResponseDto_1OfString {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetContentResponseDto_1OfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["isEmptyDataSet"] = this.isEmptyDataSet;
        data["data"] = this.data;
        return data;
    }
}

export interface IWidgetContentResponseDto_1OfString {
    success?: boolean;
    errorMessage?: string | undefined;
    isEmptyDataSet?: boolean;
    data?: string | undefined;
}

export class DuplicateReportRequest implements IDuplicateReportRequest {
    reportName!: string | undefined;
    reportDescription?: string | undefined;
    powerBiReportId?: string;
    authorizationSettings!: SelfServiceAuthorizationSettings;

    constructor(data?: IDuplicateReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.authorizationSettings = new SelfServiceAuthorizationSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportName = _data["reportName"];
            this.reportDescription = _data["reportDescription"];
            this.powerBiReportId = _data["powerBiReportId"];
            this.authorizationSettings = _data["authorizationSettings"] ? SelfServiceAuthorizationSettings.fromJS(_data["authorizationSettings"]) : new SelfServiceAuthorizationSettings();
        }
    }

    static fromJS(data: any): DuplicateReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportName"] = this.reportName;
        data["reportDescription"] = this.reportDescription;
        data["powerBiReportId"] = this.powerBiReportId;
        data["authorizationSettings"] = this.authorizationSettings ? this.authorizationSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IDuplicateReportRequest {
    reportName: string | undefined;
    reportDescription?: string | undefined;
    powerBiReportId?: string;
    authorizationSettings: SelfServiceAuthorizationSettings;
}

export class EmbedParams implements IEmbedParams {
    type?: string | undefined;
    embedReport?: EmbedReport;
    embedToken?: EmbedToken;

    constructor(data?: IEmbedParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.embedReport = _data["embedReport"] ? EmbedReport.fromJS(_data["embedReport"]) : undefined as any;
            this.embedToken = _data["embedToken"] ? EmbedToken.fromJS(_data["embedToken"]) : undefined as any;
        }
    }

    static fromJS(data: any): EmbedParams {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["embedReport"] = this.embedReport ? this.embedReport.toJSON() : undefined as any;
        data["embedToken"] = this.embedToken ? this.embedToken.toJSON() : undefined as any;
        return data;
    }
}

export interface IEmbedParams {
    type?: string | undefined;
    embedReport?: EmbedReport;
    embedToken?: EmbedToken;
}

export class ActiveSelfServiceIntegrationDto implements IActiveSelfServiceIntegrationDto {
    primaryAxNumber?: string | undefined;
    secondaryAxNumbers?: string[] | undefined;
    accountId?: number;
    workspaceId?: string;
    selfServiceEnvironmentId?: number;
    datasetCategories?: DatasetCategories[] | undefined;
    datasets?: SelfServiceDatasetDto[] | undefined;

    constructor(data?: IActiveSelfServiceIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryAxNumber = _data["primaryAxNumber"];
            if (Array.isArray(_data["secondaryAxNumbers"])) {
                this.secondaryAxNumbers = [] as any;
                for (let item of _data["secondaryAxNumbers"])
                    this.secondaryAxNumbers!.push(item);
            }
            this.accountId = _data["accountId"];
            this.workspaceId = _data["workspaceId"];
            this.selfServiceEnvironmentId = _data["selfServiceEnvironmentId"];
            if (Array.isArray(_data["datasetCategories"])) {
                this.datasetCategories = [] as any;
                for (let item of _data["datasetCategories"])
                    this.datasetCategories!.push(item);
            }
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets!.push(SelfServiceDatasetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveSelfServiceIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveSelfServiceIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryAxNumber"] = this.primaryAxNumber;
        if (Array.isArray(this.secondaryAxNumbers)) {
            data["secondaryAxNumbers"] = [];
            for (let item of this.secondaryAxNumbers)
                data["secondaryAxNumbers"].push(item);
        }
        data["accountId"] = this.accountId;
        data["workspaceId"] = this.workspaceId;
        data["selfServiceEnvironmentId"] = this.selfServiceEnvironmentId;
        if (Array.isArray(this.datasetCategories)) {
            data["datasetCategories"] = [];
            for (let item of this.datasetCategories)
                data["datasetCategories"].push(item);
        }
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IActiveSelfServiceIntegrationDto {
    primaryAxNumber?: string | undefined;
    secondaryAxNumbers?: string[] | undefined;
    accountId?: number;
    workspaceId?: string;
    selfServiceEnvironmentId?: number;
    datasetCategories?: DatasetCategories[] | undefined;
    datasets?: SelfServiceDatasetDto[] | undefined;
}

export class BookmarkDto implements IBookmarkDto {
    readonly bookmarkId?: string | undefined;
    bookmarkType?: BookmarkTypes;
    entityId?: string | undefined;
    settingsKey?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    reportId?: string | undefined;

    constructor(data?: IBookmarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).bookmarkId = _data["bookmarkId"];
            this.bookmarkType = _data["bookmarkType"];
            this.entityId = _data["entityId"];
            this.settingsKey = _data["settingsKey"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): BookmarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookmarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookmarkId"] = this.bookmarkId;
        data["bookmarkType"] = this.bookmarkType;
        data["entityId"] = this.entityId;
        data["settingsKey"] = this.settingsKey;
        data["name"] = this.name;
        data["value"] = this.value;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IBookmarkDto {
    bookmarkId?: string | undefined;
    bookmarkType?: BookmarkTypes;
    entityId?: string | undefined;
    settingsKey?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    reportId?: string | undefined;
}

export enum BookmarkTypes {
    Group = "Group",
    User = "User",
}

export class BookmarksDto implements IBookmarksDto {
    userBookmarks?: BookmarkDto[] | undefined;
    groupBookmarks?: BookmarkDto[] | undefined;

    constructor(data?: IBookmarksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userBookmarks"])) {
                this.userBookmarks = [] as any;
                for (let item of _data["userBookmarks"])
                    this.userBookmarks!.push(BookmarkDto.fromJS(item));
            }
            if (Array.isArray(_data["groupBookmarks"])) {
                this.groupBookmarks = [] as any;
                for (let item of _data["groupBookmarks"])
                    this.groupBookmarks!.push(BookmarkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookmarksDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookmarksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userBookmarks)) {
            data["userBookmarks"] = [];
            for (let item of this.userBookmarks)
                data["userBookmarks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groupBookmarks)) {
            data["groupBookmarks"] = [];
            for (let item of this.groupBookmarks)
                data["groupBookmarks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBookmarksDto {
    userBookmarks?: BookmarkDto[] | undefined;
    groupBookmarks?: BookmarkDto[] | undefined;
}

export class EmbedReport implements IEmbedReport {
    reportId?: string | undefined;
    reportName?: string | undefined;
    embedUrl?: string | undefined;

    constructor(data?: IEmbedReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportName = _data["reportName"];
            this.embedUrl = _data["embedUrl"];
        }
    }

    static fromJS(data: any): EmbedReport {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportName"] = this.reportName;
        data["embedUrl"] = this.embedUrl;
        return data;
    }
}

export interface IEmbedReport {
    reportId?: string | undefined;
    reportName?: string | undefined;
    embedUrl?: string | undefined;
}

export class GetReportHistory implements IGetReportHistory {
    versions?: SelfServiceReportVersionDto[][] | undefined;

    constructor(data?: IGetReportHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetReportHistory {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item);
        }
        return data;
    }
}

export interface IGetReportHistory {
    versions?: SelfServiceReportVersionDto[][] | undefined;
}

export class ReportDto implements IReportDto {
    id?: number;
    pbiReportId?: string;
    name?: string | undefined;
    description?: string | undefined;
    draftVersionId?: number | undefined;
    activeVersionId?: number | undefined;
    draftVersion?: ReportVersionDto;
    activeVersion?: ReportVersionDto;
    versionId?: number;
    datasetCategory?: DatasetCategories;
    pbiDatasetId?: string;
    status?: ReportStatus;
    canEdit?: boolean;
    canDuplicate?: boolean;
    canDelete?: boolean;
    canDiscardChanges?: boolean;
    canDiscardChangesAndTakeOwnership?: boolean;
    canPublish?: boolean;
    canUnpublish?: boolean;

    constructor(data?: IReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pbiReportId = _data["pbiReportId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.draftVersionId = _data["draftVersionId"];
            this.activeVersionId = _data["activeVersionId"];
            this.draftVersion = _data["draftVersion"] ? ReportVersionDto.fromJS(_data["draftVersion"]) : undefined as any;
            this.activeVersion = _data["activeVersion"] ? ReportVersionDto.fromJS(_data["activeVersion"]) : undefined as any;
            this.versionId = _data["versionId"];
            this.datasetCategory = _data["datasetCategory"];
            this.pbiDatasetId = _data["pbiDatasetId"];
            this.status = _data["status"];
            this.canEdit = _data["canEdit"];
            this.canDuplicate = _data["canDuplicate"];
            this.canDelete = _data["canDelete"];
            this.canDiscardChanges = _data["canDiscardChanges"];
            this.canDiscardChangesAndTakeOwnership = _data["canDiscardChangesAndTakeOwnership"];
            this.canPublish = _data["canPublish"];
            this.canUnpublish = _data["canUnpublish"];
        }
    }

    static fromJS(data: any): ReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pbiReportId"] = this.pbiReportId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["draftVersionId"] = this.draftVersionId;
        data["activeVersionId"] = this.activeVersionId;
        data["draftVersion"] = this.draftVersion ? this.draftVersion.toJSON() : undefined as any;
        data["activeVersion"] = this.activeVersion ? this.activeVersion.toJSON() : undefined as any;
        data["versionId"] = this.versionId;
        data["datasetCategory"] = this.datasetCategory;
        data["pbiDatasetId"] = this.pbiDatasetId;
        data["status"] = this.status;
        data["canEdit"] = this.canEdit;
        data["canDuplicate"] = this.canDuplicate;
        data["canDelete"] = this.canDelete;
        data["canDiscardChanges"] = this.canDiscardChanges;
        data["canDiscardChangesAndTakeOwnership"] = this.canDiscardChangesAndTakeOwnership;
        data["canPublish"] = this.canPublish;
        data["canUnpublish"] = this.canUnpublish;
        return data;
    }
}

export interface IReportDto {
    id?: number;
    pbiReportId?: string;
    name?: string | undefined;
    description?: string | undefined;
    draftVersionId?: number | undefined;
    activeVersionId?: number | undefined;
    draftVersion?: ReportVersionDto;
    activeVersion?: ReportVersionDto;
    versionId?: number;
    datasetCategory?: DatasetCategories;
    pbiDatasetId?: string;
    status?: ReportStatus;
    canEdit?: boolean;
    canDuplicate?: boolean;
    canDelete?: boolean;
    canDiscardChanges?: boolean;
    canDiscardChangesAndTakeOwnership?: boolean;
    canPublish?: boolean;
    canUnpublish?: boolean;
}

export enum ReportStatus {
    Published = "Published",
    PendingChanges = "PendingChanges",
    LockedForEditing = "LockedForEditing",
}

export class ReportVersionDto implements IReportVersionDto {
    id?: number;
    pbiReportId?: string;
    createdDateTimeUtc?: Date;
    createdBy?: string | undefined;

    constructor(data?: IReportVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pbiReportId = _data["pbiReportId"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): ReportVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pbiReportId"] = this.pbiReportId;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IReportVersionDto {
    id?: number;
    pbiReportId?: string;
    createdDateTimeUtc?: Date;
    createdBy?: string | undefined;
}

export class ReportsDto implements IReportsDto {
    reports?: ReportDto[] | undefined;

    constructor(data?: IReportsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(ReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportsDto {
    reports?: ReportDto[] | undefined;
}

export class SelfServiceAuthorizationSettings implements ISelfServiceAuthorizationSettings {
    accountId?: number;
    userEntityId?: string | undefined;
    hasReportEditPermission?: boolean;
    allowedDatasetCategories?: DatasetCategories[] | undefined;

    constructor(data?: ISelfServiceAuthorizationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.userEntityId = _data["userEntityId"];
            this.hasReportEditPermission = _data["hasReportEditPermission"];
            if (Array.isArray(_data["allowedDatasetCategories"])) {
                this.allowedDatasetCategories = [] as any;
                for (let item of _data["allowedDatasetCategories"])
                    this.allowedDatasetCategories!.push(item);
            }
        }
    }

    static fromJS(data: any): SelfServiceAuthorizationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceAuthorizationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["userEntityId"] = this.userEntityId;
        data["hasReportEditPermission"] = this.hasReportEditPermission;
        if (Array.isArray(this.allowedDatasetCategories)) {
            data["allowedDatasetCategories"] = [];
            for (let item of this.allowedDatasetCategories)
                data["allowedDatasetCategories"].push(item);
        }
        return data;
    }
}

export interface ISelfServiceAuthorizationSettings {
    accountId?: number;
    userEntityId?: string | undefined;
    hasReportEditPermission?: boolean;
    allowedDatasetCategories?: DatasetCategories[] | undefined;
}

export class SelfServiceDatasetDto implements ISelfServiceDatasetDto {
    selfServiceDatasetId?: number;
    selfServiceEnvironmentId?: number;
    datasetCategory?: DatasetCategories;
    datasetName?: string | undefined;
    pbiDatasetId?: string | undefined;

    constructor(data?: ISelfServiceDatasetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selfServiceDatasetId = _data["selfServiceDatasetId"];
            this.selfServiceEnvironmentId = _data["selfServiceEnvironmentId"];
            this.datasetCategory = _data["datasetCategory"];
            this.datasetName = _data["datasetName"];
            this.pbiDatasetId = _data["pbiDatasetId"];
        }
    }

    static fromJS(data: any): SelfServiceDatasetDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceDatasetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfServiceDatasetId"] = this.selfServiceDatasetId;
        data["selfServiceEnvironmentId"] = this.selfServiceEnvironmentId;
        data["datasetCategory"] = this.datasetCategory;
        data["datasetName"] = this.datasetName;
        data["pbiDatasetId"] = this.pbiDatasetId;
        return data;
    }
}

export interface ISelfServiceDatasetDto {
    selfServiceDatasetId?: number;
    selfServiceEnvironmentId?: number;
    datasetCategory?: DatasetCategories;
    datasetName?: string | undefined;
    pbiDatasetId?: string | undefined;
}

export class SelfServiceDatasetRequest implements ISelfServiceDatasetRequest {
    accountId!: number;
    datasetCategory!: DatasetCategories;
    datasetId!: string;
    datasetName!: string | undefined;

    constructor(data?: ISelfServiceDatasetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.datasetCategory = _data["datasetCategory"];
            this.datasetId = _data["datasetId"];
            this.datasetName = _data["datasetName"];
        }
    }

    static fromJS(data: any): SelfServiceDatasetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceDatasetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["datasetCategory"] = this.datasetCategory;
        data["datasetId"] = this.datasetId;
        data["datasetName"] = this.datasetName;
        return data;
    }
}

export interface ISelfServiceDatasetRequest {
    accountId: number;
    datasetCategory: DatasetCategories;
    datasetId: string;
    datasetName: string | undefined;
}

export class SelfServiceDatasetsDto implements ISelfServiceDatasetsDto {
    datasets?: SelfServiceDatasetDto[] | undefined;

    constructor(data?: ISelfServiceDatasetsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets!.push(SelfServiceDatasetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelfServiceDatasetsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceDatasetsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISelfServiceDatasetsDto {
    datasets?: SelfServiceDatasetDto[] | undefined;
}

export class SelfServiceEnvironmentDto implements ISelfServiceEnvironmentDto {
    selfServiceEnvironmentId?: number;
    accountId?: number;
    workspaceId?: string;

    constructor(data?: ISelfServiceEnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selfServiceEnvironmentId = _data["selfServiceEnvironmentId"];
            this.accountId = _data["accountId"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): SelfServiceEnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceEnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfServiceEnvironmentId"] = this.selfServiceEnvironmentId;
        data["accountId"] = this.accountId;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface ISelfServiceEnvironmentDto {
    selfServiceEnvironmentId?: number;
    accountId?: number;
    workspaceId?: string;
}

export class SelfServiceEnvironmentRequest implements ISelfServiceEnvironmentRequest {
    accountId?: number;
    workspaceId?: string;

    constructor(data?: ISelfServiceEnvironmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): SelfServiceEnvironmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceEnvironmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface ISelfServiceEnvironmentRequest {
    accountId?: number;
    workspaceId?: string;
}

export class SelfServiceReportVersionDto implements ISelfServiceReportVersionDto {
    versionId?: number;
    createTime?: Date;
    status?: string | undefined;
    createdBy?: string | undefined;
    version?: number;
    reportId?: number;

    constructor(data?: ISelfServiceReportVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionId = _data["versionId"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined as any;
            this.status = _data["status"];
            this.createdBy = _data["createdBy"];
            this.version = _data["version"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): SelfServiceReportVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceReportVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionId"] = this.versionId;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined as any;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy;
        data["version"] = this.version;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface ISelfServiceReportVersionDto {
    versionId?: number;
    createTime?: Date;
    status?: string | undefined;
    createdBy?: string | undefined;
    version?: number;
    reportId?: number;
}

export class PriceCheckItemDto implements IPriceCheckItemDto {
    productId!: number;
    currentPrice?: number | undefined;
    productName?: string | undefined;
    inCatalog?: boolean;

    constructor(data?: IPriceCheckItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.currentPrice = _data["currentPrice"];
            this.productName = _data["productName"];
            this.inCatalog = _data["inCatalog"];
        }
    }

    static fromJS(data: any): PriceCheckItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceCheckItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["currentPrice"] = this.currentPrice;
        data["productName"] = this.productName;
        data["inCatalog"] = this.inCatalog;
        return data;
    }
}

export interface IPriceCheckItemDto {
    productId: number;
    currentPrice?: number | undefined;
    productName?: string | undefined;
    inCatalog?: boolean;
}

export class PriceCheckRequestDto implements IPriceCheckRequestDto {
    productIds!: number[] | undefined;

    constructor(data?: IPriceCheckRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PriceCheckRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceCheckRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        return data;
    }
}

export interface IPriceCheckRequestDto {
    productIds: number[] | undefined;
}

export class PriceCheckResultDto implements IPriceCheckResultDto {
    items!: PriceCheckItemDto[] | undefined;

    constructor(data?: IPriceCheckResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PriceCheckItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PriceCheckResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceCheckResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPriceCheckResultDto {
    items: PriceCheckItemDto[] | undefined;
}

export class QuoteAlertDto implements IQuoteAlertDto {
    message?: string | undefined;

    constructor(data?: IQuoteAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): QuoteAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IQuoteAlertDto {
    message?: string | undefined;
}

export class QuoteStorefrontDto implements IQuoteStorefrontDto {
    orgUnitId?: number;
    name?: string | undefined;

    constructor(data?: IQuoteStorefrontDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): QuoteStorefrontDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteStorefrontDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["name"] = this.name;
        return data;
    }
}

export interface IQuoteStorefrontDto {
    orgUnitId?: number;
    name?: string | undefined;
}

export enum QuoteViewScope {
    My = "My",
    OrgUnit = "OrgUnit",
    Tenant = "Tenant",
}

export class ShareQuoteRecipientResult implements IShareQuoteRecipientResult {
    email?: string | undefined;
    succeeded?: boolean;
    error?: string | undefined;

    constructor(data?: IShareQuoteRecipientResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.succeeded = _data["succeeded"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ShareQuoteRecipientResult {
        data = typeof data === 'object' ? data : {};
        let result = new ShareQuoteRecipientResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["succeeded"] = this.succeeded;
        data["error"] = this.error;
        return data;
    }
}

export interface IShareQuoteRecipientResult {
    email?: string | undefined;
    succeeded?: boolean;
    error?: string | undefined;
}

export class ShareQuoteRequest implements IShareQuoteRequest {
    recipients?: string[] | undefined;
    message?: string | undefined;
    sendCopyToSelf?: boolean;

    constructor(data?: IShareQuoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.message = _data["message"];
            this.sendCopyToSelf = _data["sendCopyToSelf"];
        }
    }

    static fromJS(data: any): ShareQuoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShareQuoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["message"] = this.message;
        data["sendCopyToSelf"] = this.sendCopyToSelf;
        return data;
    }
}

export interface IShareQuoteRequest {
    recipients?: string[] | undefined;
    message?: string | undefined;
    sendCopyToSelf?: boolean;
}

export class ShareQuoteResultDto implements IShareQuoteResultDto {
    results?: ShareQuoteRecipientResult[] | undefined;
    readonly allSucceeded?: boolean;

    constructor(data?: IShareQuoteResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ShareQuoteRecipientResult.fromJS(item));
            }
            (this as any).allSucceeded = _data["allSucceeded"];
        }
    }

    static fromJS(data: any): ShareQuoteResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShareQuoteResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["allSucceeded"] = this.allSucceeded;
        return data;
    }
}

export interface IShareQuoteResultDto {
    results?: ShareQuoteRecipientResult[] | undefined;
    allSucceeded?: boolean;
}

export class GetRecommendationFilterOptionsResponse implements IGetRecommendationFilterOptionsResponse {
    filterOptions?: FilterOptionsDto;

    constructor(data?: IGetRecommendationFilterOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterOptions = _data["filterOptions"] ? FilterOptionsDto.fromJS(_data["filterOptions"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetRecommendationFilterOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommendationFilterOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterOptions"] = this.filterOptions ? this.filterOptions.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetRecommendationFilterOptionsResponse {
    filterOptions?: FilterOptionsDto;
}

export class GetRecommendationsByIdsResponse implements IGetRecommendationsByIdsResponse {
    recommendations?: RecommendationDto[] | undefined;
    notFoundIds?: string[] | undefined;
    totalFound?: number;
    totalRequested?: number;

    constructor(data?: IGetRecommendationsByIdsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["recommendations"])
                    this.recommendations!.push(RecommendationDto.fromJS(item));
            }
            if (Array.isArray(_data["notFoundIds"])) {
                this.notFoundIds = [] as any;
                for (let item of _data["notFoundIds"])
                    this.notFoundIds!.push(item);
            }
            this.totalFound = _data["totalFound"];
            this.totalRequested = _data["totalRequested"];
        }
    }

    static fromJS(data: any): GetRecommendationsByIdsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommendationsByIdsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recommendations)) {
            data["recommendations"] = [];
            for (let item of this.recommendations)
                data["recommendations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notFoundIds)) {
            data["notFoundIds"] = [];
            for (let item of this.notFoundIds)
                data["notFoundIds"].push(item);
        }
        data["totalFound"] = this.totalFound;
        data["totalRequested"] = this.totalRequested;
        return data;
    }
}

export interface IGetRecommendationsByIdsResponse {
    recommendations?: RecommendationDto[] | undefined;
    notFoundIds?: string[] | undefined;
    totalFound?: number;
    totalRequested?: number;
}

export class GetRecommendationsRequest implements IGetRecommendationsRequest {
    query?: PaginatedQuery;
    sortOption?: QuerySortOption;
    customerIds?: string[] | undefined;
    customerIdType?: CustomerIdType;
    sourceSystems?: string[] | undefined;
    resourceIdentifier?: string | undefined;

    constructor(data?: IGetRecommendationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? PaginatedQuery.fromJS(_data["query"]) : undefined as any;
            this.sortOption = _data["sortOption"] ? QuerySortOption.fromJS(_data["sortOption"]) : undefined as any;
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(item);
            }
            this.customerIdType = _data["customerIdType"];
            if (Array.isArray(_data["sourceSystems"])) {
                this.sourceSystems = [] as any;
                for (let item of _data["sourceSystems"])
                    this.sourceSystems!.push(item);
            }
            this.resourceIdentifier = _data["resourceIdentifier"];
        }
    }

    static fromJS(data: any): GetRecommendationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommendationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        data["sortOption"] = this.sortOption ? this.sortOption.toJSON() : undefined as any;
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["customerIdType"] = this.customerIdType;
        if (Array.isArray(this.sourceSystems)) {
            data["sourceSystems"] = [];
            for (let item of this.sourceSystems)
                data["sourceSystems"].push(item);
        }
        data["resourceIdentifier"] = this.resourceIdentifier;
        return data;
    }
}

export interface IGetRecommendationsRequest {
    query?: PaginatedQuery;
    sortOption?: QuerySortOption;
    customerIds?: string[] | undefined;
    customerIdType?: CustomerIdType;
    sourceSystems?: string[] | undefined;
    resourceIdentifier?: string | undefined;
}

export class GetRecommendationsResponse implements IGetRecommendationsResponse {
    recommendations?: PaginatedResultDto_1OfRecommendationDto;

    constructor(data?: IGetRecommendationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendations = _data["recommendations"] ? PaginatedResultDto_1OfRecommendationDto.fromJS(_data["recommendations"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetRecommendationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommendationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendations"] = this.recommendations ? this.recommendations.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetRecommendationsResponse {
    recommendations?: PaginatedResultDto_1OfRecommendationDto;
}

export class GetUnlinkedRecommendationsSummaryResponse implements IGetUnlinkedRecommendationsSummaryResponse {
    unlinkedRecommendationSummary?: UnlinkedRecommendationSummary;

    constructor(data?: IGetUnlinkedRecommendationsSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unlinkedRecommendationSummary = _data["unlinkedRecommendationSummary"] ? UnlinkedRecommendationSummary.fromJS(_data["unlinkedRecommendationSummary"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetUnlinkedRecommendationsSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnlinkedRecommendationsSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unlinkedRecommendationSummary"] = this.unlinkedRecommendationSummary ? this.unlinkedRecommendationSummary.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetUnlinkedRecommendationsSummaryResponse {
    unlinkedRecommendationSummary?: UnlinkedRecommendationSummary;
}

export class RecommendationDto implements IRecommendationDto {
    recommendationId?: string;
    sourceSystem!: string | undefined;
    sourceRecordId!: string | undefined;
    title!: string | undefined;
    description!: string | undefined;
    customerId!: string | undefined;
    customerIdType!: string | undefined;
    priority?: string | undefined;
    searchTags?: string[] | undefined;
    status?: string | undefined;
    rawSourceState?: string | undefined;
    sourceCreatedDate?: Date | undefined;
    firstSeenDate?: Date;
    lastSyncedDate?: Date;
    category?: string | undefined;
    actionUrl?: string | undefined;
    resourceType?: string | undefined;
    resourceIdentifier?: string | undefined;
    statusChangedDate?: Date | undefined;
    statusChangedBy?: string | undefined;
    aggregationKey?: string | undefined;
    isLinkedToRoadmap?: boolean;
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;
    initiativeId?: string | undefined;
    initiativeName?: string | undefined;
    metadata?: string | undefined;

    constructor(data?: IRecommendationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendationId = _data["recommendationId"];
            this.sourceSystem = _data["sourceSystem"];
            this.sourceRecordId = _data["sourceRecordId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.customerId = _data["customerId"];
            this.customerIdType = _data["customerIdType"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["searchTags"])) {
                this.searchTags = [] as any;
                for (let item of _data["searchTags"])
                    this.searchTags!.push(item);
            }
            this.status = _data["status"];
            this.rawSourceState = _data["rawSourceState"];
            this.sourceCreatedDate = _data["sourceCreatedDate"] ? new Date(_data["sourceCreatedDate"].toString()) : undefined as any;
            this.firstSeenDate = _data["firstSeenDate"] ? new Date(_data["firstSeenDate"].toString()) : undefined as any;
            this.lastSyncedDate = _data["lastSyncedDate"] ? new Date(_data["lastSyncedDate"].toString()) : undefined as any;
            this.category = _data["category"];
            this.actionUrl = _data["actionUrl"];
            this.resourceType = _data["resourceType"];
            this.resourceIdentifier = _data["resourceIdentifier"];
            this.statusChangedDate = _data["statusChangedDate"] ? new Date(_data["statusChangedDate"].toString()) : undefined as any;
            this.statusChangedBy = _data["statusChangedBy"];
            this.aggregationKey = _data["aggregationKey"];
            this.isLinkedToRoadmap = _data["isLinkedToRoadmap"];
            this.roadmapId = _data["roadmapId"];
            this.roadmapName = _data["roadmapName"];
            this.initiativeId = _data["initiativeId"];
            this.initiativeName = _data["initiativeName"];
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): RecommendationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendationId"] = this.recommendationId;
        data["sourceSystem"] = this.sourceSystem;
        data["sourceRecordId"] = this.sourceRecordId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["customerId"] = this.customerId;
        data["customerIdType"] = this.customerIdType;
        data["priority"] = this.priority;
        if (Array.isArray(this.searchTags)) {
            data["searchTags"] = [];
            for (let item of this.searchTags)
                data["searchTags"].push(item);
        }
        data["status"] = this.status;
        data["rawSourceState"] = this.rawSourceState;
        data["sourceCreatedDate"] = this.sourceCreatedDate ? this.sourceCreatedDate.toISOString() : undefined as any;
        data["firstSeenDate"] = this.firstSeenDate ? this.firstSeenDate.toISOString() : undefined as any;
        data["lastSyncedDate"] = this.lastSyncedDate ? this.lastSyncedDate.toISOString() : undefined as any;
        data["category"] = this.category;
        data["actionUrl"] = this.actionUrl;
        data["resourceType"] = this.resourceType;
        data["resourceIdentifier"] = this.resourceIdentifier;
        data["statusChangedDate"] = this.statusChangedDate ? this.statusChangedDate.toISOString() : undefined as any;
        data["statusChangedBy"] = this.statusChangedBy;
        data["aggregationKey"] = this.aggregationKey;
        data["isLinkedToRoadmap"] = this.isLinkedToRoadmap;
        data["roadmapId"] = this.roadmapId;
        data["roadmapName"] = this.roadmapName;
        data["initiativeId"] = this.initiativeId;
        data["initiativeName"] = this.initiativeName;
        data["metadata"] = this.metadata;
        return data;
    }
}

export interface IRecommendationDto {
    recommendationId?: string;
    sourceSystem: string | undefined;
    sourceRecordId: string | undefined;
    title: string | undefined;
    description: string | undefined;
    customerId: string | undefined;
    customerIdType: string | undefined;
    priority?: string | undefined;
    searchTags?: string[] | undefined;
    status?: string | undefined;
    rawSourceState?: string | undefined;
    sourceCreatedDate?: Date | undefined;
    firstSeenDate?: Date;
    lastSyncedDate?: Date;
    category?: string | undefined;
    actionUrl?: string | undefined;
    resourceType?: string | undefined;
    resourceIdentifier?: string | undefined;
    statusChangedDate?: Date | undefined;
    statusChangedBy?: string | undefined;
    aggregationKey?: string | undefined;
    isLinkedToRoadmap?: boolean;
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;
    initiativeId?: string | undefined;
    initiativeName?: string | undefined;
    metadata?: string | undefined;
}

export class UnlinkedRecommendationSummary implements IUnlinkedRecommendationSummary {
    unlinkedRecommendationIds?: string[] | undefined;
    totalCount?: number;

    constructor(data?: IUnlinkedRecommendationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["unlinkedRecommendationIds"])) {
                this.unlinkedRecommendationIds = [] as any;
                for (let item of _data["unlinkedRecommendationIds"])
                    this.unlinkedRecommendationIds!.push(item);
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UnlinkedRecommendationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkedRecommendationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.unlinkedRecommendationIds)) {
            data["unlinkedRecommendationIds"] = [];
            for (let item of this.unlinkedRecommendationIds)
                data["unlinkedRecommendationIds"].push(item);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IUnlinkedRecommendationSummary {
    unlinkedRecommendationIds?: string[] | undefined;
    totalCount?: number;
}

export class ReportAccountDto implements IReportAccountDto {
    id!: string;
    name!: string | undefined;
    accountNumber!: string | undefined;

    constructor(data?: IReportAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): ReportAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IReportAccountDto {
    id: string;
    name: string | undefined;
    accountNumber: string | undefined;
}

export class ReportCatalogEntryDto implements IReportCatalogEntryDto {
    key!: string | undefined;
    title!: string | undefined;
    description!: string | undefined;
    category!: string | undefined;

    constructor(data?: IReportCatalogEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): ReportCatalogEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportCatalogEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        return data;
    }
}

export interface IReportCatalogEntryDto {
    key: string | undefined;
    title: string | undefined;
    description: string | undefined;
    category: string | undefined;
}

export class ReportColumnDto implements IReportColumnDto {
    key!: string | undefined;
    label!: string | undefined;
    visibility!: ReportColumnVisibility;
    group?: string | undefined;
    grain!: ReportColumnGrain;
    dataType!: ReportColumnDataType;
    isSortable!: boolean;
    isFilterable!: boolean;
    isExportable!: boolean;

    constructor(data?: IReportColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.visibility = _data["visibility"];
            this.group = _data["group"];
            this.grain = _data["grain"];
            this.dataType = _data["dataType"];
            this.isSortable = _data["isSortable"];
            this.isFilterable = _data["isFilterable"];
            this.isExportable = _data["isExportable"];
        }
    }

    static fromJS(data: any): ReportColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["visibility"] = this.visibility;
        data["group"] = this.group;
        data["grain"] = this.grain;
        data["dataType"] = this.dataType;
        data["isSortable"] = this.isSortable;
        data["isFilterable"] = this.isFilterable;
        data["isExportable"] = this.isExportable;
        return data;
    }
}

export interface IReportColumnDto {
    key: string | undefined;
    label: string | undefined;
    visibility: ReportColumnVisibility;
    group?: string | undefined;
    grain: ReportColumnGrain;
    dataType: ReportColumnDataType;
    isSortable: boolean;
    isFilterable: boolean;
    isExportable: boolean;
}

export class ReportDefinitionDto implements IReportDefinitionDto {
    key!: string | undefined;
    version!: number;
    title!: string | undefined;
    description!: string | undefined;
    category!: string | undefined;
    requiredPermission!: string | undefined;
    columns!: ReportColumnDto[] | undefined;
    filters!: ReportFilterDto[] | undefined;
    defaultDateRange!: ReportDateRange;
    availableDateRanges!: ReportDateRange[] | undefined;
    accountScope!: ReportAccountScope;
    exportFormats!: ReportExportFormat[] | undefined;
    lifecycleState!: ReportLifecycleState;

    constructor(data?: IReportDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.version = _data["version"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.requiredPermission = _data["requiredPermission"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ReportColumnDto.fromJS(item));
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(ReportFilterDto.fromJS(item));
            }
            this.defaultDateRange = _data["defaultDateRange"];
            if (Array.isArray(_data["availableDateRanges"])) {
                this.availableDateRanges = [] as any;
                for (let item of _data["availableDateRanges"])
                    this.availableDateRanges!.push(item);
            }
            this.accountScope = _data["accountScope"];
            if (Array.isArray(_data["exportFormats"])) {
                this.exportFormats = [] as any;
                for (let item of _data["exportFormats"])
                    this.exportFormats!.push(item);
            }
            this.lifecycleState = _data["lifecycleState"];
        }
    }

    static fromJS(data: any): ReportDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["version"] = this.version;
        data["title"] = this.title;
        data["description"] = this.description;
        data["category"] = this.category;
        data["requiredPermission"] = this.requiredPermission;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultDateRange"] = this.defaultDateRange;
        if (Array.isArray(this.availableDateRanges)) {
            data["availableDateRanges"] = [];
            for (let item of this.availableDateRanges)
                data["availableDateRanges"].push(item);
        }
        data["accountScope"] = this.accountScope;
        if (Array.isArray(this.exportFormats)) {
            data["exportFormats"] = [];
            for (let item of this.exportFormats)
                data["exportFormats"].push(item);
        }
        data["lifecycleState"] = this.lifecycleState;
        return data;
    }
}

export interface IReportDefinitionDto {
    key: string | undefined;
    version: number;
    title: string | undefined;
    description: string | undefined;
    category: string | undefined;
    requiredPermission: string | undefined;
    columns: ReportColumnDto[] | undefined;
    filters: ReportFilterDto[] | undefined;
    defaultDateRange: ReportDateRange;
    availableDateRanges: ReportDateRange[] | undefined;
    accountScope: ReportAccountScope;
    exportFormats: ReportExportFormat[] | undefined;
    lifecycleState: ReportLifecycleState;
}

export class ReportFilterDto implements IReportFilterDto {
    key!: string | undefined;
    label!: string | undefined;
    kind!: ReportFilterKind;
    columnKeys!: string[] | undefined;

    constructor(data?: IReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.kind = _data["kind"];
            if (Array.isArray(_data["columnKeys"])) {
                this.columnKeys = [] as any;
                for (let item of _data["columnKeys"])
                    this.columnKeys!.push(item);
            }
        }
    }

    static fromJS(data: any): ReportFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["kind"] = this.kind;
        if (Array.isArray(this.columnKeys)) {
            data["columnKeys"] = [];
            for (let item of this.columnKeys)
                data["columnKeys"].push(item);
        }
        return data;
    }
}

export interface IReportFilterDto {
    key: string | undefined;
    label: string | undefined;
    kind: ReportFilterKind;
    columnKeys: string[] | undefined;
}

export class ReportFilterOptionsRequestDto implements IReportFilterOptionsRequestDto {
    accountIds?: string[] | undefined;
    dateRange?: ReportDateRange;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IReportFilterOptionsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            this.dateRange = _data["dateRange"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ReportFilterOptionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFilterOptionsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        data["dateRange"] = this.dateRange;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        return data;
    }
}

export interface IReportFilterOptionsRequestDto {
    accountIds?: string[] | undefined;
    dateRange?: ReportDateRange;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class ReportFilterValuesRequestDto implements IReportFilterValuesRequestDto {
    accountIds?: string[] | undefined;
    dateRange?: ReportDateRange;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    filterKey?: string | undefined;
    term?: string | undefined;

    constructor(data?: IReportFilterValuesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            this.dateRange = _data["dateRange"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.filterKey = _data["filterKey"];
            this.term = _data["term"];
        }
    }

    static fromJS(data: any): ReportFilterValuesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFilterValuesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        data["dateRange"] = this.dateRange;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        data["filterKey"] = this.filterKey;
        data["term"] = this.term;
        return data;
    }
}

export interface IReportFilterValuesRequestDto {
    accountIds?: string[] | undefined;
    dateRange?: ReportDateRange;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    filterKey?: string | undefined;
    term?: string | undefined;
}

export class ReportFiltersDto implements IReportFiltersDto {
    include?: { [key: string]: string[]; } | undefined;
    exclude?: { [key: string]: string[]; } | undefined;

    constructor(data?: IReportFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["include"]) {
                this.include = {} as any;
                for (let key in _data["include"]) {
                    if (_data["include"].hasOwnProperty(key))
                        (this.include as any)![key] = _data["include"][key] !== undefined ? _data["include"][key] : [];
                }
            }
            if (_data["exclude"]) {
                this.exclude = {} as any;
                for (let key in _data["exclude"]) {
                    if (_data["exclude"].hasOwnProperty(key))
                        (this.exclude as any)![key] = _data["exclude"][key] !== undefined ? _data["exclude"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ReportFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.include) {
            data["include"] = {};
            for (let key in this.include) {
                if (this.include.hasOwnProperty(key))
                    (data["include"] as any)[key] = (this.include as any)[key];
            }
        }
        if (this.exclude) {
            data["exclude"] = {};
            for (let key in this.exclude) {
                if (this.exclude.hasOwnProperty(key))
                    (data["exclude"] as any)[key] = (this.exclude as any)[key];
            }
        }
        return data;
    }
}

export interface IReportFiltersDto {
    include?: { [key: string]: string[]; } | undefined;
    exclude?: { [key: string]: string[]; } | undefined;
}

export class ReportRowDto implements IReportRowDto {
    id!: string | undefined;
    values!: { [key: string]: any; } | undefined;

    constructor(data?: IReportRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (this.values as any)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): ReportRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (data["values"] as any)[key] = (this.values as any)[key];
            }
        }
        return data;
    }
}

export interface IReportRowDto {
    id: string | undefined;
    values: { [key: string]: any; } | undefined;
}

export class ReportRowsRequestDto implements IReportRowsRequestDto {
    accountIds?: string[] | undefined;
    dateRange?: ReportDateRange;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sort?: ReportSortDto;
    filters?: ReportFiltersDto;
    columns?: string[] | undefined;
    savedViewId?: number | undefined;

    constructor(data?: IReportRowsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            this.dateRange = _data["dateRange"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sort = _data["sort"] ? ReportSortDto.fromJS(_data["sort"]) : undefined as any;
            this.filters = _data["filters"] ? ReportFiltersDto.fromJS(_data["filters"]) : undefined as any;
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            this.savedViewId = _data["savedViewId"];
        }
    }

    static fromJS(data: any): ReportRowsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRowsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        data["dateRange"] = this.dateRange;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sort"] = this.sort ? this.sort.toJSON() : undefined as any;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        data["savedViewId"] = this.savedViewId;
        return data;
    }
}

export interface IReportRowsRequestDto {
    accountIds?: string[] | undefined;
    dateRange?: ReportDateRange;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sort?: ReportSortDto;
    filters?: ReportFiltersDto;
    columns?: string[] | undefined;
    savedViewId?: number | undefined;
}

export class ReportRowsResponseDto implements IReportRowsResponseDto {
    rows!: ReportRowDto[] | undefined;
    totalCount!: number;
    page!: number;
    pageSize!: number;
    startDate!: Date;
    endDate!: Date;
    dataAsOf!: Date | undefined;

    constructor(data?: IReportRowsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ReportRowDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.dataAsOf = _data["dataAsOf"] ? new Date(_data["dataAsOf"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ReportRowsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRowsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        data["dataAsOf"] = this.dataAsOf ? this.dataAsOf.toISOString() : undefined as any;
        return data;
    }
}

export interface IReportRowsResponseDto {
    rows: ReportRowDto[] | undefined;
    totalCount: number;
    page: number;
    pageSize: number;
    startDate: Date;
    endDate: Date;
    dataAsOf: Date | undefined;
}

export class ReportSortDto implements IReportSortDto {
    columnKey?: string | undefined;
    direction?: ReportSortDirection;

    constructor(data?: IReportSortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnKey = _data["columnKey"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): ReportSortDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnKey"] = this.columnKey;
        data["direction"] = this.direction;
        return data;
    }
}

export interface IReportSortDto {
    columnKey?: string | undefined;
    direction?: ReportSortDirection;
}

export enum ReportAccountScope {
    SingleAccount = "SingleAccount",
    MultipleAccounts = "MultipleAccounts",
}

export enum ReportColumnDataType {
    Text = "Text",
    Number = "Number",
    Date = "Date",
    Money = "Money",
    Boolean = "Boolean",
}

export enum ReportColumnGrain {
    Header = "Header",
    Row = "Row",
    List = "List",
}

export enum ReportColumnVisibility {
    Default = "Default",
    Advanced = "Advanced",
}

export enum ReportDateRange {
    Last30Days = "Last30Days",
    Last90Days = "Last90Days",
    MonthToDate = "MonthToDate",
    PreviousMonth = "PreviousMonth",
    Last6Months = "Last6Months",
    YearToDate = "YearToDate",
    PreviousYear = "PreviousYear",
    Custom = "Custom",
}

export enum ReportExportFormat {
    Excel = "Excel",
    Csv = "Csv",
}

export enum ReportFilterKind {
    PickList = "PickList",
    Search = "Search",
}

export enum ReportLifecycleState {
    Preview = "Preview",
    Active = "Active",
    Deprecated = "Deprecated",
}

export enum ReportSortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export class BulkCreateRoadmapItemsResponse implements IBulkCreateRoadmapItemsResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;

    constructor(data?: IBulkCreateRoadmapItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): BulkCreateRoadmapItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BulkCreateRoadmapItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IBulkCreateRoadmapItemsResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;
}

export class CheckSourceIdsRoadmapLinkResponse implements ICheckSourceIdsRoadmapLinkResponse {
    success?: boolean;
    sourceIdLinks?: SourceIdLinkInfo[] | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ICheckSourceIdsRoadmapLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["sourceIdLinks"])) {
                this.sourceIdLinks = [] as any;
                for (let item of _data["sourceIdLinks"])
                    this.sourceIdLinks!.push(SourceIdLinkInfo.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CheckSourceIdsRoadmapLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSourceIdsRoadmapLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.sourceIdLinks)) {
            data["sourceIdLinks"] = [];
            for (let item of this.sourceIdLinks)
                data["sourceIdLinks"].push(item ? item.toJSON() : undefined as any);
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICheckSourceIdsRoadmapLinkResponse {
    success?: boolean;
    sourceIdLinks?: SourceIdLinkInfo[] | undefined;
    errorMessage?: string | undefined;
}

export class CreateRoadmapItemResponse implements ICreateRoadmapItemResponse {
    isSuccessful?: boolean;
    roadmapItem?: RoadmapItemDto;
    responseMessage?: string | undefined;

    constructor(data?: ICreateRoadmapItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmapItem = _data["roadmapItem"] ? RoadmapItemDto.fromJS(_data["roadmapItem"]) : undefined as any;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): CreateRoadmapItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoadmapItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmapItem"] = this.roadmapItem ? this.roadmapItem.toJSON() : undefined as any;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface ICreateRoadmapItemResponse {
    isSuccessful?: boolean;
    roadmapItem?: RoadmapItemDto;
    responseMessage?: string | undefined;
}

export class CreateRoadmapResponse implements ICreateRoadmapResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;

    constructor(data?: ICreateRoadmapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmap = _data["roadmap"] ? RoadmapDto.fromJS(_data["roadmap"]) : undefined as any;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): CreateRoadmapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoadmapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmap"] = this.roadmap ? this.roadmap.toJSON() : undefined as any;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface ICreateRoadmapResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;
}

export class DeleteRoadmapItemResponse implements IDeleteRoadmapItemResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;

    constructor(data?: IDeleteRoadmapItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): DeleteRoadmapItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRoadmapItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IDeleteRoadmapItemResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;
}

export class DeleteRoadmapResponse implements IDeleteRoadmapResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;

    constructor(data?: IDeleteRoadmapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): DeleteRoadmapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRoadmapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IDeleteRoadmapResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;
}

export class GetRoadmapByIdResponse implements IGetRoadmapByIdResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;

    constructor(data?: IGetRoadmapByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmap = _data["roadmap"] ? RoadmapDto.fromJS(_data["roadmap"]) : undefined as any;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): GetRoadmapByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoadmapByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmap"] = this.roadmap ? this.roadmap.toJSON() : undefined as any;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IGetRoadmapByIdResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;
}

export class GetRoadmapsByCustomerResponse implements IGetRoadmapsByCustomerResponse {
    isSuccessful?: boolean;
    roadmapList?: RoadmapDto[] | undefined;
    responseMessage?: string | undefined;

    constructor(data?: IGetRoadmapsByCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            if (Array.isArray(_data["roadmapList"])) {
                this.roadmapList = [] as any;
                for (let item of _data["roadmapList"])
                    this.roadmapList!.push(RoadmapDto.fromJS(item));
            }
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): GetRoadmapsByCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoadmapsByCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        if (Array.isArray(this.roadmapList)) {
            data["roadmapList"] = [];
            for (let item of this.roadmapList)
                data["roadmapList"].push(item ? item.toJSON() : undefined as any);
        }
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IGetRoadmapsByCustomerResponse {
    isSuccessful?: boolean;
    roadmapList?: RoadmapDto[] | undefined;
    responseMessage?: string | undefined;
}

export class SetRoadmapsPublishStatusResponse implements ISetRoadmapsPublishStatusResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;

    constructor(data?: ISetRoadmapsPublishStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): SetRoadmapsPublishStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetRoadmapsPublishStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface ISetRoadmapsPublishStatusResponse {
    isSuccessful?: boolean;
    responseMessage?: string | undefined;
}

export class SourceIdLinkInfo implements ISourceIdLinkInfo {
    sourceId?: string | undefined;
    alreadyAttached?: boolean;
    sourceType?: RoadmapItemSourceType;
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;
    initiativeId?: string | undefined;
    initiativeName?: string | undefined;
    taskId?: string | undefined;
    taskName?: string | undefined;

    constructor(data?: ISourceIdLinkInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.alreadyAttached = _data["alreadyAttached"];
            this.sourceType = _data["sourceType"];
            this.roadmapId = _data["roadmapId"];
            this.roadmapName = _data["roadmapName"];
            this.initiativeId = _data["initiativeId"];
            this.initiativeName = _data["initiativeName"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
        }
    }

    static fromJS(data: any): SourceIdLinkInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SourceIdLinkInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["alreadyAttached"] = this.alreadyAttached;
        data["sourceType"] = this.sourceType;
        data["roadmapId"] = this.roadmapId;
        data["roadmapName"] = this.roadmapName;
        data["initiativeId"] = this.initiativeId;
        data["initiativeName"] = this.initiativeName;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        return data;
    }
}

export interface ISourceIdLinkInfo {
    sourceId?: string | undefined;
    alreadyAttached?: boolean;
    sourceType?: RoadmapItemSourceType;
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;
    initiativeId?: string | undefined;
    initiativeName?: string | undefined;
    taskId?: string | undefined;
    taskName?: string | undefined;
}

export class ToggleRoadmapIsCompletedResponse implements IToggleRoadmapIsCompletedResponse {
    isSuccessful?: boolean;
    isRoadmapCompleted?: boolean | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IToggleRoadmapIsCompletedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.isRoadmapCompleted = _data["isRoadmapCompleted"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ToggleRoadmapIsCompletedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleRoadmapIsCompletedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["isRoadmapCompleted"] = this.isRoadmapCompleted;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IToggleRoadmapIsCompletedResponse {
    isSuccessful?: boolean;
    isRoadmapCompleted?: boolean | undefined;
    errorMessage?: string | undefined;
}

export class UpdateRoadmapItemResponse implements IUpdateRoadmapItemResponse {
    isSuccessful?: boolean;
    roadmapItem?: RoadmapItemDto;
    responseMessage?: string | undefined;

    constructor(data?: IUpdateRoadmapItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmapItem = _data["roadmapItem"] ? RoadmapItemDto.fromJS(_data["roadmapItem"]) : undefined as any;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): UpdateRoadmapItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoadmapItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmapItem"] = this.roadmapItem ? this.roadmapItem.toJSON() : undefined as any;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IUpdateRoadmapItemResponse {
    isSuccessful?: boolean;
    roadmapItem?: RoadmapItemDto;
    responseMessage?: string | undefined;
}

export class UpdateRoadmapResponse implements IUpdateRoadmapResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;

    constructor(data?: IUpdateRoadmapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.roadmap = _data["roadmap"] ? RoadmapDto.fromJS(_data["roadmap"]) : undefined as any;
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): UpdateRoadmapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoadmapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["roadmap"] = this.roadmap ? this.roadmap.toJSON() : undefined as any;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IUpdateRoadmapResponse {
    isSuccessful?: boolean;
    roadmap?: RoadmapDto;
    responseMessage?: string | undefined;
}

export class UploadRoadmapItemTempFileResponse implements IUploadRoadmapItemTempFileResponse {
    fileGuid?: string | undefined;

    constructor(data?: IUploadRoadmapItemTempFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileGuid = _data["fileGuid"];
        }
    }

    static fromJS(data: any): UploadRoadmapItemTempFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadRoadmapItemTempFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileGuid"] = this.fileGuid;
        return data;
    }
}

export interface IUploadRoadmapItemTempFileResponse {
    fileGuid?: string | undefined;
}

export enum RecommendationReferenceType {
    Legacy = "Legacy",
    Single = "Single",
    Group = "Group",
    None = "None",
}

export enum RoadmapAssociationType {
    Assets = "Assets",
}

export enum RoadmapItemCostFrequency {
    OneTime = "OneTime",
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Annual = "Annual",
}

export enum RoadmapItemDocumentType {
    Attachment = "Attachment",
    Note = "Note",
    Hyperlink = "Hyperlink",
    Image = "Image",
}

export enum RoadmapItemSourceType {
    Undefined = "Undefined",
    AssessmentRecommendation = "AssessmentRecommendation",
    Project = "Project",
    Custom = "Custom",
    AzureCloudRecommendation = "AzureCloudRecommendation",
    AwsCloudRecommendation = "AwsCloudRecommendation",
}

export class RoadmapAssociationQueryDto implements IRoadmapAssociationQueryDto {
    roadmapAssociationQueryId?: string;
    roadmapItemId!: string;
    roadmapItem!: RoadmapItemDto;
    query!: string | undefined;
    associationType!: RoadmapAssociationType;

    constructor(data?: IRoadmapAssociationQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.roadmapItem = new RoadmapItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roadmapAssociationQueryId = _data["roadmapAssociationQueryId"];
            this.roadmapItemId = _data["roadmapItemId"];
            this.roadmapItem = _data["roadmapItem"] ? RoadmapItemDto.fromJS(_data["roadmapItem"]) : new RoadmapItemDto();
            this.query = _data["query"];
            this.associationType = _data["associationType"];
        }
    }

    static fromJS(data: any): RoadmapAssociationQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapAssociationQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roadmapAssociationQueryId"] = this.roadmapAssociationQueryId;
        data["roadmapItemId"] = this.roadmapItemId;
        data["roadmapItem"] = this.roadmapItem ? this.roadmapItem.toJSON() : undefined as any;
        data["query"] = this.query;
        data["associationType"] = this.associationType;
        return data;
    }
}

export interface IRoadmapAssociationQueryDto {
    roadmapAssociationQueryId?: string;
    roadmapItemId: string;
    roadmapItem: RoadmapItemDto;
    query: string | undefined;
    associationType: RoadmapAssociationType;
}

export class RoadmapCostItemDto implements IRoadmapCostItemDto {
    costItemId?: string;
    roadmapItemId?: string;
    category?: string | undefined;
    subcategory?: string | undefined;
    amount?: number;
    frequency?: RoadmapItemCostFrequency;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    roadmapItem!: RoadmapItemDto;

    constructor(data?: IRoadmapCostItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.roadmapItem = new RoadmapItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costItemId = _data["costItemId"];
            this.roadmapItemId = _data["roadmapItemId"];
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.amount = _data["amount"];
            this.frequency = _data["frequency"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.roadmapItem = _data["roadmapItem"] ? RoadmapItemDto.fromJS(_data["roadmapItem"]) : new RoadmapItemDto();
        }
    }

    static fromJS(data: any): RoadmapCostItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapCostItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costItemId"] = this.costItemId;
        data["roadmapItemId"] = this.roadmapItemId;
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["amount"] = this.amount;
        data["frequency"] = this.frequency;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["roadmapItem"] = this.roadmapItem ? this.roadmapItem.toJSON() : undefined as any;
        return data;
    }
}

export interface IRoadmapCostItemDto {
    costItemId?: string;
    roadmapItemId?: string;
    category?: string | undefined;
    subcategory?: string | undefined;
    amount?: number;
    frequency?: RoadmapItemCostFrequency;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    roadmapItem: RoadmapItemDto;
}

export class RoadmapDocumentDto implements IRoadmapDocumentDto {
    id?: string;
    roadmapItemId?: string;
    title?: string | undefined;
    value?: string | undefined;
    documentType?: RoadmapItemDocumentType;

    constructor(data?: IRoadmapDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roadmapItemId = _data["roadmapItemId"];
            this.title = _data["title"];
            this.value = _data["value"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): RoadmapDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roadmapItemId"] = this.roadmapItemId;
        data["title"] = this.title;
        data["value"] = this.value;
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface IRoadmapDocumentDto {
    id?: string;
    roadmapItemId?: string;
    title?: string | undefined;
    value?: string | undefined;
    documentType?: RoadmapItemDocumentType;
}

export class RoadmapDto implements IRoadmapDto {
    id?: string;
    accountId?: number;
    name!: string | undefined;
    description?: string | undefined;
    createdDate?: Date;
    createdByUserEmail?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedByUserEmail?: string | undefined;
    deletedByUserEmail?: string | undefined;
    roadmapItems?: RoadmapItemDto[] | undefined;
    isDeleted?: boolean;
    isVisibleToCustomer?: boolean;
    isCompleted?: boolean;

    constructor(data?: IRoadmapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdByUserEmail = _data["createdByUserEmail"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedByUserEmail = _data["lastModifiedByUserEmail"];
            this.deletedByUserEmail = _data["deletedByUserEmail"];
            if (Array.isArray(_data["roadmapItems"])) {
                this.roadmapItems = [] as any;
                for (let item of _data["roadmapItems"])
                    this.roadmapItems!.push(RoadmapItemDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.isVisibleToCustomer = _data["isVisibleToCustomer"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): RoadmapDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdByUserEmail"] = this.createdByUserEmail;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedByUserEmail"] = this.lastModifiedByUserEmail;
        data["deletedByUserEmail"] = this.deletedByUserEmail;
        if (Array.isArray(this.roadmapItems)) {
            data["roadmapItems"] = [];
            for (let item of this.roadmapItems)
                data["roadmapItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        data["isVisibleToCustomer"] = this.isVisibleToCustomer;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IRoadmapDto {
    id?: string;
    accountId?: number;
    name: string | undefined;
    description?: string | undefined;
    createdDate?: Date;
    createdByUserEmail?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedByUserEmail?: string | undefined;
    deletedByUserEmail?: string | undefined;
    roadmapItems?: RoadmapItemDto[] | undefined;
    isDeleted?: boolean;
    isVisibleToCustomer?: boolean;
    isCompleted?: boolean;
}

export class RoadmapItemDto implements IRoadmapItemDto {
    roadmapItemId?: string;
    roadmapId?: string;
    parentRoadmapItemId?: string | undefined;
    recommendationId?: string | undefined;
    referenceType?: RecommendationReferenceType;
    recommendationSnapshot?: string | undefined;
    snapshotCapturedAt?: Date | undefined;
    roadmapItemOrdinal?: number;
    isMilestone?: boolean;
    isShiHelping?: boolean;
    owner?: string | undefined;
    status?: string | undefined;
    sourceType!: RoadmapItemSourceType;
    sourceMetadata?: { [key: string]: string; } | undefined;
    sourceId!: string | undefined;
    name!: string | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    startDate?: Date | undefined;
    targetDate?: Date;
    roadmap?: RoadmapDto;
    costItems?: RoadmapCostItemDto[] | undefined;
    documents?: RoadmapDocumentDto[] | undefined;
    associationQueries?: RoadmapAssociationQueryDto[] | undefined;
    createdDate?: Date;
    createdByUserEmail?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedByUserEmail?: string | undefined;
    lastModifiedByDisplayName?: string | undefined;
    deletedByUserEmail?: string | undefined;
    parentRoadmapItem?: RoadmapItemDto;
    subRoadmapItems?: RoadmapItemDto[] | undefined;
    isDeleted?: boolean;

    constructor(data?: IRoadmapItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roadmapItemId = _data["roadmapItemId"];
            this.roadmapId = _data["roadmapId"];
            this.parentRoadmapItemId = _data["parentRoadmapItemId"];
            this.recommendationId = _data["recommendationId"];
            this.referenceType = _data["referenceType"];
            this.recommendationSnapshot = _data["recommendationSnapshot"];
            this.snapshotCapturedAt = _data["snapshotCapturedAt"] ? new Date(_data["snapshotCapturedAt"].toString()) : undefined as any;
            this.roadmapItemOrdinal = _data["roadmapItemOrdinal"];
            this.isMilestone = _data["isMilestone"];
            this.isShiHelping = _data["isShiHelping"];
            this.owner = _data["owner"];
            this.status = _data["status"];
            this.sourceType = _data["sourceType"];
            if (_data["sourceMetadata"]) {
                this.sourceMetadata = {} as any;
                for (let key in _data["sourceMetadata"]) {
                    if (_data["sourceMetadata"].hasOwnProperty(key))
                        (this.sourceMetadata as any)![key] = _data["sourceMetadata"][key];
                }
            }
            this.sourceId = _data["sourceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.notes = _data["notes"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.targetDate = _data["targetDate"] ? new Date(_data["targetDate"].toString()) : undefined as any;
            this.roadmap = _data["roadmap"] ? RoadmapDto.fromJS(_data["roadmap"]) : undefined as any;
            if (Array.isArray(_data["costItems"])) {
                this.costItems = [] as any;
                for (let item of _data["costItems"])
                    this.costItems!.push(RoadmapCostItemDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(RoadmapDocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["associationQueries"])) {
                this.associationQueries = [] as any;
                for (let item of _data["associationQueries"])
                    this.associationQueries!.push(RoadmapAssociationQueryDto.fromJS(item));
            }
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdByUserEmail = _data["createdByUserEmail"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedByUserEmail = _data["lastModifiedByUserEmail"];
            this.lastModifiedByDisplayName = _data["lastModifiedByDisplayName"];
            this.deletedByUserEmail = _data["deletedByUserEmail"];
            this.parentRoadmapItem = _data["parentRoadmapItem"] ? RoadmapItemDto.fromJS(_data["parentRoadmapItem"]) : undefined as any;
            if (Array.isArray(_data["subRoadmapItems"])) {
                this.subRoadmapItems = [] as any;
                for (let item of _data["subRoadmapItems"])
                    this.subRoadmapItems!.push(RoadmapItemDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): RoadmapItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roadmapItemId"] = this.roadmapItemId;
        data["roadmapId"] = this.roadmapId;
        data["parentRoadmapItemId"] = this.parentRoadmapItemId;
        data["recommendationId"] = this.recommendationId;
        data["referenceType"] = this.referenceType;
        data["recommendationSnapshot"] = this.recommendationSnapshot;
        data["snapshotCapturedAt"] = this.snapshotCapturedAt ? this.snapshotCapturedAt.toISOString() : undefined as any;
        data["roadmapItemOrdinal"] = this.roadmapItemOrdinal;
        data["isMilestone"] = this.isMilestone;
        data["isShiHelping"] = this.isShiHelping;
        data["owner"] = this.owner;
        data["status"] = this.status;
        data["sourceType"] = this.sourceType;
        if (this.sourceMetadata) {
            data["sourceMetadata"] = {};
            for (let key in this.sourceMetadata) {
                if (this.sourceMetadata.hasOwnProperty(key))
                    (data["sourceMetadata"] as any)[key] = (this.sourceMetadata as any)[key];
            }
        }
        data["sourceId"] = this.sourceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["notes"] = this.notes;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["targetDate"] = this.targetDate ? this.targetDate.toISOString() : undefined as any;
        data["roadmap"] = this.roadmap ? this.roadmap.toJSON() : undefined as any;
        if (Array.isArray(this.costItems)) {
            data["costItems"] = [];
            for (let item of this.costItems)
                data["costItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.associationQueries)) {
            data["associationQueries"] = [];
            for (let item of this.associationQueries)
                data["associationQueries"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdByUserEmail"] = this.createdByUserEmail;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedByUserEmail"] = this.lastModifiedByUserEmail;
        data["lastModifiedByDisplayName"] = this.lastModifiedByDisplayName;
        data["deletedByUserEmail"] = this.deletedByUserEmail;
        data["parentRoadmapItem"] = this.parentRoadmapItem ? this.parentRoadmapItem.toJSON() : undefined as any;
        if (Array.isArray(this.subRoadmapItems)) {
            data["subRoadmapItems"] = [];
            for (let item of this.subRoadmapItems)
                data["subRoadmapItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IRoadmapItemDto {
    roadmapItemId?: string;
    roadmapId?: string;
    parentRoadmapItemId?: string | undefined;
    recommendationId?: string | undefined;
    referenceType?: RecommendationReferenceType;
    recommendationSnapshot?: string | undefined;
    snapshotCapturedAt?: Date | undefined;
    roadmapItemOrdinal?: number;
    isMilestone?: boolean;
    isShiHelping?: boolean;
    owner?: string | undefined;
    status?: string | undefined;
    sourceType: RoadmapItemSourceType;
    sourceMetadata?: { [key: string]: string; } | undefined;
    sourceId: string | undefined;
    name: string | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    startDate?: Date | undefined;
    targetDate?: Date;
    roadmap?: RoadmapDto;
    costItems?: RoadmapCostItemDto[] | undefined;
    documents?: RoadmapDocumentDto[] | undefined;
    associationQueries?: RoadmapAssociationQueryDto[] | undefined;
    createdDate?: Date;
    createdByUserEmail?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedByUserEmail?: string | undefined;
    lastModifiedByDisplayName?: string | undefined;
    deletedByUserEmail?: string | undefined;
    parentRoadmapItem?: RoadmapItemDto;
    subRoadmapItems?: RoadmapItemDto[] | undefined;
    isDeleted?: boolean;
}

export class ToggleRoadmapIsCompletedDto implements IToggleRoadmapIsCompletedDto {
    roadmapId!: string;
    isCompleted!: boolean;

    constructor(data?: IToggleRoadmapIsCompletedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roadmapId = _data["roadmapId"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): ToggleRoadmapIsCompletedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleRoadmapIsCompletedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roadmapId"] = this.roadmapId;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IToggleRoadmapIsCompletedDto {
    roadmapId: string;
    isCompleted: boolean;
}

export enum UserOnDemandLabRequestStatus {
    Pending = "Pending",
    Approved = "Approved",
    Denied = "Denied",
}

export class BannerImageDto implements IBannerImageDto {
    labTitle?: string | undefined;
    imageSource?: string | undefined;

    constructor(data?: IBannerImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labTitle = _data["labTitle"];
            this.imageSource = _data["imageSource"];
        }
    }

    static fromJS(data: any): BannerImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannerImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labTitle"] = this.labTitle;
        data["imageSource"] = this.imageSource;
        return data;
    }
}

export interface IBannerImageDto {
    labTitle?: string | undefined;
    imageSource?: string | undefined;
}

export class DownloadLabDocumentationByFileReference implements IDownloadLabDocumentationByFileReference {
    fileRef?: string | undefined;

    constructor(data?: IDownloadLabDocumentationByFileReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileRef = _data["fileRef"];
        }
    }

    static fromJS(data: any): DownloadLabDocumentationByFileReference {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadLabDocumentationByFileReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileRef"] = this.fileRef;
        return data;
    }
}

export interface IDownloadLabDocumentationByFileReference {
    fileRef?: string | undefined;
}

export class DownloadLabDocumentationDto implements IDownloadLabDocumentationDto {
    file?: string | undefined;
    mimeType?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IDownloadLabDocumentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.mimeType = _data["mimeType"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): DownloadLabDocumentationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadLabDocumentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["mimeType"] = this.mimeType;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IDownloadLabDocumentationDto {
    file?: string | undefined;
    mimeType?: string | undefined;
    fileName?: string | undefined;
}

export enum ELinkType {
    Article = "Article",
    Image = "Image",
    Video = "Video",
}

export class Lab implements ILab {
    id?: number;
    productName?: string | undefined;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    labLinks?: LabLink[] | undefined;
    partners?: PartnerLogo[] | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;

    constructor(data?: ILab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            if (Array.isArray(_data["practice"])) {
                this.practice = [] as any;
                for (let item of _data["practice"])
                    this.practice!.push(item);
            }
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
            if (Array.isArray(_data["labLinks"])) {
                this.labLinks = [] as any;
                for (let item of _data["labLinks"])
                    this.labLinks!.push(LabLink.fromJS(item));
            }
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerLogo.fromJS(item));
            }
            this.overview = _data["overview"];
            this.deliverables = _data["deliverables"];
            this.technology = _data["technology"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): Lab {
        data = typeof data === 'object' ? data : {};
        let result = new Lab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        if (Array.isArray(this.practice)) {
            data["practice"] = [];
            for (let item of this.practice)
                data["practice"].push(item);
        }
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        if (Array.isArray(this.labLinks)) {
            data["labLinks"] = [];
            for (let item of this.labLinks)
                data["labLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item ? item.toJSON() : undefined as any);
        }
        data["overview"] = this.overview;
        data["deliverables"] = this.deliverables;
        data["technology"] = this.technology;
        data["duration"] = this.duration;
        return data;
    }
}

export interface ILab {
    id?: number;
    productName?: string | undefined;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    labLinks?: LabLink[] | undefined;
    partners?: PartnerLogo[] | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
}

export class LabAccessRequestResponse implements ILabAccessRequestResponse {
    success?: boolean;

    constructor(data?: ILabAccessRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): LabAccessRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LabAccessRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ILabAccessRequestResponse {
    success?: boolean;
}

export class LabAttachmentDto implements ILabAttachmentDto {
    id?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    size?: number | undefined;
    downloadUrl?: string | undefined;

    constructor(data?: ILabAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.size = _data["size"];
            this.downloadUrl = _data["downloadUrl"];
        }
    }

    static fromJS(data: any): LabAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
}

export interface ILabAttachmentDto {
    id?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    size?: number | undefined;
    downloadUrl?: string | undefined;
}

export class LabDocumentationDto implements ILabDocumentationDto {
    labTitle?: string | undefined;
    documentationFileRef?: string | undefined;

    constructor(data?: ILabDocumentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labTitle = _data["labTitle"];
            this.documentationFileRef = _data["documentationFileRef"];
        }
    }

    static fromJS(data: any): LabDocumentationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabDocumentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labTitle"] = this.labTitle;
        data["documentationFileRef"] = this.documentationFileRef;
        return data;
    }
}

export interface ILabDocumentationDto {
    labTitle?: string | undefined;
    documentationFileRef?: string | undefined;
}

export class LabDto implements ILabDto {
    id?: number;
    productName?: string | undefined;
    uniqueId?: string | undefined;
    legacyId?: number | undefined;
    legacyUniqueId?: string | undefined;
    isOnDemandLab?: boolean;
    isConsultationVisible?: boolean;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
    labLinks?: LabLinkDto[] | undefined;
    partners?: PartnerLogoDto[] | undefined;
    bannerImages?: BannerImageDto[] | undefined;
    documentation?: LabDocumentationDto[] | undefined;
    attachments?: LabAttachmentDto[] | undefined;

    constructor(data?: ILabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.uniqueId = _data["uniqueId"];
            this.legacyId = _data["legacyId"];
            this.legacyUniqueId = _data["legacyUniqueId"];
            this.isOnDemandLab = _data["isOnDemandLab"];
            this.isConsultationVisible = _data["isConsultationVisible"];
            if (Array.isArray(_data["practice"])) {
                this.practice = [] as any;
                for (let item of _data["practice"])
                    this.practice!.push(item);
            }
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
            this.overview = _data["overview"];
            this.deliverables = _data["deliverables"];
            this.technology = _data["technology"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["labLinks"])) {
                this.labLinks = [] as any;
                for (let item of _data["labLinks"])
                    this.labLinks!.push(LabLinkDto.fromJS(item));
            }
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerLogoDto.fromJS(item));
            }
            if (Array.isArray(_data["bannerImages"])) {
                this.bannerImages = [] as any;
                for (let item of _data["bannerImages"])
                    this.bannerImages!.push(BannerImageDto.fromJS(item));
            }
            if (Array.isArray(_data["documentation"])) {
                this.documentation = [] as any;
                for (let item of _data["documentation"])
                    this.documentation!.push(LabDocumentationDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(LabAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LabDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["uniqueId"] = this.uniqueId;
        data["legacyId"] = this.legacyId;
        data["legacyUniqueId"] = this.legacyUniqueId;
        data["isOnDemandLab"] = this.isOnDemandLab;
        data["isConsultationVisible"] = this.isConsultationVisible;
        if (Array.isArray(this.practice)) {
            data["practice"] = [];
            for (let item of this.practice)
                data["practice"].push(item);
        }
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        data["overview"] = this.overview;
        data["deliverables"] = this.deliverables;
        data["technology"] = this.technology;
        data["duration"] = this.duration;
        if (Array.isArray(this.labLinks)) {
            data["labLinks"] = [];
            for (let item of this.labLinks)
                data["labLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bannerImages)) {
            data["bannerImages"] = [];
            for (let item of this.bannerImages)
                data["bannerImages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documentation)) {
            data["documentation"] = [];
            for (let item of this.documentation)
                data["documentation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILabDto {
    id?: number;
    productName?: string | undefined;
    uniqueId?: string | undefined;
    legacyId?: number | undefined;
    legacyUniqueId?: string | undefined;
    isOnDemandLab?: boolean;
    isConsultationVisible?: boolean;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
    labLinks?: LabLinkDto[] | undefined;
    partners?: PartnerLogoDto[] | undefined;
    bannerImages?: BannerImageDto[] | undefined;
    documentation?: LabDocumentationDto[] | undefined;
    attachments?: LabAttachmentDto[] | undefined;
}

export class LabLink implements ILabLink {
    id?: number;
    linkCaption?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    linkType?: ELinkType;

    constructor(data?: ILabLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.linkCaption = _data["linkCaption"];
            this.description = _data["description"];
            this.link = _data["link"];
            this.linkType = _data["linkType"];
        }
    }

    static fromJS(data: any): LabLink {
        data = typeof data === 'object' ? data : {};
        let result = new LabLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["linkCaption"] = this.linkCaption;
        data["description"] = this.description;
        data["link"] = this.link;
        data["linkType"] = this.linkType;
        return data;
    }
}

export interface ILabLink {
    id?: number;
    linkCaption?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    linkType?: ELinkType;
}

export class LabLinkDto implements ILabLinkDto {
    id?: number;
    linkCaption?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    linkType?: ELinkType;

    constructor(data?: ILabLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.linkCaption = _data["linkCaption"];
            this.description = _data["description"];
            this.link = _data["link"];
            this.linkType = _data["linkType"];
        }
    }

    static fromJS(data: any): LabLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["linkCaption"] = this.linkCaption;
        data["description"] = this.description;
        data["link"] = this.link;
        data["linkType"] = this.linkType;
        return data;
    }
}

export interface ILabLinkDto {
    id?: number;
    linkCaption?: string | undefined;
    description?: string | undefined;
    link?: string | undefined;
    linkType?: ELinkType;
}

export class LabLogoDto implements ILabLogoDto {
    image?: string | undefined;
    mimeType?: string | undefined;

    constructor(data?: ILabLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): LabLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface ILabLogoDto {
    image?: string | undefined;
    mimeType?: string | undefined;
}

export class OnDemandLabDto implements IOnDemandLabDto {
    labId?: string | undefined;
    userId?: string | undefined;
    status?: string | undefined;
    createdUtc?: Date | undefined;
    envId?: string | undefined;
    siteId?: string | undefined;
    expirationUtc?: Date | undefined;

    constructor(data?: IOnDemandLabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labId = _data["labId"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : undefined as any;
            this.envId = _data["envId"];
            this.siteId = _data["siteId"];
            this.expirationUtc = _data["expirationUtc"] ? new Date(_data["expirationUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OnDemandLabDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandLabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labId"] = this.labId;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : undefined as any;
        data["envId"] = this.envId;
        data["siteId"] = this.siteId;
        data["expirationUtc"] = this.expirationUtc ? this.expirationUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IOnDemandLabDto {
    labId?: string | undefined;
    userId?: string | undefined;
    status?: string | undefined;
    createdUtc?: Date | undefined;
    envId?: string | undefined;
    siteId?: string | undefined;
    expirationUtc?: Date | undefined;
}

export class PartnerLogo implements IPartnerLogo {
    partner?: string | undefined;
    logo?: string | undefined;

    constructor(data?: IPartnerLogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"];
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): PartnerLogo {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerLogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner;
        data["logo"] = this.logo;
        return data;
    }
}

export interface IPartnerLogo {
    partner?: string | undefined;
    logo?: string | undefined;
}

export class PartnerLogoDto implements IPartnerLogoDto {
    partner?: string | undefined;
    logo?: string | undefined;

    constructor(data?: IPartnerLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"];
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): PartnerLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner;
        data["logo"] = this.logo;
        return data;
    }
}

export interface IPartnerLogoDto {
    partner?: string | undefined;
    logo?: string | undefined;
}

export class ServiceCatalogAccessResponse implements IServiceCatalogAccessResponse {
    success?: boolean;

    constructor(data?: IServiceCatalogAccessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ServiceCatalogAccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCatalogAccessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IServiceCatalogAccessResponse {
    success?: boolean;
}

export class ServiceCatalogDto implements IServiceCatalogDto {
    id?: number;
    productName?: string | undefined;
    uniqueId?: string | undefined;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    manufacturer?: string | undefined;
    category?: string | undefined;
    deliveryTeam?: string | undefined;
    projectType?: string | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
    partners?: PartnerLogoDto[] | undefined;

    constructor(data?: IServiceCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.uniqueId = _data["uniqueId"];
            if (Array.isArray(_data["practice"])) {
                this.practice = [] as any;
                for (let item of _data["practice"])
                    this.practice!.push(item);
            }
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
            this.manufacturer = _data["manufacturer"];
            this.category = _data["category"];
            this.deliveryTeam = _data["deliveryTeam"];
            this.projectType = _data["projectType"];
            this.overview = _data["overview"];
            this.deliverables = _data["deliverables"];
            this.technology = _data["technology"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerLogoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["uniqueId"] = this.uniqueId;
        if (Array.isArray(this.practice)) {
            data["practice"] = [];
            for (let item of this.practice)
                data["practice"].push(item);
        }
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        data["manufacturer"] = this.manufacturer;
        data["category"] = this.category;
        data["deliveryTeam"] = this.deliveryTeam;
        data["projectType"] = this.projectType;
        data["overview"] = this.overview;
        data["deliverables"] = this.deliverables;
        data["technology"] = this.technology;
        data["duration"] = this.duration;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IServiceCatalogDto {
    id?: number;
    productName?: string | undefined;
    uniqueId?: string | undefined;
    practice?: string[] | undefined;
    platform?: string[] | undefined;
    manufacturer?: string | undefined;
    category?: string | undefined;
    deliveryTeam?: string | undefined;
    projectType?: string | undefined;
    overview?: string | undefined;
    deliverables?: string | undefined;
    technology?: string | undefined;
    duration?: string | undefined;
    partners?: PartnerLogoDto[] | undefined;
}

export class UserLabsDto implements IUserLabsDto {
    labs?: OnDemandLabDto[] | undefined;
    id?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    env0Id?: string | undefined;

    constructor(data?: IUserLabsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labs"])) {
                this.labs = [] as any;
                for (let item of _data["labs"])
                    this.labs!.push(OnDemandLabDto.fromJS(item));
            }
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.env0Id = _data["env0Id"];
        }
    }

    static fromJS(data: any): UserLabsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLabsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labs)) {
            data["labs"] = [];
            for (let item of this.labs)
                data["labs"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["env0Id"] = this.env0Id;
        return data;
    }
}

export interface IUserLabsDto {
    labs?: OnDemandLabDto[] | undefined;
    id?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    env0Id?: string | undefined;
}

export class UserOnDemandLabRequestDto implements IUserOnDemandLabRequestDto {
    accountName?: string | undefined;
    accountId?: number;
    userEmail?: string | undefined;
    accountExecutiveEmail?: string | undefined;
    primaryAx?: string | undefined;
    crmAccountLink?: string | undefined;
    reportingBuName?: string | undefined;
    reportingBuPath?: string | undefined;
    requesterUsername?: string | undefined;
    labId?: number;
    labTitle?: string | undefined;
    labDeploymentStatus?: string | undefined;
    accountExecutive?: string | undefined;
    requesterUserId?: string | undefined;
    uniqueLabIdentifier?: string | undefined;
    requestDateUtc?: Date | undefined;
    status?: UserOnDemandLabRequestStatus;
    reviewedBy?: string | undefined;
    reviewDateUtc?: Date | undefined;
    denialReason?: string | undefined;

    constructor(data?: IUserOnDemandLabRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.accountId = _data["accountId"];
            this.userEmail = _data["userEmail"];
            this.accountExecutiveEmail = _data["accountExecutiveEmail"];
            this.primaryAx = _data["primaryAx"];
            this.crmAccountLink = _data["crmAccountLink"];
            this.reportingBuName = _data["reportingBuName"];
            this.reportingBuPath = _data["reportingBuPath"];
            this.requesterUsername = _data["requesterUsername"];
            this.labId = _data["labId"];
            this.labTitle = _data["labTitle"];
            this.labDeploymentStatus = _data["labDeploymentStatus"];
            this.accountExecutive = _data["accountExecutive"];
            this.requesterUserId = _data["requesterUserId"];
            this.uniqueLabIdentifier = _data["uniqueLabIdentifier"];
            this.requestDateUtc = _data["requestDateUtc"] ? new Date(_data["requestDateUtc"].toString()) : undefined as any;
            this.status = _data["status"];
            this.reviewedBy = _data["reviewedBy"];
            this.reviewDateUtc = _data["reviewDateUtc"] ? new Date(_data["reviewDateUtc"].toString()) : undefined as any;
            this.denialReason = _data["denialReason"];
        }
    }

    static fromJS(data: any): UserOnDemandLabRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOnDemandLabRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountId"] = this.accountId;
        data["userEmail"] = this.userEmail;
        data["accountExecutiveEmail"] = this.accountExecutiveEmail;
        data["primaryAx"] = this.primaryAx;
        data["crmAccountLink"] = this.crmAccountLink;
        data["reportingBuName"] = this.reportingBuName;
        data["reportingBuPath"] = this.reportingBuPath;
        data["requesterUsername"] = this.requesterUsername;
        data["labId"] = this.labId;
        data["labTitle"] = this.labTitle;
        data["labDeploymentStatus"] = this.labDeploymentStatus;
        data["accountExecutive"] = this.accountExecutive;
        data["requesterUserId"] = this.requesterUserId;
        data["uniqueLabIdentifier"] = this.uniqueLabIdentifier;
        data["requestDateUtc"] = this.requestDateUtc ? this.requestDateUtc.toISOString() : undefined as any;
        data["status"] = this.status;
        data["reviewedBy"] = this.reviewedBy;
        data["reviewDateUtc"] = this.reviewDateUtc ? this.reviewDateUtc.toISOString() : undefined as any;
        data["denialReason"] = this.denialReason;
        return data;
    }
}

export interface IUserOnDemandLabRequestDto {
    accountName?: string | undefined;
    accountId?: number;
    userEmail?: string | undefined;
    accountExecutiveEmail?: string | undefined;
    primaryAx?: string | undefined;
    crmAccountLink?: string | undefined;
    reportingBuName?: string | undefined;
    reportingBuPath?: string | undefined;
    requesterUsername?: string | undefined;
    labId?: number;
    labTitle?: string | undefined;
    labDeploymentStatus?: string | undefined;
    accountExecutive?: string | undefined;
    requesterUserId?: string | undefined;
    uniqueLabIdentifier?: string | undefined;
    requestDateUtc?: Date | undefined;
    status?: UserOnDemandLabRequestStatus;
    reviewedBy?: string | undefined;
    reviewDateUtc?: Date | undefined;
    denialReason?: string | undefined;
}

export class AccountDto implements IAccountDto {
    id?: string;
    name?: string | undefined;
    axAccountNumber?: string | undefined;
    address1City?: string | undefined;
    address1Country?: string | undefined;
    address1Line1?: string | undefined;
    address1Line2?: string | undefined;
    address1PostalCode?: string | undefined;
    address1StateOrProvince?: string | undefined;
    address1Telephone?: string | undefined;
    customerType?: number | undefined;
    owningTeamId?: string | undefined;
    owningTeam?: TeamDto;
    parentAccountId?: string | undefined;
    parentAccount?: AccountDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
    primaryOwnerId?: string | undefined;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    roleConnections!: ResourceAlignmentDto[] | undefined;
    supplementalRoleConnections!: SupplementalResourceAlignmentDto[] | undefined;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.address1City = _data["address1City"];
            this.address1Country = _data["address1Country"];
            this.address1Line1 = _data["address1Line1"];
            this.address1Line2 = _data["address1Line2"];
            this.address1PostalCode = _data["address1PostalCode"];
            this.address1StateOrProvince = _data["address1StateOrProvince"];
            this.address1Telephone = _data["address1Telephone"];
            this.customerType = _data["customerType"];
            this.owningTeamId = _data["owningTeamId"];
            this.owningTeam = _data["owningTeam"] ? TeamDto.fromJS(_data["owningTeam"]) : undefined as any;
            this.parentAccountId = _data["parentAccountId"];
            this.parentAccount = _data["parentAccount"] ? AccountDto.fromJS(_data["parentAccount"]) : undefined as any;
            this.reportingBusinessUnitId = _data["reportingBusinessUnitId"];
            this.reportingBusinessUnit = _data["reportingBusinessUnit"] ? ReportingBusinessUnitDto.fromJS(_data["reportingBusinessUnit"]) : undefined as any;
            this.primaryOwnerId = _data["primaryOwnerId"];
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : undefined as any;
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : undefined as any;
            if (Array.isArray(_data["roleConnections"])) {
                this.roleConnections = [] as any;
                for (let item of _data["roleConnections"])
                    this.roleConnections!.push(ResourceAlignmentDto.fromJS(item));
            }
            if (Array.isArray(_data["supplementalRoleConnections"])) {
                this.supplementalRoleConnections = [] as any;
                for (let item of _data["supplementalRoleConnections"])
                    this.supplementalRoleConnections!.push(SupplementalResourceAlignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["axAccountNumber"] = this.axAccountNumber;
        data["address1City"] = this.address1City;
        data["address1Country"] = this.address1Country;
        data["address1Line1"] = this.address1Line1;
        data["address1Line2"] = this.address1Line2;
        data["address1PostalCode"] = this.address1PostalCode;
        data["address1StateOrProvince"] = this.address1StateOrProvince;
        data["address1Telephone"] = this.address1Telephone;
        data["customerType"] = this.customerType;
        data["owningTeamId"] = this.owningTeamId;
        data["owningTeam"] = this.owningTeam ? this.owningTeam.toJSON() : undefined as any;
        data["parentAccountId"] = this.parentAccountId;
        data["parentAccount"] = this.parentAccount ? this.parentAccount.toJSON() : undefined as any;
        data["reportingBusinessUnitId"] = this.reportingBusinessUnitId;
        data["reportingBusinessUnit"] = this.reportingBusinessUnit ? this.reportingBusinessUnit.toJSON() : undefined as any;
        data["primaryOwnerId"] = this.primaryOwnerId;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : undefined as any;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : undefined as any;
        if (Array.isArray(this.roleConnections)) {
            data["roleConnections"] = [];
            for (let item of this.roleConnections)
                data["roleConnections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.supplementalRoleConnections)) {
            data["supplementalRoleConnections"] = [];
            for (let item of this.supplementalRoleConnections)
                data["supplementalRoleConnections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccountDto {
    id?: string;
    name?: string | undefined;
    axAccountNumber?: string | undefined;
    address1City?: string | undefined;
    address1Country?: string | undefined;
    address1Line1?: string | undefined;
    address1Line2?: string | undefined;
    address1PostalCode?: string | undefined;
    address1StateOrProvince?: string | undefined;
    address1Telephone?: string | undefined;
    customerType?: number | undefined;
    owningTeamId?: string | undefined;
    owningTeam?: TeamDto;
    parentAccountId?: string | undefined;
    parentAccount?: AccountDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
    primaryOwnerId?: string | undefined;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    roleConnections: ResourceAlignmentDto[] | undefined;
    supplementalRoleConnections: SupplementalResourceAlignmentDto[] | undefined;
}

export class ConnectionRole implements IConnectionRole {
    id?: string;
    name!: string | undefined;
    roleActive!: number;
    modifiedInCrm?: Date | undefined;
    createdOnInCrm?: Date | undefined;

    constructor(data?: IConnectionRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.roleActive = _data["roleActive"];
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : undefined as any;
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ConnectionRole {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["roleActive"] = this.roleActive;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : undefined as any;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : undefined as any;
        return data;
    }
}

export interface IConnectionRole {
    id?: string;
    name: string | undefined;
    roleActive: number;
    modifiedInCrm?: Date | undefined;
    createdOnInCrm?: Date | undefined;
}

export class ReportingBusinessUnitDto implements IReportingBusinessUnitDto {
    id?: string;
    levelOneOutsideManagerId?: string | undefined;
    levelOneOutsideManager?: SystemUserDto;
    levelTwoOutsideManagerId?: string | undefined;
    levelTwoOutsideManager?: SystemUserDto;
    levelThreeOutsideManagerId?: string | undefined;
    levelThreeOutsideManager?: SystemUserDto;
    levelFourOutsideManagerId?: string | undefined;
    levelFourOutsideManager?: SystemUserDto;
    levelFiveOutsideManagerId?: string | undefined;
    levelFiveOutsideManager?: SystemUserDto;
    parentReportingBusinessUnitId?: string | undefined;
    parentReportingBusinessUnit?: ReportingBusinessUnitDto;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    name?: string | undefined;
    pathName?: string | undefined;
    roleConnections!: ResourceAlignmentDto[] | undefined;
    supplementalRoleConnections!: SupplementalResourceAlignmentDto[] | undefined;

    constructor(data?: IReportingBusinessUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.levelOneOutsideManagerId = _data["levelOneOutsideManagerId"];
            this.levelOneOutsideManager = _data["levelOneOutsideManager"] ? SystemUserDto.fromJS(_data["levelOneOutsideManager"]) : undefined as any;
            this.levelTwoOutsideManagerId = _data["levelTwoOutsideManagerId"];
            this.levelTwoOutsideManager = _data["levelTwoOutsideManager"] ? SystemUserDto.fromJS(_data["levelTwoOutsideManager"]) : undefined as any;
            this.levelThreeOutsideManagerId = _data["levelThreeOutsideManagerId"];
            this.levelThreeOutsideManager = _data["levelThreeOutsideManager"] ? SystemUserDto.fromJS(_data["levelThreeOutsideManager"]) : undefined as any;
            this.levelFourOutsideManagerId = _data["levelFourOutsideManagerId"];
            this.levelFourOutsideManager = _data["levelFourOutsideManager"] ? SystemUserDto.fromJS(_data["levelFourOutsideManager"]) : undefined as any;
            this.levelFiveOutsideManagerId = _data["levelFiveOutsideManagerId"];
            this.levelFiveOutsideManager = _data["levelFiveOutsideManager"] ? SystemUserDto.fromJS(_data["levelFiveOutsideManager"]) : undefined as any;
            this.parentReportingBusinessUnitId = _data["parentReportingBusinessUnitId"];
            this.parentReportingBusinessUnit = _data["parentReportingBusinessUnit"] ? ReportingBusinessUnitDto.fromJS(_data["parentReportingBusinessUnit"]) : undefined as any;
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : undefined as any;
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : undefined as any;
            this.name = _data["name"];
            this.pathName = _data["pathName"];
            if (Array.isArray(_data["roleConnections"])) {
                this.roleConnections = [] as any;
                for (let item of _data["roleConnections"])
                    this.roleConnections!.push(ResourceAlignmentDto.fromJS(item));
            }
            if (Array.isArray(_data["supplementalRoleConnections"])) {
                this.supplementalRoleConnections = [] as any;
                for (let item of _data["supplementalRoleConnections"])
                    this.supplementalRoleConnections!.push(SupplementalResourceAlignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportingBusinessUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingBusinessUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelOneOutsideManagerId"] = this.levelOneOutsideManagerId;
        data["levelOneOutsideManager"] = this.levelOneOutsideManager ? this.levelOneOutsideManager.toJSON() : undefined as any;
        data["levelTwoOutsideManagerId"] = this.levelTwoOutsideManagerId;
        data["levelTwoOutsideManager"] = this.levelTwoOutsideManager ? this.levelTwoOutsideManager.toJSON() : undefined as any;
        data["levelThreeOutsideManagerId"] = this.levelThreeOutsideManagerId;
        data["levelThreeOutsideManager"] = this.levelThreeOutsideManager ? this.levelThreeOutsideManager.toJSON() : undefined as any;
        data["levelFourOutsideManagerId"] = this.levelFourOutsideManagerId;
        data["levelFourOutsideManager"] = this.levelFourOutsideManager ? this.levelFourOutsideManager.toJSON() : undefined as any;
        data["levelFiveOutsideManagerId"] = this.levelFiveOutsideManagerId;
        data["levelFiveOutsideManager"] = this.levelFiveOutsideManager ? this.levelFiveOutsideManager.toJSON() : undefined as any;
        data["parentReportingBusinessUnitId"] = this.parentReportingBusinessUnitId;
        data["parentReportingBusinessUnit"] = this.parentReportingBusinessUnit ? this.parentReportingBusinessUnit.toJSON() : undefined as any;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : undefined as any;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : undefined as any;
        data["name"] = this.name;
        data["pathName"] = this.pathName;
        if (Array.isArray(this.roleConnections)) {
            data["roleConnections"] = [];
            for (let item of this.roleConnections)
                data["roleConnections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.supplementalRoleConnections)) {
            data["supplementalRoleConnections"] = [];
            for (let item of this.supplementalRoleConnections)
                data["supplementalRoleConnections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportingBusinessUnitDto {
    id?: string;
    levelOneOutsideManagerId?: string | undefined;
    levelOneOutsideManager?: SystemUserDto;
    levelTwoOutsideManagerId?: string | undefined;
    levelTwoOutsideManager?: SystemUserDto;
    levelThreeOutsideManagerId?: string | undefined;
    levelThreeOutsideManager?: SystemUserDto;
    levelFourOutsideManagerId?: string | undefined;
    levelFourOutsideManager?: SystemUserDto;
    levelFiveOutsideManagerId?: string | undefined;
    levelFiveOutsideManager?: SystemUserDto;
    parentReportingBusinessUnitId?: string | undefined;
    parentReportingBusinessUnit?: ReportingBusinessUnitDto;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    name?: string | undefined;
    pathName?: string | undefined;
    roleConnections: ResourceAlignmentDto[] | undefined;
    supplementalRoleConnections: SupplementalResourceAlignmentDto[] | undefined;
}

export class ResourceAlignmentDto implements IResourceAlignmentDto {
    id?: string;
    connectionRoleId?: string | undefined;
    connectionRole?: ConnectionRole;
    modifiedInCrm?: Date | undefined;
    createdOnInCrm?: Date | undefined;
    resourceAlignmentName?: string | undefined;
    systemUserId?: string | undefined;
    systemUser?: SystemUserDto;
    accountId?: string | undefined;
    account?: AccountDto;
    teamId?: string | undefined;
    team?: TeamDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;

    constructor(data?: IResourceAlignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.connectionRoleId = _data["connectionRoleId"];
            this.connectionRole = _data["connectionRole"] ? ConnectionRole.fromJS(_data["connectionRole"]) : undefined as any;
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : undefined as any;
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : undefined as any;
            this.resourceAlignmentName = _data["resourceAlignmentName"];
            this.systemUserId = _data["systemUserId"];
            this.systemUser = _data["systemUser"] ? SystemUserDto.fromJS(_data["systemUser"]) : undefined as any;
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? AccountDto.fromJS(_data["account"]) : undefined as any;
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamDto.fromJS(_data["team"]) : undefined as any;
            this.reportingBusinessUnitId = _data["reportingBusinessUnitId"];
            this.reportingBusinessUnit = _data["reportingBusinessUnit"] ? ReportingBusinessUnitDto.fromJS(_data["reportingBusinessUnit"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResourceAlignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceAlignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["connectionRoleId"] = this.connectionRoleId;
        data["connectionRole"] = this.connectionRole ? this.connectionRole.toJSON() : undefined as any;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : undefined as any;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : undefined as any;
        data["resourceAlignmentName"] = this.resourceAlignmentName;
        data["systemUserId"] = this.systemUserId;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : undefined as any;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : undefined as any;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : undefined as any;
        data["reportingBusinessUnitId"] = this.reportingBusinessUnitId;
        data["reportingBusinessUnit"] = this.reportingBusinessUnit ? this.reportingBusinessUnit.toJSON() : undefined as any;
        return data;
    }
}

export interface IResourceAlignmentDto {
    id?: string;
    connectionRoleId?: string | undefined;
    connectionRole?: ConnectionRole;
    modifiedInCrm?: Date | undefined;
    createdOnInCrm?: Date | undefined;
    resourceAlignmentName?: string | undefined;
    systemUserId?: string | undefined;
    systemUser?: SystemUserDto;
    accountId?: string | undefined;
    account?: AccountDto;
    teamId?: string | undefined;
    team?: TeamDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
}

export class ShiEmployeeDto implements IShiEmployeeDto {
    id?: string;
    displayName!: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;
    lastRetrievedFromEntra?: Date;
    managerId?: string | undefined;
    manager?: ShiEmployeeDto;
    directReports?: ShiEmployeeDto[] | undefined;
    systemUser?: SystemUserDto;
    systemUserId?: string | undefined;

    constructor(data?: IShiEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.jobTitle = _data["jobTitle"];
            this.lastRetrievedFromEntra = _data["lastRetrievedFromEntra"] ? new Date(_data["lastRetrievedFromEntra"].toString()) : undefined as any;
            this.managerId = _data["managerId"];
            this.manager = _data["manager"] ? ShiEmployeeDto.fromJS(_data["manager"]) : undefined as any;
            if (Array.isArray(_data["directReports"])) {
                this.directReports = [] as any;
                for (let item of _data["directReports"])
                    this.directReports!.push(ShiEmployeeDto.fromJS(item));
            }
            this.systemUser = _data["systemUser"] ? SystemUserDto.fromJS(_data["systemUser"]) : undefined as any;
            this.systemUserId = _data["systemUserId"];
        }
    }

    static fromJS(data: any): ShiEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["jobTitle"] = this.jobTitle;
        data["lastRetrievedFromEntra"] = this.lastRetrievedFromEntra ? this.lastRetrievedFromEntra.toISOString() : undefined as any;
        data["managerId"] = this.managerId;
        data["manager"] = this.manager ? this.manager.toJSON() : undefined as any;
        if (Array.isArray(this.directReports)) {
            data["directReports"] = [];
            for (let item of this.directReports)
                data["directReports"].push(item ? item.toJSON() : undefined as any);
        }
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : undefined as any;
        data["systemUserId"] = this.systemUserId;
        return data;
    }
}

export interface IShiEmployeeDto {
    id?: string;
    displayName: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;
    lastRetrievedFromEntra?: Date;
    managerId?: string | undefined;
    manager?: ShiEmployeeDto;
    directReports?: ShiEmployeeDto[] | undefined;
    systemUser?: SystemUserDto;
    systemUserId?: string | undefined;
}

export class SupplementalResourceAlignmentDto implements ISupplementalResourceAlignmentDto {
    id?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    resourceAlignmentName?: string | undefined;
    connectionRoleId?: string | undefined;
    connectionRole?: ConnectionRole;
    systemUserId?: string | undefined;
    systemUser?: SystemUserDto;
    accountId?: string | undefined;
    account?: AccountDto;
    teamId?: string | undefined;
    team?: TeamDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;

    constructor(data?: ISupplementalResourceAlignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : undefined as any;
            this.resourceAlignmentName = _data["resourceAlignmentName"];
            this.connectionRoleId = _data["connectionRoleId"];
            this.connectionRole = _data["connectionRole"] ? ConnectionRole.fromJS(_data["connectionRole"]) : undefined as any;
            this.systemUserId = _data["systemUserId"];
            this.systemUser = _data["systemUser"] ? SystemUserDto.fromJS(_data["systemUser"]) : undefined as any;
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? AccountDto.fromJS(_data["account"]) : undefined as any;
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamDto.fromJS(_data["team"]) : undefined as any;
            this.reportingBusinessUnitId = _data["reportingBusinessUnitId"];
            this.reportingBusinessUnit = _data["reportingBusinessUnit"] ? ReportingBusinessUnitDto.fromJS(_data["reportingBusinessUnit"]) : undefined as any;
        }
    }

    static fromJS(data: any): SupplementalResourceAlignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplementalResourceAlignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : undefined as any;
        data["resourceAlignmentName"] = this.resourceAlignmentName;
        data["connectionRoleId"] = this.connectionRoleId;
        data["connectionRole"] = this.connectionRole ? this.connectionRole.toJSON() : undefined as any;
        data["systemUserId"] = this.systemUserId;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : undefined as any;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : undefined as any;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : undefined as any;
        data["reportingBusinessUnitId"] = this.reportingBusinessUnitId;
        data["reportingBusinessUnit"] = this.reportingBusinessUnit ? this.reportingBusinessUnit.toJSON() : undefined as any;
        return data;
    }
}

export interface ISupplementalResourceAlignmentDto {
    id?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    resourceAlignmentName?: string | undefined;
    connectionRoleId?: string | undefined;
    connectionRole?: ConnectionRole;
    systemUserId?: string | undefined;
    systemUser?: SystemUserDto;
    accountId?: string | undefined;
    account?: AccountDto;
    teamId?: string | undefined;
    team?: TeamDto;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
}

export class SystemUserDto implements ISystemUserDto {
    id?: string;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
    connectionRoleId?: string | undefined;
    connectionRoleName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    fullName?: string | undefined;
    shiLocalDomainName?: string | undefined;
    title?: string | undefined;
    internalEmailAddress?: string | undefined;
    isDisabledInCrm?: boolean;
    shiEmployee?: ShiEmployeeDto;
    shiEmployeeId?: string | undefined;
    modifiedInCrm?: Date;
    createdOnInCrm?: Date;
    teamMemberships!: TeamMembershipDto[] | undefined;
    roleConnections!: ResourceAlignmentDto[] | undefined;
    supplementalRoleConnections!: SupplementalResourceAlignmentDto[] | undefined;

    constructor(data?: ISystemUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reportingBusinessUnitId = _data["reportingBusinessUnitId"];
            this.reportingBusinessUnit = _data["reportingBusinessUnit"] ? ReportingBusinessUnitDto.fromJS(_data["reportingBusinessUnit"]) : undefined as any;
            this.connectionRoleId = _data["connectionRoleId"];
            this.connectionRoleName = _data["connectionRoleName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.shiLocalDomainName = _data["shiLocalDomainName"];
            this.title = _data["title"];
            this.internalEmailAddress = _data["internalEmailAddress"];
            this.isDisabledInCrm = _data["isDisabledInCrm"];
            this.shiEmployee = _data["shiEmployee"] ? ShiEmployeeDto.fromJS(_data["shiEmployee"]) : undefined as any;
            this.shiEmployeeId = _data["shiEmployeeId"];
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : undefined as any;
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : undefined as any;
            if (Array.isArray(_data["teamMemberships"])) {
                this.teamMemberships = [] as any;
                for (let item of _data["teamMemberships"])
                    this.teamMemberships!.push(TeamMembershipDto.fromJS(item));
            }
            if (Array.isArray(_data["roleConnections"])) {
                this.roleConnections = [] as any;
                for (let item of _data["roleConnections"])
                    this.roleConnections!.push(ResourceAlignmentDto.fromJS(item));
            }
            if (Array.isArray(_data["supplementalRoleConnections"])) {
                this.supplementalRoleConnections = [] as any;
                for (let item of _data["supplementalRoleConnections"])
                    this.supplementalRoleConnections!.push(SupplementalResourceAlignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reportingBusinessUnitId"] = this.reportingBusinessUnitId;
        data["reportingBusinessUnit"] = this.reportingBusinessUnit ? this.reportingBusinessUnit.toJSON() : undefined as any;
        data["connectionRoleId"] = this.connectionRoleId;
        data["connectionRoleName"] = this.connectionRoleName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["shiLocalDomainName"] = this.shiLocalDomainName;
        data["title"] = this.title;
        data["internalEmailAddress"] = this.internalEmailAddress;
        data["isDisabledInCrm"] = this.isDisabledInCrm;
        data["shiEmployee"] = this.shiEmployee ? this.shiEmployee.toJSON() : undefined as any;
        data["shiEmployeeId"] = this.shiEmployeeId;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : undefined as any;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : undefined as any;
        if (Array.isArray(this.teamMemberships)) {
            data["teamMemberships"] = [];
            for (let item of this.teamMemberships)
                data["teamMemberships"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roleConnections)) {
            data["roleConnections"] = [];
            for (let item of this.roleConnections)
                data["roleConnections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.supplementalRoleConnections)) {
            data["supplementalRoleConnections"] = [];
            for (let item of this.supplementalRoleConnections)
                data["supplementalRoleConnections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISystemUserDto {
    id?: string;
    reportingBusinessUnitId?: string | undefined;
    reportingBusinessUnit?: ReportingBusinessUnitDto;
    connectionRoleId?: string | undefined;
    connectionRoleName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    fullName?: string | undefined;
    shiLocalDomainName?: string | undefined;
    title?: string | undefined;
    internalEmailAddress?: string | undefined;
    isDisabledInCrm?: boolean;
    shiEmployee?: ShiEmployeeDto;
    shiEmployeeId?: string | undefined;
    modifiedInCrm?: Date;
    createdOnInCrm?: Date;
    teamMemberships: TeamMembershipDto[] | undefined;
    roleConnections: ResourceAlignmentDto[] | undefined;
    supplementalRoleConnections: SupplementalResourceAlignmentDto[] | undefined;
}

export class TeamDto implements ITeamDto {
    id?: string;
    name?: string | undefined;
    salesKey?: string | undefined;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    teamMemberships!: TeamMembershipDto[] | undefined;
    roleConnections!: ResourceAlignmentDto[] | undefined;
    supplementalRoleConnections!: SupplementalResourceAlignmentDto[] | undefined;

    constructor(data?: ITeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.salesKey = _data["salesKey"];
            this.createdOnInCrm = _data["createdOnInCrm"] ? new Date(_data["createdOnInCrm"].toString()) : undefined as any;
            this.modifiedInCrm = _data["modifiedInCrm"] ? new Date(_data["modifiedInCrm"].toString()) : undefined as any;
            if (Array.isArray(_data["teamMemberships"])) {
                this.teamMemberships = [] as any;
                for (let item of _data["teamMemberships"])
                    this.teamMemberships!.push(TeamMembershipDto.fromJS(item));
            }
            if (Array.isArray(_data["roleConnections"])) {
                this.roleConnections = [] as any;
                for (let item of _data["roleConnections"])
                    this.roleConnections!.push(ResourceAlignmentDto.fromJS(item));
            }
            if (Array.isArray(_data["supplementalRoleConnections"])) {
                this.supplementalRoleConnections = [] as any;
                for (let item of _data["supplementalRoleConnections"])
                    this.supplementalRoleConnections!.push(SupplementalResourceAlignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["salesKey"] = this.salesKey;
        data["createdOnInCrm"] = this.createdOnInCrm ? this.createdOnInCrm.toISOString() : undefined as any;
        data["modifiedInCrm"] = this.modifiedInCrm ? this.modifiedInCrm.toISOString() : undefined as any;
        if (Array.isArray(this.teamMemberships)) {
            data["teamMemberships"] = [];
            for (let item of this.teamMemberships)
                data["teamMemberships"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roleConnections)) {
            data["roleConnections"] = [];
            for (let item of this.roleConnections)
                data["roleConnections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.supplementalRoleConnections)) {
            data["supplementalRoleConnections"] = [];
            for (let item of this.supplementalRoleConnections)
                data["supplementalRoleConnections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITeamDto {
    id?: string;
    name?: string | undefined;
    salesKey?: string | undefined;
    createdOnInCrm?: Date;
    modifiedInCrm?: Date;
    teamMemberships: TeamMembershipDto[] | undefined;
    roleConnections: ResourceAlignmentDto[] | undefined;
    supplementalRoleConnections: SupplementalResourceAlignmentDto[] | undefined;
}

export class TeamMembershipDto implements ITeamMembershipDto {
    id?: string;
    systemUserId!: string;
    systemUser!: SystemUserDto;
    teamId!: string;
    team!: TeamDto;
    isPrimaryTeamOwner?: boolean;

    constructor(data?: ITeamMembershipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.systemUser = new SystemUserDto();
            this.team = new TeamDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.systemUserId = _data["systemUserId"];
            this.systemUser = _data["systemUser"] ? SystemUserDto.fromJS(_data["systemUser"]) : new SystemUserDto();
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamDto.fromJS(_data["team"]) : new TeamDto();
            this.isPrimaryTeamOwner = _data["isPrimaryTeamOwner"];
        }
    }

    static fromJS(data: any): TeamMembershipDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMembershipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["systemUserId"] = this.systemUserId;
        data["systemUser"] = this.systemUser ? this.systemUser.toJSON() : undefined as any;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : undefined as any;
        data["isPrimaryTeamOwner"] = this.isPrimaryTeamOwner;
        return data;
    }
}

export interface ITeamMembershipDto {
    id?: string;
    systemUserId: string;
    systemUser: SystemUserDto;
    teamId: string;
    team: TeamDto;
    isPrimaryTeamOwner?: boolean;
}

export class AssetByCategory implements IAssetByCategory {
    category!: string | undefined;
    assetsUseStates?: AssetByUseState[] | undefined;

    constructor(data?: IAssetByCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            if (Array.isArray(_data["assetsUseStates"])) {
                this.assetsUseStates = [] as any;
                for (let item of _data["assetsUseStates"])
                    this.assetsUseStates!.push(AssetByUseState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetByCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AssetByCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        if (Array.isArray(this.assetsUseStates)) {
            data["assetsUseStates"] = [];
            for (let item of this.assetsUseStates)
                data["assetsUseStates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetByCategory {
    category: string | undefined;
    assetsUseStates?: AssetByUseState[] | undefined;
}

export class AssetByUseState implements IAssetByUseState {
    useStateType!: string | undefined;
    assetsCount!: number;

    constructor(data?: IAssetByUseState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useStateType = _data["useStateType"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): AssetByUseState {
        data = typeof data === 'object' ? data : {};
        let result = new AssetByUseState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useStateType"] = this.useStateType;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface IAssetByUseState {
    useStateType: string | undefined;
    assetsCount: number;
}

export class AssetContractsResponse implements IAssetContractsResponse {
    contracts?: AssetContract[] | undefined;
    readonly totalCount?: number;

    constructor(data?: IAssetContractsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(AssetContract.fromJS(item));
            }
            (this as any).totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetContractsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContractsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IAssetContractsResponse {
    contracts?: AssetContract[] | undefined;
    totalCount?: number;
}

export class AssetEndUserDevicesSummary implements IAssetEndUserDevicesSummary {
    rebootStatus?: TitleValue[] | undefined;
    patchStatus?: TitleValue[] | undefined;
    antivirusStatus?: TitleValue[] | undefined;
    count?: number;

    constructor(data?: IAssetEndUserDevicesSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rebootStatus"])) {
                this.rebootStatus = [] as any;
                for (let item of _data["rebootStatus"])
                    this.rebootStatus!.push(TitleValue.fromJS(item));
            }
            if (Array.isArray(_data["patchStatus"])) {
                this.patchStatus = [] as any;
                for (let item of _data["patchStatus"])
                    this.patchStatus!.push(TitleValue.fromJS(item));
            }
            if (Array.isArray(_data["antivirusStatus"])) {
                this.antivirusStatus = [] as any;
                for (let item of _data["antivirusStatus"])
                    this.antivirusStatus!.push(TitleValue.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AssetEndUserDevicesSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AssetEndUserDevicesSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rebootStatus)) {
            data["rebootStatus"] = [];
            for (let item of this.rebootStatus)
                data["rebootStatus"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.patchStatus)) {
            data["patchStatus"] = [];
            for (let item of this.patchStatus)
                data["patchStatus"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.antivirusStatus)) {
            data["antivirusStatus"] = [];
            for (let item of this.antivirusStatus)
                data["antivirusStatus"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IAssetEndUserDevicesSummary {
    rebootStatus?: TitleValue[] | undefined;
    patchStatus?: TitleValue[] | undefined;
    antivirusStatus?: TitleValue[] | undefined;
    count?: number;
}

export class AssetExpiringContractsWidgetRequest implements IAssetExpiringContractsWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    contractEndDate?: Date;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;

    constructor(data?: IAssetExpiringContractsWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
        }
    }

    static fromJS(data: any): AssetExpiringContractsWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetExpiringContractsWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : undefined as any;
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        return data;
    }
}

export interface IAssetExpiringContractsWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    contractEndDate?: Date;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;
}

export class AssetExpiringContractsWidgetResponse implements IAssetExpiringContractsWidgetResponse {
    contracts?: AssetContract[] | undefined;
    readonly totalCount?: number;

    constructor(data?: IAssetExpiringContractsWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(AssetContract.fromJS(item));
            }
            (this as any).totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetExpiringContractsWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetExpiringContractsWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IAssetExpiringContractsWidgetResponse {
    contracts?: AssetContract[] | undefined;
    totalCount?: number;
}

export class AssetInventorySummary implements IAssetInventorySummary {
    totalRows!: number;
    childrenCounts!: { [key: string]: number; } | undefined;

    constructor(data?: IAssetInventorySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (_data["childrenCounts"]) {
                this.childrenCounts = {} as any;
                for (let key in _data["childrenCounts"]) {
                    if (_data["childrenCounts"].hasOwnProperty(key))
                        (this.childrenCounts as any)![key] = _data["childrenCounts"][key];
                }
            }
        }
    }

    static fromJS(data: any): AssetInventorySummary {
        data = typeof data === 'object' ? data : {};
        let result = new AssetInventorySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (this.childrenCounts) {
            data["childrenCounts"] = {};
            for (let key in this.childrenCounts) {
                if (this.childrenCounts.hasOwnProperty(key))
                    (data["childrenCounts"] as any)[key] = (this.childrenCounts as any)[key];
            }
        }
        return data;
    }
}

export interface IAssetInventorySummary {
    totalRows: number;
    childrenCounts: { [key: string]: number; } | undefined;
}

export class AssetLifecycleManagementWidgetRequest implements IAssetLifecycleManagementWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    months?: number;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;

    constructor(data?: IAssetLifecycleManagementWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.months = _data["months"];
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
        }
    }

    static fromJS(data: any): AssetLifecycleManagementWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleManagementWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["months"] = this.months;
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        return data;
    }
}

export interface IAssetLifecycleManagementWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    months?: number;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;
}

export class AssetLifecycleManagementWidgetResponseDto implements IAssetLifecycleManagementWidgetResponseDto {
    assetsGoingEndOfLife?: number;
    assetsGoingEndOfSale?: number;
    assetsGoingEndOfSoftwareMaintenance?: number;
    assetsGoingEndOfSupport?: number;

    constructor(data?: IAssetLifecycleManagementWidgetResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetsGoingEndOfLife = _data["assetsGoingEndOfLife"];
            this.assetsGoingEndOfSale = _data["assetsGoingEndOfSale"];
            this.assetsGoingEndOfSoftwareMaintenance = _data["assetsGoingEndOfSoftwareMaintenance"];
            this.assetsGoingEndOfSupport = _data["assetsGoingEndOfSupport"];
        }
    }

    static fromJS(data: any): AssetLifecycleManagementWidgetResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleManagementWidgetResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetsGoingEndOfLife"] = this.assetsGoingEndOfLife;
        data["assetsGoingEndOfSale"] = this.assetsGoingEndOfSale;
        data["assetsGoingEndOfSoftwareMaintenance"] = this.assetsGoingEndOfSoftwareMaintenance;
        data["assetsGoingEndOfSupport"] = this.assetsGoingEndOfSupport;
        return data;
    }
}

export interface IAssetLifecycleManagementWidgetResponseDto {
    assetsGoingEndOfLife?: number;
    assetsGoingEndOfSale?: number;
    assetsGoingEndOfSoftwareMaintenance?: number;
    assetsGoingEndOfSupport?: number;
}

export class AssetLifecycleResponseDto implements IAssetLifecycleResponseDto {
    summary!: AssetLifecycleSummaryDto;
    inventory!: Asset[] | undefined;

    constructor(data?: IAssetLifecycleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.summary = new AssetLifecycleSummaryDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? AssetLifecycleSummaryDto.fromJS(_data["summary"]) : new AssetLifecycleSummaryDto();
            if (Array.isArray(_data["inventory"])) {
                this.inventory = [] as any;
                for (let item of _data["inventory"])
                    this.inventory!.push(Asset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetLifecycleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        if (Array.isArray(this.inventory)) {
            data["inventory"] = [];
            for (let item of this.inventory)
                data["inventory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetLifecycleResponseDto {
    summary: AssetLifecycleSummaryDto;
    inventory: Asset[] | undefined;
}

export class AssetLocationSearchQueryDto implements IAssetLocationSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetLocationsSearchFilterDto;
    searchFilterInclude?: AssetLocationsSearchFilterDto;
    searchFilterExclude?: AssetLocationsSearchFilterDto;

    constructor(data?: IAssetLocationSearchQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? AssetLocationsSearchFilterDto.fromJS(_data["searchFilter"]) : undefined as any;
            this.searchFilterInclude = _data["searchFilterInclude"] ? AssetLocationsSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? AssetLocationsSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetLocationSearchQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationSearchQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : undefined as any;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetLocationSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    excludeSearchFilter?: boolean;
    searchFilter?: AssetLocationsSearchFilterDto;
    searchFilterInclude?: AssetLocationsSearchFilterDto;
    searchFilterExclude?: AssetLocationsSearchFilterDto;
}

export class AssetLocationsResponse implements IAssetLocationsResponse {
    assetLocations?: AssetLocationDto[] | undefined;
    totalCount?: number;

    constructor(data?: IAssetLocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assetLocations"])) {
                this.assetLocations = [] as any;
                for (let item of _data["assetLocations"])
                    this.assetLocations!.push(AssetLocationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetLocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assetLocations)) {
            data["assetLocations"] = [];
            for (let item of this.assetLocations)
                data["assetLocations"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IAssetLocationsResponse {
    assetLocations?: AssetLocationDto[] | undefined;
    totalCount?: number;
}

export class AssetManagementResponse implements IAssetManagementResponse {
    assets?: Asset[] | undefined;
    summary?: AssetInventorySummary;

    constructor(data?: IAssetManagementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(Asset.fromJS(item));
            }
            this.summary = _data["summary"] ? AssetInventorySummary.fromJS(_data["summary"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetManagementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetManagementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetManagementResponse {
    assets?: Asset[] | undefined;
    summary?: AssetInventorySummary;
}

export class AssetOverviewWidgetRequest implements IAssetOverviewWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;

    constructor(data?: IAssetOverviewWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
        }
    }

    static fromJS(data: any): AssetOverviewWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetOverviewWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        return data;
    }
}

export interface IAssetOverviewWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;
}

export class AssetOverviewWidgetResponse implements IAssetOverviewWidgetResponse {
    totalProducts!: number;
    productTypes?: AssetWidgetBaseRecord[] | undefined;
    productCategories?: AssetWidgetBaseRecord[] | undefined;
    lifecycleStates?: AssetWidgetBaseRecord[] | undefined;
    contractCoverage?: AssetWidgetBaseRecord[] | undefined;

    constructor(data?: IAssetOverviewWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProducts = _data["totalProducts"];
            if (Array.isArray(_data["productTypes"])) {
                this.productTypes = [] as any;
                for (let item of _data["productTypes"])
                    this.productTypes!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["productCategories"])) {
                this.productCategories = [] as any;
                for (let item of _data["productCategories"])
                    this.productCategories!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["lifecycleStates"])) {
                this.lifecycleStates = [] as any;
                for (let item of _data["lifecycleStates"])
                    this.lifecycleStates!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["contractCoverage"])) {
                this.contractCoverage = [] as any;
                for (let item of _data["contractCoverage"])
                    this.contractCoverage!.push(AssetWidgetBaseRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetOverviewWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetOverviewWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProducts"] = this.totalProducts;
        if (Array.isArray(this.productTypes)) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productCategories)) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lifecycleStates)) {
            data["lifecycleStates"] = [];
            for (let item of this.lifecycleStates)
                data["lifecycleStates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractCoverage)) {
            data["contractCoverage"] = [];
            for (let item of this.contractCoverage)
                data["contractCoverage"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetOverviewWidgetResponse {
    totalProducts: number;
    productTypes?: AssetWidgetBaseRecord[] | undefined;
    productCategories?: AssetWidgetBaseRecord[] | undefined;
    lifecycleStates?: AssetWidgetBaseRecord[] | undefined;
    contractCoverage?: AssetWidgetBaseRecord[] | undefined;
}

export class AssetProductCatalogResponse implements IAssetProductCatalogResponse {
    assetProductCatalog?: AssetProductCatalogDto[] | undefined;

    constructor(data?: IAssetProductCatalogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assetProductCatalog"])) {
                this.assetProductCatalog = [] as any;
                for (let item of _data["assetProductCatalog"])
                    this.assetProductCatalog!.push(AssetProductCatalogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetProductCatalogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProductCatalogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assetProductCatalog)) {
            data["assetProductCatalog"] = [];
            for (let item of this.assetProductCatalog)
                data["assetProductCatalog"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetProductCatalogResponse {
    assetProductCatalog?: AssetProductCatalogDto[] | undefined;
}

export class AssetInventorySearchFilterDto implements IAssetInventorySearchFilterDto {
    searchFor?: string | undefined;
    uniqueIdentifier?: string[] | undefined;
    parentId?: string[] | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    datasource?: string[] | undefined;
    coveredStartDate?: string[] | undefined;
    coveredEndDate?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;

    protected _discriminator: string;

    constructor(data?: IAssetInventorySearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "AssetInventorySearchFilterDto";
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["uniqueIdentifier"])) {
                this.uniqueIdentifier = [] as any;
                for (let item of _data["uniqueIdentifier"])
                    this.uniqueIdentifier!.push(item);
            }
            if (Array.isArray(_data["parentId"])) {
                this.parentId = [] as any;
                for (let item of _data["parentId"])
                    this.parentId!.push(item);
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["displayName"])) {
                this.displayName = [] as any;
                for (let item of _data["displayName"])
                    this.displayName!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["shiUseState"])) {
                this.shiUseState = [] as any;
                for (let item of _data["shiUseState"])
                    this.shiUseState!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["discoveredOnNet"])) {
                this.discoveredOnNet = [] as any;
                for (let item of _data["discoveredOnNet"])
                    this.discoveredOnNet!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
            if (Array.isArray(_data["coveredStartDate"])) {
                this.coveredStartDate = [] as any;
                for (let item of _data["coveredStartDate"])
                    this.coveredStartDate!.push(item);
            }
            if (Array.isArray(_data["coveredEndDate"])) {
                this.coveredEndDate = [] as any;
                for (let item of _data["coveredEndDate"])
                    this.coveredEndDate!.push(item);
            }
            this.coveredStartDateStart = _data["coveredStartDateStart"] ? new Date(_data["coveredStartDateStart"].toString()) : undefined as any;
            this.coveredStartDateEnd = _data["coveredStartDateEnd"] ? new Date(_data["coveredStartDateEnd"].toString()) : undefined as any;
            this.coveredEndDateStart = _data["coveredEndDateStart"] ? new Date(_data["coveredEndDateStart"].toString()) : undefined as any;
            this.coveredEndDateEnd = _data["coveredEndDateEnd"] ? new Date(_data["coveredEndDateEnd"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AssetInventorySearchFilterDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "AssetSearchFilter") {
            let result = new AssetSearchFilter();
            result.init(data);
            return result;
        }
        let result = new AssetInventorySearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.uniqueIdentifier)) {
            data["uniqueIdentifier"] = [];
            for (let item of this.uniqueIdentifier)
                data["uniqueIdentifier"].push(item);
        }
        if (Array.isArray(this.parentId)) {
            data["parentId"] = [];
            for (let item of this.parentId)
                data["parentId"].push(item);
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.displayName)) {
            data["displayName"] = [];
            for (let item of this.displayName)
                data["displayName"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.shiUseState)) {
            data["shiUseState"] = [];
            for (let item of this.shiUseState)
                data["shiUseState"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.discoveredOnNet)) {
            data["discoveredOnNet"] = [];
            for (let item of this.discoveredOnNet)
                data["discoveredOnNet"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        if (Array.isArray(this.coveredStartDate)) {
            data["coveredStartDate"] = [];
            for (let item of this.coveredStartDate)
                data["coveredStartDate"].push(item);
        }
        if (Array.isArray(this.coveredEndDate)) {
            data["coveredEndDate"] = [];
            for (let item of this.coveredEndDate)
                data["coveredEndDate"].push(item);
        }
        data["coveredStartDateStart"] = this.coveredStartDateStart ? this.coveredStartDateStart.toISOString() : undefined as any;
        data["coveredStartDateEnd"] = this.coveredStartDateEnd ? this.coveredStartDateEnd.toISOString() : undefined as any;
        data["coveredEndDateStart"] = this.coveredEndDateStart ? this.coveredEndDateStart.toISOString() : undefined as any;
        data["coveredEndDateEnd"] = this.coveredEndDateEnd ? this.coveredEndDateEnd.toISOString() : undefined as any;
        return data;
    }
}

export interface IAssetInventorySearchFilterDto {
    searchFor?: string | undefined;
    uniqueIdentifier?: string[] | undefined;
    parentId?: string[] | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    datasource?: string[] | undefined;
    coveredStartDate?: string[] | undefined;
    coveredEndDate?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
}

export class AssetSearchFilter extends AssetInventorySearchFilterDto implements IAssetSearchFilter {
    quarter?: number | undefined;
    year?: number | undefined;

    constructor(data?: IAssetSearchFilter) {
        super(data);
        this._discriminator = "AssetSearchFilter";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.quarter = _data["quarter"];
            this.year = _data["year"];
        }
    }

    static override fromJS(data: any): AssetSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AssetSearchFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quarter"] = this.quarter;
        data["year"] = this.year;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetSearchFilter extends IAssetInventorySearchFilterDto {
    quarter?: number | undefined;
    year?: number | undefined;
}

export class AssetWidgetFilterByCategoryRequest implements IAssetWidgetFilterByCategoryRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    widgetType?: AssetWidgetType;
    byCategory?: FilterByCategory;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;

    constructor(data?: IAssetWidgetFilterByCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.widgetType = _data["widgetType"];
            this.byCategory = _data["byCategory"];
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
        }
    }

    static fromJS(data: any): AssetWidgetFilterByCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetWidgetFilterByCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["widgetType"] = this.widgetType;
        data["byCategory"] = this.byCategory;
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        return data;
    }
}

export interface IAssetWidgetFilterByCategoryRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    widgetType?: AssetWidgetType;
    byCategory?: FilterByCategory;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;
}

export class AssetWidgetFilterByCategoryResponse implements IAssetWidgetFilterByCategoryResponse {
    records?: AssetWidgetBaseRecord[] | undefined;

    constructor(data?: IAssetWidgetFilterByCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(AssetWidgetBaseRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetWidgetFilterByCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetWidgetFilterByCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetWidgetFilterByCategoryResponse {
    records?: AssetWidgetBaseRecord[] | undefined;
}

export class AssetsByProductOverviewWidgetRequest implements IAssetsByProductOverviewWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;

    constructor(data?: IAssetsByProductOverviewWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
        }
    }

    static fromJS(data: any): AssetsByProductOverviewWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsByProductOverviewWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        return data;
    }
}

export interface IAssetsByProductOverviewWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;
}

export class AssetsByProductOverviewWidgetResponse implements IAssetsByProductOverviewWidgetResponse {
    totalProducts!: number;
    productTypes?: AssetWidgetBaseRecord[] | undefined;
    productCategories?: AssetWidgetBaseRecord[] | undefined;
    lifecycleStates?: AssetWidgetBaseRecord[] | undefined;

    constructor(data?: IAssetsByProductOverviewWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProducts = _data["totalProducts"];
            if (Array.isArray(_data["productTypes"])) {
                this.productTypes = [] as any;
                for (let item of _data["productTypes"])
                    this.productTypes!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["productCategories"])) {
                this.productCategories = [] as any;
                for (let item of _data["productCategories"])
                    this.productCategories!.push(AssetWidgetBaseRecord.fromJS(item));
            }
            if (Array.isArray(_data["lifecycleStates"])) {
                this.lifecycleStates = [] as any;
                for (let item of _data["lifecycleStates"])
                    this.lifecycleStates!.push(AssetWidgetBaseRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetsByProductOverviewWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsByProductOverviewWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProducts"] = this.totalProducts;
        if (Array.isArray(this.productTypes)) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productCategories)) {
            data["productCategories"] = [];
            for (let item of this.productCategories)
                data["productCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lifecycleStates)) {
            data["lifecycleStates"] = [];
            for (let item of this.lifecycleStates)
                data["lifecycleStates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetsByProductOverviewWidgetResponse {
    totalProducts: number;
    productTypes?: AssetWidgetBaseRecord[] | undefined;
    productCategories?: AssetWidgetBaseRecord[] | undefined;
    lifecycleStates?: AssetWidgetBaseRecord[] | undefined;
}

export class AssetsByUseStateWidgetRequest implements IAssetsByUseStateWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;

    constructor(data?: IAssetsByUseStateWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
        }
    }

    static fromJS(data: any): AssetsByUseStateWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsByUseStateWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        return data;
    }
}

export interface IAssetsByUseStateWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;
}

export class AssetsByUseStateWidgetResponse implements IAssetsByUseStateWidgetResponse {
    totalAssets!: number;
    assets?: AssetByCategory[] | undefined;
    useStateList!: string[] | undefined;

    constructor(data?: IAssetsByUseStateWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAssets = _data["totalAssets"];
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(AssetByCategory.fromJS(item));
            }
            if (Array.isArray(_data["useStateList"])) {
                this.useStateList = [] as any;
                for (let item of _data["useStateList"])
                    this.useStateList!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetsByUseStateWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsByUseStateWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAssets"] = this.totalAssets;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.useStateList)) {
            data["useStateList"] = [];
            for (let item of this.useStateList)
                data["useStateList"].push(item);
        }
        return data;
    }
}

export interface IAssetsByUseStateWidgetResponse {
    totalAssets: number;
    assets?: AssetByCategory[] | undefined;
    useStateList: string[] | undefined;
}

export class CoveredAssetsByProduct implements ICoveredAssetsByProduct {
    identifier?: number | undefined;
    product!: string | undefined;
    manufacturer?: string | undefined;
    assetsCount!: number;

    constructor(data?: ICoveredAssetsByProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.product = _data["product"];
            this.manufacturer = _data["manufacturer"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): CoveredAssetsByProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CoveredAssetsByProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["product"] = this.product;
        data["manufacturer"] = this.manufacturer;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface ICoveredAssetsByProduct {
    identifier?: number | undefined;
    product: string | undefined;
    manufacturer?: string | undefined;
    assetsCount: number;
}

export class CoveredAssetsByProductWidgetRequest implements ICoveredAssetsByProductWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;

    constructor(data?: ICoveredAssetsByProductWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
        }
    }

    static fromJS(data: any): CoveredAssetsByProductWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CoveredAssetsByProductWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        return data;
    }
}

export interface ICoveredAssetsByProductWidgetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    manufacturers?: string[] | undefined;
    showParentsOnly?: boolean;
}

export class CoveredAssetsByProductWidgetResponse implements ICoveredAssetsByProductWidgetResponse {
    totalCoveredAssets!: number;
    products?: CoveredAssetsByProduct[] | undefined;

    constructor(data?: ICoveredAssetsByProductWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCoveredAssets = _data["totalCoveredAssets"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CoveredAssetsByProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoveredAssetsByProductWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CoveredAssetsByProductWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCoveredAssets"] = this.totalCoveredAssets;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICoveredAssetsByProductWidgetResponse {
    totalCoveredAssets: number;
    products?: CoveredAssetsByProduct[] | undefined;
}

export class TitleValue implements ITitleValue {
    title?: string | undefined;
    value?: number;

    constructor(data?: ITitleValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TitleValue {
        data = typeof data === 'object' ? data : {};
        let result = new TitleValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["value"] = this.value;
        return data;
    }
}

export interface ITitleValue {
    title?: string | undefined;
    value?: number;
}

export class AssetContractAggregationDto implements IAssetContractAggregationDto {
    axAccountNumber!: string | undefined;
    contractVendor?: string[] | undefined;
    contractId?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    serviceLevelDescription?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    managingPartner?: string[] | undefined;
    datasource?: string[] | undefined;

    constructor(data?: IAssetContractAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["serviceLevelAgreement"])) {
                this.serviceLevelAgreement = [] as any;
                for (let item of _data["serviceLevelAgreement"])
                    this.serviceLevelAgreement!.push(item);
            }
            if (Array.isArray(_data["serviceLevelDescription"])) {
                this.serviceLevelDescription = [] as any;
                for (let item of _data["serviceLevelDescription"])
                    this.serviceLevelDescription!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetContractAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContractAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.serviceLevelAgreement)) {
            data["serviceLevelAgreement"] = [];
            for (let item of this.serviceLevelAgreement)
                data["serviceLevelAgreement"].push(item);
        }
        if (Array.isArray(this.serviceLevelDescription)) {
            data["serviceLevelDescription"] = [];
            for (let item of this.serviceLevelDescription)
                data["serviceLevelDescription"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        return data;
    }
}

export interface IAssetContractAggregationDto {
    axAccountNumber: string | undefined;
    contractVendor?: string[] | undefined;
    contractId?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    serviceLevelDescription?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    managingPartner?: string[] | undefined;
    datasource?: string[] | undefined;
}

export class AssetInventoryAggregationDto implements IAssetInventoryAggregationDto {
    axAccountNumber!: string | undefined;
    assetType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    datasource?: string[] | undefined;

    constructor(data?: IAssetInventoryAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["shiUseState"])) {
                this.shiUseState = [] as any;
                for (let item of _data["shiUseState"])
                    this.shiUseState!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["discoveredOnNet"])) {
                this.discoveredOnNet = [] as any;
                for (let item of _data["discoveredOnNet"])
                    this.discoveredOnNet!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetInventoryAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetInventoryAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.shiUseState)) {
            data["shiUseState"] = [];
            for (let item of this.shiUseState)
                data["shiUseState"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.discoveredOnNet)) {
            data["discoveredOnNet"] = [];
            for (let item of this.discoveredOnNet)
                data["discoveredOnNet"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        return data;
    }
}

export interface IAssetInventoryAggregationDto {
    axAccountNumber: string | undefined;
    assetType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    datasource?: string[] | undefined;
}

export class AssetLifecycleAggregationDto implements IAssetLifecycleAggregationDto {
    axAccountNumber!: string | undefined;
    assetType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    datasource?: string[] | undefined;

    constructor(data?: IAssetLifecycleAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["shiUseState"])) {
                this.shiUseState = [] as any;
                for (let item of _data["shiUseState"])
                    this.shiUseState!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["discoveredOnNet"])) {
                this.discoveredOnNet = [] as any;
                for (let item of _data["discoveredOnNet"])
                    this.discoveredOnNet!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetLifecycleAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.shiUseState)) {
            data["shiUseState"] = [];
            for (let item of this.shiUseState)
                data["shiUseState"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.discoveredOnNet)) {
            data["discoveredOnNet"] = [];
            for (let item of this.discoveredOnNet)
                data["discoveredOnNet"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        return data;
    }
}

export interface IAssetLifecycleAggregationDto {
    axAccountNumber: string | undefined;
    assetType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    datasource?: string[] | undefined;
}

export class AssetLocationAggregationDto implements IAssetLocationAggregationDto {
    axAccountNumber!: string | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    manufacturer?: string[] | undefined;
    datasource?: string[] | undefined;

    constructor(data?: IAssetLocationAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetLocationAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        return data;
    }
}

export interface IAssetLocationAggregationDto {
    axAccountNumber: string | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    manufacturer?: string[] | undefined;
    datasource?: string[] | undefined;
}

export class ProductCatalogAggregationDto implements IProductCatalogAggregationDto {
    accountIdentifier!: string | undefined;
    manufacturer?: string[] | undefined;
    assetType?: string[] | undefined;
    shiCategory?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    datasource?: string[] | undefined;

    constructor(data?: IProductCatalogAggregationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductCatalogAggregationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCatalogAggregationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        return data;
    }
}

export interface IProductCatalogAggregationDto {
    accountIdentifier: string | undefined;
    manufacturer?: string[] | undefined;
    assetType?: string[] | undefined;
    shiCategory?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    datasource?: string[] | undefined;
}

export class Asset implements IAsset {
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerCustomerName?: string | undefined;
    serialNumber?: string | undefined;
    managingPartner?: string | undefined;
    product?: string | undefined;
    productFamily?: string | undefined;
    productType?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    microCategory?: string | undefined;
    listPrice?: number | undefined;
    contractId?: string | undefined;
    contractType?: string | undefined;
    shiContractType?: string | undefined;
    coveredStatus?: string | undefined;
    coveredEndDate?: Date | undefined;
    coveredStartDate?: Date | undefined;
    contractVendor?: string | undefined;
    serviceLevelAgreement?: string | undefined;
    serviceLevelDescription?: string | undefined;
    shiUseState?: string | undefined;
    shiLifecycleState?: string | undefined;
    nextLifecycleState?: string | undefined;
    closeToNextState?: boolean | undefined;
    endOfLife?: Date | undefined;
    endOfSaleDate?: Date | undefined;
    endOfSaleYear?: number | undefined;
    endOfSaleQuarter?: number | undefined;
    endOfSaleInRange?: boolean | undefined;
    endOfSoftwareMaintenanceDate?: Date | undefined;
    endOfSoftwareMaintenanceYear?: number | undefined;
    endOfSoftwareMaintenanceQuarter?: number | undefined;
    endOfSoftwareMaintenanceInRange?: boolean | undefined;
    lastDateOfSupport?: Date | undefined;
    lastDateOfSupportYear?: number | undefined;
    lastDateOfSupportQuarter?: number | undefined;
    lastDateOfSupportInRange?: boolean | undefined;
    endOfVulnerabilityDate?: Date | undefined;
    endOfSupport?: Date | undefined;
    warrantyEndDate?: Date | undefined;
    warrantyType?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    locationId?: string | undefined;
    readonly siteLocation?: string | undefined;
    migrationProductInfoUrl?: string | undefined;
    migrationProductId?: string | undefined;
    shipDate?: Date | undefined;
    licensesUsed?: number | undefined;
    licensesPurchased?: number | undefined;
    licensesAvailable?: number | undefined;
    growthAllowance?: number | undefined;
    renewalDate?: Date | undefined;
    antivirusStatus?: string | undefined;
    assignedOn?: Date | undefined;
    installDate?: Date | undefined;
    lastSeenOn?: Date | undefined;
    discoveredOnNet?: string | undefined;
    networkId?: string | undefined;
    networkAddress?: string | undefined;
    assignedTo?: string | undefined;
    companyName?: string | undefined;
    contactOwner?: string | undefined;
    datasource?: string | undefined;
    department?: string | undefined;
    firmware?: string | undefined;
    lastUser?: string | undefined;
    operatingSystem?: string | undefined;
    patchStatus?: string | undefined;
    rebootStatus?: string | undefined;
    cloudPlatform?: string | undefined;
    region?: string | undefined;
    cloudAccount?: string | undefined;
    cloudAccountId?: string | undefined;
    parentAccountId?: string | undefined;
    resourceGroup?: string | undefined;
    serviceCost?: number | undefined;
    roadmapItemIds?: string[] | undefined;
    roadmaps?: RoadmapInfoDto[] | undefined;
    uniqueIdentifier?: string | undefined;
    accountIdentifier?: string | undefined;
    assetId?: string | undefined;
    parentId?: string | undefined;
    isParent?: boolean | undefined;
    displayName?: string | undefined;
    productDescription?: string | undefined;
    manufacturer?: string | undefined;
    itemQuantity?: number;
    assetType?: string | undefined;
    userLocationName?: string | undefined;
    readonly displayLocationName?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    readonly tagsString?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    ingestedOn?: Date;
    commerceSku?: string | undefined;
    nextTrueForward?: Date | undefined;
    smartAccountName?: string | undefined;
    suiteName?: string | undefined;
    trueForwardDue?: boolean | undefined;
    totalPurchased?: number | undefined;
    totalGenerated?: number | undefined;
    balance?: number | undefined;
    exceptionalGrowthThresholdExceeded?: boolean | undefined;
    healthMessage?: string | undefined;

    constructor(data?: IAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.manufacturerCustomerName = _data["manufacturerCustomerName"];
            this.serialNumber = _data["serialNumber"];
            this.managingPartner = _data["managingPartner"];
            this.product = _data["product"];
            this.productFamily = _data["productFamily"];
            this.productType = _data["productType"];
            this.shiCategory = _data["shiCategory"];
            this.subCategory = _data["subCategory"];
            this.microCategory = _data["microCategory"];
            this.listPrice = _data["listPrice"];
            this.contractId = _data["contractId"];
            this.contractType = _data["contractType"];
            this.shiContractType = _data["shiContractType"];
            this.coveredStatus = _data["coveredStatus"];
            this.coveredEndDate = _data["coveredEndDate"] ? new Date(_data["coveredEndDate"].toString()) : undefined as any;
            this.coveredStartDate = _data["coveredStartDate"] ? new Date(_data["coveredStartDate"].toString()) : undefined as any;
            this.contractVendor = _data["contractVendor"];
            this.serviceLevelAgreement = _data["serviceLevelAgreement"];
            this.serviceLevelDescription = _data["serviceLevelDescription"];
            this.shiUseState = _data["shiUseState"];
            this.shiLifecycleState = _data["shiLifecycleState"];
            this.nextLifecycleState = _data["nextLifecycleState"];
            this.closeToNextState = _data["closeToNextState"];
            this.endOfLife = _data["endOfLife"] ? new Date(_data["endOfLife"].toString()) : undefined as any;
            this.endOfSaleDate = _data["endOfSaleDate"] ? new Date(_data["endOfSaleDate"].toString()) : undefined as any;
            this.endOfSaleYear = _data["endOfSaleYear"];
            this.endOfSaleQuarter = _data["endOfSaleQuarter"];
            this.endOfSaleInRange = _data["endOfSaleInRange"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"] ? new Date(_data["endOfSoftwareMaintenanceDate"].toString()) : undefined as any;
            this.endOfSoftwareMaintenanceYear = _data["endOfSoftwareMaintenanceYear"];
            this.endOfSoftwareMaintenanceQuarter = _data["endOfSoftwareMaintenanceQuarter"];
            this.endOfSoftwareMaintenanceInRange = _data["endOfSoftwareMaintenanceInRange"];
            this.lastDateOfSupport = _data["lastDateOfSupport"] ? new Date(_data["lastDateOfSupport"].toString()) : undefined as any;
            this.lastDateOfSupportYear = _data["lastDateOfSupportYear"];
            this.lastDateOfSupportQuarter = _data["lastDateOfSupportQuarter"];
            this.lastDateOfSupportInRange = _data["lastDateOfSupportInRange"];
            this.endOfVulnerabilityDate = _data["endOfVulnerabilityDate"] ? new Date(_data["endOfVulnerabilityDate"].toString()) : undefined as any;
            this.endOfSupport = _data["endOfSupport"] ? new Date(_data["endOfSupport"].toString()) : undefined as any;
            this.warrantyEndDate = _data["warrantyEndDate"] ? new Date(_data["warrantyEndDate"].toString()) : undefined as any;
            this.warrantyType = _data["warrantyType"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationCountry = _data["locationCountry"];
            this.locationId = _data["locationId"];
            (this as any).siteLocation = _data["siteLocation"];
            this.migrationProductInfoUrl = _data["migrationProductInfoUrl"];
            this.migrationProductId = _data["migrationProductId"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
            this.licensesUsed = _data["licensesUsed"];
            this.licensesPurchased = _data["licensesPurchased"];
            this.licensesAvailable = _data["licensesAvailable"];
            this.growthAllowance = _data["growthAllowance"];
            this.renewalDate = _data["renewalDate"] ? new Date(_data["renewalDate"].toString()) : undefined as any;
            this.antivirusStatus = _data["antivirusStatus"];
            this.assignedOn = _data["assignedOn"] ? new Date(_data["assignedOn"].toString()) : undefined as any;
            this.installDate = _data["installDate"] ? new Date(_data["installDate"].toString()) : undefined as any;
            this.lastSeenOn = _data["lastSeenOn"] ? new Date(_data["lastSeenOn"].toString()) : undefined as any;
            this.discoveredOnNet = _data["discoveredOnNet"];
            this.networkId = _data["networkId"];
            this.networkAddress = _data["networkAddress"];
            this.assignedTo = _data["assignedTo"];
            this.companyName = _data["companyName"];
            this.contactOwner = _data["contactOwner"];
            this.datasource = _data["datasource"];
            this.department = _data["department"];
            this.firmware = _data["firmware"];
            this.lastUser = _data["lastUser"];
            this.operatingSystem = _data["operatingSystem"];
            this.patchStatus = _data["patchStatus"];
            this.rebootStatus = _data["rebootStatus"];
            this.cloudPlatform = _data["cloudPlatform"];
            this.region = _data["region"];
            this.cloudAccount = _data["cloudAccount"];
            this.cloudAccountId = _data["cloudAccountId"];
            this.parentAccountId = _data["parentAccountId"];
            this.resourceGroup = _data["resourceGroup"];
            this.serviceCost = _data["serviceCost"];
            if (Array.isArray(_data["roadmapItemIds"])) {
                this.roadmapItemIds = [] as any;
                for (let item of _data["roadmapItemIds"])
                    this.roadmapItemIds!.push(item);
            }
            if (Array.isArray(_data["roadmaps"])) {
                this.roadmaps = [] as any;
                for (let item of _data["roadmaps"])
                    this.roadmaps!.push(RoadmapInfoDto.fromJS(item));
            }
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.accountIdentifier = _data["accountIdentifier"];
            this.assetId = _data["assetId"];
            this.parentId = _data["parentId"];
            this.isParent = _data["isParent"];
            this.displayName = _data["displayName"];
            this.productDescription = _data["productDescription"];
            this.manufacturer = _data["manufacturer"];
            this.itemQuantity = _data["itemQuantity"];
            this.assetType = _data["assetType"];
            this.userLocationName = _data["userLocationName"];
            (this as any).displayLocationName = _data["displayLocationName"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            (this as any).tagsString = _data["tagsString"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            this.ingestedOn = _data["ingestedOn"] ? new Date(_data["ingestedOn"].toString()) : undefined as any;
            this.commerceSku = _data["commerceSku"];
            this.nextTrueForward = _data["nextTrueForward"] ? new Date(_data["nextTrueForward"].toString()) : undefined as any;
            this.smartAccountName = _data["smartAccountName"];
            this.suiteName = _data["suiteName"];
            this.trueForwardDue = _data["trueForwardDue"];
            this.totalPurchased = _data["totalPurchased"];
            this.totalGenerated = _data["totalGenerated"];
            this.balance = _data["balance"];
            this.exceptionalGrowthThresholdExceeded = _data["exceptionalGrowthThresholdExceeded"];
            this.healthMessage = _data["healthMessage"];
        }
    }

    static fromJS(data: any): Asset {
        data = typeof data === 'object' ? data : {};
        let result = new Asset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["manufacturerCustomerName"] = this.manufacturerCustomerName;
        data["serialNumber"] = this.serialNumber;
        data["managingPartner"] = this.managingPartner;
        data["product"] = this.product;
        data["productFamily"] = this.productFamily;
        data["productType"] = this.productType;
        data["shiCategory"] = this.shiCategory;
        data["subCategory"] = this.subCategory;
        data["microCategory"] = this.microCategory;
        data["listPrice"] = this.listPrice;
        data["contractId"] = this.contractId;
        data["contractType"] = this.contractType;
        data["shiContractType"] = this.shiContractType;
        data["coveredStatus"] = this.coveredStatus;
        data["coveredEndDate"] = this.coveredEndDate ? this.coveredEndDate.toISOString() : undefined as any;
        data["coveredStartDate"] = this.coveredStartDate ? this.coveredStartDate.toISOString() : undefined as any;
        data["contractVendor"] = this.contractVendor;
        data["serviceLevelAgreement"] = this.serviceLevelAgreement;
        data["serviceLevelDescription"] = this.serviceLevelDescription;
        data["shiUseState"] = this.shiUseState;
        data["shiLifecycleState"] = this.shiLifecycleState;
        data["nextLifecycleState"] = this.nextLifecycleState;
        data["closeToNextState"] = this.closeToNextState;
        data["endOfLife"] = this.endOfLife ? this.endOfLife.toISOString() : undefined as any;
        data["endOfSaleDate"] = this.endOfSaleDate ? this.endOfSaleDate.toISOString() : undefined as any;
        data["endOfSaleYear"] = this.endOfSaleYear;
        data["endOfSaleQuarter"] = this.endOfSaleQuarter;
        data["endOfSaleInRange"] = this.endOfSaleInRange;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate ? this.endOfSoftwareMaintenanceDate.toISOString() : undefined as any;
        data["endOfSoftwareMaintenanceYear"] = this.endOfSoftwareMaintenanceYear;
        data["endOfSoftwareMaintenanceQuarter"] = this.endOfSoftwareMaintenanceQuarter;
        data["endOfSoftwareMaintenanceInRange"] = this.endOfSoftwareMaintenanceInRange;
        data["lastDateOfSupport"] = this.lastDateOfSupport ? this.lastDateOfSupport.toISOString() : undefined as any;
        data["lastDateOfSupportYear"] = this.lastDateOfSupportYear;
        data["lastDateOfSupportQuarter"] = this.lastDateOfSupportQuarter;
        data["lastDateOfSupportInRange"] = this.lastDateOfSupportInRange;
        data["endOfVulnerabilityDate"] = this.endOfVulnerabilityDate ? this.endOfVulnerabilityDate.toISOString() : undefined as any;
        data["endOfSupport"] = this.endOfSupport ? this.endOfSupport.toISOString() : undefined as any;
        data["warrantyEndDate"] = this.warrantyEndDate ? this.warrantyEndDate.toISOString() : undefined as any;
        data["warrantyType"] = this.warrantyType;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationCountry"] = this.locationCountry;
        data["locationId"] = this.locationId;
        data["siteLocation"] = this.siteLocation;
        data["migrationProductInfoUrl"] = this.migrationProductInfoUrl;
        data["migrationProductId"] = this.migrationProductId;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        data["licensesUsed"] = this.licensesUsed;
        data["licensesPurchased"] = this.licensesPurchased;
        data["licensesAvailable"] = this.licensesAvailable;
        data["growthAllowance"] = this.growthAllowance;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : undefined as any;
        data["antivirusStatus"] = this.antivirusStatus;
        data["assignedOn"] = this.assignedOn ? this.assignedOn.toISOString() : undefined as any;
        data["installDate"] = this.installDate ? this.installDate.toISOString() : undefined as any;
        data["lastSeenOn"] = this.lastSeenOn ? this.lastSeenOn.toISOString() : undefined as any;
        data["discoveredOnNet"] = this.discoveredOnNet;
        data["networkId"] = this.networkId;
        data["networkAddress"] = this.networkAddress;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["contactOwner"] = this.contactOwner;
        data["datasource"] = this.datasource;
        data["department"] = this.department;
        data["firmware"] = this.firmware;
        data["lastUser"] = this.lastUser;
        data["operatingSystem"] = this.operatingSystem;
        data["patchStatus"] = this.patchStatus;
        data["rebootStatus"] = this.rebootStatus;
        data["cloudPlatform"] = this.cloudPlatform;
        data["region"] = this.region;
        data["cloudAccount"] = this.cloudAccount;
        data["cloudAccountId"] = this.cloudAccountId;
        data["parentAccountId"] = this.parentAccountId;
        data["resourceGroup"] = this.resourceGroup;
        data["serviceCost"] = this.serviceCost;
        if (Array.isArray(this.roadmapItemIds)) {
            data["roadmapItemIds"] = [];
            for (let item of this.roadmapItemIds)
                data["roadmapItemIds"].push(item);
        }
        if (Array.isArray(this.roadmaps)) {
            data["roadmaps"] = [];
            for (let item of this.roadmaps)
                data["roadmaps"].push(item ? item.toJSON() : undefined as any);
        }
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["accountIdentifier"] = this.accountIdentifier;
        data["assetId"] = this.assetId;
        data["parentId"] = this.parentId;
        data["isParent"] = this.isParent;
        data["displayName"] = this.displayName;
        data["productDescription"] = this.productDescription;
        data["manufacturer"] = this.manufacturer;
        data["itemQuantity"] = this.itemQuantity;
        data["assetType"] = this.assetType;
        data["userLocationName"] = this.userLocationName;
        data["displayLocationName"] = this.displayLocationName;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["tagsString"] = this.tagsString;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        data["ingestedOn"] = this.ingestedOn ? this.ingestedOn.toISOString() : undefined as any;
        data["commerceSku"] = this.commerceSku;
        data["nextTrueForward"] = this.nextTrueForward ? this.nextTrueForward.toISOString() : undefined as any;
        data["smartAccountName"] = this.smartAccountName;
        data["suiteName"] = this.suiteName;
        data["trueForwardDue"] = this.trueForwardDue;
        data["totalPurchased"] = this.totalPurchased;
        data["totalGenerated"] = this.totalGenerated;
        data["balance"] = this.balance;
        data["exceptionalGrowthThresholdExceeded"] = this.exceptionalGrowthThresholdExceeded;
        data["healthMessage"] = this.healthMessage;
        return data;
    }
}

export interface IAsset {
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerCustomerName?: string | undefined;
    serialNumber?: string | undefined;
    managingPartner?: string | undefined;
    product?: string | undefined;
    productFamily?: string | undefined;
    productType?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    microCategory?: string | undefined;
    listPrice?: number | undefined;
    contractId?: string | undefined;
    contractType?: string | undefined;
    shiContractType?: string | undefined;
    coveredStatus?: string | undefined;
    coveredEndDate?: Date | undefined;
    coveredStartDate?: Date | undefined;
    contractVendor?: string | undefined;
    serviceLevelAgreement?: string | undefined;
    serviceLevelDescription?: string | undefined;
    shiUseState?: string | undefined;
    shiLifecycleState?: string | undefined;
    nextLifecycleState?: string | undefined;
    closeToNextState?: boolean | undefined;
    endOfLife?: Date | undefined;
    endOfSaleDate?: Date | undefined;
    endOfSaleYear?: number | undefined;
    endOfSaleQuarter?: number | undefined;
    endOfSaleInRange?: boolean | undefined;
    endOfSoftwareMaintenanceDate?: Date | undefined;
    endOfSoftwareMaintenanceYear?: number | undefined;
    endOfSoftwareMaintenanceQuarter?: number | undefined;
    endOfSoftwareMaintenanceInRange?: boolean | undefined;
    lastDateOfSupport?: Date | undefined;
    lastDateOfSupportYear?: number | undefined;
    lastDateOfSupportQuarter?: number | undefined;
    lastDateOfSupportInRange?: boolean | undefined;
    endOfVulnerabilityDate?: Date | undefined;
    endOfSupport?: Date | undefined;
    warrantyEndDate?: Date | undefined;
    warrantyType?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    locationId?: string | undefined;
    siteLocation?: string | undefined;
    migrationProductInfoUrl?: string | undefined;
    migrationProductId?: string | undefined;
    shipDate?: Date | undefined;
    licensesUsed?: number | undefined;
    licensesPurchased?: number | undefined;
    licensesAvailable?: number | undefined;
    growthAllowance?: number | undefined;
    renewalDate?: Date | undefined;
    antivirusStatus?: string | undefined;
    assignedOn?: Date | undefined;
    installDate?: Date | undefined;
    lastSeenOn?: Date | undefined;
    discoveredOnNet?: string | undefined;
    networkId?: string | undefined;
    networkAddress?: string | undefined;
    assignedTo?: string | undefined;
    companyName?: string | undefined;
    contactOwner?: string | undefined;
    datasource?: string | undefined;
    department?: string | undefined;
    firmware?: string | undefined;
    lastUser?: string | undefined;
    operatingSystem?: string | undefined;
    patchStatus?: string | undefined;
    rebootStatus?: string | undefined;
    cloudPlatform?: string | undefined;
    region?: string | undefined;
    cloudAccount?: string | undefined;
    cloudAccountId?: string | undefined;
    parentAccountId?: string | undefined;
    resourceGroup?: string | undefined;
    serviceCost?: number | undefined;
    roadmapItemIds?: string[] | undefined;
    roadmaps?: RoadmapInfoDto[] | undefined;
    uniqueIdentifier?: string | undefined;
    accountIdentifier?: string | undefined;
    assetId?: string | undefined;
    parentId?: string | undefined;
    isParent?: boolean | undefined;
    displayName?: string | undefined;
    productDescription?: string | undefined;
    manufacturer?: string | undefined;
    itemQuantity?: number;
    assetType?: string | undefined;
    userLocationName?: string | undefined;
    displayLocationName?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    tagsString?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    ingestedOn?: Date;
    commerceSku?: string | undefined;
    nextTrueForward?: Date | undefined;
    smartAccountName?: string | undefined;
    suiteName?: string | undefined;
    trueForwardDue?: boolean | undefined;
    totalPurchased?: number | undefined;
    totalGenerated?: number | undefined;
    balance?: number | undefined;
    exceptionalGrowthThresholdExceeded?: boolean | undefined;
    healthMessage?: string | undefined;
}

export class AssetContract implements IAssetContract {
    shiOneAssetType?: ShiOneAssetType;
    contractId?: string | undefined;
    contractVendor?: string | undefined;
    shiContractType?: string[] | undefined;
    slaItems?: AssetSlaItem[] | undefined;
    totalAssets?: number;
    earliestCoveredEndDate?: string | undefined;
    coveredStartDate?: string | undefined;
    coveredEndDate?: string | undefined;
    coveredStatus?: string | undefined;
    managedBy?: string | undefined;
    subType?: string | undefined;
    readonly shiContractTypeString?: string | undefined;
    readonly slaItemsString?: string | undefined;

    constructor(data?: IAssetContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiOneAssetType = _data["shiOneAssetType"];
            this.contractId = _data["contractId"];
            this.contractVendor = _data["contractVendor"];
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["slaItems"])) {
                this.slaItems = [] as any;
                for (let item of _data["slaItems"])
                    this.slaItems!.push(AssetSlaItem.fromJS(item));
            }
            this.totalAssets = _data["totalAssets"];
            this.earliestCoveredEndDate = _data["earliestCoveredEndDate"];
            this.coveredStartDate = _data["coveredStartDate"];
            this.coveredEndDate = _data["coveredEndDate"];
            this.coveredStatus = _data["coveredStatus"];
            this.managedBy = _data["managedBy"];
            this.subType = _data["subType"];
            (this as any).shiContractTypeString = _data["shiContractTypeString"];
            (this as any).slaItemsString = _data["slaItemsString"];
        }
    }

    static fromJS(data: any): AssetContract {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiOneAssetType"] = this.shiOneAssetType;
        data["contractId"] = this.contractId;
        data["contractVendor"] = this.contractVendor;
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.slaItems)) {
            data["slaItems"] = [];
            for (let item of this.slaItems)
                data["slaItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalAssets"] = this.totalAssets;
        data["earliestCoveredEndDate"] = this.earliestCoveredEndDate;
        data["coveredStartDate"] = this.coveredStartDate;
        data["coveredEndDate"] = this.coveredEndDate;
        data["coveredStatus"] = this.coveredStatus;
        data["managedBy"] = this.managedBy;
        data["subType"] = this.subType;
        data["shiContractTypeString"] = this.shiContractTypeString;
        data["slaItemsString"] = this.slaItemsString;
        return data;
    }
}

export interface IAssetContract {
    shiOneAssetType?: ShiOneAssetType;
    contractId?: string | undefined;
    contractVendor?: string | undefined;
    shiContractType?: string[] | undefined;
    slaItems?: AssetSlaItem[] | undefined;
    totalAssets?: number;
    earliestCoveredEndDate?: string | undefined;
    coveredStartDate?: string | undefined;
    coveredEndDate?: string | undefined;
    coveredStatus?: string | undefined;
    managedBy?: string | undefined;
    subType?: string | undefined;
    shiContractTypeString?: string | undefined;
    slaItemsString?: string | undefined;
}

export class AssetSlaItem implements IAssetSlaItem {
    contractType?: string | undefined;
    serviceLevelAgreement?: string | undefined;

    constructor(data?: IAssetSlaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractType = _data["contractType"];
            this.serviceLevelAgreement = _data["serviceLevelAgreement"];
        }
    }

    static fromJS(data: any): AssetSlaItem {
        data = typeof data === 'object' ? data : {};
        let result = new AssetSlaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractType"] = this.contractType;
        data["serviceLevelAgreement"] = this.serviceLevelAgreement;
        return data;
    }
}

export interface IAssetSlaItem {
    contractType?: string | undefined;
    serviceLevelAgreement?: string | undefined;
}

export class AssetWidgetBaseRecord implements IAssetWidgetBaseRecord {
    category?: string | undefined;
    assetsCount?: number;

    constructor(data?: IAssetWidgetBaseRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): AssetWidgetBaseRecord {
        data = typeof data === 'object' ? data : {};
        let result = new AssetWidgetBaseRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface IAssetWidgetBaseRecord {
    category?: string | undefined;
    assetsCount?: number;
}

export class AssetContractSearchQueryDto implements IAssetContractSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    searchFilter!: AssetContractsSearchFilterDto;
    searchFilterInclude?: AssetContractsSearchFilterDto;
    searchFilterExclude?: AssetContractsSearchFilterDto;
    limit?: number;
    scrollSearch?: boolean;

    constructor(data?: IAssetContractSearchQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.searchFilter = new AssetContractsSearchFilterDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? AssetContractsSearchFilterDto.fromJS(_data["searchFilter"]) : new AssetContractsSearchFilterDto();
            this.searchFilterInclude = _data["searchFilterInclude"] ? AssetContractsSearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? AssetContractsSearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
            this.limit = _data["limit"];
            this.scrollSearch = _data["scrollSearch"];
        }
    }

    static fromJS(data: any): AssetContractSearchQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContractSearchQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : undefined as any;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        data["limit"] = this.limit;
        data["scrollSearch"] = this.scrollSearch;
        return data;
    }
}

export interface IAssetContractSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    searchFilter: AssetContractsSearchFilterDto;
    searchFilterInclude?: AssetContractsSearchFilterDto;
    searchFilterExclude?: AssetContractsSearchFilterDto;
    limit?: number;
    scrollSearch?: boolean;
}

export class AssetEndUserDevicesResponse implements IAssetEndUserDevicesResponse {
    devices?: Asset[] | undefined;
    summaryData?: AssetEndUserDevicesSummary;

    constructor(data?: IAssetEndUserDevicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Asset.fromJS(item));
            }
            this.summaryData = _data["summaryData"] ? AssetEndUserDevicesSummary.fromJS(_data["summaryData"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetEndUserDevicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssetEndUserDevicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item ? item.toJSON() : undefined as any);
        }
        data["summaryData"] = this.summaryData ? this.summaryData.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetEndUserDevicesResponse {
    devices?: Asset[] | undefined;
    summaryData?: AssetEndUserDevicesSummary;
}

export class AssetLifecycleSummaryDto implements IAssetLifecycleSummaryDto {
    quarterlyExpiration?: AssetQuarterlyExpirationFilterDto[] | undefined;
    totalParentRows?: number;

    constructor(data?: IAssetLifecycleSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["quarterlyExpiration"])) {
                this.quarterlyExpiration = [] as any;
                for (let item of _data["quarterlyExpiration"])
                    this.quarterlyExpiration!.push(AssetQuarterlyExpirationFilterDto.fromJS(item));
            }
            this.totalParentRows = _data["totalParentRows"];
        }
    }

    static fromJS(data: any): AssetLifecycleSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quarterlyExpiration)) {
            data["quarterlyExpiration"] = [];
            for (let item of this.quarterlyExpiration)
                data["quarterlyExpiration"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalParentRows"] = this.totalParentRows;
        return data;
    }
}

export interface IAssetLifecycleSummaryDto {
    quarterlyExpiration?: AssetQuarterlyExpirationFilterDto[] | undefined;
    totalParentRows?: number;
}

export class AssetLocationDto implements IAssetLocationDto {
    locationId?: string | undefined;
    locationName?: string | undefined;
    userLocationName?: string | undefined;
    readonly displayLocationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    manufacturer?: string | undefined;
    assetsCount?: number;
    isStockroom?: boolean;

    constructor(data?: IAssetLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.userLocationName = _data["userLocationName"];
            (this as any).displayLocationName = _data["displayLocationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationCountry = _data["locationCountry"];
            this.manufacturer = _data["manufacturer"];
            this.assetsCount = _data["assetsCount"];
            this.isStockroom = _data["isStockroom"];
        }
    }

    static fromJS(data: any): AssetLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["userLocationName"] = this.userLocationName;
        data["displayLocationName"] = this.displayLocationName;
        data["locationAddress"] = this.locationAddress;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationCountry"] = this.locationCountry;
        data["manufacturer"] = this.manufacturer;
        data["assetsCount"] = this.assetsCount;
        data["isStockroom"] = this.isStockroom;
        return data;
    }
}

export interface IAssetLocationDto {
    locationId?: string | undefined;
    locationName?: string | undefined;
    userLocationName?: string | undefined;
    displayLocationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    manufacturer?: string | undefined;
    assetsCount?: number;
    isStockroom?: boolean;
}

export class AssetManagementSearchQueryDto implements IAssetManagementSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    assetType?: ShiOneAssetType;
    sortCriteria?: ElasticSortCriteria;
    searchFilter?: AssetInventorySearchFilterDto | undefined;
    searchFilterInclude?: AssetInventorySearchFilterDto | undefined;
    searchFilterExclude?: AssetInventorySearchFilterDto | undefined;
    scrollSearch?: boolean;

    constructor(data?: IAssetManagementSearchQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.showParentsOnly = _data["showParentsOnly"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.assetType = _data["assetType"];
            this.sortCriteria = _data["sortCriteria"] ? ElasticSortCriteria.fromJS(_data["sortCriteria"]) : undefined as any;
            this.searchFilter = _data["searchFilter"] ? AssetInventorySearchFilterDto.fromJS(_data["searchFilter"]) : undefined as any;
            this.searchFilterInclude = _data["searchFilterInclude"] ? AssetInventorySearchFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? AssetInventorySearchFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
            this.scrollSearch = _data["scrollSearch"];
        }
    }

    static fromJS(data: any): AssetManagementSearchQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetManagementSearchQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["showParentsOnly"] = this.showParentsOnly;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["assetType"] = this.assetType;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : undefined as any;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : undefined as any;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        data["scrollSearch"] = this.scrollSearch;
        return data;
    }
}

export interface IAssetManagementSearchQueryDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean;
    assetType?: ShiOneAssetType;
    sortCriteria?: ElasticSortCriteria;
    searchFilter?: AssetInventorySearchFilterDto | undefined;
    searchFilterInclude?: AssetInventorySearchFilterDto | undefined;
    searchFilterExclude?: AssetInventorySearchFilterDto | undefined;
    scrollSearch?: boolean;
}

export class AssetProductCatalogDto implements IAssetProductCatalogDto {
    product!: string | undefined;
    id?: string | undefined;
    productDescription?: string | undefined;
    manufacturer?: string | undefined;
    assetType?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    assetsCount?: number;
    locationsCount?: number | undefined;
    contractsCount?: number | undefined;
    listPrice?: number | undefined;
    minCoveredEndDate?: string | undefined;
    shiLifecycleState?: string | undefined;
    endOfLife?: string | undefined;
    endOfSaleDate?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    endOfSupport?: string | undefined;
    readonly descriptionString?: string | undefined;
    readonly manufacturerString?: string | undefined;
    readonly assetTypeString?: string | undefined;
    readonly categoryString?: string | undefined;

    constructor(data?: IAssetProductCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"];
            this.id = _data["id"];
            this.productDescription = _data["productDescription"];
            this.manufacturer = _data["manufacturer"];
            this.assetType = _data["assetType"];
            this.shiCategory = _data["shiCategory"];
            this.subCategory = _data["subCategory"];
            this.assetsCount = _data["assetsCount"];
            this.locationsCount = _data["locationsCount"];
            this.contractsCount = _data["contractsCount"];
            this.listPrice = _data["listPrice"];
            this.minCoveredEndDate = _data["minCoveredEndDate"];
            this.shiLifecycleState = _data["shiLifecycleState"];
            this.endOfLife = _data["endOfLife"];
            this.endOfSaleDate = _data["endOfSaleDate"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.lastDateOfSupport = _data["lastDateOfSupport"];
            this.endOfSupport = _data["endOfSupport"];
            (this as any).descriptionString = _data["descriptionString"];
            (this as any).manufacturerString = _data["manufacturerString"];
            (this as any).assetTypeString = _data["assetTypeString"];
            (this as any).categoryString = _data["categoryString"];
        }
    }

    static fromJS(data: any): AssetProductCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProductCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["id"] = this.id;
        data["productDescription"] = this.productDescription;
        data["manufacturer"] = this.manufacturer;
        data["assetType"] = this.assetType;
        data["shiCategory"] = this.shiCategory;
        data["subCategory"] = this.subCategory;
        data["assetsCount"] = this.assetsCount;
        data["locationsCount"] = this.locationsCount;
        data["contractsCount"] = this.contractsCount;
        data["listPrice"] = this.listPrice;
        data["minCoveredEndDate"] = this.minCoveredEndDate;
        data["shiLifecycleState"] = this.shiLifecycleState;
        data["endOfLife"] = this.endOfLife;
        data["endOfSaleDate"] = this.endOfSaleDate;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["lastDateOfSupport"] = this.lastDateOfSupport;
        data["endOfSupport"] = this.endOfSupport;
        data["descriptionString"] = this.descriptionString;
        data["manufacturerString"] = this.manufacturerString;
        data["assetTypeString"] = this.assetTypeString;
        data["categoryString"] = this.categoryString;
        return data;
    }
}

export interface IAssetProductCatalogDto {
    product: string | undefined;
    id?: string | undefined;
    productDescription?: string | undefined;
    manufacturer?: string | undefined;
    assetType?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    assetsCount?: number;
    locationsCount?: number | undefined;
    contractsCount?: number | undefined;
    listPrice?: number | undefined;
    minCoveredEndDate?: string | undefined;
    shiLifecycleState?: string | undefined;
    endOfLife?: string | undefined;
    endOfSaleDate?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    endOfSupport?: string | undefined;
    descriptionString?: string | undefined;
    manufacturerString?: string | undefined;
    assetTypeString?: string | undefined;
    categoryString?: string | undefined;
}

export class AssetContractsSearchFilterDto implements IAssetContractsSearchFilterDto {
    searchFor?: string | undefined;
    manufacturer?: string[] | undefined;
    contractVendor?: string[] | undefined;
    contractId?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    serviceLevelDescription?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    managingPartner?: string[] | undefined;
    assetType?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
    product?: string[] | undefined;
    datasource?: string[] | undefined;

    constructor(data?: IAssetContractsSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["serviceLevelAgreement"])) {
                this.serviceLevelAgreement = [] as any;
                for (let item of _data["serviceLevelAgreement"])
                    this.serviceLevelAgreement!.push(item);
            }
            if (Array.isArray(_data["serviceLevelDescription"])) {
                this.serviceLevelDescription = [] as any;
                for (let item of _data["serviceLevelDescription"])
                    this.serviceLevelDescription!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            this.coveredStartDateStart = _data["coveredStartDateStart"] ? new Date(_data["coveredStartDateStart"].toString()) : undefined as any;
            this.coveredStartDateEnd = _data["coveredStartDateEnd"] ? new Date(_data["coveredStartDateEnd"].toString()) : undefined as any;
            this.coveredEndDateStart = _data["coveredEndDateStart"] ? new Date(_data["coveredEndDateStart"].toString()) : undefined as any;
            this.coveredEndDateEnd = _data["coveredEndDateEnd"] ? new Date(_data["coveredEndDateEnd"].toString()) : undefined as any;
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetContractsSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetContractsSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.serviceLevelAgreement)) {
            data["serviceLevelAgreement"] = [];
            for (let item of this.serviceLevelAgreement)
                data["serviceLevelAgreement"].push(item);
        }
        if (Array.isArray(this.serviceLevelDescription)) {
            data["serviceLevelDescription"] = [];
            for (let item of this.serviceLevelDescription)
                data["serviceLevelDescription"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        data["coveredStartDateStart"] = this.coveredStartDateStart ? this.coveredStartDateStart.toISOString() : undefined as any;
        data["coveredStartDateEnd"] = this.coveredStartDateEnd ? this.coveredStartDateEnd.toISOString() : undefined as any;
        data["coveredEndDateStart"] = this.coveredEndDateStart ? this.coveredEndDateStart.toISOString() : undefined as any;
        data["coveredEndDateEnd"] = this.coveredEndDateEnd ? this.coveredEndDateEnd.toISOString() : undefined as any;
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        return data;
    }
}

export interface IAssetContractsSearchFilterDto {
    searchFor?: string | undefined;
    manufacturer?: string[] | undefined;
    contractVendor?: string[] | undefined;
    contractId?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    serviceLevelDescription?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    managingPartner?: string[] | undefined;
    assetType?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
    product?: string[] | undefined;
    datasource?: string[] | undefined;
}

export class AssetLifecycleSearchFilterDto implements IAssetLifecycleSearchFilterDto {
    searchFor?: string | undefined;
    identifier?: string | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    datasource?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
    endOfSaleDateStart?: Date | undefined;
    endOfSaleDateEnd?: Date | undefined;
    endOfSoftwareMaintenanceDateStart?: Date | undefined;
    endOfSoftwareMaintenanceDateEnd?: Date | undefined;
    lastDateOfSupportStart?: Date | undefined;
    lastDateOfSupportEnd?: Date | undefined;
    shipDateStart?: Date | undefined;
    shipDateEnd?: Date | undefined;
    quarter?: number | undefined;
    year?: number | undefined;

    constructor(data?: IAssetLifecycleSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["displayName"])) {
                this.displayName = [] as any;
                for (let item of _data["displayName"])
                    this.displayName!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["managingPartner"])) {
                this.managingPartner = [] as any;
                for (let item of _data["managingPartner"])
                    this.managingPartner!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["shiUseState"])) {
                this.shiUseState = [] as any;
                for (let item of _data["shiUseState"])
                    this.shiUseState!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["contractId"])) {
                this.contractId = [] as any;
                for (let item of _data["contractId"])
                    this.contractId!.push(item);
            }
            if (Array.isArray(_data["shiContractType"])) {
                this.shiContractType = [] as any;
                for (let item of _data["shiContractType"])
                    this.shiContractType!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["contractVendor"])) {
                this.contractVendor = [] as any;
                for (let item of _data["contractVendor"])
                    this.contractVendor!.push(item);
            }
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["discoveredOnNet"])) {
                this.discoveredOnNet = [] as any;
                for (let item of _data["discoveredOnNet"])
                    this.discoveredOnNet!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
            this.coveredStartDateStart = _data["coveredStartDateStart"] ? new Date(_data["coveredStartDateStart"].toString()) : undefined as any;
            this.coveredStartDateEnd = _data["coveredStartDateEnd"] ? new Date(_data["coveredStartDateEnd"].toString()) : undefined as any;
            this.coveredEndDateStart = _data["coveredEndDateStart"] ? new Date(_data["coveredEndDateStart"].toString()) : undefined as any;
            this.coveredEndDateEnd = _data["coveredEndDateEnd"] ? new Date(_data["coveredEndDateEnd"].toString()) : undefined as any;
            this.endOfSaleDateStart = _data["endOfSaleDateStart"] ? new Date(_data["endOfSaleDateStart"].toString()) : undefined as any;
            this.endOfSaleDateEnd = _data["endOfSaleDateEnd"] ? new Date(_data["endOfSaleDateEnd"].toString()) : undefined as any;
            this.endOfSoftwareMaintenanceDateStart = _data["endOfSoftwareMaintenanceDateStart"] ? new Date(_data["endOfSoftwareMaintenanceDateStart"].toString()) : undefined as any;
            this.endOfSoftwareMaintenanceDateEnd = _data["endOfSoftwareMaintenanceDateEnd"] ? new Date(_data["endOfSoftwareMaintenanceDateEnd"].toString()) : undefined as any;
            this.lastDateOfSupportStart = _data["lastDateOfSupportStart"] ? new Date(_data["lastDateOfSupportStart"].toString()) : undefined as any;
            this.lastDateOfSupportEnd = _data["lastDateOfSupportEnd"] ? new Date(_data["lastDateOfSupportEnd"].toString()) : undefined as any;
            this.shipDateStart = _data["shipDateStart"] ? new Date(_data["shipDateStart"].toString()) : undefined as any;
            this.shipDateEnd = _data["shipDateEnd"] ? new Date(_data["shipDateEnd"].toString()) : undefined as any;
            this.quarter = _data["quarter"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): AssetLifecycleSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLifecycleSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.displayName)) {
            data["displayName"] = [];
            for (let item of this.displayName)
                data["displayName"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.managingPartner)) {
            data["managingPartner"] = [];
            for (let item of this.managingPartner)
                data["managingPartner"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.shiUseState)) {
            data["shiUseState"] = [];
            for (let item of this.shiUseState)
                data["shiUseState"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.contractId)) {
            data["contractId"] = [];
            for (let item of this.contractId)
                data["contractId"].push(item);
        }
        if (Array.isArray(this.shiContractType)) {
            data["shiContractType"] = [];
            for (let item of this.shiContractType)
                data["shiContractType"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.contractVendor)) {
            data["contractVendor"] = [];
            for (let item of this.contractVendor)
                data["contractVendor"].push(item);
        }
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.discoveredOnNet)) {
            data["discoveredOnNet"] = [];
            for (let item of this.discoveredOnNet)
                data["discoveredOnNet"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        data["coveredStartDateStart"] = this.coveredStartDateStart ? this.coveredStartDateStart.toISOString() : undefined as any;
        data["coveredStartDateEnd"] = this.coveredStartDateEnd ? this.coveredStartDateEnd.toISOString() : undefined as any;
        data["coveredEndDateStart"] = this.coveredEndDateStart ? this.coveredEndDateStart.toISOString() : undefined as any;
        data["coveredEndDateEnd"] = this.coveredEndDateEnd ? this.coveredEndDateEnd.toISOString() : undefined as any;
        data["endOfSaleDateStart"] = this.endOfSaleDateStart ? this.endOfSaleDateStart.toISOString() : undefined as any;
        data["endOfSaleDateEnd"] = this.endOfSaleDateEnd ? this.endOfSaleDateEnd.toISOString() : undefined as any;
        data["endOfSoftwareMaintenanceDateStart"] = this.endOfSoftwareMaintenanceDateStart ? this.endOfSoftwareMaintenanceDateStart.toISOString() : undefined as any;
        data["endOfSoftwareMaintenanceDateEnd"] = this.endOfSoftwareMaintenanceDateEnd ? this.endOfSoftwareMaintenanceDateEnd.toISOString() : undefined as any;
        data["lastDateOfSupportStart"] = this.lastDateOfSupportStart ? this.lastDateOfSupportStart.toISOString() : undefined as any;
        data["lastDateOfSupportEnd"] = this.lastDateOfSupportEnd ? this.lastDateOfSupportEnd.toISOString() : undefined as any;
        data["shipDateStart"] = this.shipDateStart ? this.shipDateStart.toISOString() : undefined as any;
        data["shipDateEnd"] = this.shipDateEnd ? this.shipDateEnd.toISOString() : undefined as any;
        data["quarter"] = this.quarter;
        data["year"] = this.year;
        return data;
    }
}

export interface IAssetLifecycleSearchFilterDto {
    searchFor?: string | undefined;
    identifier?: string | undefined;
    assetType?: string[] | undefined;
    displayName?: string[] | undefined;
    manufacturer?: string[] | undefined;
    managingPartner?: string[] | undefined;
    product?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    shiUseState?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    contractId?: string[] | undefined;
    shiContractType?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    contractVendor?: string[] | undefined;
    displayLocationName?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    discoveredOnNet?: string[] | undefined;
    tags?: string[] | undefined;
    datasource?: string[] | undefined;
    coveredStartDateStart?: Date | undefined;
    coveredStartDateEnd?: Date | undefined;
    coveredEndDateStart?: Date | undefined;
    coveredEndDateEnd?: Date | undefined;
    endOfSaleDateStart?: Date | undefined;
    endOfSaleDateEnd?: Date | undefined;
    endOfSoftwareMaintenanceDateStart?: Date | undefined;
    endOfSoftwareMaintenanceDateEnd?: Date | undefined;
    lastDateOfSupportStart?: Date | undefined;
    lastDateOfSupportEnd?: Date | undefined;
    shipDateStart?: Date | undefined;
    shipDateEnd?: Date | undefined;
    quarter?: number | undefined;
    year?: number | undefined;
}

export class AssetLocationsSearchFilterDto implements IAssetLocationsSearchFilterDto {
    searchFor?: string | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    product?: string[] | undefined;
    manufacturer?: string[] | undefined;
    datasource?: string[] | undefined;
    assetType?: string[] | undefined;

    constructor(data?: IAssetLocationsSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["displayLocationName"])) {
                this.displayLocationName = [] as any;
                for (let item of _data["displayLocationName"])
                    this.displayLocationName!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetLocationsSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationsSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.displayLocationName)) {
            data["displayLocationName"] = [];
            for (let item of this.displayLocationName)
                data["displayLocationName"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        return data;
    }
}

export interface IAssetLocationsSearchFilterDto {
    searchFor?: string | undefined;
    displayLocationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationState?: string[] | undefined;
    locationCountry?: string[] | undefined;
    product?: string[] | undefined;
    manufacturer?: string[] | undefined;
    datasource?: string[] | undefined;
    assetType?: string[] | undefined;
}

export class AssetProductSearchFilterDto implements IAssetProductSearchFilterDto {
    searchFor?: string | undefined;
    product?: string[] | undefined;
    assetType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    shiCategory?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    datasource?: string[] | undefined;
    endOfSoftwareMaintenanceDate?: string[] | undefined;
    endOfSoftwareMaintenanceDateStart?: Date | undefined;
    endOfSoftwareMaintenanceDateEnd?: Date | undefined;
    lastDateOfSupport?: string[] | undefined;
    lastDateOfSupportStart?: Date | undefined;
    lastDateOfSupportEnd?: Date | undefined;

    constructor(data?: IAssetProductSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["manufacturer"])) {
                this.manufacturer = [] as any;
                for (let item of _data["manufacturer"])
                    this.manufacturer!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["shiLifecycleState"])) {
                this.shiLifecycleState = [] as any;
                for (let item of _data["shiLifecycleState"])
                    this.shiLifecycleState!.push(item);
            }
            if (Array.isArray(_data["datasource"])) {
                this.datasource = [] as any;
                for (let item of _data["datasource"])
                    this.datasource!.push(item);
            }
            if (Array.isArray(_data["endOfSoftwareMaintenanceDate"])) {
                this.endOfSoftwareMaintenanceDate = [] as any;
                for (let item of _data["endOfSoftwareMaintenanceDate"])
                    this.endOfSoftwareMaintenanceDate!.push(item);
            }
            this.endOfSoftwareMaintenanceDateStart = _data["endOfSoftwareMaintenanceDateStart"] ? new Date(_data["endOfSoftwareMaintenanceDateStart"].toString()) : undefined as any;
            this.endOfSoftwareMaintenanceDateEnd = _data["endOfSoftwareMaintenanceDateEnd"] ? new Date(_data["endOfSoftwareMaintenanceDateEnd"].toString()) : undefined as any;
            if (Array.isArray(_data["lastDateOfSupport"])) {
                this.lastDateOfSupport = [] as any;
                for (let item of _data["lastDateOfSupport"])
                    this.lastDateOfSupport!.push(item);
            }
            this.lastDateOfSupportStart = _data["lastDateOfSupportStart"] ? new Date(_data["lastDateOfSupportStart"].toString()) : undefined as any;
            this.lastDateOfSupportEnd = _data["lastDateOfSupportEnd"] ? new Date(_data["lastDateOfSupportEnd"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AssetProductSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProductSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.manufacturer)) {
            data["manufacturer"] = [];
            for (let item of this.manufacturer)
                data["manufacturer"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.shiLifecycleState)) {
            data["shiLifecycleState"] = [];
            for (let item of this.shiLifecycleState)
                data["shiLifecycleState"].push(item);
        }
        if (Array.isArray(this.datasource)) {
            data["datasource"] = [];
            for (let item of this.datasource)
                data["datasource"].push(item);
        }
        if (Array.isArray(this.endOfSoftwareMaintenanceDate)) {
            data["endOfSoftwareMaintenanceDate"] = [];
            for (let item of this.endOfSoftwareMaintenanceDate)
                data["endOfSoftwareMaintenanceDate"].push(item);
        }
        data["endOfSoftwareMaintenanceDateStart"] = this.endOfSoftwareMaintenanceDateStart ? this.endOfSoftwareMaintenanceDateStart.toISOString() : undefined as any;
        data["endOfSoftwareMaintenanceDateEnd"] = this.endOfSoftwareMaintenanceDateEnd ? this.endOfSoftwareMaintenanceDateEnd.toISOString() : undefined as any;
        if (Array.isArray(this.lastDateOfSupport)) {
            data["lastDateOfSupport"] = [];
            for (let item of this.lastDateOfSupport)
                data["lastDateOfSupport"].push(item);
        }
        data["lastDateOfSupportStart"] = this.lastDateOfSupportStart ? this.lastDateOfSupportStart.toISOString() : undefined as any;
        data["lastDateOfSupportEnd"] = this.lastDateOfSupportEnd ? this.lastDateOfSupportEnd.toISOString() : undefined as any;
        return data;
    }
}

export interface IAssetProductSearchFilterDto {
    searchFor?: string | undefined;
    product?: string[] | undefined;
    assetType?: string[] | undefined;
    manufacturer?: string[] | undefined;
    shiCategory?: string[] | undefined;
    shiLifecycleState?: string[] | undefined;
    datasource?: string[] | undefined;
    endOfSoftwareMaintenanceDate?: string[] | undefined;
    endOfSoftwareMaintenanceDateStart?: Date | undefined;
    endOfSoftwareMaintenanceDateEnd?: Date | undefined;
    lastDateOfSupport?: string[] | undefined;
    lastDateOfSupportStart?: Date | undefined;
    lastDateOfSupportEnd?: Date | undefined;
}

export class AssetQuarterlyExpirationFilterDto implements IAssetQuarterlyExpirationFilterDto {
    endOfSale?: number;
    endOfSoftwareMaintenanceDate?: number;
    lastDateOfSupport?: number;
    total?: number;
    year?: number;
    quarter?: number;

    constructor(data?: IAssetQuarterlyExpirationFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endOfSale = _data["endOfSale"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.lastDateOfSupport = _data["lastDateOfSupport"];
            this.total = _data["total"];
            this.year = _data["year"];
            this.quarter = _data["quarter"];
        }
    }

    static fromJS(data: any): AssetQuarterlyExpirationFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetQuarterlyExpirationFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endOfSale"] = this.endOfSale;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["lastDateOfSupport"] = this.lastDateOfSupport;
        data["total"] = this.total;
        data["year"] = this.year;
        data["quarter"] = this.quarter;
        return data;
    }
}

export interface IAssetQuarterlyExpirationFilterDto {
    endOfSale?: number;
    endOfSoftwareMaintenanceDate?: number;
    lastDateOfSupport?: number;
    total?: number;
    year?: number;
    quarter?: number;
}

export enum ShiOneAssetType {
    All = "All",
    Meraki = "Meraki",
    Cisco = "Cisco",
    ManuallyManaged = "ManuallyManaged",
    CiscoEnterprise = "CiscoEnterprise",
    CiscoSubscription = "CiscoSubscription",
    DattoRmm = "DattoRmm",
    Iba = "Iba",
    Unknown = "Unknown",
}

export enum AssetWidgetType {
    Asset = "Asset",
    Product = "Product",
}

export enum FilterByCategory {
    ByType = "ByType",
    ByCategory = "ByCategory",
    ByLifecycleState = "ByLifecycleState",
    ByContractCoverage = "ByContractCoverage",
}

export class ChangeDetail implements IChangeDetail {
    key!: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;

    constructor(data?: IChangeDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): ChangeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IChangeDetail {
    key: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;
}

export class ClaimDto implements IClaimDto {
    claimType?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): ClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

export interface IClaimDto {
    claimType?: string | undefined;
    claimValue?: string | undefined;
}

export class GetCurrentMonthCloudConsumptionResponse implements IGetCurrentMonthCloudConsumptionResponse {
    currentCost?: number | undefined;
    averageDailyCost?: number | undefined;
    projectedCost?: number | undefined;

    constructor(data?: IGetCurrentMonthCloudConsumptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentCost = _data["currentCost"];
            this.averageDailyCost = _data["averageDailyCost"];
            this.projectedCost = _data["projectedCost"];
        }
    }

    static fromJS(data: any): GetCurrentMonthCloudConsumptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentMonthCloudConsumptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentCost"] = this.currentCost;
        data["averageDailyCost"] = this.averageDailyCost;
        data["projectedCost"] = this.projectedCost;
        return data;
    }
}

export interface IGetCurrentMonthCloudConsumptionResponse {
    currentCost?: number | undefined;
    averageDailyCost?: number | undefined;
    projectedCost?: number | undefined;
}

export class AffectedResourceDto implements IAffectedResourceDto {
    resourceId!: string | undefined;
    resourceType!: string | undefined;
    resourceName!: string | undefined;

    constructor(data?: IAffectedResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.resourceType = _data["resourceType"];
            this.resourceName = _data["resourceName"];
        }
    }

    static fromJS(data: any): AffectedResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffectedResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["resourceType"] = this.resourceType;
        data["resourceName"] = this.resourceName;
        return data;
    }
}

export interface IAffectedResourceDto {
    resourceId: string | undefined;
    resourceType: string | undefined;
    resourceName: string | undefined;
}

export class AffectedSubscriptionDto implements IAffectedSubscriptionDto {
    subscriptionId!: string | undefined;
    affectedResources?: AffectedResourceDto[] | undefined;

    constructor(data?: IAffectedSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            if (Array.isArray(_data["affectedResources"])) {
                this.affectedResources = [] as any;
                for (let item of _data["affectedResources"])
                    this.affectedResources!.push(AffectedResourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AffectedSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffectedSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        if (Array.isArray(this.affectedResources)) {
            data["affectedResources"] = [];
            for (let item of this.affectedResources)
                data["affectedResources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAffectedSubscriptionDto {
    subscriptionId: string | undefined;
    affectedResources?: AffectedResourceDto[] | undefined;
}

export class AzureRecommendationSummaryDto implements IAzureRecommendationSummaryDto {
    recommendationTypeId!: string | undefined;
    category!: string | undefined;
    impact!: string | undefined;
    problem!: string | undefined;
    solution!: string | undefined;
    impactedField!: string | undefined;
    affectedSubscriptions?: AffectedSubscriptionDto[] | undefined;
    totalAffectedSubscriptions?: number;
    totalAffectedResources?: number;
    accountId?: number;
    isLinkedToRoadmap?: boolean;
    roadmapName?: string | undefined;

    constructor(data?: IAzureRecommendationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendationTypeId = _data["recommendationTypeId"];
            this.category = _data["category"];
            this.impact = _data["impact"];
            this.problem = _data["problem"];
            this.solution = _data["solution"];
            this.impactedField = _data["impactedField"];
            if (Array.isArray(_data["affectedSubscriptions"])) {
                this.affectedSubscriptions = [] as any;
                for (let item of _data["affectedSubscriptions"])
                    this.affectedSubscriptions!.push(AffectedSubscriptionDto.fromJS(item));
            }
            this.totalAffectedSubscriptions = _data["totalAffectedSubscriptions"];
            this.totalAffectedResources = _data["totalAffectedResources"];
            this.accountId = _data["accountId"];
            this.isLinkedToRoadmap = _data["isLinkedToRoadmap"];
            this.roadmapName = _data["roadmapName"];
        }
    }

    static fromJS(data: any): AzureRecommendationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureRecommendationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendationTypeId"] = this.recommendationTypeId;
        data["category"] = this.category;
        data["impact"] = this.impact;
        data["problem"] = this.problem;
        data["solution"] = this.solution;
        data["impactedField"] = this.impactedField;
        if (Array.isArray(this.affectedSubscriptions)) {
            data["affectedSubscriptions"] = [];
            for (let item of this.affectedSubscriptions)
                data["affectedSubscriptions"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalAffectedSubscriptions"] = this.totalAffectedSubscriptions;
        data["totalAffectedResources"] = this.totalAffectedResources;
        data["accountId"] = this.accountId;
        data["isLinkedToRoadmap"] = this.isLinkedToRoadmap;
        data["roadmapName"] = this.roadmapName;
        return data;
    }
}

export interface IAzureRecommendationSummaryDto {
    recommendationTypeId: string | undefined;
    category: string | undefined;
    impact: string | undefined;
    problem: string | undefined;
    solution: string | undefined;
    impactedField: string | undefined;
    affectedSubscriptions?: AffectedSubscriptionDto[] | undefined;
    totalAffectedSubscriptions?: number;
    totalAffectedResources?: number;
    accountId?: number;
    isLinkedToRoadmap?: boolean;
    roadmapName?: string | undefined;
}

export class AzureRecommendationsSummaryResponseDto implements IAzureRecommendationsSummaryResponseDto {
    recommendations?: AzureRecommendationSummaryDto[] | undefined;
    totalRecommendationTypes?: number;
    totalAffectedSubscriptions?: number;
    totalAffectedResources?: number;
    recommendationsByCategory?: { [key: string]: number; } | undefined;
    recommendationsByImpact?: { [key: string]: number; } | undefined;

    constructor(data?: IAzureRecommendationsSummaryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["recommendations"])
                    this.recommendations!.push(AzureRecommendationSummaryDto.fromJS(item));
            }
            this.totalRecommendationTypes = _data["totalRecommendationTypes"];
            this.totalAffectedSubscriptions = _data["totalAffectedSubscriptions"];
            this.totalAffectedResources = _data["totalAffectedResources"];
            if (_data["recommendationsByCategory"]) {
                this.recommendationsByCategory = {} as any;
                for (let key in _data["recommendationsByCategory"]) {
                    if (_data["recommendationsByCategory"].hasOwnProperty(key))
                        (this.recommendationsByCategory as any)![key] = _data["recommendationsByCategory"][key];
                }
            }
            if (_data["recommendationsByImpact"]) {
                this.recommendationsByImpact = {} as any;
                for (let key in _data["recommendationsByImpact"]) {
                    if (_data["recommendationsByImpact"].hasOwnProperty(key))
                        (this.recommendationsByImpact as any)![key] = _data["recommendationsByImpact"][key];
                }
            }
        }
    }

    static fromJS(data: any): AzureRecommendationsSummaryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureRecommendationsSummaryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recommendations)) {
            data["recommendations"] = [];
            for (let item of this.recommendations)
                data["recommendations"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecommendationTypes"] = this.totalRecommendationTypes;
        data["totalAffectedSubscriptions"] = this.totalAffectedSubscriptions;
        data["totalAffectedResources"] = this.totalAffectedResources;
        if (this.recommendationsByCategory) {
            data["recommendationsByCategory"] = {};
            for (let key in this.recommendationsByCategory) {
                if (this.recommendationsByCategory.hasOwnProperty(key))
                    (data["recommendationsByCategory"] as any)[key] = (this.recommendationsByCategory as any)[key];
            }
        }
        if (this.recommendationsByImpact) {
            data["recommendationsByImpact"] = {};
            for (let key in this.recommendationsByImpact) {
                if (this.recommendationsByImpact.hasOwnProperty(key))
                    (data["recommendationsByImpact"] as any)[key] = (this.recommendationsByImpact as any)[key];
            }
        }
        return data;
    }
}

export interface IAzureRecommendationsSummaryResponseDto {
    recommendations?: AzureRecommendationSummaryDto[] | undefined;
    totalRecommendationTypes?: number;
    totalAffectedSubscriptions?: number;
    totalAffectedResources?: number;
    recommendationsByCategory?: { [key: string]: number; } | undefined;
    recommendationsByImpact?: { [key: string]: number; } | undefined;
}

export class CloudSubscriptionExportRequest implements ICloudSubscriptionExportRequest {
    rows?: CloudSubscriptionExportRow[] | undefined;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;

    constructor(data?: ICloudSubscriptionExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CloudSubscriptionExportRow.fromJS(item));
            }
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CloudSubscriptionExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloudSubscriptionExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICloudSubscriptionExportRequest {
    rows?: CloudSubscriptionExportRow[] | undefined;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
}

export class CloudSubscriptionExportRow implements ICloudSubscriptionExportRow {
    billingAccount?: string | undefined;
    cloudSubscription?: string | undefined;
    type?: string | undefined;
    cloudProvider?: string | undefined;
    consumption?: string | undefined;
    costCenter?: string | undefined;
    renewalDate?: string | undefined;
    shiSupport?: string | undefined;
    providerSupport?: string | undefined;
    ownerId?: string | undefined;
    created?: string | undefined;

    constructor(data?: ICloudSubscriptionExportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingAccount = _data["billingAccount"];
            this.cloudSubscription = _data["cloudSubscription"];
            this.type = _data["type"];
            this.cloudProvider = _data["cloudProvider"];
            this.consumption = _data["consumption"];
            this.costCenter = _data["costCenter"];
            this.renewalDate = _data["renewalDate"];
            this.shiSupport = _data["shiSupport"];
            this.providerSupport = _data["providerSupport"];
            this.ownerId = _data["ownerId"];
            this.created = _data["created"];
        }
    }

    static fromJS(data: any): CloudSubscriptionExportRow {
        data = typeof data === 'object' ? data : {};
        let result = new CloudSubscriptionExportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingAccount"] = this.billingAccount;
        data["cloudSubscription"] = this.cloudSubscription;
        data["type"] = this.type;
        data["cloudProvider"] = this.cloudProvider;
        data["consumption"] = this.consumption;
        data["costCenter"] = this.costCenter;
        data["renewalDate"] = this.renewalDate;
        data["shiSupport"] = this.shiSupport;
        data["providerSupport"] = this.providerSupport;
        data["ownerId"] = this.ownerId;
        data["created"] = this.created;
        return data;
    }
}

export interface ICloudSubscriptionExportRow {
    billingAccount?: string | undefined;
    cloudSubscription?: string | undefined;
    type?: string | undefined;
    cloudProvider?: string | undefined;
    consumption?: string | undefined;
    costCenter?: string | undefined;
    renewalDate?: string | undefined;
    shiSupport?: string | undefined;
    providerSupport?: string | undefined;
    ownerId?: string | undefined;
    created?: string | undefined;
}

export class AxAccountOption implements IAxAccountOption {
    axNumber?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IAxAccountOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axNumber = _data["axNumber"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AxAccountOption {
        data = typeof data === 'object' ? data : {};
        let result = new AxAccountOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axNumber"] = this.axNumber;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAxAccountOption {
    axNumber?: string | undefined;
    displayName?: string | undefined;
}

export class ChangeHistory implements IChangeHistory {
    activity!: ChangeHistoryEntry[] | undefined;
    actors!: ChangeHistoryActorEntity[] | undefined;
    changedKeys!: string[] | undefined;

    constructor(data?: IChangeHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activity"])) {
                this.activity = [] as any;
                for (let item of _data["activity"])
                    this.activity!.push(ChangeHistoryEntry.fromJS(item));
            }
            if (Array.isArray(_data["actors"])) {
                this.actors = [] as any;
                for (let item of _data["actors"])
                    this.actors!.push(ChangeHistoryActorEntity.fromJS(item));
            }
            if (Array.isArray(_data["changedKeys"])) {
                this.changedKeys = [] as any;
                for (let item of _data["changedKeys"])
                    this.changedKeys!.push(item);
            }
        }
    }

    static fromJS(data: any): ChangeHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activity)) {
            data["activity"] = [];
            for (let item of this.activity)
                data["activity"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.actors)) {
            data["actors"] = [];
            for (let item of this.actors)
                data["actors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.changedKeys)) {
            data["changedKeys"] = [];
            for (let item of this.changedKeys)
                data["changedKeys"].push(item);
        }
        return data;
    }
}

export interface IChangeHistory {
    activity: ChangeHistoryEntry[] | undefined;
    actors: ChangeHistoryActorEntity[] | undefined;
    changedKeys: string[] | undefined;
}

export class ChangeHistoryActor implements IChangeHistoryActor {
    uri!: string | undefined;
    actor!: ChangeHistoryActorEntity;
    as?: ChangeHistoryActorEntity;

    constructor(data?: IChangeHistoryActor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.actor = new ChangeHistoryActorEntity();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.actor = _data["actor"] ? ChangeHistoryActorEntity.fromJS(_data["actor"]) : new ChangeHistoryActorEntity();
            this.as = _data["as"] ? ChangeHistoryActorEntity.fromJS(_data["as"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChangeHistoryActor {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeHistoryActor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["actor"] = this.actor ? this.actor.toJSON() : undefined as any;
        data["as"] = this.as ? this.as.toJSON() : undefined as any;
        return data;
    }
}

export interface IChangeHistoryActor {
    uri: string | undefined;
    actor: ChangeHistoryActorEntity;
    as?: ChangeHistoryActorEntity;
}

export class ChangeHistoryActorEntity implements IChangeHistoryActorEntity {
    uri!: string | undefined;
    uriProtocol!: string | undefined;
    uriValue!: string | undefined;
    displayName?: string | undefined;
    sortName?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IChangeHistoryActorEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.uriProtocol = _data["uriProtocol"];
            this.uriValue = _data["uriValue"];
            this.displayName = _data["displayName"];
            this.sortName = _data["sortName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ChangeHistoryActorEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeHistoryActorEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["uriProtocol"] = this.uriProtocol;
        data["uriValue"] = this.uriValue;
        data["displayName"] = this.displayName;
        data["sortName"] = this.sortName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IChangeHistoryActorEntity {
    uri: string | undefined;
    uriProtocol: string | undefined;
    uriValue: string | undefined;
    displayName?: string | undefined;
    sortName?: string | undefined;
    emailAddress?: string | undefined;
}

export class ChangeHistoryEntry implements IChangeHistoryEntry {
    id!: string | undefined;
    changedBy!: ChangeHistoryActor;
    changedAt?: Date;
    change!: ChangeDetail;

    constructor(data?: IChangeHistoryEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.changedBy = new ChangeHistoryActor();
            this.change = new ChangeDetail();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.changedBy = _data["changedBy"] ? ChangeHistoryActor.fromJS(_data["changedBy"]) : new ChangeHistoryActor();
            this.changedAt = _data["changedAt"] ? new Date(_data["changedAt"].toString()) : undefined as any;
            this.change = _data["change"] ? ChangeDetail.fromJS(_data["change"]) : new ChangeDetail();
        }
    }

    static fromJS(data: any): ChangeHistoryEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeHistoryEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["changedBy"] = this.changedBy ? this.changedBy.toJSON() : undefined as any;
        data["changedAt"] = this.changedAt ? this.changedAt.toISOString() : undefined as any;
        data["change"] = this.change ? this.change.toJSON() : undefined as any;
        return data;
    }
}

export interface IChangeHistoryEntry {
    id: string | undefined;
    changedBy: ChangeHistoryActor;
    changedAt?: Date;
    change: ChangeDetail;
}

export enum CustomerIdType {
    AxNumber = "AxNumber",
    AutotaskAccountId = "AutotaskAccountId",
    CrmGuid = "CrmGuid",
}

export class IncludeExcludeFilterCategory implements IIncludeExcludeFilterCategory {
    id?: string | undefined;
    label?: string | undefined;
    type?: IncludeExcludeFilterCategoryType;
    options?: IncludeExcludeFilterOption[] | undefined;

    constructor(data?: IIncludeExcludeFilterCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.type = _data["type"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(IncludeExcludeFilterOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncludeExcludeFilterCategory {
        data = typeof data === 'object' ? data : {};
        let result = new IncludeExcludeFilterCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["type"] = this.type;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIncludeExcludeFilterCategory {
    id?: string | undefined;
    label?: string | undefined;
    type?: IncludeExcludeFilterCategoryType;
    options?: IncludeExcludeFilterOption[] | undefined;
}

export enum IncludeExcludeFilterCategoryType {
    Checkbox = "checkbox",
}

export class IncludeExcludeFilterOption implements IIncludeExcludeFilterOption {
    item?: string | undefined;
    checked?: boolean;
    categoryId?: string | undefined;
    label?: string | undefined;
    subItems?: IncludeExcludeFilterOption[] | undefined;

    constructor(data?: IIncludeExcludeFilterOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"];
            this.checked = _data["checked"];
            this.categoryId = _data["categoryId"];
            this.label = _data["label"];
            if (Array.isArray(_data["subItems"])) {
                this.subItems = [] as any;
                for (let item of _data["subItems"])
                    this.subItems!.push(IncludeExcludeFilterOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncludeExcludeFilterOption {
        data = typeof data === 'object' ? data : {};
        let result = new IncludeExcludeFilterOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item;
        data["checked"] = this.checked;
        data["categoryId"] = this.categoryId;
        data["label"] = this.label;
        if (Array.isArray(this.subItems)) {
            data["subItems"] = [];
            for (let item of this.subItems)
                data["subItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIncludeExcludeFilterOption {
    item?: string | undefined;
    checked?: boolean;
    categoryId?: string | undefined;
    label?: string | undefined;
    subItems?: IncludeExcludeFilterOption[] | undefined;
}

export class FilterOption implements IFilterOption {
    accessor?: string | undefined;
    value?: string | undefined;

    constructor(data?: IFilterOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessor = _data["accessor"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FilterOption {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessor"] = this.accessor;
        data["value"] = this.value;
        return data;
    }
}

export interface IFilterOption {
    accessor?: string | undefined;
    value?: string | undefined;
}

export class FilterOptionValues implements IFilterOptionValues {
    displayName?: string | undefined;
    values?: string[] | undefined;
    additionalOptions?: FilterOptionValues[] | undefined;

    constructor(data?: IFilterOptionValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["additionalOptions"])) {
                this.additionalOptions = [] as any;
                for (let item of _data["additionalOptions"])
                    this.additionalOptions!.push(FilterOptionValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterOptionValues {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOptionValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.additionalOptions)) {
            data["additionalOptions"] = [];
            for (let item of this.additionalOptions)
                data["additionalOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterOptionValues {
    displayName?: string | undefined;
    values?: string[] | undefined;
    additionalOptions?: FilterOptionValues[] | undefined;
}

export class QuerySortOption implements IQuerySortOption {
    column?: string | undefined;
    descending?: boolean;

    constructor(data?: IQuerySortOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            this.descending = _data["descending"];
        }
    }

    static fromJS(data: any): QuerySortOption {
        data = typeof data === 'object' ? data : {};
        let result = new QuerySortOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        data["descending"] = this.descending;
        return data;
    }
}

export interface IQuerySortOption {
    column?: string | undefined;
    descending?: boolean;
}

export class SearchFilter implements ISearchFilter {
    searchTerm?: string | undefined;
    filters?: FilterOption[] | undefined;
    excludeFilters?: FilterOption[] | undefined;

    protected _discriminator: string;

    constructor(data?: ISearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "SearchFilter";
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterOption.fromJS(item));
            }
            if (Array.isArray(_data["excludeFilters"])) {
                this.excludeFilters = [] as any;
                for (let item of _data["excludeFilters"])
                    this.excludeFilters!.push(FilterOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchFilter {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "PaginatedQuery") {
            let result = new PaginatedQuery();
            result.init(data);
            return result;
        }
        let result = new SearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.excludeFilters)) {
            data["excludeFilters"] = [];
            for (let item of this.excludeFilters)
                data["excludeFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchFilter {
    searchTerm?: string | undefined;
    filters?: FilterOption[] | undefined;
    excludeFilters?: FilterOption[] | undefined;
}

export class FilterOptionsDto implements IFilterOptionsDto {
    options?: { [key: string]: FilterOptionValues; } | undefined;

    constructor(data?: IFilterOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["options"]) {
                this.options = {} as any;
                for (let key in _data["options"]) {
                    if (_data["options"].hasOwnProperty(key))
                        (this.options as any)![key] = _data["options"][key] ? FilterOptionValues.fromJS(_data["options"][key]) : new FilterOptionValues();
                }
            }
        }
    }

    static fromJS(data: any): FilterOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.options) {
            data["options"] = {};
            for (let key in this.options) {
                if (this.options.hasOwnProperty(key))
                    (data["options"] as any)[key] = this.options[key] ? this.options[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IFilterOptionsDto {
    options?: { [key: string]: FilterOptionValues; } | undefined;
}

export class IncludeExcludeSearchFilter_1OfAwsReservationSearchFilter implements IIncludeExcludeSearchFilter_1OfAwsReservationSearchFilter {
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: AwsReservationSearchFilter;
    searchFilterExclude?: AwsReservationSearchFilter;

    protected _discriminator: string;

    constructor(data?: IIncludeExcludeSearchFilter_1OfAwsReservationSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "IncludeExcludeSearchFilter`1";
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? AwsReservationSearchFilter.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? AwsReservationSearchFilter.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): IncludeExcludeSearchFilter_1OfAwsReservationSearchFilter {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "AwsReservationSearchRequest") {
            let result = new AwsReservationSearchRequest();
            result.init(data);
            return result;
        }
        let result = new IncludeExcludeSearchFilter_1OfAwsReservationSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IIncludeExcludeSearchFilter_1OfAwsReservationSearchFilter {
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: AwsReservationSearchFilter;
    searchFilterExclude?: AwsReservationSearchFilter;
}

export class IncludeExcludeSearchFilter_1OfAwsRightsizingSearchFilter implements IIncludeExcludeSearchFilter_1OfAwsRightsizingSearchFilter {
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: AwsRightsizingSearchFilter;
    searchFilterExclude?: AwsRightsizingSearchFilter;

    protected _discriminator: string;

    constructor(data?: IIncludeExcludeSearchFilter_1OfAwsRightsizingSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "IncludeExcludeSearchFilter`1";
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? AwsRightsizingSearchFilter.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? AwsRightsizingSearchFilter.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): IncludeExcludeSearchFilter_1OfAwsRightsizingSearchFilter {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "AwsRightsizingSearchRequest") {
            let result = new AwsRightsizingSearchRequest();
            result.init(data);
            return result;
        }
        let result = new IncludeExcludeSearchFilter_1OfAwsRightsizingSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IIncludeExcludeSearchFilter_1OfAwsRightsizingSearchFilter {
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: AwsRightsizingSearchFilter;
    searchFilterExclude?: AwsRightsizingSearchFilter;
}

export class PaginatedIncludeExcludeSearchFilter_1OfDictionary_2OfStringAndList_1OfString implements IPaginatedIncludeExcludeSearchFilter_1OfDictionary_2OfStringAndList_1OfString {
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: { [key: string]: string[]; } | undefined;
    searchFilterExclude?: { [key: string]: string[]; } | undefined;

    protected _discriminator: string;

    constructor(data?: IPaginatedIncludeExcludeSearchFilter_1OfDictionary_2OfStringAndList_1OfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PaginatedIncludeExcludeSearchFilter`1";
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortByColumn = _data["sortByColumn"];
            this.isDescending = _data["isDescending"];
            this.afterKey = _data["afterKey"];
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            if (_data["searchFilterInclude"]) {
                this.searchFilterInclude = {} as any;
                for (let key in _data["searchFilterInclude"]) {
                    if (_data["searchFilterInclude"].hasOwnProperty(key))
                        (this.searchFilterInclude as any)![key] = _data["searchFilterInclude"][key];
                }
            }
            if (_data["searchFilterExclude"]) {
                this.searchFilterExclude = {} as any;
                for (let key in _data["searchFilterExclude"]) {
                    if (_data["searchFilterExclude"].hasOwnProperty(key))
                        (this.searchFilterExclude as any)![key] = _data["searchFilterExclude"][key];
                }
            }
        }
    }

    static fromJS(data: any): PaginatedIncludeExcludeSearchFilter_1OfDictionary_2OfStringAndList_1OfString {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "PaginatedFilterQuery") {
            let result = new PaginatedFilterQuery();
            result.init(data);
            return result;
        }
        let result = new PaginatedIncludeExcludeSearchFilter_1OfDictionary_2OfStringAndList_1OfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortByColumn"] = this.sortByColumn;
        data["isDescending"] = this.isDescending;
        data["afterKey"] = this.afterKey;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        if (this.searchFilterInclude) {
            data["searchFilterInclude"] = {};
            for (let key in this.searchFilterInclude) {
                if (this.searchFilterInclude.hasOwnProperty(key))
                    (data["searchFilterInclude"] as any)[key] = (this.searchFilterInclude as any)[key];
            }
        }
        if (this.searchFilterExclude) {
            data["searchFilterExclude"] = {};
            for (let key in this.searchFilterExclude) {
                if (this.searchFilterExclude.hasOwnProperty(key))
                    (data["searchFilterExclude"] as any)[key] = (this.searchFilterExclude as any)[key];
            }
        }
        return data;
    }
}

export interface IPaginatedIncludeExcludeSearchFilter_1OfDictionary_2OfStringAndList_1OfString {
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: { [key: string]: string[]; } | undefined;
    searchFilterExclude?: { [key: string]: string[]; } | undefined;
}

export class PaginatedFilterQuery extends PaginatedIncludeExcludeSearchFilter_1OfDictionary_2OfStringAndList_1OfString implements IPaginatedFilterQuery {

    constructor(data?: IPaginatedFilterQuery) {
        super(data);
        this._discriminator = "PaginatedFilterQuery";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PaginatedFilterQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedFilterQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedFilterQuery extends IPaginatedIncludeExcludeSearchFilter_1OfDictionary_2OfStringAndList_1OfString {
}

export class PaginatedIncludeExcludeSearchFilter_1OfMessageCenterArticlesPicklist implements IPaginatedIncludeExcludeSearchFilter_1OfMessageCenterArticlesPicklist {
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: MessageCenterArticlesPicklist;
    searchFilterExclude?: MessageCenterArticlesPicklist;

    protected _discriminator: string;

    constructor(data?: IPaginatedIncludeExcludeSearchFilter_1OfMessageCenterArticlesPicklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "PaginatedIncludeExcludeSearchFilter`1";
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortByColumn = _data["sortByColumn"];
            this.isDescending = _data["isDescending"];
            this.afterKey = _data["afterKey"];
            this.searchString = _data["searchString"];
            this.excludeSearchString = _data["excludeSearchString"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? MessageCenterArticlesPicklist.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? MessageCenterArticlesPicklist.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): PaginatedIncludeExcludeSearchFilter_1OfMessageCenterArticlesPicklist {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "MessageCenterQuery") {
            let result = new MessageCenterQuery();
            result.init(data);
            return result;
        }
        let result = new PaginatedIncludeExcludeSearchFilter_1OfMessageCenterArticlesPicklist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortByColumn"] = this.sortByColumn;
        data["isDescending"] = this.isDescending;
        data["afterKey"] = this.afterKey;
        data["searchString"] = this.searchString;
        data["excludeSearchString"] = this.excludeSearchString;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IPaginatedIncludeExcludeSearchFilter_1OfMessageCenterArticlesPicklist {
    page?: number;
    pageSize?: number;
    sortByColumn?: string | undefined;
    isDescending?: boolean | undefined;
    afterKey?: string | undefined;
    searchString?: string | undefined;
    excludeSearchString?: boolean;
    searchFilterInclude?: MessageCenterArticlesPicklist;
    searchFilterExclude?: MessageCenterArticlesPicklist;
}

export class PaginatedQuery extends SearchFilter implements IPaginatedQuery {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IPaginatedQuery) {
        super(data);
        this._discriminator = "PaginatedQuery";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): PaginatedQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedQuery extends ISearchFilter {
    pageNumber?: number;
    pageSize?: number;
}

export class PaginatedResultDto_1OfCustomerTenantSearchResultDto implements IPaginatedResultDto_1OfCustomerTenantSearchResultDto {
    items?: CustomerTenantSearchResultDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfCustomerTenantSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerTenantSearchResultDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfCustomerTenantSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfCustomerTenantSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfCustomerTenantSearchResultDto {
    items?: CustomerTenantSearchResultDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfCombinedWarehouseOrderItemDto implements IPaginatedResultDto_1OfCombinedWarehouseOrderItemDto {
    items?: CombinedWarehouseOrderItemDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfCombinedWarehouseOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CombinedWarehouseOrderItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfCombinedWarehouseOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfCombinedWarehouseOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfCombinedWarehouseOrderItemDto {
    items?: CombinedWarehouseOrderItemDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfCxUserAccountDto implements IPaginatedResultDto_1OfCxUserAccountDto {
    items?: CxUserAccountDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfCxUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CxUserAccountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfCxUserAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfCxUserAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfCxUserAccountDto {
    items?: CxUserAccountDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfTenantAdminUserDto implements IPaginatedResultDto_1OfTenantAdminUserDto {
    items?: TenantAdminUserDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfTenantAdminUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantAdminUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfTenantAdminUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfTenantAdminUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfTenantAdminUserDto {
    items?: TenantAdminUserDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfInvoiceSummaryDto implements IPaginatedResultDto_1OfInvoiceSummaryDto {
    items?: InvoiceSummaryDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfInvoiceSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InvoiceSummaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfInvoiceSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfInvoiceSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfInvoiceSummaryDto {
    items?: InvoiceSummaryDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfOrderSummaryDto implements IPaginatedResultDto_1OfOrderSummaryDto {
    items?: OrderSummaryDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfOrderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderSummaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfOrderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfOrderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfOrderSummaryDto {
    items?: OrderSummaryDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfRecommendationDto implements IPaginatedResultDto_1OfRecommendationDto {
    items?: RecommendationDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfRecommendationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RecommendationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfRecommendationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfRecommendationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfRecommendationDto {
    items?: RecommendationDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfServiceCatalogDto implements IPaginatedResultDto_1OfServiceCatalogDto {
    items?: ServiceCatalogDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfServiceCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceCatalogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfServiceCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfServiceCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfServiceCatalogDto {
    items?: ServiceCatalogDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PaginatedResultDto_1OfArticleDto implements IPaginatedResultDto_1OfArticleDto {
    items?: ArticleDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    readonly totalPages?: number;

    constructor(data?: IPaginatedResultDto_1OfArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArticleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResultDto_1OfArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultDto_1OfArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IPaginatedResultDto_1OfArticleDto {
    items?: ArticleDto[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class ContractReport implements IContractReport {
    accountId?: number;
    expireIn30?: number;
    expireIn60?: number;
    expireIn90?: number;
    expireOver90?: number;
    contractTypeStats?: ContractTypeStats[] | undefined;

    constructor(data?: IContractReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.expireIn30 = _data["expireIn30"];
            this.expireIn60 = _data["expireIn60"];
            this.expireIn90 = _data["expireIn90"];
            this.expireOver90 = _data["expireOver90"];
            if (Array.isArray(_data["contractTypeStats"])) {
                this.contractTypeStats = [] as any;
                for (let item of _data["contractTypeStats"])
                    this.contractTypeStats!.push(ContractTypeStats.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractReport {
        data = typeof data === 'object' ? data : {};
        let result = new ContractReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["expireIn30"] = this.expireIn30;
        data["expireIn60"] = this.expireIn60;
        data["expireIn90"] = this.expireIn90;
        data["expireOver90"] = this.expireOver90;
        if (Array.isArray(this.contractTypeStats)) {
            data["contractTypeStats"] = [];
            for (let item of this.contractTypeStats)
                data["contractTypeStats"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContractReport {
    accountId?: number;
    expireIn30?: number;
    expireIn60?: number;
    expireIn90?: number;
    expireOver90?: number;
    contractTypeStats?: ContractTypeStats[] | undefined;
}

export class ContractTypeStats implements IContractTypeStats {
    counted?: number;
    contractCategory?: number;
    contractType?: number;

    constructor(data?: IContractTypeStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counted = _data["counted"];
            this.contractCategory = _data["contractCategory"];
            this.contractType = _data["contractType"];
        }
    }

    static fromJS(data: any): ContractTypeStats {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counted"] = this.counted;
        data["contractCategory"] = this.contractCategory;
        data["contractType"] = this.contractType;
        return data;
    }
}

export interface IContractTypeStats {
    counted?: number;
    contractCategory?: number;
    contractType?: number;
}

export class ContractSlaDto implements IContractSlaDto {
    id?: number | undefined;
    contractCategory?: number;
    contractType?: string | undefined;
    serviceLevelAgreementID?: number;
    ticketCategoryMappings?: TicketCategoryMappingDto[] | undefined;

    constructor(data?: IContractSlaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractCategory = _data["contractCategory"];
            this.contractType = _data["contractType"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            if (Array.isArray(_data["ticketCategoryMappings"])) {
                this.ticketCategoryMappings = [] as any;
                for (let item of _data["ticketCategoryMappings"])
                    this.ticketCategoryMappings!.push(TicketCategoryMappingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractSlaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSlaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractCategory"] = this.contractCategory;
        data["contractType"] = this.contractType;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        if (Array.isArray(this.ticketCategoryMappings)) {
            data["ticketCategoryMappings"] = [];
            for (let item of this.ticketCategoryMappings)
                data["ticketCategoryMappings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContractSlaDto {
    id?: number | undefined;
    contractCategory?: number;
    contractType?: string | undefined;
    serviceLevelAgreementID?: number;
    ticketCategoryMappings?: TicketCategoryMappingDto[] | undefined;
}

export class TeamTicketCategoryMappingDto2 implements ITeamTicketCategoryMappingDto2 {
    teamId?: number;
    ticketCategoryMappingId?: number;
    contractId?: number;
    enabledIssueType!: string | undefined;

    constructor(data?: ITeamTicketCategoryMappingDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.ticketCategoryMappingId = _data["ticketCategoryMappingId"];
            this.contractId = _data["contractId"];
            this.enabledIssueType = _data["enabledIssueType"];
        }
    }

    static fromJS(data: any): TeamTicketCategoryMappingDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new TeamTicketCategoryMappingDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["ticketCategoryMappingId"] = this.ticketCategoryMappingId;
        data["contractId"] = this.contractId;
        data["enabledIssueType"] = this.enabledIssueType;
        return data;
    }
}

export interface ITeamTicketCategoryMappingDto2 {
    teamId?: number;
    ticketCategoryMappingId?: number;
    contractId?: number;
    enabledIssueType: string | undefined;
}

export class TicketCategoryMappingDto implements ITicketCategoryMappingDto {
    id?: number | undefined;
    contractSLAId?: number;
    ticketCategoryId?: number;
    listOfValidIssueTypes!: number[] | undefined;
    teamTicketCategoryMappings?: TeamTicketCategoryMappingDto2[] | undefined;

    constructor(data?: ITicketCategoryMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractSLAId = _data["contractSLAId"];
            this.ticketCategoryId = _data["ticketCategoryId"];
            if (Array.isArray(_data["listOfValidIssueTypes"])) {
                this.listOfValidIssueTypes = [] as any;
                for (let item of _data["listOfValidIssueTypes"])
                    this.listOfValidIssueTypes!.push(item);
            }
            if (Array.isArray(_data["teamTicketCategoryMappings"])) {
                this.teamTicketCategoryMappings = [] as any;
                for (let item of _data["teamTicketCategoryMappings"])
                    this.teamTicketCategoryMappings!.push(TeamTicketCategoryMappingDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketCategoryMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCategoryMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractSLAId"] = this.contractSLAId;
        data["ticketCategoryId"] = this.ticketCategoryId;
        if (Array.isArray(this.listOfValidIssueTypes)) {
            data["listOfValidIssueTypes"] = [];
            for (let item of this.listOfValidIssueTypes)
                data["listOfValidIssueTypes"].push(item);
        }
        if (Array.isArray(this.teamTicketCategoryMappings)) {
            data["teamTicketCategoryMappings"] = [];
            for (let item of this.teamTicketCategoryMappings)
                data["teamTicketCategoryMappings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketCategoryMappingDto {
    id?: number | undefined;
    contractSLAId?: number;
    ticketCategoryId?: number;
    listOfValidIssueTypes: number[] | undefined;
    teamTicketCategoryMappings?: TeamTicketCategoryMappingDto2[] | undefined;
}

export class ContractsListFilterDto implements IContractsListFilterDto {
    accountId?: string[] | undefined;
    accountName?: string[] | undefined;
    status?: string[] | undefined;
    billingTypeLabel?: string[] | undefined;
    serviceContractTypeName?: string[] | undefined;
    startDateAfter?: string | undefined;
    startDateBefore?: string | undefined;
    endDateAfter?: string | undefined;
    endDateBefore?: string | undefined;

    constructor(data?: IContractsListFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountId"])) {
                this.accountId = [] as any;
                for (let item of _data["accountId"])
                    this.accountId!.push(item);
            }
            if (Array.isArray(_data["accountName"])) {
                this.accountName = [] as any;
                for (let item of _data["accountName"])
                    this.accountName!.push(item);
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["billingTypeLabel"])) {
                this.billingTypeLabel = [] as any;
                for (let item of _data["billingTypeLabel"])
                    this.billingTypeLabel!.push(item);
            }
            if (Array.isArray(_data["serviceContractTypeName"])) {
                this.serviceContractTypeName = [] as any;
                for (let item of _data["serviceContractTypeName"])
                    this.serviceContractTypeName!.push(item);
            }
            this.startDateAfter = _data["startDateAfter"];
            this.startDateBefore = _data["startDateBefore"];
            this.endDateAfter = _data["endDateAfter"];
            this.endDateBefore = _data["endDateBefore"];
        }
    }

    static fromJS(data: any): ContractsListFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractsListFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountId)) {
            data["accountId"] = [];
            for (let item of this.accountId)
                data["accountId"].push(item);
        }
        if (Array.isArray(this.accountName)) {
            data["accountName"] = [];
            for (let item of this.accountName)
                data["accountName"].push(item);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.billingTypeLabel)) {
            data["billingTypeLabel"] = [];
            for (let item of this.billingTypeLabel)
                data["billingTypeLabel"].push(item);
        }
        if (Array.isArray(this.serviceContractTypeName)) {
            data["serviceContractTypeName"] = [];
            for (let item of this.serviceContractTypeName)
                data["serviceContractTypeName"].push(item);
        }
        data["startDateAfter"] = this.startDateAfter;
        data["startDateBefore"] = this.startDateBefore;
        data["endDateAfter"] = this.endDateAfter;
        data["endDateBefore"] = this.endDateBefore;
        return data;
    }
}

export interface IContractsListFilterDto {
    accountId?: string[] | undefined;
    accountName?: string[] | undefined;
    status?: string[] | undefined;
    billingTypeLabel?: string[] | undefined;
    serviceContractTypeName?: string[] | undefined;
    startDateAfter?: string | undefined;
    startDateBefore?: string | undefined;
    endDateAfter?: string | undefined;
    endDateBefore?: string | undefined;
}

export class ContractsPicklistDto implements IContractsPicklistDto {
    contractTypes?: number[] | undefined;
    serviceContractTypeNames?: string[] | undefined;

    constructor(data?: IContractsPicklistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(item);
            }
            if (Array.isArray(_data["serviceContractTypeNames"])) {
                this.serviceContractTypeNames = [] as any;
                for (let item of _data["serviceContractTypeNames"])
                    this.serviceContractTypeNames!.push(item);
            }
        }
    }

    static fromJS(data: any): ContractsPicklistDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractsPicklistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item);
        }
        if (Array.isArray(this.serviceContractTypeNames)) {
            data["serviceContractTypeNames"] = [];
            for (let item of this.serviceContractTypeNames)
                data["serviceContractTypeNames"].push(item);
        }
        return data;
    }
}

export interface IContractsPicklistDto {
    contractTypes?: number[] | undefined;
    serviceContractTypeNames?: string[] | undefined;
}

export class RecurringServicesContractBurndownDto implements IRecurringServicesContractBurndownDto {
    contractId?: number;
    contractName?: string | undefined;
    accountId?: number;
    isActive?: boolean;
    contractStartDate?: Date;
    contractEndDate?: Date | undefined;
    totalPurchased?: number;
    totalPurchasedBilled?: number;
    totalPurchasedUnbilled?: number;
    totalUsed?: number;
    currentBalance?: number;
    totalDollarsUsageBilled?: number;
    totalDollarsUsageUnbilled?: number;
    utilizationPercentage?: number;
    estimatedMonthlyBurnRate?: number;
    estimatedDaysRemaining?: number | undefined;
    totalChargeCount?: number;
    totalTimeEntryCount?: number;
    proactiveDollarsUsed?: number;
    nonProactiveDollarsUsed?: number;
    usageByRole?: RoleUsageDto[] | undefined;
    expertSupportTier?: string | undefined;

    constructor(data?: IRecurringServicesContractBurndownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.accountId = _data["accountId"];
            this.isActive = _data["isActive"];
            this.contractStartDate = _data["contractStartDate"] ? new Date(_data["contractStartDate"].toString()) : undefined as any;
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : undefined as any;
            this.totalPurchased = _data["totalPurchased"];
            this.totalPurchasedBilled = _data["totalPurchasedBilled"];
            this.totalPurchasedUnbilled = _data["totalPurchasedUnbilled"];
            this.totalUsed = _data["totalUsed"];
            this.currentBalance = _data["currentBalance"];
            this.totalDollarsUsageBilled = _data["totalDollarsUsageBilled"];
            this.totalDollarsUsageUnbilled = _data["totalDollarsUsageUnbilled"];
            this.utilizationPercentage = _data["utilizationPercentage"];
            this.estimatedMonthlyBurnRate = _data["estimatedMonthlyBurnRate"];
            this.estimatedDaysRemaining = _data["estimatedDaysRemaining"];
            this.totalChargeCount = _data["totalChargeCount"];
            this.totalTimeEntryCount = _data["totalTimeEntryCount"];
            this.proactiveDollarsUsed = _data["proactiveDollarsUsed"];
            this.nonProactiveDollarsUsed = _data["nonProactiveDollarsUsed"];
            if (Array.isArray(_data["usageByRole"])) {
                this.usageByRole = [] as any;
                for (let item of _data["usageByRole"])
                    this.usageByRole!.push(RoleUsageDto.fromJS(item));
            }
            this.expertSupportTier = _data["expertSupportTier"];
        }
    }

    static fromJS(data: any): RecurringServicesContractBurndownDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringServicesContractBurndownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["accountId"] = this.accountId;
        data["isActive"] = this.isActive;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : undefined as any;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : undefined as any;
        data["totalPurchased"] = this.totalPurchased;
        data["totalPurchasedBilled"] = this.totalPurchasedBilled;
        data["totalPurchasedUnbilled"] = this.totalPurchasedUnbilled;
        data["totalUsed"] = this.totalUsed;
        data["currentBalance"] = this.currentBalance;
        data["totalDollarsUsageBilled"] = this.totalDollarsUsageBilled;
        data["totalDollarsUsageUnbilled"] = this.totalDollarsUsageUnbilled;
        data["utilizationPercentage"] = this.utilizationPercentage;
        data["estimatedMonthlyBurnRate"] = this.estimatedMonthlyBurnRate;
        data["estimatedDaysRemaining"] = this.estimatedDaysRemaining;
        data["totalChargeCount"] = this.totalChargeCount;
        data["totalTimeEntryCount"] = this.totalTimeEntryCount;
        data["proactiveDollarsUsed"] = this.proactiveDollarsUsed;
        data["nonProactiveDollarsUsed"] = this.nonProactiveDollarsUsed;
        if (Array.isArray(this.usageByRole)) {
            data["usageByRole"] = [];
            for (let item of this.usageByRole)
                data["usageByRole"].push(item ? item.toJSON() : undefined as any);
        }
        data["expertSupportTier"] = this.expertSupportTier;
        return data;
    }
}

export interface IRecurringServicesContractBurndownDto {
    contractId?: number;
    contractName?: string | undefined;
    accountId?: number;
    isActive?: boolean;
    contractStartDate?: Date;
    contractEndDate?: Date | undefined;
    totalPurchased?: number;
    totalPurchasedBilled?: number;
    totalPurchasedUnbilled?: number;
    totalUsed?: number;
    currentBalance?: number;
    totalDollarsUsageBilled?: number;
    totalDollarsUsageUnbilled?: number;
    utilizationPercentage?: number;
    estimatedMonthlyBurnRate?: number;
    estimatedDaysRemaining?: number | undefined;
    totalChargeCount?: number;
    totalTimeEntryCount?: number;
    proactiveDollarsUsed?: number;
    nonProactiveDollarsUsed?: number;
    usageByRole?: RoleUsageDto[] | undefined;
    expertSupportTier?: string | undefined;
}

export class RecurringServicesContractDetailDto implements IRecurringServicesContractDetailDto {
    burndown?: RecurringServicesContractBurndownDto;
    monthlyBreakdowns?: RecurringServicesContractMonthlyBreakdownDto[] | undefined;
    detailRecords?: RecurringServicesContractDetailRecordDto[] | undefined;

    constructor(data?: IRecurringServicesContractDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.burndown = _data["burndown"] ? RecurringServicesContractBurndownDto.fromJS(_data["burndown"]) : undefined as any;
            if (Array.isArray(_data["monthlyBreakdowns"])) {
                this.monthlyBreakdowns = [] as any;
                for (let item of _data["monthlyBreakdowns"])
                    this.monthlyBreakdowns!.push(RecurringServicesContractMonthlyBreakdownDto.fromJS(item));
            }
            if (Array.isArray(_data["detailRecords"])) {
                this.detailRecords = [] as any;
                for (let item of _data["detailRecords"])
                    this.detailRecords!.push(RecurringServicesContractDetailRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecurringServicesContractDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringServicesContractDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["burndown"] = this.burndown ? this.burndown.toJSON() : undefined as any;
        if (Array.isArray(this.monthlyBreakdowns)) {
            data["monthlyBreakdowns"] = [];
            for (let item of this.monthlyBreakdowns)
                data["monthlyBreakdowns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.detailRecords)) {
            data["detailRecords"] = [];
            for (let item of this.detailRecords)
                data["detailRecords"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRecurringServicesContractDetailDto {
    burndown?: RecurringServicesContractBurndownDto;
    monthlyBreakdowns?: RecurringServicesContractMonthlyBreakdownDto[] | undefined;
    detailRecords?: RecurringServicesContractDetailRecordDto[] | undefined;
}

export class RecurringServicesContractDetailRecordDto implements IRecurringServicesContractDetailRecordDto {
    contractId?: number;
    accountId?: number;
    year?: number;
    month?: number;
    detailType?: string | undefined;
    purchasedAmount?: number;
    usageAmount?: number;
    hoursWorked?: number;
    status?: string | undefined;
    ticketNumbers?: string[] | undefined;
    recordCount?: number;
    dataLoadedDateTime?: Date;

    constructor(data?: IRecurringServicesContractDetailRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.accountId = _data["accountId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.detailType = _data["detailType"];
            this.purchasedAmount = _data["purchasedAmount"];
            this.usageAmount = _data["usageAmount"];
            this.hoursWorked = _data["hoursWorked"];
            this.status = _data["status"];
            if (Array.isArray(_data["ticketNumbers"])) {
                this.ticketNumbers = [] as any;
                for (let item of _data["ticketNumbers"])
                    this.ticketNumbers!.push(item);
            }
            this.recordCount = _data["recordCount"];
            this.dataLoadedDateTime = _data["dataLoadedDateTime"] ? new Date(_data["dataLoadedDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RecurringServicesContractDetailRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringServicesContractDetailRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["accountId"] = this.accountId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["detailType"] = this.detailType;
        data["purchasedAmount"] = this.purchasedAmount;
        data["usageAmount"] = this.usageAmount;
        data["hoursWorked"] = this.hoursWorked;
        data["status"] = this.status;
        if (Array.isArray(this.ticketNumbers)) {
            data["ticketNumbers"] = [];
            for (let item of this.ticketNumbers)
                data["ticketNumbers"].push(item);
        }
        data["recordCount"] = this.recordCount;
        data["dataLoadedDateTime"] = this.dataLoadedDateTime ? this.dataLoadedDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IRecurringServicesContractDetailRecordDto {
    contractId?: number;
    accountId?: number;
    year?: number;
    month?: number;
    detailType?: string | undefined;
    purchasedAmount?: number;
    usageAmount?: number;
    hoursWorked?: number;
    status?: string | undefined;
    ticketNumbers?: string[] | undefined;
    recordCount?: number;
    dataLoadedDateTime?: Date;
}

export class RecurringServicesContractMonthlyBreakdownDto implements IRecurringServicesContractMonthlyBreakdownDto {
    contractId?: number;
    accountId?: number;
    year?: number;
    month?: number;
    openingBalance?: number;
    closingBalance?: number;
    chargesAdded?: number;
    consumed?: number;
    usageByRole?: RoleUsageDto[] | undefined;

    constructor(data?: IRecurringServicesContractMonthlyBreakdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.accountId = _data["accountId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.openingBalance = _data["openingBalance"];
            this.closingBalance = _data["closingBalance"];
            this.chargesAdded = _data["chargesAdded"];
            this.consumed = _data["consumed"];
            if (Array.isArray(_data["usageByRole"])) {
                this.usageByRole = [] as any;
                for (let item of _data["usageByRole"])
                    this.usageByRole!.push(RoleUsageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecurringServicesContractMonthlyBreakdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringServicesContractMonthlyBreakdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["accountId"] = this.accountId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["openingBalance"] = this.openingBalance;
        data["closingBalance"] = this.closingBalance;
        data["chargesAdded"] = this.chargesAdded;
        data["consumed"] = this.consumed;
        if (Array.isArray(this.usageByRole)) {
            data["usageByRole"] = [];
            for (let item of this.usageByRole)
                data["usageByRole"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRecurringServicesContractMonthlyBreakdownDto {
    contractId?: number;
    accountId?: number;
    year?: number;
    month?: number;
    openingBalance?: number;
    closingBalance?: number;
    chargesAdded?: number;
    consumed?: number;
    usageByRole?: RoleUsageDto[] | undefined;
}

export class RoleUsageDto implements IRoleUsageDto {
    roleType?: string | undefined;
    hours?: number;
    dollars?: number;
    percentageOfTotal?: number;

    constructor(data?: IRoleUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleType = _data["roleType"];
            this.hours = _data["hours"];
            this.dollars = _data["dollars"];
            this.percentageOfTotal = _data["percentageOfTotal"];
        }
    }

    static fromJS(data: any): RoleUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleType"] = this.roleType;
        data["hours"] = this.hours;
        data["dollars"] = this.dollars;
        data["percentageOfTotal"] = this.percentageOfTotal;
        return data;
    }
}

export interface IRoleUsageDto {
    roleType?: string | undefined;
    hours?: number;
    dollars?: number;
    percentageOfTotal?: number;
}

export enum DynamicTagActions {
    AddTags = "AddTags",
    RemoveTags = "RemoveTags",
    Notes = "Notes",
}

export enum DynamicTagSource {
    AssetInventory = "AssetInventory",
    AssetLifecycle = "AssetLifecycle",
    AssetLocations = "AssetLocations",
}

export class DynamicTagsGetRequest implements IDynamicTagsGetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    tagType?: string | undefined;
    tagSource?: DynamicTagSource;
    tagKeys?: string[] | undefined;
    tagValues?: string[] | undefined;
    showParentsOnly?: boolean | undefined;
    allCheckboxSelected?: boolean | undefined;
    excludeSearchFilter?: boolean | undefined;
    searchFilter?: DynamicTagsSearchFilter;

    constructor(data?: IDynamicTagsGetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.tagType = _data["tagType"];
            this.tagSource = _data["tagSource"];
            if (Array.isArray(_data["tagKeys"])) {
                this.tagKeys = [] as any;
                for (let item of _data["tagKeys"])
                    this.tagKeys!.push(item);
            }
            if (Array.isArray(_data["tagValues"])) {
                this.tagValues = [] as any;
                for (let item of _data["tagValues"])
                    this.tagValues!.push(item);
            }
            this.showParentsOnly = _data["showParentsOnly"];
            this.allCheckboxSelected = _data["allCheckboxSelected"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? DynamicTagsSearchFilter.fromJS(_data["searchFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): DynamicTagsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagsGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["tagType"] = this.tagType;
        data["tagSource"] = this.tagSource;
        if (Array.isArray(this.tagKeys)) {
            data["tagKeys"] = [];
            for (let item of this.tagKeys)
                data["tagKeys"].push(item);
        }
        if (Array.isArray(this.tagValues)) {
            data["tagValues"] = [];
            for (let item of this.tagValues)
                data["tagValues"].push(item);
        }
        data["showParentsOnly"] = this.showParentsOnly;
        data["allCheckboxSelected"] = this.allCheckboxSelected;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IDynamicTagsGetRequest {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    tagType?: string | undefined;
    tagSource?: DynamicTagSource;
    tagKeys?: string[] | undefined;
    tagValues?: string[] | undefined;
    showParentsOnly?: boolean | undefined;
    allCheckboxSelected?: boolean | undefined;
    excludeSearchFilter?: boolean | undefined;
    searchFilter?: DynamicTagsSearchFilter;
}

export class DynamicTagsGetResponse implements IDynamicTagsGetResponse {
    dynamicTags?: string[] | undefined;

    constructor(data?: IDynamicTagsGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dynamicTags"])) {
                this.dynamicTags = [] as any;
                for (let item of _data["dynamicTags"])
                    this.dynamicTags!.push(item);
            }
        }
    }

    static fromJS(data: any): DynamicTagsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagsGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dynamicTags)) {
            data["dynamicTags"] = [];
            for (let item of this.dynamicTags)
                data["dynamicTags"].push(item);
        }
        return data;
    }
}

export interface IDynamicTagsGetResponse {
    dynamicTags?: string[] | undefined;
}

export class DynamicTagsRequest implements IDynamicTagsRequest {
    action?: DynamicTagActions;
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    accountId?: number;
    userId?: string | undefined;
    sourceIdentifier?: string | undefined;
    tagType?: string | undefined;
    tagKeys?: string[] | undefined;
    tagValues?: string[] | undefined;
    tagSource?: DynamicTagSource;
    allCheckboxSelected?: boolean | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean | undefined;
    searchFilter?: DynamicTagsSearchFilter;

    constructor(data?: IDynamicTagsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            this.accountId = _data["accountId"];
            this.userId = _data["userId"];
            this.sourceIdentifier = _data["sourceIdentifier"];
            this.tagType = _data["tagType"];
            if (Array.isArray(_data["tagKeys"])) {
                this.tagKeys = [] as any;
                for (let item of _data["tagKeys"])
                    this.tagKeys!.push(item);
            }
            if (Array.isArray(_data["tagValues"])) {
                this.tagValues = [] as any;
                for (let item of _data["tagValues"])
                    this.tagValues!.push(item);
            }
            this.tagSource = _data["tagSource"];
            this.allCheckboxSelected = _data["allCheckboxSelected"];
            this.showParentsOnly = _data["showParentsOnly"];
            this.excludeSearchFilter = _data["excludeSearchFilter"];
            this.searchFilter = _data["searchFilter"] ? DynamicTagsSearchFilter.fromJS(_data["searchFilter"]) : undefined as any;
        }
    }

    static fromJS(data: any): DynamicTagsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        data["accountId"] = this.accountId;
        data["userId"] = this.userId;
        data["sourceIdentifier"] = this.sourceIdentifier;
        data["tagType"] = this.tagType;
        if (Array.isArray(this.tagKeys)) {
            data["tagKeys"] = [];
            for (let item of this.tagKeys)
                data["tagKeys"].push(item);
        }
        if (Array.isArray(this.tagValues)) {
            data["tagValues"] = [];
            for (let item of this.tagValues)
                data["tagValues"].push(item);
        }
        data["tagSource"] = this.tagSource;
        data["allCheckboxSelected"] = this.allCheckboxSelected;
        data["showParentsOnly"] = this.showParentsOnly;
        data["excludeSearchFilter"] = this.excludeSearchFilter;
        data["searchFilter"] = this.searchFilter ? this.searchFilter.toJSON() : undefined as any;
        return data;
    }
}

export interface IDynamicTagsRequest {
    action?: DynamicTagActions;
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    accountId?: number;
    userId?: string | undefined;
    sourceIdentifier?: string | undefined;
    tagType?: string | undefined;
    tagKeys?: string[] | undefined;
    tagValues?: string[] | undefined;
    tagSource?: DynamicTagSource;
    allCheckboxSelected?: boolean | undefined;
    showParentsOnly?: boolean | undefined;
    excludeSearchFilter?: boolean | undefined;
    searchFilter?: DynamicTagsSearchFilter;
}

export class DynamicTagsSearchFilter implements IDynamicTagsSearchFilter {
    searchFor?: string | undefined;
    quarter?: number | undefined;
    year?: number | undefined;

    constructor(data?: IDynamicTagsSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchFor = _data["searchFor"];
            this.quarter = _data["quarter"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): DynamicTagsSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagsSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchFor"] = this.searchFor;
        data["quarter"] = this.quarter;
        data["year"] = this.year;
        return data;
    }
}

export interface IDynamicTagsSearchFilter {
    searchFor?: string | undefined;
    quarter?: number | undefined;
    year?: number | undefined;
}

export enum ServiceRequestVisualsTypes {
    ServiceRequestType = "ServiceRequestType",
    Priority = "Priority",
    ServiceRequestCategory = "ServiceRequestCategory",
    RequestHistory = "RequestHistory",
}

export class RoadmapsAssetsSearchRequestDto implements IRoadmapsAssetsSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    roadmapsSearchFilters?: RoadmapsAssetsSearchFilterDto[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;

    constructor(data?: IRoadmapsAssetsSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            if (Array.isArray(_data["accountReferences"])) {
                this.accountReferences = [] as any;
                for (let item of _data["accountReferences"])
                    this.accountReferences!.push(item);
            }
            if (Array.isArray(_data["roadmapsSearchFilters"])) {
                this.roadmapsSearchFilters = [] as any;
                for (let item of _data["roadmapsSearchFilters"])
                    this.roadmapsSearchFilters!.push(RoadmapsAssetsSearchFilterDto.fromJS(item));
            }
            this.limit = _data["limit"];
            this.offset = _data["offset"];
        }
    }

    static fromJS(data: any): RoadmapsAssetsSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapsAssetsSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        if (Array.isArray(this.accountReferences)) {
            data["accountReferences"] = [];
            for (let item of this.accountReferences)
                data["accountReferences"].push(item);
        }
        if (Array.isArray(this.roadmapsSearchFilters)) {
            data["roadmapsSearchFilters"] = [];
            for (let item of this.roadmapsSearchFilters)
                data["roadmapsSearchFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        return data;
    }
}

export interface IRoadmapsAssetsSearchRequestDto {
    accountIdentifier?: string | undefined;
    accountReferences?: string[] | undefined;
    roadmapsSearchFilters?: RoadmapsAssetsSearchFilterDto[] | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
}

export class ElasticSortCriteria implements IElasticSortCriteria {
    descending?: boolean;
    sortField?: string | undefined;

    constructor(data?: IElasticSortCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descending = _data["descending"];
            this.sortField = _data["sortField"];
        }
    }

    static fromJS(data: any): ElasticSortCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new ElasticSortCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descending"] = this.descending;
        data["sortField"] = this.sortField;
        return data;
    }
}

export interface IElasticSortCriteria {
    descending?: boolean;
    sortField?: string | undefined;
}

export class ExcelDownloadDefinition implements IExcelDownloadDefinition {
    header!: string | undefined;
    dataField!: string | undefined;
    format?: string | undefined;

    constructor(data?: IExcelDownloadDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.dataField = _data["dataField"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): ExcelDownloadDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelDownloadDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["dataField"] = this.dataField;
        data["format"] = this.format;
        return data;
    }
}

export interface IExcelDownloadDefinition {
    header: string | undefined;
    dataField: string | undefined;
    format?: string | undefined;
}

export class CiscoSupplementalDataDto implements ICiscoSupplementalDataDto {
    instanceId?: string | undefined;
    ipAddress?: string | undefined;
    hostName?: string | undefined;
    tags?: string | undefined;
    notes?: string | undefined;

    constructor(data?: ICiscoSupplementalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.ipAddress = _data["ipAddress"];
            this.hostName = _data["hostName"];
            this.tags = _data["tags"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CiscoSupplementalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoSupplementalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["ipAddress"] = this.ipAddress;
        data["hostName"] = this.hostName;
        data["tags"] = this.tags;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICiscoSupplementalDataDto {
    instanceId?: string | undefined;
    ipAddress?: string | undefined;
    hostName?: string | undefined;
    tags?: string | undefined;
    notes?: string | undefined;
}

export class CiscoThirdPartyContractDataDto implements ICiscoThirdPartyContractDataDto {
    instanceId?: string | undefined;
    serialNumber?: string | undefined;
    vendor?: string | undefined;
    contractNumber?: string | undefined;
    serviceLevel?: string | undefined;
    coverageStartDate?: string | undefined;
    coverageEndDate?: string | undefined;
    description?: string | undefined;
    customerName?: string | undefined;
    oem?: string | undefined;
    partNumber?: string | undefined;
    remoteMonitoring?: string | undefined;
    status?: string | undefined;
    hostName?: string | undefined;
    ipAddress?: string | undefined;
    assetTags?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: ICiscoThirdPartyContractDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.serialNumber = _data["serialNumber"];
            this.vendor = _data["vendor"];
            this.contractNumber = _data["contractNumber"];
            this.serviceLevel = _data["serviceLevel"];
            this.coverageStartDate = _data["coverageStartDate"];
            this.coverageEndDate = _data["coverageEndDate"];
            this.description = _data["description"];
            this.customerName = _data["customerName"];
            this.oem = _data["oem"];
            this.partNumber = _data["partNumber"];
            this.remoteMonitoring = _data["remoteMonitoring"];
            this.status = _data["status"];
            this.hostName = _data["hostName"];
            this.ipAddress = _data["ipAddress"];
            this.assetTags = _data["assetTags"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): CiscoThirdPartyContractDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoThirdPartyContractDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["serialNumber"] = this.serialNumber;
        data["vendor"] = this.vendor;
        data["contractNumber"] = this.contractNumber;
        data["serviceLevel"] = this.serviceLevel;
        data["coverageStartDate"] = this.coverageStartDate;
        data["coverageEndDate"] = this.coverageEndDate;
        data["description"] = this.description;
        data["customerName"] = this.customerName;
        data["oem"] = this.oem;
        data["partNumber"] = this.partNumber;
        data["remoteMonitoring"] = this.remoteMonitoring;
        data["status"] = this.status;
        data["hostName"] = this.hostName;
        data["ipAddress"] = this.ipAddress;
        data["assetTags"] = this.assetTags;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface ICiscoThirdPartyContractDataDto {
    instanceId?: string | undefined;
    serialNumber?: string | undefined;
    vendor?: string | undefined;
    contractNumber?: string | undefined;
    serviceLevel?: string | undefined;
    coverageStartDate?: string | undefined;
    coverageEndDate?: string | undefined;
    description?: string | undefined;
    customerName?: string | undefined;
    oem?: string | undefined;
    partNumber?: string | undefined;
    remoteMonitoring?: string | undefined;
    status?: string | undefined;
    hostName?: string | undefined;
    ipAddress?: string | undefined;
    assetTags?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
}

export class FileValidationDto implements IFileValidationDto {
    title?: string | undefined;
    errorMessage?: string | undefined;
    errorResults?: FileValidationErrors[] | undefined;

    constructor(data?: IFileValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["errorResults"])) {
                this.errorResults = [] as any;
                for (let item of _data["errorResults"])
                    this.errorResults!.push(FileValidationErrors.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.errorResults)) {
            data["errorResults"] = [];
            for (let item of this.errorResults)
                data["errorResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFileValidationDto {
    title?: string | undefined;
    errorMessage?: string | undefined;
    errorResults?: FileValidationErrors[] | undefined;
}

export class ManualManagedAssetDataRecordDto implements IManualManagedAssetDataRecordDto {
    assetId?: string | undefined;
    parentId?: string | undefined;
    name?: string | undefined;
    product?: string | undefined;
    description?: string | undefined;
    productFamily?: string | undefined;
    serialNumber?: string | undefined;
    manufacturer?: string | undefined;
    assetType?: string | undefined;
    useState?: string | undefined;
    operatingSystem?: string | undefined;
    firmware?: string | undefined;
    shipDate?: string | undefined;
    installDate?: string | undefined;
    assignedTo?: string | undefined;
    assignedOn?: string | undefined;
    contactOwner?: string | undefined;
    itemQuantity?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    microCategory?: string | undefined;
    ipAddress?: string | undefined;
    hostname?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    listPrice?: string | undefined;
    warrantyType?: string | undefined;
    warrantyEndDate?: string | undefined;
    lifecycleState?: string | undefined;
    endOfSaleDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    endOfLife?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    licensesPurchased?: string | undefined;
    licensesUsed?: string | undefined;
    growthAllowance?: string | undefined;
    licensesAvailable?: string | undefined;
    tags?: string | undefined;
    notes?: string | undefined;
    contractId?: string | undefined;
    contractVendor?: string | undefined;
    contractType?: string | undefined;
    contractStatus?: string | undefined;
    contractStartDate?: string | undefined;
    contractEndDate?: string | undefined;

    constructor(data?: IManualManagedAssetDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.product = _data["product"];
            this.description = _data["description"];
            this.productFamily = _data["productFamily"];
            this.serialNumber = _data["serialNumber"];
            this.manufacturer = _data["manufacturer"];
            this.assetType = _data["assetType"];
            this.useState = _data["useState"];
            this.operatingSystem = _data["operatingSystem"];
            this.firmware = _data["firmware"];
            this.shipDate = _data["shipDate"];
            this.installDate = _data["installDate"];
            this.assignedTo = _data["assignedTo"];
            this.assignedOn = _data["assignedOn"];
            this.contactOwner = _data["contactOwner"];
            this.itemQuantity = _data["itemQuantity"];
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.microCategory = _data["microCategory"];
            this.ipAddress = _data["ipAddress"];
            this.hostname = _data["hostname"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationCountry = _data["locationCountry"];
            this.listPrice = _data["listPrice"];
            this.warrantyType = _data["warrantyType"];
            this.warrantyEndDate = _data["warrantyEndDate"];
            this.lifecycleState = _data["lifecycleState"];
            this.endOfSaleDate = _data["endOfSaleDate"];
            this.lastDateOfSupport = _data["lastDateOfSupport"];
            this.endOfLife = _data["endOfLife"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.licensesPurchased = _data["licensesPurchased"];
            this.licensesUsed = _data["licensesUsed"];
            this.growthAllowance = _data["growthAllowance"];
            this.licensesAvailable = _data["licensesAvailable"];
            this.tags = _data["tags"];
            this.notes = _data["notes"];
            this.contractId = _data["contractId"];
            this.contractVendor = _data["contractVendor"];
            this.contractType = _data["contractType"];
            this.contractStatus = _data["contractStatus"];
            this.contractStartDate = _data["contractStartDate"];
            this.contractEndDate = _data["contractEndDate"];
        }
    }

    static fromJS(data: any): ManualManagedAssetDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualManagedAssetDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["product"] = this.product;
        data["description"] = this.description;
        data["productFamily"] = this.productFamily;
        data["serialNumber"] = this.serialNumber;
        data["manufacturer"] = this.manufacturer;
        data["assetType"] = this.assetType;
        data["useState"] = this.useState;
        data["operatingSystem"] = this.operatingSystem;
        data["firmware"] = this.firmware;
        data["shipDate"] = this.shipDate;
        data["installDate"] = this.installDate;
        data["assignedTo"] = this.assignedTo;
        data["assignedOn"] = this.assignedOn;
        data["contactOwner"] = this.contactOwner;
        data["itemQuantity"] = this.itemQuantity;
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["microCategory"] = this.microCategory;
        data["ipAddress"] = this.ipAddress;
        data["hostname"] = this.hostname;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationCountry"] = this.locationCountry;
        data["listPrice"] = this.listPrice;
        data["warrantyType"] = this.warrantyType;
        data["warrantyEndDate"] = this.warrantyEndDate;
        data["lifecycleState"] = this.lifecycleState;
        data["endOfSaleDate"] = this.endOfSaleDate;
        data["lastDateOfSupport"] = this.lastDateOfSupport;
        data["endOfLife"] = this.endOfLife;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["licensesPurchased"] = this.licensesPurchased;
        data["licensesUsed"] = this.licensesUsed;
        data["growthAllowance"] = this.growthAllowance;
        data["licensesAvailable"] = this.licensesAvailable;
        data["tags"] = this.tags;
        data["notes"] = this.notes;
        data["contractId"] = this.contractId;
        data["contractVendor"] = this.contractVendor;
        data["contractType"] = this.contractType;
        data["contractStatus"] = this.contractStatus;
        data["contractStartDate"] = this.contractStartDate;
        data["contractEndDate"] = this.contractEndDate;
        return data;
    }
}

export interface IManualManagedAssetDataRecordDto {
    assetId?: string | undefined;
    parentId?: string | undefined;
    name?: string | undefined;
    product?: string | undefined;
    description?: string | undefined;
    productFamily?: string | undefined;
    serialNumber?: string | undefined;
    manufacturer?: string | undefined;
    assetType?: string | undefined;
    useState?: string | undefined;
    operatingSystem?: string | undefined;
    firmware?: string | undefined;
    shipDate?: string | undefined;
    installDate?: string | undefined;
    assignedTo?: string | undefined;
    assignedOn?: string | undefined;
    contactOwner?: string | undefined;
    itemQuantity?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    microCategory?: string | undefined;
    ipAddress?: string | undefined;
    hostname?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    listPrice?: string | undefined;
    warrantyType?: string | undefined;
    warrantyEndDate?: string | undefined;
    lifecycleState?: string | undefined;
    endOfSaleDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    endOfLife?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    licensesPurchased?: string | undefined;
    licensesUsed?: string | undefined;
    growthAllowance?: string | undefined;
    licensesAvailable?: string | undefined;
    tags?: string | undefined;
    notes?: string | undefined;
    contractId?: string | undefined;
    contractVendor?: string | undefined;
    contractType?: string | undefined;
    contractStatus?: string | undefined;
    contractStartDate?: string | undefined;
    contractEndDate?: string | undefined;
}

export class FileHandlerUploadRecord_1OfCiscoSupplementalDataDto implements IFileHandlerUploadRecord_1OfCiscoSupplementalDataDto {
    record?: CiscoSupplementalDataDto;
    errorMessages?: string[] | undefined;
    row?: number;

    constructor(data?: IFileHandlerUploadRecord_1OfCiscoSupplementalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.record = _data["record"] ? CiscoSupplementalDataDto.fromJS(_data["record"]) : undefined as any;
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): FileHandlerUploadRecord_1OfCiscoSupplementalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileHandlerUploadRecord_1OfCiscoSupplementalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["record"] = this.record ? this.record.toJSON() : undefined as any;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["row"] = this.row;
        return data;
    }
}

export interface IFileHandlerUploadRecord_1OfCiscoSupplementalDataDto {
    record?: CiscoSupplementalDataDto;
    errorMessages?: string[] | undefined;
    row?: number;
}

export class FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto implements IFileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto {
    record?: CiscoThirdPartyContractDataDto;
    errorMessages?: string[] | undefined;
    row?: number;

    constructor(data?: IFileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.record = _data["record"] ? CiscoThirdPartyContractDataDto.fromJS(_data["record"]) : undefined as any;
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["record"] = this.record ? this.record.toJSON() : undefined as any;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["row"] = this.row;
        return data;
    }
}

export interface IFileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto {
    record?: CiscoThirdPartyContractDataDto;
    errorMessages?: string[] | undefined;
    row?: number;
}

export class FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto implements IFileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto {
    record?: ManualManagedAssetDataRecordDto;
    errorMessages?: string[] | undefined;
    row?: number;

    constructor(data?: IFileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.record = _data["record"] ? ManualManagedAssetDataRecordDto.fromJS(_data["record"]) : undefined as any;
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["record"] = this.record ? this.record.toJSON() : undefined as any;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["row"] = this.row;
        return data;
    }
}

export interface IFileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto {
    record?: ManualManagedAssetDataRecordDto;
    errorMessages?: string[] | undefined;
    row?: number;
}

export enum FileTypes {
    RawRenewalReport = "RawRenewalReport",
    UpdateCiscoMappings = "UpdateCiscoMappings",
    TechdataResults = "TechdataResults",
    SubscriptionMapping = "SubscriptionMapping",
    AssessmentGeneratedTemplate = "AssessmentGeneratedTemplate",
    SecurityPostureReviewV2Assessment = "SecurityPostureReviewV2Assessment",
    Other = "Other",
}

export class FileValidationErrors implements IFileValidationErrors {
    errorMessages?: string[] | undefined;
    row?: number;

    constructor(data?: IFileValidationErrors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): FileValidationErrors {
        data = typeof data === 'object' ? data : {};
        let result = new FileValidationErrors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["row"] = this.row;
        return data;
    }
}

export interface IFileValidationErrors {
    errorMessages?: string[] | undefined;
    row?: number;
}

export enum IntegrationStatus {
    Error = "Error",
    Disabled = "Disabled",
    Pending = "Pending",
    New = "New",
    Success = "Success",
}

export class CsvRows implements ICsvRows {
    columnName!: string | undefined;
    exampleData?: string[] | undefined;

    constructor(data?: ICsvRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            if (Array.isArray(_data["exampleData"])) {
                this.exampleData = [] as any;
                for (let item of _data["exampleData"])
                    this.exampleData!.push(item);
            }
        }
    }

    static fromJS(data: any): CsvRows {
        data = typeof data === 'object' ? data : {};
        let result = new CsvRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        if (Array.isArray(this.exampleData)) {
            data["exampleData"] = [];
            for (let item of this.exampleData)
                data["exampleData"].push(item);
        }
        return data;
    }
}

export interface ICsvRows {
    columnName: string | undefined;
    exampleData?: string[] | undefined;
}

export class ExcelRows implements IExcelRows {
    columnName!: string | undefined;
    sheetName!: string | undefined;
    exampleData?: string[] | undefined;
    headerRow?: number | undefined;

    constructor(data?: IExcelRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.sheetName = _data["sheetName"];
            if (Array.isArray(_data["exampleData"])) {
                this.exampleData = [] as any;
                for (let item of _data["exampleData"])
                    this.exampleData!.push(item);
            }
            this.headerRow = _data["headerRow"];
        }
    }

    static fromJS(data: any): ExcelRows {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["sheetName"] = this.sheetName;
        if (Array.isArray(this.exampleData)) {
            data["exampleData"] = [];
            for (let item of this.exampleData)
                data["exampleData"].push(item);
        }
        data["headerRow"] = this.headerRow;
        return data;
    }
}

export interface IExcelRows {
    columnName: string | undefined;
    sheetName: string | undefined;
    exampleData?: string[] | undefined;
    headerRow?: number | undefined;
}

export class MappingDto implements IMappingDto {
    id?: number;
    schemaId?: number;
    version?: number;
    description?: string | undefined;
    mapping?: string | undefined;
    published?: boolean;
    uploadResponse?: MappingRowsResultDto;

    constructor(data?: IMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.schemaId = _data["schemaId"];
            this.version = _data["version"];
            this.description = _data["description"];
            this.mapping = _data["mapping"];
            this.published = _data["published"];
            this.uploadResponse = _data["uploadResponse"] ? MappingRowsResultDto.fromJS(_data["uploadResponse"]) : undefined as any;
        }
    }

    static fromJS(data: any): MappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["schemaId"] = this.schemaId;
        data["version"] = this.version;
        data["description"] = this.description;
        data["mapping"] = this.mapping;
        data["published"] = this.published;
        data["uploadResponse"] = this.uploadResponse ? this.uploadResponse.toJSON() : undefined as any;
        return data;
    }
}

export interface IMappingDto {
    id?: number;
    schemaId?: number;
    version?: number;
    description?: string | undefined;
    mapping?: string | undefined;
    published?: boolean;
    uploadResponse?: MappingRowsResultDto;
}

export class MappingEngineMetadata implements IMappingEngineMetadata {
    name!: string | undefined;
    schemaId!: number;
    status!: string | undefined;
    additionalInformation?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IMappingEngineMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.schemaId = _data["schemaId"];
            this.status = _data["status"];
            this.additionalInformation = _data["additionalInformation"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): MappingEngineMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new MappingEngineMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["schemaId"] = this.schemaId;
        data["status"] = this.status;
        data["additionalInformation"] = this.additionalInformation;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IMappingEngineMetadata {
    name: string | undefined;
    schemaId: number;
    status: string | undefined;
    additionalInformation?: string | undefined;
    fileName?: string | undefined;
}

export class MappingEngineMetadataDto implements IMappingEngineMetadataDto {
    integrationType?: IntegrationType;
    metadata?: MappingEngineMetadata[] | undefined;
    integrationId?: number;

    constructor(data?: IMappingEngineMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationType = _data["integrationType"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MappingEngineMetadata.fromJS(item));
            }
            this.integrationId = _data["integrationId"];
        }
    }

    static fromJS(data: any): MappingEngineMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingEngineMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item ? item.toJSON() : undefined as any);
        }
        data["integrationId"] = this.integrationId;
        return data;
    }
}

export interface IMappingEngineMetadataDto {
    integrationType?: IntegrationType;
    metadata?: MappingEngineMetadata[] | undefined;
    integrationId?: number;
}

export enum MappingFileType {
    Csv = "Csv",
    Excel = "Excel",
}

export class MappingRowsResultDto implements IMappingRowsResultDto {
    guid?: string;
    fileType?: MappingFileType;
    excelRowsList?: ExcelRows[] | undefined;
    csvRowsList?: CsvRows[] | undefined;

    constructor(data?: IMappingRowsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fileType = _data["fileType"];
            if (Array.isArray(_data["excelRowsList"])) {
                this.excelRowsList = [] as any;
                for (let item of _data["excelRowsList"])
                    this.excelRowsList!.push(ExcelRows.fromJS(item));
            }
            if (Array.isArray(_data["csvRowsList"])) {
                this.csvRowsList = [] as any;
                for (let item of _data["csvRowsList"])
                    this.csvRowsList!.push(CsvRows.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MappingRowsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingRowsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fileType"] = this.fileType;
        if (Array.isArray(this.excelRowsList)) {
            data["excelRowsList"] = [];
            for (let item of this.excelRowsList)
                data["excelRowsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.csvRowsList)) {
            data["csvRowsList"] = [];
            for (let item of this.csvRowsList)
                data["csvRowsList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMappingRowsResultDto {
    guid?: string;
    fileType?: MappingFileType;
    excelRowsList?: ExcelRows[] | undefined;
    csvRowsList?: CsvRows[] | undefined;
}

export class SchemaDto implements ISchemaDto {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    schemaType?: string | undefined;
    targetSchemaUrl?: string | undefined;

    constructor(data?: ISchemaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.schemaType = _data["schemaType"];
            this.targetSchemaUrl = _data["targetSchemaUrl"];
        }
    }

    static fromJS(data: any): SchemaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["schemaType"] = this.schemaType;
        data["targetSchemaUrl"] = this.targetSchemaUrl;
        return data;
    }
}

export interface ISchemaDto {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    schemaType?: string | undefined;
    targetSchemaUrl?: string | undefined;
}

export enum OnboardingStatus {
    NotConfigured = "NotConfigured",
    Pending = "Pending",
    Onboarded = "Onboarded",
    NotConfiguredInAx = "NotConfiguredInAx",
}

export class FeatureRulesDto implements IFeatureRulesDto {
    featureName?: string | undefined;
    workflows?: WorkflowDto[] | undefined;

    constructor(data?: IFeatureRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureName = _data["featureName"];
            if (Array.isArray(_data["workflows"])) {
                this.workflows = [] as any;
                for (let item of _data["workflows"])
                    this.workflows!.push(WorkflowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureName"] = this.featureName;
        if (Array.isArray(this.workflows)) {
            data["workflows"] = [];
            for (let item of this.workflows)
                data["workflows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFeatureRulesDto {
    featureName?: string | undefined;
    workflows?: WorkflowDto[] | undefined;
}

export class RuleDto implements IRuleDto {
    enabled?: boolean;
    ruleName?: string | undefined;
    fullRuleName?: string | undefined;
    axNumbers?: string[] | undefined;
    filters?: string | undefined;

    constructor(data?: IRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.ruleName = _data["ruleName"];
            this.fullRuleName = _data["fullRuleName"];
            if (Array.isArray(_data["axNumbers"])) {
                this.axNumbers = [] as any;
                for (let item of _data["axNumbers"])
                    this.axNumbers!.push(item);
            }
            this.filters = _data["filters"];
        }
    }

    static fromJS(data: any): RuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["ruleName"] = this.ruleName;
        data["fullRuleName"] = this.fullRuleName;
        if (Array.isArray(this.axNumbers)) {
            data["axNumbers"] = [];
            for (let item of this.axNumbers)
                data["axNumbers"].push(item);
        }
        data["filters"] = this.filters;
        return data;
    }
}

export interface IRuleDto {
    enabled?: boolean;
    ruleName?: string | undefined;
    fullRuleName?: string | undefined;
    axNumbers?: string[] | undefined;
    filters?: string | undefined;
}

export class WorkflowDto implements IWorkflowDto {
    workflowName?: string | undefined;
    rules?: RuleDto[] | undefined;

    constructor(data?: IWorkflowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowName = _data["workflowName"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowName"] = this.workflowName;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkflowDto {
    workflowName?: string | undefined;
    rules?: RuleDto[] | undefined;
}

export class MessageCenterArticlesResponse implements IMessageCenterArticlesResponse {
    paginatedResponseDto?: PaginatedResultDto_1OfArticleDto;

    constructor(data?: IMessageCenterArticlesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paginatedResponseDto = _data["paginatedResponseDto"] ? PaginatedResultDto_1OfArticleDto.fromJS(_data["paginatedResponseDto"]) : undefined as any;
        }
    }

    static fromJS(data: any): MessageCenterArticlesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MessageCenterArticlesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paginatedResponseDto"] = this.paginatedResponseDto ? this.paginatedResponseDto.toJSON() : undefined as any;
        return data;
    }
}

export interface IMessageCenterArticlesResponse {
    paginatedResponseDto?: PaginatedResultDto_1OfArticleDto;
}

export class MessageCenterPicklistsResponse implements IMessageCenterPicklistsResponse {
    includeExcludeFilterCategories?: IncludeExcludeFilterCategory[] | undefined;

    constructor(data?: IMessageCenterPicklistsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["includeExcludeFilterCategories"])) {
                this.includeExcludeFilterCategories = [] as any;
                for (let item of _data["includeExcludeFilterCategories"])
                    this.includeExcludeFilterCategories!.push(IncludeExcludeFilterCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageCenterPicklistsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MessageCenterPicklistsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.includeExcludeFilterCategories)) {
            data["includeExcludeFilterCategories"] = [];
            for (let item of this.includeExcludeFilterCategories)
                data["includeExcludeFilterCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMessageCenterPicklistsResponse {
    includeExcludeFilterCategories?: IncludeExcludeFilterCategory[] | undefined;
}

export class NewsCenterArticlesResponse implements INewsCenterArticlesResponse {
    articles?: PaginatedResultDto_1OfArticleDto;
    filterOptions?: NewsCenterFilterOptionDto[] | undefined;

    constructor(data?: INewsCenterArticlesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articles = _data["articles"] ? PaginatedResultDto_1OfArticleDto.fromJS(_data["articles"]) : undefined as any;
            if (Array.isArray(_data["filterOptions"])) {
                this.filterOptions = [] as any;
                for (let item of _data["filterOptions"])
                    this.filterOptions!.push(NewsCenterFilterOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsCenterArticlesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterArticlesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articles"] = this.articles ? this.articles.toJSON() : undefined as any;
        if (Array.isArray(this.filterOptions)) {
            data["filterOptions"] = [];
            for (let item of this.filterOptions)
                data["filterOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INewsCenterArticlesResponse {
    articles?: PaginatedResultDto_1OfArticleDto;
    filterOptions?: NewsCenterFilterOptionDto[] | undefined;
}

export enum SeverityLevel {
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export class ArticleDetailDto implements IArticleDetailDto {
    id?: number;
    title?: string | undefined;
    content?: string | undefined;
    category?: string | undefined;
    partner?: string | undefined;
    severityLevel?: SeverityLevel;
    modified?: Date;
    tags?: string[] | undefined;

    constructor(data?: IArticleDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.category = _data["category"];
            this.partner = _data["partner"];
            this.severityLevel = _data["severityLevel"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["category"] = this.category;
        data["partner"] = this.partner;
        data["severityLevel"] = this.severityLevel;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IArticleDetailDto {
    id?: number;
    title?: string | undefined;
    content?: string | undefined;
    category?: string | undefined;
    partner?: string | undefined;
    severityLevel?: SeverityLevel;
    modified?: Date;
    tags?: string[] | undefined;
}

export class ArticleDto implements IArticleDto {
    id?: number;
    title?: string | undefined;
    category?: string | undefined;
    partner?: string | undefined;
    severityLevel?: SeverityLevel;
    modified?: Date;
    tags?: string[] | undefined;
    sourceUrl?: string | undefined;

    constructor(data?: IArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.category = _data["category"];
            this.partner = _data["partner"];
            this.severityLevel = _data["severityLevel"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.sourceUrl = _data["sourceUrl"];
        }
    }

    static fromJS(data: any): ArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["category"] = this.category;
        data["partner"] = this.partner;
        data["severityLevel"] = this.severityLevel;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["sourceUrl"] = this.sourceUrl;
        return data;
    }
}

export interface IArticleDto {
    id?: number;
    title?: string | undefined;
    category?: string | undefined;
    partner?: string | undefined;
    severityLevel?: SeverityLevel;
    modified?: Date;
    tags?: string[] | undefined;
    sourceUrl?: string | undefined;
}

export class MessageCenterArticlesPicklist implements IMessageCenterArticlesPicklist {
    category?: string[] | undefined;
    partner?: string[] | undefined;
    severityLevel?: string[] | undefined;
    tags?: string[] | undefined;
    modified?: string[] | undefined;

    constructor(data?: IMessageCenterArticlesPicklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            if (Array.isArray(_data["partner"])) {
                this.partner = [] as any;
                for (let item of _data["partner"])
                    this.partner!.push(item);
            }
            if (Array.isArray(_data["severityLevel"])) {
                this.severityLevel = [] as any;
                for (let item of _data["severityLevel"])
                    this.severityLevel!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["modified"])) {
                this.modified = [] as any;
                for (let item of _data["modified"])
                    this.modified!.push(item);
            }
        }
    }

    static fromJS(data: any): MessageCenterArticlesPicklist {
        data = typeof data === 'object' ? data : {};
        let result = new MessageCenterArticlesPicklist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        if (Array.isArray(this.partner)) {
            data["partner"] = [];
            for (let item of this.partner)
                data["partner"].push(item);
        }
        if (Array.isArray(this.severityLevel)) {
            data["severityLevel"] = [];
            for (let item of this.severityLevel)
                data["severityLevel"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.modified)) {
            data["modified"] = [];
            for (let item of this.modified)
                data["modified"].push(item);
        }
        return data;
    }
}

export interface IMessageCenterArticlesPicklist {
    category?: string[] | undefined;
    partner?: string[] | undefined;
    severityLevel?: string[] | undefined;
    tags?: string[] | undefined;
    modified?: string[] | undefined;
}

export class NewsCenterFilterOptionDto implements INewsCenterFilterOptionDto {
    accessor?: string | undefined;
    options?: string[] | undefined;

    constructor(data?: INewsCenterFilterOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessor = _data["accessor"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any): NewsCenterFilterOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterFilterOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessor"] = this.accessor;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }
}

export interface INewsCenterFilterOptionDto {
    accessor?: string | undefined;
    options?: string[] | undefined;
}

export class MessageCenterQuery extends PaginatedIncludeExcludeSearchFilter_1OfMessageCenterArticlesPicklist implements IMessageCenterQuery {

    constructor(data?: IMessageCenterQuery) {
        super(data);
        this._discriminator = "MessageCenterQuery";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MessageCenterQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MessageCenterQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMessageCenterQuery extends IPaginatedIncludeExcludeSearchFilter_1OfMessageCenterArticlesPicklist {
}

export class NewsCenterQuery implements INewsCenterQuery {
    page?: number;
    pageSize?: number;
    searchString?: string | undefined;
    sortOption?: NewsCenterQuerySortOption;
    filters?: NewsCenterQueryFilter[] | undefined;

    constructor(data?: INewsCenterQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.searchString = _data["searchString"];
            this.sortOption = _data["sortOption"] ? NewsCenterQuerySortOption.fromJS(_data["sortOption"]) : undefined as any;
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(NewsCenterQueryFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsCenterQuery {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["searchString"] = this.searchString;
        data["sortOption"] = this.sortOption ? this.sortOption.toJSON() : undefined as any;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INewsCenterQuery {
    page?: number;
    pageSize?: number;
    searchString?: string | undefined;
    sortOption?: NewsCenterQuerySortOption;
    filters?: NewsCenterQueryFilter[] | undefined;
}

export class NewsCenterQueryFilter implements INewsCenterQueryFilter {
    column?: string | undefined;
    values?: string[] | undefined;

    constructor(data?: INewsCenterQueryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): NewsCenterQueryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterQueryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface INewsCenterQueryFilter {
    column?: string | undefined;
    values?: string[] | undefined;
}

export class NewsCenterQuerySortOption implements INewsCenterQuerySortOption {
    column?: string | undefined;
    descending?: boolean;

    constructor(data?: INewsCenterQuerySortOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            this.descending = _data["descending"];
        }
    }

    static fromJS(data: any): NewsCenterQuerySortOption {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCenterQuerySortOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        data["descending"] = this.descending;
        return data;
    }
}

export interface INewsCenterQuerySortOption {
    column?: string | undefined;
    descending?: boolean;
}

export enum PermissionConfigurationType {
    Manual = "Manual",
    InferredAtRuntimeForAdmins = "InferredAtRuntimeForAdmins",
    InferredAtRuntimeForEveryone = "InferredAtRuntimeForEveryone",
}

export enum DatasetCategories {
    AWSConsumption = "AWSConsumption",
    AzureDirectConsumption = "AzureDirectConsumption",
    AzurePlanConsumption = "AzurePlanConsumption",
    ServiceRequests = "ServiceRequests",
    MicrosoftConsolidatedAssets = "MicrosoftConsolidatedAssets",
    CustomerAssets = "CustomerAssets",
}

export class IncludeExcludeFilters implements IIncludeExcludeFilters {
    phase?: string[] | undefined;
    status?: string[] | undefined;
    assignedResourceID?: string[] | undefined;
    daterange?: string[] | undefined;

    constructor(data?: IIncludeExcludeFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phase"])) {
                this.phase = [] as any;
                for (let item of _data["phase"])
                    this.phase!.push(item);
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["assignedResourceID"])) {
                this.assignedResourceID = [] as any;
                for (let item of _data["assignedResourceID"])
                    this.assignedResourceID!.push(item);
            }
            if (Array.isArray(_data["daterange"])) {
                this.daterange = [] as any;
                for (let item of _data["daterange"])
                    this.daterange!.push(item);
            }
        }
    }

    static fromJS(data: any): IncludeExcludeFilters {
        data = typeof data === 'object' ? data : {};
        let result = new IncludeExcludeFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phase)) {
            data["phase"] = [];
            for (let item of this.phase)
                data["phase"].push(item);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.assignedResourceID)) {
            data["assignedResourceID"] = [];
            for (let item of this.assignedResourceID)
                data["assignedResourceID"].push(item);
        }
        if (Array.isArray(this.daterange)) {
            data["daterange"] = [];
            for (let item of this.daterange)
                data["daterange"].push(item);
        }
        return data;
    }
}

export interface IIncludeExcludeFilters {
    phase?: string[] | undefined;
    status?: string[] | undefined;
    assignedResourceID?: string[] | undefined;
    daterange?: string[] | undefined;
}

export class ProjectDetailRequest implements IProjectDetailRequest {
    projectId?: number;
    includeFilters?: IncludeExcludeFilters;
    excludeFilters?: IncludeExcludeFilters;
    sortBy?: string | undefined;
    groupBy?: string | undefined;

    constructor(data?: IProjectDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.includeFilters = _data["includeFilters"] ? IncludeExcludeFilters.fromJS(_data["includeFilters"]) : undefined as any;
            this.excludeFilters = _data["excludeFilters"] ? IncludeExcludeFilters.fromJS(_data["excludeFilters"]) : undefined as any;
            this.sortBy = _data["sortBy"];
            this.groupBy = _data["groupBy"];
        }
    }

    static fromJS(data: any): ProjectDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["includeFilters"] = this.includeFilters ? this.includeFilters.toJSON() : undefined as any;
        data["excludeFilters"] = this.excludeFilters ? this.excludeFilters.toJSON() : undefined as any;
        data["sortBy"] = this.sortBy;
        data["groupBy"] = this.groupBy;
        return data;
    }
}

export interface IProjectDetailRequest {
    projectId?: number;
    includeFilters?: IncludeExcludeFilters;
    excludeFilters?: IncludeExcludeFilters;
    sortBy?: string | undefined;
    groupBy?: string | undefined;
}

export class ProjectDetailResponse implements IProjectDetailResponse {
    projectTasksGroups?: ProjectDetailResponseGroup[] | undefined;

    constructor(data?: IProjectDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectTasksGroups"])) {
                this.projectTasksGroups = [] as any;
                for (let item of _data["projectTasksGroups"])
                    this.projectTasksGroups!.push(ProjectDetailResponseGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectTasksGroups)) {
            data["projectTasksGroups"] = [];
            for (let item of this.projectTasksGroups)
                data["projectTasksGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDetailResponse {
    projectTasksGroups?: ProjectDetailResponseGroup[] | undefined;
}

export class ProjectDetailResponseGroup implements IProjectDetailResponseGroup {
    title?: string | undefined;
    completedTasks?: number;
    totalTasks?: number;
    projectStartDate?: Date | undefined;
    projectEndDate?: Date | undefined;
    projectTasks?: ProjectTaskDto[] | undefined;

    constructor(data?: IProjectDetailResponseGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.completedTasks = _data["completedTasks"];
            this.totalTasks = _data["totalTasks"];
            this.projectStartDate = _data["projectStartDate"] ? new Date(_data["projectStartDate"].toString()) : undefined as any;
            this.projectEndDate = _data["projectEndDate"] ? new Date(_data["projectEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDetailResponseGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDetailResponseGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["completedTasks"] = this.completedTasks;
        data["totalTasks"] = this.totalTasks;
        data["projectStartDate"] = this.projectStartDate ? formatDate(this.projectStartDate) : undefined as any;
        data["projectEndDate"] = this.projectEndDate ? formatDate(this.projectEndDate) : undefined as any;
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDetailResponseGroup {
    title?: string | undefined;
    completedTasks?: number;
    totalTasks?: number;
    projectStartDate?: Date | undefined;
    projectEndDate?: Date | undefined;
    projectTasks?: ProjectTaskDto[] | undefined;
}

export class ContractBlockDto implements IContractBlockDto {
    id?: number;
    contractID?: number | undefined;
    datePurchased?: Date;
    startDate?: Date;
    endDate?: Date;
    hours?: number;
    hoursApproved?: number;
    status?: number;

    constructor(data?: IContractBlockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractID = _data["contractID"];
            this.datePurchased = _data["datePurchased"] ? new Date(_data["datePurchased"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.hours = _data["hours"];
            this.hoursApproved = _data["hoursApproved"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContractBlockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractBlockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractID"] = this.contractID;
        data["datePurchased"] = this.datePurchased ? this.datePurchased.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["hours"] = this.hours;
        data["hoursApproved"] = this.hoursApproved;
        data["status"] = this.status;
        return data;
    }
}

export interface IContractBlockDto {
    id?: number;
    contractID?: number | undefined;
    datePurchased?: Date;
    startDate?: Date;
    endDate?: Date;
    hours?: number;
    hoursApproved?: number;
    status?: number;
}

export class ContractDto implements IContractDto {
    id?: number;
    userDefinedFieldsJson?: string | undefined;
    accountID?: number | undefined;
    businessDivisionSubdivisionID?: number;
    compliance?: boolean;
    contactID?: number | undefined;
    contactName?: string | undefined;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractPeriodType?: string | undefined;
    contractType?: number;
    contractServiceType?: string | undefined;
    contractVendor?: string | undefined;
    contractSubType?: string | undefined;
    description?: string | undefined;
    endDate?: Date;
    purchaseOrderNumber?: string | undefined;
    renewedContractID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    startDate?: Date;
    status?: number;
    timeReportingRequiresStartAndStopTimes?: number;
    contractBlock?: ContractBlockDto;
    contractTicketPurchase?: ContractTicketPurchaseDto;
    recurringServiceBurndown?: RecurringServicesContractBurndownDto;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.accountID = _data["accountID"];
            this.businessDivisionSubdivisionID = _data["businessDivisionSubdivisionID"];
            this.compliance = _data["compliance"];
            this.contactID = _data["contactID"];
            this.contactName = _data["contactName"];
            this.contractCategory = _data["contractCategory"];
            this.contractName = _data["contractName"];
            this.contractNumber = _data["contractNumber"];
            this.contractPeriodType = _data["contractPeriodType"];
            this.contractType = _data["contractType"];
            this.contractServiceType = _data["contractServiceType"];
            this.contractVendor = _data["contractVendor"];
            this.contractSubType = _data["contractSubType"];
            this.description = _data["description"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.renewedContractID = _data["renewedContractID"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.timeReportingRequiresStartAndStopTimes = _data["timeReportingRequiresStartAndStopTimes"];
            this.contractBlock = _data["contractBlock"] ? ContractBlockDto.fromJS(_data["contractBlock"]) : undefined as any;
            this.contractTicketPurchase = _data["contractTicketPurchase"] ? ContractTicketPurchaseDto.fromJS(_data["contractTicketPurchase"]) : undefined as any;
            this.recurringServiceBurndown = _data["recurringServiceBurndown"] ? RecurringServicesContractBurndownDto.fromJS(_data["recurringServiceBurndown"]) : undefined as any;
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["accountID"] = this.accountID;
        data["businessDivisionSubdivisionID"] = this.businessDivisionSubdivisionID;
        data["compliance"] = this.compliance;
        data["contactID"] = this.contactID;
        data["contactName"] = this.contactName;
        data["contractCategory"] = this.contractCategory;
        data["contractName"] = this.contractName;
        data["contractNumber"] = this.contractNumber;
        data["contractPeriodType"] = this.contractPeriodType;
        data["contractType"] = this.contractType;
        data["contractServiceType"] = this.contractServiceType;
        data["contractVendor"] = this.contractVendor;
        data["contractSubType"] = this.contractSubType;
        data["description"] = this.description;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["renewedContractID"] = this.renewedContractID;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["timeReportingRequiresStartAndStopTimes"] = this.timeReportingRequiresStartAndStopTimes;
        data["contractBlock"] = this.contractBlock ? this.contractBlock.toJSON() : undefined as any;
        data["contractTicketPurchase"] = this.contractTicketPurchase ? this.contractTicketPurchase.toJSON() : undefined as any;
        data["recurringServiceBurndown"] = this.recurringServiceBurndown ? this.recurringServiceBurndown.toJSON() : undefined as any;
        return data;
    }
}

export interface IContractDto {
    id?: number;
    userDefinedFieldsJson?: string | undefined;
    accountID?: number | undefined;
    businessDivisionSubdivisionID?: number;
    compliance?: boolean;
    contactID?: number | undefined;
    contactName?: string | undefined;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractPeriodType?: string | undefined;
    contractType?: number;
    contractServiceType?: string | undefined;
    contractVendor?: string | undefined;
    contractSubType?: string | undefined;
    description?: string | undefined;
    endDate?: Date;
    purchaseOrderNumber?: string | undefined;
    renewedContractID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    startDate?: Date;
    status?: number;
    timeReportingRequiresStartAndStopTimes?: number;
    contractBlock?: ContractBlockDto;
    contractTicketPurchase?: ContractTicketPurchaseDto;
    recurringServiceBurndown?: RecurringServicesContractBurndownDto;
}

export class ContractTicketPurchaseDto implements IContractTicketPurchaseDto {
    id?: number;
    contractID?: number | undefined;
    datePurchased?: Date;
    startDate?: Date;
    endDate?: Date;
    ticketsPurchased?: number;
    ticketsUsed?: number;
    status?: number;

    constructor(data?: IContractTicketPurchaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractID = _data["contractID"];
            this.datePurchased = _data["datePurchased"] ? new Date(_data["datePurchased"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.ticketsPurchased = _data["ticketsPurchased"];
            this.ticketsUsed = _data["ticketsUsed"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContractTicketPurchaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTicketPurchaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractID"] = this.contractID;
        data["datePurchased"] = this.datePurchased ? this.datePurchased.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["ticketsPurchased"] = this.ticketsPurchased;
        data["ticketsUsed"] = this.ticketsUsed;
        data["status"] = this.status;
        return data;
    }
}

export interface IContractTicketPurchaseDto {
    id?: number;
    contractID?: number | undefined;
    datePurchased?: Date;
    startDate?: Date;
    endDate?: Date;
    ticketsPurchased?: number;
    ticketsUsed?: number;
    status?: number;
}

export class PhaseDto implements IPhaseDto {
    id?: number;
    createDate?: Date | undefined;
    creatorResourceID?: number;
    description?: string | undefined;
    dueDate?: Date | undefined;
    estimatedHours?: number | undefined;
    externalID?: string | undefined;
    parentPhaseID?: number;
    phaseNumber?: string | undefined;
    projectID?: number;
    scheduled?: boolean;
    startDate?: Date | undefined;
    title?: string | undefined;
    lastActivityDateTime?: Date;

    constructor(data?: IPhaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.creatorResourceID = _data["creatorResourceID"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.estimatedHours = _data["estimatedHours"];
            this.externalID = _data["externalID"];
            this.parentPhaseID = _data["parentPhaseID"];
            this.phaseNumber = _data["phaseNumber"];
            this.projectID = _data["projectID"];
            this.scheduled = _data["scheduled"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.title = _data["title"];
            this.lastActivityDateTime = _data["lastActivityDateTime"] ? new Date(_data["lastActivityDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PhaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["creatorResourceID"] = this.creatorResourceID;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["estimatedHours"] = this.estimatedHours;
        data["externalID"] = this.externalID;
        data["parentPhaseID"] = this.parentPhaseID;
        data["phaseNumber"] = this.phaseNumber;
        data["projectID"] = this.projectID;
        data["scheduled"] = this.scheduled;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["title"] = this.title;
        data["lastActivityDateTime"] = this.lastActivityDateTime ? this.lastActivityDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IPhaseDto {
    id?: number;
    createDate?: Date | undefined;
    creatorResourceID?: number;
    description?: string | undefined;
    dueDate?: Date | undefined;
    estimatedHours?: number | undefined;
    externalID?: string | undefined;
    parentPhaseID?: number;
    phaseNumber?: string | undefined;
    projectID?: number;
    scheduled?: boolean;
    startDate?: Date | undefined;
    title?: string | undefined;
    lastActivityDateTime?: Date;
}

export class ProjectCacheResponse implements IProjectCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    projects?: ProjectDto[] | undefined;

    constructor(data?: IProjectCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiry = _data["expiry"];
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiry"] = this.expiry;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    projects?: ProjectDto[] | undefined;
}

export class ProjectDto implements IProjectDto {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    type?: number;
    extProjectType?: number | undefined;
    extPNumber?: string | undefined;
    projectNumber?: string | undefined;
    description?: string | undefined;
    createDateTime?: Date | undefined;
    creatorResourceId?: number | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    actualHours?: number | undefined;
    actualBilledHours?: number | undefined;
    estimatedTime?: number | undefined;
    laborEstimatedRevenue?: number | undefined;
    laborEstimatedCosts?: number | undefined;
    laborEstimatedMarginPercentage?: number | undefined;
    projectCostsRevenue?: number | undefined;
    projectCostsBudget?: number | undefined;
    projectCostEstimatedMarginPercentage?: number | undefined;
    changeOrdersRevenue?: number | undefined;
    sgda?: number | undefined;
    originalEstimatedRevenue?: number | undefined;
    estimatedSalesCost?: number | undefined;
    status?: number;
    contractID?: number | undefined;
    projectLeadResourceID?: number;
    companyOwnerResourceID?: number;
    completedPercentage?: number;
    completedDateTime?: Date | undefined;
    statusDetail?: string | undefined;
    statusDateTime?: Date | undefined;
    department?: number;
    lineOfBusiness?: number;
    purchaseOrderNumber?: string | undefined;
    businessDivisionSubdivisionID?: number;
    lastActivityDateTime?: Date;
    userDefinedFieldsJson?: string | undefined;
    projectLead?: ResourceDto;
    contract?: ContractDto;
    phases?: PhaseDto[] | undefined;
    projectTasks?: ProjectTaskDto[] | undefined;
    projectTaskPredecessors?: ProjectTaskPredecessorDto[] | undefined;
    allowedResources?: ResourceDto[] | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.accountID = _data["accountID"];
            this.type = _data["type"];
            this.extProjectType = _data["extProjectType"];
            this.extPNumber = _data["extPNumber"];
            this.projectNumber = _data["projectNumber"];
            this.description = _data["description"];
            this.createDateTime = _data["createDateTime"] ? new Date(_data["createDateTime"].toString()) : undefined as any;
            this.creatorResourceId = _data["creatorResourceId"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.actualHours = _data["actualHours"];
            this.actualBilledHours = _data["actualBilledHours"];
            this.estimatedTime = _data["estimatedTime"];
            this.laborEstimatedRevenue = _data["laborEstimatedRevenue"];
            this.laborEstimatedCosts = _data["laborEstimatedCosts"];
            this.laborEstimatedMarginPercentage = _data["laborEstimatedMarginPercentage"];
            this.projectCostsRevenue = _data["projectCostsRevenue"];
            this.projectCostsBudget = _data["projectCostsBudget"];
            this.projectCostEstimatedMarginPercentage = _data["projectCostEstimatedMarginPercentage"];
            this.changeOrdersRevenue = _data["changeOrdersRevenue"];
            this.sgda = _data["sgda"];
            this.originalEstimatedRevenue = _data["originalEstimatedRevenue"];
            this.estimatedSalesCost = _data["estimatedSalesCost"];
            this.status = _data["status"];
            this.contractID = _data["contractID"];
            this.projectLeadResourceID = _data["projectLeadResourceID"];
            this.companyOwnerResourceID = _data["companyOwnerResourceID"];
            this.completedPercentage = _data["completedPercentage"];
            this.completedDateTime = _data["completedDateTime"] ? new Date(_data["completedDateTime"].toString()) : undefined as any;
            this.statusDetail = _data["statusDetail"];
            this.statusDateTime = _data["statusDateTime"] ? new Date(_data["statusDateTime"].toString()) : undefined as any;
            this.department = _data["department"];
            this.lineOfBusiness = _data["lineOfBusiness"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.businessDivisionSubdivisionID = _data["businessDivisionSubdivisionID"];
            this.lastActivityDateTime = _data["lastActivityDateTime"] ? new Date(_data["lastActivityDateTime"].toString()) : undefined as any;
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.projectLead = _data["projectLead"] ? ResourceDto.fromJS(_data["projectLead"]) : undefined as any;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : undefined as any;
            if (Array.isArray(_data["phases"])) {
                this.phases = [] as any;
                for (let item of _data["phases"])
                    this.phases!.push(PhaseDto.fromJS(item));
            }
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTaskDto.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskPredecessors"])) {
                this.projectTaskPredecessors = [] as any;
                for (let item of _data["projectTaskPredecessors"])
                    this.projectTaskPredecessors!.push(ProjectTaskPredecessorDto.fromJS(item));
            }
            if (Array.isArray(_data["allowedResources"])) {
                this.allowedResources = [] as any;
                for (let item of _data["allowedResources"])
                    this.allowedResources!.push(ResourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["accountID"] = this.accountID;
        data["type"] = this.type;
        data["extProjectType"] = this.extProjectType;
        data["extPNumber"] = this.extPNumber;
        data["projectNumber"] = this.projectNumber;
        data["description"] = this.description;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : undefined as any;
        data["creatorResourceId"] = this.creatorResourceId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["actualHours"] = this.actualHours;
        data["actualBilledHours"] = this.actualBilledHours;
        data["estimatedTime"] = this.estimatedTime;
        data["laborEstimatedRevenue"] = this.laborEstimatedRevenue;
        data["laborEstimatedCosts"] = this.laborEstimatedCosts;
        data["laborEstimatedMarginPercentage"] = this.laborEstimatedMarginPercentage;
        data["projectCostsRevenue"] = this.projectCostsRevenue;
        data["projectCostsBudget"] = this.projectCostsBudget;
        data["projectCostEstimatedMarginPercentage"] = this.projectCostEstimatedMarginPercentage;
        data["changeOrdersRevenue"] = this.changeOrdersRevenue;
        data["sgda"] = this.sgda;
        data["originalEstimatedRevenue"] = this.originalEstimatedRevenue;
        data["estimatedSalesCost"] = this.estimatedSalesCost;
        data["status"] = this.status;
        data["contractID"] = this.contractID;
        data["projectLeadResourceID"] = this.projectLeadResourceID;
        data["companyOwnerResourceID"] = this.companyOwnerResourceID;
        data["completedPercentage"] = this.completedPercentage;
        data["completedDateTime"] = this.completedDateTime ? this.completedDateTime.toISOString() : undefined as any;
        data["statusDetail"] = this.statusDetail;
        data["statusDateTime"] = this.statusDateTime ? this.statusDateTime.toISOString() : undefined as any;
        data["department"] = this.department;
        data["lineOfBusiness"] = this.lineOfBusiness;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["businessDivisionSubdivisionID"] = this.businessDivisionSubdivisionID;
        data["lastActivityDateTime"] = this.lastActivityDateTime ? this.lastActivityDateTime.toISOString() : undefined as any;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["projectLead"] = this.projectLead ? this.projectLead.toJSON() : undefined as any;
        data["contract"] = this.contract ? this.contract.toJSON() : undefined as any;
        if (Array.isArray(this.phases)) {
            data["phases"] = [];
            for (let item of this.phases)
                data["phases"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTaskPredecessors)) {
            data["projectTaskPredecessors"] = [];
            for (let item of this.projectTaskPredecessors)
                data["projectTaskPredecessors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allowedResources)) {
            data["allowedResources"] = [];
            for (let item of this.allowedResources)
                data["allowedResources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDto {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    type?: number;
    extProjectType?: number | undefined;
    extPNumber?: string | undefined;
    projectNumber?: string | undefined;
    description?: string | undefined;
    createDateTime?: Date | undefined;
    creatorResourceId?: number | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    actualHours?: number | undefined;
    actualBilledHours?: number | undefined;
    estimatedTime?: number | undefined;
    laborEstimatedRevenue?: number | undefined;
    laborEstimatedCosts?: number | undefined;
    laborEstimatedMarginPercentage?: number | undefined;
    projectCostsRevenue?: number | undefined;
    projectCostsBudget?: number | undefined;
    projectCostEstimatedMarginPercentage?: number | undefined;
    changeOrdersRevenue?: number | undefined;
    sgda?: number | undefined;
    originalEstimatedRevenue?: number | undefined;
    estimatedSalesCost?: number | undefined;
    status?: number;
    contractID?: number | undefined;
    projectLeadResourceID?: number;
    companyOwnerResourceID?: number;
    completedPercentage?: number;
    completedDateTime?: Date | undefined;
    statusDetail?: string | undefined;
    statusDateTime?: Date | undefined;
    department?: number;
    lineOfBusiness?: number;
    purchaseOrderNumber?: string | undefined;
    businessDivisionSubdivisionID?: number;
    lastActivityDateTime?: Date;
    userDefinedFieldsJson?: string | undefined;
    projectLead?: ResourceDto;
    contract?: ContractDto;
    phases?: PhaseDto[] | undefined;
    projectTasks?: ProjectTaskDto[] | undefined;
    projectTaskPredecessors?: ProjectTaskPredecessorDto[] | undefined;
    allowedResources?: ResourceDto[] | undefined;
}

export class ProjectIndividualResponse implements IProjectIndividualResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    projectId?: number;
    project?: ProjectListItem;
    activePhase?: number | undefined;
    tasks?: ProjectTaskDto[] | undefined;
    orphanTasks?: ProjectTaskDto[] | undefined;
    attachedResources?: ResourceDto[] | undefined;

    constructor(data?: IProjectIndividualResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? ProjectListItem.fromJS(_data["project"]) : undefined as any;
            this.activePhase = _data["activePhase"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ProjectTaskDto.fromJS(item));
            }
            if (Array.isArray(_data["orphanTasks"])) {
                this.orphanTasks = [] as any;
                for (let item of _data["orphanTasks"])
                    this.orphanTasks!.push(ProjectTaskDto.fromJS(item));
            }
            if (Array.isArray(_data["attachedResources"])) {
                this.attachedResources = [] as any;
                for (let item of _data["attachedResources"])
                    this.attachedResources!.push(ResourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectIndividualResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIndividualResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["activePhase"] = this.activePhase;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.orphanTasks)) {
            data["orphanTasks"] = [];
            for (let item of this.orphanTasks)
                data["orphanTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachedResources)) {
            data["attachedResources"] = [];
            for (let item of this.attachedResources)
                data["attachedResources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectIndividualResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    projectId?: number;
    project?: ProjectListItem;
    activePhase?: number | undefined;
    tasks?: ProjectTaskDto[] | undefined;
    orphanTasks?: ProjectTaskDto[] | undefined;
    attachedResources?: ResourceDto[] | undefined;
}

export class ProjectListItem implements IProjectListItem {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    accountName?: string | undefined;
    axAccountNumber?: string | undefined;
    accountExecutive?: string | undefined;
    type?: number;
    createDateTime?: Date | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    status?: number;
    contractType?: number;
    projectLeadFirstName?: string | undefined;
    projectLeadLastName?: string | undefined;
    projectLeadEmail?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    contractID?: number | undefined;

    constructor(data?: IProjectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.accountID = _data["accountID"];
            this.accountName = _data["accountName"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.accountExecutive = _data["accountExecutive"];
            this.type = _data["type"];
            this.createDateTime = _data["createDateTime"] ? new Date(_data["createDateTime"].toString()) : undefined as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.contractType = _data["contractType"];
            this.projectLeadFirstName = _data["projectLeadFirstName"];
            this.projectLeadLastName = _data["projectLeadLastName"];
            this.projectLeadEmail = _data["projectLeadEmail"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.contractID = _data["contractID"];
        }
    }

    static fromJS(data: any): ProjectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["accountID"] = this.accountID;
        data["accountName"] = this.accountName;
        data["axAccountNumber"] = this.axAccountNumber;
        data["accountExecutive"] = this.accountExecutive;
        data["type"] = this.type;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : undefined as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["contractType"] = this.contractType;
        data["projectLeadFirstName"] = this.projectLeadFirstName;
        data["projectLeadLastName"] = this.projectLeadLastName;
        data["projectLeadEmail"] = this.projectLeadEmail;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["contractID"] = this.contractID;
        return data;
    }
}

export interface IProjectListItem {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    accountName?: string | undefined;
    axAccountNumber?: string | undefined;
    accountExecutive?: string | undefined;
    type?: number;
    createDateTime?: Date | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    status?: number;
    contractType?: number;
    projectLeadFirstName?: string | undefined;
    projectLeadLastName?: string | undefined;
    projectLeadEmail?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    contractID?: number | undefined;
}

export class ProjectListItemDto implements IProjectListItemDto {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    accountName?: string | undefined;
    axAccountNumber?: string | undefined;
    accountExecutive?: string | undefined;
    type?: number;
    createDateTime?: Date | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    status?: number;
    contractType?: number;
    projectLeadFirstName?: string | undefined;
    projectLeadLastName?: string | undefined;
    projectLeadEmail?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    contractID?: number | undefined;

    constructor(data?: IProjectListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.accountID = _data["accountID"];
            this.accountName = _data["accountName"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.accountExecutive = _data["accountExecutive"];
            this.type = _data["type"];
            this.createDateTime = _data["createDateTime"] ? new Date(_data["createDateTime"].toString()) : undefined as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.contractType = _data["contractType"];
            this.projectLeadFirstName = _data["projectLeadFirstName"];
            this.projectLeadLastName = _data["projectLeadLastName"];
            this.projectLeadEmail = _data["projectLeadEmail"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.contractID = _data["contractID"];
        }
    }

    static fromJS(data: any): ProjectListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["accountID"] = this.accountID;
        data["accountName"] = this.accountName;
        data["axAccountNumber"] = this.axAccountNumber;
        data["accountExecutive"] = this.accountExecutive;
        data["type"] = this.type;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : undefined as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["contractType"] = this.contractType;
        data["projectLeadFirstName"] = this.projectLeadFirstName;
        data["projectLeadLastName"] = this.projectLeadLastName;
        data["projectLeadEmail"] = this.projectLeadEmail;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["contractID"] = this.contractID;
        return data;
    }
}

export interface IProjectListItemDto {
    id?: number;
    projectName?: string | undefined;
    accountID?: number;
    accountName?: string | undefined;
    axAccountNumber?: string | undefined;
    accountExecutive?: string | undefined;
    type?: number;
    createDateTime?: Date | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    duration?: number | undefined;
    status?: number;
    contractType?: number;
    projectLeadFirstName?: string | undefined;
    projectLeadLastName?: string | undefined;
    projectLeadEmail?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    contractID?: number | undefined;
}

export class ProjectListResponse implements IProjectListResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    projects?: ProjectListItem[] | undefined;
    associatedContracts?: ContractDto[] | undefined;

    constructor(data?: IProjectListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectListItem.fromJS(item));
            }
            if (Array.isArray(_data["associatedContracts"])) {
                this.associatedContracts = [] as any;
                for (let item of _data["associatedContracts"])
                    this.associatedContracts!.push(ContractDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.associatedContracts)) {
            data["associatedContracts"] = [];
            for (let item of this.associatedContracts)
                data["associatedContracts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectListResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    projects?: ProjectListItem[] | undefined;
    associatedContracts?: ContractDto[] | undefined;
}

export enum ProjectStatus {
    Inactive = "Inactive",
    New = "New",
    InProgress = "InProgress",
    OnHold = "OnHold",
    ChangeOrder = "ChangeOrder",
    Complete = "Complete",
    WaitingParts = "WaitingParts",
    WaitingCustomer = "WaitingCustomer",
    AtRisk = "AtRisk",
    Backlog = "Backlog",
}

export class ProjectTaskDto implements IProjectTaskDto {
    id?: number;
    allocationCodeID?: number;
    assignedResourceID?: number;
    assignedResourceName?: string | undefined;
    assignedResource?: ResourceDto;
    assignedResourceRoleID?: number;
    createDateTime?: Date | undefined;
    completedDateTime?: Date | undefined;
    creatorResourceID?: number;
    departmentID?: number;
    description?: string | undefined;
    endDateTime?: Date | undefined;
    progress?: number;
    estimatedHours?: number | undefined;
    externalID?: string | undefined;
    hoursToBeScheduled?: number | undefined;
    isVisibleInClientPortal?: boolean;
    phaseID?: number;
    phase?: string | undefined;
    priority?: number;
    projectID?: number;
    purchaseOrderNumber?: string | undefined;
    remainingHours?: number;
    startDateTime?: Date | undefined;
    status?: number;
    taskIsBillable?: boolean;
    taskNumber?: string | undefined;
    taskType?: number;
    title?: string | undefined;
    priorityLabel?: number;
    creatorType?: number;
    completedByResourceID?: number;
    completedByType?: number;
    lastActivityResourceID?: number;
    lastActivityPersonType?: number;
    lastActivityDateTime?: Date;
    userDefinedFieldsJson?: string | undefined;

    constructor(data?: IProjectTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.allocationCodeID = _data["allocationCodeID"];
            this.assignedResourceID = _data["assignedResourceID"];
            this.assignedResourceName = _data["assignedResourceName"];
            this.assignedResource = _data["assignedResource"] ? ResourceDto.fromJS(_data["assignedResource"]) : undefined as any;
            this.assignedResourceRoleID = _data["assignedResourceRoleID"];
            this.createDateTime = _data["createDateTime"] ? new Date(_data["createDateTime"].toString()) : undefined as any;
            this.completedDateTime = _data["completedDateTime"] ? new Date(_data["completedDateTime"].toString()) : undefined as any;
            this.creatorResourceID = _data["creatorResourceID"];
            this.departmentID = _data["departmentID"];
            this.description = _data["description"];
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : undefined as any;
            this.progress = _data["progress"];
            this.estimatedHours = _data["estimatedHours"];
            this.externalID = _data["externalID"];
            this.hoursToBeScheduled = _data["hoursToBeScheduled"];
            this.isVisibleInClientPortal = _data["isVisibleInClientPortal"];
            this.phaseID = _data["phaseID"];
            this.phase = _data["phase"];
            this.priority = _data["priority"];
            this.projectID = _data["projectID"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.remainingHours = _data["remainingHours"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : undefined as any;
            this.status = _data["status"];
            this.taskIsBillable = _data["taskIsBillable"];
            this.taskNumber = _data["taskNumber"];
            this.taskType = _data["taskType"];
            this.title = _data["title"];
            this.priorityLabel = _data["priorityLabel"];
            this.creatorType = _data["creatorType"];
            this.completedByResourceID = _data["completedByResourceID"];
            this.completedByType = _data["completedByType"];
            this.lastActivityResourceID = _data["lastActivityResourceID"];
            this.lastActivityPersonType = _data["lastActivityPersonType"];
            this.lastActivityDateTime = _data["lastActivityDateTime"] ? new Date(_data["lastActivityDateTime"].toString()) : undefined as any;
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
        }
    }

    static fromJS(data: any): ProjectTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allocationCodeID"] = this.allocationCodeID;
        data["assignedResourceID"] = this.assignedResourceID;
        data["assignedResourceName"] = this.assignedResourceName;
        data["assignedResource"] = this.assignedResource ? this.assignedResource.toJSON() : undefined as any;
        data["assignedResourceRoleID"] = this.assignedResourceRoleID;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : undefined as any;
        data["completedDateTime"] = this.completedDateTime ? this.completedDateTime.toISOString() : undefined as any;
        data["creatorResourceID"] = this.creatorResourceID;
        data["departmentID"] = this.departmentID;
        data["description"] = this.description;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["progress"] = this.progress;
        data["estimatedHours"] = this.estimatedHours;
        data["externalID"] = this.externalID;
        data["hoursToBeScheduled"] = this.hoursToBeScheduled;
        data["isVisibleInClientPortal"] = this.isVisibleInClientPortal;
        data["phaseID"] = this.phaseID;
        data["phase"] = this.phase;
        data["priority"] = this.priority;
        data["projectID"] = this.projectID;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["remainingHours"] = this.remainingHours;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["status"] = this.status;
        data["taskIsBillable"] = this.taskIsBillable;
        data["taskNumber"] = this.taskNumber;
        data["taskType"] = this.taskType;
        data["title"] = this.title;
        data["priorityLabel"] = this.priorityLabel;
        data["creatorType"] = this.creatorType;
        data["completedByResourceID"] = this.completedByResourceID;
        data["completedByType"] = this.completedByType;
        data["lastActivityResourceID"] = this.lastActivityResourceID;
        data["lastActivityPersonType"] = this.lastActivityPersonType;
        data["lastActivityDateTime"] = this.lastActivityDateTime ? this.lastActivityDateTime.toISOString() : undefined as any;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        return data;
    }
}

export interface IProjectTaskDto {
    id?: number;
    allocationCodeID?: number;
    assignedResourceID?: number;
    assignedResourceName?: string | undefined;
    assignedResource?: ResourceDto;
    assignedResourceRoleID?: number;
    createDateTime?: Date | undefined;
    completedDateTime?: Date | undefined;
    creatorResourceID?: number;
    departmentID?: number;
    description?: string | undefined;
    endDateTime?: Date | undefined;
    progress?: number;
    estimatedHours?: number | undefined;
    externalID?: string | undefined;
    hoursToBeScheduled?: number | undefined;
    isVisibleInClientPortal?: boolean;
    phaseID?: number;
    phase?: string | undefined;
    priority?: number;
    projectID?: number;
    purchaseOrderNumber?: string | undefined;
    remainingHours?: number;
    startDateTime?: Date | undefined;
    status?: number;
    taskIsBillable?: boolean;
    taskNumber?: string | undefined;
    taskType?: number;
    title?: string | undefined;
    priorityLabel?: number;
    creatorType?: number;
    completedByResourceID?: number;
    completedByType?: number;
    lastActivityResourceID?: number;
    lastActivityPersonType?: number;
    lastActivityDateTime?: Date;
    userDefinedFieldsJson?: string | undefined;
}

export class ProjectTaskPredecessorDto implements IProjectTaskPredecessorDto {
    id?: number;
    lagDays?: number;
    predecessorTaskID?: number;
    successorTaskID?: number;

    constructor(data?: IProjectTaskPredecessorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lagDays = _data["lagDays"];
            this.predecessorTaskID = _data["predecessorTaskID"];
            this.successorTaskID = _data["successorTaskID"];
        }
    }

    static fromJS(data: any): ProjectTaskPredecessorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskPredecessorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lagDays"] = this.lagDays;
        data["predecessorTaskID"] = this.predecessorTaskID;
        data["successorTaskID"] = this.successorTaskID;
        return data;
    }
}

export interface IProjectTaskPredecessorDto {
    id?: number;
    lagDays?: number;
    predecessorTaskID?: number;
    successorTaskID?: number;
}

export class ProjectWidgetItemDto implements IProjectWidgetItemDto {
    status?: ProjectStatus;
    count?: number;

    constructor(data?: IProjectWidgetItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ProjectWidgetItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectWidgetItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IProjectWidgetItemDto {
    status?: ProjectStatus;
    count?: number;
}

export class ResourceDto implements IResourceDto {
    id?: number;
    accountingReferenceID?: string | undefined;
    active?: boolean;
    dateFormat?: string | undefined;
    defaultServiceDeskRoleID?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    initials?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    email3?: string | undefined;
    emailTypeCode?: string | undefined;
    emailTypeCode2?: string | undefined;
    emailTypeCode3?: string | undefined;
    gender?: string | undefined;
    greeting?: number;
    hiredate?: Date;
    homePhone?: string | undefined;
    internalCost?: number;
    locationID?: number;
    mobilePhone?: string | undefined;
    numberFormat?: string | undefined;
    officeExtension?: string | undefined;
    officePhone?: string | undefined;
    payrollType?: number;
    resourceType?: string | undefined;
    timeFormat?: string | undefined;
    travelAvailabilityPct?: string | undefined;
    userName?: string | undefined;
    userType?: number;
    userDefinedFieldsJson?: string | undefined;

    constructor(data?: IResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountingReferenceID = _data["accountingReferenceID"];
            this.active = _data["active"];
            this.dateFormat = _data["dateFormat"];
            this.defaultServiceDeskRoleID = _data["defaultServiceDeskRoleID"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.initials = _data["initials"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.email3 = _data["email3"];
            this.emailTypeCode = _data["emailTypeCode"];
            this.emailTypeCode2 = _data["emailTypeCode2"];
            this.emailTypeCode3 = _data["emailTypeCode3"];
            this.gender = _data["gender"];
            this.greeting = _data["greeting"];
            this.hiredate = _data["hiredate"] ? new Date(_data["hiredate"].toString()) : undefined as any;
            this.homePhone = _data["homePhone"];
            this.internalCost = _data["internalCost"];
            this.locationID = _data["locationID"];
            this.mobilePhone = _data["mobilePhone"];
            this.numberFormat = _data["numberFormat"];
            this.officeExtension = _data["officeExtension"];
            this.officePhone = _data["officePhone"];
            this.payrollType = _data["payrollType"];
            this.resourceType = _data["resourceType"];
            this.timeFormat = _data["timeFormat"];
            this.travelAvailabilityPct = _data["travelAvailabilityPct"];
            this.userName = _data["userName"];
            this.userType = _data["userType"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
        }
    }

    static fromJS(data: any): ResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountingReferenceID"] = this.accountingReferenceID;
        data["active"] = this.active;
        data["dateFormat"] = this.dateFormat;
        data["defaultServiceDeskRoleID"] = this.defaultServiceDeskRoleID;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["initials"] = this.initials;
        data["title"] = this.title;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["email3"] = this.email3;
        data["emailTypeCode"] = this.emailTypeCode;
        data["emailTypeCode2"] = this.emailTypeCode2;
        data["emailTypeCode3"] = this.emailTypeCode3;
        data["gender"] = this.gender;
        data["greeting"] = this.greeting;
        data["hiredate"] = this.hiredate ? this.hiredate.toISOString() : undefined as any;
        data["homePhone"] = this.homePhone;
        data["internalCost"] = this.internalCost;
        data["locationID"] = this.locationID;
        data["mobilePhone"] = this.mobilePhone;
        data["numberFormat"] = this.numberFormat;
        data["officeExtension"] = this.officeExtension;
        data["officePhone"] = this.officePhone;
        data["payrollType"] = this.payrollType;
        data["resourceType"] = this.resourceType;
        data["timeFormat"] = this.timeFormat;
        data["travelAvailabilityPct"] = this.travelAvailabilityPct;
        data["userName"] = this.userName;
        data["userType"] = this.userType;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        return data;
    }
}

export interface IResourceDto {
    id?: number;
    accountingReferenceID?: string | undefined;
    active?: boolean;
    dateFormat?: string | undefined;
    defaultServiceDeskRoleID?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    initials?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    email3?: string | undefined;
    emailTypeCode?: string | undefined;
    emailTypeCode2?: string | undefined;
    emailTypeCode3?: string | undefined;
    gender?: string | undefined;
    greeting?: number;
    hiredate?: Date;
    homePhone?: string | undefined;
    internalCost?: number;
    locationID?: number;
    mobilePhone?: string | undefined;
    numberFormat?: string | undefined;
    officeExtension?: string | undefined;
    officePhone?: string | undefined;
    payrollType?: number;
    resourceType?: string | undefined;
    timeFormat?: string | undefined;
    travelAvailabilityPct?: string | undefined;
    userName?: string | undefined;
    userType?: number;
    userDefinedFieldsJson?: string | undefined;
}

export class CiscoIbaAssetsArchitectureLdosResponse implements ICiscoIbaAssetsArchitectureLdosResponse {
    assets?: CiscoIbaAssetsArchitectureLdosDto[] | undefined;
    allArchitectures?: string[] | undefined;

    constructor(data?: ICiscoIbaAssetsArchitectureLdosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(CiscoIbaAssetsArchitectureLdosDto.fromJS(item));
            }
            if (Array.isArray(_data["allArchitectures"])) {
                this.allArchitectures = [] as any;
                for (let item of _data["allArchitectures"])
                    this.allArchitectures!.push(item);
            }
        }
    }

    static fromJS(data: any): CiscoIbaAssetsArchitectureLdosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsArchitectureLdosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allArchitectures)) {
            data["allArchitectures"] = [];
            for (let item of this.allArchitectures)
                data["allArchitectures"].push(item);
        }
        return data;
    }
}

export interface ICiscoIbaAssetsArchitectureLdosResponse {
    assets?: CiscoIbaAssetsArchitectureLdosDto[] | undefined;
    allArchitectures?: string[] | undefined;
}

export class CiscoIbaAssetsSearchResponse implements ICiscoIbaAssetsSearchResponse {
    assets?: CiscoIbaAssetDto[] | undefined;
    totalAssetsCount?: number;

    constructor(data?: ICiscoIbaAssetsSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(CiscoIbaAssetDto.fromJS(item));
            }
            this.totalAssetsCount = _data["totalAssetsCount"];
        }
    }

    static fromJS(data: any): CiscoIbaAssetsSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalAssetsCount"] = this.totalAssetsCount;
        return data;
    }
}

export interface ICiscoIbaAssetsSearchResponse {
    assets?: CiscoIbaAssetDto[] | undefined;
    totalAssetsCount?: number;
}

export class CiscoIbaBaseInsightsResponse implements ICiscoIbaBaseInsightsResponse {
    subscriptionCount?: number;
    enterpriseAgreementCount?: number;
    smartNetSlaCount?: number;
    coveredAssetCount?: number;
    ciscoGuidCount?: number;
    ciscoPartyCount?: number;
    locationCount?: number;

    constructor(data?: ICiscoIbaBaseInsightsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionCount = _data["subscriptionCount"];
            this.enterpriseAgreementCount = _data["enterpriseAgreementCount"];
            this.smartNetSlaCount = _data["smartNetSlaCount"];
            this.coveredAssetCount = _data["coveredAssetCount"];
            this.ciscoGuidCount = _data["ciscoGuidCount"];
            this.ciscoPartyCount = _data["ciscoPartyCount"];
            this.locationCount = _data["locationCount"];
        }
    }

    static fromJS(data: any): CiscoIbaBaseInsightsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaBaseInsightsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionCount"] = this.subscriptionCount;
        data["enterpriseAgreementCount"] = this.enterpriseAgreementCount;
        data["smartNetSlaCount"] = this.smartNetSlaCount;
        data["coveredAssetCount"] = this.coveredAssetCount;
        data["ciscoGuidCount"] = this.ciscoGuidCount;
        data["ciscoPartyCount"] = this.ciscoPartyCount;
        data["locationCount"] = this.locationCount;
        return data;
    }
}

export interface ICiscoIbaBaseInsightsResponse {
    subscriptionCount?: number;
    enterpriseAgreementCount?: number;
    smartNetSlaCount?: number;
    coveredAssetCount?: number;
    ciscoGuidCount?: number;
    ciscoPartyCount?: number;
    locationCount?: number;
}

export class CiscoIbaEaDetailDto implements ICiscoIbaEaDetailDto {
    commerceSku!: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    nextTrueForward?: Date | undefined;
    smartAccountName?: string | undefined;
    suiteName?: string | undefined;
    trueForwardDue?: number | undefined;
    totalPurchased?: number | undefined;
    totalGenerated?: number | undefined;
    balance?: number | undefined;
    exceptionalGrowthThresholdExceeded?: string | undefined;
    healthMessage?: string | undefined;

    constructor(data?: ICiscoIbaEaDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commerceSku = _data["commerceSku"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.nextTrueForward = _data["nextTrueForward"] ? new Date(_data["nextTrueForward"].toString()) : undefined as any;
            this.smartAccountName = _data["smartAccountName"];
            this.suiteName = _data["suiteName"];
            this.trueForwardDue = _data["trueForwardDue"];
            this.totalPurchased = _data["totalPurchased"];
            this.totalGenerated = _data["totalGenerated"];
            this.balance = _data["balance"];
            this.exceptionalGrowthThresholdExceeded = _data["exceptionalGrowthThresholdExceeded"];
            this.healthMessage = _data["healthMessage"];
        }
    }

    static fromJS(data: any): CiscoIbaEaDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaEaDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commerceSku"] = this.commerceSku;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["nextTrueForward"] = this.nextTrueForward ? this.nextTrueForward.toISOString() : undefined as any;
        data["smartAccountName"] = this.smartAccountName;
        data["suiteName"] = this.suiteName;
        data["trueForwardDue"] = this.trueForwardDue;
        data["totalPurchased"] = this.totalPurchased;
        data["totalGenerated"] = this.totalGenerated;
        data["balance"] = this.balance;
        data["exceptionalGrowthThresholdExceeded"] = this.exceptionalGrowthThresholdExceeded;
        data["healthMessage"] = this.healthMessage;
        return data;
    }
}

export interface ICiscoIbaEaDetailDto {
    commerceSku: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    nextTrueForward?: Date | undefined;
    smartAccountName?: string | undefined;
    suiteName?: string | undefined;
    trueForwardDue?: number | undefined;
    totalPurchased?: number | undefined;
    totalGenerated?: number | undefined;
    balance?: number | undefined;
    exceptionalGrowthThresholdExceeded?: string | undefined;
    healthMessage?: string | undefined;
}

export class CiscoIbaEaResponse implements ICiscoIbaEaResponse {
    enterpriseAgreements?: CiscoIbaEaDto[] | undefined;
    enterpriseAgreementsCount?: number;

    constructor(data?: ICiscoIbaEaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enterpriseAgreements"])) {
                this.enterpriseAgreements = [] as any;
                for (let item of _data["enterpriseAgreements"])
                    this.enterpriseAgreements!.push(CiscoIbaEaDto.fromJS(item));
            }
            this.enterpriseAgreementsCount = _data["enterpriseAgreementsCount"];
        }
    }

    static fromJS(data: any): CiscoIbaEaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaEaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enterpriseAgreements)) {
            data["enterpriseAgreements"] = [];
            for (let item of this.enterpriseAgreements)
                data["enterpriseAgreements"].push(item ? item.toJSON() : undefined as any);
        }
        data["enterpriseAgreementsCount"] = this.enterpriseAgreementsCount;
        return data;
    }
}

export interface ICiscoIbaEaResponse {
    enterpriseAgreements?: CiscoIbaEaDto[] | undefined;
    enterpriseAgreementsCount?: number;
}

export class CiscoIbaExpiringAssetsResponse implements ICiscoIbaExpiringAssetsResponse {
    next6Months?: ExpiringAssetCounts;
    next12Months?: ExpiringAssetCounts;
    next3Years?: ExpiringAssetCounts;

    constructor(data?: ICiscoIbaExpiringAssetsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.next6Months = _data["next6Months"] ? ExpiringAssetCounts.fromJS(_data["next6Months"]) : undefined as any;
            this.next12Months = _data["next12Months"] ? ExpiringAssetCounts.fromJS(_data["next12Months"]) : undefined as any;
            this.next3Years = _data["next3Years"] ? ExpiringAssetCounts.fromJS(_data["next3Years"]) : undefined as any;
        }
    }

    static fromJS(data: any): CiscoIbaExpiringAssetsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaExpiringAssetsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["next6Months"] = this.next6Months ? this.next6Months.toJSON() : undefined as any;
        data["next12Months"] = this.next12Months ? this.next12Months.toJSON() : undefined as any;
        data["next3Years"] = this.next3Years ? this.next3Years.toJSON() : undefined as any;
        return data;
    }
}

export interface ICiscoIbaExpiringAssetsResponse {
    next6Months?: ExpiringAssetCounts;
    next12Months?: ExpiringAssetCounts;
    next3Years?: ExpiringAssetCounts;
}

export class CiscoIbaLdosResponse implements ICiscoIbaLdosResponse {
    products?: CiscoIbaLdosDto[] | undefined;
    coveredCount?: number | undefined;
    totalCount?: number | undefined;

    constructor(data?: ICiscoIbaLdosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CiscoIbaLdosDto.fromJS(item));
            }
            this.coveredCount = _data["coveredCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CiscoIbaLdosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLdosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        data["coveredCount"] = this.coveredCount;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICiscoIbaLdosResponse {
    products?: CiscoIbaLdosDto[] | undefined;
    coveredCount?: number | undefined;
    totalCount?: number | undefined;
}

export class CiscoIbaLocationDto implements ICiscoIbaLocationDto {
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerCustomerName?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    assetCount?: number;

    constructor(data?: ICiscoIbaLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.manufacturerCustomerName = _data["manufacturerCustomerName"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationCountry = _data["locationCountry"];
            this.assetCount = _data["assetCount"];
        }
    }

    static fromJS(data: any): CiscoIbaLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["manufacturerCustomerName"] = this.manufacturerCustomerName;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationCountry"] = this.locationCountry;
        data["assetCount"] = this.assetCount;
        return data;
    }
}

export interface ICiscoIbaLocationDto {
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    manufacturerCustomerName?: string | undefined;
    locationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
    assetCount?: number;
}

export class CiscoIbaLocationResponse implements ICiscoIbaLocationResponse {
    locationData?: CiscoIbaLocationDto[] | undefined;
    globalLocationData?: GlobalLocationData[] | undefined;
    customerNameLocationData?: CustomerNameLocationData[] | undefined;

    constructor(data?: ICiscoIbaLocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locationData"])) {
                this.locationData = [] as any;
                for (let item of _data["locationData"])
                    this.locationData!.push(CiscoIbaLocationDto.fromJS(item));
            }
            if (Array.isArray(_data["globalLocationData"])) {
                this.globalLocationData = [] as any;
                for (let item of _data["globalLocationData"])
                    this.globalLocationData!.push(GlobalLocationData.fromJS(item));
            }
            if (Array.isArray(_data["customerNameLocationData"])) {
                this.customerNameLocationData = [] as any;
                for (let item of _data["customerNameLocationData"])
                    this.customerNameLocationData!.push(CustomerNameLocationData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CiscoIbaLocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationData)) {
            data["locationData"] = [];
            for (let item of this.locationData)
                data["locationData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.globalLocationData)) {
            data["globalLocationData"] = [];
            for (let item of this.globalLocationData)
                data["globalLocationData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerNameLocationData)) {
            data["customerNameLocationData"] = [];
            for (let item of this.customerNameLocationData)
                data["customerNameLocationData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICiscoIbaLocationResponse {
    locationData?: CiscoIbaLocationDto[] | undefined;
    globalLocationData?: GlobalLocationData[] | undefined;
    customerNameLocationData?: CustomerNameLocationData[] | undefined;
}

export class CiscoIbaPicklistResponse implements ICiscoIbaPicklistResponse {
    productFamily?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    manufacturerGlobalCustomerName?: string[] | undefined;
    manufacturerCustomerName?: string[] | undefined;
    siteLocation?: SiteLocationGroup[] | undefined;
    assetType?: string[] | undefined;
    tags?: string[] | undefined;
    shiCategory?: ShiCategoryGroup[] | undefined;
    importantDates?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    productType?: string[] | undefined;
    subCategory?: string[] | undefined;
    serviceCost?: string[] | undefined;

    constructor(data?: ICiscoIbaPicklistResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productFamily"])) {
                this.productFamily = [] as any;
                for (let item of _data["productFamily"])
                    this.productFamily!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["manufacturerGlobalCustomerName"])) {
                this.manufacturerGlobalCustomerName = [] as any;
                for (let item of _data["manufacturerGlobalCustomerName"])
                    this.manufacturerGlobalCustomerName!.push(item);
            }
            if (Array.isArray(_data["manufacturerCustomerName"])) {
                this.manufacturerCustomerName = [] as any;
                for (let item of _data["manufacturerCustomerName"])
                    this.manufacturerCustomerName!.push(item);
            }
            if (Array.isArray(_data["siteLocation"])) {
                this.siteLocation = [] as any;
                for (let item of _data["siteLocation"])
                    this.siteLocation!.push(SiteLocationGroup.fromJS(item));
            }
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(ShiCategoryGroup.fromJS(item));
            }
            if (Array.isArray(_data["importantDates"])) {
                this.importantDates = [] as any;
                for (let item of _data["importantDates"])
                    this.importantDates!.push(item);
            }
            if (Array.isArray(_data["serviceLevelAgreement"])) {
                this.serviceLevelAgreement = [] as any;
                for (let item of _data["serviceLevelAgreement"])
                    this.serviceLevelAgreement!.push(item);
            }
            if (Array.isArray(_data["productType"])) {
                this.productType = [] as any;
                for (let item of _data["productType"])
                    this.productType!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["serviceCost"])) {
                this.serviceCost = [] as any;
                for (let item of _data["serviceCost"])
                    this.serviceCost!.push(item);
            }
        }
    }

    static fromJS(data: any): CiscoIbaPicklistResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaPicklistResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productFamily)) {
            data["productFamily"] = [];
            for (let item of this.productFamily)
                data["productFamily"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.manufacturerGlobalCustomerName)) {
            data["manufacturerGlobalCustomerName"] = [];
            for (let item of this.manufacturerGlobalCustomerName)
                data["manufacturerGlobalCustomerName"].push(item);
        }
        if (Array.isArray(this.manufacturerCustomerName)) {
            data["manufacturerCustomerName"] = [];
            for (let item of this.manufacturerCustomerName)
                data["manufacturerCustomerName"].push(item);
        }
        if (Array.isArray(this.siteLocation)) {
            data["siteLocation"] = [];
            for (let item of this.siteLocation)
                data["siteLocation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.importantDates)) {
            data["importantDates"] = [];
            for (let item of this.importantDates)
                data["importantDates"].push(item);
        }
        if (Array.isArray(this.serviceLevelAgreement)) {
            data["serviceLevelAgreement"] = [];
            for (let item of this.serviceLevelAgreement)
                data["serviceLevelAgreement"].push(item);
        }
        if (Array.isArray(this.productType)) {
            data["productType"] = [];
            for (let item of this.productType)
                data["productType"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.serviceCost)) {
            data["serviceCost"] = [];
            for (let item of this.serviceCost)
                data["serviceCost"].push(item);
        }
        return data;
    }
}

export interface ICiscoIbaPicklistResponse {
    productFamily?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    manufacturerGlobalCustomerName?: string[] | undefined;
    manufacturerCustomerName?: string[] | undefined;
    siteLocation?: SiteLocationGroup[] | undefined;
    assetType?: string[] | undefined;
    tags?: string[] | undefined;
    shiCategory?: ShiCategoryGroup[] | undefined;
    importantDates?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    productType?: string[] | undefined;
    subCategory?: string[] | undefined;
    serviceCost?: string[] | undefined;
}

export class CiscoIbaProductResponse implements ICiscoIbaProductResponse {
    products?: CiscoIbaProductDto[] | undefined;
    summary?: CiscoIbaProductSummaryDto;

    constructor(data?: ICiscoIbaProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CiscoIbaProductDto.fromJS(item));
            }
            this.summary = _data["summary"] ? CiscoIbaProductSummaryDto.fromJS(_data["summary"]) : undefined as any;
        }
    }

    static fromJS(data: any): CiscoIbaProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        return data;
    }
}

export interface ICiscoIbaProductResponse {
    products?: CiscoIbaProductDto[] | undefined;
    summary?: CiscoIbaProductSummaryDto;
}

export class CiscoIbaShippedHardwareResponse implements ICiscoIbaShippedHardwareResponse {
    cisco?: { [key: string]: CiscoIbaShippedHardwareCiscoDto[]; } | undefined;
    meraki?: { [key: string]: CiscoIbaShippedHardwareMerakiDto[]; } | undefined;

    constructor(data?: ICiscoIbaShippedHardwareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["cisco"]) {
                this.cisco = {} as any;
                for (let key in _data["cisco"]) {
                    if (_data["cisco"].hasOwnProperty(key))
                        (this.cisco as any)![key] = _data["cisco"][key] ? _data["cisco"][key].map((i: any) => CiscoIbaShippedHardwareCiscoDto.fromJS(i)) : [];
                }
            }
            if (_data["meraki"]) {
                this.meraki = {} as any;
                for (let key in _data["meraki"]) {
                    if (_data["meraki"].hasOwnProperty(key))
                        (this.meraki as any)![key] = _data["meraki"][key] ? _data["meraki"][key].map((i: any) => CiscoIbaShippedHardwareMerakiDto.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): CiscoIbaShippedHardwareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaShippedHardwareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.cisco) {
            data["cisco"] = {};
            for (let key in this.cisco) {
                if (this.cisco.hasOwnProperty(key))
                    (data["cisco"] as any)[key] = (this.cisco as any)[key];
            }
        }
        if (this.meraki) {
            data["meraki"] = {};
            for (let key in this.meraki) {
                if (this.meraki.hasOwnProperty(key))
                    (data["meraki"] as any)[key] = (this.meraki as any)[key];
            }
        }
        return data;
    }
}

export interface ICiscoIbaShippedHardwareResponse {
    cisco?: { [key: string]: CiscoIbaShippedHardwareCiscoDto[]; } | undefined;
    meraki?: { [key: string]: CiscoIbaShippedHardwareMerakiDto[]; } | undefined;
}

export class CustomerNameLocationData implements ICustomerNameLocationData {
    manufacturerCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    assetCountByManufacturerCustomerName?: number;

    constructor(data?: ICustomerNameLocationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerCustomerName = _data["manufacturerCustomerName"];
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.assetCountByManufacturerCustomerName = _data["assetCountByManufacturerCustomerName"];
        }
    }

    static fromJS(data: any): CustomerNameLocationData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerNameLocationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerCustomerName"] = this.manufacturerCustomerName;
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["assetCountByManufacturerCustomerName"] = this.assetCountByManufacturerCustomerName;
        return data;
    }
}

export interface ICustomerNameLocationData {
    manufacturerCustomerName?: string | undefined;
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    assetCountByManufacturerCustomerName?: number;
}

export class ExpiringAssetCounts implements IExpiringAssetCounts {
    subscriptionCount?: number;
    enterpriseAgreementCount?: number;
    smartnetCount?: number;
    ciscoHardwareCount?: number;
    merakiHardwareCount?: number;

    constructor(data?: IExpiringAssetCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionCount = _data["subscriptionCount"];
            this.enterpriseAgreementCount = _data["enterpriseAgreementCount"];
            this.smartnetCount = _data["smartnetCount"];
            this.ciscoHardwareCount = _data["ciscoHardwareCount"];
            this.merakiHardwareCount = _data["merakiHardwareCount"];
        }
    }

    static fromJS(data: any): ExpiringAssetCounts {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringAssetCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionCount"] = this.subscriptionCount;
        data["enterpriseAgreementCount"] = this.enterpriseAgreementCount;
        data["smartnetCount"] = this.smartnetCount;
        data["ciscoHardwareCount"] = this.ciscoHardwareCount;
        data["merakiHardwareCount"] = this.merakiHardwareCount;
        return data;
    }
}

export interface IExpiringAssetCounts {
    subscriptionCount?: number;
    enterpriseAgreementCount?: number;
    smartnetCount?: number;
    ciscoHardwareCount?: number;
    merakiHardwareCount?: number;
}

export class GetCiscoEaHealthWidgetResponse implements IGetCiscoEaHealthWidgetResponse {
    consumption?: number | undefined;
    tripReportNumberLast6Months?: number | undefined;
    averageTripReportScore?: number | undefined;
    overallHealthScore?: number | undefined;

    constructor(data?: IGetCiscoEaHealthWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumption = _data["consumption"];
            this.tripReportNumberLast6Months = _data["tripReportNumberLast6Months"];
            this.averageTripReportScore = _data["averageTripReportScore"];
            this.overallHealthScore = _data["overallHealthScore"];
        }
    }

    static fromJS(data: any): GetCiscoEaHealthWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCiscoEaHealthWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumption"] = this.consumption;
        data["tripReportNumberLast6Months"] = this.tripReportNumberLast6Months;
        data["averageTripReportScore"] = this.averageTripReportScore;
        data["overallHealthScore"] = this.overallHealthScore;
        return data;
    }
}

export interface IGetCiscoEaHealthWidgetResponse {
    consumption?: number | undefined;
    tripReportNumberLast6Months?: number | undefined;
    averageTripReportScore?: number | undefined;
    overallHealthScore?: number | undefined;
}

export class GetCiscoIbaEaDetailResponse implements IGetCiscoIbaEaDetailResponse {
    eaDetails!: CiscoIbaEaDetailDto[] | undefined;
    totalPurchased!: number;
    totalGenerated!: number;

    constructor(data?: IGetCiscoIbaEaDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["eaDetails"])) {
                this.eaDetails = [] as any;
                for (let item of _data["eaDetails"])
                    this.eaDetails!.push(CiscoIbaEaDetailDto.fromJS(item));
            }
            this.totalPurchased = _data["totalPurchased"];
            this.totalGenerated = _data["totalGenerated"];
        }
    }

    static fromJS(data: any): GetCiscoIbaEaDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCiscoIbaEaDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.eaDetails)) {
            data["eaDetails"] = [];
            for (let item of this.eaDetails)
                data["eaDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalPurchased"] = this.totalPurchased;
        data["totalGenerated"] = this.totalGenerated;
        return data;
    }
}

export interface IGetCiscoIbaEaDetailResponse {
    eaDetails: CiscoIbaEaDetailDto[] | undefined;
    totalPurchased: number;
    totalGenerated: number;
}

export class GlobalLocationData implements IGlobalLocationData {
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    assetCountByManufacturerGlobal?: number;

    constructor(data?: IGlobalLocationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.assetCountByManufacturerGlobal = _data["assetCountByManufacturerGlobal"];
        }
    }

    static fromJS(data: any): GlobalLocationData {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalLocationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["assetCountByManufacturerGlobal"] = this.assetCountByManufacturerGlobal;
        return data;
    }
}

export interface IGlobalLocationData {
    manufacturerGlobalCustomerId?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    assetCountByManufacturerGlobal?: number;
}

export class GuidsWidgetResponse implements IGuidsWidgetResponse {
    guids?: CiscoIbaGuidsDto[] | undefined;

    constructor(data?: IGuidsWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["guids"])) {
                this.guids = [] as any;
                for (let item of _data["guids"])
                    this.guids!.push(CiscoIbaGuidsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GuidsWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GuidsWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.guids)) {
            data["guids"] = [];
            for (let item of this.guids)
                data["guids"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGuidsWidgetResponse {
    guids?: CiscoIbaGuidsDto[] | undefined;
}

export class ShiCategoryGroup implements IShiCategoryGroup {
    shiCategory?: string | undefined;
    subCategory?: SubCategoryGroup[] | undefined;

    constructor(data?: IShiCategoryGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiCategory = _data["shiCategory"];
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(SubCategoryGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiCategoryGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ShiCategoryGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiCategory"] = this.shiCategory;
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShiCategoryGroup {
    shiCategory?: string | undefined;
    subCategory?: SubCategoryGroup[] | undefined;
}

export class SiteLocationGroup implements ISiteLocationGroup {
    siteLocation?: string | undefined;
    locationAddress?: string[] | undefined;

    constructor(data?: ISiteLocationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteLocation = _data["siteLocation"];
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): SiteLocationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SiteLocationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteLocation"] = this.siteLocation;
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        return data;
    }
}

export interface ISiteLocationGroup {
    siteLocation?: string | undefined;
    locationAddress?: string[] | undefined;
}

export class SmartNetSlasWidgetResponse implements ISmartNetSlasWidgetResponse {
    smartNetSlas?: CiscoIbaSmartNetSlaDto[] | undefined;

    constructor(data?: ISmartNetSlasWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["smartNetSlas"])) {
                this.smartNetSlas = [] as any;
                for (let item of _data["smartNetSlas"])
                    this.smartNetSlas!.push(CiscoIbaSmartNetSlaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SmartNetSlasWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SmartNetSlasWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.smartNetSlas)) {
            data["smartNetSlas"] = [];
            for (let item of this.smartNetSlas)
                data["smartNetSlas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISmartNetSlasWidgetResponse {
    smartNetSlas?: CiscoIbaSmartNetSlaDto[] | undefined;
}

export class SubCategoryGroup implements ISubCategoryGroup {
    subCategory?: string | undefined;
    microCategory?: string[] | undefined;

    constructor(data?: ISubCategoryGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory = _data["subCategory"];
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
        }
    }

    static fromJS(data: any): SubCategoryGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory"] = this.subCategory;
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        return data;
    }
}

export interface ISubCategoryGroup {
    subCategory?: string | undefined;
    microCategory?: string[] | undefined;
}

export class CiscoIbaAssetDto implements ICiscoIbaAssetDto {
    uniqueIdentifier?: string | undefined;
    displayName?: string | undefined;
    assetId?: string | undefined;
    product?: string | undefined;
    itemQuantity?: number;
    serialNumber?: string | undefined;
    assetType?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    productDescription?: string | undefined;
    coveredEndDate?: Date | undefined;
    coveredStatus?: string | undefined;
    contractType?: string | undefined;
    endOfSoftwareMaintenanceDate?: Date | undefined;
    lastDateOfSupport?: Date | undefined;
    displayLocationName?: string | undefined;
    locationAddress?: string | undefined;
    siteLocation?: string | undefined;
    tags?: string[] | undefined;
    manufacturer?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    accountIdentifier?: string | undefined;

    constructor(data?: ICiscoIbaAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.displayName = _data["displayName"];
            this.assetId = _data["assetId"];
            this.product = _data["product"];
            this.itemQuantity = _data["itemQuantity"];
            this.serialNumber = _data["serialNumber"];
            this.assetType = _data["assetType"];
            this.shiCategory = _data["shiCategory"];
            this.subCategory = _data["subCategory"];
            this.productDescription = _data["productDescription"];
            this.coveredEndDate = _data["coveredEndDate"] ? new Date(_data["coveredEndDate"].toString()) : undefined as any;
            this.coveredStatus = _data["coveredStatus"];
            this.contractType = _data["contractType"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"] ? new Date(_data["endOfSoftwareMaintenanceDate"].toString()) : undefined as any;
            this.lastDateOfSupport = _data["lastDateOfSupport"] ? new Date(_data["lastDateOfSupport"].toString()) : undefined as any;
            this.displayLocationName = _data["displayLocationName"];
            this.locationAddress = _data["locationAddress"];
            this.siteLocation = _data["siteLocation"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.manufacturer = _data["manufacturer"];
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.accountIdentifier = _data["accountIdentifier"];
        }
    }

    static fromJS(data: any): CiscoIbaAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["displayName"] = this.displayName;
        data["assetId"] = this.assetId;
        data["product"] = this.product;
        data["itemQuantity"] = this.itemQuantity;
        data["serialNumber"] = this.serialNumber;
        data["assetType"] = this.assetType;
        data["shiCategory"] = this.shiCategory;
        data["subCategory"] = this.subCategory;
        data["productDescription"] = this.productDescription;
        data["coveredEndDate"] = this.coveredEndDate ? this.coveredEndDate.toISOString() : undefined as any;
        data["coveredStatus"] = this.coveredStatus;
        data["contractType"] = this.contractType;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate ? this.endOfSoftwareMaintenanceDate.toISOString() : undefined as any;
        data["lastDateOfSupport"] = this.lastDateOfSupport ? this.lastDateOfSupport.toISOString() : undefined as any;
        data["displayLocationName"] = this.displayLocationName;
        data["locationAddress"] = this.locationAddress;
        data["siteLocation"] = this.siteLocation;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["manufacturer"] = this.manufacturer;
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["accountIdentifier"] = this.accountIdentifier;
        return data;
    }
}

export interface ICiscoIbaAssetDto {
    uniqueIdentifier?: string | undefined;
    displayName?: string | undefined;
    assetId?: string | undefined;
    product?: string | undefined;
    itemQuantity?: number;
    serialNumber?: string | undefined;
    assetType?: string | undefined;
    shiCategory?: string | undefined;
    subCategory?: string | undefined;
    productDescription?: string | undefined;
    coveredEndDate?: Date | undefined;
    coveredStatus?: string | undefined;
    contractType?: string | undefined;
    endOfSoftwareMaintenanceDate?: Date | undefined;
    lastDateOfSupport?: Date | undefined;
    displayLocationName?: string | undefined;
    locationAddress?: string | undefined;
    siteLocation?: string | undefined;
    tags?: string[] | undefined;
    manufacturer?: string | undefined;
    manufacturerGlobalCustomerName?: string | undefined;
    accountIdentifier?: string | undefined;
}

export class CiscoIbaAssetsArchitectureLdosAssetDetailsDto implements ICiscoIbaAssetsArchitectureLdosAssetDetailsDto {
    architecture!: string | undefined;
    totalAssetCount?: number;

    constructor(data?: ICiscoIbaAssetsArchitectureLdosAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.architecture = _data["architecture"];
            this.totalAssetCount = _data["totalAssetCount"];
        }
    }

    static fromJS(data: any): CiscoIbaAssetsArchitectureLdosAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsArchitectureLdosAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["architecture"] = this.architecture;
        data["totalAssetCount"] = this.totalAssetCount;
        return data;
    }
}

export interface ICiscoIbaAssetsArchitectureLdosAssetDetailsDto {
    architecture: string | undefined;
    totalAssetCount?: number;
}

export class CiscoIbaAssetsArchitectureLdosDto implements ICiscoIbaAssetsArchitectureLdosDto {
    year!: number;
    assetDetails!: CiscoIbaAssetsArchitectureLdosAssetDetailsDto[] | undefined;

    constructor(data?: ICiscoIbaAssetsArchitectureLdosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["assetDetails"])) {
                this.assetDetails = [] as any;
                for (let item of _data["assetDetails"])
                    this.assetDetails!.push(CiscoIbaAssetsArchitectureLdosAssetDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CiscoIbaAssetsArchitectureLdosDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsArchitectureLdosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.assetDetails)) {
            data["assetDetails"] = [];
            for (let item of this.assetDetails)
                data["assetDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICiscoIbaAssetsArchitectureLdosDto {
    year: number;
    assetDetails: CiscoIbaAssetsArchitectureLdosAssetDetailsDto[] | undefined;
}

export class CiscoIbaSearchFilterDto implements ICiscoIbaSearchFilterDto {
    assetType?: string[] | undefined;
    category?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    productFamily?: string[] | undefined;
    productType?: string[] | undefined;
    tags?: string[] | undefined;
    manufacturerGlobalCustomerName?: string[] | undefined;
    manufacturerCustomerName?: string[] | undefined;
    siteLocation?: string[] | undefined;
    locationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    coveredEndDate?: string[] | undefined;
    endOfLife?: string[] | undefined;
    endOfSaleDate?: string[] | undefined;
    endOfSoftwareMaintenanceDate?: string[] | undefined;
    lastDateOfSupport?: string[] | undefined;
    shipDate?: string[] | undefined;
    serviceCost?: string[] | undefined;
    displayName?: string[] | undefined;

    protected _discriminator: string;

    constructor(data?: ICiscoIbaSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "CiscoIbaSearchFilterDto";
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assetType"])) {
                this.assetType = [] as any;
                for (let item of _data["assetType"])
                    this.assetType!.push(item);
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            if (Array.isArray(_data["coveredStatus"])) {
                this.coveredStatus = [] as any;
                for (let item of _data["coveredStatus"])
                    this.coveredStatus!.push(item);
            }
            if (Array.isArray(_data["shiCategory"])) {
                this.shiCategory = [] as any;
                for (let item of _data["shiCategory"])
                    this.shiCategory!.push(item);
            }
            if (Array.isArray(_data["subCategory"])) {
                this.subCategory = [] as any;
                for (let item of _data["subCategory"])
                    this.subCategory!.push(item);
            }
            if (Array.isArray(_data["microCategory"])) {
                this.microCategory = [] as any;
                for (let item of _data["microCategory"])
                    this.microCategory!.push(item);
            }
            if (Array.isArray(_data["productFamily"])) {
                this.productFamily = [] as any;
                for (let item of _data["productFamily"])
                    this.productFamily!.push(item);
            }
            if (Array.isArray(_data["productType"])) {
                this.productType = [] as any;
                for (let item of _data["productType"])
                    this.productType!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["manufacturerGlobalCustomerName"])) {
                this.manufacturerGlobalCustomerName = [] as any;
                for (let item of _data["manufacturerGlobalCustomerName"])
                    this.manufacturerGlobalCustomerName!.push(item);
            }
            if (Array.isArray(_data["manufacturerCustomerName"])) {
                this.manufacturerCustomerName = [] as any;
                for (let item of _data["manufacturerCustomerName"])
                    this.manufacturerCustomerName!.push(item);
            }
            if (Array.isArray(_data["siteLocation"])) {
                this.siteLocation = [] as any;
                for (let item of _data["siteLocation"])
                    this.siteLocation!.push(item);
            }
            if (Array.isArray(_data["locationName"])) {
                this.locationName = [] as any;
                for (let item of _data["locationName"])
                    this.locationName!.push(item);
            }
            if (Array.isArray(_data["locationAddress"])) {
                this.locationAddress = [] as any;
                for (let item of _data["locationAddress"])
                    this.locationAddress!.push(item);
            }
            if (Array.isArray(_data["serviceLevelAgreement"])) {
                this.serviceLevelAgreement = [] as any;
                for (let item of _data["serviceLevelAgreement"])
                    this.serviceLevelAgreement!.push(item);
            }
            if (Array.isArray(_data["coveredEndDate"])) {
                this.coveredEndDate = [] as any;
                for (let item of _data["coveredEndDate"])
                    this.coveredEndDate!.push(item);
            }
            if (Array.isArray(_data["endOfLife"])) {
                this.endOfLife = [] as any;
                for (let item of _data["endOfLife"])
                    this.endOfLife!.push(item);
            }
            if (Array.isArray(_data["endOfSaleDate"])) {
                this.endOfSaleDate = [] as any;
                for (let item of _data["endOfSaleDate"])
                    this.endOfSaleDate!.push(item);
            }
            if (Array.isArray(_data["endOfSoftwareMaintenanceDate"])) {
                this.endOfSoftwareMaintenanceDate = [] as any;
                for (let item of _data["endOfSoftwareMaintenanceDate"])
                    this.endOfSoftwareMaintenanceDate!.push(item);
            }
            if (Array.isArray(_data["lastDateOfSupport"])) {
                this.lastDateOfSupport = [] as any;
                for (let item of _data["lastDateOfSupport"])
                    this.lastDateOfSupport!.push(item);
            }
            if (Array.isArray(_data["shipDate"])) {
                this.shipDate = [] as any;
                for (let item of _data["shipDate"])
                    this.shipDate!.push(item);
            }
            if (Array.isArray(_data["serviceCost"])) {
                this.serviceCost = [] as any;
                for (let item of _data["serviceCost"])
                    this.serviceCost!.push(item);
            }
            if (Array.isArray(_data["displayName"])) {
                this.displayName = [] as any;
                for (let item of _data["displayName"])
                    this.displayName!.push(item);
            }
        }
    }

    static fromJS(data: any): CiscoIbaSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "CiscoIbaAssetsSearchFilterDto") {
            let result = new CiscoIbaAssetsSearchFilterDto();
            result.init(data);
            return result;
        }
        let result = new CiscoIbaSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        if (Array.isArray(this.assetType)) {
            data["assetType"] = [];
            for (let item of this.assetType)
                data["assetType"].push(item);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        if (Array.isArray(this.coveredStatus)) {
            data["coveredStatus"] = [];
            for (let item of this.coveredStatus)
                data["coveredStatus"].push(item);
        }
        if (Array.isArray(this.shiCategory)) {
            data["shiCategory"] = [];
            for (let item of this.shiCategory)
                data["shiCategory"].push(item);
        }
        if (Array.isArray(this.subCategory)) {
            data["subCategory"] = [];
            for (let item of this.subCategory)
                data["subCategory"].push(item);
        }
        if (Array.isArray(this.microCategory)) {
            data["microCategory"] = [];
            for (let item of this.microCategory)
                data["microCategory"].push(item);
        }
        if (Array.isArray(this.productFamily)) {
            data["productFamily"] = [];
            for (let item of this.productFamily)
                data["productFamily"].push(item);
        }
        if (Array.isArray(this.productType)) {
            data["productType"] = [];
            for (let item of this.productType)
                data["productType"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.manufacturerGlobalCustomerName)) {
            data["manufacturerGlobalCustomerName"] = [];
            for (let item of this.manufacturerGlobalCustomerName)
                data["manufacturerGlobalCustomerName"].push(item);
        }
        if (Array.isArray(this.manufacturerCustomerName)) {
            data["manufacturerCustomerName"] = [];
            for (let item of this.manufacturerCustomerName)
                data["manufacturerCustomerName"].push(item);
        }
        if (Array.isArray(this.siteLocation)) {
            data["siteLocation"] = [];
            for (let item of this.siteLocation)
                data["siteLocation"].push(item);
        }
        if (Array.isArray(this.locationName)) {
            data["locationName"] = [];
            for (let item of this.locationName)
                data["locationName"].push(item);
        }
        if (Array.isArray(this.locationAddress)) {
            data["locationAddress"] = [];
            for (let item of this.locationAddress)
                data["locationAddress"].push(item);
        }
        if (Array.isArray(this.serviceLevelAgreement)) {
            data["serviceLevelAgreement"] = [];
            for (let item of this.serviceLevelAgreement)
                data["serviceLevelAgreement"].push(item);
        }
        if (Array.isArray(this.coveredEndDate)) {
            data["coveredEndDate"] = [];
            for (let item of this.coveredEndDate)
                data["coveredEndDate"].push(item);
        }
        if (Array.isArray(this.endOfLife)) {
            data["endOfLife"] = [];
            for (let item of this.endOfLife)
                data["endOfLife"].push(item);
        }
        if (Array.isArray(this.endOfSaleDate)) {
            data["endOfSaleDate"] = [];
            for (let item of this.endOfSaleDate)
                data["endOfSaleDate"].push(item);
        }
        if (Array.isArray(this.endOfSoftwareMaintenanceDate)) {
            data["endOfSoftwareMaintenanceDate"] = [];
            for (let item of this.endOfSoftwareMaintenanceDate)
                data["endOfSoftwareMaintenanceDate"].push(item);
        }
        if (Array.isArray(this.lastDateOfSupport)) {
            data["lastDateOfSupport"] = [];
            for (let item of this.lastDateOfSupport)
                data["lastDateOfSupport"].push(item);
        }
        if (Array.isArray(this.shipDate)) {
            data["shipDate"] = [];
            for (let item of this.shipDate)
                data["shipDate"].push(item);
        }
        if (Array.isArray(this.serviceCost)) {
            data["serviceCost"] = [];
            for (let item of this.serviceCost)
                data["serviceCost"].push(item);
        }
        if (Array.isArray(this.displayName)) {
            data["displayName"] = [];
            for (let item of this.displayName)
                data["displayName"].push(item);
        }
        return data;
    }
}

export interface ICiscoIbaSearchFilterDto {
    assetType?: string[] | undefined;
    category?: string[] | undefined;
    coveredStatus?: string[] | undefined;
    shiCategory?: string[] | undefined;
    subCategory?: string[] | undefined;
    microCategory?: string[] | undefined;
    productFamily?: string[] | undefined;
    productType?: string[] | undefined;
    tags?: string[] | undefined;
    manufacturerGlobalCustomerName?: string[] | undefined;
    manufacturerCustomerName?: string[] | undefined;
    siteLocation?: string[] | undefined;
    locationName?: string[] | undefined;
    locationAddress?: string[] | undefined;
    serviceLevelAgreement?: string[] | undefined;
    coveredEndDate?: string[] | undefined;
    endOfLife?: string[] | undefined;
    endOfSaleDate?: string[] | undefined;
    endOfSoftwareMaintenanceDate?: string[] | undefined;
    lastDateOfSupport?: string[] | undefined;
    shipDate?: string[] | undefined;
    serviceCost?: string[] | undefined;
    displayName?: string[] | undefined;
}

export class CiscoIbaAssetsSearchFilterDto extends CiscoIbaSearchFilterDto implements ICiscoIbaAssetsSearchFilterDto {
    product?: string[] | undefined;
    manufacturerGlobalCustomerId?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationCountry?: string[] | undefined;
    locationState?: string[] | undefined;

    constructor(data?: ICiscoIbaAssetsSearchFilterDto) {
        super(data);
        this._discriminator = "CiscoIbaAssetsSearchFilterDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["manufacturerGlobalCustomerId"])) {
                this.manufacturerGlobalCustomerId = [] as any;
                for (let item of _data["manufacturerGlobalCustomerId"])
                    this.manufacturerGlobalCustomerId!.push(item);
            }
            if (Array.isArray(_data["locationCity"])) {
                this.locationCity = [] as any;
                for (let item of _data["locationCity"])
                    this.locationCity!.push(item);
            }
            if (Array.isArray(_data["locationCountry"])) {
                this.locationCountry = [] as any;
                for (let item of _data["locationCountry"])
                    this.locationCountry!.push(item);
            }
            if (Array.isArray(_data["locationState"])) {
                this.locationState = [] as any;
                for (let item of _data["locationState"])
                    this.locationState!.push(item);
            }
        }
    }

    static override fromJS(data: any): CiscoIbaAssetsSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaAssetsSearchFilterDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.manufacturerGlobalCustomerId)) {
            data["manufacturerGlobalCustomerId"] = [];
            for (let item of this.manufacturerGlobalCustomerId)
                data["manufacturerGlobalCustomerId"].push(item);
        }
        if (Array.isArray(this.locationCity)) {
            data["locationCity"] = [];
            for (let item of this.locationCity)
                data["locationCity"].push(item);
        }
        if (Array.isArray(this.locationCountry)) {
            data["locationCountry"] = [];
            for (let item of this.locationCountry)
                data["locationCountry"].push(item);
        }
        if (Array.isArray(this.locationState)) {
            data["locationState"] = [];
            for (let item of this.locationState)
                data["locationState"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoIbaAssetsSearchFilterDto extends ICiscoIbaSearchFilterDto {
    product?: string[] | undefined;
    manufacturerGlobalCustomerId?: string[] | undefined;
    locationCity?: string[] | undefined;
    locationCountry?: string[] | undefined;
    locationState?: string[] | undefined;
}

export class CiscoIbaEaDto implements ICiscoIbaEaDto {
    enterpriseAgreement?: string | undefined;
    contractType?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalPurchased?: number | undefined;
    totalGenerated?: number | undefined;
    balance?: number | undefined;
    trueForwardDue?: number | undefined;
    nextTrueForward?: Date | undefined;
    smartAccount?: string | undefined;
    suite?: string | undefined;
    healthMessage?: string | undefined;

    constructor(data?: ICiscoIbaEaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseAgreement = _data["enterpriseAgreement"];
            this.contractType = _data["contractType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.totalPurchased = _data["totalPurchased"];
            this.totalGenerated = _data["totalGenerated"];
            this.balance = _data["balance"];
            this.trueForwardDue = _data["trueForwardDue"];
            this.nextTrueForward = _data["nextTrueForward"] ? new Date(_data["nextTrueForward"].toString()) : undefined as any;
            this.smartAccount = _data["smartAccount"];
            this.suite = _data["suite"];
            this.healthMessage = _data["healthMessage"];
        }
    }

    static fromJS(data: any): CiscoIbaEaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaEaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseAgreement"] = this.enterpriseAgreement;
        data["contractType"] = this.contractType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["totalPurchased"] = this.totalPurchased;
        data["totalGenerated"] = this.totalGenerated;
        data["balance"] = this.balance;
        data["trueForwardDue"] = this.trueForwardDue;
        data["nextTrueForward"] = this.nextTrueForward ? this.nextTrueForward.toISOString() : undefined as any;
        data["smartAccount"] = this.smartAccount;
        data["suite"] = this.suite;
        data["healthMessage"] = this.healthMessage;
        return data;
    }
}

export interface ICiscoIbaEaDto {
    enterpriseAgreement?: string | undefined;
    contractType?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalPurchased?: number | undefined;
    totalGenerated?: number | undefined;
    balance?: number | undefined;
    trueForwardDue?: number | undefined;
    nextTrueForward?: Date | undefined;
    smartAccount?: string | undefined;
    suite?: string | undefined;
    healthMessage?: string | undefined;
}

export class CiscoIbaGuidsDto implements ICiscoIbaGuidsDto {
    manufacturerGlobalCustomerName!: string | undefined;
    manufacturerGlobalCustomerId!: string | undefined;
    partiesCount?: number;
    assetsCount?: number;

    constructor(data?: ICiscoIbaGuidsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturerGlobalCustomerName = _data["manufacturerGlobalCustomerName"];
            this.manufacturerGlobalCustomerId = _data["manufacturerGlobalCustomerId"];
            this.partiesCount = _data["partiesCount"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): CiscoIbaGuidsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaGuidsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerGlobalCustomerName"] = this.manufacturerGlobalCustomerName;
        data["manufacturerGlobalCustomerId"] = this.manufacturerGlobalCustomerId;
        data["partiesCount"] = this.partiesCount;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface ICiscoIbaGuidsDto {
    manufacturerGlobalCustomerName: string | undefined;
    manufacturerGlobalCustomerId: string | undefined;
    partiesCount?: number;
    assetsCount?: number;
}

export class CiscoIbaLdosDto implements ICiscoIbaLdosDto {
    product!: string | undefined;
    documentCount?: number | undefined;
    coverageDetails!: CiscoIbaLdosDtoCoverageDetailsDto[] | undefined;
    ldos?: string | undefined;

    constructor(data?: ICiscoIbaLdosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"];
            this.documentCount = _data["documentCount"];
            if (Array.isArray(_data["coverageDetails"])) {
                this.coverageDetails = [] as any;
                for (let item of _data["coverageDetails"])
                    this.coverageDetails!.push(CiscoIbaLdosDtoCoverageDetailsDto.fromJS(item));
            }
            this.ldos = _data["ldos"];
        }
    }

    static fromJS(data: any): CiscoIbaLdosDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLdosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["documentCount"] = this.documentCount;
        if (Array.isArray(this.coverageDetails)) {
            data["coverageDetails"] = [];
            for (let item of this.coverageDetails)
                data["coverageDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["ldos"] = this.ldos;
        return data;
    }
}

export interface ICiscoIbaLdosDto {
    product: string | undefined;
    documentCount?: number | undefined;
    coverageDetails: CiscoIbaLdosDtoCoverageDetailsDto[] | undefined;
    ldos?: string | undefined;
}

export class CiscoIbaLdosDtoCoverageDetailsDto implements ICiscoIbaLdosDtoCoverageDetailsDto {
    coveredStatus!: string | undefined;
    count?: number | undefined;

    constructor(data?: ICiscoIbaLdosDtoCoverageDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coveredStatus = _data["coveredStatus"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CiscoIbaLdosDtoCoverageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaLdosDtoCoverageDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coveredStatus"] = this.coveredStatus;
        data["count"] = this.count;
        return data;
    }
}

export interface ICiscoIbaLdosDtoCoverageDetailsDto {
    coveredStatus: string | undefined;
    count?: number | undefined;
}

export class CiscoIbaProductDto implements ICiscoIbaProductDto {
    product!: string | undefined;
    assetType?: string | undefined;
    assetsCount?: number;
    endOfSoftwareMaintenanceDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    coveredLineStatus?: string | undefined;
    minCoveredEndDate?: string | undefined;
    migrationProductId?: string | undefined;
    migrationProductInfoUrl?: string | undefined;
    tags?: string[] | undefined;
    contractTypes?: string[] | undefined;

    constructor(data?: ICiscoIbaProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"];
            this.assetType = _data["assetType"];
            this.assetsCount = _data["assetsCount"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.lastDateOfSupport = _data["lastDateOfSupport"];
            this.coveredLineStatus = _data["coveredLineStatus"];
            this.minCoveredEndDate = _data["minCoveredEndDate"];
            this.migrationProductId = _data["migrationProductId"];
            this.migrationProductInfoUrl = _data["migrationProductInfoUrl"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): CiscoIbaProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["assetType"] = this.assetType;
        data["assetsCount"] = this.assetsCount;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["lastDateOfSupport"] = this.lastDateOfSupport;
        data["coveredLineStatus"] = this.coveredLineStatus;
        data["minCoveredEndDate"] = this.minCoveredEndDate;
        data["migrationProductId"] = this.migrationProductId;
        data["migrationProductInfoUrl"] = this.migrationProductInfoUrl;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item);
        }
        return data;
    }
}

export interface ICiscoIbaProductDto {
    product: string | undefined;
    assetType?: string | undefined;
    assetsCount?: number;
    endOfSoftwareMaintenanceDate?: string | undefined;
    lastDateOfSupport?: string | undefined;
    coveredLineStatus?: string | undefined;
    minCoveredEndDate?: string | undefined;
    migrationProductId?: string | undefined;
    migrationProductInfoUrl?: string | undefined;
    tags?: string[] | undefined;
    contractTypes?: string[] | undefined;
}

export class CiscoIbaProductSummaryDto implements ICiscoIbaProductSummaryDto {
    productsCount?: number;
    totalAssetsCounts?: number;

    constructor(data?: ICiscoIbaProductSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productsCount = _data["productsCount"];
            this.totalAssetsCounts = _data["totalAssetsCounts"];
        }
    }

    static fromJS(data: any): CiscoIbaProductSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaProductSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productsCount"] = this.productsCount;
        data["totalAssetsCounts"] = this.totalAssetsCounts;
        return data;
    }
}

export interface ICiscoIbaProductSummaryDto {
    productsCount?: number;
    totalAssetsCounts?: number;
}

export class CiscoIbaShippedHardwareCiscoDto implements ICiscoIbaShippedHardwareCiscoDto {
    coveredStatus!: string | undefined;
    itemQuantity!: number;

    constructor(data?: ICiscoIbaShippedHardwareCiscoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coveredStatus = _data["coveredStatus"];
            this.itemQuantity = _data["itemQuantity"];
        }
    }

    static fromJS(data: any): CiscoIbaShippedHardwareCiscoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaShippedHardwareCiscoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coveredStatus"] = this.coveredStatus;
        data["itemQuantity"] = this.itemQuantity;
        return data;
    }
}

export interface ICiscoIbaShippedHardwareCiscoDto {
    coveredStatus: string | undefined;
    itemQuantity: number;
}

export class CiscoIbaShippedHardwareMerakiDto implements ICiscoIbaShippedHardwareMerakiDto {
    microCategory!: string | undefined;
    itemQuantity!: number;

    constructor(data?: ICiscoIbaShippedHardwareMerakiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.microCategory = _data["microCategory"];
            this.itemQuantity = _data["itemQuantity"];
        }
    }

    static fromJS(data: any): CiscoIbaShippedHardwareMerakiDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaShippedHardwareMerakiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["microCategory"] = this.microCategory;
        data["itemQuantity"] = this.itemQuantity;
        return data;
    }
}

export interface ICiscoIbaShippedHardwareMerakiDto {
    microCategory: string | undefined;
    itemQuantity: number;
}

export class CiscoIbaSmartNetSlaDto implements ICiscoIbaSmartNetSlaDto {
    serviceLevelAgreement!: string | undefined;
    serviceLevelDescription!: string | undefined;
    assetsCount?: number;

    constructor(data?: ICiscoIbaSmartNetSlaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceLevelAgreement = _data["serviceLevelAgreement"];
            this.serviceLevelDescription = _data["serviceLevelDescription"];
            this.assetsCount = _data["assetsCount"];
        }
    }

    static fromJS(data: any): CiscoIbaSmartNetSlaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoIbaSmartNetSlaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceLevelAgreement"] = this.serviceLevelAgreement;
        data["serviceLevelDescription"] = this.serviceLevelDescription;
        data["assetsCount"] = this.assetsCount;
        return data;
    }
}

export interface ICiscoIbaSmartNetSlaDto {
    serviceLevelAgreement: string | undefined;
    serviceLevelDescription: string | undefined;
    assetsCount?: number;
}

export class RoadmapsAssetsSearchResponse implements IRoadmapsAssetsSearchResponse {
    assets?: Asset[] | undefined;
    totalAssetsCount?: number;
    roadmapsAssetsSearchRequest?: RoadmapsAssetsSearchRequestDto;

    constructor(data?: IRoadmapsAssetsSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(Asset.fromJS(item));
            }
            this.totalAssetsCount = _data["totalAssetsCount"];
            this.roadmapsAssetsSearchRequest = _data["roadmapsAssetsSearchRequest"] ? RoadmapsAssetsSearchRequestDto.fromJS(_data["roadmapsAssetsSearchRequest"]) : undefined as any;
        }
    }

    static fromJS(data: any): RoadmapsAssetsSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapsAssetsSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalAssetsCount"] = this.totalAssetsCount;
        data["roadmapsAssetsSearchRequest"] = this.roadmapsAssetsSearchRequest ? this.roadmapsAssetsSearchRequest.toJSON() : undefined as any;
        return data;
    }
}

export interface IRoadmapsAssetsSearchResponse {
    assets?: Asset[] | undefined;
    totalAssetsCount?: number;
    roadmapsAssetsSearchRequest?: RoadmapsAssetsSearchRequestDto;
}

export class RoadmapInfoDto implements IRoadmapInfoDto {
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;
    isVisibleToCustomer?: boolean;
    isDeleted?: boolean;
    isRoadmapItemDeleted?: boolean;
    roadmapItemId?: string;

    constructor(data?: IRoadmapInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roadmapId = _data["roadmapId"];
            this.roadmapName = _data["roadmapName"];
            this.isVisibleToCustomer = _data["isVisibleToCustomer"];
            this.isDeleted = _data["isDeleted"];
            this.isRoadmapItemDeleted = _data["isRoadmapItemDeleted"];
            this.roadmapItemId = _data["roadmapItemId"];
        }
    }

    static fromJS(data: any): RoadmapInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roadmapId"] = this.roadmapId;
        data["roadmapName"] = this.roadmapName;
        data["isVisibleToCustomer"] = this.isVisibleToCustomer;
        data["isDeleted"] = this.isDeleted;
        data["isRoadmapItemDeleted"] = this.isRoadmapItemDeleted;
        data["roadmapItemId"] = this.roadmapItemId;
        return data;
    }
}

export interface IRoadmapInfoDto {
    roadmapId?: string | undefined;
    roadmapName?: string | undefined;
    isVisibleToCustomer?: boolean;
    isDeleted?: boolean;
    isRoadmapItemDeleted?: boolean;
    roadmapItemId?: string;
}

export class RoadmapsAssetsSearchFilterDto implements IRoadmapsAssetsSearchFilterDto {
    id?: number;
    isExclude?: boolean;
    contractId?: string | undefined;
    displayLocationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;

    constructor(data?: IRoadmapsAssetsSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isExclude = _data["isExclude"];
            this.contractId = _data["contractId"];
            this.displayLocationName = _data["displayLocationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationCountry = _data["locationCountry"];
        }
    }

    static fromJS(data: any): RoadmapsAssetsSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadmapsAssetsSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isExclude"] = this.isExclude;
        data["contractId"] = this.contractId;
        data["displayLocationName"] = this.displayLocationName;
        data["locationAddress"] = this.locationAddress;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationCountry"] = this.locationCountry;
        return data;
    }
}

export interface IRoadmapsAssetsSearchFilterDto {
    id?: number;
    isExclude?: boolean;
    contractId?: string | undefined;
    displayLocationName?: string | undefined;
    locationAddress?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationCountry?: string | undefined;
}

export class CreateUpdateSecretDto implements ICreateUpdateSecretDto {
    integrationType!: IntegrationType;
    friendlyKeyName!: string | undefined;
    axNumber!: string | undefined;
    keyValue!: string | undefined;

    constructor(data?: ICreateUpdateSecretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.friendlyKeyName = _data["friendlyKeyName"];
            this.axNumber = _data["axNumber"];
            this.keyValue = _data["keyValue"];
        }
    }

    static fromJS(data: any): CreateUpdateSecretDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateSecretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["friendlyKeyName"] = this.friendlyKeyName;
        data["axNumber"] = this.axNumber;
        data["keyValue"] = this.keyValue;
        return data;
    }
}

export interface ICreateUpdateSecretDto {
    integrationType: IntegrationType;
    friendlyKeyName: string | undefined;
    axNumber: string | undefined;
    keyValue: string | undefined;
}

export class DeleteSecretDto implements IDeleteSecretDto {
    keyName!: string | undefined;
    axNumber!: string | undefined;

    constructor(data?: IDeleteSecretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyName = _data["keyName"];
            this.axNumber = _data["axNumber"];
        }
    }

    static fromJS(data: any): DeleteSecretDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSecretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyName"] = this.keyName;
        data["axNumber"] = this.axNumber;
        return data;
    }
}

export interface IDeleteSecretDto {
    keyName: string | undefined;
    axNumber: string | undefined;
}

export class GetSecretDto implements IGetSecretDto {
    keyName!: string | undefined;
    axNumber!: string | undefined;

    constructor(data?: IGetSecretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyName = _data["keyName"];
            this.axNumber = _data["axNumber"];
        }
    }

    static fromJS(data: any): GetSecretDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyName"] = this.keyName;
        data["axNumber"] = this.axNumber;
        return data;
    }
}

export interface IGetSecretDto {
    keyName: string | undefined;
    axNumber: string | undefined;
}

export class AccountsPendingSelfServiceEnvironmentCreationDto implements IAccountsPendingSelfServiceEnvironmentCreationDto {
    accounts?: EnvironmentCreationAccountDetailsDto[] | undefined;

    constructor(data?: IAccountsPendingSelfServiceEnvironmentCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(EnvironmentCreationAccountDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountsPendingSelfServiceEnvironmentCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsPendingSelfServiceEnvironmentCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccountsPendingSelfServiceEnvironmentCreationDto {
    accounts?: EnvironmentCreationAccountDetailsDto[] | undefined;
}

export class EnvironmentCreationAccountDetailsDto implements IEnvironmentCreationAccountDetailsDto {
    accountId?: number;
    axAccount?: string | undefined;
    accountName?: string | undefined;

    constructor(data?: IEnvironmentCreationAccountDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.axAccount = _data["axAccount"];
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): EnvironmentCreationAccountDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentCreationAccountDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["axAccount"] = this.axAccount;
        data["accountName"] = this.accountName;
        return data;
    }
}

export interface IEnvironmentCreationAccountDetailsDto {
    accountId?: number;
    axAccount?: string | undefined;
    accountName?: string | undefined;
}

export class AirtableFileObject implements IAirtableFileObject {
    fileName?: string | undefined;
    contentType?: string | undefined;
    base64FileStream?: string | undefined;

    constructor(data?: IAirtableFileObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.base64FileStream = _data["base64FileStream"];
        }
    }

    static fromJS(data: any): AirtableFileObject {
        data = typeof data === 'object' ? data : {};
        let result = new AirtableFileObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["base64FileStream"] = this.base64FileStream;
        return data;
    }
}

export interface IAirtableFileObject {
    fileName?: string | undefined;
    contentType?: string | undefined;
    base64FileStream?: string | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    id?: number;
    dateUploaded?: Date;
    fileName?: string | undefined;
    fileSize?: number;
    fileType?: string | undefined;
    guid?: string | undefined;
    ticketId?: number | undefined;
    ticketNoteId?: number | undefined;
    url?: string | undefined;
    attachedByName?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateUploaded = _data["dateUploaded"] ? new Date(_data["dateUploaded"].toString()) : undefined as any;
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.fileType = _data["fileType"];
            this.guid = _data["guid"];
            this.ticketId = _data["ticketId"];
            this.ticketNoteId = _data["ticketNoteId"];
            this.url = _data["url"];
            this.attachedByName = _data["attachedByName"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateUploaded"] = this.dateUploaded ? this.dateUploaded.toISOString() : undefined as any;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["fileType"] = this.fileType;
        data["guid"] = this.guid;
        data["ticketId"] = this.ticketId;
        data["ticketNoteId"] = this.ticketNoteId;
        data["url"] = this.url;
        data["attachedByName"] = this.attachedByName;
        return data;
    }
}

export interface IAttachmentDto {
    id?: number;
    dateUploaded?: Date;
    fileName?: string | undefined;
    fileSize?: number;
    fileType?: string | undefined;
    guid?: string | undefined;
    ticketId?: number | undefined;
    ticketNoteId?: number | undefined;
    url?: string | undefined;
    attachedByName?: string | undefined;
}

export class ContactDto implements IContactDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ContactDto";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "ContactDtoWithServiceRequestIdAndAxNumber") {
            let result = new ContactDtoWithServiceRequestIdAndAxNumber();
            result.init(data);
            return result;
        }
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IContactDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
}

export class ContactDtoWithServiceRequestIdAndAxNumber extends ContactDto implements IContactDtoWithServiceRequestIdAndAxNumber {
    serviceRequestId?: number;
    axAccountNumber?: string | undefined;
    accountId?: number;

    constructor(data?: IContactDtoWithServiceRequestIdAndAxNumber) {
        super(data);
        this._discriminator = "ContactDtoWithServiceRequestIdAndAxNumber";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.accountId = _data["accountId"];
        }
    }

    static override fromJS(data: any): ContactDtoWithServiceRequestIdAndAxNumber {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDtoWithServiceRequestIdAndAxNumber();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId;
        data["axAccountNumber"] = this.axAccountNumber;
        data["accountId"] = this.accountId;
        super.toJSON(data);
        return data;
    }
}

export interface IContactDtoWithServiceRequestIdAndAxNumber extends IContactDto {
    serviceRequestId?: number;
    axAccountNumber?: string | undefined;
    accountId?: number;
}

export enum ServiceRequestActionType {
    Save = "Save",
    Close = "Close",
    PlaceOnHold = "PlaceOnHold",
    RemoveHold = "RemoveHold",
    Reject = "Reject",
}

export class ServiceRequestDetailsDto implements IServiceRequestDetailsDto {
    id?: number;
    requestIdentifier?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    secondaryContacts?: ContactDto[] | undefined;
    surveyRating?: number | undefined;
    preferredContactMethod?: string | undefined;
    status?: string | undefined;
    severity?: string | undefined;
    category?: string | undefined;
    issue?: string | undefined;
    serviceRequestType?: string | undefined;
    cloudAccount?: string | undefined;
    accountId?: number;
    createdBy?: string | undefined;
    createdByContactId?: number | undefined;
    assignedTo?: string | undefined;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    completedDate?: Date;
    messages?: ServiceRequestMessageDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    serviceRequestMapping?: ServiceRequestMappingDto;
    availableActions?: ServiceRequestActionType[] | undefined;
    showFormWhenViewing?: boolean;
    onboardingState?: ServiceRequestState;
    ticketId?: number;

    constructor(data?: IServiceRequestDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestIdentifier = _data["requestIdentifier"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["secondaryContacts"])) {
                this.secondaryContacts = [] as any;
                for (let item of _data["secondaryContacts"])
                    this.secondaryContacts!.push(ContactDto.fromJS(item));
            }
            this.surveyRating = _data["surveyRating"];
            this.preferredContactMethod = _data["preferredContactMethod"];
            this.status = _data["status"];
            this.severity = _data["severity"];
            this.category = _data["category"];
            this.issue = _data["issue"];
            this.serviceRequestType = _data["serviceRequestType"];
            this.cloudAccount = _data["cloudAccount"];
            this.accountId = _data["accountId"];
            this.createdBy = _data["createdBy"];
            this.createdByContactId = _data["createdByContactId"];
            this.assignedTo = _data["assignedTo"];
            this.totalBillingHours = _data["totalBillingHours"];
            this.totalBillingAmount = _data["totalBillingAmount"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ServiceRequestMessageDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.serviceRequestMapping = _data["serviceRequestMapping"] ? ServiceRequestMappingDto.fromJS(_data["serviceRequestMapping"]) : undefined as any;
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.showFormWhenViewing = _data["showFormWhenViewing"];
            this.onboardingState = _data["onboardingState"];
            this.ticketId = _data["ticketId"];
        }
    }

    static fromJS(data: any): ServiceRequestDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestIdentifier"] = this.requestIdentifier;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.secondaryContacts)) {
            data["secondaryContacts"] = [];
            for (let item of this.secondaryContacts)
                data["secondaryContacts"].push(item ? item.toJSON() : undefined as any);
        }
        data["surveyRating"] = this.surveyRating;
        data["preferredContactMethod"] = this.preferredContactMethod;
        data["status"] = this.status;
        data["severity"] = this.severity;
        data["category"] = this.category;
        data["issue"] = this.issue;
        data["serviceRequestType"] = this.serviceRequestType;
        data["cloudAccount"] = this.cloudAccount;
        data["accountId"] = this.accountId;
        data["createdBy"] = this.createdBy;
        data["createdByContactId"] = this.createdByContactId;
        data["assignedTo"] = this.assignedTo;
        data["totalBillingHours"] = this.totalBillingHours;
        data["totalBillingAmount"] = this.totalBillingAmount;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["serviceRequestMapping"] = this.serviceRequestMapping ? this.serviceRequestMapping.toJSON() : undefined as any;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["showFormWhenViewing"] = this.showFormWhenViewing;
        data["onboardingState"] = this.onboardingState;
        data["ticketId"] = this.ticketId;
        return data;
    }
}

export interface IServiceRequestDetailsDto {
    id?: number;
    requestIdentifier?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    secondaryContacts?: ContactDto[] | undefined;
    surveyRating?: number | undefined;
    preferredContactMethod?: string | undefined;
    status?: string | undefined;
    severity?: string | undefined;
    category?: string | undefined;
    issue?: string | undefined;
    serviceRequestType?: string | undefined;
    cloudAccount?: string | undefined;
    accountId?: number;
    createdBy?: string | undefined;
    createdByContactId?: number | undefined;
    assignedTo?: string | undefined;
    totalBillingHours?: number | undefined;
    totalBillingAmount?: number | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date;
    completedDate?: Date;
    messages?: ServiceRequestMessageDto[] | undefined;
    attachments?: AttachmentDto[] | undefined;
    serviceRequestMapping?: ServiceRequestMappingDto;
    availableActions?: ServiceRequestActionType[] | undefined;
    showFormWhenViewing?: boolean;
    onboardingState?: ServiceRequestState;
    ticketId?: number;
}

export class ServiceRequestMappingDto implements IServiceRequestMappingDto {
    ticketTypeId?: number | undefined;
    formSchema?: string | undefined;
    formUiSchema?: string | undefined;
    rules?: string | undefined;

    constructor(data?: IServiceRequestMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketTypeId = _data["ticketTypeId"];
            this.formSchema = _data["formSchema"];
            this.formUiSchema = _data["formUiSchema"];
            this.rules = _data["rules"];
        }
    }

    static fromJS(data: any): ServiceRequestMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketTypeId"] = this.ticketTypeId;
        data["formSchema"] = this.formSchema;
        data["formUiSchema"] = this.formUiSchema;
        data["rules"] = this.rules;
        return data;
    }
}

export interface IServiceRequestMappingDto {
    ticketTypeId?: number | undefined;
    formSchema?: string | undefined;
    formUiSchema?: string | undefined;
    rules?: string | undefined;
}

export class ServiceRequestMessageDto implements IServiceRequestMessageDto {
    id?: number;
    serviceRequestId?: number;
    author?: string | undefined;
    message?: string | undefined;
    lastActivityDate?: Date;
    hoursWorked?: number | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: IServiceRequestMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceRequestId = _data["serviceRequestId"];
            this.author = _data["author"];
            this.message = _data["message"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
            this.hoursWorked = _data["hoursWorked"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceRequestMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceRequestId"] = this.serviceRequestId;
        data["author"] = this.author;
        data["message"] = this.message;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : undefined as any;
        data["hoursWorked"] = this.hoursWorked;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IServiceRequestMessageDto {
    id?: number;
    serviceRequestId?: number;
    author?: string | undefined;
    message?: string | undefined;
    lastActivityDate?: Date;
    hoursWorked?: number | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export enum ServiceRequestState {
    New = "New",
    Open = "Open",
    Closed = "Closed",
    Rejected = "Rejected",
}

export class AwsReservationSearchFilter implements IAwsReservationSearchFilter {
    family?: string[] | undefined;
    paymentOption?: string[] | undefined;

    constructor(data?: IAwsReservationSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["family"])) {
                this.family = [] as any;
                for (let item of _data["family"])
                    this.family!.push(item);
            }
            if (Array.isArray(_data["paymentOption"])) {
                this.paymentOption = [] as any;
                for (let item of _data["paymentOption"])
                    this.paymentOption!.push(item);
            }
        }
    }

    static fromJS(data: any): AwsReservationSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AwsReservationSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.family)) {
            data["family"] = [];
            for (let item of this.family)
                data["family"].push(item);
        }
        if (Array.isArray(this.paymentOption)) {
            data["paymentOption"] = [];
            for (let item of this.paymentOption)
                data["paymentOption"].push(item);
        }
        return data;
    }
}

export interface IAwsReservationSearchFilter {
    family?: string[] | undefined;
    paymentOption?: string[] | undefined;
}

export class AwsReservationSearchRequest extends IncludeExcludeSearchFilter_1OfAwsReservationSearchFilter implements IAwsReservationSearchRequest {

    constructor(data?: IAwsReservationSearchRequest) {
        super(data);
        this._discriminator = "AwsReservationSearchRequest";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AwsReservationSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AwsReservationSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAwsReservationSearchRequest extends IIncludeExcludeSearchFilter_1OfAwsReservationSearchFilter {
}

export class AwsRightsizingSearchFilter implements IAwsRightsizingSearchFilter {
    rightsizingType?: string[] | undefined;
    instanceType?: string[] | undefined;
    region?: string[] | undefined;
    platform?: string[] | undefined;

    constructor(data?: IAwsRightsizingSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rightsizingType"])) {
                this.rightsizingType = [] as any;
                for (let item of _data["rightsizingType"])
                    this.rightsizingType!.push(item);
            }
            if (Array.isArray(_data["instanceType"])) {
                this.instanceType = [] as any;
                for (let item of _data["instanceType"])
                    this.instanceType!.push(item);
            }
            if (Array.isArray(_data["region"])) {
                this.region = [] as any;
                for (let item of _data["region"])
                    this.region!.push(item);
            }
            if (Array.isArray(_data["platform"])) {
                this.platform = [] as any;
                for (let item of _data["platform"])
                    this.platform!.push(item);
            }
        }
    }

    static fromJS(data: any): AwsRightsizingSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AwsRightsizingSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rightsizingType)) {
            data["rightsizingType"] = [];
            for (let item of this.rightsizingType)
                data["rightsizingType"].push(item);
        }
        if (Array.isArray(this.instanceType)) {
            data["instanceType"] = [];
            for (let item of this.instanceType)
                data["instanceType"].push(item);
        }
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item);
        }
        if (Array.isArray(this.platform)) {
            data["platform"] = [];
            for (let item of this.platform)
                data["platform"].push(item);
        }
        return data;
    }
}

export interface IAwsRightsizingSearchFilter {
    rightsizingType?: string[] | undefined;
    instanceType?: string[] | undefined;
    region?: string[] | undefined;
    platform?: string[] | undefined;
}

export class AwsRightsizingSearchRequest extends IncludeExcludeSearchFilter_1OfAwsRightsizingSearchFilter implements IAwsRightsizingSearchRequest {

    constructor(data?: IAwsRightsizingSearchRequest) {
        super(data);
        this._discriminator = "AwsRightsizingSearchRequest";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AwsRightsizingSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AwsRightsizingSearchRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAwsRightsizingSearchRequest extends IIncludeExcludeSearchFilter_1OfAwsRightsizingSearchFilter {
}

export class ReservationPurchaseResult implements IReservationPurchaseResult {
    payerAccountId?: string | undefined;
    reservationPurchaseRecommendation?: ReservationPurchaseRecommendation[] | undefined;

    constructor(data?: IReservationPurchaseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            if (Array.isArray(_data["reservationPurchaseRecommendation"])) {
                this.reservationPurchaseRecommendation = [] as any;
                for (let item of _data["reservationPurchaseRecommendation"])
                    this.reservationPurchaseRecommendation!.push(ReservationPurchaseRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReservationPurchaseResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationPurchaseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        if (Array.isArray(this.reservationPurchaseRecommendation)) {
            data["reservationPurchaseRecommendation"] = [];
            for (let item of this.reservationPurchaseRecommendation)
                data["reservationPurchaseRecommendation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReservationPurchaseResult {
    payerAccountId?: string | undefined;
    reservationPurchaseRecommendation?: ReservationPurchaseRecommendation[] | undefined;
}

export class RightSizingResult implements IRightSizingResult {
    payerAccountId?: string | undefined;
    rightSizingRecommendations?: RightsizingRecommendation[] | undefined;

    constructor(data?: IRightSizingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            if (Array.isArray(_data["rightSizingRecommendations"])) {
                this.rightSizingRecommendations = [] as any;
                for (let item of _data["rightSizingRecommendations"])
                    this.rightSizingRecommendations!.push(RightsizingRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RightSizingResult {
        data = typeof data === 'object' ? data : {};
        let result = new RightSizingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        if (Array.isArray(this.rightSizingRecommendations)) {
            data["rightSizingRecommendations"] = [];
            for (let item of this.rightSizingRecommendations)
                data["rightSizingRecommendations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRightSizingResult {
    payerAccountId?: string | undefined;
    rightSizingRecommendations?: RightsizingRecommendation[] | undefined;
}

export class SavingsPlansPurchaseResult implements ISavingsPlansPurchaseResult {
    payerAccountId?: string | undefined;
    savingsPlansPurchaseRecommendations?: SavingsPlansPurchaseRecommendation[] | undefined;

    constructor(data?: ISavingsPlansPurchaseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            if (Array.isArray(_data["savingsPlansPurchaseRecommendations"])) {
                this.savingsPlansPurchaseRecommendations = [] as any;
                for (let item of _data["savingsPlansPurchaseRecommendations"])
                    this.savingsPlansPurchaseRecommendations!.push(SavingsPlansPurchaseRecommendation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavingsPlansPurchaseResult {
        data = typeof data === 'object' ? data : {};
        let result = new SavingsPlansPurchaseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        if (Array.isArray(this.savingsPlansPurchaseRecommendations)) {
            data["savingsPlansPurchaseRecommendations"] = [];
            for (let item of this.savingsPlansPurchaseRecommendations)
                data["savingsPlansPurchaseRecommendations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISavingsPlansPurchaseResult {
    payerAccountId?: string | undefined;
    savingsPlansPurchaseRecommendations?: SavingsPlansPurchaseRecommendation[] | undefined;
}

export class TrustedAdvisorResult implements ITrustedAdvisorResult {
    payerAccountId?: string | undefined;
    linkedAccountId?: string | undefined;
    trustedAdvisorRecommendations?: TrustedAdvisorComposite[] | undefined;

    constructor(data?: ITrustedAdvisorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            this.linkedAccountId = _data["linkedAccountId"];
            if (Array.isArray(_data["trustedAdvisorRecommendations"])) {
                this.trustedAdvisorRecommendations = [] as any;
                for (let item of _data["trustedAdvisorRecommendations"])
                    this.trustedAdvisorRecommendations!.push(TrustedAdvisorComposite.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrustedAdvisorResult {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        data["linkedAccountId"] = this.linkedAccountId;
        if (Array.isArray(this.trustedAdvisorRecommendations)) {
            data["trustedAdvisorRecommendations"] = [];
            for (let item of this.trustedAdvisorRecommendations)
                data["trustedAdvisorRecommendations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrustedAdvisorResult {
    payerAccountId?: string | undefined;
    linkedAccountId?: string | undefined;
    trustedAdvisorRecommendations?: TrustedAdvisorComposite[] | undefined;
}

export class AccountSearchQuery implements IAccountSearchQuery {
    searchString?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string | undefined;
    descending?: boolean;
    impersonateOnly?: boolean;
    successPlanId?: number;
    shiOneStatus?: AccountStatus;

    constructor(data?: IAccountSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.orderBy = _data["orderBy"];
            this.descending = _data["descending"];
            this.impersonateOnly = _data["impersonateOnly"];
            this.successPlanId = _data["successPlanId"];
            this.shiOneStatus = _data["shiOneStatus"];
        }
    }

    static fromJS(data: any): AccountSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["orderBy"] = this.orderBy;
        data["descending"] = this.descending;
        data["impersonateOnly"] = this.impersonateOnly;
        data["successPlanId"] = this.successPlanId;
        data["shiOneStatus"] = this.shiOneStatus;
        return data;
    }
}

export interface IAccountSearchQuery {
    searchString?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string | undefined;
    descending?: boolean;
    impersonateOnly?: boolean;
    successPlanId?: number;
    shiOneStatus?: AccountStatus;
}

export enum AccountStatus {
    None = "None",
    NotConfigured = "NotConfigured",
    Pending = "Pending",
    Unhealthy = "Unhealthy",
    Healthy = "Healthy",
}

export enum IntegrationGroup {
    Other = "Other",
    Assets = "Assets",
    Cloud = "Cloud",
    Assessments = "Assessments",
}

export enum IntegrationType {
    Unknown = "Unknown",
    AwsCompliance = "AwsCompliance",
    AzureCompliance = "AzureCompliance",
    Unknown2 = "Unknown2",
    AzurePlanReport = "AzurePlanReport",
    AwsSimpleRecommendations = "AwsSimpleRecommendations",
    AwsBillingReport = "AwsBillingReport",
    AzureSimpleRecommendations = "AzureSimpleRecommendations",
    AzureBackups = "AzureBackups",
    RackAndStack = "RackAndStack",
    CiscoSNTC = "CiscoSNTC",
    GcpUsageReport = "GcpUsageReport",
    CiscoReadyReport = "CiscoReadyReport",
    AzureDirectConsumption = "AzureDirectConsumption",
    DatadogUsageReport = "DatadogUsageReport",
    DattoRMM = "DattoRMM",
    AzureDevOpsReport = "AzureDevOpsReport",
    CiscoContractCoverage = "CiscoContractCoverage",
    IdcsReport = "IdcsReport",
    HardwareLifecycleManagement = "HardwareLifecycleManagement",
    AwsGovernanceReports = "AwsGovernanceReports",
    CiscoMeraki = "CiscoMeraki",
    AssetManagement = "AssetManagement",
    CiscoSubscriptionManagement = "CiscoSubscriptionManagement",
    CiscoEnterpriseAgreement = "CiscoEnterpriseAgreement",
    AzureGovernanceReports = "AzureGovernanceReports",
    SelfServiceReporting = "SelfServiceReporting",
    AzureResourceGraph = "AzureResourceGraph",
    AwsResourceExplorer = "AwsResourceExplorer",
    GcpCloudAssetInventory = "GcpCloudAssetInventory",
    Catalyst = "Catalyst",
    SecurityPostureReview = "SecurityPostureReview",
    AIReadiness = "AIReadiness",
    InstallBaseAnalysis = "InstallBaseAnalysis",
    LiveOptics = "LiveOptics",
    MicrosoftAdoptionAssessment = "MicrosoftAdoptionAssessment",
    Microsoft365Reports = "Microsoft365Reports",
    DevOpsPostureReview = "DevOpsPostureReview",
    AzureAssetConnection = "AzureAssetConnection",
    AzureCostAndUsageConnection = "AzureCostAndUsageConnection",
    CiscoMerakiCustomer = "CiscoMerakiCustomer",
    AwsMaturity = "AwsMaturity",
    CiscoCxCloud = "CiscoCxCloud",
    Tpx = "Tpx",
    WarehousePickOrder = "WarehousePickOrder",
    MicrosoftInsights = "MicrosoftInsights",
}

export class TrustedAdvisorComposite implements ITrustedAdvisorComposite {
    description?: TrustedAdvisorCheckDescription;
    summary?: TrustedAdvisorCheckSummary;
    result?: TrustedAdvisorCheckResult;

    constructor(data?: ITrustedAdvisorComposite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] ? TrustedAdvisorCheckDescription.fromJS(_data["description"]) : undefined as any;
            this.summary = _data["summary"] ? TrustedAdvisorCheckSummary.fromJS(_data["summary"]) : undefined as any;
            this.result = _data["result"] ? TrustedAdvisorCheckResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): TrustedAdvisorComposite {
        data = typeof data === 'object' ? data : {};
        let result = new TrustedAdvisorComposite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface ITrustedAdvisorComposite {
    description?: TrustedAdvisorCheckDescription;
    summary?: TrustedAdvisorCheckSummary;
    result?: TrustedAdvisorCheckResult;
}

export class UserConfigDto implements IUserConfigDto {
    entityId?: string | undefined;
    settingsKey?: string | undefined;
    settingsValue?: string | undefined;
    lastUpdatedUtc?: Date;

    constructor(data?: IUserConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.settingsKey = _data["settingsKey"];
            this.settingsValue = _data["settingsValue"];
            this.lastUpdatedUtc = _data["lastUpdatedUtc"] ? new Date(_data["lastUpdatedUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["settingsKey"] = this.settingsKey;
        data["settingsValue"] = this.settingsValue;
        data["lastUpdatedUtc"] = this.lastUpdatedUtc ? this.lastUpdatedUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserConfigDto {
    entityId?: string | undefined;
    settingsKey?: string | undefined;
    settingsValue?: string | undefined;
    lastUpdatedUtc?: Date;
}

export class BulkUpdateExecutionAreasRequest implements IBulkUpdateExecutionAreasRequest {
    executionItems?: VsemExecutionItemRequest[] | undefined;
    recommendations?: VsemRecommendationUpdateItem[] | undefined;

    constructor(data?: IBulkUpdateExecutionAreasRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["executionItems"])) {
                this.executionItems = [] as any;
                for (let item of _data["executionItems"])
                    this.executionItems!.push(VsemExecutionItemRequest.fromJS(item));
            }
            if (Array.isArray(_data["recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["recommendations"])
                    this.recommendations!.push(VsemRecommendationUpdateItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkUpdateExecutionAreasRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateExecutionAreasRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.executionItems)) {
            data["executionItems"] = [];
            for (let item of this.executionItems)
                data["executionItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.recommendations)) {
            data["recommendations"] = [];
            for (let item of this.recommendations)
                data["recommendations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBulkUpdateExecutionAreasRequest {
    executionItems?: VsemExecutionItemRequest[] | undefined;
    recommendations?: VsemRecommendationUpdateItem[] | undefined;
}

export class CreateVsemRecommendationRequest implements ICreateVsemRecommendationRequest {
    vsemExecutionItemId?: string;
    section?: number;
    title?: string | undefined;
    content?: string | undefined;

    constructor(data?: ICreateVsemRecommendationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vsemExecutionItemId = _data["vsemExecutionItemId"];
            this.section = _data["section"];
            this.title = _data["title"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CreateVsemRecommendationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVsemRecommendationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vsemExecutionItemId"] = this.vsemExecutionItemId;
        data["section"] = this.section;
        data["title"] = this.title;
        data["content"] = this.content;
        return data;
    }
}

export interface ICreateVsemRecommendationRequest {
    vsemExecutionItemId?: string;
    section?: number;
    title?: string | undefined;
    content?: string | undefined;
}

export class UpdateVsemRecommendationRequest implements IUpdateVsemRecommendationRequest {
    title?: string | undefined;
    content?: string | undefined;

    constructor(data?: IUpdateVsemRecommendationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): UpdateVsemRecommendationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVsemRecommendationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        return data;
    }
}

export interface IUpdateVsemRecommendationRequest {
    title?: string | undefined;
    content?: string | undefined;
}

export class VsemRecommendationUpdateItem implements IVsemRecommendationUpdateItem {
    vsemRecommendationId?: string;
    section?: VsemRecommendationSection;
    title?: string | undefined;
    content?: string | undefined;
    displayOrder?: number;

    constructor(data?: IVsemRecommendationUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vsemRecommendationId = _data["vsemRecommendationId"];
            this.section = _data["section"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): VsemRecommendationUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new VsemRecommendationUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vsemRecommendationId"] = this.vsemRecommendationId;
        data["section"] = this.section;
        data["title"] = this.title;
        data["content"] = this.content;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IVsemRecommendationUpdateItem {
    vsemRecommendationId?: string;
    section?: VsemRecommendationSection;
    title?: string | undefined;
    content?: string | undefined;
    displayOrder?: number;
}

export class EditVsemRequest implements IEditVsemRequest {
    vsemId?: string;
    vision?: string | undefined;
    strategy?: string | undefined;
    executionItems?: VsemExecutionItemRequest[] | undefined;

    constructor(data?: IEditVsemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vsemId = _data["vsemId"];
            this.vision = _data["vision"];
            this.strategy = _data["strategy"];
            if (Array.isArray(_data["executionItems"])) {
                this.executionItems = [] as any;
                for (let item of _data["executionItems"])
                    this.executionItems!.push(VsemExecutionItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditVsemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditVsemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vsemId"] = this.vsemId;
        data["vision"] = this.vision;
        data["strategy"] = this.strategy;
        if (Array.isArray(this.executionItems)) {
            data["executionItems"] = [];
            for (let item of this.executionItems)
                data["executionItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEditVsemRequest {
    vsemId?: string;
    vision?: string | undefined;
    strategy?: string | undefined;
    executionItems?: VsemExecutionItemRequest[] | undefined;
}

export class VsemAggregateDto implements IVsemAggregateDto {
    vsemId?: string;
    assessmentGuid?: string;
    transcriptRecordId?: string | undefined;
    vision?: string | undefined;
    strategy?: string | undefined;
    isPublished?: boolean;
    publishedAt?: Date | undefined;
    publishStatus?: VsemPublishStatus;
    publishStartedAt?: Date | undefined;
    publishCompletedAt?: Date | undefined;
    publishFailureReason?: string | undefined;
    recommendationStatus?: VsemRecommendationStatus;
    recommendationStartedAt?: Date | undefined;
    recommendationCompletedAt?: Date | undefined;
    recommendationFailureReason?: string | undefined;
    recommendationsCreatedAt?: Date | undefined;
    executionItems?: VsemExecutionItemDto[] | undefined;

    constructor(data?: IVsemAggregateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vsemId = _data["vsemId"];
            this.assessmentGuid = _data["assessmentGuid"];
            this.transcriptRecordId = _data["transcriptRecordId"];
            this.vision = _data["vision"];
            this.strategy = _data["strategy"];
            this.isPublished = _data["isPublished"];
            this.publishedAt = _data["publishedAt"] ? new Date(_data["publishedAt"].toString()) : undefined as any;
            this.publishStatus = _data["publishStatus"];
            this.publishStartedAt = _data["publishStartedAt"] ? new Date(_data["publishStartedAt"].toString()) : undefined as any;
            this.publishCompletedAt = _data["publishCompletedAt"] ? new Date(_data["publishCompletedAt"].toString()) : undefined as any;
            this.publishFailureReason = _data["publishFailureReason"];
            this.recommendationStatus = _data["recommendationStatus"];
            this.recommendationStartedAt = _data["recommendationStartedAt"] ? new Date(_data["recommendationStartedAt"].toString()) : undefined as any;
            this.recommendationCompletedAt = _data["recommendationCompletedAt"] ? new Date(_data["recommendationCompletedAt"].toString()) : undefined as any;
            this.recommendationFailureReason = _data["recommendationFailureReason"];
            this.recommendationsCreatedAt = _data["recommendationsCreatedAt"] ? new Date(_data["recommendationsCreatedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["executionItems"])) {
                this.executionItems = [] as any;
                for (let item of _data["executionItems"])
                    this.executionItems!.push(VsemExecutionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VsemAggregateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VsemAggregateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vsemId"] = this.vsemId;
        data["assessmentGuid"] = this.assessmentGuid;
        data["transcriptRecordId"] = this.transcriptRecordId;
        data["vision"] = this.vision;
        data["strategy"] = this.strategy;
        data["isPublished"] = this.isPublished;
        data["publishedAt"] = this.publishedAt ? this.publishedAt.toISOString() : undefined as any;
        data["publishStatus"] = this.publishStatus;
        data["publishStartedAt"] = this.publishStartedAt ? this.publishStartedAt.toISOString() : undefined as any;
        data["publishCompletedAt"] = this.publishCompletedAt ? this.publishCompletedAt.toISOString() : undefined as any;
        data["publishFailureReason"] = this.publishFailureReason;
        data["recommendationStatus"] = this.recommendationStatus;
        data["recommendationStartedAt"] = this.recommendationStartedAt ? this.recommendationStartedAt.toISOString() : undefined as any;
        data["recommendationCompletedAt"] = this.recommendationCompletedAt ? this.recommendationCompletedAt.toISOString() : undefined as any;
        data["recommendationFailureReason"] = this.recommendationFailureReason;
        data["recommendationsCreatedAt"] = this.recommendationsCreatedAt ? this.recommendationsCreatedAt.toISOString() : undefined as any;
        if (Array.isArray(this.executionItems)) {
            data["executionItems"] = [];
            for (let item of this.executionItems)
                data["executionItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVsemAggregateDto {
    vsemId?: string;
    assessmentGuid?: string;
    transcriptRecordId?: string | undefined;
    vision?: string | undefined;
    strategy?: string | undefined;
    isPublished?: boolean;
    publishedAt?: Date | undefined;
    publishStatus?: VsemPublishStatus;
    publishStartedAt?: Date | undefined;
    publishCompletedAt?: Date | undefined;
    publishFailureReason?: string | undefined;
    recommendationStatus?: VsemRecommendationStatus;
    recommendationStartedAt?: Date | undefined;
    recommendationCompletedAt?: Date | undefined;
    recommendationFailureReason?: string | undefined;
    recommendationsCreatedAt?: Date | undefined;
    executionItems?: VsemExecutionItemDto[] | undefined;
}

export class VsemExecutionItemDto implements IVsemExecutionItemDto {
    vsemExecutionItemId?: string;
    vsemId?: string;
    title?: string | undefined;
    content?: string | undefined;
    metrics?: string | undefined;
    displayOrder?: number;
    recommendations?: VsemRecommendationDto[] | undefined;

    constructor(data?: IVsemExecutionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vsemExecutionItemId = _data["vsemExecutionItemId"];
            this.vsemId = _data["vsemId"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.metrics = _data["metrics"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["recommendations"])
                    this.recommendations!.push(VsemRecommendationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VsemExecutionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new VsemExecutionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vsemExecutionItemId"] = this.vsemExecutionItemId;
        data["vsemId"] = this.vsemId;
        data["title"] = this.title;
        data["content"] = this.content;
        data["metrics"] = this.metrics;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.recommendations)) {
            data["recommendations"] = [];
            for (let item of this.recommendations)
                data["recommendations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVsemExecutionItemDto {
    vsemExecutionItemId?: string;
    vsemId?: string;
    title?: string | undefined;
    content?: string | undefined;
    metrics?: string | undefined;
    displayOrder?: number;
    recommendations?: VsemRecommendationDto[] | undefined;
}

export class VsemExecutionItemRequest implements IVsemExecutionItemRequest {
    vsemExecutionItemId?: string;
    title?: string | undefined;
    content?: string | undefined;
    metrics?: string | undefined;
    displayOrder?: number;

    constructor(data?: IVsemExecutionItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vsemExecutionItemId = _data["vsemExecutionItemId"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.metrics = _data["metrics"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): VsemExecutionItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VsemExecutionItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vsemExecutionItemId"] = this.vsemExecutionItemId;
        data["title"] = this.title;
        data["content"] = this.content;
        data["metrics"] = this.metrics;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IVsemExecutionItemRequest {
    vsemExecutionItemId?: string;
    title?: string | undefined;
    content?: string | undefined;
    metrics?: string | undefined;
    displayOrder?: number;
}

export enum VsemPublishStatus {
    Draft = "Draft",
    Publishing = "Publishing",
    Published = "Published",
    Failed = "Failed",
}

export class VsemRecommendationDto implements IVsemRecommendationDto {
    vsemRecommendationId?: string;
    vsemExecutionItemId?: string;
    section?: VsemRecommendationSection;
    title?: string | undefined;
    content?: string | undefined;
    displayOrder?: number;

    constructor(data?: IVsemRecommendationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vsemRecommendationId = _data["vsemRecommendationId"];
            this.vsemExecutionItemId = _data["vsemExecutionItemId"];
            this.section = _data["section"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): VsemRecommendationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VsemRecommendationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vsemRecommendationId"] = this.vsemRecommendationId;
        data["vsemExecutionItemId"] = this.vsemExecutionItemId;
        data["section"] = this.section;
        data["title"] = this.title;
        data["content"] = this.content;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IVsemRecommendationDto {
    vsemRecommendationId?: string;
    vsemExecutionItemId?: string;
    section?: VsemRecommendationSection;
    title?: string | undefined;
    content?: string | undefined;
    displayOrder?: number;
}

export enum VsemRecommendationSection {
    ImmediateImpact = "ImmediateImpact",
    BuildAndScale = "BuildAndScale",
    EnablementAndChangeManagement = "EnablementAndChangeManagement",
}

export enum VsemRecommendationStatus {
    NotStarted = "NotStarted",
    Processing = "Processing",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export class GridFilterDto implements IGridFilterDto {
    id?: number;
    entityId!: string | undefined;
    scope!: string | undefined;
    location!: string | undefined;
    filterName!: string | undefined;
    includeFiltersObject?: string | undefined;
    excludeFiltersObject?: string | undefined;
    generalFiltersObject?: string | undefined;
    isDefault?: boolean | undefined;
    lastUpdatedUtc?: Date;

    constructor(data?: IGridFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.scope = _data["scope"];
            this.location = _data["location"];
            this.filterName = _data["filterName"];
            this.includeFiltersObject = _data["includeFiltersObject"];
            this.excludeFiltersObject = _data["excludeFiltersObject"];
            this.generalFiltersObject = _data["generalFiltersObject"];
            this.isDefault = _data["isDefault"];
            this.lastUpdatedUtc = _data["lastUpdatedUtc"] ? new Date(_data["lastUpdatedUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GridFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["scope"] = this.scope;
        data["location"] = this.location;
        data["filterName"] = this.filterName;
        data["includeFiltersObject"] = this.includeFiltersObject;
        data["excludeFiltersObject"] = this.excludeFiltersObject;
        data["generalFiltersObject"] = this.generalFiltersObject;
        data["isDefault"] = this.isDefault;
        data["lastUpdatedUtc"] = this.lastUpdatedUtc ? this.lastUpdatedUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IGridFilterDto {
    id?: number;
    entityId: string | undefined;
    scope: string | undefined;
    location: string | undefined;
    filterName: string | undefined;
    includeFiltersObject?: string | undefined;
    excludeFiltersObject?: string | undefined;
    generalFiltersObject?: string | undefined;
    isDefault?: boolean | undefined;
    lastUpdatedUtc?: Date;
}

export class GridFilterResult implements IGridFilterResult {
    isSuccess?: boolean;
    errorMessage?: string | undefined;
    filter?: GridFilterDto;

    constructor(data?: IGridFilterResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.errorMessage = _data["errorMessage"];
            this.filter = _data["filter"] ? GridFilterDto.fromJS(_data["filter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GridFilterResult {
        data = typeof data === 'object' ? data : {};
        let result = new GridFilterResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["errorMessage"] = this.errorMessage;
        data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGridFilterResult {
    isSuccess?: boolean;
    errorMessage?: string | undefined;
    filter?: GridFilterDto;
}

export class AutoTaskResourceController_ResourceIdsRequest implements IAutoTaskResourceController_ResourceIdsRequest {
    resourceIds?: number[] | undefined;

    constructor(data?: IAutoTaskResourceController_ResourceIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resourceIds"])) {
                this.resourceIds = [] as any;
                for (let item of _data["resourceIds"])
                    this.resourceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AutoTaskResourceController_ResourceIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AutoTaskResourceController_ResourceIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resourceIds)) {
            data["resourceIds"] = [];
            for (let item of this.resourceIds)
                data["resourceIds"].push(item);
        }
        return data;
    }
}

export interface IAutoTaskResourceController_ResourceIdsRequest {
    resourceIds?: number[] | undefined;
}

export class CurrentPrefix implements ICurrentPrefix {
    prefix?: string | undefined;

    constructor(data?: ICurrentPrefix) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
        }
    }

    static fromJS(data: any): CurrentPrefix {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentPrefix();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        return data;
    }
}

export interface ICurrentPrefix {
    prefix?: string | undefined;
}

export class FileUploadResponse implements IFileUploadResponse {
    url?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IFileUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): FileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IFileUploadResponse {
    url?: string | undefined;
    errorMessage?: string | undefined;
}

export class WhiteLabelResult implements IWhiteLabelResult {
    defaultSet?: boolean;
    subDomain?: string | undefined;
    logoUrl?: string | undefined;
    landingTitle?: string | undefined;
    topLeftTitle?: string | undefined;
    welcomeMessage?: string | undefined;
    hasError?: boolean;
    errorMessage?: string | undefined;
    accountName?: string | undefined;

    constructor(data?: IWhiteLabelResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultSet = _data["defaultSet"];
            this.subDomain = _data["subDomain"];
            this.logoUrl = _data["logoUrl"];
            this.landingTitle = _data["landingTitle"];
            this.topLeftTitle = _data["topLeftTitle"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.hasError = _data["hasError"];
            this.errorMessage = _data["errorMessage"];
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): WhiteLabelResult {
        data = typeof data === 'object' ? data : {};
        let result = new WhiteLabelResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultSet"] = this.defaultSet;
        data["subDomain"] = this.subDomain;
        data["logoUrl"] = this.logoUrl;
        data["landingTitle"] = this.landingTitle;
        data["topLeftTitle"] = this.topLeftTitle;
        data["welcomeMessage"] = this.welcomeMessage;
        data["hasError"] = this.hasError;
        data["errorMessage"] = this.errorMessage;
        data["accountName"] = this.accountName;
        return data;
    }
}

export interface IWhiteLabelResult {
    defaultSet?: boolean;
    subDomain?: string | undefined;
    logoUrl?: string | undefined;
    landingTitle?: string | undefined;
    topLeftTitle?: string | undefined;
    welcomeMessage?: string | undefined;
    hasError?: boolean;
    errorMessage?: string | undefined;
    accountName?: string | undefined;
}

export enum CloudAssetWidgetRequestType {
    Cloud = "Cloud",
    CostCenter = "CostCenter",
}

export class AXReference implements IAXReference {
    id?: number;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    account?: Account;
    dateCreated?: Date;
    createdByEntraId?: string | undefined;
    dateModified?: Date | undefined;
    modifiedByEntraId?: string | undefined;

    constructor(data?: IAXReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axNumber = _data["axNumber"];
            this.axTitle = _data["axTitle"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : undefined as any;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.createdByEntraId = _data["createdByEntraId"];
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.modifiedByEntraId = _data["modifiedByEntraId"];
        }
    }

    static fromJS(data: any): AXReference {
        data = typeof data === 'object' ? data : {};
        let result = new AXReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axNumber"] = this.axNumber;
        data["axTitle"] = this.axTitle;
        data["account"] = this.account ? this.account.toJSON() : undefined as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["createdByEntraId"] = this.createdByEntraId;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["modifiedByEntraId"] = this.modifiedByEntraId;
        return data;
    }
}

export interface IAXReference {
    id?: number;
    axNumber?: string | undefined;
    axTitle?: string | undefined;
    account?: Account;
    dateCreated?: Date;
    createdByEntraId?: string | undefined;
    dateModified?: Date | undefined;
    modifiedByEntraId?: string | undefined;
}

export class Account implements IAccount {
    id?: number;
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: number;
    active?: boolean;
    additionalAddressInformation?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    alternatePhone1?: string | undefined;
    alternatePhone2?: string | undefined;
    assetValue?: number;
    billToAccountPhysicalLocationID?: number;
    billToAdditionalAddressInformation?: string | undefined;
    billToAddress1?: string | undefined;
    billToAddress2?: string | undefined;
    billToAddressToUse?: number;
    billToAttention?: string | undefined;
    billToCity?: string | undefined;
    billToCountryID?: number;
    billToState?: string | undefined;
    billToZipCode?: string | undefined;
    city?: string | undefined;
    clientPortalActive?: boolean;
    competitorID?: number;
    country?: string | undefined;
    countryID?: number;
    createDate?: Date;
    currencyID?: number;
    invoiceEmailMessageID?: number;
    invoiceMethod?: number;
    invoiceNonContractItemsToParentAccount?: boolean;
    invoiceTemplateID?: number;
    keyAccountIcon?: number;
    marketSegmentID?: number;
    phone?: string | undefined;
    postalCode?: string | undefined;
    quoteEmailMessageID?: number;
    quoteTemplateID?: number;
    sicCode?: string | undefined;
    state?: string | undefined;
    stockMarket?: string | undefined;
    stockSymbol?: string | undefined;
    taskFireActive?: boolean;
    taxExempt?: boolean;
    taxID?: string | undefined;
    taxRegionID?: number;
    territoryID?: number;
    webAddress?: string | undefined;
    readonly userDefinedFieldsObject?: string | undefined;
    axNumber?: string | undefined;
    accountExecutiveEmail?: string | undefined;
    lastActivityDate?: Date;
    parentAccountID?: number | undefined;
    userDefinedFieldsJson?: string | undefined;
    subdomainPrefix?: string | undefined;
    subdomainSettingsJson?: string | undefined;
    axReferences?: AXReference[] | undefined;
    noManualAuthRequired?: boolean;
    onboardingStatus?: number;
    costCenters?: CostCenter[] | undefined;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.accountType = _data["accountType"];
            this.active = _data["active"];
            this.additionalAddressInformation = _data["additionalAddressInformation"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.alternatePhone1 = _data["alternatePhone1"];
            this.alternatePhone2 = _data["alternatePhone2"];
            this.assetValue = _data["assetValue"];
            this.billToAccountPhysicalLocationID = _data["billToAccountPhysicalLocationID"];
            this.billToAdditionalAddressInformation = _data["billToAdditionalAddressInformation"];
            this.billToAddress1 = _data["billToAddress1"];
            this.billToAddress2 = _data["billToAddress2"];
            this.billToAddressToUse = _data["billToAddressToUse"];
            this.billToAttention = _data["billToAttention"];
            this.billToCity = _data["billToCity"];
            this.billToCountryID = _data["billToCountryID"];
            this.billToState = _data["billToState"];
            this.billToZipCode = _data["billToZipCode"];
            this.city = _data["city"];
            this.clientPortalActive = _data["clientPortalActive"];
            this.competitorID = _data["competitorID"];
            this.country = _data["country"];
            this.countryID = _data["countryID"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.currencyID = _data["currencyID"];
            this.invoiceEmailMessageID = _data["invoiceEmailMessageID"];
            this.invoiceMethod = _data["invoiceMethod"];
            this.invoiceNonContractItemsToParentAccount = _data["invoiceNonContractItemsToParentAccount"];
            this.invoiceTemplateID = _data["invoiceTemplateID"];
            this.keyAccountIcon = _data["keyAccountIcon"];
            this.marketSegmentID = _data["marketSegmentID"];
            this.phone = _data["phone"];
            this.postalCode = _data["postalCode"];
            this.quoteEmailMessageID = _data["quoteEmailMessageID"];
            this.quoteTemplateID = _data["quoteTemplateID"];
            this.sicCode = _data["sicCode"];
            this.state = _data["state"];
            this.stockMarket = _data["stockMarket"];
            this.stockSymbol = _data["stockSymbol"];
            this.taskFireActive = _data["taskFireActive"];
            this.taxExempt = _data["taxExempt"];
            this.taxID = _data["taxID"];
            this.taxRegionID = _data["taxRegionID"];
            this.territoryID = _data["territoryID"];
            this.webAddress = _data["webAddress"];
            (this as any).userDefinedFieldsObject = _data["userDefinedFieldsObject"];
            this.axNumber = _data["axNumber"];
            this.accountExecutiveEmail = _data["accountExecutiveEmail"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
            this.parentAccountID = _data["parentAccountID"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.subdomainPrefix = _data["subdomainPrefix"];
            this.subdomainSettingsJson = _data["subdomainSettingsJson"];
            if (Array.isArray(_data["axReferences"])) {
                this.axReferences = [] as any;
                for (let item of _data["axReferences"])
                    this.axReferences!.push(AXReference.fromJS(item));
            }
            this.noManualAuthRequired = _data["noManualAuthRequired"];
            this.onboardingStatus = _data["onboardingStatus"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters!.push(CostCenter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["accountType"] = this.accountType;
        data["active"] = this.active;
        data["additionalAddressInformation"] = this.additionalAddressInformation;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["alternatePhone1"] = this.alternatePhone1;
        data["alternatePhone2"] = this.alternatePhone2;
        data["assetValue"] = this.assetValue;
        data["billToAccountPhysicalLocationID"] = this.billToAccountPhysicalLocationID;
        data["billToAdditionalAddressInformation"] = this.billToAdditionalAddressInformation;
        data["billToAddress1"] = this.billToAddress1;
        data["billToAddress2"] = this.billToAddress2;
        data["billToAddressToUse"] = this.billToAddressToUse;
        data["billToAttention"] = this.billToAttention;
        data["billToCity"] = this.billToCity;
        data["billToCountryID"] = this.billToCountryID;
        data["billToState"] = this.billToState;
        data["billToZipCode"] = this.billToZipCode;
        data["city"] = this.city;
        data["clientPortalActive"] = this.clientPortalActive;
        data["competitorID"] = this.competitorID;
        data["country"] = this.country;
        data["countryID"] = this.countryID;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["currencyID"] = this.currencyID;
        data["invoiceEmailMessageID"] = this.invoiceEmailMessageID;
        data["invoiceMethod"] = this.invoiceMethod;
        data["invoiceNonContractItemsToParentAccount"] = this.invoiceNonContractItemsToParentAccount;
        data["invoiceTemplateID"] = this.invoiceTemplateID;
        data["keyAccountIcon"] = this.keyAccountIcon;
        data["marketSegmentID"] = this.marketSegmentID;
        data["phone"] = this.phone;
        data["postalCode"] = this.postalCode;
        data["quoteEmailMessageID"] = this.quoteEmailMessageID;
        data["quoteTemplateID"] = this.quoteTemplateID;
        data["sicCode"] = this.sicCode;
        data["state"] = this.state;
        data["stockMarket"] = this.stockMarket;
        data["stockSymbol"] = this.stockSymbol;
        data["taskFireActive"] = this.taskFireActive;
        data["taxExempt"] = this.taxExempt;
        data["taxID"] = this.taxID;
        data["taxRegionID"] = this.taxRegionID;
        data["territoryID"] = this.territoryID;
        data["webAddress"] = this.webAddress;
        data["userDefinedFieldsObject"] = this.userDefinedFieldsObject;
        data["axNumber"] = this.axNumber;
        data["accountExecutiveEmail"] = this.accountExecutiveEmail;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : undefined as any;
        data["parentAccountID"] = this.parentAccountID;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["subdomainPrefix"] = this.subdomainPrefix;
        data["subdomainSettingsJson"] = this.subdomainSettingsJson;
        if (Array.isArray(this.axReferences)) {
            data["axReferences"] = [];
            for (let item of this.axReferences)
                data["axReferences"].push(item ? item.toJSON() : undefined as any);
        }
        data["noManualAuthRequired"] = this.noManualAuthRequired;
        data["onboardingStatus"] = this.onboardingStatus;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccount {
    id?: number;
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: number;
    active?: boolean;
    additionalAddressInformation?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    alternatePhone1?: string | undefined;
    alternatePhone2?: string | undefined;
    assetValue?: number;
    billToAccountPhysicalLocationID?: number;
    billToAdditionalAddressInformation?: string | undefined;
    billToAddress1?: string | undefined;
    billToAddress2?: string | undefined;
    billToAddressToUse?: number;
    billToAttention?: string | undefined;
    billToCity?: string | undefined;
    billToCountryID?: number;
    billToState?: string | undefined;
    billToZipCode?: string | undefined;
    city?: string | undefined;
    clientPortalActive?: boolean;
    competitorID?: number;
    country?: string | undefined;
    countryID?: number;
    createDate?: Date;
    currencyID?: number;
    invoiceEmailMessageID?: number;
    invoiceMethod?: number;
    invoiceNonContractItemsToParentAccount?: boolean;
    invoiceTemplateID?: number;
    keyAccountIcon?: number;
    marketSegmentID?: number;
    phone?: string | undefined;
    postalCode?: string | undefined;
    quoteEmailMessageID?: number;
    quoteTemplateID?: number;
    sicCode?: string | undefined;
    state?: string | undefined;
    stockMarket?: string | undefined;
    stockSymbol?: string | undefined;
    taskFireActive?: boolean;
    taxExempt?: boolean;
    taxID?: string | undefined;
    taxRegionID?: number;
    territoryID?: number;
    webAddress?: string | undefined;
    userDefinedFieldsObject?: string | undefined;
    axNumber?: string | undefined;
    accountExecutiveEmail?: string | undefined;
    lastActivityDate?: Date;
    parentAccountID?: number | undefined;
    userDefinedFieldsJson?: string | undefined;
    subdomainPrefix?: string | undefined;
    subdomainSettingsJson?: string | undefined;
    axReferences?: AXReference[] | undefined;
    noManualAuthRequired?: boolean;
    onboardingStatus?: number;
    costCenters?: CostCenter[] | undefined;
}

export class AggregatedContractsResponse implements IAggregatedContractsResponse {
    contractRetainers?: ContractRetainerSpend[] | undefined;

    constructor(data?: IAggregatedContractsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contractRetainers"])) {
                this.contractRetainers = [] as any;
                for (let item of _data["contractRetainers"])
                    this.contractRetainers!.push(ContractRetainerSpend.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AggregatedContractsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AggregatedContractsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contractRetainers)) {
            data["contractRetainers"] = [];
            for (let item of this.contractRetainers)
                data["contractRetainers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAggregatedContractsResponse {
    contractRetainers?: ContractRetainerSpend[] | undefined;
}

export class ConfigurationItem implements IConfigurationItem {
    id?: number;
    accountID?: number | undefined;
    accountPhysicalLocationID?: number | undefined;
    productID?: number | undefined;
    contractID?: number | undefined;
    serviceID?: number | undefined;
    serviceBundleID?: number | undefined;
    contactID?: number | undefined;
    vendorID?: number | undefined;
    installedByID?: number | undefined;
    installedByContactID?: number | undefined;
    parentInstalledProductID?: number | undefined;
    contractServiceID?: number | undefined;
    contractServiceBundleID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    active?: boolean;
    createDate?: Date;
    installDate?: Date;
    notes?: string | undefined;
    referenceNumber?: string | undefined;
    referenceTitle?: string | undefined;
    serialNumber?: string | undefined;
    warrantyExpirationDate?: Date;
    type?: number;
    location?: string | undefined;
    lastModifiedTime?: Date;
    rmmDeviceID?: number | undefined;
    rmmDeviceUID?: string | undefined;
    rmmDeviceAuditArchitectureID?: number | undefined;
    rmmDeviceAuditDescription?: string | undefined;
    rmmDeviceAuditDisplayAdaptorID?: number | undefined;
    rmmDeviceAuditDomainID?: number | undefined;
    rmmDeviceAuditExternalIPAddress?: string | undefined;
    rmmDeviceAuditHostname?: string | undefined;
    rmmDeviceAuditIPAddress?: string | undefined;
    rmmDeviceAuditMacAddress?: string | undefined;
    rmmDeviceAuditManufacturerID?: number | undefined;
    rmmDeviceAuditMemoryBytes?: number | undefined;
    rmmDeviceAuditModelID?: number | undefined;
    rmmDeviceAuditMotherboardID?: number | undefined;
    rmmDeviceAuditOperatingSystem?: string | undefined;
    rmmDeviceAuditProcessorID?: number | undefined;
    rmmDeviceAuditServicePackID?: number | undefined;
    rmmDeviceAuditStorageBytes?: number | undefined;
    rmmDeviceAuditDeviceTypeID?: number | undefined;
    rmmDeviceAuditSNMPLocation?: string | undefined;
    rmmDeviceAuditSNMPName?: string | undefined;
    rmmDeviceAuditSNMPContact?: string | undefined;
    rmmDeviceAuditMobileNetworkOperatorID?: number | undefined;
    rmmDeviceAuditMobileNumber?: string | undefined;
    rmmDeviceAuditMissingPatchCount?: number | undefined;
    rmmOpenAlertCount?: number | undefined;
    rmmDeviceAuditLastUser?: string | undefined;
    dattoSerialNumber?: string | undefined;
    dattoInternalIP?: string | undefined;
    dattoRemoteIP?: string | undefined;
    dattoHostname?: string | undefined;
    dattoProtectedKilobytes?: number | undefined;
    dattoUsedKilobytes?: number | undefined;
    dattoAvailableKilobytes?: number | undefined;
    dattoPercentageUsed?: number | undefined;
    dattoOffsiteUsedBytes?: number | undefined;
    dattoOSVersionID?: number | undefined;
    dattoZFSVersionID?: number | undefined;
    dattoKernelVersionID?: number | undefined;
    dattoNICSpeedKilobitsPerSecond?: number | undefined;
    dattoDeviceMemoryMegabytes?: number | undefined;
    dattoUptimeSeconds?: number | undefined;
    dattoNumberOfAgents?: number | undefined;
    dattoNumberOfDrives?: number | undefined;
    dattoDrivesErrors?: boolean;
    dattoNumberOfVolumes?: number | undefined;
    numberOfUsers?: number;
    dattoLastCheckInDateTime?: Date | undefined;
    userDefinedFieldsJson?: string | undefined;
    installedProductCategoryID?: number | undefined;
    costCenters?: CostCenterConfigItem[] | undefined;

    constructor(data?: IConfigurationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountID = _data["accountID"];
            this.accountPhysicalLocationID = _data["accountPhysicalLocationID"];
            this.productID = _data["productID"];
            this.contractID = _data["contractID"];
            this.serviceID = _data["serviceID"];
            this.serviceBundleID = _data["serviceBundleID"];
            this.contactID = _data["contactID"];
            this.vendorID = _data["vendorID"];
            this.installedByID = _data["installedByID"];
            this.installedByContactID = _data["installedByContactID"];
            this.parentInstalledProductID = _data["parentInstalledProductID"];
            this.contractServiceID = _data["contractServiceID"];
            this.contractServiceBundleID = _data["contractServiceBundleID"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            this.active = _data["active"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.installDate = _data["installDate"] ? new Date(_data["installDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.referenceNumber = _data["referenceNumber"];
            this.referenceTitle = _data["referenceTitle"];
            this.serialNumber = _data["serialNumber"];
            this.warrantyExpirationDate = _data["warrantyExpirationDate"] ? new Date(_data["warrantyExpirationDate"].toString()) : undefined as any;
            this.type = _data["type"];
            this.location = _data["location"];
            this.lastModifiedTime = _data["lastModifiedTime"] ? new Date(_data["lastModifiedTime"].toString()) : undefined as any;
            this.rmmDeviceID = _data["rmmDeviceID"];
            this.rmmDeviceUID = _data["rmmDeviceUID"];
            this.rmmDeviceAuditArchitectureID = _data["rmmDeviceAuditArchitectureID"];
            this.rmmDeviceAuditDescription = _data["rmmDeviceAuditDescription"];
            this.rmmDeviceAuditDisplayAdaptorID = _data["rmmDeviceAuditDisplayAdaptorID"];
            this.rmmDeviceAuditDomainID = _data["rmmDeviceAuditDomainID"];
            this.rmmDeviceAuditExternalIPAddress = _data["rmmDeviceAuditExternalIPAddress"];
            this.rmmDeviceAuditHostname = _data["rmmDeviceAuditHostname"];
            this.rmmDeviceAuditIPAddress = _data["rmmDeviceAuditIPAddress"];
            this.rmmDeviceAuditMacAddress = _data["rmmDeviceAuditMacAddress"];
            this.rmmDeviceAuditManufacturerID = _data["rmmDeviceAuditManufacturerID"];
            this.rmmDeviceAuditMemoryBytes = _data["rmmDeviceAuditMemoryBytes"];
            this.rmmDeviceAuditModelID = _data["rmmDeviceAuditModelID"];
            this.rmmDeviceAuditMotherboardID = _data["rmmDeviceAuditMotherboardID"];
            this.rmmDeviceAuditOperatingSystem = _data["rmmDeviceAuditOperatingSystem"];
            this.rmmDeviceAuditProcessorID = _data["rmmDeviceAuditProcessorID"];
            this.rmmDeviceAuditServicePackID = _data["rmmDeviceAuditServicePackID"];
            this.rmmDeviceAuditStorageBytes = _data["rmmDeviceAuditStorageBytes"];
            this.rmmDeviceAuditDeviceTypeID = _data["rmmDeviceAuditDeviceTypeID"];
            this.rmmDeviceAuditSNMPLocation = _data["rmmDeviceAuditSNMPLocation"];
            this.rmmDeviceAuditSNMPName = _data["rmmDeviceAuditSNMPName"];
            this.rmmDeviceAuditSNMPContact = _data["rmmDeviceAuditSNMPContact"];
            this.rmmDeviceAuditMobileNetworkOperatorID = _data["rmmDeviceAuditMobileNetworkOperatorID"];
            this.rmmDeviceAuditMobileNumber = _data["rmmDeviceAuditMobileNumber"];
            this.rmmDeviceAuditMissingPatchCount = _data["rmmDeviceAuditMissingPatchCount"];
            this.rmmOpenAlertCount = _data["rmmOpenAlertCount"];
            this.rmmDeviceAuditLastUser = _data["rmmDeviceAuditLastUser"];
            this.dattoSerialNumber = _data["dattoSerialNumber"];
            this.dattoInternalIP = _data["dattoInternalIP"];
            this.dattoRemoteIP = _data["dattoRemoteIP"];
            this.dattoHostname = _data["dattoHostname"];
            this.dattoProtectedKilobytes = _data["dattoProtectedKilobytes"];
            this.dattoUsedKilobytes = _data["dattoUsedKilobytes"];
            this.dattoAvailableKilobytes = _data["dattoAvailableKilobytes"];
            this.dattoPercentageUsed = _data["dattoPercentageUsed"];
            this.dattoOffsiteUsedBytes = _data["dattoOffsiteUsedBytes"];
            this.dattoOSVersionID = _data["dattoOSVersionID"];
            this.dattoZFSVersionID = _data["dattoZFSVersionID"];
            this.dattoKernelVersionID = _data["dattoKernelVersionID"];
            this.dattoNICSpeedKilobitsPerSecond = _data["dattoNICSpeedKilobitsPerSecond"];
            this.dattoDeviceMemoryMegabytes = _data["dattoDeviceMemoryMegabytes"];
            this.dattoUptimeSeconds = _data["dattoUptimeSeconds"];
            this.dattoNumberOfAgents = _data["dattoNumberOfAgents"];
            this.dattoNumberOfDrives = _data["dattoNumberOfDrives"];
            this.dattoDrivesErrors = _data["dattoDrivesErrors"];
            this.dattoNumberOfVolumes = _data["dattoNumberOfVolumes"];
            this.numberOfUsers = _data["numberOfUsers"];
            this.dattoLastCheckInDateTime = _data["dattoLastCheckInDateTime"] ? new Date(_data["dattoLastCheckInDateTime"].toString()) : undefined as any;
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.installedProductCategoryID = _data["installedProductCategoryID"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters!.push(CostCenterConfigItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationItem {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountID"] = this.accountID;
        data["accountPhysicalLocationID"] = this.accountPhysicalLocationID;
        data["productID"] = this.productID;
        data["contractID"] = this.contractID;
        data["serviceID"] = this.serviceID;
        data["serviceBundleID"] = this.serviceBundleID;
        data["contactID"] = this.contactID;
        data["vendorID"] = this.vendorID;
        data["installedByID"] = this.installedByID;
        data["installedByContactID"] = this.installedByContactID;
        data["parentInstalledProductID"] = this.parentInstalledProductID;
        data["contractServiceID"] = this.contractServiceID;
        data["contractServiceBundleID"] = this.contractServiceBundleID;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        data["active"] = this.active;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["installDate"] = this.installDate ? this.installDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["referenceNumber"] = this.referenceNumber;
        data["referenceTitle"] = this.referenceTitle;
        data["serialNumber"] = this.serialNumber;
        data["warrantyExpirationDate"] = this.warrantyExpirationDate ? this.warrantyExpirationDate.toISOString() : undefined as any;
        data["type"] = this.type;
        data["location"] = this.location;
        data["lastModifiedTime"] = this.lastModifiedTime ? this.lastModifiedTime.toISOString() : undefined as any;
        data["rmmDeviceID"] = this.rmmDeviceID;
        data["rmmDeviceUID"] = this.rmmDeviceUID;
        data["rmmDeviceAuditArchitectureID"] = this.rmmDeviceAuditArchitectureID;
        data["rmmDeviceAuditDescription"] = this.rmmDeviceAuditDescription;
        data["rmmDeviceAuditDisplayAdaptorID"] = this.rmmDeviceAuditDisplayAdaptorID;
        data["rmmDeviceAuditDomainID"] = this.rmmDeviceAuditDomainID;
        data["rmmDeviceAuditExternalIPAddress"] = this.rmmDeviceAuditExternalIPAddress;
        data["rmmDeviceAuditHostname"] = this.rmmDeviceAuditHostname;
        data["rmmDeviceAuditIPAddress"] = this.rmmDeviceAuditIPAddress;
        data["rmmDeviceAuditMacAddress"] = this.rmmDeviceAuditMacAddress;
        data["rmmDeviceAuditManufacturerID"] = this.rmmDeviceAuditManufacturerID;
        data["rmmDeviceAuditMemoryBytes"] = this.rmmDeviceAuditMemoryBytes;
        data["rmmDeviceAuditModelID"] = this.rmmDeviceAuditModelID;
        data["rmmDeviceAuditMotherboardID"] = this.rmmDeviceAuditMotherboardID;
        data["rmmDeviceAuditOperatingSystem"] = this.rmmDeviceAuditOperatingSystem;
        data["rmmDeviceAuditProcessorID"] = this.rmmDeviceAuditProcessorID;
        data["rmmDeviceAuditServicePackID"] = this.rmmDeviceAuditServicePackID;
        data["rmmDeviceAuditStorageBytes"] = this.rmmDeviceAuditStorageBytes;
        data["rmmDeviceAuditDeviceTypeID"] = this.rmmDeviceAuditDeviceTypeID;
        data["rmmDeviceAuditSNMPLocation"] = this.rmmDeviceAuditSNMPLocation;
        data["rmmDeviceAuditSNMPName"] = this.rmmDeviceAuditSNMPName;
        data["rmmDeviceAuditSNMPContact"] = this.rmmDeviceAuditSNMPContact;
        data["rmmDeviceAuditMobileNetworkOperatorID"] = this.rmmDeviceAuditMobileNetworkOperatorID;
        data["rmmDeviceAuditMobileNumber"] = this.rmmDeviceAuditMobileNumber;
        data["rmmDeviceAuditMissingPatchCount"] = this.rmmDeviceAuditMissingPatchCount;
        data["rmmOpenAlertCount"] = this.rmmOpenAlertCount;
        data["rmmDeviceAuditLastUser"] = this.rmmDeviceAuditLastUser;
        data["dattoSerialNumber"] = this.dattoSerialNumber;
        data["dattoInternalIP"] = this.dattoInternalIP;
        data["dattoRemoteIP"] = this.dattoRemoteIP;
        data["dattoHostname"] = this.dattoHostname;
        data["dattoProtectedKilobytes"] = this.dattoProtectedKilobytes;
        data["dattoUsedKilobytes"] = this.dattoUsedKilobytes;
        data["dattoAvailableKilobytes"] = this.dattoAvailableKilobytes;
        data["dattoPercentageUsed"] = this.dattoPercentageUsed;
        data["dattoOffsiteUsedBytes"] = this.dattoOffsiteUsedBytes;
        data["dattoOSVersionID"] = this.dattoOSVersionID;
        data["dattoZFSVersionID"] = this.dattoZFSVersionID;
        data["dattoKernelVersionID"] = this.dattoKernelVersionID;
        data["dattoNICSpeedKilobitsPerSecond"] = this.dattoNICSpeedKilobitsPerSecond;
        data["dattoDeviceMemoryMegabytes"] = this.dattoDeviceMemoryMegabytes;
        data["dattoUptimeSeconds"] = this.dattoUptimeSeconds;
        data["dattoNumberOfAgents"] = this.dattoNumberOfAgents;
        data["dattoNumberOfDrives"] = this.dattoNumberOfDrives;
        data["dattoDrivesErrors"] = this.dattoDrivesErrors;
        data["dattoNumberOfVolumes"] = this.dattoNumberOfVolumes;
        data["numberOfUsers"] = this.numberOfUsers;
        data["dattoLastCheckInDateTime"] = this.dattoLastCheckInDateTime ? this.dattoLastCheckInDateTime.toISOString() : undefined as any;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["installedProductCategoryID"] = this.installedProductCategoryID;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConfigurationItem {
    id?: number;
    accountID?: number | undefined;
    accountPhysicalLocationID?: number | undefined;
    productID?: number | undefined;
    contractID?: number | undefined;
    serviceID?: number | undefined;
    serviceBundleID?: number | undefined;
    contactID?: number | undefined;
    vendorID?: number | undefined;
    installedByID?: number | undefined;
    installedByContactID?: number | undefined;
    parentInstalledProductID?: number | undefined;
    contractServiceID?: number | undefined;
    contractServiceBundleID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    active?: boolean;
    createDate?: Date;
    installDate?: Date;
    notes?: string | undefined;
    referenceNumber?: string | undefined;
    referenceTitle?: string | undefined;
    serialNumber?: string | undefined;
    warrantyExpirationDate?: Date;
    type?: number;
    location?: string | undefined;
    lastModifiedTime?: Date;
    rmmDeviceID?: number | undefined;
    rmmDeviceUID?: string | undefined;
    rmmDeviceAuditArchitectureID?: number | undefined;
    rmmDeviceAuditDescription?: string | undefined;
    rmmDeviceAuditDisplayAdaptorID?: number | undefined;
    rmmDeviceAuditDomainID?: number | undefined;
    rmmDeviceAuditExternalIPAddress?: string | undefined;
    rmmDeviceAuditHostname?: string | undefined;
    rmmDeviceAuditIPAddress?: string | undefined;
    rmmDeviceAuditMacAddress?: string | undefined;
    rmmDeviceAuditManufacturerID?: number | undefined;
    rmmDeviceAuditMemoryBytes?: number | undefined;
    rmmDeviceAuditModelID?: number | undefined;
    rmmDeviceAuditMotherboardID?: number | undefined;
    rmmDeviceAuditOperatingSystem?: string | undefined;
    rmmDeviceAuditProcessorID?: number | undefined;
    rmmDeviceAuditServicePackID?: number | undefined;
    rmmDeviceAuditStorageBytes?: number | undefined;
    rmmDeviceAuditDeviceTypeID?: number | undefined;
    rmmDeviceAuditSNMPLocation?: string | undefined;
    rmmDeviceAuditSNMPName?: string | undefined;
    rmmDeviceAuditSNMPContact?: string | undefined;
    rmmDeviceAuditMobileNetworkOperatorID?: number | undefined;
    rmmDeviceAuditMobileNumber?: string | undefined;
    rmmDeviceAuditMissingPatchCount?: number | undefined;
    rmmOpenAlertCount?: number | undefined;
    rmmDeviceAuditLastUser?: string | undefined;
    dattoSerialNumber?: string | undefined;
    dattoInternalIP?: string | undefined;
    dattoRemoteIP?: string | undefined;
    dattoHostname?: string | undefined;
    dattoProtectedKilobytes?: number | undefined;
    dattoUsedKilobytes?: number | undefined;
    dattoAvailableKilobytes?: number | undefined;
    dattoPercentageUsed?: number | undefined;
    dattoOffsiteUsedBytes?: number | undefined;
    dattoOSVersionID?: number | undefined;
    dattoZFSVersionID?: number | undefined;
    dattoKernelVersionID?: number | undefined;
    dattoNICSpeedKilobitsPerSecond?: number | undefined;
    dattoDeviceMemoryMegabytes?: number | undefined;
    dattoUptimeSeconds?: number | undefined;
    dattoNumberOfAgents?: number | undefined;
    dattoNumberOfDrives?: number | undefined;
    dattoDrivesErrors?: boolean;
    dattoNumberOfVolumes?: number | undefined;
    numberOfUsers?: number;
    dattoLastCheckInDateTime?: Date | undefined;
    userDefinedFieldsJson?: string | undefined;
    installedProductCategoryID?: number | undefined;
    costCenters?: CostCenterConfigItem[] | undefined;
}

export class ConfigurationItem_CreateUpdate implements IConfigurationItem_CreateUpdate {
    axNumber?: string | undefined;
    referenceName?: string | undefined;
    referenceNumber?: string | undefined;
    product?: string | undefined;
    installDate?: Date | undefined;
    active?: boolean;
    numberOfUsers?: number | undefined;
    contractID?: number | undefined;
    msCustomerID?: string | undefined;
    msProgram?: string | undefined;
    msParentSubscriptionId?: string | undefined;
    msDomain?: string | undefined;
    msCompanyName?: string | undefined;
    awsAccountEmail?: string | undefined;
    awsAccountName?: string | undefined;
    awsSupportLevel?: string | undefined;
    awsAccountType?: string | undefined;
    awsPayerId?: string | undefined;
    awsPayerAccountName?: string | undefined;
    awsPayerAccountEmail?: string | undefined;
    gcpBillingAccountId?: string | undefined;

    constructor(data?: IConfigurationItem_CreateUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axNumber = _data["axNumber"];
            this.referenceName = _data["referenceName"];
            this.referenceNumber = _data["referenceNumber"];
            this.product = _data["product"];
            this.installDate = _data["installDate"] ? new Date(_data["installDate"].toString()) : undefined as any;
            this.active = _data["active"];
            this.numberOfUsers = _data["numberOfUsers"];
            this.contractID = _data["contractID"];
            this.msCustomerID = _data["msCustomerID"];
            this.msProgram = _data["msProgram"];
            this.msParentSubscriptionId = _data["msParentSubscriptionId"];
            this.msDomain = _data["msDomain"];
            this.msCompanyName = _data["msCompanyName"];
            this.awsAccountEmail = _data["awsAccountEmail"];
            this.awsAccountName = _data["awsAccountName"];
            this.awsSupportLevel = _data["awsSupportLevel"];
            this.awsAccountType = _data["awsAccountType"];
            this.awsPayerId = _data["awsPayerId"];
            this.awsPayerAccountName = _data["awsPayerAccountName"];
            this.awsPayerAccountEmail = _data["awsPayerAccountEmail"];
            this.gcpBillingAccountId = _data["gcpBillingAccountId"];
        }
    }

    static fromJS(data: any): ConfigurationItem_CreateUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationItem_CreateUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axNumber"] = this.axNumber;
        data["referenceName"] = this.referenceName;
        data["referenceNumber"] = this.referenceNumber;
        data["product"] = this.product;
        data["installDate"] = this.installDate ? this.installDate.toISOString() : undefined as any;
        data["active"] = this.active;
        data["numberOfUsers"] = this.numberOfUsers;
        data["contractID"] = this.contractID;
        data["msCustomerID"] = this.msCustomerID;
        data["msProgram"] = this.msProgram;
        data["msParentSubscriptionId"] = this.msParentSubscriptionId;
        data["msDomain"] = this.msDomain;
        data["msCompanyName"] = this.msCompanyName;
        data["awsAccountEmail"] = this.awsAccountEmail;
        data["awsAccountName"] = this.awsAccountName;
        data["awsSupportLevel"] = this.awsSupportLevel;
        data["awsAccountType"] = this.awsAccountType;
        data["awsPayerId"] = this.awsPayerId;
        data["awsPayerAccountName"] = this.awsPayerAccountName;
        data["awsPayerAccountEmail"] = this.awsPayerAccountEmail;
        data["gcpBillingAccountId"] = this.gcpBillingAccountId;
        return data;
    }
}

export interface IConfigurationItem_CreateUpdate {
    axNumber?: string | undefined;
    referenceName?: string | undefined;
    referenceNumber?: string | undefined;
    product?: string | undefined;
    installDate?: Date | undefined;
    active?: boolean;
    numberOfUsers?: number | undefined;
    contractID?: number | undefined;
    msCustomerID?: string | undefined;
    msProgram?: string | undefined;
    msParentSubscriptionId?: string | undefined;
    msDomain?: string | undefined;
    msCompanyName?: string | undefined;
    awsAccountEmail?: string | undefined;
    awsAccountName?: string | undefined;
    awsSupportLevel?: string | undefined;
    awsAccountType?: string | undefined;
    awsPayerId?: string | undefined;
    awsPayerAccountName?: string | undefined;
    awsPayerAccountEmail?: string | undefined;
    gcpBillingAccountId?: string | undefined;
}

export class Contact implements IContact {
    id?: number;
    active?: number;
    alternatePhone?: string | undefined;
    bulkEmailOptOut?: boolean;
    bulkEmailOptOutTime?: Date;
    accountPhysicalLocationId?: number;
    addressLine?: string | undefined;
    addressLine1?: string | undefined;
    additionalAddressInformation?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    roomNumber?: string | undefined;
    countryId?: number;
    createDate?: Date;
    eMailAddress?: string | undefined;
    eMailAddress2?: string | undefined;
    eMailAddress3?: string | undefined;
    externalId?: string | undefined;
    faxNumber?: string | undefined;
    mobilePhone?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    lastName?: string | undefined;
    namePrefix?: number;
    nameSuffix?: number;
    note?: string | undefined;
    notification?: boolean;
    primaryContact?: boolean;
    solicitationOptOut?: boolean;
    solicitationOptOutTime?: Date;
    surveyOptOut?: boolean;
    facebookUrl?: string | undefined;
    twitterUrl?: string | undefined;
    linkedInUrl?: string | undefined;
    accountID?: number | undefined;
    ticketAdditionalContacts?: TicketAdditionalContact[] | undefined;
    fullProjectAccess?: boolean;
    lastActivityDate?: Date;
    lastModifiedDate?: Date;
    userDefinedFieldsJson?: string | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.alternatePhone = _data["alternatePhone"];
            this.bulkEmailOptOut = _data["bulkEmailOptOut"];
            this.bulkEmailOptOutTime = _data["bulkEmailOptOutTime"] ? new Date(_data["bulkEmailOptOutTime"].toString()) : undefined as any;
            this.accountPhysicalLocationId = _data["accountPhysicalLocationId"];
            this.addressLine = _data["addressLine"];
            this.addressLine1 = _data["addressLine1"];
            this.additionalAddressInformation = _data["additionalAddressInformation"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.zipCode = _data["zipCode"];
            this.roomNumber = _data["roomNumber"];
            this.countryId = _data["countryId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.eMailAddress = _data["eMailAddress"];
            this.eMailAddress2 = _data["eMailAddress2"];
            this.eMailAddress3 = _data["eMailAddress3"];
            this.externalId = _data["externalId"];
            this.faxNumber = _data["faxNumber"];
            this.mobilePhone = _data["mobilePhone"];
            this.phone = _data["phone"];
            this.extension = _data["extension"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleInitial = _data["middleInitial"];
            this.lastName = _data["lastName"];
            this.namePrefix = _data["namePrefix"];
            this.nameSuffix = _data["nameSuffix"];
            this.note = _data["note"];
            this.notification = _data["notification"];
            this.primaryContact = _data["primaryContact"];
            this.solicitationOptOut = _data["solicitationOptOut"];
            this.solicitationOptOutTime = _data["solicitationOptOutTime"] ? new Date(_data["solicitationOptOutTime"].toString()) : undefined as any;
            this.surveyOptOut = _data["surveyOptOut"];
            this.facebookUrl = _data["facebookUrl"];
            this.twitterUrl = _data["twitterUrl"];
            this.linkedInUrl = _data["linkedInUrl"];
            this.accountID = _data["accountID"];
            if (Array.isArray(_data["ticketAdditionalContacts"])) {
                this.ticketAdditionalContacts = [] as any;
                for (let item of _data["ticketAdditionalContacts"])
                    this.ticketAdditionalContacts!.push(TicketAdditionalContact.fromJS(item));
            }
            this.fullProjectAccess = _data["fullProjectAccess"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["alternatePhone"] = this.alternatePhone;
        data["bulkEmailOptOut"] = this.bulkEmailOptOut;
        data["bulkEmailOptOutTime"] = this.bulkEmailOptOutTime ? this.bulkEmailOptOutTime.toISOString() : undefined as any;
        data["accountPhysicalLocationId"] = this.accountPhysicalLocationId;
        data["addressLine"] = this.addressLine;
        data["addressLine1"] = this.addressLine1;
        data["additionalAddressInformation"] = this.additionalAddressInformation;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["zipCode"] = this.zipCode;
        data["roomNumber"] = this.roomNumber;
        data["countryId"] = this.countryId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["eMailAddress"] = this.eMailAddress;
        data["eMailAddress2"] = this.eMailAddress2;
        data["eMailAddress3"] = this.eMailAddress3;
        data["externalId"] = this.externalId;
        data["faxNumber"] = this.faxNumber;
        data["mobilePhone"] = this.mobilePhone;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleInitial"] = this.middleInitial;
        data["lastName"] = this.lastName;
        data["namePrefix"] = this.namePrefix;
        data["nameSuffix"] = this.nameSuffix;
        data["note"] = this.note;
        data["notification"] = this.notification;
        data["primaryContact"] = this.primaryContact;
        data["solicitationOptOut"] = this.solicitationOptOut;
        data["solicitationOptOutTime"] = this.solicitationOptOutTime ? this.solicitationOptOutTime.toISOString() : undefined as any;
        data["surveyOptOut"] = this.surveyOptOut;
        data["facebookUrl"] = this.facebookUrl;
        data["twitterUrl"] = this.twitterUrl;
        data["linkedInUrl"] = this.linkedInUrl;
        data["accountID"] = this.accountID;
        if (Array.isArray(this.ticketAdditionalContacts)) {
            data["ticketAdditionalContacts"] = [];
            for (let item of this.ticketAdditionalContacts)
                data["ticketAdditionalContacts"].push(item ? item.toJSON() : undefined as any);
        }
        data["fullProjectAccess"] = this.fullProjectAccess;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : undefined as any;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        return data;
    }
}

export interface IContact {
    id?: number;
    active?: number;
    alternatePhone?: string | undefined;
    bulkEmailOptOut?: boolean;
    bulkEmailOptOutTime?: Date;
    accountPhysicalLocationId?: number;
    addressLine?: string | undefined;
    addressLine1?: string | undefined;
    additionalAddressInformation?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    roomNumber?: string | undefined;
    countryId?: number;
    createDate?: Date;
    eMailAddress?: string | undefined;
    eMailAddress2?: string | undefined;
    eMailAddress3?: string | undefined;
    externalId?: string | undefined;
    faxNumber?: string | undefined;
    mobilePhone?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    lastName?: string | undefined;
    namePrefix?: number;
    nameSuffix?: number;
    note?: string | undefined;
    notification?: boolean;
    primaryContact?: boolean;
    solicitationOptOut?: boolean;
    solicitationOptOutTime?: Date;
    surveyOptOut?: boolean;
    facebookUrl?: string | undefined;
    twitterUrl?: string | undefined;
    linkedInUrl?: string | undefined;
    accountID?: number | undefined;
    ticketAdditionalContacts?: TicketAdditionalContact[] | undefined;
    fullProjectAccess?: boolean;
    lastActivityDate?: Date;
    lastModifiedDate?: Date;
    userDefinedFieldsJson?: string | undefined;
}

export class Contract implements IContract {
    id?: number;
    userDefinedFieldsJson?: string | undefined;
    readonly userDefinedFieldsObject?: string | undefined;
    partnerName?: string | undefined;
    accountID?: number | undefined;
    axNumber?: string | undefined;
    billingPreference?: number;
    businessDivisionSubdivisionID?: number;
    compliance?: boolean;
    contactID?: number | undefined;
    contactName?: string | undefined;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractPeriodType?: string | undefined;
    contractType?: number;
    description?: string | undefined;
    endDate?: Date;
    estimatedCost?: number | undefined;
    estimatedHours?: number | undefined;
    estimatedRevenue?: number | undefined;
    exclusionContractID?: number | undefined;
    internalCurrencyOverageBillingRate?: number | undefined;
    internalCurrencySetupFee?: number | undefined;
    isDefaultContract?: boolean;
    opportunityID?: number | undefined;
    overageBillingRate?: number | undefined;
    purchaseOrderNumber?: string | undefined;
    renewedContractID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    setupFee?: number | undefined;
    setupFeeAllocationCodeID?: number | undefined;
    startDate?: Date;
    status?: number;
    timeReportingRequiresStartAndStopTimes?: number;
    deleted?: boolean;
    systemGuid?: string | undefined;
    parentSystemGuid?: string | undefined;

    constructor(data?: IContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            (this as any).userDefinedFieldsObject = _data["userDefinedFieldsObject"];
            this.partnerName = _data["partnerName"];
            this.accountID = _data["accountID"];
            this.axNumber = _data["axNumber"];
            this.billingPreference = _data["billingPreference"];
            this.businessDivisionSubdivisionID = _data["businessDivisionSubdivisionID"];
            this.compliance = _data["compliance"];
            this.contactID = _data["contactID"];
            this.contactName = _data["contactName"];
            this.contractCategory = _data["contractCategory"];
            this.contractName = _data["contractName"];
            this.contractNumber = _data["contractNumber"];
            this.contractPeriodType = _data["contractPeriodType"];
            this.contractType = _data["contractType"];
            this.description = _data["description"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.estimatedCost = _data["estimatedCost"];
            this.estimatedHours = _data["estimatedHours"];
            this.estimatedRevenue = _data["estimatedRevenue"];
            this.exclusionContractID = _data["exclusionContractID"];
            this.internalCurrencyOverageBillingRate = _data["internalCurrencyOverageBillingRate"];
            this.internalCurrencySetupFee = _data["internalCurrencySetupFee"];
            this.isDefaultContract = _data["isDefaultContract"];
            this.opportunityID = _data["opportunityID"];
            this.overageBillingRate = _data["overageBillingRate"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.renewedContractID = _data["renewedContractID"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            this.setupFee = _data["setupFee"];
            this.setupFeeAllocationCodeID = _data["setupFeeAllocationCodeID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.timeReportingRequiresStartAndStopTimes = _data["timeReportingRequiresStartAndStopTimes"];
            this.deleted = _data["deleted"];
            this.systemGuid = _data["systemGuid"];
            this.parentSystemGuid = _data["parentSystemGuid"];
        }
    }

    static fromJS(data: any): Contract {
        data = typeof data === 'object' ? data : {};
        let result = new Contract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["userDefinedFieldsObject"] = this.userDefinedFieldsObject;
        data["partnerName"] = this.partnerName;
        data["accountID"] = this.accountID;
        data["axNumber"] = this.axNumber;
        data["billingPreference"] = this.billingPreference;
        data["businessDivisionSubdivisionID"] = this.businessDivisionSubdivisionID;
        data["compliance"] = this.compliance;
        data["contactID"] = this.contactID;
        data["contactName"] = this.contactName;
        data["contractCategory"] = this.contractCategory;
        data["contractName"] = this.contractName;
        data["contractNumber"] = this.contractNumber;
        data["contractPeriodType"] = this.contractPeriodType;
        data["contractType"] = this.contractType;
        data["description"] = this.description;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["estimatedCost"] = this.estimatedCost;
        data["estimatedHours"] = this.estimatedHours;
        data["estimatedRevenue"] = this.estimatedRevenue;
        data["exclusionContractID"] = this.exclusionContractID;
        data["internalCurrencyOverageBillingRate"] = this.internalCurrencyOverageBillingRate;
        data["internalCurrencySetupFee"] = this.internalCurrencySetupFee;
        data["isDefaultContract"] = this.isDefaultContract;
        data["opportunityID"] = this.opportunityID;
        data["overageBillingRate"] = this.overageBillingRate;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["renewedContractID"] = this.renewedContractID;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        data["setupFee"] = this.setupFee;
        data["setupFeeAllocationCodeID"] = this.setupFeeAllocationCodeID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["timeReportingRequiresStartAndStopTimes"] = this.timeReportingRequiresStartAndStopTimes;
        data["deleted"] = this.deleted;
        data["systemGuid"] = this.systemGuid;
        data["parentSystemGuid"] = this.parentSystemGuid;
        return data;
    }
}

export interface IContract {
    id?: number;
    userDefinedFieldsJson?: string | undefined;
    userDefinedFieldsObject?: string | undefined;
    partnerName?: string | undefined;
    accountID?: number | undefined;
    axNumber?: string | undefined;
    billingPreference?: number;
    businessDivisionSubdivisionID?: number;
    compliance?: boolean;
    contactID?: number | undefined;
    contactName?: string | undefined;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    contractNumber?: string | undefined;
    contractPeriodType?: string | undefined;
    contractType?: number;
    description?: string | undefined;
    endDate?: Date;
    estimatedCost?: number | undefined;
    estimatedHours?: number | undefined;
    estimatedRevenue?: number | undefined;
    exclusionContractID?: number | undefined;
    internalCurrencyOverageBillingRate?: number | undefined;
    internalCurrencySetupFee?: number | undefined;
    isDefaultContract?: boolean;
    opportunityID?: number | undefined;
    overageBillingRate?: number | undefined;
    purchaseOrderNumber?: string | undefined;
    renewedContractID?: number | undefined;
    serviceLevelAgreementID?: number | undefined;
    setupFee?: number | undefined;
    setupFeeAllocationCodeID?: number | undefined;
    startDate?: Date;
    status?: number;
    timeReportingRequiresStartAndStopTimes?: number;
    deleted?: boolean;
    systemGuid?: string | undefined;
    parentSystemGuid?: string | undefined;
}

export class ContractRetainerSpend implements IContractRetainerSpend {
    id?: number;
    accountId?: number;
    contractId?: number;
    contractActive?: boolean;
    hasAnyRetainerActive?: boolean;
    totalActiveRetainerAmount?: number;
    billedSpend?: number;
    pendingSpend?: number;
    billedOverage?: number;
    pendingOverage?: number;
    dataLoadedDateTime?: Date;

    constructor(data?: IContractRetainerSpend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.contractId = _data["contractId"];
            this.contractActive = _data["contractActive"];
            this.hasAnyRetainerActive = _data["hasAnyRetainerActive"];
            this.totalActiveRetainerAmount = _data["totalActiveRetainerAmount"];
            this.billedSpend = _data["billedSpend"];
            this.pendingSpend = _data["pendingSpend"];
            this.billedOverage = _data["billedOverage"];
            this.pendingOverage = _data["pendingOverage"];
            this.dataLoadedDateTime = _data["dataLoadedDateTime"] ? new Date(_data["dataLoadedDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContractRetainerSpend {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRetainerSpend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["contractId"] = this.contractId;
        data["contractActive"] = this.contractActive;
        data["hasAnyRetainerActive"] = this.hasAnyRetainerActive;
        data["totalActiveRetainerAmount"] = this.totalActiveRetainerAmount;
        data["billedSpend"] = this.billedSpend;
        data["pendingSpend"] = this.pendingSpend;
        data["billedOverage"] = this.billedOverage;
        data["pendingOverage"] = this.pendingOverage;
        data["dataLoadedDateTime"] = this.dataLoadedDateTime ? this.dataLoadedDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IContractRetainerSpend {
    id?: number;
    accountId?: number;
    contractId?: number;
    contractActive?: boolean;
    hasAnyRetainerActive?: boolean;
    totalActiveRetainerAmount?: number;
    billedSpend?: number;
    pendingSpend?: number;
    billedOverage?: number;
    pendingOverage?: number;
    dataLoadedDateTime?: Date;
}

export class DetailedContractRetainerExpenseDto implements IDetailedContractRetainerExpenseDto {
    retainerContractSpendResults?: RetainerMonthlyExpenseDto[] | undefined;
    retainerMonthlyBreakdown?: RetainerMonthlyBreakdownDto[] | undefined;

    constructor(data?: IDetailedContractRetainerExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["retainerContractSpendResults"])) {
                this.retainerContractSpendResults = [] as any;
                for (let item of _data["retainerContractSpendResults"])
                    this.retainerContractSpendResults!.push(RetainerMonthlyExpenseDto.fromJS(item));
            }
            if (Array.isArray(_data["retainerMonthlyBreakdown"])) {
                this.retainerMonthlyBreakdown = [] as any;
                for (let item of _data["retainerMonthlyBreakdown"])
                    this.retainerMonthlyBreakdown!.push(RetainerMonthlyBreakdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetailedContractRetainerExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedContractRetainerExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.retainerContractSpendResults)) {
            data["retainerContractSpendResults"] = [];
            for (let item of this.retainerContractSpendResults)
                data["retainerContractSpendResults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.retainerMonthlyBreakdown)) {
            data["retainerMonthlyBreakdown"] = [];
            for (let item of this.retainerMonthlyBreakdown)
                data["retainerMonthlyBreakdown"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDetailedContractRetainerExpenseDto {
    retainerContractSpendResults?: RetainerMonthlyExpenseDto[] | undefined;
    retainerMonthlyBreakdown?: RetainerMonthlyBreakdownDto[] | undefined;
}

export enum RetainerBreakdownStatus {
    Consumed = "Consumed",
    Pending = "Pending",
    Invoiced = "Invoiced",
    Other = "Other",
}

export class RetainerExpenseAmountDto implements IRetainerExpenseAmountDto {
    expenseType?: RetainerExpenseType;
    amount?: number;

    constructor(data?: IRetainerExpenseAmountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseType = _data["expenseType"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): RetainerExpenseAmountDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetainerExpenseAmountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseType"] = this.expenseType;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IRetainerExpenseAmountDto {
    expenseType?: RetainerExpenseType;
    amount?: number;
}

export enum RetainerExpenseType {
    RetainerSigning = "RetainerSigning",
    TicketExpense = "TicketExpense",
    ProjectTaskExpense = "ProjectTaskExpense",
    ContractExpense = "ContractExpense",
    Other = "Other",
}

export class RetainerMonthlyBreakdownDto implements IRetainerMonthlyBreakdownDto {
    year?: number;
    month?: number;
    classification?: RetainerExpenseType;
    deposits?: number;
    usage?: number;
    status?: RetainerBreakdownStatus;
    accountId?: number;
    contractId?: number;
    invoiceIds?: number[] | undefined;
    ticketNumbers?: string[] | undefined;
    projectIds?: number[] | undefined;

    constructor(data?: IRetainerMonthlyBreakdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.classification = _data["classification"];
            this.deposits = _data["deposits"];
            this.usage = _data["usage"];
            this.status = _data["status"];
            this.accountId = _data["accountId"];
            this.contractId = _data["contractId"];
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
            if (Array.isArray(_data["ticketNumbers"])) {
                this.ticketNumbers = [] as any;
                for (let item of _data["ticketNumbers"])
                    this.ticketNumbers!.push(item);
            }
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RetainerMonthlyBreakdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetainerMonthlyBreakdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["classification"] = this.classification;
        data["deposits"] = this.deposits;
        data["usage"] = this.usage;
        data["status"] = this.status;
        data["accountId"] = this.accountId;
        data["contractId"] = this.contractId;
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        if (Array.isArray(this.ticketNumbers)) {
            data["ticketNumbers"] = [];
            for (let item of this.ticketNumbers)
                data["ticketNumbers"].push(item);
        }
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IRetainerMonthlyBreakdownDto {
    year?: number;
    month?: number;
    classification?: RetainerExpenseType;
    deposits?: number;
    usage?: number;
    status?: RetainerBreakdownStatus;
    accountId?: number;
    contractId?: number;
    invoiceIds?: number[] | undefined;
    ticketNumbers?: string[] | undefined;
    projectIds?: number[] | undefined;
}

export class RetainerMonthlyExpenseDto implements IRetainerMonthlyExpenseDto {
    label?: string | undefined;
    amounts?: RetainerExpenseAmountDto[] | undefined;

    constructor(data?: IRetainerMonthlyExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            if (Array.isArray(_data["amounts"])) {
                this.amounts = [] as any;
                for (let item of _data["amounts"])
                    this.amounts!.push(RetainerExpenseAmountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetainerMonthlyExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetainerMonthlyExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        if (Array.isArray(this.amounts)) {
            data["amounts"] = [];
            for (let item of this.amounts)
                data["amounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRetainerMonthlyExpenseDto {
    label?: string | undefined;
    amounts?: RetainerExpenseAmountDto[] | undefined;
}

export class Resource implements IResource {
    id?: number;
    accountingReferenceID?: string | undefined;
    active?: boolean;
    dateFormat?: string | undefined;
    defaultServiceDeskRoleID?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    initials?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    email3?: string | undefined;
    emailTypeCode?: string | undefined;
    emailTypeCode2?: string | undefined;
    emailTypeCode3?: string | undefined;
    gender?: string | undefined;
    greeting?: number;
    hiredate?: Date;
    homePhone?: string | undefined;
    internalCost?: number;
    locationID?: number;
    mobilePhone?: string | undefined;
    numberFormat?: string | undefined;
    officeExtension?: string | undefined;
    officePhone?: string | undefined;
    payrollType?: number;
    resourceType?: string | undefined;
    timeFormat?: string | undefined;
    travelAvailabilityPct?: string | undefined;
    userName?: string | undefined;
    userType?: number;
    userDefinedFieldsJson?: string | undefined;
    manualResource?: boolean;

    constructor(data?: IResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountingReferenceID = _data["accountingReferenceID"];
            this.active = _data["active"];
            this.dateFormat = _data["dateFormat"];
            this.defaultServiceDeskRoleID = _data["defaultServiceDeskRoleID"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.initials = _data["initials"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.email2 = _data["email2"];
            this.email3 = _data["email3"];
            this.emailTypeCode = _data["emailTypeCode"];
            this.emailTypeCode2 = _data["emailTypeCode2"];
            this.emailTypeCode3 = _data["emailTypeCode3"];
            this.gender = _data["gender"];
            this.greeting = _data["greeting"];
            this.hiredate = _data["hiredate"] ? new Date(_data["hiredate"].toString()) : undefined as any;
            this.homePhone = _data["homePhone"];
            this.internalCost = _data["internalCost"];
            this.locationID = _data["locationID"];
            this.mobilePhone = _data["mobilePhone"];
            this.numberFormat = _data["numberFormat"];
            this.officeExtension = _data["officeExtension"];
            this.officePhone = _data["officePhone"];
            this.payrollType = _data["payrollType"];
            this.resourceType = _data["resourceType"];
            this.timeFormat = _data["timeFormat"];
            this.travelAvailabilityPct = _data["travelAvailabilityPct"];
            this.userName = _data["userName"];
            this.userType = _data["userType"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.manualResource = _data["manualResource"];
        }
    }

    static fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        let result = new Resource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountingReferenceID"] = this.accountingReferenceID;
        data["active"] = this.active;
        data["dateFormat"] = this.dateFormat;
        data["defaultServiceDeskRoleID"] = this.defaultServiceDeskRoleID;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["initials"] = this.initials;
        data["title"] = this.title;
        data["email"] = this.email;
        data["email2"] = this.email2;
        data["email3"] = this.email3;
        data["emailTypeCode"] = this.emailTypeCode;
        data["emailTypeCode2"] = this.emailTypeCode2;
        data["emailTypeCode3"] = this.emailTypeCode3;
        data["gender"] = this.gender;
        data["greeting"] = this.greeting;
        data["hiredate"] = this.hiredate ? this.hiredate.toISOString() : undefined as any;
        data["homePhone"] = this.homePhone;
        data["internalCost"] = this.internalCost;
        data["locationID"] = this.locationID;
        data["mobilePhone"] = this.mobilePhone;
        data["numberFormat"] = this.numberFormat;
        data["officeExtension"] = this.officeExtension;
        data["officePhone"] = this.officePhone;
        data["payrollType"] = this.payrollType;
        data["resourceType"] = this.resourceType;
        data["timeFormat"] = this.timeFormat;
        data["travelAvailabilityPct"] = this.travelAvailabilityPct;
        data["userName"] = this.userName;
        data["userType"] = this.userType;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["manualResource"] = this.manualResource;
        return data;
    }
}

export interface IResource {
    id?: number;
    accountingReferenceID?: string | undefined;
    active?: boolean;
    dateFormat?: string | undefined;
    defaultServiceDeskRoleID?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    initials?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    email2?: string | undefined;
    email3?: string | undefined;
    emailTypeCode?: string | undefined;
    emailTypeCode2?: string | undefined;
    emailTypeCode3?: string | undefined;
    gender?: string | undefined;
    greeting?: number;
    hiredate?: Date;
    homePhone?: string | undefined;
    internalCost?: number;
    locationID?: number;
    mobilePhone?: string | undefined;
    numberFormat?: string | undefined;
    officeExtension?: string | undefined;
    officePhone?: string | undefined;
    payrollType?: number;
    resourceType?: string | undefined;
    timeFormat?: string | undefined;
    travelAvailabilityPct?: string | undefined;
    userName?: string | undefined;
    userType?: number;
    userDefinedFieldsJson?: string | undefined;
    manualResource?: boolean;
}

export class TicketAdditionalContact implements ITicketAdditionalContact {
    id?: number;
    contactId?: number;
    ticketId?: number;

    constructor(data?: ITicketAdditionalContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.ticketId = _data["ticketId"];
        }
    }

    static fromJS(data: any): TicketAdditionalContact {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAdditionalContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["ticketId"] = this.ticketId;
        return data;
    }
}

export interface ITicketAdditionalContact {
    id?: number;
    contactId?: number;
    ticketId?: number;
}

export enum CostAnalyticProviders {
    Aws = "Aws",
    Azure = "Azure",
    Gcp = "Gcp",
    AzureDirect = "AzureDirect",
}

export class CostCenter implements ICostCenter {
    id?: number;
    costCenterId?: string | undefined;
    accountId?: number;
    account?: Account;
    name?: string | undefined;
    description?: string | undefined;
    costCenterPurchaseOrders?: CostCenterPurchaseOrders[] | undefined;
    createTime?: Date;
    modifyTime?: Date;
    isUnallocated?: boolean;
    configItems?: CostCenterConfigItem[] | undefined;

    constructor(data?: ICostCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.isUnallocated = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.costCenterId = _data["costCenterId"];
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["costCenterPurchaseOrders"])) {
                this.costCenterPurchaseOrders = [] as any;
                for (let item of _data["costCenterPurchaseOrders"])
                    this.costCenterPurchaseOrders!.push(CostCenterPurchaseOrders.fromJS(item));
            }
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined as any;
            this.modifyTime = _data["modifyTime"] ? new Date(_data["modifyTime"].toString()) : undefined as any;
            this.isUnallocated = _data["isUnallocated"] !== undefined ? _data["isUnallocated"] : false;
            if (Array.isArray(_data["configItems"])) {
                this.configItems = [] as any;
                for (let item of _data["configItems"])
                    this.configItems!.push(CostCenterConfigItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostCenter {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["costCenterId"] = this.costCenterId;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.costCenterPurchaseOrders)) {
            data["costCenterPurchaseOrders"] = [];
            for (let item of this.costCenterPurchaseOrders)
                data["costCenterPurchaseOrders"].push(item ? item.toJSON() : undefined as any);
        }
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined as any;
        data["modifyTime"] = this.modifyTime ? this.modifyTime.toISOString() : undefined as any;
        data["isUnallocated"] = this.isUnallocated;
        if (Array.isArray(this.configItems)) {
            data["configItems"] = [];
            for (let item of this.configItems)
                data["configItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICostCenter {
    id?: number;
    costCenterId?: string | undefined;
    accountId?: number;
    account?: Account;
    name?: string | undefined;
    description?: string | undefined;
    costCenterPurchaseOrders?: CostCenterPurchaseOrders[] | undefined;
    createTime?: Date;
    modifyTime?: Date;
    isUnallocated?: boolean;
    configItems?: CostCenterConfigItem[] | undefined;
}

export class CostCenterConfigItem implements ICostCenterConfigItem {
    configurationItemId?: number;
    costCenterId?: number;
    createTime?: Date;
    modifyTime?: Date;
    licenseCount?: number | undefined;
    configurationItem?: ConfigurationItem;
    costCenter?: CostCenter;

    constructor(data?: ICostCenterConfigItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            this.costCenterId = _data["costCenterId"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined as any;
            this.modifyTime = _data["modifyTime"] ? new Date(_data["modifyTime"].toString()) : undefined as any;
            this.licenseCount = _data["licenseCount"];
            this.configurationItem = _data["configurationItem"] ? ConfigurationItem.fromJS(_data["configurationItem"]) : undefined as any;
            this.costCenter = _data["costCenter"] ? CostCenter.fromJS(_data["costCenter"]) : undefined as any;
        }
    }

    static fromJS(data: any): CostCenterConfigItem {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterConfigItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        data["costCenterId"] = this.costCenterId;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined as any;
        data["modifyTime"] = this.modifyTime ? this.modifyTime.toISOString() : undefined as any;
        data["licenseCount"] = this.licenseCount;
        data["configurationItem"] = this.configurationItem ? this.configurationItem.toJSON() : undefined as any;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : undefined as any;
        return data;
    }
}

export interface ICostCenterConfigItem {
    configurationItemId?: number;
    costCenterId?: number;
    createTime?: Date;
    modifyTime?: Date;
    licenseCount?: number | undefined;
    configurationItem?: ConfigurationItem;
    costCenter?: CostCenter;
}

export class CostCenterPurchaseOrders implements ICostCenterPurchaseOrders {
    id?: number;
    costCenterId?: number;
    purchaseOrderId?: number | undefined;
    cloudType?: string | undefined;
    costCenter!: CostCenter;
    purchaseOrder!: PurchaseOrder;

    constructor(data?: ICostCenterPurchaseOrders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.costCenter = new CostCenter();
            this.purchaseOrder = new PurchaseOrder();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.costCenterId = _data["costCenterId"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.cloudType = _data["cloudType"];
            this.costCenter = _data["costCenter"] ? CostCenter.fromJS(_data["costCenter"]) : new CostCenter();
            this.purchaseOrder = _data["purchaseOrder"] ? PurchaseOrder.fromJS(_data["purchaseOrder"]) : new PurchaseOrder();
        }
    }

    static fromJS(data: any): CostCenterPurchaseOrders {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterPurchaseOrders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["costCenterId"] = this.costCenterId;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["cloudType"] = this.cloudType;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : undefined as any;
        data["purchaseOrder"] = this.purchaseOrder ? this.purchaseOrder.toJSON() : undefined as any;
        return data;
    }
}

export interface ICostCenterPurchaseOrders {
    id?: number;
    costCenterId?: number;
    purchaseOrderId?: number | undefined;
    cloudType?: string | undefined;
    costCenter: CostCenter;
    purchaseOrder: PurchaseOrder;
}

export class DynamicTag implements IDynamicTag {
    id?: number;
    accountId?: number;
    userId?: string | undefined;
    sourceIdentifier?: string | undefined;
    tagKey?: string | undefined;
    tagValue?: string | undefined;
    tagType?: string | undefined;

    constructor(data?: IDynamicTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.userId = _data["userId"];
            this.sourceIdentifier = _data["sourceIdentifier"];
            this.tagKey = _data["tagKey"];
            this.tagValue = _data["tagValue"];
            this.tagType = _data["tagType"];
        }
    }

    static fromJS(data: any): DynamicTag {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["userId"] = this.userId;
        data["sourceIdentifier"] = this.sourceIdentifier;
        data["tagKey"] = this.tagKey;
        data["tagValue"] = this.tagValue;
        data["tagType"] = this.tagType;
        return data;
    }
}

export interface IDynamicTag {
    id?: number;
    accountId?: number;
    userId?: string | undefined;
    sourceIdentifier?: string | undefined;
    tagKey?: string | undefined;
    tagValue?: string | undefined;
    tagType?: string | undefined;
}

export class ServiceRequestMappingSubmissionTypes implements IServiceRequestMappingSubmissionTypes {
    id?: number;
    name?: string | undefined;

    constructor(data?: IServiceRequestMappingSubmissionTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceRequestMappingSubmissionTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestMappingSubmissionTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceRequestMappingSubmissionTypes {
    id?: number;
    name?: string | undefined;
}

export class ServiceRequestSubmissionTypes implements IServiceRequestSubmissionTypes {
    id?: number;
    name?: string | undefined;

    constructor(data?: IServiceRequestSubmissionTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceRequestSubmissionTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestSubmissionTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceRequestSubmissionTypes {
    id?: number;
    name?: string | undefined;
}

export class ServiceRequestTypes implements IServiceRequestTypes {
    id?: number;
    name?: string | undefined;

    constructor(data?: IServiceRequestTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceRequestTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceRequestTypes {
    id?: number;
    name?: string | undefined;
}

export class PurchaseOrder implements IPurchaseOrder {
    id?: number;
    poNumber?: string | undefined;
    costCenterPurchaseOrders?: CostCenterPurchaseOrders[] | undefined;

    constructor(data?: IPurchaseOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.poNumber = _data["poNumber"];
            if (Array.isArray(_data["costCenterPurchaseOrders"])) {
                this.costCenterPurchaseOrders = [] as any;
                for (let item of _data["costCenterPurchaseOrders"])
                    this.costCenterPurchaseOrders!.push(CostCenterPurchaseOrders.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseOrder {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["poNumber"] = this.poNumber;
        if (Array.isArray(this.costCenterPurchaseOrders)) {
            data["costCenterPurchaseOrders"] = [];
            for (let item of this.costCenterPurchaseOrders)
                data["costCenterPurchaseOrders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPurchaseOrder {
    id?: number;
    poNumber?: string | undefined;
    costCenterPurchaseOrders?: CostCenterPurchaseOrders[] | undefined;
}

export class ServiceRequestMapping implements IServiceRequestMapping {
    id?: number;
    submissionTypeId?: number;
    submissionType?: ServiceRequestMappingSubmissionTypes;
    supportOptionName?: string | undefined;
    accountId?: number;
    ticketCategory?: number | undefined;
    ticketTypeId?: number | undefined;
    issue?: number;
    enabledSubIssues?: string | undefined;
    userInputFieldsJson?: string | undefined;
    serviceRequestTypeId?: number;
    serviceRequestType?: ServiceRequestTypes;
    formSchema!: string;
    formUiSchema!: string;
    rules!: string;
    submitterEntraId?: string;
    approverEntraId?: string | undefined;
    mappingIdentifier?: string | undefined;
    revision?: number;
    approved?: boolean;
    serviceRequestSubmissionTypeId?: number;
    serviceRequestSubmissionType?: ServiceRequestSubmissionTypes;
    displayAsTile?: boolean;
    tileIcon?: string | undefined;
    tileTitle?: string | undefined;
    tileDescription?: string | undefined;
    tileRoute?: string | undefined;
    canBeIncident?: boolean;
    canBeServiceRequest?: boolean;
    canBeChangeRequest?: boolean;
    displayOrder?: number;

    constructor(data?: IServiceRequestMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionTypeId = _data["submissionTypeId"];
            this.submissionType = _data["submissionType"] ? ServiceRequestMappingSubmissionTypes.fromJS(_data["submissionType"]) : undefined as any;
            this.supportOptionName = _data["supportOptionName"];
            this.accountId = _data["accountId"];
            this.ticketCategory = _data["ticketCategory"];
            this.ticketTypeId = _data["ticketTypeId"];
            this.issue = _data["issue"];
            this.enabledSubIssues = _data["enabledSubIssues"];
            this.userInputFieldsJson = _data["userInputFieldsJson"];
            this.serviceRequestTypeId = _data["serviceRequestTypeId"];
            this.serviceRequestType = _data["serviceRequestType"] ? ServiceRequestTypes.fromJS(_data["serviceRequestType"]) : undefined as any;
            this.formSchema = _data["formSchema"];
            this.formUiSchema = _data["formUiSchema"];
            this.rules = _data["rules"];
            this.submitterEntraId = _data["submitterEntraId"];
            this.approverEntraId = _data["approverEntraId"];
            this.mappingIdentifier = _data["mappingIdentifier"];
            this.revision = _data["revision"];
            this.approved = _data["approved"];
            this.serviceRequestSubmissionTypeId = _data["serviceRequestSubmissionTypeId"];
            this.serviceRequestSubmissionType = _data["serviceRequestSubmissionType"] ? ServiceRequestSubmissionTypes.fromJS(_data["serviceRequestSubmissionType"]) : undefined as any;
            this.displayAsTile = _data["displayAsTile"];
            this.tileIcon = _data["tileIcon"];
            this.tileTitle = _data["tileTitle"];
            this.tileDescription = _data["tileDescription"];
            this.tileRoute = _data["tileRoute"];
            this.canBeIncident = _data["canBeIncident"];
            this.canBeServiceRequest = _data["canBeServiceRequest"];
            this.canBeChangeRequest = _data["canBeChangeRequest"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ServiceRequestMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionTypeId"] = this.submissionTypeId;
        data["submissionType"] = this.submissionType ? this.submissionType.toJSON() : undefined as any;
        data["supportOptionName"] = this.supportOptionName;
        data["accountId"] = this.accountId;
        data["ticketCategory"] = this.ticketCategory;
        data["ticketTypeId"] = this.ticketTypeId;
        data["issue"] = this.issue;
        data["enabledSubIssues"] = this.enabledSubIssues;
        data["userInputFieldsJson"] = this.userInputFieldsJson;
        data["serviceRequestTypeId"] = this.serviceRequestTypeId;
        data["serviceRequestType"] = this.serviceRequestType ? this.serviceRequestType.toJSON() : undefined as any;
        data["formSchema"] = this.formSchema;
        data["formUiSchema"] = this.formUiSchema;
        data["rules"] = this.rules;
        data["submitterEntraId"] = this.submitterEntraId;
        data["approverEntraId"] = this.approverEntraId;
        data["mappingIdentifier"] = this.mappingIdentifier;
        data["revision"] = this.revision;
        data["approved"] = this.approved;
        data["serviceRequestSubmissionTypeId"] = this.serviceRequestSubmissionTypeId;
        data["serviceRequestSubmissionType"] = this.serviceRequestSubmissionType ? this.serviceRequestSubmissionType.toJSON() : undefined as any;
        data["displayAsTile"] = this.displayAsTile;
        data["tileIcon"] = this.tileIcon;
        data["tileTitle"] = this.tileTitle;
        data["tileDescription"] = this.tileDescription;
        data["tileRoute"] = this.tileRoute;
        data["canBeIncident"] = this.canBeIncident;
        data["canBeServiceRequest"] = this.canBeServiceRequest;
        data["canBeChangeRequest"] = this.canBeChangeRequest;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IServiceRequestMapping {
    id?: number;
    submissionTypeId?: number;
    submissionType?: ServiceRequestMappingSubmissionTypes;
    supportOptionName?: string | undefined;
    accountId?: number;
    ticketCategory?: number | undefined;
    ticketTypeId?: number | undefined;
    issue?: number;
    enabledSubIssues?: string | undefined;
    userInputFieldsJson?: string | undefined;
    serviceRequestTypeId?: number;
    serviceRequestType?: ServiceRequestTypes;
    formSchema: string;
    formUiSchema: string;
    rules: string;
    submitterEntraId?: string;
    approverEntraId?: string | undefined;
    mappingIdentifier?: string | undefined;
    revision?: number;
    approved?: boolean;
    serviceRequestSubmissionTypeId?: number;
    serviceRequestSubmissionType?: ServiceRequestSubmissionTypes;
    displayAsTile?: boolean;
    tileIcon?: string | undefined;
    tileTitle?: string | undefined;
    tileDescription?: string | undefined;
    tileRoute?: string | undefined;
    canBeIncident?: boolean;
    canBeServiceRequest?: boolean;
    canBeChangeRequest?: boolean;
    displayOrder?: number;
}

export enum BusinessUnitPathType {
    CompanyId = "CompanyId",
    BusinessUnitId = "BusinessUnitId",
    SegmentId = "SegmentId",
    DivisionId = "DivisionId",
    RegionId = "RegionId",
    DistrictId = "DistrictId",
}

export enum ResponseStatusValues {
    Success = "Success",
    InvalidLogin = "InvalidLogin",
    Error = "Error",
    ProfileNotConfigured = "ProfileNotConfigured",
    AccountPendingApproval = "AccountPendingApproval",
    AccessRequested = "AccessRequested",
    UserNotAssignedToAccount = "UserNotAssignedToAccount",
    ExternalProcessingError = "ExternalProcessingError",
    InternalProcessingError = "InternalProcessingError",
    Unauthorized = "Unauthorized",
    AuthenticationError = "AuthenticationError",
    Failed = "Failed",
}

export enum ServiceRequestCloudTypes {
    AWS = "AWS",
    GCP = "GCP",
}

export class BaseAwsResponse implements IBaseAwsResponse {
    operationId?: string | undefined;
    exceptionOccurred?: boolean;
    exceptionMessage?: string | undefined;
    message?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IBaseAwsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "BaseAwsResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.operationId = _data["operationId"];
            this.exceptionOccurred = _data["exceptionOccurred"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BaseAwsResponse {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "CreateAccountResponse") {
            let result = new CreateAccountResponse();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "InviteAccountResponse") {
            let result = new InviteAccountResponse();
            result.init(data);
            return result;
        }
        let result = new BaseAwsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["operationId"] = this.operationId;
        data["exceptionOccurred"] = this.exceptionOccurred;
        data["exceptionMessage"] = this.exceptionMessage;
        data["message"] = this.message;
        return data;
    }
}

export interface IBaseAwsResponse {
    operationId?: string | undefined;
    exceptionOccurred?: boolean;
    exceptionMessage?: string | undefined;
    message?: string | undefined;
}

export class CreateAccountRequest implements ICreateAccountRequest {
    autotaskAccountId!: number;
    autotaskContractId!: number;
    requesterEmail!: string;
    payerAccountId!: string;
    newAccountName!: string;
    newAccountEmail!: string;

    constructor(data?: ICreateAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.autotaskContractId = _data["autotaskContractId"];
            this.requesterEmail = _data["requesterEmail"];
            this.payerAccountId = _data["payerAccountId"];
            this.newAccountName = _data["newAccountName"];
            this.newAccountEmail = _data["newAccountEmail"];
        }
    }

    static fromJS(data: any): CreateAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["autotaskContractId"] = this.autotaskContractId;
        data["requesterEmail"] = this.requesterEmail;
        data["payerAccountId"] = this.payerAccountId;
        data["newAccountName"] = this.newAccountName;
        data["newAccountEmail"] = this.newAccountEmail;
        return data;
    }
}

export interface ICreateAccountRequest {
    autotaskAccountId: number;
    autotaskContractId: number;
    requesterEmail: string;
    payerAccountId: string;
    newAccountName: string;
    newAccountEmail: string;
}

export class CreateAccountResponse extends BaseAwsResponse implements ICreateAccountResponse {
    newAccountId?: string | undefined;
    accountName?: string | undefined;
    requestFailed?: boolean;
    failureReason?: string | undefined;
    state?: string | undefined;

    constructor(data?: ICreateAccountResponse) {
        super(data);
        this._discriminator = "CreateAccountResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.newAccountId = _data["newAccountId"];
            this.accountName = _data["accountName"];
            this.requestFailed = _data["requestFailed"];
            this.failureReason = _data["failureReason"];
            this.state = _data["state"];
        }
    }

    static override fromJS(data: any): CreateAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newAccountId"] = this.newAccountId;
        data["accountName"] = this.accountName;
        data["requestFailed"] = this.requestFailed;
        data["failureReason"] = this.failureReason;
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateAccountResponse extends IBaseAwsResponse {
    newAccountId?: string | undefined;
    accountName?: string | undefined;
    requestFailed?: boolean;
    failureReason?: string | undefined;
    state?: string | undefined;
}

export class InviteAccountRequest implements IInviteAccountRequest {
    autotaskAccountId!: number;
    autotaskContractId!: number;
    requesterEmail!: string;
    payerAccountId!: string;
    invitationNotes?: string | undefined;
    inviteAccountId?: string | undefined;
    inviteAccountEmail?: string | undefined;

    constructor(data?: IInviteAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.autotaskContractId = _data["autotaskContractId"];
            this.requesterEmail = _data["requesterEmail"];
            this.payerAccountId = _data["payerAccountId"];
            this.invitationNotes = _data["invitationNotes"];
            this.inviteAccountId = _data["inviteAccountId"];
            this.inviteAccountEmail = _data["inviteAccountEmail"];
        }
    }

    static fromJS(data: any): InviteAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["autotaskContractId"] = this.autotaskContractId;
        data["requesterEmail"] = this.requesterEmail;
        data["payerAccountId"] = this.payerAccountId;
        data["invitationNotes"] = this.invitationNotes;
        data["inviteAccountId"] = this.inviteAccountId;
        data["inviteAccountEmail"] = this.inviteAccountEmail;
        return data;
    }
}

export interface IInviteAccountRequest {
    autotaskAccountId: number;
    autotaskContractId: number;
    requesterEmail: string;
    payerAccountId: string;
    invitationNotes?: string | undefined;
    inviteAccountId?: string | undefined;
    inviteAccountEmail?: string | undefined;
}

export class InviteAccountResponse extends BaseAwsResponse implements IInviteAccountResponse {
    readonly actionType?: string | undefined;
    expirationTimestamp?: Date;
    parties?: Party[] | undefined;
    state?: string | undefined;

    constructor(data?: IInviteAccountResponse) {
        super(data);
        this._discriminator = "InviteAccountResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            (this as any).actionType = _data["actionType"];
            this.expirationTimestamp = _data["expirationTimestamp"] ? new Date(_data["expirationTimestamp"].toString()) : undefined as any;
            if (Array.isArray(_data["parties"])) {
                this.parties = [] as any;
                for (let item of _data["parties"])
                    this.parties!.push(Party.fromJS(item));
            }
            this.state = _data["state"];
        }
    }

    static override fromJS(data: any): InviteAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InviteAccountResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["expirationTimestamp"] = this.expirationTimestamp ? this.expirationTimestamp.toISOString() : undefined as any;
        if (Array.isArray(this.parties)) {
            data["parties"] = [];
            for (let item of this.parties)
                data["parties"].push(item ? item.toJSON() : undefined as any);
        }
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface IInviteAccountResponse extends IBaseAwsResponse {
    actionType?: string | undefined;
    expirationTimestamp?: Date;
    parties?: Party[] | undefined;
    state?: string | undefined;
}

export class Party implements IParty {
    id?: string | undefined;
    type?: string | undefined;
    isOrganization?: boolean;

    constructor(data?: IParty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.isOrganization = _data["isOrganization"];
        }
    }

    static fromJS(data: any): Party {
        data = typeof data === 'object' ? data : {};
        let result = new Party();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["isOrganization"] = this.isOrganization;
        return data;
    }
}

export interface IParty {
    id?: string | undefined;
    type?: string | undefined;
    isOrganization?: boolean;
}

export class AccountContractResponse implements IAccountContractResponse {
    contractSummary?: ContractReport;
    resultInfo?: PagedResultData;
    resultContracts?: ContractDto[] | undefined;
    resultContacts?: Contact[] | undefined;

    constructor(data?: IAccountContractResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractSummary = _data["contractSummary"] ? ContractReport.fromJS(_data["contractSummary"]) : undefined as any;
            this.resultInfo = _data["resultInfo"] ? PagedResultData.fromJS(_data["resultInfo"]) : undefined as any;
            if (Array.isArray(_data["resultContracts"])) {
                this.resultContracts = [] as any;
                for (let item of _data["resultContracts"])
                    this.resultContracts!.push(ContractDto.fromJS(item));
            }
            if (Array.isArray(_data["resultContacts"])) {
                this.resultContacts = [] as any;
                for (let item of _data["resultContacts"])
                    this.resultContacts!.push(Contact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountContractResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountContractResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractSummary"] = this.contractSummary ? this.contractSummary.toJSON() : undefined as any;
        data["resultInfo"] = this.resultInfo ? this.resultInfo.toJSON() : undefined as any;
        if (Array.isArray(this.resultContracts)) {
            data["resultContracts"] = [];
            for (let item of this.resultContracts)
                data["resultContracts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultContacts)) {
            data["resultContacts"] = [];
            for (let item of this.resultContacts)
                data["resultContacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccountContractResponse {
    contractSummary?: ContractReport;
    resultInfo?: PagedResultData;
    resultContracts?: ContractDto[] | undefined;
    resultContacts?: Contact[] | undefined;
}

export class AccountNameWithAxNumber implements IAccountNameWithAxNumber {
    accountName?: string | undefined;
    axNumber?: string | undefined;

    constructor(data?: IAccountNameWithAxNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.axNumber = _data["axNumber"];
        }
    }

    static fromJS(data: any): AccountNameWithAxNumber {
        data = typeof data === 'object' ? data : {};
        let result = new AccountNameWithAxNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["axNumber"] = this.axNumber;
        return data;
    }
}

export interface IAccountNameWithAxNumber {
    accountName?: string | undefined;
    axNumber?: string | undefined;
}

export class AccountTeamLastSyncDateTime implements IAccountTeamLastSyncDateTime {
    id?: number;
    accountId?: number;
    lastSyncDateTime?: Date;

    constructor(data?: IAccountTeamLastSyncDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.lastSyncDateTime = _data["lastSyncDateTime"] ? new Date(_data["lastSyncDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AccountTeamLastSyncDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamLastSyncDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["lastSyncDateTime"] = this.lastSyncDateTime ? this.lastSyncDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IAccountTeamLastSyncDateTime {
    id?: number;
    accountId?: number;
    lastSyncDateTime?: Date;
}

export class AccountTeamMember implements IAccountTeamMember {
    id?: number;
    contactId?: number | undefined;
    accountId?: number;
    readAccess?: boolean;
    writeAccess?: boolean;
    manageAccess?: boolean;
    note?: string | undefined;
    source?: string | undefined;
    jobTitle?: string | undefined;
    accountTeamMemberRoleId?: number;
    accountTeamMemberRole?: AccountTeamMemberRole;
    systemUserId?: string | undefined;
    crmUserDetails?: CrmUserDetails;
    createdUtc?: Date;
    createdBy?: number | undefined;
    modifiedUtc?: Date;
    modifiedBy?: number | undefined;
    deleted?: boolean;
    deletedUtc?: Date | undefined;
    deletedBy?: number | undefined;

    constructor(data?: IAccountTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.accountId = _data["accountId"];
            this.readAccess = _data["readAccess"];
            this.writeAccess = _data["writeAccess"];
            this.manageAccess = _data["manageAccess"];
            this.note = _data["note"];
            this.source = _data["source"];
            this.jobTitle = _data["jobTitle"];
            this.accountTeamMemberRoleId = _data["accountTeamMemberRoleId"];
            this.accountTeamMemberRole = _data["accountTeamMemberRole"] ? AccountTeamMemberRole.fromJS(_data["accountTeamMemberRole"]) : undefined as any;
            this.systemUserId = _data["systemUserId"];
            this.crmUserDetails = _data["crmUserDetails"] ? CrmUserDetails.fromJS(_data["crmUserDetails"]) : undefined as any;
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedUtc = _data["modifiedUtc"] ? new Date(_data["modifiedUtc"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.deleted = _data["deleted"];
            this.deletedUtc = _data["deletedUtc"] ? new Date(_data["deletedUtc"].toString()) : undefined as any;
            this.deletedBy = _data["deletedBy"];
        }
    }

    static fromJS(data: any): AccountTeamMember {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["accountId"] = this.accountId;
        data["readAccess"] = this.readAccess;
        data["writeAccess"] = this.writeAccess;
        data["manageAccess"] = this.manageAccess;
        data["note"] = this.note;
        data["source"] = this.source;
        data["jobTitle"] = this.jobTitle;
        data["accountTeamMemberRoleId"] = this.accountTeamMemberRoleId;
        data["accountTeamMemberRole"] = this.accountTeamMemberRole ? this.accountTeamMemberRole.toJSON() : undefined as any;
        data["systemUserId"] = this.systemUserId;
        data["crmUserDetails"] = this.crmUserDetails ? this.crmUserDetails.toJSON() : undefined as any;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedUtc"] = this.modifiedUtc ? this.modifiedUtc.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["deleted"] = this.deleted;
        data["deletedUtc"] = this.deletedUtc ? this.deletedUtc.toISOString() : undefined as any;
        data["deletedBy"] = this.deletedBy;
        return data;
    }
}

export interface IAccountTeamMember {
    id?: number;
    contactId?: number | undefined;
    accountId?: number;
    readAccess?: boolean;
    writeAccess?: boolean;
    manageAccess?: boolean;
    note?: string | undefined;
    source?: string | undefined;
    jobTitle?: string | undefined;
    accountTeamMemberRoleId?: number;
    accountTeamMemberRole?: AccountTeamMemberRole;
    systemUserId?: string | undefined;
    crmUserDetails?: CrmUserDetails;
    createdUtc?: Date;
    createdBy?: number | undefined;
    modifiedUtc?: Date;
    modifiedBy?: number | undefined;
    deleted?: boolean;
    deletedUtc?: Date | undefined;
    deletedBy?: number | undefined;
}

export class AccountTeamMemberRole implements IAccountTeamMemberRole {
    id?: number;
    name?: string | undefined;
    accountTeamMembers?: AccountTeamMember[] | undefined;

    constructor(data?: IAccountTeamMemberRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["accountTeamMembers"])) {
                this.accountTeamMembers = [] as any;
                for (let item of _data["accountTeamMembers"])
                    this.accountTeamMembers!.push(AccountTeamMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountTeamMemberRole {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamMemberRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.accountTeamMembers)) {
            data["accountTeamMembers"] = [];
            for (let item of this.accountTeamMembers)
                data["accountTeamMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccountTeamMemberRole {
    id?: number;
    name?: string | undefined;
    accountTeamMembers?: AccountTeamMember[] | undefined;
}

export class AccountTeamMemberSyncDetails implements IAccountTeamMemberSyncDetails {
    teamid?: string | undefined;
    ownerid?: string | undefined;
    teammembership_association?: CrmAccountTeamMember[] | undefined;
    teammembership_associationodataNextLink?: string | undefined;

    constructor(data?: IAccountTeamMemberSyncDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamid = _data["teamid"];
            this.ownerid = _data["ownerid"];
            if (Array.isArray(_data["teammembership_association"])) {
                this.teammembership_association = [] as any;
                for (let item of _data["teammembership_association"])
                    this.teammembership_association!.push(CrmAccountTeamMember.fromJS(item));
            }
            this.teammembership_associationodataNextLink = _data["teammembership_association@odata.nextLink"];
        }
    }

    static fromJS(data: any): AccountTeamMemberSyncDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTeamMemberSyncDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamid"] = this.teamid;
        data["ownerid"] = this.ownerid;
        if (Array.isArray(this.teammembership_association)) {
            data["teammembership_association"] = [];
            for (let item of this.teammembership_association)
                data["teammembership_association"].push(item ? item.toJSON() : undefined as any);
        }
        data["teammembership_association@odata.nextLink"] = this.teammembership_associationodataNextLink;
        return data;
    }
}

export interface IAccountTeamMemberSyncDetails {
    teamid?: string | undefined;
    ownerid?: string | undefined;
    teammembership_association?: CrmAccountTeamMember[] | undefined;
    teammembership_associationodataNextLink?: string | undefined;
}

export class ActiveDirectoryAccountTeamMember implements IActiveDirectoryAccountTeamMember {
    activeDirectoryId?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IActiveDirectoryAccountTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeDirectoryId = _data["activeDirectoryId"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ActiveDirectoryAccountTeamMember {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDirectoryAccountTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeDirectoryId"] = this.activeDirectoryId;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IActiveDirectoryAccountTeamMember {
    activeDirectoryId?: string | undefined;
    emailAddress?: string | undefined;
}

export class AllServiceRequestsRequest implements IAllServiceRequestsRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    issueType?: number | undefined;
    status?: number[] | undefined;
    contractIds?: number[] | undefined;
    ticketCategoryIds?: number[] | undefined;
    issueIds?: number[] | undefined;
    priority?: number | undefined;
    ticketType?: number | undefined;
    contractId?: number | undefined;
    accountId?: number | undefined;
    createdBefore?: Date | undefined;
    createdAfter?: Date | undefined;
    completedBefore?: Date | undefined;
    completedAfter?: Date | undefined;
    lastUpdatedBefore?: Date | undefined;
    lastUpdatedAfter?: Date | undefined;
    accounts?: number[] | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;

    constructor(data?: IAllServiceRequestsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.searchString = _data["searchString"];
            this.issueType = _data["issueType"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["contractIds"])) {
                this.contractIds = [] as any;
                for (let item of _data["contractIds"])
                    this.contractIds!.push(item);
            }
            if (Array.isArray(_data["ticketCategoryIds"])) {
                this.ticketCategoryIds = [] as any;
                for (let item of _data["ticketCategoryIds"])
                    this.ticketCategoryIds!.push(item);
            }
            if (Array.isArray(_data["issueIds"])) {
                this.issueIds = [] as any;
                for (let item of _data["issueIds"])
                    this.issueIds!.push(item);
            }
            this.priority = _data["priority"];
            this.ticketType = _data["ticketType"];
            this.contractId = _data["contractId"];
            this.accountId = _data["accountId"];
            this.createdBefore = _data["createdBefore"] ? new Date(_data["createdBefore"].toString()) : undefined as any;
            this.createdAfter = _data["createdAfter"] ? new Date(_data["createdAfter"].toString()) : undefined as any;
            this.completedBefore = _data["completedBefore"] ? new Date(_data["completedBefore"].toString()) : undefined as any;
            this.completedAfter = _data["completedAfter"] ? new Date(_data["completedAfter"].toString()) : undefined as any;
            this.lastUpdatedBefore = _data["lastUpdatedBefore"] ? new Date(_data["lastUpdatedBefore"].toString()) : undefined as any;
            this.lastUpdatedAfter = _data["lastUpdatedAfter"] ? new Date(_data["lastUpdatedAfter"].toString()) : undefined as any;
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(item);
            }
            this.orderBy = _data["orderBy"];
            this.orderDirection = _data["orderDirection"];
        }
    }

    static fromJS(data: any): AllServiceRequestsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AllServiceRequestsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["searchString"] = this.searchString;
        data["issueType"] = this.issueType;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.contractIds)) {
            data["contractIds"] = [];
            for (let item of this.contractIds)
                data["contractIds"].push(item);
        }
        if (Array.isArray(this.ticketCategoryIds)) {
            data["ticketCategoryIds"] = [];
            for (let item of this.ticketCategoryIds)
                data["ticketCategoryIds"].push(item);
        }
        if (Array.isArray(this.issueIds)) {
            data["issueIds"] = [];
            for (let item of this.issueIds)
                data["issueIds"].push(item);
        }
        data["priority"] = this.priority;
        data["ticketType"] = this.ticketType;
        data["contractId"] = this.contractId;
        data["accountId"] = this.accountId;
        data["createdBefore"] = this.createdBefore ? this.createdBefore.toISOString() : undefined as any;
        data["createdAfter"] = this.createdAfter ? this.createdAfter.toISOString() : undefined as any;
        data["completedBefore"] = this.completedBefore ? this.completedBefore.toISOString() : undefined as any;
        data["completedAfter"] = this.completedAfter ? this.completedAfter.toISOString() : undefined as any;
        data["lastUpdatedBefore"] = this.lastUpdatedBefore ? this.lastUpdatedBefore.toISOString() : undefined as any;
        data["lastUpdatedAfter"] = this.lastUpdatedAfter ? this.lastUpdatedAfter.toISOString() : undefined as any;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item);
        }
        data["orderBy"] = this.orderBy;
        data["orderDirection"] = this.orderDirection;
        return data;
    }
}

export interface IAllServiceRequestsRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    issueType?: number | undefined;
    status?: number[] | undefined;
    contractIds?: number[] | undefined;
    ticketCategoryIds?: number[] | undefined;
    issueIds?: number[] | undefined;
    priority?: number | undefined;
    ticketType?: number | undefined;
    contractId?: number | undefined;
    accountId?: number | undefined;
    createdBefore?: Date | undefined;
    createdAfter?: Date | undefined;
    completedBefore?: Date | undefined;
    completedAfter?: Date | undefined;
    lastUpdatedBefore?: Date | undefined;
    lastUpdatedAfter?: Date | undefined;
    accounts?: number[] | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;
}

export class IntegrationMetadata implements IIntegrationMetadata {
    status?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IIntegrationMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "IntegrationMetadata";
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): IntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "GcpUsageReportIntegrationMetadata") {
            let result = new GcpUsageReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AssessmentIntegrationMetadata") {
            let result = new AssessmentIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsBillingReportIntegrationMetadata") {
            let result = new AwsBillingReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsComplianceIntegrationMetadata") {
            let result = new AwsComplianceIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsSimpleRecommendationsIntegrationMetadata") {
            let result = new AwsSimpleRecommendationsIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureDevOpsReportIntegrationMetadata") {
            let result = new AzureDevOpsReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureIntegrationMetadata") {
            let result = new AzureIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzurePlanReportIntegrationMetadata") {
            let result = new AzurePlanReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CatalystIntegrationMetadata") {
            let result = new CatalystIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoMerakiCustomerMetadata") {
            let result = new CiscoMerakiCustomerMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsResourceExplorerMetadata") {
            let result = new AwsResourceExplorerMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "GcpCloudAssetInventoryMetadata") {
            let result = new GcpCloudAssetInventoryMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "HardwareLifecycleIntegrationMetadata") {
            let result = new HardwareLifecycleIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "IdcsReportIntegrationMetadata") {
            let result = new IdcsReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "MicrosoftInsightsIntegrationMetadata") {
            let result = new MicrosoftInsightsIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "RackAndStackIntegrationMetadata") {
            let result = new RackAndStackIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "SelfServiceReportingIntegrationMetadata") {
            let result = new SelfServiceReportingIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "WarehousePickOrderIntegrationMetadata") {
            let result = new WarehousePickOrderIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "LiveOpticsIntegrationMetadata") {
            let result = new LiveOpticsIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureAssetIntegrationMetadata") {
            let result = new AzureAssetIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureCostAndUsageIntegrationMetadata") {
            let result = new AzureCostAndUsageIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "Microsoft365ReportsIntegrationMetadata") {
            let result = new Microsoft365ReportsIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "IbaIntegrationMetadata") {
            let result = new IbaIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DattoRMMIntegrationMetadata") {
            let result = new DattoRMMIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DatadogUsageReportIntegrationMetadata") {
            let result = new DatadogUsageReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoContractCoverageIntegrationMetadata") {
            let result = new CiscoContractCoverageIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoEnterpriseAgreementMetadata") {
            let result = new CiscoEnterpriseAgreementMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoMerakiIntegrationMetadata") {
            let result = new CiscoMerakiIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoReadyReportIntegrationMetadata") {
            let result = new CiscoReadyReportIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoSNTCIntegrationMetadata") {
            let result = new CiscoSNTCIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoSubscriptionManagementIntegrationMetadata") {
            let result = new CiscoSubscriptionManagementIntegrationMetadata();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AssetManagementIntegrationMetadata") {
            let result = new AssetManagementIntegrationMetadata();
            result.init(data);
            return result;
        }
        let result = new IntegrationMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["status"] = this.status;
        return data;
    }
}

export interface IIntegrationMetadata {
    status?: string | undefined;
}

export class AssessmentIntegrationMetadata extends IntegrationMetadata implements IAssessmentIntegrationMetadata {
    crmGuid?: string | undefined;
    airtableAssessmentLink?: string | undefined;
    airtableId?: string | undefined;
    assessmentGuid!: string | undefined;

    constructor(data?: IAssessmentIntegrationMetadata) {
        super(data);
        this._discriminator = "AssessmentIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.crmGuid = _data["crmGuid"];
            this.airtableAssessmentLink = _data["airtableAssessmentLink"];
            this.airtableId = _data["airtableId"];
            this.assessmentGuid = _data["assessmentGuid"];
        }
    }

    static override fromJS(data: any): AssessmentIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crmGuid"] = this.crmGuid;
        data["airtableAssessmentLink"] = this.airtableAssessmentLink;
        data["airtableId"] = this.airtableId;
        data["assessmentGuid"] = this.assessmentGuid;
        super.toJSON(data);
        return data;
    }
}

export interface IAssessmentIntegrationMetadata extends IIntegrationMetadata {
    crmGuid?: string | undefined;
    airtableAssessmentLink?: string | undefined;
    airtableId?: string | undefined;
    assessmentGuid: string | undefined;
}

export class AssetManagementIntegrationMetadata extends IntegrationMetadata implements IAssetManagementIntegrationMetadata {
    axAccount?: string | undefined;
    filename?: string | undefined;

    constructor(data?: IAssetManagementIntegrationMetadata) {
        super(data);
        this._discriminator = "AssetManagementIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
            this.filename = _data["filename"];
        }
    }

    static override fromJS(data: any): AssetManagementIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AssetManagementIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        data["filename"] = this.filename;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetManagementIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
    filename?: string | undefined;
}

export class AssetDownloadContractsRequest implements IAssetDownloadContractsRequest {
    query!: AssetContractSearchQueryDto;
    gridDefinitions!: ExcelDownloadDefinition[] | undefined;

    constructor(data?: IAssetDownloadContractsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.query = new AssetContractSearchQueryDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? AssetContractSearchQueryDto.fromJS(_data["query"]) : new AssetContractSearchQueryDto();
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetDownloadContractsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDownloadContractsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetDownloadContractsRequest {
    query: AssetContractSearchQueryDto;
    gridDefinitions: ExcelDownloadDefinition[] | undefined;
}

export class AssetDownloadInventoryRequest implements IAssetDownloadInventoryRequest {
    query?: AssetManagementSearchQueryDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
    queryString?: string | undefined;

    constructor(data?: IAssetDownloadInventoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? AssetManagementSearchQueryDto.fromJS(_data["query"]) : undefined as any;
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
            this.queryString = _data["queryString"];
        }
    }

    static fromJS(data: any): AssetDownloadInventoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDownloadInventoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        data["queryString"] = this.queryString;
        return data;
    }
}

export interface IAssetDownloadInventoryRequest {
    query?: AssetManagementSearchQueryDto;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
    queryString?: string | undefined;
}

export class AssetDownloadLifecycleRequest implements IAssetDownloadLifecycleRequest {
    query!: AssetLifecycleSearchRequestDto;
    gridDefinitions!: ExcelDownloadDefinition[] | undefined;

    constructor(data?: IAssetDownloadLifecycleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.query = new AssetLifecycleSearchRequestDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? AssetLifecycleSearchRequestDto.fromJS(_data["query"]) : new AssetLifecycleSearchRequestDto();
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetDownloadLifecycleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDownloadLifecycleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetDownloadLifecycleRequest {
    query: AssetLifecycleSearchRequestDto;
    gridDefinitions: ExcelDownloadDefinition[] | undefined;
}

export class AssetDownloadProductCatalogRequest implements IAssetDownloadProductCatalogRequest {
    query!: AssetProductCatalogSearchRequestDto;
    gridDefinitions!: ExcelDownloadDefinition[] | undefined;

    constructor(data?: IAssetDownloadProductCatalogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.query = new AssetProductCatalogSearchRequestDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? AssetProductCatalogSearchRequestDto.fromJS(_data["query"]) : new AssetProductCatalogSearchRequestDto();
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetDownloadProductCatalogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDownloadProductCatalogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetDownloadProductCatalogRequest {
    query: AssetProductCatalogSearchRequestDto;
    gridDefinitions: ExcelDownloadDefinition[] | undefined;
}

export class AwsBillingReportIntegrationMetadata extends IntegrationMetadata implements IAwsBillingReportIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: IAwsBillingReportIntegrationMetadata) {
        super(data);
        this._discriminator = "AwsBillingReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): AwsBillingReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AwsBillingReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsBillingReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class AwsComplianceIntegrationMetadata extends IntegrationMetadata implements IAwsComplianceIntegrationMetadata {
    accountId?: string | undefined;
    roleArn?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IAwsComplianceIntegrationMetadata) {
        super(data);
        this._discriminator = "AwsComplianceIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountId = _data["accountId"];
            this.roleArn = _data["roleArn"];
            this.externalId = _data["externalId"];
        }
    }

    static override fromJS(data: any): AwsComplianceIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AwsComplianceIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["roleArn"] = this.roleArn;
        data["externalId"] = this.externalId;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsComplianceIntegrationMetadata extends IIntegrationMetadata {
    accountId?: string | undefined;
    roleArn?: string | undefined;
    externalId?: string | undefined;
}

export class AwsResourceExplorerMetadata extends IntegrationMetadata implements IAwsResourceExplorerMetadata {
    roleArn?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IAwsResourceExplorerMetadata) {
        super(data);
        this._discriminator = "AwsResourceExplorerMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roleArn = _data["roleArn"];
            this.externalId = _data["externalId"];
        }
    }

    static override fromJS(data: any): AwsResourceExplorerMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AwsResourceExplorerMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleArn"] = this.roleArn;
        data["externalId"] = this.externalId;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsResourceExplorerMetadata extends IIntegrationMetadata {
    roleArn?: string | undefined;
    externalId?: string | undefined;
}

export class AwsSimpleRecommendationsIntegrationMetadata extends IntegrationMetadata implements IAwsSimpleRecommendationsIntegrationMetadata {
    payerAccountId?: string | undefined;
    roleArn?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IAwsSimpleRecommendationsIntegrationMetadata) {
        super(data);
        this._discriminator = "AwsSimpleRecommendationsIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payerAccountId = _data["payerAccountId"];
            this.roleArn = _data["roleArn"];
            this.externalId = _data["externalId"];
        }
    }

    static override fromJS(data: any): AwsSimpleRecommendationsIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AwsSimpleRecommendationsIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerAccountId"] = this.payerAccountId;
        data["roleArn"] = this.roleArn;
        data["externalId"] = this.externalId;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsSimpleRecommendationsIntegrationMetadata extends IIntegrationMetadata {
    payerAccountId?: string | undefined;
    roleArn?: string | undefined;
    externalId?: string | undefined;
}

export class AzureSubscriptionStatus implements IAzureSubscriptionStatus {
    id?: number;
    accountId?: number;
    createDateTime?: Date;
    displayName?: string | undefined;
    subscriptionId?: string | undefined;
    creationConfirmedDateTime?: Date | undefined;

    constructor(data?: IAzureSubscriptionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.createDateTime = _data["createDateTime"] ? new Date(_data["createDateTime"].toString()) : undefined as any;
            this.displayName = _data["displayName"];
            this.subscriptionId = _data["subscriptionId"];
            this.creationConfirmedDateTime = _data["creationConfirmedDateTime"] ? new Date(_data["creationConfirmedDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AzureSubscriptionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSubscriptionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toISOString() : undefined as any;
        data["displayName"] = this.displayName;
        data["subscriptionId"] = this.subscriptionId;
        data["creationConfirmedDateTime"] = this.creationConfirmedDateTime ? this.creationConfirmedDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IAzureSubscriptionStatus {
    id?: number;
    accountId?: number;
    createDateTime?: Date;
    displayName?: string | undefined;
    subscriptionId?: string | undefined;
    creationConfirmedDateTime?: Date | undefined;
}

export class CustomerAccount implements ICustomerAccount {
    customerId?: string | undefined;
    displayName?: string | undefined;
    typeName?: string | undefined;
    active?: boolean;

    constructor(data?: ICustomerAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.displayName = _data["displayName"];
            this.typeName = _data["typeName"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CustomerAccount {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["displayName"] = this.displayName;
        data["typeName"] = this.typeName;
        data["active"] = this.active;
        return data;
    }
}

export interface ICustomerAccount {
    customerId?: string | undefined;
    displayName?: string | undefined;
    typeName?: string | undefined;
    active?: boolean;
}

export class SubscriptionMapping implements ISubscriptionMapping {
    axNumber?: string | undefined;
    subscriptionIds?: string[] | undefined;

    constructor(data?: ISubscriptionMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axNumber = _data["axNumber"];
            if (Array.isArray(_data["subscriptionIds"])) {
                this.subscriptionIds = [] as any;
                for (let item of _data["subscriptionIds"])
                    this.subscriptionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SubscriptionMapping {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axNumber"] = this.axNumber;
        if (Array.isArray(this.subscriptionIds)) {
            data["subscriptionIds"] = [];
            for (let item of this.subscriptionIds)
                data["subscriptionIds"].push(item);
        }
        return data;
    }
}

export interface ISubscriptionMapping {
    axNumber?: string | undefined;
    subscriptionIds?: string[] | undefined;
}

export class SubscriptionResponseProperties implements ISubscriptionResponseProperties {
    subscriptionId?: string | undefined;
    provisioningState?: string | undefined;

    constructor(data?: ISubscriptionResponseProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.provisioningState = _data["provisioningState"];
        }
    }

    static fromJS(data: any): SubscriptionResponseProperties {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionResponseProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["provisioningState"] = this.provisioningState;
        return data;
    }
}

export interface ISubscriptionResponseProperties {
    subscriptionId?: string | undefined;
    provisioningState?: string | undefined;
}

export class TenantSubscriptions implements ITenantSubscriptions {
    tenantId?: string | undefined;
    subscriptions?: CustomerAccount[] | undefined;

    constructor(data?: ITenantSubscriptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(CustomerAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantSubscriptions {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSubscriptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITenantSubscriptions {
    tenantId?: string | undefined;
    subscriptions?: CustomerAccount[] | undefined;
}

export class AzureBackupAlert implements IAzureBackupAlert {
    name?: string | undefined;
    resourceLocation?: string | undefined;
    resourceTags?: string | undefined;
    backupLocation?: string | undefined;
    backupPlan?: string | undefined;
    healthStatus?: string | undefined;
    protectionState?: string | undefined;
    workloadType?: string | undefined;
    lastRecoveryPoint?: string | undefined;
    lastBackupStatus?: string | undefined;
    lastBackupTime?: string | undefined;
    subscriptionId?: string | undefined;
    resourceId?: string | undefined;
    resourceGroup?: string | undefined;

    constructor(data?: IAzureBackupAlert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.resourceLocation = _data["resourceLocation"];
            this.resourceTags = _data["resourceTags"];
            this.backupLocation = _data["backupLocation"];
            this.backupPlan = _data["backupPlan"];
            this.healthStatus = _data["healthStatus"];
            this.protectionState = _data["protectionState"];
            this.workloadType = _data["workloadType"];
            this.lastRecoveryPoint = _data["lastRecoveryPoint"];
            this.lastBackupStatus = _data["lastBackupStatus"];
            this.lastBackupTime = _data["lastBackupTime"];
            this.subscriptionId = _data["subscriptionId"];
            this.resourceId = _data["resourceId"];
            this.resourceGroup = _data["resourceGroup"];
        }
    }

    static fromJS(data: any): AzureBackupAlert {
        data = typeof data === 'object' ? data : {};
        let result = new AzureBackupAlert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["resourceLocation"] = this.resourceLocation;
        data["resourceTags"] = this.resourceTags;
        data["backupLocation"] = this.backupLocation;
        data["backupPlan"] = this.backupPlan;
        data["healthStatus"] = this.healthStatus;
        data["protectionState"] = this.protectionState;
        data["workloadType"] = this.workloadType;
        data["lastRecoveryPoint"] = this.lastRecoveryPoint;
        data["lastBackupStatus"] = this.lastBackupStatus;
        data["lastBackupTime"] = this.lastBackupTime;
        data["subscriptionId"] = this.subscriptionId;
        data["resourceId"] = this.resourceId;
        data["resourceGroup"] = this.resourceGroup;
        return data;
    }
}

export interface IAzureBackupAlert {
    name?: string | undefined;
    resourceLocation?: string | undefined;
    resourceTags?: string | undefined;
    backupLocation?: string | undefined;
    backupPlan?: string | undefined;
    healthStatus?: string | undefined;
    protectionState?: string | undefined;
    workloadType?: string | undefined;
    lastRecoveryPoint?: string | undefined;
    lastBackupStatus?: string | undefined;
    lastBackupTime?: string | undefined;
    subscriptionId?: string | undefined;
    resourceId?: string | undefined;
    resourceGroup?: string | undefined;
}

export class AzureDevOpsReportIntegrationMetadata extends IntegrationMetadata implements IAzureDevOpsReportIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: IAzureDevOpsReportIntegrationMetadata) {
        super(data);
        this._discriminator = "AzureDevOpsReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): AzureDevOpsReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzureDevOpsReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureDevOpsReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class AzureIntegrationMetadata extends IntegrationMetadata implements IAzureIntegrationMetadata {
    subscriptionId?: string | undefined;

    constructor(data?: IAzureIntegrationMetadata) {
        super(data);
        this._discriminator = "AzureIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static override fromJS(data: any): AzureIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzureIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureIntegrationMetadata extends IIntegrationMetadata {
    subscriptionId?: string | undefined;
}

export class AzurePlanReportIntegrationMetadata extends IntegrationMetadata implements IAzurePlanReportIntegrationMetadata {
    customerTenantId?: string | undefined;
    axAccount?: string | undefined;

    constructor(data?: IAzurePlanReportIntegrationMetadata) {
        super(data);
        this._discriminator = "AzurePlanReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerTenantId = _data["customerTenantId"];
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): AzurePlanReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzurePlanReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerTenantId"] = this.customerTenantId;
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IAzurePlanReportIntegrationMetadata extends IIntegrationMetadata {
    customerTenantId?: string | undefined;
    axAccount?: string | undefined;
}

export class AzureTenantConnection implements IAzureTenantConnection {
    tenantId?: string | undefined;
    appRegistrationId?: string | undefined;
    purpose?: Purpose[] | undefined;
    currentState?: ConnectionStatus;
    errorMessage?: string | undefined;

    constructor(data?: IAzureTenantConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.appRegistrationId = _data["appRegistrationId"];
            if (Array.isArray(_data["purpose"])) {
                this.purpose = [] as any;
                for (let item of _data["purpose"])
                    this.purpose!.push(item);
            }
            this.currentState = _data["currentState"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): AzureTenantConnection {
        data = typeof data === 'object' ? data : {};
        let result = new AzureTenantConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["appRegistrationId"] = this.appRegistrationId;
        if (Array.isArray(this.purpose)) {
            data["purpose"] = [];
            for (let item of this.purpose)
                data["purpose"].push(item);
        }
        data["currentState"] = this.currentState;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IAzureTenantConnection {
    tenantId?: string | undefined;
    appRegistrationId?: string | undefined;
    purpose?: Purpose[] | undefined;
    currentState?: ConnectionStatus;
    errorMessage?: string | undefined;
}

export class BillingInvoiceDto implements IBillingInvoiceDto {
    invoiceId?: string | undefined;
    invoiceDate?: Date;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;
    serviceType?: string | undefined;
    contractType?: string | undefined;
    companyName?: string | undefined;
    contractName?: string | undefined;
    contractId?: number | undefined;
    projectId?: number | undefined;
    projectName?: string | undefined;

    constructor(data?: IBillingInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.customerPo = _data["customerPo"];
            this.customerRequisition = _data["customerRequisition"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.tagFilter = _data["tagFilter"];
            this.tag = _data["tag"];
            this.tenant = _data["tenant"];
            this.serviceProjectName = _data["serviceProjectName"];
            this.serviceType = _data["serviceType"];
            this.contractType = _data["contractType"];
            this.companyName = _data["companyName"];
            this.contractName = _data["contractName"];
            this.contractId = _data["contractId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): BillingInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["customerPo"] = this.customerPo;
        data["customerRequisition"] = this.customerRequisition;
        data["invoiceAmount"] = this.invoiceAmount;
        data["tagFilter"] = this.tagFilter;
        data["tag"] = this.tag;
        data["tenant"] = this.tenant;
        data["serviceProjectName"] = this.serviceProjectName;
        data["serviceType"] = this.serviceType;
        data["contractType"] = this.contractType;
        data["companyName"] = this.companyName;
        data["contractName"] = this.contractName;
        data["contractId"] = this.contractId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IBillingInvoiceDto {
    invoiceId?: string | undefined;
    invoiceDate?: Date;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;
    serviceType?: string | undefined;
    contractType?: string | undefined;
    companyName?: string | undefined;
    contractName?: string | undefined;
    contractId?: number | undefined;
    projectId?: number | undefined;
    projectName?: string | undefined;
}

export class EmailInvoicesDto implements IEmailInvoicesDto {
    emailAddress?: string | undefined;
    invoices?: BillingInvoiceDto[] | undefined;
    isInvoicedOnRange?: boolean;
    additionalEmailAddresses?: string[] | undefined;

    constructor(data?: IEmailInvoicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(BillingInvoiceDto.fromJS(item));
            }
            this.isInvoicedOnRange = _data["isInvoicedOnRange"];
            if (Array.isArray(_data["additionalEmailAddresses"])) {
                this.additionalEmailAddresses = [] as any;
                for (let item of _data["additionalEmailAddresses"])
                    this.additionalEmailAddresses!.push(item);
            }
        }
    }

    static fromJS(data: any): EmailInvoicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailInvoicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["isInvoicedOnRange"] = this.isInvoicedOnRange;
        if (Array.isArray(this.additionalEmailAddresses)) {
            data["additionalEmailAddresses"] = [];
            for (let item of this.additionalEmailAddresses)
                data["additionalEmailAddresses"].push(item);
        }
        return data;
    }
}

export interface IEmailInvoicesDto {
    emailAddress?: string | undefined;
    invoices?: BillingInvoiceDto[] | undefined;
    isInvoicedOnRange?: boolean;
    additionalEmailAddresses?: string[] | undefined;
}

export class InvoicesByMonthResponseDto implements IInvoicesByMonthResponseDto {
    startDate?: Date;
    endDate?: Date;
    monthlyInvoices?: MonthlyInvoiceList[] | undefined;
    hasRetrievalErrors?: boolean;
    failedTags?: string[] | undefined;

    constructor(data?: IInvoicesByMonthResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["monthlyInvoices"])) {
                this.monthlyInvoices = [] as any;
                for (let item of _data["monthlyInvoices"])
                    this.monthlyInvoices!.push(MonthlyInvoiceList.fromJS(item));
            }
            this.hasRetrievalErrors = _data["hasRetrievalErrors"];
            if (Array.isArray(_data["failedTags"])) {
                this.failedTags = [] as any;
                for (let item of _data["failedTags"])
                    this.failedTags!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoicesByMonthResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesByMonthResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.monthlyInvoices)) {
            data["monthlyInvoices"] = [];
            for (let item of this.monthlyInvoices)
                data["monthlyInvoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasRetrievalErrors"] = this.hasRetrievalErrors;
        if (Array.isArray(this.failedTags)) {
            data["failedTags"] = [];
            for (let item of this.failedTags)
                data["failedTags"].push(item);
        }
        return data;
    }
}

export interface IInvoicesByMonthResponseDto {
    startDate?: Date;
    endDate?: Date;
    monthlyInvoices?: MonthlyInvoiceList[] | undefined;
    hasRetrievalErrors?: boolean;
    failedTags?: string[] | undefined;
}

export class LastMonthsCostDto implements ILastMonthsCostDto {
    lastMonthsCostType?: LastMonthsCostType;
    totalCost?: number;
    lastMonthsCostLineItems?: LastMonthsCostLineItem[] | undefined;

    constructor(data?: ILastMonthsCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastMonthsCostType = _data["lastMonthsCostType"];
            this.totalCost = _data["totalCost"];
            if (Array.isArray(_data["lastMonthsCostLineItems"])) {
                this.lastMonthsCostLineItems = [] as any;
                for (let item of _data["lastMonthsCostLineItems"])
                    this.lastMonthsCostLineItems!.push(LastMonthsCostLineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LastMonthsCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new LastMonthsCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastMonthsCostType"] = this.lastMonthsCostType;
        data["totalCost"] = this.totalCost;
        if (Array.isArray(this.lastMonthsCostLineItems)) {
            data["lastMonthsCostLineItems"] = [];
            for (let item of this.lastMonthsCostLineItems)
                data["lastMonthsCostLineItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILastMonthsCostDto {
    lastMonthsCostType?: LastMonthsCostType;
    totalCost?: number;
    lastMonthsCostLineItems?: LastMonthsCostLineItem[] | undefined;
}

export class LastMonthsCostLineItem implements ILastMonthsCostLineItem {
    name?: string | undefined;
    cost?: number;
    percentage?: number;

    constructor(data?: ILastMonthsCostLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cost = _data["cost"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): LastMonthsCostLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new LastMonthsCostLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cost"] = this.cost;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface ILastMonthsCostLineItem {
    name?: string | undefined;
    cost?: number;
    percentage?: number;
}

export enum LastMonthsCostType {
    ByContract = "ByContract",
    ByContractType = "ByContractType",
    ByVendor = "ByVendor",
    ByServiceType = "ByServiceType",
}

export class MonthlyInvoiceList implements IMonthlyInvoiceList {
    totalCost?: number;
    differenceFromPreviousMonthPercentage?: number;
    billingPeriod?: Date;
    differenceFromPreviousMonth?: number;
    invoices?: BillingInvoiceDto[] | undefined;

    constructor(data?: IMonthlyInvoiceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCost = _data["totalCost"];
            this.differenceFromPreviousMonthPercentage = _data["differenceFromPreviousMonthPercentage"];
            this.billingPeriod = _data["billingPeriod"] ? new Date(_data["billingPeriod"].toString()) : undefined as any;
            this.differenceFromPreviousMonth = _data["differenceFromPreviousMonth"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(BillingInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthlyInvoiceList {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyInvoiceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCost"] = this.totalCost;
        data["differenceFromPreviousMonthPercentage"] = this.differenceFromPreviousMonthPercentage;
        data["billingPeriod"] = this.billingPeriod ? this.billingPeriod.toISOString() : undefined as any;
        data["differenceFromPreviousMonth"] = this.differenceFromPreviousMonth;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMonthlyInvoiceList {
    totalCost?: number;
    differenceFromPreviousMonthPercentage?: number;
    billingPeriod?: Date;
    differenceFromPreviousMonth?: number;
    invoices?: BillingInvoiceDto[] | undefined;
}

export class Bookmark implements IBookmark {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
    reportId?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IBookmark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "Bookmark";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): Bookmark {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "AccountBookmark") {
            let result = new AccountBookmark();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "ContactBookmark") {
            let result = new ContactBookmark();
            result.init(data);
            return result;
        }
        let result = new Bookmark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IBookmark {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
    reportId?: string | undefined;
}

export class AccountBookmark extends Bookmark implements IAccountBookmark {
    accountId?: number;

    constructor(data?: IAccountBookmark) {
        super(data);
        this._discriminator = "AccountBookmark";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static override fromJS(data: any): AccountBookmark {
        data = typeof data === 'object' ? data : {};
        let result = new AccountBookmark();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        super.toJSON(data);
        return data;
    }
}

export interface IAccountBookmark extends IBookmark {
    accountId?: number;
}

export class ContactBookmark extends Bookmark implements IContactBookmark {
    contactId?: number;

    constructor(data?: IContactBookmark) {
        super(data);
        this._discriminator = "ContactBookmark";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactId = _data["contactId"];
        }
    }

    static override fromJS(data: any): ContactBookmark {
        data = typeof data === 'object' ? data : {};
        let result = new ContactBookmark();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        super.toJSON(data);
        return data;
    }
}

export interface IContactBookmark extends IBookmark {
    contactId?: number;
}

export class BusinessPath implements IBusinessPath {
    reportingBuId?: string | undefined;
    name?: string | undefined;
    pathName?: string | undefined;
    parentReportingBuId?: string | undefined;
    businessUnitPathType?: BusinessUnitPathType;
    children?: BusinessPath[] | undefined;

    constructor(data?: IBusinessPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportingBuId = _data["reportingBuId"];
            this.name = _data["name"];
            this.pathName = _data["pathName"];
            this.parentReportingBuId = _data["parentReportingBuId"];
            this.businessUnitPathType = _data["businessUnitPathType"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BusinessPath.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessPath {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportingBuId"] = this.reportingBuId;
        data["name"] = this.name;
        data["pathName"] = this.pathName;
        data["parentReportingBuId"] = this.parentReportingBuId;
        data["businessUnitPathType"] = this.businessUnitPathType;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBusinessPath {
    reportingBuId?: string | undefined;
    name?: string | undefined;
    pathName?: string | undefined;
    parentReportingBuId?: string | undefined;
    businessUnitPathType?: BusinessUnitPathType;
    children?: BusinessPath[] | undefined;
}

export class BusinessPathAccount implements IBusinessPathAccount {
    reportingBuPathId?: string | undefined;
    owningTeamId?: string | undefined;
    axAccountNumber?: string | undefined;
    crmAccountGuid?: string | undefined;
    businessPathCompanyGuid?: string | undefined;
    businessPathBusinessUnitGuid?: string | undefined;
    businessPathSegmentGuid?: string | undefined;
    businessPathDivisionGuid?: string | undefined;
    businessPathRegionGuid?: string | undefined;
    businessPathDistrictGuid?: string | undefined;

    constructor(data?: IBusinessPathAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportingBuPathId = _data["reportingBuPathId"];
            this.owningTeamId = _data["owningTeamId"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.crmAccountGuid = _data["crmAccountGuid"];
            this.businessPathCompanyGuid = _data["businessPathCompanyGuid"];
            this.businessPathBusinessUnitGuid = _data["businessPathBusinessUnitGuid"];
            this.businessPathSegmentGuid = _data["businessPathSegmentGuid"];
            this.businessPathDivisionGuid = _data["businessPathDivisionGuid"];
            this.businessPathRegionGuid = _data["businessPathRegionGuid"];
            this.businessPathDistrictGuid = _data["businessPathDistrictGuid"];
        }
    }

    static fromJS(data: any): BusinessPathAccount {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessPathAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportingBuPathId"] = this.reportingBuPathId;
        data["owningTeamId"] = this.owningTeamId;
        data["axAccountNumber"] = this.axAccountNumber;
        data["crmAccountGuid"] = this.crmAccountGuid;
        data["businessPathCompanyGuid"] = this.businessPathCompanyGuid;
        data["businessPathBusinessUnitGuid"] = this.businessPathBusinessUnitGuid;
        data["businessPathSegmentGuid"] = this.businessPathSegmentGuid;
        data["businessPathDivisionGuid"] = this.businessPathDivisionGuid;
        data["businessPathRegionGuid"] = this.businessPathRegionGuid;
        data["businessPathDistrictGuid"] = this.businessPathDistrictGuid;
        return data;
    }
}

export interface IBusinessPathAccount {
    reportingBuPathId?: string | undefined;
    owningTeamId?: string | undefined;
    axAccountNumber?: string | undefined;
    crmAccountGuid?: string | undefined;
    businessPathCompanyGuid?: string | undefined;
    businessPathBusinessUnitGuid?: string | undefined;
    businessPathSegmentGuid?: string | undefined;
    businessPathDivisionGuid?: string | undefined;
    businessPathRegionGuid?: string | undefined;
    businessPathDistrictGuid?: string | undefined;
}

export class CartChangeSummaryDto implements ICartChangeSummaryDto {
    removedCount!: number;
    repricedCount!: number;
    changes!: CartLineChangeDto[] | undefined;

    constructor(data?: ICartChangeSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.removedCount = _data["removedCount"];
            this.repricedCount = _data["repricedCount"];
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(CartLineChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CartChangeSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartChangeSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["removedCount"] = this.removedCount;
        data["repricedCount"] = this.repricedCount;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICartChangeSummaryDto {
    removedCount: number;
    repricedCount: number;
    changes: CartLineChangeDto[] | undefined;
}

export class CartLineChangeDto implements ICartLineChangeDto {
    lineNumber!: number;
    productName?: string | undefined;
    /** `Removed` or `Repriced`. */
    change!: string | undefined;
    removalReason?: string | undefined;
    previousUnitPrice!: number;
    unitPrice!: number;

    constructor(data?: ICartLineChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.productName = _data["productName"];
            this.change = _data["change"];
            this.removalReason = _data["removalReason"];
            this.previousUnitPrice = _data["previousUnitPrice"];
            this.unitPrice = _data["unitPrice"];
        }
    }

    static fromJS(data: any): CartLineChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartLineChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["productName"] = this.productName;
        data["change"] = this.change;
        data["removalReason"] = this.removalReason;
        data["previousUnitPrice"] = this.previousUnitPrice;
        data["unitPrice"] = this.unitPrice;
        return data;
    }
}

export interface ICartLineChangeDto {
    lineNumber: number;
    productName?: string | undefined;
    /** `Removed` or `Repriced`. */
    change: string | undefined;
    removalReason?: string | undefined;
    previousUnitPrice: number;
    unitPrice: number;
}

export class CatalystIntegrationMetadata extends IntegrationMetadata implements ICatalystIntegrationMetadata {
    advisoryContractId?: number | undefined;
    manuallyEnabled?: boolean;
    azureTenants?: AzureTenantConnection[] | undefined;
    m365Tenants?: Microsoft365TenantConnection[] | undefined;

    constructor(data?: ICatalystIntegrationMetadata) {
        super(data);
        this._discriminator = "CatalystIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.advisoryContractId = _data["advisoryContractId"];
            this.manuallyEnabled = _data["manuallyEnabled"];
            if (Array.isArray(_data["azureTenants"])) {
                this.azureTenants = [] as any;
                for (let item of _data["azureTenants"])
                    this.azureTenants!.push(AzureTenantConnection.fromJS(item));
            }
            if (Array.isArray(_data["m365Tenants"])) {
                this.m365Tenants = [] as any;
                for (let item of _data["m365Tenants"])
                    this.m365Tenants!.push(Microsoft365TenantConnection.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CatalystIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CatalystIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advisoryContractId"] = this.advisoryContractId;
        data["manuallyEnabled"] = this.manuallyEnabled;
        if (Array.isArray(this.azureTenants)) {
            data["azureTenants"] = [];
            for (let item of this.azureTenants)
                data["azureTenants"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.m365Tenants)) {
            data["m365Tenants"] = [];
            for (let item of this.m365Tenants)
                data["m365Tenants"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICatalystIntegrationMetadata extends IIntegrationMetadata {
    advisoryContractId?: number | undefined;
    manuallyEnabled?: boolean;
    azureTenants?: AzureTenantConnection[] | undefined;
    m365Tenants?: Microsoft365TenantConnection[] | undefined;
}

export class CiscoContractCoverageIntegrationMetadata extends IntegrationMetadata implements ICiscoContractCoverageIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: ICiscoContractCoverageIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoContractCoverageIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoContractCoverageIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoContractCoverageIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoContractCoverageIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class CiscoEnterpriseAgreementMetadata extends IntegrationMetadata implements ICiscoEnterpriseAgreementMetadata {
    smartAccountDomain?: string | undefined;
    axAccount?: string | undefined;

    constructor(data?: ICiscoEnterpriseAgreementMetadata) {
        super(data);
        this._discriminator = "CiscoEnterpriseAgreementMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.smartAccountDomain = _data["smartAccountDomain"];
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoEnterpriseAgreementMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoEnterpriseAgreementMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smartAccountDomain"] = this.smartAccountDomain;
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoEnterpriseAgreementMetadata extends IIntegrationMetadata {
    smartAccountDomain?: string | undefined;
    axAccount?: string | undefined;
}

export class CiscoMerakiIntegrationMetadata extends IntegrationMetadata implements ICiscoMerakiIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: ICiscoMerakiIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoMerakiIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoMerakiIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoMerakiIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoMerakiIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class CiscoReadyReportIntegrationMetadata extends IntegrationMetadata implements ICiscoReadyReportIntegrationMetadata {
    axAccount?: string | undefined;
    originalFilename?: string | undefined;
    processedFilename?: string | undefined;
    fileSubmissionUtcDateTime?: Date;

    constructor(data?: ICiscoReadyReportIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoReadyReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
            this.originalFilename = _data["originalFilename"];
            this.processedFilename = _data["processedFilename"];
            this.fileSubmissionUtcDateTime = _data["fileSubmissionUtcDateTime"] ? new Date(_data["fileSubmissionUtcDateTime"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): CiscoReadyReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoReadyReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        data["originalFilename"] = this.originalFilename;
        data["processedFilename"] = this.processedFilename;
        data["fileSubmissionUtcDateTime"] = this.fileSubmissionUtcDateTime ? this.fileSubmissionUtcDateTime.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoReadyReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
    originalFilename?: string | undefined;
    processedFilename?: string | undefined;
    fileSubmissionUtcDateTime?: Date;
}

export class CiscoReadyReportUploadResponse implements ICiscoReadyReportUploadResponse {
    warnings?: EvaluatedCiscoReadyReportRecord[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: ICiscoReadyReportUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(EvaluatedCiscoReadyReportRecord.fromJS(item));
            }
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : undefined as any;
        }
    }

    static fromJS(data: any): CiscoReadyReportUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoReadyReportUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : undefined as any;
        return data;
    }
}

export interface ICiscoReadyReportUploadResponse {
    warnings?: EvaluatedCiscoReadyReportRecord[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;
}

export class CiscoSNTCIntegrationMetadata extends IntegrationMetadata implements ICiscoSNTCIntegrationMetadata {
    customerId?: string | undefined;
    axAccount?: string | undefined;

    constructor(data?: ICiscoSNTCIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoSNTCIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoSNTCIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoSNTCIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoSNTCIntegrationMetadata extends IIntegrationMetadata {
    customerId?: string | undefined;
    axAccount?: string | undefined;
}

export class CiscoSubscriptionManagementIntegrationMetadata extends IntegrationMetadata implements ICiscoSubscriptionManagementIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: ICiscoSubscriptionManagementIntegrationMetadata) {
        super(data);
        this._discriminator = "CiscoSubscriptionManagementIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): CiscoSubscriptionManagementIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoSubscriptionManagementIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoSubscriptionManagementIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class CiscoMerakiCustomerMetadata extends IntegrationMetadata implements ICiscoMerakiCustomerMetadata {
    customerApiKey?: string | undefined;
    friendlyKeyName?: string | undefined;

    constructor(data?: ICiscoMerakiCustomerMetadata) {
        super(data);
        this._discriminator = "CiscoMerakiCustomerMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerApiKey = _data["customerApiKey"];
            this.friendlyKeyName = _data["friendlyKeyName"];
        }
    }

    static override fromJS(data: any): CiscoMerakiCustomerMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoMerakiCustomerMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerApiKey"] = this.customerApiKey;
        data["friendlyKeyName"] = this.friendlyKeyName;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoMerakiCustomerMetadata extends IIntegrationMetadata {
    customerApiKey?: string | undefined;
    friendlyKeyName?: string | undefined;
}

export class CloudConsumptionDto implements ICloudConsumptionDto {
    customerPrice?: number[] | undefined;
    monthToDateCustomerPrice?: number[] | undefined;
    monthlyTotalCustomerPrice?: number;
    consumptionDates?: Date[] | undefined;
    billingPeriodStartDate?: Date;

    constructor(data?: ICloudConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerPrice"])) {
                this.customerPrice = [] as any;
                for (let item of _data["customerPrice"])
                    this.customerPrice!.push(item);
            }
            if (Array.isArray(_data["monthToDateCustomerPrice"])) {
                this.monthToDateCustomerPrice = [] as any;
                for (let item of _data["monthToDateCustomerPrice"])
                    this.monthToDateCustomerPrice!.push(item);
            }
            this.monthlyTotalCustomerPrice = _data["monthlyTotalCustomerPrice"];
            if (Array.isArray(_data["consumptionDates"])) {
                this.consumptionDates = [] as any;
                for (let item of _data["consumptionDates"])
                    this.consumptionDates!.push(new Date(item));
            }
            this.billingPeriodStartDate = _data["billingPeriodStartDate"] ? new Date(_data["billingPeriodStartDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CloudConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerPrice)) {
            data["customerPrice"] = [];
            for (let item of this.customerPrice)
                data["customerPrice"].push(item);
        }
        if (Array.isArray(this.monthToDateCustomerPrice)) {
            data["monthToDateCustomerPrice"] = [];
            for (let item of this.monthToDateCustomerPrice)
                data["monthToDateCustomerPrice"].push(item);
        }
        data["monthlyTotalCustomerPrice"] = this.monthlyTotalCustomerPrice;
        if (Array.isArray(this.consumptionDates)) {
            data["consumptionDates"] = [];
            for (let item of this.consumptionDates)
                data["consumptionDates"].push(item.toISOString());
        }
        data["billingPeriodStartDate"] = this.billingPeriodStartDate ? this.billingPeriodStartDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICloudConsumptionDto {
    customerPrice?: number[] | undefined;
    monthToDateCustomerPrice?: number[] | undefined;
    monthlyTotalCustomerPrice?: number;
    consumptionDates?: Date[] | undefined;
    billingPeriodStartDate?: Date;
}

export class AccessValidationRequest implements IAccessValidationRequest {
    accountRoleName?: string | undefined;
    uniqueId?: string | undefined;
    integrationType?: IntegrationType;

    constructor(data?: IAccessValidationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountRoleName = _data["accountRoleName"];
            this.uniqueId = _data["uniqueId"];
            this.integrationType = _data["integrationType"];
        }
    }

    static fromJS(data: any): AccessValidationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccessValidationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountRoleName"] = this.accountRoleName;
        data["uniqueId"] = this.uniqueId;
        data["integrationType"] = this.integrationType;
        return data;
    }
}

export interface IAccessValidationRequest {
    accountRoleName?: string | undefined;
    uniqueId?: string | undefined;
    integrationType?: IntegrationType;
}

export class AccessValidationResponse implements IAccessValidationResponse {
    responseMessage?: string[] | undefined;
    passed?: boolean;
    integrationType?: IntegrationType;

    constructor(data?: IAccessValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseMessage"])) {
                this.responseMessage = [] as any;
                for (let item of _data["responseMessage"])
                    this.responseMessage!.push(item);
            }
            this.passed = _data["passed"];
            this.integrationType = _data["integrationType"];
        }
    }

    static fromJS(data: any): AccessValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccessValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseMessage)) {
            data["responseMessage"] = [];
            for (let item of this.responseMessage)
                data["responseMessage"].push(item);
        }
        data["passed"] = this.passed;
        data["integrationType"] = this.integrationType;
        return data;
    }
}

export interface IAccessValidationResponse {
    responseMessage?: string[] | undefined;
    passed?: boolean;
    integrationType?: IntegrationType;
}

export class CloudAccountIdentifier implements ICloudAccountIdentifier {
    cloud?: string | undefined;
    awsPayerID?: string | undefined;
    accountID?: string | undefined;
    microsoftAzureParentID?: string | undefined;
    gcpBillingAccountId?: string | undefined;

    constructor(data?: ICloudAccountIdentifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloud = _data["cloud"];
            this.awsPayerID = _data["awsPayerID"];
            this.accountID = _data["accountID"];
            this.microsoftAzureParentID = _data["microsoftAzureParentID"];
            this.gcpBillingAccountId = _data["gcpBillingAccountId"];
        }
    }

    static fromJS(data: any): CloudAccountIdentifier {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAccountIdentifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloud"] = this.cloud;
        data["awsPayerID"] = this.awsPayerID;
        data["accountID"] = this.accountID;
        data["microsoftAzureParentID"] = this.microsoftAzureParentID;
        data["gcpBillingAccountId"] = this.gcpBillingAccountId;
        return data;
    }
}

export interface ICloudAccountIdentifier {
    cloud?: string | undefined;
    awsPayerID?: string | undefined;
    accountID?: string | undefined;
    microsoftAzureParentID?: string | undefined;
    gcpBillingAccountId?: string | undefined;
}

export class CustomerSubscription implements ICustomerSubscription {
    subscriptionId?: string | undefined;
    customerName?: string | undefined;
    contractName?: string | undefined;

    constructor(data?: ICustomerSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.customerName = _data["customerName"];
            this.contractName = _data["contractName"];
        }
    }

    static fromJS(data: any): CustomerSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["customerName"] = this.customerName;
        data["contractName"] = this.contractName;
        return data;
    }
}

export interface ICustomerSubscription {
    subscriptionId?: string | undefined;
    customerName?: string | undefined;
    contractName?: string | undefined;
}

export class ConfigContractSLA implements IConfigContractSLA {
    id?: number;
    contractCategory?: number;
    serviceLevelAgreementID?: number;
    configTicketCategoryMappings?: ConfigTicketCategoryMapping[] | undefined;

    constructor(data?: IConfigContractSLA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractCategory = _data["contractCategory"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            if (Array.isArray(_data["configTicketCategoryMappings"])) {
                this.configTicketCategoryMappings = [] as any;
                for (let item of _data["configTicketCategoryMappings"])
                    this.configTicketCategoryMappings!.push(ConfigTicketCategoryMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigContractSLA {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigContractSLA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractCategory"] = this.contractCategory;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        if (Array.isArray(this.configTicketCategoryMappings)) {
            data["configTicketCategoryMappings"] = [];
            for (let item of this.configTicketCategoryMappings)
                data["configTicketCategoryMappings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConfigContractSLA {
    id?: number;
    contractCategory?: number;
    serviceLevelAgreementID?: number;
    configTicketCategoryMappings?: ConfigTicketCategoryMapping[] | undefined;
}

export class ConfigTicketCategoryMapping implements IConfigTicketCategoryMapping {
    id?: number;
    contractSLAId?: number;
    ticketCategoryId?: number;
    issueTypes?: number[] | undefined;

    constructor(data?: IConfigTicketCategoryMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractSLAId = _data["contractSLAId"];
            this.ticketCategoryId = _data["ticketCategoryId"];
            if (Array.isArray(_data["issueTypes"])) {
                this.issueTypes = [] as any;
                for (let item of _data["issueTypes"])
                    this.issueTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): ConfigTicketCategoryMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigTicketCategoryMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractSLAId"] = this.contractSLAId;
        data["ticketCategoryId"] = this.ticketCategoryId;
        if (Array.isArray(this.issueTypes)) {
            data["issueTypes"] = [];
            for (let item of this.issueTypes)
                data["issueTypes"].push(item);
        }
        return data;
    }
}

export interface IConfigTicketCategoryMapping {
    id?: number;
    contractSLAId?: number;
    ticketCategoryId?: number;
    issueTypes?: number[] | undefined;
}

export enum ConnectionStatus {
    Success = "Success",
    Partial = "Partial",
    Failure = "Failure",
}

export class CostCenterCloudAccountRequest implements ICostCenterCloudAccountRequest {
    costCenterId?: number;
    configurationItems?: CostCenterConfigurationItem[] | undefined;

    constructor(data?: ICostCenterCloudAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCenterId = _data["costCenterId"];
            if (Array.isArray(_data["configurationItems"])) {
                this.configurationItems = [] as any;
                for (let item of _data["configurationItems"])
                    this.configurationItems!.push(CostCenterConfigurationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostCenterCloudAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterCloudAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCenterId"] = this.costCenterId;
        if (Array.isArray(this.configurationItems)) {
            data["configurationItems"] = [];
            for (let item of this.configurationItems)
                data["configurationItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICostCenterCloudAccountRequest {
    costCenterId?: number;
    configurationItems?: CostCenterConfigurationItem[] | undefined;
}

export class CostCenterConfigurationItem implements ICostCenterConfigurationItem {
    configurationItemId?: number;
    licenseCount?: number | undefined;

    constructor(data?: ICostCenterConfigurationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            this.licenseCount = _data["licenseCount"];
        }
    }

    static fromJS(data: any): CostCenterConfigurationItem {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterConfigurationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        data["licenseCount"] = this.licenseCount;
        return data;
    }
}

export interface ICostCenterConfigurationItem {
    configurationItemId?: number;
    licenseCount?: number | undefined;
}

export class CostCenterDeleteRequest implements ICostCenterDeleteRequest {
    id?: number;
    accountId?: number | undefined;

    constructor(data?: ICostCenterDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): CostCenterDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface ICostCenterDeleteRequest {
    id?: number;
    accountId?: number | undefined;
}

export class CostCenterWithCloudAccountsDTO implements ICostCenterWithCloudAccountsDTO {
    costCenter?: CostCenterDTO;
    cloudAccounts?: CloudAccountDTO[] | undefined;

    constructor(data?: ICostCenterWithCloudAccountsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCenter = _data["costCenter"] ? CostCenterDTO.fromJS(_data["costCenter"]) : undefined as any;
            if (Array.isArray(_data["cloudAccounts"])) {
                this.cloudAccounts = [] as any;
                for (let item of _data["cloudAccounts"])
                    this.cloudAccounts!.push(CloudAccountDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostCenterWithCloudAccountsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterWithCloudAccountsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : undefined as any;
        if (Array.isArray(this.cloudAccounts)) {
            data["cloudAccounts"] = [];
            for (let item of this.cloudAccounts)
                data["cloudAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICostCenterWithCloudAccountsDTO {
    costCenter?: CostCenterDTO;
    cloudAccounts?: CloudAccountDTO[] | undefined;
}

export class BulkUpsertCostCenterByPoItem implements IBulkUpsertCostCenterByPoItem {
    axAccountNumber?: string | undefined;
    cloudAccountId?: string | undefined;
    poNumber?: string | undefined;

    constructor(data?: IBulkUpsertCostCenterByPoItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.cloudAccountId = _data["cloudAccountId"];
            this.poNumber = _data["poNumber"];
        }
    }

    static fromJS(data: any): BulkUpsertCostCenterByPoItem {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpsertCostCenterByPoItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["cloudAccountId"] = this.cloudAccountId;
        data["poNumber"] = this.poNumber;
        return data;
    }
}

export interface IBulkUpsertCostCenterByPoItem {
    axAccountNumber?: string | undefined;
    cloudAccountId?: string | undefined;
    poNumber?: string | undefined;
}

export class BulkUpsertCostCenterByPoResponse implements IBulkUpsertCostCenterByPoResponse {
    results?: BulkUpsertCostCenterByPoResult[] | undefined;
    readonly successCount?: number;
    readonly failureCount?: number;

    constructor(data?: IBulkUpsertCostCenterByPoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BulkUpsertCostCenterByPoResult.fromJS(item));
            }
            (this as any).successCount = _data["successCount"];
            (this as any).failureCount = _data["failureCount"];
        }
    }

    static fromJS(data: any): BulkUpsertCostCenterByPoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpsertCostCenterByPoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["successCount"] = this.successCount;
        data["failureCount"] = this.failureCount;
        return data;
    }
}

export interface IBulkUpsertCostCenterByPoResponse {
    results?: BulkUpsertCostCenterByPoResult[] | undefined;
    successCount?: number;
    failureCount?: number;
}

export class BulkUpsertCostCenterByPoResult implements IBulkUpsertCostCenterByPoResult {
    axAccountNumber?: string | undefined;
    cloudAccountId?: string | undefined;
    poNumber?: string | undefined;
    costCenterId?: number | undefined;
    created?: boolean;
    success?: boolean;
    error?: string | undefined;

    constructor(data?: IBulkUpsertCostCenterByPoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.cloudAccountId = _data["cloudAccountId"];
            this.poNumber = _data["poNumber"];
            this.costCenterId = _data["costCenterId"];
            this.created = _data["created"];
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): BulkUpsertCostCenterByPoResult {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpsertCostCenterByPoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["cloudAccountId"] = this.cloudAccountId;
        data["poNumber"] = this.poNumber;
        data["costCenterId"] = this.costCenterId;
        data["created"] = this.created;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IBulkUpsertCostCenterByPoResult {
    axAccountNumber?: string | undefined;
    cloudAccountId?: string | undefined;
    poNumber?: string | undefined;
    costCenterId?: number | undefined;
    created?: boolean;
    success?: boolean;
    error?: string | undefined;
}

export enum CloudType {
    Azure = "Azure",
    AWS = "AWS",
    GCP = "GCP",
    M365 = "M365",
}

export class DefaultCostCenterPurchaseOrder implements IDefaultCostCenterPurchaseOrder {
    cloudType!: CloudType;
    purchaseOrderNumber!: string | undefined;

    constructor(data?: IDefaultCostCenterPurchaseOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloudType = _data["cloudType"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
        }
    }

    static fromJS(data: any): DefaultCostCenterPurchaseOrder {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultCostCenterPurchaseOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloudType"] = this.cloudType;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        return data;
    }
}

export interface IDefaultCostCenterPurchaseOrder {
    cloudType: CloudType;
    purchaseOrderNumber: string | undefined;
}

export class DefaultCostCenterPurchaseOrdersResponse implements IDefaultCostCenterPurchaseOrdersResponse {
    defaultCostCenterPurchaseOrders?: DefaultCostCenterPurchaseOrder[] | undefined;

    constructor(data?: IDefaultCostCenterPurchaseOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["defaultCostCenterPurchaseOrders"])) {
                this.defaultCostCenterPurchaseOrders = [] as any;
                for (let item of _data["defaultCostCenterPurchaseOrders"])
                    this.defaultCostCenterPurchaseOrders!.push(DefaultCostCenterPurchaseOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DefaultCostCenterPurchaseOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultCostCenterPurchaseOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.defaultCostCenterPurchaseOrders)) {
            data["defaultCostCenterPurchaseOrders"] = [];
            for (let item of this.defaultCostCenterPurchaseOrders)
                data["defaultCostCenterPurchaseOrders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDefaultCostCenterPurchaseOrdersResponse {
    defaultCostCenterPurchaseOrders?: DefaultCostCenterPurchaseOrder[] | undefined;
}

export class UpdateDefaultCostCenterPurchaseOrdersRequest implements IUpdateDefaultCostCenterPurchaseOrdersRequest {
    defaultCostCenterPurchaseOrders?: DefaultCostCenterPurchaseOrder[] | undefined;
    accountId?: number | undefined;

    constructor(data?: IUpdateDefaultCostCenterPurchaseOrdersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["defaultCostCenterPurchaseOrders"])) {
                this.defaultCostCenterPurchaseOrders = [] as any;
                for (let item of _data["defaultCostCenterPurchaseOrders"])
                    this.defaultCostCenterPurchaseOrders!.push(DefaultCostCenterPurchaseOrder.fromJS(item));
            }
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): UpdateDefaultCostCenterPurchaseOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDefaultCostCenterPurchaseOrdersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.defaultCostCenterPurchaseOrders)) {
            data["defaultCostCenterPurchaseOrders"] = [];
            for (let item of this.defaultCostCenterPurchaseOrders)
                data["defaultCostCenterPurchaseOrders"].push(item ? item.toJSON() : undefined as any);
        }
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IUpdateDefaultCostCenterPurchaseOrdersRequest {
    defaultCostCenterPurchaseOrders?: DefaultCostCenterPurchaseOrder[] | undefined;
    accountId?: number | undefined;
}

export class CreateGridFilterRequest implements ICreateGridFilterRequest {
    location?: string | undefined;
    filterName?: string | undefined;
    includeFiltersObject?: string | undefined;
    excludeFiltersObject?: string | undefined;
    generalFiltersObject?: string | undefined;
    isDefault?: boolean;

    constructor(data?: ICreateGridFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.filterName = _data["filterName"];
            this.includeFiltersObject = _data["includeFiltersObject"];
            this.excludeFiltersObject = _data["excludeFiltersObject"];
            this.generalFiltersObject = _data["generalFiltersObject"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): CreateGridFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGridFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["filterName"] = this.filterName;
        data["includeFiltersObject"] = this.includeFiltersObject;
        data["excludeFiltersObject"] = this.excludeFiltersObject;
        data["generalFiltersObject"] = this.generalFiltersObject;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ICreateGridFilterRequest {
    location?: string | undefined;
    filterName?: string | undefined;
    includeFiltersObject?: string | undefined;
    excludeFiltersObject?: string | undefined;
    generalFiltersObject?: string | undefined;
    isDefault?: boolean;
}

export class CreateRequestConsultationRequest implements ICreateRequestConsultationRequest {
    applicationContext!: string;

    constructor(data?: ICreateRequestConsultationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationContext = _data["applicationContext"];
        }
    }

    static fromJS(data: any): CreateRequestConsultationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestConsultationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationContext"] = this.applicationContext;
        return data;
    }
}

export interface ICreateRequestConsultationRequest {
    applicationContext: string;
}

export class CrmAccountTeamMember implements ICrmAccountTeamMember {
    contactId?: number | undefined;
    activeDirectoryId?: string | undefined;
    jobTitle?: string | undefined;
    systemUserId?: string | undefined;
    accountId?: number;
    source?: string | undefined;
    crmConnectionRoleId?: string | undefined;
    isAccountTeamLeadership?: boolean;

    constructor(data?: ICrmAccountTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.activeDirectoryId = _data["activeDirectoryId"];
            this.jobTitle = _data["jobTitle"];
            this.systemUserId = _data["systemUserId"];
            this.accountId = _data["accountId"];
            this.source = _data["source"];
            this.crmConnectionRoleId = _data["crmConnectionRoleId"];
            this.isAccountTeamLeadership = _data["isAccountTeamLeadership"];
        }
    }

    static fromJS(data: any): CrmAccountTeamMember {
        data = typeof data === 'object' ? data : {};
        let result = new CrmAccountTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["activeDirectoryId"] = this.activeDirectoryId;
        data["jobTitle"] = this.jobTitle;
        data["systemUserId"] = this.systemUserId;
        data["accountId"] = this.accountId;
        data["source"] = this.source;
        data["crmConnectionRoleId"] = this.crmConnectionRoleId;
        data["isAccountTeamLeadership"] = this.isAccountTeamLeadership;
        return data;
    }
}

export interface ICrmAccountTeamMember {
    contactId?: number | undefined;
    activeDirectoryId?: string | undefined;
    jobTitle?: string | undefined;
    systemUserId?: string | undefined;
    accountId?: number;
    source?: string | undefined;
    crmConnectionRoleId?: string | undefined;
    isAccountTeamLeadership?: boolean;
}

export class CrmShiConnectionRole implements ICrmShiConnectionRole {
    id?: number;
    crmConnectionRoleId?: string | undefined;
    crmConnectionRoleName?: string | undefined;
    enabled?: boolean;
    interfaceType?: CrmUserTypes;

    constructor(data?: ICrmShiConnectionRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crmConnectionRoleId = _data["crmConnectionRoleId"];
            this.crmConnectionRoleName = _data["crmConnectionRoleName"];
            this.enabled = _data["enabled"];
            this.interfaceType = _data["interfaceType"];
        }
    }

    static fromJS(data: any): CrmShiConnectionRole {
        data = typeof data === 'object' ? data : {};
        let result = new CrmShiConnectionRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crmConnectionRoleId"] = this.crmConnectionRoleId;
        data["crmConnectionRoleName"] = this.crmConnectionRoleName;
        data["enabled"] = this.enabled;
        data["interfaceType"] = this.interfaceType;
        return data;
    }
}

export interface ICrmShiConnectionRole {
    id?: number;
    crmConnectionRoleId?: string | undefined;
    crmConnectionRoleName?: string | undefined;
    enabled?: boolean;
    interfaceType?: CrmUserTypes;
}

export class CrmUserDetails implements ICrmUserDetails {
    id?: number;
    systemUserId?: string | undefined;
    shiReportingBuPath?: string | undefined;
    azureActiveDirectoryId?: string | undefined;
    parentSystemUserId?: string | undefined;
    fullName?: string | undefined;
    title?: string | undefined;
    emailAddress?: string | undefined;
    contactId?: number | undefined;
    contact?: Contact;
    crmConnectionRoleId?: string | undefined;
    crmRole?: CrmShiConnectionRole;
    accountTeamMember?: AccountTeamMember[] | undefined;

    constructor(data?: ICrmUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.systemUserId = _data["systemUserId"];
            this.shiReportingBuPath = _data["shiReportingBuPath"];
            this.azureActiveDirectoryId = _data["azureActiveDirectoryId"];
            this.parentSystemUserId = _data["parentSystemUserId"];
            this.fullName = _data["fullName"];
            this.title = _data["title"];
            this.emailAddress = _data["emailAddress"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : undefined as any;
            this.crmConnectionRoleId = _data["crmConnectionRoleId"];
            this.crmRole = _data["crmRole"] ? CrmShiConnectionRole.fromJS(_data["crmRole"]) : undefined as any;
            if (Array.isArray(_data["accountTeamMember"])) {
                this.accountTeamMember = [] as any;
                for (let item of _data["accountTeamMember"])
                    this.accountTeamMember!.push(AccountTeamMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CrmUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CrmUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["systemUserId"] = this.systemUserId;
        data["shiReportingBuPath"] = this.shiReportingBuPath;
        data["azureActiveDirectoryId"] = this.azureActiveDirectoryId;
        data["parentSystemUserId"] = this.parentSystemUserId;
        data["fullName"] = this.fullName;
        data["title"] = this.title;
        data["emailAddress"] = this.emailAddress;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["crmConnectionRoleId"] = this.crmConnectionRoleId;
        data["crmRole"] = this.crmRole ? this.crmRole.toJSON() : undefined as any;
        if (Array.isArray(this.accountTeamMember)) {
            data["accountTeamMember"] = [];
            for (let item of this.accountTeamMember)
                data["accountTeamMember"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICrmUserDetails {
    id?: number;
    systemUserId?: string | undefined;
    shiReportingBuPath?: string | undefined;
    azureActiveDirectoryId?: string | undefined;
    parentSystemUserId?: string | undefined;
    fullName?: string | undefined;
    title?: string | undefined;
    emailAddress?: string | undefined;
    contactId?: number | undefined;
    contact?: Contact;
    crmConnectionRoleId?: string | undefined;
    crmRole?: CrmShiConnectionRole;
    accountTeamMember?: AccountTeamMember[] | undefined;
}

export enum CrmUserTypes {
    None = "None",
    ISAM = "ISAM",
    ISAMLeadership = "ISAMLeadership",
}

export class AXAccountBillingUsersDTO implements IAXAccountBillingUsersDTO {
    name?: string | undefined;
    readonly emails?: string[] | undefined;
    readonly phoneNumbers?: string[] | undefined;

    constructor(data?: IAXAccountBillingUsersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["emails"])) {
                (this as any).emails = [] as any;
                for (let item of _data["emails"])
                    (this as any).emails!.push(item);
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                (this as any).phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    (this as any).phoneNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): AXAccountBillingUsersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AXAccountBillingUsersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }
}

export interface IAXAccountBillingUsersDTO {
    name?: string | undefined;
    emails?: string[] | undefined;
    phoneNumbers?: string[] | undefined;
}

export class AXAccountDetailsDTO implements IAXAccountDetailsDTO {
    axAccountNumber?: string | undefined;
    companyName?: string | undefined;
    paymentTerms?: string | undefined;

    constructor(data?: IAXAccountDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.companyName = _data["companyName"];
            this.paymentTerms = _data["paymentTerms"];
        }
    }

    static fromJS(data: any): AXAccountDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AXAccountDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["companyName"] = this.companyName;
        data["paymentTerms"] = this.paymentTerms;
        return data;
    }
}

export interface IAXAccountDetailsDTO {
    axAccountNumber?: string | undefined;
    companyName?: string | undefined;
    paymentTerms?: string | undefined;
}

export class AccountCRMAccountTeamSyncDTO implements IAccountCRMAccountTeamSyncDTO {
    id?: number;
    axNumber?: string | undefined;
    owningTeamId?: string | undefined;
    reportingBuId?: string | undefined;

    constructor(data?: IAccountCRMAccountTeamSyncDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.axNumber = _data["axNumber"];
            this.owningTeamId = _data["owningTeamId"];
            this.reportingBuId = _data["reportingBuId"];
        }
    }

    static fromJS(data: any): AccountCRMAccountTeamSyncDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCRMAccountTeamSyncDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["axNumber"] = this.axNumber;
        data["owningTeamId"] = this.owningTeamId;
        data["reportingBuId"] = this.reportingBuId;
        return data;
    }
}

export interface IAccountCRMAccountTeamSyncDTO {
    id?: number;
    axNumber?: string | undefined;
    owningTeamId?: string | undefined;
    reportingBuId?: string | undefined;
}

export class AccountWelcomeLinkDto implements IAccountWelcomeLinkDto {
    linkId?: string;
    email?: string | undefined;
    domain?: string[] | undefined;
    accountID?: number;
    completed?: boolean;
    microsoftSSOSelected?: boolean;
    microsoftSSOSuccessful?: boolean;
    userId?: string | undefined;

    constructor(data?: IAccountWelcomeLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkId = _data["linkId"];
            this.email = _data["email"];
            if (Array.isArray(_data["domain"])) {
                this.domain = [] as any;
                for (let item of _data["domain"])
                    this.domain!.push(item);
            }
            this.accountID = _data["accountID"];
            this.completed = _data["completed"];
            this.microsoftSSOSelected = _data["microsoftSSOSelected"];
            this.microsoftSSOSuccessful = _data["microsoftSSOSuccessful"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AccountWelcomeLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountWelcomeLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkId"] = this.linkId;
        data["email"] = this.email;
        if (Array.isArray(this.domain)) {
            data["domain"] = [];
            for (let item of this.domain)
                data["domain"].push(item);
        }
        data["accountID"] = this.accountID;
        data["completed"] = this.completed;
        data["microsoftSSOSelected"] = this.microsoftSSOSelected;
        data["microsoftSSOSuccessful"] = this.microsoftSSOSuccessful;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAccountWelcomeLinkDto {
    linkId?: string;
    email?: string | undefined;
    domain?: string[] | undefined;
    accountID?: number;
    completed?: boolean;
    microsoftSSOSelected?: boolean;
    microsoftSSOSuccessful?: boolean;
    userId?: string | undefined;
}

export class IntegrationDTO implements IIntegrationDTO {
    id?: number;
    accountId?: number;
    axAccountNumber?: string | undefined;
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    activated?: boolean;
    metadata?: IntegrationMetadata | undefined;
    lastSuccessfulCheckDateTime?: Date | undefined;
    lastFailedCheckDateTime?: Date | undefined;
    lastExceptionMessage?: string | undefined;
    statusMessage?: string | undefined;
    statusMessageDateTime?: Date | undefined;
    status?: IntegrationStatus;

    protected _discriminator: string;

    constructor(data?: IIntegrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "IntegrationDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.axAccountNumber = _data["axAccountNumber"];
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.activated = _data["activated"];
            this.metadata = _data["metadata"] ? IntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
            this.lastSuccessfulCheckDateTime = _data["lastSuccessfulCheckDateTime"] ? new Date(_data["lastSuccessfulCheckDateTime"].toString()) : undefined as any;
            this.lastFailedCheckDateTime = _data["lastFailedCheckDateTime"] ? new Date(_data["lastFailedCheckDateTime"].toString()) : undefined as any;
            this.lastExceptionMessage = _data["lastExceptionMessage"];
            this.statusMessage = _data["statusMessage"];
            this.statusMessageDateTime = _data["statusMessageDateTime"] ? new Date(_data["statusMessageDateTime"].toString()) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): IntegrationDTO {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "GcpUsageReportIntegrationDTO") {
            let result = new GcpUsageReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureAssetIntegrationDTO") {
            let result = new AzureAssetIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureCostAndUsageIntegrationDTO") {
            let result = new AzureCostAndUsageIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "Microsoft365ReportsIntegrationDTO") {
            let result = new Microsoft365ReportsIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AssetManagementDto") {
            let result = new AssetManagementDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsBillingReportIntegrationDTO") {
            let result = new AwsBillingReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsComplianceIntegrationDTO") {
            let result = new AwsComplianceIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsGovernanceReportsDto") {
            let result = new AwsGovernanceReportsDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsResourceExplorerIntegrationDTO") {
            let result = new AwsResourceExplorerIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsSimpleRecommendationsIntegrationDTO") {
            let result = new AwsSimpleRecommendationsIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureBackupsIntegrationDTO") {
            let result = new AzureBackupsIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureComplianceIntegrationDTO") {
            let result = new AzureComplianceIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureDevOpsReportIntegrationDTO") {
            let result = new AzureDevOpsReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureDirectConsumptionIntegrationDTO") {
            let result = new AzureDirectConsumptionIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureGovernanceReportsDto") {
            let result = new AzureGovernanceReportsDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzurePlanReportIntegrationDTO") {
            let result = new AzurePlanReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureResourceGraphIntegrationDTO") {
            let result = new AzureResourceGraphIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AzureSimpleRecommendationsIntegrationDTO") {
            let result = new AzureSimpleRecommendationsIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoContractCoverageIntegrationDTO") {
            let result = new CiscoContractCoverageIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoCxCloudIntegrationDTO") {
            let result = new CiscoCxCloudIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoSNTCIntegrationDTO") {
            let result = new CiscoSNTCIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoEnterpriseAgreementIntegrationDTO") {
            let result = new CiscoEnterpriseAgreementIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoMerakiCustomerIntegrationDto") {
            let result = new CiscoMerakiCustomerIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoMerakiIntegrationDTO") {
            let result = new CiscoMerakiIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoReadyReportIntegrationDTO") {
            let result = new CiscoReadyReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CiscoSubscriptionManagementIntegrationDTO") {
            let result = new CiscoSubscriptionManagementIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DatadogUsageReportIntegrationDTO") {
            let result = new DatadogUsageReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DattoRMMIntegrationDTO") {
            let result = new DattoRMMIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "GcpCloudAssetInventoryIntegrationDTO") {
            let result = new GcpCloudAssetInventoryIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "HardwareLifecycleManagementIntegrationDTO") {
            let result = new HardwareLifecycleManagementIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "IdcsReportIntegrationDTO") {
            let result = new IdcsReportIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "MicrosoftInsightsIntegrationDTO") {
            let result = new MicrosoftInsightsIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "RackAndStackIntegrationDTO") {
            let result = new RackAndStackIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "SelfServiceReportingIntegrationDto") {
            let result = new SelfServiceReportingIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "WarehousePickOrderDTO") {
            let result = new WarehousePickOrderDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AiReadinessIntegrationDto") {
            let result = new AiReadinessIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AssessmentIntegrationDto") {
            let result = new AssessmentIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsMaturityAssessmentIntegrationDto") {
            let result = new AwsMaturityAssessmentIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DevOpsPostureReviewIntegrationDto") {
            let result = new DevOpsPostureReviewIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "MicrosoftAdoptionIntegrationDto") {
            let result = new MicrosoftAdoptionIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "SecurityPostureReviewIntegrationDto") {
            let result = new SecurityPostureReviewIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "TpxIntegrationDto") {
            let result = new TpxIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "CatalystIntegrationDTO") {
            let result = new CatalystIntegrationDTO();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "InstallBaseAnalysisDto") {
            let result = new InstallBaseAnalysisDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "LiveOpticsIntegrationDto") {
            let result = new LiveOpticsIntegrationDto();
            result.init(data);
            return result;
        }
        let result = new IntegrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["axAccountNumber"] = this.axAccountNumber;
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["activated"] = this.activated;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        data["lastSuccessfulCheckDateTime"] = this.lastSuccessfulCheckDateTime ? this.lastSuccessfulCheckDateTime.toISOString() : undefined as any;
        data["lastFailedCheckDateTime"] = this.lastFailedCheckDateTime ? this.lastFailedCheckDateTime.toISOString() : undefined as any;
        data["lastExceptionMessage"] = this.lastExceptionMessage;
        data["statusMessage"] = this.statusMessage;
        data["statusMessageDateTime"] = this.statusMessageDateTime ? this.statusMessageDateTime.toISOString() : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IIntegrationDTO {
    id?: number;
    accountId?: number;
    axAccountNumber?: string | undefined;
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    activated?: boolean;
    metadata?: IntegrationMetadata | undefined;
    lastSuccessfulCheckDateTime?: Date | undefined;
    lastFailedCheckDateTime?: Date | undefined;
    lastExceptionMessage?: string | undefined;
    statusMessage?: string | undefined;
    statusMessageDateTime?: Date | undefined;
    status?: IntegrationStatus;
}

export class AssetManagementDto extends IntegrationDTO implements IAssetManagementDto {
    integrationType?: IntegrationType;

    constructor(data?: IAssetManagementDto) {
        super(data);
        this._discriminator = "AssetManagementDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AssetManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetManagementDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetManagementDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
}

export class AwsBillingReportIntegrationDTO extends IntegrationDTO implements IAwsBillingReportIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: AwsBillingReportIntegrationMetadata;

    constructor(data?: IAwsBillingReportIntegrationDTO) {
        super(data);
        this._discriminator = "AwsBillingReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? AwsBillingReportIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AwsBillingReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AwsBillingReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsBillingReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: AwsBillingReportIntegrationMetadata;
}

export class AwsComplianceIntegrationDTO extends IntegrationDTO implements IAwsComplianceIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AwsComplianceIntegrationMetadata;

    constructor(data?: IAwsComplianceIntegrationDTO) {
        super(data);
        this._discriminator = "AwsComplianceIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AwsComplianceIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AwsComplianceIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AwsComplianceIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsComplianceIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AwsComplianceIntegrationMetadata;
}

export class AwsGovernanceReportsDto extends IntegrationDTO implements IAwsGovernanceReportsDto {
    integrationType?: IntegrationType;

    constructor(data?: IAwsGovernanceReportsDto) {
        super(data);
        this._discriminator = "AwsGovernanceReportsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AwsGovernanceReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwsGovernanceReportsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsGovernanceReportsDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
}

export class AwsResourceExplorerIntegrationDTO extends IntegrationDTO implements IAwsResourceExplorerIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: AwsResourceExplorerMetadata;

    constructor(data?: IAwsResourceExplorerIntegrationDTO) {
        super(data);
        this._discriminator = "AwsResourceExplorerIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? AwsResourceExplorerMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AwsResourceExplorerIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AwsResourceExplorerIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsResourceExplorerIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: AwsResourceExplorerMetadata;
}

export class AwsSimpleRecommendationsIntegrationDTO extends IntegrationDTO implements IAwsSimpleRecommendationsIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AwsSimpleRecommendationsIntegrationMetadata;

    constructor(data?: IAwsSimpleRecommendationsIntegrationDTO) {
        super(data);
        this._discriminator = "AwsSimpleRecommendationsIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AwsSimpleRecommendationsIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AwsSimpleRecommendationsIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AwsSimpleRecommendationsIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsSimpleRecommendationsIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AwsSimpleRecommendationsIntegrationMetadata;
}

export class AzureBackupsIntegrationDTO extends IntegrationDTO implements IAzureBackupsIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureBackupsIntegrationDTO) {
        super(data);
        this._discriminator = "AzureBackupsIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AzureBackupsIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureBackupsIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureBackupsIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class AzureComplianceIntegrationDTO extends IntegrationDTO implements IAzureComplianceIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureComplianceIntegrationDTO) {
        super(data);
        this._discriminator = "AzureComplianceIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AzureComplianceIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureComplianceIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureComplianceIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class AzureDevOpsReportIntegrationDTO extends IntegrationDTO implements IAzureDevOpsReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureDevOpsReportIntegrationMetadata;

    constructor(data?: IAzureDevOpsReportIntegrationDTO) {
        super(data);
        this._discriminator = "AzureDevOpsReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureDevOpsReportIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AzureDevOpsReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureDevOpsReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureDevOpsReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureDevOpsReportIntegrationMetadata;
}

export class AzureDirectConsumptionIntegrationDTO extends IntegrationDTO implements IAzureDirectConsumptionIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureDirectConsumptionIntegrationDTO) {
        super(data);
        this._discriminator = "AzureDirectConsumptionIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AzureDirectConsumptionIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureDirectConsumptionIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureDirectConsumptionIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class AzureGovernanceReportsDto extends IntegrationDTO implements IAzureGovernanceReportsDto {
    integrationType?: IntegrationType;

    constructor(data?: IAzureGovernanceReportsDto) {
        super(data);
        this._discriminator = "AzureGovernanceReportsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AzureGovernanceReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureGovernanceReportsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureGovernanceReportsDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
}

export class AzurePlanReportIntegrationDTO extends IntegrationDTO implements IAzurePlanReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzurePlanReportIntegrationMetadata;

    constructor(data?: IAzurePlanReportIntegrationDTO) {
        super(data);
        this._discriminator = "AzurePlanReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzurePlanReportIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AzurePlanReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzurePlanReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzurePlanReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzurePlanReportIntegrationMetadata;
}

export class AzureResourceGraphIntegrationDTO extends IntegrationDTO implements IAzureResourceGraphIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureResourceGraphIntegrationDTO) {
        super(data);
        this._discriminator = "AzureResourceGraphIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AzureResourceGraphIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureResourceGraphIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureResourceGraphIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class AzureSimpleRecommendationsIntegrationDTO extends IntegrationDTO implements IAzureSimpleRecommendationsIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;

    constructor(data?: IAzureSimpleRecommendationsIntegrationDTO) {
        super(data);
        this._discriminator = "AzureSimpleRecommendationsIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AzureSimpleRecommendationsIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSimpleRecommendationsIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureSimpleRecommendationsIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureIntegrationMetadata;
}

export class BasicCiscoEAIntegrationDTO implements IBasicCiscoEAIntegrationDTO {
    smartAccountDomain?: string | undefined;
    existingSmartAccountDomain?: string | undefined;

    constructor(data?: IBasicCiscoEAIntegrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smartAccountDomain = _data["smartAccountDomain"];
            this.existingSmartAccountDomain = _data["existingSmartAccountDomain"];
        }
    }

    static fromJS(data: any): BasicCiscoEAIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BasicCiscoEAIntegrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smartAccountDomain"] = this.smartAccountDomain;
        data["existingSmartAccountDomain"] = this.existingSmartAccountDomain;
        return data;
    }
}

export interface IBasicCiscoEAIntegrationDTO {
    smartAccountDomain?: string | undefined;
    existingSmartAccountDomain?: string | undefined;
}

export class BasicCiscoSNTCIntegrationDTO implements IBasicCiscoSNTCIntegrationDTO {
    customerId?: string | undefined;
    existingId?: string | undefined;

    constructor(data?: IBasicCiscoSNTCIntegrationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.existingId = _data["existingId"];
        }
    }

    static fromJS(data: any): BasicCiscoSNTCIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BasicCiscoSNTCIntegrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["existingId"] = this.existingId;
        return data;
    }
}

export interface IBasicCiscoSNTCIntegrationDTO {
    customerId?: string | undefined;
    existingId?: string | undefined;
}

export class BillingItemMetadataDto implements IBillingItemMetadataDto {
    id?: number;
    itemDate?: Date;

    constructor(data?: IBillingItemMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemDate = _data["itemDate"] ? new Date(_data["itemDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BillingItemMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingItemMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemDate"] = this.itemDate ? this.itemDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IBillingItemMetadataDto {
    id?: number;
    itemDate?: Date;
}

export class CiscoContractCoverageIntegrationDTO extends IntegrationDTO implements ICiscoContractCoverageIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoContractCoverageIntegrationMetadata;

    constructor(data?: ICiscoContractCoverageIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoContractCoverageIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoContractCoverageIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CiscoContractCoverageIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoContractCoverageIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoContractCoverageIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoContractCoverageIntegrationMetadata;
}

export class CiscoSNTCIntegrationDTO extends IntegrationDTO implements ICiscoSNTCIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoSNTCIntegrationMetadata;

    protected _discriminator: string;

    constructor(data?: ICiscoSNTCIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoSNTCIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoSNTCIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CiscoSNTCIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "CiscoCxCloudIntegrationDTO") {
            let result = new CiscoCxCloudIntegrationDTO();
            result.init(data);
            return result;
        }
        let result = new CiscoSNTCIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoSNTCIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoSNTCIntegrationMetadata;
}

export class CiscoCxCloudIntegrationDTO extends CiscoSNTCIntegrationDTO implements ICiscoCxCloudIntegrationDTO {
    integrationType?: IntegrationType;

    constructor(data?: ICiscoCxCloudIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoCxCloudIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): CiscoCxCloudIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoCxCloudIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoCxCloudIntegrationDTO extends ICiscoSNTCIntegrationDTO {
    integrationType?: IntegrationType;
}

export class CiscoEnterpriseAgreementIntegrationDTO extends IntegrationDTO implements ICiscoEnterpriseAgreementIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoEnterpriseAgreementMetadata;

    constructor(data?: ICiscoEnterpriseAgreementIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoEnterpriseAgreementIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoEnterpriseAgreementMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CiscoEnterpriseAgreementIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoEnterpriseAgreementIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoEnterpriseAgreementIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoEnterpriseAgreementMetadata;
}

export class CiscoMerakiCustomerIntegrationDto extends IntegrationDTO implements ICiscoMerakiCustomerIntegrationDto {
    integrationType?: IntegrationType;
    metadata?: CiscoMerakiCustomerMetadata;

    constructor(data?: ICiscoMerakiCustomerIntegrationDto) {
        super(data);
        this._discriminator = "CiscoMerakiCustomerIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? CiscoMerakiCustomerMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CiscoMerakiCustomerIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoMerakiCustomerIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoMerakiCustomerIntegrationDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: CiscoMerakiCustomerMetadata;
}

export class CiscoMerakiIntegrationDTO extends IntegrationDTO implements ICiscoMerakiIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoMerakiIntegrationMetadata;

    constructor(data?: ICiscoMerakiIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoMerakiIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoMerakiIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CiscoMerakiIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoMerakiIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoMerakiIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoMerakiIntegrationMetadata;
}

export class CiscoReadyReportIntegrationDTO extends IntegrationDTO implements ICiscoReadyReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoReadyReportIntegrationMetadata;

    constructor(data?: ICiscoReadyReportIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoReadyReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoReadyReportIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CiscoReadyReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoReadyReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoReadyReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoReadyReportIntegrationMetadata;
}

export class CiscoSubscriptionManagementIntegrationDTO extends IntegrationDTO implements ICiscoSubscriptionManagementIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: CiscoSubscriptionManagementIntegrationMetadata;

    constructor(data?: ICiscoSubscriptionManagementIntegrationDTO) {
        super(data);
        this._discriminator = "CiscoSubscriptionManagementIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? CiscoSubscriptionManagementIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CiscoSubscriptionManagementIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoSubscriptionManagementIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICiscoSubscriptionManagementIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: CiscoSubscriptionManagementIntegrationMetadata;
}

export class CloudAccountDTO implements ICloudAccountDTO {
    cloudAccountName?: string | undefined;
    cloud?: string | undefined;
    cloudAccountStatus?: string | undefined;
    cloudAccountCreateDate?: Date;
    cloudAccountId?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    serviceLevel?: string | undefined;
    licenseCount?: number;
    account?: Account;
    contractId?: number;
    configurationItemId?: number;
    costCenterId?: number | undefined;
    costCenterName?: string | undefined;
    allocatedLicenseCount?: number | undefined;

    constructor(data?: ICloudAccountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloud = _data["cloud"];
            this.cloudAccountStatus = _data["cloudAccountStatus"];
            this.cloudAccountCreateDate = _data["cloudAccountCreateDate"] ? new Date(_data["cloudAccountCreateDate"].toString()) : undefined as any;
            this.cloudAccountId = _data["cloudAccountId"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.serviceLevel = _data["serviceLevel"];
            this.licenseCount = _data["licenseCount"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : undefined as any;
            this.contractId = _data["contractId"];
            this.configurationItemId = _data["configurationItemId"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.allocatedLicenseCount = _data["allocatedLicenseCount"];
        }
    }

    static fromJS(data: any): CloudAccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloud"] = this.cloud;
        data["cloudAccountStatus"] = this.cloudAccountStatus;
        data["cloudAccountCreateDate"] = this.cloudAccountCreateDate ? this.cloudAccountCreateDate.toISOString() : undefined as any;
        data["cloudAccountId"] = this.cloudAccountId;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["serviceLevel"] = this.serviceLevel;
        data["licenseCount"] = this.licenseCount;
        data["account"] = this.account ? this.account.toJSON() : undefined as any;
        data["contractId"] = this.contractId;
        data["configurationItemId"] = this.configurationItemId;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["allocatedLicenseCount"] = this.allocatedLicenseCount;
        return data;
    }
}

export interface ICloudAccountDTO {
    cloudAccountName?: string | undefined;
    cloud?: string | undefined;
    cloudAccountStatus?: string | undefined;
    cloudAccountCreateDate?: Date;
    cloudAccountId?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    serviceLevel?: string | undefined;
    licenseCount?: number;
    account?: Account;
    contractId?: number;
    configurationItemId?: number;
    costCenterId?: number | undefined;
    costCenterName?: string | undefined;
    allocatedLicenseCount?: number | undefined;
}

export class CloudAccountV2Dto implements ICloudAccountV2Dto {
    parent?: string | undefined;
    cloudAccountName?: string | undefined;
    cloudPlatform?: string | undefined;
    cloudAccountId?: string | undefined;
    type?: string | undefined;
    shiSupportLevel?: string | undefined;
    vendorSupportLevel?: string | undefined;
    currentConsumption?: CloudConsumptionDto;
    monthlyConsumption?: MonthlyCloudConsumptionDto;
    availableActions?: string[] | undefined;
    ownerId?: string | undefined;
    created?: string | undefined;
    contractId?: number;
    configurationItemId?: number;
    itemQuantity?: number | undefined;
    unitType?: string | undefined;
    licensesUsed?: number | undefined;
    licensesAvailable?: number | undefined;
    costCenterId?: number | undefined;
    costCenterName?: string | undefined;
    allocatedLicenseCount?: number | undefined;
    costCenterPO?: string | undefined;
    accountId?: number | undefined;
    axNumber?: string | undefined;
    accountName?: string | undefined;
    renewalDate?: Date | undefined;
    autoRenewEnabled?: boolean | undefined;
    billingCycle?: string | undefined;
    renewalDisplay?: string | undefined;

    constructor(data?: ICloudAccountV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent = _data["parent"];
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloudPlatform = _data["cloudPlatform"];
            this.cloudAccountId = _data["cloudAccountId"];
            this.type = _data["type"];
            this.shiSupportLevel = _data["shiSupportLevel"];
            this.vendorSupportLevel = _data["vendorSupportLevel"];
            this.currentConsumption = _data["currentConsumption"] ? CloudConsumptionDto.fromJS(_data["currentConsumption"]) : undefined as any;
            this.monthlyConsumption = _data["monthlyConsumption"] ? MonthlyCloudConsumptionDto.fromJS(_data["monthlyConsumption"]) : undefined as any;
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.ownerId = _data["ownerId"];
            this.created = _data["created"];
            this.contractId = _data["contractId"];
            this.configurationItemId = _data["configurationItemId"];
            this.itemQuantity = _data["itemQuantity"];
            this.unitType = _data["unitType"];
            this.licensesUsed = _data["licensesUsed"];
            this.licensesAvailable = _data["licensesAvailable"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.allocatedLicenseCount = _data["allocatedLicenseCount"];
            this.costCenterPO = _data["costCenterPO"];
            this.accountId = _data["accountId"];
            this.axNumber = _data["axNumber"];
            this.accountName = _data["accountName"];
            this.renewalDate = _data["renewalDate"] ? new Date(_data["renewalDate"].toString()) : undefined as any;
            this.autoRenewEnabled = _data["autoRenewEnabled"];
            this.billingCycle = _data["billingCycle"];
            this.renewalDisplay = _data["renewalDisplay"];
        }
    }

    static fromJS(data: any): CloudAccountV2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAccountV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent"] = this.parent;
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloudPlatform"] = this.cloudPlatform;
        data["cloudAccountId"] = this.cloudAccountId;
        data["type"] = this.type;
        data["shiSupportLevel"] = this.shiSupportLevel;
        data["vendorSupportLevel"] = this.vendorSupportLevel;
        data["currentConsumption"] = this.currentConsumption ? this.currentConsumption.toJSON() : undefined as any;
        data["monthlyConsumption"] = this.monthlyConsumption ? this.monthlyConsumption.toJSON() : undefined as any;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["ownerId"] = this.ownerId;
        data["created"] = this.created;
        data["contractId"] = this.contractId;
        data["configurationItemId"] = this.configurationItemId;
        data["itemQuantity"] = this.itemQuantity;
        data["unitType"] = this.unitType;
        data["licensesUsed"] = this.licensesUsed;
        data["licensesAvailable"] = this.licensesAvailable;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["allocatedLicenseCount"] = this.allocatedLicenseCount;
        data["costCenterPO"] = this.costCenterPO;
        data["accountId"] = this.accountId;
        data["axNumber"] = this.axNumber;
        data["accountName"] = this.accountName;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : undefined as any;
        data["autoRenewEnabled"] = this.autoRenewEnabled;
        data["billingCycle"] = this.billingCycle;
        data["renewalDisplay"] = this.renewalDisplay;
        return data;
    }
}

export interface ICloudAccountV2Dto {
    parent?: string | undefined;
    cloudAccountName?: string | undefined;
    cloudPlatform?: string | undefined;
    cloudAccountId?: string | undefined;
    type?: string | undefined;
    shiSupportLevel?: string | undefined;
    vendorSupportLevel?: string | undefined;
    currentConsumption?: CloudConsumptionDto;
    monthlyConsumption?: MonthlyCloudConsumptionDto;
    availableActions?: string[] | undefined;
    ownerId?: string | undefined;
    created?: string | undefined;
    contractId?: number;
    configurationItemId?: number;
    itemQuantity?: number | undefined;
    unitType?: string | undefined;
    licensesUsed?: number | undefined;
    licensesAvailable?: number | undefined;
    costCenterId?: number | undefined;
    costCenterName?: string | undefined;
    allocatedLicenseCount?: number | undefined;
    costCenterPO?: string | undefined;
    accountId?: number | undefined;
    axNumber?: string | undefined;
    accountName?: string | undefined;
    renewalDate?: Date | undefined;
    autoRenewEnabled?: boolean | undefined;
    billingCycle?: string | undefined;
    renewalDisplay?: string | undefined;
}

export class CloudAssetsWidgetDto implements ICloudAssetsWidgetDto {
    name?: string | undefined;
    count?: number;

    constructor(data?: ICloudAssetsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CloudAssetsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAssetsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }
}

export interface ICloudAssetsWidgetDto {
    name?: string | undefined;
    count?: number;
}

export class CloudConsumptionHistoryDto implements ICloudConsumptionHistoryDto {
    monthStart?: Date;
    monthlyProviderAmount?: { [key: string]: number; } | undefined;

    constructor(data?: ICloudConsumptionHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthStart = _data["monthStart"] ? new Date(_data["monthStart"].toString()) : undefined as any;
            if (_data["monthlyProviderAmount"]) {
                this.monthlyProviderAmount = {} as any;
                for (let key in _data["monthlyProviderAmount"]) {
                    if (_data["monthlyProviderAmount"].hasOwnProperty(key))
                        (this.monthlyProviderAmount as any)![key] = _data["monthlyProviderAmount"][key];
                }
            }
        }
    }

    static fromJS(data: any): CloudConsumptionHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudConsumptionHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthStart"] = this.monthStart ? this.monthStart.toISOString() : undefined as any;
        if (this.monthlyProviderAmount) {
            data["monthlyProviderAmount"] = {};
            for (let key in this.monthlyProviderAmount) {
                if (this.monthlyProviderAmount.hasOwnProperty(key))
                    (data["monthlyProviderAmount"] as any)[key] = (this.monthlyProviderAmount as any)[key];
            }
        }
        return data;
    }
}

export interface ICloudConsumptionHistoryDto {
    monthStart?: Date;
    monthlyProviderAmount?: { [key: string]: number; } | undefined;
}

export class ConfigurationItemDTO implements IConfigurationItemDTO {
    id?: number;
    accountID?: number;
    productID?: number | undefined;
    productName?: string | undefined;
    contractID?: number | undefined;
    type?: number;
    rmmDeviceAuditModelID?: number | undefined;
    rmmDeviceAuditHostname?: string | undefined;
    installDate?: Date;
    contactID?: number | undefined;
    rmmDeviceAuditLastUser?: string | undefined;
    rmmDeviceAuditMissingPatchCount?: number | undefined;
    rmmDeviceID?: number | undefined;
    imageUrl?: string | undefined;
    serialNumber?: string | undefined;
    rmmDeviceUID?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IConfigurationItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ConfigurationItemDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountID = _data["accountID"];
            this.productID = _data["productID"];
            this.productName = _data["productName"];
            this.contractID = _data["contractID"];
            this.type = _data["type"];
            this.rmmDeviceAuditModelID = _data["rmmDeviceAuditModelID"];
            this.rmmDeviceAuditHostname = _data["rmmDeviceAuditHostname"];
            this.installDate = _data["installDate"] ? new Date(_data["installDate"].toString()) : undefined as any;
            this.contactID = _data["contactID"];
            this.rmmDeviceAuditLastUser = _data["rmmDeviceAuditLastUser"];
            this.rmmDeviceAuditMissingPatchCount = _data["rmmDeviceAuditMissingPatchCount"];
            this.rmmDeviceID = _data["rmmDeviceID"];
            this.imageUrl = _data["imageUrl"];
            this.serialNumber = _data["serialNumber"];
            this.rmmDeviceUID = _data["rmmDeviceUID"];
        }
    }

    static fromJS(data: any): ConfigurationItemDTO {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "DattoRmmConfigurationItemDTO") {
            let result = new DattoRmmConfigurationItemDTO();
            result.init(data);
            return result;
        }
        let result = new ConfigurationItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["id"] = this.id;
        data["accountID"] = this.accountID;
        data["productID"] = this.productID;
        data["productName"] = this.productName;
        data["contractID"] = this.contractID;
        data["type"] = this.type;
        data["rmmDeviceAuditModelID"] = this.rmmDeviceAuditModelID;
        data["rmmDeviceAuditHostname"] = this.rmmDeviceAuditHostname;
        data["installDate"] = this.installDate ? this.installDate.toISOString() : undefined as any;
        data["contactID"] = this.contactID;
        data["rmmDeviceAuditLastUser"] = this.rmmDeviceAuditLastUser;
        data["rmmDeviceAuditMissingPatchCount"] = this.rmmDeviceAuditMissingPatchCount;
        data["rmmDeviceID"] = this.rmmDeviceID;
        data["imageUrl"] = this.imageUrl;
        data["serialNumber"] = this.serialNumber;
        data["rmmDeviceUID"] = this.rmmDeviceUID;
        return data;
    }
}

export interface IConfigurationItemDTO {
    id?: number;
    accountID?: number;
    productID?: number | undefined;
    productName?: string | undefined;
    contractID?: number | undefined;
    type?: number;
    rmmDeviceAuditModelID?: number | undefined;
    rmmDeviceAuditHostname?: string | undefined;
    installDate?: Date;
    contactID?: number | undefined;
    rmmDeviceAuditLastUser?: string | undefined;
    rmmDeviceAuditMissingPatchCount?: number | undefined;
    rmmDeviceID?: number | undefined;
    imageUrl?: string | undefined;
    serialNumber?: string | undefined;
    rmmDeviceUID?: string | undefined;
}

export class ContractFilterOptionDto implements IContractFilterOptionDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IContractFilterOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ContractFilterOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractFilterOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IContractFilterOptionDto {
    id?: number;
    name?: string | undefined;
}

export class CostCenterAccountDto implements ICostCenterAccountDto {
    id?: number;
    name!: string | undefined;
    axNumber!: string | undefined;

    constructor(data?: ICostCenterAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.axNumber = _data["axNumber"];
        }
    }

    static fromJS(data: any): CostCenterAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["axNumber"] = this.axNumber;
        return data;
    }
}

export interface ICostCenterAccountDto {
    id?: number;
    name: string | undefined;
    axNumber: string | undefined;
}

export class CostCenterDTO implements ICostCenterDTO {
    id?: number;
    accountId?: number;
    accountName?: string | undefined;
    axNumber?: string | undefined;
    costCenterId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    poNumber?: string | undefined;
    isUnallocated?: boolean;

    constructor(data?: ICostCenterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.axNumber = _data["axNumber"];
            this.costCenterId = _data["costCenterId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.poNumber = _data["poNumber"];
            this.isUnallocated = _data["isUnallocated"];
        }
    }

    static fromJS(data: any): CostCenterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["axNumber"] = this.axNumber;
        data["costCenterId"] = this.costCenterId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["poNumber"] = this.poNumber;
        data["isUnallocated"] = this.isUnallocated;
        return data;
    }
}

export interface ICostCenterDTO {
    id?: number;
    accountId?: number;
    accountName?: string | undefined;
    axNumber?: string | undefined;
    costCenterId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    poNumber?: string | undefined;
    isUnallocated?: boolean;
}

/** Signatory details for creating a Microsoft Customer Agreement signing link. Values are trimmed on binding. Rules match the Review and Sign form (attestationSignatory.ts); invalid input is rejected, never rewritten. */
export class CreateAttestationLinkRequest implements ICreateAttestationLinkRequest {
    firstName!: string;
    lastName!: string;
    email!: string;
    phoneNumber!: string;

    constructor(data?: ICreateAttestationLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateAttestationLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttestationLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

/** Signatory details for creating a Microsoft Customer Agreement signing link. Values are trimmed on binding. Rules match the Review and Sign form (attestationSignatory.ts); invalid input is rejected, never rewritten. */
export interface ICreateAttestationLinkRequest {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
}

export class DatadogUsageReportIntegrationDTO extends IntegrationDTO implements IDatadogUsageReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: DatadogUsageReportIntegrationMetadata;

    constructor(data?: IDatadogUsageReportIntegrationDTO) {
        super(data);
        this._discriminator = "DatadogUsageReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? DatadogUsageReportIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): DatadogUsageReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DatadogUsageReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDatadogUsageReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: DatadogUsageReportIntegrationMetadata;
}

export class DattoRMMIntegrationDTO extends IntegrationDTO implements IDattoRMMIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: DattoRMMIntegrationMetadata;

    constructor(data?: IDattoRMMIntegrationDTO) {
        super(data);
        this._discriminator = "DattoRMMIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? DattoRMMIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): DattoRMMIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRMMIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDattoRMMIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: DattoRMMIntegrationMetadata;
}

export class DattoRmmConfigurationItemDTO extends ConfigurationItemDTO implements IDattoRmmConfigurationItemDTO {
    rebootStatus?: string | undefined;
    antiVirusStatus?: string | undefined;
    patchStatus?: string | undefined;
    contactName?: string | undefined;
    lastSeen?: number;

    constructor(data?: IDattoRmmConfigurationItemDTO) {
        super(data);
        this._discriminator = "DattoRmmConfigurationItemDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rebootStatus = _data["rebootStatus"];
            this.antiVirusStatus = _data["antiVirusStatus"];
            this.patchStatus = _data["patchStatus"];
            this.contactName = _data["contactName"];
            this.lastSeen = _data["lastSeen"];
        }
    }

    static override fromJS(data: any): DattoRmmConfigurationItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRmmConfigurationItemDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rebootStatus"] = this.rebootStatus;
        data["antiVirusStatus"] = this.antiVirusStatus;
        data["patchStatus"] = this.patchStatus;
        data["contactName"] = this.contactName;
        data["lastSeen"] = this.lastSeen;
        super.toJSON(data);
        return data;
    }
}

export interface IDattoRmmConfigurationItemDTO extends IConfigurationItemDTO {
    rebootStatus?: string | undefined;
    antiVirusStatus?: string | undefined;
    patchStatus?: string | undefined;
    contactName?: string | undefined;
    lastSeen?: number;
}

export class FlexibleServicesAgreementDTO implements IFlexibleServicesAgreementDTO {
    contractId?: number;
    contractTitle?: string | undefined;
    purchasedBilled?: number;
    purchasedAll?: number;
    consumedBilled?: number;
    hoursSpent?: number;
    retainerPurchases?: RetainerPurchaseDTO[] | undefined;
    endDate?: Date;

    constructor(data?: IFlexibleServicesAgreementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contractTitle = _data["contractTitle"];
            this.purchasedBilled = _data["purchasedBilled"];
            this.purchasedAll = _data["purchasedAll"];
            this.consumedBilled = _data["consumedBilled"];
            this.hoursSpent = _data["hoursSpent"];
            if (Array.isArray(_data["retainerPurchases"])) {
                this.retainerPurchases = [] as any;
                for (let item of _data["retainerPurchases"])
                    this.retainerPurchases!.push(RetainerPurchaseDTO.fromJS(item));
            }
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FlexibleServicesAgreementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FlexibleServicesAgreementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contractTitle"] = this.contractTitle;
        data["purchasedBilled"] = this.purchasedBilled;
        data["purchasedAll"] = this.purchasedAll;
        data["consumedBilled"] = this.consumedBilled;
        data["hoursSpent"] = this.hoursSpent;
        if (Array.isArray(this.retainerPurchases)) {
            data["retainerPurchases"] = [];
            for (let item of this.retainerPurchases)
                data["retainerPurchases"].push(item ? item.toJSON() : undefined as any);
        }
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IFlexibleServicesAgreementDTO {
    contractId?: number;
    contractTitle?: string | undefined;
    purchasedBilled?: number;
    purchasedAll?: number;
    consumedBilled?: number;
    hoursSpent?: number;
    retainerPurchases?: RetainerPurchaseDTO[] | undefined;
    endDate?: Date;
}

export class GcpCloudAssetInventoryIntegrationDTO extends IntegrationDTO implements IGcpCloudAssetInventoryIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: GcpCloudAssetInventoryMetadata;

    constructor(data?: IGcpCloudAssetInventoryIntegrationDTO) {
        super(data);
        this._discriminator = "GcpCloudAssetInventoryIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? GcpCloudAssetInventoryMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GcpCloudAssetInventoryIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GcpCloudAssetInventoryIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGcpCloudAssetInventoryIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: GcpCloudAssetInventoryMetadata;
}

export class GetCloudConsumptionHistoryResponse implements IGetCloudConsumptionHistoryResponse {
    cloudConsumptionHistory?: CloudConsumptionHistoryDto[] | undefined;

    constructor(data?: IGetCloudConsumptionHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cloudConsumptionHistory"])) {
                this.cloudConsumptionHistory = [] as any;
                for (let item of _data["cloudConsumptionHistory"])
                    this.cloudConsumptionHistory!.push(CloudConsumptionHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCloudConsumptionHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCloudConsumptionHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cloudConsumptionHistory)) {
            data["cloudConsumptionHistory"] = [];
            for (let item of this.cloudConsumptionHistory)
                data["cloudConsumptionHistory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCloudConsumptionHistoryResponse {
    cloudConsumptionHistory?: CloudConsumptionHistoryDto[] | undefined;
}

export class HardwareLifecycleManagementIntegrationDTO extends IntegrationDTO implements IHardwareLifecycleManagementIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: HardwareLifecycleIntegrationMetadata;

    constructor(data?: IHardwareLifecycleManagementIntegrationDTO) {
        super(data);
        this._discriminator = "HardwareLifecycleManagementIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? HardwareLifecycleIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): HardwareLifecycleManagementIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HardwareLifecycleManagementIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IHardwareLifecycleManagementIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: HardwareLifecycleIntegrationMetadata;
}

export class IdcsReportIntegrationDTO extends IntegrationDTO implements IIdcsReportIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: IdcsReportIntegrationMetadata;

    constructor(data?: IIdcsReportIntegrationDTO) {
        super(data);
        this._discriminator = "IdcsReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? IdcsReportIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): IdcsReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IdcsReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IIdcsReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: IdcsReportIntegrationMetadata;
}

export class AssessmentIntegrationDto extends IntegrationDTO implements IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AssessmentIntegrationMetadata;

    protected _discriminator: string;

    constructor(data?: IAssessmentIntegrationDto) {
        super(data);
        this._discriminator = "AssessmentIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AssessmentIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AssessmentIntegrationDto {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "AiReadinessIntegrationDto") {
            let result = new AiReadinessIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "AwsMaturityAssessmentIntegrationDto") {
            let result = new AwsMaturityAssessmentIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "DevOpsPostureReviewIntegrationDto") {
            let result = new DevOpsPostureReviewIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "MicrosoftAdoptionIntegrationDto") {
            let result = new MicrosoftAdoptionIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "SecurityPostureReviewIntegrationDto") {
            let result = new SecurityPostureReviewIntegrationDto();
            result.init(data);
            return result;
        }
        if (data["typeName"] === "TpxIntegrationDto") {
            let result = new TpxIntegrationDto();
            result.init(data);
            return result;
        }
        let result = new AssessmentIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAssessmentIntegrationDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AssessmentIntegrationMetadata;
}

export class AiReadinessIntegrationDto extends AssessmentIntegrationDto implements IAiReadinessIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: IAiReadinessIntegrationDto) {
        super(data);
        this._discriminator = "AiReadinessIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AiReadinessIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiReadinessIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAiReadinessIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class AwsMaturityAssessmentIntegrationDto extends AssessmentIntegrationDto implements IAwsMaturityAssessmentIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: IAwsMaturityAssessmentIntegrationDto) {
        super(data);
        this._discriminator = "AwsMaturityAssessmentIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): AwsMaturityAssessmentIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwsMaturityAssessmentIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IAwsMaturityAssessmentIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class BatchIntegrationError implements IBatchIntegrationError {
    axAccountNumber?: string | undefined;
    customerTenantId?: string | undefined;
    error?: string | undefined;

    constructor(data?: IBatchIntegrationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.customerTenantId = _data["customerTenantId"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): BatchIntegrationError {
        data = typeof data === 'object' ? data : {};
        let result = new BatchIntegrationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["customerTenantId"] = this.customerTenantId;
        data["error"] = this.error;
        return data;
    }
}

export interface IBatchIntegrationError {
    axAccountNumber?: string | undefined;
    customerTenantId?: string | undefined;
    error?: string | undefined;
}

export class BatchIntegrationResult implements IBatchIntegrationResult {
    succeeded?: number;
    failed?: number;
    errors?: BatchIntegrationError[] | undefined;

    constructor(data?: IBatchIntegrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.failed = _data["failed"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(BatchIntegrationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchIntegrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new BatchIntegrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["failed"] = this.failed;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBatchIntegrationResult {
    succeeded?: number;
    failed?: number;
    errors?: BatchIntegrationError[] | undefined;
}

export class CatalystIntegrationDTO extends IntegrationDTO implements ICatalystIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: CatalystIntegrationMetadata;

    constructor(data?: ICatalystIntegrationDTO) {
        super(data);
        this._discriminator = "CatalystIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? CatalystIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CatalystIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CatalystIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICatalystIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: CatalystIntegrationMetadata;
}

export class DevOpsPostureReviewIntegrationDto extends AssessmentIntegrationDto implements IDevOpsPostureReviewIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: IDevOpsPostureReviewIntegrationDto) {
        super(data);
        this._discriminator = "DevOpsPostureReviewIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): DevOpsPostureReviewIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DevOpsPostureReviewIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IDevOpsPostureReviewIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class InstallBaseAnalysisDto extends IntegrationDTO implements IInstallBaseAnalysisDto {
    integrationType?: IntegrationType;
    metadata?: IbaIntegrationMetadata;

    constructor(data?: IInstallBaseAnalysisDto) {
        super(data);
        this._discriminator = "InstallBaseAnalysisDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? IbaIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): InstallBaseAnalysisDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallBaseAnalysisDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IInstallBaseAnalysisDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: IbaIntegrationMetadata;
}

export class LiveOpticsIntegrationDto extends IntegrationDTO implements ILiveOpticsIntegrationDto {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: LiveOpticsIntegrationMetadata;

    constructor(data?: ILiveOpticsIntegrationDto) {
        super(data);
        this._discriminator = "LiveOpticsIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? LiveOpticsIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): LiveOpticsIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiveOpticsIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ILiveOpticsIntegrationDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: LiveOpticsIntegrationMetadata;
}

export class MicrosoftAdoptionIntegrationDto extends AssessmentIntegrationDto implements IMicrosoftAdoptionIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: IMicrosoftAdoptionIntegrationDto) {
        super(data);
        this._discriminator = "MicrosoftAdoptionIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): MicrosoftAdoptionIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftAdoptionIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface IMicrosoftAdoptionIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class SecurityPostureReviewIntegrationDto extends AssessmentIntegrationDto implements ISecurityPostureReviewIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: ISecurityPostureReviewIntegrationDto) {
        super(data);
        this._discriminator = "SecurityPostureReviewIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): SecurityPostureReviewIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityPostureReviewIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface ISecurityPostureReviewIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class TpxIntegrationDto extends AssessmentIntegrationDto implements ITpxIntegrationDto {
    integrationType?: IntegrationType;

    constructor(data?: ITpxIntegrationDto) {
        super(data);
        this._discriminator = "TpxIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
        }
    }

    static override fromJS(data: any): TpxIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TpxIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        super.toJSON(data);
        return data;
    }
}

export interface ITpxIntegrationDto extends IAssessmentIntegrationDto {
    integrationType?: IntegrationType;
}

export class InvoiceFilterMetadataDto implements IInvoiceFilterMetadataDto {
    maxInvoiceAmount?: number;
    contractOptions?: ContractFilterOptionDto[] | undefined;

    constructor(data?: IInvoiceFilterMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxInvoiceAmount = _data["maxInvoiceAmount"];
            if (Array.isArray(_data["contractOptions"])) {
                this.contractOptions = [] as any;
                for (let item of _data["contractOptions"])
                    this.contractOptions!.push(ContractFilterOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceFilterMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceFilterMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxInvoiceAmount"] = this.maxInvoiceAmount;
        if (Array.isArray(this.contractOptions)) {
            data["contractOptions"] = [];
            for (let item of this.contractOptions)
                data["contractOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceFilterMetadataDto {
    maxInvoiceAmount?: number;
    contractOptions?: ContractFilterOptionDto[] | undefined;
}

export class InvoiceSearchFilterDto implements IInvoiceSearchFilterDto {
    searchTerm?: string | undefined;
    page?: number;
    pageSize?: number;
    sortBy?: string | undefined;
    sortDescending?: boolean;
    invoiceId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    customerPo?: string | undefined;
    tag?: string | undefined;
    contractId?: number | undefined;
    projectId?: number | undefined;
    minAmount?: number | undefined;
    maxAmount?: number | undefined;

    constructor(data?: IInvoiceSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortBy = _data["sortBy"];
            this.sortDescending = _data["sortDescending"];
            this.invoiceId = _data["invoiceId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.customerPo = _data["customerPo"];
            this.tag = _data["tag"];
            this.contractId = _data["contractId"];
            this.projectId = _data["projectId"];
            this.minAmount = _data["minAmount"];
            this.maxAmount = _data["maxAmount"];
        }
    }

    static fromJS(data: any): InvoiceSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortBy"] = this.sortBy;
        data["sortDescending"] = this.sortDescending;
        data["invoiceId"] = this.invoiceId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["customerPo"] = this.customerPo;
        data["tag"] = this.tag;
        data["contractId"] = this.contractId;
        data["projectId"] = this.projectId;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        return data;
    }
}

export interface IInvoiceSearchFilterDto {
    searchTerm?: string | undefined;
    page?: number;
    pageSize?: number;
    sortBy?: string | undefined;
    sortDescending?: boolean;
    invoiceId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    customerPo?: string | undefined;
    tag?: string | undefined;
    contractId?: number | undefined;
    projectId?: number | undefined;
    minAmount?: number | undefined;
    maxAmount?: number | undefined;
}

export class MicrosoftInsightsIntegrationDTO extends IntegrationDTO implements IMicrosoftInsightsIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: MicrosoftInsightsIntegrationMetadata;

    constructor(data?: IMicrosoftInsightsIntegrationDTO) {
        super(data);
        this._discriminator = "MicrosoftInsightsIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? MicrosoftInsightsIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): MicrosoftInsightsIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftInsightsIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMicrosoftInsightsIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: MicrosoftInsightsIntegrationMetadata;
}

export class MonthlyCloudConsumptionDto implements IMonthlyCloudConsumptionDto {
    cloudAccountId?: string | undefined;
    monthlySpend?: MonthlySpendDto[] | undefined;

    constructor(data?: IMonthlyCloudConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloudAccountId = _data["cloudAccountId"];
            if (Array.isArray(_data["monthlySpend"])) {
                this.monthlySpend = [] as any;
                for (let item of _data["monthlySpend"])
                    this.monthlySpend!.push(MonthlySpendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthlyCloudConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyCloudConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloudAccountId"] = this.cloudAccountId;
        if (Array.isArray(this.monthlySpend)) {
            data["monthlySpend"] = [];
            for (let item of this.monthlySpend)
                data["monthlySpend"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMonthlyCloudConsumptionDto {
    cloudAccountId?: string | undefined;
    monthlySpend?: MonthlySpendDto[] | undefined;
}

export class MonthlySpendDto implements IMonthlySpendDto {
    billingMonth?: Date;
    price?: number;

    constructor(data?: IMonthlySpendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingMonth = _data["billingMonth"] ? new Date(_data["billingMonth"].toString()) : undefined as any;
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): MonthlySpendDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlySpendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingMonth"] = this.billingMonth ? this.billingMonth.toISOString() : undefined as any;
        data["price"] = this.price;
        return data;
    }
}

export interface IMonthlySpendDto {
    billingMonth?: Date;
    price?: number;
}

export class PagedInvoiceResponseDto implements IPagedInvoiceResponseDto {
    invoices?: BillingInvoiceDto[] | undefined;
    pagination?: PagedResultData;
    filterMetadata?: InvoiceFilterMetadataDto;
    hasRetrievalErrors?: boolean;
    failedTags?: string[] | undefined;

    constructor(data?: IPagedInvoiceResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(BillingInvoiceDto.fromJS(item));
            }
            this.pagination = _data["pagination"] ? PagedResultData.fromJS(_data["pagination"]) : undefined as any;
            this.filterMetadata = _data["filterMetadata"] ? InvoiceFilterMetadataDto.fromJS(_data["filterMetadata"]) : undefined as any;
            this.hasRetrievalErrors = _data["hasRetrievalErrors"];
            if (Array.isArray(_data["failedTags"])) {
                this.failedTags = [] as any;
                for (let item of _data["failedTags"])
                    this.failedTags!.push(item);
            }
        }
    }

    static fromJS(data: any): PagedInvoiceResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedInvoiceResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        data["filterMetadata"] = this.filterMetadata ? this.filterMetadata.toJSON() : undefined as any;
        data["hasRetrievalErrors"] = this.hasRetrievalErrors;
        if (Array.isArray(this.failedTags)) {
            data["failedTags"] = [];
            for (let item of this.failedTags)
                data["failedTags"].push(item);
        }
        return data;
    }
}

export interface IPagedInvoiceResponseDto {
    invoices?: BillingInvoiceDto[] | undefined;
    pagination?: PagedResultData;
    filterMetadata?: InvoiceFilterMetadataDto;
    hasRetrievalErrors?: boolean;
    failedTags?: string[] | undefined;
}

export class PostTicketServiceRequestContactsResponse implements IPostTicketServiceRequestContactsResponse {
    serviceRequestContacts?: TicketAdditionalContactDTO[] | undefined;
    failed?: ServiceRequestContactCandidateDto[] | undefined;

    constructor(data?: IPostTicketServiceRequestContactsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceRequestContacts"])) {
                this.serviceRequestContacts = [] as any;
                for (let item of _data["serviceRequestContacts"])
                    this.serviceRequestContacts!.push(TicketAdditionalContactDTO.fromJS(item));
            }
            if (Array.isArray(_data["failed"])) {
                this.failed = [] as any;
                for (let item of _data["failed"])
                    this.failed!.push(ServiceRequestContactCandidateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostTicketServiceRequestContactsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostTicketServiceRequestContactsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceRequestContacts)) {
            data["serviceRequestContacts"] = [];
            for (let item of this.serviceRequestContacts)
                data["serviceRequestContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.failed)) {
            data["failed"] = [];
            for (let item of this.failed)
                data["failed"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPostTicketServiceRequestContactsResponse {
    serviceRequestContacts?: TicketAdditionalContactDTO[] | undefined;
    failed?: ServiceRequestContactCandidateDto[] | undefined;
}

export class AccountProfileAddressDto implements IAccountProfileAddressDto {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IAccountProfileAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): AccountProfileAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountProfileAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }
}

export interface IAccountProfileAddressDto {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
}

export class AccountProfileAdministratorDto implements IAccountProfileAdministratorDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    photoUrl?: string | undefined;

    constructor(data?: IAccountProfileAdministratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtension = _data["phoneExtension"];
            this.photoUrl = _data["photoUrl"];
        }
    }

    static fromJS(data: any): AccountProfileAdministratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountProfileAdministratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtension"] = this.phoneExtension;
        data["photoUrl"] = this.photoUrl;
        return data;
    }
}

export interface IAccountProfileAdministratorDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    photoUrl?: string | undefined;
}

export class AccountProfileDrawerResponse implements IAccountProfileDrawerResponse {
    accountId?: number;
    accountName?: string | undefined;
    storefrontName?: string | undefined;
    parentCompanyName?: string | undefined;
    companyLogoUrl?: string | undefined;
    primaryAxNumber?: string | undefined;
    axNumbers?: string[] | undefined;
    crmAccountId?: string | undefined;
    phone?: string | undefined;
    webAddress?: string | undefined;
    address?: AccountProfileAddressDto;
    administrators?: AccountProfileAdministratorDto[] | undefined;
    shiAccountTeam?: AccountProfileShiTeamDto;

    constructor(data?: IAccountProfileDrawerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.storefrontName = _data["storefrontName"];
            this.parentCompanyName = _data["parentCompanyName"];
            this.companyLogoUrl = _data["companyLogoUrl"];
            this.primaryAxNumber = _data["primaryAxNumber"];
            if (Array.isArray(_data["axNumbers"])) {
                this.axNumbers = [] as any;
                for (let item of _data["axNumbers"])
                    this.axNumbers!.push(item);
            }
            this.crmAccountId = _data["crmAccountId"];
            this.phone = _data["phone"];
            this.webAddress = _data["webAddress"];
            this.address = _data["address"] ? AccountProfileAddressDto.fromJS(_data["address"]) : undefined as any;
            if (Array.isArray(_data["administrators"])) {
                this.administrators = [] as any;
                for (let item of _data["administrators"])
                    this.administrators!.push(AccountProfileAdministratorDto.fromJS(item));
            }
            this.shiAccountTeam = _data["shiAccountTeam"] ? AccountProfileShiTeamDto.fromJS(_data["shiAccountTeam"]) : undefined as any;
        }
    }

    static fromJS(data: any): AccountProfileDrawerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountProfileDrawerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["storefrontName"] = this.storefrontName;
        data["parentCompanyName"] = this.parentCompanyName;
        data["companyLogoUrl"] = this.companyLogoUrl;
        data["primaryAxNumber"] = this.primaryAxNumber;
        if (Array.isArray(this.axNumbers)) {
            data["axNumbers"] = [];
            for (let item of this.axNumbers)
                data["axNumbers"].push(item);
        }
        data["crmAccountId"] = this.crmAccountId;
        data["phone"] = this.phone;
        data["webAddress"] = this.webAddress;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        if (Array.isArray(this.administrators)) {
            data["administrators"] = [];
            for (let item of this.administrators)
                data["administrators"].push(item ? item.toJSON() : undefined as any);
        }
        data["shiAccountTeam"] = this.shiAccountTeam ? this.shiAccountTeam.toJSON() : undefined as any;
        return data;
    }
}

export interface IAccountProfileDrawerResponse {
    accountId?: number;
    accountName?: string | undefined;
    storefrontName?: string | undefined;
    parentCompanyName?: string | undefined;
    companyLogoUrl?: string | undefined;
    primaryAxNumber?: string | undefined;
    axNumbers?: string[] | undefined;
    crmAccountId?: string | undefined;
    phone?: string | undefined;
    webAddress?: string | undefined;
    address?: AccountProfileAddressDto;
    administrators?: AccountProfileAdministratorDto[] | undefined;
    shiAccountTeam?: AccountProfileShiTeamDto;
}

export class AccountProfileShiTeamDto implements IAccountProfileShiTeamDto {
    primaryAccountExecutive?: YourShiAccountTeamMemberDto;
    yourShiTeamMembers?: YourShiAccountTeamMemberDto[] | undefined;

    constructor(data?: IAccountProfileShiTeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryAccountExecutive = _data["primaryAccountExecutive"] ? YourShiAccountTeamMemberDto.fromJS(_data["primaryAccountExecutive"]) : undefined as any;
            if (Array.isArray(_data["yourShiTeamMembers"])) {
                this.yourShiTeamMembers = [] as any;
                for (let item of _data["yourShiTeamMembers"])
                    this.yourShiTeamMembers!.push(YourShiAccountTeamMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountProfileShiTeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountProfileShiTeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryAccountExecutive"] = this.primaryAccountExecutive ? this.primaryAccountExecutive.toJSON() : undefined as any;
        if (Array.isArray(this.yourShiTeamMembers)) {
            data["yourShiTeamMembers"] = [];
            for (let item of this.yourShiTeamMembers)
                data["yourShiTeamMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccountProfileShiTeamDto {
    primaryAccountExecutive?: YourShiAccountTeamMemberDto;
    yourShiTeamMembers?: YourShiAccountTeamMemberDto[] | undefined;
}

export class RackAndStackIntegrationDTO extends IntegrationDTO implements IRackAndStackIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: RackAndStackIntegrationMetadata;

    constructor(data?: IRackAndStackIntegrationDTO) {
        super(data);
        this._discriminator = "RackAndStackIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? RackAndStackIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): RackAndStackIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RackAndStackIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IRackAndStackIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: RackAndStackIntegrationMetadata;
}

/** Records the signatory's acceptance of a Microsoft Customer Agreement. Signatory rules match ShiOne.WebApi.Models.DTO.CreateAttestationLinkRequest. The agreement type, date, and template are controlled server-side; no agreement link is accepted from the caller. */
export class RecordAttestationAcceptanceRequest implements IRecordAttestationAcceptanceRequest {
    attestationId!: string;
    firstName!: string;
    lastName!: string;
    email!: string;
    phoneNumber!: string;

    constructor(data?: IRecordAttestationAcceptanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attestationId = _data["attestationId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): RecordAttestationAcceptanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecordAttestationAcceptanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attestationId"] = this.attestationId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

/** Records the signatory's acceptance of a Microsoft Customer Agreement. Signatory rules match ShiOne.WebApi.Models.DTO.CreateAttestationLinkRequest. The agreement type, date, and template are controlled server-side; no agreement link is accepted from the caller. */
export interface IRecordAttestationAcceptanceRequest {
    attestationId: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
}

export class RequestSummary implements IRequestSummary {
    severity?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    type?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    category?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    count?: number;

    constructor(data?: IRequestSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["severity"])) {
                this.severity = [] as any;
                for (let item of _data["severity"])
                    this.severity!.push(KeyValuePair_2OfInt32AndInt32.fromJS(item));
            }
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(KeyValuePair_2OfInt32AndInt32.fromJS(item));
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(KeyValuePair_2OfInt32AndInt32.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): RequestSummary {
        data = typeof data === 'object' ? data : {};
        let result = new RequestSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.severity)) {
            data["severity"] = [];
            for (let item of this.severity)
                data["severity"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IRequestSummary {
    severity?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    type?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    category?: KeyValuePair_2OfInt32AndInt32[] | undefined;
    count?: number;
}

export class ResponsesMeetingSlaDto implements IResponsesMeetingSlaDto {
    responseType?: string | undefined;
    meetingSla?: number;
    notMeetingSla?: number;

    constructor(data?: IResponsesMeetingSlaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseType = _data["responseType"];
            this.meetingSla = _data["meetingSla"];
            this.notMeetingSla = _data["notMeetingSla"];
        }
    }

    static fromJS(data: any): ResponsesMeetingSlaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsesMeetingSlaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseType"] = this.responseType;
        data["meetingSla"] = this.meetingSla;
        data["notMeetingSla"] = this.notMeetingSla;
        return data;
    }
}

export interface IResponsesMeetingSlaDto {
    responseType?: string | undefined;
    meetingSla?: number;
    notMeetingSla?: number;
}

export class RetainerPurchaseDTO implements IRetainerPurchaseDTO {
    retainerId?: number;
    purchased?: Date;
    startDate?: Date;
    endDate?: Date;
    description?: string | undefined;
    amount?: number;
    active?: boolean;
    billed?: boolean;

    constructor(data?: IRetainerPurchaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.retainerId = _data["retainerId"];
            this.purchased = _data["purchased"] ? new Date(_data["purchased"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.active = _data["active"];
            this.billed = _data["billed"];
        }
    }

    static fromJS(data: any): RetainerPurchaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RetainerPurchaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retainerId"] = this.retainerId;
        data["purchased"] = this.purchased ? this.purchased.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["active"] = this.active;
        data["billed"] = this.billed;
        return data;
    }
}

export interface IRetainerPurchaseDTO {
    retainerId?: number;
    purchased?: Date;
    startDate?: Date;
    endDate?: Date;
    description?: string | undefined;
    amount?: number;
    active?: boolean;
    billed?: boolean;
}

export class SelfServiceReportingIntegrationDto extends IntegrationDTO implements ISelfServiceReportingIntegrationDto {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: SelfServiceReportingIntegrationMetadata;

    constructor(data?: ISelfServiceReportingIntegrationDto) {
        super(data);
        this._discriminator = "SelfServiceReportingIntegrationDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? SelfServiceReportingIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): SelfServiceReportingIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceReportingIntegrationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISelfServiceReportingIntegrationDto extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: SelfServiceReportingIntegrationMetadata;
}

export class ServiceContractTypeDto implements IServiceContractTypeDto {
    contractType?: string | undefined;
    count?: number;

    constructor(data?: IServiceContractTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractType = _data["contractType"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ServiceContractTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceContractTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractType"] = this.contractType;
        data["count"] = this.count;
        return data;
    }
}

export interface IServiceContractTypeDto {
    contractType?: string | undefined;
    count?: number;
}

export class ServiceContractsWidgetDto implements IServiceContractsWidgetDto {
    contractTypes?: ServiceContractTypeDto[] | undefined;

    constructor(data?: IServiceContractsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(ServiceContractTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceContractsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceContractsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IServiceContractsWidgetDto {
    contractTypes?: ServiceContractTypeDto[] | undefined;
}

export class ServiceLevelAgreementResultMetadataDto implements IServiceLevelAgreementResultMetadataDto {
    id?: number;
    lastModifiedDateTime?: Date;

    constructor(data?: IServiceLevelAgreementResultMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceLevelAgreementResultMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLevelAgreementResultMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IServiceLevelAgreementResultMetadataDto {
    id?: number;
    lastModifiedDateTime?: Date;
}

export class ServiceRequestAccountLocationDTO implements IServiceRequestAccountLocationDTO {
    id?: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: IServiceRequestAccountLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): ServiceRequestAccountLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestAccountLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IServiceRequestAccountLocationDTO {
    id?: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
}

export class ServiceRequestCompletedMeetingSlaWidgetDto implements IServiceRequestCompletedMeetingSlaWidgetDto {
    responseTypes?: ResponsesMeetingSlaDto[] | undefined;
    totalMeetingSla?: number;
    totalNotMeetingSla?: number;

    constructor(data?: IServiceRequestCompletedMeetingSlaWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responseTypes"])) {
                this.responseTypes = [] as any;
                for (let item of _data["responseTypes"])
                    this.responseTypes!.push(ResponsesMeetingSlaDto.fromJS(item));
            }
            this.totalMeetingSla = _data["totalMeetingSla"];
            this.totalNotMeetingSla = _data["totalNotMeetingSla"];
        }
    }

    static fromJS(data: any): ServiceRequestCompletedMeetingSlaWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestCompletedMeetingSlaWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responseTypes)) {
            data["responseTypes"] = [];
            for (let item of this.responseTypes)
                data["responseTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalMeetingSla"] = this.totalMeetingSla;
        data["totalNotMeetingSla"] = this.totalNotMeetingSla;
        return data;
    }
}

export interface IServiceRequestCompletedMeetingSlaWidgetDto {
    responseTypes?: ResponsesMeetingSlaDto[] | undefined;
    totalMeetingSla?: number;
    totalNotMeetingSla?: number;
}

/** A person who can be added to a request as a service request contact. Exactly one of ShiOne.WebApi.Models.DTO.ServiceRequestContactCandidateDto.ContactId (Autotask contact) and ShiOne.WebApi.Models.DTO.ServiceRequestContactCandidateDto.UserId (CX user) is set. */
export class ServiceRequestContactCandidateDto implements IServiceRequestContactCandidateDto {
    contactId?: number | undefined;
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    source?: ServiceRequestContactSource;

    constructor(data?: IServiceRequestContactCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ServiceRequestContactCandidateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestContactCandidateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["source"] = this.source;
        return data;
    }
}

/** A person who can be added to a request as a service request contact. Exactly one of ShiOne.WebApi.Models.DTO.ServiceRequestContactCandidateDto.ContactId (Autotask contact) and ShiOne.WebApi.Models.DTO.ServiceRequestContactCandidateDto.UserId (CX user) is set. */
export interface IServiceRequestContactCandidateDto {
    contactId?: number | undefined;
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    source?: ServiceRequestContactSource;
}

export class ServiceRequestContactDTO implements IServiceRequestContactDTO {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IServiceRequestContactDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ServiceRequestContactDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestContactDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IServiceRequestContactDTO {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
}

/** A service request contact chosen by the caller. Exactly one of ShiOne.WebApi.Models.DTO.ServiceRequestContactSelectionDto.ContactId and ShiOne.WebApi.Models.DTO.ServiceRequestContactSelectionDto.UserId must be set. */
export class ServiceRequestContactSelectionDto implements IServiceRequestContactSelectionDto {
    contactId?: number | undefined;
    userId?: string | undefined;

    constructor(data?: IServiceRequestContactSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ServiceRequestContactSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestContactSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["userId"] = this.userId;
        return data;
    }
}

/** A service request contact chosen by the caller. Exactly one of ShiOne.WebApi.Models.DTO.ServiceRequestContactSelectionDto.ContactId and ShiOne.WebApi.Models.DTO.ServiceRequestContactSelectionDto.UserId must be set. */
export interface IServiceRequestContactSelectionDto {
    contactId?: number | undefined;
    userId?: string | undefined;
}

export enum ServiceRequestContactSource {
    Autotask = "Autotask",
    CxUser = "CxUser",
}

export class ServiceRequestDTO implements IServiceRequestDTO {
    id?: number;
    serviceRequestData?: string | undefined;
    state?: ServiceRequestState;
    serviceRequestMappingId?: number | undefined;
    autotaskTicketData?: TicketDTO;
    serviceRequestMapping?: ServiceRequestMapping;
    createdByContactId?: number | undefined;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    availableActions?: ServiceRequestActionType[] | undefined;
    showFormWhenViewing?: boolean;
    isDemoData?: boolean;

    constructor(data?: IServiceRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceRequestData = _data["serviceRequestData"];
            this.state = _data["state"];
            this.serviceRequestMappingId = _data["serviceRequestMappingId"];
            this.autotaskTicketData = _data["autotaskTicketData"] ? TicketDTO.fromJS(_data["autotaskTicketData"]) : undefined as any;
            this.serviceRequestMapping = _data["serviceRequestMapping"] ? ServiceRequestMapping.fromJS(_data["serviceRequestMapping"]) : undefined as any;
            this.createdByContactId = _data["createdByContactId"];
            this.createdByName = _data["createdByName"];
            this.createdByEmail = _data["createdByEmail"];
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(item);
            }
            this.showFormWhenViewing = _data["showFormWhenViewing"];
            this.isDemoData = _data["isDemoData"];
        }
    }

    static fromJS(data: any): ServiceRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceRequestData"] = this.serviceRequestData;
        data["state"] = this.state;
        data["serviceRequestMappingId"] = this.serviceRequestMappingId;
        data["autotaskTicketData"] = this.autotaskTicketData ? this.autotaskTicketData.toJSON() : undefined as any;
        data["serviceRequestMapping"] = this.serviceRequestMapping ? this.serviceRequestMapping.toJSON() : undefined as any;
        data["createdByContactId"] = this.createdByContactId;
        data["createdByName"] = this.createdByName;
        data["createdByEmail"] = this.createdByEmail;
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item);
        }
        data["showFormWhenViewing"] = this.showFormWhenViewing;
        data["isDemoData"] = this.isDemoData;
        return data;
    }
}

export interface IServiceRequestDTO {
    id?: number;
    serviceRequestData?: string | undefined;
    state?: ServiceRequestState;
    serviceRequestMappingId?: number | undefined;
    autotaskTicketData?: TicketDTO;
    serviceRequestMapping?: ServiceRequestMapping;
    createdByContactId?: number | undefined;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    availableActions?: ServiceRequestActionType[] | undefined;
    showFormWhenViewing?: boolean;
    isDemoData?: boolean;
}

export class ServiceRequestSummaryDTO implements IServiceRequestSummaryDTO {
    allServiceRequestsSummary?: RequestSummary;
    myServiceRequestSummary?: RequestSummary;
    secondaryServiceRequestsSummary?: RequestSummary;

    constructor(data?: IServiceRequestSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allServiceRequestsSummary = _data["allServiceRequestsSummary"] ? RequestSummary.fromJS(_data["allServiceRequestsSummary"]) : undefined as any;
            this.myServiceRequestSummary = _data["myServiceRequestSummary"] ? RequestSummary.fromJS(_data["myServiceRequestSummary"]) : undefined as any;
            this.secondaryServiceRequestsSummary = _data["secondaryServiceRequestsSummary"] ? RequestSummary.fromJS(_data["secondaryServiceRequestsSummary"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceRequestSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allServiceRequestsSummary"] = this.allServiceRequestsSummary ? this.allServiceRequestsSummary.toJSON() : undefined as any;
        data["myServiceRequestSummary"] = this.myServiceRequestSummary ? this.myServiceRequestSummary.toJSON() : undefined as any;
        data["secondaryServiceRequestsSummary"] = this.secondaryServiceRequestsSummary ? this.secondaryServiceRequestsSummary.toJSON() : undefined as any;
        return data;
    }
}

export interface IServiceRequestSummaryDTO {
    allServiceRequestsSummary?: RequestSummary;
    myServiceRequestSummary?: RequestSummary;
    secondaryServiceRequestsSummary?: RequestSummary;
}

export class ServiceRequestsResponseDTO implements IServiceRequestsResponseDTO {
    requests?: ServiceRequestDTO[] | undefined;
    count?: number;
    contacts?: Contact[] | undefined;
    resources?: Resource[] | undefined;

    constructor(data?: IServiceRequestsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(ServiceRequestDTO.fromJS(item));
            }
            this.count = _data["count"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(Resource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceRequestsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IServiceRequestsResponseDTO {
    requests?: ServiceRequestDTO[] | undefined;
    count?: number;
    contacts?: Contact[] | undefined;
    resources?: Resource[] | undefined;
}

export class ServicesExpiringContractDto implements IServicesExpiringContractDto {
    name?: string | undefined;
    company?: string | undefined;
    contractType?: string | undefined;
    daysUntilExpiration?: number;

    constructor(data?: IServicesExpiringContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.company = _data["company"];
            this.contractType = _data["contractType"];
            this.daysUntilExpiration = _data["daysUntilExpiration"];
        }
    }

    static fromJS(data: any): ServicesExpiringContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesExpiringContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["company"] = this.company;
        data["contractType"] = this.contractType;
        data["daysUntilExpiration"] = this.daysUntilExpiration;
        return data;
    }
}

export interface IServicesExpiringContractDto {
    name?: string | undefined;
    company?: string | undefined;
    contractType?: string | undefined;
    daysUntilExpiration?: number;
}

export class ServicesExpiringContractsWidgetDto implements IServicesExpiringContractsWidgetDto {
    expiringContracts?: ServicesExpiringContractDto[] | undefined;

    constructor(data?: IServicesExpiringContractsWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringContracts"])) {
                this.expiringContracts = [] as any;
                for (let item of _data["expiringContracts"])
                    this.expiringContracts!.push(ServicesExpiringContractDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServicesExpiringContractsWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesExpiringContractsWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringContracts)) {
            data["expiringContracts"] = [];
            for (let item of this.expiringContracts)
                data["expiringContracts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IServicesExpiringContractsWidgetDto {
    expiringContracts?: ServicesExpiringContractDto[] | undefined;
}

export class SurveyResultMetadataDto implements ISurveyResultMetadataDto {
    id?: number;
    completeDate?: Date;

    constructor(data?: ISurveyResultMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SurveyResultMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["completeDate"] = this.completeDate ? this.completeDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISurveyResultMetadataDto {
    id?: number;
    completeDate?: Date;
}

export class TicketAdditionalContactDTO implements ITicketAdditionalContactDTO {
    id?: number;
    contactId?: number;
    ticketId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: ITicketAdditionalContactDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.ticketId = _data["ticketId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): TicketAdditionalContactDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAdditionalContactDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["ticketId"] = this.ticketId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ITicketAdditionalContactDTO {
    id?: number;
    contactId?: number;
    ticketId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class TicketAttachmentDTO implements ITicketAttachmentDTO {
    id?: number;
    guid?: string | undefined;
    fileName?: string | undefined;
    fileType?: string | undefined;
    dateUploaded?: Date;
    fileSize?: number;
    ticketId?: number;
    ticketNoteId?: number;
    attachedByName?: string | undefined;

    constructor(data?: ITicketAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.dateUploaded = _data["dateUploaded"] ? new Date(_data["dateUploaded"].toString()) : undefined as any;
            this.fileSize = _data["fileSize"];
            this.ticketId = _data["ticketId"];
            this.ticketNoteId = _data["ticketNoteId"];
            this.attachedByName = _data["attachedByName"];
        }
    }

    static fromJS(data: any): TicketAttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["dateUploaded"] = this.dateUploaded ? this.dateUploaded.toISOString() : undefined as any;
        data["fileSize"] = this.fileSize;
        data["ticketId"] = this.ticketId;
        data["ticketNoteId"] = this.ticketNoteId;
        data["attachedByName"] = this.attachedByName;
        return data;
    }
}

export interface ITicketAttachmentDTO {
    id?: number;
    guid?: string | undefined;
    fileName?: string | undefined;
    fileType?: string | undefined;
    dateUploaded?: Date;
    fileSize?: number;
    ticketId?: number;
    ticketNoteId?: number;
    attachedByName?: string | undefined;
}

export class TicketDTO implements ITicketDTO {
    id?: number;
    accountPhysicalLocationID?: number;
    rmmAlertID?: string | undefined;
    allocationCodeID?: number;
    assignedResourceRoleID?: number;
    businessDivisionSubdivisionID?: number;
    changeApprovalBoard?: number;
    changeApprovalStatus?: number;
    changeApprovalType?: number;
    changeInfoField1?: string | undefined;
    changeInfoField2?: string | undefined;
    changeInfoField3?: string | undefined;
    changeInfoField4?: string | undefined;
    changeInfoField5?: string | undefined;
    completedDate?: Date;
    contractID?: number;
    contractServiceBundleID?: number;
    contractServiceID?: number;
    createDate?: Date;
    creatorType?: number;
    description?: string | undefined;
    dueDateTime?: Date;
    estimatedHours?: number;
    externalID?: string | undefined;
    firstResponseAssignedResourceID?: number;
    firstResponseDateTime?: Date;
    firstResponseDueDateTime?: Date;
    firstResponseInitiatingResourceID?: number;
    hoursToBeScheduled?: number;
    installedProductID?: number;
    issueType?: number;
    lastActivityDate?: Date;
    lastActivityPersonType?: number;
    lastCustomerNotificationDateTime?: Date;
    lastCustomerVisibleActivityDateTime?: Date;
    monitorID?: number;
    monitorTypeID?: number;
    opportunityID?: number;
    priority?: number;
    problemTicketID?: number;
    projectID?: number;
    purchaseOrderNumber?: string | undefined;
    queueID?: number;
    resolution?: string | undefined;
    resolutionPlanDateTime?: Date;
    resolutionPlanDueDateTime?: Date;
    resolvedDateTime?: Date;
    resolvedDueDateTime?: Date;
    serviceLevelAgreementHasBeenMet?: boolean;
    serviceLevelAgreementID?: number;
    source?: number;
    status?: number;
    subIssueType?: number;
    ticketCategory?: number;
    ticketNumber?: string | undefined;
    ticketType?: number;
    title?: string | undefined;
    accountID?: number | undefined;
    contactID?: number | undefined;
    contactName?: string | undefined;
    lastActivity?: Date;
    ticketNotes?: TicketNoteDTO[] | undefined;
    assignedResourceID?: number | undefined;
    completedByResourceID?: number | undefined;
    creatorResourceID?: number | undefined;
    lastActivityResourceID?: number | undefined;
    deleted?: boolean;
    assignedResourceName?: string | undefined;
    completedByResourceName?: string | undefined;
    creatorResourceName?: string | undefined;
    lastActivityResourceName?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    ticketAttachmentGuids?: string[] | undefined;
    ticketAttachments?: TicketAttachmentDTO[] | undefined;
    secondaryContactIds?: number[] | undefined;
    secondaryCxUserIds?: string[] | undefined;
    configurationPageUrl?: string | undefined;
    totalRows?: number | undefined;

    constructor(data?: ITicketDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountPhysicalLocationID = _data["accountPhysicalLocationID"];
            this.rmmAlertID = _data["rmmAlertID"];
            this.allocationCodeID = _data["allocationCodeID"];
            this.assignedResourceRoleID = _data["assignedResourceRoleID"];
            this.businessDivisionSubdivisionID = _data["businessDivisionSubdivisionID"];
            this.changeApprovalBoard = _data["changeApprovalBoard"];
            this.changeApprovalStatus = _data["changeApprovalStatus"];
            this.changeApprovalType = _data["changeApprovalType"];
            this.changeInfoField1 = _data["changeInfoField1"];
            this.changeInfoField2 = _data["changeInfoField2"];
            this.changeInfoField3 = _data["changeInfoField3"];
            this.changeInfoField4 = _data["changeInfoField4"];
            this.changeInfoField5 = _data["changeInfoField5"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined as any;
            this.contractID = _data["contractID"];
            this.contractServiceBundleID = _data["contractServiceBundleID"];
            this.contractServiceID = _data["contractServiceID"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.creatorType = _data["creatorType"];
            this.description = _data["description"];
            this.dueDateTime = _data["dueDateTime"] ? new Date(_data["dueDateTime"].toString()) : undefined as any;
            this.estimatedHours = _data["estimatedHours"];
            this.externalID = _data["externalID"];
            this.firstResponseAssignedResourceID = _data["firstResponseAssignedResourceID"];
            this.firstResponseDateTime = _data["firstResponseDateTime"] ? new Date(_data["firstResponseDateTime"].toString()) : undefined as any;
            this.firstResponseDueDateTime = _data["firstResponseDueDateTime"] ? new Date(_data["firstResponseDueDateTime"].toString()) : undefined as any;
            this.firstResponseInitiatingResourceID = _data["firstResponseInitiatingResourceID"];
            this.hoursToBeScheduled = _data["hoursToBeScheduled"];
            this.installedProductID = _data["installedProductID"];
            this.issueType = _data["issueType"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
            this.lastActivityPersonType = _data["lastActivityPersonType"];
            this.lastCustomerNotificationDateTime = _data["lastCustomerNotificationDateTime"] ? new Date(_data["lastCustomerNotificationDateTime"].toString()) : undefined as any;
            this.lastCustomerVisibleActivityDateTime = _data["lastCustomerVisibleActivityDateTime"] ? new Date(_data["lastCustomerVisibleActivityDateTime"].toString()) : undefined as any;
            this.monitorID = _data["monitorID"];
            this.monitorTypeID = _data["monitorTypeID"];
            this.opportunityID = _data["opportunityID"];
            this.priority = _data["priority"];
            this.problemTicketID = _data["problemTicketID"];
            this.projectID = _data["projectID"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.queueID = _data["queueID"];
            this.resolution = _data["resolution"];
            this.resolutionPlanDateTime = _data["resolutionPlanDateTime"] ? new Date(_data["resolutionPlanDateTime"].toString()) : undefined as any;
            this.resolutionPlanDueDateTime = _data["resolutionPlanDueDateTime"] ? new Date(_data["resolutionPlanDueDateTime"].toString()) : undefined as any;
            this.resolvedDateTime = _data["resolvedDateTime"] ? new Date(_data["resolvedDateTime"].toString()) : undefined as any;
            this.resolvedDueDateTime = _data["resolvedDueDateTime"] ? new Date(_data["resolvedDueDateTime"].toString()) : undefined as any;
            this.serviceLevelAgreementHasBeenMet = _data["serviceLevelAgreementHasBeenMet"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
            this.source = _data["source"];
            this.status = _data["status"];
            this.subIssueType = _data["subIssueType"];
            this.ticketCategory = _data["ticketCategory"];
            this.ticketNumber = _data["ticketNumber"];
            this.ticketType = _data["ticketType"];
            this.title = _data["title"];
            this.accountID = _data["accountID"];
            this.contactID = _data["contactID"];
            this.contactName = _data["contactName"];
            this.lastActivity = _data["lastActivity"] ? new Date(_data["lastActivity"].toString()) : undefined as any;
            if (Array.isArray(_data["ticketNotes"])) {
                this.ticketNotes = [] as any;
                for (let item of _data["ticketNotes"])
                    this.ticketNotes!.push(TicketNoteDTO.fromJS(item));
            }
            this.assignedResourceID = _data["assignedResourceID"];
            this.completedByResourceID = _data["completedByResourceID"];
            this.creatorResourceID = _data["creatorResourceID"];
            this.lastActivityResourceID = _data["lastActivityResourceID"];
            this.deleted = _data["deleted"];
            this.assignedResourceName = _data["assignedResourceName"];
            this.completedByResourceName = _data["completedByResourceName"];
            this.creatorResourceName = _data["creatorResourceName"];
            this.lastActivityResourceName = _data["lastActivityResourceName"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            if (Array.isArray(_data["ticketAttachmentGuids"])) {
                this.ticketAttachmentGuids = [] as any;
                for (let item of _data["ticketAttachmentGuids"])
                    this.ticketAttachmentGuids!.push(item);
            }
            if (Array.isArray(_data["ticketAttachments"])) {
                this.ticketAttachments = [] as any;
                for (let item of _data["ticketAttachments"])
                    this.ticketAttachments!.push(TicketAttachmentDTO.fromJS(item));
            }
            if (Array.isArray(_data["secondaryContactIds"])) {
                this.secondaryContactIds = [] as any;
                for (let item of _data["secondaryContactIds"])
                    this.secondaryContactIds!.push(item);
            }
            if (Array.isArray(_data["secondaryCxUserIds"])) {
                this.secondaryCxUserIds = [] as any;
                for (let item of _data["secondaryCxUserIds"])
                    this.secondaryCxUserIds!.push(item);
            }
            this.configurationPageUrl = _data["configurationPageUrl"];
            this.totalRows = _data["totalRows"];
        }
    }

    static fromJS(data: any): TicketDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountPhysicalLocationID"] = this.accountPhysicalLocationID;
        data["rmmAlertID"] = this.rmmAlertID;
        data["allocationCodeID"] = this.allocationCodeID;
        data["assignedResourceRoleID"] = this.assignedResourceRoleID;
        data["businessDivisionSubdivisionID"] = this.businessDivisionSubdivisionID;
        data["changeApprovalBoard"] = this.changeApprovalBoard;
        data["changeApprovalStatus"] = this.changeApprovalStatus;
        data["changeApprovalType"] = this.changeApprovalType;
        data["changeInfoField1"] = this.changeInfoField1;
        data["changeInfoField2"] = this.changeInfoField2;
        data["changeInfoField3"] = this.changeInfoField3;
        data["changeInfoField4"] = this.changeInfoField4;
        data["changeInfoField5"] = this.changeInfoField5;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        data["contractID"] = this.contractID;
        data["contractServiceBundleID"] = this.contractServiceBundleID;
        data["contractServiceID"] = this.contractServiceID;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["creatorType"] = this.creatorType;
        data["description"] = this.description;
        data["dueDateTime"] = this.dueDateTime ? this.dueDateTime.toISOString() : undefined as any;
        data["estimatedHours"] = this.estimatedHours;
        data["externalID"] = this.externalID;
        data["firstResponseAssignedResourceID"] = this.firstResponseAssignedResourceID;
        data["firstResponseDateTime"] = this.firstResponseDateTime ? this.firstResponseDateTime.toISOString() : undefined as any;
        data["firstResponseDueDateTime"] = this.firstResponseDueDateTime ? this.firstResponseDueDateTime.toISOString() : undefined as any;
        data["firstResponseInitiatingResourceID"] = this.firstResponseInitiatingResourceID;
        data["hoursToBeScheduled"] = this.hoursToBeScheduled;
        data["installedProductID"] = this.installedProductID;
        data["issueType"] = this.issueType;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : undefined as any;
        data["lastActivityPersonType"] = this.lastActivityPersonType;
        data["lastCustomerNotificationDateTime"] = this.lastCustomerNotificationDateTime ? this.lastCustomerNotificationDateTime.toISOString() : undefined as any;
        data["lastCustomerVisibleActivityDateTime"] = this.lastCustomerVisibleActivityDateTime ? this.lastCustomerVisibleActivityDateTime.toISOString() : undefined as any;
        data["monitorID"] = this.monitorID;
        data["monitorTypeID"] = this.monitorTypeID;
        data["opportunityID"] = this.opportunityID;
        data["priority"] = this.priority;
        data["problemTicketID"] = this.problemTicketID;
        data["projectID"] = this.projectID;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["queueID"] = this.queueID;
        data["resolution"] = this.resolution;
        data["resolutionPlanDateTime"] = this.resolutionPlanDateTime ? this.resolutionPlanDateTime.toISOString() : undefined as any;
        data["resolutionPlanDueDateTime"] = this.resolutionPlanDueDateTime ? this.resolutionPlanDueDateTime.toISOString() : undefined as any;
        data["resolvedDateTime"] = this.resolvedDateTime ? this.resolvedDateTime.toISOString() : undefined as any;
        data["resolvedDueDateTime"] = this.resolvedDueDateTime ? this.resolvedDueDateTime.toISOString() : undefined as any;
        data["serviceLevelAgreementHasBeenMet"] = this.serviceLevelAgreementHasBeenMet;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        data["source"] = this.source;
        data["status"] = this.status;
        data["subIssueType"] = this.subIssueType;
        data["ticketCategory"] = this.ticketCategory;
        data["ticketNumber"] = this.ticketNumber;
        data["ticketType"] = this.ticketType;
        data["title"] = this.title;
        data["accountID"] = this.accountID;
        data["contactID"] = this.contactID;
        data["contactName"] = this.contactName;
        data["lastActivity"] = this.lastActivity ? this.lastActivity.toISOString() : undefined as any;
        if (Array.isArray(this.ticketNotes)) {
            data["ticketNotes"] = [];
            for (let item of this.ticketNotes)
                data["ticketNotes"].push(item ? item.toJSON() : undefined as any);
        }
        data["assignedResourceID"] = this.assignedResourceID;
        data["completedByResourceID"] = this.completedByResourceID;
        data["creatorResourceID"] = this.creatorResourceID;
        data["lastActivityResourceID"] = this.lastActivityResourceID;
        data["deleted"] = this.deleted;
        data["assignedResourceName"] = this.assignedResourceName;
        data["completedByResourceName"] = this.completedByResourceName;
        data["creatorResourceName"] = this.creatorResourceName;
        data["lastActivityResourceName"] = this.lastActivityResourceName;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        if (Array.isArray(this.ticketAttachmentGuids)) {
            data["ticketAttachmentGuids"] = [];
            for (let item of this.ticketAttachmentGuids)
                data["ticketAttachmentGuids"].push(item);
        }
        if (Array.isArray(this.ticketAttachments)) {
            data["ticketAttachments"] = [];
            for (let item of this.ticketAttachments)
                data["ticketAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.secondaryContactIds)) {
            data["secondaryContactIds"] = [];
            for (let item of this.secondaryContactIds)
                data["secondaryContactIds"].push(item);
        }
        if (Array.isArray(this.secondaryCxUserIds)) {
            data["secondaryCxUserIds"] = [];
            for (let item of this.secondaryCxUserIds)
                data["secondaryCxUserIds"].push(item);
        }
        data["configurationPageUrl"] = this.configurationPageUrl;
        data["totalRows"] = this.totalRows;
        return data;
    }
}

export interface ITicketDTO {
    id?: number;
    accountPhysicalLocationID?: number;
    rmmAlertID?: string | undefined;
    allocationCodeID?: number;
    assignedResourceRoleID?: number;
    businessDivisionSubdivisionID?: number;
    changeApprovalBoard?: number;
    changeApprovalStatus?: number;
    changeApprovalType?: number;
    changeInfoField1?: string | undefined;
    changeInfoField2?: string | undefined;
    changeInfoField3?: string | undefined;
    changeInfoField4?: string | undefined;
    changeInfoField5?: string | undefined;
    completedDate?: Date;
    contractID?: number;
    contractServiceBundleID?: number;
    contractServiceID?: number;
    createDate?: Date;
    creatorType?: number;
    description?: string | undefined;
    dueDateTime?: Date;
    estimatedHours?: number;
    externalID?: string | undefined;
    firstResponseAssignedResourceID?: number;
    firstResponseDateTime?: Date;
    firstResponseDueDateTime?: Date;
    firstResponseInitiatingResourceID?: number;
    hoursToBeScheduled?: number;
    installedProductID?: number;
    issueType?: number;
    lastActivityDate?: Date;
    lastActivityPersonType?: number;
    lastCustomerNotificationDateTime?: Date;
    lastCustomerVisibleActivityDateTime?: Date;
    monitorID?: number;
    monitorTypeID?: number;
    opportunityID?: number;
    priority?: number;
    problemTicketID?: number;
    projectID?: number;
    purchaseOrderNumber?: string | undefined;
    queueID?: number;
    resolution?: string | undefined;
    resolutionPlanDateTime?: Date;
    resolutionPlanDueDateTime?: Date;
    resolvedDateTime?: Date;
    resolvedDueDateTime?: Date;
    serviceLevelAgreementHasBeenMet?: boolean;
    serviceLevelAgreementID?: number;
    source?: number;
    status?: number;
    subIssueType?: number;
    ticketCategory?: number;
    ticketNumber?: string | undefined;
    ticketType?: number;
    title?: string | undefined;
    accountID?: number | undefined;
    contactID?: number | undefined;
    contactName?: string | undefined;
    lastActivity?: Date;
    ticketNotes?: TicketNoteDTO[] | undefined;
    assignedResourceID?: number | undefined;
    completedByResourceID?: number | undefined;
    creatorResourceID?: number | undefined;
    lastActivityResourceID?: number | undefined;
    deleted?: boolean;
    assignedResourceName?: string | undefined;
    completedByResourceName?: string | undefined;
    creatorResourceName?: string | undefined;
    lastActivityResourceName?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    ticketAttachmentGuids?: string[] | undefined;
    ticketAttachments?: TicketAttachmentDTO[] | undefined;
    secondaryContactIds?: number[] | undefined;
    secondaryCxUserIds?: string[] | undefined;
    configurationPageUrl?: string | undefined;
    totalRows?: number | undefined;
}

export class TicketMetadataDto implements ITicketMetadataDto {
    id?: number;
    accountId?: number;
    lastActivityDate?: Date;
    deleted?: boolean;

    constructor(data?: ITicketMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): TicketMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : undefined as any;
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface ITicketMetadataDto {
    id?: number;
    accountId?: number;
    lastActivityDate?: Date;
    deleted?: boolean;
}

export class TicketNoteDTO implements ITicketNoteDTO {
    id?: number;
    creatorResourceID?: number;
    resourceName?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    noteType?: number;
    publish?: number;
    lastActivityDate?: Date;
    ticketID?: number | undefined;
    ticketAttachmentGuids?: string[] | undefined;
    ticketAttachments?: TicketAttachmentDTO[] | undefined;

    constructor(data?: ITicketNoteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorResourceID = _data["creatorResourceID"];
            this.resourceName = _data["resourceName"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.noteType = _data["noteType"];
            this.publish = _data["publish"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
            this.ticketID = _data["ticketID"];
            if (Array.isArray(_data["ticketAttachmentGuids"])) {
                this.ticketAttachmentGuids = [] as any;
                for (let item of _data["ticketAttachmentGuids"])
                    this.ticketAttachmentGuids!.push(item);
            }
            if (Array.isArray(_data["ticketAttachments"])) {
                this.ticketAttachments = [] as any;
                for (let item of _data["ticketAttachments"])
                    this.ticketAttachments!.push(TicketAttachmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketNoteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketNoteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorResourceID"] = this.creatorResourceID;
        data["resourceName"] = this.resourceName;
        data["title"] = this.title;
        data["description"] = this.description;
        data["noteType"] = this.noteType;
        data["publish"] = this.publish;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : undefined as any;
        data["ticketID"] = this.ticketID;
        if (Array.isArray(this.ticketAttachmentGuids)) {
            data["ticketAttachmentGuids"] = [];
            for (let item of this.ticketAttachmentGuids)
                data["ticketAttachmentGuids"].push(item);
        }
        if (Array.isArray(this.ticketAttachments)) {
            data["ticketAttachments"] = [];
            for (let item of this.ticketAttachments)
                data["ticketAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketNoteDTO {
    id?: number;
    creatorResourceID?: number;
    resourceName?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    noteType?: number;
    publish?: number;
    lastActivityDate?: Date;
    ticketID?: number | undefined;
    ticketAttachmentGuids?: string[] | undefined;
    ticketAttachments?: TicketAttachmentDTO[] | undefined;
}

export class TicketNoteMetadataDto implements ITicketNoteMetadataDto {
    id?: number;
    ticketId?: number;
    lastActivityDate?: Date;

    constructor(data?: ITicketNoteMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketId = _data["ticketId"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TicketNoteMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketNoteMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketId"] = this.ticketId;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ITicketNoteMetadataDto {
    id?: number;
    ticketId?: number;
    lastActivityDate?: Date;
}

export class TimeEntryMetadataDto implements ITimeEntryMetadataDto {
    id?: number;
    ticketId?: number;
    lastActivityDate?: Date;

    constructor(data?: ITimeEntryMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketId = _data["ticketId"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TimeEntryMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketId"] = this.ticketId;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ITimeEntryMetadataDto {
    id?: number;
    ticketId?: number;
    lastActivityDate?: Date;
}

/** Request body for updating subscription auto-renew setting. */
export class UpdateAutoRenewRequest implements IUpdateAutoRenewRequest {
    enable?: boolean;

    constructor(data?: IUpdateAutoRenewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): UpdateAutoRenewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAutoRenewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }
}

/** Request body for updating subscription auto-renew setting. */
export interface IUpdateAutoRenewRequest {
    enable?: boolean;
}

/** Request body for updating subscription seat count. */
export class UpdateQuantityRequest implements IUpdateQuantityRequest {
    quantity?: number;

    constructor(data?: IUpdateQuantityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): UpdateQuantityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuantityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        return data;
    }
}

/** Request body for updating subscription seat count. */
export interface IUpdateQuantityRequest {
    quantity?: number;
}

export class UpdateServiceRequestContactsResponse implements IUpdateServiceRequestContactsResponse {
    contacts?: ContactDto[] | undefined;
    failed?: ServiceRequestContactCandidateDto[] | undefined;

    constructor(data?: IUpdateServiceRequestContactsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactDto.fromJS(item));
            }
            if (Array.isArray(_data["failed"])) {
                this.failed = [] as any;
                for (let item of _data["failed"])
                    this.failed!.push(ServiceRequestContactCandidateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateServiceRequestContactsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceRequestContactsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.failed)) {
            data["failed"] = [];
            for (let item of this.failed)
                data["failed"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateServiceRequestContactsResponse {
    contacts?: ContactDto[] | undefined;
    failed?: ServiceRequestContactCandidateDto[] | undefined;
}

/** Request body for updating a CSP subscription. All fields are optional; only provided fields are applied. */
export class UpdateSubscriptionRequest implements IUpdateSubscriptionRequest {
    autoRenew?: boolean | undefined;
    quantity?: number | undefined;
    scheduleChange?: ScheduleSubscriptionChangeDto;

    constructor(data?: IUpdateSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoRenew = _data["autoRenew"];
            this.quantity = _data["quantity"];
            this.scheduleChange = _data["scheduleChange"] ? ScheduleSubscriptionChangeDto.fromJS(_data["scheduleChange"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateSubscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoRenew"] = this.autoRenew;
        data["quantity"] = this.quantity;
        data["scheduleChange"] = this.scheduleChange ? this.scheduleChange.toJSON() : undefined as any;
        return data;
    }
}

/** Request body for updating a CSP subscription. All fields are optional; only provided fields are applied. */
export interface IUpdateSubscriptionRequest {
    autoRenew?: boolean | undefined;
    quantity?: number | undefined;
    scheduleChange?: ScheduleSubscriptionChangeDto;
}

export class WarehousePickOrderDTO extends IntegrationDTO implements IWarehousePickOrderDTO {
    integrationType?: IntegrationType;
    metadata?: WarehousePickOrderIntegrationMetadata;

    constructor(data?: IWarehousePickOrderDTO) {
        super(data);
        this._discriminator = "WarehousePickOrderDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? WarehousePickOrderIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): WarehousePickOrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousePickOrderDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IWarehousePickOrderDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: WarehousePickOrderIntegrationMetadata;
}

export class SimpleCloudContract implements ISimpleCloudContract {
    id?: number;
    accountId?: number;
    contractCategory?: number;
    contractName?: string | undefined;

    constructor(data?: ISimpleCloudContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.contractCategory = _data["contractCategory"];
            this.contractName = _data["contractName"];
        }
    }

    static fromJS(data: any): SimpleCloudContract {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleCloudContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["contractCategory"] = this.contractCategory;
        data["contractName"] = this.contractName;
        return data;
    }
}

export interface ISimpleCloudContract {
    id?: number;
    accountId?: number;
    contractCategory?: number;
    contractName?: string | undefined;
}

export class DatadogUsageReportIntegrationMetadata extends IntegrationMetadata implements IDatadogUsageReportIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: IDatadogUsageReportIntegrationMetadata) {
        super(data);
        this._discriminator = "DatadogUsageReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): DatadogUsageReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new DatadogUsageReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IDatadogUsageReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class Antivirus implements IAntivirus {
    antivirusProduct?: string | undefined;
    antivirusStatus?: string | undefined;

    constructor(data?: IAntivirus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.antivirusProduct = _data["antivirusProduct"];
            this.antivirusStatus = _data["antivirusStatus"];
        }
    }

    static fromJS(data: any): Antivirus {
        data = typeof data === 'object' ? data : {};
        let result = new Antivirus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["antivirusProduct"] = this.antivirusProduct;
        data["antivirusStatus"] = this.antivirusStatus;
        return data;
    }
}

export interface IAntivirus {
    antivirusProduct?: string | undefined;
    antivirusStatus?: string | undefined;
}

export class DattoRMMIntegrationMetadata extends IntegrationMetadata implements IDattoRMMIntegrationMetadata {
    dattoSite?: DattoSite;

    constructor(data?: IDattoRMMIntegrationMetadata) {
        super(data);
        this._discriminator = "DattoRMMIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dattoSite = _data["dattoSite"] ? DattoSite.fromJS(_data["dattoSite"]) : undefined as any;
        }
    }

    static override fromJS(data: any): DattoRMMIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRMMIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dattoSite"] = this.dattoSite ? this.dattoSite.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDattoRMMIntegrationMetadata extends IIntegrationMetadata {
    dattoSite?: DattoSite;
}

export class DattoRmmDevice implements IDattoRmmDevice {
    id?: number;
    uid?: string | undefined;
    siteId?: number;
    siteUid?: string | undefined;
    siteName?: string | undefined;
    deviceType?: DeviceType;
    hostname?: string | undefined;
    intIpAddress?: string | undefined;
    operatingSystem?: string | undefined;
    lastLoggedInUser?: string | undefined;
    domain?: string | undefined;
    cagVersion?: string | undefined;
    displayVersion?: string | undefined;
    extIpAddress?: string | undefined;
    description?: string | undefined;
    a64Bit?: boolean | undefined;
    rebootRequired?: boolean | undefined;
    online?: boolean | undefined;
    suspended?: boolean | undefined;
    deleted?: boolean | undefined;
    lastSeen?: number | undefined;
    lastReboot?: number | undefined;
    lastAuditDate?: number | undefined;
    creationDate?: number | undefined;
    udf?: Udf;
    snmpEnabled?: boolean | undefined;
    deviceClass?: string | undefined;
    portalUrl?: string | undefined;
    warrantyDate?: any | undefined;
    antivirus?: Antivirus;
    patchManagement?: PatchManagement;
    softwareStatus?: string | undefined;

    constructor(data?: IDattoRmmDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.siteId = _data["siteId"];
            this.siteUid = _data["siteUid"];
            this.siteName = _data["siteName"];
            this.deviceType = _data["deviceType"] ? DeviceType.fromJS(_data["deviceType"]) : undefined as any;
            this.hostname = _data["hostname"];
            this.intIpAddress = _data["intIpAddress"];
            this.operatingSystem = _data["operatingSystem"];
            this.lastLoggedInUser = _data["lastLoggedInUser"];
            this.domain = _data["domain"];
            this.cagVersion = _data["cagVersion"];
            this.displayVersion = _data["displayVersion"];
            this.extIpAddress = _data["extIpAddress"];
            this.description = _data["description"];
            this.a64Bit = _data["a64Bit"];
            this.rebootRequired = _data["rebootRequired"];
            this.online = _data["online"];
            this.suspended = _data["suspended"];
            this.deleted = _data["deleted"];
            this.lastSeen = _data["lastSeen"];
            this.lastReboot = _data["lastReboot"];
            this.lastAuditDate = _data["lastAuditDate"];
            this.creationDate = _data["creationDate"];
            this.udf = _data["udf"] ? Udf.fromJS(_data["udf"]) : undefined as any;
            this.snmpEnabled = _data["snmpEnabled"];
            this.deviceClass = _data["deviceClass"];
            this.portalUrl = _data["portalUrl"];
            this.warrantyDate = _data["warrantyDate"];
            this.antivirus = _data["antivirus"] ? Antivirus.fromJS(_data["antivirus"]) : undefined as any;
            this.patchManagement = _data["patchManagement"] ? PatchManagement.fromJS(_data["patchManagement"]) : undefined as any;
            this.softwareStatus = _data["softwareStatus"];
        }
    }

    static fromJS(data: any): DattoRmmDevice {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRmmDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["siteId"] = this.siteId;
        data["siteUid"] = this.siteUid;
        data["siteName"] = this.siteName;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : undefined as any;
        data["hostname"] = this.hostname;
        data["intIpAddress"] = this.intIpAddress;
        data["operatingSystem"] = this.operatingSystem;
        data["lastLoggedInUser"] = this.lastLoggedInUser;
        data["domain"] = this.domain;
        data["cagVersion"] = this.cagVersion;
        data["displayVersion"] = this.displayVersion;
        data["extIpAddress"] = this.extIpAddress;
        data["description"] = this.description;
        data["a64Bit"] = this.a64Bit;
        data["rebootRequired"] = this.rebootRequired;
        data["online"] = this.online;
        data["suspended"] = this.suspended;
        data["deleted"] = this.deleted;
        data["lastSeen"] = this.lastSeen;
        data["lastReboot"] = this.lastReboot;
        data["lastAuditDate"] = this.lastAuditDate;
        data["creationDate"] = this.creationDate;
        data["udf"] = this.udf ? this.udf.toJSON() : undefined as any;
        data["snmpEnabled"] = this.snmpEnabled;
        data["deviceClass"] = this.deviceClass;
        data["portalUrl"] = this.portalUrl;
        data["warrantyDate"] = this.warrantyDate;
        data["antivirus"] = this.antivirus ? this.antivirus.toJSON() : undefined as any;
        data["patchManagement"] = this.patchManagement ? this.patchManagement.toJSON() : undefined as any;
        data["softwareStatus"] = this.softwareStatus;
        return data;
    }
}

export interface IDattoRmmDevice {
    id?: number;
    uid?: string | undefined;
    siteId?: number;
    siteUid?: string | undefined;
    siteName?: string | undefined;
    deviceType?: DeviceType;
    hostname?: string | undefined;
    intIpAddress?: string | undefined;
    operatingSystem?: string | undefined;
    lastLoggedInUser?: string | undefined;
    domain?: string | undefined;
    cagVersion?: string | undefined;
    displayVersion?: string | undefined;
    extIpAddress?: string | undefined;
    description?: string | undefined;
    a64Bit?: boolean | undefined;
    rebootRequired?: boolean | undefined;
    online?: boolean | undefined;
    suspended?: boolean | undefined;
    deleted?: boolean | undefined;
    lastSeen?: number | undefined;
    lastReboot?: number | undefined;
    lastAuditDate?: number | undefined;
    creationDate?: number | undefined;
    udf?: Udf;
    snmpEnabled?: boolean | undefined;
    deviceClass?: string | undefined;
    portalUrl?: string | undefined;
    warrantyDate?: any | undefined;
    antivirus?: Antivirus;
    patchManagement?: PatchManagement;
    softwareStatus?: string | undefined;
}

export class DattoRmmDevicesRequest implements IDattoRmmDevicesRequest {
    siteUid?: string | undefined;
    skip?: number;
    take?: number;

    constructor(data?: IDattoRmmDevicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteUid = _data["siteUid"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): DattoRmmDevicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DattoRmmDevicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteUid"] = this.siteUid;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IDattoRmmDevicesRequest {
    siteUid?: string | undefined;
    skip?: number;
    take?: number;
}

export class DeviceType implements IDeviceType {
    category?: string | undefined;
    type?: string | undefined;

    constructor(data?: IDeviceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DeviceType {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["type"] = this.type;
        return data;
    }
}

export interface IDeviceType {
    category?: string | undefined;
    type?: string | undefined;
}

export class PatchManagement implements IPatchManagement {
    patchStatus?: string | undefined;
    patchesApprovedPending?: number | undefined;
    patchesNotApproved?: number | undefined;
    patchesInstalled?: number | undefined;

    constructor(data?: IPatchManagement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patchStatus = _data["patchStatus"];
            this.patchesApprovedPending = _data["patchesApprovedPending"];
            this.patchesNotApproved = _data["patchesNotApproved"];
            this.patchesInstalled = _data["patchesInstalled"];
        }
    }

    static fromJS(data: any): PatchManagement {
        data = typeof data === 'object' ? data : {};
        let result = new PatchManagement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patchStatus"] = this.patchStatus;
        data["patchesApprovedPending"] = this.patchesApprovedPending;
        data["patchesNotApproved"] = this.patchesNotApproved;
        data["patchesInstalled"] = this.patchesInstalled;
        return data;
    }
}

export interface IPatchManagement {
    patchStatus?: string | undefined;
    patchesApprovedPending?: number | undefined;
    patchesNotApproved?: number | undefined;
    patchesInstalled?: number | undefined;
}

export class Udf implements IUdf {
    udf1?: any | undefined;
    udf2?: any | undefined;
    udf3?: any | undefined;
    udf4?: any | undefined;
    udf5?: any | undefined;
    udf6?: any | undefined;
    udf7?: any | undefined;
    udf8?: any | undefined;
    udf9?: any | undefined;
    udf10?: string | undefined;
    udf11?: string | undefined;
    udf12?: any | undefined;
    udf13?: any | undefined;
    udf14?: any | undefined;
    udf15?: any | undefined;
    udf16?: any | undefined;
    udf17?: any | undefined;
    udf18?: any | undefined;
    udf19?: any | undefined;
    udf20?: any | undefined;
    udf21?: any | undefined;
    udf22?: string | undefined;
    udf23?: any | undefined;
    udf24?: any | undefined;
    udf25?: any | undefined;
    udf26?: any | undefined;
    udf27?: string | undefined;
    udf28?: string | undefined;
    udf29?: any | undefined;
    udf30?: any | undefined;

    constructor(data?: IUdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.udf1 = _data["udf1"];
            this.udf2 = _data["udf2"];
            this.udf3 = _data["udf3"];
            this.udf4 = _data["udf4"];
            this.udf5 = _data["udf5"];
            this.udf6 = _data["udf6"];
            this.udf7 = _data["udf7"];
            this.udf8 = _data["udf8"];
            this.udf9 = _data["udf9"];
            this.udf10 = _data["udf10"];
            this.udf11 = _data["udf11"];
            this.udf12 = _data["udf12"];
            this.udf13 = _data["udf13"];
            this.udf14 = _data["udf14"];
            this.udf15 = _data["udf15"];
            this.udf16 = _data["udf16"];
            this.udf17 = _data["udf17"];
            this.udf18 = _data["udf18"];
            this.udf19 = _data["udf19"];
            this.udf20 = _data["udf20"];
            this.udf21 = _data["udf21"];
            this.udf22 = _data["udf22"];
            this.udf23 = _data["udf23"];
            this.udf24 = _data["udf24"];
            this.udf25 = _data["udf25"];
            this.udf26 = _data["udf26"];
            this.udf27 = _data["udf27"];
            this.udf28 = _data["udf28"];
            this.udf29 = _data["udf29"];
            this.udf30 = _data["udf30"];
        }
    }

    static fromJS(data: any): Udf {
        data = typeof data === 'object' ? data : {};
        let result = new Udf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["udf1"] = this.udf1;
        data["udf2"] = this.udf2;
        data["udf3"] = this.udf3;
        data["udf4"] = this.udf4;
        data["udf5"] = this.udf5;
        data["udf6"] = this.udf6;
        data["udf7"] = this.udf7;
        data["udf8"] = this.udf8;
        data["udf9"] = this.udf9;
        data["udf10"] = this.udf10;
        data["udf11"] = this.udf11;
        data["udf12"] = this.udf12;
        data["udf13"] = this.udf13;
        data["udf14"] = this.udf14;
        data["udf15"] = this.udf15;
        data["udf16"] = this.udf16;
        data["udf17"] = this.udf17;
        data["udf18"] = this.udf18;
        data["udf19"] = this.udf19;
        data["udf20"] = this.udf20;
        data["udf21"] = this.udf21;
        data["udf22"] = this.udf22;
        data["udf23"] = this.udf23;
        data["udf24"] = this.udf24;
        data["udf25"] = this.udf25;
        data["udf26"] = this.udf26;
        data["udf27"] = this.udf27;
        data["udf28"] = this.udf28;
        data["udf29"] = this.udf29;
        data["udf30"] = this.udf30;
        return data;
    }
}

export interface IUdf {
    udf1?: any | undefined;
    udf2?: any | undefined;
    udf3?: any | undefined;
    udf4?: any | undefined;
    udf5?: any | undefined;
    udf6?: any | undefined;
    udf7?: any | undefined;
    udf8?: any | undefined;
    udf9?: any | undefined;
    udf10?: string | undefined;
    udf11?: string | undefined;
    udf12?: any | undefined;
    udf13?: any | undefined;
    udf14?: any | undefined;
    udf15?: any | undefined;
    udf16?: any | undefined;
    udf17?: any | undefined;
    udf18?: any | undefined;
    udf19?: any | undefined;
    udf20?: any | undefined;
    udf21?: any | undefined;
    udf22?: string | undefined;
    udf23?: any | undefined;
    udf24?: any | undefined;
    udf25?: any | undefined;
    udf26?: any | undefined;
    udf27?: string | undefined;
    udf28?: string | undefined;
    udf29?: any | undefined;
    udf30?: any | undefined;
}

export class DynamicTagRequest implements IDynamicTagRequest {
    accountId?: number;
    axReferences?: string[] | undefined;
    userId?: string | undefined;
    sourceIdentifier?: string | undefined;
    tagType?: string | undefined;
    dynamicTags?: DynamicTag[] | undefined;

    constructor(data?: IDynamicTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["axReferences"])) {
                this.axReferences = [] as any;
                for (let item of _data["axReferences"])
                    this.axReferences!.push(item);
            }
            this.userId = _data["userId"];
            this.sourceIdentifier = _data["sourceIdentifier"];
            this.tagType = _data["tagType"];
            if (Array.isArray(_data["dynamicTags"])) {
                this.dynamicTags = [] as any;
                for (let item of _data["dynamicTags"])
                    this.dynamicTags!.push(DynamicTag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DynamicTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        if (Array.isArray(this.axReferences)) {
            data["axReferences"] = [];
            for (let item of this.axReferences)
                data["axReferences"].push(item);
        }
        data["userId"] = this.userId;
        data["sourceIdentifier"] = this.sourceIdentifier;
        data["tagType"] = this.tagType;
        if (Array.isArray(this.dynamicTags)) {
            data["dynamicTags"] = [];
            for (let item of this.dynamicTags)
                data["dynamicTags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDynamicTagRequest {
    accountId?: number;
    axReferences?: string[] | undefined;
    userId?: string | undefined;
    sourceIdentifier?: string | undefined;
    tagType?: string | undefined;
    dynamicTags?: DynamicTag[] | undefined;
}

export class FileDownloadResponse implements IFileDownloadResponse {
    file?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IFileDownloadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): FileDownloadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IFileDownloadResponse {
    file?: string | undefined;
    errorMessage?: string | undefined;
}

export class FileUploadResponse_1OfCiscoSupplementalDataDto implements IFileUploadResponse_1OfCiscoSupplementalDataDto {
    warnings?: FileHandlerUploadRecord_1OfCiscoSupplementalDataDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: IFileUploadResponse_1OfCiscoSupplementalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(FileHandlerUploadRecord_1OfCiscoSupplementalDataDto.fromJS(item));
            }
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : undefined as any;
        }
    }

    static fromJS(data: any): FileUploadResponse_1OfCiscoSupplementalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse_1OfCiscoSupplementalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : undefined as any;
        return data;
    }
}

export interface IFileUploadResponse_1OfCiscoSupplementalDataDto {
    warnings?: FileHandlerUploadRecord_1OfCiscoSupplementalDataDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;
}

export class FileUploadResponse_1OfCiscoThirdPartyContractDataDto implements IFileUploadResponse_1OfCiscoThirdPartyContractDataDto {
    warnings?: FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: IFileUploadResponse_1OfCiscoThirdPartyContractDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto.fromJS(item));
            }
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : undefined as any;
        }
    }

    static fromJS(data: any): FileUploadResponse_1OfCiscoThirdPartyContractDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse_1OfCiscoThirdPartyContractDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : undefined as any;
        return data;
    }
}

export interface IFileUploadResponse_1OfCiscoThirdPartyContractDataDto {
    warnings?: FileHandlerUploadRecord_1OfCiscoThirdPartyContractDataDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;
}

export class FileUploadResponse_1OfManualManagedAssetDataRecordDto implements IFileUploadResponse_1OfManualManagedAssetDataRecordDto {
    warnings?: FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: IFileUploadResponse_1OfManualManagedAssetDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto.fromJS(item));
            }
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : undefined as any;
        }
    }

    static fromJS(data: any): FileUploadResponse_1OfManualManagedAssetDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse_1OfManualManagedAssetDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : undefined as any;
        return data;
    }
}

export interface IFileUploadResponse_1OfManualManagedAssetDataRecordDto {
    warnings?: FileHandlerUploadRecord_1OfManualManagedAssetDataRecordDto[] | undefined;
    integrationRecord?: IntegrationDTO | undefined;
}

export class GcpCloudAssetInventoryMetadata extends IntegrationMetadata implements IGcpCloudAssetInventoryMetadata {
    authorizationScope?: string | undefined;
    serviceAccountKey?: string | undefined;

    constructor(data?: IGcpCloudAssetInventoryMetadata) {
        super(data);
        this._discriminator = "GcpCloudAssetInventoryMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authorizationScope = _data["authorizationScope"];
            this.serviceAccountKey = _data["serviceAccountKey"];
        }
    }

    static override fromJS(data: any): GcpCloudAssetInventoryMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new GcpCloudAssetInventoryMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationScope"] = this.authorizationScope;
        data["serviceAccountKey"] = this.serviceAccountKey;
        super.toJSON(data);
        return data;
    }
}

export interface IGcpCloudAssetInventoryMetadata extends IIntegrationMetadata {
    authorizationScope?: string | undefined;
    serviceAccountKey?: string | undefined;
}

export class GcpUsageReportIntegrationDTO extends IntegrationDTO implements IGcpUsageReportIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: GcpUsageReportIntegrationMetadata;

    constructor(data?: IGcpUsageReportIntegrationDTO) {
        super(data);
        this._discriminator = "GcpUsageReportIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            this.metadata = _data["metadata"] ? GcpUsageReportIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GcpUsageReportIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GcpUsageReportIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGcpUsageReportIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    metadata?: GcpUsageReportIntegrationMetadata;
}

export class GcpUsageReportIntegrationMetadata extends IntegrationMetadata implements IGcpUsageReportIntegrationMetadata {
    axAccount?: string | undefined;

    constructor(data?: IGcpUsageReportIntegrationMetadata) {
        super(data);
        this._discriminator = "GcpUsageReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): GcpUsageReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new GcpUsageReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IGcpUsageReportIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
}

export class HardwareLifecycleIntegrationMetadata extends IntegrationMetadata implements IHardwareLifecycleIntegrationMetadata {
    deviceMakeModel?: string | undefined;

    constructor(data?: IHardwareLifecycleIntegrationMetadata) {
        super(data);
        this._discriminator = "HardwareLifecycleIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceMakeModel = _data["deviceMakeModel"];
        }
    }

    static override fromJS(data: any): HardwareLifecycleIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new HardwareLifecycleIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceMakeModel"] = this.deviceMakeModel;
        super.toJSON(data);
        return data;
    }
}

export interface IHardwareLifecycleIntegrationMetadata extends IIntegrationMetadata {
    deviceMakeModel?: string | undefined;
}

export class IbaIntegrationMetadata extends IntegrationMetadata implements IIbaIntegrationMetadata {
    integrations?: MappingEngineMetadata[] | undefined;

    constructor(data?: IIbaIntegrationMetadata) {
        super(data);
        this._discriminator = "IbaIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["integrations"])) {
                this.integrations = [] as any;
                for (let item of _data["integrations"])
                    this.integrations!.push(MappingEngineMetadata.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): IbaIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new IbaIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.integrations)) {
            data["integrations"] = [];
            for (let item of this.integrations)
                data["integrations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIbaIntegrationMetadata extends IIntegrationMetadata {
    integrations?: MappingEngineMetadata[] | undefined;
}

export class IdcsReportIntegrationMetadata extends IntegrationMetadata implements IIdcsReportIntegrationMetadata {
    axNumber?: string | undefined;
    reportDescription?: string | undefined;
    reportKeys?: WarehouseReportConfig[] | undefined;

    constructor(data?: IIdcsReportIntegrationMetadata) {
        super(data);
        this._discriminator = "IdcsReportIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axNumber = _data["axNumber"];
            this.reportDescription = _data["reportDescription"];
            if (Array.isArray(_data["reportKeys"])) {
                this.reportKeys = [] as any;
                for (let item of _data["reportKeys"])
                    this.reportKeys!.push(WarehouseReportConfig.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): IdcsReportIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new IdcsReportIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axNumber"] = this.axNumber;
        data["reportDescription"] = this.reportDescription;
        if (Array.isArray(this.reportKeys)) {
            data["reportKeys"] = [];
            for (let item of this.reportKeys)
                data["reportKeys"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIdcsReportIntegrationMetadata extends IIntegrationMetadata {
    axNumber?: string | undefined;
    reportDescription?: string | undefined;
    reportKeys?: WarehouseReportConfig[] | undefined;
}

export class InsertWelcomeMessageBodyRequest implements IInsertWelcomeMessageBodyRequest {
    messageText?: string | undefined;
    oldMessageKey?: string | undefined;

    constructor(data?: IInsertWelcomeMessageBodyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageText = _data["messageText"];
            this.oldMessageKey = _data["oldMessageKey"];
        }
    }

    static fromJS(data: any): InsertWelcomeMessageBodyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertWelcomeMessageBodyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageText"] = this.messageText;
        data["oldMessageKey"] = this.oldMessageKey;
        return data;
    }
}

export interface IInsertWelcomeMessageBodyRequest {
    messageText?: string | undefined;
    oldMessageKey?: string | undefined;
}

export class IntegrationDefinition implements IIntegrationDefinition {
    id?: number;
    integrationTitle?: string | undefined;
    enabled?: boolean;
    selfRegister?: boolean;
    statusVisibleToCustomer?: boolean;
    configurationVisibleToCustomer?: boolean;
    configurationVisibleToShi?: boolean;
    thumbnailImageUrl?: string | undefined;
    contentMarkdownUrl?: string | undefined;
    requiresEulaAgreement?: boolean;
    eulaAgreementUrl?: string | undefined;
    integrationDescriptionMarkdown?: string | undefined;
    activationDescription?: string | undefined;
    multipleIntegrationsAllowed?: boolean;
    integrationType?: IntegrationType;
    integrationGroup?: IntegrationGroup;
    canSelfConnect?: boolean;

    constructor(data?: IIntegrationDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.integrationTitle = _data["integrationTitle"];
            this.enabled = _data["enabled"];
            this.selfRegister = _data["selfRegister"];
            this.statusVisibleToCustomer = _data["statusVisibleToCustomer"];
            this.configurationVisibleToCustomer = _data["configurationVisibleToCustomer"];
            this.configurationVisibleToShi = _data["configurationVisibleToShi"];
            this.thumbnailImageUrl = _data["thumbnailImageUrl"];
            this.contentMarkdownUrl = _data["contentMarkdownUrl"];
            this.requiresEulaAgreement = _data["requiresEulaAgreement"];
            this.eulaAgreementUrl = _data["eulaAgreementUrl"];
            this.integrationDescriptionMarkdown = _data["integrationDescriptionMarkdown"];
            this.activationDescription = _data["activationDescription"];
            this.multipleIntegrationsAllowed = _data["multipleIntegrationsAllowed"];
            this.integrationType = _data["integrationType"];
            this.integrationGroup = _data["integrationGroup"];
            this.canSelfConnect = _data["canSelfConnect"];
        }
    }

    static fromJS(data: any): IntegrationDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["integrationTitle"] = this.integrationTitle;
        data["enabled"] = this.enabled;
        data["selfRegister"] = this.selfRegister;
        data["statusVisibleToCustomer"] = this.statusVisibleToCustomer;
        data["configurationVisibleToCustomer"] = this.configurationVisibleToCustomer;
        data["configurationVisibleToShi"] = this.configurationVisibleToShi;
        data["thumbnailImageUrl"] = this.thumbnailImageUrl;
        data["contentMarkdownUrl"] = this.contentMarkdownUrl;
        data["requiresEulaAgreement"] = this.requiresEulaAgreement;
        data["eulaAgreementUrl"] = this.eulaAgreementUrl;
        data["integrationDescriptionMarkdown"] = this.integrationDescriptionMarkdown;
        data["activationDescription"] = this.activationDescription;
        data["multipleIntegrationsAllowed"] = this.multipleIntegrationsAllowed;
        data["integrationType"] = this.integrationType;
        data["integrationGroup"] = this.integrationGroup;
        data["canSelfConnect"] = this.canSelfConnect;
        return data;
    }
}

export interface IIntegrationDefinition {
    id?: number;
    integrationTitle?: string | undefined;
    enabled?: boolean;
    selfRegister?: boolean;
    statusVisibleToCustomer?: boolean;
    configurationVisibleToCustomer?: boolean;
    configurationVisibleToShi?: boolean;
    thumbnailImageUrl?: string | undefined;
    contentMarkdownUrl?: string | undefined;
    requiresEulaAgreement?: boolean;
    eulaAgreementUrl?: string | undefined;
    integrationDescriptionMarkdown?: string | undefined;
    activationDescription?: string | undefined;
    multipleIntegrationsAllowed?: boolean;
    integrationType?: IntegrationType;
    integrationGroup?: IntegrationGroup;
    canSelfConnect?: boolean;
}

export class AzureAssetIntegrationDTO extends IntegrationDTO implements IAzureAssetIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureAssetIntegrationMetadata;

    constructor(data?: IAzureAssetIntegrationDTO) {
        super(data);
        this._discriminator = "AzureAssetIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureAssetIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AzureAssetIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureAssetIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureAssetIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureAssetIntegrationMetadata;
}

export class AzureCostAndUsageIntegrationDTO extends IntegrationDTO implements IAzureCostAndUsageIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: AzureCostAndUsageIntegrationMetadata;

    constructor(data?: IAzureCostAndUsageIntegrationDTO) {
        super(data);
        this._discriminator = "AzureCostAndUsageIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? AzureCostAndUsageIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AzureCostAndUsageIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AzureCostAndUsageIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureCostAndUsageIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: AzureCostAndUsageIntegrationMetadata;
}

export class Microsoft365ReportsIntegrationDTO extends IntegrationDTO implements IMicrosoft365ReportsIntegrationDTO {
    integrationType?: IntegrationType;
    readonly identifier?: string | undefined;
    metadata?: Microsoft365ReportsIntegrationMetadata;

    constructor(data?: IMicrosoft365ReportsIntegrationDTO) {
        super(data);
        this._discriminator = "Microsoft365ReportsIntegrationDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.integrationType = _data["integrationType"];
            (this as any).identifier = _data["identifier"];
            this.metadata = _data["metadata"] ? Microsoft365ReportsIntegrationMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): Microsoft365ReportsIntegrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Microsoft365ReportsIntegrationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationType"] = this.integrationType;
        data["identifier"] = this.identifier;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMicrosoft365ReportsIntegrationDTO extends IIntegrationDTO {
    integrationType?: IntegrationType;
    identifier?: string | undefined;
    metadata?: Microsoft365ReportsIntegrationMetadata;
}

export class AzureAssetIntegrationMetadata extends IntegrationMetadata implements IAzureAssetIntegrationMetadata {
    shiRegistrationGuid!: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    servicePrincipalRegistrationStatus?: RegistrationStatus;
    registrationLink?: string | undefined;
    linkCreationDate?: Date | undefined;
    linkCreationUser?: string | undefined;
    directoryAccessRegistrationStatus?: RegistrationStatus;
    isCallbackReceived?: boolean | undefined;
    callbackReceivedDate?: Date | undefined;
    callbackPermittedScope?: string | undefined;
    callbackState?: string | undefined;

    constructor(data?: IAzureAssetIntegrationMetadata) {
        super(data);
        this._discriminator = "AzureAssetIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shiRegistrationGuid = _data["shiRegistrationGuid"];
            this.domainName = _data["domainName"];
            this.tenantId = _data["tenantId"];
            this.applicationRegistrationId = _data["applicationRegistrationId"];
            this.servicePrincipalRegistrationStatus = _data["servicePrincipalRegistrationStatus"];
            this.registrationLink = _data["registrationLink"];
            this.linkCreationDate = _data["linkCreationDate"] ? new Date(_data["linkCreationDate"].toString()) : undefined as any;
            this.linkCreationUser = _data["linkCreationUser"];
            this.directoryAccessRegistrationStatus = _data["directoryAccessRegistrationStatus"];
            this.isCallbackReceived = _data["isCallbackReceived"];
            this.callbackReceivedDate = _data["callbackReceivedDate"] ? new Date(_data["callbackReceivedDate"].toString()) : undefined as any;
            this.callbackPermittedScope = _data["callbackPermittedScope"];
            this.callbackState = _data["callbackState"];
        }
    }

    static override fromJS(data: any): AzureAssetIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzureAssetIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiRegistrationGuid"] = this.shiRegistrationGuid;
        data["domainName"] = this.domainName;
        data["tenantId"] = this.tenantId;
        data["applicationRegistrationId"] = this.applicationRegistrationId;
        data["servicePrincipalRegistrationStatus"] = this.servicePrincipalRegistrationStatus;
        data["registrationLink"] = this.registrationLink;
        data["linkCreationDate"] = this.linkCreationDate ? this.linkCreationDate.toISOString() : undefined as any;
        data["linkCreationUser"] = this.linkCreationUser;
        data["directoryAccessRegistrationStatus"] = this.directoryAccessRegistrationStatus;
        data["isCallbackReceived"] = this.isCallbackReceived;
        data["callbackReceivedDate"] = this.callbackReceivedDate ? this.callbackReceivedDate.toISOString() : undefined as any;
        data["callbackPermittedScope"] = this.callbackPermittedScope;
        data["callbackState"] = this.callbackState;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureAssetIntegrationMetadata extends IIntegrationMetadata {
    shiRegistrationGuid: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    servicePrincipalRegistrationStatus?: RegistrationStatus;
    registrationLink?: string | undefined;
    linkCreationDate?: Date | undefined;
    linkCreationUser?: string | undefined;
    directoryAccessRegistrationStatus?: RegistrationStatus;
    isCallbackReceived?: boolean | undefined;
    callbackReceivedDate?: Date | undefined;
    callbackPermittedScope?: string | undefined;
    callbackState?: string | undefined;
}

export class AzureCostAndUsageIntegrationMetadata extends IntegrationMetadata implements IAzureCostAndUsageIntegrationMetadata {
    shiRegistrationGuid!: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    storageAccountContributorStatus?: RegistrationStatus;
    azureStorageAccountSubscription?: string | undefined;
    azureResourceGroup?: string | undefined;
    azureStorageAccount?: string | undefined;
    hasAccessToStorageAccount?: boolean;

    constructor(data?: IAzureCostAndUsageIntegrationMetadata) {
        super(data);
        this._discriminator = "AzureCostAndUsageIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shiRegistrationGuid = _data["shiRegistrationGuid"];
            this.domainName = _data["domainName"];
            this.tenantId = _data["tenantId"];
            this.applicationRegistrationId = _data["applicationRegistrationId"];
            this.storageAccountContributorStatus = _data["storageAccountContributorStatus"];
            this.azureStorageAccountSubscription = _data["azureStorageAccountSubscription"];
            this.azureResourceGroup = _data["azureResourceGroup"];
            this.azureStorageAccount = _data["azureStorageAccount"];
            this.hasAccessToStorageAccount = _data["hasAccessToStorageAccount"];
        }
    }

    static override fromJS(data: any): AzureCostAndUsageIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new AzureCostAndUsageIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiRegistrationGuid"] = this.shiRegistrationGuid;
        data["domainName"] = this.domainName;
        data["tenantId"] = this.tenantId;
        data["applicationRegistrationId"] = this.applicationRegistrationId;
        data["storageAccountContributorStatus"] = this.storageAccountContributorStatus;
        data["azureStorageAccountSubscription"] = this.azureStorageAccountSubscription;
        data["azureResourceGroup"] = this.azureResourceGroup;
        data["azureStorageAccount"] = this.azureStorageAccount;
        data["hasAccessToStorageAccount"] = this.hasAccessToStorageAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IAzureCostAndUsageIntegrationMetadata extends IIntegrationMetadata {
    shiRegistrationGuid: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    storageAccountContributorStatus?: RegistrationStatus;
    azureStorageAccountSubscription?: string | undefined;
    azureResourceGroup?: string | undefined;
    azureStorageAccount?: string | undefined;
    hasAccessToStorageAccount?: boolean;
}

export enum RegistrationStatus {
    Pending = "Pending",
    Completed = "Completed",
    Failed = "Failed",
}

export class Microsoft365ReportsIntegrationMetadata extends IntegrationMetadata implements IMicrosoft365ReportsIntegrationMetadata {
    shiRegistrationGuid!: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    registrationLink?: string | undefined;
    linkCreationDate?: Date | undefined;
    linkCreationUser?: string | undefined;
    registrationStatus?: RegistrationStatus;
    isCallbackReceived?: boolean | undefined;
    callbackReceivedDate?: Date | undefined;
    callbackPermittedScope?: string | undefined;
    callbackState?: string | undefined;

    constructor(data?: IMicrosoft365ReportsIntegrationMetadata) {
        super(data);
        this._discriminator = "Microsoft365ReportsIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shiRegistrationGuid = _data["shiRegistrationGuid"];
            this.domainName = _data["domainName"];
            this.tenantId = _data["tenantId"];
            this.applicationRegistrationId = _data["applicationRegistrationId"];
            this.registrationLink = _data["registrationLink"];
            this.linkCreationDate = _data["linkCreationDate"] ? new Date(_data["linkCreationDate"].toString()) : undefined as any;
            this.linkCreationUser = _data["linkCreationUser"];
            this.registrationStatus = _data["registrationStatus"];
            this.isCallbackReceived = _data["isCallbackReceived"];
            this.callbackReceivedDate = _data["callbackReceivedDate"] ? new Date(_data["callbackReceivedDate"].toString()) : undefined as any;
            this.callbackPermittedScope = _data["callbackPermittedScope"];
            this.callbackState = _data["callbackState"];
        }
    }

    static override fromJS(data: any): Microsoft365ReportsIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new Microsoft365ReportsIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiRegistrationGuid"] = this.shiRegistrationGuid;
        data["domainName"] = this.domainName;
        data["tenantId"] = this.tenantId;
        data["applicationRegistrationId"] = this.applicationRegistrationId;
        data["registrationLink"] = this.registrationLink;
        data["linkCreationDate"] = this.linkCreationDate ? this.linkCreationDate.toISOString() : undefined as any;
        data["linkCreationUser"] = this.linkCreationUser;
        data["registrationStatus"] = this.registrationStatus;
        data["isCallbackReceived"] = this.isCallbackReceived;
        data["callbackReceivedDate"] = this.callbackReceivedDate ? this.callbackReceivedDate.toISOString() : undefined as any;
        data["callbackPermittedScope"] = this.callbackPermittedScope;
        data["callbackState"] = this.callbackState;
        super.toJSON(data);
        return data;
    }
}

export interface IMicrosoft365ReportsIntegrationMetadata extends IIntegrationMetadata {
    shiRegistrationGuid: string;
    domainName?: string | undefined;
    tenantId?: string | undefined;
    applicationRegistrationId?: string | undefined;
    registrationLink?: string | undefined;
    linkCreationDate?: Date | undefined;
    linkCreationUser?: string | undefined;
    registrationStatus?: RegistrationStatus;
    isCallbackReceived?: boolean | undefined;
    callbackReceivedDate?: Date | undefined;
    callbackPermittedScope?: string | undefined;
    callbackState?: string | undefined;
}

export class LicenseAllocation implements ILicenseAllocation {
    costCenterId!: number;
    licenseCount!: number;

    constructor(data?: ILicenseAllocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCenterId = _data["costCenterId"];
            this.licenseCount = _data["licenseCount"];
        }
    }

    static fromJS(data: any): LicenseAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCenterId"] = this.costCenterId;
        data["licenseCount"] = this.licenseCount;
        return data;
    }
}

export interface ILicenseAllocation {
    costCenterId: number;
    licenseCount: number;
}

export class Microsoft365CallbackDetails implements IMicrosoft365CallbackDetails {
    code?: string | undefined;
    registrationId?: string | undefined;
    registrationType?: IntegrationType;
    sessionState?: string | undefined;

    constructor(data?: IMicrosoft365CallbackDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.registrationId = _data["registrationId"];
            this.registrationType = _data["registrationType"];
            this.sessionState = _data["sessionState"];
        }
    }

    static fromJS(data: any): Microsoft365CallbackDetails {
        data = typeof data === 'object' ? data : {};
        let result = new Microsoft365CallbackDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["registrationId"] = this.registrationId;
        data["registrationType"] = this.registrationType;
        data["sessionState"] = this.sessionState;
        return data;
    }
}

export interface IMicrosoft365CallbackDetails {
    code?: string | undefined;
    registrationId?: string | undefined;
    registrationType?: IntegrationType;
    sessionState?: string | undefined;
}

export class RegistrationError implements IRegistrationError {
    errorInformation?: string | undefined;

    constructor(data?: IRegistrationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorInformation = _data["errorInformation"];
        }
    }

    static fromJS(data: any): RegistrationError {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorInformation"] = this.errorInformation;
        return data;
    }
}

export interface IRegistrationError {
    errorInformation?: string | undefined;
}

export class Microsoft365TenantConnection implements IMicrosoft365TenantConnection {
    tenantId?: string | undefined;
    currentState?: ConnectionStatus;
    errorMessage?: string | undefined;

    constructor(data?: IMicrosoft365TenantConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.currentState = _data["currentState"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): Microsoft365TenantConnection {
        data = typeof data === 'object' ? data : {};
        let result = new Microsoft365TenantConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["currentState"] = this.currentState;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IMicrosoft365TenantConnection {
    tenantId?: string | undefined;
    currentState?: ConnectionStatus;
    errorMessage?: string | undefined;
}

export class MicrosoftInsightsIntegrationMetadata extends IntegrationMetadata implements IMicrosoftInsightsIntegrationMetadata {
    tenantId?: string | undefined;
    axAccount?: string | undefined;

    constructor(data?: IMicrosoftInsightsIntegrationMetadata) {
        super(data);
        this._discriminator = "MicrosoftInsightsIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.axAccount = _data["axAccount"];
        }
    }

    static override fromJS(data: any): MicrosoftInsightsIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftInsightsIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["axAccount"] = this.axAccount;
        super.toJSON(data);
        return data;
    }
}

export interface IMicrosoftInsightsIntegrationMetadata extends IIntegrationMetadata {
    tenantId?: string | undefined;
    axAccount?: string | undefined;
}

export class MoveConfigurationItemRequest implements IMoveConfigurationItemRequest {
    configurationItemId!: number;
    targetCostCenterId!: number;

    constructor(data?: IMoveConfigurationItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            this.targetCostCenterId = _data["targetCostCenterId"];
        }
    }

    static fromJS(data: any): MoveConfigurationItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveConfigurationItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        data["targetCostCenterId"] = this.targetCostCenterId;
        return data;
    }
}

export interface IMoveConfigurationItemRequest {
    configurationItemId: number;
    targetCostCenterId: number;
}

export class LiveOpticsIntegrationMetadata extends IntegrationMetadata implements ILiveOpticsIntegrationMetadata {
    axAccount?: string | undefined;
    originalFilename?: string | undefined;
    processedFilename?: string | undefined;
    fileSubmissionUtcDateTime?: Date;
    liveOpticsProjectId?: string | undefined;

    constructor(data?: ILiveOpticsIntegrationMetadata) {
        super(data);
        this._discriminator = "LiveOpticsIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
            this.originalFilename = _data["originalFilename"];
            this.processedFilename = _data["processedFilename"];
            this.fileSubmissionUtcDateTime = _data["fileSubmissionUtcDateTime"] ? new Date(_data["fileSubmissionUtcDateTime"].toString()) : undefined as any;
            this.liveOpticsProjectId = _data["liveOpticsProjectId"];
        }
    }

    static override fromJS(data: any): LiveOpticsIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new LiveOpticsIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        data["originalFilename"] = this.originalFilename;
        data["processedFilename"] = this.processedFilename;
        data["fileSubmissionUtcDateTime"] = this.fileSubmissionUtcDateTime ? this.fileSubmissionUtcDateTime.toISOString() : undefined as any;
        data["liveOpticsProjectId"] = this.liveOpticsProjectId;
        super.toJSON(data);
        return data;
    }
}

export interface ILiveOpticsIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
    originalFilename?: string | undefined;
    processedFilename?: string | undefined;
    fileSubmissionUtcDateTime?: Date;
    liveOpticsProjectId?: string | undefined;
}

export class LiveOpticsProjectUploadResponse implements ILiveOpticsProjectUploadResponse {
    integrationRecord?: IntegrationDTO | undefined;

    constructor(data?: ILiveOpticsProjectUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationRecord = _data["integrationRecord"] ? IntegrationDTO.fromJS(_data["integrationRecord"]) : undefined as any;
        }
    }

    static fromJS(data: any): LiveOpticsProjectUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LiveOpticsProjectUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationRecord"] = this.integrationRecord ? this.integrationRecord.toJSON() : undefined as any;
        return data;
    }
}

export interface ILiveOpticsProjectUploadResponse {
    integrationRecord?: IntegrationDTO | undefined;
}

export enum Purpose {
    AzureAssets = "AzureAssets",
    AzureCostAndUsage = "AzureCostAndUsage",
}

export enum OrderBy {
    LastActivityDate = "LastActivityDate",
    Id = "Id",
}

export class RackAndStackIntegrationMetadata extends IntegrationMetadata implements IRackAndStackIntegrationMetadata {
    axNumber?: string | undefined;

    constructor(data?: IRackAndStackIntegrationMetadata) {
        super(data);
        this._discriminator = "RackAndStackIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axNumber = _data["axNumber"];
        }
    }

    static override fromJS(data: any): RackAndStackIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new RackAndStackIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axNumber"] = this.axNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IRackAndStackIntegrationMetadata extends IIntegrationMetadata {
    axNumber?: string | undefined;
}

export class AzureCreateSubscriptionRequest implements IAzureCreateSubscriptionRequest {
    displayName?: string | undefined;
    customerId?: string | undefined;
    desiredOwnerEmail?: string | undefined;
    azurePlanDomain?: string | undefined;
    azurePlanParentID?: string | undefined;
    contractID?: number;

    constructor(data?: IAzureCreateSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.customerId = _data["customerId"];
            this.desiredOwnerEmail = _data["desiredOwnerEmail"];
            this.azurePlanDomain = _data["azurePlanDomain"];
            this.azurePlanParentID = _data["azurePlanParentID"];
            this.contractID = _data["contractID"];
        }
    }

    static fromJS(data: any): AzureCreateSubscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AzureCreateSubscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["customerId"] = this.customerId;
        data["desiredOwnerEmail"] = this.desiredOwnerEmail;
        data["azurePlanDomain"] = this.azurePlanDomain;
        data["azurePlanParentID"] = this.azurePlanParentID;
        data["contractID"] = this.contractID;
        return data;
    }
}

export interface IAzureCreateSubscriptionRequest {
    displayName?: string | undefined;
    customerId?: string | undefined;
    desiredOwnerEmail?: string | undefined;
    azurePlanDomain?: string | undefined;
    azurePlanParentID?: string | undefined;
    contractID?: number;
}

export class CostAnalytics implements ICostAnalytics {
    axAccountNumber?: string | undefined;
    month?: number;
    year?: number;
    monthlyCost?: number;
    dailyAverageCost?: number;
    numberOfAccounts?: number;
    projectedCost?: number;
    lastSuccessfulCheckDateTime?: Date;

    constructor(data?: ICostAnalytics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.monthlyCost = _data["monthlyCost"];
            this.dailyAverageCost = _data["dailyAverageCost"];
            this.numberOfAccounts = _data["numberOfAccounts"];
            this.projectedCost = _data["projectedCost"];
            this.lastSuccessfulCheckDateTime = _data["lastSuccessfulCheckDateTime"] ? new Date(_data["lastSuccessfulCheckDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CostAnalytics {
        data = typeof data === 'object' ? data : {};
        let result = new CostAnalytics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        data["month"] = this.month;
        data["year"] = this.year;
        data["monthlyCost"] = this.monthlyCost;
        data["dailyAverageCost"] = this.dailyAverageCost;
        data["numberOfAccounts"] = this.numberOfAccounts;
        data["projectedCost"] = this.projectedCost;
        data["lastSuccessfulCheckDateTime"] = this.lastSuccessfulCheckDateTime ? this.lastSuccessfulCheckDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ICostAnalytics {
    axAccountNumber?: string | undefined;
    month?: number;
    year?: number;
    monthlyCost?: number;
    dailyAverageCost?: number;
    numberOfAccounts?: number;
    projectedCost?: number;
    lastSuccessfulCheckDateTime?: Date;
}

export class PostCostAnalyticsRequest implements IPostCostAnalyticsRequest {
    costAnalytics?: CostAnalytics[] | undefined;

    constructor(data?: IPostCostAnalyticsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costAnalytics"])) {
                this.costAnalytics = [] as any;
                for (let item of _data["costAnalytics"])
                    this.costAnalytics!.push(CostAnalytics.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostCostAnalyticsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostCostAnalyticsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costAnalytics)) {
            data["costAnalytics"] = [];
            for (let item of this.costAnalytics)
                data["costAnalytics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPostCostAnalyticsRequest {
    costAnalytics?: CostAnalytics[] | undefined;
}

export class AzureSubscriptionErrorResponse implements IAzureSubscriptionErrorResponse {
    error?: SubscriptionError;
    code?: string | undefined;
    message?: string | undefined;

    constructor(data?: IAzureSubscriptionErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? SubscriptionError.fromJS(_data["error"]) : undefined as any;
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AzureSubscriptionErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSubscriptionErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IAzureSubscriptionErrorResponse {
    error?: SubscriptionError;
    code?: string | undefined;
    message?: string | undefined;
}

export class AzureSubscriptionResponse implements IAzureSubscriptionResponse {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    properties?: SubscriptionResponseProperties;
    error?: AzureSubscriptionErrorResponse;

    constructor(data?: IAzureSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.properties = _data["properties"] ? SubscriptionResponseProperties.fromJS(_data["properties"]) : undefined as any;
            this.error = _data["error"] ? AzureSubscriptionErrorResponse.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): AzureSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined as any;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface IAzureSubscriptionResponse {
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    properties?: SubscriptionResponseProperties;
    error?: AzureSubscriptionErrorResponse;
}

export class AzureSubscriptionStatusResponse implements IAzureSubscriptionStatusResponse {
    subscriptionStatuses?: AzureSubscriptionStatus[] | undefined;

    constructor(data?: IAzureSubscriptionStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscriptionStatuses"])) {
                this.subscriptionStatuses = [] as any;
                for (let item of _data["subscriptionStatuses"])
                    this.subscriptionStatuses!.push(AzureSubscriptionStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AzureSubscriptionStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AzureSubscriptionStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptionStatuses)) {
            data["subscriptionStatuses"] = [];
            for (let item of this.subscriptionStatuses)
                data["subscriptionStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAzureSubscriptionStatusResponse {
    subscriptionStatuses?: AzureSubscriptionStatus[] | undefined;
}

export class SubscriptionError implements ISubscriptionError {
    code?: string | undefined;
    message?: string | undefined;

    constructor(data?: ISubscriptionError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SubscriptionError {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface ISubscriptionError {
    code?: string | undefined;
    message?: string | undefined;
}

export class ContractOverview implements IContractOverview {
    contractId?: number;
    totalHoursSpent?: number;
    ticketIdHoursSpent?: HoursSpentByTicket[] | undefined;

    constructor(data?: IContractOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.totalHoursSpent = _data["totalHoursSpent"];
            if (Array.isArray(_data["ticketIdHoursSpent"])) {
                this.ticketIdHoursSpent = [] as any;
                for (let item of _data["ticketIdHoursSpent"])
                    this.ticketIdHoursSpent!.push(HoursSpentByTicket.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractOverview {
        data = typeof data === 'object' ? data : {};
        let result = new ContractOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["totalHoursSpent"] = this.totalHoursSpent;
        if (Array.isArray(this.ticketIdHoursSpent)) {
            data["ticketIdHoursSpent"] = [];
            for (let item of this.ticketIdHoursSpent)
                data["ticketIdHoursSpent"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContractOverview {
    contractId?: number;
    totalHoursSpent?: number;
    ticketIdHoursSpent?: HoursSpentByTicket[] | undefined;
}

export class CostAnalyticsResponse implements ICostAnalyticsResponse {
    accounts?: { [key: string]: CostAnalytics[]; } | undefined;

    constructor(data?: ICostAnalyticsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["accounts"]) {
                this.accounts = {} as any;
                for (let key in _data["accounts"]) {
                    if (_data["accounts"].hasOwnProperty(key))
                        (this.accounts as any)![key] = _data["accounts"][key] ? _data["accounts"][key].map((i: any) => CostAnalytics.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): CostAnalyticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CostAnalyticsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.accounts) {
            data["accounts"] = {};
            for (let key in this.accounts) {
                if (this.accounts.hasOwnProperty(key))
                    (data["accounts"] as any)[key] = (this.accounts as any)[key];
            }
        }
        return data;
    }
}

export interface ICostAnalyticsResponse {
    accounts?: { [key: string]: CostAnalytics[]; } | undefined;
}

export class HoursSpentByTicket implements IHoursSpentByTicket {
    ticketId?: number;
    hours?: number;

    constructor(data?: IHoursSpentByTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): HoursSpentByTicket {
        data = typeof data === 'object' ? data : {};
        let result = new HoursSpentByTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["hours"] = this.hours;
        return data;
    }
}

export interface IHoursSpentByTicket {
    ticketId?: number;
    hours?: number;
}

export class SaveAccountTeamMembersRequest implements ISaveAccountTeamMembersRequest {
    activeDirectoryAccountTeamMembers?: ActiveDirectoryAccountTeamMember[] | undefined;
    crmAccountTeamMembers?: CrmAccountTeamMember[] | undefined;

    constructor(data?: ISaveAccountTeamMembersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeDirectoryAccountTeamMembers"])) {
                this.activeDirectoryAccountTeamMembers = [] as any;
                for (let item of _data["activeDirectoryAccountTeamMembers"])
                    this.activeDirectoryAccountTeamMembers!.push(ActiveDirectoryAccountTeamMember.fromJS(item));
            }
            if (Array.isArray(_data["crmAccountTeamMembers"])) {
                this.crmAccountTeamMembers = [] as any;
                for (let item of _data["crmAccountTeamMembers"])
                    this.crmAccountTeamMembers!.push(CrmAccountTeamMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveAccountTeamMembersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAccountTeamMembersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeDirectoryAccountTeamMembers)) {
            data["activeDirectoryAccountTeamMembers"] = [];
            for (let item of this.activeDirectoryAccountTeamMembers)
                data["activeDirectoryAccountTeamMembers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crmAccountTeamMembers)) {
            data["crmAccountTeamMembers"] = [];
            for (let item of this.crmAccountTeamMembers)
                data["crmAccountTeamMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveAccountTeamMembersRequest {
    activeDirectoryAccountTeamMembers?: ActiveDirectoryAccountTeamMember[] | undefined;
    crmAccountTeamMembers?: CrmAccountTeamMember[] | undefined;
}

export class AccountContractRequest implements IAccountContractRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    accountId?: number | undefined;
    contractTypes?: number[] | undefined;
    accounts?: number[] | undefined;
    status?: number | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;
    searchFilterInclude?: ContractsListFilterDto;
    searchFilterExclude?: ContractsListFilterDto;

    constructor(data?: IAccountContractRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.searchString = _data["searchString"];
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["contractTypes"])) {
                this.contractTypes = [] as any;
                for (let item of _data["contractTypes"])
                    this.contractTypes!.push(item);
            }
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(item);
            }
            this.status = _data["status"];
            this.orderBy = _data["orderBy"];
            this.orderDirection = _data["orderDirection"];
            this.searchFilterInclude = _data["searchFilterInclude"] ? ContractsListFilterDto.fromJS(_data["searchFilterInclude"]) : undefined as any;
            this.searchFilterExclude = _data["searchFilterExclude"] ? ContractsListFilterDto.fromJS(_data["searchFilterExclude"]) : undefined as any;
        }
    }

    static fromJS(data: any): AccountContractRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountContractRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["searchString"] = this.searchString;
        data["accountId"] = this.accountId;
        if (Array.isArray(this.contractTypes)) {
            data["contractTypes"] = [];
            for (let item of this.contractTypes)
                data["contractTypes"].push(item);
        }
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item);
        }
        data["status"] = this.status;
        data["orderBy"] = this.orderBy;
        data["orderDirection"] = this.orderDirection;
        data["searchFilterInclude"] = this.searchFilterInclude ? this.searchFilterInclude.toJSON() : undefined as any;
        data["searchFilterExclude"] = this.searchFilterExclude ? this.searchFilterExclude.toJSON() : undefined as any;
        return data;
    }
}

export interface IAccountContractRequest {
    pageNumber?: number;
    pageSize?: number;
    searchString?: string | undefined;
    accountId?: number | undefined;
    contractTypes?: number[] | undefined;
    accounts?: number[] | undefined;
    status?: number | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;
    searchFilterInclude?: ContractsListFilterDto;
    searchFilterExclude?: ContractsListFilterDto;
}

export class ToggleManualEmailRequest implements IToggleManualEmailRequest {
    accountId?: number;
    noManualAuthRequired?: boolean;

    constructor(data?: IToggleManualEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.noManualAuthRequired = _data["noManualAuthRequired"];
        }
    }

    static fromJS(data: any): ToggleManualEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleManualEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["noManualAuthRequired"] = this.noManualAuthRequired;
        return data;
    }
}

export interface IToggleManualEmailRequest {
    accountId?: number;
    noManualAuthRequired?: boolean;
}

export class ResourceAction implements IResourceAction {
    displayName?: string | undefined;
    actionName?: string | undefined;
    alertMessage?: string | undefined;

    constructor(data?: IResourceAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.actionName = _data["actionName"];
            this.alertMessage = _data["alertMessage"];
        }
    }

    static fromJS(data: any): ResourceAction {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["actionName"] = this.actionName;
        data["alertMessage"] = this.alertMessage;
        return data;
    }
}

export interface IResourceAction {
    displayName?: string | undefined;
    actionName?: string | undefined;
    alertMessage?: string | undefined;
}

export class ResourceDefinition implements IResourceDefinition {
    displayName?: string | undefined;
    configurationType?: PermissionConfigurationType;
    actions?: ResourceAction[] | undefined;

    constructor(data?: IResourceDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.configurationType = _data["configurationType"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ResourceAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResourceDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["configurationType"] = this.configurationType;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResourceDefinition {
    displayName?: string | undefined;
    configurationType?: PermissionConfigurationType;
    actions?: ResourceAction[] | undefined;
}

export class SelfServiceReportingIntegrationMetadata extends IntegrationMetadata implements ISelfServiceReportingIntegrationMetadata {
    axAccount?: string | undefined;
    workspaceId?: string | undefined;
    accountName?: string | undefined;
    datasetCategories?: DatasetCategories[] | undefined;

    constructor(data?: ISelfServiceReportingIntegrationMetadata) {
        super(data);
        this._discriminator = "SelfServiceReportingIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.axAccount = _data["axAccount"];
            this.workspaceId = _data["workspaceId"];
            this.accountName = _data["accountName"];
            if (Array.isArray(_data["datasetCategories"])) {
                this.datasetCategories = [] as any;
                for (let item of _data["datasetCategories"])
                    this.datasetCategories!.push(item);
            }
        }
    }

    static override fromJS(data: any): SelfServiceReportingIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceReportingIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccount"] = this.axAccount;
        data["workspaceId"] = this.workspaceId;
        data["accountName"] = this.accountName;
        if (Array.isArray(this.datasetCategories)) {
            data["datasetCategories"] = [];
            for (let item of this.datasetCategories)
                data["datasetCategories"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISelfServiceReportingIntegrationMetadata extends IIntegrationMetadata {
    axAccount?: string | undefined;
    workspaceId?: string | undefined;
    accountName?: string | undefined;
    datasetCategories?: DatasetCategories[] | undefined;
}

export class ServiceRequestDownloadRequest implements IServiceRequestDownloadRequest {
    query?: ServiceRequestBaseElasticQueryRequest;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
    queryString?: string | undefined;

    constructor(data?: IServiceRequestDownloadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? ServiceRequestBaseElasticQueryRequest.fromJS(_data["query"]) : undefined as any;
            if (Array.isArray(_data["gridDefinitions"])) {
                this.gridDefinitions = [] as any;
                for (let item of _data["gridDefinitions"])
                    this.gridDefinitions!.push(ExcelDownloadDefinition.fromJS(item));
            }
            this.queryString = _data["queryString"];
        }
    }

    static fromJS(data: any): ServiceRequestDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDownloadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        if (Array.isArray(this.gridDefinitions)) {
            data["gridDefinitions"] = [];
            for (let item of this.gridDefinitions)
                data["gridDefinitions"].push(item ? item.toJSON() : undefined as any);
        }
        data["queryString"] = this.queryString;
        return data;
    }
}

export interface IServiceRequestDownloadRequest {
    query?: ServiceRequestBaseElasticQueryRequest;
    gridDefinitions?: ExcelDownloadDefinition[] | undefined;
    queryString?: string | undefined;
}

export enum ServiceRequestLandingPageIconColor {
    ServiceRequestColor = "ServiceRequestColor",
    IncidentColor = "IncidentColor",
    ChangeRequestColor = "ChangeRequestColor",
}

export class ServiceRequestLandingPageItemDto implements IServiceRequestLandingPageItemDto {
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    landingPageUrl?: string | undefined;
    targetUrl?: string | undefined;
    iconColorCategory?: ServiceRequestLandingPageIconColor;
    contractId?: number | undefined;
    issueTypeId?: number | undefined;
    subIssueTypeId?: number | undefined;
    collectTitle?: boolean;
    collectDescription?: boolean;
    categoryId?: number | undefined;
    serviceRequestMappingId?: number;
    iconColor?: string | undefined;

    constructor(data?: IServiceRequestLandingPageItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.landingPageUrl = _data["landingPageUrl"];
            this.targetUrl = _data["targetUrl"];
            this.iconColorCategory = _data["iconColorCategory"];
            this.contractId = _data["contractId"];
            this.issueTypeId = _data["issueTypeId"];
            this.subIssueTypeId = _data["subIssueTypeId"];
            this.collectTitle = _data["collectTitle"];
            this.collectDescription = _data["collectDescription"];
            this.categoryId = _data["categoryId"];
            this.serviceRequestMappingId = _data["serviceRequestMappingId"];
            this.iconColor = _data["iconColor"];
        }
    }

    static fromJS(data: any): ServiceRequestLandingPageItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestLandingPageItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["landingPageUrl"] = this.landingPageUrl;
        data["targetUrl"] = this.targetUrl;
        data["iconColorCategory"] = this.iconColorCategory;
        data["contractId"] = this.contractId;
        data["issueTypeId"] = this.issueTypeId;
        data["subIssueTypeId"] = this.subIssueTypeId;
        data["collectTitle"] = this.collectTitle;
        data["collectDescription"] = this.collectDescription;
        data["categoryId"] = this.categoryId;
        data["serviceRequestMappingId"] = this.serviceRequestMappingId;
        data["iconColor"] = this.iconColor;
        return data;
    }
}

export interface IServiceRequestLandingPageItemDto {
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    landingPageUrl?: string | undefined;
    targetUrl?: string | undefined;
    iconColorCategory?: ServiceRequestLandingPageIconColor;
    contractId?: number | undefined;
    issueTypeId?: number | undefined;
    subIssueTypeId?: number | undefined;
    collectTitle?: boolean;
    collectDescription?: boolean;
    categoryId?: number | undefined;
    serviceRequestMappingId?: number;
    iconColor?: string | undefined;
}

export class ServiceRequestsRequest implements IServiceRequestsRequest {
    searchString?: string | undefined;
    requestType?: number | undefined;
    status?: number[] | undefined;
    priority?: number | undefined;
    ticketCategory?: number[] | undefined;
    issueType?: number | undefined;
    createdBefore?: Date | undefined;
    createdAfter?: Date | undefined;
    lastUpdatedBefore?: Date | undefined;
    lastUpdatedAfter?: Date | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;
    skip?: number;
    take?: number;

    protected _discriminator: string;

    constructor(data?: IServiceRequestsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ServiceRequestsRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.searchString = _data["searchString"];
            this.requestType = _data["requestType"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.priority = _data["priority"];
            if (Array.isArray(_data["ticketCategory"])) {
                this.ticketCategory = [] as any;
                for (let item of _data["ticketCategory"])
                    this.ticketCategory!.push(item);
            }
            this.issueType = _data["issueType"];
            this.createdBefore = _data["createdBefore"] ? new Date(_data["createdBefore"].toString()) : undefined as any;
            this.createdAfter = _data["createdAfter"] ? new Date(_data["createdAfter"].toString()) : undefined as any;
            this.lastUpdatedBefore = _data["lastUpdatedBefore"] ? new Date(_data["lastUpdatedBefore"].toString()) : undefined as any;
            this.lastUpdatedAfter = _data["lastUpdatedAfter"] ? new Date(_data["lastUpdatedAfter"].toString()) : undefined as any;
            this.orderBy = _data["orderBy"];
            this.orderDirection = _data["orderDirection"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): ServiceRequestsRequest {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "TicketQueryRequest") {
            let result = new TicketQueryRequest();
            result.init(data);
            return result;
        }
        let result = new ServiceRequestsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["searchString"] = this.searchString;
        data["requestType"] = this.requestType;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["priority"] = this.priority;
        if (Array.isArray(this.ticketCategory)) {
            data["ticketCategory"] = [];
            for (let item of this.ticketCategory)
                data["ticketCategory"].push(item);
        }
        data["issueType"] = this.issueType;
        data["createdBefore"] = this.createdBefore ? this.createdBefore.toISOString() : undefined as any;
        data["createdAfter"] = this.createdAfter ? this.createdAfter.toISOString() : undefined as any;
        data["lastUpdatedBefore"] = this.lastUpdatedBefore ? this.lastUpdatedBefore.toISOString() : undefined as any;
        data["lastUpdatedAfter"] = this.lastUpdatedAfter ? this.lastUpdatedAfter.toISOString() : undefined as any;
        data["orderBy"] = this.orderBy;
        data["orderDirection"] = this.orderDirection;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IServiceRequestsRequest {
    searchString?: string | undefined;
    requestType?: number | undefined;
    status?: number[] | undefined;
    priority?: number | undefined;
    ticketCategory?: number[] | undefined;
    issueType?: number | undefined;
    createdBefore?: Date | undefined;
    createdAfter?: Date | undefined;
    lastUpdatedBefore?: Date | undefined;
    lastUpdatedAfter?: Date | undefined;
    orderBy?: string | undefined;
    orderDirection?: string | undefined;
    skip?: number;
    take?: number;
}

export class AXBillingAddressDTO implements IAXBillingAddressDTO {
    axAccountNumber?: string | undefined;
    readonly addresses?: string[] | undefined;

    constructor(data?: IAXBillingAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.axAccountNumber = _data["axAccountNumber"];
            if (Array.isArray(_data["addresses"])) {
                (this as any).addresses = [] as any;
                for (let item of _data["addresses"])
                    (this as any).addresses!.push(item);
            }
        }
    }

    static fromJS(data: any): AXBillingAddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AXBillingAddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["axAccountNumber"] = this.axAccountNumber;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item);
        }
        return data;
    }
}

export interface IAXBillingAddressDTO {
    axAccountNumber?: string | undefined;
    addresses?: string[] | undefined;
}

export class AXProjectInvoicesResponse implements IAXProjectInvoicesResponse {
    message?: string | undefined;
    projectInvoices?: ProjectInvoice[] | undefined;

    constructor(data?: IAXProjectInvoicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["projectInvoices"])) {
                this.projectInvoices = [] as any;
                for (let item of _data["projectInvoices"])
                    this.projectInvoices!.push(ProjectInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AXProjectInvoicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AXProjectInvoicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.projectInvoices)) {
            data["projectInvoices"] = [];
            for (let item of this.projectInvoices)
                data["projectInvoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAXProjectInvoicesResponse {
    message?: string | undefined;
    projectInvoices?: ProjectInvoice[] | undefined;
}

export class Invoice implements IInvoice {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceDate = _data["invoiceDate"];
            this.customerPo = _data["customerPo"];
            this.customerRequisition = _data["customerRequisition"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.tagFilter = _data["tagFilter"];
            this.tag = _data["tag"];
            this.tenant = _data["tenant"];
            this.serviceProjectName = _data["serviceProjectName"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceDate"] = this.invoiceDate;
        data["customerPo"] = this.customerPo;
        data["customerRequisition"] = this.customerRequisition;
        data["invoiceAmount"] = this.invoiceAmount;
        data["tagFilter"] = this.tagFilter;
        data["tag"] = this.tag;
        data["tenant"] = this.tenant;
        data["serviceProjectName"] = this.serviceProjectName;
        return data;
    }
}

export interface IInvoice {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    customerPo?: string | undefined;
    customerRequisition?: string | undefined;
    invoiceAmount?: number;
    tagFilter?: string | undefined;
    tag?: string | undefined;
    tenant?: string | undefined;
    serviceProjectName?: string | undefined;
}

export class InvoiceEmail implements IInvoiceEmail {
    statusCode?: number;
    invoiceId?: string | undefined;
    message?: string | undefined;

    constructor(data?: IInvoiceEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.invoiceId = _data["invoiceId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InvoiceEmail {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["invoiceId"] = this.invoiceId;
        data["message"] = this.message;
        return data;
    }
}

export interface IInvoiceEmail {
    statusCode?: number;
    invoiceId?: string | undefined;
    message?: string | undefined;
}

export class InvoiceEmail_Request implements IInvoiceEmail_Request {
    invoiceIds?: string[] | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IInvoiceEmail_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): InvoiceEmail_Request {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmail_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IInvoiceEmail_Request {
    invoiceIds?: string[] | undefined;
    emailAddress?: string | undefined;
}

export class InvoiceEmail_Response implements IInvoiceEmail_Response {
    allSuccessful?: boolean;
    message?: string | undefined;
    hasError?: boolean;
    responseStatus?: number;
    invoiceResponses?: InvoiceEmail[] | undefined;

    constructor(data?: IInvoiceEmail_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allSuccessful = _data["allSuccessful"];
            this.message = _data["message"];
            this.hasError = _data["hasError"];
            this.responseStatus = _data["responseStatus"];
            if (Array.isArray(_data["invoiceResponses"])) {
                this.invoiceResponses = [] as any;
                for (let item of _data["invoiceResponses"])
                    this.invoiceResponses!.push(InvoiceEmail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceEmail_Response {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmail_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allSuccessful"] = this.allSuccessful;
        data["message"] = this.message;
        data["hasError"] = this.hasError;
        data["responseStatus"] = this.responseStatus;
        if (Array.isArray(this.invoiceResponses)) {
            data["invoiceResponses"] = [];
            for (let item of this.invoiceResponses)
                data["invoiceResponses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceEmail_Response {
    allSuccessful?: boolean;
    message?: string | undefined;
    hasError?: boolean;
    responseStatus?: number;
    invoiceResponses?: InvoiceEmail[] | undefined;
}

export class Invoice_Response implements IInvoice_Response {
    accountId?: number;
    hasError?: boolean | undefined;
    message?: string | undefined;
    invoices?: Invoice[] | undefined;

    constructor(data?: IInvoice_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(Invoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Invoice_Response {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoice_Response {
    accountId?: number;
    hasError?: boolean | undefined;
    message?: string | undefined;
    invoices?: Invoice[] | undefined;
}

export class ProjectInvoice implements IProjectInvoice {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceAmount?: number;
    customerPo?: string | undefined;
    tag?: string | undefined;
    serviceProjectName?: string | undefined;

    constructor(data?: IProjectInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceDate = _data["invoiceDate"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.customerPo = _data["customerPo"];
            this.tag = _data["tag"];
            this.serviceProjectName = _data["serviceProjectName"];
        }
    }

    static fromJS(data: any): ProjectInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceDate"] = this.invoiceDate;
        data["invoiceAmount"] = this.invoiceAmount;
        data["customerPo"] = this.customerPo;
        data["tag"] = this.tag;
        data["serviceProjectName"] = this.serviceProjectName;
        return data;
    }
}

export interface IProjectInvoice {
    invoiceId?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceAmount?: number;
    customerPo?: string | undefined;
    tag?: string | undefined;
    serviceProjectName?: string | undefined;
}

export class StorefrontOrgUnitNavHeaderResponse implements IStorefrontOrgUnitNavHeaderResponse {
    orgUnitId!: number;
    displayName?: string | undefined;
    orgUnitName?: string | undefined;
    logoUrl?: string | undefined;
    fallbackInitials?: string | undefined;

    constructor(data?: IStorefrontOrgUnitNavHeaderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.displayName = _data["displayName"];
            this.orgUnitName = _data["orgUnitName"];
            this.logoUrl = _data["logoUrl"];
            this.fallbackInitials = _data["fallbackInitials"];
        }
    }

    static fromJS(data: any): StorefrontOrgUnitNavHeaderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StorefrontOrgUnitNavHeaderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["displayName"] = this.displayName;
        data["orgUnitName"] = this.orgUnitName;
        data["logoUrl"] = this.logoUrl;
        data["fallbackInitials"] = this.fallbackInitials;
        return data;
    }
}

export interface IStorefrontOrgUnitNavHeaderResponse {
    orgUnitId: number;
    displayName?: string | undefined;
    orgUnitName?: string | undefined;
    logoUrl?: string | undefined;
    fallbackInitials?: string | undefined;
}

export class UnityStatusDto implements IUnityStatusDto {
    status?: UnityExperienceStatus;
    isEligibleForUnity?: boolean;

    constructor(data?: IUnityStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.isEligibleForUnity = _data["isEligibleForUnity"];
        }
    }

    static fromJS(data: any): UnityStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnityStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["isEligibleForUnity"] = this.isEligibleForUnity;
        return data;
    }
}

export interface IUnityStatusDto {
    status?: UnityExperienceStatus;
    isEligibleForUnity?: boolean;
}

/** A null ShiOne.WebApi.Models.SwitchUserContextRequest.StorefrontOrgUnitId switches the tenant only. */
export class SwitchUserContextRequest implements ISwitchUserContextRequest {
    tenantId!: string;
    storefrontOrgUnitId?: number | undefined;

    constructor(data?: ISwitchUserContextRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.storefrontOrgUnitId = _data["storefrontOrgUnitId"];
        }
    }

    static fromJS(data: any): SwitchUserContextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchUserContextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["storefrontOrgUnitId"] = this.storefrontOrgUnitId;
        return data;
    }
}

/** A null ShiOne.WebApi.Models.SwitchUserContextRequest.StorefrontOrgUnitId switches the tenant only. */
export interface ISwitchUserContextRequest {
    tenantId: string;
    storefrontOrgUnitId?: number | undefined;
}

export class SwitchUserContextResponse implements ISwitchUserContextResponse {
    tenantId!: string;
    orgUnitId?: number | undefined;
    compositeCatalogId?: number | undefined;
    cart?: CartChangeSummaryDto;
    /** The storefront switched but the cart could not be revalidated. */
    cartMigrationFailed!: boolean;

    constructor(data?: ISwitchUserContextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.orgUnitId = _data["orgUnitId"];
            this.compositeCatalogId = _data["compositeCatalogId"];
            this.cart = _data["cart"] ? CartChangeSummaryDto.fromJS(_data["cart"]) : undefined as any;
            this.cartMigrationFailed = _data["cartMigrationFailed"];
        }
    }

    static fromJS(data: any): SwitchUserContextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchUserContextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["orgUnitId"] = this.orgUnitId;
        data["compositeCatalogId"] = this.compositeCatalogId;
        data["cart"] = this.cart ? this.cart.toJSON() : undefined as any;
        data["cartMigrationFailed"] = this.cartMigrationFailed;
        return data;
    }
}

export interface ISwitchUserContextResponse {
    tenantId: string;
    orgUnitId?: number | undefined;
    compositeCatalogId?: number | undefined;
    cart?: CartChangeSummaryDto;
    /** The storefront switched but the cart could not be revalidated. */
    cartMigrationFailed: boolean;
}

export class AccountNotifications implements IAccountNotifications {
    contractsWithoutGroups?: number;
    contractsWithoutGroupsList?: NotificationContract[] | undefined;
    cloudAccountsWithoutGroups?: number;
    cloudAccountsWithoutGroupsList?: NotificationCloudAccount[] | undefined;

    constructor(data?: IAccountNotifications) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractsWithoutGroups = _data["contractsWithoutGroups"];
            if (Array.isArray(_data["contractsWithoutGroupsList"])) {
                this.contractsWithoutGroupsList = [] as any;
                for (let item of _data["contractsWithoutGroupsList"])
                    this.contractsWithoutGroupsList!.push(NotificationContract.fromJS(item));
            }
            this.cloudAccountsWithoutGroups = _data["cloudAccountsWithoutGroups"];
            if (Array.isArray(_data["cloudAccountsWithoutGroupsList"])) {
                this.cloudAccountsWithoutGroupsList = [] as any;
                for (let item of _data["cloudAccountsWithoutGroupsList"])
                    this.cloudAccountsWithoutGroupsList!.push(NotificationCloudAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountNotifications {
        data = typeof data === 'object' ? data : {};
        let result = new AccountNotifications();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractsWithoutGroups"] = this.contractsWithoutGroups;
        if (Array.isArray(this.contractsWithoutGroupsList)) {
            data["contractsWithoutGroupsList"] = [];
            for (let item of this.contractsWithoutGroupsList)
                data["contractsWithoutGroupsList"].push(item ? item.toJSON() : undefined as any);
        }
        data["cloudAccountsWithoutGroups"] = this.cloudAccountsWithoutGroups;
        if (Array.isArray(this.cloudAccountsWithoutGroupsList)) {
            data["cloudAccountsWithoutGroupsList"] = [];
            for (let item of this.cloudAccountsWithoutGroupsList)
                data["cloudAccountsWithoutGroupsList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccountNotifications {
    contractsWithoutGroups?: number;
    contractsWithoutGroupsList?: NotificationContract[] | undefined;
    cloudAccountsWithoutGroups?: number;
    cloudAccountsWithoutGroupsList?: NotificationCloudAccount[] | undefined;
}

export class AccountResponse implements IAccountResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    accounts?: Account[] | undefined;

    constructor(data?: IAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(Account.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccountResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    accounts?: Account[] | undefined;
}

export class AllServiceRequestsResponse implements IAllServiceRequestsResponse {
    resultInfo?: PagedResultData;
    resultData?: ServiceRequestDTO[] | undefined;
    resultContacts?: Contact[] | undefined;
    resultResources?: Resource[] | undefined;
    resultIssueTypes?: number[] | undefined;

    constructor(data?: IAllServiceRequestsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultInfo = _data["resultInfo"] ? PagedResultData.fromJS(_data["resultInfo"]) : undefined as any;
            if (Array.isArray(_data["resultData"])) {
                this.resultData = [] as any;
                for (let item of _data["resultData"])
                    this.resultData!.push(ServiceRequestDTO.fromJS(item));
            }
            if (Array.isArray(_data["resultContacts"])) {
                this.resultContacts = [] as any;
                for (let item of _data["resultContacts"])
                    this.resultContacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["resultResources"])) {
                this.resultResources = [] as any;
                for (let item of _data["resultResources"])
                    this.resultResources!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["resultIssueTypes"])) {
                this.resultIssueTypes = [] as any;
                for (let item of _data["resultIssueTypes"])
                    this.resultIssueTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): AllServiceRequestsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AllServiceRequestsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultInfo"] = this.resultInfo ? this.resultInfo.toJSON() : undefined as any;
        if (Array.isArray(this.resultData)) {
            data["resultData"] = [];
            for (let item of this.resultData)
                data["resultData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultContacts)) {
            data["resultContacts"] = [];
            for (let item of this.resultContacts)
                data["resultContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultResources)) {
            data["resultResources"] = [];
            for (let item of this.resultResources)
                data["resultResources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultIssueTypes)) {
            data["resultIssueTypes"] = [];
            for (let item of this.resultIssueTypes)
                data["resultIssueTypes"].push(item);
        }
        return data;
    }
}

export interface IAllServiceRequestsResponse {
    resultInfo?: PagedResultData;
    resultData?: ServiceRequestDTO[] | undefined;
    resultContacts?: Contact[] | undefined;
    resultResources?: Resource[] | undefined;
    resultIssueTypes?: number[] | undefined;
}

export class CloudAccount implements ICloudAccount {
    cloudAccountName?: string | undefined;
    cloud?: string | undefined;
    cloudAccountID?: string | undefined;
    cloudAccountCreateDate?: string | undefined;
    cloudAccountStatus?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    serviceLevel?: string | undefined;
    licenseCount?: number;
    configurationItem?: ConfigurationItem;
    account?: Account;
    accountId!: number;
    accountName!: string;
    contractId?: number;
    configurationItemId?: number;

    constructor(data?: ICloudAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloud = _data["cloud"];
            this.cloudAccountID = _data["cloudAccountID"];
            this.cloudAccountCreateDate = _data["cloudAccountCreateDate"];
            this.cloudAccountStatus = _data["cloudAccountStatus"];
            this.userDefinedFieldsJson = _data["userDefinedFieldsJson"];
            this.serviceLevel = _data["serviceLevel"];
            this.licenseCount = _data["licenseCount"];
            this.configurationItem = _data["configurationItem"] ? ConfigurationItem.fromJS(_data["configurationItem"]) : undefined as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : undefined as any;
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.contractId = _data["contractId"];
            this.configurationItemId = _data["configurationItemId"];
        }
    }

    static fromJS(data: any): CloudAccount {
        data = typeof data === 'object' ? data : {};
        let result = new CloudAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloud"] = this.cloud;
        data["cloudAccountID"] = this.cloudAccountID;
        data["cloudAccountCreateDate"] = this.cloudAccountCreateDate;
        data["cloudAccountStatus"] = this.cloudAccountStatus;
        data["userDefinedFieldsJson"] = this.userDefinedFieldsJson;
        data["serviceLevel"] = this.serviceLevel;
        data["licenseCount"] = this.licenseCount;
        data["configurationItem"] = this.configurationItem ? this.configurationItem.toJSON() : undefined as any;
        data["account"] = this.account ? this.account.toJSON() : undefined as any;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["contractId"] = this.contractId;
        data["configurationItemId"] = this.configurationItemId;
        return data;
    }
}

export interface ICloudAccount {
    cloudAccountName?: string | undefined;
    cloud?: string | undefined;
    cloudAccountID?: string | undefined;
    cloudAccountCreateDate?: string | undefined;
    cloudAccountStatus?: string | undefined;
    userDefinedFieldsJson?: string | undefined;
    serviceLevel?: string | undefined;
    licenseCount?: number;
    configurationItem?: ConfigurationItem;
    account?: Account;
    accountId: number;
    accountName: string;
    contractId?: number;
    configurationItemId?: number;
}

export class ContractCacheResponse implements IContractCacheResponse {
    contract?: ContractModel;
    contractID?: number | undefined;
    responseStatus?: number | undefined;
    errorMessage?: string | undefined;
    shiOneContract?: Contract;
    contracts?: Contract[] | undefined;
    simpleCloudContracts?: SimpleCloudContract[] | undefined;
    contractServices?: ContractServiceRecord[] | undefined;
    services?: ServiceRecord[] | undefined;

    constructor(data?: IContractCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractModel.fromJS(_data["contract"]) : undefined as any;
            this.contractID = _data["contractID"];
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.shiOneContract = _data["shiOneContract"] ? Contract.fromJS(_data["shiOneContract"]) : undefined as any;
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["simpleCloudContracts"])) {
                this.simpleCloudContracts = [] as any;
                for (let item of _data["simpleCloudContracts"])
                    this.simpleCloudContracts!.push(SimpleCloudContract.fromJS(item));
            }
            if (Array.isArray(_data["contractServices"])) {
                this.contractServices = [] as any;
                for (let item of _data["contractServices"])
                    this.contractServices!.push(ContractServiceRecord.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : undefined as any;
        data["contractID"] = this.contractID;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["shiOneContract"] = this.shiOneContract ? this.shiOneContract.toJSON() : undefined as any;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.simpleCloudContracts)) {
            data["simpleCloudContracts"] = [];
            for (let item of this.simpleCloudContracts)
                data["simpleCloudContracts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractServices)) {
            data["contractServices"] = [];
            for (let item of this.contractServices)
                data["contractServices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContractCacheResponse {
    contract?: ContractModel;
    contractID?: number | undefined;
    responseStatus?: number | undefined;
    errorMessage?: string | undefined;
    shiOneContract?: Contract;
    contracts?: Contract[] | undefined;
    simpleCloudContracts?: SimpleCloudContract[] | undefined;
    contractServices?: ContractServiceRecord[] | undefined;
    services?: ServiceRecord[] | undefined;
}

export class ContractModel implements IContractModel {
    systemGuid!: string;
    cloudSourceId!: string;
    cloudAccountName!: string;
    axNumber!: number;
    autotaskAccountId!: number;
    autotaskContractId?: number | undefined;
    contractCategory!: string;
    parentSystemGuid?: string | undefined;
    startDate!: Date;
    endDate?: Date;
    serviceLevelAgreement!: string;
    active!: boolean;

    constructor(data?: IContractModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemGuid = _data["systemGuid"];
            this.cloudSourceId = _data["cloudSourceId"];
            this.cloudAccountName = _data["cloudAccountName"];
            this.axNumber = _data["axNumber"];
            this.autotaskAccountId = _data["autotaskAccountId"];
            this.autotaskContractId = _data["autotaskContractId"];
            this.contractCategory = _data["contractCategory"];
            this.parentSystemGuid = _data["parentSystemGuid"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.serviceLevelAgreement = _data["serviceLevelAgreement"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ContractModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemGuid"] = this.systemGuid;
        data["cloudSourceId"] = this.cloudSourceId;
        data["cloudAccountName"] = this.cloudAccountName;
        data["axNumber"] = this.axNumber;
        data["autotaskAccountId"] = this.autotaskAccountId;
        data["autotaskContractId"] = this.autotaskContractId;
        data["contractCategory"] = this.contractCategory;
        data["parentSystemGuid"] = this.parentSystemGuid;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["serviceLevelAgreement"] = this.serviceLevelAgreement;
        data["active"] = this.active;
        return data;
    }
}

export interface IContractModel {
    systemGuid: string;
    cloudSourceId: string;
    cloudAccountName: string;
    axNumber: number;
    autotaskAccountId: number;
    autotaskContractId?: number | undefined;
    contractCategory: string;
    parentSystemGuid?: string | undefined;
    startDate: Date;
    endDate?: Date;
    serviceLevelAgreement: string;
    active: boolean;
}

export class ContractSchema implements IContractSchema {
    title?: string | undefined;
    description?: string | undefined;
    properties?: ContractSchema_ContractDetails;
    required?: string[] | undefined;

    constructor(data?: IContractSchema) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.properties = _data["properties"] ? ContractSchema_ContractDetails.fromJS(_data["properties"]) : undefined as any;
            if (Array.isArray(_data["required"])) {
                this.required = [] as any;
                for (let item of _data["required"])
                    this.required!.push(item);
            }
        }
    }

    static fromJS(data: any): ContractSchema {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSchema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined as any;
        if (Array.isArray(this.required)) {
            data["required"] = [];
            for (let item of this.required)
                data["required"].push(item);
        }
        return data;
    }
}

export interface IContractSchema {
    title?: string | undefined;
    description?: string | undefined;
    properties?: ContractSchema_ContractDetails;
    required?: string[] | undefined;
}

export class ContractSchema_ContractDetails implements IContractSchema_ContractDetails {
    systemGuid!: ContractSchema_ContractDetails_Details;
    parentSystemGuid?: ContractSchema_ContractDetails_Details;
    cloudSourceId!: ContractSchema_ContractDetails_Details;
    cloudAccountName!: ContractSchema_ContractDetails_Details;
    axNumber!: ContractSchema_ContractDetails_Details;
    autotaskAccountId!: ContractSchema_ContractDetails_Details;
    contractCategory!: ContractSchema_ContractDetails_Details;
    startDate!: ContractSchema_ContractDetails_Details;
    endDate?: ContractSchema_ContractDetails_Details;
    serviceLevelAgreement!: ContractSchema_ContractDetails_Details;
    cloudAccountActive?: ContractSchema_ContractDetails_Details;

    constructor(data?: IContractSchema_ContractDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.systemGuid = new ContractSchema_ContractDetails_Details();
            this.cloudSourceId = new ContractSchema_ContractDetails_Details();
            this.cloudAccountName = new ContractSchema_ContractDetails_Details();
            this.axNumber = new ContractSchema_ContractDetails_Details();
            this.autotaskAccountId = new ContractSchema_ContractDetails_Details();
            this.contractCategory = new ContractSchema_ContractDetails_Details();
            this.startDate = new ContractSchema_ContractDetails_Details();
            this.serviceLevelAgreement = new ContractSchema_ContractDetails_Details();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemGuid = _data["systemGuid"] ? ContractSchema_ContractDetails_Details.fromJS(_data["systemGuid"]) : new ContractSchema_ContractDetails_Details();
            this.parentSystemGuid = _data["parentSystemGuid"] ? ContractSchema_ContractDetails_Details.fromJS(_data["parentSystemGuid"]) : undefined as any;
            this.cloudSourceId = _data["cloudSourceId"] ? ContractSchema_ContractDetails_Details.fromJS(_data["cloudSourceId"]) : new ContractSchema_ContractDetails_Details();
            this.cloudAccountName = _data["cloudAccountName"] ? ContractSchema_ContractDetails_Details.fromJS(_data["cloudAccountName"]) : new ContractSchema_ContractDetails_Details();
            this.axNumber = _data["axNumber"] ? ContractSchema_ContractDetails_Details.fromJS(_data["axNumber"]) : new ContractSchema_ContractDetails_Details();
            this.autotaskAccountId = _data["autotaskAccountId"] ? ContractSchema_ContractDetails_Details.fromJS(_data["autotaskAccountId"]) : new ContractSchema_ContractDetails_Details();
            this.contractCategory = _data["contractCategory"] ? ContractSchema_ContractDetails_Details.fromJS(_data["contractCategory"]) : new ContractSchema_ContractDetails_Details();
            this.startDate = _data["startDate"] ? ContractSchema_ContractDetails_Details.fromJS(_data["startDate"]) : new ContractSchema_ContractDetails_Details();
            this.endDate = _data["endDate"] ? ContractSchema_ContractDetails_Details.fromJS(_data["endDate"]) : undefined as any;
            this.serviceLevelAgreement = _data["serviceLevelAgreement"] ? ContractSchema_ContractDetails_Details.fromJS(_data["serviceLevelAgreement"]) : new ContractSchema_ContractDetails_Details();
            this.cloudAccountActive = _data["cloudAccountActive"] ? ContractSchema_ContractDetails_Details.fromJS(_data["cloudAccountActive"]) : undefined as any;
        }
    }

    static fromJS(data: any): ContractSchema_ContractDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSchema_ContractDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemGuid"] = this.systemGuid ? this.systemGuid.toJSON() : undefined as any;
        data["parentSystemGuid"] = this.parentSystemGuid ? this.parentSystemGuid.toJSON() : undefined as any;
        data["cloudSourceId"] = this.cloudSourceId ? this.cloudSourceId.toJSON() : undefined as any;
        data["cloudAccountName"] = this.cloudAccountName ? this.cloudAccountName.toJSON() : undefined as any;
        data["axNumber"] = this.axNumber ? this.axNumber.toJSON() : undefined as any;
        data["autotaskAccountId"] = this.autotaskAccountId ? this.autotaskAccountId.toJSON() : undefined as any;
        data["contractCategory"] = this.contractCategory ? this.contractCategory.toJSON() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : undefined as any;
        data["serviceLevelAgreement"] = this.serviceLevelAgreement ? this.serviceLevelAgreement.toJSON() : undefined as any;
        data["cloudAccountActive"] = this.cloudAccountActive ? this.cloudAccountActive.toJSON() : undefined as any;
        return data;
    }
}

export interface IContractSchema_ContractDetails {
    systemGuid: ContractSchema_ContractDetails_Details;
    parentSystemGuid?: ContractSchema_ContractDetails_Details;
    cloudSourceId: ContractSchema_ContractDetails_Details;
    cloudAccountName: ContractSchema_ContractDetails_Details;
    axNumber: ContractSchema_ContractDetails_Details;
    autotaskAccountId: ContractSchema_ContractDetails_Details;
    contractCategory: ContractSchema_ContractDetails_Details;
    startDate: ContractSchema_ContractDetails_Details;
    endDate?: ContractSchema_ContractDetails_Details;
    serviceLevelAgreement: ContractSchema_ContractDetails_Details;
    cloudAccountActive?: ContractSchema_ContractDetails_Details;
}

export class ContractSchema_ContractDetails_Details implements IContractSchema_ContractDetails_Details {
    description?: string | undefined;
    type?: string | undefined;
    enum?: string[] | undefined;

    constructor(data?: IContractSchema_ContractDetails_Details) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.type = _data["type"];
            if (Array.isArray(_data["enum"])) {
                this.enum = [] as any;
                for (let item of _data["enum"])
                    this.enum!.push(item);
            }
        }
    }

    static fromJS(data: any): ContractSchema_ContractDetails_Details {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSchema_ContractDetails_Details();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        if (Array.isArray(this.enum)) {
            data["enum"] = [];
            for (let item of this.enum)
                data["enum"].push(item);
        }
        return data;
    }
}

export interface IContractSchema_ContractDetails_Details {
    description?: string | undefined;
    type?: string | undefined;
    enum?: string[] | undefined;
}

export class CreateProfile implements ICreateProfile {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;

    constructor(data?: ICreateProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): CreateProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        return data;
    }
}

export interface ICreateProfile {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
}

export class EmailVerificationRequest implements IEmailVerificationRequest {
    guid?: string | undefined;
    email?: string | undefined;
    code?: number;

    constructor(data?: IEmailVerificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.email = _data["email"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): EmailVerificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailVerificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["email"] = this.email;
        data["code"] = this.code;
        return data;
    }
}

export interface IEmailVerificationRequest {
    guid?: string | undefined;
    email?: string | undefined;
    code?: number;
}

export class FSACacheResponse implements IFSACacheResponse {
    responseStatus?: number | undefined;
    errorMessage?: string | undefined;
    flexibleServicesAgreements?: FlexibleServicesAgreementDTO[] | undefined;

    constructor(data?: IFSACacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["flexibleServicesAgreements"])) {
                this.flexibleServicesAgreements = [] as any;
                for (let item of _data["flexibleServicesAgreements"])
                    this.flexibleServicesAgreements!.push(FlexibleServicesAgreementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FSACacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FSACacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.flexibleServicesAgreements)) {
            data["flexibleServicesAgreements"] = [];
            for (let item of this.flexibleServicesAgreements)
                data["flexibleServicesAgreements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFSACacheResponse {
    responseStatus?: number | undefined;
    errorMessage?: string | undefined;
    flexibleServicesAgreements?: FlexibleServicesAgreementDTO[] | undefined;
}

export class MonitoringAlert implements IMonitoringAlert {
    serviceRequestId?: number;
    ticketId?: number;
    ticketNumber?: string | undefined;
    title?: string | undefined;
    priority?: number;
    status?: number;
    source?: number;
    contractName?: string | undefined;
    contractId?: number;
    resourceFirstName?: string | undefined;
    resourceLastName?: string | undefined;
    configurationItemName?: string | undefined;
    configurationItemId?: number;
    configurationItemReferenceNumber?: string | undefined;
    contactId?: number;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    created?: Date;
    contractType?: number;

    constructor(data?: IMonitoringAlert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceRequestId = _data["serviceRequestId"];
            this.ticketId = _data["ticketId"];
            this.ticketNumber = _data["ticketNumber"];
            this.title = _data["title"];
            this.priority = _data["priority"];
            this.status = _data["status"];
            this.source = _data["source"];
            this.contractName = _data["contractName"];
            this.contractId = _data["contractId"];
            this.resourceFirstName = _data["resourceFirstName"];
            this.resourceLastName = _data["resourceLastName"];
            this.configurationItemName = _data["configurationItemName"];
            this.configurationItemId = _data["configurationItemId"];
            this.configurationItemReferenceNumber = _data["configurationItemReferenceNumber"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.contractType = _data["contractType"];
        }
    }

    static fromJS(data: any): MonitoringAlert {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringAlert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRequestId"] = this.serviceRequestId;
        data["ticketId"] = this.ticketId;
        data["ticketNumber"] = this.ticketNumber;
        data["title"] = this.title;
        data["priority"] = this.priority;
        data["status"] = this.status;
        data["source"] = this.source;
        data["contractName"] = this.contractName;
        data["contractId"] = this.contractId;
        data["resourceFirstName"] = this.resourceFirstName;
        data["resourceLastName"] = this.resourceLastName;
        data["configurationItemName"] = this.configurationItemName;
        data["configurationItemId"] = this.configurationItemId;
        data["configurationItemReferenceNumber"] = this.configurationItemReferenceNumber;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["contractType"] = this.contractType;
        return data;
    }
}

export interface IMonitoringAlert {
    serviceRequestId?: number;
    ticketId?: number;
    ticketNumber?: string | undefined;
    title?: string | undefined;
    priority?: number;
    status?: number;
    source?: number;
    contractName?: string | undefined;
    contractId?: number;
    resourceFirstName?: string | undefined;
    resourceLastName?: string | undefined;
    configurationItemName?: string | undefined;
    configurationItemId?: number;
    configurationItemReferenceNumber?: string | undefined;
    contactId?: number;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    created?: Date;
    contractType?: number;
}

export class NotificationCloudAccount implements INotificationCloudAccount {
    configurationItemId?: number;
    contractId?: number;
    contractName?: string | undefined;
    contractServiceLevelAgreementId?: number;
    cloudAccountName?: string | undefined;
    cloudAccountId?: string | undefined;
    accountId?: number;
    accountName?: string | undefined;

    constructor(data?: INotificationCloudAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.contractServiceLevelAgreementId = _data["contractServiceLevelAgreementId"];
            this.cloudAccountName = _data["cloudAccountName"];
            this.cloudAccountId = _data["cloudAccountId"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): NotificationCloudAccount {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationCloudAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["contractServiceLevelAgreementId"] = this.contractServiceLevelAgreementId;
        data["cloudAccountName"] = this.cloudAccountName;
        data["cloudAccountId"] = this.cloudAccountId;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        return data;
    }
}

export interface INotificationCloudAccount {
    configurationItemId?: number;
    contractId?: number;
    contractName?: string | undefined;
    contractServiceLevelAgreementId?: number;
    cloudAccountName?: string | undefined;
    cloudAccountId?: string | undefined;
    accountId?: number;
    accountName?: string | undefined;
}

export class NotificationContract implements INotificationContract {
    contractId?: number;
    contractName?: string | undefined;
    serviceLevelAgreementId?: number;
    accountId?: number;
    accountName?: string | undefined;

    constructor(data?: INotificationContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.serviceLevelAgreementId = _data["serviceLevelAgreementId"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): NotificationContract {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["serviceLevelAgreementId"] = this.serviceLevelAgreementId;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        return data;
    }
}

export interface INotificationContract {
    contractId?: number;
    contractName?: string | undefined;
    serviceLevelAgreementId?: number;
    accountId?: number;
    accountName?: string | undefined;
}

export class OnboardingAdmin implements IOnboardingAdmin {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: string | undefined;
    hasLoggedIn?: boolean;
    connectionsUsed?: string[] | undefined;

    constructor(data?: IOnboardingAdmin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.phoneExtension = _data["phoneExtension"];
            this.hasLoggedIn = _data["hasLoggedIn"];
            if (Array.isArray(_data["connectionsUsed"])) {
                this.connectionsUsed = [] as any;
                for (let item of _data["connectionsUsed"])
                    this.connectionsUsed!.push(item);
            }
        }
    }

    static fromJS(data: any): OnboardingAdmin {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingAdmin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["phoneExtension"] = this.phoneExtension;
        data["hasLoggedIn"] = this.hasLoggedIn;
        if (Array.isArray(this.connectionsUsed)) {
            data["connectionsUsed"] = [];
            for (let item of this.connectionsUsed)
                data["connectionsUsed"].push(item);
        }
        return data;
    }
}

export interface IOnboardingAdmin {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: string | undefined;
    hasLoggedIn?: boolean;
    connectionsUsed?: string[] | undefined;
}

export class OnboardingStatus2 implements IOnboardingStatus2 {
    accountId?: number;
    accountName?: string | undefined;
    contactCreationSuccessful?: boolean;
    welcomeLinkGuid?: string | undefined;
    firstAdmin?: OnboardingAdmin;
    connections?: string[] | undefined;

    constructor(data?: IOnboardingStatus2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.contactCreationSuccessful = _data["contactCreationSuccessful"];
            this.welcomeLinkGuid = _data["welcomeLinkGuid"];
            this.firstAdmin = _data["firstAdmin"] ? OnboardingAdmin.fromJS(_data["firstAdmin"]) : undefined as any;
            if (Array.isArray(_data["connections"])) {
                this.connections = [] as any;
                for (let item of _data["connections"])
                    this.connections!.push(item);
            }
        }
    }

    static fromJS(data: any): OnboardingStatus2 {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingStatus2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["contactCreationSuccessful"] = this.contactCreationSuccessful;
        data["welcomeLinkGuid"] = this.welcomeLinkGuid;
        data["firstAdmin"] = this.firstAdmin ? this.firstAdmin.toJSON() : undefined as any;
        if (Array.isArray(this.connections)) {
            data["connections"] = [];
            for (let item of this.connections)
                data["connections"].push(item);
        }
        return data;
    }
}

export interface IOnboardingStatus2 {
    accountId?: number;
    accountName?: string | undefined;
    contactCreationSuccessful?: boolean;
    welcomeLinkGuid?: string | undefined;
    firstAdmin?: OnboardingAdmin;
    connections?: string[] | undefined;
}

export class PagedResultData implements IPagedResultData {
    currentPage?: number;
    totalPages?: number;
    pageSize?: number;
    totalCount?: number;
    hasPrevious?: boolean;
    hasNext?: boolean;

    constructor(data?: IPagedResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.hasPrevious = _data["hasPrevious"];
            this.hasNext = _data["hasNext"];
        }
    }

    static fromJS(data: any): PagedResultData {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["hasPrevious"] = this.hasPrevious;
        data["hasNext"] = this.hasNext;
        return data;
    }
}

export interface IPagedResultData {
    currentPage?: number;
    totalPages?: number;
    pageSize?: number;
    totalCount?: number;
    hasPrevious?: boolean;
    hasNext?: boolean;
}

export class StatusResponse implements IStatusResponse {
    responseStatus?: ResponseStatusValues;
    errorMessage?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "StatusResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): StatusResponse {
        data = typeof data === 'object' ? data : {};
        if (data["typeName"] === "ServiceRequestResponse") {
            let result = new ServiceRequestResponse();
            result.init(data);
            return result;
        }
        let result = new StatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this._discriminator;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IStatusResponse {
    responseStatus?: ResponseStatusValues;
    errorMessage?: string | undefined;
}

export class ServiceRequestResponse extends StatusResponse implements IServiceRequestResponse {
    serviceRequests?: ServiceRequestDTO[] | undefined;
    lastServiceRequestId?: number | undefined;
    lastAutotaskTicketId?: number | undefined;
    lastAutotaskTicketNumber?: string | undefined;
    failedContacts?: ServiceRequestContactCandidateDto[] | undefined;

    constructor(data?: IServiceRequestResponse) {
        super(data);
        this._discriminator = "ServiceRequestResponse";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["serviceRequests"])) {
                this.serviceRequests = [] as any;
                for (let item of _data["serviceRequests"])
                    this.serviceRequests!.push(ServiceRequestDTO.fromJS(item));
            }
            this.lastServiceRequestId = _data["lastServiceRequestId"];
            this.lastAutotaskTicketId = _data["lastAutotaskTicketId"];
            this.lastAutotaskTicketNumber = _data["lastAutotaskTicketNumber"];
            if (Array.isArray(_data["failedContacts"])) {
                this.failedContacts = [] as any;
                for (let item of _data["failedContacts"])
                    this.failedContacts!.push(ServiceRequestContactCandidateDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServiceRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceRequests)) {
            data["serviceRequests"] = [];
            for (let item of this.serviceRequests)
                data["serviceRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastServiceRequestId"] = this.lastServiceRequestId;
        data["lastAutotaskTicketId"] = this.lastAutotaskTicketId;
        data["lastAutotaskTicketNumber"] = this.lastAutotaskTicketNumber;
        if (Array.isArray(this.failedContacts)) {
            data["failedContacts"] = [];
            for (let item of this.failedContacts)
                data["failedContacts"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServiceRequestResponse extends IStatusResponse {
    serviceRequests?: ServiceRequestDTO[] | undefined;
    lastServiceRequestId?: number | undefined;
    lastAutotaskTicketId?: number | undefined;
    lastAutotaskTicketNumber?: string | undefined;
    failedContacts?: ServiceRequestContactCandidateDto[] | undefined;
}

export class TeamContractItemDto implements ITeamContractItemDto {
    id!: number;
    accountId!: number;
    accountName!: string;
    status!: number;
    endDate!: Date;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    serviceLevelAgreementID?: number | undefined;

    constructor(data?: ITeamContractItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.status = _data["status"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.contractCategory = _data["contractCategory"];
            this.contractName = _data["contractName"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
        }
    }

    static fromJS(data: any): TeamContractItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamContractItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["status"] = this.status;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["contractCategory"] = this.contractCategory;
        data["contractName"] = this.contractName;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        return data;
    }
}

export interface ITeamContractItemDto {
    id: number;
    accountId: number;
    accountName: string;
    status: number;
    endDate: Date;
    contractCategory?: number | undefined;
    contractName?: string | undefined;
    serviceLevelAgreementID?: number | undefined;
}

export class TeamContractReponse implements ITeamContractReponse {
    standardContracts?: TeamContractItemDto[] | undefined;
    cloudContracts?: TeamContractItemDto[] | undefined;
    cloudContractAccounts?: CloudAccount[] | undefined;

    constructor(data?: ITeamContractReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standardContracts"])) {
                this.standardContracts = [] as any;
                for (let item of _data["standardContracts"])
                    this.standardContracts!.push(TeamContractItemDto.fromJS(item));
            }
            if (Array.isArray(_data["cloudContracts"])) {
                this.cloudContracts = [] as any;
                for (let item of _data["cloudContracts"])
                    this.cloudContracts!.push(TeamContractItemDto.fromJS(item));
            }
            if (Array.isArray(_data["cloudContractAccounts"])) {
                this.cloudContractAccounts = [] as any;
                for (let item of _data["cloudContractAccounts"])
                    this.cloudContractAccounts!.push(CloudAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamContractReponse {
        data = typeof data === 'object' ? data : {};
        let result = new TeamContractReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standardContracts)) {
            data["standardContracts"] = [];
            for (let item of this.standardContracts)
                data["standardContracts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cloudContracts)) {
            data["cloudContracts"] = [];
            for (let item of this.cloudContracts)
                data["cloudContracts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cloudContractAccounts)) {
            data["cloudContractAccounts"] = [];
            for (let item of this.cloudContractAccounts)
                data["cloudContractAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITeamContractReponse {
    standardContracts?: TeamContractItemDto[] | undefined;
    cloudContracts?: TeamContractItemDto[] | undefined;
    cloudContractAccounts?: CloudAccount[] | undefined;
}

export class TicketCacheResponse implements ITicketCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    tickets?: TicketDTO[] | undefined;
    lastTicketNumber?: string | undefined;
    lastTicketId?: number;
    failedContacts?: ServiceRequestContactCandidateDto[] | undefined;

    constructor(data?: ITicketCacheResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiry = _data["expiry"];
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(TicketDTO.fromJS(item));
            }
            this.lastTicketNumber = _data["lastTicketNumber"];
            this.lastTicketId = _data["lastTicketId"];
            if (Array.isArray(_data["failedContacts"])) {
                this.failedContacts = [] as any;
                for (let item of _data["failedContacts"])
                    this.failedContacts!.push(ServiceRequestContactCandidateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketCacheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCacheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiry"] = this.expiry;
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastTicketNumber"] = this.lastTicketNumber;
        data["lastTicketId"] = this.lastTicketId;
        if (Array.isArray(this.failedContacts)) {
            data["failedContacts"] = [];
            for (let item of this.failedContacts)
                data["failedContacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketCacheResponse {
    expiry?: number | undefined;
    responseStatus?: number;
    errorMessage?: string | undefined;
    tickets?: TicketDTO[] | undefined;
    lastTicketNumber?: string | undefined;
    lastTicketId?: number;
    failedContacts?: ServiceRequestContactCandidateDto[] | undefined;
}

export class UnmappedContractSLA implements IUnmappedContractSLA {
    contractCategory?: number;
    serviceLevelAgreementID?: number;

    constructor(data?: IUnmappedContractSLA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractCategory = _data["contractCategory"];
            this.serviceLevelAgreementID = _data["serviceLevelAgreementID"];
        }
    }

    static fromJS(data: any): UnmappedContractSLA {
        data = typeof data === 'object' ? data : {};
        let result = new UnmappedContractSLA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractCategory"] = this.contractCategory;
        data["serviceLevelAgreementID"] = this.serviceLevelAgreementID;
        return data;
    }
}

export interface IUnmappedContractSLA {
    contractCategory?: number;
    serviceLevelAgreementID?: number;
}

export class ValidateEmailStatus implements IValidateEmailStatus {
    emailSent?: boolean;
    codeGenerated?: boolean;
    validCode?: boolean;
    codeExpired?: boolean;
    guid?: string | undefined;

    constructor(data?: IValidateEmailStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailSent = _data["emailSent"];
            this.codeGenerated = _data["codeGenerated"];
            this.validCode = _data["validCode"];
            this.codeExpired = _data["codeExpired"];
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ValidateEmailStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateEmailStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailSent"] = this.emailSent;
        data["codeGenerated"] = this.codeGenerated;
        data["validCode"] = this.validCode;
        data["codeExpired"] = this.codeExpired;
        data["guid"] = this.guid;
        return data;
    }
}

export interface IValidateEmailStatus {
    emailSent?: boolean;
    codeGenerated?: boolean;
    validCode?: boolean;
    codeExpired?: boolean;
    guid?: string | undefined;
}

export class TicketQueryRequest extends ServiceRequestsRequest implements ITicketQueryRequest {
    contactIds?: number[] | undefined;
    accountIds?: number[] | undefined;
    ticketIds?: number[] | undefined;

    constructor(data?: ITicketQueryRequest) {
        super(data);
        this._discriminator = "TicketQueryRequest";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            if (Array.isArray(_data["ticketIds"])) {
                this.ticketIds = [] as any;
                for (let item of _data["ticketIds"])
                    this.ticketIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): TicketQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TicketQueryRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        if (Array.isArray(this.ticketIds)) {
            data["ticketIds"] = [];
            for (let item of this.ticketIds)
                data["ticketIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITicketQueryRequest extends IServiceRequestsRequest {
    contactIds?: number[] | undefined;
    accountIds?: number[] | undefined;
    ticketIds?: number[] | undefined;
}

export class ConfigContractSLAsResponse implements IConfigContractSLAsResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    unmappedContractSLAs?: UnmappedContractSLA[] | undefined;
    mappedContractSLAs?: ConfigContractSLA[] | undefined;

    constructor(data?: IConfigContractSLAsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["unmappedContractSLAs"])) {
                this.unmappedContractSLAs = [] as any;
                for (let item of _data["unmappedContractSLAs"])
                    this.unmappedContractSLAs!.push(UnmappedContractSLA.fromJS(item));
            }
            if (Array.isArray(_data["mappedContractSLAs"])) {
                this.mappedContractSLAs = [] as any;
                for (let item of _data["mappedContractSLAs"])
                    this.mappedContractSLAs!.push(ConfigContractSLA.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigContractSLAsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigContractSLAsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.unmappedContractSLAs)) {
            data["unmappedContractSLAs"] = [];
            for (let item of this.unmappedContractSLAs)
                data["unmappedContractSLAs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mappedContractSLAs)) {
            data["mappedContractSLAs"] = [];
            for (let item of this.mappedContractSLAs)
                data["mappedContractSLAs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConfigContractSLAsResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    unmappedContractSLAs?: UnmappedContractSLA[] | undefined;
    mappedContractSLAs?: ConfigContractSLA[] | undefined;
}

export class CreateConfigContractSLAResponse implements ICreateConfigContractSLAResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    create?: ConfigContractSLA;

    constructor(data?: ICreateConfigContractSLAResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.create = _data["create"] ? ConfigContractSLA.fromJS(_data["create"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateConfigContractSLAResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConfigContractSLAResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["create"] = this.create ? this.create.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateConfigContractSLAResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    create?: ConfigContractSLA;
}

export class UpdateConfigContractSLAResponse implements IUpdateConfigContractSLAResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    update?: ConfigContractSLA;

    constructor(data?: IUpdateConfigContractSLAResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseStatus = _data["responseStatus"];
            this.errorMessage = _data["errorMessage"];
            this.update = _data["update"] ? ConfigContractSLA.fromJS(_data["update"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateConfigContractSLAResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigContractSLAResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseStatus"] = this.responseStatus;
        data["errorMessage"] = this.errorMessage;
        data["update"] = this.update ? this.update.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateConfigContractSLAResponse {
    responseStatus?: number;
    errorMessage?: string | undefined;
    update?: ConfigContractSLA;
}

export class UpdateGridFilterRequest implements IUpdateGridFilterRequest {
    location?: string | undefined;
    filterName?: string | undefined;
    includeFiltersObject?: string | undefined;
    excludeFiltersObject?: string | undefined;
    generalFiltersObject?: string | undefined;
    isDefault?: boolean;

    constructor(data?: IUpdateGridFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.filterName = _data["filterName"];
            this.includeFiltersObject = _data["includeFiltersObject"];
            this.excludeFiltersObject = _data["excludeFiltersObject"];
            this.generalFiltersObject = _data["generalFiltersObject"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UpdateGridFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGridFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["filterName"] = this.filterName;
        data["includeFiltersObject"] = this.includeFiltersObject;
        data["excludeFiltersObject"] = this.excludeFiltersObject;
        data["generalFiltersObject"] = this.generalFiltersObject;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IUpdateGridFilterRequest {
    location?: string | undefined;
    filterName?: string | undefined;
    includeFiltersObject?: string | undefined;
    excludeFiltersObject?: string | undefined;
    generalFiltersObject?: string | undefined;
    isDefault?: boolean;
}

export class UpdateLicenseAllocationsRequest implements IUpdateLicenseAllocationsRequest {
    configurationItemId!: number;
    allocations!: LicenseAllocation[];

    constructor(data?: IUpdateLicenseAllocationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.allocations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationItemId = _data["configurationItemId"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(LicenseAllocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateLicenseAllocationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLicenseAllocationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationItemId"] = this.configurationItemId;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateLicenseAllocationsRequest {
    configurationItemId: number;
    allocations: LicenseAllocation[];
}

/** A storefront switch that started but did not finish; other switches return 409 until it is repeated. */
export class UserContextPendingSwitchDto implements IUserContextPendingSwitchDto {
    tenantId!: string;
    orgUnitId!: number;

    constructor(data?: IUserContextPendingSwitchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.orgUnitId = _data["orgUnitId"];
        }
    }

    static fromJS(data: any): UserContextPendingSwitchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContextPendingSwitchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["orgUnitId"] = this.orgUnitId;
        return data;
    }
}

/** A storefront switch that started but did not finish; other switches return 409 until it is repeated. */
export interface IUserContextPendingSwitchDto {
    tenantId: string;
    orgUnitId: number;
}

/** The signed-in user's tenants, storefronts and current selection. */
export class UserContextResponse implements IUserContextResponse {
    tenants!: UserContextTenantDto[] | undefined;
    currentTenantId?: string | undefined;
    currentOrgUnitId?: number | undefined;
    pendingSwitch?: UserContextPendingSwitchDto;
    canSwitchTenant!: boolean;
    canSwitchStorefront!: boolean;

    constructor(data?: IUserContextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(UserContextTenantDto.fromJS(item));
            }
            this.currentTenantId = _data["currentTenantId"];
            this.currentOrgUnitId = _data["currentOrgUnitId"];
            this.pendingSwitch = _data["pendingSwitch"] ? UserContextPendingSwitchDto.fromJS(_data["pendingSwitch"]) : undefined as any;
            this.canSwitchTenant = _data["canSwitchTenant"];
            this.canSwitchStorefront = _data["canSwitchStorefront"];
        }
    }

    static fromJS(data: any): UserContextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserContextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentTenantId"] = this.currentTenantId;
        data["currentOrgUnitId"] = this.currentOrgUnitId;
        data["pendingSwitch"] = this.pendingSwitch ? this.pendingSwitch.toJSON() : undefined as any;
        data["canSwitchTenant"] = this.canSwitchTenant;
        data["canSwitchStorefront"] = this.canSwitchStorefront;
        return data;
    }
}

/** The signed-in user's tenants, storefronts and current selection. */
export interface IUserContextResponse {
    tenants: UserContextTenantDto[] | undefined;
    currentTenantId?: string | undefined;
    currentOrgUnitId?: number | undefined;
    pendingSwitch?: UserContextPendingSwitchDto;
    canSwitchTenant: boolean;
    canSwitchStorefront: boolean;
}

export class UserContextStorefrontDto implements IUserContextStorefrontDto {
    orgUnitId!: number;
    name!: string | undefined;
    logoPath?: string | undefined;
    isCurrent!: boolean;

    constructor(data?: IUserContextStorefrontDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgUnitId = _data["orgUnitId"];
            this.name = _data["name"];
            this.logoPath = _data["logoPath"];
            this.isCurrent = _data["isCurrent"];
        }
    }

    static fromJS(data: any): UserContextStorefrontDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContextStorefrontDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgUnitId"] = this.orgUnitId;
        data["name"] = this.name;
        data["logoPath"] = this.logoPath;
        data["isCurrent"] = this.isCurrent;
        return data;
    }
}

export interface IUserContextStorefrontDto {
    orgUnitId: number;
    name: string | undefined;
    logoPath?: string | undefined;
    isCurrent: boolean;
}

export class UserContextTenantDto implements IUserContextTenantDto {
    tenantId!: string;
    name!: string | undefined;
    isCurrent!: boolean;
    storefronts!: UserContextStorefrontDto[] | undefined;

    constructor(data?: IUserContextTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isCurrent = _data["isCurrent"];
            if (Array.isArray(_data["storefronts"])) {
                this.storefronts = [] as any;
                for (let item of _data["storefronts"])
                    this.storefronts!.push(UserContextStorefrontDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserContextTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContextTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isCurrent"] = this.isCurrent;
        if (Array.isArray(this.storefronts)) {
            data["storefronts"] = [];
            for (let item of this.storefronts)
                data["storefronts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserContextTenantDto {
    tenantId: string;
    name: string | undefined;
    isCurrent: boolean;
    storefronts: UserContextStorefrontDto[] | undefined;
}

export class WarehousePickOrderIntegrationMetadata extends IntegrationMetadata implements IWarehousePickOrderIntegrationMetadata {
    contactIds?: number[] | undefined;

    constructor(data?: IWarehousePickOrderIntegrationMetadata) {
        super(data);
        this._discriminator = "WarehousePickOrderIntegrationMetadata";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): WarehousePickOrderIntegrationMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousePickOrderIntegrationMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWarehousePickOrderIntegrationMetadata extends IIntegrationMetadata {
    contactIds?: number[] | undefined;
}

export class WarehouseReportConfig implements IWarehouseReportConfig {
    reportId?: string | undefined;
    reportName?: string | undefined;

    constructor(data?: IWarehouseReportConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportName = _data["reportName"];
        }
    }

    static fromJS(data: any): WarehouseReportConfig {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseReportConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportName"] = this.reportName;
        return data;
    }
}

export interface IWarehouseReportConfig {
    reportId?: string | undefined;
    reportName?: string | undefined;
}

export class ContractServiceRecord implements IContractServiceRecord {
    contractID?: any | undefined;
    serviceID?: any | undefined;
    unitPrice?: any | undefined;
    adjustedPrice?: any | undefined;
    invoiceDescription?: any | undefined;
    quoteItemID?: any | undefined;
    internalCurrencyUnitPrice?: any | undefined;
    internalCurrencyAdjustedPrice?: any | undefined;
    internalDescription?: any | undefined;
    unitCost?: any | undefined;
    fields?: AutotaskPicklistField[] | undefined;
    id?: number;
    userDefinedFields?: UDFNameValue[] | undefined;

    constructor(data?: IContractServiceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractID = _data["contractID"];
            this.serviceID = _data["serviceID"];
            this.unitPrice = _data["unitPrice"];
            this.adjustedPrice = _data["adjustedPrice"];
            this.invoiceDescription = _data["invoiceDescription"];
            this.quoteItemID = _data["quoteItemID"];
            this.internalCurrencyUnitPrice = _data["internalCurrencyUnitPrice"];
            this.internalCurrencyAdjustedPrice = _data["internalCurrencyAdjustedPrice"];
            this.internalDescription = _data["internalDescription"];
            this.unitCost = _data["unitCost"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(AutotaskPicklistField.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["userDefinedFields"])) {
                this.userDefinedFields = [] as any;
                for (let item of _data["userDefinedFields"])
                    this.userDefinedFields!.push(UDFNameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractServiceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ContractServiceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractID"] = this.contractID;
        data["serviceID"] = this.serviceID;
        data["unitPrice"] = this.unitPrice;
        data["adjustedPrice"] = this.adjustedPrice;
        data["invoiceDescription"] = this.invoiceDescription;
        data["quoteItemID"] = this.quoteItemID;
        data["internalCurrencyUnitPrice"] = this.internalCurrencyUnitPrice;
        data["internalCurrencyAdjustedPrice"] = this.internalCurrencyAdjustedPrice;
        data["internalDescription"] = this.internalDescription;
        data["unitCost"] = this.unitCost;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        if (Array.isArray(this.userDefinedFields)) {
            data["userDefinedFields"] = [];
            for (let item of this.userDefinedFields)
                data["userDefinedFields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContractServiceRecord {
    contractID?: any | undefined;
    serviceID?: any | undefined;
    unitPrice?: any | undefined;
    adjustedPrice?: any | undefined;
    invoiceDescription?: any | undefined;
    quoteItemID?: any | undefined;
    internalCurrencyUnitPrice?: any | undefined;
    internalCurrencyAdjustedPrice?: any | undefined;
    internalDescription?: any | undefined;
    unitCost?: any | undefined;
    fields?: AutotaskPicklistField[] | undefined;
    id?: number;
    userDefinedFields?: UDFNameValue[] | undefined;
}

export class CiscoReadyReportRecord implements ICiscoReadyReportRecord {
    instanceID?: string | undefined;
    assetType?: string | undefined;
    bestSiteCRPartyID?: string | undefined;
    bestSiteName?: string | undefined;
    bestSiteID?: string | undefined;
    bestSiteCity?: string | undefined;
    bestSiteState?: string | undefined;
    bestSiteCountry?: string | undefined;
    bestSitePostalCode?: string | undefined;
    businessEntity?: string | undefined;
    contract?: string | undefined;
    contractType?: string | undefined;
    coverage?: string | undefined;
    coveredLineStatus?: string | undefined;
    coveredLineStartDate?: string | undefined;
    coveredLineEndDate?: string | undefined;
    endOfProductSaleDate?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    itemQuantity?: string | undefined;
    lDoS?: string | undefined;
    parentInstanceID?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    productID?: string | undefined;
    productType?: string | undefined;
    serialNumber?: string | undefined;
    subBusinessEntity?: string | undefined;
    warrantyEndDate?: string | undefined;
    warrantyType?: string | undefined;

    constructor(data?: ICiscoReadyReportRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceID = _data["instanceID"];
            this.assetType = _data["assetType"];
            this.bestSiteCRPartyID = _data["bestSiteCRPartyID"];
            this.bestSiteName = _data["bestSiteName"];
            this.bestSiteID = _data["bestSiteID"];
            this.bestSiteCity = _data["bestSiteCity"];
            this.bestSiteState = _data["bestSiteState"];
            this.bestSiteCountry = _data["bestSiteCountry"];
            this.bestSitePostalCode = _data["bestSitePostalCode"];
            this.businessEntity = _data["businessEntity"];
            this.contract = _data["contract"];
            this.contractType = _data["contractType"];
            this.coverage = _data["coverage"];
            this.coveredLineStatus = _data["coveredLineStatus"];
            this.coveredLineStartDate = _data["coveredLineStartDate"];
            this.coveredLineEndDate = _data["coveredLineEndDate"];
            this.endOfProductSaleDate = _data["endOfProductSaleDate"];
            this.endOfSoftwareMaintenanceDate = _data["endOfSoftwareMaintenanceDate"];
            this.itemQuantity = _data["itemQuantity"];
            this.lDoS = _data["lDoS"];
            this.parentInstanceID = _data["parentInstanceID"];
            this.productDescription = _data["productDescription"];
            this.productFamily = _data["productFamily"];
            this.productID = _data["productID"];
            this.productType = _data["productType"];
            this.serialNumber = _data["serialNumber"];
            this.subBusinessEntity = _data["subBusinessEntity"];
            this.warrantyEndDate = _data["warrantyEndDate"];
            this.warrantyType = _data["warrantyType"];
        }
    }

    static fromJS(data: any): CiscoReadyReportRecord {
        data = typeof data === 'object' ? data : {};
        let result = new CiscoReadyReportRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceID"] = this.instanceID;
        data["assetType"] = this.assetType;
        data["bestSiteCRPartyID"] = this.bestSiteCRPartyID;
        data["bestSiteName"] = this.bestSiteName;
        data["bestSiteID"] = this.bestSiteID;
        data["bestSiteCity"] = this.bestSiteCity;
        data["bestSiteState"] = this.bestSiteState;
        data["bestSiteCountry"] = this.bestSiteCountry;
        data["bestSitePostalCode"] = this.bestSitePostalCode;
        data["businessEntity"] = this.businessEntity;
        data["contract"] = this.contract;
        data["contractType"] = this.contractType;
        data["coverage"] = this.coverage;
        data["coveredLineStatus"] = this.coveredLineStatus;
        data["coveredLineStartDate"] = this.coveredLineStartDate;
        data["coveredLineEndDate"] = this.coveredLineEndDate;
        data["endOfProductSaleDate"] = this.endOfProductSaleDate;
        data["endOfSoftwareMaintenanceDate"] = this.endOfSoftwareMaintenanceDate;
        data["itemQuantity"] = this.itemQuantity;
        data["lDoS"] = this.lDoS;
        data["parentInstanceID"] = this.parentInstanceID;
        data["productDescription"] = this.productDescription;
        data["productFamily"] = this.productFamily;
        data["productID"] = this.productID;
        data["productType"] = this.productType;
        data["serialNumber"] = this.serialNumber;
        data["subBusinessEntity"] = this.subBusinessEntity;
        data["warrantyEndDate"] = this.warrantyEndDate;
        data["warrantyType"] = this.warrantyType;
        return data;
    }
}

export interface ICiscoReadyReportRecord {
    instanceID?: string | undefined;
    assetType?: string | undefined;
    bestSiteCRPartyID?: string | undefined;
    bestSiteName?: string | undefined;
    bestSiteID?: string | undefined;
    bestSiteCity?: string | undefined;
    bestSiteState?: string | undefined;
    bestSiteCountry?: string | undefined;
    bestSitePostalCode?: string | undefined;
    businessEntity?: string | undefined;
    contract?: string | undefined;
    contractType?: string | undefined;
    coverage?: string | undefined;
    coveredLineStatus?: string | undefined;
    coveredLineStartDate?: string | undefined;
    coveredLineEndDate?: string | undefined;
    endOfProductSaleDate?: string | undefined;
    endOfSoftwareMaintenanceDate?: string | undefined;
    itemQuantity?: string | undefined;
    lDoS?: string | undefined;
    parentInstanceID?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    productID?: string | undefined;
    productType?: string | undefined;
    serialNumber?: string | undefined;
    subBusinessEntity?: string | undefined;
    warrantyEndDate?: string | undefined;
    warrantyType?: string | undefined;
}

export class EvaluatedCiscoReadyReportRecord implements IEvaluatedCiscoReadyReportRecord {
    errorMessages?: string[] | undefined;
    record?: CiscoReadyReportRecord;
    row?: number;

    constructor(data?: IEvaluatedCiscoReadyReportRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.record = _data["record"] ? CiscoReadyReportRecord.fromJS(_data["record"]) : undefined as any;
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): EvaluatedCiscoReadyReportRecord {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluatedCiscoReadyReportRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["record"] = this.record ? this.record.toJSON() : undefined as any;
        data["row"] = this.row;
        return data;
    }
}

export interface IEvaluatedCiscoReadyReportRecord {
    errorMessages?: string[] | undefined;
    record?: CiscoReadyReportRecord;
    row?: number;
}

export class OldField implements IOldField {
    name?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    length?: number;
    description?: string | undefined;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isQueryable?: boolean;
    isReference?: boolean;
    referenceEntityType?: string | undefined;
    isPickList?: boolean;
    picklistValues?: OldPickListValue[] | undefined;
    picklistParentValueField?: string | undefined;
    defaultValue?: string | undefined;
    isSupportedWebhookField?: boolean;

    constructor(data?: IOldField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.type = _data["type"];
            this.length = _data["length"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
            this.isReadOnly = _data["isReadOnly"];
            this.isQueryable = _data["isQueryable"];
            this.isReference = _data["isReference"];
            this.referenceEntityType = _data["referenceEntityType"];
            this.isPickList = _data["isPickList"];
            if (Array.isArray(_data["picklistValues"])) {
                this.picklistValues = [] as any;
                for (let item of _data["picklistValues"])
                    this.picklistValues!.push(OldPickListValue.fromJS(item));
            }
            this.picklistParentValueField = _data["picklistParentValueField"];
            this.defaultValue = _data["defaultValue"];
            this.isSupportedWebhookField = _data["isSupportedWebhookField"];
        }
    }

    static fromJS(data: any): OldField {
        data = typeof data === 'object' ? data : {};
        let result = new OldField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["type"] = this.type;
        data["length"] = this.length;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        data["isReadOnly"] = this.isReadOnly;
        data["isQueryable"] = this.isQueryable;
        data["isReference"] = this.isReference;
        data["referenceEntityType"] = this.referenceEntityType;
        data["isPickList"] = this.isPickList;
        if (Array.isArray(this.picklistValues)) {
            data["picklistValues"] = [];
            for (let item of this.picklistValues)
                data["picklistValues"].push(item ? item.toJSON() : undefined as any);
        }
        data["picklistParentValueField"] = this.picklistParentValueField;
        data["defaultValue"] = this.defaultValue;
        data["isSupportedWebhookField"] = this.isSupportedWebhookField;
        return data;
    }
}

export interface IOldField {
    name?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    length?: number;
    description?: string | undefined;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isQueryable?: boolean;
    isReference?: boolean;
    referenceEntityType?: string | undefined;
    isPickList?: boolean;
    picklistValues?: OldPickListValue[] | undefined;
    picklistParentValueField?: string | undefined;
    defaultValue?: string | undefined;
    isSupportedWebhookField?: boolean;
}

export class OldPickListValue implements IOldPickListValue {
    value?: string | undefined;
    label?: string | undefined;
    isDefaultValue?: boolean;
    sortOrder?: number;
    parentValue?: string | undefined;
    isActive?: boolean;
    isActiveSpecified?: boolean;
    isSystem?: boolean;
    isSystemSpecified?: boolean;

    constructor(data?: IOldPickListValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.isDefaultValue = _data["isDefaultValue"];
            this.sortOrder = _data["sortOrder"];
            this.parentValue = _data["parentValue"];
            this.isActive = _data["isActive"];
            this.isActiveSpecified = _data["isActiveSpecified"];
            this.isSystem = _data["isSystem"];
            this.isSystemSpecified = _data["isSystemSpecified"];
        }
    }

    static fromJS(data: any): OldPickListValue {
        data = typeof data === 'object' ? data : {};
        let result = new OldPickListValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["isDefaultValue"] = this.isDefaultValue;
        data["sortOrder"] = this.sortOrder;
        data["parentValue"] = this.parentValue;
        data["isActive"] = this.isActive;
        data["isActiveSpecified"] = this.isActiveSpecified;
        data["isSystem"] = this.isSystem;
        data["isSystemSpecified"] = this.isSystemSpecified;
        return data;
    }
}

export interface IOldPickListValue {
    value?: string | undefined;
    label?: string | undefined;
    isDefaultValue?: boolean;
    sortOrder?: number;
    parentValue?: string | undefined;
    isActive?: boolean;
    isActiveSpecified?: boolean;
    isSystem?: boolean;
    isSystemSpecified?: boolean;
}

export class OldPicklistValue implements IOldPicklistValue {
    entityType?: string | undefined;
    fields?: OldField[] | undefined;

    constructor(data?: IOldPicklistValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(OldField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OldPicklistValue {
        data = typeof data === 'object' ? data : {};
        let result = new OldPicklistValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOldPicklistValue {
    entityType?: string | undefined;
    fields?: OldField[] | undefined;
}

export class ServiceRecord implements IServiceRecord {
    id?: number;
    allocationCodeID?: number;
    createDate?: Date | undefined;
    creatorResourceId?: number | undefined;
    description?: string | undefined;
    invoiceDescription?: string | undefined;
    isActive?: boolean;
    lastModifiedDate?: Date | undefined;
    markupRate?: number | undefined;
    name?: string | undefined;
    periodType?: string | undefined;
    serviceLevelAgreementId?: number | undefined;
    unitCost?: number | undefined;
    unitPrice?: number;
    updateResourceId?: number | undefined;
    vendorAccountId?: number | undefined;

    constructor(data?: IServiceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.allocationCodeID = _data["allocationCodeID"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.creatorResourceId = _data["creatorResourceId"];
            this.description = _data["description"];
            this.invoiceDescription = _data["invoiceDescription"];
            this.isActive = _data["isActive"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.markupRate = _data["markupRate"];
            this.name = _data["name"];
            this.periodType = _data["periodType"];
            this.serviceLevelAgreementId = _data["serviceLevelAgreementId"];
            this.unitCost = _data["unitCost"];
            this.unitPrice = _data["unitPrice"];
            this.updateResourceId = _data["updateResourceId"];
            this.vendorAccountId = _data["vendorAccountId"];
        }
    }

    static fromJS(data: any): ServiceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allocationCodeID"] = this.allocationCodeID;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["creatorResourceId"] = this.creatorResourceId;
        data["description"] = this.description;
        data["invoiceDescription"] = this.invoiceDescription;
        data["isActive"] = this.isActive;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["markupRate"] = this.markupRate;
        data["name"] = this.name;
        data["periodType"] = this.periodType;
        data["serviceLevelAgreementId"] = this.serviceLevelAgreementId;
        data["unitCost"] = this.unitCost;
        data["unitPrice"] = this.unitPrice;
        data["updateResourceId"] = this.updateResourceId;
        data["vendorAccountId"] = this.vendorAccountId;
        return data;
    }
}

export interface IServiceRecord {
    id?: number;
    allocationCodeID?: number;
    createDate?: Date | undefined;
    creatorResourceId?: number | undefined;
    description?: string | undefined;
    invoiceDescription?: string | undefined;
    isActive?: boolean;
    lastModifiedDate?: Date | undefined;
    markupRate?: number | undefined;
    name?: string | undefined;
    periodType?: string | undefined;
    serviceLevelAgreementId?: number | undefined;
    unitCost?: number | undefined;
    unitPrice?: number;
    updateResourceId?: number | undefined;
    vendorAccountId?: number | undefined;
}

export class UDFNameValue implements IUDFNameValue {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IUDFNameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UDFNameValue {
        data = typeof data === 'object' ? data : {};
        let result = new UDFNameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IUDFNameValue {
    name?: string | undefined;
    value?: string | undefined;
}

export class KeyValuePair_2OfInt32AndInt32 implements IKeyValuePair_2OfInt32AndInt32 {
    key?: number;
    value?: number;

    constructor(data?: IKeyValuePair_2OfInt32AndInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePair_2OfInt32AndInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePair_2OfInt32AndInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePair_2OfInt32AndInt32 {
    key?: number;
    value?: number;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    RedirectKeepVerb = "RedirectKeepVerb",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class Body implements IBody {
    attachments?: string[];

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        return data;
    }
}

export interface IBody {
    attachments?: string[];

    [key: string]: any;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}